var zU = Object.defineProperty;
var FU = (e, t, n) => t in e ? zU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ri = (e, t, n) => (FU(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as gc from "react";
import vr, { useContext as ln, useRef as ya, useLayoutEffect as Sb, useState as pr, useMemo as jo, useEffect as Ht, createElement as LU, createContext as bI, forwardRef as t3, useCallback as Le, createRef as $U, useReducer as WU, StrictMode as cx } from "react";
import n3 from "react-dom";
import { keyStores as KU, Near as VU, WalletConnection as qU, Contract as HU } from "near-api-js";
var _ = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Vi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Qc(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      if (this instanceof r) {
        var i = [null];
        i.push.apply(i, arguments);
        var o = Function.bind.apply(t, i);
        return new o();
      }
      return t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var r3 = { exports: {} }, cm = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var GU = vr, YU = Symbol.for("react.element"), ZU = Symbol.for("react.fragment"), JU = Object.prototype.hasOwnProperty, XU = GU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, QU = { key: !0, ref: !0, __self: !0, __source: !0 };
function i3(e, t, n) {
  var r, i = {}, o = null, a = null;
  n !== void 0 && (o = "" + n), t.key !== void 0 && (o = "" + t.key), t.ref !== void 0 && (a = t.ref);
  for (r in t)
    JU.call(t, r) && !QU.hasOwnProperty(r) && (i[r] = t[r]);
  if (e && e.defaultProps)
    for (r in t = e.defaultProps, t)
      i[r] === void 0 && (i[r] = t[r]);
  return { $$typeof: YU, type: e, key: o, ref: a, props: i, _owner: XU.current };
}
cm.Fragment = ZU;
cm.jsx = i3;
cm.jsxs = i3;
r3.exports = cm;
var mI = r3.exports;
const ar = mI.Fragment, ee = mI.jsx, We = mI.jsxs;
var _I, ux = n3;
_I = ux.createRoot, ux.hydrateRoot;
var o3 = { exports: {} }, Cn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wI = Symbol.for("react.element"), vI = Symbol.for("react.portal"), um = Symbol.for("react.fragment"), lm = Symbol.for("react.strict_mode"), fm = Symbol.for("react.profiler"), dm = Symbol.for("react.provider"), hm = Symbol.for("react.context"), e4 = Symbol.for("react.server_context"), pm = Symbol.for("react.forward_ref"), ym = Symbol.for("react.suspense"), gm = Symbol.for("react.suspense_list"), bm = Symbol.for("react.memo"), mm = Symbol.for("react.lazy"), t4 = Symbol.for("react.offscreen"), a3;
a3 = Symbol.for("react.module.reference");
function yo(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case wI:
        switch (e = e.type, e) {
          case um:
          case fm:
          case lm:
          case ym:
          case gm:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case e4:
              case hm:
              case pm:
              case mm:
              case bm:
              case dm:
                return e;
              default:
                return t;
            }
        }
      case vI:
        return t;
    }
  }
}
Cn.ContextConsumer = hm;
Cn.ContextProvider = dm;
Cn.Element = wI;
Cn.ForwardRef = pm;
Cn.Fragment = um;
Cn.Lazy = mm;
Cn.Memo = bm;
Cn.Portal = vI;
Cn.Profiler = fm;
Cn.StrictMode = lm;
Cn.Suspense = ym;
Cn.SuspenseList = gm;
Cn.isAsyncMode = function() {
  return !1;
};
Cn.isConcurrentMode = function() {
  return !1;
};
Cn.isContextConsumer = function(e) {
  return yo(e) === hm;
};
Cn.isContextProvider = function(e) {
  return yo(e) === dm;
};
Cn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === wI;
};
Cn.isForwardRef = function(e) {
  return yo(e) === pm;
};
Cn.isFragment = function(e) {
  return yo(e) === um;
};
Cn.isLazy = function(e) {
  return yo(e) === mm;
};
Cn.isMemo = function(e) {
  return yo(e) === bm;
};
Cn.isPortal = function(e) {
  return yo(e) === vI;
};
Cn.isProfiler = function(e) {
  return yo(e) === fm;
};
Cn.isStrictMode = function(e) {
  return yo(e) === lm;
};
Cn.isSuspense = function(e) {
  return yo(e) === ym;
};
Cn.isSuspenseList = function(e) {
  return yo(e) === gm;
};
Cn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === um || e === fm || e === lm || e === ym || e === gm || e === t4 || typeof e == "object" && e !== null && (e.$$typeof === mm || e.$$typeof === bm || e.$$typeof === dm || e.$$typeof === hm || e.$$typeof === pm || e.$$typeof === a3 || e.getModuleId !== void 0);
};
Cn.typeOf = yo;
o3.exports = Cn;
var s3 = o3.exports, n4 = function(t, n, r, i) {
  var o = r ? r.call(i, t, n) : void 0;
  if (o !== void 0)
    return !!o;
  if (t === n)
    return !0;
  if (typeof t != "object" || !t || typeof n != "object" || !n)
    return !1;
  var a = Object.keys(t), s = Object.keys(n);
  if (a.length !== s.length)
    return !1;
  for (var c = Object.prototype.hasOwnProperty.bind(n), l = 0; l < a.length; l++) {
    var u = a[l];
    if (!c(u))
      return !1;
    var f = t[u], d = n[u];
    if (o = r ? r.call(i, f, d, u) : void 0, o === !1 || o === void 0 && f !== d)
      return !1;
  }
  return !0;
};
const r4 = /* @__PURE__ */ Vi(n4);
function i4(e) {
  function t(m, D, Y, Q, G) {
    for (var he = 0, se = 0, _e = 0, Me = 0, Pe, Be, at = 0, Fe = 0, Re, Nt = Re = Pe = 0, qe = 0, _t = 0, ve = 0, mt = 0, Gt = Y.length, ue = Gt - 1, fe, me = "", De = "", ze = "", L = "", T; qe < Gt; ) {
      if (Be = Y.charCodeAt(qe), qe === ue && se + Me + _e + he !== 0 && (se !== 0 && (Be = se === 47 ? 10 : 47), Me = _e = he = 0, Gt++, ue++), se + Me + _e + he === 0) {
        if (qe === ue && (0 < _t && (me = me.replace(d, "")), 0 < me.trim().length)) {
          switch (Be) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              me += Y.charAt(qe);
          }
          Be = 59;
        }
        switch (Be) {
          case 123:
            for (me = me.trim(), Pe = me.charCodeAt(0), Re = 1, mt = ++qe; qe < Gt; ) {
              switch (Be = Y.charCodeAt(qe)) {
                case 123:
                  Re++;
                  break;
                case 125:
                  Re--;
                  break;
                case 47:
                  switch (Be = Y.charCodeAt(qe + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Nt = qe + 1; Nt < ue; ++Nt)
                          switch (Y.charCodeAt(Nt)) {
                            case 47:
                              if (Be === 42 && Y.charCodeAt(Nt - 1) === 42 && qe + 2 !== Nt) {
                                qe = Nt + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (Be === 47) {
                                qe = Nt + 1;
                                break e;
                              }
                          }
                        qe = Nt;
                      }
                  }
                  break;
                case 91:
                  Be++;
                case 40:
                  Be++;
                case 34:
                case 39:
                  for (; qe++ < ue && Y.charCodeAt(qe) !== Be; )
                    ;
              }
              if (Re === 0)
                break;
              qe++;
            }
            switch (Re = Y.substring(mt, qe), Pe === 0 && (Pe = (me = me.replace(f, "").trim()).charCodeAt(0)), Pe) {
              case 64:
                switch (0 < _t && (me = me.replace(d, "")), Be = me.charCodeAt(1), Be) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    _t = D;
                    break;
                  default:
                    _t = v;
                }
                if (Re = t(D, _t, Re, Be, G + 1), mt = Re.length, 0 < B && (_t = n(v, me, ve), T = s(3, Re, _t, D, S, M, mt, Be, G, Q), me = _t.join(""), T !== void 0 && (mt = (Re = T.trim()).length) === 0 && (Be = 0, Re = "")), 0 < mt)
                  switch (Be) {
                    case 115:
                      me = me.replace(K, a);
                    case 100:
                    case 109:
                    case 45:
                      Re = me + "{" + Re + "}";
                      break;
                    case 107:
                      me = me.replace(A, "$1 $2"), Re = me + "{" + Re + "}", Re = y === 1 || y === 2 && o("@" + Re, 3) ? "@-webkit-" + Re + "@" + Re : "@" + Re;
                      break;
                    default:
                      Re = me + Re, Q === 112 && (Re = (De += Re, ""));
                  }
                else
                  Re = "";
                break;
              default:
                Re = t(D, n(D, me, ve), Re, Q, G + 1);
            }
            ze += Re, Re = ve = _t = Nt = Pe = 0, me = "", Be = Y.charCodeAt(++qe);
            break;
          case 125:
          case 59:
            if (me = (0 < _t ? me.replace(d, "") : me).trim(), 1 < (mt = me.length))
              switch (Nt === 0 && (Pe = me.charCodeAt(0), Pe === 45 || 96 < Pe && 123 > Pe) && (mt = (me = me.replace(" ", ":")).length), 0 < B && (T = s(1, me, D, m, S, M, De.length, Q, G, Q)) !== void 0 && (mt = (me = T.trim()).length) === 0 && (me = "\0\0"), Pe = me.charCodeAt(0), Be = me.charCodeAt(1), Pe) {
                case 0:
                  break;
                case 64:
                  if (Be === 105 || Be === 99) {
                    L += me + Y.charAt(qe);
                    break;
                  }
                default:
                  me.charCodeAt(mt - 1) !== 58 && (De += i(me, Pe, Be, me.charCodeAt(2)));
              }
            ve = _t = Nt = Pe = 0, me = "", Be = Y.charCodeAt(++qe);
        }
      }
      switch (Be) {
        case 13:
        case 10:
          se === 47 ? se = 0 : 1 + Pe === 0 && Q !== 107 && 0 < me.length && (_t = 1, me += "\0"), 0 < B * q && s(0, me, D, m, S, M, De.length, Q, G, Q), M = 1, S++;
          break;
        case 59:
        case 125:
          if (se + Me + _e + he === 0) {
            M++;
            break;
          }
        default:
          switch (M++, fe = Y.charAt(qe), Be) {
            case 9:
            case 32:
              if (Me + he + se === 0)
                switch (at) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    fe = "";
                    break;
                  default:
                    Be !== 32 && (fe = " ");
                }
              break;
            case 0:
              fe = "\\0";
              break;
            case 12:
              fe = "\\f";
              break;
            case 11:
              fe = "\\v";
              break;
            case 38:
              Me + se + he === 0 && (_t = ve = 1, fe = "\f" + fe);
              break;
            case 108:
              if (Me + se + he + p === 0 && 0 < Nt)
                switch (qe - Nt) {
                  case 2:
                    at === 112 && Y.charCodeAt(qe - 3) === 58 && (p = at);
                  case 8:
                    Fe === 111 && (p = Fe);
                }
              break;
            case 58:
              Me + se + he === 0 && (Nt = qe);
              break;
            case 44:
              se + _e + Me + he === 0 && (_t = 1, fe += "\r");
              break;
            case 34:
            case 39:
              se === 0 && (Me = Me === Be ? 0 : Me === 0 ? Be : Me);
              break;
            case 91:
              Me + se + _e === 0 && he++;
              break;
            case 93:
              Me + se + _e === 0 && he--;
              break;
            case 41:
              Me + se + he === 0 && _e--;
              break;
            case 40:
              if (Me + se + he === 0) {
                if (Pe === 0)
                  switch (2 * at + 3 * Fe) {
                    case 533:
                      break;
                    default:
                      Pe = 1;
                  }
                _e++;
              }
              break;
            case 64:
              se + _e + Me + he + Nt + Re === 0 && (Re = 1);
              break;
            case 42:
            case 47:
              if (!(0 < Me + he + _e))
                switch (se) {
                  case 0:
                    switch (2 * Be + 3 * Y.charCodeAt(qe + 1)) {
                      case 235:
                        se = 47;
                        break;
                      case 220:
                        mt = qe, se = 42;
                    }
                    break;
                  case 42:
                    Be === 47 && at === 42 && mt + 2 !== qe && (Y.charCodeAt(mt + 2) === 33 && (De += Y.substring(mt, qe + 1)), fe = "", se = 0);
                }
          }
          se === 0 && (me += fe);
      }
      Fe = at, at = Be, qe++;
    }
    if (mt = De.length, 0 < mt) {
      if (_t = D, 0 < B && (T = s(2, De, _t, m, S, M, mt, Q, G, Q), T !== void 0 && (De = T).length === 0))
        return L + De + ze;
      if (De = _t.join(",") + "{" + De + "}", y * p !== 0) {
        switch (y !== 2 || o(De, 2) || (p = 0), p) {
          case 111:
            De = De.replace(N, ":-moz-$1") + De;
            break;
          case 112:
            De = De.replace(x, "::-webkit-input-$1") + De.replace(x, "::-moz-$1") + De.replace(x, ":-ms-input-$1") + De;
        }
        p = 0;
      }
    }
    return L + De + ze;
  }
  function n(m, D, Y) {
    var Q = D.trim().split(b);
    D = Q;
    var G = Q.length, he = m.length;
    switch (he) {
      case 0:
      case 1:
        var se = 0;
        for (m = he === 0 ? "" : m[0] + " "; se < G; ++se)
          D[se] = r(m, D[se], Y).trim();
        break;
      default:
        var _e = se = 0;
        for (D = []; se < G; ++se)
          for (var Me = 0; Me < he; ++Me)
            D[_e++] = r(m[Me] + " ", Q[se], Y).trim();
    }
    return D;
  }
  function r(m, D, Y) {
    var Q = D.charCodeAt(0);
    switch (33 > Q && (Q = (D = D.trim()).charCodeAt(0)), Q) {
      case 38:
        return D.replace(I, "$1" + m.trim());
      case 58:
        return m.trim() + D.replace(I, "$1" + m.trim());
      default:
        if (0 < 1 * Y && 0 < D.indexOf("\f"))
          return D.replace(I, (m.charCodeAt(0) === 58 ? "" : "$1") + m.trim());
    }
    return m + D;
  }
  function i(m, D, Y, Q) {
    var G = m + ";", he = 2 * D + 3 * Y + 4 * Q;
    if (he === 944) {
      m = G.indexOf(":", 9) + 1;
      var se = G.substring(m, G.length - 1).trim();
      return se = G.substring(0, m).trim() + se + ";", y === 1 || y === 2 && o(se, 1) ? "-webkit-" + se + se : se;
    }
    if (y === 0 || y === 2 && !o(G, 1))
      return G;
    switch (he) {
      case 1015:
        return G.charCodeAt(10) === 97 ? "-webkit-" + G + G : G;
      case 951:
        return G.charCodeAt(3) === 116 ? "-webkit-" + G + G : G;
      case 963:
        return G.charCodeAt(5) === 110 ? "-webkit-" + G + G : G;
      case 1009:
        if (G.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + G + G;
      case 978:
        return "-webkit-" + G + "-moz-" + G + G;
      case 1019:
      case 983:
        return "-webkit-" + G + "-moz-" + G + "-ms-" + G + G;
      case 883:
        if (G.charCodeAt(8) === 45)
          return "-webkit-" + G + G;
        if (0 < G.indexOf("image-set(", 11))
          return G.replace(C, "$1-webkit-$2") + G;
        break;
      case 932:
        if (G.charCodeAt(4) === 45)
          switch (G.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + G.replace("-grow", "") + "-webkit-" + G + "-ms-" + G.replace("grow", "positive") + G;
            case 115:
              return "-webkit-" + G + "-ms-" + G.replace("shrink", "negative") + G;
            case 98:
              return "-webkit-" + G + "-ms-" + G.replace("basis", "preferred-size") + G;
          }
        return "-webkit-" + G + "-ms-" + G + G;
      case 964:
        return "-webkit-" + G + "-ms-flex-" + G + G;
      case 1023:
        if (G.charCodeAt(8) !== 99)
          break;
        return se = G.substring(G.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + se + "-webkit-" + G + "-ms-flex-pack" + se + G;
      case 1005:
        return g.test(G) ? G.replace(h, ":-webkit-") + G.replace(h, ":-moz-") + G : G;
      case 1e3:
        switch (se = G.substring(13).trim(), D = se.indexOf("-") + 1, se.charCodeAt(0) + se.charCodeAt(D)) {
          case 226:
            se = G.replace(j, "tb");
            break;
          case 232:
            se = G.replace(j, "tb-rl");
            break;
          case 220:
            se = G.replace(j, "lr");
            break;
          default:
            return G;
        }
        return "-webkit-" + G + "-ms-" + se + G;
      case 1017:
        if (G.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (D = (G = m).length - 10, se = (G.charCodeAt(D) === 33 ? G.substring(0, D) : G).substring(m.indexOf(":", 7) + 1).trim(), he = se.charCodeAt(0) + (se.charCodeAt(7) | 0)) {
          case 203:
            if (111 > se.charCodeAt(8))
              break;
          case 115:
            G = G.replace(se, "-webkit-" + se) + ";" + G;
            break;
          case 207:
          case 102:
            G = G.replace(se, "-webkit-" + (102 < he ? "inline-" : "") + "box") + ";" + G.replace(se, "-webkit-" + se) + ";" + G.replace(se, "-ms-" + se + "box") + ";" + G;
        }
        return G + ";";
      case 938:
        if (G.charCodeAt(5) === 45)
          switch (G.charCodeAt(6)) {
            case 105:
              return se = G.replace("-items", ""), "-webkit-" + G + "-webkit-box-" + se + "-ms-flex-" + se + G;
            case 115:
              return "-webkit-" + G + "-ms-flex-item-" + G.replace(O, "") + G;
            default:
              return "-webkit-" + G + "-ms-flex-line-pack" + G.replace("align-content", "").replace(O, "") + G;
          }
        break;
      case 973:
      case 989:
        if (G.charCodeAt(3) !== 45 || G.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (z.test(m) === !0)
          return (se = m.substring(m.indexOf(":") + 1)).charCodeAt(0) === 115 ? i(m.replace("stretch", "fill-available"), D, Y, Q).replace(":fill-available", ":stretch") : G.replace(se, "-webkit-" + se) + G.replace(se, "-moz-" + se.replace("fill-", "")) + G;
        break;
      case 962:
        if (G = "-webkit-" + G + (G.charCodeAt(5) === 102 ? "-ms-" + G : "") + G, Y + Q === 211 && G.charCodeAt(13) === 105 && 0 < G.indexOf("transform", 10))
          return G.substring(0, G.indexOf(";", 27) + 1).replace(w, "$1-webkit-$2") + G;
    }
    return G;
  }
  function o(m, D) {
    var Y = m.indexOf(D === 1 ? ":" : "{"), Q = m.substring(0, D !== 3 ? Y : 10);
    return Y = m.substring(Y + 1, m.length - 1), F(D !== 2 ? Q : Q.replace(k, "$1"), Y, D);
  }
  function a(m, D) {
    var Y = i(D, D.charCodeAt(0), D.charCodeAt(1), D.charCodeAt(2));
    return Y !== D + ";" ? Y.replace(W, " or ($1)").substring(4) : "(" + D + ")";
  }
  function s(m, D, Y, Q, G, he, se, _e, Me, Pe) {
    for (var Be = 0, at = D, Fe; Be < B; ++Be)
      switch (Fe = E[Be].call(u, m, at, Y, Q, G, he, se, _e, Me, Pe)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          at = Fe;
      }
    if (at !== D)
      return at;
  }
  function c(m) {
    switch (m) {
      case void 0:
      case null:
        B = E.length = 0;
        break;
      default:
        if (typeof m == "function")
          E[B++] = m;
        else if (typeof m == "object")
          for (var D = 0, Y = m.length; D < Y; ++D)
            c(m[D]);
        else
          q = !!m | 0;
    }
    return c;
  }
  function l(m) {
    return m = m.prefix, m !== void 0 && (F = null, m ? typeof m != "function" ? y = 1 : (y = 2, F = m) : y = 0), l;
  }
  function u(m, D) {
    var Y = m;
    if (33 > Y.charCodeAt(0) && (Y = Y.trim()), U = Y, Y = [U], 0 < B) {
      var Q = s(-1, D, Y, Y, S, M, 0, 0, 0, 0);
      Q !== void 0 && typeof Q == "string" && (D = Q);
    }
    var G = t(v, Y, D, 0, 0);
    return 0 < B && (Q = s(-2, G, Y, Y, S, M, G.length, 0, 0, 0), Q !== void 0 && (G = Q)), U = "", p = 0, M = S = 1, G;
  }
  var f = /^\0+/g, d = /[\0\r\f]/g, h = /: */g, g = /zoo|gra/, w = /([,: ])(transform)/g, b = /,\r+?/g, I = /([\t\r\n ])*\f?&/g, A = /@(k\w+)\s*(\S*)\s*/, x = /::(place)/g, N = /:(read-only)/g, j = /[svh]\w+-[tblr]{2}/, K = /\(\s*(.*)\s*\)/g, W = /([\s\S]*?);/g, O = /-self|flex-/g, k = /[^]*?(:[rp][el]a[\w-]+)[^]*/, z = /stretch|:\s*\w+\-(?:conte|avail)/, C = /([^-])(image-set\()/, M = 1, S = 1, p = 0, y = 1, v = [], E = [], B = 0, F = null, q = 0, U = "";
  return u.use = c, u.set = l, e !== void 0 && l(e), u;
}
var o4 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function a4(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var s4 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, lx = /* @__PURE__ */ a4(
  function(e) {
    return s4.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), c3 = { exports: {} }, Dn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wr = typeof Symbol == "function" && Symbol.for, SI = Wr ? Symbol.for("react.element") : 60103, EI = Wr ? Symbol.for("react.portal") : 60106, _m = Wr ? Symbol.for("react.fragment") : 60107, wm = Wr ? Symbol.for("react.strict_mode") : 60108, vm = Wr ? Symbol.for("react.profiler") : 60114, Sm = Wr ? Symbol.for("react.provider") : 60109, Em = Wr ? Symbol.for("react.context") : 60110, AI = Wr ? Symbol.for("react.async_mode") : 60111, Am = Wr ? Symbol.for("react.concurrent_mode") : 60111, Im = Wr ? Symbol.for("react.forward_ref") : 60112, km = Wr ? Symbol.for("react.suspense") : 60113, c4 = Wr ? Symbol.for("react.suspense_list") : 60120, Tm = Wr ? Symbol.for("react.memo") : 60115, xm = Wr ? Symbol.for("react.lazy") : 60116, u4 = Wr ? Symbol.for("react.block") : 60121, l4 = Wr ? Symbol.for("react.fundamental") : 60117, f4 = Wr ? Symbol.for("react.responder") : 60118, d4 = Wr ? Symbol.for("react.scope") : 60119;
function qi(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case SI:
        switch (e = e.type, e) {
          case AI:
          case Am:
          case _m:
          case vm:
          case wm:
          case km:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Em:
              case Im:
              case xm:
              case Tm:
              case Sm:
                return e;
              default:
                return t;
            }
        }
      case EI:
        return t;
    }
  }
}
function u3(e) {
  return qi(e) === Am;
}
Dn.AsyncMode = AI;
Dn.ConcurrentMode = Am;
Dn.ContextConsumer = Em;
Dn.ContextProvider = Sm;
Dn.Element = SI;
Dn.ForwardRef = Im;
Dn.Fragment = _m;
Dn.Lazy = xm;
Dn.Memo = Tm;
Dn.Portal = EI;
Dn.Profiler = vm;
Dn.StrictMode = wm;
Dn.Suspense = km;
Dn.isAsyncMode = function(e) {
  return u3(e) || qi(e) === AI;
};
Dn.isConcurrentMode = u3;
Dn.isContextConsumer = function(e) {
  return qi(e) === Em;
};
Dn.isContextProvider = function(e) {
  return qi(e) === Sm;
};
Dn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === SI;
};
Dn.isForwardRef = function(e) {
  return qi(e) === Im;
};
Dn.isFragment = function(e) {
  return qi(e) === _m;
};
Dn.isLazy = function(e) {
  return qi(e) === xm;
};
Dn.isMemo = function(e) {
  return qi(e) === Tm;
};
Dn.isPortal = function(e) {
  return qi(e) === EI;
};
Dn.isProfiler = function(e) {
  return qi(e) === vm;
};
Dn.isStrictMode = function(e) {
  return qi(e) === wm;
};
Dn.isSuspense = function(e) {
  return qi(e) === km;
};
Dn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === _m || e === Am || e === vm || e === wm || e === km || e === c4 || typeof e == "object" && e !== null && (e.$$typeof === xm || e.$$typeof === Tm || e.$$typeof === Sm || e.$$typeof === Em || e.$$typeof === Im || e.$$typeof === l4 || e.$$typeof === f4 || e.$$typeof === d4 || e.$$typeof === u4);
};
Dn.typeOf = qi;
c3.exports = Dn;
var h4 = c3.exports, II = h4, p4 = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, y4 = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, g4 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, l3 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, kI = {};
kI[II.ForwardRef] = g4;
kI[II.Memo] = l3;
function fx(e) {
  return II.isMemo(e) ? l3 : kI[e.$$typeof] || p4;
}
var b4 = Object.defineProperty, m4 = Object.getOwnPropertyNames, dx = Object.getOwnPropertySymbols, _4 = Object.getOwnPropertyDescriptor, w4 = Object.getPrototypeOf, hx = Object.prototype;
function f3(e, t, n) {
  if (typeof t != "string") {
    if (hx) {
      var r = w4(t);
      r && r !== hx && f3(e, r, n);
    }
    var i = m4(t);
    dx && (i = i.concat(dx(t)));
    for (var o = fx(e), a = fx(t), s = 0; s < i.length; ++s) {
      var c = i[s];
      if (!y4[c] && !(n && n[c]) && !(a && a[c]) && !(o && o[c])) {
        var l = _4(t, c);
        try {
          b4(e, c, l);
        } catch {
        }
      }
    }
  }
  return e;
}
var v4 = f3;
const d3 = /* @__PURE__ */ Vi(v4);
function Li() {
  return (Li = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var px = function(e, t) {
  for (var n = [e[0]], r = 0, i = t.length; r < i; r += 1)
    n.push(t[r], e[r + 1]);
  return n;
}, EE = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !s3.typeOf(e);
}, Eb = Object.freeze([]), Bs = Object.freeze({});
function nl(e) {
  return typeof e == "function";
}
function AE(e) {
  return e.displayName || e.name || "Component";
}
function Mm(e) {
  return e && typeof e.styledComponentId == "string";
}
var Ks = typeof process < "u" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", S4 = "5.3.6", TI = typeof window < "u" && "HTMLElement" in window, E4 = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" && process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY), A4 = {};
function ko(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var I4 = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(n) {
    for (var r = 0, i = 0; i < n; i++)
      r += this.groupSizes[i];
    return r;
  }, t.insertRules = function(n, r) {
    if (n >= this.groupSizes.length) {
      for (var i = this.groupSizes, o = i.length, a = o; n >= a; )
        (a <<= 1) < 0 && ko(16, "" + n);
      this.groupSizes = new Uint32Array(a), this.groupSizes.set(i), this.length = a;
      for (var s = o; s < a; s++)
        this.groupSizes[s] = 0;
    }
    for (var c = this.indexOfGroup(n + 1), l = 0, u = r.length; l < u; l++)
      this.tag.insertRule(c, r[l]) && (this.groupSizes[n]++, c++);
  }, t.clearGroup = function(n) {
    if (n < this.length) {
      var r = this.groupSizes[n], i = this.indexOfGroup(n), o = i + r;
      this.groupSizes[n] = 0;
      for (var a = i; a < o; a++)
        this.tag.deleteRule(i);
    }
  }, t.getGroup = function(n) {
    var r = "";
    if (n >= this.length || this.groupSizes[n] === 0)
      return r;
    for (var i = this.groupSizes[n], o = this.indexOfGroup(n), a = o + i, s = o; s < a; s++)
      r += this.tag.getRule(s) + `/*!sc*/
`;
    return r;
  }, e;
}(), Xg = /* @__PURE__ */ new Map(), Ab = /* @__PURE__ */ new Map(), Nf = 1, Q0 = function(e) {
  if (Xg.has(e))
    return Xg.get(e);
  for (; Ab.has(Nf); )
    Nf++;
  var t = Nf++;
  return Xg.set(e, t), Ab.set(t, e), t;
}, k4 = function(e) {
  return Ab.get(e);
}, T4 = function(e, t) {
  t >= Nf && (Nf = t + 1), Xg.set(e, t), Ab.set(t, e);
}, x4 = "style[" + Ks + '][data-styled-version="5.3.6"]', M4 = new RegExp("^" + Ks + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), O4 = function(e, t, n) {
  for (var r, i = n.split(","), o = 0, a = i.length; o < a; o++)
    (r = i[o]) && e.registerName(t, r);
}, P4 = function(e, t) {
  for (var n = (t.textContent || "").split(`/*!sc*/
`), r = [], i = 0, o = n.length; i < o; i++) {
    var a = n[i].trim();
    if (a) {
      var s = a.match(M4);
      if (s) {
        var c = 0 | parseInt(s[1], 10), l = s[2];
        c !== 0 && (T4(l, c), O4(e, l, s[3]), e.getTag().insertRules(c, r)), r.length = 0;
      } else
        r.push(a);
    }
  }
}, IE = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, h3 = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), i = function(s) {
    for (var c = s.childNodes, l = c.length; l >= 0; l--) {
      var u = c[l];
      if (u && u.nodeType === 1 && u.hasAttribute(Ks))
        return u;
    }
  }(n), o = i !== void 0 ? i.nextSibling : null;
  r.setAttribute(Ks, "active"), r.setAttribute("data-styled-version", "5.3.6");
  var a = IE();
  return a && r.setAttribute("nonce", a), n.insertBefore(r, o), r;
}, B4 = function() {
  function e(n) {
    var r = this.element = h3(n);
    r.appendChild(document.createTextNode("")), this.sheet = function(i) {
      if (i.sheet)
        return i.sheet;
      for (var o = document.styleSheets, a = 0, s = o.length; a < s; a++) {
        var c = o[a];
        if (c.ownerNode === i)
          return c;
      }
      ko(17);
    }(r), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    try {
      return this.sheet.insertRule(r, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, t.getRule = function(n) {
    var r = this.sheet.cssRules[n];
    return r !== void 0 && typeof r.cssText == "string" ? r.cssText : "";
  }, e;
}(), C4 = function() {
  function e(n) {
    var r = this.element = h3(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    if (n <= this.length && n >= 0) {
      var i = document.createTextNode(r), o = this.nodes[n];
      return this.element.insertBefore(i, o || null), this.length++, !0;
    }
    return !1;
  }, t.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), D4 = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    return n <= this.length && (this.rules.splice(n, 0, r), this.length++, !0);
  }, t.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), yx = TI, R4 = { isServer: !TI, useCSSOMInjection: !E4 }, rl = function() {
  function e(n, r, i) {
    n === void 0 && (n = Bs), r === void 0 && (r = {}), this.options = Li({}, R4, {}, n), this.gs = r, this.names = new Map(i), this.server = !!n.isServer, !this.server && TI && yx && (yx = !1, function(o) {
      for (var a = document.querySelectorAll(x4), s = 0, c = a.length; s < c; s++) {
        var l = a[s];
        l && l.getAttribute(Ks) !== "active" && (P4(o, l), l.parentNode && l.parentNode.removeChild(l));
      }
    }(this));
  }
  e.registerId = function(n) {
    return Q0(n);
  };
  var t = e.prototype;
  return t.reconstructWithOptions = function(n, r) {
    return r === void 0 && (r = !0), new e(Li({}, this.options, {}, n), this.gs, r && this.names || void 0);
  }, t.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = (i = (r = this.options).isServer, o = r.useCSSOMInjection, a = r.target, n = i ? new D4(a) : o ? new B4(a) : new C4(a), new I4(n)));
    var n, r, i, o, a;
  }, t.hasNameForId = function(n, r) {
    return this.names.has(n) && this.names.get(n).has(r);
  }, t.registerName = function(n, r) {
    if (Q0(n), this.names.has(n))
      this.names.get(n).add(r);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(r), this.names.set(n, i);
    }
  }, t.insertRules = function(n, r, i) {
    this.registerName(n, r), this.getTag().insertRules(Q0(n), i);
  }, t.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, t.clearRules = function(n) {
    this.getTag().clearGroup(Q0(n)), this.clearNames(n);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return function(n) {
      for (var r = n.getTag(), i = r.length, o = "", a = 0; a < i; a++) {
        var s = k4(a);
        if (s !== void 0) {
          var c = n.names.get(s), l = r.getGroup(a);
          if (c && l && c.size) {
            var u = Ks + ".g" + a + '[id="' + s + '"]', f = "";
            c !== void 0 && c.forEach(function(d) {
              d.length > 0 && (f += d + ",");
            }), o += "" + l + u + '{content:"' + f + `"}/*!sc*/
`;
          }
        }
      }
      return o;
    }(this);
  }, e;
}(), N4 = /(a)(d)/gi, gx = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function kE(e) {
  var t, n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0)
    n = gx(t % 52) + n;
  return (gx(t % 52) + n).replace(N4, "$1-$2");
}
var Bu = function(e, t) {
  for (var n = t.length; n; )
    e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, p3 = function(e) {
  return Bu(5381, e);
};
function y3(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (nl(n) && !Mm(n))
      return !1;
  }
  return !0;
}
var j4 = p3("5.3.6"), U4 = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = (r === void 0 || r.isStatic) && y3(t), this.componentId = n, this.baseHash = Bu(j4, n), this.baseStyle = r, rl.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var i = this.componentId, o = [];
    if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(t, n, r)), this.isStatic && !r.hash)
      if (this.staticRulesId && n.hasNameForId(i, this.staticRulesId))
        o.push(this.staticRulesId);
      else {
        var a = kc(this.rules, t, n, r).join(""), s = kE(Bu(this.baseHash, a) >>> 0);
        if (!n.hasNameForId(i, s)) {
          var c = r(a, "." + s, void 0, i);
          n.insertRules(i, s, c);
        }
        o.push(s), this.staticRulesId = s;
      }
    else {
      for (var l = this.rules.length, u = Bu(this.baseHash, r.hash), f = "", d = 0; d < l; d++) {
        var h = this.rules[d];
        if (typeof h == "string")
          f += h;
        else if (h) {
          var g = kc(h, t, n, r), w = Array.isArray(g) ? g.join("") : g;
          u = Bu(u, w + d), f += w;
        }
      }
      if (f) {
        var b = kE(u >>> 0);
        if (!n.hasNameForId(i, b)) {
          var I = r(f, "." + b, void 0, i);
          n.insertRules(i, b, I);
        }
        o.push(b);
      }
    }
    return o.join(" ");
  }, e;
}(), z4 = /^\s*\/\/.*$/gm, F4 = [":", "[", ".", "#"];
function g3(e) {
  var t, n, r, i, o = e === void 0 ? Bs : e, a = o.options, s = a === void 0 ? Bs : a, c = o.plugins, l = c === void 0 ? Eb : c, u = new i4(s), f = [], d = function(w) {
    function b(I) {
      if (I)
        try {
          w(I + "}");
        } catch {
        }
    }
    return function(I, A, x, N, j, K, W, O, k, z) {
      switch (I) {
        case 1:
          if (k === 0 && A.charCodeAt(0) === 64)
            return w(A + ";"), "";
          break;
        case 2:
          if (O === 0)
            return A + "/*|*/";
          break;
        case 3:
          switch (O) {
            case 102:
            case 112:
              return w(x[0] + A), "";
            default:
              return A + (z === 0 ? "/*|*/" : "");
          }
        case -2:
          A.split("/*|*/}").forEach(b);
      }
    };
  }(function(w) {
    f.push(w);
  }), h = function(w, b, I) {
    return b === 0 && F4.indexOf(I[n.length]) !== -1 || I.match(i) ? w : "." + t;
  };
  function g(w, b, I, A) {
    A === void 0 && (A = "&");
    var x = w.replace(z4, ""), N = b && I ? I + " " + b + " { " + x + " }" : x;
    return t = A, n = b, r = new RegExp("\\" + n + "\\b", "g"), i = new RegExp("(\\" + n + "\\b){2,}"), u(I || !b ? "" : b, N);
  }
  return u.use([].concat(l, [function(w, b, I) {
    w === 2 && I.length && I[0].lastIndexOf(n) > 0 && (I[0] = I[0].replace(r, h));
  }, d, function(w) {
    if (w === -2) {
      var b = f;
      return f = [], b;
    }
  }])), g.hash = l.length ? l.reduce(function(w, b) {
    return b.name || ko(15), Bu(w, b.name);
  }, 5381).toString() : "", g;
}
var Om = vr.createContext(), L4 = Om.Consumer, xI = vr.createContext(), b3 = (xI.Consumer, new rl()), TE = g3();
function MI() {
  return ln(Om) || b3;
}
function m3() {
  return ln(xI) || TE;
}
function _3(e) {
  var t = pr(e.stylisPlugins), n = t[0], r = t[1], i = MI(), o = jo(function() {
    var s = i;
    return e.sheet ? s = e.sheet : e.target && (s = s.reconstructWithOptions({ target: e.target }, !1)), e.disableCSSOMInjection && (s = s.reconstructWithOptions({ useCSSOMInjection: !1 })), s;
  }, [e.disableCSSOMInjection, e.sheet, e.target]), a = jo(function() {
    return g3({ options: { prefix: !e.disableVendorPrefixes }, plugins: n });
  }, [e.disableVendorPrefixes, n]);
  return Ht(function() {
    r4(n, e.stylisPlugins) || r(e.stylisPlugins);
  }, [e.stylisPlugins]), vr.createElement(Om.Provider, { value: o }, vr.createElement(xI.Provider, { value: a }, e.children));
}
var w3 = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(i, o) {
      o === void 0 && (o = TE);
      var a = r.name + o.hash;
      i.hasNameForId(r.id, a) || i.insertRules(r.id, a, o(r.rules, a, "@keyframes"));
    }, this.toString = function() {
      return ko(12, String(r.name));
    }, this.name = t, this.id = "sc-keyframes-" + t, this.rules = n;
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = TE), this.name + t.hash;
  }, e;
}(), $4 = /([A-Z])/, W4 = /([A-Z])/g, K4 = /^ms-/, V4 = function(e) {
  return "-" + e.toLowerCase();
};
function bx(e) {
  return $4.test(e) ? e.replace(W4, V4).replace(K4, "-ms-") : e;
}
var mx = function(e) {
  return e == null || e === !1 || e === "";
};
function kc(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var i, o = [], a = 0, s = e.length; a < s; a += 1)
      (i = kc(e[a], t, n, r)) !== "" && (Array.isArray(i) ? o.push.apply(o, i) : o.push(i));
    return o;
  }
  if (mx(e))
    return "";
  if (Mm(e))
    return "." + e.styledComponentId;
  if (nl(e)) {
    if (typeof (l = e) != "function" || l.prototype && l.prototype.isReactComponent || !t)
      return e;
    var c = e(t);
    return kc(c, t, n, r);
  }
  var l;
  return e instanceof w3 ? n ? (e.inject(n, r), e.getName(r)) : e : EE(e) ? function u(f, d) {
    var h, g, w = [];
    for (var b in f)
      f.hasOwnProperty(b) && !mx(f[b]) && (Array.isArray(f[b]) && f[b].isCss || nl(f[b]) ? w.push(bx(b) + ":", f[b], ";") : EE(f[b]) ? w.push.apply(w, u(f[b], b)) : w.push(bx(b) + ": " + (h = b, (g = f[b]) == null || typeof g == "boolean" || g === "" ? "" : typeof g != "number" || g === 0 || h in o4 ? String(g).trim() : g + "px") + ";"));
    return d ? [d + " {"].concat(w, ["}"]) : w;
  }(e) : e.toString();
}
var _x = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function ir(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return nl(e) || EE(e) ? _x(kc(px(Eb, [e].concat(n)))) : n.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : _x(kc(px(e, n)));
}
var OI = function(e, t, n) {
  return n === void 0 && (n = Bs), e.theme !== n.theme && e.theme || t || n.theme;
}, q4 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, H4 = /(^-|-$)/g;
function sv(e) {
  return e.replace(q4, "-").replace(H4, "");
}
var PI = function(e) {
  return kE(p3(e) >>> 0);
};
function eg(e) {
  return typeof e == "string" && !0;
}
var xE = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, G4 = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function Y4(e, t, n) {
  var r = e[n];
  xE(t) && xE(r) ? v3(r, t) : e[n] = t;
}
function v3(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  for (var i = 0, o = n; i < o.length; i++) {
    var a = o[i];
    if (xE(a))
      for (var s in a)
        G4(s) && Y4(e, a[s], s);
  }
  return e;
}
var Vs = vr.createContext(), Z4 = Vs.Consumer;
function J4(e) {
  var t = ln(Vs), n = jo(function() {
    return function(r, i) {
      if (!r)
        return ko(14);
      if (nl(r)) {
        var o = r(i);
        return o;
      }
      return Array.isArray(r) || typeof r != "object" ? ko(8) : i ? Li({}, i, {}, r) : r;
    }(e.theme, t);
  }, [e.theme, t]);
  return e.children ? vr.createElement(Vs.Provider, { value: n }, e.children) : null;
}
var cv = {};
function S3(e, t, n) {
  var r = Mm(e), i = !eg(e), o = t.attrs, a = o === void 0 ? Eb : o, s = t.componentId, c = s === void 0 ? function(A, x) {
    var N = typeof A != "string" ? "sc" : sv(A);
    cv[N] = (cv[N] || 0) + 1;
    var j = N + "-" + PI("5.3.6" + N + cv[N]);
    return x ? x + "-" + j : j;
  }(t.displayName, t.parentComponentId) : s, l = t.displayName, u = l === void 0 ? function(A) {
    return eg(A) ? "styled." + A : "Styled(" + AE(A) + ")";
  }(e) : l, f = t.displayName && t.componentId ? sv(t.displayName) + "-" + t.componentId : t.componentId || c, d = r && e.attrs ? Array.prototype.concat(e.attrs, a).filter(Boolean) : a, h = t.shouldForwardProp;
  r && e.shouldForwardProp && (h = t.shouldForwardProp ? function(A, x, N) {
    return e.shouldForwardProp(A, x, N) && t.shouldForwardProp(A, x, N);
  } : e.shouldForwardProp);
  var g, w = new U4(n, f, r ? e.componentStyle : void 0), b = w.isStatic && a.length === 0, I = function(A, x) {
    return function(N, j, K, W) {
      var O = N.attrs, k = N.componentStyle, z = N.defaultProps, C = N.foldedComponentIds, M = N.shouldForwardProp, S = N.styledComponentId, p = N.target, y = function(Q, G, he) {
        Q === void 0 && (Q = Bs);
        var se = Li({}, G, { theme: Q }), _e = {};
        return he.forEach(function(Me) {
          var Pe, Be, at, Fe = Me;
          for (Pe in nl(Fe) && (Fe = Fe(se)), Fe)
            se[Pe] = _e[Pe] = Pe === "className" ? (Be = _e[Pe], at = Fe[Pe], Be && at ? Be + " " + at : Be || at) : Fe[Pe];
        }), [se, _e];
      }(OI(j, ln(Vs), z) || Bs, j, O), v = y[0], E = y[1], B = function(Q, G, he, se) {
        var _e = MI(), Me = m3(), Pe = G ? Q.generateAndInjectStyles(Bs, _e, Me) : Q.generateAndInjectStyles(he, _e, Me);
        return Pe;
      }(k, W, v), F = K, q = E.$as || j.$as || E.as || j.as || p, U = eg(q), m = E !== j ? Li({}, j, {}, E) : j, D = {};
      for (var Y in m)
        Y[0] !== "$" && Y !== "as" && (Y === "forwardedAs" ? D.as = m[Y] : (M ? M(Y, lx, q) : !U || lx(Y)) && (D[Y] = m[Y]));
      return j.style && E.style !== j.style && (D.style = Li({}, j.style, {}, E.style)), D.className = Array.prototype.concat(C, S, B !== S ? B : null, j.className, E.className).filter(Boolean).join(" "), D.ref = F, LU(q, D);
    }(g, A, x, b);
  };
  return I.displayName = u, (g = vr.forwardRef(I)).attrs = d, g.componentStyle = w, g.displayName = u, g.shouldForwardProp = h, g.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : Eb, g.styledComponentId = f, g.target = r ? e.target : e, g.withComponent = function(A) {
    var x = t.componentId, N = function(K, W) {
      if (K == null)
        return {};
      var O, k, z = {}, C = Object.keys(K);
      for (k = 0; k < C.length; k++)
        O = C[k], W.indexOf(O) >= 0 || (z[O] = K[O]);
      return z;
    }(t, ["componentId"]), j = x && x + "-" + (eg(A) ? A : sv(AE(A)));
    return S3(A, Li({}, N, { attrs: d, componentId: j }), n);
  }, Object.defineProperty(g, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(A) {
    this._foldedDefaultProps = r ? v3({}, e.defaultProps, A) : A;
  } }), g.toString = function() {
    return "." + g.styledComponentId;
  }, i && d3(g, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), g;
}
var ME = function(e) {
  return function t(n, r, i) {
    if (i === void 0 && (i = Bs), !s3.isValidElementType(r))
      return ko(1, String(r));
    var o = function() {
      return n(r, i, ir.apply(void 0, arguments));
    };
    return o.withConfig = function(a) {
      return t(n, r, Li({}, i, {}, a));
    }, o.attrs = function(a) {
      return t(n, r, Li({}, i, { attrs: Array.prototype.concat(i.attrs, a).filter(Boolean) }));
    }, o;
  }(S3, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  ME[e] = ME(e);
});
var X4 = function() {
  function e(n, r) {
    this.rules = n, this.componentId = r, this.isStatic = y3(n), rl.registerId(this.componentId + 1);
  }
  var t = e.prototype;
  return t.createStyles = function(n, r, i, o) {
    var a = o(kc(this.rules, r, i, o).join(""), ""), s = this.componentId + n;
    i.insertRules(s, s, a);
  }, t.removeStyles = function(n, r) {
    r.clearRules(this.componentId + n);
  }, t.renderStyles = function(n, r, i, o) {
    n > 2 && rl.registerId(this.componentId + n), this.removeStyles(n, i), this.createStyles(n, r, i, o);
  }, e;
}();
function E3(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var i = ir.apply(void 0, [e].concat(n)), o = "sc-global-" + PI(JSON.stringify(i)), a = new X4(i, o);
  function s(l) {
    var u = MI(), f = m3(), d = ln(Vs), h = ya(u.allocateGSInstance(o)).current;
    return u.server && c(h, l, u, d, f), Sb(function() {
      if (!u.server)
        return c(h, l, u, d, f), function() {
          return a.removeStyles(h, u);
        };
    }, [h, l, u, d, f]), null;
  }
  function c(l, u, f, d, h) {
    if (a.isStatic)
      a.renderStyles(l, A4, f, h);
    else {
      var g = Li({}, u, { theme: OI(u, d, s.defaultProps) });
      a.renderStyles(l, g, f, h);
    }
  }
  return vr.memo(s);
}
function A3(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var i = ir.apply(void 0, [e].concat(n)).join(""), o = PI(i);
  return new w3(o, i);
}
var Q4 = function() {
  function e() {
    var n = this;
    this._emitSheetCSS = function() {
      var r = n.instance.toString();
      if (!r)
        return "";
      var i = IE();
      return "<style " + [i && 'nonce="' + i + '"', Ks + '="true"', 'data-styled-version="5.3.6"'].filter(Boolean).join(" ") + ">" + r + "</style>";
    }, this.getStyleTags = function() {
      return n.sealed ? ko(2) : n._emitSheetCSS();
    }, this.getStyleElement = function() {
      var r;
      if (n.sealed)
        return ko(2);
      var i = ((r = {})[Ks] = "", r["data-styled-version"] = "5.3.6", r.dangerouslySetInnerHTML = { __html: n.instance.toString() }, r), o = IE();
      return o && (i.nonce = o), [vr.createElement("style", Li({}, i, { key: "sc-0-0" }))];
    }, this.seal = function() {
      n.sealed = !0;
    }, this.instance = new rl({ isServer: !0 }), this.sealed = !1;
  }
  var t = e.prototype;
  return t.collectStyles = function(n) {
    return this.sealed ? ko(2) : vr.createElement(_3, { sheet: this.instance }, n);
  }, t.interleaveWithNodeStream = function(n) {
    return ko(3);
  }, e;
}(), ez = function(e) {
  var t = vr.forwardRef(function(n, r) {
    var i = ln(Vs), o = e.defaultProps, a = OI(n, i, o);
    return vr.createElement(e, Li({}, n, { theme: a, ref: r }));
  });
  return d3(t, e), t.displayName = "WithTheme(" + AE(e) + ")", t;
}, tz = function() {
  return ln(Vs);
}, nz = { StyleSheet: rl, masterSheet: b3 };
const Ge = ME, rz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ServerStyleSheet: Q4,
  StyleSheetConsumer: L4,
  StyleSheetContext: Om,
  StyleSheetManager: _3,
  ThemeConsumer: Z4,
  ThemeContext: Vs,
  ThemeProvider: J4,
  __PRIVATE__: nz,
  createGlobalStyle: E3,
  css: ir,
  default: Ge,
  isStyledComponent: Mm,
  keyframes: A3,
  useTheme: tz,
  version: S4,
  withTheme: ez
}, Symbol.toStringTag, { value: "Module" })), wx = Ge.div`
  font-size: 12px;

  --kyc-sdk-primary-font: neue-machina;
  --kyc-sdk-cybergreen: #00ffb3;
  --kyc-sdk-cybergreen-35: rgba(0, 255, 177, 0.35);
  --kyc-sdk-cybergreen-50: rgba(0, 255, 177, 0.5);
  --darken-green: #0af292;

  --kyc-sdk-normal-blue: #3a4be9;
  --kyc-sdk-dark-blue: #181f60;
  --kyc-sdk-dark-purple: #21114a;
  --kyc-sdk-green: #03f682;
  --kyc-sdk-green-darken: #0bcb77;
  --kyc-sdk-dark-green: #09b678;
  --kyc-sdk-cyberpunk: #72f9d1;
  --kyc-sdk-red: #ff4646;
  --kyc-sdk-red-darken: #d51f4f;

  --kyc-sdk-border: rgba(24, 31, 96, 0.05);
  --steps-padding: 2rem;
  --kyc-sdk-border-radius-full: 999rem;
  --kyc-sdk-border-radius-light: 5px;
  --kyc-sdk-inactive: #d7d9df;

  --kyc-sdk-button-height: 3rem;
  --kyc-sdk-header-height: 64px;
  --kyc-sdk-unit: 4.166666666666667vw;
  --kyc-sdk-connect-button-width: 19rem;

  --kyc-sdk-normal-blue-75: rgba(58, 75, 233, 0.75);
  --kyc-sdk-normal-blue-50: rgba(58, 75, 233, 0.5);
  --kyc-sdk-normal-blue-35: rgba(58, 75, 233, 0.35);
  --kyc-sdk-normal-blue-15: rgba(58, 75, 233, 0.15);

  --kyc-sdk-dark-blue-35: rgba(24, 31, 96, 0.35);
  --kyc-sdk-dark-blue-50: rgba(24, 31, 96, 0.5);
  --kyc-sdk-dark-blue-75: rgba(24, 31, 96, 0.75);

  --kyc-sdk-green-35: rgba(3, 246, 13, 0.35);
  --kyc-sdk-green-50: rgba(3, 246, 13, 0.5);
  --kyc-sdk-green-75: rgba(3, 246, 13, 0.75);

  --kyc-sdk-cyberpunk-15: rgba(144, 249, 209, 0.15);
  --kyc-sdk-cyberpunk-35: rgba(144, 249, 209, 0.35);
  --kyc-sdk-cyberpunk-50: rgba(144, 249, 209, 0.5);

  --kyc-sdk-red-35: rgba(255, 70, 70, 0.35);

  --light-font: gilroyLight;
  --display-font: gilroyBold;

  @font-face {
    font-family: gilroy-bold;
    font-style: normal;
    font-weight: 400;
    src: local("Gilroy-Bold"),
      url(https://fonts.cdnfonts.com/s/16219/Gilroy-Bold.woff) format("woff");
  }
  @font-face {
    font-family: gilroy-heavy;
    font-style: normal;
    font-weight: 400;
    src: local("Gilroy-Heavy"),
      url(https://fonts.cdnfonts.com/s/16219/Gilroy-Heavy.woff) format("woff");
  }
  @font-face {
    font-family: gilroy-light;
    font-style: normal;
    font-weight: 400;
    src: local("Gilroy-Light"),
      url(https://fonts.cdnfonts.com/s/16219/Gilroy-Light.woff) format("woff");
  }
  @font-face {
    font-family: gilroy-medium;
    font-style: normal;
    font-weight: 400;
    src: local("Gilroy-Medium"),
      url(https://fonts.cdnfonts.com/s/16219/Gilroy-Medium.woff) format("woff");
  }
  @font-face {
    font-family: gilroy-regular;
    font-style: normal;
    font-weight: 400;
    src: local("Gilroy-Regular"),
      url(https://fonts.cdnfonts.com/s/16219/Gilroy-Regular.woff) format("woff");
  }

  @font-face {
    font-family: itc avant garde gothic std book;
    font-style: normal;
    font-weight: 300;
    src: local("ITC Avant Garde Gothic Std Book"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-book-58957161d80eb.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std extra light;
    font-style: normal;
    font-weight: 275;
    src: local("ITC Avant Garde Gothic Std Extra Light"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-extra-light-5895708744eb6.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std extra light condensed;
    font-style: normal;
    font-weight: 275;
    src: local("ITC Avant Garde Gothic Std Extra Light Condensed"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-extra-light-condensed-589570b606f66.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std;
    font-style: italic;
    font-weight: 275;
    src: local("ITC Avant Garde Gothic Std"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-extra-light-oblique-5895712c301f0.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std book condensed;
    font-style: normal;
    font-weight: 300;
    src: local("ITC Avant Garde Gothic Std Book Condensed"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-book-condensed-5895704105b51.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std;
    font-style: italic;
    font-weight: 300;
    src: local("ITC Avant Garde Gothic Std"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-book-condensed-oblique-589570ed92a2c.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std;
    font-style: italic;
    font-weight: 300;
    src: local("ITC Avant Garde Gothic Std"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-book-oblique-589571c924212.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std medium condensed;
    font-style: normal;
    font-weight: 500;
    src: local("ITC Avant Garde Gothic Std Medium Condensed"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-medium-condensed-5895720edc668.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std demi;
    font-style: normal;
    font-weight: 600;
    src: local("ITC Avant Garde Gothic Std Demi"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-demi-589572a199962.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std demi condensed;
    font-style: normal;
    font-weight: 600;
    src: local("ITC Avant Garde Gothic Std Demi Condensed"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-demi-condensed-589571f095e47.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std;
    font-style: italic;
    font-weight: 600;
    src: local("ITC Avant Garde Gothic Std"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-demi-condensed-oblique-5895723d52f87.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std bold;
    font-style: normal;
    font-weight: 700;
    src: local("ITC Avant Garde Gothic Std Bold"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-bold-589572c7e9955.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std bold condensed;
    font-style: normal;
    font-weight: 700;
    src: local("ITC Avant Garde Gothic Std Bold Condensed"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-bold-condensed-5895705e8fe31.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std;
    font-style: italic;
    font-weight: 700;
    src: local("ITC Avant Garde Gothic Std"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-bold-condensed-oblique-5895710fb8537.woff)
        format("woff");
  }
  @font-face {
    font-family: itc avant garde gothic std;
    font-style: italic;
    font-weight: 700;
    src: local("ITC Avant Garde Gothic Std"),
      url(https://fonts.cdnfonts.com/s/14411/itc-avant-garde-gothic-std-bold-oblique-589573024abd6.woff)
        format("woff");
  }

  /* fallback */
  @font-face {
    font-family: Material Icons;
    font-style: normal;
    font-weight: 400;
    src: url(https://fonts.gstatic.com/s/materialicons/v139/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2)
      format("woff2");
    font-display: block;
  }

  .material-icons {
    font-family: Material Icons;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    font-feature-settings: liga;
    -webkit-font-smoothing: antialiased;
  }
`;
var OE = function(e, t) {
  return OE = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, OE(e, t);
};
function Pm(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  OE(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function PE(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Ib(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}
function kb(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, o; r < i; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function za(e) {
  return typeof e == "function";
}
function I3(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var uv = I3(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, i) {
      return i + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function BE(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var Bm = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, i, o;
    if (!this.closed) {
      this.closed = !0;
      var a = this._parentage;
      if (a)
        if (this._parentage = null, Array.isArray(a))
          try {
            for (var s = PE(a), c = s.next(); !c.done; c = s.next()) {
              var l = c.value;
              l.remove(this);
            }
          } catch (w) {
            t = { error: w };
          } finally {
            try {
              c && !c.done && (n = s.return) && n.call(s);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          a.remove(this);
      var u = this.initialTeardown;
      if (za(u))
        try {
          u();
        } catch (w) {
          o = w instanceof uv ? w.errors : [w];
        }
      var f = this._finalizers;
      if (f) {
        this._finalizers = null;
        try {
          for (var d = PE(f), h = d.next(); !h.done; h = d.next()) {
            var g = h.value;
            try {
              vx(g);
            } catch (w) {
              o = o ?? [], w instanceof uv ? o = kb(kb([], Ib(o)), Ib(w.errors)) : o.push(w);
            }
          }
        } catch (w) {
          r = { error: w };
        } finally {
          try {
            h && !h.done && (i = d.return) && i.call(d);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (o)
        throw new uv(o);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        vx(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && BE(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && BE(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}(), k3 = Bm.EMPTY;
function T3(e) {
  return e instanceof Bm || e && "closed" in e && za(e.remove) && za(e.add) && za(e.unsubscribe);
}
function vx(e) {
  za(e) ? e() : e.unsubscribe();
}
var x3 = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, CE = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    var i = CE.delegate;
    return i != null && i.setTimeout ? i.setTimeout.apply(i, kb([e, t], Ib(n))) : setTimeout.apply(void 0, kb([e, t], Ib(n)));
  },
  clearTimeout: function(e) {
    var t = CE.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function iz(e) {
  CE.setTimeout(function() {
    throw e;
  });
}
function Sx() {
}
function Qg(e) {
  e();
}
var M3 = function(e) {
  Pm(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, T3(n) && n.add(r)) : r.destination = cz, r;
  }
  return t.create = function(n, r, i) {
    return new DE(n, r, i);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(Bm), oz = Function.prototype.bind;
function lv(e, t) {
  return oz.call(e, t);
}
var az = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        tg(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        tg(r);
      }
    else
      tg(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        tg(n);
      }
  }, e;
}(), DE = function(e) {
  Pm(t, e);
  function t(n, r, i) {
    var o = e.call(this) || this, a;
    if (za(n) || !n)
      a = {
        next: n ?? void 0,
        error: r ?? void 0,
        complete: i ?? void 0
      };
    else {
      var s;
      o && x3.useDeprecatedNextContext ? (s = Object.create(n), s.unsubscribe = function() {
        return o.unsubscribe();
      }, a = {
        next: n.next && lv(n.next, s),
        error: n.error && lv(n.error, s),
        complete: n.complete && lv(n.complete, s)
      }) : a = n;
    }
    return o.destination = new az(a), o;
  }
  return t;
}(M3);
function tg(e) {
  iz(e);
}
function sz(e) {
  throw e;
}
var cz = {
  closed: !0,
  next: Sx,
  error: sz,
  complete: Sx
}, uz = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function lz(e) {
  return e;
}
function fz(e) {
  return e.length === 0 ? lz : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(r, i) {
      return i(r);
    }, n);
  };
}
var Ex = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var i = this, o = hz(t) ? t : new DE(t, n, r);
    return Qg(function() {
      var a = i, s = a.operator, c = a.source;
      o.add(s ? s.call(o, c) : c ? i._subscribe(o) : i._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = Ax(n), new n(function(i, o) {
      var a = new DE({
        next: function(s) {
          try {
            t(s);
          } catch (c) {
            o(c), a.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
      r.subscribe(a);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[uz] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return fz(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = Ax(t), new t(function(r, i) {
      var o;
      n.subscribe(function(a) {
        return o = a;
      }, function(a) {
        return i(a);
      }, function() {
        return r(o);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function Ax(e) {
  var t;
  return (t = e ?? x3.Promise) !== null && t !== void 0 ? t : Promise;
}
function dz(e) {
  return e && za(e.next) && za(e.error) && za(e.complete);
}
function hz(e) {
  return e && e instanceof M3 || dz(e) && T3(e);
}
var pz = I3(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), Cm = function(e) {
  Pm(t, e);
  function t() {
    var n = e.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return t.prototype.lift = function(n) {
    var r = new Ix(this, this);
    return r.operator = n, r;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new pz();
  }, t.prototype.next = function(n) {
    var r = this;
    Qg(function() {
      var i, o;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var a = PE(r.currentObservers), s = a.next(); !s.done; s = a.next()) {
            var c = s.value;
            c.next(n);
          }
        } catch (l) {
          i = { error: l };
        } finally {
          try {
            s && !s.done && (o = a.return) && o.call(a);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(n) {
    var r = this;
    Qg(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = n;
        for (var i = r.observers; i.length; )
          i.shift().error(n);
      }
    });
  }, t.prototype.complete = function() {
    var n = this;
    Qg(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var r = n.observers; r.length; )
          r.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, n);
  }, t.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, t.prototype._innerSubscribe = function(n) {
    var r = this, i = this, o = i.hasError, a = i.isStopped, s = i.observers;
    return o || a ? k3 : (this.currentObservers = null, s.push(n), new Bm(function() {
      r.currentObservers = null, BE(s, n);
    }));
  }, t.prototype._checkFinalizedStatuses = function(n) {
    var r = this, i = r.hasError, o = r.thrownError, a = r.isStopped;
    i ? n.error(o) : a && n.complete();
  }, t.prototype.asObservable = function() {
    var n = new Ex();
    return n.source = this, n;
  }, t.create = function(n, r) {
    return new Ix(n, r);
  }, t;
}(Ex), Ix = function(e) {
  Pm(t, e);
  function t(n, r) {
    var i = e.call(this) || this;
    return i.destination = n, i.source = r, i;
  }
  return t.prototype.next = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || i === void 0 || i.call(r, n);
  }, t.prototype.error = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || i === void 0 || i.call(r, n);
  }, t.prototype.complete = function() {
    var n, r;
    (r = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || r === void 0 || r.call(n);
  }, t.prototype._subscribe = function(n) {
    var r, i;
    return (i = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(n)) !== null && i !== void 0 ? i : k3;
  }, t;
}(Cm), Pt = /* @__PURE__ */ ((e) => (e[e.prev = 0] = "prev", e[e.next = 1] = "next", e[e.close = 2] = "close", e))(Pt || {}), ke = /* @__PURE__ */ ((e) => (e[e.chainChange = 0] = "chainChange", e[e.changePage = 1] = "changePage", e[e.prevPage = 2] = "prevPage", e[e.emailChange = 3] = "emailChange", e[e.taxResidenceChange = 4] = "taxResidenceChange", e[e.termsAcceptedChange = 5] = "termsAcceptedChange", e[e.SetHeaderButtonState = 6] = "SetHeaderButtonState", e[e.setVerifyingModalOpen = 7] = "setVerifyingModalOpen", e[e.OnClickHeaderButton = 8] = "OnClickHeaderButton", e[e.setModal = 9] = "setModal", e[e.setEmailConfirmed = 10] = "setEmailConfirmed", e[e.nftImageChange = 11] = "nftImageChange", e[e.subscriptionYearsChange = 12] = "subscriptionYearsChange", e[e.SetErrorModalText = 13] = "SetErrorModalText", e[e.setChainExplorerUrl = 14] = "setChainExplorerUrl", e[e.setMessageTargetOrigin = 15] = "setMessageTargetOrigin", e[e.setModalMode = 16] = "setModalMode", e[e.grantNameAndAddressChange = 17] = "grantNameAndAddressChange", e[e.grantSocialSecurityNumberChange = 18] = "grantSocialSecurityNumberChange", e[e.setNftImageUrl = 19] = "setNftImageUrl", e[e.SetReturnUserFlow = 20] = "SetReturnUserFlow", e[e.SetProcessSucess = 21] = "SetProcessSucess", e[e.SetAlreadyHaveAnNftOnThisChain = 22] = "SetAlreadyHaveAnNftOnThisChain", e[e.SetNearMinted = 23] = "SetNearMinted", e))(ke || {}), Ue = /* @__PURE__ */ ((e) => (e[e.AgreementStep = 1] = "AgreementStep", e[e.kycDAOMembershipStep = 2] = "kycDAOMembershipStep", e[e.verificationStep = 3] = "verificationStep", e[e.emailDiscordVerificationStep = 4] = "emailDiscordVerificationStep", e[e.taxResidenceStep = 5] = "taxResidenceStep", e[e.beginVerificationStep = 6] = "beginVerificationStep", e[e.nftArtSelection = 7] = "nftArtSelection", e[e.finalStep = 8] = "finalStep", e[e.chainSelection = 9] = "chainSelection", e[e.termsAccepted = 10] = "termsAccepted", e[e.loading = 11] = "loading", e[e.mintStep = 12] = "mintStep", e[e.subscribedStartStep = 13] = "subscribedStartStep", e[e.grantNameAndAddressStep = 14] = "grantNameAndAddressStep", e[e.grantSocialSecurityNumberStep = 15] = "grantSocialSecurityNumberStep", e[e.fatalError = 16] = "fatalError", e[e.verifyAccountStep = 17] = "verifyAccountStep", e))(Ue || {});
const O3 = new Cm(), P3 = new Cm(), B3 = new Cm(), Lo = O3.asObservable(), Za = P3.asObservable(), yz = B3.asObservable(), gz = (e, { payload: t, type: n }) => {
  switch (n) {
    case ke.SetNearMinted:
      return { ...e, nearMinted: t };
    case ke.SetAlreadyHaveAnNftOnThisChain:
      return { ...e, alreadyHaveAnNftOnThisChain: t };
    case ke.SetProcessSucess:
      return { ...e, isProcessSuccess: t };
    case ke.SetReturnUserFlow:
      return { ...e, returningUserFlow: t };
    case ke.setModalMode:
      return { ...e, isModal: t };
    case ke.setMessageTargetOrigin:
      return { ...e, messageTargetOrigin: t };
    case ke.setEmailConfirmed:
      return { ...e, isEmailConfirmed: t };
    case ke.chainChange:
      return { ...e, chain: t };
    case ke.emailChange:
      return { ...e, email: t };
    case ke.setModal:
      return { ...e, currentModal: t };
    case ke.subscriptionYearsChange:
      return { ...e, subscriptionYears: t };
    case ke.changePage:
      return {
        ...e,
        nextPage: t.next,
        prevPage: t.prev,
        currentPage: t.current
      };
    case ke.SetErrorModalText:
      return {
        ...e,
        errorModalHeader: t.header,
        errorModalBody: t.body
      };
    case ke.taxResidenceChange:
      return { ...e, taxResidency: t };
    case ke.setNftImageUrl:
      return { ...e, nftImageUrl: t };
    case ke.termsAcceptedChange:
      return { ...e, termsAccepted: t };
    case ke.setVerifyingModalOpen:
      return { ...e, verifyingModalOpen: t };
    case ke.nftImageChange:
      return { ...e, imageId: t };
    case ke.setChainExplorerUrl:
      return { ...e, chainExplorerUrl: t };
    case ke.SetHeaderButtonState:
      switch (t.button) {
        case Pt.close:
          return { ...e, closeButtonState: t.state };
        case Pt.next:
          return { ...e, nextButtonState: t.state };
        case Pt.prev:
          return { ...e, prevButtonState: t.state };
        default:
          return e;
      }
    case ke.OnClickHeaderButton:
      switch (t.button) {
        case Pt.close:
          return B3.next(), e;
        case Pt.next:
          return O3.next(), e;
        case Pt.prev:
          return P3.next(), e;
        default:
          return e;
      }
    case ke.grantNameAndAddressChange:
      return { ...e, grantFlow: { ...e.grantFlow, ...t } };
    case ke.grantSocialSecurityNumberChange:
      return {
        ...e,
        grantFlow: { ...e.grantFlow, socialSecurityNumber: t }
      };
  }
}, C3 = {
  returningUserFlow: !1,
  isProcessSuccess: !1,
  closeButtonState: "enabled",
  currentPage: Ue.loading,
  email: "",
  taxResidency: "",
  termsAccepted: !1,
  verifyingModalOpen: !1,
  nextButtonState: "enabled",
  prevButtonState: "enabled",
  translations: {
    agreementStep: {
      body1: "",
      body2: ""
    }
  },
  currentModal: null,
  isEmailConfirmed: !1,
  messageTargetOrigin: "",
  isModal: !1,
  grantFlow: {},
  width: 650,
  height: 400,
  grantFlowEnabled: !1,
  alreadyHaveAnNftOnThisChain: !1,
  nearMinted: !1
}, Wn = bI({
  data: C3,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dispatch: () => {
  }
});
function bz(e) {
  return typeof e == "object" && !(e instanceof Error) ? JSON.stringify(e) : `${e}`;
}
function RE(e, t, n, r, i) {
  const o = bz(t);
  if (n({
    type: ke.SetErrorModalText,
    payload: {
      header: "An error happened",
      body: `${o}`
    }
  }), /\[RejectedByUser\]/g.test(o)) {
    window.parent.postMessage(
      {
        type: "kycDaoCloseModal",
        data: o
      },
      i
    );
    return;
  }
  switch (console.error(o), e) {
    case "fatal":
      n({
        payload: { current: Ue.fatalError, prev: r },
        type: ke.changePage
      }), n({
        type: ke.setModal,
        payload: null
      });
      break;
    case "minting": {
      n({
        type: ke.setModal,
        payload: "mintingFailed"
      });
      break;
    }
    case "modal":
      n({
        type: ke.setModal,
        payload: "genericError"
      });
  }
}
function Ja() {
  const {
    dispatch: e,
    data: { currentPage: t, messageTargetOrigin: n }
  } = ln(Wn);
  return (r, i) => RE(r, i, e, t, n);
}
var D3 = {}, Sr = {}, BI = { exports: {} };
const mz = {}, CI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mz
}, Symbol.toStringTag, { value: "Module" })), R3 = /* @__PURE__ */ Qc(CI);
BI.exports;
(function(e) {
  (function(t, n) {
    function r(S, p) {
      if (!S)
        throw new Error(p || "Assertion failed");
    }
    function i(S, p) {
      S.super_ = p;
      var y = function() {
      };
      y.prototype = p.prototype, S.prototype = new y(), S.prototype.constructor = S;
    }
    function o(S, p, y) {
      if (o.isBN(S))
        return S;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, S !== null && ((p === "le" || p === "be") && (y = p, p = 10), this._init(S || 0, p || 10, y || "be"));
    }
    typeof t == "object" ? t.exports = o : n.BN = o, o.BN = o, o.wordSize = 26;
    var a;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? a = window.Buffer : a = R3.Buffer;
    } catch {
    }
    o.isBN = function(p) {
      return p instanceof o ? !0 : p !== null && typeof p == "object" && p.constructor.wordSize === o.wordSize && Array.isArray(p.words);
    }, o.max = function(p, y) {
      return p.cmp(y) > 0 ? p : y;
    }, o.min = function(p, y) {
      return p.cmp(y) < 0 ? p : y;
    }, o.prototype._init = function(p, y, v) {
      if (typeof p == "number")
        return this._initNumber(p, y, v);
      if (typeof p == "object")
        return this._initArray(p, y, v);
      y === "hex" && (y = 16), r(y === (y | 0) && y >= 2 && y <= 36), p = p.toString().replace(/\s+/g, "");
      var E = 0;
      p[0] === "-" && (E++, this.negative = 1), E < p.length && (y === 16 ? this._parseHex(p, E, v) : (this._parseBase(p, y, E), v === "le" && this._initArray(this.toArray(), y, v)));
    }, o.prototype._initNumber = function(p, y, v) {
      p < 0 && (this.negative = 1, p = -p), p < 67108864 ? (this.words = [p & 67108863], this.length = 1) : p < 4503599627370496 ? (this.words = [
        p & 67108863,
        p / 67108864 & 67108863
      ], this.length = 2) : (r(p < 9007199254740992), this.words = [
        p & 67108863,
        p / 67108864 & 67108863,
        1
      ], this.length = 3), v === "le" && this._initArray(this.toArray(), y, v);
    }, o.prototype._initArray = function(p, y, v) {
      if (r(typeof p.length == "number"), p.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(p.length / 3), this.words = new Array(this.length);
      for (var E = 0; E < this.length; E++)
        this.words[E] = 0;
      var B, F, q = 0;
      if (v === "be")
        for (E = p.length - 1, B = 0; E >= 0; E -= 3)
          F = p[E] | p[E - 1] << 8 | p[E - 2] << 16, this.words[B] |= F << q & 67108863, this.words[B + 1] = F >>> 26 - q & 67108863, q += 24, q >= 26 && (q -= 26, B++);
      else if (v === "le")
        for (E = 0, B = 0; E < p.length; E += 3)
          F = p[E] | p[E + 1] << 8 | p[E + 2] << 16, this.words[B] |= F << q & 67108863, this.words[B + 1] = F >>> 26 - q & 67108863, q += 24, q >= 26 && (q -= 26, B++);
      return this._strip();
    };
    function s(S, p) {
      var y = S.charCodeAt(p);
      if (y >= 48 && y <= 57)
        return y - 48;
      if (y >= 65 && y <= 70)
        return y - 55;
      if (y >= 97 && y <= 102)
        return y - 87;
      r(!1, "Invalid character in " + S);
    }
    function c(S, p, y) {
      var v = s(S, y);
      return y - 1 >= p && (v |= s(S, y - 1) << 4), v;
    }
    o.prototype._parseHex = function(p, y, v) {
      this.length = Math.ceil((p.length - y) / 6), this.words = new Array(this.length);
      for (var E = 0; E < this.length; E++)
        this.words[E] = 0;
      var B = 0, F = 0, q;
      if (v === "be")
        for (E = p.length - 1; E >= y; E -= 2)
          q = c(p, y, E) << B, this.words[F] |= q & 67108863, B >= 18 ? (B -= 18, F += 1, this.words[F] |= q >>> 26) : B += 8;
      else {
        var U = p.length - y;
        for (E = U % 2 === 0 ? y + 1 : y; E < p.length; E += 2)
          q = c(p, y, E) << B, this.words[F] |= q & 67108863, B >= 18 ? (B -= 18, F += 1, this.words[F] |= q >>> 26) : B += 8;
      }
      this._strip();
    };
    function l(S, p, y, v) {
      for (var E = 0, B = 0, F = Math.min(S.length, y), q = p; q < F; q++) {
        var U = S.charCodeAt(q) - 48;
        E *= v, U >= 49 ? B = U - 49 + 10 : U >= 17 ? B = U - 17 + 10 : B = U, r(U >= 0 && B < v, "Invalid character"), E += B;
      }
      return E;
    }
    o.prototype._parseBase = function(p, y, v) {
      this.words = [0], this.length = 1;
      for (var E = 0, B = 1; B <= 67108863; B *= y)
        E++;
      E--, B = B / y | 0;
      for (var F = p.length - v, q = F % E, U = Math.min(F, F - q) + v, m = 0, D = v; D < U; D += E)
        m = l(p, D, D + E, y), this.imuln(B), this.words[0] + m < 67108864 ? this.words[0] += m : this._iaddn(m);
      if (q !== 0) {
        var Y = 1;
        for (m = l(p, D, p.length, y), D = 0; D < q; D++)
          Y *= y;
        this.imuln(Y), this.words[0] + m < 67108864 ? this.words[0] += m : this._iaddn(m);
      }
      this._strip();
    }, o.prototype.copy = function(p) {
      p.words = new Array(this.length);
      for (var y = 0; y < this.length; y++)
        p.words[y] = this.words[y];
      p.length = this.length, p.negative = this.negative, p.red = this.red;
    };
    function u(S, p) {
      S.words = p.words, S.length = p.length, S.negative = p.negative, S.red = p.red;
    }
    if (o.prototype._move = function(p) {
      u(p, this);
    }, o.prototype.clone = function() {
      var p = new o(null);
      return this.copy(p), p;
    }, o.prototype._expand = function(p) {
      for (; this.length < p; )
        this.words[this.length++] = 0;
      return this;
    }, o.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, o.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        o.prototype[Symbol.for("nodejs.util.inspect.custom")] = f;
      } catch {
        o.prototype.inspect = f;
      }
    else
      o.prototype.inspect = f;
    function f() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var d = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], h = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], g = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    o.prototype.toString = function(p, y) {
      p = p || 10, y = y | 0 || 1;
      var v;
      if (p === 16 || p === "hex") {
        v = "";
        for (var E = 0, B = 0, F = 0; F < this.length; F++) {
          var q = this.words[F], U = ((q << E | B) & 16777215).toString(16);
          B = q >>> 24 - E & 16777215, E += 2, E >= 26 && (E -= 26, F--), B !== 0 || F !== this.length - 1 ? v = d[6 - U.length] + U + v : v = U + v;
        }
        for (B !== 0 && (v = B.toString(16) + v); v.length % y !== 0; )
          v = "0" + v;
        return this.negative !== 0 && (v = "-" + v), v;
      }
      if (p === (p | 0) && p >= 2 && p <= 36) {
        var m = h[p], D = g[p];
        v = "";
        var Y = this.clone();
        for (Y.negative = 0; !Y.isZero(); ) {
          var Q = Y.modrn(D).toString(p);
          Y = Y.idivn(D), Y.isZero() ? v = Q + v : v = d[m - Q.length] + Q + v;
        }
        for (this.isZero() && (v = "0" + v); v.length % y !== 0; )
          v = "0" + v;
        return this.negative !== 0 && (v = "-" + v), v;
      }
      r(!1, "Base should be between 2 and 36");
    }, o.prototype.toNumber = function() {
      var p = this.words[0];
      return this.length === 2 ? p += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? p += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && r(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -p : p;
    }, o.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, a && (o.prototype.toBuffer = function(p, y) {
      return this.toArrayLike(a, p, y);
    }), o.prototype.toArray = function(p, y) {
      return this.toArrayLike(Array, p, y);
    };
    var w = function(p, y) {
      return p.allocUnsafe ? p.allocUnsafe(y) : new p(y);
    };
    o.prototype.toArrayLike = function(p, y, v) {
      this._strip();
      var E = this.byteLength(), B = v || Math.max(1, E);
      r(E <= B, "byte array longer than desired length"), r(B > 0, "Requested array length <= 0");
      var F = w(p, B), q = y === "le" ? "LE" : "BE";
      return this["_toArrayLike" + q](F, E), F;
    }, o.prototype._toArrayLikeLE = function(p, y) {
      for (var v = 0, E = 0, B = 0, F = 0; B < this.length; B++) {
        var q = this.words[B] << F | E;
        p[v++] = q & 255, v < p.length && (p[v++] = q >> 8 & 255), v < p.length && (p[v++] = q >> 16 & 255), F === 6 ? (v < p.length && (p[v++] = q >> 24 & 255), E = 0, F = 0) : (E = q >>> 24, F += 2);
      }
      if (v < p.length)
        for (p[v++] = E; v < p.length; )
          p[v++] = 0;
    }, o.prototype._toArrayLikeBE = function(p, y) {
      for (var v = p.length - 1, E = 0, B = 0, F = 0; B < this.length; B++) {
        var q = this.words[B] << F | E;
        p[v--] = q & 255, v >= 0 && (p[v--] = q >> 8 & 255), v >= 0 && (p[v--] = q >> 16 & 255), F === 6 ? (v >= 0 && (p[v--] = q >> 24 & 255), E = 0, F = 0) : (E = q >>> 24, F += 2);
      }
      if (v >= 0)
        for (p[v--] = E; v >= 0; )
          p[v--] = 0;
    }, Math.clz32 ? o.prototype._countBits = function(p) {
      return 32 - Math.clz32(p);
    } : o.prototype._countBits = function(p) {
      var y = p, v = 0;
      return y >= 4096 && (v += 13, y >>>= 13), y >= 64 && (v += 7, y >>>= 7), y >= 8 && (v += 4, y >>>= 4), y >= 2 && (v += 2, y >>>= 2), v + y;
    }, o.prototype._zeroBits = function(p) {
      if (p === 0)
        return 26;
      var y = p, v = 0;
      return y & 8191 || (v += 13, y >>>= 13), y & 127 || (v += 7, y >>>= 7), y & 15 || (v += 4, y >>>= 4), y & 3 || (v += 2, y >>>= 2), y & 1 || v++, v;
    }, o.prototype.bitLength = function() {
      var p = this.words[this.length - 1], y = this._countBits(p);
      return (this.length - 1) * 26 + y;
    };
    function b(S) {
      for (var p = new Array(S.bitLength()), y = 0; y < p.length; y++) {
        var v = y / 26 | 0, E = y % 26;
        p[y] = S.words[v] >>> E & 1;
      }
      return p;
    }
    o.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var p = 0, y = 0; y < this.length; y++) {
        var v = this._zeroBits(this.words[y]);
        if (p += v, v !== 26)
          break;
      }
      return p;
    }, o.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, o.prototype.toTwos = function(p) {
      return this.negative !== 0 ? this.abs().inotn(p).iaddn(1) : this.clone();
    }, o.prototype.fromTwos = function(p) {
      return this.testn(p - 1) ? this.notn(p).iaddn(1).ineg() : this.clone();
    }, o.prototype.isNeg = function() {
      return this.negative !== 0;
    }, o.prototype.neg = function() {
      return this.clone().ineg();
    }, o.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, o.prototype.iuor = function(p) {
      for (; this.length < p.length; )
        this.words[this.length++] = 0;
      for (var y = 0; y < p.length; y++)
        this.words[y] = this.words[y] | p.words[y];
      return this._strip();
    }, o.prototype.ior = function(p) {
      return r((this.negative | p.negative) === 0), this.iuor(p);
    }, o.prototype.or = function(p) {
      return this.length > p.length ? this.clone().ior(p) : p.clone().ior(this);
    }, o.prototype.uor = function(p) {
      return this.length > p.length ? this.clone().iuor(p) : p.clone().iuor(this);
    }, o.prototype.iuand = function(p) {
      var y;
      this.length > p.length ? y = p : y = this;
      for (var v = 0; v < y.length; v++)
        this.words[v] = this.words[v] & p.words[v];
      return this.length = y.length, this._strip();
    }, o.prototype.iand = function(p) {
      return r((this.negative | p.negative) === 0), this.iuand(p);
    }, o.prototype.and = function(p) {
      return this.length > p.length ? this.clone().iand(p) : p.clone().iand(this);
    }, o.prototype.uand = function(p) {
      return this.length > p.length ? this.clone().iuand(p) : p.clone().iuand(this);
    }, o.prototype.iuxor = function(p) {
      var y, v;
      this.length > p.length ? (y = this, v = p) : (y = p, v = this);
      for (var E = 0; E < v.length; E++)
        this.words[E] = y.words[E] ^ v.words[E];
      if (this !== y)
        for (; E < y.length; E++)
          this.words[E] = y.words[E];
      return this.length = y.length, this._strip();
    }, o.prototype.ixor = function(p) {
      return r((this.negative | p.negative) === 0), this.iuxor(p);
    }, o.prototype.xor = function(p) {
      return this.length > p.length ? this.clone().ixor(p) : p.clone().ixor(this);
    }, o.prototype.uxor = function(p) {
      return this.length > p.length ? this.clone().iuxor(p) : p.clone().iuxor(this);
    }, o.prototype.inotn = function(p) {
      r(typeof p == "number" && p >= 0);
      var y = Math.ceil(p / 26) | 0, v = p % 26;
      this._expand(y), v > 0 && y--;
      for (var E = 0; E < y; E++)
        this.words[E] = ~this.words[E] & 67108863;
      return v > 0 && (this.words[E] = ~this.words[E] & 67108863 >> 26 - v), this._strip();
    }, o.prototype.notn = function(p) {
      return this.clone().inotn(p);
    }, o.prototype.setn = function(p, y) {
      r(typeof p == "number" && p >= 0);
      var v = p / 26 | 0, E = p % 26;
      return this._expand(v + 1), y ? this.words[v] = this.words[v] | 1 << E : this.words[v] = this.words[v] & ~(1 << E), this._strip();
    }, o.prototype.iadd = function(p) {
      var y;
      if (this.negative !== 0 && p.negative === 0)
        return this.negative = 0, y = this.isub(p), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && p.negative !== 0)
        return p.negative = 0, y = this.isub(p), p.negative = 1, y._normSign();
      var v, E;
      this.length > p.length ? (v = this, E = p) : (v = p, E = this);
      for (var B = 0, F = 0; F < E.length; F++)
        y = (v.words[F] | 0) + (E.words[F] | 0) + B, this.words[F] = y & 67108863, B = y >>> 26;
      for (; B !== 0 && F < v.length; F++)
        y = (v.words[F] | 0) + B, this.words[F] = y & 67108863, B = y >>> 26;
      if (this.length = v.length, B !== 0)
        this.words[this.length] = B, this.length++;
      else if (v !== this)
        for (; F < v.length; F++)
          this.words[F] = v.words[F];
      return this;
    }, o.prototype.add = function(p) {
      var y;
      return p.negative !== 0 && this.negative === 0 ? (p.negative = 0, y = this.sub(p), p.negative ^= 1, y) : p.negative === 0 && this.negative !== 0 ? (this.negative = 0, y = p.sub(this), this.negative = 1, y) : this.length > p.length ? this.clone().iadd(p) : p.clone().iadd(this);
    }, o.prototype.isub = function(p) {
      if (p.negative !== 0) {
        p.negative = 0;
        var y = this.iadd(p);
        return p.negative = 1, y._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(p), this.negative = 1, this._normSign();
      var v = this.cmp(p);
      if (v === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var E, B;
      v > 0 ? (E = this, B = p) : (E = p, B = this);
      for (var F = 0, q = 0; q < B.length; q++)
        y = (E.words[q] | 0) - (B.words[q] | 0) + F, F = y >> 26, this.words[q] = y & 67108863;
      for (; F !== 0 && q < E.length; q++)
        y = (E.words[q] | 0) + F, F = y >> 26, this.words[q] = y & 67108863;
      if (F === 0 && q < E.length && E !== this)
        for (; q < E.length; q++)
          this.words[q] = E.words[q];
      return this.length = Math.max(this.length, q), E !== this && (this.negative = 1), this._strip();
    }, o.prototype.sub = function(p) {
      return this.clone().isub(p);
    };
    function I(S, p, y) {
      y.negative = p.negative ^ S.negative;
      var v = S.length + p.length | 0;
      y.length = v, v = v - 1 | 0;
      var E = S.words[0] | 0, B = p.words[0] | 0, F = E * B, q = F & 67108863, U = F / 67108864 | 0;
      y.words[0] = q;
      for (var m = 1; m < v; m++) {
        for (var D = U >>> 26, Y = U & 67108863, Q = Math.min(m, p.length - 1), G = Math.max(0, m - S.length + 1); G <= Q; G++) {
          var he = m - G | 0;
          E = S.words[he] | 0, B = p.words[G] | 0, F = E * B + Y, D += F / 67108864 | 0, Y = F & 67108863;
        }
        y.words[m] = Y | 0, U = D | 0;
      }
      return U !== 0 ? y.words[m] = U | 0 : y.length--, y._strip();
    }
    var A = function(p, y, v) {
      var E = p.words, B = y.words, F = v.words, q = 0, U, m, D, Y = E[0] | 0, Q = Y & 8191, G = Y >>> 13, he = E[1] | 0, se = he & 8191, _e = he >>> 13, Me = E[2] | 0, Pe = Me & 8191, Be = Me >>> 13, at = E[3] | 0, Fe = at & 8191, Re = at >>> 13, Nt = E[4] | 0, qe = Nt & 8191, _t = Nt >>> 13, ve = E[5] | 0, mt = ve & 8191, Gt = ve >>> 13, ue = E[6] | 0, fe = ue & 8191, me = ue >>> 13, De = E[7] | 0, ze = De & 8191, L = De >>> 13, T = E[8] | 0, R = T & 8191, J = T >>> 13, te = E[9] | 0, re = te & 8191, de = te >>> 13, et = B[0] | 0, st = et & 8191, tt = et >>> 13, Yt = B[1] | 0, gt = Yt & 8191, Rn = Yt >>> 13, Ho = B[2] | 0, Yn = Ho & 8191, Zn = Ho >>> 13, bu = B[3] | 0, fn = bu & 8191, vn = bu >>> 13, Zi = B[4] | 0, Ln = Zi & 8191, $n = Zi >>> 13, ts = B[5] | 0, Jn = ts & 8191, en = ts >>> 13, ns = B[6] | 0, $ = ns & 8191, H = ns >>> 13, Z = B[7] | 0, P = Z & 8191, X = Z >>> 13, le = B[8] | 0, ce = le & 8191, ye = le >>> 13, Ce = B[9] | 0, $e = Ce & 8191, je = Ce >>> 13;
      v.negative = p.negative ^ y.negative, v.length = 19, U = Math.imul(Q, st), m = Math.imul(Q, tt), m = m + Math.imul(G, st) | 0, D = Math.imul(G, tt);
      var Jt = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, U = Math.imul(se, st), m = Math.imul(se, tt), m = m + Math.imul(_e, st) | 0, D = Math.imul(_e, tt), U = U + Math.imul(Q, gt) | 0, m = m + Math.imul(Q, Rn) | 0, m = m + Math.imul(G, gt) | 0, D = D + Math.imul(G, Rn) | 0;
      var Xe = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, U = Math.imul(Pe, st), m = Math.imul(Pe, tt), m = m + Math.imul(Be, st) | 0, D = Math.imul(Be, tt), U = U + Math.imul(se, gt) | 0, m = m + Math.imul(se, Rn) | 0, m = m + Math.imul(_e, gt) | 0, D = D + Math.imul(_e, Rn) | 0, U = U + Math.imul(Q, Yn) | 0, m = m + Math.imul(Q, Zn) | 0, m = m + Math.imul(G, Yn) | 0, D = D + Math.imul(G, Zn) | 0;
      var Et = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, U = Math.imul(Fe, st), m = Math.imul(Fe, tt), m = m + Math.imul(Re, st) | 0, D = Math.imul(Re, tt), U = U + Math.imul(Pe, gt) | 0, m = m + Math.imul(Pe, Rn) | 0, m = m + Math.imul(Be, gt) | 0, D = D + Math.imul(Be, Rn) | 0, U = U + Math.imul(se, Yn) | 0, m = m + Math.imul(se, Zn) | 0, m = m + Math.imul(_e, Yn) | 0, D = D + Math.imul(_e, Zn) | 0, U = U + Math.imul(Q, fn) | 0, m = m + Math.imul(Q, vn) | 0, m = m + Math.imul(G, fn) | 0, D = D + Math.imul(G, vn) | 0;
      var At = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, U = Math.imul(qe, st), m = Math.imul(qe, tt), m = m + Math.imul(_t, st) | 0, D = Math.imul(_t, tt), U = U + Math.imul(Fe, gt) | 0, m = m + Math.imul(Fe, Rn) | 0, m = m + Math.imul(Re, gt) | 0, D = D + Math.imul(Re, Rn) | 0, U = U + Math.imul(Pe, Yn) | 0, m = m + Math.imul(Pe, Zn) | 0, m = m + Math.imul(Be, Yn) | 0, D = D + Math.imul(Be, Zn) | 0, U = U + Math.imul(se, fn) | 0, m = m + Math.imul(se, vn) | 0, m = m + Math.imul(_e, fn) | 0, D = D + Math.imul(_e, vn) | 0, U = U + Math.imul(Q, Ln) | 0, m = m + Math.imul(Q, $n) | 0, m = m + Math.imul(G, Ln) | 0, D = D + Math.imul(G, $n) | 0;
      var Bt = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863, U = Math.imul(mt, st), m = Math.imul(mt, tt), m = m + Math.imul(Gt, st) | 0, D = Math.imul(Gt, tt), U = U + Math.imul(qe, gt) | 0, m = m + Math.imul(qe, Rn) | 0, m = m + Math.imul(_t, gt) | 0, D = D + Math.imul(_t, Rn) | 0, U = U + Math.imul(Fe, Yn) | 0, m = m + Math.imul(Fe, Zn) | 0, m = m + Math.imul(Re, Yn) | 0, D = D + Math.imul(Re, Zn) | 0, U = U + Math.imul(Pe, fn) | 0, m = m + Math.imul(Pe, vn) | 0, m = m + Math.imul(Be, fn) | 0, D = D + Math.imul(Be, vn) | 0, U = U + Math.imul(se, Ln) | 0, m = m + Math.imul(se, $n) | 0, m = m + Math.imul(_e, Ln) | 0, D = D + Math.imul(_e, $n) | 0, U = U + Math.imul(Q, Jn) | 0, m = m + Math.imul(Q, en) | 0, m = m + Math.imul(G, Jn) | 0, D = D + Math.imul(G, en) | 0;
      var Ot = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863, U = Math.imul(fe, st), m = Math.imul(fe, tt), m = m + Math.imul(me, st) | 0, D = Math.imul(me, tt), U = U + Math.imul(mt, gt) | 0, m = m + Math.imul(mt, Rn) | 0, m = m + Math.imul(Gt, gt) | 0, D = D + Math.imul(Gt, Rn) | 0, U = U + Math.imul(qe, Yn) | 0, m = m + Math.imul(qe, Zn) | 0, m = m + Math.imul(_t, Yn) | 0, D = D + Math.imul(_t, Zn) | 0, U = U + Math.imul(Fe, fn) | 0, m = m + Math.imul(Fe, vn) | 0, m = m + Math.imul(Re, fn) | 0, D = D + Math.imul(Re, vn) | 0, U = U + Math.imul(Pe, Ln) | 0, m = m + Math.imul(Pe, $n) | 0, m = m + Math.imul(Be, Ln) | 0, D = D + Math.imul(Be, $n) | 0, U = U + Math.imul(se, Jn) | 0, m = m + Math.imul(se, en) | 0, m = m + Math.imul(_e, Jn) | 0, D = D + Math.imul(_e, en) | 0, U = U + Math.imul(Q, $) | 0, m = m + Math.imul(Q, H) | 0, m = m + Math.imul(G, $) | 0, D = D + Math.imul(G, H) | 0;
      var It = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, U = Math.imul(ze, st), m = Math.imul(ze, tt), m = m + Math.imul(L, st) | 0, D = Math.imul(L, tt), U = U + Math.imul(fe, gt) | 0, m = m + Math.imul(fe, Rn) | 0, m = m + Math.imul(me, gt) | 0, D = D + Math.imul(me, Rn) | 0, U = U + Math.imul(mt, Yn) | 0, m = m + Math.imul(mt, Zn) | 0, m = m + Math.imul(Gt, Yn) | 0, D = D + Math.imul(Gt, Zn) | 0, U = U + Math.imul(qe, fn) | 0, m = m + Math.imul(qe, vn) | 0, m = m + Math.imul(_t, fn) | 0, D = D + Math.imul(_t, vn) | 0, U = U + Math.imul(Fe, Ln) | 0, m = m + Math.imul(Fe, $n) | 0, m = m + Math.imul(Re, Ln) | 0, D = D + Math.imul(Re, $n) | 0, U = U + Math.imul(Pe, Jn) | 0, m = m + Math.imul(Pe, en) | 0, m = m + Math.imul(Be, Jn) | 0, D = D + Math.imul(Be, en) | 0, U = U + Math.imul(se, $) | 0, m = m + Math.imul(se, H) | 0, m = m + Math.imul(_e, $) | 0, D = D + Math.imul(_e, H) | 0, U = U + Math.imul(Q, P) | 0, m = m + Math.imul(Q, X) | 0, m = m + Math.imul(G, P) | 0, D = D + Math.imul(G, X) | 0;
      var Tt = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, U = Math.imul(R, st), m = Math.imul(R, tt), m = m + Math.imul(J, st) | 0, D = Math.imul(J, tt), U = U + Math.imul(ze, gt) | 0, m = m + Math.imul(ze, Rn) | 0, m = m + Math.imul(L, gt) | 0, D = D + Math.imul(L, Rn) | 0, U = U + Math.imul(fe, Yn) | 0, m = m + Math.imul(fe, Zn) | 0, m = m + Math.imul(me, Yn) | 0, D = D + Math.imul(me, Zn) | 0, U = U + Math.imul(mt, fn) | 0, m = m + Math.imul(mt, vn) | 0, m = m + Math.imul(Gt, fn) | 0, D = D + Math.imul(Gt, vn) | 0, U = U + Math.imul(qe, Ln) | 0, m = m + Math.imul(qe, $n) | 0, m = m + Math.imul(_t, Ln) | 0, D = D + Math.imul(_t, $n) | 0, U = U + Math.imul(Fe, Jn) | 0, m = m + Math.imul(Fe, en) | 0, m = m + Math.imul(Re, Jn) | 0, D = D + Math.imul(Re, en) | 0, U = U + Math.imul(Pe, $) | 0, m = m + Math.imul(Pe, H) | 0, m = m + Math.imul(Be, $) | 0, D = D + Math.imul(Be, H) | 0, U = U + Math.imul(se, P) | 0, m = m + Math.imul(se, X) | 0, m = m + Math.imul(_e, P) | 0, D = D + Math.imul(_e, X) | 0, U = U + Math.imul(Q, ce) | 0, m = m + Math.imul(Q, ye) | 0, m = m + Math.imul(G, ce) | 0, D = D + Math.imul(G, ye) | 0;
      var kt = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, U = Math.imul(re, st), m = Math.imul(re, tt), m = m + Math.imul(de, st) | 0, D = Math.imul(de, tt), U = U + Math.imul(R, gt) | 0, m = m + Math.imul(R, Rn) | 0, m = m + Math.imul(J, gt) | 0, D = D + Math.imul(J, Rn) | 0, U = U + Math.imul(ze, Yn) | 0, m = m + Math.imul(ze, Zn) | 0, m = m + Math.imul(L, Yn) | 0, D = D + Math.imul(L, Zn) | 0, U = U + Math.imul(fe, fn) | 0, m = m + Math.imul(fe, vn) | 0, m = m + Math.imul(me, fn) | 0, D = D + Math.imul(me, vn) | 0, U = U + Math.imul(mt, Ln) | 0, m = m + Math.imul(mt, $n) | 0, m = m + Math.imul(Gt, Ln) | 0, D = D + Math.imul(Gt, $n) | 0, U = U + Math.imul(qe, Jn) | 0, m = m + Math.imul(qe, en) | 0, m = m + Math.imul(_t, Jn) | 0, D = D + Math.imul(_t, en) | 0, U = U + Math.imul(Fe, $) | 0, m = m + Math.imul(Fe, H) | 0, m = m + Math.imul(Re, $) | 0, D = D + Math.imul(Re, H) | 0, U = U + Math.imul(Pe, P) | 0, m = m + Math.imul(Pe, X) | 0, m = m + Math.imul(Be, P) | 0, D = D + Math.imul(Be, X) | 0, U = U + Math.imul(se, ce) | 0, m = m + Math.imul(se, ye) | 0, m = m + Math.imul(_e, ce) | 0, D = D + Math.imul(_e, ye) | 0, U = U + Math.imul(Q, $e) | 0, m = m + Math.imul(Q, je) | 0, m = m + Math.imul(G, $e) | 0, D = D + Math.imul(G, je) | 0;
      var nt = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (nt >>> 26) | 0, nt &= 67108863, U = Math.imul(re, gt), m = Math.imul(re, Rn), m = m + Math.imul(de, gt) | 0, D = Math.imul(de, Rn), U = U + Math.imul(R, Yn) | 0, m = m + Math.imul(R, Zn) | 0, m = m + Math.imul(J, Yn) | 0, D = D + Math.imul(J, Zn) | 0, U = U + Math.imul(ze, fn) | 0, m = m + Math.imul(ze, vn) | 0, m = m + Math.imul(L, fn) | 0, D = D + Math.imul(L, vn) | 0, U = U + Math.imul(fe, Ln) | 0, m = m + Math.imul(fe, $n) | 0, m = m + Math.imul(me, Ln) | 0, D = D + Math.imul(me, $n) | 0, U = U + Math.imul(mt, Jn) | 0, m = m + Math.imul(mt, en) | 0, m = m + Math.imul(Gt, Jn) | 0, D = D + Math.imul(Gt, en) | 0, U = U + Math.imul(qe, $) | 0, m = m + Math.imul(qe, H) | 0, m = m + Math.imul(_t, $) | 0, D = D + Math.imul(_t, H) | 0, U = U + Math.imul(Fe, P) | 0, m = m + Math.imul(Fe, X) | 0, m = m + Math.imul(Re, P) | 0, D = D + Math.imul(Re, X) | 0, U = U + Math.imul(Pe, ce) | 0, m = m + Math.imul(Pe, ye) | 0, m = m + Math.imul(Be, ce) | 0, D = D + Math.imul(Be, ye) | 0, U = U + Math.imul(se, $e) | 0, m = m + Math.imul(se, je) | 0, m = m + Math.imul(_e, $e) | 0, D = D + Math.imul(_e, je) | 0;
      var yt = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, U = Math.imul(re, Yn), m = Math.imul(re, Zn), m = m + Math.imul(de, Yn) | 0, D = Math.imul(de, Zn), U = U + Math.imul(R, fn) | 0, m = m + Math.imul(R, vn) | 0, m = m + Math.imul(J, fn) | 0, D = D + Math.imul(J, vn) | 0, U = U + Math.imul(ze, Ln) | 0, m = m + Math.imul(ze, $n) | 0, m = m + Math.imul(L, Ln) | 0, D = D + Math.imul(L, $n) | 0, U = U + Math.imul(fe, Jn) | 0, m = m + Math.imul(fe, en) | 0, m = m + Math.imul(me, Jn) | 0, D = D + Math.imul(me, en) | 0, U = U + Math.imul(mt, $) | 0, m = m + Math.imul(mt, H) | 0, m = m + Math.imul(Gt, $) | 0, D = D + Math.imul(Gt, H) | 0, U = U + Math.imul(qe, P) | 0, m = m + Math.imul(qe, X) | 0, m = m + Math.imul(_t, P) | 0, D = D + Math.imul(_t, X) | 0, U = U + Math.imul(Fe, ce) | 0, m = m + Math.imul(Fe, ye) | 0, m = m + Math.imul(Re, ce) | 0, D = D + Math.imul(Re, ye) | 0, U = U + Math.imul(Pe, $e) | 0, m = m + Math.imul(Pe, je) | 0, m = m + Math.imul(Be, $e) | 0, D = D + Math.imul(Be, je) | 0;
      var Ye = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (Ye >>> 26) | 0, Ye &= 67108863, U = Math.imul(re, fn), m = Math.imul(re, vn), m = m + Math.imul(de, fn) | 0, D = Math.imul(de, vn), U = U + Math.imul(R, Ln) | 0, m = m + Math.imul(R, $n) | 0, m = m + Math.imul(J, Ln) | 0, D = D + Math.imul(J, $n) | 0, U = U + Math.imul(ze, Jn) | 0, m = m + Math.imul(ze, en) | 0, m = m + Math.imul(L, Jn) | 0, D = D + Math.imul(L, en) | 0, U = U + Math.imul(fe, $) | 0, m = m + Math.imul(fe, H) | 0, m = m + Math.imul(me, $) | 0, D = D + Math.imul(me, H) | 0, U = U + Math.imul(mt, P) | 0, m = m + Math.imul(mt, X) | 0, m = m + Math.imul(Gt, P) | 0, D = D + Math.imul(Gt, X) | 0, U = U + Math.imul(qe, ce) | 0, m = m + Math.imul(qe, ye) | 0, m = m + Math.imul(_t, ce) | 0, D = D + Math.imul(_t, ye) | 0, U = U + Math.imul(Fe, $e) | 0, m = m + Math.imul(Fe, je) | 0, m = m + Math.imul(Re, $e) | 0, D = D + Math.imul(Re, je) | 0;
      var rt = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (rt >>> 26) | 0, rt &= 67108863, U = Math.imul(re, Ln), m = Math.imul(re, $n), m = m + Math.imul(de, Ln) | 0, D = Math.imul(de, $n), U = U + Math.imul(R, Jn) | 0, m = m + Math.imul(R, en) | 0, m = m + Math.imul(J, Jn) | 0, D = D + Math.imul(J, en) | 0, U = U + Math.imul(ze, $) | 0, m = m + Math.imul(ze, H) | 0, m = m + Math.imul(L, $) | 0, D = D + Math.imul(L, H) | 0, U = U + Math.imul(fe, P) | 0, m = m + Math.imul(fe, X) | 0, m = m + Math.imul(me, P) | 0, D = D + Math.imul(me, X) | 0, U = U + Math.imul(mt, ce) | 0, m = m + Math.imul(mt, ye) | 0, m = m + Math.imul(Gt, ce) | 0, D = D + Math.imul(Gt, ye) | 0, U = U + Math.imul(qe, $e) | 0, m = m + Math.imul(qe, je) | 0, m = m + Math.imul(_t, $e) | 0, D = D + Math.imul(_t, je) | 0;
      var ct = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, U = Math.imul(re, Jn), m = Math.imul(re, en), m = m + Math.imul(de, Jn) | 0, D = Math.imul(de, en), U = U + Math.imul(R, $) | 0, m = m + Math.imul(R, H) | 0, m = m + Math.imul(J, $) | 0, D = D + Math.imul(J, H) | 0, U = U + Math.imul(ze, P) | 0, m = m + Math.imul(ze, X) | 0, m = m + Math.imul(L, P) | 0, D = D + Math.imul(L, X) | 0, U = U + Math.imul(fe, ce) | 0, m = m + Math.imul(fe, ye) | 0, m = m + Math.imul(me, ce) | 0, D = D + Math.imul(me, ye) | 0, U = U + Math.imul(mt, $e) | 0, m = m + Math.imul(mt, je) | 0, m = m + Math.imul(Gt, $e) | 0, D = D + Math.imul(Gt, je) | 0;
      var He = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (He >>> 26) | 0, He &= 67108863, U = Math.imul(re, $), m = Math.imul(re, H), m = m + Math.imul(de, $) | 0, D = Math.imul(de, H), U = U + Math.imul(R, P) | 0, m = m + Math.imul(R, X) | 0, m = m + Math.imul(J, P) | 0, D = D + Math.imul(J, X) | 0, U = U + Math.imul(ze, ce) | 0, m = m + Math.imul(ze, ye) | 0, m = m + Math.imul(L, ce) | 0, D = D + Math.imul(L, ye) | 0, U = U + Math.imul(fe, $e) | 0, m = m + Math.imul(fe, je) | 0, m = m + Math.imul(me, $e) | 0, D = D + Math.imul(me, je) | 0;
      var ge = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, U = Math.imul(re, P), m = Math.imul(re, X), m = m + Math.imul(de, P) | 0, D = Math.imul(de, X), U = U + Math.imul(R, ce) | 0, m = m + Math.imul(R, ye) | 0, m = m + Math.imul(J, ce) | 0, D = D + Math.imul(J, ye) | 0, U = U + Math.imul(ze, $e) | 0, m = m + Math.imul(ze, je) | 0, m = m + Math.imul(L, $e) | 0, D = D + Math.imul(L, je) | 0;
      var be = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, U = Math.imul(re, ce), m = Math.imul(re, ye), m = m + Math.imul(de, ce) | 0, D = Math.imul(de, ye), U = U + Math.imul(R, $e) | 0, m = m + Math.imul(R, je) | 0, m = m + Math.imul(J, $e) | 0, D = D + Math.imul(J, je) | 0;
      var Te = (q + U | 0) + ((m & 8191) << 13) | 0;
      q = (D + (m >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, U = Math.imul(re, $e), m = Math.imul(re, je), m = m + Math.imul(de, $e) | 0, D = Math.imul(de, je);
      var Ee = (q + U | 0) + ((m & 8191) << 13) | 0;
      return q = (D + (m >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, F[0] = Jt, F[1] = Xe, F[2] = Et, F[3] = At, F[4] = Bt, F[5] = Ot, F[6] = It, F[7] = Tt, F[8] = kt, F[9] = nt, F[10] = yt, F[11] = Ye, F[12] = rt, F[13] = ct, F[14] = He, F[15] = ge, F[16] = be, F[17] = Te, F[18] = Ee, q !== 0 && (F[19] = q, v.length++), v;
    };
    Math.imul || (A = I);
    function x(S, p, y) {
      y.negative = p.negative ^ S.negative, y.length = S.length + p.length;
      for (var v = 0, E = 0, B = 0; B < y.length - 1; B++) {
        var F = E;
        E = 0;
        for (var q = v & 67108863, U = Math.min(B, p.length - 1), m = Math.max(0, B - S.length + 1); m <= U; m++) {
          var D = B - m, Y = S.words[D] | 0, Q = p.words[m] | 0, G = Y * Q, he = G & 67108863;
          F = F + (G / 67108864 | 0) | 0, he = he + q | 0, q = he & 67108863, F = F + (he >>> 26) | 0, E += F >>> 26, F &= 67108863;
        }
        y.words[B] = q, v = F, F = E;
      }
      return v !== 0 ? y.words[B] = v : y.length--, y._strip();
    }
    function N(S, p, y) {
      return x(S, p, y);
    }
    o.prototype.mulTo = function(p, y) {
      var v, E = this.length + p.length;
      return this.length === 10 && p.length === 10 ? v = A(this, p, y) : E < 63 ? v = I(this, p, y) : E < 1024 ? v = x(this, p, y) : v = N(this, p, y), v;
    }, o.prototype.mul = function(p) {
      var y = new o(null);
      return y.words = new Array(this.length + p.length), this.mulTo(p, y);
    }, o.prototype.mulf = function(p) {
      var y = new o(null);
      return y.words = new Array(this.length + p.length), N(this, p, y);
    }, o.prototype.imul = function(p) {
      return this.clone().mulTo(p, this);
    }, o.prototype.imuln = function(p) {
      var y = p < 0;
      y && (p = -p), r(typeof p == "number"), r(p < 67108864);
      for (var v = 0, E = 0; E < this.length; E++) {
        var B = (this.words[E] | 0) * p, F = (B & 67108863) + (v & 67108863);
        v >>= 26, v += B / 67108864 | 0, v += F >>> 26, this.words[E] = F & 67108863;
      }
      return v !== 0 && (this.words[E] = v, this.length++), y ? this.ineg() : this;
    }, o.prototype.muln = function(p) {
      return this.clone().imuln(p);
    }, o.prototype.sqr = function() {
      return this.mul(this);
    }, o.prototype.isqr = function() {
      return this.imul(this.clone());
    }, o.prototype.pow = function(p) {
      var y = b(p);
      if (y.length === 0)
        return new o(1);
      for (var v = this, E = 0; E < y.length && y[E] === 0; E++, v = v.sqr())
        ;
      if (++E < y.length)
        for (var B = v.sqr(); E < y.length; E++, B = B.sqr())
          y[E] !== 0 && (v = v.mul(B));
      return v;
    }, o.prototype.iushln = function(p) {
      r(typeof p == "number" && p >= 0);
      var y = p % 26, v = (p - y) / 26, E = 67108863 >>> 26 - y << 26 - y, B;
      if (y !== 0) {
        var F = 0;
        for (B = 0; B < this.length; B++) {
          var q = this.words[B] & E, U = (this.words[B] | 0) - q << y;
          this.words[B] = U | F, F = q >>> 26 - y;
        }
        F && (this.words[B] = F, this.length++);
      }
      if (v !== 0) {
        for (B = this.length - 1; B >= 0; B--)
          this.words[B + v] = this.words[B];
        for (B = 0; B < v; B++)
          this.words[B] = 0;
        this.length += v;
      }
      return this._strip();
    }, o.prototype.ishln = function(p) {
      return r(this.negative === 0), this.iushln(p);
    }, o.prototype.iushrn = function(p, y, v) {
      r(typeof p == "number" && p >= 0);
      var E;
      y ? E = (y - y % 26) / 26 : E = 0;
      var B = p % 26, F = Math.min((p - B) / 26, this.length), q = 67108863 ^ 67108863 >>> B << B, U = v;
      if (E -= F, E = Math.max(0, E), U) {
        for (var m = 0; m < F; m++)
          U.words[m] = this.words[m];
        U.length = F;
      }
      if (F !== 0)
        if (this.length > F)
          for (this.length -= F, m = 0; m < this.length; m++)
            this.words[m] = this.words[m + F];
        else
          this.words[0] = 0, this.length = 1;
      var D = 0;
      for (m = this.length - 1; m >= 0 && (D !== 0 || m >= E); m--) {
        var Y = this.words[m] | 0;
        this.words[m] = D << 26 - B | Y >>> B, D = Y & q;
      }
      return U && D !== 0 && (U.words[U.length++] = D), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, o.prototype.ishrn = function(p, y, v) {
      return r(this.negative === 0), this.iushrn(p, y, v);
    }, o.prototype.shln = function(p) {
      return this.clone().ishln(p);
    }, o.prototype.ushln = function(p) {
      return this.clone().iushln(p);
    }, o.prototype.shrn = function(p) {
      return this.clone().ishrn(p);
    }, o.prototype.ushrn = function(p) {
      return this.clone().iushrn(p);
    }, o.prototype.testn = function(p) {
      r(typeof p == "number" && p >= 0);
      var y = p % 26, v = (p - y) / 26, E = 1 << y;
      if (this.length <= v)
        return !1;
      var B = this.words[v];
      return !!(B & E);
    }, o.prototype.imaskn = function(p) {
      r(typeof p == "number" && p >= 0);
      var y = p % 26, v = (p - y) / 26;
      if (r(this.negative === 0, "imaskn works only with positive numbers"), this.length <= v)
        return this;
      if (y !== 0 && v++, this.length = Math.min(v, this.length), y !== 0) {
        var E = 67108863 ^ 67108863 >>> y << y;
        this.words[this.length - 1] &= E;
      }
      return this._strip();
    }, o.prototype.maskn = function(p) {
      return this.clone().imaskn(p);
    }, o.prototype.iaddn = function(p) {
      return r(typeof p == "number"), r(p < 67108864), p < 0 ? this.isubn(-p) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= p ? (this.words[0] = p - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(p), this.negative = 1, this) : this._iaddn(p);
    }, o.prototype._iaddn = function(p) {
      this.words[0] += p;
      for (var y = 0; y < this.length && this.words[y] >= 67108864; y++)
        this.words[y] -= 67108864, y === this.length - 1 ? this.words[y + 1] = 1 : this.words[y + 1]++;
      return this.length = Math.max(this.length, y + 1), this;
    }, o.prototype.isubn = function(p) {
      if (r(typeof p == "number"), r(p < 67108864), p < 0)
        return this.iaddn(-p);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(p), this.negative = 1, this;
      if (this.words[0] -= p, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var y = 0; y < this.length && this.words[y] < 0; y++)
          this.words[y] += 67108864, this.words[y + 1] -= 1;
      return this._strip();
    }, o.prototype.addn = function(p) {
      return this.clone().iaddn(p);
    }, o.prototype.subn = function(p) {
      return this.clone().isubn(p);
    }, o.prototype.iabs = function() {
      return this.negative = 0, this;
    }, o.prototype.abs = function() {
      return this.clone().iabs();
    }, o.prototype._ishlnsubmul = function(p, y, v) {
      var E = p.length + v, B;
      this._expand(E);
      var F, q = 0;
      for (B = 0; B < p.length; B++) {
        F = (this.words[B + v] | 0) + q;
        var U = (p.words[B] | 0) * y;
        F -= U & 67108863, q = (F >> 26) - (U / 67108864 | 0), this.words[B + v] = F & 67108863;
      }
      for (; B < this.length - v; B++)
        F = (this.words[B + v] | 0) + q, q = F >> 26, this.words[B + v] = F & 67108863;
      if (q === 0)
        return this._strip();
      for (r(q === -1), q = 0, B = 0; B < this.length; B++)
        F = -(this.words[B] | 0) + q, q = F >> 26, this.words[B] = F & 67108863;
      return this.negative = 1, this._strip();
    }, o.prototype._wordDiv = function(p, y) {
      var v = this.length - p.length, E = this.clone(), B = p, F = B.words[B.length - 1] | 0, q = this._countBits(F);
      v = 26 - q, v !== 0 && (B = B.ushln(v), E.iushln(v), F = B.words[B.length - 1] | 0);
      var U = E.length - B.length, m;
      if (y !== "mod") {
        m = new o(null), m.length = U + 1, m.words = new Array(m.length);
        for (var D = 0; D < m.length; D++)
          m.words[D] = 0;
      }
      var Y = E.clone()._ishlnsubmul(B, 1, U);
      Y.negative === 0 && (E = Y, m && (m.words[U] = 1));
      for (var Q = U - 1; Q >= 0; Q--) {
        var G = (E.words[B.length + Q] | 0) * 67108864 + (E.words[B.length + Q - 1] | 0);
        for (G = Math.min(G / F | 0, 67108863), E._ishlnsubmul(B, G, Q); E.negative !== 0; )
          G--, E.negative = 0, E._ishlnsubmul(B, 1, Q), E.isZero() || (E.negative ^= 1);
        m && (m.words[Q] = G);
      }
      return m && m._strip(), E._strip(), y !== "div" && v !== 0 && E.iushrn(v), {
        div: m || null,
        mod: E
      };
    }, o.prototype.divmod = function(p, y, v) {
      if (r(!p.isZero()), this.isZero())
        return {
          div: new o(0),
          mod: new o(0)
        };
      var E, B, F;
      return this.negative !== 0 && p.negative === 0 ? (F = this.neg().divmod(p, y), y !== "mod" && (E = F.div.neg()), y !== "div" && (B = F.mod.neg(), v && B.negative !== 0 && B.iadd(p)), {
        div: E,
        mod: B
      }) : this.negative === 0 && p.negative !== 0 ? (F = this.divmod(p.neg(), y), y !== "mod" && (E = F.div.neg()), {
        div: E,
        mod: F.mod
      }) : this.negative & p.negative ? (F = this.neg().divmod(p.neg(), y), y !== "div" && (B = F.mod.neg(), v && B.negative !== 0 && B.isub(p)), {
        div: F.div,
        mod: B
      }) : p.length > this.length || this.cmp(p) < 0 ? {
        div: new o(0),
        mod: this
      } : p.length === 1 ? y === "div" ? {
        div: this.divn(p.words[0]),
        mod: null
      } : y === "mod" ? {
        div: null,
        mod: new o(this.modrn(p.words[0]))
      } : {
        div: this.divn(p.words[0]),
        mod: new o(this.modrn(p.words[0]))
      } : this._wordDiv(p, y);
    }, o.prototype.div = function(p) {
      return this.divmod(p, "div", !1).div;
    }, o.prototype.mod = function(p) {
      return this.divmod(p, "mod", !1).mod;
    }, o.prototype.umod = function(p) {
      return this.divmod(p, "mod", !0).mod;
    }, o.prototype.divRound = function(p) {
      var y = this.divmod(p);
      if (y.mod.isZero())
        return y.div;
      var v = y.div.negative !== 0 ? y.mod.isub(p) : y.mod, E = p.ushrn(1), B = p.andln(1), F = v.cmp(E);
      return F < 0 || B === 1 && F === 0 ? y.div : y.div.negative !== 0 ? y.div.isubn(1) : y.div.iaddn(1);
    }, o.prototype.modrn = function(p) {
      var y = p < 0;
      y && (p = -p), r(p <= 67108863);
      for (var v = (1 << 26) % p, E = 0, B = this.length - 1; B >= 0; B--)
        E = (v * E + (this.words[B] | 0)) % p;
      return y ? -E : E;
    }, o.prototype.modn = function(p) {
      return this.modrn(p);
    }, o.prototype.idivn = function(p) {
      var y = p < 0;
      y && (p = -p), r(p <= 67108863);
      for (var v = 0, E = this.length - 1; E >= 0; E--) {
        var B = (this.words[E] | 0) + v * 67108864;
        this.words[E] = B / p | 0, v = B % p;
      }
      return this._strip(), y ? this.ineg() : this;
    }, o.prototype.divn = function(p) {
      return this.clone().idivn(p);
    }, o.prototype.egcd = function(p) {
      r(p.negative === 0), r(!p.isZero());
      var y = this, v = p.clone();
      y.negative !== 0 ? y = y.umod(p) : y = y.clone();
      for (var E = new o(1), B = new o(0), F = new o(0), q = new o(1), U = 0; y.isEven() && v.isEven(); )
        y.iushrn(1), v.iushrn(1), ++U;
      for (var m = v.clone(), D = y.clone(); !y.isZero(); ) {
        for (var Y = 0, Q = 1; !(y.words[0] & Q) && Y < 26; ++Y, Q <<= 1)
          ;
        if (Y > 0)
          for (y.iushrn(Y); Y-- > 0; )
            (E.isOdd() || B.isOdd()) && (E.iadd(m), B.isub(D)), E.iushrn(1), B.iushrn(1);
        for (var G = 0, he = 1; !(v.words[0] & he) && G < 26; ++G, he <<= 1)
          ;
        if (G > 0)
          for (v.iushrn(G); G-- > 0; )
            (F.isOdd() || q.isOdd()) && (F.iadd(m), q.isub(D)), F.iushrn(1), q.iushrn(1);
        y.cmp(v) >= 0 ? (y.isub(v), E.isub(F), B.isub(q)) : (v.isub(y), F.isub(E), q.isub(B));
      }
      return {
        a: F,
        b: q,
        gcd: v.iushln(U)
      };
    }, o.prototype._invmp = function(p) {
      r(p.negative === 0), r(!p.isZero());
      var y = this, v = p.clone();
      y.negative !== 0 ? y = y.umod(p) : y = y.clone();
      for (var E = new o(1), B = new o(0), F = v.clone(); y.cmpn(1) > 0 && v.cmpn(1) > 0; ) {
        for (var q = 0, U = 1; !(y.words[0] & U) && q < 26; ++q, U <<= 1)
          ;
        if (q > 0)
          for (y.iushrn(q); q-- > 0; )
            E.isOdd() && E.iadd(F), E.iushrn(1);
        for (var m = 0, D = 1; !(v.words[0] & D) && m < 26; ++m, D <<= 1)
          ;
        if (m > 0)
          for (v.iushrn(m); m-- > 0; )
            B.isOdd() && B.iadd(F), B.iushrn(1);
        y.cmp(v) >= 0 ? (y.isub(v), E.isub(B)) : (v.isub(y), B.isub(E));
      }
      var Y;
      return y.cmpn(1) === 0 ? Y = E : Y = B, Y.cmpn(0) < 0 && Y.iadd(p), Y;
    }, o.prototype.gcd = function(p) {
      if (this.isZero())
        return p.abs();
      if (p.isZero())
        return this.abs();
      var y = this.clone(), v = p.clone();
      y.negative = 0, v.negative = 0;
      for (var E = 0; y.isEven() && v.isEven(); E++)
        y.iushrn(1), v.iushrn(1);
      do {
        for (; y.isEven(); )
          y.iushrn(1);
        for (; v.isEven(); )
          v.iushrn(1);
        var B = y.cmp(v);
        if (B < 0) {
          var F = y;
          y = v, v = F;
        } else if (B === 0 || v.cmpn(1) === 0)
          break;
        y.isub(v);
      } while (!0);
      return v.iushln(E);
    }, o.prototype.invm = function(p) {
      return this.egcd(p).a.umod(p);
    }, o.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, o.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, o.prototype.andln = function(p) {
      return this.words[0] & p;
    }, o.prototype.bincn = function(p) {
      r(typeof p == "number");
      var y = p % 26, v = (p - y) / 26, E = 1 << y;
      if (this.length <= v)
        return this._expand(v + 1), this.words[v] |= E, this;
      for (var B = E, F = v; B !== 0 && F < this.length; F++) {
        var q = this.words[F] | 0;
        q += B, B = q >>> 26, q &= 67108863, this.words[F] = q;
      }
      return B !== 0 && (this.words[F] = B, this.length++), this;
    }, o.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, o.prototype.cmpn = function(p) {
      var y = p < 0;
      if (this.negative !== 0 && !y)
        return -1;
      if (this.negative === 0 && y)
        return 1;
      this._strip();
      var v;
      if (this.length > 1)
        v = 1;
      else {
        y && (p = -p), r(p <= 67108863, "Number is too big");
        var E = this.words[0] | 0;
        v = E === p ? 0 : E < p ? -1 : 1;
      }
      return this.negative !== 0 ? -v | 0 : v;
    }, o.prototype.cmp = function(p) {
      if (this.negative !== 0 && p.negative === 0)
        return -1;
      if (this.negative === 0 && p.negative !== 0)
        return 1;
      var y = this.ucmp(p);
      return this.negative !== 0 ? -y | 0 : y;
    }, o.prototype.ucmp = function(p) {
      if (this.length > p.length)
        return 1;
      if (this.length < p.length)
        return -1;
      for (var y = 0, v = this.length - 1; v >= 0; v--) {
        var E = this.words[v] | 0, B = p.words[v] | 0;
        if (E !== B) {
          E < B ? y = -1 : E > B && (y = 1);
          break;
        }
      }
      return y;
    }, o.prototype.gtn = function(p) {
      return this.cmpn(p) === 1;
    }, o.prototype.gt = function(p) {
      return this.cmp(p) === 1;
    }, o.prototype.gten = function(p) {
      return this.cmpn(p) >= 0;
    }, o.prototype.gte = function(p) {
      return this.cmp(p) >= 0;
    }, o.prototype.ltn = function(p) {
      return this.cmpn(p) === -1;
    }, o.prototype.lt = function(p) {
      return this.cmp(p) === -1;
    }, o.prototype.lten = function(p) {
      return this.cmpn(p) <= 0;
    }, o.prototype.lte = function(p) {
      return this.cmp(p) <= 0;
    }, o.prototype.eqn = function(p) {
      return this.cmpn(p) === 0;
    }, o.prototype.eq = function(p) {
      return this.cmp(p) === 0;
    }, o.red = function(p) {
      return new C(p);
    }, o.prototype.toRed = function(p) {
      return r(!this.red, "Already a number in reduction context"), r(this.negative === 0, "red works only with positives"), p.convertTo(this)._forceRed(p);
    }, o.prototype.fromRed = function() {
      return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, o.prototype._forceRed = function(p) {
      return this.red = p, this;
    }, o.prototype.forceRed = function(p) {
      return r(!this.red, "Already a number in reduction context"), this._forceRed(p);
    }, o.prototype.redAdd = function(p) {
      return r(this.red, "redAdd works only with red numbers"), this.red.add(this, p);
    }, o.prototype.redIAdd = function(p) {
      return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, p);
    }, o.prototype.redSub = function(p) {
      return r(this.red, "redSub works only with red numbers"), this.red.sub(this, p);
    }, o.prototype.redISub = function(p) {
      return r(this.red, "redISub works only with red numbers"), this.red.isub(this, p);
    }, o.prototype.redShl = function(p) {
      return r(this.red, "redShl works only with red numbers"), this.red.shl(this, p);
    }, o.prototype.redMul = function(p) {
      return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, p), this.red.mul(this, p);
    }, o.prototype.redIMul = function(p) {
      return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, p), this.red.imul(this, p);
    }, o.prototype.redSqr = function() {
      return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, o.prototype.redISqr = function() {
      return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, o.prototype.redSqrt = function() {
      return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, o.prototype.redInvm = function() {
      return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, o.prototype.redNeg = function() {
      return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, o.prototype.redPow = function(p) {
      return r(this.red && !p.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, p);
    };
    var j = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function K(S, p) {
      this.name = S, this.p = new o(p, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    K.prototype._tmp = function() {
      var p = new o(null);
      return p.words = new Array(Math.ceil(this.n / 13)), p;
    }, K.prototype.ireduce = function(p) {
      var y = p, v;
      do
        this.split(y, this.tmp), y = this.imulK(y), y = y.iadd(this.tmp), v = y.bitLength();
      while (v > this.n);
      var E = v < this.n ? -1 : y.ucmp(this.p);
      return E === 0 ? (y.words[0] = 0, y.length = 1) : E > 0 ? y.isub(this.p) : y.strip !== void 0 ? y.strip() : y._strip(), y;
    }, K.prototype.split = function(p, y) {
      p.iushrn(this.n, 0, y);
    }, K.prototype.imulK = function(p) {
      return p.imul(this.k);
    };
    function W() {
      K.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    i(W, K), W.prototype.split = function(p, y) {
      for (var v = 4194303, E = Math.min(p.length, 9), B = 0; B < E; B++)
        y.words[B] = p.words[B];
      if (y.length = E, p.length <= 9) {
        p.words[0] = 0, p.length = 1;
        return;
      }
      var F = p.words[9];
      for (y.words[y.length++] = F & v, B = 10; B < p.length; B++) {
        var q = p.words[B] | 0;
        p.words[B - 10] = (q & v) << 4 | F >>> 22, F = q;
      }
      F >>>= 22, p.words[B - 10] = F, F === 0 && p.length > 10 ? p.length -= 10 : p.length -= 9;
    }, W.prototype.imulK = function(p) {
      p.words[p.length] = 0, p.words[p.length + 1] = 0, p.length += 2;
      for (var y = 0, v = 0; v < p.length; v++) {
        var E = p.words[v] | 0;
        y += E * 977, p.words[v] = y & 67108863, y = E * 64 + (y / 67108864 | 0);
      }
      return p.words[p.length - 1] === 0 && (p.length--, p.words[p.length - 1] === 0 && p.length--), p;
    };
    function O() {
      K.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    i(O, K);
    function k() {
      K.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    i(k, K);
    function z() {
      K.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    i(z, K), z.prototype.imulK = function(p) {
      for (var y = 0, v = 0; v < p.length; v++) {
        var E = (p.words[v] | 0) * 19 + y, B = E & 67108863;
        E >>>= 26, p.words[v] = B, y = E;
      }
      return y !== 0 && (p.words[p.length++] = y), p;
    }, o._prime = function(p) {
      if (j[p])
        return j[p];
      var y;
      if (p === "k256")
        y = new W();
      else if (p === "p224")
        y = new O();
      else if (p === "p192")
        y = new k();
      else if (p === "p25519")
        y = new z();
      else
        throw new Error("Unknown prime " + p);
      return j[p] = y, y;
    };
    function C(S) {
      if (typeof S == "string") {
        var p = o._prime(S);
        this.m = p.p, this.prime = p;
      } else
        r(S.gtn(1), "modulus must be greater than 1"), this.m = S, this.prime = null;
    }
    C.prototype._verify1 = function(p) {
      r(p.negative === 0, "red works only with positives"), r(p.red, "red works only with red numbers");
    }, C.prototype._verify2 = function(p, y) {
      r((p.negative | y.negative) === 0, "red works only with positives"), r(
        p.red && p.red === y.red,
        "red works only with red numbers"
      );
    }, C.prototype.imod = function(p) {
      return this.prime ? this.prime.ireduce(p)._forceRed(this) : (u(p, p.umod(this.m)._forceRed(this)), p);
    }, C.prototype.neg = function(p) {
      return p.isZero() ? p.clone() : this.m.sub(p)._forceRed(this);
    }, C.prototype.add = function(p, y) {
      this._verify2(p, y);
      var v = p.add(y);
      return v.cmp(this.m) >= 0 && v.isub(this.m), v._forceRed(this);
    }, C.prototype.iadd = function(p, y) {
      this._verify2(p, y);
      var v = p.iadd(y);
      return v.cmp(this.m) >= 0 && v.isub(this.m), v;
    }, C.prototype.sub = function(p, y) {
      this._verify2(p, y);
      var v = p.sub(y);
      return v.cmpn(0) < 0 && v.iadd(this.m), v._forceRed(this);
    }, C.prototype.isub = function(p, y) {
      this._verify2(p, y);
      var v = p.isub(y);
      return v.cmpn(0) < 0 && v.iadd(this.m), v;
    }, C.prototype.shl = function(p, y) {
      return this._verify1(p), this.imod(p.ushln(y));
    }, C.prototype.imul = function(p, y) {
      return this._verify2(p, y), this.imod(p.imul(y));
    }, C.prototype.mul = function(p, y) {
      return this._verify2(p, y), this.imod(p.mul(y));
    }, C.prototype.isqr = function(p) {
      return this.imul(p, p.clone());
    }, C.prototype.sqr = function(p) {
      return this.mul(p, p);
    }, C.prototype.sqrt = function(p) {
      if (p.isZero())
        return p.clone();
      var y = this.m.andln(3);
      if (r(y % 2 === 1), y === 3) {
        var v = this.m.add(new o(1)).iushrn(2);
        return this.pow(p, v);
      }
      for (var E = this.m.subn(1), B = 0; !E.isZero() && E.andln(1) === 0; )
        B++, E.iushrn(1);
      r(!E.isZero());
      var F = new o(1).toRed(this), q = F.redNeg(), U = this.m.subn(1).iushrn(1), m = this.m.bitLength();
      for (m = new o(2 * m * m).toRed(this); this.pow(m, U).cmp(q) !== 0; )
        m.redIAdd(q);
      for (var D = this.pow(m, E), Y = this.pow(p, E.addn(1).iushrn(1)), Q = this.pow(p, E), G = B; Q.cmp(F) !== 0; ) {
        for (var he = Q, se = 0; he.cmp(F) !== 0; se++)
          he = he.redSqr();
        r(se < G);
        var _e = this.pow(D, new o(1).iushln(G - se - 1));
        Y = Y.redMul(_e), D = _e.redSqr(), Q = Q.redMul(D), G = se;
      }
      return Y;
    }, C.prototype.invm = function(p) {
      var y = p._invmp(this.m);
      return y.negative !== 0 ? (y.negative = 0, this.imod(y).redNeg()) : this.imod(y);
    }, C.prototype.pow = function(p, y) {
      if (y.isZero())
        return new o(1).toRed(this);
      if (y.cmpn(1) === 0)
        return p.clone();
      var v = 4, E = new Array(1 << v);
      E[0] = new o(1).toRed(this), E[1] = p;
      for (var B = 2; B < E.length; B++)
        E[B] = this.mul(E[B - 1], p);
      var F = E[0], q = 0, U = 0, m = y.bitLength() % 26;
      for (m === 0 && (m = 26), B = y.length - 1; B >= 0; B--) {
        for (var D = y.words[B], Y = m - 1; Y >= 0; Y--) {
          var Q = D >> Y & 1;
          if (F !== E[0] && (F = this.sqr(F)), Q === 0 && q === 0) {
            U = 0;
            continue;
          }
          q <<= 1, q |= Q, U++, !(U !== v && (B !== 0 || Y !== 0)) && (F = this.mul(F, E[q]), U = 0, q = 0);
        }
        m = 26;
      }
      return F;
    }, C.prototype.convertTo = function(p) {
      var y = p.umod(this.m);
      return y === p ? y.clone() : y;
    }, C.prototype.convertFrom = function(p) {
      var y = p.clone();
      return y.red = null, y;
    }, o.mont = function(p) {
      return new M(p);
    };
    function M(S) {
      C.call(this, S), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    i(M, C), M.prototype.convertTo = function(p) {
      return this.imod(p.ushln(this.shift));
    }, M.prototype.convertFrom = function(p) {
      var y = this.imod(p.mul(this.rinv));
      return y.red = null, y;
    }, M.prototype.imul = function(p, y) {
      if (p.isZero() || y.isZero())
        return p.words[0] = 0, p.length = 1, p;
      var v = p.imul(y), E = v.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), B = v.isub(E).iushrn(this.shift), F = B;
      return B.cmp(this.m) >= 0 ? F = B.isub(this.m) : B.cmpn(0) < 0 && (F = B.iadd(this.m)), F._forceRed(this);
    }, M.prototype.mul = function(p, y) {
      if (p.isZero() || y.isZero())
        return new o(0)._forceRed(this);
      var v = p.mul(y), E = v.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), B = v.isub(E).iushrn(this.shift), F = B;
      return B.cmp(this.m) >= 0 ? F = B.isub(this.m) : B.cmpn(0) < 0 && (F = B.iadd(this.m)), F._forceRed(this);
    }, M.prototype.invm = function(p) {
      var y = this.imod(p._invmp(this.m).mul(this.r2));
      return y._forceRed(this);
    };
  })(e, _);
})(BI);
var Ka = BI.exports;
const il = /* @__PURE__ */ Vi(Ka);
var NE = { exports: {} }, it = {}, Dm = {};
Dm.byteLength = vz;
var N3 = Dm.toByteArray = Ez, kx = Dm.fromByteArray = kz, na = [], no = [], _z = typeof Uint8Array < "u" ? Uint8Array : Array, fv = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var mu = 0, wz = fv.length; mu < wz; ++mu)
  na[mu] = fv[mu], no[fv.charCodeAt(mu)] = mu;
no["-".charCodeAt(0)] = 62;
no["_".charCodeAt(0)] = 63;
function j3(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  n === -1 && (n = t);
  var r = n === t ? 0 : 4 - n % 4;
  return [n, r];
}
function vz(e) {
  var t = j3(e), n = t[0], r = t[1];
  return (n + r) * 3 / 4 - r;
}
function Sz(e, t, n) {
  return (t + n) * 3 / 4 - n;
}
function Ez(e) {
  var t, n = j3(e), r = n[0], i = n[1], o = new _z(Sz(e, r, i)), a = 0, s = i > 0 ? r - 4 : r, c;
  for (c = 0; c < s; c += 4)
    t = no[e.charCodeAt(c)] << 18 | no[e.charCodeAt(c + 1)] << 12 | no[e.charCodeAt(c + 2)] << 6 | no[e.charCodeAt(c + 3)], o[a++] = t >> 16 & 255, o[a++] = t >> 8 & 255, o[a++] = t & 255;
  return i === 2 && (t = no[e.charCodeAt(c)] << 2 | no[e.charCodeAt(c + 1)] >> 4, o[a++] = t & 255), i === 1 && (t = no[e.charCodeAt(c)] << 10 | no[e.charCodeAt(c + 1)] << 4 | no[e.charCodeAt(c + 2)] >> 2, o[a++] = t >> 8 & 255, o[a++] = t & 255), o;
}
function Az(e) {
  return na[e >> 18 & 63] + na[e >> 12 & 63] + na[e >> 6 & 63] + na[e & 63];
}
function Iz(e, t, n) {
  for (var r, i = [], o = t; o < n; o += 3)
    r = (e[o] << 16 & 16711680) + (e[o + 1] << 8 & 65280) + (e[o + 2] & 255), i.push(Az(r));
  return i.join("");
}
function kz(e) {
  for (var t, n = e.length, r = n % 3, i = [], o = 16383, a = 0, s = n - r; a < s; a += o)
    i.push(Iz(e, a, a + o > s ? s : a + o));
  return r === 1 ? (t = e[n - 1], i.push(
    na[t >> 2] + na[t << 4 & 63] + "=="
  )) : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], i.push(
    na[t >> 10] + na[t >> 4 & 63] + na[t << 2 & 63] + "="
  )), i.join("");
}
var DI = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
DI.read = function(e, t, n, r, i) {
  var o, a, s = i * 8 - r - 1, c = (1 << s) - 1, l = c >> 1, u = -7, f = n ? i - 1 : 0, d = n ? -1 : 1, h = e[t + f];
  for (f += d, o = h & (1 << -u) - 1, h >>= -u, u += s; u > 0; o = o * 256 + e[t + f], f += d, u -= 8)
    ;
  for (a = o & (1 << -u) - 1, o >>= -u, u += r; u > 0; a = a * 256 + e[t + f], f += d, u -= 8)
    ;
  if (o === 0)
    o = 1 - l;
  else {
    if (o === c)
      return a ? NaN : (h ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, r), o = o - l;
  }
  return (h ? -1 : 1) * a * Math.pow(2, o - r);
};
DI.write = function(e, t, n, r, i, o) {
  var a, s, c, l = o * 8 - i - 1, u = (1 << l) - 1, f = u >> 1, d = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = r ? 0 : o - 1, g = r ? 1 : -1, w = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = u) : (a = Math.floor(Math.log(t) / Math.LN2), t * (c = Math.pow(2, -a)) < 1 && (a--, c *= 2), a + f >= 1 ? t += d / c : t += d * Math.pow(2, 1 - f), t * c >= 2 && (a++, c /= 2), a + f >= u ? (s = 0, a = u) : a + f >= 1 ? (s = (t * c - 1) * Math.pow(2, i), a = a + f) : (s = t * Math.pow(2, f - 1) * Math.pow(2, i), a = 0)); i >= 8; e[n + h] = s & 255, h += g, s /= 256, i -= 8)
    ;
  for (a = a << i | s, l += i; l > 0; e[n + h] = a & 255, h += g, a /= 256, l -= 8)
    ;
  e[n + h - g] |= w * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = Dm, n = DI, r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = s, e.SlowBuffer = A, e.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  e.kMaxLength = i, s.TYPED_ARRAY_SUPPORT = o(), !s.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function o() {
    try {
      const L = new Uint8Array(1), T = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(T, Uint8Array.prototype), Object.setPrototypeOf(L, T), L.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(s.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(s.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.byteOffset;
    }
  });
  function a(L) {
    if (L > i)
      throw new RangeError('The value "' + L + '" is invalid for option "size"');
    const T = new Uint8Array(L);
    return Object.setPrototypeOf(T, s.prototype), T;
  }
  function s(L, T, R) {
    if (typeof L == "number") {
      if (typeof T == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return f(L);
    }
    return c(L, T, R);
  }
  s.poolSize = 8192;
  function c(L, T, R) {
    if (typeof L == "string")
      return d(L, T);
    if (ArrayBuffer.isView(L))
      return g(L);
    if (L == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof L
      );
    if (ue(L, ArrayBuffer) || L && ue(L.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ue(L, SharedArrayBuffer) || L && ue(L.buffer, SharedArrayBuffer)))
      return w(L, T, R);
    if (typeof L == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const J = L.valueOf && L.valueOf();
    if (J != null && J !== L)
      return s.from(J, T, R);
    const te = b(L);
    if (te)
      return te;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof L[Symbol.toPrimitive] == "function")
      return s.from(L[Symbol.toPrimitive]("string"), T, R);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof L
    );
  }
  s.from = function(L, T, R) {
    return c(L, T, R);
  }, Object.setPrototypeOf(s.prototype, Uint8Array.prototype), Object.setPrototypeOf(s, Uint8Array);
  function l(L) {
    if (typeof L != "number")
      throw new TypeError('"size" argument must be of type number');
    if (L < 0)
      throw new RangeError('The value "' + L + '" is invalid for option "size"');
  }
  function u(L, T, R) {
    return l(L), L <= 0 ? a(L) : T !== void 0 ? typeof R == "string" ? a(L).fill(T, R) : a(L).fill(T) : a(L);
  }
  s.alloc = function(L, T, R) {
    return u(L, T, R);
  };
  function f(L) {
    return l(L), a(L < 0 ? 0 : I(L) | 0);
  }
  s.allocUnsafe = function(L) {
    return f(L);
  }, s.allocUnsafeSlow = function(L) {
    return f(L);
  };
  function d(L, T) {
    if ((typeof T != "string" || T === "") && (T = "utf8"), !s.isEncoding(T))
      throw new TypeError("Unknown encoding: " + T);
    const R = x(L, T) | 0;
    let J = a(R);
    const te = J.write(L, T);
    return te !== R && (J = J.slice(0, te)), J;
  }
  function h(L) {
    const T = L.length < 0 ? 0 : I(L.length) | 0, R = a(T);
    for (let J = 0; J < T; J += 1)
      R[J] = L[J] & 255;
    return R;
  }
  function g(L) {
    if (ue(L, Uint8Array)) {
      const T = new Uint8Array(L);
      return w(T.buffer, T.byteOffset, T.byteLength);
    }
    return h(L);
  }
  function w(L, T, R) {
    if (T < 0 || L.byteLength < T)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (L.byteLength < T + (R || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let J;
    return T === void 0 && R === void 0 ? J = new Uint8Array(L) : R === void 0 ? J = new Uint8Array(L, T) : J = new Uint8Array(L, T, R), Object.setPrototypeOf(J, s.prototype), J;
  }
  function b(L) {
    if (s.isBuffer(L)) {
      const T = I(L.length) | 0, R = a(T);
      return R.length === 0 || L.copy(R, 0, 0, T), R;
    }
    if (L.length !== void 0)
      return typeof L.length != "number" || fe(L.length) ? a(0) : h(L);
    if (L.type === "Buffer" && Array.isArray(L.data))
      return h(L.data);
  }
  function I(L) {
    if (L >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return L | 0;
  }
  function A(L) {
    return +L != L && (L = 0), s.alloc(+L);
  }
  s.isBuffer = function(T) {
    return T != null && T._isBuffer === !0 && T !== s.prototype;
  }, s.compare = function(T, R) {
    if (ue(T, Uint8Array) && (T = s.from(T, T.offset, T.byteLength)), ue(R, Uint8Array) && (R = s.from(R, R.offset, R.byteLength)), !s.isBuffer(T) || !s.isBuffer(R))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (T === R)
      return 0;
    let J = T.length, te = R.length;
    for (let re = 0, de = Math.min(J, te); re < de; ++re)
      if (T[re] !== R[re]) {
        J = T[re], te = R[re];
        break;
      }
    return J < te ? -1 : te < J ? 1 : 0;
  }, s.isEncoding = function(T) {
    switch (String(T).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, s.concat = function(T, R) {
    if (!Array.isArray(T))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (T.length === 0)
      return s.alloc(0);
    let J;
    if (R === void 0)
      for (R = 0, J = 0; J < T.length; ++J)
        R += T[J].length;
    const te = s.allocUnsafe(R);
    let re = 0;
    for (J = 0; J < T.length; ++J) {
      let de = T[J];
      if (ue(de, Uint8Array))
        re + de.length > te.length ? (s.isBuffer(de) || (de = s.from(de)), de.copy(te, re)) : Uint8Array.prototype.set.call(
          te,
          de,
          re
        );
      else if (s.isBuffer(de))
        de.copy(te, re);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      re += de.length;
    }
    return te;
  };
  function x(L, T) {
    if (s.isBuffer(L))
      return L.length;
    if (ArrayBuffer.isView(L) || ue(L, ArrayBuffer))
      return L.byteLength;
    if (typeof L != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof L
      );
    const R = L.length, J = arguments.length > 2 && arguments[2] === !0;
    if (!J && R === 0)
      return 0;
    let te = !1;
    for (; ; )
      switch (T) {
        case "ascii":
        case "latin1":
        case "binary":
          return R;
        case "utf8":
        case "utf-8":
          return qe(L).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return R * 2;
        case "hex":
          return R >>> 1;
        case "base64":
          return mt(L).length;
        default:
          if (te)
            return J ? -1 : qe(L).length;
          T = ("" + T).toLowerCase(), te = !0;
      }
  }
  s.byteLength = x;
  function N(L, T, R) {
    let J = !1;
    if ((T === void 0 || T < 0) && (T = 0), T > this.length || ((R === void 0 || R > this.length) && (R = this.length), R <= 0) || (R >>>= 0, T >>>= 0, R <= T))
      return "";
    for (L || (L = "utf8"); ; )
      switch (L) {
        case "hex":
          return F(this, T, R);
        case "utf8":
        case "utf-8":
          return p(this, T, R);
        case "ascii":
          return E(this, T, R);
        case "latin1":
        case "binary":
          return B(this, T, R);
        case "base64":
          return S(this, T, R);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return q(this, T, R);
        default:
          if (J)
            throw new TypeError("Unknown encoding: " + L);
          L = (L + "").toLowerCase(), J = !0;
      }
  }
  s.prototype._isBuffer = !0;
  function j(L, T, R) {
    const J = L[T];
    L[T] = L[R], L[R] = J;
  }
  s.prototype.swap16 = function() {
    const T = this.length;
    if (T % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let R = 0; R < T; R += 2)
      j(this, R, R + 1);
    return this;
  }, s.prototype.swap32 = function() {
    const T = this.length;
    if (T % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let R = 0; R < T; R += 4)
      j(this, R, R + 3), j(this, R + 1, R + 2);
    return this;
  }, s.prototype.swap64 = function() {
    const T = this.length;
    if (T % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let R = 0; R < T; R += 8)
      j(this, R, R + 7), j(this, R + 1, R + 6), j(this, R + 2, R + 5), j(this, R + 3, R + 4);
    return this;
  }, s.prototype.toString = function() {
    const T = this.length;
    return T === 0 ? "" : arguments.length === 0 ? p(this, 0, T) : N.apply(this, arguments);
  }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(T) {
    if (!s.isBuffer(T))
      throw new TypeError("Argument must be a Buffer");
    return this === T ? !0 : s.compare(this, T) === 0;
  }, s.prototype.inspect = function() {
    let T = "";
    const R = e.INSPECT_MAX_BYTES;
    return T = this.toString("hex", 0, R).replace(/(.{2})/g, "$1 ").trim(), this.length > R && (T += " ... "), "<Buffer " + T + ">";
  }, r && (s.prototype[r] = s.prototype.inspect), s.prototype.compare = function(T, R, J, te, re) {
    if (ue(T, Uint8Array) && (T = s.from(T, T.offset, T.byteLength)), !s.isBuffer(T))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof T
      );
    if (R === void 0 && (R = 0), J === void 0 && (J = T ? T.length : 0), te === void 0 && (te = 0), re === void 0 && (re = this.length), R < 0 || J > T.length || te < 0 || re > this.length)
      throw new RangeError("out of range index");
    if (te >= re && R >= J)
      return 0;
    if (te >= re)
      return -1;
    if (R >= J)
      return 1;
    if (R >>>= 0, J >>>= 0, te >>>= 0, re >>>= 0, this === T)
      return 0;
    let de = re - te, et = J - R;
    const st = Math.min(de, et), tt = this.slice(te, re), Yt = T.slice(R, J);
    for (let gt = 0; gt < st; ++gt)
      if (tt[gt] !== Yt[gt]) {
        de = tt[gt], et = Yt[gt];
        break;
      }
    return de < et ? -1 : et < de ? 1 : 0;
  };
  function K(L, T, R, J, te) {
    if (L.length === 0)
      return -1;
    if (typeof R == "string" ? (J = R, R = 0) : R > 2147483647 ? R = 2147483647 : R < -2147483648 && (R = -2147483648), R = +R, fe(R) && (R = te ? 0 : L.length - 1), R < 0 && (R = L.length + R), R >= L.length) {
      if (te)
        return -1;
      R = L.length - 1;
    } else if (R < 0)
      if (te)
        R = 0;
      else
        return -1;
    if (typeof T == "string" && (T = s.from(T, J)), s.isBuffer(T))
      return T.length === 0 ? -1 : W(L, T, R, J, te);
    if (typeof T == "number")
      return T = T & 255, typeof Uint8Array.prototype.indexOf == "function" ? te ? Uint8Array.prototype.indexOf.call(L, T, R) : Uint8Array.prototype.lastIndexOf.call(L, T, R) : W(L, [T], R, J, te);
    throw new TypeError("val must be string, number or Buffer");
  }
  function W(L, T, R, J, te) {
    let re = 1, de = L.length, et = T.length;
    if (J !== void 0 && (J = String(J).toLowerCase(), J === "ucs2" || J === "ucs-2" || J === "utf16le" || J === "utf-16le")) {
      if (L.length < 2 || T.length < 2)
        return -1;
      re = 2, de /= 2, et /= 2, R /= 2;
    }
    function st(Yt, gt) {
      return re === 1 ? Yt[gt] : Yt.readUInt16BE(gt * re);
    }
    let tt;
    if (te) {
      let Yt = -1;
      for (tt = R; tt < de; tt++)
        if (st(L, tt) === st(T, Yt === -1 ? 0 : tt - Yt)) {
          if (Yt === -1 && (Yt = tt), tt - Yt + 1 === et)
            return Yt * re;
        } else
          Yt !== -1 && (tt -= tt - Yt), Yt = -1;
    } else
      for (R + et > de && (R = de - et), tt = R; tt >= 0; tt--) {
        let Yt = !0;
        for (let gt = 0; gt < et; gt++)
          if (st(L, tt + gt) !== st(T, gt)) {
            Yt = !1;
            break;
          }
        if (Yt)
          return tt;
      }
    return -1;
  }
  s.prototype.includes = function(T, R, J) {
    return this.indexOf(T, R, J) !== -1;
  }, s.prototype.indexOf = function(T, R, J) {
    return K(this, T, R, J, !0);
  }, s.prototype.lastIndexOf = function(T, R, J) {
    return K(this, T, R, J, !1);
  };
  function O(L, T, R, J) {
    R = Number(R) || 0;
    const te = L.length - R;
    J ? (J = Number(J), J > te && (J = te)) : J = te;
    const re = T.length;
    J > re / 2 && (J = re / 2);
    let de;
    for (de = 0; de < J; ++de) {
      const et = parseInt(T.substr(de * 2, 2), 16);
      if (fe(et))
        return de;
      L[R + de] = et;
    }
    return de;
  }
  function k(L, T, R, J) {
    return Gt(qe(T, L.length - R), L, R, J);
  }
  function z(L, T, R, J) {
    return Gt(_t(T), L, R, J);
  }
  function C(L, T, R, J) {
    return Gt(mt(T), L, R, J);
  }
  function M(L, T, R, J) {
    return Gt(ve(T, L.length - R), L, R, J);
  }
  s.prototype.write = function(T, R, J, te) {
    if (R === void 0)
      te = "utf8", J = this.length, R = 0;
    else if (J === void 0 && typeof R == "string")
      te = R, J = this.length, R = 0;
    else if (isFinite(R))
      R = R >>> 0, isFinite(J) ? (J = J >>> 0, te === void 0 && (te = "utf8")) : (te = J, J = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const re = this.length - R;
    if ((J === void 0 || J > re) && (J = re), T.length > 0 && (J < 0 || R < 0) || R > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    te || (te = "utf8");
    let de = !1;
    for (; ; )
      switch (te) {
        case "hex":
          return O(this, T, R, J);
        case "utf8":
        case "utf-8":
          return k(this, T, R, J);
        case "ascii":
        case "latin1":
        case "binary":
          return z(this, T, R, J);
        case "base64":
          return C(this, T, R, J);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return M(this, T, R, J);
        default:
          if (de)
            throw new TypeError("Unknown encoding: " + te);
          te = ("" + te).toLowerCase(), de = !0;
      }
  }, s.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function S(L, T, R) {
    return T === 0 && R === L.length ? t.fromByteArray(L) : t.fromByteArray(L.slice(T, R));
  }
  function p(L, T, R) {
    R = Math.min(L.length, R);
    const J = [];
    let te = T;
    for (; te < R; ) {
      const re = L[te];
      let de = null, et = re > 239 ? 4 : re > 223 ? 3 : re > 191 ? 2 : 1;
      if (te + et <= R) {
        let st, tt, Yt, gt;
        switch (et) {
          case 1:
            re < 128 && (de = re);
            break;
          case 2:
            st = L[te + 1], (st & 192) === 128 && (gt = (re & 31) << 6 | st & 63, gt > 127 && (de = gt));
            break;
          case 3:
            st = L[te + 1], tt = L[te + 2], (st & 192) === 128 && (tt & 192) === 128 && (gt = (re & 15) << 12 | (st & 63) << 6 | tt & 63, gt > 2047 && (gt < 55296 || gt > 57343) && (de = gt));
            break;
          case 4:
            st = L[te + 1], tt = L[te + 2], Yt = L[te + 3], (st & 192) === 128 && (tt & 192) === 128 && (Yt & 192) === 128 && (gt = (re & 15) << 18 | (st & 63) << 12 | (tt & 63) << 6 | Yt & 63, gt > 65535 && gt < 1114112 && (de = gt));
        }
      }
      de === null ? (de = 65533, et = 1) : de > 65535 && (de -= 65536, J.push(de >>> 10 & 1023 | 55296), de = 56320 | de & 1023), J.push(de), te += et;
    }
    return v(J);
  }
  const y = 4096;
  function v(L) {
    const T = L.length;
    if (T <= y)
      return String.fromCharCode.apply(String, L);
    let R = "", J = 0;
    for (; J < T; )
      R += String.fromCharCode.apply(
        String,
        L.slice(J, J += y)
      );
    return R;
  }
  function E(L, T, R) {
    let J = "";
    R = Math.min(L.length, R);
    for (let te = T; te < R; ++te)
      J += String.fromCharCode(L[te] & 127);
    return J;
  }
  function B(L, T, R) {
    let J = "";
    R = Math.min(L.length, R);
    for (let te = T; te < R; ++te)
      J += String.fromCharCode(L[te]);
    return J;
  }
  function F(L, T, R) {
    const J = L.length;
    (!T || T < 0) && (T = 0), (!R || R < 0 || R > J) && (R = J);
    let te = "";
    for (let re = T; re < R; ++re)
      te += me[L[re]];
    return te;
  }
  function q(L, T, R) {
    const J = L.slice(T, R);
    let te = "";
    for (let re = 0; re < J.length - 1; re += 2)
      te += String.fromCharCode(J[re] + J[re + 1] * 256);
    return te;
  }
  s.prototype.slice = function(T, R) {
    const J = this.length;
    T = ~~T, R = R === void 0 ? J : ~~R, T < 0 ? (T += J, T < 0 && (T = 0)) : T > J && (T = J), R < 0 ? (R += J, R < 0 && (R = 0)) : R > J && (R = J), R < T && (R = T);
    const te = this.subarray(T, R);
    return Object.setPrototypeOf(te, s.prototype), te;
  };
  function U(L, T, R) {
    if (L % 1 !== 0 || L < 0)
      throw new RangeError("offset is not uint");
    if (L + T > R)
      throw new RangeError("Trying to access beyond buffer length");
  }
  s.prototype.readUintLE = s.prototype.readUIntLE = function(T, R, J) {
    T = T >>> 0, R = R >>> 0, J || U(T, R, this.length);
    let te = this[T], re = 1, de = 0;
    for (; ++de < R && (re *= 256); )
      te += this[T + de] * re;
    return te;
  }, s.prototype.readUintBE = s.prototype.readUIntBE = function(T, R, J) {
    T = T >>> 0, R = R >>> 0, J || U(T, R, this.length);
    let te = this[T + --R], re = 1;
    for (; R > 0 && (re *= 256); )
      te += this[T + --R] * re;
    return te;
  }, s.prototype.readUint8 = s.prototype.readUInt8 = function(T, R) {
    return T = T >>> 0, R || U(T, 1, this.length), this[T];
  }, s.prototype.readUint16LE = s.prototype.readUInt16LE = function(T, R) {
    return T = T >>> 0, R || U(T, 2, this.length), this[T] | this[T + 1] << 8;
  }, s.prototype.readUint16BE = s.prototype.readUInt16BE = function(T, R) {
    return T = T >>> 0, R || U(T, 2, this.length), this[T] << 8 | this[T + 1];
  }, s.prototype.readUint32LE = s.prototype.readUInt32LE = function(T, R) {
    return T = T >>> 0, R || U(T, 4, this.length), (this[T] | this[T + 1] << 8 | this[T + 2] << 16) + this[T + 3] * 16777216;
  }, s.prototype.readUint32BE = s.prototype.readUInt32BE = function(T, R) {
    return T = T >>> 0, R || U(T, 4, this.length), this[T] * 16777216 + (this[T + 1] << 16 | this[T + 2] << 8 | this[T + 3]);
  }, s.prototype.readBigUInt64LE = De(function(T) {
    T = T >>> 0, at(T, "offset");
    const R = this[T], J = this[T + 7];
    (R === void 0 || J === void 0) && Fe(T, this.length - 8);
    const te = R + this[++T] * 2 ** 8 + this[++T] * 2 ** 16 + this[++T] * 2 ** 24, re = this[++T] + this[++T] * 2 ** 8 + this[++T] * 2 ** 16 + J * 2 ** 24;
    return BigInt(te) + (BigInt(re) << BigInt(32));
  }), s.prototype.readBigUInt64BE = De(function(T) {
    T = T >>> 0, at(T, "offset");
    const R = this[T], J = this[T + 7];
    (R === void 0 || J === void 0) && Fe(T, this.length - 8);
    const te = R * 2 ** 24 + this[++T] * 2 ** 16 + this[++T] * 2 ** 8 + this[++T], re = this[++T] * 2 ** 24 + this[++T] * 2 ** 16 + this[++T] * 2 ** 8 + J;
    return (BigInt(te) << BigInt(32)) + BigInt(re);
  }), s.prototype.readIntLE = function(T, R, J) {
    T = T >>> 0, R = R >>> 0, J || U(T, R, this.length);
    let te = this[T], re = 1, de = 0;
    for (; ++de < R && (re *= 256); )
      te += this[T + de] * re;
    return re *= 128, te >= re && (te -= Math.pow(2, 8 * R)), te;
  }, s.prototype.readIntBE = function(T, R, J) {
    T = T >>> 0, R = R >>> 0, J || U(T, R, this.length);
    let te = R, re = 1, de = this[T + --te];
    for (; te > 0 && (re *= 256); )
      de += this[T + --te] * re;
    return re *= 128, de >= re && (de -= Math.pow(2, 8 * R)), de;
  }, s.prototype.readInt8 = function(T, R) {
    return T = T >>> 0, R || U(T, 1, this.length), this[T] & 128 ? (255 - this[T] + 1) * -1 : this[T];
  }, s.prototype.readInt16LE = function(T, R) {
    T = T >>> 0, R || U(T, 2, this.length);
    const J = this[T] | this[T + 1] << 8;
    return J & 32768 ? J | 4294901760 : J;
  }, s.prototype.readInt16BE = function(T, R) {
    T = T >>> 0, R || U(T, 2, this.length);
    const J = this[T + 1] | this[T] << 8;
    return J & 32768 ? J | 4294901760 : J;
  }, s.prototype.readInt32LE = function(T, R) {
    return T = T >>> 0, R || U(T, 4, this.length), this[T] | this[T + 1] << 8 | this[T + 2] << 16 | this[T + 3] << 24;
  }, s.prototype.readInt32BE = function(T, R) {
    return T = T >>> 0, R || U(T, 4, this.length), this[T] << 24 | this[T + 1] << 16 | this[T + 2] << 8 | this[T + 3];
  }, s.prototype.readBigInt64LE = De(function(T) {
    T = T >>> 0, at(T, "offset");
    const R = this[T], J = this[T + 7];
    (R === void 0 || J === void 0) && Fe(T, this.length - 8);
    const te = this[T + 4] + this[T + 5] * 2 ** 8 + this[T + 6] * 2 ** 16 + (J << 24);
    return (BigInt(te) << BigInt(32)) + BigInt(R + this[++T] * 2 ** 8 + this[++T] * 2 ** 16 + this[++T] * 2 ** 24);
  }), s.prototype.readBigInt64BE = De(function(T) {
    T = T >>> 0, at(T, "offset");
    const R = this[T], J = this[T + 7];
    (R === void 0 || J === void 0) && Fe(T, this.length - 8);
    const te = (R << 24) + // Overflow
    this[++T] * 2 ** 16 + this[++T] * 2 ** 8 + this[++T];
    return (BigInt(te) << BigInt(32)) + BigInt(this[++T] * 2 ** 24 + this[++T] * 2 ** 16 + this[++T] * 2 ** 8 + J);
  }), s.prototype.readFloatLE = function(T, R) {
    return T = T >>> 0, R || U(T, 4, this.length), n.read(this, T, !0, 23, 4);
  }, s.prototype.readFloatBE = function(T, R) {
    return T = T >>> 0, R || U(T, 4, this.length), n.read(this, T, !1, 23, 4);
  }, s.prototype.readDoubleLE = function(T, R) {
    return T = T >>> 0, R || U(T, 8, this.length), n.read(this, T, !0, 52, 8);
  }, s.prototype.readDoubleBE = function(T, R) {
    return T = T >>> 0, R || U(T, 8, this.length), n.read(this, T, !1, 52, 8);
  };
  function m(L, T, R, J, te, re) {
    if (!s.isBuffer(L))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (T > te || T < re)
      throw new RangeError('"value" argument is out of bounds');
    if (R + J > L.length)
      throw new RangeError("Index out of range");
  }
  s.prototype.writeUintLE = s.prototype.writeUIntLE = function(T, R, J, te) {
    if (T = +T, R = R >>> 0, J = J >>> 0, !te) {
      const et = Math.pow(2, 8 * J) - 1;
      m(this, T, R, J, et, 0);
    }
    let re = 1, de = 0;
    for (this[R] = T & 255; ++de < J && (re *= 256); )
      this[R + de] = T / re & 255;
    return R + J;
  }, s.prototype.writeUintBE = s.prototype.writeUIntBE = function(T, R, J, te) {
    if (T = +T, R = R >>> 0, J = J >>> 0, !te) {
      const et = Math.pow(2, 8 * J) - 1;
      m(this, T, R, J, et, 0);
    }
    let re = J - 1, de = 1;
    for (this[R + re] = T & 255; --re >= 0 && (de *= 256); )
      this[R + re] = T / de & 255;
    return R + J;
  }, s.prototype.writeUint8 = s.prototype.writeUInt8 = function(T, R, J) {
    return T = +T, R = R >>> 0, J || m(this, T, R, 1, 255, 0), this[R] = T & 255, R + 1;
  }, s.prototype.writeUint16LE = s.prototype.writeUInt16LE = function(T, R, J) {
    return T = +T, R = R >>> 0, J || m(this, T, R, 2, 65535, 0), this[R] = T & 255, this[R + 1] = T >>> 8, R + 2;
  }, s.prototype.writeUint16BE = s.prototype.writeUInt16BE = function(T, R, J) {
    return T = +T, R = R >>> 0, J || m(this, T, R, 2, 65535, 0), this[R] = T >>> 8, this[R + 1] = T & 255, R + 2;
  }, s.prototype.writeUint32LE = s.prototype.writeUInt32LE = function(T, R, J) {
    return T = +T, R = R >>> 0, J || m(this, T, R, 4, 4294967295, 0), this[R + 3] = T >>> 24, this[R + 2] = T >>> 16, this[R + 1] = T >>> 8, this[R] = T & 255, R + 4;
  }, s.prototype.writeUint32BE = s.prototype.writeUInt32BE = function(T, R, J) {
    return T = +T, R = R >>> 0, J || m(this, T, R, 4, 4294967295, 0), this[R] = T >>> 24, this[R + 1] = T >>> 16, this[R + 2] = T >>> 8, this[R + 3] = T & 255, R + 4;
  };
  function D(L, T, R, J, te) {
    Be(T, J, te, L, R, 7);
    let re = Number(T & BigInt(4294967295));
    L[R++] = re, re = re >> 8, L[R++] = re, re = re >> 8, L[R++] = re, re = re >> 8, L[R++] = re;
    let de = Number(T >> BigInt(32) & BigInt(4294967295));
    return L[R++] = de, de = de >> 8, L[R++] = de, de = de >> 8, L[R++] = de, de = de >> 8, L[R++] = de, R;
  }
  function Y(L, T, R, J, te) {
    Be(T, J, te, L, R, 7);
    let re = Number(T & BigInt(4294967295));
    L[R + 7] = re, re = re >> 8, L[R + 6] = re, re = re >> 8, L[R + 5] = re, re = re >> 8, L[R + 4] = re;
    let de = Number(T >> BigInt(32) & BigInt(4294967295));
    return L[R + 3] = de, de = de >> 8, L[R + 2] = de, de = de >> 8, L[R + 1] = de, de = de >> 8, L[R] = de, R + 8;
  }
  s.prototype.writeBigUInt64LE = De(function(T, R = 0) {
    return D(this, T, R, BigInt(0), BigInt("0xffffffffffffffff"));
  }), s.prototype.writeBigUInt64BE = De(function(T, R = 0) {
    return Y(this, T, R, BigInt(0), BigInt("0xffffffffffffffff"));
  }), s.prototype.writeIntLE = function(T, R, J, te) {
    if (T = +T, R = R >>> 0, !te) {
      const st = Math.pow(2, 8 * J - 1);
      m(this, T, R, J, st - 1, -st);
    }
    let re = 0, de = 1, et = 0;
    for (this[R] = T & 255; ++re < J && (de *= 256); )
      T < 0 && et === 0 && this[R + re - 1] !== 0 && (et = 1), this[R + re] = (T / de >> 0) - et & 255;
    return R + J;
  }, s.prototype.writeIntBE = function(T, R, J, te) {
    if (T = +T, R = R >>> 0, !te) {
      const st = Math.pow(2, 8 * J - 1);
      m(this, T, R, J, st - 1, -st);
    }
    let re = J - 1, de = 1, et = 0;
    for (this[R + re] = T & 255; --re >= 0 && (de *= 256); )
      T < 0 && et === 0 && this[R + re + 1] !== 0 && (et = 1), this[R + re] = (T / de >> 0) - et & 255;
    return R + J;
  }, s.prototype.writeInt8 = function(T, R, J) {
    return T = +T, R = R >>> 0, J || m(this, T, R, 1, 127, -128), T < 0 && (T = 255 + T + 1), this[R] = T & 255, R + 1;
  }, s.prototype.writeInt16LE = function(T, R, J) {
    return T = +T, R = R >>> 0, J || m(this, T, R, 2, 32767, -32768), this[R] = T & 255, this[R + 1] = T >>> 8, R + 2;
  }, s.prototype.writeInt16BE = function(T, R, J) {
    return T = +T, R = R >>> 0, J || m(this, T, R, 2, 32767, -32768), this[R] = T >>> 8, this[R + 1] = T & 255, R + 2;
  }, s.prototype.writeInt32LE = function(T, R, J) {
    return T = +T, R = R >>> 0, J || m(this, T, R, 4, 2147483647, -2147483648), this[R] = T & 255, this[R + 1] = T >>> 8, this[R + 2] = T >>> 16, this[R + 3] = T >>> 24, R + 4;
  }, s.prototype.writeInt32BE = function(T, R, J) {
    return T = +T, R = R >>> 0, J || m(this, T, R, 4, 2147483647, -2147483648), T < 0 && (T = 4294967295 + T + 1), this[R] = T >>> 24, this[R + 1] = T >>> 16, this[R + 2] = T >>> 8, this[R + 3] = T & 255, R + 4;
  }, s.prototype.writeBigInt64LE = De(function(T, R = 0) {
    return D(this, T, R, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), s.prototype.writeBigInt64BE = De(function(T, R = 0) {
    return Y(this, T, R, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Q(L, T, R, J, te, re) {
    if (R + J > L.length)
      throw new RangeError("Index out of range");
    if (R < 0)
      throw new RangeError("Index out of range");
  }
  function G(L, T, R, J, te) {
    return T = +T, R = R >>> 0, te || Q(L, T, R, 4), n.write(L, T, R, J, 23, 4), R + 4;
  }
  s.prototype.writeFloatLE = function(T, R, J) {
    return G(this, T, R, !0, J);
  }, s.prototype.writeFloatBE = function(T, R, J) {
    return G(this, T, R, !1, J);
  };
  function he(L, T, R, J, te) {
    return T = +T, R = R >>> 0, te || Q(L, T, R, 8), n.write(L, T, R, J, 52, 8), R + 8;
  }
  s.prototype.writeDoubleLE = function(T, R, J) {
    return he(this, T, R, !0, J);
  }, s.prototype.writeDoubleBE = function(T, R, J) {
    return he(this, T, R, !1, J);
  }, s.prototype.copy = function(T, R, J, te) {
    if (!s.isBuffer(T))
      throw new TypeError("argument should be a Buffer");
    if (J || (J = 0), !te && te !== 0 && (te = this.length), R >= T.length && (R = T.length), R || (R = 0), te > 0 && te < J && (te = J), te === J || T.length === 0 || this.length === 0)
      return 0;
    if (R < 0)
      throw new RangeError("targetStart out of bounds");
    if (J < 0 || J >= this.length)
      throw new RangeError("Index out of range");
    if (te < 0)
      throw new RangeError("sourceEnd out of bounds");
    te > this.length && (te = this.length), T.length - R < te - J && (te = T.length - R + J);
    const re = te - J;
    return this === T && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(R, J, te) : Uint8Array.prototype.set.call(
      T,
      this.subarray(J, te),
      R
    ), re;
  }, s.prototype.fill = function(T, R, J, te) {
    if (typeof T == "string") {
      if (typeof R == "string" ? (te = R, R = 0, J = this.length) : typeof J == "string" && (te = J, J = this.length), te !== void 0 && typeof te != "string")
        throw new TypeError("encoding must be a string");
      if (typeof te == "string" && !s.isEncoding(te))
        throw new TypeError("Unknown encoding: " + te);
      if (T.length === 1) {
        const de = T.charCodeAt(0);
        (te === "utf8" && de < 128 || te === "latin1") && (T = de);
      }
    } else
      typeof T == "number" ? T = T & 255 : typeof T == "boolean" && (T = Number(T));
    if (R < 0 || this.length < R || this.length < J)
      throw new RangeError("Out of range index");
    if (J <= R)
      return this;
    R = R >>> 0, J = J === void 0 ? this.length : J >>> 0, T || (T = 0);
    let re;
    if (typeof T == "number")
      for (re = R; re < J; ++re)
        this[re] = T;
    else {
      const de = s.isBuffer(T) ? T : s.from(T, te), et = de.length;
      if (et === 0)
        throw new TypeError('The value "' + T + '" is invalid for argument "value"');
      for (re = 0; re < J - R; ++re)
        this[re + R] = de[re % et];
    }
    return this;
  };
  const se = {};
  function _e(L, T, R) {
    se[L] = class extends R {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: T.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${L}]`, this.stack, delete this.name;
      }
      get code() {
        return L;
      }
      set code(te) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: te,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${L}]: ${this.message}`;
      }
    };
  }
  _e(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(L) {
      return L ? `${L} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), _e(
    "ERR_INVALID_ARG_TYPE",
    function(L, T) {
      return `The "${L}" argument must be of type number. Received type ${typeof T}`;
    },
    TypeError
  ), _e(
    "ERR_OUT_OF_RANGE",
    function(L, T, R) {
      let J = `The value of "${L}" is out of range.`, te = R;
      return Number.isInteger(R) && Math.abs(R) > 2 ** 32 ? te = Me(String(R)) : typeof R == "bigint" && (te = String(R), (R > BigInt(2) ** BigInt(32) || R < -(BigInt(2) ** BigInt(32))) && (te = Me(te)), te += "n"), J += ` It must be ${T}. Received ${te}`, J;
    },
    RangeError
  );
  function Me(L) {
    let T = "", R = L.length;
    const J = L[0] === "-" ? 1 : 0;
    for (; R >= J + 4; R -= 3)
      T = `_${L.slice(R - 3, R)}${T}`;
    return `${L.slice(0, R)}${T}`;
  }
  function Pe(L, T, R) {
    at(T, "offset"), (L[T] === void 0 || L[T + R] === void 0) && Fe(T, L.length - (R + 1));
  }
  function Be(L, T, R, J, te, re) {
    if (L > R || L < T) {
      const de = typeof T == "bigint" ? "n" : "";
      let et;
      throw re > 3 ? T === 0 || T === BigInt(0) ? et = `>= 0${de} and < 2${de} ** ${(re + 1) * 8}${de}` : et = `>= -(2${de} ** ${(re + 1) * 8 - 1}${de}) and < 2 ** ${(re + 1) * 8 - 1}${de}` : et = `>= ${T}${de} and <= ${R}${de}`, new se.ERR_OUT_OF_RANGE("value", et, L);
    }
    Pe(J, te, re);
  }
  function at(L, T) {
    if (typeof L != "number")
      throw new se.ERR_INVALID_ARG_TYPE(T, "number", L);
  }
  function Fe(L, T, R) {
    throw Math.floor(L) !== L ? (at(L, R), new se.ERR_OUT_OF_RANGE(R || "offset", "an integer", L)) : T < 0 ? new se.ERR_BUFFER_OUT_OF_BOUNDS() : new se.ERR_OUT_OF_RANGE(
      R || "offset",
      `>= ${R ? 1 : 0} and <= ${T}`,
      L
    );
  }
  const Re = /[^+/0-9A-Za-z-_]/g;
  function Nt(L) {
    if (L = L.split("=")[0], L = L.trim().replace(Re, ""), L.length < 2)
      return "";
    for (; L.length % 4 !== 0; )
      L = L + "=";
    return L;
  }
  function qe(L, T) {
    T = T || 1 / 0;
    let R;
    const J = L.length;
    let te = null;
    const re = [];
    for (let de = 0; de < J; ++de) {
      if (R = L.charCodeAt(de), R > 55295 && R < 57344) {
        if (!te) {
          if (R > 56319) {
            (T -= 3) > -1 && re.push(239, 191, 189);
            continue;
          } else if (de + 1 === J) {
            (T -= 3) > -1 && re.push(239, 191, 189);
            continue;
          }
          te = R;
          continue;
        }
        if (R < 56320) {
          (T -= 3) > -1 && re.push(239, 191, 189), te = R;
          continue;
        }
        R = (te - 55296 << 10 | R - 56320) + 65536;
      } else
        te && (T -= 3) > -1 && re.push(239, 191, 189);
      if (te = null, R < 128) {
        if ((T -= 1) < 0)
          break;
        re.push(R);
      } else if (R < 2048) {
        if ((T -= 2) < 0)
          break;
        re.push(
          R >> 6 | 192,
          R & 63 | 128
        );
      } else if (R < 65536) {
        if ((T -= 3) < 0)
          break;
        re.push(
          R >> 12 | 224,
          R >> 6 & 63 | 128,
          R & 63 | 128
        );
      } else if (R < 1114112) {
        if ((T -= 4) < 0)
          break;
        re.push(
          R >> 18 | 240,
          R >> 12 & 63 | 128,
          R >> 6 & 63 | 128,
          R & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return re;
  }
  function _t(L) {
    const T = [];
    for (let R = 0; R < L.length; ++R)
      T.push(L.charCodeAt(R) & 255);
    return T;
  }
  function ve(L, T) {
    let R, J, te;
    const re = [];
    for (let de = 0; de < L.length && !((T -= 2) < 0); ++de)
      R = L.charCodeAt(de), J = R >> 8, te = R % 256, re.push(te), re.push(J);
    return re;
  }
  function mt(L) {
    return t.toByteArray(Nt(L));
  }
  function Gt(L, T, R, J) {
    let te;
    for (te = 0; te < J && !(te + R >= T.length || te >= L.length); ++te)
      T[te + R] = L[te];
    return te;
  }
  function ue(L, T) {
    return L instanceof T || L != null && L.constructor != null && L.constructor.name != null && L.constructor.name === T.name;
  }
  function fe(L) {
    return L !== L;
  }
  const me = function() {
    const L = "0123456789abcdef", T = new Array(256);
    for (let R = 0; R < 16; ++R) {
      const J = R * 16;
      for (let te = 0; te < 16; ++te)
        T[J + te] = L[R] + L[te];
    }
    return T;
  }();
  function De(L) {
    return typeof BigInt > "u" ? ze : L;
  }
  function ze() {
    throw new Error("BigInt not supported");
  }
})(it);
const Tz = /* @__PURE__ */ Vi(it);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(e, t) {
  var n = it, r = n.Buffer;
  function i(a, s) {
    for (var c in a)
      s[c] = a[c];
  }
  r.from && r.alloc && r.allocUnsafe && r.allocUnsafeSlow ? e.exports = n : (i(n, t), t.Buffer = o);
  function o(a, s, c) {
    return r(a, s, c);
  }
  o.prototype = Object.create(r.prototype), i(r, o), o.from = function(a, s, c) {
    if (typeof a == "number")
      throw new TypeError("Argument must not be a number");
    return r(a, s, c);
  }, o.alloc = function(a, s, c) {
    if (typeof a != "number")
      throw new TypeError("Argument must be a number");
    var l = r(a);
    return s !== void 0 ? typeof c == "string" ? l.fill(s, c) : l.fill(s) : l.fill(0), l;
  }, o.allocUnsafe = function(a) {
    if (typeof a != "number")
      throw new TypeError("Argument must be a number");
    return r(a);
  }, o.allocUnsafeSlow = function(a) {
    if (typeof a != "number")
      throw new TypeError("Argument must be a number");
    return n.SlowBuffer(a);
  };
})(NE, NE.exports);
var xz = NE.exports, ng = xz.Buffer;
function Mz(e) {
  if (e.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var t = new Uint8Array(256), n = 0; n < t.length; n++)
    t[n] = 255;
  for (var r = 0; r < e.length; r++) {
    var i = e.charAt(r), o = i.charCodeAt(0);
    if (t[o] !== 255)
      throw new TypeError(i + " is ambiguous");
    t[o] = r;
  }
  var a = e.length, s = e.charAt(0), c = Math.log(a) / Math.log(256), l = Math.log(256) / Math.log(a);
  function u(h) {
    if ((Array.isArray(h) || h instanceof Uint8Array) && (h = ng.from(h)), !ng.isBuffer(h))
      throw new TypeError("Expected Buffer");
    if (h.length === 0)
      return "";
    for (var g = 0, w = 0, b = 0, I = h.length; b !== I && h[b] === 0; )
      b++, g++;
    for (var A = (I - b) * l + 1 >>> 0, x = new Uint8Array(A); b !== I; ) {
      for (var N = h[b], j = 0, K = A - 1; (N !== 0 || j < w) && K !== -1; K--, j++)
        N += 256 * x[K] >>> 0, x[K] = N % a >>> 0, N = N / a >>> 0;
      if (N !== 0)
        throw new Error("Non-zero carry");
      w = j, b++;
    }
    for (var W = A - w; W !== A && x[W] === 0; )
      W++;
    for (var O = s.repeat(g); W < A; ++W)
      O += e.charAt(x[W]);
    return O;
  }
  function f(h) {
    if (typeof h != "string")
      throw new TypeError("Expected String");
    if (h.length === 0)
      return ng.alloc(0);
    for (var g = 0, w = 0, b = 0; h[g] === s; )
      w++, g++;
    for (var I = (h.length - g) * c + 1 >>> 0, A = new Uint8Array(I); h[g]; ) {
      var x = t[h.charCodeAt(g)];
      if (x === 255)
        return;
      for (var N = 0, j = I - 1; (x !== 0 || N < b) && j !== -1; j--, N++)
        x += a * A[j] >>> 0, A[j] = x % 256 >>> 0, x = x / 256 >>> 0;
      if (x !== 0)
        throw new Error("Non-zero carry");
      b = N, g++;
    }
    for (var K = I - b; K !== I && A[K] === 0; )
      K++;
    var W = ng.allocUnsafe(w + (I - K));
    W.fill(0, 0, w);
    for (var O = w; K !== I; )
      W[O++] = A[K++];
    return W;
  }
  function d(h) {
    var g = f(h);
    if (g)
      return g;
    throw new Error("Non-base" + a + " character");
  }
  return {
    encode: u,
    decodeUnsafe: f,
    decode: d
  };
}
var Oz = Mz, Pz = Oz, Bz = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", U3 = Pz(Bz);
const Er = /* @__PURE__ */ Vi(U3);
function Da(e, t, n) {
  return t <= e && e <= n;
}
function Rm(e) {
  if (e === void 0)
    return {};
  if (e === Object(e))
    return e;
  throw TypeError("Could not convert argument to dictionary");
}
function Cz(e) {
  for (var t = String(e), n = t.length, r = 0, i = []; r < n; ) {
    var o = t.charCodeAt(r);
    if (o < 55296 || o > 57343)
      i.push(o);
    else if (56320 <= o && o <= 57343)
      i.push(65533);
    else if (55296 <= o && o <= 56319)
      if (r === n - 1)
        i.push(65533);
      else {
        var a = e.charCodeAt(r + 1);
        if (56320 <= a && a <= 57343) {
          var s = o & 1023, c = a & 1023;
          i.push(65536 + (s << 10) + c), r += 1;
        } else
          i.push(65533);
      }
    r += 1;
  }
  return i;
}
function Dz(e) {
  for (var t = "", n = 0; n < e.length; ++n) {
    var r = e[n];
    r <= 65535 ? t += String.fromCharCode(r) : (r -= 65536, t += String.fromCharCode(
      (r >> 10) + 55296,
      (r & 1023) + 56320
    ));
  }
  return t;
}
var Tb = -1;
function RI(e) {
  this.tokens = [].slice.call(e);
}
RI.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },
  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
  read: function() {
    return this.tokens.length ? this.tokens.shift() : Tb;
  },
  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(e) {
    if (Array.isArray(e))
      for (var t = (
        /**@type {!Array.<number>}*/
        e
      ); t.length; )
        this.tokens.unshift(t.pop());
    else
      this.tokens.unshift(e);
  },
  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(e) {
    if (Array.isArray(e))
      for (var t = (
        /**@type {!Array.<number>}*/
        e
      ); t.length; )
        this.tokens.push(t.shift());
    else
      this.tokens.push(e);
  }
};
var ol = -1;
function dv(e, t) {
  if (e)
    throw TypeError("Decoder error");
  return t || 65533;
}
var xb = "utf-8";
function Mb(e, t) {
  if (!(this instanceof Mb))
    return new Mb(e, t);
  if (e = e !== void 0 ? String(e).toLowerCase() : xb, e !== xb)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  t = Rm(t), this._streaming = !1, this._BOMseen = !1, this._decoder = null, this._fatal = !!t.fatal, this._ignoreBOM = !!t.ignoreBOM, Object.defineProperty(this, "encoding", { value: "utf-8" }), Object.defineProperty(this, "fatal", { value: this._fatal }), Object.defineProperty(this, "ignoreBOM", { value: this._ignoreBOM });
}
Mb.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function(t, n) {
    var r;
    typeof t == "object" && t instanceof ArrayBuffer ? r = new Uint8Array(t) : typeof t == "object" && "buffer" in t && t.buffer instanceof ArrayBuffer ? r = new Uint8Array(
      t.buffer,
      t.byteOffset,
      t.byteLength
    ) : r = new Uint8Array(0), n = Rm(n), this._streaming || (this._decoder = new Rz({ fatal: this._fatal }), this._BOMseen = !1), this._streaming = !!n.stream;
    for (var i = new RI(r), o = [], a; !i.endOfStream() && (a = this._decoder.handler(i, i.read()), a !== ol); )
      a !== null && (Array.isArray(a) ? o.push.apply(
        o,
        /**@type {!Array.<number>}*/
        a
      ) : o.push(a));
    if (!this._streaming) {
      do {
        if (a = this._decoder.handler(i, i.read()), a === ol)
          break;
        a !== null && (Array.isArray(a) ? o.push.apply(
          o,
          /**@type {!Array.<number>}*/
          a
        ) : o.push(a));
      } while (!i.endOfStream());
      this._decoder = null;
    }
    return o.length && ["utf-8"].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen && (o[0] === 65279 ? (this._BOMseen = !0, o.shift()) : this._BOMseen = !0), Dz(o);
  }
};
function Ob(e, t) {
  if (!(this instanceof Ob))
    return new Ob(e, t);
  if (e = e !== void 0 ? String(e).toLowerCase() : xb, e !== xb)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  t = Rm(t), this._streaming = !1, this._encoder = null, this._options = { fatal: !!t.fatal }, Object.defineProperty(this, "encoding", { value: "utf-8" });
}
Ob.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function(t, n) {
    t = t ? String(t) : "", n = Rm(n), this._streaming || (this._encoder = new Nz(this._options)), this._streaming = !!n.stream;
    for (var r = [], i = new RI(Cz(t)), o; !i.endOfStream() && (o = this._encoder.handler(i, i.read()), o !== ol); )
      Array.isArray(o) ? r.push.apply(
        r,
        /**@type {!Array.<number>}*/
        o
      ) : r.push(o);
    if (!this._streaming) {
      for (; o = this._encoder.handler(i, i.read()), o !== ol; )
        Array.isArray(o) ? r.push.apply(
          r,
          /**@type {!Array.<number>}*/
          o
        ) : r.push(o);
      this._encoder = null;
    }
    return new Uint8Array(r);
  }
};
function Rz(e) {
  var t = e.fatal, n = 0, r = 0, i = 0, o = 128, a = 191;
  this.handler = function(s, c) {
    if (c === Tb && i !== 0)
      return i = 0, dv(t);
    if (c === Tb)
      return ol;
    if (i === 0) {
      if (Da(c, 0, 127))
        return c;
      if (Da(c, 194, 223))
        i = 1, n = c - 192;
      else if (Da(c, 224, 239))
        c === 224 && (o = 160), c === 237 && (a = 159), i = 2, n = c - 224;
      else if (Da(c, 240, 244))
        c === 240 && (o = 144), c === 244 && (a = 143), i = 3, n = c - 240;
      else
        return dv(t);
      return n = n << 6 * i, null;
    }
    if (!Da(c, o, a))
      return n = i = r = 0, o = 128, a = 191, s.prepend(c), dv(t);
    if (o = 128, a = 191, r += 1, n += c - 128 << 6 * (i - r), r !== i)
      return null;
    var l = n;
    return n = i = r = 0, l;
  };
}
function Nz(e) {
  e.fatal, this.handler = function(t, n) {
    if (n === Tb)
      return ol;
    if (Da(n, 0, 127))
      return n;
    var r, i;
    Da(n, 128, 2047) ? (r = 1, i = 192) : Da(n, 2048, 65535) ? (r = 2, i = 224) : Da(n, 65536, 1114111) && (r = 3, i = 240);
    for (var o = [(n >> 6 * r) + i]; r > 0; ) {
      var a = n >> 6 * (r - 1);
      o.push(128 | a & 63), r -= 1;
    }
    return o;
  };
}
const jz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextDecoder: Mb,
  TextEncoder: Ob
}, Symbol.toStringTag, { value: "Module" })), Uz = /* @__PURE__ */ Qc(jz);
var zz = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n), Object.defineProperty(e, r, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Fz = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), ma = _ && _.__decorate || function(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(e, t, n, r);
  else
    for (var s = e.length - 1; s >= 0; s--)
      (a = e[s]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, n, o) : a(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
}, Lz = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.hasOwnProperty.call(e, n) && zz(t, e, n);
  return Fz(t, e), t;
}, z3 = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Sr, "__esModule", { value: !0 });
var F3 = Sr.deserializeUnchecked = q3 = Sr.deserialize = V3 = Sr.serialize = Sr.BinaryReader = Sr.BinaryWriter = Sr.BorshError = Sr.baseDecode = Sr.baseEncode = void 0;
const xs = z3(Ka), L3 = z3(U3), $z = Lz(Uz), Wz = typeof TextDecoder != "function" ? $z.TextDecoder : TextDecoder, Kz = new Wz("utf-8", { fatal: !0 });
function Vz(e) {
  return typeof e == "string" && (e = Buffer.from(e, "utf8")), L3.default.encode(Buffer.from(e));
}
Sr.baseEncode = Vz;
function qz(e) {
  return Buffer.from(L3.default.decode(e));
}
Sr.baseDecode = qz;
const hv = 1024;
class fi extends Error {
  constructor(t) {
    super(t), this.fieldPath = [], this.originalMessage = t;
  }
  addToFieldPath(t) {
    this.fieldPath.splice(0, 0, t), this.message = this.originalMessage + ": " + this.fieldPath.join(".");
  }
}
Sr.BorshError = fi;
class $3 {
  constructor() {
    this.buf = Buffer.alloc(hv), this.length = 0;
  }
  maybeResize() {
    this.buf.length < 16 + this.length && (this.buf = Buffer.concat([this.buf, Buffer.alloc(hv)]));
  }
  writeU8(t) {
    this.maybeResize(), this.buf.writeUInt8(t, this.length), this.length += 1;
  }
  writeU16(t) {
    this.maybeResize(), this.buf.writeUInt16LE(t, this.length), this.length += 2;
  }
  writeU32(t) {
    this.maybeResize(), this.buf.writeUInt32LE(t, this.length), this.length += 4;
  }
  writeU64(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new xs.default(t).toArray("le", 8)));
  }
  writeU128(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new xs.default(t).toArray("le", 16)));
  }
  writeU256(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new xs.default(t).toArray("le", 32)));
  }
  writeU512(t) {
    this.maybeResize(), this.writeBuffer(Buffer.from(new xs.default(t).toArray("le", 64)));
  }
  writeBuffer(t) {
    this.buf = Buffer.concat([
      Buffer.from(this.buf.subarray(0, this.length)),
      t,
      Buffer.alloc(hv)
    ]), this.length += t.length;
  }
  writeString(t) {
    this.maybeResize();
    const n = Buffer.from(t, "utf8");
    this.writeU32(n.length), this.writeBuffer(n);
  }
  writeFixedArray(t) {
    this.writeBuffer(Buffer.from(t));
  }
  writeArray(t, n) {
    this.maybeResize(), this.writeU32(t.length);
    for (const r of t)
      this.maybeResize(), n(r);
  }
  toArray() {
    return this.buf.subarray(0, this.length);
  }
}
Sr.BinaryWriter = $3;
function _a(e, t, n) {
  const r = n.value;
  n.value = function(...i) {
    try {
      return r.apply(this, i);
    } catch (o) {
      if (o instanceof RangeError) {
        const a = o.code;
        if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(a) >= 0)
          throw new fi("Reached the end of buffer when deserializing");
      }
      throw o;
    }
  };
}
class Hi {
  constructor(t) {
    this.buf = t, this.offset = 0;
  }
  readU8() {
    const t = this.buf.readUInt8(this.offset);
    return this.offset += 1, t;
  }
  readU16() {
    const t = this.buf.readUInt16LE(this.offset);
    return this.offset += 2, t;
  }
  readU32() {
    const t = this.buf.readUInt32LE(this.offset);
    return this.offset += 4, t;
  }
  readU64() {
    const t = this.readBuffer(8);
    return new xs.default(t, "le");
  }
  readU128() {
    const t = this.readBuffer(16);
    return new xs.default(t, "le");
  }
  readU256() {
    const t = this.readBuffer(32);
    return new xs.default(t, "le");
  }
  readU512() {
    const t = this.readBuffer(64);
    return new xs.default(t, "le");
  }
  readBuffer(t) {
    if (this.offset + t > this.buf.length)
      throw new fi(`Expected buffer length ${t} isn't within bounds`);
    const n = this.buf.slice(this.offset, this.offset + t);
    return this.offset += t, n;
  }
  readString() {
    const t = this.readU32(), n = this.readBuffer(t);
    try {
      return Kz.decode(n);
    } catch (r) {
      throw new fi(`Error decoding UTF-8 string: ${r}`);
    }
  }
  readFixedArray(t) {
    return new Uint8Array(this.readBuffer(t));
  }
  readArray(t) {
    const n = this.readU32(), r = Array();
    for (let i = 0; i < n; ++i)
      r.push(t());
    return r;
  }
}
ma([
  _a
], Hi.prototype, "readU8", null);
ma([
  _a
], Hi.prototype, "readU16", null);
ma([
  _a
], Hi.prototype, "readU32", null);
ma([
  _a
], Hi.prototype, "readU64", null);
ma([
  _a
], Hi.prototype, "readU128", null);
ma([
  _a
], Hi.prototype, "readU256", null);
ma([
  _a
], Hi.prototype, "readU512", null);
ma([
  _a
], Hi.prototype, "readString", null);
ma([
  _a
], Hi.prototype, "readFixedArray", null);
ma([
  _a
], Hi.prototype, "readArray", null);
Sr.BinaryReader = Hi;
function W3(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function fc(e, t, n, r, i) {
  try {
    if (typeof r == "string")
      i[`write${W3(r)}`](n);
    else if (r instanceof Array)
      if (typeof r[0] == "number") {
        if (n.length !== r[0])
          throw new fi(`Expecting byte array of length ${r[0]}, but got ${n.length} bytes`);
        i.writeFixedArray(n);
      } else if (r.length === 2 && typeof r[1] == "number") {
        if (n.length !== r[1])
          throw new fi(`Expecting byte array of length ${r[1]}, but got ${n.length} bytes`);
        for (let o = 0; o < r[1]; o++)
          fc(e, null, n[o], r[0], i);
      } else
        i.writeArray(n, (o) => {
          fc(e, t, o, r[0], i);
        });
    else if (r.kind !== void 0)
      switch (r.kind) {
        case "option": {
          n == null ? i.writeU8(0) : (i.writeU8(1), fc(e, t, n, r.type, i));
          break;
        }
        case "map": {
          i.writeU32(n.size), n.forEach((o, a) => {
            fc(e, t, a, r.key, i), fc(e, t, o, r.value, i);
          });
          break;
        }
        default:
          throw new fi(`FieldType ${r} unrecognized`);
      }
    else
      K3(e, n, i);
  } catch (o) {
    throw o instanceof fi && o.addToFieldPath(t), o;
  }
}
function K3(e, t, n) {
  if (typeof t.borshSerialize == "function") {
    t.borshSerialize(n);
    return;
  }
  const r = e.get(t.constructor);
  if (!r)
    throw new fi(`Class ${t.constructor.name} is missing in schema`);
  if (r.kind === "struct")
    r.fields.map(([i, o]) => {
      fc(e, i, t[i], o, n);
    });
  else if (r.kind === "enum") {
    const i = t[r.field];
    for (let o = 0; o < r.values.length; ++o) {
      const [a, s] = r.values[o];
      if (a === i) {
        n.writeU8(o), fc(e, a, t[a], s, n);
        break;
      }
    }
  } else
    throw new fi(`Unexpected schema kind: ${r.kind} for ${t.constructor.name}`);
}
function Hz(e, t, n = $3) {
  const r = new n();
  return K3(e, t, r), r.toArray();
}
var V3 = Sr.serialize = Hz;
function dc(e, t, n, r) {
  try {
    if (typeof n == "string")
      return r[`read${W3(n)}`]();
    if (n instanceof Array) {
      if (typeof n[0] == "number")
        return r.readFixedArray(n[0]);
      if (typeof n[1] == "number") {
        const i = [];
        for (let o = 0; o < n[1]; o++)
          i.push(dc(e, null, n[0], r));
        return i;
      } else
        return r.readArray(() => dc(e, t, n[0], r));
    }
    if (n.kind === "option")
      return r.readU8() ? dc(e, t, n.type, r) : void 0;
    if (n.kind === "map") {
      let i = /* @__PURE__ */ new Map();
      const o = r.readU32();
      for (let a = 0; a < o; a++) {
        const s = dc(e, t, n.key, r), c = dc(e, t, n.value, r);
        i.set(s, c);
      }
      return i;
    }
    return NI(e, n, r);
  } catch (i) {
    throw i instanceof fi && i.addToFieldPath(t), i;
  }
}
function NI(e, t, n) {
  if (typeof t.borshDeserialize == "function")
    return t.borshDeserialize(n);
  const r = e.get(t);
  if (!r)
    throw new fi(`Class ${t.name} is missing in schema`);
  if (r.kind === "struct") {
    const i = {};
    for (const [o, a] of e.get(t).fields)
      i[o] = dc(e, o, a, n);
    return new t(i);
  }
  if (r.kind === "enum") {
    const i = n.readU8();
    if (i >= r.values.length)
      throw new fi(`Enum index: ${i} is out of range`);
    const [o, a] = r.values[i], s = dc(e, o, a, n);
    return new t({ [o]: s });
  }
  throw new fi(`Unexpected schema kind: ${r.kind} for ${t.constructor.name}`);
}
function Gz(e, t, n, r = Hi) {
  const i = new r(n), o = NI(e, t, i);
  if (i.offset < n.length)
    throw new fi(`Unexpected ${n.length - i.offset} bytes after deserialized data`);
  return o;
}
var q3 = Sr.deserialize = Gz;
function Yz(e, t, n, r = Hi) {
  const i = new r(n);
  return NI(e, t, i);
}
F3 = Sr.deserializeUnchecked = Yz;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BinaryReader = e.BinaryWriter = e.BorshError = e.deserialize = e.serialize = e.base_decode = e.base_encode = void 0;
  var t = Sr;
  Object.defineProperty(e, "base_encode", { enumerable: !0, get: function() {
    return t.baseEncode;
  } }), Object.defineProperty(e, "base_decode", { enumerable: !0, get: function() {
    return t.baseDecode;
  } }), Object.defineProperty(e, "serialize", { enumerable: !0, get: function() {
    return t.serialize;
  } }), Object.defineProperty(e, "deserialize", { enumerable: !0, get: function() {
    return t.deserialize;
  } }), Object.defineProperty(e, "BorshError", { enumerable: !0, get: function() {
    return t.BorshError;
  } }), Object.defineProperty(e, "BinaryWriter", { enumerable: !0, get: function() {
    return t.BinaryWriter;
  } }), Object.defineProperty(e, "BinaryReader", { enumerable: !0, get: function() {
    return t.BinaryReader;
  } });
})(D3);
var H3 = { exports: {} };
const Zz = /* @__PURE__ */ Qc(rz);
(function(e, t) {
  (function(n, r) {
    e.exports = r(vr, n3, Zz);
  })(self, function(n, r, i) {
    return (() => {
      var o = { 937: (c, l, u) => {
        var f = u(158).Symbol;
        c.exports = f;
      }, 41: (c) => {
        c.exports = function(l, u) {
          for (var f = -1, d = l == null ? 0 : l.length, h = Array(d); ++f < d; )
            h[f] = u(l[f], f, l);
          return h;
        };
      }, 276: (c) => {
        c.exports = function(l, u, f, d) {
          var h = -1, g = l == null ? 0 : l.length;
          for (d && g && (f = l[++h]); ++h < g; )
            f = u(f, l[h], h, l);
          return f;
        };
      }, 28: (c) => {
        var l = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
        c.exports = function(u) {
          return u.match(l) || [];
        };
      }, 194: (c, l, u) => {
        var f = u(937), d = u(401), h = u(445), g = f ? f.toStringTag : void 0;
        c.exports = function(w) {
          return w == null ? w === void 0 ? "[object Undefined]" : "[object Null]" : g && g in Object(w) ? d(w) : h(w);
        };
      }, 653: (c) => {
        c.exports = function(l) {
          return function(u) {
            return l == null ? void 0 : l[u];
          };
        };
      }, 430: (c, l, u) => {
        var f = u(937), d = u(41), h = u(706), g = u(878), w = f ? f.prototype : void 0, b = w ? w.toString : void 0;
        c.exports = function I(A) {
          if (typeof A == "string")
            return A;
          if (h(A))
            return d(A, I) + "";
          if (g(A))
            return b ? b.call(A) : "";
          var x = A + "";
          return x == "0" && 1 / A == -1 / 0 ? "-0" : x;
        };
      }, 292: (c, l, u) => {
        var f = u(276), d = u(567), h = u(973), g = RegExp("['’]", "g");
        c.exports = function(w) {
          return function(b) {
            return f(h(d(b).replace(g, "")), w, "");
          };
        };
      }, 64: (c, l, u) => {
        var f = u(653)({ À: "A", Á: "A", Â: "A", Ã: "A", Ä: "A", Å: "A", à: "a", á: "a", â: "a", ã: "a", ä: "a", å: "a", Ç: "C", ç: "c", Ð: "D", ð: "d", È: "E", É: "E", Ê: "E", Ë: "E", è: "e", é: "e", ê: "e", ë: "e", Ì: "I", Í: "I", Î: "I", Ï: "I", ì: "i", í: "i", î: "i", ï: "i", Ñ: "N", ñ: "n", Ò: "O", Ó: "O", Ô: "O", Õ: "O", Ö: "O", Ø: "O", ò: "o", ó: "o", ô: "o", õ: "o", ö: "o", ø: "o", Ù: "U", Ú: "U", Û: "U", Ü: "U", ù: "u", ú: "u", û: "u", ü: "u", Ý: "Y", ý: "y", ÿ: "y", Æ: "Ae", æ: "ae", Þ: "Th", þ: "th", ß: "ss", Ā: "A", Ă: "A", Ą: "A", ā: "a", ă: "a", ą: "a", Ć: "C", Ĉ: "C", Ċ: "C", Č: "C", ć: "c", ĉ: "c", ċ: "c", č: "c", Ď: "D", Đ: "D", ď: "d", đ: "d", Ē: "E", Ĕ: "E", Ė: "E", Ę: "E", Ě: "E", ē: "e", ĕ: "e", ė: "e", ę: "e", ě: "e", Ĝ: "G", Ğ: "G", Ġ: "G", Ģ: "G", ĝ: "g", ğ: "g", ġ: "g", ģ: "g", Ĥ: "H", Ħ: "H", ĥ: "h", ħ: "h", Ĩ: "I", Ī: "I", Ĭ: "I", Į: "I", İ: "I", ĩ: "i", ī: "i", ĭ: "i", į: "i", ı: "i", Ĵ: "J", ĵ: "j", Ķ: "K", ķ: "k", ĸ: "k", Ĺ: "L", Ļ: "L", Ľ: "L", Ŀ: "L", Ł: "L", ĺ: "l", ļ: "l", ľ: "l", ŀ: "l", ł: "l", Ń: "N", Ņ: "N", Ň: "N", Ŋ: "N", ń: "n", ņ: "n", ň: "n", ŋ: "n", Ō: "O", Ŏ: "O", Ő: "O", ō: "o", ŏ: "o", ő: "o", Ŕ: "R", Ŗ: "R", Ř: "R", ŕ: "r", ŗ: "r", ř: "r", Ś: "S", Ŝ: "S", Ş: "S", Š: "S", ś: "s", ŝ: "s", ş: "s", š: "s", Ţ: "T", Ť: "T", Ŧ: "T", ţ: "t", ť: "t", ŧ: "t", Ũ: "U", Ū: "U", Ŭ: "U", Ů: "U", Ű: "U", Ų: "U", ũ: "u", ū: "u", ŭ: "u", ů: "u", ű: "u", ų: "u", Ŵ: "W", ŵ: "w", Ŷ: "Y", ŷ: "y", Ÿ: "Y", Ź: "Z", Ż: "Z", Ž: "Z", ź: "z", ż: "z", ž: "z", Ĳ: "IJ", ĳ: "ij", Œ: "Oe", œ: "oe", ŉ: "'n", ſ: "s" });
        c.exports = f;
      }, 528: (c, l, u) => {
        var f = typeof u.g == "object" && u.g && u.g.Object === Object && u.g;
        c.exports = f;
      }, 401: (c, l, u) => {
        var f = u(937), d = Object.prototype, h = d.hasOwnProperty, g = d.toString, w = f ? f.toStringTag : void 0;
        c.exports = function(b) {
          var I = h.call(b, w), A = b[w];
          try {
            b[w] = void 0;
            var x = !0;
          } catch {
          }
          var N = g.call(b);
          return x && (I ? b[w] = A : delete b[w]), N;
        };
      }, 405: (c) => {
        var l = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
        c.exports = function(u) {
          return l.test(u);
        };
      }, 445: (c) => {
        var l = Object.prototype.toString;
        c.exports = function(u) {
          return l.call(u);
        };
      }, 158: (c, l, u) => {
        var f = u(528), d = typeof self == "object" && self && self.Object === Object && self, h = f || d || Function("return this")();
        c.exports = h;
      }, 667: (c) => {
        var l = "a-z\\xdf-\\xf6\\xf8-\\xff", u = "A-Z\\xc0-\\xd6\\xd8-\\xde", f = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", d = "[" + f + "]", h = "\\d+", g = "[" + l + "]", w = "[^\\ud800-\\udfff" + f + h + "\\u2700-\\u27bf" + l + u + "]", b = "(?:\\ud83c[\\udde6-\\uddff]){2}", I = "[\\ud800-\\udbff][\\udc00-\\udfff]", A = "[" + u + "]", x = "(?:" + g + "|" + w + ")", N = "(?:" + A + "|" + w + ")", j = "(?:['’](?:d|ll|m|re|s|t|ve))?", K = "(?:['’](?:D|LL|M|RE|S|T|VE))?", W = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?", O = "[\\ufe0e\\ufe0f]?", k = O + W + "(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", b, I].join("|") + ")" + O + W + ")*", z = "(?:" + ["[\\u2700-\\u27bf]", b, I].join("|") + ")" + k, C = RegExp([A + "?" + g + "+" + j + "(?=" + [d, A, "$"].join("|") + ")", N + "+" + K + "(?=" + [d, A + x, "$"].join("|") + ")", A + "?" + x + "+" + j, A + "+" + K, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", h, z].join("|"), "g");
        c.exports = function(M) {
          return M.match(C) || [];
        };
      }, 567: (c, l, u) => {
        var f = u(64), d = u(270), h = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, g = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");
        c.exports = function(w) {
          return (w = d(w)) && w.replace(h, f).replace(g, "");
        };
      }, 706: (c) => {
        var l = Array.isArray;
        c.exports = l;
      }, 288: (c) => {
        c.exports = function(l) {
          return l != null && typeof l == "object";
        };
      }, 878: (c, l, u) => {
        var f = u(194), d = u(288);
        c.exports = function(h) {
          return typeof h == "symbol" || d(h) && f(h) == "[object Symbol]";
        };
      }, 277: (c, l, u) => {
        var f = u(292)(function(d, h, g) {
          return d + (g ? "-" : "") + h.toLowerCase();
        });
        c.exports = f;
      }, 270: (c, l, u) => {
        var f = u(430);
        c.exports = function(d) {
          return d == null ? "" : f(d);
        };
      }, 973: (c, l, u) => {
        var f = u(28), d = u(405), h = u(270), g = u(667);
        c.exports = function(w, b, I) {
          return w = h(w), (b = I ? void 0 : b) === void 0 ? d(w) ? g(w) : f(w) : w.match(b) || [];
        };
      }, 663: (c) => {
        var l = String.prototype.replace, u = /%20/g;
        c.exports = { default: "RFC3986", formatters: { RFC1738: function(f) {
          return l.call(f, u, "+");
        }, RFC3986: function(f) {
          return f;
        } }, RFC1738: "RFC1738", RFC3986: "RFC3986" };
      }, 907: (c, l, u) => {
        var f = u(38), d = u(186), h = u(663);
        c.exports = { formats: h, parse: d, stringify: f };
      }, 186: (c, l, u) => {
        var f = u(304), d = Object.prototype.hasOwnProperty, h = { allowDots: !1, allowPrototypes: !1, arrayLimit: 20, charset: "utf-8", charsetSentinel: !1, comma: !1, decoder: f.decode, delimiter: "&", depth: 5, ignoreQueryPrefix: !1, interpretNumericEntities: !1, parameterLimit: 1e3, parseArrays: !0, plainObjects: !1, strictNullHandling: !1 }, g = function(b) {
          return b.replace(/&#(\d+);/g, function(I, A) {
            return String.fromCharCode(parseInt(A, 10));
          });
        }, w = function(b, I, A) {
          if (b) {
            var x = A.allowDots ? b.replace(/\.([^.[]+)/g, "[$1]") : b, N = /(\[[^[\]]*])/g, j = /(\[[^[\]]*])/.exec(x), K = j ? x.slice(0, j.index) : x, W = [];
            if (K) {
              if (!A.plainObjects && d.call(Object.prototype, K) && !A.allowPrototypes)
                return;
              W.push(K);
            }
            for (var O = 0; (j = N.exec(x)) !== null && O < A.depth; ) {
              if (O += 1, !A.plainObjects && d.call(Object.prototype, j[1].slice(1, -1)) && !A.allowPrototypes)
                return;
              W.push(j[1]);
            }
            return j && W.push("[" + x.slice(j.index) + "]"), function(k, z, C) {
              for (var M = z, S = k.length - 1; S >= 0; --S) {
                var p, y = k[S];
                if (y === "[]" && C.parseArrays)
                  p = [].concat(M);
                else {
                  p = C.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
                  var v = y.charAt(0) === "[" && y.charAt(y.length - 1) === "]" ? y.slice(1, -1) : y, E = parseInt(v, 10);
                  C.parseArrays || v !== "" ? !isNaN(E) && y !== v && String(E) === v && E >= 0 && C.parseArrays && E <= C.arrayLimit ? (p = [])[E] = M : p[v] = M : p = { 0: M };
                }
                M = p;
              }
              return M;
            }(W, I, A);
          }
        };
        c.exports = function(b, I) {
          var A = function(k) {
            if (!k)
              return h;
            if (k.decoder !== null && k.decoder !== void 0 && typeof k.decoder != "function")
              throw new TypeError("Decoder has to be a function.");
            if (k.charset !== void 0 && k.charset !== "utf-8" && k.charset !== "iso-8859-1")
              throw new Error("The charset option must be either utf-8, iso-8859-1, or undefined");
            var z = k.charset === void 0 ? h.charset : k.charset;
            return { allowDots: k.allowDots === void 0 ? h.allowDots : !!k.allowDots, allowPrototypes: typeof k.allowPrototypes == "boolean" ? k.allowPrototypes : h.allowPrototypes, arrayLimit: typeof k.arrayLimit == "number" ? k.arrayLimit : h.arrayLimit, charset: z, charsetSentinel: typeof k.charsetSentinel == "boolean" ? k.charsetSentinel : h.charsetSentinel, comma: typeof k.comma == "boolean" ? k.comma : h.comma, decoder: typeof k.decoder == "function" ? k.decoder : h.decoder, delimiter: typeof k.delimiter == "string" || f.isRegExp(k.delimiter) ? k.delimiter : h.delimiter, depth: typeof k.depth == "number" ? k.depth : h.depth, ignoreQueryPrefix: k.ignoreQueryPrefix === !0, interpretNumericEntities: typeof k.interpretNumericEntities == "boolean" ? k.interpretNumericEntities : h.interpretNumericEntities, parameterLimit: typeof k.parameterLimit == "number" ? k.parameterLimit : h.parameterLimit, parseArrays: k.parseArrays !== !1, plainObjects: typeof k.plainObjects == "boolean" ? k.plainObjects : h.plainObjects, strictNullHandling: typeof k.strictNullHandling == "boolean" ? k.strictNullHandling : h.strictNullHandling };
          }(I);
          if (b === "" || b == null)
            return A.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
          for (var x = typeof b == "string" ? function(k, z) {
            var C, M = {}, S = z.ignoreQueryPrefix ? k.replace(/^\?/, "") : k, p = z.parameterLimit === 1 / 0 ? void 0 : z.parameterLimit, y = S.split(z.delimiter, p), v = -1, E = z.charset;
            if (z.charsetSentinel)
              for (C = 0; C < y.length; ++C)
                y[C].indexOf("utf8=") === 0 && (y[C] === "utf8=%E2%9C%93" ? E = "utf-8" : y[C] === "utf8=%26%2310003%3B" && (E = "iso-8859-1"), v = C, C = y.length);
            for (C = 0; C < y.length; ++C)
              if (C !== v) {
                var B, F, q = y[C], U = q.indexOf("]="), m = U === -1 ? q.indexOf("=") : U + 1;
                m === -1 ? (B = z.decoder(q, h.decoder, E), F = z.strictNullHandling ? null : "") : (B = z.decoder(q.slice(0, m), h.decoder, E), F = z.decoder(q.slice(m + 1), h.decoder, E)), F && z.interpretNumericEntities && E === "iso-8859-1" && (F = g(F)), F && z.comma && F.indexOf(",") > -1 && (F = F.split(",")), d.call(M, B) ? M[B] = f.combine(M[B], F) : M[B] = F;
              }
            return M;
          }(b, A) : b, N = A.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, j = Object.keys(x), K = 0; K < j.length; ++K) {
            var W = j[K], O = w(W, x[W], A);
            N = f.merge(N, O, A);
          }
          return f.compact(N);
        };
      }, 38: (c, l, u) => {
        var f = u(304), d = u(663), h = Object.prototype.hasOwnProperty, g = { brackets: function(j) {
          return j + "[]";
        }, comma: "comma", indices: function(j, K) {
          return j + "[" + K + "]";
        }, repeat: function(j) {
          return j;
        } }, w = Array.isArray, b = Array.prototype.push, I = function(j, K) {
          b.apply(j, w(K) ? K : [K]);
        }, A = Date.prototype.toISOString, x = { addQueryPrefix: !1, allowDots: !1, charset: "utf-8", charsetSentinel: !1, delimiter: "&", encode: !0, encoder: f.encode, encodeValuesOnly: !1, formatter: d.formatters[d.default], indices: !1, serializeDate: function(j) {
          return A.call(j);
        }, skipNulls: !1, strictNullHandling: !1 }, N = function j(K, W, O, k, z, C, M, S, p, y, v, E, B) {
          var F = K;
          if (typeof M == "function" ? F = M(W, F) : F instanceof Date ? F = y(F) : O === "comma" && w(F) && (F = F.join(",")), F === null) {
            if (k)
              return C && !E ? C(W, x.encoder, B) : W;
            F = "";
          }
          if (typeof F == "string" || typeof F == "number" || typeof F == "boolean" || f.isBuffer(F))
            return C ? [v(E ? W : C(W, x.encoder, B)) + "=" + v(C(F, x.encoder, B))] : [v(W) + "=" + v(String(F))];
          var q, U = [];
          if (F === void 0)
            return U;
          if (w(M))
            q = M;
          else {
            var m = Object.keys(F);
            q = S ? m.sort(S) : m;
          }
          for (var D = 0; D < q.length; ++D) {
            var Y = q[D];
            z && F[Y] === null || (w(F) ? I(U, j(F[Y], typeof O == "function" ? O(W, Y) : W, O, k, z, C, M, S, p, y, v, E, B)) : I(U, j(F[Y], W + (p ? "." + Y : "[" + Y + "]"), O, k, z, C, M, S, p, y, v, E, B)));
          }
          return U;
        };
        c.exports = function(j, K) {
          var W, O = j, k = function(E) {
            if (!E)
              return x;
            if (E.encoder !== null && E.encoder !== void 0 && typeof E.encoder != "function")
              throw new TypeError("Encoder has to be a function.");
            var B = E.charset || x.charset;
            if (E.charset !== void 0 && E.charset !== "utf-8" && E.charset !== "iso-8859-1")
              throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
            var F = d.default;
            if (E.format !== void 0) {
              if (!h.call(d.formatters, E.format))
                throw new TypeError("Unknown format option provided.");
              F = E.format;
            }
            var q = d.formatters[F], U = x.filter;
            return (typeof E.filter == "function" || w(E.filter)) && (U = E.filter), { addQueryPrefix: typeof E.addQueryPrefix == "boolean" ? E.addQueryPrefix : x.addQueryPrefix, allowDots: E.allowDots === void 0 ? x.allowDots : !!E.allowDots, charset: B, charsetSentinel: typeof E.charsetSentinel == "boolean" ? E.charsetSentinel : x.charsetSentinel, delimiter: E.delimiter === void 0 ? x.delimiter : E.delimiter, encode: typeof E.encode == "boolean" ? E.encode : x.encode, encoder: typeof E.encoder == "function" ? E.encoder : x.encoder, encodeValuesOnly: typeof E.encodeValuesOnly == "boolean" ? E.encodeValuesOnly : x.encodeValuesOnly, filter: U, formatter: q, serializeDate: typeof E.serializeDate == "function" ? E.serializeDate : x.serializeDate, skipNulls: typeof E.skipNulls == "boolean" ? E.skipNulls : x.skipNulls, sort: typeof E.sort == "function" ? E.sort : null, strictNullHandling: typeof E.strictNullHandling == "boolean" ? E.strictNullHandling : x.strictNullHandling };
          }(K);
          typeof k.filter == "function" ? O = (0, k.filter)("", O) : w(k.filter) && (W = k.filter);
          var z, C = [];
          if (typeof O != "object" || O === null)
            return "";
          z = K && K.arrayFormat in g ? K.arrayFormat : K && "indices" in K ? K.indices ? "indices" : "repeat" : "indices";
          var M = g[z];
          W || (W = Object.keys(O)), k.sort && W.sort(k.sort);
          for (var S = 0; S < W.length; ++S) {
            var p = W[S];
            k.skipNulls && O[p] === null || I(C, N(O[p], p, M, k.strictNullHandling, k.skipNulls, k.encode ? k.encoder : null, k.filter, k.sort, k.allowDots, k.serializeDate, k.formatter, k.encodeValuesOnly, k.charset));
          }
          var y = C.join(k.delimiter), v = k.addQueryPrefix === !0 ? "?" : "";
          return k.charsetSentinel && (k.charset === "iso-8859-1" ? v += "utf8=%26%2310003%3B&" : v += "utf8=%E2%9C%93&"), y.length > 0 ? v + y : "";
        };
      }, 304: (c) => {
        var l = Object.prototype.hasOwnProperty, u = Array.isArray, f = function() {
          for (var h = [], g = 0; g < 256; ++g)
            h.push("%" + ((g < 16 ? "0" : "") + g.toString(16)).toUpperCase());
          return h;
        }(), d = function(h, g) {
          for (var w = g && g.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, b = 0; b < h.length; ++b)
            h[b] !== void 0 && (w[b] = h[b]);
          return w;
        };
        c.exports = { arrayToObject: d, assign: function(h, g) {
          return Object.keys(g).reduce(function(w, b) {
            return w[b] = g[b], w;
          }, h);
        }, combine: function(h, g) {
          return [].concat(h, g);
        }, compact: function(h) {
          for (var g = [{ obj: { o: h }, prop: "o" }], w = [], b = 0; b < g.length; ++b)
            for (var I = g[b], A = I.obj[I.prop], x = Object.keys(A), N = 0; N < x.length; ++N) {
              var j = x[N], K = A[j];
              typeof K == "object" && K !== null && w.indexOf(K) === -1 && (g.push({ obj: A, prop: j }), w.push(K));
            }
          return function(W) {
            for (; W.length > 1; ) {
              var O = W.pop(), k = O.obj[O.prop];
              if (u(k)) {
                for (var z = [], C = 0; C < k.length; ++C)
                  k[C] !== void 0 && z.push(k[C]);
                O.obj[O.prop] = z;
              }
            }
          }(g), h;
        }, decode: function(h, g, w) {
          var b = h.replace(/\+/g, " ");
          if (w === "iso-8859-1")
            return b.replace(/%[0-9a-f]{2}/gi, unescape);
          try {
            return decodeURIComponent(b);
          } catch {
            return b;
          }
        }, encode: function(h, g, w) {
          if (h.length === 0)
            return h;
          var b = typeof h == "string" ? h : String(h);
          if (w === "iso-8859-1")
            return escape(b).replace(/%u[0-9a-f]{4}/gi, function(N) {
              return "%26%23" + parseInt(N.slice(2), 16) + "%3B";
            });
          for (var I = "", A = 0; A < b.length; ++A) {
            var x = b.charCodeAt(A);
            x === 45 || x === 46 || x === 95 || x === 126 || x >= 48 && x <= 57 || x >= 65 && x <= 90 || x >= 97 && x <= 122 ? I += b.charAt(A) : x < 128 ? I += f[x] : x < 2048 ? I += f[192 | x >> 6] + f[128 | 63 & x] : x < 55296 || x >= 57344 ? I += f[224 | x >> 12] + f[128 | x >> 6 & 63] + f[128 | 63 & x] : (A += 1, x = 65536 + ((1023 & x) << 10 | 1023 & b.charCodeAt(A)), I += f[240 | x >> 18] + f[128 | x >> 12 & 63] + f[128 | x >> 6 & 63] + f[128 | 63 & x]);
          }
          return I;
        }, isBuffer: function(h) {
          return !(!h || typeof h != "object" || !(h.constructor && h.constructor.isBuffer && h.constructor.isBuffer(h)));
        }, isRegExp: function(h) {
          return Object.prototype.toString.call(h) === "[object RegExp]";
        }, merge: function h(g, w, b) {
          if (!w)
            return g;
          if (typeof w != "object") {
            if (u(g))
              g.push(w);
            else {
              if (!g || typeof g != "object")
                return [g, w];
              (b && (b.plainObjects || b.allowPrototypes) || !l.call(Object.prototype, w)) && (g[w] = !0);
            }
            return g;
          }
          if (!g || typeof g != "object")
            return [g].concat(w);
          var I = g;
          return u(g) && !u(w) && (I = d(g, b)), u(g) && u(w) ? (w.forEach(function(A, x) {
            if (l.call(g, x)) {
              var N = g[x];
              N && typeof N == "object" && A && typeof A == "object" ? g[x] = h(N, A, b) : g.push(A);
            } else
              g[x] = A;
          }), g) : Object.keys(w).reduce(function(A, x) {
            var N = w[x];
            return l.call(A, x) ? A[x] = h(A[x], N, b) : A[x] = N, A;
          }, I);
        } };
      }, 793: (c, l, u) => {
        u.d(l, { default: () => ze });
        var f, d = u(297), h = u(268), g = u(914), w = u.n(g);
        function b() {
          return "persona-widget-" + new Array(16).fill(void 0).map(function() {
            return Math.floor(35 * Math.random()).toString(35);
          }).join("");
        }
        (function(L) {
          L.Embedded = "embedded", L.Inline = "inline";
        })(f || (f = {}));
        var I = u(907), A = u.n(I), x, N, j, K, W;
        (function(L) {
          L.Front = "front", L.Back = "back", L.BarcodePdf417 = "barcode_pdf417", L.FrontOrBack = "front_or_back", L.PassportSignature = "passport_signature";
        })(x || (x = {})), function(L) {
          L.Center = "center", L.Left = "left", L.Right = "right";
        }(N || (N = {})), function(L) {
          L.Cancel = "exit", L.Complete = "complete", L.Error = "error", L.Fail = "fail", L.Load = "load", L.Ready = "ready", L.Start = "start", L.Success = "success", L.DocumentCameraSelect = "document-camera-select", L.DocumentCameraCapture = "document-camera-capture", L.DocumentUpload = "document-upload", L.OneTimeLinkSent = "one-time-link-sent", L.OneTimeLinkStart = "one-time-link-start", L.OneTimeLinkExit = "one-time-link-exit", L.SelfieCameraSelect = "selfie-camera-select", L.SelfieCameraCapture = "selfie-camera-capture", L.SelfieRecordUpload = "selfie-record-upload", L.LoadCameraFailed = "load-camera-failed", L.InquiryLoad = "inquiry-load", L.CountrySelect = "country-select", L.VerificationChange = "verification-change";
        }(j || (j = {})), function(L) {
          L.Open = "open", L.Exit = "exit", L.Destroy = "destroy";
        }(K || (K = {})), function(L) {
          L.Development = "http://localhost:3000", L.Staging = "https://withpersona-staging.com", L.Production = "https://withpersona.com";
        }(W || (W = {}));
        var O = u(277), k = u.n(O), z = function() {
          return (z = Object.assign || function(L) {
            for (var T, R = 1, J = arguments.length; R < J; R++)
              for (var te in T = arguments[R])
                Object.prototype.hasOwnProperty.call(T, te) && (L[te] = T[te]);
            return L;
          }).apply(this, arguments);
        };
        function C(L) {
          return Array.isArray(L) ? L.map(C) : function(T) {
            return T != null && T.constructor === Object;
          }(L) ? Object.keys(L).reduce(function(T, R) {
            var J;
            return z(z({}, T), ((J = {})[k()(R)] = C(L[R]), J));
          }, {}) : L;
        }
        var M = function(L) {
          return L.split(".").slice(-2).join(".");
        };
        const S = function(L) {
          var T, R = L.accountId, J = L.containerId, te = L.environment, re = L.sendClientSideCollectedDataInEvents, de = L.environmentId, et = L.fields, st = L.flowType, tt = L.frameAncestors, Yt = L.frameHeight, gt = L.frameWidth, Rn = L.host, Ho = L.inquiryId, Yn = L.language, Zn = L.lockedAttributes, bu = L.messageTargetOrigin, fn = L.onCancel, vn = L.onComplete, Zi = L.onError, Ln = L.onEvent, $n = L.onLoad, ts = L.onReady, Jn = L.prefill, en = L.refIframe, ns = L.referenceId, $ = L.sessionToken, H = L.templateId, Z = L.templateVersionId, P = L.themeId, X = !(!H && !Z), le = H == null ? void 0 : H.startsWith("itmpl_");
          if (!X && !Ho)
            throw new Error("Either templateId or inquiryId must be specified to start a flow");
          if (X && Ho)
            throw new Error("Only one of templateId or inquiryId should be specified to start a flow");
          if (ns && R)
            throw new Error("Only one of referenceId or accountId should be specified");
          switch (Rn) {
            case "development":
              T = W.Development;
              break;
            case "staging":
              T = W.Staging;
              break;
            default:
              T = W.Production;
          }
          d.useEffect(function() {
            window.addEventListener("message", function(ye) {
              var Ce;
              if ((ye.origin === "" || M(new URL(ye.origin).host) === M(new URL(T).host)) && !(H && H !== ye.data.templateId || Z && Z !== ye.data.templateVersionId || ye.data.containerId && J !== ye.data.containerId))
                switch (Ln == null || Ln(ye.data.name, ye.data.metadata), ye.data.name) {
                  case j.Load:
                    $n == null || $n();
                    break;
                  case j.Ready:
                    ts == null || ts();
                    break;
                  case j.Complete:
                  case j.Fail:
                    vn == null || vn({ inquiryId: ye.data.metadata.inquiryId, status: ye.data.metadata.status, fields: (Ce = ye.data.metadata.fields) !== null && Ce !== void 0 ? Ce : ye.data.metadata.scopes, collectedData: ye.data.metadata.collectedData });
                    break;
                  case j.Cancel:
                    fn == null || fn({ inquiryId: ye.data.metadata.inquiryId, sessionToken: ye.data.metadata.sessionToken });
                    break;
                  case j.Error:
                    Zi == null || Zi(ye.data.error);
                }
            });
          }, []);
          var ce = A().stringify({ "client-version": "4.8.0-alpha", "container-id": J, "flow-type": st, "template-id": (le ? null : H) || null, "inquiry-template-id": (le ? H : null) || null, "inquiry-template-version-id": Z || null, environment: te, "environment-id": de, "iframe-origin": window.location.origin, "frame-ancestors": tt ?? null, "message-target-origin": bu || null, "inquiry-id": Ho || null, language: Yn, "session-token": $, "reference-id": ns, "account-id": R, fields: C(et ?? {}), "send-client-side-collected-data-in-events": re, "theme-id": P, prefill: C(Jn ?? {}), "locked-attributes": C(Zn ?? {}) }, { addQueryPrefix: !0, skipNulls: !0 });
          return d.createElement("iframe", { style: { maxHeight: Yt, maxWidth: gt }, className: "persona-widget__iframe", allow: "camera", sandbox: "allow-same-origin allow-scripts allow-forms allow-popups allow-modals allow-top-navigation-by-user-activation", frameBorder: "0", ref: en, src: T + "/widget" + ce, onLoad: function() {
          } });
        };
        var p = function(L, T) {
          return Object.defineProperty ? Object.defineProperty(L, "raw", { value: T }) : L.raw = T, L;
        }, y = (0, g.keyframes)(B || (B = p([`
  from {
    transform: translate(-50%,-50%) rotate(0deg);
  }
  to {
    transform: translate(-50%,-50%) rotate(360deg);
  }
`], [`
  from {
    transform: translate(-50%,-50%) rotate(0deg);
  }
  to {
    transform: translate(-50%,-50%) rotate(360deg);
  }
`]))), v = w()("svg")(F || (F = p([`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: `, ` 5s linear infinite;
`], [`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: `, ` 5s linear infinite;
`])), y);
        const E = function() {
          return d.createElement(v, { xmlns: "http://www.w3.org/2000/svg", width: "114", height: "114" }, d.createElement("path", { fill: "none", stroke: "#0F2B72", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M25.887 10.432a56.275 56.275 0 0 0-15.455 15.455 55.86 55.86 0 0 0-5.183 9.678A55.576 55.576 0 0 0 2.066 46.07m-.8 5.438A56.678 56.678 0 0 0 1 57m4.249 21.435a55.86 55.86 0 0 0 5.183 9.678 56.275 56.275 0 0 0 6.97 8.485m8.485 6.97a55.86 55.86 0 0 0 9.678 5.183 55.576 55.576 0 0 0 10.506 3.183c3.535.7 7.19 1.066 10.929 1.066 3.74 0 7.394-.367 10.929-1.066a55.576 55.576 0 0 0 10.506-3.183 55.86 55.86 0 0 0 9.678-5.183 56.275 56.275 0 0 0 15.455-15.455 55.86 55.86 0 0 0 5.183-9.678 55.576 55.576 0 0 0 3.183-10.506A56.274 56.274 0 0 0 113 57c0-3.74-.367-7.394-1.066-10.929a55.576 55.576 0 0 0-3.183-10.506M96.598 17.402a56.275 56.275 0 0 0-8.485-6.97 55.86 55.86 0 0 0-9.678-5.183A55.576 55.576 0 0 0 67.93 2.066 56.274 56.274 0 0 0 57 1c-3.74 0-7.394.367-10.929 1.066m-34.94 30.418A51.76 51.76 0 0 0 7.225 41.9a51.633 51.633 0 0 0-1.98 10 52.63 52.63 0 0 0 .744 15.247 51.633 51.633 0 0 0 7.768 18.743 52.188 52.188 0 0 0 10.254 11.308 52.188 52.188 0 0 0 8.472 5.67m9.417 3.905a51.633 51.633 0 0 0 10 1.98 52.63 52.63 0 0 0 10.197 0 51.939 51.939 0 0 0 10-1.98 51.61 51.61 0 0 0 9.418-3.904 51.984 51.984 0 0 0 8.472-5.671m3.782-3.43a52.308 52.308 0 0 0 3.429-3.78m9.575-17.89a51.633 51.633 0 0 0 1.98-10 52.63 52.63 0 0 0-.744-15.247 51.633 51.633 0 0 0-7.768-18.743 52.188 52.188 0 0 0-10.254-11.308m-4.097-3.043a51.984 51.984 0 0 0-4.375-2.628M67.148 5.99a51.939 51.939 0 0 0-5.05-.743 52.63 52.63 0 0 0-15.246.743 51.633 51.633 0 0 0-18.743 7.768M24.012 16.8a52.308 52.308 0 0 0-3.782 3.43" }));
        };
        var B, F, q = function(L, T) {
          return Object.defineProperty ? Object.defineProperty(L, "raw", { value: T }) : L.raw = T, L;
        }, U = ((0, g.keyframes)(D || (D = q([`
  from {
    transform: translate(-50%,-50%) rotate(0deg);
  }
  to {
    transform: translate(-50%,-50%) rotate(360deg);
  }
`], [`
  from {
    transform: translate(-50%,-50%) rotate(0deg);
  }
  to {
    transform: translate(-50%,-50%) rotate(360deg);
  }
`]))), w()("div")(Y || (Y = q([`
  position: relative;
  width: 120px;
  height: 120px;
`], [`
  position: relative;
  width: 120px;
  height: 120px;
`]))));
        const m = function() {
          return d.createElement(U, null, d.createElement(E, null));
        };
        var D, Y, Q = function(L, T) {
          return Object.defineProperty ? Object.defineProperty(L, "raw", { value: T }) : L.raw = T, L;
        }, G = function() {
          return (G = Object.assign || function(L) {
            for (var T, R = 1, J = arguments.length; R < J; R++)
              for (var te in T = arguments[R])
                Object.prototype.hasOwnProperty.call(T, te) && (L[te] = T[te]);
            return L;
          }).apply(this, arguments);
        }, he = (0, g.keyframes)(Re || (Re = Q([`
  from {
    background-color: rgba(0, 0, 0, 0);
    opacity: 0;
  }
  to {
    background-color: rgba(0, 0, 0, `, `);
    opacity: 1;
  }
`], [`
  from {
    background-color: rgba(0, 0, 0, 0);
    opacity: 0;
  }
  to {
    background-color: rgba(0, 0, 0, `, `);
    opacity: 1;
  }
`])), 0.7), se = w()("div")(Nt || (Nt = Q([`
  animation: `, ` 0.3s;
  background-color: rgba(0, 0, 0, `, `);
  display: `, `;

  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
`], [`
  animation: `, ` 0.3s;
  background-color: rgba(0, 0, 0, `, `);
  display: `, `;

  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
`])), he, 0.7, function(L) {
          return L.isOpen ? "block" : "none";
        }), _e = w()("div")(qe || (qe = Q([`
  width: 120px;
  height: 120px;
  position: absolute;
  left: calc(50% - 60px);
  top: calc(50% - 60px);
  z-index: 9999;
`], [`
  width: 120px;
  height: 120px;
  position: absolute;
  left: calc(50% - 60px);
  top: calc(50% - 60px);
  z-index: 9999;
`]))), Me = (0, g.keyframes)(_t || (_t = Q([`
  from {
    transform: translate(-50%, -40%) scale(.8);
  }
  90% {
    transform: translate(-50%, -51%) scale(1.01);
  }
  to {
    transform: translate(-50%, -50%);
  }
`], [`
  from {
    transform: translate(-50%, -40%) scale(.8);
  }
  90% {
    transform: translate(-50%, -51%) scale(1.01);
  }
  to {
    transform: translate(-50%, -50%);
  }
`]))), Pe = (0, g.keyframes)(ve || (ve = Q([`
  from {
    transform: translate(-50%, -55%);
  }
  to {
    transform: translate(-50%, -50%);
  }
`], [`
  from {
    transform: translate(-50%, -55%);
  }
  to {
    transform: translate(-50%, -50%);
  }
`]))), Be = w()("div")(mt || (mt = Q([`
  iframe {
    animation: `, " 0.3s, ", ` ease-out 0.3s;

    width: 100%;
    height: 100%;

    margin-left: auto;
    margin-right: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    background-color: #ffffff;
    border: none;
    border-radius: 4px;
    box-shadow: 0px 12px 40px 2px rgba(0, 0, 0, 0.4);

    @media only screen and (min-width: 600.02px) and (min-height: 600.02px) {
      max-width: 400px;
      max-height: 650px;
    }
  }
`], [`
  iframe {
    animation: `, " 0.3s, ", ` ease-out 0.3s;

    width: 100%;
    height: 100%;

    margin-left: auto;
    margin-right: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    background-color: #ffffff;
    border: none;
    border-radius: 4px;
    box-shadow: 0px 12px 40px 2px rgba(0, 0, 0, 0.4);

    @media only screen and (min-width: 600.02px) and (min-height: 600.02px) {
      max-width: 400px;
      max-height: 650px;
    }
  }
`])), Me, Pe), at = (0, g.createGlobalStyle)(Gt || (Gt = Q([`
  // Don't allow scrolling when widget is open
  html body {
    overflow: hidden !important;
  }

  // When the widget takes the full screen, hide everything else to prevent iOS scroll issues.
  @media `, ` {
    html body > *:not(#`, `) {
      display: none !important;
    }
  }
`], [`
  // Don't allow scrolling when widget is open
  html body {
    overflow: hidden !important;
  }

  // When the widget takes the full screen, hide everything else to prevent iOS scroll issues.
  @media `, ` {
    html body > *:not(#`, `) {
      display: none !important;
    }
  }
`])), "(max-width: 600px), (max-height: 420px)", function(L) {
          return L.containerId;
        });
        const Fe = function(L) {
          return d.createElement(se, { isOpen: L.isOpen, className: "persona-widget__overlay" }, L.isLoading && d.createElement(_e, null, d.createElement(m, null)), d.createElement(Be, null, d.createElement(S, G({}, L, { flowType: f.Embedded }))), L.isOpen && d.createElement(at, { containerId: L.containerId }));
        };
        var Re, Nt, qe, _t, ve, mt, Gt;
        const ue = function() {
          function L() {
          }
          return L.log = function(T, R) {
          }, L;
        }();
        var fe = function() {
          return (fe = Object.assign || function(L) {
            for (var T, R = 1, J = arguments.length; R < J; R++)
              for (var te in T = arguments[R])
                Object.prototype.hasOwnProperty.call(T, te) && (L[te] = T[te]);
            return L;
          }).apply(this, arguments);
        }, me = function() {
          function L(T) {
            var R, J, te = this;
            this._isLoading = !0, this._isOpen = !1, this.onLoad = function() {
              var re, de;
              te._isLoading = !1, te.render(), (de = (re = te.options).onLoad) === null || de === void 0 || de.call(re);
            }, this.onReady = function() {
              var re, de;
              (de = (re = te.options).onReady) === null || de === void 0 || de.call(re);
            }, this.onComplete = function(re) {
              var de, et, st = re.inquiryId, tt = re.status, Yt = re.fields, gt = re.collectedData;
              te._isOpen = !1, te.render(), (et = (de = te.options).onComplete) === null || et === void 0 || et.call(de, gt ? { inquiryId: st, status: tt, fields: Yt, collectedData: gt } : { inquiryId: st, status: tt, fields: Yt });
            }, this.onCancel = function(re) {
              var de, et, st = re.inquiryId, tt = re.sessionToken;
              te._isOpen = !1, te.render(), (et = (de = te.options).onCancel) === null || et === void 0 || et.call(de, { inquiryId: st, sessionToken: tt });
            }, this.options = T, this.refIframe = d.createRef(), this.container = document.createElement("div"), this.containerId = b(), this.container.setAttribute("id", this.containerId), this.containerParent = (J = (R = T.parent) !== null && R !== void 0 ? R : document.body) !== null && J !== void 0 ? J : document.children[0], this.containerParent.appendChild(this.container), this.render();
          }
          return L.prototype.render = function() {
            if (this.container != null)
              try {
                h.render(d.createElement(Fe, fe({ isLoading: this._isLoading, isOpen: this._isOpen, containerId: this.containerId, refIframe: this.refIframe }, this.options, { onLoad: this.onLoad, onReady: this.onReady, onComplete: this.onComplete, onCancel: this.onCancel, onEvent: this.options.onEvent })), this.container);
              } catch (T) {
                throw this.destroy(), T;
              }
            else
              ue.log("Cannot render client that has been destroyed", "error");
          }, L.prototype.open = function() {
            var T, R;
            (R = (T = this.refIframe.current) === null || T === void 0 ? void 0 : T.contentWindow) === null || R === void 0 || R.postMessage({ action: K.Open, metadata: {} }, this.baseUrl), this._isOpen = !0, this.render();
          }, L.prototype.cancel = function(T) {
            var R, J;
            (J = (R = this.refIframe.current) === null || R === void 0 ? void 0 : R.contentWindow) === null || J === void 0 || J.postMessage({ action: K.Exit, metadata: { force: T } }, this.baseUrl), this.render();
          }, L.prototype.destroy = function() {
            var T, R;
            (R = (T = this.refIframe.current) === null || T === void 0 ? void 0 : T.contentWindow) === null || R === void 0 || R.postMessage({ action: K.Destroy, metadata: {} }, this.baseUrl), h.unmountComponentAtNode(this.container), this.containerParent.removeChild(this.container);
          }, Object.defineProperty(L.prototype, "isLoading", { get: function() {
            return this._isLoading;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(L.prototype, "isOpen", { get: function() {
            return this._isOpen;
          }, enumerable: !1, configurable: !0 }), Object.defineProperty(L.prototype, "baseUrl", { get: function() {
            switch (this.options.host) {
              case "development":
                return W.Development;
              case "staging":
                return W.Staging;
              default:
                return W.Production;
            }
          }, enumerable: !1, configurable: !0 }), L;
        }(), De = function() {
          return (De = Object.assign || function(L) {
            for (var T, R = 1, J = arguments.length; R < J; R++)
              for (var te in T = arguments[R])
                Object.prototype.hasOwnProperty.call(T, te) && (L[te] = T[te]);
            return L;
          }).apply(this, arguments);
        };
        const ze = { Client: me, Inquiry: function(L) {
          var T = function(J, te) {
            var re = typeof Symbol == "function" && J[Symbol.iterator];
            if (!re)
              return J;
            var de, et, st = re.call(J), tt = [];
            try {
              for (; (te === void 0 || te-- > 0) && !(de = st.next()).done; )
                tt.push(de.value);
            } catch (Yt) {
              et = { error: Yt };
            } finally {
              try {
                de && !de.done && (re = st.return) && re.call(st);
              } finally {
                if (et)
                  throw et.error;
              }
            }
            return tt;
          }(d.useState(b()), 2), R = T[0];
          return T[1], d.createElement(S, De({}, L, { containerId: R, flowType: f.Inline }));
        } };
      }, 297: (c) => {
        c.exports = n;
      }, 268: (c) => {
        c.exports = r;
      }, 914: (c) => {
        c.exports = i;
      } }, a = {};
      function s(c) {
        if (a[c])
          return a[c].exports;
        var l = a[c] = { exports: {} };
        return o[c](l, l.exports, s), l.exports;
      }
      return s.n = (c) => {
        var l = c && c.__esModule ? () => c.default : () => c;
        return s.d(l, { a: l }), l;
      }, s.d = (c, l) => {
        for (var u in l)
          s.o(l, u) && !s.o(c, u) && Object.defineProperty(c, u, { enumerable: !0, get: l[u] });
      }, s.g = function() {
        if (typeof globalThis == "object")
          return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object")
            return window;
        }
      }(), s.o = (c, l) => Object.prototype.hasOwnProperty.call(c, l), s(793);
    })().default;
  });
})(H3);
var Jz = H3.exports, pv = { exports: {} }, Tx;
function jI() {
  return Tx || (Tx = 1, function(e) {
    var t = Object.prototype.hasOwnProperty, n = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
    function i(c, l, u) {
      this.fn = c, this.context = l, this.once = u || !1;
    }
    function o(c, l, u, f, d) {
      if (typeof u != "function")
        throw new TypeError("The listener must be a function");
      var h = new i(u, f || c, d), g = n ? n + l : l;
      return c._events[g] ? c._events[g].fn ? c._events[g] = [c._events[g], h] : c._events[g].push(h) : (c._events[g] = h, c._eventsCount++), c;
    }
    function a(c, l) {
      --c._eventsCount === 0 ? c._events = new r() : delete c._events[l];
    }
    function s() {
      this._events = new r(), this._eventsCount = 0;
    }
    s.prototype.eventNames = function() {
      var l = [], u, f;
      if (this._eventsCount === 0)
        return l;
      for (f in u = this._events)
        t.call(u, f) && l.push(n ? f.slice(1) : f);
      return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(u)) : l;
    }, s.prototype.listeners = function(l) {
      var u = n ? n + l : l, f = this._events[u];
      if (!f)
        return [];
      if (f.fn)
        return [f.fn];
      for (var d = 0, h = f.length, g = new Array(h); d < h; d++)
        g[d] = f[d].fn;
      return g;
    }, s.prototype.listenerCount = function(l) {
      var u = n ? n + l : l, f = this._events[u];
      return f ? f.fn ? 1 : f.length : 0;
    }, s.prototype.emit = function(l, u, f, d, h, g) {
      var w = n ? n + l : l;
      if (!this._events[w])
        return !1;
      var b = this._events[w], I = arguments.length, A, x;
      if (b.fn) {
        switch (b.once && this.removeListener(l, b.fn, void 0, !0), I) {
          case 1:
            return b.fn.call(b.context), !0;
          case 2:
            return b.fn.call(b.context, u), !0;
          case 3:
            return b.fn.call(b.context, u, f), !0;
          case 4:
            return b.fn.call(b.context, u, f, d), !0;
          case 5:
            return b.fn.call(b.context, u, f, d, h), !0;
          case 6:
            return b.fn.call(b.context, u, f, d, h, g), !0;
        }
        for (x = 1, A = new Array(I - 1); x < I; x++)
          A[x - 1] = arguments[x];
        b.fn.apply(b.context, A);
      } else {
        var N = b.length, j;
        for (x = 0; x < N; x++)
          switch (b[x].once && this.removeListener(l, b[x].fn, void 0, !0), I) {
            case 1:
              b[x].fn.call(b[x].context);
              break;
            case 2:
              b[x].fn.call(b[x].context, u);
              break;
            case 3:
              b[x].fn.call(b[x].context, u, f);
              break;
            case 4:
              b[x].fn.call(b[x].context, u, f, d);
              break;
            default:
              if (!A)
                for (j = 1, A = new Array(I - 1); j < I; j++)
                  A[j - 1] = arguments[j];
              b[x].fn.apply(b[x].context, A);
          }
      }
      return !0;
    }, s.prototype.on = function(l, u, f) {
      return o(this, l, u, f, !1);
    }, s.prototype.once = function(l, u, f) {
      return o(this, l, u, f, !0);
    }, s.prototype.removeListener = function(l, u, f, d) {
      var h = n ? n + l : l;
      if (!this._events[h])
        return this;
      if (!u)
        return a(this, h), this;
      var g = this._events[h];
      if (g.fn)
        g.fn === u && (!d || g.once) && (!f || g.context === f) && a(this, h);
      else {
        for (var w = 0, b = [], I = g.length; w < I; w++)
          (g[w].fn !== u || d && !g[w].once || f && g[w].context !== f) && b.push(g[w]);
        b.length ? this._events[h] = b.length === 1 ? b[0] : b : a(this, h);
      }
      return this;
    }, s.prototype.removeAllListeners = function(l) {
      var u;
      return l ? (u = n ? n + l : l, this._events[u] && a(this, u)) : (this._events = new r(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s;
  }(pv)), pv.exports;
}
var Xz = jI();
const G3 = /* @__PURE__ */ Vi(Xz);
let go = class extends Error {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(t, n) {
    super(t), this.error = n;
  }
};
class Qz extends go {
  constructor() {
    super(...arguments), this.name = "WalletNotReadyError";
  }
}
class eF extends go {
  constructor() {
    super(...arguments), this.name = "WalletConnectionError";
  }
}
class tF extends go {
  constructor() {
    super(...arguments), this.name = "WalletDisconnectedError";
  }
}
class nF extends go {
  constructor() {
    super(...arguments), this.name = "WalletDisconnectionError";
  }
}
class rF extends go {
  constructor() {
    super(...arguments), this.name = "WalletAccountError";
  }
}
class xx extends go {
  constructor() {
    super(...arguments), this.name = "WalletPublicKeyError";
  }
}
class If extends go {
  constructor() {
    super(...arguments), this.name = "WalletNotConnectedError";
  }
}
class kf extends go {
  constructor() {
    super(...arguments), this.name = "WalletSendTransactionError";
  }
}
class iF extends go {
  constructor() {
    super(...arguments), this.name = "WalletSignMessageError";
  }
}
class Cu extends go {
  constructor() {
    super(...arguments), this.name = "WalletSignTransactionError";
  }
}
var ro;
(function(e) {
  e.Installed = "Installed", e.NotDetected = "NotDetected", e.Loadable = "Loadable", e.Unsupported = "Unsupported";
})(ro || (ro = {}));
class oF extends G3 {
  get connected() {
    return !!this.publicKey;
  }
  async autoConnect() {
    await this.connect();
  }
  async prepareTransaction(t, n, r = {}) {
    const i = this.publicKey;
    if (!i)
      throw new If();
    return t.feePayer = t.feePayer || i, t.recentBlockhash = t.recentBlockhash || (await n.getLatestBlockhash({
      commitment: r.preflightCommitment,
      minContextSlot: r.minContextSlot
    })).blockhash, t;
  }
}
function aF(e) {
  if (typeof window > "u" || typeof document > "u")
    return;
  const t = [];
  function n() {
    if (e())
      for (const o of t)
        o();
  }
  const r = (
    // TODO: #334 Replace with idle callback strategy.
    setInterval(n, 1e3)
  );
  t.push(() => clearInterval(r)), // Implies that `DOMContentLoaded` has not yet fired.
  document.readyState === "loading" && (document.addEventListener("DOMContentLoaded", n, { once: !0 }), t.push(() => document.removeEventListener("DOMContentLoaded", n))), // If the `complete` state has been reached, we're too late.
  document.readyState !== "complete" && (window.addEventListener("load", n, { once: !0 }), t.push(() => window.removeEventListener("load", n))), n();
}
function sF() {
  if (!navigator)
    return !1;
  const e = navigator.userAgent.toLowerCase(), t = e.includes("iphone") || e.includes("ipad"), n = e.includes("safari");
  return t && n;
}
function jE(e) {
  return "version" in e;
}
class cF extends oF {
  async sendTransaction(t, n, r = {}) {
    let i = !0;
    try {
      if (jE(t)) {
        if (!this.supportedTransactionVersions)
          throw new kf("Sending versioned transactions isn't supported by this wallet");
        if (!this.supportedTransactionVersions.has(t.version))
          throw new kf(`Sending transaction version ${t.version} isn't supported by this wallet`);
        try {
          t = await this.signTransaction(t);
          const o = t.serialize();
          return await n.sendRawTransaction(o, r);
        } catch (o) {
          throw o instanceof Cu ? (i = !1, o) : new kf(o == null ? void 0 : o.message, o);
        }
      } else
        try {
          const { signers: o, ...a } = r;
          t = await this.prepareTransaction(t, n, a), o != null && o.length && t.partialSign(...o), t = await this.signTransaction(t);
          const s = t.serialize();
          return await n.sendRawTransaction(s, a);
        } catch (o) {
          throw o instanceof Cu ? (i = !1, o) : new kf(o == null ? void 0 : o.message, o);
        }
    } catch (o) {
      throw i && this.emit("error", o), o;
    }
  }
  async signAllTransactions(t) {
    for (const r of t)
      if (jE(r)) {
        if (!this.supportedTransactionVersions)
          throw new Cu("Signing versioned transactions isn't supported by this wallet");
        if (!this.supportedTransactionVersions.has(r.version))
          throw new Cu(`Signing transaction version ${r.version} isn't supported by this wallet`);
      }
    const n = [];
    for (const r of t)
      n.push(await this.signTransaction(r));
    return n;
  }
}
class uF extends cF {
}
var jf;
(function(e) {
  e.Mainnet = "mainnet-beta", e.Testnet = "testnet", e.Devnet = "devnet";
})(jf || (jf = {}));
const lF = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function fF(e, t) {
  let n = "";
  for (let r = 0; r < e; r++)
    n += t.charAt(Math.floor(Math.random() * t.length));
  return n;
}
function dF(e) {
  return fF(e, lF);
}
function yv(e, t) {
  const n = [[], []];
  return e.forEach((r) => {
    n[t(r) ? 0 : 1].push(r);
  }), n;
}
function Uf(e) {
  return Object.keys(e);
}
function Pb(e) {
  return typeof e == "object" && e !== null;
}
function hF(e) {
  return e.status === "fulfilled";
}
function Mx(e, t, n) {
  return e === "Ethereum" ? t.toLowerCase() === n.toLowerCase() : t === n;
}
function eb(e, t) {
  if (e === t)
    return !0;
  if (e == null || t == null)
    return !1;
  if (typeof e != "object" || typeof t != "object")
    return e === t;
  const n = Uf(e), r = Uf(t);
  if (n.length !== r.length)
    return !1;
  for (const i of n)
    if (!r.includes(i))
      return !1;
  for (const i of n)
    if (!eb(e[i], t[i]))
      return !1;
  return !0;
}
class UE extends Error {
  constructor(t, n) {
    super(t), this.name = "TimeOutError", this.wrappedError = n;
  }
}
async function zE(e, t, n, r) {
  const { useExponentialBackoff: i, resolvePredicate: o, retryOnErrorPredicate: a } = r || {};
  let s = 0;
  const c = (l, u) => {
    let f = t;
    i && (f = 2 ** s * t);
    const d = (h) => {
      s >= n ? u(new UE("TIMEOUT", h)) : setTimeout(c, f, l, u);
    };
    Promise.resolve(e()).then((h) => {
      !o || o && o(h) ? l(h) : d();
    }).catch((h) => {
      a && a(h) ? d(h) : u(h);
    }).finally(() => s++);
  };
  return new Promise(c);
}
function pF(e, t) {
  const n = {
    CeloAlfajores: "",
    CeloMainnet: "",
    NearMainnet: "",
    NearTestnet: "",
    EthereumGoerli: "",
    EthereumMainnet: "",
    PolygonMainnet: "",
    PolygonMumbai: "",
    SolanaDevnet: "?cluster=devnet",
    SolanaMainnet: "",
    SolanaTestnet: "?cluster=testnet",
    BaseGoerli: "",
    ArbitrumMainnet: "",
    ArbitrumGoerli: "",
    ZKSyncMainnet: "",
    ZKSyncGoerli: "",
    AptosDevnet: "?network=devnet",
    AptosMainnet: "?network=mainnet",
    AptosTestnet: "?network=testnet"
  }, { url: r, transaction_path: i } = t.explorer;
  return r + i + e + n[t.id];
}
function Ox(e, t, n, r) {
  return {
    transactionUrl: pF(t, e),
    tokenId: n,
    imageUrl: r.image_url
  };
}
function Bb(e) {
  return e.replace("ipfs://", "https://kycdao.infura-ipfs.io/ipfs/");
}
const Y3 = Object.prototype.toString;
function Z3(e) {
  switch (Y3.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return !0;
    default:
      return Nl(e, Error);
  }
}
function Rl(e, t) {
  return Y3.call(e) === `[object ${t}]`;
}
function J3(e) {
  return Rl(e, "ErrorEvent");
}
function Px(e) {
  return Rl(e, "DOMError");
}
function yF(e) {
  return Rl(e, "DOMException");
}
function Tc(e) {
  return Rl(e, "String");
}
function X3(e) {
  return e === null || typeof e != "object" && typeof e != "function";
}
function al(e) {
  return Rl(e, "Object");
}
function UI(e) {
  return typeof Event < "u" && Nl(e, Event);
}
function gF(e) {
  return typeof Element < "u" && Nl(e, Element);
}
function bF(e) {
  return Rl(e, "RegExp");
}
function zI(e) {
  return !!(e && e.then && typeof e.then == "function");
}
function mF(e) {
  return al(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
}
function _F(e) {
  return typeof e == "number" && e !== e;
}
function Nl(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
function rg(e) {
  return e && e.Math == Math ? e : void 0;
}
const lo = typeof globalThis == "object" && rg(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && rg(window) || typeof self == "object" && rg(self) || typeof global == "object" && rg(global) || function() {
  return this;
}() || {};
function Sd() {
  return lo;
}
function FI(e, t, n) {
  const r = n || lo, i = r.__SENTRY__ = r.__SENTRY__ || {};
  return i[e] || (i[e] = t());
}
const wF = Sd(), vF = 80;
function FE(e, t = {}) {
  try {
    let n = e;
    const r = 5, i = [];
    let o = 0, a = 0;
    const s = " > ", c = s.length;
    let l;
    const u = Array.isArray(t) ? t : t.keyAttrs, f = !Array.isArray(t) && t.maxStringLength || vF;
    for (; n && o++ < r && (l = SF(n, u), !(l === "html" || o > 1 && a + i.length * c + l.length >= f)); )
      i.push(l), a += l.length, n = n.parentNode;
    return i.reverse().join(s);
  } catch {
    return "<unknown>";
  }
}
function SF(e, t) {
  const n = e, r = [];
  let i, o, a, s, c;
  if (!n || !n.tagName)
    return "";
  r.push(n.tagName.toLowerCase());
  const l = t && t.length ? t.filter((f) => n.getAttribute(f)).map((f) => [f, n.getAttribute(f)]) : null;
  if (l && l.length)
    l.forEach((f) => {
      r.push(`[${f[0]}="${f[1]}"]`);
    });
  else if (n.id && r.push(`#${n.id}`), i = n.className, i && Tc(i))
    for (o = i.split(/\s+/), c = 0; c < o.length; c++)
      r.push(`.${o[c]}`);
  const u = ["aria-label", "type", "name", "title", "alt"];
  for (c = 0; c < u.length; c++)
    a = u[c], s = n.getAttribute(a), s && r.push(`[${a}="${s}"]`);
  return r.join("");
}
function EF() {
  try {
    return wF.document.location.href;
  } catch {
    return "";
  }
}
class ci extends Error {
  /** Display name of this error instance. */
  constructor(t, n = "warn") {
    super(t), this.message = t, this.name = new.target.prototype.constructor.name, Object.setPrototypeOf(this, new.target.prototype), this.logLevel = n;
  }
}
const AF = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function IF(e) {
  return e === "http" || e === "https";
}
function Nm(e, t = !1) {
  const { host: n, path: r, pass: i, port: o, projectId: a, protocol: s, publicKey: c } = e;
  return `${s}://${c}${t && i ? `:${i}` : ""}@${n}${o ? `:${o}` : ""}/${r && `${r}/`}${a}`;
}
function kF(e) {
  const t = AF.exec(e);
  if (!t)
    throw new ci(`Invalid Sentry Dsn: ${e}`);
  const [n, r, i = "", o, a = "", s] = t.slice(1);
  let c = "", l = s;
  const u = l.split("/");
  if (u.length > 1 && (c = u.slice(0, -1).join("/"), l = u.pop()), l) {
    const f = l.match(/^\d+/);
    f && (l = f[0]);
  }
  return Q3({ host: o, pass: i, path: c, projectId: l, port: a, protocol: n, publicKey: r });
}
function Q3(e) {
  return {
    protocol: e.protocol,
    publicKey: e.publicKey || "",
    pass: e.pass || "",
    host: e.host,
    port: e.port || "",
    path: e.path || "",
    projectId: e.projectId
  };
}
function TF(e) {
  if (!(typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__))
    return;
  const { port: t, projectId: n, protocol: r } = e;
  if (["protocol", "publicKey", "host", "projectId"].forEach((o) => {
    if (!e[o])
      throw new ci(`Invalid Sentry Dsn: ${o} missing`);
  }), !n.match(/^\d+$/))
    throw new ci(`Invalid Sentry Dsn: Invalid projectId ${n}`);
  if (!IF(r))
    throw new ci(`Invalid Sentry Dsn: Invalid protocol ${r}`);
  if (t && isNaN(parseInt(t, 10)))
    throw new ci(`Invalid Sentry Dsn: Invalid port ${t}`);
  return !0;
}
function xF(e) {
  const t = typeof e == "string" ? kF(e) : Q3(e);
  return TF(t), t;
}
const MF = "Sentry Logger ", Cb = ["debug", "info", "warn", "error", "log", "assert", "trace"];
function eC(e) {
  if (!("console" in lo))
    return e();
  const t = lo.console, n = {};
  Cb.forEach((r) => {
    const i = t[r] && t[r].__sentry_original__;
    r in t && i && (n[r] = t[r], t[r] = i);
  });
  try {
    return e();
  } finally {
    Object.keys(n).forEach((r) => {
      t[r] = n[r];
    });
  }
}
function Bx() {
  let e = !1;
  const t = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    }
  };
  return typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__ ? Cb.forEach((n) => {
    t[n] = (...r) => {
      e && eC(() => {
        lo.console[n](`${MF}[${n}]:`, ...r);
      });
    };
  }) : Cb.forEach((n) => {
    t[n] = () => {
    };
  }), t;
}
let Xt;
typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__ ? Xt = FI("logger", Bx) : Xt = Bx();
function zf(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function Cx(e, t) {
  if (!Array.isArray(e))
    return "";
  const n = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    try {
      n.push(String(i));
    } catch {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(t);
}
function OF(e, t, n = !1) {
  return Tc(e) ? bF(t) ? t.test(e) : Tc(t) ? n ? e === t : e.includes(t) : !1 : !1;
}
function jm(e, t = [], n = !1) {
  return t.some((r) => OF(e, r, n));
}
function Hr(e, t, n) {
  if (!(t in e))
    return;
  const r = e[t], i = n(r);
  if (typeof i == "function")
    try {
      tC(i, r);
    } catch {
    }
  e[t] = i;
}
function LI(e, t, n) {
  Object.defineProperty(e, t, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: n,
    writable: !0,
    configurable: !0
  });
}
function tC(e, t) {
  const n = t.prototype || {};
  e.prototype = t.prototype = n, LI(e, "__sentry_original__", t);
}
function $I(e) {
  return e.__sentry_original__;
}
function PF(e) {
  return Object.keys(e).map((t) => `${encodeURIComponent(t)}=${encodeURIComponent(e[t])}`).join("&");
}
function nC(e) {
  if (Z3(e))
    return {
      message: e.message,
      name: e.name,
      stack: e.stack,
      ...Rx(e)
    };
  if (UI(e)) {
    const t = {
      type: e.type,
      target: Dx(e.target),
      currentTarget: Dx(e.currentTarget),
      ...Rx(e)
    };
    return typeof CustomEvent < "u" && Nl(e, CustomEvent) && (t.detail = e.detail), t;
  } else
    return e;
}
function Dx(e) {
  try {
    return gF(e) ? FE(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
}
function Rx(e) {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t;
  } else
    return {};
}
function BF(e, t = 40) {
  const n = Object.keys(nC(e));
  if (n.sort(), !n.length)
    return "[object has no keys]";
  if (n[0].length >= t)
    return zf(n[0], t);
  for (let r = n.length; r > 0; r--) {
    const i = n.slice(0, r).join(", ");
    if (!(i.length > t))
      return r === n.length ? i : zf(i, t);
  }
  return "";
}
function WI(e) {
  return LE(e, /* @__PURE__ */ new Map());
}
function LE(e, t) {
  if (al(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const r = {};
    t.set(e, r);
    for (const i of Object.keys(e))
      typeof e[i] < "u" && (r[i] = LE(e[i], t));
    return r;
  }
  if (Array.isArray(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const r = [];
    return t.set(e, r), e.forEach((i) => {
      r.push(LE(i, t));
    }), r;
  }
  return e;
}
const rC = 50, Nx = /\(error: (.*)\)/;
function CF(...e) {
  const t = e.sort((n, r) => n[0] - r[0]).map((n) => n[1]);
  return (n, r = 0) => {
    const i = [], o = n.split(`
`);
    for (let a = r; a < o.length; a++) {
      const s = o[a];
      if (s.length > 1024)
        continue;
      const c = Nx.test(s) ? s.replace(Nx, "$1") : s;
      if (!c.match(/\S*Error: /)) {
        for (const l of t) {
          const u = l(c);
          if (u) {
            i.push(u);
            break;
          }
        }
        if (i.length >= rC)
          break;
      }
    }
    return DF(i);
  };
}
function DF(e) {
  if (!e.length)
    return [];
  const t = e.slice(0, rC), n = t[t.length - 1].function;
  n && /sentryWrapped/.test(n) && t.pop(), t.reverse();
  const r = t[t.length - 1].function;
  return r && /captureMessage|captureException/.test(r) && t.pop(), t.map((i) => ({
    ...i,
    filename: i.filename || t[t.length - 1].filename,
    function: i.function || "?"
  }));
}
const gv = "<anonymous>";
function qs(e) {
  try {
    return !e || typeof e != "function" ? gv : e.name || gv;
  } catch {
    return gv;
  }
}
const $E = Sd();
function RF() {
  if (!("fetch" in $E))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function WE(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function NF() {
  if (!RF())
    return !1;
  if (WE($E.fetch))
    return !0;
  let e = !1;
  const t = $E.document;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = WE(n.contentWindow.fetch)), t.head.removeChild(n);
    } catch (n) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return e;
}
const ig = Sd();
function jF() {
  const e = ig.chrome, t = e && e.app && e.app.runtime, n = "history" in ig && !!ig.history.pushState && !!ig.history.replaceState;
  return !t && n;
}
const or = Sd(), Tf = "__sentry_xhr_v2__", Ff = {}, jx = {};
function UF(e) {
  if (!jx[e])
    switch (jx[e] = !0, e) {
      case "console":
        zF();
        break;
      case "dom":
        HF();
        break;
      case "xhr":
        $F();
        break;
      case "fetch":
        FF();
        break;
      case "history":
        WF();
        break;
      case "error":
        GF();
        break;
      case "unhandledrejection":
        YF();
        break;
      default:
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn("unknown instrumentation type:", e);
        return;
    }
}
function hc(e, t) {
  Ff[e] = Ff[e] || [], Ff[e].push(t), UF(e);
}
function Ro(e, t) {
  if (!(!e || !Ff[e]))
    for (const n of Ff[e] || [])
      try {
        n(t);
      } catch (r) {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${qs(n)}
Error:`,
          r
        );
      }
}
function zF() {
  "console" in or && Cb.forEach(function(e) {
    e in or.console && Hr(or.console, e, function(t) {
      return function(...n) {
        Ro("console", { args: n, level: e }), t && t.apply(or.console, n);
      };
    });
  });
}
function FF() {
  NF() && Hr(or, "fetch", function(e) {
    return function(...t) {
      const { method: n, url: r } = LF(t), i = {
        args: t,
        fetchData: {
          method: n,
          url: r
        },
        startTimestamp: Date.now()
      };
      return Ro("fetch", {
        ...i
      }), e.apply(or, t).then(
        (o) => (Ro("fetch", {
          ...i,
          endTimestamp: Date.now(),
          response: o
        }), o),
        (o) => {
          throw Ro("fetch", {
            ...i,
            endTimestamp: Date.now(),
            error: o
          }), o;
        }
      );
    };
  });
}
function KE(e, t) {
  return !!e && typeof e == "object" && !!e[t];
}
function Ux(e) {
  return typeof e == "string" ? e : e ? KE(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
}
function LF(e) {
  if (e.length === 0)
    return { method: "GET", url: "" };
  if (e.length === 2) {
    const [n, r] = e;
    return {
      url: Ux(n),
      method: KE(r, "method") ? String(r.method).toUpperCase() : "GET"
    };
  }
  const t = e[0];
  return {
    url: Ux(t),
    method: KE(t, "method") ? String(t.method).toUpperCase() : "GET"
  };
}
function $F() {
  if (!("XMLHttpRequest" in or))
    return;
  const e = XMLHttpRequest.prototype;
  Hr(e, "open", function(t) {
    return function(...n) {
      const r = n[1], i = this[Tf] = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: Tc(n[0]) ? n[0].toUpperCase() : n[0],
        url: n[1],
        request_headers: {}
      };
      Tc(r) && i.method === "POST" && r.match(/sentry_key/) && (this.__sentry_own_request__ = !0);
      const o = () => {
        const a = this[Tf];
        if (a && this.readyState === 4) {
          try {
            a.status_code = this.status;
          } catch {
          }
          Ro("xhr", {
            args: n,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr: this
          });
        }
      };
      return "onreadystatechange" in this && typeof this.onreadystatechange == "function" ? Hr(this, "onreadystatechange", function(a) {
        return function(...s) {
          return o(), a.apply(this, s);
        };
      }) : this.addEventListener("readystatechange", o), Hr(this, "setRequestHeader", function(a) {
        return function(...s) {
          const [c, l] = s, u = this[Tf];
          return u && (u.request_headers[c.toLowerCase()] = l), a.apply(this, s);
        };
      }), t.apply(this, n);
    };
  }), Hr(e, "send", function(t) {
    return function(...n) {
      const r = this[Tf];
      return r && n[0] !== void 0 && (r.body = n[0]), Ro("xhr", {
        args: n,
        startTimestamp: Date.now(),
        xhr: this
      }), t.apply(this, n);
    };
  });
}
let og;
function WF() {
  if (!jF())
    return;
  const e = or.onpopstate;
  or.onpopstate = function(...n) {
    const r = or.location.href, i = og;
    if (og = r, Ro("history", {
      from: i,
      to: r
    }), e)
      try {
        return e.apply(this, n);
      } catch {
      }
  };
  function t(n) {
    return function(...r) {
      const i = r.length > 2 ? r[2] : void 0;
      if (i) {
        const o = og, a = String(i);
        og = a, Ro("history", {
          from: o,
          to: a
        });
      }
      return n.apply(this, r);
    };
  }
  Hr(or.history, "pushState", t), Hr(or.history, "replaceState", t);
}
const KF = 1e3;
let ag, sg;
function VF(e, t) {
  if (!e || e.type !== t.type)
    return !0;
  try {
    if (e.target !== t.target)
      return !0;
  } catch {
  }
  return !1;
}
function qF(e) {
  if (e.type !== "keypress")
    return !1;
  try {
    const t = e.target;
    if (!t || !t.tagName)
      return !0;
    if (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable)
      return !1;
  } catch {
  }
  return !0;
}
function zx(e, t = !1) {
  return (n) => {
    if (!n || sg === n || qF(n))
      return;
    const r = n.type === "keypress" ? "input" : n.type;
    ag === void 0 ? (e({
      event: n,
      name: r,
      global: t
    }), sg = n) : VF(sg, n) && (e({
      event: n,
      name: r,
      global: t
    }), sg = n), clearTimeout(ag), ag = or.setTimeout(() => {
      ag = void 0;
    }, KF);
  };
}
function HF() {
  if (!("document" in or))
    return;
  const e = Ro.bind(null, "dom"), t = zx(e, !0);
  or.document.addEventListener("click", t, !1), or.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach((n) => {
    const r = or[n] && or[n].prototype;
    !r || !r.hasOwnProperty || !r.hasOwnProperty("addEventListener") || (Hr(r, "addEventListener", function(i) {
      return function(o, a, s) {
        if (o === "click" || o == "keypress")
          try {
            const c = this, l = c.__sentry_instrumentation_handlers__ = c.__sentry_instrumentation_handlers__ || {}, u = l[o] = l[o] || { refCount: 0 };
            if (!u.handler) {
              const f = zx(e);
              u.handler = f, i.call(this, o, f, s);
            }
            u.refCount++;
          } catch {
          }
        return i.call(this, o, a, s);
      };
    }), Hr(
      r,
      "removeEventListener",
      function(i) {
        return function(o, a, s) {
          if (o === "click" || o == "keypress")
            try {
              const c = this, l = c.__sentry_instrumentation_handlers__ || {}, u = l[o];
              u && (u.refCount--, u.refCount <= 0 && (i.call(this, o, u.handler, s), u.handler = void 0, delete l[o]), Object.keys(l).length === 0 && delete c.__sentry_instrumentation_handlers__);
            } catch {
            }
          return i.call(this, o, a, s);
        };
      }
    ));
  });
}
let cg = null;
function GF() {
  cg = or.onerror, or.onerror = function(e, t, n, r, i) {
    return Ro("error", {
      column: r,
      error: i,
      line: n,
      msg: e,
      url: t
    }), cg && !cg.__SENTRY_LOADER__ ? cg.apply(this, arguments) : !1;
  }, or.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let ug = null;
function YF() {
  ug = or.onunhandledrejection, or.onunhandledrejection = function(e) {
    return Ro("unhandledrejection", e), ug && !ug.__SENTRY_LOADER__ ? ug.apply(this, arguments) : !0;
  }, or.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
function ZF() {
  const e = typeof WeakSet == "function", t = e ? /* @__PURE__ */ new WeakSet() : [];
  function n(i) {
    if (e)
      return t.has(i) ? !0 : (t.add(i), !1);
    for (let o = 0; o < t.length; o++)
      if (t[o] === i)
        return !0;
    return t.push(i), !1;
  }
  function r(i) {
    if (e)
      t.delete(i);
    else
      for (let o = 0; o < t.length; o++)
        if (t[o] === i) {
          t.splice(o, 1);
          break;
        }
  }
  return [n, r];
}
function Lu() {
  const e = lo, t = e.crypto || e.msCrypto;
  if (t && t.randomUUID)
    return t.randomUUID().replace(/-/g, "");
  const n = t && t.getRandomValues ? () => t.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;
  return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(
    /[018]/g,
    (r) => (
      // eslint-disable-next-line no-bitwise
      (r ^ (n() & 15) >> r / 4).toString(16)
    )
  );
}
function iC(e) {
  return e.exception && e.exception.values ? e.exception.values[0] : void 0;
}
function As(e) {
  const { message: t, event_id: n } = e;
  if (t)
    return t;
  const r = iC(e);
  return r ? r.type && r.value ? `${r.type}: ${r.value}` : r.type || r.value || n || "<unknown>" : n || "<unknown>";
}
function VE(e, t, n) {
  const r = e.exception = e.exception || {}, i = r.values = r.values || [], o = i[0] = i[0] || {};
  o.value || (o.value = t || ""), o.type || (o.type = n || "Error");
}
function Jf(e, t) {
  const n = iC(e);
  if (!n)
    return;
  const r = { type: "generic", handled: !0 }, i = n.mechanism;
  if (n.mechanism = { ...r, ...i, ...t }, t && "data" in t) {
    const o = { ...i && i.data, ...t.data };
    n.mechanism.data = o;
  }
}
function Fx(e) {
  if (e && e.__sentry_captured__)
    return !0;
  try {
    LI(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function JF(e) {
  return Array.isArray(e) ? e : [e];
}
function XF() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function QF() {
  return "npm";
}
function eL() {
  return !XF() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function tL(e, t) {
  return e.require(t);
}
function vs(e, t = 100, n = 1 / 0) {
  try {
    return qE("", e, t, n);
  } catch (r) {
    return { ERROR: `**non-serializable** (${r})` };
  }
}
function oC(e, t = 3, n = 100 * 1024) {
  const r = vs(e, t);
  return oL(r) > n ? oC(e, t - 1, n) : r;
}
function qE(e, t, n = 1 / 0, r = 1 / 0, i = ZF()) {
  const [o, a] = i;
  if (t == null || // this matches null and undefined -> eqeq not eqeqeq
  ["number", "boolean", "string"].includes(typeof t) && !_F(t))
    return t;
  const s = nL(e, t);
  if (!s.startsWith("[object "))
    return s;
  if (t.__sentry_skip_normalization__)
    return t;
  const c = typeof t.__sentry_override_normalization_depth__ == "number" ? t.__sentry_override_normalization_depth__ : n;
  if (c === 0)
    return s.replace("object ", "");
  if (o(t))
    return "[Circular ~]";
  const l = t;
  if (l && typeof l.toJSON == "function")
    try {
      const h = l.toJSON();
      return qE("", h, c - 1, r, i);
    } catch {
    }
  const u = Array.isArray(t) ? [] : {};
  let f = 0;
  const d = nC(t);
  for (const h in d) {
    if (!Object.prototype.hasOwnProperty.call(d, h))
      continue;
    if (f >= r) {
      u[h] = "[MaxProperties ~]";
      break;
    }
    const g = d[h];
    u[h] = qE(h, g, c - 1, r, i), f++;
  }
  return a(t), u;
}
function nL(e, t) {
  try {
    if (e === "domain" && t && typeof t == "object" && t._events)
      return "[Domain]";
    if (e === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && t === global)
      return "[Global]";
    if (typeof window < "u" && t === window)
      return "[Window]";
    if (typeof document < "u" && t === document)
      return "[Document]";
    if (mF(t))
      return "[SyntheticEvent]";
    if (typeof t == "number" && t !== t)
      return "[NaN]";
    if (typeof t == "function")
      return `[Function: ${qs(t)}]`;
    if (typeof t == "symbol")
      return `[${String(t)}]`;
    if (typeof t == "bigint")
      return `[BigInt: ${String(t)}]`;
    const n = rL(t);
    return /^HTML(\w*)Element$/.test(n) ? `[HTMLElement: ${n}]` : `[object ${n}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function rL(e) {
  const t = Object.getPrototypeOf(e);
  return t ? t.constructor.name : "null prototype";
}
function iL(e) {
  return ~-encodeURI(e).split(/%..|./).length;
}
function oL(e) {
  return iL(JSON.stringify(e));
}
var xa;
(function(e) {
  e[e.PENDING = 0] = "PENDING";
  const n = 1;
  e[e.RESOLVED = n] = "RESOLVED";
  const r = 2;
  e[e.REJECTED = r] = "REJECTED";
})(xa || (xa = {}));
function xc(e) {
  return new _i((t) => {
    t(e);
  });
}
function Db(e) {
  return new _i((t, n) => {
    n(e);
  });
}
class _i {
  __init() {
    this._state = xa.PENDING;
  }
  __init2() {
    this._handlers = [];
  }
  constructor(t) {
    _i.prototype.__init.call(this), _i.prototype.__init2.call(this), _i.prototype.__init3.call(this), _i.prototype.__init4.call(this), _i.prototype.__init5.call(this), _i.prototype.__init6.call(this);
    try {
      t(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  /** JSDoc */
  then(t, n) {
    return new _i((r, i) => {
      this._handlers.push([
        !1,
        (o) => {
          if (!t)
            r(o);
          else
            try {
              r(t(o));
            } catch (a) {
              i(a);
            }
        },
        (o) => {
          if (!n)
            i(o);
          else
            try {
              r(n(o));
            } catch (a) {
              i(a);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(t) {
    return this.then((n) => n, t);
  }
  /** JSDoc */
  finally(t) {
    return new _i((n, r) => {
      let i, o;
      return this.then(
        (a) => {
          o = !1, i = a, t && t();
        },
        (a) => {
          o = !0, i = a, t && t();
        }
      ).then(() => {
        if (o) {
          r(i);
          return;
        }
        n(i);
      });
    });
  }
  /** JSDoc */
  __init3() {
    this._resolve = (t) => {
      this._setResult(xa.RESOLVED, t);
    };
  }
  /** JSDoc */
  __init4() {
    this._reject = (t) => {
      this._setResult(xa.REJECTED, t);
    };
  }
  /** JSDoc */
  __init5() {
    this._setResult = (t, n) => {
      if (this._state === xa.PENDING) {
        if (zI(n)) {
          n.then(this._resolve, this._reject);
          return;
        }
        this._state = t, this._value = n, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init6() {
    this._executeHandlers = () => {
      if (this._state === xa.PENDING)
        return;
      const t = this._handlers.slice();
      this._handlers = [], t.forEach((n) => {
        n[0] || (this._state === xa.RESOLVED && n[1](this._value), this._state === xa.REJECTED && n[2](this._value), n[0] = !0);
      });
    };
  }
}
function aL(e) {
  const t = [];
  function n() {
    return e === void 0 || t.length < e;
  }
  function r(a) {
    return t.splice(t.indexOf(a), 1)[0];
  }
  function i(a) {
    if (!n())
      return Db(new ci("Not adding Promise because buffer limit was reached."));
    const s = a();
    return t.indexOf(s) === -1 && t.push(s), s.then(() => r(s)).then(
      null,
      () => r(s).then(null, () => {
      })
    ), s;
  }
  function o(a) {
    return new _i((s, c) => {
      let l = t.length;
      if (!l)
        return s(!0);
      const u = setTimeout(() => {
        a && a > 0 && s(!1);
      }, a);
      t.forEach((f) => {
        xc(f).then(() => {
          --l || (clearTimeout(u), s(!0));
        }, c);
      });
    });
  }
  return {
    $: t,
    add: i,
    drain: o
  };
}
function bv(e) {
  if (!e)
    return {};
  const t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t)
    return {};
  const n = t[6] || "", r = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    search: n,
    hash: r,
    relative: t[5] + n + r
    // everything minus origin
  };
}
const sL = ["fatal", "error", "warning", "log", "info", "debug"];
function cL(e) {
  return e === "warn" ? "warning" : sL.includes(e) ? e : "log";
}
const aC = Sd(), HE = {
  nowSeconds: () => Date.now() / 1e3
};
function uL() {
  const { performance: e } = aC;
  if (!e || !e.now)
    return;
  const t = Date.now() - e.now();
  return {
    now: () => e.now(),
    timeOrigin: t
  };
}
function lL() {
  try {
    return tL(module, "perf_hooks").performance;
  } catch {
    return;
  }
}
const mv = eL() ? lL() : uL(), Lx = mv === void 0 ? HE : {
  nowSeconds: () => (mv.timeOrigin + mv.now()) / 1e3
}, Um = HE.nowSeconds.bind(HE), sC = Lx.nowSeconds.bind(Lx);
(() => {
  const { performance: e } = aC;
  if (!e || !e.now)
    return;
  const t = 3600 * 1e3, n = e.now(), r = Date.now(), i = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, o = i < t, a = e.timing && e.timing.navigationStart, c = typeof a == "number" ? Math.abs(a + n - r) : t, l = c < t;
  return o || l ? i <= c ? e.timeOrigin : a : r;
})();
function Ed(e, t = []) {
  return [e, t];
}
function fL(e, t) {
  const [n, r] = e;
  return [n, [...r, t]];
}
function $x(e, t) {
  const n = e[1];
  for (const r of n) {
    const i = r[0].type;
    if (t(r, i))
      return !0;
  }
  return !1;
}
function GE(e, t) {
  return (t || new TextEncoder()).encode(e);
}
function dL(e, t) {
  const [n, r] = e;
  let i = JSON.stringify(n);
  function o(a) {
    typeof i == "string" ? i = typeof a == "string" ? i + a : [GE(i, t), a] : i.push(typeof a == "string" ? GE(a, t) : a);
  }
  for (const a of r) {
    const [s, c] = a;
    if (o(`
${JSON.stringify(s)}
`), typeof c == "string" || c instanceof Uint8Array)
      o(c);
    else {
      let l;
      try {
        l = JSON.stringify(c);
      } catch {
        l = JSON.stringify(vs(c));
      }
      o(l);
    }
  }
  return typeof i == "string" ? i : hL(i);
}
function hL(e) {
  const t = e.reduce((i, o) => i + o.length, 0), n = new Uint8Array(t);
  let r = 0;
  for (const i of e)
    n.set(i, r), r += i.length;
  return n;
}
function pL(e, t) {
  const n = typeof e.data == "string" ? GE(e.data, t) : e.data;
  return [
    WI({
      type: "attachment",
      length: n.length,
      filename: e.filename,
      content_type: e.contentType,
      attachment_type: e.attachmentType
    }),
    n
  ];
}
const yL = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor"
};
function Wx(e) {
  return yL[e];
}
function cC(e) {
  if (!e || !e.sdk)
    return;
  const { name: t, version: n } = e.sdk;
  return { name: t, version: n };
}
function gL(e, t, n, r) {
  const i = e.sdkProcessingMetadata && e.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && { sdk: t },
    ...!!n && { dsn: Nm(r) },
    ...i && {
      trace: WI({ ...i })
    }
  };
}
function bL(e, t, n) {
  const r = [
    { type: "client_report" },
    {
      timestamp: n || Um(),
      discarded_events: e
    }
  ];
  return Ed(t ? { dsn: t } : {}, [r]);
}
const mL = 60 * 1e3;
function _L(e, t = Date.now()) {
  const n = parseInt(`${e}`, 10);
  if (!isNaN(n))
    return n * 1e3;
  const r = Date.parse(`${e}`);
  return isNaN(r) ? mL : r - t;
}
function wL(e, t) {
  return e[t] || e.all || 0;
}
function vL(e, t, n = Date.now()) {
  return wL(e, t) > n;
}
function SL(e, { statusCode: t, headers: n }, r = Date.now()) {
  const i = {
    ...e
  }, o = n && n["x-sentry-rate-limits"], a = n && n["retry-after"];
  if (o)
    for (const s of o.trim().split(",")) {
      const [c, l] = s.split(":", 2), u = parseInt(c, 10), f = (isNaN(u) ? 60 : u) * 1e3;
      if (!l)
        i.all = r + f;
      else
        for (const d of l.split(";"))
          i[d] = r + f;
    }
  else
    a ? i.all = r + _L(a, r) : t === 429 && (i.all = r + 60 * 1e3);
  return i;
}
const uC = "production";
function EL(e) {
  const t = sC(), n = {
    sid: Lu(),
    init: !0,
    timestamp: t,
    started: t,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => IL(n)
  };
  return e && sl(n, e), n;
}
function sl(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || sC(), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : Lu()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function AL(e, t) {
  let n = {};
  t ? n = { status: t } : e.status === "ok" && (n = { status: "exited" }), sl(e, n);
}
function IL(e) {
  return WI({
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  });
}
const kL = 100;
class Ec {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called after {@link applyToEvent}. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  // eslint-disable-next-line deprecation/deprecation
  /** Transaction Name */
  /** Span */
  /** Session */
  /** Request Mode Session Status */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {};
  }
  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
  static clone(t) {
    const n = new Ec();
    return t && (n._breadcrumbs = [...t._breadcrumbs], n._tags = { ...t._tags }, n._extra = { ...t._extra }, n._contexts = { ...t._contexts }, n._user = t._user, n._level = t._level, n._span = t._span, n._session = t._session, n._transactionName = t._transactionName, n._fingerprint = t._fingerprint, n._eventProcessors = [...t._eventProcessors], n._requestSession = t._requestSession, n._attachments = [...t._attachments], n._sdkProcessingMetadata = { ...t._sdkProcessingMetadata }), n;
  }
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * @inheritDoc
   */
  setUser(t) {
    return this._user = t || {}, this._session && sl(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(t) {
    return this._requestSession = t, this;
  }
  /**
   * @inheritDoc
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSpan(t) {
    return this._span = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSpan() {
    return this._span;
  }
  /**
   * @inheritDoc
   */
  getTransaction() {
    const t = this.getSpan();
    return t && t.transaction;
  }
  /**
   * @inheritDoc
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(t) {
    if (!t)
      return this;
    if (typeof t == "function") {
      const n = t(this);
      return n instanceof Ec ? n : this;
    }
    return t instanceof Ec ? (this._tags = { ...this._tags, ...t._tags }, this._extra = { ...this._extra, ...t._extra }, this._contexts = { ...this._contexts, ...t._contexts }, t._user && Object.keys(t._user).length && (this._user = t._user), t._level && (this._level = t._level), t._fingerprint && (this._fingerprint = t._fingerprint), t._requestSession && (this._requestSession = t._requestSession)) : al(t) && (t = t, this._tags = { ...this._tags, ...t.tags }, this._extra = { ...this._extra, ...t.extra }, this._contexts = { ...this._contexts, ...t.contexts }, t.user && (this._user = t.user), t.level && (this._level = t.level), t.fingerprint && (this._fingerprint = t.fingerprint), t.requestSession && (this._requestSession = t.requestSession)), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this._attachments = [], this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(t, n) {
    const r = typeof n == "number" ? n : kL;
    if (r <= 0)
      return this;
    const i = {
      timestamp: Um(),
      ...t
    };
    return this._breadcrumbs = [...this._breadcrumbs, i].slice(-r), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * @inheritDoc
   */
  getAttachments() {
    return this._attachments;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
  applyToEvent(t, n = {}) {
    if (this._extra && Object.keys(this._extra).length && (t.extra = { ...this._extra, ...t.extra }), this._tags && Object.keys(this._tags).length && (t.tags = { ...this._tags, ...t.tags }), this._user && Object.keys(this._user).length && (t.user = { ...this._user, ...t.user }), this._contexts && Object.keys(this._contexts).length && (t.contexts = { ...this._contexts, ...t.contexts }), this._level && (t.level = this._level), this._transactionName && (t.transaction = this._transactionName), this._span) {
      t.contexts = { trace: this._span.getTraceContext(), ...t.contexts };
      const r = this._span.transaction;
      if (r) {
        t.sdkProcessingMetadata = {
          dynamicSamplingContext: r.getDynamicSamplingContext(),
          ...t.sdkProcessingMetadata
        };
        const i = r.name;
        i && (t.tags = { transaction: i, ...t.tags });
      }
    }
    return this._applyFingerprint(t), t.breadcrumbs = [...t.breadcrumbs || [], ...this._breadcrumbs], t.breadcrumbs = t.breadcrumbs.length > 0 ? t.breadcrumbs : void 0, t.sdkProcessingMetadata = { ...t.sdkProcessingMetadata, ...this._sdkProcessingMetadata }, this._notifyEventProcessors([...lC(), ...this._eventProcessors], t, n);
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...t }, this;
  }
  /**
   * This will be called after {@link applyToEvent} is finished.
   */
  _notifyEventProcessors(t, n, r, i = 0) {
    return new _i((o, a) => {
      const s = t[i];
      if (n === null || typeof s != "function")
        o(n);
      else {
        const c = s({ ...n }, r);
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && s.id && c === null && Xt.log(`Event processor "${s.id}" dropped event`), zI(c) ? c.then((l) => this._notifyEventProcessors(t, l, r, i + 1).then(o)).then(null, a) : this._notifyEventProcessors(t, c, r, i + 1).then(o).then(null, a);
      }
    });
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
  _applyFingerprint(t) {
    t.fingerprint = t.fingerprint ? JF(t.fingerprint) : [], this._fingerprint && (t.fingerprint = t.fingerprint.concat(this._fingerprint)), t.fingerprint && !t.fingerprint.length && delete t.fingerprint;
  }
}
function lC() {
  return FI("globalEventProcessors", () => []);
}
function KI(e) {
  lC().push(e);
}
const fC = 4, TL = 100;
class VI {
  /** Is a {@link Layer}[] containing the client and scope */
  /** Contains the last event id of a captured event.  */
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
  constructor(t, n = new Ec(), r = fC) {
    this._version = r, this._stack = [{ scope: n }], t && this.bindClient(t);
  }
  /**
   * @inheritDoc
   */
  isOlderThan(t) {
    return this._version < t;
  }
  /**
   * @inheritDoc
   */
  bindClient(t) {
    const n = this.getStackTop();
    n.client = t, t && t.setupIntegrations && t.setupIntegrations();
  }
  /**
   * @inheritDoc
   */
  pushScope() {
    const t = Ec.clone(this.getScope());
    return this.getStack().push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * @inheritDoc
   */
  popScope() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }
  /**
   * @inheritDoc
   */
  withScope(t) {
    const n = this.pushScope();
    try {
      t(n);
    } finally {
      this.popScope();
    }
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this.getStackTop().client;
  }
  /** Returns the scope of the top stack. */
  getScope() {
    return this.getStackTop().scope;
  }
  /** Returns the scope stack for domains or the process. */
  getStack() {
    return this._stack;
  }
  /** Returns the topmost scope layer in the order domain > local > process. */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * @inheritDoc
   */
  captureException(t, n) {
    const r = this._lastEventId = n && n.event_id ? n.event_id : Lu(), i = new Error("Sentry syntheticException");
    return this._withClient((o, a) => {
      o.captureException(
        t,
        {
          originalException: t,
          syntheticException: i,
          ...n,
          event_id: r
        },
        a
      );
    }), r;
  }
  /**
   * @inheritDoc
   */
  captureMessage(t, n, r) {
    const i = this._lastEventId = r && r.event_id ? r.event_id : Lu(), o = new Error(t);
    return this._withClient((a, s) => {
      a.captureMessage(
        t,
        n,
        {
          originalException: t,
          syntheticException: o,
          ...r,
          event_id: i
        },
        s
      );
    }), i;
  }
  /**
   * @inheritDoc
   */
  captureEvent(t, n) {
    const r = n && n.event_id ? n.event_id : Lu();
    return t.type || (this._lastEventId = r), this._withClient((i, o) => {
      i.captureEvent(t, { ...n, event_id: r }, o);
    }), r;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(t, n) {
    const { scope: r, client: i } = this.getStackTop();
    if (!i)
      return;
    const { beforeBreadcrumb: o = null, maxBreadcrumbs: a = TL } = i.getOptions && i.getOptions() || {};
    if (a <= 0)
      return;
    const c = { timestamp: Um(), ...t }, l = o ? eC(() => o(c, n)) : c;
    l !== null && (i.emit && i.emit("beforeAddBreadcrumb", l, n), r.addBreadcrumb(l, a));
  }
  /**
   * @inheritDoc
   */
  setUser(t) {
    this.getScope().setUser(t);
  }
  /**
   * @inheritDoc
   */
  setTags(t) {
    this.getScope().setTags(t);
  }
  /**
   * @inheritDoc
   */
  setExtras(t) {
    this.getScope().setExtras(t);
  }
  /**
   * @inheritDoc
   */
  setTag(t, n) {
    this.getScope().setTag(t, n);
  }
  /**
   * @inheritDoc
   */
  setExtra(t, n) {
    this.getScope().setExtra(t, n);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(t, n) {
    this.getScope().setContext(t, n);
  }
  /**
   * @inheritDoc
   */
  configureScope(t) {
    const { scope: n, client: r } = this.getStackTop();
    r && t(n);
  }
  /**
   * @inheritDoc
   */
  run(t) {
    const n = Kx(this);
    try {
      t(this);
    } finally {
      Kx(n);
    }
  }
  /**
   * @inheritDoc
   */
  getIntegration(t) {
    const n = this.getClient();
    if (!n)
      return null;
    try {
      return n.getIntegration(t);
    } catch {
      return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn(`Cannot retrieve integration ${t.id} from the current Hub`), null;
    }
  }
  /**
   * @inheritDoc
   */
  startTransaction(t, n) {
    const r = this._callExtensionMethod("startTransaction", t, n);
    return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && !r && console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`), r;
  }
  /**
   * @inheritDoc
   */
  traceHeaders() {
    return this._callExtensionMethod("traceHeaders");
  }
  /**
   * @inheritDoc
   */
  captureSession(t = !1) {
    if (t)
      return this.endSession();
    this._sendSessionUpdate();
  }
  /**
   * @inheritDoc
   */
  endSession() {
    const n = this.getStackTop().scope, r = n.getSession();
    r && AL(r), this._sendSessionUpdate(), n.setSession();
  }
  /**
   * @inheritDoc
   */
  startSession(t) {
    const { scope: n, client: r } = this.getStackTop(), { release: i, environment: o = uC } = r && r.getOptions() || {}, { userAgent: a } = lo.navigator || {}, s = EL({
      release: i,
      environment: o,
      user: n.getUser(),
      ...a && { userAgent: a },
      ...t
    }), c = n.getSession && n.getSession();
    return c && c.status === "ok" && sl(c, { status: "exited" }), this.endSession(), n.setSession(s), s;
  }
  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
  shouldSendDefaultPii() {
    const t = this.getClient(), n = t && t.getOptions();
    return !!(n && n.sendDefaultPii);
  }
  /**
   * Sends the current Session on the scope
   */
  _sendSessionUpdate() {
    const { scope: t, client: n } = this.getStackTop(), r = t.getSession();
    r && n && n.captureSession && n.captureSession(r);
  }
  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
  _withClient(t) {
    const { scope: n, client: r } = this.getStackTop();
    r && t(r, n);
  }
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _callExtensionMethod(t, ...n) {
    const i = zm().__SENTRY__;
    if (i && i.extensions && typeof i.extensions[t] == "function")
      return i.extensions[t].apply(this, n);
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn(`Extension method ${t} couldn't be found, doing nothing.`);
  }
}
function zm() {
  return lo.__SENTRY__ = lo.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, lo;
}
function Kx(e) {
  const t = zm(), n = YE(t);
  return dC(t, e), n;
}
function hi() {
  const e = zm();
  if (e.__SENTRY__ && e.__SENTRY__.acs) {
    const t = e.__SENTRY__.acs.getCurrentHub();
    if (t)
      return t;
  }
  return xL(e);
}
function xL(e = zm()) {
  return (!ML(e) || YE(e).isOlderThan(fC)) && dC(e, new VI()), YE(e);
}
function ML(e) {
  return !!(e && e.__SENTRY__ && e.__SENTRY__.hub);
}
function YE(e) {
  return FI("hub", () => new VI(), e);
}
function dC(e, t) {
  if (!e)
    return !1;
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.hub = t, !0;
}
function OL(e, t) {
  return hi().captureException(e, { captureContext: t });
}
function PL(e) {
  hi().withScope(e);
}
const BL = "7";
function CL(e) {
  const t = e.protocol ? `${e.protocol}:` : "", n = e.port ? `:${e.port}` : "";
  return `${t}//${e.host}${n}${e.path ? `/${e.path}` : ""}/api/`;
}
function DL(e) {
  return `${CL(e)}${e.projectId}/envelope/`;
}
function RL(e, t) {
  return PF({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: e.publicKey,
    sentry_version: BL,
    ...t && { sentry_client: `${t.name}/${t.version}` }
  });
}
function NL(e, t = {}) {
  const n = typeof t == "string" ? t : t.tunnel, r = typeof t == "string" || !t._metadata ? void 0 : t._metadata.sdk;
  return n || `${DL(e)}?${RL(e, r)}`;
}
function jL(e, t) {
  return t && (e.sdk = e.sdk || {}, e.sdk.name = e.sdk.name || t.name, e.sdk.version = e.sdk.version || t.version, e.sdk.integrations = [...e.sdk.integrations || [], ...t.integrations || []], e.sdk.packages = [...e.sdk.packages || [], ...t.packages || []]), e;
}
function UL(e, t, n, r) {
  const i = cC(n), o = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...i && { sdk: i },
    ...!!r && { dsn: Nm(t) }
  }, a = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e];
  return Ed(o, [a]);
}
function zL(e, t, n, r) {
  const i = cC(n), o = e.type && e.type !== "replay_event" ? e.type : "event";
  jL(e, n && n.sdk);
  const a = gL(e, i, r, t);
  return delete e.sdkProcessingMetadata, Ed(a, [[{ type: o }, e]]);
}
const Vx = [];
function FL(e) {
  const t = {};
  return e.forEach((n) => {
    n && hC(n, t);
  }), t;
}
function hC(e, t) {
  t[e.name] = e, Vx.indexOf(e.name) === -1 && (e.setupOnce(KI, hi), Vx.push(e.name), (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.log(`Integration installed: ${e.name}`));
}
function LL(e, t, n, r) {
  const { normalizeDepth: i = 3, normalizeMaxBreadth: o = 1e3 } = e, a = {
    ...t,
    event_id: t.event_id || n.event_id || Lu(),
    timestamp: t.timestamp || Um()
  }, s = n.integrations || e.integrations.map((u) => u.name);
  $L(a, e), KL(a, s), t.type === void 0 && WL(a, e.stackParser);
  let c = r;
  n.captureContext && (c = Ec.clone(c).update(n.captureContext));
  let l = xc(a);
  if (c) {
    if (c.getAttachments) {
      const u = [...n.attachments || [], ...c.getAttachments()];
      u.length && (n.attachments = u);
    }
    l = c.applyToEvent(a, n);
  }
  return l.then((u) => typeof i == "number" && i > 0 ? VL(u, i, o) : u);
}
function $L(e, t) {
  const { environment: n, release: r, dist: i, maxValueLength: o = 250 } = t;
  "environment" in e || (e.environment = "environment" in t ? n : uC), e.release === void 0 && r !== void 0 && (e.release = r), e.dist === void 0 && i !== void 0 && (e.dist = i), e.message && (e.message = zf(e.message, o));
  const a = e.exception && e.exception.values && e.exception.values[0];
  a && a.value && (a.value = zf(a.value, o));
  const s = e.request;
  s && s.url && (s.url = zf(s.url, o));
}
const qx = /* @__PURE__ */ new WeakMap();
function WL(e, t) {
  const n = lo._sentryDebugIds;
  if (!n)
    return;
  let r;
  const i = qx.get(t);
  i ? r = i : (r = /* @__PURE__ */ new Map(), qx.set(t, r));
  const o = Object.keys(n).reduce((c, l) => {
    let u;
    const f = r.get(l);
    f ? u = f : (u = t(l), r.set(l, u));
    for (let d = u.length - 1; d >= 0; d--) {
      const h = u[d];
      if (h.filename) {
        c[h.filename] = n[l];
        break;
      }
    }
    return c;
  }, {}), a = /* @__PURE__ */ new Set();
  try {
    e.exception.values.forEach((c) => {
      c.stacktrace.frames.forEach((l) => {
        l.filename && a.add(l.filename);
      });
    });
  } catch {
  }
  e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
  const s = e.debug_meta.images;
  a.forEach((c) => {
    o[c] && s.push({
      type: "sourcemap",
      code_file: c,
      debug_id: o[c]
    });
  });
}
function KL(e, t) {
  t.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [...e.sdk.integrations || [], ...t]);
}
function VL(e, t, n) {
  if (!e)
    return null;
  const r = {
    ...e,
    ...e.breadcrumbs && {
      breadcrumbs: e.breadcrumbs.map((i) => ({
        ...i,
        ...i.data && {
          data: vs(i.data, t, n)
        }
      }))
    },
    ...e.user && {
      user: vs(e.user, t, n)
    },
    ...e.contexts && {
      contexts: vs(e.contexts, t, n)
    },
    ...e.extra && {
      extra: vs(e.extra, t, n)
    }
  };
  return e.contexts && e.contexts.trace && r.contexts && (r.contexts.trace = e.contexts.trace, e.contexts.trace.data && (r.contexts.trace.data = vs(e.contexts.trace.data, t, n))), e.spans && (r.spans = e.spans.map((i) => (i.data && (i.data = vs(i.data, t, n)), i))), r;
}
const Hx = "Not capturing exception because it's already been captured.";
class pc {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  __init() {
    this._integrations = {};
  }
  /** Indicates whether this client's integrations have been set up. */
  __init2() {
    this._integrationsInitialized = !1;
  }
  /** Number of calls being processed */
  __init3() {
    this._numProcessing = 0;
  }
  /** Holds flushable  */
  __init4() {
    this._outcomes = {};
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  __init5() {
    this._hooks = {};
  }
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(t) {
    if (pc.prototype.__init.call(this), pc.prototype.__init2.call(this), pc.prototype.__init3.call(this), pc.prototype.__init4.call(this), pc.prototype.__init5.call(this), this._options = t, t.dsn) {
      this._dsn = xF(t.dsn);
      const n = NL(this._dsn, t);
      this._transport = t.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...t.transportOptions,
        url: n
      });
    } else
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn("No DSN provided, client will not do anything.");
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  captureException(t, n, r) {
    if (Fx(t)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.log(Hx);
      return;
    }
    let i = n && n.event_id;
    return this._process(
      this.eventFromException(t, n).then((o) => this._captureEvent(o, n, r)).then((o) => {
        i = o;
      })
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(t, n, r, i) {
    let o = r && r.event_id;
    const a = X3(t) ? this.eventFromMessage(String(t), n, r) : this.eventFromException(t, r);
    return this._process(
      a.then((s) => this._captureEvent(s, r, i)).then((s) => {
        o = s;
      })
    ), o;
  }
  /**
   * @inheritDoc
   */
  captureEvent(t, n, r) {
    if (n && n.originalException && Fx(n.originalException)) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.log(Hx);
      return;
    }
    let i = n && n.event_id;
    return this._process(
      this._captureEvent(t, n, r).then((o) => {
        i = o;
      })
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureSession(t) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn("SDK not enabled, will not capture session.");
      return;
    }
    typeof t.release != "string" ? (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn("Discarded session because of missing or non-string release") : (this.sendSession(t), sl(t, { init: !1 }));
  }
  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }
  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }
  /**
   * @inheritDoc
   */
  flush(t) {
    const n = this._transport;
    return n ? this._isClientDoneProcessing(t).then((r) => n.flush(t).then((i) => r && i)) : xc(!0);
  }
  /**
   * @inheritDoc
   */
  close(t) {
    return this.flush(t).then((n) => (this.getOptions().enabled = !1, n));
  }
  /**
   * Sets up the integrations
   */
  setupIntegrations() {
    this._isEnabled() && !this._integrationsInitialized && (this._integrations = FL(this._options.integrations), this._integrationsInitialized = !0);
  }
  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
  getIntegrationById(t) {
    return this._integrations[t];
  }
  /**
   * @inheritDoc
   */
  getIntegration(t) {
    try {
      return this._integrations[t.id] || null;
    } catch {
      return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn(`Cannot retrieve integration ${t.id} from the current Client`), null;
    }
  }
  /**
   * @inheritDoc
   */
  addIntegration(t) {
    hC(t, this._integrations);
  }
  /**
   * @inheritDoc
   */
  sendEvent(t, n = {}) {
    if (this._dsn) {
      let r = zL(t, this._dsn, this._options._metadata, this._options.tunnel);
      for (const o of n.attachments || [])
        r = fL(
          r,
          pL(
            o,
            this._options.transportOptions && this._options.transportOptions.textEncoder
          )
        );
      const i = this._sendEnvelope(r);
      i && i.then((o) => this.emit("afterSendEvent", t, o), null);
    }
  }
  /**
   * @inheritDoc
   */
  sendSession(t) {
    if (this._dsn) {
      const n = UL(t, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(n);
    }
  }
  /**
   * @inheritDoc
   */
  recordDroppedEvent(t, n, r) {
    if (this._options.sendClientReports) {
      const i = `${t}:${n}`;
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.log(`Adding outcome: "${i}"`), this._outcomes[i] = this._outcomes[i] + 1 || 1;
    }
  }
  // Keep on() & emit() signatures in sync with types' client.ts interface
  /** @inheritdoc */
  /** @inheritdoc */
  on(t, n) {
    this._hooks[t] || (this._hooks[t] = []), this._hooks[t].push(n);
  }
  /** @inheritdoc */
  /** @inheritdoc */
  emit(t, ...n) {
    this._hooks[t] && this._hooks[t].forEach((r) => r(...n));
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(t, n) {
    let r = !1, i = !1;
    const o = n.exception && n.exception.values;
    if (o) {
      i = !0;
      for (const c of o) {
        const l = c.mechanism;
        if (l && l.handled === !1) {
          r = !0;
          break;
        }
      }
    }
    const a = t.status === "ok";
    (a && t.errors === 0 || a && r) && (sl(t, {
      ...r && { status: "crashed" },
      errors: t.errors || Number(i || r)
    }), this.captureSession(t));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(t) {
    return new _i((n) => {
      let r = 0;
      const i = 1, o = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(o), n(!0)) : (r += i, t && r >= t && (clearInterval(o), n(!1)));
      }, i);
    });
  }
  /** Determines whether this SDK is enabled and a valid Dsn is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._dsn !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(t, n, r) {
    const i = this.getOptions(), o = Object.keys(this._integrations);
    return !n.integrations && o.length > 0 && (n.integrations = o), LL(i, t, n, r);
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(t, n = {}, r) {
    return this._processEvent(t, n, r).then(
      (i) => i.event_id,
      (i) => {
        if (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) {
          const o = i;
          o.logLevel === "log" ? Xt.log(o.message) : Xt.warn(o);
        }
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(t, n, r) {
    const i = this.getOptions(), { sampleRate: o } = i;
    if (!this._isEnabled())
      return Db(new ci("SDK not enabled, will not capture event.", "log"));
    const a = yC(t), s = pC(t), c = t.type || "error", l = `before send for type \`${c}\``;
    if (s && typeof o == "number" && Math.random() > o)
      return this.recordDroppedEvent("sample_rate", "error", t), Db(
        new ci(
          `Discarding event because it's not included in the random sample (sampling rate = ${o})`,
          "log"
        )
      );
    const u = c === "replay_event" ? "replay" : c;
    return this._prepareEvent(t, n, r).then((f) => {
      if (f === null)
        throw this.recordDroppedEvent("event_processor", u, t), new ci("An event processor returned `null`, will not send event.", "log");
      if (n.data && n.data.__sentry__ === !0)
        return f;
      const h = HL(i, f, n);
      return qL(h, l);
    }).then((f) => {
      if (f === null)
        throw this.recordDroppedEvent("before_send", u, t), new ci(`${l} returned \`null\`, will not send event.`, "log");
      const d = r && r.getSession();
      !a && d && this._updateSessionFromEvent(d, f);
      const h = f.transaction_info;
      if (a && h && f.transaction !== t.transaction) {
        const g = "custom";
        f.transaction_info = {
          ...h,
          source: g
        };
      }
      return this.sendEvent(f, n), f;
    }).then(null, (f) => {
      throw f instanceof ci ? f : (this.captureException(f, {
        data: {
          __sentry__: !0
        },
        originalException: f
      }), new ci(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${f}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(t) {
    this._numProcessing++, t.then(
      (n) => (this._numProcessing--, n),
      (n) => (this._numProcessing--, n)
    );
  }
  /**
   * @inheritdoc
   */
  _sendEnvelope(t) {
    if (this._transport && this._dsn)
      return this.emit("beforeEnvelope", t), this._transport.send(t).then(null, (n) => {
        (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.error("Error while sending event:", n);
      });
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.error("Transport disabled");
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const t = this._outcomes;
    return this._outcomes = {}, Object.keys(t).map((n) => {
      const [r, i] = n.split(":");
      return {
        reason: r,
        category: i,
        quantity: t[n]
      };
    });
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
}
function qL(e, t) {
  const n = `${t} must return \`null\` or a valid event.`;
  if (zI(e))
    return e.then(
      (r) => {
        if (!al(r) && r !== null)
          throw new ci(n);
        return r;
      },
      (r) => {
        throw new ci(`${t} rejected with ${r}`);
      }
    );
  if (!al(e) && e !== null)
    throw new ci(n);
  return e;
}
function HL(e, t, n) {
  const { beforeSend: r, beforeSendTransaction: i } = e;
  return pC(t) && r ? r(t, n) : yC(t) && i ? i(t, n) : t;
}
function pC(e) {
  return e.type === void 0;
}
function yC(e) {
  return e.type === "transaction";
}
const GL = 30;
function YL(e, t, n = aL(
  e.bufferSize || GL
)) {
  let r = {};
  const i = (a) => n.drain(a);
  function o(a) {
    const s = [];
    if ($x(a, (f, d) => {
      const h = Wx(d);
      if (vL(r, h)) {
        const g = Gx(f, d);
        e.recordDroppedEvent("ratelimit_backoff", h, g);
      } else
        s.push(f);
    }), s.length === 0)
      return xc();
    const c = Ed(a[0], s), l = (f) => {
      $x(c, (d, h) => {
        const g = Gx(d, h);
        e.recordDroppedEvent(f, Wx(h), g);
      });
    }, u = () => t({ body: dL(c, e.textEncoder) }).then(
      (f) => (f.statusCode !== void 0 && (f.statusCode < 200 || f.statusCode >= 300) && (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn(`Sentry responded with status code ${f.statusCode} to sent event.`), r = SL(r, f), f),
      (f) => {
        throw l("network_error"), f;
      }
    );
    return n.add(u).then(
      (f) => f,
      (f) => {
        if (f instanceof ci)
          return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.error("Skipped sending event because buffer is full."), l("queue_overflow"), xc();
        throw f;
      }
    );
  }
  return o.__sentry__baseTransport__ = !0, {
    send: o,
    flush: i
  };
}
function Gx(e, t) {
  if (!(t !== "event" && t !== "transaction"))
    return Array.isArray(e) ? e[1] : void 0;
}
const Yx = "7.52.1";
let Zx;
class Xf {
  constructor() {
    Xf.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "FunctionToString";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Xf.id;
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    Zx = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...t) {
        const n = $I(this) || this;
        return Zx.apply(n, t);
      };
    } catch {
    }
  }
}
Xf.__initStatic();
const ZL = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
class $u {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "InboundFilters";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = $u.id;
  }
  constructor(t = {}) {
    this._options = t, $u.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    const r = (i) => {
      const o = n();
      if (o) {
        const a = o.getIntegration($u);
        if (a) {
          const s = o.getClient(), c = s ? s.getOptions() : {}, l = JL(a._options, c);
          return XL(i, l) ? null : i;
        }
      }
      return i;
    };
    r.id = this.name, t(r);
  }
}
$u.__initStatic();
function JL(e = {}, t = {}) {
  return {
    allowUrls: [...e.allowUrls || [], ...t.allowUrls || []],
    denyUrls: [...e.denyUrls || [], ...t.denyUrls || []],
    ignoreErrors: [
      ...e.ignoreErrors || [],
      ...t.ignoreErrors || [],
      ...ZL
    ],
    ignoreTransactions: [...e.ignoreTransactions || [], ...t.ignoreTransactions || []],
    ignoreInternal: e.ignoreInternal !== void 0 ? e.ignoreInternal : !0
  };
}
function XL(e, t) {
  return t.ignoreInternal && i9(e) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn(`Event dropped due to being internal Sentry Error.
Event: ${As(e)}`), !0) : QL(e, t.ignoreErrors) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn(
    `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${As(e)}`
  ), !0) : e9(e, t.ignoreTransactions) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn(
    `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${As(e)}`
  ), !0) : t9(e, t.denyUrls) ? ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn(
    `Event dropped due to being matched by \`denyUrls\` option.
Event: ${As(
      e
    )}.
Url: ${Rb(e)}`
  ), !0) : n9(e, t.allowUrls) ? !1 : ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn(
    `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${As(
      e
    )}.
Url: ${Rb(e)}`
  ), !0);
}
function QL(e, t) {
  return e.type || !t || !t.length ? !1 : r9(e).some((n) => jm(n, t));
}
function e9(e, t) {
  if (e.type !== "transaction" || !t || !t.length)
    return !1;
  const n = e.transaction;
  return n ? jm(n, t) : !1;
}
function t9(e, t) {
  if (!t || !t.length)
    return !1;
  const n = Rb(e);
  return n ? jm(n, t) : !1;
}
function n9(e, t) {
  if (!t || !t.length)
    return !0;
  const n = Rb(e);
  return n ? jm(n, t) : !0;
}
function r9(e) {
  if (e.message)
    return [e.message];
  if (e.exception) {
    const { values: t } = e.exception;
    try {
      const { type: n = "", value: r = "" } = t && t[t.length - 1] || {};
      return [`${r}`, `${n}: ${r}`];
    } catch {
      return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.error(`Cannot extract message for event ${As(e)}`), [];
    }
  }
  return [];
}
function i9(e) {
  try {
    return e.exception.values[0].type === "SentryError";
  } catch {
  }
  return !1;
}
function o9(e = []) {
  for (let t = e.length - 1; t >= 0; t--) {
    const n = e[t];
    if (n && n.filename !== "<anonymous>" && n.filename !== "[native code]")
      return n.filename || null;
  }
  return null;
}
function Rb(e) {
  try {
    let t;
    try {
      t = e.exception.values[0].stacktrace.frames;
    } catch {
    }
    return t ? o9(t) : null;
  } catch {
    return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.error(`Cannot extract url for event ${As(e)}`), null;
  }
}
const fr = lo;
let ZE = 0;
function gC() {
  return ZE > 0;
}
function a9() {
  ZE++, setTimeout(() => {
    ZE--;
  });
}
function cl(e, t = {}, n) {
  if (typeof e != "function")
    return e;
  try {
    const i = e.__sentry_wrapped__;
    if (i)
      return i;
    if ($I(e))
      return e;
  } catch {
    return e;
  }
  const r = function() {
    const i = Array.prototype.slice.call(arguments);
    try {
      n && typeof n == "function" && n.apply(this, arguments);
      const o = i.map((a) => cl(a, t));
      return e.apply(this, o);
    } catch (o) {
      throw a9(), PL((a) => {
        a.addEventProcessor((s) => (t.mechanism && (VE(s, void 0, void 0), Jf(s, t.mechanism)), s.extra = {
          ...s.extra,
          arguments: i
        }, s)), OL(o);
      }), o;
    }
  };
  try {
    for (const i in e)
      Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
  } catch {
  }
  tC(r, e), LI(e, "__sentry_wrapped__", r);
  try {
    Object.getOwnPropertyDescriptor(r, "name").configurable && Object.defineProperty(r, "name", {
      get() {
        return e.name;
      }
    });
  } catch {
  }
  return r;
}
function bC(e, t) {
  const n = qI(e, t), r = {
    type: t && t.name,
    value: l9(t)
  };
  return n.length && (r.stacktrace = { frames: n }), r.type === void 0 && r.value === "" && (r.value = "Unrecoverable error caught"), r;
}
function s9(e, t, n, r) {
  const o = hi().getClient(), a = o && o.getOptions().normalizeDepth, s = {
    exception: {
      values: [
        {
          type: UI(t) ? t.constructor.name : r ? "UnhandledRejection" : "Error",
          value: `Non-Error ${r ? "promise rejection" : "exception"} captured with keys: ${BF(t)}`
        }
      ]
    },
    extra: {
      __serialized__: oC(t, a)
    }
  };
  if (n) {
    const c = qI(e, n);
    c.length && (s.exception.values[0].stacktrace = { frames: c });
  }
  return s;
}
function _v(e, t) {
  return {
    exception: {
      values: [bC(e, t)]
    }
  };
}
function qI(e, t) {
  const n = t.stacktrace || t.stack || "", r = u9(t);
  try {
    return e(n, r);
  } catch {
  }
  return [];
}
const c9 = /Minified React error #\d+;/i;
function u9(e) {
  if (e) {
    if (typeof e.framesToPop == "number")
      return e.framesToPop;
    if (c9.test(e.message))
      return 1;
  }
  return 0;
}
function l9(e) {
  const t = e && e.message;
  return t ? t.error && typeof t.error.message == "string" ? t.error.message : t : "No error message";
}
function f9(e, t, n, r) {
  const i = n && n.syntheticException || void 0, o = HI(e, t, i, r);
  return Jf(o), o.level = "error", n && n.event_id && (o.event_id = n.event_id), xc(o);
}
function d9(e, t, n = "info", r, i) {
  const o = r && r.syntheticException || void 0, a = JE(e, t, o, i);
  return a.level = n, r && r.event_id && (a.event_id = r.event_id), xc(a);
}
function HI(e, t, n, r, i) {
  let o;
  if (J3(t) && t.error)
    return _v(e, t.error);
  if (Px(t) || yF(t)) {
    const a = t;
    if ("stack" in t)
      o = _v(e, t);
    else {
      const s = a.name || (Px(a) ? "DOMError" : "DOMException"), c = a.message ? `${s}: ${a.message}` : s;
      o = JE(e, c, n, r), VE(o, c);
    }
    return "code" in a && (o.tags = { ...o.tags, "DOMException.code": `${a.code}` }), o;
  }
  return Z3(t) ? _v(e, t) : al(t) || UI(t) ? (o = s9(e, t, n, i), Jf(o, {
    synthetic: !0
  }), o) : (o = JE(e, t, n, r), VE(o, `${t}`, void 0), Jf(o, {
    synthetic: !0
  }), o);
}
function JE(e, t, n, r) {
  const i = {
    message: t
  };
  if (r && n) {
    const o = qI(e, n);
    o.length && (i.exception = {
      values: [{ value: t, stacktrace: { frames: o } }]
    });
  }
  return i;
}
const lg = 1024, mC = "Breadcrumbs";
class Qf {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = mC;
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Qf.id;
  }
  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
  /**
   * @inheritDoc
   */
  constructor(t) {
    Qf.prototype.__init.call(this), this.options = {
      console: !0,
      dom: !0,
      fetch: !0,
      history: !0,
      sentry: !0,
      xhr: !0,
      ...t
    };
  }
  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
  setupOnce() {
    this.options.console && hc("console", p9), this.options.dom && hc("dom", h9(this.options.dom)), this.options.xhr && hc("xhr", y9), this.options.fetch && hc("fetch", g9), this.options.history && hc("history", b9);
  }
  /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */
  addSentryBreadcrumb(t) {
    this.options.sentry && hi().addBreadcrumb(
      {
        category: `sentry.${t.type === "transaction" ? "transaction" : "event"}`,
        event_id: t.event_id,
        level: t.level,
        message: As(t)
      },
      {
        event: t
      }
    );
  }
}
Qf.__initStatic();
function h9(e) {
  function t(n) {
    let r, i = typeof e == "object" ? e.serializeAttribute : void 0, o = typeof e == "object" && typeof e.maxStringLength == "number" ? e.maxStringLength : void 0;
    o && o > lg && ((typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn(
      `\`dom.maxStringLength\` cannot exceed ${lg}, but a value of ${o} was configured. Sentry will use ${lg} instead.`
    ), o = lg), typeof i == "string" && (i = [i]);
    try {
      const a = n.event;
      r = m9(a) ? FE(a.target, { keyAttrs: i, maxStringLength: o }) : FE(a, { keyAttrs: i, maxStringLength: o });
    } catch {
      r = "<unknown>";
    }
    r.length !== 0 && hi().addBreadcrumb(
      {
        category: `ui.${n.name}`,
        message: r
      },
      {
        event: n.event,
        name: n.name,
        global: n.global
      }
    );
  }
  return t;
}
function p9(e) {
  for (let n = 0; n < e.args.length; n++)
    if (e.args[n] === "ref=Ref<") {
      e.args[n + 1] = "viewRef";
      break;
    }
  const t = {
    category: "console",
    data: {
      arguments: e.args,
      logger: "console"
    },
    level: cL(e.level),
    message: Cx(e.args, " ")
  };
  if (e.level === "assert")
    if (e.args[0] === !1)
      t.message = `Assertion failed: ${Cx(e.args.slice(1), " ") || "console.assert"}`, t.data.arguments = e.args.slice(1);
    else
      return;
  hi().addBreadcrumb(t, {
    input: e.args,
    level: e.level
  });
}
function y9(e) {
  const { startTimestamp: t, endTimestamp: n } = e, r = e.xhr[Tf];
  if (!t || !n || !r)
    return;
  const { method: i, url: o, status_code: a, body: s } = r, c = {
    method: i,
    url: o,
    status_code: a
  }, l = {
    xhr: e.xhr,
    input: s,
    startTimestamp: t,
    endTimestamp: n
  };
  hi().addBreadcrumb(
    {
      category: "xhr",
      data: c,
      type: "http"
    },
    l
  );
}
function g9(e) {
  const { startTimestamp: t, endTimestamp: n } = e;
  if (n && !(e.fetchData.url.match(/sentry_key/) && e.fetchData.method === "POST"))
    if (e.error) {
      const r = e.fetchData, i = {
        data: e.error,
        input: e.args,
        startTimestamp: t,
        endTimestamp: n
      };
      hi().addBreadcrumb(
        {
          category: "fetch",
          data: r,
          level: "error",
          type: "http"
        },
        i
      );
    } else {
      const r = {
        ...e.fetchData,
        status_code: e.response && e.response.status
      }, i = {
        input: e.args,
        response: e.response,
        startTimestamp: t,
        endTimestamp: n
      };
      hi().addBreadcrumb(
        {
          category: "fetch",
          data: r,
          type: "http"
        },
        i
      );
    }
}
function b9(e) {
  let t = e.from, n = e.to;
  const r = bv(fr.location.href);
  let i = bv(t);
  const o = bv(n);
  i.path || (i = r), r.protocol === o.protocol && r.host === o.host && (n = o.relative), r.protocol === i.protocol && r.host === i.host && (t = i.relative), hi().addBreadcrumb({
    category: "navigation",
    data: {
      from: t,
      to: n
    }
  });
}
function m9(e) {
  return e && !!e.target;
}
function _9(e, {
  metadata: t,
  tunnel: n,
  dsn: r
}) {
  const i = {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && t.sdk && {
      sdk: {
        name: t.sdk.name,
        version: t.sdk.version
      }
    },
    ...!!n && !!r && { dsn: Nm(r) }
  }, o = w9(e);
  return Ed(i, [o]);
}
function w9(e) {
  return [{
    type: "user_report"
  }, e];
}
class v9 extends pc {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(t) {
    const n = fr.SENTRY_SDK_SOURCE || QF();
    t._metadata = t._metadata || {}, t._metadata.sdk = t._metadata.sdk || {
      name: "sentry.javascript.browser",
      packages: [
        {
          name: `${n}:@sentry/browser`,
          version: Yx
        }
      ],
      version: Yx
    }, super(t), t.sendClientReports && fr.document && fr.document.addEventListener("visibilitychange", () => {
      fr.document.visibilityState === "hidden" && this._flushOutcomes();
    });
  }
  /**
   * @inheritDoc
   */
  eventFromException(t, n) {
    return f9(this._options.stackParser, t, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(t, n = "info", r) {
    return d9(this._options.stackParser, t, n, r, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  sendEvent(t, n) {
    const r = this.getIntegrationById(mC);
    r && r.addSentryBreadcrumb && r.addSentryBreadcrumb(t), super.sendEvent(t, n);
  }
  /**
   * Sends user feedback to Sentry.
   */
  captureUserFeedback(t) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn("SDK not enabled, will not capture user feedback.");
      return;
    }
    const n = _9(t, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel
    });
    this._sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(t, n, r) {
    return t.platform = t.platform || "javascript", super._prepareEvent(t, n, r);
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    const t = this._clearOutcomes();
    if (t.length === 0) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.log("No dsn provided, will not send outcomes");
      return;
    }
    (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.log("Sending outcomes:", t);
    const n = bL(t, this._options.tunnel && Nm(this._dsn));
    this._sendEnvelope(n);
  }
}
let xf;
function S9() {
  if (xf)
    return xf;
  if (WE(fr.fetch))
    return xf = fr.fetch.bind(fr);
  const e = fr.document;
  let t = fr.fetch;
  if (e && typeof e.createElement == "function")
    try {
      const n = e.createElement("iframe");
      n.hidden = !0, e.head.appendChild(n);
      const r = n.contentWindow;
      r && r.fetch && (t = r.fetch), e.head.removeChild(n);
    } catch (n) {
      (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return xf = t.bind(fr);
}
function E9() {
  xf = void 0;
}
function A9(e, t = S9()) {
  let n = 0, r = 0;
  function i(o) {
    const a = o.body.length;
    n += a, r++;
    const s = {
      body: o.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: e.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && r < 15,
      ...e.fetchOptions
    };
    try {
      return t(e.url, s).then((c) => (n -= a, r--, {
        statusCode: c.status,
        headers: {
          "x-sentry-rate-limits": c.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": c.headers.get("Retry-After")
        }
      }));
    } catch (c) {
      return E9(), n -= a, r--, Db(c);
    }
  }
  return YL(e, i);
}
const Fm = "?", I9 = 30, k9 = 40, T9 = 50;
function GI(e, t, n, r) {
  const i = {
    filename: e,
    function: t,
    in_app: !0
    // All browser frames are considered in_app
  };
  return n !== void 0 && (i.lineno = n), r !== void 0 && (i.colno = r), i;
}
const x9 = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, M9 = /\((\S*)(?::(\d+))(?::(\d+))\)/, O9 = (e) => {
  const t = x9.exec(e);
  if (t) {
    if (t[2] && t[2].indexOf("eval") === 0) {
      const o = M9.exec(t[2]);
      o && (t[2] = o[1], t[3] = o[2], t[4] = o[3]);
    }
    const [r, i] = _C(t[1] || Fm, t[2]);
    return GI(i, r, t[3] ? +t[3] : void 0, t[4] ? +t[4] : void 0);
  }
}, P9 = [I9, O9], B9 = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, C9 = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, D9 = (e) => {
  const t = B9.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      const o = C9.exec(t[3]);
      o && (t[1] = t[1] || "eval", t[3] = o[1], t[4] = o[2], t[5] = "");
    }
    let r = t[3], i = t[1] || Fm;
    return [i, r] = _C(i, r), GI(r, i, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}, R9 = [T9, D9], N9 = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i, j9 = (e) => {
  const t = N9.exec(e);
  return t ? GI(t[2], t[1] || Fm, +t[3], t[4] ? +t[4] : void 0) : void 0;
}, U9 = [k9, j9], z9 = [P9, R9, U9], F9 = CF(...z9), _C = (e, t) => {
  const n = e.indexOf("safari-extension") !== -1, r = e.indexOf("safari-web-extension") !== -1;
  return n || r ? [
    e.indexOf("@") !== -1 ? e.split("@")[0] : Fm,
    n ? `safari-extension:${t}` : `safari-web-extension:${t}`
  ] : [e, t];
};
class Cs {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "GlobalHandlers";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Cs.id;
  }
  /** JSDoc */
  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
  __init2() {
    this._installFunc = {
      onerror: L9,
      onunhandledrejection: $9
    };
  }
  /** JSDoc */
  constructor(t) {
    Cs.prototype.__init.call(this), Cs.prototype.__init2.call(this), this._options = {
      onerror: !0,
      onunhandledrejection: !0,
      ...t
    };
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    Error.stackTraceLimit = 50;
    const t = this._options;
    for (const n in t) {
      const r = this._installFunc[n];
      r && t[n] && (V9(n), r(), this._installFunc[n] = void 0);
    }
  }
}
Cs.__initStatic();
function L9() {
  hc(
    "error",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [t, n, r] = SC();
      if (!t.getIntegration(Cs))
        return;
      const { msg: i, url: o, line: a, column: s, error: c } = e;
      if (gC() || c && c.__sentry_own_request__)
        return;
      const l = c === void 0 && Tc(i) ? K9(i, o, a, s) : wC(
        HI(n, c || i, void 0, r, !1),
        o,
        a,
        s
      );
      l.level = "error", vC(t, c, l, "onerror");
    }
  );
}
function $9() {
  hc(
    "unhandledrejection",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [t, n, r] = SC();
      if (!t.getIntegration(Cs))
        return;
      let i = e;
      try {
        "reason" in e ? i = e.reason : "detail" in e && "reason" in e.detail && (i = e.detail.reason);
      } catch {
      }
      if (gC() || i && i.__sentry_own_request__)
        return !0;
      const o = X3(i) ? W9(i) : HI(n, i, void 0, r, !0);
      o.level = "error", vC(t, i, o, "onunhandledrejection");
    }
  );
}
function W9(e) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(e)}`
        }
      ]
    }
  };
}
function K9(e, t, n, r) {
  const i = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
  let o = J3(e) ? e.message : e, a = "Error";
  const s = o.match(i);
  return s && (a = s[1], o = s[2]), wC({
    exception: {
      values: [
        {
          type: a,
          value: o
        }
      ]
    }
  }, t, n, r);
}
function wC(e, t, n, r) {
  const i = e.exception = e.exception || {}, o = i.values = i.values || [], a = o[0] = o[0] || {}, s = a.stacktrace = a.stacktrace || {}, c = s.frames = s.frames || [], l = isNaN(parseInt(r, 10)) ? void 0 : r, u = isNaN(parseInt(n, 10)) ? void 0 : n, f = Tc(t) && t.length > 0 ? t : EF();
  return c.length === 0 && c.push({
    colno: l,
    filename: f,
    function: "?",
    in_app: !0,
    lineno: u
  }), e;
}
function V9(e) {
  (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.log(`Global Handler attached: ${e}`);
}
function vC(e, t, n, r) {
  Jf(n, {
    handled: !1,
    type: r
  }), e.captureEvent(n, {
    originalException: t
  });
}
function SC() {
  const e = hi(), t = e.getClient(), n = t && t.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
  return [e, n.stackParser, n.attachStacktrace];
}
const q9 = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
];
class ed {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "TryCatch";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = ed.id;
  }
  /** JSDoc */
  /**
   * @inheritDoc
   */
  constructor(t) {
    ed.prototype.__init.call(this), this._options = {
      XMLHttpRequest: !0,
      eventTarget: !0,
      requestAnimationFrame: !0,
      setInterval: !0,
      setTimeout: !0,
      ...t
    };
  }
  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
  setupOnce() {
    this._options.setTimeout && Hr(fr, "setTimeout", Jx), this._options.setInterval && Hr(fr, "setInterval", Jx), this._options.requestAnimationFrame && Hr(fr, "requestAnimationFrame", H9), this._options.XMLHttpRequest && "XMLHttpRequest" in fr && Hr(XMLHttpRequest.prototype, "send", G9);
    const t = this._options.eventTarget;
    t && (Array.isArray(t) ? t : q9).forEach(Y9);
  }
}
ed.__initStatic();
function Jx(e) {
  return function(...t) {
    const n = t[0];
    return t[0] = cl(n, {
      mechanism: {
        data: { function: qs(e) },
        handled: !0,
        type: "instrument"
      }
    }), e.apply(this, t);
  };
}
function H9(e) {
  return function(t) {
    return e.apply(this, [
      cl(t, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: qs(e)
          },
          handled: !0,
          type: "instrument"
        }
      })
    ]);
  };
}
function G9(e) {
  return function(...t) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((i) => {
      i in n && typeof n[i] == "function" && Hr(n, i, function(o) {
        const a = {
          mechanism: {
            data: {
              function: i,
              handler: qs(o)
            },
            handled: !0,
            type: "instrument"
          }
        }, s = $I(o);
        return s && (a.mechanism.data.handler = qs(s)), cl(o, a);
      });
    }), e.apply(this, t);
  };
}
function Y9(e) {
  const t = fr, n = t[e] && t[e].prototype;
  !n || !n.hasOwnProperty || !n.hasOwnProperty("addEventListener") || (Hr(n, "addEventListener", function(r) {
    return function(i, o, a) {
      try {
        typeof o.handleEvent == "function" && (o.handleEvent = cl(o.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: qs(o),
              target: e
            },
            handled: !0,
            type: "instrument"
          }
        }));
      } catch {
      }
      return r.apply(this, [
        i,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        cl(o, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: qs(o),
              target: e
            },
            handled: !0,
            type: "instrument"
          }
        }),
        a
      ]);
    };
  }), Hr(
    n,
    "removeEventListener",
    function(r) {
      return function(i, o, a) {
        const s = o;
        try {
          const c = s && s.__sentry_wrapped__;
          c && r.call(this, i, c, a);
        } catch {
        }
        return r.call(this, i, s, a);
      };
    }
  ));
}
const Z9 = "cause", J9 = 5;
class Wu {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "LinkedErrors";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Wu.id;
  }
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  constructor(t = {}) {
    Wu.prototype.__init.call(this), this._key = t.key || Z9, this._limit = t.limit || J9;
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    const t = hi().getClient();
    t && KI((n, r) => {
      const i = hi().getIntegration(Wu);
      return i ? X9(t.getOptions().stackParser, i._key, i._limit, n, r) : n;
    });
  }
}
Wu.__initStatic();
function X9(e, t, n, r, i) {
  if (!r.exception || !r.exception.values || !i || !Nl(i.originalException, Error))
    return r;
  const o = EC(e, n, i.originalException, t);
  return r.exception.values = [...o, ...r.exception.values], r;
}
function EC(e, t, n, r, i = []) {
  if (!Nl(n[r], Error) || i.length + 1 >= t)
    return i;
  const o = bC(e, n[r]);
  return EC(e, t, n[r], r, [o, ...i]);
}
class Ku {
  constructor() {
    Ku.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "HttpContext";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Ku.id;
  }
  /**
   * @inheritDoc
   */
  setupOnce() {
    KI((t) => {
      if (hi().getIntegration(Ku)) {
        if (!fr.navigator && !fr.location && !fr.document)
          return t;
        const n = t.request && t.request.url || fr.location && fr.location.href, { referrer: r } = fr.document || {}, { userAgent: i } = fr.navigator || {}, o = {
          ...t.request && t.request.headers,
          ...r && { Referer: r },
          ...i && { "User-Agent": i }
        }, a = { ...t.request, ...n && { url: n }, headers: o };
        return { ...t, request: a };
      }
      return t;
    });
  }
}
Ku.__initStatic();
class Vu {
  constructor() {
    Vu.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Dedupe";
  }
  /**
   * @inheritDoc
   */
  __init() {
    this.name = Vu.id;
  }
  /**
   * @inheritDoc
   */
  /**
   * @inheritDoc
   */
  setupOnce(t, n) {
    const r = (i) => {
      if (i.type)
        return i;
      const o = n().getIntegration(Vu);
      if (o) {
        try {
          if (Q9(i, o._previousEvent))
            return (typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__) && Xt.warn("Event dropped due to being a duplicate of previously captured event."), null;
        } catch {
          return o._previousEvent = i;
        }
        return o._previousEvent = i;
      }
      return i;
    };
    r.id = this.name, t(r);
  }
}
Vu.__initStatic();
function Q9(e, t) {
  return t ? !!(e$(e, t) || t$(e, t)) : !1;
}
function e$(e, t) {
  const n = e.message, r = t.message;
  return !(!n && !r || n && !r || !n && r || n !== r || !IC(e, t) || !AC(e, t));
}
function t$(e, t) {
  const n = Xx(t), r = Xx(e);
  return !(!n || !r || n.type !== r.type || n.value !== r.value || !IC(e, t) || !AC(e, t));
}
function AC(e, t) {
  let n = Qx(e), r = Qx(t);
  if (!n && !r)
    return !0;
  if (n && !r || !n && r || (n = n, r = r, r.length !== n.length))
    return !1;
  for (let i = 0; i < r.length; i++) {
    const o = r[i], a = n[i];
    if (o.filename !== a.filename || o.lineno !== a.lineno || o.colno !== a.colno || o.function !== a.function)
      return !1;
  }
  return !0;
}
function IC(e, t) {
  let n = e.fingerprint, r = t.fingerprint;
  if (!n && !r)
    return !0;
  if (n && !r || !n && r)
    return !1;
  n = n, r = r;
  try {
    return n.join("") === r.join("");
  } catch {
    return !1;
  }
}
function Xx(e) {
  return e.exception && e.exception.values && e.exception.values[0];
}
function Qx(e) {
  const t = e.exception;
  if (t)
    try {
      return t.values[0].stacktrace.frames;
    } catch {
      return;
    }
}
const n$ = [
  new $u(),
  new Xf(),
  new ed(),
  new Qf(),
  new Cs(),
  new Wu(),
  new Vu(),
  new Ku()
];
function kC() {
  return (e) => e;
}
function r$(e, t) {
  window.kycDaoSentry && window.kycDaoSentry.captureSDKError(e, t);
}
const i$ = kC()({
  UserNotLoggedIn: "User is not logged in. Please make sure that third party cookies are enabled in your browser and try again.",
  InvalidEmailAddress: "Invalid email address",
  InvalidTaxResidency: "Invalid taxResidency. Please use the country list provided by the SDK.",
  TermsAndConditionsNotAccepted: "Terms and Conditions and Privacy Policy must be accepted to start verification",
  DisclaimerNotAccepted: "Disclaimer must be accepted",
  WalletNotConnected: "Wallet connection required",
  UserNotVerified: "User must be verified to be able to mint an NFT",
  UserAlreadyVerified: "User already verified",
  NetworkNotSupported: "Selected network is not supported",
  NetworkNotEnabled: "Selected network is not enabled",
  NetworkSwitchingFailed: "Network switching failed",
  NetworkPriceTooHigh: "Network price too high, try again later"
}), o$ = kC()({
  TransactionNotFound: "Transaction not found",
  TransactionFailed: "Transaction failed",
  TransactionRejected: "Transaction rejected by the contract",
  MintingCostCalculationError: "Minting cost calculation error",
  GasEstimationError: "Gas estimation error"
});
class $o extends Error {
  constructor(t, n, r) {
    super(n), this.name = "KycDaoSDKError", this._errorCode = t, this.referenceId = r || dF(10);
  }
  toString() {
    return `${this.name}${this.errorCode ? "[" + this.errorCode + "]" : ""}: ${this.message} (ref: ${this.referenceId})`;
  }
  get errorCode() {
    return this._errorCode;
  }
}
class un extends $o {
  constructor(t) {
    super(void 0, t), this.name = "ConfigurationError";
  }
  get errorCode() {
  }
}
class Xn extends $o {
  constructor(t, n) {
    n || (n = i$[t]), super(t, n), this.name = "StatusError";
  }
  get errorCode() {
    return super.errorCode;
  }
}
class ea extends $o {
  constructor(t, n, r) {
    super(t, n), this.name = "WalletError", this.errorCodeFromWallet = r;
  }
  get errorCode() {
    return super.errorCode;
  }
  toString() {
    return `${this.name}[${this.errorCode}]: ${this.message} (ref: ${this.referenceId}, errorCodeFromWallet: ${this.errorCodeFromWallet})`;
  }
}
class Pa extends $o {
  constructor(t, n) {
    n || (n = o$[t]), super(t, n), this.name = "TransactionError";
  }
  get errorCode() {
    return super.errorCode;
  }
}
class lt extends $o {
  constructor(t, n) {
    super(void 0, t, n), this.name = "InternalError";
  }
  get errorCode() {
  }
}
let bs = class extends lt {
  constructor(t) {
    super(`Unreachable case: ${JSON.stringify(t)}`);
  }
};
class wv extends $o {
  constructor(t) {
    super(void 0, t), this.name = "UnknownError";
  }
  get errorCode() {
  }
}
function a$(e) {
  let t;
  if (e instanceof $o)
    t = e;
  else if (e instanceof Nb)
    if (e.statusCode === 401)
      t = new Xn("UserNotLoggedIn");
    else {
      const r = `${e.errorCode} - ${e.message}`;
      t = new lt(r, e.referenceId);
    }
  for (const r of [c$, s$])
    t || (t = r(e));
  t || (typeof e == "string" ? t = new wv(e) : e instanceof Error ? t = new wv(e.message) : t = new wv(JSON.stringify(e)));
  let n;
  throw t instanceof ea && (n = t.errorCodeFromWallet), t !== e && Pb(e) && e.stack && (t.stack = "" + e.stack), r$(t, { errorCodeFromWallet: n }), console.error(t), t;
}
function TC(e, t) {
  switch (e) {
    case 4001:
      return new ea("RejectedByUser", t, e);
    case 4100:
      return new ea("AccountUnauthorized", t, e);
    case 4900:
    case 4901:
      return new ea("UserNotConnected", t, e);
    case 4902:
      return new ea("ChainMissing", t, e);
    case -32e3:
      return t.indexOf("insufficient funds") !== -1 ? new ea("InsufficientFunds", t, e) : new ea("InternalWalletError", t, e);
    case 4200:
    case -32700:
    case -32600:
    case -32601:
    case -32602:
    case -32603:
    case -32001:
    case -32002:
    case -32004:
    case -32005:
    case -32003:
      return new ea("InternalWalletError", t, e);
  }
}
function xC(e) {
  const t = e;
  if (!t.code || !t.message)
    return;
  let { code: n, message: r } = t;
  const i = t.data;
  return n === -32603 && (i != null && i.code) && (i.message || i.details) && (n = i.code, r = i.message || i.details || ""), {
    code: n,
    message: r
  };
}
function s$(e) {
  const t = xC(e);
  if (!t)
    return;
  const { code: n, message: r } = t;
  return n === 3 ? new Pa("TransactionRejected", r) : TC(n, r);
}
function c$(e) {
  if (e instanceof go) {
    const t = e.error;
    return !t || !t.code || !t.message ? void 0 : TC(t.code, t.message);
  }
}
function Gn(e) {
  return function(t, n, r) {
    const i = r.value;
    return r.value = async function(...o) {
      try {
        return await i.apply(this, o);
      } catch (a) {
        e ? e.call(null, a) : a$.call(null, a);
      }
    }, r;
  };
}
class u$ {
  get dsn() {
    return this._dsn;
  }
  get environment() {
    return this._environment;
  }
  getEnvironment() {
    const n = (() => {
      var r;
      if (window !== window.self)
        try {
          return (r = window.top) === null || r === void 0 ? void 0 : r.location.hostname;
        } catch {
          return;
        }
      else
        return window.location.hostname;
    })();
    return n != null ? n === "localhost" || n === "127.0.0.1" ? "local" : n.includes("pre.kycdao.xyz") || n.includes("dev.kycdao.xyz") || n.includes("staging.kycdao.xyz") ? "development" : "production" : "unknown";
  }
  constructor() {
    this._dsn = "https://23dafecec027439b9413cd50eb22567d@o1184096.ingest.sentry.io/4504559638413313", this._environment = this.getEnvironment();
    const t = new v9({
      dsn: this._dsn,
      environment: this._environment,
      transport: A9,
      stackParser: F9,
      integrations: n$
    });
    this._hub = new VI(t), window.kycDaoSentry = this;
  }
  captureSDKError(t, n) {
    this._hub.withScope((r) => {
      this._hub.setTags(Object.assign(Object.assign({}, n), { errorCode: t.errorCode, referenceId: t.referenceId })), this._hub.captureException(t);
    });
  }
}
class Nb extends Error {
  constructor(t, n, r, i) {
    super(r), this.name = "KycDaoApiError", this.statusCode = t, this.errorCode = n, this.referenceId = i;
  }
}
class l$ {
  get baseUrl() {
    return this._baseUrl;
  }
  constructor(t) {
    var n;
    this._apiKey = t.apiKey, this._baseUrl = t.baseUrl.endsWith("/") ? t.baseUrl : t.baseUrl + "/";
    const r = (n = t.publicApiPath) !== null && n !== void 0 ? n : "api/public/";
    this._publicApiPath = r.endsWith("/") ? r : r + "/";
  }
  url(t) {
    return t.startsWith("/") && (t = t.slice(1)), t.endsWith("/") && (t = t.slice(0, t.length - 1)), this._baseUrl + this._publicApiPath + t;
  }
  async request(t, n) {
    var r;
    let i = this.url(t);
    (!(n != null && n.method) || (n == null ? void 0 : n.method) === "GET") && (n != null && n.body) && n.body instanceof URLSearchParams && (i = i + "?" + n.body, n.body = null);
    const o = new Headers();
    n != null && n.body && typeof n.body == "string" && o.append("Content-type", "application/json"), this._apiKey && o.append("Authorization", this._apiKey);
    const a = Object.assign(Object.assign({}, n), { headers: o, credentials: "include" }), s = await fetch(i, a).catch((u) => {
      throw new lt(`The kycDAO server at ${this.baseUrl} is unreachable. Reason: ${u}. If you have an ad blocker please disable it and try again.`);
    }), l = ((r = s.headers.get("content-type")) === null || r === void 0 ? void 0 : r.includes("application/json")) ? await s.json().catch((u) => {
      throw new lt(`kycDAO server JSON response is invalid. Reason: ${u}`);
    }) : null;
    if (!s.ok) {
      let u = s.status, f = "KycDaoApiError", d = u.toString(), h;
      if (l) {
        const g = l;
        if (typeof g == "string" && (d = g), g != null && g.error) {
          const w = g.error;
          u = w.code, d = w.description;
        }
        if (g != null && g.reference_id) {
          const w = g;
          u = w.status_code, f = w.error_code, d = w.message, h = w.reference_id;
        }
      }
      throw new Nb(u, f, d, h);
    }
    return l;
  }
  async get(t, n) {
    return this.request(t, {
      method: "GET",
      body: new URLSearchParams(n)
    });
  }
  async post(t, n) {
    return this.request(t, {
      method: "POST",
      body: n ? JSON.stringify(n) : null
    });
  }
  async put(t, n) {
    return this.request(t, {
      method: "PUT",
      body: JSON.stringify(n)
    });
  }
}
const XE = {
  CeloAlfajores: "CeloAlfajores",
  CeloMainnet: "CeloMainnet",
  EthereumGoerli: "EthereumGoerli",
  EthereumMainnet: "EthereumMainnet",
  PolygonMainnet: "PolygonMainnet",
  PolygonMumbai: "PolygonMumbai",
  BaseGoerli: "BaseGoerli",
  ArbitrumMainnet: "ArbitrumMainnet",
  ArbitrumGoerli: "ArbitrumGoerli",
  ZKSyncMainnet: "ZKSyncMainnet",
  ZKSyncGoerli: "ZKSyncGoerli"
}, f$ = {
  NearMainnet: "NearMainnet",
  NearTestnet: "NearTestnet"
}, d$ = {
  SolanaDevnet: "SolanaDevnet",
  SolanaMainnet: "SolanaMainnet",
  SolanaTestnet: "SolanaTestnet"
}, h$ = {
  AptosDevnet: "AptosDevnet",
  AptosMainnet: "AptosMainnet",
  AptosTestnet: "AptosTestnet"
}, p$ = Object.assign(Object.assign(Object.assign(Object.assign({}, XE), f$), d$), h$), Du = {
  AccreditedInvestor: "AccreditedInvestor",
  KYC: "KYC"
}, y$ = {
  networkId: "testnet",
  nodeUrl: "https://rpc.testnet.near.org",
  walletUrl: "https://wallet.testnet.near.org",
  helperUrl: "https://helper.testnet.near.org",
  headers: {}
}, g$ = {
  networkId: "mainnet",
  nodeUrl: "https://rpc.mainnet.near.org",
  walletUrl: "https://wallet.mainnet.near.org",
  helperUrl: "https://helper.mainnet.near.org",
  headers: {}
}, b$ = "https://archival-rpc.testnet.near.org", m$ = "https://archival-rpc.mainnet.near.org", _$ = [
  {
    name: "Aruba",
    iso_cca2: "AW"
  },
  {
    name: "Afghanistan",
    iso_cca2: "AF"
  },
  {
    name: "Angola",
    iso_cca2: "AO"
  },
  {
    name: "Anguilla",
    iso_cca2: "AI"
  },
  {
    name: "Åland Islands",
    iso_cca2: "AX"
  },
  {
    name: "Albania",
    iso_cca2: "AL"
  },
  {
    name: "Andorra",
    iso_cca2: "AD"
  },
  {
    name: "United Arab Emirates",
    iso_cca2: "AE"
  },
  {
    name: "Argentina",
    iso_cca2: "AR"
  },
  {
    name: "Armenia",
    iso_cca2: "AM"
  },
  {
    name: "American Samoa",
    iso_cca2: "AS"
  },
  {
    name: "Antarctica",
    iso_cca2: "AQ"
  },
  {
    name: "French Southern and Antarctic Lands",
    iso_cca2: "TF"
  },
  {
    name: "Antigua and Barbuda",
    iso_cca2: "AG"
  },
  {
    name: "Australia",
    iso_cca2: "AU"
  },
  {
    name: "Austria",
    iso_cca2: "AT"
  },
  {
    name: "Azerbaijan",
    iso_cca2: "AZ"
  },
  {
    name: "Burundi",
    iso_cca2: "BI"
  },
  {
    name: "Belgium",
    iso_cca2: "BE"
  },
  {
    name: "Benin",
    iso_cca2: "BJ"
  },
  {
    name: "Burkina Faso",
    iso_cca2: "BF"
  },
  {
    name: "Bangladesh",
    iso_cca2: "BD"
  },
  {
    name: "Bulgaria",
    iso_cca2: "BG"
  },
  {
    name: "Bahrain",
    iso_cca2: "BH"
  },
  {
    name: "Bahamas",
    iso_cca2: "BS"
  },
  {
    name: "Bosnia and Herzegovina",
    iso_cca2: "BA"
  },
  {
    name: "Saint Barthélemy",
    iso_cca2: "BL"
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    iso_cca2: "SH"
  },
  {
    name: "Belarus",
    iso_cca2: "BY"
  },
  {
    name: "Belize",
    iso_cca2: "BZ"
  },
  {
    name: "Bermuda",
    iso_cca2: "BM"
  },
  {
    name: "Bolivia",
    iso_cca2: "BO"
  },
  {
    name: "Caribbean Netherlands",
    iso_cca2: "BQ"
  },
  {
    name: "Brazil",
    iso_cca2: "BR"
  },
  {
    name: "Barbados",
    iso_cca2: "BB"
  },
  {
    name: "Brunei",
    iso_cca2: "BN"
  },
  {
    name: "Bhutan",
    iso_cca2: "BT"
  },
  {
    name: "Bouvet Island",
    iso_cca2: "BV"
  },
  {
    name: "Botswana",
    iso_cca2: "BW"
  },
  {
    name: "Central African Republic",
    iso_cca2: "CF"
  },
  {
    name: "Canada",
    iso_cca2: "CA"
  },
  {
    name: "Cocos (Keeling) Islands",
    iso_cca2: "CC"
  },
  {
    name: "Switzerland",
    iso_cca2: "CH"
  },
  {
    name: "Chile",
    iso_cca2: "CL"
  },
  {
    name: "China",
    iso_cca2: "CN"
  },
  {
    name: "Ivory Coast",
    iso_cca2: "CI"
  },
  {
    name: "Cameroon",
    iso_cca2: "CM"
  },
  {
    name: "DR Congo",
    iso_cca2: "CD"
  },
  {
    name: "Republic of the Congo",
    iso_cca2: "CG"
  },
  {
    name: "Cook Islands",
    iso_cca2: "CK"
  },
  {
    name: "Colombia",
    iso_cca2: "CO"
  },
  {
    name: "Comoros",
    iso_cca2: "KM"
  },
  {
    name: "Cape Verde",
    iso_cca2: "CV"
  },
  {
    name: "Costa Rica",
    iso_cca2: "CR"
  },
  {
    name: "Cuba",
    iso_cca2: "CU"
  },
  {
    name: "Curaçao",
    iso_cca2: "CW"
  },
  {
    name: "Christmas Island",
    iso_cca2: "CX"
  },
  {
    name: "Cayman Islands",
    iso_cca2: "KY"
  },
  {
    name: "Cyprus",
    iso_cca2: "CY"
  },
  {
    name: "Czechia",
    iso_cca2: "CZ"
  },
  {
    name: "Germany",
    iso_cca2: "DE"
  },
  {
    name: "Djibouti",
    iso_cca2: "DJ"
  },
  {
    name: "Dominica",
    iso_cca2: "DM"
  },
  {
    name: "Denmark",
    iso_cca2: "DK"
  },
  {
    name: "Dominican Republic",
    iso_cca2: "DO"
  },
  {
    name: "Algeria",
    iso_cca2: "DZ"
  },
  {
    name: "Ecuador",
    iso_cca2: "EC"
  },
  {
    name: "Egypt",
    iso_cca2: "EG"
  },
  {
    name: "Eritrea",
    iso_cca2: "ER"
  },
  {
    name: "Western Sahara",
    iso_cca2: "EH"
  },
  {
    name: "Spain",
    iso_cca2: "ES"
  },
  {
    name: "Estonia",
    iso_cca2: "EE"
  },
  {
    name: "Ethiopia",
    iso_cca2: "ET"
  },
  {
    name: "Finland",
    iso_cca2: "FI"
  },
  {
    name: "Fiji",
    iso_cca2: "FJ"
  },
  {
    name: "Falkland Islands",
    iso_cca2: "FK"
  },
  {
    name: "France",
    iso_cca2: "FR"
  },
  {
    name: "Faroe Islands",
    iso_cca2: "FO"
  },
  {
    name: "Micronesia",
    iso_cca2: "FM"
  },
  {
    name: "Gabon",
    iso_cca2: "GA"
  },
  {
    name: "United Kingdom",
    iso_cca2: "GB"
  },
  {
    name: "Georgia",
    iso_cca2: "GE"
  },
  {
    name: "Guernsey",
    iso_cca2: "GG"
  },
  {
    name: "Ghana",
    iso_cca2: "GH"
  },
  {
    name: "Gibraltar",
    iso_cca2: "GI"
  },
  {
    name: "Guinea",
    iso_cca2: "GN"
  },
  {
    name: "Guadeloupe",
    iso_cca2: "GP"
  },
  {
    name: "Gambia",
    iso_cca2: "GM"
  },
  {
    name: "Guinea-Bissau",
    iso_cca2: "GW"
  },
  {
    name: "Equatorial Guinea",
    iso_cca2: "GQ"
  },
  {
    name: "Greece",
    iso_cca2: "GR"
  },
  {
    name: "Grenada",
    iso_cca2: "GD"
  },
  {
    name: "Greenland",
    iso_cca2: "GL"
  },
  {
    name: "Guatemala",
    iso_cca2: "GT"
  },
  {
    name: "French Guiana",
    iso_cca2: "GF"
  },
  {
    name: "Guam",
    iso_cca2: "GU"
  },
  {
    name: "Guyana",
    iso_cca2: "GY"
  },
  {
    name: "Hong Kong",
    iso_cca2: "HK"
  },
  {
    name: "Heard Island and McDonald Islands",
    iso_cca2: "HM"
  },
  {
    name: "Honduras",
    iso_cca2: "HN"
  },
  {
    name: "Croatia",
    iso_cca2: "HR"
  },
  {
    name: "Haiti",
    iso_cca2: "HT"
  },
  {
    name: "Hungary",
    iso_cca2: "HU"
  },
  {
    name: "Indonesia",
    iso_cca2: "ID"
  },
  {
    name: "Isle of Man",
    iso_cca2: "IM"
  },
  {
    name: "India",
    iso_cca2: "IN"
  },
  {
    name: "British Indian Ocean Territory",
    iso_cca2: "IO"
  },
  {
    name: "Ireland",
    iso_cca2: "IE"
  },
  {
    name: "Iran",
    iso_cca2: "IR"
  },
  {
    name: "Iraq",
    iso_cca2: "IQ"
  },
  {
    name: "Iceland",
    iso_cca2: "IS"
  },
  {
    name: "Israel",
    iso_cca2: "IL"
  },
  {
    name: "Italy",
    iso_cca2: "IT"
  },
  {
    name: "Jamaica",
    iso_cca2: "JM"
  },
  {
    name: "Jersey",
    iso_cca2: "JE"
  },
  {
    name: "Jordan",
    iso_cca2: "JO"
  },
  {
    name: "Japan",
    iso_cca2: "JP"
  },
  {
    name: "Kazakhstan",
    iso_cca2: "KZ"
  },
  {
    name: "Kenya",
    iso_cca2: "KE"
  },
  {
    name: "Kyrgyzstan",
    iso_cca2: "KG"
  },
  {
    name: "Cambodia",
    iso_cca2: "KH"
  },
  {
    name: "Kiribati",
    iso_cca2: "KI"
  },
  {
    name: "Saint Kitts and Nevis",
    iso_cca2: "KN"
  },
  {
    name: "South Korea",
    iso_cca2: "KR"
  },
  {
    name: "Kosovo",
    iso_cca2: "XK"
  },
  {
    name: "Kuwait",
    iso_cca2: "KW"
  },
  {
    name: "Laos",
    iso_cca2: "LA"
  },
  {
    name: "Lebanon",
    iso_cca2: "LB"
  },
  {
    name: "Liberia",
    iso_cca2: "LR"
  },
  {
    name: "Libya",
    iso_cca2: "LY"
  },
  {
    name: "Saint Lucia",
    iso_cca2: "LC"
  },
  {
    name: "Liechtenstein",
    iso_cca2: "LI"
  },
  {
    name: "Sri Lanka",
    iso_cca2: "LK"
  },
  {
    name: "Lesotho",
    iso_cca2: "LS"
  },
  {
    name: "Lithuania",
    iso_cca2: "LT"
  },
  {
    name: "Luxembourg",
    iso_cca2: "LU"
  },
  {
    name: "Latvia",
    iso_cca2: "LV"
  },
  {
    name: "Macau",
    iso_cca2: "MO"
  },
  {
    name: "Saint Martin",
    iso_cca2: "MF"
  },
  {
    name: "Morocco",
    iso_cca2: "MA"
  },
  {
    name: "Monaco",
    iso_cca2: "MC"
  },
  {
    name: "Moldova",
    iso_cca2: "MD"
  },
  {
    name: "Madagascar",
    iso_cca2: "MG"
  },
  {
    name: "Maldives",
    iso_cca2: "MV"
  },
  {
    name: "Mexico",
    iso_cca2: "MX"
  },
  {
    name: "Marshall Islands",
    iso_cca2: "MH"
  },
  {
    name: "North Macedonia",
    iso_cca2: "MK"
  },
  {
    name: "Mali",
    iso_cca2: "ML"
  },
  {
    name: "Malta",
    iso_cca2: "MT"
  },
  {
    name: "Myanmar",
    iso_cca2: "MM"
  },
  {
    name: "Montenegro",
    iso_cca2: "ME"
  },
  {
    name: "Mongolia",
    iso_cca2: "MN"
  },
  {
    name: "Northern Mariana Islands",
    iso_cca2: "MP"
  },
  {
    name: "Mozambique",
    iso_cca2: "MZ"
  },
  {
    name: "Mauritania",
    iso_cca2: "MR"
  },
  {
    name: "Montserrat",
    iso_cca2: "MS"
  },
  {
    name: "Martinique",
    iso_cca2: "MQ"
  },
  {
    name: "Mauritius",
    iso_cca2: "MU"
  },
  {
    name: "Malawi",
    iso_cca2: "MW"
  },
  {
    name: "Malaysia",
    iso_cca2: "MY"
  },
  {
    name: "Mayotte",
    iso_cca2: "YT"
  },
  {
    name: "Namibia",
    iso_cca2: "NA"
  },
  {
    name: "New Caledonia",
    iso_cca2: "NC"
  },
  {
    name: "Niger",
    iso_cca2: "NE"
  },
  {
    name: "Norfolk Island",
    iso_cca2: "NF"
  },
  {
    name: "Nigeria",
    iso_cca2: "NG"
  },
  {
    name: "Nicaragua",
    iso_cca2: "NI"
  },
  {
    name: "Niue",
    iso_cca2: "NU"
  },
  {
    name: "Netherlands",
    iso_cca2: "NL"
  },
  {
    name: "Norway",
    iso_cca2: "NO"
  },
  {
    name: "Nepal",
    iso_cca2: "NP"
  },
  {
    name: "Nauru",
    iso_cca2: "NR"
  },
  {
    name: "New Zealand",
    iso_cca2: "NZ"
  },
  {
    name: "Oman",
    iso_cca2: "OM"
  },
  {
    name: "Pakistan",
    iso_cca2: "PK"
  },
  {
    name: "Panama",
    iso_cca2: "PA"
  },
  {
    name: "Pitcairn Islands",
    iso_cca2: "PN"
  },
  {
    name: "Peru",
    iso_cca2: "PE"
  },
  {
    name: "Philippines",
    iso_cca2: "PH"
  },
  {
    name: "Palau",
    iso_cca2: "PW"
  },
  {
    name: "Papua New Guinea",
    iso_cca2: "PG"
  },
  {
    name: "Poland",
    iso_cca2: "PL"
  },
  {
    name: "Puerto Rico",
    iso_cca2: "PR"
  },
  {
    name: "North Korea",
    iso_cca2: "KP"
  },
  {
    name: "Portugal",
    iso_cca2: "PT"
  },
  {
    name: "Paraguay",
    iso_cca2: "PY"
  },
  {
    name: "Palestine",
    iso_cca2: "PS"
  },
  {
    name: "French Polynesia",
    iso_cca2: "PF"
  },
  {
    name: "Qatar",
    iso_cca2: "QA"
  },
  {
    name: "Réunion",
    iso_cca2: "RE"
  },
  {
    name: "Romania",
    iso_cca2: "RO"
  },
  {
    name: "Russia",
    iso_cca2: "RU"
  },
  {
    name: "Rwanda",
    iso_cca2: "RW"
  },
  {
    name: "Saudi Arabia",
    iso_cca2: "SA"
  },
  {
    name: "Sudan",
    iso_cca2: "SD"
  },
  {
    name: "Senegal",
    iso_cca2: "SN"
  },
  {
    name: "Singapore",
    iso_cca2: "SG"
  },
  {
    name: "South Georgia",
    iso_cca2: "GS"
  },
  {
    name: "Svalbard and Jan Mayen",
    iso_cca2: "SJ"
  },
  {
    name: "Solomon Islands",
    iso_cca2: "SB"
  },
  {
    name: "Sierra Leone",
    iso_cca2: "SL"
  },
  {
    name: "El Salvador",
    iso_cca2: "SV"
  },
  {
    name: "San Marino",
    iso_cca2: "SM"
  },
  {
    name: "Somalia",
    iso_cca2: "SO"
  },
  {
    name: "Saint Pierre and Miquelon",
    iso_cca2: "PM"
  },
  {
    name: "Serbia",
    iso_cca2: "RS"
  },
  {
    name: "South Sudan",
    iso_cca2: "SS"
  },
  {
    name: "São Tomé and Príncipe",
    iso_cca2: "ST"
  },
  {
    name: "Suriname",
    iso_cca2: "SR"
  },
  {
    name: "Slovakia",
    iso_cca2: "SK"
  },
  {
    name: "Slovenia",
    iso_cca2: "SI"
  },
  {
    name: "Sweden",
    iso_cca2: "SE"
  },
  {
    name: "Eswatini",
    iso_cca2: "SZ"
  },
  {
    name: "Sint Maarten",
    iso_cca2: "SX"
  },
  {
    name: "Seychelles",
    iso_cca2: "SC"
  },
  {
    name: "Syria",
    iso_cca2: "SY"
  },
  {
    name: "Turks and Caicos Islands",
    iso_cca2: "TC"
  },
  {
    name: "Chad",
    iso_cca2: "TD"
  },
  {
    name: "Togo",
    iso_cca2: "TG"
  },
  {
    name: "Thailand",
    iso_cca2: "TH"
  },
  {
    name: "Tajikistan",
    iso_cca2: "TJ"
  },
  {
    name: "Tokelau",
    iso_cca2: "TK"
  },
  {
    name: "Turkmenistan",
    iso_cca2: "TM"
  },
  {
    name: "Timor-Leste",
    iso_cca2: "TL"
  },
  {
    name: "Tonga",
    iso_cca2: "TO"
  },
  {
    name: "Trinidad and Tobago",
    iso_cca2: "TT"
  },
  {
    name: "Tunisia",
    iso_cca2: "TN"
  },
  {
    name: "Turkey",
    iso_cca2: "TR"
  },
  {
    name: "Tuvalu",
    iso_cca2: "TV"
  },
  {
    name: "Taiwan",
    iso_cca2: "TW"
  },
  {
    name: "Tanzania",
    iso_cca2: "TZ"
  },
  {
    name: "Uganda",
    iso_cca2: "UG"
  },
  {
    name: "Ukraine",
    iso_cca2: "UA"
  },
  {
    name: "United States Minor Outlying Islands",
    iso_cca2: "UM"
  },
  {
    name: "Uruguay",
    iso_cca2: "UY"
  },
  {
    name: "United States",
    iso_cca2: "US"
  },
  {
    name: "Uzbekistan",
    iso_cca2: "UZ"
  },
  {
    name: "Vatican City",
    iso_cca2: "VA"
  },
  {
    name: "Saint Vincent and the Grenadines",
    iso_cca2: "VC"
  },
  {
    name: "Venezuela",
    iso_cca2: "VE"
  },
  {
    name: "British Virgin Islands",
    iso_cca2: "VG"
  },
  {
    name: "United States Virgin Islands",
    iso_cca2: "VI"
  },
  {
    name: "Vietnam",
    iso_cca2: "VN"
  },
  {
    name: "Vanuatu",
    iso_cca2: "VU"
  },
  {
    name: "Wallis and Futuna",
    iso_cca2: "WF"
  },
  {
    name: "Samoa",
    iso_cca2: "WS"
  },
  {
    name: "Yemen",
    iso_cca2: "YE"
  },
  {
    name: "South Africa",
    iso_cca2: "ZA"
  },
  {
    name: "Zambia",
    iso_cca2: "ZM"
  },
  {
    name: "Zimbabwe",
    iso_cca2: "ZW"
  }
];
var YI = {}, MC = {}, ZI = {}, Lm = {}, w$ = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Lm, "__esModule", { value: !0 });
Lm.DEFAULT_FUNCTION_CALL_GAS = void 0;
const v$ = w$(Ka);
Lm.DEFAULT_FUNCTION_CALL_GAS = new v$.default("30000000000000");
var JI = {}, $m = {};
Object.defineProperty($m, "__esModule", { value: !0 });
$m.logWarning = void 0;
function S$(...e) {
  process.env.NEAR_NO_LOGS || console.warn(...e);
}
$m.logWarning = S$;
var so = {}, bo = {}, Wm = {};
Object.defineProperty(Wm, "__esModule", { value: !0 });
Wm.Assignable = void 0;
class E$ {
  constructor(t) {
    Object.keys(t).map((n) => {
      this[n] = t[n];
    });
  }
}
Wm.Assignable = E$;
var oa = {};
Object.defineProperty(oa, "__esModule", { value: !0 });
oa.ErrorContext = oa.TypedError = oa.ArgumentTypeError = oa.PositionalArgsError = void 0;
class A$ extends Error {
  constructor() {
    super("Contract method calls expect named arguments wrapped in object, e.g. { argName1: argValue1, argName2: argValue2 }");
  }
}
oa.PositionalArgsError = A$;
class I$ extends Error {
  constructor(t, n, r) {
    super(`Expected ${n} for '${t}' argument, but got '${JSON.stringify(r)}'`);
  }
}
oa.ArgumentTypeError = I$;
class k$ extends Error {
  constructor(t, n, r) {
    super(t), this.type = n || "UntypedError", this.context = r;
  }
}
oa.TypedError = k$;
class T$ {
  constructor(t) {
    this.transactionHash = t;
  }
}
oa.ErrorContext = T$;
var OC = {}, PC = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.IdType = void 0, function(t) {
    t.Transaction = "transaction", t.Receipt = "receipt";
  }(e.IdType || (e.IdType = {}));
})(PC);
var BC = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.FinalExecutionStatusBasic = e.ExecutionStatusBasic = void 0, function(t) {
    t.Unknown = "Unknown", t.Pending = "Pending", t.Failure = "Failure";
  }(e.ExecutionStatusBasic || (e.ExecutionStatusBasic = {})), function(t) {
    t.NotStarted = "NotStarted", t.Started = "Started", t.Failure = "Failure";
  }(e.FinalExecutionStatusBasic || (e.FinalExecutionStatusBasic = {}));
})(BC);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.FinalExecutionStatusBasic = e.ExecutionStatusBasic = e.IdType = void 0;
  var t = PC;
  Object.defineProperty(e, "IdType", { enumerable: !0, get: function() {
    return t.IdType;
  } });
  var n = BC;
  Object.defineProperty(e, "ExecutionStatusBasic", { enumerable: !0, get: function() {
    return n.ExecutionStatusBasic;
  } }), Object.defineProperty(e, "FinalExecutionStatusBasic", { enumerable: !0, get: function() {
    return n.FinalExecutionStatusBasic;
  } });
})(OC);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(Wm, e), n(oa, e), n(OC, e);
})(bo);
var CC = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(_, function() {
    /*!
     * mustache.js - Logic-less {{mustache}} templates with JavaScript
     * http://github.com/janl/mustache.js
     */
    var n = Object.prototype.toString, r = Array.isArray || function(S) {
      return n.call(S) === "[object Array]";
    };
    function i(M) {
      return typeof M == "function";
    }
    function o(M) {
      return r(M) ? "array" : typeof M;
    }
    function a(M) {
      return M.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    }
    function s(M, S) {
      return M != null && typeof M == "object" && S in M;
    }
    function c(M, S) {
      return M != null && typeof M != "object" && M.hasOwnProperty && M.hasOwnProperty(S);
    }
    var l = RegExp.prototype.test;
    function u(M, S) {
      return l.call(M, S);
    }
    var f = /\S/;
    function d(M) {
      return !u(f, M);
    }
    var h = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "/": "&#x2F;",
      "`": "&#x60;",
      "=": "&#x3D;"
    };
    function g(M) {
      return String(M).replace(/[&<>"'`=\/]/g, function(p) {
        return h[p];
      });
    }
    var w = /\s*/, b = /\s+/, I = /\s*=/, A = /\s*\}/, x = /#|\^|\/|>|\{|&|=|!/;
    function N(M, S) {
      if (!M)
        return [];
      var p = !1, y = [], v = [], E = [], B = !1, F = !1, q = "", U = 0;
      function m() {
        if (B && !F)
          for (; E.length; )
            delete v[E.pop()];
        else
          E = [];
        B = !1, F = !1;
      }
      var D, Y, Q;
      function G(Nt) {
        if (typeof Nt == "string" && (Nt = Nt.split(b, 2)), !r(Nt) || Nt.length !== 2)
          throw new Error("Invalid tags: " + Nt);
        D = new RegExp(a(Nt[0]) + "\\s*"), Y = new RegExp("\\s*" + a(Nt[1])), Q = new RegExp("\\s*" + a("}" + Nt[1]));
      }
      G(S || z.tags);
      for (var he = new W(M), se, _e, Me, Pe, Be, at; !he.eos(); ) {
        if (se = he.pos, Me = he.scanUntil(D), Me)
          for (var Fe = 0, Re = Me.length; Fe < Re; ++Fe)
            Pe = Me.charAt(Fe), d(Pe) ? (E.push(v.length), q += Pe) : (F = !0, p = !0, q += " "), v.push(["text", Pe, se, se + 1]), se += 1, Pe === `
` && (m(), q = "", U = 0, p = !1);
        if (!he.scan(D))
          break;
        if (B = !0, _e = he.scan(x) || "name", he.scan(w), _e === "=" ? (Me = he.scanUntil(I), he.scan(I), he.scanUntil(Y)) : _e === "{" ? (Me = he.scanUntil(Q), he.scan(A), he.scanUntil(Y), _e = "&") : Me = he.scanUntil(Y), !he.scan(Y))
          throw new Error("Unclosed tag at " + he.pos);
        if (_e == ">" ? Be = [_e, Me, se, he.pos, q, U, p] : Be = [_e, Me, se, he.pos], U++, v.push(Be), _e === "#" || _e === "^")
          y.push(Be);
        else if (_e === "/") {
          if (at = y.pop(), !at)
            throw new Error('Unopened section "' + Me + '" at ' + se);
          if (at[1] !== Me)
            throw new Error('Unclosed section "' + at[1] + '" at ' + se);
        } else
          _e === "name" || _e === "{" || _e === "&" ? F = !0 : _e === "=" && G(Me);
      }
      if (m(), at = y.pop(), at)
        throw new Error('Unclosed section "' + at[1] + '" at ' + he.pos);
      return K(j(v));
    }
    function j(M) {
      for (var S = [], p, y, v = 0, E = M.length; v < E; ++v)
        p = M[v], p && (p[0] === "text" && y && y[0] === "text" ? (y[1] += p[1], y[3] = p[3]) : (S.push(p), y = p));
      return S;
    }
    function K(M) {
      for (var S = [], p = S, y = [], v, E, B = 0, F = M.length; B < F; ++B)
        switch (v = M[B], v[0]) {
          case "#":
          case "^":
            p.push(v), y.push(v), p = v[4] = [];
            break;
          case "/":
            E = y.pop(), E[5] = v[2], p = y.length > 0 ? y[y.length - 1][4] : S;
            break;
          default:
            p.push(v);
        }
      return S;
    }
    function W(M) {
      this.string = M, this.tail = M, this.pos = 0;
    }
    W.prototype.eos = function() {
      return this.tail === "";
    }, W.prototype.scan = function(S) {
      var p = this.tail.match(S);
      if (!p || p.index !== 0)
        return "";
      var y = p[0];
      return this.tail = this.tail.substring(y.length), this.pos += y.length, y;
    }, W.prototype.scanUntil = function(S) {
      var p = this.tail.search(S), y;
      switch (p) {
        case -1:
          y = this.tail, this.tail = "";
          break;
        case 0:
          y = "";
          break;
        default:
          y = this.tail.substring(0, p), this.tail = this.tail.substring(p);
      }
      return this.pos += y.length, y;
    };
    function O(M, S) {
      this.view = M, this.cache = { ".": this.view }, this.parent = S;
    }
    O.prototype.push = function(S) {
      return new O(S, this);
    }, O.prototype.lookup = function(S) {
      var p = this.cache, y;
      if (p.hasOwnProperty(S))
        y = p[S];
      else {
        for (var v = this, E, B, F, q = !1; v; ) {
          if (S.indexOf(".") > 0)
            for (E = v.view, B = S.split("."), F = 0; E != null && F < B.length; )
              F === B.length - 1 && (q = s(E, B[F]) || c(E, B[F])), E = E[B[F++]];
          else
            E = v.view[S], q = s(v.view, S);
          if (q) {
            y = E;
            break;
          }
          v = v.parent;
        }
        p[S] = y;
      }
      return i(y) && (y = y.call(this.view)), y;
    };
    function k() {
      this.templateCache = {
        _cache: {},
        set: function(S, p) {
          this._cache[S] = p;
        },
        get: function(S) {
          return this._cache[S];
        },
        clear: function() {
          this._cache = {};
        }
      };
    }
    k.prototype.clearCache = function() {
      typeof this.templateCache < "u" && this.templateCache.clear();
    }, k.prototype.parse = function(S, p) {
      var y = this.templateCache, v = S + ":" + (p || z.tags).join(":"), E = typeof y < "u", B = E ? y.get(v) : void 0;
      return B == null && (B = N(S, p), E && y.set(v, B)), B;
    }, k.prototype.render = function(S, p, y, v) {
      var E = this.getConfigTags(v), B = this.parse(S, E), F = p instanceof O ? p : new O(p, void 0);
      return this.renderTokens(B, F, y, S, v);
    }, k.prototype.renderTokens = function(S, p, y, v, E) {
      for (var B = "", F, q, U, m = 0, D = S.length; m < D; ++m)
        U = void 0, F = S[m], q = F[0], q === "#" ? U = this.renderSection(F, p, y, v, E) : q === "^" ? U = this.renderInverted(F, p, y, v, E) : q === ">" ? U = this.renderPartial(F, p, y, E) : q === "&" ? U = this.unescapedValue(F, p) : q === "name" ? U = this.escapedValue(F, p, E) : q === "text" && (U = this.rawValue(F)), U !== void 0 && (B += U);
      return B;
    }, k.prototype.renderSection = function(S, p, y, v, E) {
      var B = this, F = "", q = p.lookup(S[1]);
      function U(Y) {
        return B.render(Y, p, y, E);
      }
      if (q) {
        if (r(q))
          for (var m = 0, D = q.length; m < D; ++m)
            F += this.renderTokens(S[4], p.push(q[m]), y, v, E);
        else if (typeof q == "object" || typeof q == "string" || typeof q == "number")
          F += this.renderTokens(S[4], p.push(q), y, v, E);
        else if (i(q)) {
          if (typeof v != "string")
            throw new Error("Cannot use higher-order sections without the original template");
          q = q.call(p.view, v.slice(S[3], S[5]), U), q != null && (F += q);
        } else
          F += this.renderTokens(S[4], p, y, v, E);
        return F;
      }
    }, k.prototype.renderInverted = function(S, p, y, v, E) {
      var B = p.lookup(S[1]);
      if (!B || r(B) && B.length === 0)
        return this.renderTokens(S[4], p, y, v, E);
    }, k.prototype.indentPartial = function(S, p, y) {
      for (var v = p.replace(/[^ \t]/g, ""), E = S.split(`
`), B = 0; B < E.length; B++)
        E[B].length && (B > 0 || !y) && (E[B] = v + E[B]);
      return E.join(`
`);
    }, k.prototype.renderPartial = function(S, p, y, v) {
      if (y) {
        var E = this.getConfigTags(v), B = i(y) ? y(S[1]) : y[S[1]];
        if (B != null) {
          var F = S[6], q = S[5], U = S[4], m = B;
          q == 0 && U && (m = this.indentPartial(B, U, F));
          var D = this.parse(m, E);
          return this.renderTokens(D, p, y, m, v);
        }
      }
    }, k.prototype.unescapedValue = function(S, p) {
      var y = p.lookup(S[1]);
      if (y != null)
        return y;
    }, k.prototype.escapedValue = function(S, p, y) {
      var v = this.getConfigEscape(y) || z.escape, E = p.lookup(S[1]);
      if (E != null)
        return typeof E == "number" && v === z.escape ? String(E) : v(E);
    }, k.prototype.rawValue = function(S) {
      return S[1];
    }, k.prototype.getConfigTags = function(S) {
      return r(S) ? S : S && typeof S == "object" ? S.tags : void 0;
    }, k.prototype.getConfigEscape = function(S) {
      if (S && typeof S == "object" && !r(S))
        return S.escape;
    };
    var z = {
      name: "mustache.js",
      version: "4.2.0",
      tags: ["{{", "}}"],
      clearCache: void 0,
      escape: void 0,
      parse: void 0,
      render: void 0,
      Scanner: void 0,
      Context: void 0,
      Writer: void 0,
      /**
       * Allows a user to override the default caching strategy, by providing an
       * object with set, get and clear methods. This can also be used to disable
       * the cache by setting it to the literal `undefined`.
       */
      set templateCache(M) {
        C.templateCache = M;
      },
      /**
       * Gets the default or overridden caching object from the default writer.
       */
      get templateCache() {
        return C.templateCache;
      }
    }, C = new k();
    return z.clearCache = function() {
      return C.clearCache();
    }, z.parse = function(S, p) {
      return C.parse(S, p);
    }, z.render = function(S, p, y, v) {
      if (typeof S != "string")
        throw new TypeError('Invalid template! Template should be a "string" but "' + o(S) + '" was given as the first argument for mustache#render(template, view, partials)');
      return C.render(S, p, y, v);
    }, z.escape = g, z.Scanner = W, z.Context = O, z.Writer = k, z;
  });
})(CC);
var x$ = CC.exports, XI = {};
(function(e) {
  var t = _ && _.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.parseNearAmount = e.formatNearAmount = e.NEAR_NOMINATION = e.NEAR_NOMINATION_EXP = void 0;
  const n = t(Ka);
  e.NEAR_NOMINATION_EXP = 24, e.NEAR_NOMINATION = new n.default("10", 10).pow(new n.default(e.NEAR_NOMINATION_EXP, 10));
  const r = [], i = new n.default(10);
  for (let f = 0, d = new n.default(5); f < e.NEAR_NOMINATION_EXP; f++, d = d.mul(i))
    r[f] = d;
  function o(f, d = e.NEAR_NOMINATION_EXP) {
    const h = new n.default(f, 10);
    if (d !== e.NEAR_NOMINATION_EXP) {
      const b = e.NEAR_NOMINATION_EXP - d - 1;
      b > 0 && h.iadd(r[b]);
    }
    f = h.toString();
    const g = f.substring(0, f.length - e.NEAR_NOMINATION_EXP) || "0", w = f.substring(f.length - e.NEAR_NOMINATION_EXP).padStart(e.NEAR_NOMINATION_EXP, "0").substring(0, d);
    return c(`${u(g)}.${w}`);
  }
  e.formatNearAmount = o;
  function a(f) {
    if (!f)
      return null;
    f = s(f);
    const d = f.split("."), h = d[0], g = d[1] || "";
    if (d.length > 2 || g.length > e.NEAR_NOMINATION_EXP)
      throw new Error(`Cannot parse '${f}' as NEAR amount`);
    return l(h + g.padEnd(e.NEAR_NOMINATION_EXP, "0"));
  }
  e.parseNearAmount = a;
  function s(f) {
    return f.replace(/,/g, "").trim();
  }
  function c(f) {
    return f.replace(/\.?0*$/, "");
  }
  function l(f) {
    return f = f.replace(/^0+/, ""), f === "" ? "0" : f;
  }
  function u(f) {
    const d = /(-?\d+)(\d{3})/;
    for (; d.test(f); )
      f = f.replace(d, "$1,$2");
    return f;
  }
})(XI);
const M$ = "Exceeded the maximum amount of gas allowed to burn per contract", O$ = "Method name is empty", P$ = "Wasmer compilation error: {{msg}}", B$ = "Smart contract panicked: {{panic_msg}}", C$ = "Error creating Wasm memory", D$ = "Exceeded the prepaid gas", R$ = "Method name is not valid UTF8 string", N$ = "String encoding is bad UTF-16 sequence", j$ = "WebAssembly trap: {{msg}}", U$ = "Gas instrumentation failed or contract has denied instructions.", z$ = "{{promise_idx}} does not correspond to existing promises", F$ = "Accessed invalid promise result index: {{result_idx}}", L$ = "Error happened while deserializing the module", $$ = "Contract method is not found", W$ = "Accessed invalid register id: {{register_id}}", K$ = "VM Logic returned an invalid receipt index: {{receipt_index}}", V$ = "Method name is empty in contract call", q$ = "Returning joint promise is currently prohibited", H$ = "Stack instrumentation failed", G$ = "Cannot find contract code for account {{account_id}}", Y$ = "Invalid method signature", Z$ = "Integer overflow happened during contract execution", J$ = "MemoryAccessViolation", X$ = "Iterator index {{iterator_index}} does not exist", Q$ = "Iterator {{iterator_index}} was invalidated after its creation by performing a mutable operation on trie", e7 = "VM Logic returned an invalid account id", t7 = "Error happened while serializing the module", n7 = "Actions can only be appended to non-joint promise.", r7 = "Internal memory declaration has been found in the module", i7 = "Error happened during instantiation", o7 = "{{method_name}} is not allowed in view calls", a7 = "VM Logic returned an invalid method name", s7 = "String encoding is bad UTF-8 sequence", c7 = "Exceeded the account balance", u7 = "Wasm contract link error: {{msg}}", l7 = "VM Logic provided an invalid public key", f7 = "Actor {{actor_id}} doesn't have permission to account {{account_id}} to complete the action", d7 = "The account {{account_id}} wouldn't have enough balance to cover storage, required to have {{amount}} yoctoNEAR more", h7 = "Wrong AccessKey used for transaction: transaction is sent to receiver_id={{tx_receiver}}, but is signed with function call access key that restricted to only use with receiver_id={{ak_receiver}}. Either change receiver_id in your transaction or switch to use a FullAccessKey.", p7 = "Transaction gas or balance cost is too high", y7 = "Transaction is not signed with the given public key", g7 = `Signer "{{account_id}}" doesn't have access key with the given public_key {{public_key}}`, b7 = "Sender {{signer_id}} does not have enough balance {{#formatNear}}{{balance}}{{/formatNear}} for operation costing {{#formatNear}}{{cost}}{{/formatNear}}", m7 = "Access Key {account_id}:{public_key} does not have enough balance {{#formatNear}}{{allowance}}{{/formatNear}} for transaction costing {{#formatNear}}{{cost}}{{/formatNear}}", _7 = "Transaction has expired", w7 = "Account {{account_id}} is staking and can not be deleted", v7 = "Signer {{signer_id}} does not exist", S7 = "Account {{account_id}} tried to stake {{#formatNear}}{{stake}}{{/formatNear}}, but has staked {{#formatNear}}{{locked}}{{/formatNear}} and only has {{#formatNear}}{{balance}}{{/formatNear}}", E7 = "The public key {{public_key}} is already used for an existing access key", A7 = "Invalid signer account ID {{signer_id}} according to requirements", I7 = "The new account_id {{account_id}} can't be created by {{predecessor_id}}", k7 = "The transaction contains more then one action, but it was signed with an access key which allows transaction to apply only one specific action. To apply more then one actions TX must be signed with a full access key", T7 = "Account {{account_id}} is not yet staked, but tried to unstake", x7 = "Transaction nonce {{tx_nonce}} must be larger than nonce of the used access key {{ak_nonce}}", M7 = "Can't create a new account {{account_id}}, because it already exists", O7 = "Transaction parent block hash doesn't belong to the current chain", P7 = "Can't complete the action because account {{account_id}} doesn't exist", B7 = "Transaction method name {{method_name}} isn't allowed by the access key", C7 = "Account {{account_id}} can't be deleted. It has {{#formatNear}}{{balance}}{{/formatNear}}, which is enough to cover the rent", D7 = "Account {{account_id}} can't be deleted. It has {{#formatNear}}{{balance}}{{/formatNear}}, which is enough to cover it's storage", R7 = "Invalid receiver account ID {{receiver_id}} according to requirements", N7 = "Account {{account_id}} tries to remove an access key that doesn't exist", j7 = "Timeout exceeded", U7 = "Connection closed", z7 = {
  GasLimitExceeded: M$,
  MethodEmptyName: O$,
  WasmerCompileError: P$,
  GuestPanic: B$,
  Memory: C$,
  GasExceeded: D$,
  MethodUTF8Error: R$,
  BadUTF16: N$,
  WasmTrap: j$,
  GasInstrumentation: U$,
  InvalidPromiseIndex: z$,
  InvalidPromiseResultIndex: F$,
  Deserialization: L$,
  MethodNotFound: $$,
  InvalidRegisterId: W$,
  InvalidReceiptIndex: K$,
  EmptyMethodName: V$,
  CannotReturnJointPromise: q$,
  StackHeightInstrumentation: H$,
  CodeDoesNotExist: G$,
  MethodInvalidSignature: Y$,
  IntegerOverflow: Z$,
  MemoryAccessViolation: J$,
  InvalidIteratorIndex: X$,
  IteratorWasInvalidated: Q$,
  InvalidAccountId: e7,
  Serialization: t7,
  CannotAppendActionToJointPromise: n7,
  InternalMemoryDeclared: r7,
  Instantiate: i7,
  ProhibitedInView: o7,
  InvalidMethodName: a7,
  BadUTF8: s7,
  BalanceExceeded: c7,
  LinkError: u7,
  InvalidPublicKey: l7,
  ActorNoPermission: f7,
  LackBalanceForState: d7,
  ReceiverMismatch: h7,
  CostOverflow: p7,
  InvalidSignature: y7,
  AccessKeyNotFound: g7,
  NotEnoughBalance: b7,
  NotEnoughAllowance: m7,
  Expired: _7,
  DeleteAccountStaking: w7,
  SignerDoesNotExist: v7,
  TriesToStake: S7,
  AddKeyAlreadyExists: E7,
  InvalidSigner: A7,
  CreateAccountNotAllowed: I7,
  RequiresFullAccess: k7,
  TriesToUnstake: T7,
  InvalidNonce: x7,
  AccountAlreadyExists: M7,
  InvalidChain: O7,
  AccountDoesNotExist: P7,
  MethodNameMismatch: B7,
  DeleteAccountHasRent: C7,
  DeleteAccountHasEnoughBalance: D7,
  InvalidReceiver: R7,
  DeleteKeyDoesNotExist: N7,
  Timeout: j7,
  Closed: U7
}, F7 = {
  BadUTF16: {
    name: "BadUTF16",
    subtypes: [],
    props: {}
  },
  BadUTF8: {
    name: "BadUTF8",
    subtypes: [],
    props: {}
  },
  BalanceExceeded: {
    name: "BalanceExceeded",
    subtypes: [],
    props: {}
  },
  BreakpointTrap: {
    name: "BreakpointTrap",
    subtypes: [],
    props: {}
  },
  CacheError: {
    name: "CacheError",
    subtypes: [
      "ReadError",
      "WriteError",
      "DeserializationError",
      "SerializationError"
    ],
    props: {}
  },
  CallIndirectOOB: {
    name: "CallIndirectOOB",
    subtypes: [],
    props: {}
  },
  CannotAppendActionToJointPromise: {
    name: "CannotAppendActionToJointPromise",
    subtypes: [],
    props: {}
  },
  CannotReturnJointPromise: {
    name: "CannotReturnJointPromise",
    subtypes: [],
    props: {}
  },
  CodeDoesNotExist: {
    name: "CodeDoesNotExist",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  CompilationError: {
    name: "CompilationError",
    subtypes: [
      "CodeDoesNotExist",
      "PrepareError",
      "WasmerCompileError"
    ],
    props: {}
  },
  ContractSizeExceeded: {
    name: "ContractSizeExceeded",
    subtypes: [],
    props: {
      limit: "",
      size: ""
    }
  },
  Deprecated: {
    name: "Deprecated",
    subtypes: [],
    props: {
      method_name: ""
    }
  },
  Deserialization: {
    name: "Deserialization",
    subtypes: [],
    props: {}
  },
  DeserializationError: {
    name: "DeserializationError",
    subtypes: [],
    props: {}
  },
  EmptyMethodName: {
    name: "EmptyMethodName",
    subtypes: [],
    props: {}
  },
  FunctionCallError: {
    name: "FunctionCallError",
    subtypes: [
      "CompilationError",
      "LinkError",
      "MethodResolveError",
      "WasmTrap",
      "WasmUnknownError",
      "HostError",
      "EvmError"
    ],
    props: {}
  },
  GasExceeded: {
    name: "GasExceeded",
    subtypes: [],
    props: {}
  },
  GasInstrumentation: {
    name: "GasInstrumentation",
    subtypes: [],
    props: {}
  },
  GasLimitExceeded: {
    name: "GasLimitExceeded",
    subtypes: [],
    props: {}
  },
  GenericTrap: {
    name: "GenericTrap",
    subtypes: [],
    props: {}
  },
  GuestPanic: {
    name: "GuestPanic",
    subtypes: [],
    props: {
      panic_msg: ""
    }
  },
  HostError: {
    name: "HostError",
    subtypes: [
      "BadUTF16",
      "BadUTF8",
      "GasExceeded",
      "GasLimitExceeded",
      "BalanceExceeded",
      "EmptyMethodName",
      "GuestPanic",
      "IntegerOverflow",
      "InvalidPromiseIndex",
      "CannotAppendActionToJointPromise",
      "CannotReturnJointPromise",
      "InvalidPromiseResultIndex",
      "InvalidRegisterId",
      "IteratorWasInvalidated",
      "MemoryAccessViolation",
      "InvalidReceiptIndex",
      "InvalidIteratorIndex",
      "InvalidAccountId",
      "InvalidMethodName",
      "InvalidPublicKey",
      "ProhibitedInView",
      "NumberOfLogsExceeded",
      "KeyLengthExceeded",
      "ValueLengthExceeded",
      "TotalLogLengthExceeded",
      "NumberPromisesExceeded",
      "NumberInputDataDependenciesExceeded",
      "ReturnedValueLengthExceeded",
      "ContractSizeExceeded",
      "Deprecated"
    ],
    props: {}
  },
  IllegalArithmetic: {
    name: "IllegalArithmetic",
    subtypes: [],
    props: {}
  },
  IncorrectCallIndirectSignature: {
    name: "IncorrectCallIndirectSignature",
    subtypes: [],
    props: {}
  },
  Instantiate: {
    name: "Instantiate",
    subtypes: [],
    props: {}
  },
  IntegerOverflow: {
    name: "IntegerOverflow",
    subtypes: [],
    props: {}
  },
  InternalMemoryDeclared: {
    name: "InternalMemoryDeclared",
    subtypes: [],
    props: {}
  },
  InvalidAccountId: {
    name: "InvalidAccountId",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  InvalidIteratorIndex: {
    name: "InvalidIteratorIndex",
    subtypes: [],
    props: {
      iterator_index: ""
    }
  },
  InvalidMethodName: {
    name: "InvalidMethodName",
    subtypes: [],
    props: {}
  },
  InvalidPromiseIndex: {
    name: "InvalidPromiseIndex",
    subtypes: [],
    props: {
      promise_idx: ""
    }
  },
  InvalidPromiseResultIndex: {
    name: "InvalidPromiseResultIndex",
    subtypes: [],
    props: {
      result_idx: ""
    }
  },
  InvalidPublicKey: {
    name: "InvalidPublicKey",
    subtypes: [],
    props: {}
  },
  InvalidReceiptIndex: {
    name: "InvalidReceiptIndex",
    subtypes: [],
    props: {
      receipt_index: ""
    }
  },
  InvalidRegisterId: {
    name: "InvalidRegisterId",
    subtypes: [],
    props: {
      register_id: ""
    }
  },
  IteratorWasInvalidated: {
    name: "IteratorWasInvalidated",
    subtypes: [],
    props: {
      iterator_index: ""
    }
  },
  KeyLengthExceeded: {
    name: "KeyLengthExceeded",
    subtypes: [],
    props: {
      length: "",
      limit: ""
    }
  },
  LinkError: {
    name: "LinkError",
    subtypes: [],
    props: {
      msg: ""
    }
  },
  Memory: {
    name: "Memory",
    subtypes: [],
    props: {}
  },
  MemoryAccessViolation: {
    name: "MemoryAccessViolation",
    subtypes: [],
    props: {}
  },
  MemoryOutOfBounds: {
    name: "MemoryOutOfBounds",
    subtypes: [],
    props: {}
  },
  MethodEmptyName: {
    name: "MethodEmptyName",
    subtypes: [],
    props: {}
  },
  MethodInvalidSignature: {
    name: "MethodInvalidSignature",
    subtypes: [],
    props: {}
  },
  MethodNotFound: {
    name: "MethodNotFound",
    subtypes: [],
    props: {}
  },
  MethodResolveError: {
    name: "MethodResolveError",
    subtypes: [
      "MethodEmptyName",
      "MethodUTF8Error",
      "MethodNotFound",
      "MethodInvalidSignature"
    ],
    props: {}
  },
  MethodUTF8Error: {
    name: "MethodUTF8Error",
    subtypes: [],
    props: {}
  },
  MisalignedAtomicAccess: {
    name: "MisalignedAtomicAccess",
    subtypes: [],
    props: {}
  },
  NumberInputDataDependenciesExceeded: {
    name: "NumberInputDataDependenciesExceeded",
    subtypes: [],
    props: {
      limit: "",
      number_of_input_data_dependencies: ""
    }
  },
  NumberOfLogsExceeded: {
    name: "NumberOfLogsExceeded",
    subtypes: [],
    props: {
      limit: ""
    }
  },
  NumberPromisesExceeded: {
    name: "NumberPromisesExceeded",
    subtypes: [],
    props: {
      limit: "",
      number_of_promises: ""
    }
  },
  PrepareError: {
    name: "PrepareError",
    subtypes: [
      "Serialization",
      "Deserialization",
      "InternalMemoryDeclared",
      "GasInstrumentation",
      "StackHeightInstrumentation",
      "Instantiate",
      "Memory"
    ],
    props: {}
  },
  ProhibitedInView: {
    name: "ProhibitedInView",
    subtypes: [],
    props: {
      method_name: ""
    }
  },
  ReadError: {
    name: "ReadError",
    subtypes: [],
    props: {}
  },
  ReturnedValueLengthExceeded: {
    name: "ReturnedValueLengthExceeded",
    subtypes: [],
    props: {
      length: "",
      limit: ""
    }
  },
  Serialization: {
    name: "Serialization",
    subtypes: [],
    props: {}
  },
  SerializationError: {
    name: "SerializationError",
    subtypes: [],
    props: {
      hash: ""
    }
  },
  StackHeightInstrumentation: {
    name: "StackHeightInstrumentation",
    subtypes: [],
    props: {}
  },
  StackOverflow: {
    name: "StackOverflow",
    subtypes: [],
    props: {}
  },
  TotalLogLengthExceeded: {
    name: "TotalLogLengthExceeded",
    subtypes: [],
    props: {
      length: "",
      limit: ""
    }
  },
  Unreachable: {
    name: "Unreachable",
    subtypes: [],
    props: {}
  },
  ValueLengthExceeded: {
    name: "ValueLengthExceeded",
    subtypes: [],
    props: {
      length: "",
      limit: ""
    }
  },
  WasmTrap: {
    name: "WasmTrap",
    subtypes: [
      "Unreachable",
      "IncorrectCallIndirectSignature",
      "MemoryOutOfBounds",
      "CallIndirectOOB",
      "IllegalArithmetic",
      "MisalignedAtomicAccess",
      "BreakpointTrap",
      "StackOverflow",
      "GenericTrap"
    ],
    props: {}
  },
  WasmUnknownError: {
    name: "WasmUnknownError",
    subtypes: [],
    props: {}
  },
  WasmerCompileError: {
    name: "WasmerCompileError",
    subtypes: [],
    props: {
      msg: ""
    }
  },
  WriteError: {
    name: "WriteError",
    subtypes: [],
    props: {}
  },
  AccessKeyNotFound: {
    name: "AccessKeyNotFound",
    subtypes: [],
    props: {
      account_id: "",
      public_key: ""
    }
  },
  AccountAlreadyExists: {
    name: "AccountAlreadyExists",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  AccountDoesNotExist: {
    name: "AccountDoesNotExist",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  ActionError: {
    name: "ActionError",
    subtypes: [
      "AccountAlreadyExists",
      "AccountDoesNotExist",
      "CreateAccountOnlyByRegistrar",
      "CreateAccountNotAllowed",
      "ActorNoPermission",
      "DeleteKeyDoesNotExist",
      "AddKeyAlreadyExists",
      "DeleteAccountStaking",
      "LackBalanceForState",
      "TriesToUnstake",
      "TriesToStake",
      "InsufficientStake",
      "FunctionCallError",
      "NewReceiptValidationError",
      "OnlyImplicitAccountCreationAllowed"
    ],
    props: {
      index: ""
    }
  },
  ActionsValidationError: {
    name: "ActionsValidationError",
    subtypes: [
      "DeleteActionMustBeFinal",
      "TotalPrepaidGasExceeded",
      "TotalNumberOfActionsExceeded",
      "AddKeyMethodNamesNumberOfBytesExceeded",
      "AddKeyMethodNameLengthExceeded",
      "IntegerOverflow",
      "InvalidAccountId",
      "ContractSizeExceeded",
      "FunctionCallMethodNameLengthExceeded",
      "FunctionCallArgumentsLengthExceeded",
      "UnsuitableStakingKey",
      "FunctionCallZeroAttachedGas"
    ],
    props: {}
  },
  ActorNoPermission: {
    name: "ActorNoPermission",
    subtypes: [],
    props: {
      account_id: "",
      actor_id: ""
    }
  },
  AddKeyAlreadyExists: {
    name: "AddKeyAlreadyExists",
    subtypes: [],
    props: {
      account_id: "",
      public_key: ""
    }
  },
  AddKeyMethodNameLengthExceeded: {
    name: "AddKeyMethodNameLengthExceeded",
    subtypes: [],
    props: {
      length: "",
      limit: ""
    }
  },
  AddKeyMethodNamesNumberOfBytesExceeded: {
    name: "AddKeyMethodNamesNumberOfBytesExceeded",
    subtypes: [],
    props: {
      limit: "",
      total_number_of_bytes: ""
    }
  },
  BalanceMismatchError: {
    name: "BalanceMismatchError",
    subtypes: [],
    props: {
      final_accounts_balance: "",
      final_postponed_receipts_balance: "",
      incoming_receipts_balance: "",
      incoming_validator_rewards: "",
      initial_accounts_balance: "",
      initial_postponed_receipts_balance: "",
      new_delayed_receipts_balance: "",
      other_burnt_amount: "",
      outgoing_receipts_balance: "",
      processed_delayed_receipts_balance: "",
      slashed_burnt_amount: "",
      tx_burnt_amount: ""
    }
  },
  CostOverflow: {
    name: "CostOverflow",
    subtypes: [],
    props: {}
  },
  CreateAccountNotAllowed: {
    name: "CreateAccountNotAllowed",
    subtypes: [],
    props: {
      account_id: "",
      predecessor_id: ""
    }
  },
  CreateAccountOnlyByRegistrar: {
    name: "CreateAccountOnlyByRegistrar",
    subtypes: [],
    props: {
      account_id: "",
      predecessor_id: "",
      registrar_account_id: ""
    }
  },
  DeleteAccountStaking: {
    name: "DeleteAccountStaking",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  DeleteActionMustBeFinal: {
    name: "DeleteActionMustBeFinal",
    subtypes: [],
    props: {}
  },
  DeleteKeyDoesNotExist: {
    name: "DeleteKeyDoesNotExist",
    subtypes: [],
    props: {
      account_id: "",
      public_key: ""
    }
  },
  DepositWithFunctionCall: {
    name: "DepositWithFunctionCall",
    subtypes: [],
    props: {}
  },
  Expired: {
    name: "Expired",
    subtypes: [],
    props: {}
  },
  FunctionCallArgumentsLengthExceeded: {
    name: "FunctionCallArgumentsLengthExceeded",
    subtypes: [],
    props: {
      length: "",
      limit: ""
    }
  },
  FunctionCallMethodNameLengthExceeded: {
    name: "FunctionCallMethodNameLengthExceeded",
    subtypes: [],
    props: {
      length: "",
      limit: ""
    }
  },
  FunctionCallZeroAttachedGas: {
    name: "FunctionCallZeroAttachedGas",
    subtypes: [],
    props: {}
  },
  InsufficientStake: {
    name: "InsufficientStake",
    subtypes: [],
    props: {
      account_id: "",
      minimum_stake: "",
      stake: ""
    }
  },
  InvalidAccessKeyError: {
    name: "InvalidAccessKeyError",
    subtypes: [
      "AccessKeyNotFound",
      "ReceiverMismatch",
      "MethodNameMismatch",
      "RequiresFullAccess",
      "NotEnoughAllowance",
      "DepositWithFunctionCall"
    ],
    props: {}
  },
  InvalidChain: {
    name: "InvalidChain",
    subtypes: [],
    props: {}
  },
  InvalidDataReceiverId: {
    name: "InvalidDataReceiverId",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  InvalidNonce: {
    name: "InvalidNonce",
    subtypes: [],
    props: {
      ak_nonce: "",
      tx_nonce: ""
    }
  },
  InvalidPredecessorId: {
    name: "InvalidPredecessorId",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  InvalidReceiverId: {
    name: "InvalidReceiverId",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  InvalidSignature: {
    name: "InvalidSignature",
    subtypes: [],
    props: {}
  },
  InvalidSignerId: {
    name: "InvalidSignerId",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  InvalidTxError: {
    name: "InvalidTxError",
    subtypes: [
      "InvalidAccessKeyError",
      "InvalidSignerId",
      "SignerDoesNotExist",
      "InvalidNonce",
      "InvalidReceiverId",
      "InvalidSignature",
      "NotEnoughBalance",
      "LackBalanceForState",
      "CostOverflow",
      "InvalidChain",
      "Expired",
      "ActionsValidation"
    ],
    props: {}
  },
  LackBalanceForState: {
    name: "LackBalanceForState",
    subtypes: [],
    props: {
      account_id: "",
      amount: ""
    }
  },
  MethodNameMismatch: {
    name: "MethodNameMismatch",
    subtypes: [],
    props: {
      method_name: ""
    }
  },
  NotEnoughAllowance: {
    name: "NotEnoughAllowance",
    subtypes: [],
    props: {
      account_id: "",
      allowance: "",
      cost: "",
      public_key: ""
    }
  },
  NotEnoughBalance: {
    name: "NotEnoughBalance",
    subtypes: [],
    props: {
      balance: "",
      cost: "",
      signer_id: ""
    }
  },
  OnlyImplicitAccountCreationAllowed: {
    name: "OnlyImplicitAccountCreationAllowed",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  ReceiptValidationError: {
    name: "ReceiptValidationError",
    subtypes: [
      "InvalidPredecessorId",
      "InvalidReceiverId",
      "InvalidSignerId",
      "InvalidDataReceiverId",
      "ReturnedValueLengthExceeded",
      "NumberInputDataDependenciesExceeded",
      "ActionsValidation"
    ],
    props: {}
  },
  ReceiverMismatch: {
    name: "ReceiverMismatch",
    subtypes: [],
    props: {
      ak_receiver: "",
      tx_receiver: ""
    }
  },
  RequiresFullAccess: {
    name: "RequiresFullAccess",
    subtypes: [],
    props: {}
  },
  SignerDoesNotExist: {
    name: "SignerDoesNotExist",
    subtypes: [],
    props: {
      signer_id: ""
    }
  },
  TotalNumberOfActionsExceeded: {
    name: "TotalNumberOfActionsExceeded",
    subtypes: [],
    props: {
      limit: "",
      total_number_of_actions: ""
    }
  },
  TotalPrepaidGasExceeded: {
    name: "TotalPrepaidGasExceeded",
    subtypes: [],
    props: {
      limit: "",
      total_prepaid_gas: ""
    }
  },
  TriesToStake: {
    name: "TriesToStake",
    subtypes: [],
    props: {
      account_id: "",
      balance: "",
      locked: "",
      stake: ""
    }
  },
  TriesToUnstake: {
    name: "TriesToUnstake",
    subtypes: [],
    props: {
      account_id: ""
    }
  },
  TxExecutionError: {
    name: "TxExecutionError",
    subtypes: [
      "ActionError",
      "InvalidTxError"
    ],
    props: {}
  },
  UnsuitableStakingKey: {
    name: "UnsuitableStakingKey",
    subtypes: [],
    props: {
      public_key: ""
    }
  },
  Closed: {
    name: "Closed",
    subtypes: [],
    props: {}
  },
  InternalError: {
    name: "InternalError",
    subtypes: [],
    props: {}
  },
  ServerError: {
    name: "ServerError",
    subtypes: [
      "TxExecutionError",
      "Timeout",
      "Closed",
      "InternalError"
    ],
    props: {}
  },
  Timeout: {
    name: "Timeout",
    subtypes: [],
    props: {}
  }
}, L7 = {
  schema: F7
};
var QI = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(so, "__esModule", { value: !0 });
so.getErrorTypeFromErrorMessage = so.formatError = so.parseResultError = so.parseRpcError = so.ServerError = void 0;
const $7 = bo, W7 = QI(x$), K7 = XI, e2 = QI(z7), V7 = QI(L7), q7 = {
  formatNear: () => (e, t) => (0, K7.formatNearAmount)(t(e))
};
class ek extends $7.TypedError {
}
so.ServerError = ek;
class H7 extends ek {
}
function DC(e) {
  const t = {}, n = NC(e, V7.default.schema, t, ""), r = new ek(RC(n, t), n);
  return Object.assign(r, t), r;
}
so.parseRpcError = DC;
function G7(e) {
  const t = DC(e.status.Failure), n = new H7();
  return Object.assign(n, t), n.type = t.type, n.message = t.message, n.transaction_outcome = e.transaction_outcome, n;
}
so.parseResultError = G7;
function RC(e, t) {
  return typeof e2.default[e] == "string" ? W7.default.render(e2.default[e], Object.assign(Object.assign({}, t), q7)) : JSON.stringify(t);
}
so.formatError = RC;
function NC(e, t, n, r) {
  let i, o, a;
  for (const s in t) {
    if (Z7(e[s]))
      return e[s];
    if (vv(e[s]))
      i = e[s], o = t[s], a = s;
    else if (vv(e.kind) && vv(e.kind[s]))
      i = e.kind[s], o = t[s], a = s;
    else
      continue;
  }
  if (i && o) {
    for (const s of Object.keys(o.props))
      n[s] = i[s];
    return NC(i, t, n, a);
  } else
    return n.kind = e, r;
}
function Y7(e, t) {
  switch (!0) {
    case /^account .*? does not exist while viewing$/.test(e):
      return "AccountDoesNotExist";
    case /^Account .*? doesn't exist$/.test(e):
      return "AccountDoesNotExist";
    case /^access key .*? does not exist while viewing$/.test(e):
      return "AccessKeyDoesNotExist";
    case /wasm execution failed with error: FunctionCallError\(CompilationError\(CodeDoesNotExist/.test(e):
      return "CodeDoesNotExist";
    case /Transaction nonce \d+ must be larger than nonce of the used access key \d+/.test(e):
      return "InvalidNonce";
    default:
      return t;
  }
}
so.getErrorTypeFromErrorMessage = Y7;
function vv(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Z7(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.parseRpcError = e.parseResultError = e.getErrorTypeFromErrorMessage = e.formatError = e.ServerError = e.logWarning = void 0;
  var t = $m;
  Object.defineProperty(e, "logWarning", { enumerable: !0, get: function() {
    return t.logWarning;
  } });
  var n = so;
  Object.defineProperty(e, "ServerError", { enumerable: !0, get: function() {
    return n.ServerError;
  } }), Object.defineProperty(e, "formatError", { enumerable: !0, get: function() {
    return n.formatError;
  } }), Object.defineProperty(e, "getErrorTypeFromErrorMessage", { enumerable: !0, get: function() {
    return n.getErrorTypeFromErrorMessage;
  } }), Object.defineProperty(e, "parseResultError", { enumerable: !0, get: function() {
    return n.parseResultError;
  } }), Object.defineProperty(e, "parseRpcError", { enumerable: !0, get: function() {
    return n.parseRpcError;
  } });
})(JI);
var ul = {};
Object.defineProperty(ul, "__esModule", { value: !0 });
ul.printTxOutcomeLogs = ul.printTxOutcomeLogsAndFailures = void 0;
const J7 = JI;
function X7({ contractId: e, outcome: t }) {
  const n = [t.transaction_outcome, ...t.receipts_outcome].reduce((r, i) => {
    const o = typeof i.outcome.status == "object" && typeof i.outcome.status.Failure == "object";
    return i.outcome.logs.length || o ? r.concat({
      receiptIds: i.outcome.receipt_ids,
      logs: i.outcome.logs,
      failure: typeof i.outcome.status == "object" && i.outcome.status.Failure !== void 0 ? (0, J7.parseRpcError)(i.outcome.status.Failure) : null
    }) : r;
  }, []);
  for (const r of n)
    console.log(`Receipt${r.receiptIds.length > 1 ? "s" : ""}: ${r.receiptIds.join(", ")}`), jC({
      contractId: e,
      logs: r.logs,
      prefix: "	"
    }), r.failure && console.warn(`	Failure [${e}]: ${r.failure}`);
}
ul.printTxOutcomeLogsAndFailures = X7;
function jC({ contractId: e, logs: t, prefix: n = "" }) {
  for (const r of t)
    console.log(`${n}Log [${e}]: ${r}`);
}
ul.printTxOutcomeLogs = jC;
var Km = {};
Object.defineProperty(Km, "__esModule", { value: !0 });
Km.getTransactionLastResult = void 0;
function Q7(e) {
  if (typeof e.status == "object" && typeof e.status.SuccessValue == "string") {
    const t = Buffer.from(e.status.SuccessValue, "base64").toString();
    try {
      return JSON.parse(t);
    } catch {
      return t;
    }
  }
  return null;
}
Km.getTransactionLastResult = Q7;
var ll = {};
/*!
 * depd
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var eW = tW;
function tW(e) {
  if (!e)
    throw new TypeError("argument namespace is required");
  function t(n) {
  }
  return t._file = void 0, t._ignored = !0, t._namespace = e, t._traced = !1, t._warned = /* @__PURE__ */ Object.create(null), t.function = nW, t.property = rW, t;
}
function nW(e, t) {
  if (typeof e != "function")
    throw new TypeError("argument fn must be a function");
  return e;
}
function rW(e, t, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new TypeError("argument obj must be object");
  var r = Object.getOwnPropertyDescriptor(e, t);
  if (!r)
    throw new TypeError("must call property on owner object");
  if (!r.configurable)
    throw new TypeError("property must be configurable");
}
var UC = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ll, "__esModule", { value: !0 });
ll.diffEpochValidators = ll.findSeatPrice = void 0;
const Ao = UC(Ka), iW = UC(eW);
function oW(e, t, n, r) {
  return r && r < 49 ? aW(e, t) : (n || ((0, iW.default)("findSeatPrice(validators, maxNumberOfSeats)")("`use `findSeatPrice(validators, maxNumberOfSeats, minimumStakeRatio)` instead"), n = [1, 6250]), sW(e, t, n));
}
ll.findSeatPrice = oW;
function aW(e, t) {
  const n = e.map((s) => new Ao.default(s.stake, 10)).sort((s, c) => s.cmp(c)), r = new Ao.default(t), i = n.reduce((s, c) => s.add(c));
  if (i.lt(r))
    throw new Error("Stakes are below seats");
  let o = new Ao.default(1), a = i.add(new Ao.default(1));
  for (; !o.eq(a.sub(new Ao.default(1))); ) {
    const s = o.add(a).div(new Ao.default(2));
    let c = !1, l = new Ao.default(0);
    for (let u = 0; u < n.length; ++u)
      if (l = l.add(n[u].div(s)), l.gte(r)) {
        o = s, c = !0;
        break;
      }
    c || (a = s);
  }
  return o;
}
function sW(e, t, n) {
  if (n.length != 2)
    throw Error("minimumStakeRatio should have 2 elements");
  const r = e.map((o) => new Ao.default(o.stake, 10)).sort((o, a) => o.cmp(a)), i = r.reduce((o, a) => o.add(a));
  return e.length < t ? i.mul(new Ao.default(n[0])).div(new Ao.default(n[1])) : r[0].add(new Ao.default(1));
}
function cW(e, t) {
  const n = /* @__PURE__ */ new Map();
  e.forEach((i) => n.set(i.account_id, i));
  const r = new Set(t.map((i) => i.account_id));
  return {
    newValidators: t.filter((i) => !n.has(i.account_id)),
    removedValidators: e.filter((i) => !r.has(i.account_id)),
    changedValidators: t.filter((i) => n.has(i.account_id) && n.get(i.account_id).stake != i.stake).map((i) => ({ current: n.get(i.account_id), next: i }))
  };
}
ll.diffEpochValidators = cW;
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(Lm, e), n(JI, e), n(XI, e), n(ul, e), n(Km, e), n(ll, e);
})(ZI);
var tk = {}, jl = {}, uW = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(jl, "__esModule", { value: !0 });
jl.exponentialBackoff = void 0;
function lW(e, t, n, r) {
  return uW(this, void 0, void 0, function* () {
    let i = e;
    for (let o = 0; o < t; o++) {
      const a = yield r();
      if (a)
        return a;
      yield fW(i), i *= n;
    }
    return null;
  });
}
jl.exponentialBackoff = lW;
function fW(e) {
  return new Promise((t) => setTimeout(t, e));
}
var Vm = {}, zC = {}, Mc = {}, rn = {};
Object.defineProperty(rn, "__esModule", { value: !0 });
rn.Action = rn.SignedDelegate = rn.DeleteAccount = rn.DeleteKey = rn.AddKey = rn.Stake = rn.Transfer = rn.FunctionCall = rn.DeployContract = rn.CreateAccount = rn.IAction = rn.AccessKey = rn.AccessKeyPermission = rn.FullAccessPermission = rn.FunctionCallPermission = void 0;
const qm = bo;
let FC = class {
  constructor(t) {
    if (Object.keys(t).length !== 1)
      throw new Error("Enum can only take single value");
    Object.keys(t).map((n) => {
      this[n] = t[n], this.enum = n;
    });
  }
};
class dW extends qm.Assignable {
}
rn.FunctionCallPermission = dW;
class hW extends qm.Assignable {
}
rn.FullAccessPermission = hW;
class pW extends FC {
}
rn.AccessKeyPermission = pW;
class yW extends qm.Assignable {
}
rn.AccessKey = yW;
class wa extends qm.Assignable {
}
rn.IAction = wa;
class gW extends wa {
}
rn.CreateAccount = gW;
class bW extends wa {
}
rn.DeployContract = bW;
class mW extends wa {
}
rn.FunctionCall = mW;
let _W = class extends wa {
};
rn.Transfer = _W;
class wW extends wa {
}
rn.Stake = wW;
class vW extends wa {
}
rn.AddKey = vW;
class SW extends wa {
}
rn.DeleteKey = SW;
class EW extends wa {
}
rn.DeleteAccount = EW;
class AW extends wa {
}
rn.SignedDelegate = AW;
class IW extends FC {
}
rn.Action = IW;
Object.defineProperty(Mc, "__esModule", { value: !0 });
Mc.actionCreators = Mc.stringifyJsonOrBytes = void 0;
const qn = rn;
function kW() {
  return new qn.AccessKey({
    permission: new qn.AccessKeyPermission({
      fullAccess: new qn.FullAccessPermission({})
    })
  });
}
function TW(e, t, n) {
  return new qn.AccessKey({
    permission: new qn.AccessKeyPermission({
      functionCall: new qn.FunctionCallPermission({ receiverId: e, allowance: n, methodNames: t })
    })
  });
}
function xW() {
  return new qn.Action({ createAccount: new qn.CreateAccount({}) });
}
function MW(e) {
  return new qn.Action({ deployContract: new qn.DeployContract({ code: e }) });
}
function LC(e) {
  return e.byteLength !== void 0 && e.byteLength === e.length ? e : Buffer.from(JSON.stringify(e));
}
Mc.stringifyJsonOrBytes = LC;
function OW(e, t, n, r, i = LC, o = !1) {
  return o ? new qn.Action({ functionCall: new qn.FunctionCall({ methodName: e, args: t, gas: n, deposit: r }) }) : new qn.Action({
    functionCall: new qn.FunctionCall({
      methodName: e,
      args: i(t),
      gas: n,
      deposit: r
    })
  });
}
function PW(e) {
  return new qn.Action({ transfer: new qn.Transfer({ deposit: e }) });
}
function BW(e, t) {
  return new qn.Action({ stake: new qn.Stake({ stake: e, publicKey: t }) });
}
function CW(e, t) {
  return new qn.Action({ addKey: new qn.AddKey({ publicKey: e, accessKey: t }) });
}
function DW(e) {
  return new qn.Action({ deleteKey: new qn.DeleteKey({ publicKey: e }) });
}
function RW(e) {
  return new qn.Action({ deleteAccount: new qn.DeleteAccount({ beneficiaryId: e }) });
}
function NW({ delegateAction: e, signature: t }) {
  return new qn.Action({ signedDelegate: new qn.SignedDelegate({ delegateAction: e, signature: t }) });
}
Mc.actionCreators = {
  addKey: CW,
  createAccount: xW,
  deleteAccount: RW,
  deleteKey: DW,
  deployContract: MW,
  fullAccessKey: kW,
  functionCall: OW,
  functionCallAccessKey: TW,
  signedDelegate: NW,
  stake: BW,
  transfer: PW
};
var Ad = {}, Hm = {}, $C = {}, Gm = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.KeyType = void 0, function(t) {
    t[t.ED25519 = 0] = "ED25519";
  }(e.KeyType || (e.KeyType = {}));
})(Gm);
var Ym = {}, Id = {};
Object.defineProperty(Id, "__esModule", { value: !0 });
Id.KeyPairBase = void 0;
class jW {
}
Id.KeyPairBase = jW;
var kd = {};
function UW(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var WC = { exports: {} };
(function(e) {
  (function(t) {
    var n = function($) {
      var H, Z = new Float64Array(16);
      if ($)
        for (H = 0; H < $.length; H++)
          Z[H] = $[H];
      return Z;
    }, r = function() {
      throw new Error("no PRNG");
    }, i = new Uint8Array(16), o = new Uint8Array(32);
    o[0] = 9;
    var a = n(), s = n([1]), c = n([56129, 1]), l = n([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), u = n([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), f = n([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), d = n([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), h = n([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function g($, H, Z, P) {
      $[H] = Z >> 24 & 255, $[H + 1] = Z >> 16 & 255, $[H + 2] = Z >> 8 & 255, $[H + 3] = Z & 255, $[H + 4] = P >> 24 & 255, $[H + 5] = P >> 16 & 255, $[H + 6] = P >> 8 & 255, $[H + 7] = P & 255;
    }
    function w($, H, Z, P, X) {
      var le, ce = 0;
      for (le = 0; le < X; le++)
        ce |= $[H + le] ^ Z[P + le];
      return (1 & ce - 1 >>> 8) - 1;
    }
    function b($, H, Z, P) {
      return w($, H, Z, P, 16);
    }
    function I($, H, Z, P) {
      return w($, H, Z, P, 32);
    }
    function A($, H, Z, P) {
      for (var X = P[0] & 255 | (P[1] & 255) << 8 | (P[2] & 255) << 16 | (P[3] & 255) << 24, le = Z[0] & 255 | (Z[1] & 255) << 8 | (Z[2] & 255) << 16 | (Z[3] & 255) << 24, ce = Z[4] & 255 | (Z[5] & 255) << 8 | (Z[6] & 255) << 16 | (Z[7] & 255) << 24, ye = Z[8] & 255 | (Z[9] & 255) << 8 | (Z[10] & 255) << 16 | (Z[11] & 255) << 24, Ce = Z[12] & 255 | (Z[13] & 255) << 8 | (Z[14] & 255) << 16 | (Z[15] & 255) << 24, $e = P[4] & 255 | (P[5] & 255) << 8 | (P[6] & 255) << 16 | (P[7] & 255) << 24, je = H[0] & 255 | (H[1] & 255) << 8 | (H[2] & 255) << 16 | (H[3] & 255) << 24, Jt = H[4] & 255 | (H[5] & 255) << 8 | (H[6] & 255) << 16 | (H[7] & 255) << 24, Xe = H[8] & 255 | (H[9] & 255) << 8 | (H[10] & 255) << 16 | (H[11] & 255) << 24, Et = H[12] & 255 | (H[13] & 255) << 8 | (H[14] & 255) << 16 | (H[15] & 255) << 24, At = P[8] & 255 | (P[9] & 255) << 8 | (P[10] & 255) << 16 | (P[11] & 255) << 24, Bt = Z[16] & 255 | (Z[17] & 255) << 8 | (Z[18] & 255) << 16 | (Z[19] & 255) << 24, Ot = Z[20] & 255 | (Z[21] & 255) << 8 | (Z[22] & 255) << 16 | (Z[23] & 255) << 24, It = Z[24] & 255 | (Z[25] & 255) << 8 | (Z[26] & 255) << 16 | (Z[27] & 255) << 24, Tt = Z[28] & 255 | (Z[29] & 255) << 8 | (Z[30] & 255) << 16 | (Z[31] & 255) << 24, kt = P[12] & 255 | (P[13] & 255) << 8 | (P[14] & 255) << 16 | (P[15] & 255) << 24, nt = X, yt = le, Ye = ce, rt = ye, ct = Ce, He = $e, ge = je, be = Jt, Te = Xe, Ee = Et, Ie = At, Ne = Bt, St = Ot, zt = It, Lt = Tt, Ft = kt, ne, Zt = 0; Zt < 20; Zt += 2)
        ne = nt + St | 0, ct ^= ne << 7 | ne >>> 32 - 7, ne = ct + nt | 0, Te ^= ne << 9 | ne >>> 32 - 9, ne = Te + ct | 0, St ^= ne << 13 | ne >>> 32 - 13, ne = St + Te | 0, nt ^= ne << 18 | ne >>> 32 - 18, ne = He + yt | 0, Ee ^= ne << 7 | ne >>> 32 - 7, ne = Ee + He | 0, zt ^= ne << 9 | ne >>> 32 - 9, ne = zt + Ee | 0, yt ^= ne << 13 | ne >>> 32 - 13, ne = yt + zt | 0, He ^= ne << 18 | ne >>> 32 - 18, ne = Ie + ge | 0, Lt ^= ne << 7 | ne >>> 32 - 7, ne = Lt + Ie | 0, Ye ^= ne << 9 | ne >>> 32 - 9, ne = Ye + Lt | 0, ge ^= ne << 13 | ne >>> 32 - 13, ne = ge + Ye | 0, Ie ^= ne << 18 | ne >>> 32 - 18, ne = Ft + Ne | 0, rt ^= ne << 7 | ne >>> 32 - 7, ne = rt + Ft | 0, be ^= ne << 9 | ne >>> 32 - 9, ne = be + rt | 0, Ne ^= ne << 13 | ne >>> 32 - 13, ne = Ne + be | 0, Ft ^= ne << 18 | ne >>> 32 - 18, ne = nt + rt | 0, yt ^= ne << 7 | ne >>> 32 - 7, ne = yt + nt | 0, Ye ^= ne << 9 | ne >>> 32 - 9, ne = Ye + yt | 0, rt ^= ne << 13 | ne >>> 32 - 13, ne = rt + Ye | 0, nt ^= ne << 18 | ne >>> 32 - 18, ne = He + ct | 0, ge ^= ne << 7 | ne >>> 32 - 7, ne = ge + He | 0, be ^= ne << 9 | ne >>> 32 - 9, ne = be + ge | 0, ct ^= ne << 13 | ne >>> 32 - 13, ne = ct + be | 0, He ^= ne << 18 | ne >>> 32 - 18, ne = Ie + Ee | 0, Ne ^= ne << 7 | ne >>> 32 - 7, ne = Ne + Ie | 0, Te ^= ne << 9 | ne >>> 32 - 9, ne = Te + Ne | 0, Ee ^= ne << 13 | ne >>> 32 - 13, ne = Ee + Te | 0, Ie ^= ne << 18 | ne >>> 32 - 18, ne = Ft + Lt | 0, St ^= ne << 7 | ne >>> 32 - 7, ne = St + Ft | 0, zt ^= ne << 9 | ne >>> 32 - 9, ne = zt + St | 0, Lt ^= ne << 13 | ne >>> 32 - 13, ne = Lt + zt | 0, Ft ^= ne << 18 | ne >>> 32 - 18;
      nt = nt + X | 0, yt = yt + le | 0, Ye = Ye + ce | 0, rt = rt + ye | 0, ct = ct + Ce | 0, He = He + $e | 0, ge = ge + je | 0, be = be + Jt | 0, Te = Te + Xe | 0, Ee = Ee + Et | 0, Ie = Ie + At | 0, Ne = Ne + Bt | 0, St = St + Ot | 0, zt = zt + It | 0, Lt = Lt + Tt | 0, Ft = Ft + kt | 0, $[0] = nt >>> 0 & 255, $[1] = nt >>> 8 & 255, $[2] = nt >>> 16 & 255, $[3] = nt >>> 24 & 255, $[4] = yt >>> 0 & 255, $[5] = yt >>> 8 & 255, $[6] = yt >>> 16 & 255, $[7] = yt >>> 24 & 255, $[8] = Ye >>> 0 & 255, $[9] = Ye >>> 8 & 255, $[10] = Ye >>> 16 & 255, $[11] = Ye >>> 24 & 255, $[12] = rt >>> 0 & 255, $[13] = rt >>> 8 & 255, $[14] = rt >>> 16 & 255, $[15] = rt >>> 24 & 255, $[16] = ct >>> 0 & 255, $[17] = ct >>> 8 & 255, $[18] = ct >>> 16 & 255, $[19] = ct >>> 24 & 255, $[20] = He >>> 0 & 255, $[21] = He >>> 8 & 255, $[22] = He >>> 16 & 255, $[23] = He >>> 24 & 255, $[24] = ge >>> 0 & 255, $[25] = ge >>> 8 & 255, $[26] = ge >>> 16 & 255, $[27] = ge >>> 24 & 255, $[28] = be >>> 0 & 255, $[29] = be >>> 8 & 255, $[30] = be >>> 16 & 255, $[31] = be >>> 24 & 255, $[32] = Te >>> 0 & 255, $[33] = Te >>> 8 & 255, $[34] = Te >>> 16 & 255, $[35] = Te >>> 24 & 255, $[36] = Ee >>> 0 & 255, $[37] = Ee >>> 8 & 255, $[38] = Ee >>> 16 & 255, $[39] = Ee >>> 24 & 255, $[40] = Ie >>> 0 & 255, $[41] = Ie >>> 8 & 255, $[42] = Ie >>> 16 & 255, $[43] = Ie >>> 24 & 255, $[44] = Ne >>> 0 & 255, $[45] = Ne >>> 8 & 255, $[46] = Ne >>> 16 & 255, $[47] = Ne >>> 24 & 255, $[48] = St >>> 0 & 255, $[49] = St >>> 8 & 255, $[50] = St >>> 16 & 255, $[51] = St >>> 24 & 255, $[52] = zt >>> 0 & 255, $[53] = zt >>> 8 & 255, $[54] = zt >>> 16 & 255, $[55] = zt >>> 24 & 255, $[56] = Lt >>> 0 & 255, $[57] = Lt >>> 8 & 255, $[58] = Lt >>> 16 & 255, $[59] = Lt >>> 24 & 255, $[60] = Ft >>> 0 & 255, $[61] = Ft >>> 8 & 255, $[62] = Ft >>> 16 & 255, $[63] = Ft >>> 24 & 255;
    }
    function x($, H, Z, P) {
      for (var X = P[0] & 255 | (P[1] & 255) << 8 | (P[2] & 255) << 16 | (P[3] & 255) << 24, le = Z[0] & 255 | (Z[1] & 255) << 8 | (Z[2] & 255) << 16 | (Z[3] & 255) << 24, ce = Z[4] & 255 | (Z[5] & 255) << 8 | (Z[6] & 255) << 16 | (Z[7] & 255) << 24, ye = Z[8] & 255 | (Z[9] & 255) << 8 | (Z[10] & 255) << 16 | (Z[11] & 255) << 24, Ce = Z[12] & 255 | (Z[13] & 255) << 8 | (Z[14] & 255) << 16 | (Z[15] & 255) << 24, $e = P[4] & 255 | (P[5] & 255) << 8 | (P[6] & 255) << 16 | (P[7] & 255) << 24, je = H[0] & 255 | (H[1] & 255) << 8 | (H[2] & 255) << 16 | (H[3] & 255) << 24, Jt = H[4] & 255 | (H[5] & 255) << 8 | (H[6] & 255) << 16 | (H[7] & 255) << 24, Xe = H[8] & 255 | (H[9] & 255) << 8 | (H[10] & 255) << 16 | (H[11] & 255) << 24, Et = H[12] & 255 | (H[13] & 255) << 8 | (H[14] & 255) << 16 | (H[15] & 255) << 24, At = P[8] & 255 | (P[9] & 255) << 8 | (P[10] & 255) << 16 | (P[11] & 255) << 24, Bt = Z[16] & 255 | (Z[17] & 255) << 8 | (Z[18] & 255) << 16 | (Z[19] & 255) << 24, Ot = Z[20] & 255 | (Z[21] & 255) << 8 | (Z[22] & 255) << 16 | (Z[23] & 255) << 24, It = Z[24] & 255 | (Z[25] & 255) << 8 | (Z[26] & 255) << 16 | (Z[27] & 255) << 24, Tt = Z[28] & 255 | (Z[29] & 255) << 8 | (Z[30] & 255) << 16 | (Z[31] & 255) << 24, kt = P[12] & 255 | (P[13] & 255) << 8 | (P[14] & 255) << 16 | (P[15] & 255) << 24, nt = X, yt = le, Ye = ce, rt = ye, ct = Ce, He = $e, ge = je, be = Jt, Te = Xe, Ee = Et, Ie = At, Ne = Bt, St = Ot, zt = It, Lt = Tt, Ft = kt, ne, Zt = 0; Zt < 20; Zt += 2)
        ne = nt + St | 0, ct ^= ne << 7 | ne >>> 32 - 7, ne = ct + nt | 0, Te ^= ne << 9 | ne >>> 32 - 9, ne = Te + ct | 0, St ^= ne << 13 | ne >>> 32 - 13, ne = St + Te | 0, nt ^= ne << 18 | ne >>> 32 - 18, ne = He + yt | 0, Ee ^= ne << 7 | ne >>> 32 - 7, ne = Ee + He | 0, zt ^= ne << 9 | ne >>> 32 - 9, ne = zt + Ee | 0, yt ^= ne << 13 | ne >>> 32 - 13, ne = yt + zt | 0, He ^= ne << 18 | ne >>> 32 - 18, ne = Ie + ge | 0, Lt ^= ne << 7 | ne >>> 32 - 7, ne = Lt + Ie | 0, Ye ^= ne << 9 | ne >>> 32 - 9, ne = Ye + Lt | 0, ge ^= ne << 13 | ne >>> 32 - 13, ne = ge + Ye | 0, Ie ^= ne << 18 | ne >>> 32 - 18, ne = Ft + Ne | 0, rt ^= ne << 7 | ne >>> 32 - 7, ne = rt + Ft | 0, be ^= ne << 9 | ne >>> 32 - 9, ne = be + rt | 0, Ne ^= ne << 13 | ne >>> 32 - 13, ne = Ne + be | 0, Ft ^= ne << 18 | ne >>> 32 - 18, ne = nt + rt | 0, yt ^= ne << 7 | ne >>> 32 - 7, ne = yt + nt | 0, Ye ^= ne << 9 | ne >>> 32 - 9, ne = Ye + yt | 0, rt ^= ne << 13 | ne >>> 32 - 13, ne = rt + Ye | 0, nt ^= ne << 18 | ne >>> 32 - 18, ne = He + ct | 0, ge ^= ne << 7 | ne >>> 32 - 7, ne = ge + He | 0, be ^= ne << 9 | ne >>> 32 - 9, ne = be + ge | 0, ct ^= ne << 13 | ne >>> 32 - 13, ne = ct + be | 0, He ^= ne << 18 | ne >>> 32 - 18, ne = Ie + Ee | 0, Ne ^= ne << 7 | ne >>> 32 - 7, ne = Ne + Ie | 0, Te ^= ne << 9 | ne >>> 32 - 9, ne = Te + Ne | 0, Ee ^= ne << 13 | ne >>> 32 - 13, ne = Ee + Te | 0, Ie ^= ne << 18 | ne >>> 32 - 18, ne = Ft + Lt | 0, St ^= ne << 7 | ne >>> 32 - 7, ne = St + Ft | 0, zt ^= ne << 9 | ne >>> 32 - 9, ne = zt + St | 0, Lt ^= ne << 13 | ne >>> 32 - 13, ne = Lt + zt | 0, Ft ^= ne << 18 | ne >>> 32 - 18;
      $[0] = nt >>> 0 & 255, $[1] = nt >>> 8 & 255, $[2] = nt >>> 16 & 255, $[3] = nt >>> 24 & 255, $[4] = He >>> 0 & 255, $[5] = He >>> 8 & 255, $[6] = He >>> 16 & 255, $[7] = He >>> 24 & 255, $[8] = Ie >>> 0 & 255, $[9] = Ie >>> 8 & 255, $[10] = Ie >>> 16 & 255, $[11] = Ie >>> 24 & 255, $[12] = Ft >>> 0 & 255, $[13] = Ft >>> 8 & 255, $[14] = Ft >>> 16 & 255, $[15] = Ft >>> 24 & 255, $[16] = ge >>> 0 & 255, $[17] = ge >>> 8 & 255, $[18] = ge >>> 16 & 255, $[19] = ge >>> 24 & 255, $[20] = be >>> 0 & 255, $[21] = be >>> 8 & 255, $[22] = be >>> 16 & 255, $[23] = be >>> 24 & 255, $[24] = Te >>> 0 & 255, $[25] = Te >>> 8 & 255, $[26] = Te >>> 16 & 255, $[27] = Te >>> 24 & 255, $[28] = Ee >>> 0 & 255, $[29] = Ee >>> 8 & 255, $[30] = Ee >>> 16 & 255, $[31] = Ee >>> 24 & 255;
    }
    function N($, H, Z, P) {
      A($, H, Z, P);
    }
    function j($, H, Z, P) {
      x($, H, Z, P);
    }
    var K = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function W($, H, Z, P, X, le, ce) {
      var ye = new Uint8Array(16), Ce = new Uint8Array(64), $e, je;
      for (je = 0; je < 16; je++)
        ye[je] = 0;
      for (je = 0; je < 8; je++)
        ye[je] = le[je];
      for (; X >= 64; ) {
        for (N(Ce, ye, ce, K), je = 0; je < 64; je++)
          $[H + je] = Z[P + je] ^ Ce[je];
        for ($e = 1, je = 8; je < 16; je++)
          $e = $e + (ye[je] & 255) | 0, ye[je] = $e & 255, $e >>>= 8;
        X -= 64, H += 64, P += 64;
      }
      if (X > 0)
        for (N(Ce, ye, ce, K), je = 0; je < X; je++)
          $[H + je] = Z[P + je] ^ Ce[je];
      return 0;
    }
    function O($, H, Z, P, X) {
      var le = new Uint8Array(16), ce = new Uint8Array(64), ye, Ce;
      for (Ce = 0; Ce < 16; Ce++)
        le[Ce] = 0;
      for (Ce = 0; Ce < 8; Ce++)
        le[Ce] = P[Ce];
      for (; Z >= 64; ) {
        for (N(ce, le, X, K), Ce = 0; Ce < 64; Ce++)
          $[H + Ce] = ce[Ce];
        for (ye = 1, Ce = 8; Ce < 16; Ce++)
          ye = ye + (le[Ce] & 255) | 0, le[Ce] = ye & 255, ye >>>= 8;
        Z -= 64, H += 64;
      }
      if (Z > 0)
        for (N(ce, le, X, K), Ce = 0; Ce < Z; Ce++)
          $[H + Ce] = ce[Ce];
      return 0;
    }
    function k($, H, Z, P, X) {
      var le = new Uint8Array(32);
      j(le, P, X, K);
      for (var ce = new Uint8Array(8), ye = 0; ye < 8; ye++)
        ce[ye] = P[ye + 16];
      return O($, H, Z, ce, le);
    }
    function z($, H, Z, P, X, le, ce) {
      var ye = new Uint8Array(32);
      j(ye, le, ce, K);
      for (var Ce = new Uint8Array(8), $e = 0; $e < 8; $e++)
        Ce[$e] = le[$e + 16];
      return W($, H, Z, P, X, Ce, ye);
    }
    var C = function($) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var H, Z, P, X, le, ce, ye, Ce;
      H = $[0] & 255 | ($[1] & 255) << 8, this.r[0] = H & 8191, Z = $[2] & 255 | ($[3] & 255) << 8, this.r[1] = (H >>> 13 | Z << 3) & 8191, P = $[4] & 255 | ($[5] & 255) << 8, this.r[2] = (Z >>> 10 | P << 6) & 7939, X = $[6] & 255 | ($[7] & 255) << 8, this.r[3] = (P >>> 7 | X << 9) & 8191, le = $[8] & 255 | ($[9] & 255) << 8, this.r[4] = (X >>> 4 | le << 12) & 255, this.r[5] = le >>> 1 & 8190, ce = $[10] & 255 | ($[11] & 255) << 8, this.r[6] = (le >>> 14 | ce << 2) & 8191, ye = $[12] & 255 | ($[13] & 255) << 8, this.r[7] = (ce >>> 11 | ye << 5) & 8065, Ce = $[14] & 255 | ($[15] & 255) << 8, this.r[8] = (ye >>> 8 | Ce << 8) & 8191, this.r[9] = Ce >>> 5 & 127, this.pad[0] = $[16] & 255 | ($[17] & 255) << 8, this.pad[1] = $[18] & 255 | ($[19] & 255) << 8, this.pad[2] = $[20] & 255 | ($[21] & 255) << 8, this.pad[3] = $[22] & 255 | ($[23] & 255) << 8, this.pad[4] = $[24] & 255 | ($[25] & 255) << 8, this.pad[5] = $[26] & 255 | ($[27] & 255) << 8, this.pad[6] = $[28] & 255 | ($[29] & 255) << 8, this.pad[7] = $[30] & 255 | ($[31] & 255) << 8;
    };
    C.prototype.blocks = function($, H, Z) {
      for (var P = this.fin ? 0 : 2048, X, le, ce, ye, Ce, $e, je, Jt, Xe, Et, At, Bt, Ot, It, Tt, kt, nt, yt, Ye, rt = this.h[0], ct = this.h[1], He = this.h[2], ge = this.h[3], be = this.h[4], Te = this.h[5], Ee = this.h[6], Ie = this.h[7], Ne = this.h[8], St = this.h[9], zt = this.r[0], Lt = this.r[1], Ft = this.r[2], ne = this.r[3], Zt = this.r[4], dn = this.r[5], hn = this.r[6], $t = this.r[7], sn = this.r[8], cn = this.r[9]; Z >= 16; )
        X = $[H + 0] & 255 | ($[H + 1] & 255) << 8, rt += X & 8191, le = $[H + 2] & 255 | ($[H + 3] & 255) << 8, ct += (X >>> 13 | le << 3) & 8191, ce = $[H + 4] & 255 | ($[H + 5] & 255) << 8, He += (le >>> 10 | ce << 6) & 8191, ye = $[H + 6] & 255 | ($[H + 7] & 255) << 8, ge += (ce >>> 7 | ye << 9) & 8191, Ce = $[H + 8] & 255 | ($[H + 9] & 255) << 8, be += (ye >>> 4 | Ce << 12) & 8191, Te += Ce >>> 1 & 8191, $e = $[H + 10] & 255 | ($[H + 11] & 255) << 8, Ee += (Ce >>> 14 | $e << 2) & 8191, je = $[H + 12] & 255 | ($[H + 13] & 255) << 8, Ie += ($e >>> 11 | je << 5) & 8191, Jt = $[H + 14] & 255 | ($[H + 15] & 255) << 8, Ne += (je >>> 8 | Jt << 8) & 8191, St += Jt >>> 5 | P, Xe = 0, Et = Xe, Et += rt * zt, Et += ct * (5 * cn), Et += He * (5 * sn), Et += ge * (5 * $t), Et += be * (5 * hn), Xe = Et >>> 13, Et &= 8191, Et += Te * (5 * dn), Et += Ee * (5 * Zt), Et += Ie * (5 * ne), Et += Ne * (5 * Ft), Et += St * (5 * Lt), Xe += Et >>> 13, Et &= 8191, At = Xe, At += rt * Lt, At += ct * zt, At += He * (5 * cn), At += ge * (5 * sn), At += be * (5 * $t), Xe = At >>> 13, At &= 8191, At += Te * (5 * hn), At += Ee * (5 * dn), At += Ie * (5 * Zt), At += Ne * (5 * ne), At += St * (5 * Ft), Xe += At >>> 13, At &= 8191, Bt = Xe, Bt += rt * Ft, Bt += ct * Lt, Bt += He * zt, Bt += ge * (5 * cn), Bt += be * (5 * sn), Xe = Bt >>> 13, Bt &= 8191, Bt += Te * (5 * $t), Bt += Ee * (5 * hn), Bt += Ie * (5 * dn), Bt += Ne * (5 * Zt), Bt += St * (5 * ne), Xe += Bt >>> 13, Bt &= 8191, Ot = Xe, Ot += rt * ne, Ot += ct * Ft, Ot += He * Lt, Ot += ge * zt, Ot += be * (5 * cn), Xe = Ot >>> 13, Ot &= 8191, Ot += Te * (5 * sn), Ot += Ee * (5 * $t), Ot += Ie * (5 * hn), Ot += Ne * (5 * dn), Ot += St * (5 * Zt), Xe += Ot >>> 13, Ot &= 8191, It = Xe, It += rt * Zt, It += ct * ne, It += He * Ft, It += ge * Lt, It += be * zt, Xe = It >>> 13, It &= 8191, It += Te * (5 * cn), It += Ee * (5 * sn), It += Ie * (5 * $t), It += Ne * (5 * hn), It += St * (5 * dn), Xe += It >>> 13, It &= 8191, Tt = Xe, Tt += rt * dn, Tt += ct * Zt, Tt += He * ne, Tt += ge * Ft, Tt += be * Lt, Xe = Tt >>> 13, Tt &= 8191, Tt += Te * zt, Tt += Ee * (5 * cn), Tt += Ie * (5 * sn), Tt += Ne * (5 * $t), Tt += St * (5 * hn), Xe += Tt >>> 13, Tt &= 8191, kt = Xe, kt += rt * hn, kt += ct * dn, kt += He * Zt, kt += ge * ne, kt += be * Ft, Xe = kt >>> 13, kt &= 8191, kt += Te * Lt, kt += Ee * zt, kt += Ie * (5 * cn), kt += Ne * (5 * sn), kt += St * (5 * $t), Xe += kt >>> 13, kt &= 8191, nt = Xe, nt += rt * $t, nt += ct * hn, nt += He * dn, nt += ge * Zt, nt += be * ne, Xe = nt >>> 13, nt &= 8191, nt += Te * Ft, nt += Ee * Lt, nt += Ie * zt, nt += Ne * (5 * cn), nt += St * (5 * sn), Xe += nt >>> 13, nt &= 8191, yt = Xe, yt += rt * sn, yt += ct * $t, yt += He * hn, yt += ge * dn, yt += be * Zt, Xe = yt >>> 13, yt &= 8191, yt += Te * ne, yt += Ee * Ft, yt += Ie * Lt, yt += Ne * zt, yt += St * (5 * cn), Xe += yt >>> 13, yt &= 8191, Ye = Xe, Ye += rt * cn, Ye += ct * sn, Ye += He * $t, Ye += ge * hn, Ye += be * dn, Xe = Ye >>> 13, Ye &= 8191, Ye += Te * Zt, Ye += Ee * ne, Ye += Ie * Ft, Ye += Ne * Lt, Ye += St * zt, Xe += Ye >>> 13, Ye &= 8191, Xe = (Xe << 2) + Xe | 0, Xe = Xe + Et | 0, Et = Xe & 8191, Xe = Xe >>> 13, At += Xe, rt = Et, ct = At, He = Bt, ge = Ot, be = It, Te = Tt, Ee = kt, Ie = nt, Ne = yt, St = Ye, H += 16, Z -= 16;
      this.h[0] = rt, this.h[1] = ct, this.h[2] = He, this.h[3] = ge, this.h[4] = be, this.h[5] = Te, this.h[6] = Ee, this.h[7] = Ie, this.h[8] = Ne, this.h[9] = St;
    }, C.prototype.finish = function($, H) {
      var Z = new Uint16Array(10), P, X, le, ce;
      if (this.leftover) {
        for (ce = this.leftover, this.buffer[ce++] = 1; ce < 16; ce++)
          this.buffer[ce] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (P = this.h[1] >>> 13, this.h[1] &= 8191, ce = 2; ce < 10; ce++)
        this.h[ce] += P, P = this.h[ce] >>> 13, this.h[ce] &= 8191;
      for (this.h[0] += P * 5, P = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += P, P = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += P, Z[0] = this.h[0] + 5, P = Z[0] >>> 13, Z[0] &= 8191, ce = 1; ce < 10; ce++)
        Z[ce] = this.h[ce] + P, P = Z[ce] >>> 13, Z[ce] &= 8191;
      for (Z[9] -= 8192, X = (P ^ 1) - 1, ce = 0; ce < 10; ce++)
        Z[ce] &= X;
      for (X = ~X, ce = 0; ce < 10; ce++)
        this.h[ce] = this.h[ce] & X | Z[ce];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, le = this.h[0] + this.pad[0], this.h[0] = le & 65535, ce = 1; ce < 8; ce++)
        le = (this.h[ce] + this.pad[ce] | 0) + (le >>> 16) | 0, this.h[ce] = le & 65535;
      $[H + 0] = this.h[0] >>> 0 & 255, $[H + 1] = this.h[0] >>> 8 & 255, $[H + 2] = this.h[1] >>> 0 & 255, $[H + 3] = this.h[1] >>> 8 & 255, $[H + 4] = this.h[2] >>> 0 & 255, $[H + 5] = this.h[2] >>> 8 & 255, $[H + 6] = this.h[3] >>> 0 & 255, $[H + 7] = this.h[3] >>> 8 & 255, $[H + 8] = this.h[4] >>> 0 & 255, $[H + 9] = this.h[4] >>> 8 & 255, $[H + 10] = this.h[5] >>> 0 & 255, $[H + 11] = this.h[5] >>> 8 & 255, $[H + 12] = this.h[6] >>> 0 & 255, $[H + 13] = this.h[6] >>> 8 & 255, $[H + 14] = this.h[7] >>> 0 & 255, $[H + 15] = this.h[7] >>> 8 & 255;
    }, C.prototype.update = function($, H, Z) {
      var P, X;
      if (this.leftover) {
        for (X = 16 - this.leftover, X > Z && (X = Z), P = 0; P < X; P++)
          this.buffer[this.leftover + P] = $[H + P];
        if (Z -= X, H += X, this.leftover += X, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (Z >= 16 && (X = Z - Z % 16, this.blocks($, H, X), H += X, Z -= X), Z) {
        for (P = 0; P < Z; P++)
          this.buffer[this.leftover + P] = $[H + P];
        this.leftover += Z;
      }
    };
    function M($, H, Z, P, X, le) {
      var ce = new C(le);
      return ce.update(Z, P, X), ce.finish($, H), 0;
    }
    function S($, H, Z, P, X, le) {
      var ce = new Uint8Array(16);
      return M(ce, 0, Z, P, X, le), b($, H, ce, 0);
    }
    function p($, H, Z, P, X) {
      var le;
      if (Z < 32)
        return -1;
      for (z($, 0, H, 0, Z, P, X), M($, 16, $, 32, Z - 32, $), le = 0; le < 16; le++)
        $[le] = 0;
      return 0;
    }
    function y($, H, Z, P, X) {
      var le, ce = new Uint8Array(32);
      if (Z < 32 || (k(ce, 0, 32, P, X), S(H, 16, H, 32, Z - 32, ce) !== 0))
        return -1;
      for (z($, 0, H, 0, Z, P, X), le = 0; le < 32; le++)
        $[le] = 0;
      return 0;
    }
    function v($, H) {
      var Z;
      for (Z = 0; Z < 16; Z++)
        $[Z] = H[Z] | 0;
    }
    function E($) {
      var H, Z, P = 1;
      for (H = 0; H < 16; H++)
        Z = $[H] + P + 65535, P = Math.floor(Z / 65536), $[H] = Z - P * 65536;
      $[0] += P - 1 + 37 * (P - 1);
    }
    function B($, H, Z) {
      for (var P, X = ~(Z - 1), le = 0; le < 16; le++)
        P = X & ($[le] ^ H[le]), $[le] ^= P, H[le] ^= P;
    }
    function F($, H) {
      var Z, P, X, le = n(), ce = n();
      for (Z = 0; Z < 16; Z++)
        ce[Z] = H[Z];
      for (E(ce), E(ce), E(ce), P = 0; P < 2; P++) {
        for (le[0] = ce[0] - 65517, Z = 1; Z < 15; Z++)
          le[Z] = ce[Z] - 65535 - (le[Z - 1] >> 16 & 1), le[Z - 1] &= 65535;
        le[15] = ce[15] - 32767 - (le[14] >> 16 & 1), X = le[15] >> 16 & 1, le[14] &= 65535, B(ce, le, 1 - X);
      }
      for (Z = 0; Z < 16; Z++)
        $[2 * Z] = ce[Z] & 255, $[2 * Z + 1] = ce[Z] >> 8;
    }
    function q($, H) {
      var Z = new Uint8Array(32), P = new Uint8Array(32);
      return F(Z, $), F(P, H), I(Z, 0, P, 0);
    }
    function U($) {
      var H = new Uint8Array(32);
      return F(H, $), H[0] & 1;
    }
    function m($, H) {
      var Z;
      for (Z = 0; Z < 16; Z++)
        $[Z] = H[2 * Z] + (H[2 * Z + 1] << 8);
      $[15] &= 32767;
    }
    function D($, H, Z) {
      for (var P = 0; P < 16; P++)
        $[P] = H[P] + Z[P];
    }
    function Y($, H, Z) {
      for (var P = 0; P < 16; P++)
        $[P] = H[P] - Z[P];
    }
    function Q($, H, Z) {
      var P, X, le = 0, ce = 0, ye = 0, Ce = 0, $e = 0, je = 0, Jt = 0, Xe = 0, Et = 0, At = 0, Bt = 0, Ot = 0, It = 0, Tt = 0, kt = 0, nt = 0, yt = 0, Ye = 0, rt = 0, ct = 0, He = 0, ge = 0, be = 0, Te = 0, Ee = 0, Ie = 0, Ne = 0, St = 0, zt = 0, Lt = 0, Ft = 0, ne = Z[0], Zt = Z[1], dn = Z[2], hn = Z[3], $t = Z[4], sn = Z[5], cn = Z[6], Ir = Z[7], Mn = Z[8], mr = Z[9], _r = Z[10], wr = Z[11], Dr = Z[12], ei = Z[13], ti = Z[14], ni = Z[15];
      P = H[0], le += P * ne, ce += P * Zt, ye += P * dn, Ce += P * hn, $e += P * $t, je += P * sn, Jt += P * cn, Xe += P * Ir, Et += P * Mn, At += P * mr, Bt += P * _r, Ot += P * wr, It += P * Dr, Tt += P * ei, kt += P * ti, nt += P * ni, P = H[1], ce += P * ne, ye += P * Zt, Ce += P * dn, $e += P * hn, je += P * $t, Jt += P * sn, Xe += P * cn, Et += P * Ir, At += P * Mn, Bt += P * mr, Ot += P * _r, It += P * wr, Tt += P * Dr, kt += P * ei, nt += P * ti, yt += P * ni, P = H[2], ye += P * ne, Ce += P * Zt, $e += P * dn, je += P * hn, Jt += P * $t, Xe += P * sn, Et += P * cn, At += P * Ir, Bt += P * Mn, Ot += P * mr, It += P * _r, Tt += P * wr, kt += P * Dr, nt += P * ei, yt += P * ti, Ye += P * ni, P = H[3], Ce += P * ne, $e += P * Zt, je += P * dn, Jt += P * hn, Xe += P * $t, Et += P * sn, At += P * cn, Bt += P * Ir, Ot += P * Mn, It += P * mr, Tt += P * _r, kt += P * wr, nt += P * Dr, yt += P * ei, Ye += P * ti, rt += P * ni, P = H[4], $e += P * ne, je += P * Zt, Jt += P * dn, Xe += P * hn, Et += P * $t, At += P * sn, Bt += P * cn, Ot += P * Ir, It += P * Mn, Tt += P * mr, kt += P * _r, nt += P * wr, yt += P * Dr, Ye += P * ei, rt += P * ti, ct += P * ni, P = H[5], je += P * ne, Jt += P * Zt, Xe += P * dn, Et += P * hn, At += P * $t, Bt += P * sn, Ot += P * cn, It += P * Ir, Tt += P * Mn, kt += P * mr, nt += P * _r, yt += P * wr, Ye += P * Dr, rt += P * ei, ct += P * ti, He += P * ni, P = H[6], Jt += P * ne, Xe += P * Zt, Et += P * dn, At += P * hn, Bt += P * $t, Ot += P * sn, It += P * cn, Tt += P * Ir, kt += P * Mn, nt += P * mr, yt += P * _r, Ye += P * wr, rt += P * Dr, ct += P * ei, He += P * ti, ge += P * ni, P = H[7], Xe += P * ne, Et += P * Zt, At += P * dn, Bt += P * hn, Ot += P * $t, It += P * sn, Tt += P * cn, kt += P * Ir, nt += P * Mn, yt += P * mr, Ye += P * _r, rt += P * wr, ct += P * Dr, He += P * ei, ge += P * ti, be += P * ni, P = H[8], Et += P * ne, At += P * Zt, Bt += P * dn, Ot += P * hn, It += P * $t, Tt += P * sn, kt += P * cn, nt += P * Ir, yt += P * Mn, Ye += P * mr, rt += P * _r, ct += P * wr, He += P * Dr, ge += P * ei, be += P * ti, Te += P * ni, P = H[9], At += P * ne, Bt += P * Zt, Ot += P * dn, It += P * hn, Tt += P * $t, kt += P * sn, nt += P * cn, yt += P * Ir, Ye += P * Mn, rt += P * mr, ct += P * _r, He += P * wr, ge += P * Dr, be += P * ei, Te += P * ti, Ee += P * ni, P = H[10], Bt += P * ne, Ot += P * Zt, It += P * dn, Tt += P * hn, kt += P * $t, nt += P * sn, yt += P * cn, Ye += P * Ir, rt += P * Mn, ct += P * mr, He += P * _r, ge += P * wr, be += P * Dr, Te += P * ei, Ee += P * ti, Ie += P * ni, P = H[11], Ot += P * ne, It += P * Zt, Tt += P * dn, kt += P * hn, nt += P * $t, yt += P * sn, Ye += P * cn, rt += P * Ir, ct += P * Mn, He += P * mr, ge += P * _r, be += P * wr, Te += P * Dr, Ee += P * ei, Ie += P * ti, Ne += P * ni, P = H[12], It += P * ne, Tt += P * Zt, kt += P * dn, nt += P * hn, yt += P * $t, Ye += P * sn, rt += P * cn, ct += P * Ir, He += P * Mn, ge += P * mr, be += P * _r, Te += P * wr, Ee += P * Dr, Ie += P * ei, Ne += P * ti, St += P * ni, P = H[13], Tt += P * ne, kt += P * Zt, nt += P * dn, yt += P * hn, Ye += P * $t, rt += P * sn, ct += P * cn, He += P * Ir, ge += P * Mn, be += P * mr, Te += P * _r, Ee += P * wr, Ie += P * Dr, Ne += P * ei, St += P * ti, zt += P * ni, P = H[14], kt += P * ne, nt += P * Zt, yt += P * dn, Ye += P * hn, rt += P * $t, ct += P * sn, He += P * cn, ge += P * Ir, be += P * Mn, Te += P * mr, Ee += P * _r, Ie += P * wr, Ne += P * Dr, St += P * ei, zt += P * ti, Lt += P * ni, P = H[15], nt += P * ne, yt += P * Zt, Ye += P * dn, rt += P * hn, ct += P * $t, He += P * sn, ge += P * cn, be += P * Ir, Te += P * Mn, Ee += P * mr, Ie += P * _r, Ne += P * wr, St += P * Dr, zt += P * ei, Lt += P * ti, Ft += P * ni, le += 38 * yt, ce += 38 * Ye, ye += 38 * rt, Ce += 38 * ct, $e += 38 * He, je += 38 * ge, Jt += 38 * be, Xe += 38 * Te, Et += 38 * Ee, At += 38 * Ie, Bt += 38 * Ne, Ot += 38 * St, It += 38 * zt, Tt += 38 * Lt, kt += 38 * Ft, X = 1, P = le + X + 65535, X = Math.floor(P / 65536), le = P - X * 65536, P = ce + X + 65535, X = Math.floor(P / 65536), ce = P - X * 65536, P = ye + X + 65535, X = Math.floor(P / 65536), ye = P - X * 65536, P = Ce + X + 65535, X = Math.floor(P / 65536), Ce = P - X * 65536, P = $e + X + 65535, X = Math.floor(P / 65536), $e = P - X * 65536, P = je + X + 65535, X = Math.floor(P / 65536), je = P - X * 65536, P = Jt + X + 65535, X = Math.floor(P / 65536), Jt = P - X * 65536, P = Xe + X + 65535, X = Math.floor(P / 65536), Xe = P - X * 65536, P = Et + X + 65535, X = Math.floor(P / 65536), Et = P - X * 65536, P = At + X + 65535, X = Math.floor(P / 65536), At = P - X * 65536, P = Bt + X + 65535, X = Math.floor(P / 65536), Bt = P - X * 65536, P = Ot + X + 65535, X = Math.floor(P / 65536), Ot = P - X * 65536, P = It + X + 65535, X = Math.floor(P / 65536), It = P - X * 65536, P = Tt + X + 65535, X = Math.floor(P / 65536), Tt = P - X * 65536, P = kt + X + 65535, X = Math.floor(P / 65536), kt = P - X * 65536, P = nt + X + 65535, X = Math.floor(P / 65536), nt = P - X * 65536, le += X - 1 + 37 * (X - 1), X = 1, P = le + X + 65535, X = Math.floor(P / 65536), le = P - X * 65536, P = ce + X + 65535, X = Math.floor(P / 65536), ce = P - X * 65536, P = ye + X + 65535, X = Math.floor(P / 65536), ye = P - X * 65536, P = Ce + X + 65535, X = Math.floor(P / 65536), Ce = P - X * 65536, P = $e + X + 65535, X = Math.floor(P / 65536), $e = P - X * 65536, P = je + X + 65535, X = Math.floor(P / 65536), je = P - X * 65536, P = Jt + X + 65535, X = Math.floor(P / 65536), Jt = P - X * 65536, P = Xe + X + 65535, X = Math.floor(P / 65536), Xe = P - X * 65536, P = Et + X + 65535, X = Math.floor(P / 65536), Et = P - X * 65536, P = At + X + 65535, X = Math.floor(P / 65536), At = P - X * 65536, P = Bt + X + 65535, X = Math.floor(P / 65536), Bt = P - X * 65536, P = Ot + X + 65535, X = Math.floor(P / 65536), Ot = P - X * 65536, P = It + X + 65535, X = Math.floor(P / 65536), It = P - X * 65536, P = Tt + X + 65535, X = Math.floor(P / 65536), Tt = P - X * 65536, P = kt + X + 65535, X = Math.floor(P / 65536), kt = P - X * 65536, P = nt + X + 65535, X = Math.floor(P / 65536), nt = P - X * 65536, le += X - 1 + 37 * (X - 1), $[0] = le, $[1] = ce, $[2] = ye, $[3] = Ce, $[4] = $e, $[5] = je, $[6] = Jt, $[7] = Xe, $[8] = Et, $[9] = At, $[10] = Bt, $[11] = Ot, $[12] = It, $[13] = Tt, $[14] = kt, $[15] = nt;
    }
    function G($, H) {
      Q($, H, H);
    }
    function he($, H) {
      var Z = n(), P;
      for (P = 0; P < 16; P++)
        Z[P] = H[P];
      for (P = 253; P >= 0; P--)
        G(Z, Z), P !== 2 && P !== 4 && Q(Z, Z, H);
      for (P = 0; P < 16; P++)
        $[P] = Z[P];
    }
    function se($, H) {
      var Z = n(), P;
      for (P = 0; P < 16; P++)
        Z[P] = H[P];
      for (P = 250; P >= 0; P--)
        G(Z, Z), P !== 1 && Q(Z, Z, H);
      for (P = 0; P < 16; P++)
        $[P] = Z[P];
    }
    function _e($, H, Z) {
      var P = new Uint8Array(32), X = new Float64Array(80), le, ce, ye = n(), Ce = n(), $e = n(), je = n(), Jt = n(), Xe = n();
      for (ce = 0; ce < 31; ce++)
        P[ce] = H[ce];
      for (P[31] = H[31] & 127 | 64, P[0] &= 248, m(X, Z), ce = 0; ce < 16; ce++)
        Ce[ce] = X[ce], je[ce] = ye[ce] = $e[ce] = 0;
      for (ye[0] = je[0] = 1, ce = 254; ce >= 0; --ce)
        le = P[ce >>> 3] >>> (ce & 7) & 1, B(ye, Ce, le), B($e, je, le), D(Jt, ye, $e), Y(ye, ye, $e), D($e, Ce, je), Y(Ce, Ce, je), G(je, Jt), G(Xe, ye), Q(ye, $e, ye), Q($e, Ce, Jt), D(Jt, ye, $e), Y(ye, ye, $e), G(Ce, ye), Y($e, je, Xe), Q(ye, $e, c), D(ye, ye, je), Q($e, $e, ye), Q(ye, je, Xe), Q(je, Ce, X), G(Ce, Jt), B(ye, Ce, le), B($e, je, le);
      for (ce = 0; ce < 16; ce++)
        X[ce + 16] = ye[ce], X[ce + 32] = $e[ce], X[ce + 48] = Ce[ce], X[ce + 64] = je[ce];
      var Et = X.subarray(32), At = X.subarray(16);
      return he(Et, Et), Q(At, At, Et), F($, At), 0;
    }
    function Me($, H) {
      return _e($, H, o);
    }
    function Pe($, H) {
      return r(H, 32), Me($, H);
    }
    function Be($, H, Z) {
      var P = new Uint8Array(32);
      return _e(P, Z, H), j($, i, P, K);
    }
    var at = p, Fe = y;
    function Re($, H, Z, P, X, le) {
      var ce = new Uint8Array(32);
      return Be(ce, X, le), at($, H, Z, P, ce);
    }
    function Nt($, H, Z, P, X, le) {
      var ce = new Uint8Array(32);
      return Be(ce, X, le), Fe($, H, Z, P, ce);
    }
    var qe = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function _t($, H, Z, P) {
      for (var X = new Int32Array(16), le = new Int32Array(16), ce, ye, Ce, $e, je, Jt, Xe, Et, At, Bt, Ot, It, Tt, kt, nt, yt, Ye, rt, ct, He, ge, be, Te, Ee, Ie, Ne, St = $[0], zt = $[1], Lt = $[2], Ft = $[3], ne = $[4], Zt = $[5], dn = $[6], hn = $[7], $t = H[0], sn = H[1], cn = H[2], Ir = H[3], Mn = H[4], mr = H[5], _r = H[6], wr = H[7], Dr = 0; P >= 128; ) {
        for (ct = 0; ct < 16; ct++)
          He = 8 * ct + Dr, X[ct] = Z[He + 0] << 24 | Z[He + 1] << 16 | Z[He + 2] << 8 | Z[He + 3], le[ct] = Z[He + 4] << 24 | Z[He + 5] << 16 | Z[He + 6] << 8 | Z[He + 7];
        for (ct = 0; ct < 80; ct++)
          if (ce = St, ye = zt, Ce = Lt, $e = Ft, je = ne, Jt = Zt, Xe = dn, Et = hn, At = $t, Bt = sn, Ot = cn, It = Ir, Tt = Mn, kt = mr, nt = _r, yt = wr, ge = hn, be = wr, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = (ne >>> 14 | Mn << 32 - 14) ^ (ne >>> 18 | Mn << 32 - 18) ^ (Mn >>> 41 - 32 | ne << 32 - (41 - 32)), be = (Mn >>> 14 | ne << 32 - 14) ^ (Mn >>> 18 | ne << 32 - 18) ^ (ne >>> 41 - 32 | Mn << 32 - (41 - 32)), Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, ge = ne & Zt ^ ~ne & dn, be = Mn & mr ^ ~Mn & _r, Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, ge = qe[ct * 2], be = qe[ct * 2 + 1], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, ge = X[ct % 16], be = le[ct % 16], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, Ye = Ie & 65535 | Ne << 16, rt = Te & 65535 | Ee << 16, ge = Ye, be = rt, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = (St >>> 28 | $t << 32 - 28) ^ ($t >>> 34 - 32 | St << 32 - (34 - 32)) ^ ($t >>> 39 - 32 | St << 32 - (39 - 32)), be = ($t >>> 28 | St << 32 - 28) ^ (St >>> 34 - 32 | $t << 32 - (34 - 32)) ^ (St >>> 39 - 32 | $t << 32 - (39 - 32)), Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, ge = St & zt ^ St & Lt ^ zt & Lt, be = $t & sn ^ $t & cn ^ sn & cn, Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, Et = Ie & 65535 | Ne << 16, yt = Te & 65535 | Ee << 16, ge = $e, be = It, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = Ye, be = rt, Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, $e = Ie & 65535 | Ne << 16, It = Te & 65535 | Ee << 16, zt = ce, Lt = ye, Ft = Ce, ne = $e, Zt = je, dn = Jt, hn = Xe, St = Et, sn = At, cn = Bt, Ir = Ot, Mn = It, mr = Tt, _r = kt, wr = nt, $t = yt, ct % 16 === 15)
            for (He = 0; He < 16; He++)
              ge = X[He], be = le[He], Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = X[(He + 9) % 16], be = le[(He + 9) % 16], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ye = X[(He + 1) % 16], rt = le[(He + 1) % 16], ge = (Ye >>> 1 | rt << 32 - 1) ^ (Ye >>> 8 | rt << 32 - 8) ^ Ye >>> 7, be = (rt >>> 1 | Ye << 32 - 1) ^ (rt >>> 8 | Ye << 32 - 8) ^ (rt >>> 7 | Ye << 32 - 7), Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ye = X[(He + 14) % 16], rt = le[(He + 14) % 16], ge = (Ye >>> 19 | rt << 32 - 19) ^ (rt >>> 61 - 32 | Ye << 32 - (61 - 32)) ^ Ye >>> 6, be = (rt >>> 19 | Ye << 32 - 19) ^ (Ye >>> 61 - 32 | rt << 32 - (61 - 32)) ^ (rt >>> 6 | Ye << 32 - 6), Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, X[He] = Ie & 65535 | Ne << 16, le[He] = Te & 65535 | Ee << 16;
        ge = St, be = $t, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = $[0], be = H[0], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, $[0] = St = Ie & 65535 | Ne << 16, H[0] = $t = Te & 65535 | Ee << 16, ge = zt, be = sn, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = $[1], be = H[1], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, $[1] = zt = Ie & 65535 | Ne << 16, H[1] = sn = Te & 65535 | Ee << 16, ge = Lt, be = cn, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = $[2], be = H[2], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, $[2] = Lt = Ie & 65535 | Ne << 16, H[2] = cn = Te & 65535 | Ee << 16, ge = Ft, be = Ir, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = $[3], be = H[3], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, $[3] = Ft = Ie & 65535 | Ne << 16, H[3] = Ir = Te & 65535 | Ee << 16, ge = ne, be = Mn, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = $[4], be = H[4], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, $[4] = ne = Ie & 65535 | Ne << 16, H[4] = Mn = Te & 65535 | Ee << 16, ge = Zt, be = mr, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = $[5], be = H[5], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, $[5] = Zt = Ie & 65535 | Ne << 16, H[5] = mr = Te & 65535 | Ee << 16, ge = dn, be = _r, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = $[6], be = H[6], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, $[6] = dn = Ie & 65535 | Ne << 16, H[6] = _r = Te & 65535 | Ee << 16, ge = hn, be = wr, Te = be & 65535, Ee = be >>> 16, Ie = ge & 65535, Ne = ge >>> 16, ge = $[7], be = H[7], Te += be & 65535, Ee += be >>> 16, Ie += ge & 65535, Ne += ge >>> 16, Ee += Te >>> 16, Ie += Ee >>> 16, Ne += Ie >>> 16, $[7] = hn = Ie & 65535 | Ne << 16, H[7] = wr = Te & 65535 | Ee << 16, Dr += 128, P -= 128;
      }
      return P;
    }
    function ve($, H, Z) {
      var P = new Int32Array(8), X = new Int32Array(8), le = new Uint8Array(256), ce, ye = Z;
      for (P[0] = 1779033703, P[1] = 3144134277, P[2] = 1013904242, P[3] = 2773480762, P[4] = 1359893119, P[5] = 2600822924, P[6] = 528734635, P[7] = 1541459225, X[0] = 4089235720, X[1] = 2227873595, X[2] = 4271175723, X[3] = 1595750129, X[4] = 2917565137, X[5] = 725511199, X[6] = 4215389547, X[7] = 327033209, _t(P, X, H, Z), Z %= 128, ce = 0; ce < Z; ce++)
        le[ce] = H[ye - Z + ce];
      for (le[Z] = 128, Z = 256 - 128 * (Z < 112 ? 1 : 0), le[Z - 9] = 0, g(le, Z - 8, ye / 536870912 | 0, ye << 3), _t(P, X, le, Z), ce = 0; ce < 8; ce++)
        g($, 8 * ce, P[ce], X[ce]);
      return 0;
    }
    function mt($, H) {
      var Z = n(), P = n(), X = n(), le = n(), ce = n(), ye = n(), Ce = n(), $e = n(), je = n();
      Y(Z, $[1], $[0]), Y(je, H[1], H[0]), Q(Z, Z, je), D(P, $[0], $[1]), D(je, H[0], H[1]), Q(P, P, je), Q(X, $[3], H[3]), Q(X, X, u), Q(le, $[2], H[2]), D(le, le, le), Y(ce, P, Z), Y(ye, le, X), D(Ce, le, X), D($e, P, Z), Q($[0], ce, ye), Q($[1], $e, Ce), Q($[2], Ce, ye), Q($[3], ce, $e);
    }
    function Gt($, H, Z) {
      var P;
      for (P = 0; P < 4; P++)
        B($[P], H[P], Z);
    }
    function ue($, H) {
      var Z = n(), P = n(), X = n();
      he(X, H[2]), Q(Z, H[0], X), Q(P, H[1], X), F($, P), $[31] ^= U(Z) << 7;
    }
    function fe($, H, Z) {
      var P, X;
      for (v($[0], a), v($[1], s), v($[2], s), v($[3], a), X = 255; X >= 0; --X)
        P = Z[X / 8 | 0] >> (X & 7) & 1, Gt($, H, P), mt(H, $), mt($, $), Gt($, H, P);
    }
    function me($, H) {
      var Z = [n(), n(), n(), n()];
      v(Z[0], f), v(Z[1], d), v(Z[2], s), Q(Z[3], f, d), fe($, Z, H);
    }
    function De($, H, Z) {
      var P = new Uint8Array(64), X = [n(), n(), n(), n()], le;
      for (Z || r(H, 32), ve(P, H, 32), P[0] &= 248, P[31] &= 127, P[31] |= 64, me(X, P), ue($, X), le = 0; le < 32; le++)
        H[le + 32] = $[le];
      return 0;
    }
    var ze = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function L($, H) {
      var Z, P, X, le;
      for (P = 63; P >= 32; --P) {
        for (Z = 0, X = P - 32, le = P - 12; X < le; ++X)
          H[X] += Z - 16 * H[P] * ze[X - (P - 32)], Z = Math.floor((H[X] + 128) / 256), H[X] -= Z * 256;
        H[X] += Z, H[P] = 0;
      }
      for (Z = 0, X = 0; X < 32; X++)
        H[X] += Z - (H[31] >> 4) * ze[X], Z = H[X] >> 8, H[X] &= 255;
      for (X = 0; X < 32; X++)
        H[X] -= Z * ze[X];
      for (P = 0; P < 32; P++)
        H[P + 1] += H[P] >> 8, $[P] = H[P] & 255;
    }
    function T($) {
      var H = new Float64Array(64), Z;
      for (Z = 0; Z < 64; Z++)
        H[Z] = $[Z];
      for (Z = 0; Z < 64; Z++)
        $[Z] = 0;
      L($, H);
    }
    function R($, H, Z, P) {
      var X = new Uint8Array(64), le = new Uint8Array(64), ce = new Uint8Array(64), ye, Ce, $e = new Float64Array(64), je = [n(), n(), n(), n()];
      ve(X, P, 32), X[0] &= 248, X[31] &= 127, X[31] |= 64;
      var Jt = Z + 64;
      for (ye = 0; ye < Z; ye++)
        $[64 + ye] = H[ye];
      for (ye = 0; ye < 32; ye++)
        $[32 + ye] = X[32 + ye];
      for (ve(ce, $.subarray(32), Z + 32), T(ce), me(je, ce), ue($, je), ye = 32; ye < 64; ye++)
        $[ye] = P[ye];
      for (ve(le, $, Z + 64), T(le), ye = 0; ye < 64; ye++)
        $e[ye] = 0;
      for (ye = 0; ye < 32; ye++)
        $e[ye] = ce[ye];
      for (ye = 0; ye < 32; ye++)
        for (Ce = 0; Ce < 32; Ce++)
          $e[ye + Ce] += le[ye] * X[Ce];
      return L($.subarray(32), $e), Jt;
    }
    function J($, H) {
      var Z = n(), P = n(), X = n(), le = n(), ce = n(), ye = n(), Ce = n();
      return v($[2], s), m($[1], H), G(X, $[1]), Q(le, X, l), Y(X, X, $[2]), D(le, $[2], le), G(ce, le), G(ye, ce), Q(Ce, ye, ce), Q(Z, Ce, X), Q(Z, Z, le), se(Z, Z), Q(Z, Z, X), Q(Z, Z, le), Q(Z, Z, le), Q($[0], Z, le), G(P, $[0]), Q(P, P, le), q(P, X) && Q($[0], $[0], h), G(P, $[0]), Q(P, P, le), q(P, X) ? -1 : (U($[0]) === H[31] >> 7 && Y($[0], a, $[0]), Q($[3], $[0], $[1]), 0);
    }
    function te($, H, Z, P) {
      var X, le = new Uint8Array(32), ce = new Uint8Array(64), ye = [n(), n(), n(), n()], Ce = [n(), n(), n(), n()];
      if (Z < 64 || J(Ce, P))
        return -1;
      for (X = 0; X < Z; X++)
        $[X] = H[X];
      for (X = 0; X < 32; X++)
        $[X + 32] = P[X];
      if (ve(ce, $, Z), T(ce), fe(ye, Ce, ce), me(Ce, H.subarray(32)), mt(ye, Ce), ue(le, ye), Z -= 64, I(H, 0, le, 0)) {
        for (X = 0; X < Z; X++)
          $[X] = 0;
        return -1;
      }
      for (X = 0; X < Z; X++)
        $[X] = H[X + 64];
      return Z;
    }
    var re = 32, de = 24, et = 32, st = 16, tt = 32, Yt = 32, gt = 32, Rn = 32, Ho = 32, Yn = de, Zn = et, bu = st, fn = 64, vn = 32, Zi = 64, Ln = 32, $n = 64;
    t.lowlevel = {
      crypto_core_hsalsa20: j,
      crypto_stream_xor: z,
      crypto_stream: k,
      crypto_stream_salsa20_xor: W,
      crypto_stream_salsa20: O,
      crypto_onetimeauth: M,
      crypto_onetimeauth_verify: S,
      crypto_verify_16: b,
      crypto_verify_32: I,
      crypto_secretbox: p,
      crypto_secretbox_open: y,
      crypto_scalarmult: _e,
      crypto_scalarmult_base: Me,
      crypto_box_beforenm: Be,
      crypto_box_afternm: at,
      crypto_box: Re,
      crypto_box_open: Nt,
      crypto_box_keypair: Pe,
      crypto_hash: ve,
      crypto_sign: R,
      crypto_sign_keypair: De,
      crypto_sign_open: te,
      crypto_secretbox_KEYBYTES: re,
      crypto_secretbox_NONCEBYTES: de,
      crypto_secretbox_ZEROBYTES: et,
      crypto_secretbox_BOXZEROBYTES: st,
      crypto_scalarmult_BYTES: tt,
      crypto_scalarmult_SCALARBYTES: Yt,
      crypto_box_PUBLICKEYBYTES: gt,
      crypto_box_SECRETKEYBYTES: Rn,
      crypto_box_BEFORENMBYTES: Ho,
      crypto_box_NONCEBYTES: Yn,
      crypto_box_ZEROBYTES: Zn,
      crypto_box_BOXZEROBYTES: bu,
      crypto_sign_BYTES: fn,
      crypto_sign_PUBLICKEYBYTES: vn,
      crypto_sign_SECRETKEYBYTES: Zi,
      crypto_sign_SEEDBYTES: Ln,
      crypto_hash_BYTES: $n,
      gf: n,
      D: l,
      L: ze,
      pack25519: F,
      unpack25519: m,
      M: Q,
      A: D,
      S: G,
      Z: Y,
      pow2523: se,
      add: mt,
      set25519: v,
      modL: L,
      scalarmult: fe,
      scalarbase: me
    };
    function ts($, H) {
      if ($.length !== re)
        throw new Error("bad key size");
      if (H.length !== de)
        throw new Error("bad nonce size");
    }
    function Jn($, H) {
      if ($.length !== gt)
        throw new Error("bad public key size");
      if (H.length !== Rn)
        throw new Error("bad secret key size");
    }
    function en() {
      for (var $ = 0; $ < arguments.length; $++)
        if (!(arguments[$] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function ns($) {
      for (var H = 0; H < $.length; H++)
        $[H] = 0;
    }
    t.randomBytes = function($) {
      var H = new Uint8Array($);
      return r(H, $), H;
    }, t.secretbox = function($, H, Z) {
      en($, H, Z), ts(Z, H);
      for (var P = new Uint8Array(et + $.length), X = new Uint8Array(P.length), le = 0; le < $.length; le++)
        P[le + et] = $[le];
      return p(X, P, P.length, H, Z), X.subarray(st);
    }, t.secretbox.open = function($, H, Z) {
      en($, H, Z), ts(Z, H);
      for (var P = new Uint8Array(st + $.length), X = new Uint8Array(P.length), le = 0; le < $.length; le++)
        P[le + st] = $[le];
      return P.length < 32 || y(X, P, P.length, H, Z) !== 0 ? null : X.subarray(et);
    }, t.secretbox.keyLength = re, t.secretbox.nonceLength = de, t.secretbox.overheadLength = st, t.scalarMult = function($, H) {
      if (en($, H), $.length !== Yt)
        throw new Error("bad n size");
      if (H.length !== tt)
        throw new Error("bad p size");
      var Z = new Uint8Array(tt);
      return _e(Z, $, H), Z;
    }, t.scalarMult.base = function($) {
      if (en($), $.length !== Yt)
        throw new Error("bad n size");
      var H = new Uint8Array(tt);
      return Me(H, $), H;
    }, t.scalarMult.scalarLength = Yt, t.scalarMult.groupElementLength = tt, t.box = function($, H, Z, P) {
      var X = t.box.before(Z, P);
      return t.secretbox($, H, X);
    }, t.box.before = function($, H) {
      en($, H), Jn($, H);
      var Z = new Uint8Array(Ho);
      return Be(Z, $, H), Z;
    }, t.box.after = t.secretbox, t.box.open = function($, H, Z, P) {
      var X = t.box.before(Z, P);
      return t.secretbox.open($, H, X);
    }, t.box.open.after = t.secretbox.open, t.box.keyPair = function() {
      var $ = new Uint8Array(gt), H = new Uint8Array(Rn);
      return Pe($, H), { publicKey: $, secretKey: H };
    }, t.box.keyPair.fromSecretKey = function($) {
      if (en($), $.length !== Rn)
        throw new Error("bad secret key size");
      var H = new Uint8Array(gt);
      return Me(H, $), { publicKey: H, secretKey: new Uint8Array($) };
    }, t.box.publicKeyLength = gt, t.box.secretKeyLength = Rn, t.box.sharedKeyLength = Ho, t.box.nonceLength = Yn, t.box.overheadLength = t.secretbox.overheadLength, t.sign = function($, H) {
      if (en($, H), H.length !== Zi)
        throw new Error("bad secret key size");
      var Z = new Uint8Array(fn + $.length);
      return R(Z, $, $.length, H), Z;
    }, t.sign.open = function($, H) {
      if (en($, H), H.length !== vn)
        throw new Error("bad public key size");
      var Z = new Uint8Array($.length), P = te(Z, $, $.length, H);
      if (P < 0)
        return null;
      for (var X = new Uint8Array(P), le = 0; le < X.length; le++)
        X[le] = Z[le];
      return X;
    }, t.sign.detached = function($, H) {
      for (var Z = t.sign($, H), P = new Uint8Array(fn), X = 0; X < P.length; X++)
        P[X] = Z[X];
      return P;
    }, t.sign.detached.verify = function($, H, Z) {
      if (en($, H, Z), H.length !== fn)
        throw new Error("bad signature size");
      if (Z.length !== vn)
        throw new Error("bad public key size");
      var P = new Uint8Array(fn + $.length), X = new Uint8Array(fn + $.length), le;
      for (le = 0; le < fn; le++)
        P[le] = H[le];
      for (le = 0; le < $.length; le++)
        P[le + fn] = $[le];
      return te(X, P, P.length, Z) >= 0;
    }, t.sign.keyPair = function() {
      var $ = new Uint8Array(vn), H = new Uint8Array(Zi);
      return De($, H), { publicKey: $, secretKey: H };
    }, t.sign.keyPair.fromSecretKey = function($) {
      if (en($), $.length !== Zi)
        throw new Error("bad secret key size");
      for (var H = new Uint8Array(vn), Z = 0; Z < H.length; Z++)
        H[Z] = $[32 + Z];
      return { publicKey: H, secretKey: new Uint8Array($) };
    }, t.sign.keyPair.fromSeed = function($) {
      if (en($), $.length !== Ln)
        throw new Error("bad seed size");
      for (var H = new Uint8Array(vn), Z = new Uint8Array(Zi), P = 0; P < 32; P++)
        Z[P] = $[P];
      return De(H, Z, !0), { publicKey: H, secretKey: Z };
    }, t.sign.publicKeyLength = vn, t.sign.secretKeyLength = Zi, t.sign.seedLength = Ln, t.sign.signatureLength = fn, t.hash = function($) {
      en($);
      var H = new Uint8Array($n);
      return ve(H, $, $.length), H;
    }, t.hash.hashLength = $n, t.verify = function($, H) {
      return en($, H), $.length === 0 || H.length === 0 || $.length !== H.length ? !1 : w($, 0, H, 0, $.length) === 0;
    }, t.setPRNG = function($) {
      r = $;
    }, function() {
      var $ = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if ($ && $.getRandomValues) {
        var H = 65536;
        t.setPRNG(function(Z, P) {
          var X, le = new Uint8Array(P);
          for (X = 0; X < P; X += H)
            $.getRandomValues(le.subarray(X, X + Math.min(P - X, H)));
          for (X = 0; X < P; X++)
            Z[X] = le[X];
          ns(le);
        });
      } else
        typeof UW < "u" && ($ = R3, $ && $.randomBytes && t.setPRNG(function(Z, P) {
          var X, le = $.randomBytes(P);
          for (X = 0; X < P; X++)
            Z[X] = le[X];
          ns(le);
        }));
    }();
  })(e.exports ? e.exports : self.nacl = self.nacl || {});
})(WC);
var nk = WC.exports;
const fg = /* @__PURE__ */ Vi(nk);
var Td = {}, zW = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Td, "__esModule", { value: !0 });
Td.PublicKey = void 0;
const FW = bo, Sv = Sr, LW = zW(nk), jb = Gm;
function $W(e) {
  switch (e) {
    case jb.KeyType.ED25519:
      return "ed25519";
    default:
      throw new Error(`Unknown key type ${e}`);
  }
}
function WW(e) {
  switch (e.toLowerCase()) {
    case "ed25519":
      return jb.KeyType.ED25519;
    default:
      throw new Error(`Unknown key type ${e}`);
  }
}
let KW = class tb extends FW.Assignable {
  static from(t) {
    return typeof t == "string" ? tb.fromString(t) : t;
  }
  static fromString(t) {
    const n = t.split(":");
    if (n.length === 1)
      return new tb({ keyType: jb.KeyType.ED25519, data: (0, Sv.baseDecode)(n[0]) });
    if (n.length === 2)
      return new tb({ keyType: WW(n[0]), data: (0, Sv.baseDecode)(n[1]) });
    throw new Error("Invalid encoded key format, must be <curve>:<encoded key>");
  }
  toString() {
    return `${$W(this.keyType)}:${(0, Sv.baseEncode)(this.data)}`;
  }
  verify(t, n) {
    switch (this.keyType) {
      case jb.KeyType.ED25519:
        return LW.default.sign.detached.verify(t, n, this.data);
      default:
        throw new Error(`Unknown key type ${this.keyType}`);
    }
  }
};
Td.PublicKey = KW;
var VW = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(kd, "__esModule", { value: !0 });
kd.KeyPairEd25519 = void 0;
const Ev = Sr, Av = VW(nk), qW = Gm, HW = Id, GW = Td;
class rk extends HW.KeyPairBase {
  /**
   * Construct an instance of key pair given a secret key.
   * It's generally assumed that these are encoded in base58.
   * @param {string} secretKey
   */
  constructor(t) {
    super();
    const n = Av.default.sign.keyPair.fromSecretKey((0, Ev.baseDecode)(t));
    this.publicKey = new GW.PublicKey({ keyType: qW.KeyType.ED25519, data: n.publicKey }), this.secretKey = t;
  }
  /**
   * Generate a new random keypair.
   * @example
   * const keyRandom = KeyPair.fromRandom();
   * keyRandom.publicKey
   * // returns [PUBLIC_KEY]
   *
   * keyRandom.secretKey
   * // returns [SECRET_KEY]
   */
  static fromRandom() {
    const t = Av.default.sign.keyPair();
    return new rk((0, Ev.baseEncode)(t.secretKey));
  }
  sign(t) {
    return { signature: Av.default.sign.detached(t, (0, Ev.baseDecode)(this.secretKey)), publicKey: this.publicKey };
  }
  verify(t, n) {
    return this.publicKey.verify(t, n);
  }
  toString() {
    return `ed25519:${this.secretKey}`;
  }
  getPublicKey() {
    return this.publicKey;
  }
}
kd.KeyPairEd25519 = rk;
Object.defineProperty(Ym, "__esModule", { value: !0 });
Ym.KeyPair = void 0;
const YW = Id, Iv = kd;
class ZW extends YW.KeyPairBase {
  /**
   * @param curve Name of elliptical curve, case-insensitive
   * @returns Random KeyPair based on the curve
   */
  static fromRandom(t) {
    switch (t.toUpperCase()) {
      case "ED25519":
        return Iv.KeyPairEd25519.fromRandom();
      default:
        throw new Error(`Unknown curve ${t}`);
    }
  }
  static fromString(t) {
    const n = t.split(":");
    if (n.length === 1)
      return new Iv.KeyPairEd25519(n[0]);
    if (n.length === 2)
      switch (n[0].toUpperCase()) {
        case "ED25519":
          return new Iv.KeyPairEd25519(n[1]);
        default:
          throw new Error(`Unknown curve: ${n[0]}`);
      }
    else
      throw new Error("Invalid encoded key format, must be <curve>:<encoded key>");
  }
}
Ym.KeyPair = ZW;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.PublicKey = e.KeyPairEd25519 = e.KeyPair = e.KeyType = void 0;
  var t = Gm;
  Object.defineProperty(e, "KeyType", { enumerable: !0, get: function() {
    return t.KeyType;
  } });
  var n = Ym;
  Object.defineProperty(e, "KeyPair", { enumerable: !0, get: function() {
    return n.KeyPair;
  } });
  var r = kd;
  Object.defineProperty(e, "KeyPairEd25519", { enumerable: !0, get: function() {
    return r.KeyPairEd25519;
  } });
  var i = Td;
  Object.defineProperty(e, "PublicKey", { enumerable: !0, get: function() {
    return i.PublicKey;
  } });
})($C);
var Oc = {};
Object.defineProperty(Oc, "__esModule", { value: !0 });
Oc.buildDelegateAction = Oc.DelegateAction = void 0;
const JW = bo, XW = Mc, { addKey: QW, createAccount: eK, deleteAccount: tK, deleteKey: nK, deployContract: rK, functionCall: iK, stake: oK, transfer: aK } = XW.actionCreators;
class KC extends JW.Assignable {
}
Oc.DelegateAction = KC;
function sK({ actions: e, maxBlockHeight: t, nonce: n, publicKey: r, receiverId: i, senderId: o }) {
  return new KC({
    senderId: o,
    receiverId: i,
    actions: e.map((a) => {
      if (!a.type && !a.params)
        return a;
      switch (a.type) {
        case "AddKey": {
          const { publicKey: s, accessKey: c } = a.params;
          return QW(s, c);
        }
        case "CreateAccount":
          return eK(a.params.createAccount);
        case "DeleteAccount":
          return tK(a.params.deleteAccount);
        case "DeleteKey":
          return nK(a.params.publicKey);
        case "DeployContract":
          return rK(a.params.code);
        case "FunctionCall": {
          const { methodName: s, args: c, gas: l, deposit: u } = a.params;
          return iK(s, c, l, u);
        }
        case "Stake":
          return oK(a.params.stake, a.params.publicKey);
        case "Transfer": {
          const { deposit: s } = a.params;
          return aK(s);
        }
      }
      throw new Error("Unrecognized action");
    }),
    nonce: n,
    maxBlockHeight: t,
    publicKey: r
  });
}
Oc.buildDelegateAction = sK;
var Zm = {};
Object.defineProperty(Zm, "__esModule", { value: !0 });
Zm.DelegateActionPrefix = void 0;
const cK = bo, uK = Math.pow(2, 30), lK = {
  MetaTransactions: 366
};
class fK extends cK.Assignable {
}
class dK extends fK {
  /** Given the NEP number, set the prefix using 2^30 as the offset **/
  constructor(t) {
    super({ prefix: uK + t });
  }
}
class hK extends dK {
  constructor() {
    super(lK.MetaTransactions);
  }
}
Zm.DelegateActionPrefix = hK;
var Ul = {};
Object.defineProperty(Ul, "__esModule", { value: !0 });
Ul.Signature = void 0;
const pK = bo;
let yK = class extends pK.Assignable {
};
Ul.Signature = yK;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SCHEMA = e.SignedTransaction = e.Transaction = e.decodeSignedTransaction = e.decodeTransaction = e.encodeTransaction = e.encodeSignedDelegate = e.encodeDelegateAction = void 0;
  const t = $C, n = bo, r = Sr, i = rn, o = Oc, a = Zm, s = Ul;
  function c(w) {
    return new Uint8Array([
      ...(0, r.serialize)(e.SCHEMA, new a.DelegateActionPrefix()),
      ...(0, r.serialize)(e.SCHEMA, w)
    ]);
  }
  e.encodeDelegateAction = c;
  function l(w) {
    return (0, r.serialize)(e.SCHEMA, w);
  }
  e.encodeSignedDelegate = l;
  function u(w) {
    return (0, r.serialize)(e.SCHEMA, w);
  }
  e.encodeTransaction = u;
  function f(w) {
    return (0, r.deserialize)(e.SCHEMA, h, w);
  }
  e.decodeTransaction = f;
  function d(w) {
    return (0, r.deserialize)(e.SCHEMA, g, w);
  }
  e.decodeSignedTransaction = d;
  class h extends n.Assignable {
    encode() {
      return u(this);
    }
    static decode(b) {
      return f(b);
    }
  }
  e.Transaction = h;
  class g extends n.Assignable {
    encode() {
      return u(this);
    }
    static decode(b) {
      return d(b);
    }
  }
  e.SignedTransaction = g, e.SCHEMA = /* @__PURE__ */ new Map([
    [s.Signature, { kind: "struct", fields: [
      ["keyType", "u8"],
      ["data", [64]]
    ] }],
    [g, { kind: "struct", fields: [
      ["transaction", h],
      ["signature", s.Signature]
    ] }],
    [h, { kind: "struct", fields: [
      ["signerId", "string"],
      ["publicKey", t.PublicKey],
      ["nonce", "u64"],
      ["receiverId", "string"],
      ["blockHash", [32]],
      ["actions", [i.Action]]
    ] }],
    [t.PublicKey, { kind: "struct", fields: [
      ["keyType", "u8"],
      ["data", [32]]
    ] }],
    [i.AccessKey, { kind: "struct", fields: [
      ["nonce", "u64"],
      ["permission", i.AccessKeyPermission]
    ] }],
    [i.AccessKeyPermission, { kind: "enum", field: "enum", values: [
      ["functionCall", i.FunctionCallPermission],
      ["fullAccess", i.FullAccessPermission]
    ] }],
    [i.FunctionCallPermission, { kind: "struct", fields: [
      ["allowance", { kind: "option", type: "u128" }],
      ["receiverId", "string"],
      ["methodNames", ["string"]]
    ] }],
    [i.FullAccessPermission, { kind: "struct", fields: [] }],
    [i.Action, { kind: "enum", field: "enum", values: [
      ["createAccount", i.CreateAccount],
      ["deployContract", i.DeployContract],
      ["functionCall", i.FunctionCall],
      ["transfer", i.Transfer],
      ["stake", i.Stake],
      ["addKey", i.AddKey],
      ["deleteKey", i.DeleteKey],
      ["deleteAccount", i.DeleteAccount],
      ["signedDelegate", i.SignedDelegate]
    ] }],
    [i.CreateAccount, { kind: "struct", fields: [] }],
    [i.DeployContract, { kind: "struct", fields: [
      ["code", ["u8"]]
    ] }],
    [i.FunctionCall, { kind: "struct", fields: [
      ["methodName", "string"],
      ["args", ["u8"]],
      ["gas", "u64"],
      ["deposit", "u128"]
    ] }],
    [i.Transfer, { kind: "struct", fields: [
      ["deposit", "u128"]
    ] }],
    [i.Stake, { kind: "struct", fields: [
      ["stake", "u128"],
      ["publicKey", t.PublicKey]
    ] }],
    [i.AddKey, { kind: "struct", fields: [
      ["publicKey", t.PublicKey],
      ["accessKey", i.AccessKey]
    ] }],
    [i.DeleteKey, { kind: "struct", fields: [
      ["publicKey", t.PublicKey]
    ] }],
    [i.DeleteAccount, { kind: "struct", fields: [
      ["beneficiaryId", "string"]
    ] }],
    [o.DelegateAction, { kind: "struct", fields: [
      ["senderId", "string"],
      ["receiverId", "string"],
      ["actions", [i.Action]],
      ["nonce", "u64"],
      ["maxBlockHeight", "u64"],
      ["publicKey", t.PublicKey]
    ] }],
    [a.DelegateActionPrefix, { kind: "struct", fields: [
      ["prefix", "u32"]
    ] }],
    [i.SignedDelegate, { kind: "struct", fields: [
      ["delegateAction", o.DelegateAction],
      ["signature", s.Signature]
    ] }]
  ]);
})(Hm);
Object.defineProperty(Ad, "__esModule", { value: !0 });
Ad.createTransaction = void 0;
const gK = Hm;
function bK(e, t, n, r, i, o) {
  return new gK.Transaction({ signerId: e, publicKey: t, nonce: r, receiverId: n, actions: i, blockHash: o });
}
Ad.createTransaction = bK;
var fl = {}, VC = { exports: {} };
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
(function(e) {
  (function() {
    var t = "input is invalid type", n = typeof window == "object", r = n ? window : {};
    r.JS_SHA256_NO_WINDOW && (n = !1);
    var i = !n && typeof self == "object", o = !r.JS_SHA256_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
    o ? r = _ : i && (r = self);
    var a = !r.JS_SHA256_NO_COMMON_JS && !0 && e.exports, s = !r.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", c = "0123456789abcdef".split(""), l = [-2147483648, 8388608, 32768, 128], u = [24, 16, 8, 0], f = [
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ], d = ["hex", "array", "digest", "arrayBuffer"], h = [];
    (r.JS_SHA256_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(K) {
      return Object.prototype.toString.call(K) === "[object Array]";
    }), s && (r.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(K) {
      return typeof K == "object" && K.buffer && K.buffer.constructor === ArrayBuffer;
    });
    var g = function(K, W) {
      return function(O) {
        return new x(W, !0).update(O)[K]();
      };
    }, w = function(K) {
      var W = g("hex", K);
      o && (W = b(W, K)), W.create = function() {
        return new x(K);
      }, W.update = function(z) {
        return W.create().update(z);
      };
      for (var O = 0; O < d.length; ++O) {
        var k = d[O];
        W[k] = g(k, K);
      }
      return W;
    }, b = function(K, W) {
      var O = require("crypto"), k = require("buffer").Buffer, z = W ? "sha224" : "sha256", C = function(M) {
        if (typeof M == "string")
          return O.createHash(z).update(M, "utf8").digest("hex");
        if (M == null)
          throw new Error(t);
        return M.constructor === ArrayBuffer && (M = new Uint8Array(M)), Array.isArray(M) || ArrayBuffer.isView(M) || M.constructor === k ? O.createHash(z).update(new k(M)).digest("hex") : K(M);
      };
      return C;
    }, I = function(K, W) {
      return function(O, k) {
        return new N(O, W, !0).update(k)[K]();
      };
    }, A = function(K) {
      var W = I("hex", K);
      W.create = function(z) {
        return new N(z, K);
      }, W.update = function(z, C) {
        return W.create(z).update(C);
      };
      for (var O = 0; O < d.length; ++O) {
        var k = d[O];
        W[k] = I(k, K);
      }
      return W;
    };
    function x(K, W) {
      W ? (h[0] = h[16] = h[1] = h[2] = h[3] = h[4] = h[5] = h[6] = h[7] = h[8] = h[9] = h[10] = h[11] = h[12] = h[13] = h[14] = h[15] = 0, this.blocks = h) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], K ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = K;
    }
    x.prototype.update = function(K) {
      if (!this.finalized) {
        var W, O = typeof K;
        if (O !== "string") {
          if (O === "object") {
            if (K === null)
              throw new Error(t);
            if (s && K.constructor === ArrayBuffer)
              K = new Uint8Array(K);
            else if (!Array.isArray(K) && (!s || !ArrayBuffer.isView(K)))
              throw new Error(t);
          } else
            throw new Error(t);
          W = !0;
        }
        for (var k, z = 0, C, M = K.length, S = this.blocks; z < M; ) {
          if (this.hashed && (this.hashed = !1, S[0] = this.block, S[16] = S[1] = S[2] = S[3] = S[4] = S[5] = S[6] = S[7] = S[8] = S[9] = S[10] = S[11] = S[12] = S[13] = S[14] = S[15] = 0), W)
            for (C = this.start; z < M && C < 64; ++z)
              S[C >> 2] |= K[z] << u[C++ & 3];
          else
            for (C = this.start; z < M && C < 64; ++z)
              k = K.charCodeAt(z), k < 128 ? S[C >> 2] |= k << u[C++ & 3] : k < 2048 ? (S[C >> 2] |= (192 | k >> 6) << u[C++ & 3], S[C >> 2] |= (128 | k & 63) << u[C++ & 3]) : k < 55296 || k >= 57344 ? (S[C >> 2] |= (224 | k >> 12) << u[C++ & 3], S[C >> 2] |= (128 | k >> 6 & 63) << u[C++ & 3], S[C >> 2] |= (128 | k & 63) << u[C++ & 3]) : (k = 65536 + ((k & 1023) << 10 | K.charCodeAt(++z) & 1023), S[C >> 2] |= (240 | k >> 18) << u[C++ & 3], S[C >> 2] |= (128 | k >> 12 & 63) << u[C++ & 3], S[C >> 2] |= (128 | k >> 6 & 63) << u[C++ & 3], S[C >> 2] |= (128 | k & 63) << u[C++ & 3]);
          this.lastByteIndex = C, this.bytes += C - this.start, C >= 64 ? (this.block = S[16], this.start = C - 64, this.hash(), this.hashed = !0) : this.start = C;
        }
        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }
    }, x.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var K = this.blocks, W = this.lastByteIndex;
        K[16] = this.block, K[W >> 2] |= l[W & 3], this.block = K[16], W >= 56 && (this.hashed || this.hash(), K[0] = this.block, K[16] = K[1] = K[2] = K[3] = K[4] = K[5] = K[6] = K[7] = K[8] = K[9] = K[10] = K[11] = K[12] = K[13] = K[14] = K[15] = 0), K[14] = this.hBytes << 3 | this.bytes >>> 29, K[15] = this.bytes << 3, this.hash();
      }
    }, x.prototype.hash = function() {
      var K = this.h0, W = this.h1, O = this.h2, k = this.h3, z = this.h4, C = this.h5, M = this.h6, S = this.h7, p = this.blocks, y, v, E, B, F, q, U, m, D, Y, Q;
      for (y = 16; y < 64; ++y)
        F = p[y - 15], v = (F >>> 7 | F << 25) ^ (F >>> 18 | F << 14) ^ F >>> 3, F = p[y - 2], E = (F >>> 17 | F << 15) ^ (F >>> 19 | F << 13) ^ F >>> 10, p[y] = p[y - 16] + v + p[y - 7] + E << 0;
      for (Q = W & O, y = 0; y < 64; y += 4)
        this.first ? (this.is224 ? (m = 300032, F = p[0] - 1413257819, S = F - 150054599 << 0, k = F + 24177077 << 0) : (m = 704751109, F = p[0] - 210244248, S = F - 1521486534 << 0, k = F + 143694565 << 0), this.first = !1) : (v = (K >>> 2 | K << 30) ^ (K >>> 13 | K << 19) ^ (K >>> 22 | K << 10), E = (z >>> 6 | z << 26) ^ (z >>> 11 | z << 21) ^ (z >>> 25 | z << 7), m = K & W, B = m ^ K & O ^ Q, U = z & C ^ ~z & M, F = S + E + U + f[y] + p[y], q = v + B, S = k + F << 0, k = F + q << 0), v = (k >>> 2 | k << 30) ^ (k >>> 13 | k << 19) ^ (k >>> 22 | k << 10), E = (S >>> 6 | S << 26) ^ (S >>> 11 | S << 21) ^ (S >>> 25 | S << 7), D = k & K, B = D ^ k & W ^ m, U = S & z ^ ~S & C, F = M + E + U + f[y + 1] + p[y + 1], q = v + B, M = O + F << 0, O = F + q << 0, v = (O >>> 2 | O << 30) ^ (O >>> 13 | O << 19) ^ (O >>> 22 | O << 10), E = (M >>> 6 | M << 26) ^ (M >>> 11 | M << 21) ^ (M >>> 25 | M << 7), Y = O & k, B = Y ^ O & K ^ D, U = M & S ^ ~M & z, F = C + E + U + f[y + 2] + p[y + 2], q = v + B, C = W + F << 0, W = F + q << 0, v = (W >>> 2 | W << 30) ^ (W >>> 13 | W << 19) ^ (W >>> 22 | W << 10), E = (C >>> 6 | C << 26) ^ (C >>> 11 | C << 21) ^ (C >>> 25 | C << 7), Q = W & O, B = Q ^ W & k ^ Y, U = C & M ^ ~C & S, F = z + E + U + f[y + 3] + p[y + 3], q = v + B, z = K + F << 0, K = F + q << 0;
      this.h0 = this.h0 + K << 0, this.h1 = this.h1 + W << 0, this.h2 = this.h2 + O << 0, this.h3 = this.h3 + k << 0, this.h4 = this.h4 + z << 0, this.h5 = this.h5 + C << 0, this.h6 = this.h6 + M << 0, this.h7 = this.h7 + S << 0;
    }, x.prototype.hex = function() {
      this.finalize();
      var K = this.h0, W = this.h1, O = this.h2, k = this.h3, z = this.h4, C = this.h5, M = this.h6, S = this.h7, p = c[K >> 28 & 15] + c[K >> 24 & 15] + c[K >> 20 & 15] + c[K >> 16 & 15] + c[K >> 12 & 15] + c[K >> 8 & 15] + c[K >> 4 & 15] + c[K & 15] + c[W >> 28 & 15] + c[W >> 24 & 15] + c[W >> 20 & 15] + c[W >> 16 & 15] + c[W >> 12 & 15] + c[W >> 8 & 15] + c[W >> 4 & 15] + c[W & 15] + c[O >> 28 & 15] + c[O >> 24 & 15] + c[O >> 20 & 15] + c[O >> 16 & 15] + c[O >> 12 & 15] + c[O >> 8 & 15] + c[O >> 4 & 15] + c[O & 15] + c[k >> 28 & 15] + c[k >> 24 & 15] + c[k >> 20 & 15] + c[k >> 16 & 15] + c[k >> 12 & 15] + c[k >> 8 & 15] + c[k >> 4 & 15] + c[k & 15] + c[z >> 28 & 15] + c[z >> 24 & 15] + c[z >> 20 & 15] + c[z >> 16 & 15] + c[z >> 12 & 15] + c[z >> 8 & 15] + c[z >> 4 & 15] + c[z & 15] + c[C >> 28 & 15] + c[C >> 24 & 15] + c[C >> 20 & 15] + c[C >> 16 & 15] + c[C >> 12 & 15] + c[C >> 8 & 15] + c[C >> 4 & 15] + c[C & 15] + c[M >> 28 & 15] + c[M >> 24 & 15] + c[M >> 20 & 15] + c[M >> 16 & 15] + c[M >> 12 & 15] + c[M >> 8 & 15] + c[M >> 4 & 15] + c[M & 15];
      return this.is224 || (p += c[S >> 28 & 15] + c[S >> 24 & 15] + c[S >> 20 & 15] + c[S >> 16 & 15] + c[S >> 12 & 15] + c[S >> 8 & 15] + c[S >> 4 & 15] + c[S & 15]), p;
    }, x.prototype.toString = x.prototype.hex, x.prototype.digest = function() {
      this.finalize();
      var K = this.h0, W = this.h1, O = this.h2, k = this.h3, z = this.h4, C = this.h5, M = this.h6, S = this.h7, p = [
        K >> 24 & 255,
        K >> 16 & 255,
        K >> 8 & 255,
        K & 255,
        W >> 24 & 255,
        W >> 16 & 255,
        W >> 8 & 255,
        W & 255,
        O >> 24 & 255,
        O >> 16 & 255,
        O >> 8 & 255,
        O & 255,
        k >> 24 & 255,
        k >> 16 & 255,
        k >> 8 & 255,
        k & 255,
        z >> 24 & 255,
        z >> 16 & 255,
        z >> 8 & 255,
        z & 255,
        C >> 24 & 255,
        C >> 16 & 255,
        C >> 8 & 255,
        C & 255,
        M >> 24 & 255,
        M >> 16 & 255,
        M >> 8 & 255,
        M & 255
      ];
      return this.is224 || p.push(S >> 24 & 255, S >> 16 & 255, S >> 8 & 255, S & 255), p;
    }, x.prototype.array = x.prototype.digest, x.prototype.arrayBuffer = function() {
      this.finalize();
      var K = new ArrayBuffer(this.is224 ? 28 : 32), W = new DataView(K);
      return W.setUint32(0, this.h0), W.setUint32(4, this.h1), W.setUint32(8, this.h2), W.setUint32(12, this.h3), W.setUint32(16, this.h4), W.setUint32(20, this.h5), W.setUint32(24, this.h6), this.is224 || W.setUint32(28, this.h7), K;
    };
    function N(K, W, O) {
      var k, z = typeof K;
      if (z === "string") {
        var C = [], M = K.length, S = 0, p;
        for (k = 0; k < M; ++k)
          p = K.charCodeAt(k), p < 128 ? C[S++] = p : p < 2048 ? (C[S++] = 192 | p >> 6, C[S++] = 128 | p & 63) : p < 55296 || p >= 57344 ? (C[S++] = 224 | p >> 12, C[S++] = 128 | p >> 6 & 63, C[S++] = 128 | p & 63) : (p = 65536 + ((p & 1023) << 10 | K.charCodeAt(++k) & 1023), C[S++] = 240 | p >> 18, C[S++] = 128 | p >> 12 & 63, C[S++] = 128 | p >> 6 & 63, C[S++] = 128 | p & 63);
        K = C;
      } else if (z === "object") {
        if (K === null)
          throw new Error(t);
        if (s && K.constructor === ArrayBuffer)
          K = new Uint8Array(K);
        else if (!Array.isArray(K) && (!s || !ArrayBuffer.isView(K)))
          throw new Error(t);
      } else
        throw new Error(t);
      K.length > 64 && (K = new x(W, !0).update(K).array());
      var y = [], v = [];
      for (k = 0; k < 64; ++k) {
        var E = K[k] || 0;
        y[k] = 92 ^ E, v[k] = 54 ^ E;
      }
      x.call(this, W, O), this.update(v), this.oKeyPad = y, this.inner = !0, this.sharedMemory = O;
    }
    N.prototype = new x(), N.prototype.finalize = function() {
      if (x.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var K = this.array();
        x.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(K), x.prototype.finalize.call(this);
      }
    };
    var j = w();
    j.sha256 = j, j.sha224 = w(!0), j.sha256.hmac = A(), j.sha224.hmac = A(!0), a ? e.exports = j : (r.sha256 = j.sha256, r.sha224 = j.sha224);
  })();
})(VC);
var Jm = VC.exports, ik = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
}, mK = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(fl, "__esModule", { value: !0 });
fl.signDelegateAction = fl.signTransaction = void 0;
const qC = mK(Jm), _K = rn, wK = Ad, Ub = Hm, HC = Ul;
function t2(e, t, n, r) {
  return ik(this, void 0, void 0, function* () {
    const i = (0, Ub.encodeTransaction)(e), o = new Uint8Array(qC.default.sha256.array(i)), a = yield t.signMessage(i, n, r), s = new Ub.SignedTransaction({
      transaction: e,
      signature: new HC.Signature({ keyType: e.publicKey.keyType, data: a.signature })
    });
    return [o, s];
  });
}
function vK(...e) {
  return ik(this, void 0, void 0, function* () {
    if (e[0].constructor === Ub.Transaction) {
      const [t, n, r, i] = e;
      return t2(t, n, r, i);
    } else {
      const [t, n, r, i, o, a, s] = e, c = yield o.getPublicKey(a, s), l = (0, wK.createTransaction)(a, c, t, n, r, i);
      return t2(l, o, a, s);
    }
  });
}
fl.signTransaction = vK;
function SK({ delegateAction: e, signer: t }) {
  return ik(this, void 0, void 0, function* () {
    const n = (0, Ub.encodeDelegateAction)(e), r = yield t.sign(n), i = new _K.SignedDelegate({
      delegateAction: e,
      signature: new HC.Signature({
        keyType: e.publicKey.keyType,
        data: r
      })
    });
    return {
      hash: new Uint8Array(qC.default.sha256.array(n)),
      signedDelegateAction: i
    };
  });
}
fl.signDelegateAction = SK;
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(Mc, e), n(rn, e), n(Ad, e), n(Oc, e), n(Hm, e), n(fl, e), n(Ul, e);
})(zC);
var xd = {};
Object.defineProperty(xd, "__esModule", { value: !0 });
xd.Provider = void 0;
let EK = class {
};
xd.Provider = EK;
var Md = {}, GC = { exports: {} };
/*!
 * depd
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var AK = IK;
function IK(e) {
  if (!e)
    throw new TypeError("argument namespace is required");
  function t(n) {
  }
  return t._file = void 0, t._ignored = !0, t._namespace = e, t._traced = !1, t._warned = /* @__PURE__ */ Object.create(null), t.function = kK, t.property = TK, t;
}
function kK(e, t) {
  if (typeof e != "function")
    throw new TypeError("argument fn must be a function");
  return e;
}
function TK(e, t, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new TypeError("argument obj must be object");
  var r = Object.getOwnPropertyDescriptor(e, t);
  if (!r)
    throw new TypeError("must call property on owner object");
  if (!r.configurable)
    throw new TypeError("property must be configurable");
}
var xK = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? MK : OK);
function MK(e, t) {
  return e.__proto__ = t, e;
}
function OK(e, t) {
  for (var n in t)
    Object.prototype.hasOwnProperty.call(e, n) || (e[n] = t[n]);
  return e;
}
const PK = {
  100: "Continue",
  101: "Switching Protocols",
  102: "Processing",
  103: "Early Hints",
  200: "OK",
  201: "Created",
  202: "Accepted",
  203: "Non-Authoritative Information",
  204: "No Content",
  205: "Reset Content",
  206: "Partial Content",
  207: "Multi-Status",
  208: "Already Reported",
  226: "IM Used",
  300: "Multiple Choices",
  301: "Moved Permanently",
  302: "Found",
  303: "See Other",
  304: "Not Modified",
  305: "Use Proxy",
  306: "(Unused)",
  307: "Temporary Redirect",
  308: "Permanent Redirect",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Payload Too Large",
  414: "URI Too Long",
  415: "Unsupported Media Type",
  416: "Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  421: "Misdirected Request",
  422: "Unprocessable Entity",
  423: "Locked",
  424: "Failed Dependency",
  425: "Unordered Collection",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  451: "Unavailable For Legal Reasons",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates",
  507: "Insufficient Storage",
  508: "Loop Detected",
  509: "Bandwidth Limit Exceeded",
  510: "Not Extended",
  511: "Network Authentication Required"
};
/*!
 * statuses
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */
var YC = PK, BK = la;
la.STATUS_CODES = YC;
la.codes = CK(la, YC);
la.redirect = {
  300: !0,
  301: !0,
  302: !0,
  303: !0,
  305: !0,
  307: !0,
  308: !0
};
la.empty = {
  204: !0,
  205: !0,
  304: !0
};
la.retry = {
  502: !0,
  503: !0,
  504: !0
};
function CK(e, t) {
  var n = [];
  return Object.keys(t).forEach(function(i) {
    var o = t[i], a = Number(i);
    e[a] = o, e[o] = a, e[o.toLowerCase()] = a, n.push(a);
  }), n;
}
function la(e) {
  if (typeof e == "number") {
    if (!la[e])
      throw new Error("invalid status code: " + e);
    return e;
  }
  if (typeof e != "string")
    throw new TypeError("code must be a number or string");
  var t = parseInt(e, 10);
  if (!isNaN(t)) {
    if (!la[t])
      throw new Error("invalid status code: " + t);
    return t;
  }
  if (t = la[e.toLowerCase()], !t)
    throw new Error('invalid status message: "' + e + '"');
  return t;
}
var QE = { exports: {} };
typeof Object.create == "function" ? QE.exports = function(t, n) {
  n && (t.super_ = n, t.prototype = Object.create(n.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : QE.exports = function(t, n) {
  if (n) {
    t.super_ = n;
    var r = function() {
    };
    r.prototype = n.prototype, t.prototype = new r(), t.prototype.constructor = t;
  }
};
var ZC = QE.exports;
/*!
 * toidentifier
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */
var DK = RK;
function RK(e) {
  return e.split(" ").map(function(t) {
    return t.slice(0, 1).toUpperCase() + t.slice(1);
  }).join("").replace(/[^ _0-9a-z]/gi, "");
}
/*!
 * http-errors
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */
(function(e) {
  var t = AK("http-errors"), n = xK, r = BK, i = ZC, o = DK;
  e.exports = s, e.exports.HttpError = c(), e.exports.isHttpError = u(e.exports.HttpError), h(e.exports, r.codes, e.exports.HttpError);
  function a(w) {
    return +(String(w).charAt(0) + "00");
  }
  function s() {
    for (var w, b, I = 500, A = {}, x = 0; x < arguments.length; x++) {
      var N = arguments[x];
      if (N instanceof Error) {
        w = N, I = w.status || w.statusCode || I;
        continue;
      }
      switch (typeof N) {
        case "string":
          b = N;
          break;
        case "number":
          I = N;
          break;
        case "object":
          A = N;
          break;
      }
    }
    (typeof I != "number" || !r[I] && (I < 400 || I >= 600)) && (I = 500);
    var j = s[I] || s[a(I)];
    w || (w = j ? new j(b) : new Error(b || r[I]), Error.captureStackTrace(w, s)), (!j || !(w instanceof j) || w.status !== I) && (w.expose = I < 500, w.status = w.statusCode = I);
    for (var K in A)
      K !== "status" && K !== "statusCode" && (w[K] = A[K]);
    return w;
  }
  function c() {
    function w() {
      throw new TypeError("cannot construct abstract class");
    }
    return i(w, Error), w;
  }
  function l(w, b, I) {
    var A = g(b);
    function x(N) {
      var j = N ?? r[I], K = new Error(j);
      return Error.captureStackTrace(K, x), n(K, x.prototype), Object.defineProperty(K, "message", {
        enumerable: !0,
        configurable: !0,
        value: j,
        writable: !0
      }), Object.defineProperty(K, "name", {
        enumerable: !1,
        configurable: !0,
        value: A,
        writable: !0
      }), K;
    }
    return i(x, w), d(x, A), x.prototype.status = I, x.prototype.statusCode = I, x.prototype.expose = !0, x;
  }
  function u(w) {
    return function(I) {
      return !I || typeof I != "object" ? !1 : I instanceof w ? !0 : I instanceof Error && typeof I.expose == "boolean" && typeof I.statusCode == "number" && I.status === I.statusCode;
    };
  }
  function f(w, b, I) {
    var A = g(b);
    function x(N) {
      var j = N ?? r[I], K = new Error(j);
      return Error.captureStackTrace(K, x), n(K, x.prototype), Object.defineProperty(K, "message", {
        enumerable: !0,
        configurable: !0,
        value: j,
        writable: !0
      }), Object.defineProperty(K, "name", {
        enumerable: !1,
        configurable: !0,
        value: A,
        writable: !0
      }), K;
    }
    return i(x, w), d(x, A), x.prototype.status = I, x.prototype.statusCode = I, x.prototype.expose = !1, x;
  }
  function d(w, b) {
    var I = Object.getOwnPropertyDescriptor(w, "name");
    I && I.configurable && (I.value = b, Object.defineProperty(w, "name", I));
  }
  function h(w, b, I) {
    b.forEach(function(x) {
      var N, j = o(r[x]);
      switch (a(x)) {
        case 400:
          N = l(I, j, x);
          break;
        case 500:
          N = f(I, j, x);
          break;
      }
      N && (w[x] = N, w[j] = N);
    }), w["I'mateapot"] = t.function(
      w.ImATeapot,
      `"I'mateapot"; use "ImATeapot" instead`
    );
  }
  function g(w) {
    return w.substr(-5) !== "Error" ? w + "Error" : w;
  }
})(GC);
var NK = GC.exports, dg = {}, hg = { exports: {} }, n2;
function jK() {
  return n2 || (n2 = 1, function(e, t) {
    var n = function() {
      if (typeof self < "u")
        return self;
      if (typeof window < "u")
        return window;
      if (typeof _ < "u")
        return _;
      throw new Error("unable to locate global object");
    }, r = n();
    e.exports = t = r.fetch, r.fetch && (t.default = r.fetch.bind(r)), t.Headers = r.Headers, t.Request = r.Request, t.Response = r.Response;
  }(hg, hg.exports)), hg.exports;
}
var ok = { exports: {} }, qu = typeof Reflect == "object" ? Reflect : null, r2 = qu && typeof qu.apply == "function" ? qu.apply : function(t, n, r) {
  return Function.prototype.apply.call(t, n, r);
}, nb;
qu && typeof qu.ownKeys == "function" ? nb = qu.ownKeys : Object.getOwnPropertySymbols ? nb = function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : nb = function(t) {
  return Object.getOwnPropertyNames(t);
};
function UK(e) {
  console && console.warn && console.warn(e);
}
var JC = Number.isNaN || function(t) {
  return t !== t;
};
function Un() {
  Un.init.call(this);
}
ok.exports = Un;
ok.exports.once = $K;
Un.EventEmitter = Un;
Un.prototype._events = void 0;
Un.prototype._eventsCount = 0;
Un.prototype._maxListeners = void 0;
var i2 = 10;
function Xm(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(Un, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return i2;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || JC(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    i2 = e;
  }
});
Un.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Un.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || JC(t))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
  return this._maxListeners = t, this;
};
function XC(e) {
  return e._maxListeners === void 0 ? Un.defaultMaxListeners : e._maxListeners;
}
Un.prototype.getMaxListeners = function() {
  return XC(this);
};
Un.prototype.emit = function(t) {
  for (var n = [], r = 1; r < arguments.length; r++)
    n.push(arguments[r]);
  var i = t === "error", o = this._events;
  if (o !== void 0)
    i = i && o.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var a;
    if (n.length > 0 && (a = n[0]), a instanceof Error)
      throw a;
    var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
    throw s.context = a, s;
  }
  var c = o[t];
  if (c === void 0)
    return !1;
  if (typeof c == "function")
    r2(c, this, n);
  else
    for (var l = c.length, u = rD(c, l), r = 0; r < l; ++r)
      r2(u[r], this, n);
  return !0;
};
function QC(e, t, n, r) {
  var i, o, a;
  if (Xm(n), o = e._events, o === void 0 ? (o = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (o.newListener !== void 0 && (e.emit(
    "newListener",
    t,
    n.listener ? n.listener : n
  ), o = e._events), a = o[t]), a === void 0)
    a = o[t] = n, ++e._eventsCount;
  else if (typeof a == "function" ? a = o[t] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), i = XC(e), i > 0 && a.length > i && !a.warned) {
    a.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = a.length, UK(s);
  }
  return e;
}
Un.prototype.addListener = function(t, n) {
  return QC(this, t, n, !1);
};
Un.prototype.on = Un.prototype.addListener;
Un.prototype.prependListener = function(t, n) {
  return QC(this, t, n, !0);
};
function zK() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function eD(e, t, n) {
  var r = { fired: !1, wrapFn: void 0, target: e, type: t, listener: n }, i = zK.bind(r);
  return i.listener = n, r.wrapFn = i, i;
}
Un.prototype.once = function(t, n) {
  return Xm(n), this.on(t, eD(this, t, n)), this;
};
Un.prototype.prependOnceListener = function(t, n) {
  return Xm(n), this.prependListener(t, eD(this, t, n)), this;
};
Un.prototype.removeListener = function(t, n) {
  var r, i, o, a, s;
  if (Xm(n), i = this._events, i === void 0)
    return this;
  if (r = i[t], r === void 0)
    return this;
  if (r === n || r.listener === n)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[t], i.removeListener && this.emit("removeListener", t, r.listener || n));
  else if (typeof r != "function") {
    for (o = -1, a = r.length - 1; a >= 0; a--)
      if (r[a] === n || r[a].listener === n) {
        s = r[a].listener, o = a;
        break;
      }
    if (o < 0)
      return this;
    o === 0 ? r.shift() : FK(r, o), r.length === 1 && (i[t] = r[0]), i.removeListener !== void 0 && this.emit("removeListener", t, s || n);
  }
  return this;
};
Un.prototype.off = Un.prototype.removeListener;
Un.prototype.removeAllListeners = function(t) {
  var n, r, i;
  if (r = this._events, r === void 0)
    return this;
  if (r.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : r[t] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete r[t]), this;
  if (arguments.length === 0) {
    var o = Object.keys(r), a;
    for (i = 0; i < o.length; ++i)
      a = o[i], a !== "removeListener" && this.removeAllListeners(a);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (n = r[t], typeof n == "function")
    this.removeListener(t, n);
  else if (n !== void 0)
    for (i = n.length - 1; i >= 0; i--)
      this.removeListener(t, n[i]);
  return this;
};
function tD(e, t, n) {
  var r = e._events;
  if (r === void 0)
    return [];
  var i = r[t];
  return i === void 0 ? [] : typeof i == "function" ? n ? [i.listener || i] : [i] : n ? LK(i) : rD(i, i.length);
}
Un.prototype.listeners = function(t) {
  return tD(this, t, !0);
};
Un.prototype.rawListeners = function(t) {
  return tD(this, t, !1);
};
Un.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : nD.call(e, t);
};
Un.prototype.listenerCount = nD;
function nD(e) {
  var t = this._events;
  if (t !== void 0) {
    var n = t[e];
    if (typeof n == "function")
      return 1;
    if (n !== void 0)
      return n.length;
  }
  return 0;
}
Un.prototype.eventNames = function() {
  return this._eventsCount > 0 ? nb(this._events) : [];
};
function rD(e, t) {
  for (var n = new Array(t), r = 0; r < t; ++r)
    n[r] = e[r];
  return n;
}
function FK(e, t) {
  for (; t + 1 < e.length; t++)
    e[t] = e[t + 1];
  e.pop();
}
function LK(e) {
  for (var t = new Array(e.length), n = 0; n < t.length; ++n)
    t[n] = e[n].listener || e[n];
  return t;
}
function $K(e, t) {
  return new Promise(function(n, r) {
    function i(a) {
      e.removeListener(t, o), r(a);
    }
    function o() {
      typeof e.removeListener == "function" && e.removeListener("error", i), n([].slice.call(arguments));
    }
    iD(e, t, o, { once: !0 }), t !== "error" && WK(e, i, { once: !0 });
  });
}
function WK(e, t, n) {
  typeof e.on == "function" && iD(e, "error", t, n);
}
function iD(e, t, n, r) {
  if (typeof e.on == "function")
    r.once ? e.once(t, n) : e.on(t, n);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(t, function i(o) {
      r.once && e.removeEventListener(t, i), n(o);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var KK = ok.exports, pg = { exports: {} }, kv, o2;
function VK() {
  if (o2)
    return kv;
  o2 = 1;
  var e = 1e3, t = e * 60, n = t * 60, r = n * 24, i = r * 7, o = r * 365.25;
  kv = function(u, f) {
    f = f || {};
    var d = typeof u;
    if (d === "string" && u.length > 0)
      return a(u);
    if (d === "number" && isFinite(u))
      return f.long ? c(u) : s(u);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(u)
    );
  };
  function a(u) {
    if (u = String(u), !(u.length > 100)) {
      var f = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        u
      );
      if (f) {
        var d = parseFloat(f[1]), h = (f[2] || "ms").toLowerCase();
        switch (h) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return d * o;
          case "weeks":
          case "week":
          case "w":
            return d * i;
          case "days":
          case "day":
          case "d":
            return d * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return d * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return d * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return d * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return d;
          default:
            return;
        }
      }
    }
  }
  function s(u) {
    var f = Math.abs(u);
    return f >= r ? Math.round(u / r) + "d" : f >= n ? Math.round(u / n) + "h" : f >= t ? Math.round(u / t) + "m" : f >= e ? Math.round(u / e) + "s" : u + "ms";
  }
  function c(u) {
    var f = Math.abs(u);
    return f >= r ? l(u, f, r, "day") : f >= n ? l(u, f, n, "hour") : f >= t ? l(u, f, t, "minute") : f >= e ? l(u, f, e, "second") : u + " ms";
  }
  function l(u, f, d, h) {
    var g = f >= d * 1.5;
    return Math.round(u / d) + " " + h + (g ? "s" : "");
  }
  return kv;
}
var Tv, a2;
function qK() {
  if (a2)
    return Tv;
  a2 = 1;
  function e(t) {
    r.debug = r, r.default = r, r.coerce = l, r.disable = a, r.enable = o, r.enabled = s, r.humanize = VK(), r.destroy = u, Object.keys(t).forEach((f) => {
      r[f] = t[f];
    }), r.names = [], r.skips = [], r.formatters = {};
    function n(f) {
      let d = 0;
      for (let h = 0; h < f.length; h++)
        d = (d << 5) - d + f.charCodeAt(h), d |= 0;
      return r.colors[Math.abs(d) % r.colors.length];
    }
    r.selectColor = n;
    function r(f) {
      let d, h = null, g, w;
      function b(...I) {
        if (!b.enabled)
          return;
        const A = b, x = Number(/* @__PURE__ */ new Date()), N = x - (d || x);
        A.diff = N, A.prev = d, A.curr = x, d = x, I[0] = r.coerce(I[0]), typeof I[0] != "string" && I.unshift("%O");
        let j = 0;
        I[0] = I[0].replace(/%([a-zA-Z%])/g, (W, O) => {
          if (W === "%%")
            return "%";
          j++;
          const k = r.formatters[O];
          if (typeof k == "function") {
            const z = I[j];
            W = k.call(A, z), I.splice(j, 1), j--;
          }
          return W;
        }), r.formatArgs.call(A, I), (A.log || r.log).apply(A, I);
      }
      return b.namespace = f, b.useColors = r.useColors(), b.color = r.selectColor(f), b.extend = i, b.destroy = r.destroy, Object.defineProperty(b, "enabled", {
        enumerable: !0,
        configurable: !1,
        get: () => h !== null ? h : (g !== r.namespaces && (g = r.namespaces, w = r.enabled(f)), w),
        set: (I) => {
          h = I;
        }
      }), typeof r.init == "function" && r.init(b), b;
    }
    function i(f, d) {
      const h = r(this.namespace + (typeof d > "u" ? ":" : d) + f);
      return h.log = this.log, h;
    }
    function o(f) {
      r.save(f), r.namespaces = f, r.names = [], r.skips = [];
      let d;
      const h = (typeof f == "string" ? f : "").split(/[\s,]+/), g = h.length;
      for (d = 0; d < g; d++)
        h[d] && (f = h[d].replace(/\*/g, ".*?"), f[0] === "-" ? r.skips.push(new RegExp("^" + f.slice(1) + "$")) : r.names.push(new RegExp("^" + f + "$")));
    }
    function a() {
      const f = [
        ...r.names.map(c),
        ...r.skips.map(c).map((d) => "-" + d)
      ].join(",");
      return r.enable(""), f;
    }
    function s(f) {
      if (f[f.length - 1] === "*")
        return !0;
      let d, h;
      for (d = 0, h = r.skips.length; d < h; d++)
        if (r.skips[d].test(f))
          return !1;
      for (d = 0, h = r.names.length; d < h; d++)
        if (r.names[d].test(f))
          return !0;
      return !1;
    }
    function c(f) {
      return f.toString().substring(2, f.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    function l(f) {
      return f instanceof Error ? f.stack || f.message : f;
    }
    function u() {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    return r.enable(r.load()), r;
  }
  return Tv = e, Tv;
}
var s2;
function ak() {
  return s2 || (s2 = 1, function(e, t) {
    t.formatArgs = r, t.save = i, t.load = o, t.useColors = n, t.storage = a(), t.destroy = (() => {
      let c = !1;
      return () => {
        c || (c = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
      };
    })(), t.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function n() {
      return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function r(c) {
      if (c[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + c[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors)
        return;
      const l = "color: " + this.color;
      c.splice(1, 0, l, "color: inherit");
      let u = 0, f = 0;
      c[0].replace(/%[a-zA-Z%]/g, (d) => {
        d !== "%%" && (u++, d === "%c" && (f = u));
      }), c.splice(f, 0, l);
    }
    t.log = console.debug || console.log || (() => {
    });
    function i(c) {
      try {
        c ? t.storage.setItem("debug", c) : t.storage.removeItem("debug");
      } catch {
      }
    }
    function o() {
      let c;
      try {
        c = t.storage.getItem("debug");
      } catch {
      }
      return !c && typeof process < "u" && "env" in process && (c = process.env.DEBUG), c;
    }
    function a() {
      try {
        return localStorage;
      } catch {
      }
    }
    e.exports = qK()(t);
    const { formatters: s } = e.exports;
    s.j = function(c) {
      try {
        return JSON.stringify(c);
      } catch (l) {
        return "[UnexpectedJSONParseError]: " + l.message;
      }
    };
  }(pg, pg.exports)), pg.exports;
}
var yg = {}, c2;
function HK() {
  if (c2)
    return yg;
  c2 = 1, Object.defineProperty(yg, "__esModule", { value: !0 });
  function e(t) {
    return function(n, r) {
      return new Promise((i, o) => {
        t.call(this, n, r, (a, s) => {
          a ? o(a) : i(s);
        });
      });
    };
  }
  return yg.default = e, yg;
}
var xv, u2;
function l2() {
  if (u2)
    return xv;
  u2 = 1;
  var e = _ && _.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  const t = KK, n = e(ak()), r = e(HK()), i = n.default("agent-base");
  function o(c) {
    return !!c && typeof c.addRequest == "function";
  }
  function a() {
    const { stack: c } = new Error();
    return typeof c != "string" ? !1 : c.split(`
`).some((l) => l.indexOf("(https.js:") !== -1 || l.indexOf("node:https:") !== -1);
  }
  function s(c, l) {
    return new s.Agent(c, l);
  }
  return function(c) {
    class l extends t.EventEmitter {
      constructor(f, d) {
        super();
        let h = d;
        typeof f == "function" ? this.callback = f : f && (h = f), this.timeout = null, h && typeof h.timeout == "number" && (this.timeout = h.timeout), this.maxFreeSockets = 1, this.maxSockets = 1, this.maxTotalSockets = 1 / 0, this.sockets = {}, this.freeSockets = {}, this.requests = {}, this.options = {};
      }
      get defaultPort() {
        return typeof this.explicitDefaultPort == "number" ? this.explicitDefaultPort : a() ? 443 : 80;
      }
      set defaultPort(f) {
        this.explicitDefaultPort = f;
      }
      get protocol() {
        return typeof this.explicitProtocol == "string" ? this.explicitProtocol : a() ? "https:" : "http:";
      }
      set protocol(f) {
        this.explicitProtocol = f;
      }
      callback(f, d, h) {
        throw new Error('"agent-base" has no default implementation, you must subclass and override `callback()`');
      }
      /**
       * Called by node-core's "_http_client.js" module when creating
       * a new HTTP request with this Agent instance.
       *
       * @api public
       */
      addRequest(f, d) {
        const h = Object.assign({}, d);
        typeof h.secureEndpoint != "boolean" && (h.secureEndpoint = a()), h.host == null && (h.host = "localhost"), h.port == null && (h.port = h.secureEndpoint ? 443 : 80), h.protocol == null && (h.protocol = h.secureEndpoint ? "https:" : "http:"), h.host && h.path && delete h.path, delete h.agent, delete h.hostname, delete h._defaultAgent, delete h.defaultPort, delete h.createConnection, f._last = !0, f.shouldKeepAlive = !1;
        let g = !1, w = null;
        const b = h.timeout || this.timeout, I = (j) => {
          f._hadError || (f.emit("error", j), f._hadError = !0);
        }, A = () => {
          w = null, g = !0;
          const j = new Error(`A "socket" was not created for HTTP request before ${b}ms`);
          j.code = "ETIMEOUT", I(j);
        }, x = (j) => {
          g || (w !== null && (clearTimeout(w), w = null), I(j));
        }, N = (j) => {
          if (g)
            return;
          if (w != null && (clearTimeout(w), w = null), o(j)) {
            i("Callback returned another Agent instance %o", j.constructor.name), j.addRequest(f, h);
            return;
          }
          if (j) {
            j.once("free", () => {
              this.freeSocket(j, h);
            }), f.onSocket(j);
            return;
          }
          const K = new Error(`no Duplex stream was returned to agent-base for \`${f.method} ${f.path}\``);
          I(K);
        };
        if (typeof this.callback != "function") {
          I(new Error("`callback` is not defined"));
          return;
        }
        this.promisifiedCallback || (this.callback.length >= 3 ? (i("Converting legacy callback function to promise"), this.promisifiedCallback = r.default(this.callback)) : this.promisifiedCallback = this.callback), typeof b == "number" && b > 0 && (w = setTimeout(A, b)), "port" in h && typeof h.port != "number" && (h.port = Number(h.port));
        try {
          i("Resolving socket for %o request: %o", h.protocol, `${f.method} ${f.path}`), Promise.resolve(this.promisifiedCallback(f, h)).then(N, x);
        } catch (j) {
          Promise.reject(j).catch(x);
        }
      }
      freeSocket(f, d) {
        i("Freeing socket %o %o", f.constructor.name, d), f.destroy();
      }
      destroy() {
        i("Destroying agent %o", this.constructor.name);
      }
    }
    c.Agent = l, c.prototype = c.Agent.prototype;
  }(s || (s = {})), xv = s, xv;
}
var f2;
function GK() {
  if (f2)
    return dg;
  f2 = 1;
  var e = _ && _.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(dg, "__esModule", { value: !0 });
  const t = e(jK()), n = e(l2()), r = e(l2()), i = new n.default.Agent({ keepAlive: !0 }), o = new r.default.Agent({ keepAlive: !0 });
  function a(c) {
    return c.protocol === "http:" ? i : o;
  }
  function s(c, l) {
    return (0, t.default)(c, Object.assign({ agent: a(new URL(c.toString())) }, l));
  }
  return dg.default = s, dg;
}
var YK = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), ZK = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), JK = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && YK(t, e, n);
  return ZK(t, e), t;
}, d2 = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
}, XK = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Md, "__esModule", { value: !0 });
Md.fetchJson = void 0;
const QK = bo, eV = XK(NK), tV = jl, nV = 1e3, rV = 1.5, h2 = 10, p2 = (...e) => !process.env.NEAR_NO_LOGS && console.warn(...e);
function iV(e, t) {
  return d2(this, void 0, void 0, function* () {
    let n = { url: null };
    typeof e == "string" ? n.url = e : n = e;
    const r = yield (0, tV.exponentialBackoff)(nV, h2, rV, () => d2(this, void 0, void 0, function* () {
      try {
        _.fetch || (_.fetch = (yield Promise.resolve().then(() => JK(GK()))).default);
        const i = yield _.fetch(n.url, {
          method: t ? "POST" : "GET",
          body: t || void 0,
          headers: Object.assign(Object.assign({}, n.headers), { "Content-Type": "application/json" })
        });
        if (!i.ok) {
          if (i.status === 503)
            return p2(`Retrying HTTP request for ${n.url} as it's not available now`), null;
          throw (0, eV.default)(i.status, yield i.text());
        }
        return i;
      } catch (i) {
        if (i.toString().includes("FetchError") || i.toString().includes("Failed to fetch"))
          return p2(`Retrying HTTP request for ${n.url} because of error: ${i}`), null;
        throw i;
      }
    }));
    if (!r)
      throw new QK.TypedError(`Exceeded ${h2} attempts for ${n.url}.`, "RetriesExceeded");
    return yield r.json();
  });
}
Md.fetchJson = iV;
var sr = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
}, y2 = _ && _.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
Object.defineProperty(Vm, "__esModule", { value: !0 });
Vm.JsonRpcProvider = void 0;
const Mv = ZI, cf = bo, g2 = zC, b2 = Sr, oV = jl, aV = xd, sV = Md, m2 = 12, cV = 500, uV = 1.5;
let lV = 123;
class fV extends aV.Provider {
  /**
   * @param connectionInfo Connection info
   */
  constructor(t) {
    super(), this.connection = t || { url: "" };
  }
  /**
   * Gets the RPC's status
   * @see [https://docs.near.org/docs/develop/front-end/rpc#general-validator-status](https://docs.near.org/docs/develop/front-end/rpc#general-validator-status)
   */
  status() {
    return sr(this, void 0, void 0, function* () {
      return this.sendJsonRpc("status", []);
    });
  }
  /**
   * Sends a signed transaction to the RPC and waits until transaction is fully complete
   * @see [https://docs.near.org/docs/develop/front-end/rpc#send-transaction-await](https://docs.near.org/docs/develop/front-end/rpc#general-validator-status)
   *
   * @param signedTransaction The signed transaction being sent
   */
  sendTransaction(t) {
    return sr(this, void 0, void 0, function* () {
      const n = (0, g2.encodeTransaction)(t);
      return this.sendJsonRpc("broadcast_tx_commit", [Buffer.from(n).toString("base64")]);
    });
  }
  /**
   * Sends a signed transaction to the RPC and immediately returns transaction hash
   * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#send-transaction-async)
   * @param signedTransaction The signed transaction being sent
   * @returns {Promise<FinalExecutionOutcome>}
   */
  sendTransactionAsync(t) {
    return sr(this, void 0, void 0, function* () {
      const n = (0, g2.encodeTransaction)(t);
      return this.sendJsonRpc("broadcast_tx_async", [Buffer.from(n).toString("base64")]);
    });
  }
  /**
   * Gets a transaction's status from the RPC
   * @see [https://docs.near.org/docs/develop/front-end/rpc#transaction-status](https://docs.near.org/docs/develop/front-end/rpc#general-validator-status)
   *
   * @param txHash A transaction hash as either a Uint8Array or a base58 encoded string
   * @param accountId The NEAR account that signed the transaction
   */
  txStatus(t, n) {
    return sr(this, void 0, void 0, function* () {
      return typeof t == "string" ? this.txStatusString(t, n) : this.txStatusUint8Array(t, n);
    });
  }
  txStatusUint8Array(t, n) {
    return sr(this, void 0, void 0, function* () {
      return this.sendJsonRpc("tx", [(0, b2.baseEncode)(t), n]);
    });
  }
  txStatusString(t, n) {
    return sr(this, void 0, void 0, function* () {
      return this.sendJsonRpc("tx", [t, n]);
    });
  }
  /**
   * Gets a transaction's status from the RPC with receipts
   * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#transaction-status-with-receipts)
   * @param txHash The hash of the transaction
   * @param accountId The NEAR account that signed the transaction
   * @returns {Promise<FinalExecutionOutcome>}
   */
  txStatusReceipts(t, n) {
    return sr(this, void 0, void 0, function* () {
      return typeof t == "string" ? this.sendJsonRpc("EXPERIMENTAL_tx_status", [t, n]) : this.sendJsonRpc("EXPERIMENTAL_tx_status", [(0, b2.baseEncode)(t), n]);
    });
  }
  /**
   * Query the RPC by passing an {@link providers/provider!RpcQueryRequest}
   * @see [https://docs.near.org/api/rpc/contracts](https://docs.near.org/api/rpc/contracts)
   *
   * @typeParam T the shape of the returned query response
   */
  query(...t) {
    return sr(this, void 0, void 0, function* () {
      let n;
      if (t.length === 1) {
        const r = t[0], { block_id: i, blockId: o } = r, a = y2(r, ["block_id", "blockId"]);
        n = yield this.sendJsonRpc("query", Object.assign(Object.assign({}, a), { block_id: i || o }));
      } else {
        const [r, i] = t;
        n = yield this.sendJsonRpc("query", [r, i]);
      }
      if (n && n.error)
        throw new cf.TypedError(`Querying failed: ${n.error}.
${JSON.stringify(n, null, 2)}`, (0, Mv.getErrorTypeFromErrorMessage)(n.error, n.error.name));
      return n;
    });
  }
  /**
   * Query for block info from the RPC
   * pass block_id OR finality as blockQuery, not both
   * @see [https://docs.near.org/api/rpc/block-chunk](https://docs.near.org/api/rpc/block-chunk)
   *
   * @param blockQuery {@link providers/provider!BlockReference} (passing a {@link providers/provider!BlockId} is deprecated)
   */
  block(t) {
    return sr(this, void 0, void 0, function* () {
      const { finality: n } = t, { blockId: r } = t;
      return this.sendJsonRpc("block", { block_id: r, finality: n });
    });
  }
  /**
   * Query changes in block from the RPC
   * pass block_id OR finality as blockQuery, not both
   * @see [https://docs.near.org/api/rpc/block-chunk](https://docs.near.org/api/rpc/block-chunk)
   */
  blockChanges(t) {
    return sr(this, void 0, void 0, function* () {
      const { finality: n } = t, { blockId: r } = t;
      return this.sendJsonRpc("EXPERIMENTAL_changes_in_block", { block_id: r, finality: n });
    });
  }
  /**
   * Queries for details about a specific chunk appending details of receipts and transactions to the same chunk data provided by a block
   * @see [https://docs.near.org/api/rpc/block-chunk](https://docs.near.org/api/rpc/block-chunk)
   *
   * @param chunkId Hash of a chunk ID or shard ID
   */
  chunk(t) {
    return sr(this, void 0, void 0, function* () {
      return this.sendJsonRpc("chunk", [t]);
    });
  }
  /**
   * Query validators of the epoch defined by the given block id.
   * @see [https://docs.near.org/api/rpc/network#validation-status](https://docs.near.org/api/rpc/network#validation-status)
   *
   * @param blockId Block hash or height, or null for latest.
   */
  validators(t) {
    return sr(this, void 0, void 0, function* () {
      return this.sendJsonRpc("validators", [t]);
    });
  }
  /**
   * Gets the protocol config at a block from RPC
   *
   * @param blockReference specifies the block to get the protocol config for
   */
  experimental_protocolConfig(t) {
    return sr(this, void 0, void 0, function* () {
      const n = t, { blockId: r } = n, i = y2(n, ["blockId"]);
      return yield this.sendJsonRpc("EXPERIMENTAL_protocol_config", Object.assign(Object.assign({}, i), { block_id: r }));
    });
  }
  /**
   * Gets a light client execution proof for verifying execution outcomes
   * @see [https://github.com/nearprotocol/NEPs/blob/master/specs/ChainSpec/LightClient.md#light-client-proof](https://github.com/nearprotocol/NEPs/blob/master/specs/ChainSpec/LightClient.md#light-client-proof)
   */
  lightClientProof(t) {
    return sr(this, void 0, void 0, function* () {
      return yield this.sendJsonRpc("EXPERIMENTAL_light_client_proof", t);
    });
  }
  /**
   * Returns the next light client block as far in the future as possible from the last known hash
   * to still be able to validate from that hash. This will either return the last block of the
   * next epoch, or the last final known block.
   *
   * @see [https://github.com/near/NEPs/blob/master/specs/ChainSpec/LightClient.md#light-client-block](https://github.com/near/NEPs/blob/master/specs/ChainSpec/LightClient.md#light-client-block)
   */
  nextLightClientBlock(t) {
    return sr(this, void 0, void 0, function* () {
      return yield this.sendJsonRpc("next_light_client_block", t);
    });
  }
  /**
   * Gets access key changes for a given array of accountIds
   * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-access-key-changes-all)
   * @returns {Promise<ChangeResult>}
   */
  accessKeyChanges(t, n) {
    return sr(this, void 0, void 0, function* () {
      const { finality: r } = n, { blockId: i } = n;
      return this.sendJsonRpc("EXPERIMENTAL_changes", {
        changes_type: "all_access_key_changes",
        account_ids: t,
        block_id: i,
        finality: r
      });
    });
  }
  /**
   * Gets single access key changes for a given array of access keys
   * pass block_id OR finality as blockQuery, not both
   * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-access-key-changes-single)
   * @returns {Promise<ChangeResult>}
   */
  singleAccessKeyChanges(t, n) {
    return sr(this, void 0, void 0, function* () {
      const { finality: r } = n, { blockId: i } = n;
      return this.sendJsonRpc("EXPERIMENTAL_changes", {
        changes_type: "single_access_key_changes",
        keys: t,
        block_id: i,
        finality: r
      });
    });
  }
  /**
   * Gets account changes for a given array of accountIds
   * pass block_id OR finality as blockQuery, not both
   * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-account-changes)
   * @returns {Promise<ChangeResult>}
   */
  accountChanges(t, n) {
    return sr(this, void 0, void 0, function* () {
      const { finality: r } = n, { blockId: i } = n;
      return this.sendJsonRpc("EXPERIMENTAL_changes", {
        changes_type: "account_changes",
        account_ids: t,
        block_id: i,
        finality: r
      });
    });
  }
  /**
   * Gets contract state changes for a given array of accountIds
   * pass block_id OR finality as blockQuery, not both
   * Note: If you pass a keyPrefix it must be base64 encoded
   * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-contract-state-changes)
   * @returns {Promise<ChangeResult>}
   */
  contractStateChanges(t, n, r = "") {
    return sr(this, void 0, void 0, function* () {
      const { finality: i } = n, { blockId: o } = n;
      return this.sendJsonRpc("EXPERIMENTAL_changes", {
        changes_type: "data_changes",
        account_ids: t,
        key_prefix_base64: r,
        block_id: o,
        finality: i
      });
    });
  }
  /**
   * Gets contract code changes for a given array of accountIds
   * pass block_id OR finality as blockQuery, not both
   * Note: Change is returned in a base64 encoded WASM file
   * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-contract-code-changes)
   * @returns {Promise<ChangeResult>}
   */
  contractCodeChanges(t, n) {
    return sr(this, void 0, void 0, function* () {
      const { finality: r } = n, { blockId: i } = n;
      return this.sendJsonRpc("EXPERIMENTAL_changes", {
        changes_type: "contract_code_changes",
        account_ids: t,
        block_id: i,
        finality: r
      });
    });
  }
  /**
   * Returns gas price for a specific block_height or block_hash.
   * @see [https://docs.near.org/api/rpc/gas](https://docs.near.org/api/rpc/gas)
   *
   * @param blockId Block hash or height, or null for latest.
   */
  gasPrice(t) {
    return sr(this, void 0, void 0, function* () {
      return yield this.sendJsonRpc("gas_price", [t]);
    });
  }
  /**
   * Directly call the RPC specifying the method and params
   *
   * @param method RPC method
   * @param params Parameters to the method
   */
  sendJsonRpc(t, n) {
    return sr(this, void 0, void 0, function* () {
      const r = yield (0, oV.exponentialBackoff)(cV, m2, uV, () => sr(this, void 0, void 0, function* () {
        try {
          const o = {
            method: t,
            params: n,
            id: lV++,
            jsonrpc: "2.0"
          }, a = yield (0, sV.fetchJson)(this.connection, JSON.stringify(o));
          if (a.error) {
            if (typeof a.error.data == "object")
              throw typeof a.error.data.error_message == "string" && typeof a.error.data.error_type == "string" ? new cf.TypedError(a.error.data.error_message, a.error.data.error_type) : (0, Mv.parseRpcError)(a.error.data);
            {
              const s = `[${a.error.code}] ${a.error.message}: ${a.error.data}`;
              throw a.error.data === "Timeout" || s.includes("Timeout error") || s.includes("query has timed out") ? new cf.TypedError(s, "TimeoutError") : new cf.TypedError(s, (0, Mv.getErrorTypeFromErrorMessage)(a.error.data, a.error.name));
            }
          }
          return a;
        } catch (o) {
          if (o.type === "TimeoutError")
            return process.env.NEAR_NO_LOGS || console.warn(`Retrying request to ${t} as it has timed out`, n), null;
          throw o;
        }
      })), { result: i } = r;
      if (typeof i > "u")
        throw new cf.TypedError(`Exceeded ${m2} attempts for request to ${t}.`, "RetriesExceeded");
      return i;
    });
  }
}
Vm.JsonRpcProvider = fV;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.fetchJson = e.Provider = e.JsonRpcProvider = e.exponentialBackoff = void 0;
  var t = jl;
  Object.defineProperty(e, "exponentialBackoff", { enumerable: !0, get: function() {
    return t.exponentialBackoff;
  } });
  var n = Vm;
  Object.defineProperty(e, "JsonRpcProvider", { enumerable: !0, get: function() {
    return n.JsonRpcProvider;
  } });
  var r = xd;
  Object.defineProperty(e, "Provider", { enumerable: !0, get: function() {
    return r.Provider;
  } });
  var i = Md;
  Object.defineProperty(e, "fetchJson", { enumerable: !0, get: function() {
    return i.fetchJson;
  } });
})(tk);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.FinalExecutionStatusBasic = e.ExecutionStatusBasic = e.IdType = e.Provider = e.getTransactionLastResult = void 0;
  var t = ZI;
  Object.defineProperty(e, "getTransactionLastResult", { enumerable: !0, get: function() {
    return t.getTransactionLastResult;
  } });
  var n = tk;
  Object.defineProperty(e, "Provider", { enumerable: !0, get: function() {
    return n.Provider;
  } });
  var r = bo;
  Object.defineProperty(e, "IdType", { enumerable: !0, get: function() {
    return r.IdType;
  } }), Object.defineProperty(e, "ExecutionStatusBasic", { enumerable: !0, get: function() {
    return r.ExecutionStatusBasic;
  } }), Object.defineProperty(e, "FinalExecutionStatusBasic", { enumerable: !0, get: function() {
    return r.FinalExecutionStatusBasic;
  } });
})(MC);
var oD = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.JsonRpcProvider = e.TypedError = e.ErrorContext = void 0;
  var t = bo;
  Object.defineProperty(e, "ErrorContext", { enumerable: !0, get: function() {
    return t.ErrorContext;
  } }), Object.defineProperty(e, "TypedError", { enumerable: !0, get: function() {
    return t.TypedError;
  } });
  var n = tk;
  Object.defineProperty(e, "JsonRpcProvider", { enumerable: !0, get: function() {
    return n.JsonRpcProvider;
  } });
})(oD);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ErrorContext = e.TypedError = e.getTransactionLastResult = e.FinalExecutionStatusBasic = e.JsonRpcProvider = e.Provider = void 0;
  const t = MC;
  Object.defineProperty(e, "Provider", { enumerable: !0, get: function() {
    return t.Provider;
  } }), Object.defineProperty(e, "getTransactionLastResult", { enumerable: !0, get: function() {
    return t.getTransactionLastResult;
  } }), Object.defineProperty(e, "FinalExecutionStatusBasic", { enumerable: !0, get: function() {
    return t.FinalExecutionStatusBasic;
  } });
  const n = oD;
  Object.defineProperty(e, "JsonRpcProvider", { enumerable: !0, get: function() {
    return n.JsonRpcProvider;
  } }), Object.defineProperty(e, "TypedError", { enumerable: !0, get: function() {
    return n.TypedError;
  } }), Object.defineProperty(e, "ErrorContext", { enumerable: !0, get: function() {
    return n.ErrorContext;
  } });
})(YI);
class dV {
  log(t) {
    return Object.assign(Object.assign({}, t), { logIndex: parseInt(t.logIndex), transactionIndex: parseInt(t.transactionIndex), blockNumber: parseInt(t.blockNumber) });
  }
  transactionReceipt(t) {
    return Object.assign(Object.assign({}, t), { transactionIndex: parseInt(t.transactionIndex), blockNumber: parseInt(t.blockNumber), cumulativeGasUsed: parseInt(t.cumulativeGasUsed), gasUsed: parseInt(t.gasUsed), status: parseInt(t.status), logs: t.logs.map((n) => this.log(n)) });
  }
}
function sk(e, t) {
  const n = t != null && t.padToBytes ? Math.max(t.padToBytes, 0) * 2 : 0;
  return (t != null && t.addPrefix ? "0x" : "") + e.padStart(n, "0");
}
function aD(e, t) {
  return sk(Buffer.from(e, "ascii").toString("hex"), t);
}
function Ma(e, t) {
  return sk(e.toString(16), t);
}
function eA(e, t) {
  return sk(sD(e), t);
}
function sD(e) {
  return e.startsWith("0x") ? e.slice(2) : e;
}
function hV(e, t = !0) {
  t && (e = e.substring(2));
  const n = parseInt(e.substring(0, 64), 16) * 2, r = parseInt(e.substring(n, n + 64), 16);
  e = e.substring(n + 64);
  let i = "";
  for (let o = 0; o < r * 2; o += 2)
    i += String.fromCharCode(parseInt(e.substring(o, o + 2), 16));
  return i;
}
var pV = globalThis && globalThis.__decorate || function(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(e, t, n, r);
  else
    for (var s = e.length - 1; s >= 0; s--)
      (a = e[s]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, n, o) : a(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
}, Ov = globalThis && globalThis.__metadata || function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
class ck {
  constructor(t, n) {
    this.contractAddress = t, this.url = n;
  }
  async fetchJsonRpc(t) {
    var n;
    const r = Object.assign({ jsonrpc: "2.0", id: 0 }, t), o = {
      method: "POST",
      headers: new Headers({
        "Content-type": "application/json"
      }),
      body: JSON.stringify(r)
    };
    try {
      const a = await fetch(this.url, o);
      if (!((n = a.headers.get("content-type")) === null || n === void 0 ? void 0 : n.includes("application/json")))
        throw new lt(`EVM RPC response is not JSON; url: ${this.url}; request: ${JSON.stringify(o)}; response: ${a}`);
      const c = await a.json();
      if (c.error)
        throw new lt(`EVM RPC response error; url: ${this.url}; request: ${JSON.stringify(o)}; error: ${JSON.stringify(c.error)}`);
      return c.result;
    } catch (a) {
      throw new lt(`EVM RPC fetch error; url: ${this.url}; request: ${JSON.stringify(o)}; error: ${a}`);
    }
  }
  ethCall(t) {
    const n = this.contractAddress;
    return this.fetchJsonRpc({
      method: "eth_call",
      params: [{ to: n, data: t }, "latest"]
    });
  }
  async hasValidNft(t) {
    const n = "0x9d267630", r = eA(t, { padToBytes: 32 }), i = n + r, o = await this.ethCall(i);
    return !!parseInt(o, 16);
  }
  async tokenOfOwnerByIndex(t, n) {
    const r = "0x2f745c59", i = eA(t, { padToBytes: 32 }), o = Ma(n, { padToBytes: 32 }), a = r + i + o, s = await this.ethCall(a);
    return parseInt(s, 16);
  }
  async tokenUri(t) {
    const n = "0xc87b56dd", r = Ma(t, { padToBytes: 32 }), i = n + r, o = await this.ethCall(i);
    return hV(o);
  }
  async getValidNftsCore(t) {
    var n;
    if (await this.hasValidNft(t.address)) {
      const i = await this.tokenOfOwnerByIndex(t.address, 0), o = await this.tokenUri(i), a = await fetch(Bb(o));
      if (!((n = a.headers.get("content-type")) === null || n === void 0 ? void 0 : n.includes("application/json")))
        throw console.error(a), new lt("EVM token metadata is not JSON");
      const c = await a.json();
      return c.image = Bb(c.image), {
        networkAndAddress: t,
        hasValidNft: !0,
        tokens: [c]
      };
    } else
      return {
        networkAndAddress: t,
        hasValidNft: !1
      };
  }
  async getValidNfts(t) {
    try {
      return this.getValidNftsCore(t);
    } catch (n) {
      let r;
      n instanceof $o ? r = n : r = new lt(String(n));
      const i = r.toString();
      return {
        networkAndAddress: t,
        error: i
      };
    }
  }
  async getGasPrice() {
    return parseInt(await this.fetchJsonRpc({
      method: "eth_gasPrice"
    }), 16);
  }
  async getMaxPriorityFeePerGas() {
    return parseInt(await this.fetchJsonRpc({
      method: "eth_maxPriorityFeePerGas"
    }), 16);
  }
  async getBaseFeePerGas() {
    const t = await this.fetchJsonRpc({
      method: "eth_getBlockByNumber",
      params: ["latest", !1]
    });
    return parseInt(t.baseFeePerGas, 16);
  }
}
pV([
  Gn(),
  Ov("design:type", Function),
  Ov("design:paramtypes", [Object]),
  Ov("design:returntype", Promise)
], ck.prototype, "getValidNftsCore", null);
var yV = globalThis && globalThis.__decorate || function(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(e, t, n, r);
  else
    for (var s = e.length - 1; s >= 0; s--)
      (a = e[s]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, n, o) : a(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
}, Pv = globalThis && globalThis.__metadata || function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
class cD {
  constructor(t, n) {
    this.provider = t, this.decoder = new dV(), this.networkMetadata = n;
  }
  isWalletConnect() {
    return !!this.provider.isWalletConnect;
  }
  async walletConnectEnable() {
    if (this.provider.isWalletConnect)
      return await this.provider.enable();
    throw new lt("Provider is not WalletConnect");
  }
  async walletConnectDisconnect() {
    if (this.provider.isWalletConnect)
      return await this.provider.disconnect();
    throw new lt("Provider is not WalletConnect");
  }
  async getTokenTransferEventHash() {
    return this.tokenTransferEventHash || (this.tokenTransferEventHash = await this.web3Sha3("Transfer(address,address,uint256)")), this.tokenTransferEventHash;
  }
  async request(t, n = !1) {
    return this.provider.request(t).then((r) => {
      if (!n && r == null)
        throw new lt(`EVM provider request method '${t.method}' returned no value. This can indicate an unsupported Ethereum wallet browser extension or multiple conflicting extensions. Please make sure that you are only using a single, supported extension and try again.`);
      return r;
    });
  }
  on(t, n) {
    this.provider.on(t, n);
  }
  async getAccounts() {
    return this.request({
      method: "eth_accounts"
    });
  }
  async requestAccounts() {
    return this.request({
      method: "eth_requestAccounts"
    });
  }
  async getChainId() {
    return this.request({
      method: "eth_chainId"
    });
  }
  async switchNetwork(t) {
    return this.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: t }]
    }, !0);
  }
  async switchOrAddNetwork(t) {
    if (!t.chain_id)
      throw new lt("switchOrAddNetwork error: chain ID for requested network is null");
    try {
      await this.switchNetwork(Ma(t.chain_id, { addPrefix: !0 }));
    } catch (n) {
      if (this.isChainMissingError(n))
        await this.addNetwork(t);
      else
        throw n;
    }
  }
  isChainMissingError(t) {
    return t instanceof ea && t.errorCode === "ChainMissing";
  }
  async addNetwork(t) {
    if (!t.chain_id)
      throw new lt("addNetwork error: chain ID for requested network is null");
    return this.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: Ma(t.chain_id, { addPrefix: !0 }),
          blockExplorerUrls: [t.explorer.url],
          chainName: t.name,
          nativeCurrency: t.native_currency,
          rpcUrls: t.rpc_urls
        }
      ]
    }, !0);
  }
  async personalSign(t, n) {
    return this.request({
      method: "personal_sign",
      params: [aD(t, { addPrefix: !0 }), n]
    });
  }
  async getGasPrice() {
    return this.request({
      method: "eth_gasPrice"
    });
  }
  async web3Sha3(t) {
    switch (t) {
      case "Transfer(address,address,uint256)":
        return "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef";
      case "mintWithCode(uint32)":
        return "0x71bff8e43607461eaf68af7b7bb306a32cbb13c4cdfe9a9f1a64f7832b050ae8";
      case "getRequiredMintCostForCode(uint32,address)":
        return "0xf82bacf04f8cc3e49b7c065af00ec174710a0d8d0514c21a7c4cdffb661ce0f2";
      default:
        throw new lt("Unknown input.");
    }
  }
  isRepeatableError(t) {
    const n = xC(t);
    if (!n)
      return !1;
    const { code: r, message: i } = n, o = [
      { code: 3, message: "Unauthorized code" },
      { code: -32e3, message: "header not found" },
      { code: -32005, message: "Try again after some time" }
    ];
    for (const a of o)
      if (r === a.code && i.includes(a.message))
        return console.log(`Repeatable error: ${i} (code: ${r})`), !0;
    return console.log(`Non-repeatable error: ${i} (code: ${r})`), !1;
  }
  async getSighash(t) {
    return (await this.web3Sha3(t)).substring(0, 10);
  }
  async estimateGas(t, n, r, i) {
    return this.request({
      method: "eth_estimateGas",
      params: [
        {
          data: t,
          to: n,
          from: r,
          value: i
        }
      ]
    });
  }
  async sendTransaction(t, n, r, i, o, a, s) {
    return this.request({
      method: "eth_sendTransaction",
      params: [
        {
          data: t,
          to: n,
          from: r,
          maxFeePerGas: i,
          maxPriorityFeePerGas: o,
          gas: a,
          value: s
        }
      ]
    });
  }
  async getTransactionReceipt(t) {
    const n = await this.request({
      method: "eth_getTransactionReceipt",
      params: [t]
    }, !0);
    return n ? this.decoder.transactionReceipt(n) : null;
  }
  async getMintingCostForCode(t, n, r) {
    var i;
    const o = Ma(parseInt(r), { padToBytes: 32 }), a = eA(n, { padToBytes: 32 }), c = await this.getSighash("getRequiredMintCostForCode(uint32,address)") + o + a;
    try {
      return await zE(() => this.request({
        method: "eth_call",
        params: [
          {
            data: c,
            to: t
          },
          "latest"
        ]
      }), 5e3, 16, {
        retryOnErrorPredicate: (l) => this.isRepeatableError(l),
        useExponentialBackoff: !1
      });
    } catch (l) {
      throw l instanceof UE ? new Pa("MintingCostCalculationError", "Timeout while calculating minting costs: " + ((i = l.wrappedError) === null || i === void 0 ? void 0 : i.message)) : l;
    }
  }
  async mint(t, n, r) {
    var i;
    const o = Ma(parseInt(r), { padToBytes: 32 }), a = await this.getMintingCostForCode(t, n, r), l = "0x" + new il(sD(a), "hex").muln(1.1).toString("hex"), f = await this.getSighash("mintWithCode(uint32)") + o;
    let d = null;
    try {
      d = await zE(() => this.estimateGas(f, t, n, l), 5e3, 8, {
        retryOnErrorPredicate: (I) => this.isRepeatableError(I),
        useExponentialBackoff: !1
      });
    } catch (I) {
      throw I instanceof UE ? new Pa("GasEstimationError", "Timeout while estimating gas" + ((i = I.wrappedError) === null || i === void 0 ? void 0 : i.message)) : I;
    }
    const h = await this.getChainId(), g = this.networkMetadata.find((I) => I.chain_id === Number(h));
    let w, b;
    if (g) {
      const I = new ck(t, g.rpc_urls[0]);
      for (let A = 4; A >= 0; A--)
        try {
          const x = await I.getBaseFeePerGas(), N = await I.getMaxPriorityFeePerGas();
          w = x * 2 + N, b = N;
          break;
        } catch (x) {
          if (A > 0)
            console.log(`Error while fetching fee: ${x}`);
          else
            throw x;
        }
    } else
      throw new lt("Unable to load network metadata");
    if (w && b) {
      const I = Ma(w, {
        addPrefix: !0
      }), A = Ma(b, {
        addPrefix: !0
      }), x = await this.sendTransaction(f, t, n, I, A, d, l);
      return x !== Ma(0, { addPrefix: !0, padToBytes: 32 }) ? x : void 0;
    } else
      throw new lt("Unable to estimate gas");
  }
  async getTokenIdFromReceipt(t) {
    const n = await this.getTokenTransferEventHash(), r = t.logs.find((i) => i.topics[0] === n);
    if (r) {
      const i = r.topics[3];
      return parseInt(i).toString();
    }
  }
}
yV([
  Gn(),
  Pv("design:type", Function),
  Pv("design:paramtypes", [String]),
  Pv("design:returntype", Promise)
], cD.prototype, "switchNetwork", null);
var gV = globalThis && globalThis.__decorate || function(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(e, t, n, r);
  else
    for (var s = e.length - 1; s >= 0; s--)
      (a = e[s]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, n, o) : a(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
}, Bv = globalThis && globalThis.__metadata || function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
class uD {
  constructor(t, n) {
    this.contractAddress = t, this.url = n, this.provider = new YI.JsonRpcProvider({ url: n });
  }
  async callFunction(t, n) {
    const r = Buffer.from(JSON.stringify(n)).toString("base64");
    try {
      const i = await this.provider.query({
        request_type: "call_function",
        account_id: this.contractAddress,
        method_name: t,
        args_base64: r,
        finality: "final"
      });
      return JSON.parse(Buffer.from(i.result).toString());
    } catch (i) {
      throw console.error(i), new lt("NEAR RPC query error");
    }
  }
  async hasValidNft(t) {
    const n = { address: t };
    return this.callFunction("has_valid_token", n);
  }
  async ntnftTokensForOwner(t) {
    const n = { account_id: t, from_index: "0", limit: 1 };
    return this.callFunction("ntnft_tokens_for_owner", n);
  }
  validateTokenMetadata(t) {
    const n = t.metadata;
    if (!n || !n.title || !n.description || !n.media)
      throw new lt("NEAR token metadata is invalid");
    return {
      name: n.title,
      description: n.description,
      image: Bb(n.media)
    };
  }
  async getValidNftsCore(t) {
    if (await this.hasValidNft(t.address)) {
      const r = await this.ntnftTokensForOwner(t.address);
      if (!r.length)
        throw new lt("NEAR account has no tokens while it should have at least one.");
      const i = this.validateTokenMetadata(r[0]);
      return {
        networkAndAddress: t,
        hasValidNft: !0,
        tokens: [i]
      };
    } else
      return {
        networkAndAddress: t,
        hasValidNft: !1
      };
  }
  async getValidNfts(t) {
    try {
      return this.getValidNftsCore(t);
    } catch (n) {
      let r;
      n instanceof $o ? r = n : r = new lt(String(n));
      const i = r.toString();
      return {
        networkAndAddress: t,
        error: i
      };
    }
  }
}
gV([
  Gn(),
  Bv("design:type", Function),
  Bv("design:paramtypes", [Object]),
  Bv("design:returntype", Promise)
], uD.prototype, "getValidNftsCore", null);
function tA(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function bV(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function lD(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function mV(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  tA(e.outputLen), tA(e.blockLen);
}
function _V(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function wV(e, t) {
  lD(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const ji = {
  number: tA,
  bool: bV,
  bytes: lD,
  hash: mV,
  exists: _V,
  output: wV
};
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const vV = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), Cv = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), Go = (e, t) => e << 32 - t | e >>> t, SV = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!SV)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function EV(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function Od(e) {
  if (typeof e == "string" && (e = EV(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
let uk = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function eu(e) {
  const t = (r) => e().update(Od(r)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
function AV(e) {
  const t = (r, i) => e(i).update(Od(r)).digest(), n = e({});
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = (r) => e(r), t;
}
function IV(e, t, n, r) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, n, r);
  const i = BigInt(32), o = BigInt(4294967295), a = Number(n >> i & o), s = Number(n & o), c = r ? 4 : 0, l = r ? 0 : 4;
  e.setUint32(t + c, a, r), e.setUint32(t + l, s, r);
}
let fD = class extends uk {
  constructor(t, n, r, i) {
    super(), this.blockLen = t, this.outputLen = n, this.padOffset = r, this.isLE = i, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = Cv(this.buffer);
  }
  update(t) {
    ji.exists(this);
    const { view: n, buffer: r, blockLen: i } = this;
    t = Od(t);
    const o = t.length;
    for (let a = 0; a < o; ) {
      const s = Math.min(i - this.pos, o - a);
      if (s === i) {
        const c = Cv(t);
        for (; i <= o - a; a += i)
          this.process(c, a);
        continue;
      }
      r.set(t.subarray(a, a + s), this.pos), this.pos += s, a += s, this.pos === i && (this.process(n, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    ji.exists(this), ji.output(t, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: i, isLE: o } = this;
    let { pos: a } = this;
    n[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > i - a && (this.process(r, 0), a = 0);
    for (let f = a; f < i; f++)
      n[f] = 0;
    IV(r, i - 8, BigInt(this.length * 8), o), this.process(r, 0);
    const s = Cv(t), c = this.outputLen;
    if (c % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = c / 4, u = this.get();
    if (l > u.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let f = 0; f < l; f++)
      s.setUint32(4 * f, u[f], o);
  }
  digest() {
    const { buffer: t, outputLen: n } = this;
    this.digestInto(t);
    const r = t.slice(0, n);
    return this.destroy(), r;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: n, buffer: r, length: i, finished: o, destroyed: a, pos: s } = this;
    return t.length = i, t.pos = s, t.finished = o, t.destroyed = a, i % n && t.buffer.set(r), t;
  }
};
const gg = BigInt(2 ** 32 - 1), nA = BigInt(32);
function dD(e, t = !1) {
  return t ? { h: Number(e & gg), l: Number(e >> nA & gg) } : { h: Number(e >> nA & gg) | 0, l: Number(e & gg) | 0 };
}
function kV(e, t = !1) {
  let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
  for (let i = 0; i < e.length; i++) {
    const { h: o, l: a } = dD(e[i], t);
    [n[i], r[i]] = [o, a];
  }
  return [n, r];
}
const TV = (e, t) => BigInt(e >>> 0) << nA | BigInt(t >>> 0), xV = (e, t, n) => e >>> n, MV = (e, t, n) => e << 32 - n | t >>> n, OV = (e, t, n) => e >>> n | t << 32 - n, PV = (e, t, n) => e << 32 - n | t >>> n, BV = (e, t, n) => e << 64 - n | t >>> n - 32, CV = (e, t, n) => e >>> n - 32 | t << 64 - n, DV = (e, t) => t, RV = (e, t) => e, NV = (e, t, n) => e << n | t >>> 32 - n, jV = (e, t, n) => t << n | e >>> 32 - n, UV = (e, t, n) => t << n - 32 | e >>> 64 - n, zV = (e, t, n) => e << n - 32 | t >>> 64 - n;
function FV(e, t, n, r) {
  const i = (t >>> 0) + (r >>> 0);
  return { h: e + n + (i / 2 ** 32 | 0) | 0, l: i | 0 };
}
const LV = (e, t, n) => (e >>> 0) + (t >>> 0) + (n >>> 0), $V = (e, t, n, r) => t + n + r + (e / 2 ** 32 | 0) | 0, WV = (e, t, n, r) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0), KV = (e, t, n, r, i) => t + n + r + i + (e / 2 ** 32 | 0) | 0, VV = (e, t, n, r, i) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0) + (i >>> 0), qV = (e, t, n, r, i, o) => t + n + r + i + o + (e / 2 ** 32 | 0) | 0, Ct = {
  fromBig: dD,
  split: kV,
  toBig: TV,
  shrSH: xV,
  shrSL: MV,
  rotrSH: OV,
  rotrSL: PV,
  rotrBH: BV,
  rotrBL: CV,
  rotr32H: DV,
  rotr32L: RV,
  rotlSH: NV,
  rotlSL: jV,
  rotlBH: UV,
  rotlBL: zV,
  add: FV,
  add3L: LV,
  add3H: $V,
  add4L: WV,
  add4H: KV,
  add5H: qV,
  add5L: VV
}, [HV, GV] = Ct.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), rs = new Uint32Array(80), is = new Uint32Array(80);
let Qm = class extends fD {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: n, Bh: r, Bl: i, Ch: o, Cl: a, Dh: s, Dl: c, Eh: l, El: u, Fh: f, Fl: d, Gh: h, Gl: g, Hh: w, Hl: b } = this;
    return [t, n, r, i, o, a, s, c, l, u, f, d, h, g, w, b];
  }
  // prettier-ignore
  set(t, n, r, i, o, a, s, c, l, u, f, d, h, g, w, b) {
    this.Ah = t | 0, this.Al = n | 0, this.Bh = r | 0, this.Bl = i | 0, this.Ch = o | 0, this.Cl = a | 0, this.Dh = s | 0, this.Dl = c | 0, this.Eh = l | 0, this.El = u | 0, this.Fh = f | 0, this.Fl = d | 0, this.Gh = h | 0, this.Gl = g | 0, this.Hh = w | 0, this.Hl = b | 0;
  }
  process(t, n) {
    for (let x = 0; x < 16; x++, n += 4)
      rs[x] = t.getUint32(n), is[x] = t.getUint32(n += 4);
    for (let x = 16; x < 80; x++) {
      const N = rs[x - 15] | 0, j = is[x - 15] | 0, K = Ct.rotrSH(N, j, 1) ^ Ct.rotrSH(N, j, 8) ^ Ct.shrSH(N, j, 7), W = Ct.rotrSL(N, j, 1) ^ Ct.rotrSL(N, j, 8) ^ Ct.shrSL(N, j, 7), O = rs[x - 2] | 0, k = is[x - 2] | 0, z = Ct.rotrSH(O, k, 19) ^ Ct.rotrBH(O, k, 61) ^ Ct.shrSH(O, k, 6), C = Ct.rotrSL(O, k, 19) ^ Ct.rotrBL(O, k, 61) ^ Ct.shrSL(O, k, 6), M = Ct.add4L(W, C, is[x - 7], is[x - 16]), S = Ct.add4H(M, K, z, rs[x - 7], rs[x - 16]);
      rs[x] = S | 0, is[x] = M | 0;
    }
    let { Ah: r, Al: i, Bh: o, Bl: a, Ch: s, Cl: c, Dh: l, Dl: u, Eh: f, El: d, Fh: h, Fl: g, Gh: w, Gl: b, Hh: I, Hl: A } = this;
    for (let x = 0; x < 80; x++) {
      const N = Ct.rotrSH(f, d, 14) ^ Ct.rotrSH(f, d, 18) ^ Ct.rotrBH(f, d, 41), j = Ct.rotrSL(f, d, 14) ^ Ct.rotrSL(f, d, 18) ^ Ct.rotrBL(f, d, 41), K = f & h ^ ~f & w, W = d & g ^ ~d & b, O = Ct.add5L(A, j, W, GV[x], is[x]), k = Ct.add5H(O, I, N, K, HV[x], rs[x]), z = O | 0, C = Ct.rotrSH(r, i, 28) ^ Ct.rotrBH(r, i, 34) ^ Ct.rotrBH(r, i, 39), M = Ct.rotrSL(r, i, 28) ^ Ct.rotrBL(r, i, 34) ^ Ct.rotrBL(r, i, 39), S = r & o ^ r & s ^ o & s, p = i & a ^ i & c ^ a & c;
      I = w | 0, A = b | 0, w = h | 0, b = g | 0, h = f | 0, g = d | 0, { h: f, l: d } = Ct.add(l | 0, u | 0, k | 0, z | 0), l = s | 0, u = c | 0, s = o | 0, c = a | 0, o = r | 0, a = i | 0;
      const y = Ct.add3L(z, M, p);
      r = Ct.add3H(y, k, C, S), i = y | 0;
    }
    ({ h: r, l: i } = Ct.add(this.Ah | 0, this.Al | 0, r | 0, i | 0)), { h: o, l: a } = Ct.add(this.Bh | 0, this.Bl | 0, o | 0, a | 0), { h: s, l: c } = Ct.add(this.Ch | 0, this.Cl | 0, s | 0, c | 0), { h: l, l: u } = Ct.add(this.Dh | 0, this.Dl | 0, l | 0, u | 0), { h: f, l: d } = Ct.add(this.Eh | 0, this.El | 0, f | 0, d | 0), { h, l: g } = Ct.add(this.Fh | 0, this.Fl | 0, h | 0, g | 0), { h: w, l: b } = Ct.add(this.Gh | 0, this.Gl | 0, w | 0, b | 0), { h: I, l: A } = Ct.add(this.Hh | 0, this.Hl | 0, I | 0, A | 0), this.set(r, i, o, a, s, c, l, u, f, d, h, g, w, b, I, A);
  }
  roundClean() {
    rs.fill(0), is.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
class YV extends Qm {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}
let ZV = class extends Qm {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}, JV = class extends Qm {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
};
const XV = eu(() => new Qm());
eu(() => new YV());
eu(() => new ZV());
eu(() => new JV());
/*! noble-ed25519 - MIT License (c) 2019 Paul Miller (paulmillr.com) */
const Gr = BigInt(0), bn = BigInt(1), Is = BigInt(2), QV = BigInt(8), _2 = BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"), er = Object.freeze({
  a: BigInt(-1),
  d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
  P: BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"),
  l: _2,
  n: _2,
  h: BigInt(8),
  Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
  Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960")
}), hD = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000"), Lf = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
BigInt("6853475219497561581579357271197624642482790079785650197046958215289687604742");
const eq = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235"), tq = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578"), nq = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838"), rq = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
class pn {
  constructor(t, n, r, i) {
    this.x = t, this.y = n, this.z = r, this.t = i;
  }
  static fromAffine(t) {
    if (!(t instanceof Pr))
      throw new TypeError("ExtendedPoint#fromAffine: expected Point");
    return t.equals(Pr.ZERO) ? pn.ZERO : new pn(t.x, t.y, bn, xe(t.x * t.y));
  }
  static toAffineBatch(t) {
    const n = aq(t.map((r) => r.z));
    return t.map((r, i) => r.toAffine(n[i]));
  }
  static normalizeZ(t) {
    return this.toAffineBatch(t).map(this.fromAffine);
  }
  equals(t) {
    v2(t);
    const { x: n, y: r, z: i } = this, { x: o, y: a, z: s } = t, c = xe(n * s), l = xe(o * i), u = xe(r * s), f = xe(a * i);
    return c === l && u === f;
  }
  negate() {
    return new pn(xe(-this.x), this.y, this.z, xe(-this.t));
  }
  double() {
    const { x: t, y: n, z: r } = this, { a: i } = er, o = xe(t * t), a = xe(n * n), s = xe(Is * xe(r * r)), c = xe(i * o), l = t + n, u = xe(xe(l * l) - o - a), f = c + a, d = f - s, h = c - a, g = xe(u * d), w = xe(f * h), b = xe(u * h), I = xe(d * f);
    return new pn(g, w, I, b);
  }
  add(t) {
    v2(t);
    const { x: n, y: r, z: i, t: o } = this, { x: a, y: s, z: c, t: l } = t, u = xe((r - n) * (s + a)), f = xe((r + n) * (s - a)), d = xe(f - u);
    if (d === Gr)
      return this.double();
    const h = xe(i * Is * l), g = xe(o * Is * c), w = g + h, b = f + u, I = g - h, A = xe(w * d), x = xe(b * I), N = xe(w * I), j = xe(d * b);
    return new pn(A, x, j, N);
  }
  subtract(t) {
    return this.add(t.negate());
  }
  precomputeWindow(t) {
    const n = 1 + 256 / t, r = [];
    let i = this, o = i;
    for (let a = 0; a < n; a++) {
      o = i, r.push(o);
      for (let s = 1; s < 2 ** (t - 1); s++)
        o = o.add(i), r.push(o);
      i = o.double();
    }
    return r;
  }
  wNAF(t, n) {
    !n && this.equals(pn.BASE) && (n = Pr.BASE);
    const r = n && n._WINDOW_SIZE || 1;
    if (256 % r)
      throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
    let i = n && rA.get(n);
    i || (i = this.precomputeWindow(r), n && r !== 1 && (i = pn.normalizeZ(i), rA.set(n, i)));
    let o = pn.ZERO, a = pn.BASE;
    const s = 1 + 256 / r, c = 2 ** (r - 1), l = BigInt(2 ** r - 1), u = 2 ** r, f = BigInt(r);
    for (let d = 0; d < s; d++) {
      const h = d * c;
      let g = Number(t & l);
      t >>= f, g > c && (g -= u, t += bn);
      const w = h, b = h + Math.abs(g) - 1, I = d % 2 !== 0, A = g < 0;
      g === 0 ? a = a.add(w2(I, i[w])) : o = o.add(w2(A, i[b]));
    }
    return pn.normalizeZ([o, a])[0];
  }
  multiply(t, n) {
    return this.wNAF(Fb(t, er.l), n);
  }
  multiplyUnsafe(t) {
    let n = Fb(t, er.l, !1);
    const r = pn.BASE, i = pn.ZERO;
    if (n === Gr)
      return i;
    if (this.equals(i) || n === bn)
      return this;
    if (this.equals(r))
      return this.wNAF(n);
    let o = i, a = this;
    for (; n > Gr; )
      n & bn && (o = o.add(a)), a = a.double(), n >>= bn;
    return o;
  }
  isSmallOrder() {
    return this.multiplyUnsafe(er.h).equals(pn.ZERO);
  }
  isTorsionFree() {
    let t = this.multiplyUnsafe(er.l / Is).double();
    return er.l % Is && (t = t.add(this)), t.equals(pn.ZERO);
  }
  toAffine(t) {
    const { x: n, y: r, z: i } = this, o = this.equals(pn.ZERO);
    t == null && (t = o ? QV : e_(i));
    const a = xe(n * t), s = xe(r * t), c = xe(i * t);
    if (o)
      return Pr.ZERO;
    if (c !== bn)
      throw new Error("invZ was invalid");
    return new Pr(a, s);
  }
  fromRistrettoBytes() {
    Rv();
  }
  toRistrettoBytes() {
    Rv();
  }
  fromRistrettoHash() {
    Rv();
  }
}
pn.BASE = new pn(er.Gx, er.Gy, bn, xe(er.Gx * er.Gy));
pn.ZERO = new pn(Gr, bn, bn, Gr);
function w2(e, t) {
  const n = t.negate();
  return e ? n : t;
}
function v2(e) {
  if (!(e instanceof pn))
    throw new TypeError("ExtendedPoint expected");
}
function Dv(e) {
  if (!(e instanceof oo))
    throw new TypeError("RistrettoPoint expected");
}
function Rv() {
  throw new Error("Legacy method: switch to RistrettoPoint");
}
class oo {
  constructor(t) {
    this.ep = t;
  }
  static calcElligatorRistrettoMap(t) {
    const { d: n } = er, r = xe(Lf * t * t), i = xe((r + bn) * nq);
    let o = BigInt(-1);
    const a = xe((o - n * r) * xe(r + n));
    let { isValid: s, value: c } = fk(i, a), l = xe(c * t);
    ms(l) || (l = xe(-l)), s || (c = l), s || (o = r);
    const u = xe(o * (r - bn) * rq - a), f = c * c, d = xe((c + c) * a), h = xe(u * eq), g = xe(bn - f), w = xe(bn + f);
    return new pn(xe(d * w), xe(g * h), xe(h * w), xe(d * g));
  }
  static hashToCurve(t) {
    t = Hs(t, 64);
    const n = Nv(t.slice(0, 32)), r = this.calcElligatorRistrettoMap(n), i = Nv(t.slice(32, 64)), o = this.calcElligatorRistrettoMap(i);
    return new oo(r.add(o));
  }
  static fromHex(t) {
    t = Hs(t, 32);
    const { a: n, d: r } = er, i = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint", o = Nv(t);
    if (!cq(td(o), t) || ms(o))
      throw new Error(i);
    const a = xe(o * o), s = xe(bn + n * a), c = xe(bn - n * a), l = xe(s * s), u = xe(c * c), f = xe(n * r * l - u), { isValid: d, value: h } = E2(xe(f * u)), g = xe(h * c), w = xe(h * g * f);
    let b = xe((o + o) * g);
    ms(b) && (b = xe(-b));
    const I = xe(s * w), A = xe(b * I);
    if (!d || ms(A) || I === Gr)
      throw new Error(i);
    return new oo(new pn(b, I, bn, A));
  }
  toRawBytes() {
    let { x: t, y: n, z: r, t: i } = this.ep;
    const o = xe(xe(r + n) * xe(r - n)), a = xe(t * n), s = xe(a * a), { value: c } = E2(xe(o * s)), l = xe(c * o), u = xe(c * a), f = xe(l * u * i);
    let d;
    if (ms(i * f)) {
      let g = xe(n * Lf), w = xe(t * Lf);
      t = g, n = w, d = xe(l * tq);
    } else
      d = u;
    ms(t * f) && (n = xe(-n));
    let h = xe((r - n) * d);
    return ms(h) && (h = xe(-h)), td(h);
  }
  toHex() {
    return Pd(this.toRawBytes());
  }
  toString() {
    return this.toHex();
  }
  equals(t) {
    Dv(t);
    const n = this.ep, r = t.ep, i = xe(n.x * r.y) === xe(n.y * r.x), o = xe(n.y * r.y) === xe(n.x * r.x);
    return i || o;
  }
  add(t) {
    return Dv(t), new oo(this.ep.add(t.ep));
  }
  subtract(t) {
    return Dv(t), new oo(this.ep.subtract(t.ep));
  }
  multiply(t) {
    return new oo(this.ep.multiply(t));
  }
  multiplyUnsafe(t) {
    return new oo(this.ep.multiplyUnsafe(t));
  }
}
oo.BASE = new oo(pn.BASE);
oo.ZERO = new oo(pn.ZERO);
const rA = /* @__PURE__ */ new WeakMap();
let Pr = class iA {
  constructor(t, n) {
    this.x = t, this.y = n;
  }
  _setWindowSize(t) {
    this._WINDOW_SIZE = t, rA.delete(this);
  }
  static fromHex(t, n = !0) {
    const { d: r, P: i } = er;
    t = Hs(t, 32);
    const o = t.slice();
    o[31] = t[31] & -129;
    const a = Bd(o);
    if (n && a >= i)
      throw new Error("Expected 0 < hex < P");
    if (!n && a >= hD)
      throw new Error("Expected 0 < hex < 2**256");
    const s = xe(a * a), c = xe(s - bn), l = xe(r * s + bn);
    let { isValid: u, value: f } = fk(c, l);
    if (!u)
      throw new Error("Point.fromHex: invalid y coordinate");
    const d = (f & bn) === bn;
    return (t[31] & 128) !== 0 !== d && (f = xe(-f)), new iA(f, a);
  }
  static async fromPrivateKey(t) {
    return (await mD(t)).point;
  }
  toRawBytes() {
    const t = td(this.y);
    return t[31] |= this.x & bn ? 128 : 0, t;
  }
  toHex() {
    return Pd(this.toRawBytes());
  }
  toX25519() {
    const { y: t } = this, n = xe((bn + t) * e_(bn - t));
    return td(n);
  }
  isTorsionFree() {
    return pn.fromAffine(this).isTorsionFree();
  }
  equals(t) {
    return this.x === t.x && this.y === t.y;
  }
  negate() {
    return new iA(xe(-this.x), this.y);
  }
  add(t) {
    return pn.fromAffine(this).add(pn.fromAffine(t)).toAffine();
  }
  subtract(t) {
    return this.add(t.negate());
  }
  multiply(t) {
    return pn.fromAffine(this).multiply(t, this).toAffine();
  }
};
Pr.BASE = new Pr(er.Gx, er.Gy);
Pr.ZERO = new Pr(Gr, bn);
let oA = class pD {
  constructor(t, n) {
    this.r = t, this.s = n, this.assertValidity();
  }
  static fromHex(t) {
    const n = Hs(t, 64), r = Pr.fromHex(n.slice(0, 32), !1), i = Bd(n.slice(32, 64));
    return new pD(r, i);
  }
  assertValidity() {
    const { r: t, s: n } = this;
    if (!(t instanceof Pr))
      throw new Error("Expected Point instance");
    return Fb(n, er.l, !1), this;
  }
  toRawBytes() {
    const t = new Uint8Array(64);
    return t.set(this.r.toRawBytes()), t.set(td(this.s), 32), t;
  }
  toHex() {
    return Pd(this.toRawBytes());
  }
};
function S2(...e) {
  if (!e.every((r) => r instanceof Uint8Array))
    throw new Error("Expected Uint8Array list");
  if (e.length === 1)
    return e[0];
  const t = e.reduce((r, i) => r + i.length, 0), n = new Uint8Array(t);
  for (let r = 0, i = 0; r < e.length; r++) {
    const o = e[r];
    n.set(o, i), i += o.length;
  }
  return n;
}
const iq = Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Pd(e) {
  if (!(e instanceof Uint8Array))
    throw new Error("Uint8Array expected");
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += iq[e[n]];
  return t;
}
function lk(e) {
  if (typeof e != "string")
    throw new TypeError("hexToBytes: expected string, got " + typeof e);
  if (e.length % 2)
    throw new Error("hexToBytes: received invalid unpadded hex");
  const t = new Uint8Array(e.length / 2);
  for (let n = 0; n < t.length; n++) {
    const r = n * 2, i = e.slice(r, r + 2), o = Number.parseInt(i, 16);
    if (Number.isNaN(o) || o < 0)
      throw new Error("Invalid byte sequence");
    t[n] = o;
  }
  return t;
}
function yD(e) {
  const n = e.toString(16).padStart(64, "0");
  return lk(n);
}
function td(e) {
  return yD(e).reverse();
}
function ms(e) {
  return (xe(e) & bn) === bn;
}
function Bd(e) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  return BigInt("0x" + Pd(Uint8Array.from(e).reverse()));
}
const oq = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function Nv(e) {
  return xe(Bd(e) & oq);
}
function xe(e, t = er.P) {
  const n = e % t;
  return n >= Gr ? n : t + n;
}
function e_(e, t = er.P) {
  if (e === Gr || t <= Gr)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let n = xe(e, t), r = t, i = Gr, o = bn;
  for (; n !== Gr; ) {
    const s = r / n, c = r % n, l = i - o * s;
    r = n, n = c, i = o, o = l;
  }
  if (r !== bn)
    throw new Error("invert: does not exist");
  return xe(i, t);
}
function aq(e, t = er.P) {
  const n = new Array(e.length), r = e.reduce((o, a, s) => a === Gr ? o : (n[s] = o, xe(o * a, t)), bn), i = e_(r, t);
  return e.reduceRight((o, a, s) => a === Gr ? o : (n[s] = xe(o * n[s], t), xe(o * a, t)), i), n;
}
function Yo(e, t) {
  const { P: n } = er;
  let r = e;
  for (; t-- > Gr; )
    r *= r, r %= n;
  return r;
}
function sq(e) {
  const { P: t } = er, n = BigInt(5), r = BigInt(10), i = BigInt(20), o = BigInt(40), a = BigInt(80), c = e * e % t * e % t, l = Yo(c, Is) * c % t, u = Yo(l, bn) * e % t, f = Yo(u, n) * u % t, d = Yo(f, r) * f % t, h = Yo(d, i) * d % t, g = Yo(h, o) * h % t, w = Yo(g, a) * g % t, b = Yo(w, a) * g % t, I = Yo(b, r) * f % t;
  return { pow_p_5_8: Yo(I, Is) * e % t, b2: c };
}
function fk(e, t) {
  const n = xe(t * t * t), r = xe(n * n * t), i = sq(e * r).pow_p_5_8;
  let o = xe(e * n * i);
  const a = xe(t * o * o), s = o, c = xe(o * Lf), l = a === e, u = a === xe(-e), f = a === xe(-e * Lf);
  return l && (o = s), (u || f) && (o = c), ms(o) && (o = xe(-o)), { isValid: l || u, value: o };
}
function E2(e) {
  return fk(bn, e);
}
function zb(e) {
  return xe(Bd(e), er.l);
}
function cq(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Hs(e, t) {
  const n = e instanceof Uint8Array ? Uint8Array.from(e) : lk(e);
  if (typeof t == "number" && n.length !== t)
    throw new Error(`Expected ${t} bytes`);
  return n;
}
function Fb(e, t, n = !0) {
  if (!t)
    throw new TypeError("Specify max value");
  if (typeof e == "number" && Number.isSafeInteger(e) && (e = BigInt(e)), typeof e == "bigint" && e < t) {
    if (n) {
      if (Gr < e)
        return e;
    } else if (Gr <= e)
      return e;
  }
  throw new TypeError("Expected valid scalar: 0 < scalar < max");
}
function uq(e) {
  return e[0] &= 248, e[31] &= 127, e[31] |= 64, e;
}
function gD(e) {
  if (e = typeof e == "bigint" || typeof e == "number" ? yD(Fb(e, hD)) : Hs(e), e.length !== 32)
    throw new Error("Expected 32 bytes");
  return e;
}
function bD(e) {
  const t = uq(e.slice(0, 32)), n = e.slice(32, 64), r = zb(t), i = Pr.BASE.multiply(r), o = i.toRawBytes();
  return { head: t, prefix: n, scalar: r, point: i, pointBytes: o };
}
let $f;
function Lb(...e) {
  if (typeof $f != "function")
    throw new Error("utils.sha512Sync must be set to use sync methods");
  return $f(...e);
}
async function mD(e) {
  return bD(await Pc.sha512(gD(e)));
}
function dk(e) {
  return bD(Lb(gD(e)));
}
function lq(e) {
  return dk(e).pointBytes;
}
function fq(e, t) {
  e = Hs(e);
  const { prefix: n, scalar: r, pointBytes: i } = dk(t), o = zb(Lb(n, e)), a = Pr.BASE.multiply(o), s = zb(Lb(a.toRawBytes(), i, e)), c = xe(o + s * r, er.l);
  return new oA(a, c).toRawBytes();
}
function dq(e, t, n) {
  t = Hs(t), n instanceof Pr || (n = Pr.fromHex(n, !1));
  const { r, s: i } = e instanceof oA ? e.assertValidity() : oA.fromHex(e), o = pn.BASE.multiplyUnsafe(i);
  return { r, s: i, SB: o, pub: n, msg: t };
}
function hq(e, t, n, r) {
  const i = zb(r), o = pn.fromAffine(e).multiplyUnsafe(i);
  return pn.fromAffine(t).add(o).subtract(n).multiplyUnsafe(er.h).equals(pn.ZERO);
}
function pq(e, t, n) {
  const { r, SB: i, msg: o, pub: a } = dq(e, t, n), s = Lb(r.toRawBytes(), a.toRawBytes(), o);
  return hq(a, r, i, s);
}
const hk = {
  getExtendedPublicKey: dk,
  getPublicKey: lq,
  sign: fq,
  verify: pq
};
Pr.BASE._setWindowSize(8);
const os = {
  node: CI,
  web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
}, Pc = {
  bytesToHex: Pd,
  hexToBytes: lk,
  concatBytes: S2,
  getExtendedPublicKey: mD,
  mod: xe,
  invert: e_,
  TORSION_SUBGROUP: [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
  ],
  hashToPrivateScalar: (e) => {
    if (e = Hs(e), e.length < 40 || e.length > 1024)
      throw new Error("Expected 40-1024 bytes of private key as per FIPS 186");
    return xe(Bd(e), er.l - bn) + bn;
  },
  randomBytes: (e = 32) => {
    if (os.web)
      return os.web.getRandomValues(new Uint8Array(e));
    if (os.node) {
      const { randomBytes: t } = os.node;
      return new Uint8Array(t(e).buffer);
    } else
      throw new Error("The environment doesn't have randomBytes function");
  },
  randomPrivateKey: () => Pc.randomBytes(32),
  sha512: async (...e) => {
    const t = S2(...e);
    if (os.web) {
      const n = await os.web.subtle.digest("SHA-512", t.buffer);
      return new Uint8Array(n);
    } else {
      if (os.node)
        return Uint8Array.from(os.node.createHash("sha512").update(t).digest());
      throw new Error("The environment doesn't have sha512 function");
    }
  },
  precompute(e = 8, t = Pr.BASE) {
    const n = t.equals(Pr.BASE) ? t : new Pr(t.x, t.y);
    return n._setWindowSize(e), n.multiply(Is), n;
  },
  sha512Sync: void 0
};
Object.defineProperties(Pc, {
  sha512Sync: {
    configurable: !1,
    get() {
      return $f;
    },
    set(e) {
      $f || ($f = e);
    }
  }
});
const yq = (e, t, n) => e & t ^ ~e & n, gq = (e, t, n) => e & t ^ e & n ^ t & n, bq = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), as = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), ss = new Uint32Array(64);
let _D = class extends fD {
  constructor() {
    super(64, 32, 8, !1), this.A = as[0] | 0, this.B = as[1] | 0, this.C = as[2] | 0, this.D = as[3] | 0, this.E = as[4] | 0, this.F = as[5] | 0, this.G = as[6] | 0, this.H = as[7] | 0;
  }
  get() {
    const { A: t, B: n, C: r, D: i, E: o, F: a, G: s, H: c } = this;
    return [t, n, r, i, o, a, s, c];
  }
  // prettier-ignore
  set(t, n, r, i, o, a, s, c) {
    this.A = t | 0, this.B = n | 0, this.C = r | 0, this.D = i | 0, this.E = o | 0, this.F = a | 0, this.G = s | 0, this.H = c | 0;
  }
  process(t, n) {
    for (let f = 0; f < 16; f++, n += 4)
      ss[f] = t.getUint32(n, !1);
    for (let f = 16; f < 64; f++) {
      const d = ss[f - 15], h = ss[f - 2], g = Go(d, 7) ^ Go(d, 18) ^ d >>> 3, w = Go(h, 17) ^ Go(h, 19) ^ h >>> 10;
      ss[f] = w + ss[f - 7] + g + ss[f - 16] | 0;
    }
    let { A: r, B: i, C: o, D: a, E: s, F: c, G: l, H: u } = this;
    for (let f = 0; f < 64; f++) {
      const d = Go(s, 6) ^ Go(s, 11) ^ Go(s, 25), h = u + d + yq(s, c, l) + bq[f] + ss[f] | 0, w = (Go(r, 2) ^ Go(r, 13) ^ Go(r, 22)) + gq(r, i, o) | 0;
      u = l, l = c, c = s, s = a + h | 0, a = o, o = i, i = r, r = h + w | 0;
    }
    r = r + this.A | 0, i = i + this.B | 0, o = o + this.C | 0, a = a + this.D | 0, s = s + this.E | 0, c = c + this.F | 0, l = l + this.G | 0, u = u + this.H | 0, this.set(r, i, o, a, s, c, l, u);
  }
  roundClean() {
    ss.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
class mq extends _D {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
}
const aA = eu(() => new _D());
eu(() => new mq());
var ie = {};
Object.defineProperty(ie, "__esModule", { value: !0 });
ie.s16 = ie.s8 = ie.nu64be = ie.u48be = ie.u40be = ie.u32be = ie.u24be = ie.u16be = Vr = ie.nu64 = ie.u48 = ie.u40 = ft = ie.u32 = ie.u24 = io = ie.u16 = an = ie.u8 = Ds = ie.offset = ie.greedy = ie.Constant = ie.UTF8 = ie.CString = ie.Blob = ie.Boolean = ie.BitField = ie.BitStructure = ie.VariantLayout = ie.Union = ie.UnionLayoutDiscriminator = ie.UnionDiscriminator = ie.Structure = ie.Sequence = ie.DoubleBE = ie.Double = ie.FloatBE = ie.Float = ie.NearInt64BE = ie.NearInt64 = ie.NearUInt64BE = ie.NearUInt64 = ie.IntBE = ie.Int = ie.UIntBE = ie.UInt = ie.OffsetLayout = ie.GreedyCount = ie.ExternalLayout = ie.bindConstructorLayout = ie.nameWithProperty = ie.Layout = ie.uint8ArrayToBuffer = ie.checkUint8Array = void 0;
ie.constant = ie.utf8 = ie.cstr = Nn = ie.blob = ie.unionLayoutDiscriminator = ie.union = Yr = ie.seq = ie.bits = ht = ie.struct = ie.f64be = ie.f64 = ie.f32be = ie.f32 = ie.ns64be = ie.s48be = ie.s40be = ie.s32be = ie.s24be = ie.s16be = Di = ie.ns64 = ie.s48 = ie.s40 = ie.s32 = ie.s24 = void 0;
const pk = it;
function zl(e) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("b must be a Uint8Array");
}
ie.checkUint8Array = zl;
function wn(e) {
  return zl(e), pk.Buffer.from(e.buffer, e.byteOffset, e.length);
}
ie.uint8ArrayToBuffer = wn;
let Pn = class {
  constructor(t, n) {
    if (!Number.isInteger(t))
      throw new TypeError("span must be an integer");
    this.span = t, this.property = n;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Uint8Array} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(t, n) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(t) {
    const n = Object.create(this.constructor.prototype);
    return Object.assign(n, this), n.property = t, n;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(t) {
  }
};
ie.Layout = Pn;
function yk(e, t) {
  return t.property ? e + "[" + t.property + "]" : e;
}
ie.nameWithProperty = yk;
function _q(e, t) {
  if (typeof e != "function")
    throw new TypeError("Class must be constructor");
  if (Object.prototype.hasOwnProperty.call(e, "layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(t && t instanceof Pn))
    throw new TypeError("layout must be a Layout");
  if (Object.prototype.hasOwnProperty.call(t, "boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  e.layout_ = t, t.boundConstructor_ = e, t.makeDestinationObject = () => new e(), Object.defineProperty(e.prototype, "encode", {
    value(n, r) {
      return t.encode(this, n, r);
    },
    writable: !0
  }), Object.defineProperty(e, "decode", {
    value(n, r) {
      return t.decode(n, r);
    },
    writable: !0
  });
}
ie.bindConstructorLayout = _q;
let Si = class extends Pn {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
};
ie.ExternalLayout = Si;
let wD = class extends Si {
  constructor(t = 1, n) {
    if (!Number.isInteger(t) || 0 >= t)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, n), this.elementSpan = t;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(t, n = 0) {
    zl(t);
    const r = t.length - n;
    return Math.floor(r / this.elementSpan);
  }
  /** @override */
  encode(t, n, r) {
    return 0;
  }
};
ie.GreedyCount = wD;
let gk = class extends Si {
  constructor(t, n = 0, r) {
    if (!(t instanceof Pn))
      throw new TypeError("layout must be a Layout");
    if (!Number.isInteger(n))
      throw new TypeError("offset must be integer or undefined");
    super(t.span, r || t.property), this.layout = t, this.offset = n;
  }
  /** @override */
  isCount() {
    return this.layout instanceof fo || this.layout instanceof No;
  }
  /** @override */
  decode(t, n = 0) {
    return this.layout.decode(t, n + this.offset);
  }
  /** @override */
  encode(t, n, r = 0) {
    return this.layout.encode(t, n, r + this.offset);
  }
};
ie.OffsetLayout = gk;
let fo = class extends Pn {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return wn(t).readUIntLE(n, this.span);
  }
  /** @override */
  encode(t, n, r = 0) {
    return wn(n).writeUIntLE(t, r, this.span), this.span;
  }
};
ie.UInt = fo;
let No = class extends Pn {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return wn(t).readUIntBE(n, this.span);
  }
  /** @override */
  encode(t, n, r = 0) {
    return wn(n).writeUIntBE(t, r, this.span), this.span;
  }
};
ie.UIntBE = No;
let tu = class extends Pn {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return wn(t).readIntLE(n, this.span);
  }
  /** @override */
  encode(t, n, r = 0) {
    return wn(n).writeIntLE(t, r, this.span), this.span;
  }
};
ie.Int = tu;
let Fl = class extends Pn {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n = 0) {
    return wn(t).readIntBE(n, this.span);
  }
  /** @override */
  encode(t, n, r = 0) {
    return wn(n).writeIntBE(t, r, this.span), this.span;
  }
};
ie.IntBE = Fl;
const sA = Math.pow(2, 32);
function t_(e) {
  const t = Math.floor(e / sA), n = e - t * sA;
  return { hi32: t, lo32: n };
}
function n_(e, t) {
  return e * sA + t;
}
let vD = class extends Pn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const r = wn(t), i = r.readUInt32LE(n), o = r.readUInt32LE(n + 4);
    return n_(o, i);
  }
  /** @override */
  encode(t, n, r = 0) {
    const i = t_(t), o = wn(n);
    return o.writeUInt32LE(i.lo32, r), o.writeUInt32LE(i.hi32, r + 4), 8;
  }
};
ie.NearUInt64 = vD;
let SD = class extends Pn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const r = wn(t), i = r.readUInt32BE(n), o = r.readUInt32BE(n + 4);
    return n_(i, o);
  }
  /** @override */
  encode(t, n, r = 0) {
    const i = t_(t), o = wn(n);
    return o.writeUInt32BE(i.hi32, r), o.writeUInt32BE(i.lo32, r + 4), 8;
  }
};
ie.NearUInt64BE = SD;
let ED = class extends Pn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const r = wn(t), i = r.readUInt32LE(n), o = r.readInt32LE(n + 4);
    return n_(o, i);
  }
  /** @override */
  encode(t, n, r = 0) {
    const i = t_(t), o = wn(n);
    return o.writeUInt32LE(i.lo32, r), o.writeInt32LE(i.hi32, r + 4), 8;
  }
};
ie.NearInt64 = ED;
let AD = class extends Pn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    const r = wn(t), i = r.readInt32BE(n), o = r.readUInt32BE(n + 4);
    return n_(i, o);
  }
  /** @override */
  encode(t, n, r = 0) {
    const i = t_(t), o = wn(n);
    return o.writeInt32BE(i.hi32, r), o.writeUInt32BE(i.lo32, r + 4), 8;
  }
};
ie.NearInt64BE = AD;
let ID = class extends Pn {
  constructor(t) {
    super(4, t);
  }
  /** @override */
  decode(t, n = 0) {
    return wn(t).readFloatLE(n);
  }
  /** @override */
  encode(t, n, r = 0) {
    return wn(n).writeFloatLE(t, r), 4;
  }
};
ie.Float = ID;
let kD = class extends Pn {
  constructor(t) {
    super(4, t);
  }
  /** @override */
  decode(t, n = 0) {
    return wn(t).readFloatBE(n);
  }
  /** @override */
  encode(t, n, r = 0) {
    return wn(n).writeFloatBE(t, r), 4;
  }
};
ie.FloatBE = kD;
let TD = class extends Pn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    return wn(t).readDoubleLE(n);
  }
  /** @override */
  encode(t, n, r = 0) {
    return wn(n).writeDoubleLE(t, r), 8;
  }
};
ie.Double = TD;
let xD = class extends Pn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n = 0) {
    return wn(t).readDoubleBE(n);
  }
  /** @override */
  encode(t, n, r = 0) {
    return wn(n).writeDoubleBE(t, r), 8;
  }
};
ie.DoubleBE = xD;
let MD = class extends Pn {
  constructor(t, n, r) {
    if (!(t instanceof Pn))
      throw new TypeError("elementLayout must be a Layout");
    if (!(n instanceof Si && n.isCount() || Number.isInteger(n) && 0 <= n))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let i = -1;
    !(n instanceof Si) && 0 < t.span && (i = n * t.span), super(i, r), this.elementLayout = t, this.count = n;
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    let r = 0, i = this.count;
    if (i instanceof Si && (i = i.decode(t, n)), 0 < this.elementLayout.span)
      r = i * this.elementLayout.span;
    else {
      let o = 0;
      for (; o < i; )
        r += this.elementLayout.getSpan(t, n + r), ++o;
    }
    return r;
  }
  /** @override */
  decode(t, n = 0) {
    const r = [];
    let i = 0, o = this.count;
    for (o instanceof Si && (o = o.decode(t, n)); i < o; )
      r.push(this.elementLayout.decode(t, n)), n += this.elementLayout.getSpan(t, n), i += 1;
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, n, r = 0) {
    const i = this.elementLayout, o = t.reduce((a, s) => a + i.encode(s, n, r + a), 0);
    return this.count instanceof Si && this.count.encode(t.length, n, r), o;
  }
};
ie.Sequence = MD;
let OD = class extends Pn {
  constructor(t, n, r) {
    if (!(Array.isArray(t) && t.reduce((o, a) => o && a instanceof Pn, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof n == "boolean" && r === void 0 && (r = n, n = void 0);
    for (const o of t)
      if (0 > o.span && o.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let i = -1;
    try {
      i = t.reduce((o, a) => o + a.getSpan(), 0);
    } catch {
    }
    super(i, n), this.fields = t, this.decodePrefixes = !!r;
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    let r = 0;
    try {
      r = this.fields.reduce((i, o) => {
        const a = o.getSpan(t, n);
        return n += a, i + a;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return r;
  }
  /** @override */
  decode(t, n = 0) {
    zl(t);
    const r = this.makeDestinationObject();
    for (const i of this.fields)
      if (i.property !== void 0 && (r[i.property] = i.decode(t, n)), n += i.getSpan(t, n), this.decodePrefixes && t.length === n)
        break;
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(t, n, r = 0) {
    const i = r;
    let o = 0, a = 0;
    for (const s of this.fields) {
      let c = s.span;
      if (a = 0 < c ? c : 0, s.property !== void 0) {
        const l = t[s.property];
        l !== void 0 && (a = s.encode(l, n, r), 0 > c && (c = s.getSpan(n, r)));
      }
      o = r, r += c;
    }
    return o + a - i;
  }
  /** @override */
  fromArray(t) {
    const n = this.makeDestinationObject();
    for (const r of this.fields)
      r.property !== void 0 && 0 < t.length && (n[r.property] = t.shift());
    return n;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const n of this.fields)
      if (n.property === t)
        return n;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    let n = 0;
    for (const r of this.fields) {
      if (r.property === t)
        return n;
      0 > r.span ? n = -1 : 0 <= n && (n += r.span);
    }
  }
};
ie.Structure = OD;
let bk = class {
  constructor(t) {
    this.property = t;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode(t, n) {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode(t, n, r) {
    throw new Error("UnionDiscriminator is abstract");
  }
};
ie.UnionDiscriminator = bk;
let $b = class extends bk {
  constructor(t, n) {
    if (!(t instanceof Si && t.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(n || t.property || "variant"), this.layout = t;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(t, n) {
    return this.layout.decode(t, n);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(t, n, r) {
    return this.layout.encode(t, n, r);
  }
};
ie.UnionLayoutDiscriminator = $b;
let mk = class extends Pn {
  constructor(t, n, r) {
    let i;
    if (t instanceof fo || t instanceof No)
      i = new $b(new gk(t));
    else if (t instanceof Si && t.isCount())
      i = new $b(t);
    else if (t instanceof bk)
      i = t;
    else
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (n === void 0 && (n = null), !(n === null || n instanceof Pn))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (n !== null) {
      if (0 > n.span)
        throw new Error("defaultLayout must have constant span");
      n.property === void 0 && (n = n.replicate("content"));
    }
    let o = -1;
    n && (o = n.span, 0 <= o && (t instanceof fo || t instanceof No) && (o += i.layout.span)), super(o, r), this.discriminator = i, this.usesPrefixDiscriminator = t instanceof fo || t instanceof No, this.defaultLayout = n, this.registry = {};
    let a = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(s) {
      return a(s);
    }, this.configGetSourceVariant = function(s) {
      a = s.bind(this);
    };
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    const r = this.getVariant(t, n);
    if (!r)
      throw new Error("unable to determine span for unrecognized variant");
    return r.getSpan(t, n);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisfied rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(t) {
    if (Object.prototype.hasOwnProperty.call(t, this.discriminator.property)) {
      if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(t, this.defaultLayout.property))
        return;
      const n = this.registry[t[this.discriminator.property]];
      if (n && (!n.layout || n.property && Object.prototype.hasOwnProperty.call(t, n.property)))
        return n;
    } else
      for (const n in this.registry) {
        const r = this.registry[n];
        if (r.property && Object.prototype.hasOwnProperty.call(t, r.property))
          return r;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(t, n = 0) {
    let r;
    const i = this.discriminator, o = i.decode(t, n), a = this.registry[o];
    if (a === void 0) {
      const s = this.defaultLayout;
      let c = 0;
      this.usesPrefixDiscriminator && (c = i.layout.span), r = this.makeDestinationObject(), r[i.property] = o, r[s.property] = s.decode(t, n + c);
    } else
      r = a.decode(t, n);
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(t, n, r = 0) {
    const i = this.getSourceVariant(t);
    if (i === void 0) {
      const o = this.discriminator, a = this.defaultLayout;
      let s = 0;
      return this.usesPrefixDiscriminator && (s = o.layout.span), o.encode(t[o.property], n, r), s + a.encode(t[a.property], n, r + s);
    }
    return i.encode(t, n, r);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(t, n, r) {
    const i = new PD(this, t, n, r);
    return this.registry[t] = i, i;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Uint8Array)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Uint8Array}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(t, n = 0) {
    let r;
    return t instanceof Uint8Array ? r = this.discriminator.decode(t, n) : r = t, this.registry[r];
  }
};
ie.Union = mk;
let PD = class extends Pn {
  constructor(t, n, r, i) {
    if (!(t instanceof mk))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(n) || 0 > n)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof r == "string" && i === void 0 && (i = r, r = null), r) {
      if (!(r instanceof Pn))
        throw new TypeError("layout must be a Layout");
      if (t.defaultLayout !== null && 0 <= r.span && r.span > t.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof i != "string")
        throw new TypeError("variant must have a String property");
    }
    let o = t.span;
    0 > t.span && (o = r ? r.span : 0, 0 <= o && t.usesPrefixDiscriminator && (o += t.discriminator.layout.span)), super(o, i), this.union = t, this.variant = n, this.layout = r || null;
  }
  /** @override */
  getSpan(t, n = 0) {
    if (0 <= this.span)
      return this.span;
    let r = 0;
    this.union.usesPrefixDiscriminator && (r = this.union.discriminator.layout.span);
    let i = 0;
    return this.layout && (i = this.layout.getSpan(t, n + r)), r + i;
  }
  /** @override */
  decode(t, n = 0) {
    const r = this.makeDestinationObject();
    if (this !== this.union.getVariant(t, n))
      throw new Error("variant mismatch");
    let i = 0;
    return this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout ? r[this.property] = this.layout.decode(t, n + i) : this.property ? r[this.property] = !0 : this.union.usesPrefixDiscriminator && (r[this.union.discriminator.property] = this.variant), r;
  }
  /** @override */
  encode(t, n, r = 0) {
    let i = 0;
    if (this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout && !Object.prototype.hasOwnProperty.call(t, this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, n, r);
    let o = i;
    if (this.layout && (this.layout.encode(t[this.property], n, r + i), o += this.layout.getSpan(n, r + i), 0 <= this.union.span && o > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return o;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(t) {
    if (this.layout)
      return this.layout.fromArray(t);
  }
};
ie.VariantLayout = PD;
function xu(e) {
  return 0 > e && (e += 4294967296), e;
}
let _k = class extends Pn {
  constructor(t, n, r) {
    if (!(t instanceof fo || t instanceof No))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof n == "string" && r === void 0 && (r = n, n = !1), 4 < t.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(t.span, r), this.word = t, this.msb = !!n, this.fields = [];
    let i = 0;
    this._packedSetValue = function(o) {
      return i = xu(o), this;
    }, this._packedGetValue = function() {
      return i;
    };
  }
  /** @override */
  decode(t, n = 0) {
    const r = this.makeDestinationObject(), i = this.word.decode(t, n);
    this._packedSetValue(i);
    for (const o of this.fields)
      o.property !== void 0 && (r[o.property] = o.decode(t));
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(t, n, r = 0) {
    const i = this.word.decode(n, r);
    this._packedSetValue(i);
    for (const o of this.fields)
      if (o.property !== void 0) {
        const a = t[o.property];
        a !== void 0 && o.encode(a);
      }
    return this.word.encode(this._packedGetValue(), n, r);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(t, n) {
    const r = new wk(this, t, n);
    return this.fields.push(r), r;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  // `Boolean` conflicts with the native primitive type
  // eslint-disable-next-line @typescript-eslint/ban-types
  addBoolean(t) {
    const n = new BD(this, t);
    return this.fields.push(n), n;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const n of this.fields)
      if (n.property === t)
        return n;
  }
};
ie.BitStructure = _k;
let wk = class {
  constructor(t, n, r) {
    if (!(t instanceof _k))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(n) || 0 >= n)
      throw new TypeError("bits must be positive integer");
    const i = 8 * t.span, o = t.fields.reduce((a, s) => a + s.bits, 0);
    if (n + o > i)
      throw new Error("bits too long for span remainder (" + (i - o) + " of " + i + " remain)");
    this.container = t, this.bits = n, this.valueMask = (1 << n) - 1, n === 32 && (this.valueMask = 4294967295), this.start = o, this.container.msb && (this.start = i - o - n), this.wordMask = xu(this.valueMask << this.start), this.property = r;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode(t, n) {
    const r = this.container._packedGetValue();
    return xu(r & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(t) {
    if (typeof t != "number" || !Number.isInteger(t) || t !== xu(t & this.valueMask))
      throw new TypeError(yk("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const n = this.container._packedGetValue(), r = xu(t << this.start);
    this.container._packedSetValue(xu(n & ~this.wordMask) | r);
  }
};
ie.BitField = wk;
let BD = class extends wk {
  constructor(t, n) {
    super(t, 1, n);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(t, n) {
    return !!super.decode(t, n);
  }
  /** @override */
  encode(t) {
    typeof t == "boolean" && (t = +t), super.encode(t);
  }
};
ie.Boolean = BD;
let CD = class extends Pn {
  constructor(t, n) {
    if (!(t instanceof Si && t.isCount() || Number.isInteger(t) && 0 <= t))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let r = -1;
    t instanceof Si || (r = t), super(r, n), this.length = t;
  }
  /** @override */
  getSpan(t, n) {
    let r = this.span;
    return 0 > r && (r = this.length.decode(t, n)), r;
  }
  /** @override */
  decode(t, n = 0) {
    let r = this.span;
    return 0 > r && (r = this.length.decode(t, n)), wn(t).slice(n, n + r);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, n, r) {
    let i = this.length;
    if (this.length instanceof Si && (i = t.length), !(t instanceof Uint8Array && i === t.length))
      throw new TypeError(yk("Blob.encode", this) + " requires (length " + i + ") Uint8Array as src");
    if (r + i > n.length)
      throw new RangeError("encoding overruns Uint8Array");
    const o = wn(t);
    return wn(n).write(o.toString("hex"), r, i, "hex"), this.length instanceof Si && this.length.encode(i, n, r), i;
  }
};
ie.Blob = CD;
let DD = class extends Pn {
  constructor(t) {
    super(-1, t);
  }
  /** @override */
  getSpan(t, n = 0) {
    zl(t);
    let r = n;
    for (; r < t.length && t[r] !== 0; )
      r += 1;
    return 1 + r - n;
  }
  /** @override */
  decode(t, n = 0) {
    const r = this.getSpan(t, n);
    return wn(t).slice(n, n + r - 1).toString("utf-8");
  }
  /** @override */
  encode(t, n, r = 0) {
    typeof t != "string" && (t = String(t));
    const i = pk.Buffer.from(t, "utf8"), o = i.length;
    if (r + o > n.length)
      throw new RangeError("encoding overruns Buffer");
    const a = wn(n);
    return i.copy(a, r), a[r + o] = 0, o + 1;
  }
};
ie.CString = DD;
let RD = class extends Pn {
  constructor(t, n) {
    if (typeof t == "string" && n === void 0 && (n = t, t = void 0), t === void 0)
      t = -1;
    else if (!Number.isInteger(t))
      throw new TypeError("maxSpan must be an integer");
    super(-1, n), this.maxSpan = t;
  }
  /** @override */
  getSpan(t, n = 0) {
    return zl(t), t.length - n;
  }
  /** @override */
  decode(t, n = 0) {
    const r = this.getSpan(t, n);
    if (0 <= this.maxSpan && this.maxSpan < r)
      throw new RangeError("text length exceeds maxSpan");
    return wn(t).slice(n, n + r).toString("utf-8");
  }
  /** @override */
  encode(t, n, r = 0) {
    typeof t != "string" && (t = String(t));
    const i = pk.Buffer.from(t, "utf8"), o = i.length;
    if (0 <= this.maxSpan && this.maxSpan < o)
      throw new RangeError("text length exceeds maxSpan");
    if (r + o > n.length)
      throw new RangeError("encoding overruns Buffer");
    return i.copy(wn(n), r), o;
  }
};
ie.UTF8 = RD;
let ND = class extends Pn {
  constructor(t, n) {
    super(0, n), this.value = t;
  }
  /** @override */
  decode(t, n) {
    return this.value;
  }
  /** @override */
  encode(t, n, r) {
    return 0;
  }
};
ie.Constant = ND;
ie.greedy = (e, t) => new wD(e, t);
var Ds = ie.offset = (e, t, n) => new gk(e, t, n), an = ie.u8 = (e) => new fo(1, e), io = ie.u16 = (e) => new fo(2, e);
ie.u24 = (e) => new fo(3, e);
var ft = ie.u32 = (e) => new fo(4, e);
ie.u40 = (e) => new fo(5, e);
ie.u48 = (e) => new fo(6, e);
var Vr = ie.nu64 = (e) => new vD(e);
ie.u16be = (e) => new No(2, e);
ie.u24be = (e) => new No(3, e);
ie.u32be = (e) => new No(4, e);
ie.u40be = (e) => new No(5, e);
ie.u48be = (e) => new No(6, e);
ie.nu64be = (e) => new SD(e);
ie.s8 = (e) => new tu(1, e);
ie.s16 = (e) => new tu(2, e);
ie.s24 = (e) => new tu(3, e);
ie.s32 = (e) => new tu(4, e);
ie.s40 = (e) => new tu(5, e);
ie.s48 = (e) => new tu(6, e);
var Di = ie.ns64 = (e) => new ED(e);
ie.s16be = (e) => new Fl(2, e);
ie.s24be = (e) => new Fl(3, e);
ie.s32be = (e) => new Fl(4, e);
ie.s40be = (e) => new Fl(5, e);
ie.s48be = (e) => new Fl(6, e);
ie.ns64be = (e) => new AD(e);
ie.f32 = (e) => new ID(e);
ie.f32be = (e) => new kD(e);
ie.f64 = (e) => new TD(e);
ie.f64be = (e) => new xD(e);
var ht = ie.struct = (e, t, n) => new OD(e, t, n);
ie.bits = (e, t, n) => new _k(e, t, n);
var Yr = ie.seq = (e, t, n) => new MD(e, t, n);
ie.union = (e, t, n) => new mk(e, t, n);
ie.unionLayoutDiscriminator = (e, t) => new $b(e, t);
var Nn = ie.blob = (e, t) => new CD(e, t);
ie.cstr = (e) => new DD(e);
ie.utf8 = (e, t) => new RD(e, t);
ie.constant = (e, t) => new ND(e, t);
var Cd = {};
Object.defineProperty(Cd, "__esModule", { value: !0 });
function wq(e) {
  {
    const t = Buffer.from(e);
    t.reverse();
    const n = t.toString("hex");
    return n.length === 0 ? BigInt(0) : BigInt(`0x${n}`);
  }
}
var jD = Cd.toBigIntLE = wq;
function vq(e) {
  {
    const t = e.toString("hex");
    return t.length === 0 ? BigInt(0) : BigInt(`0x${t}`);
  }
}
var Sq = Cd.toBigIntBE = vq;
function Eq(e, t) {
  {
    const n = e.toString(16), r = Buffer.from(n.padStart(t * 2, "0").slice(0, t * 2), "hex");
    return r.reverse(), r;
  }
}
var vk = Cd.toBufferLE = Eq;
function Aq(e, t) {
  {
    const n = e.toString(16);
    return Buffer.from(n.padStart(t * 2, "0").slice(0, t * 2), "hex");
  }
}
var Iq = Cd.toBufferBE = Aq;
let kq = class extends TypeError {
  constructor(t, n) {
    let r;
    const {
      message: i,
      ...o
    } = t, {
      path: a
    } = t, s = a.length === 0 ? i : "At path: " + a.join(".") + " -- " + i;
    super(s), Object.assign(this, o), this.name = this.constructor.name, this.failures = () => {
      var c;
      return (c = r) != null ? c : r = [t, ...n()];
    };
  }
};
function Tq(e) {
  return Rs(e) && typeof e[Symbol.iterator] == "function";
}
function Rs(e) {
  return typeof e == "object" && e != null;
}
function Uo(e) {
  return typeof e == "string" ? JSON.stringify(e) : "" + e;
}
function xq(e) {
  const {
    done: t,
    value: n
  } = e.next();
  return t ? void 0 : n;
}
function Mq(e, t, n, r) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = {
    message: e
  });
  const {
    path: i,
    branch: o
  } = t, {
    type: a
  } = n, {
    refinement: s,
    message: c = "Expected a value of type `" + a + "`" + (s ? " with refinement `" + s + "`" : "") + ", but received: `" + Uo(r) + "`"
  } = e;
  return {
    value: r,
    type: a,
    refinement: s,
    key: i[i.length - 1],
    path: i,
    branch: o,
    ...e,
    message: c
  };
}
function* A2(e, t, n, r) {
  Tq(e) || (e = [e]);
  for (const i of e) {
    const o = Mq(i, t, n, r);
    o && (yield o);
  }
}
function* Sk(e, t, n = {}) {
  const {
    path: r = [],
    branch: i = [e],
    coerce: o = !1,
    mask: a = !1
  } = n, s = {
    path: r,
    branch: i
  };
  if (o && (e = t.coercer(e, s), a && t.type !== "type" && Rs(t.schema) && Rs(e) && !Array.isArray(e)))
    for (const l in e)
      t.schema[l] === void 0 && delete e[l];
  let c = !0;
  for (const l of t.validator(e, s))
    c = !1, yield [l, void 0];
  for (let [l, u, f] of t.entries(e, s)) {
    const d = Sk(u, f, {
      path: l === void 0 ? r : [...r, l],
      branch: l === void 0 ? i : [...i, u],
      coerce: o,
      mask: a
    });
    for (const h of d)
      h[0] ? (c = !1, yield [h[0], void 0]) : o && (u = h[1], l === void 0 ? e = u : e instanceof Map ? e.set(l, u) : e instanceof Set ? e.add(u) : Rs(e) && (e[l] = u));
  }
  if (c)
    for (const l of t.refiner(e, s))
      c = !1, yield [l, void 0];
  c && (yield [void 0, e]);
}
let va = class {
  constructor(t) {
    const {
      type: n,
      schema: r,
      validator: i,
      refiner: o,
      coercer: a = (c) => c,
      entries: s = function* () {
      }
    } = t;
    this.type = n, this.schema = r, this.entries = s, this.coercer = a, i ? this.validator = (c, l) => {
      const u = i(c, l);
      return A2(u, l, this, c);
    } : this.validator = () => [], o ? this.refiner = (c, l) => {
      const u = o(c, l);
      return A2(u, l, this, c);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(t) {
    return UD(t, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(t) {
    return Ve(t, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(t) {
    return zD(t, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(t) {
    return Oq(t, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(t, n = {}) {
    return Dd(t, this, n);
  }
};
function UD(e, t) {
  const n = Dd(e, t);
  if (n[0])
    throw n[0];
}
function Ve(e, t) {
  const n = Dd(e, t, {
    coerce: !0
  });
  if (n[0])
    throw n[0];
  return n[1];
}
function Oq(e, t) {
  const n = Dd(e, t, {
    coerce: !0,
    mask: !0
  });
  if (n[0])
    throw n[0];
  return n[1];
}
function zD(e, t) {
  return !Dd(e, t)[0];
}
function Dd(e, t, n = {}) {
  const r = Sk(e, t, n), i = xq(r);
  return i[0] ? [new kq(i[0], function* () {
    for (const a of r)
      a[0] && (yield a[0]);
  }), void 0] : [void 0, i[1]];
}
function nu(e, t) {
  return new va({
    type: e,
    schema: null,
    validator: t
  });
}
function Pq() {
  return nu("any", () => !0);
}
function Ze(e) {
  return new va({
    type: "array",
    schema: e,
    *entries(t) {
      if (e && Array.isArray(t))
        for (const [n, r] of t.entries())
          yield [n, r, e];
    },
    coercer(t) {
      return Array.isArray(t) ? t.slice() : t;
    },
    validator(t) {
      return Array.isArray(t) || "Expected an array value, but received: " + Uo(t);
    }
  });
}
function Va() {
  return nu("boolean", (e) => typeof e == "boolean");
}
function Ek(e) {
  return nu("instance", (t) => t instanceof e || "Expected a `" + e.name + "` instance, but received: " + Uo(t));
}
function dr(e) {
  const t = Uo(e), n = typeof e;
  return new va({
    type: "literal",
    schema: n === "string" || n === "number" || n === "boolean" ? e : null,
    validator(r) {
      return r === e || "Expected the literal `" + t + "`, but received: " + Uo(r);
    }
  });
}
function Bq() {
  return nu("never", () => !1);
}
function Je(e) {
  return new va({
    ...e,
    validator: (t, n) => t === null || e.validator(t, n),
    refiner: (t, n) => t === null || e.refiner(t, n)
  });
}
function pe() {
  return nu("number", (e) => typeof e == "number" && !isNaN(e) || "Expected a number, but received: " + Uo(e));
}
function xt(e) {
  return new va({
    ...e,
    validator: (t, n) => t === void 0 || e.validator(t, n),
    refiner: (t, n) => t === void 0 || e.refiner(t, n)
  });
}
function FD(e, t) {
  return new va({
    type: "record",
    schema: null,
    *entries(n) {
      if (Rs(n))
        for (const r in n) {
          const i = n[r];
          yield [r, r, e], yield [r, i, t];
        }
    },
    validator(n) {
      return Rs(n) || "Expected an object, but received: " + Uo(n);
    }
  });
}
function Ke() {
  return nu("string", (e) => typeof e == "string" || "Expected a string, but received: " + Uo(e));
}
function Ak(e) {
  const t = Bq();
  return new va({
    type: "tuple",
    schema: null,
    *entries(n) {
      if (Array.isArray(n)) {
        const r = Math.max(e.length, n.length);
        for (let i = 0; i < r; i++)
          yield [i, n[i], e[i] || t];
      }
    },
    validator(n) {
      return Array.isArray(n) || "Expected an array, but received: " + Uo(n);
    }
  });
}
function Oe(e) {
  const t = Object.keys(e);
  return new va({
    type: "type",
    schema: e,
    *entries(n) {
      if (Rs(n))
        for (const r of t)
          yield [r, n[r], e[r]];
    },
    validator(n) {
      return Rs(n) || "Expected an object, but received: " + Uo(n);
    }
  });
}
function Ii(e) {
  const t = e.map((n) => n.type).join(" | ");
  return new va({
    type: "union",
    schema: null,
    validator(n, r) {
      const i = [];
      for (const o of e) {
        const [...a] = Sk(n, o, r), [s] = a;
        if (s[0])
          for (const [c] of a)
            c && i.push(c);
        else
          return [];
      }
      return ["Expected the value to satisfy a union of `" + t + "`, but received: " + Uo(n), ...i];
    }
  });
}
function Rd() {
  return nu("unknown", () => !0);
}
function Nd(e, t, n) {
  return new va({
    ...e,
    coercer: (r, i) => zD(r, t) ? e.coercer(n(r, i), i) : e.coercer(r, i)
  });
}
var bg, Cq = new Uint8Array(16);
function LD() {
  if (!bg && (bg = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !bg))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return bg(Cq);
}
const Dq = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function r_(e) {
  return typeof e == "string" && Dq.test(e);
}
var Kr = [];
for (var jv = 0; jv < 256; ++jv)
  Kr.push((jv + 256).toString(16).substr(1));
function i_(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (Kr[e[t + 0]] + Kr[e[t + 1]] + Kr[e[t + 2]] + Kr[e[t + 3]] + "-" + Kr[e[t + 4]] + Kr[e[t + 5]] + "-" + Kr[e[t + 6]] + Kr[e[t + 7]] + "-" + Kr[e[t + 8]] + Kr[e[t + 9]] + "-" + Kr[e[t + 10]] + Kr[e[t + 11]] + Kr[e[t + 12]] + Kr[e[t + 13]] + Kr[e[t + 14]] + Kr[e[t + 15]]).toLowerCase();
  if (!r_(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
var I2, Uv, zv = 0, Fv = 0;
function Rq(e, t, n) {
  var r = t && n || 0, i = t || new Array(16);
  e = e || {};
  var o = e.node || I2, a = e.clockseq !== void 0 ? e.clockseq : Uv;
  if (o == null || a == null) {
    var s = e.random || (e.rng || LD)();
    o == null && (o = I2 = [s[0] | 1, s[1], s[2], s[3], s[4], s[5]]), a == null && (a = Uv = (s[6] << 8 | s[7]) & 16383);
  }
  var c = e.msecs !== void 0 ? e.msecs : Date.now(), l = e.nsecs !== void 0 ? e.nsecs : Fv + 1, u = c - zv + (l - Fv) / 1e4;
  if (u < 0 && e.clockseq === void 0 && (a = a + 1 & 16383), (u < 0 || c > zv) && e.nsecs === void 0 && (l = 0), l >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  zv = c, Fv = l, Uv = a, c += 122192928e5;
  var f = ((c & 268435455) * 1e4 + l) % 4294967296;
  i[r++] = f >>> 24 & 255, i[r++] = f >>> 16 & 255, i[r++] = f >>> 8 & 255, i[r++] = f & 255;
  var d = c / 4294967296 * 1e4 & 268435455;
  i[r++] = d >>> 8 & 255, i[r++] = d & 255, i[r++] = d >>> 24 & 15 | 16, i[r++] = d >>> 16 & 255, i[r++] = a >>> 8 | 128, i[r++] = a & 255;
  for (var h = 0; h < 6; ++h)
    i[r + h] = o[h];
  return t || i_(i);
}
function $D(e) {
  if (!r_(e))
    throw TypeError("Invalid UUID");
  var t, n = new Uint8Array(16);
  return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = t & 255, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = t & 255, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = t & 255, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = t & 255, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = t & 255, n;
}
function Nq(e) {
  e = unescape(encodeURIComponent(e));
  for (var t = [], n = 0; n < e.length; ++n)
    t.push(e.charCodeAt(n));
  return t;
}
var jq = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", Uq = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function WD(e, t, n) {
  function r(i, o, a, s) {
    if (typeof i == "string" && (i = Nq(i)), typeof o == "string" && (o = $D(o)), o.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + i.length);
    if (c.set(o), c.set(i, o.length), c = n(c), c[6] = c[6] & 15 | t, c[8] = c[8] & 63 | 128, a) {
      s = s || 0;
      for (var l = 0; l < 16; ++l)
        a[s + l] = c[l];
      return a;
    }
    return i_(c);
  }
  try {
    r.name = e;
  } catch {
  }
  return r.DNS = jq, r.URL = Uq, r;
}
function zq(e) {
  if (typeof e == "string") {
    var t = unescape(encodeURIComponent(e));
    e = new Uint8Array(t.length);
    for (var n = 0; n < t.length; ++n)
      e[n] = t.charCodeAt(n);
  }
  return Fq(Lq($q(e), e.length * 8));
}
function Fq(e) {
  for (var t = [], n = e.length * 32, r = "0123456789abcdef", i = 0; i < n; i += 8) {
    var o = e[i >> 5] >>> i % 32 & 255, a = parseInt(r.charAt(o >>> 4 & 15) + r.charAt(o & 15), 16);
    t.push(a);
  }
  return t;
}
function KD(e) {
  return (e + 64 >>> 9 << 4) + 14 + 1;
}
function Lq(e, t) {
  e[t >> 5] |= 128 << t % 32, e[KD(t) - 1] = t;
  for (var n = 1732584193, r = -271733879, i = -1732584194, o = 271733878, a = 0; a < e.length; a += 16) {
    var s = n, c = r, l = i, u = o;
    n = ii(n, r, i, o, e[a], 7, -680876936), o = ii(o, n, r, i, e[a + 1], 12, -389564586), i = ii(i, o, n, r, e[a + 2], 17, 606105819), r = ii(r, i, o, n, e[a + 3], 22, -1044525330), n = ii(n, r, i, o, e[a + 4], 7, -176418897), o = ii(o, n, r, i, e[a + 5], 12, 1200080426), i = ii(i, o, n, r, e[a + 6], 17, -1473231341), r = ii(r, i, o, n, e[a + 7], 22, -45705983), n = ii(n, r, i, o, e[a + 8], 7, 1770035416), o = ii(o, n, r, i, e[a + 9], 12, -1958414417), i = ii(i, o, n, r, e[a + 10], 17, -42063), r = ii(r, i, o, n, e[a + 11], 22, -1990404162), n = ii(n, r, i, o, e[a + 12], 7, 1804603682), o = ii(o, n, r, i, e[a + 13], 12, -40341101), i = ii(i, o, n, r, e[a + 14], 17, -1502002290), r = ii(r, i, o, n, e[a + 15], 22, 1236535329), n = oi(n, r, i, o, e[a + 1], 5, -165796510), o = oi(o, n, r, i, e[a + 6], 9, -1069501632), i = oi(i, o, n, r, e[a + 11], 14, 643717713), r = oi(r, i, o, n, e[a], 20, -373897302), n = oi(n, r, i, o, e[a + 5], 5, -701558691), o = oi(o, n, r, i, e[a + 10], 9, 38016083), i = oi(i, o, n, r, e[a + 15], 14, -660478335), r = oi(r, i, o, n, e[a + 4], 20, -405537848), n = oi(n, r, i, o, e[a + 9], 5, 568446438), o = oi(o, n, r, i, e[a + 14], 9, -1019803690), i = oi(i, o, n, r, e[a + 3], 14, -187363961), r = oi(r, i, o, n, e[a + 8], 20, 1163531501), n = oi(n, r, i, o, e[a + 13], 5, -1444681467), o = oi(o, n, r, i, e[a + 2], 9, -51403784), i = oi(i, o, n, r, e[a + 7], 14, 1735328473), r = oi(r, i, o, n, e[a + 12], 20, -1926607734), n = ai(n, r, i, o, e[a + 5], 4, -378558), o = ai(o, n, r, i, e[a + 8], 11, -2022574463), i = ai(i, o, n, r, e[a + 11], 16, 1839030562), r = ai(r, i, o, n, e[a + 14], 23, -35309556), n = ai(n, r, i, o, e[a + 1], 4, -1530992060), o = ai(o, n, r, i, e[a + 4], 11, 1272893353), i = ai(i, o, n, r, e[a + 7], 16, -155497632), r = ai(r, i, o, n, e[a + 10], 23, -1094730640), n = ai(n, r, i, o, e[a + 13], 4, 681279174), o = ai(o, n, r, i, e[a], 11, -358537222), i = ai(i, o, n, r, e[a + 3], 16, -722521979), r = ai(r, i, o, n, e[a + 6], 23, 76029189), n = ai(n, r, i, o, e[a + 9], 4, -640364487), o = ai(o, n, r, i, e[a + 12], 11, -421815835), i = ai(i, o, n, r, e[a + 15], 16, 530742520), r = ai(r, i, o, n, e[a + 2], 23, -995338651), n = si(n, r, i, o, e[a], 6, -198630844), o = si(o, n, r, i, e[a + 7], 10, 1126891415), i = si(i, o, n, r, e[a + 14], 15, -1416354905), r = si(r, i, o, n, e[a + 5], 21, -57434055), n = si(n, r, i, o, e[a + 12], 6, 1700485571), o = si(o, n, r, i, e[a + 3], 10, -1894986606), i = si(i, o, n, r, e[a + 10], 15, -1051523), r = si(r, i, o, n, e[a + 1], 21, -2054922799), n = si(n, r, i, o, e[a + 8], 6, 1873313359), o = si(o, n, r, i, e[a + 15], 10, -30611744), i = si(i, o, n, r, e[a + 6], 15, -1560198380), r = si(r, i, o, n, e[a + 13], 21, 1309151649), n = si(n, r, i, o, e[a + 4], 6, -145523070), o = si(o, n, r, i, e[a + 11], 10, -1120210379), i = si(i, o, n, r, e[a + 2], 15, 718787259), r = si(r, i, o, n, e[a + 9], 21, -343485551), n = Ms(n, s), r = Ms(r, c), i = Ms(i, l), o = Ms(o, u);
  }
  return [n, r, i, o];
}
function $q(e) {
  if (e.length === 0)
    return [];
  for (var t = e.length * 8, n = new Uint32Array(KD(t)), r = 0; r < t; r += 8)
    n[r >> 5] |= (e[r / 8] & 255) << r % 32;
  return n;
}
function Ms(e, t) {
  var n = (e & 65535) + (t & 65535), r = (e >> 16) + (t >> 16) + (n >> 16);
  return r << 16 | n & 65535;
}
function Wq(e, t) {
  return e << t | e >>> 32 - t;
}
function o_(e, t, n, r, i, o) {
  return Ms(Wq(Ms(Ms(t, e), Ms(r, o)), i), n);
}
function ii(e, t, n, r, i, o, a) {
  return o_(t & n | ~t & r, e, t, i, o, a);
}
function oi(e, t, n, r, i, o, a) {
  return o_(t & r | n & ~r, e, t, i, o, a);
}
function ai(e, t, n, r, i, o, a) {
  return o_(t ^ n ^ r, e, t, i, o, a);
}
function si(e, t, n, r, i, o, a) {
  return o_(n ^ (t | ~r), e, t, i, o, a);
}
var Kq = WD("v3", 48, zq);
const Vq = Kq;
function qq(e, t, n) {
  e = e || {};
  var r = e.random || (e.rng || LD)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (var i = 0; i < 16; ++i)
      t[n + i] = r[i];
    return t;
  }
  return i_(r);
}
function Hq(e, t, n, r) {
  switch (e) {
    case 0:
      return t & n ^ ~t & r;
    case 1:
      return t ^ n ^ r;
    case 2:
      return t & n ^ t & r ^ n & r;
    case 3:
      return t ^ n ^ r;
  }
}
function Lv(e, t) {
  return e << t | e >>> 32 - t;
}
function Gq(e) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof e == "string") {
    var r = unescape(encodeURIComponent(e));
    e = [];
    for (var i = 0; i < r.length; ++i)
      e.push(r.charCodeAt(i));
  } else
    Array.isArray(e) || (e = Array.prototype.slice.call(e));
  e.push(128);
  for (var o = e.length / 4 + 2, a = Math.ceil(o / 16), s = new Array(a), c = 0; c < a; ++c) {
    for (var l = new Uint32Array(16), u = 0; u < 16; ++u)
      l[u] = e[c * 64 + u * 4] << 24 | e[c * 64 + u * 4 + 1] << 16 | e[c * 64 + u * 4 + 2] << 8 | e[c * 64 + u * 4 + 3];
    s[c] = l;
  }
  s[a - 1][14] = (e.length - 1) * 8 / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = (e.length - 1) * 8 & 4294967295;
  for (var f = 0; f < a; ++f) {
    for (var d = new Uint32Array(80), h = 0; h < 16; ++h)
      d[h] = s[f][h];
    for (var g = 16; g < 80; ++g)
      d[g] = Lv(d[g - 3] ^ d[g - 8] ^ d[g - 14] ^ d[g - 16], 1);
    for (var w = n[0], b = n[1], I = n[2], A = n[3], x = n[4], N = 0; N < 80; ++N) {
      var j = Math.floor(N / 20), K = Lv(w, 5) + Hq(j, b, I, A) + x + t[j] + d[N] >>> 0;
      x = A, A = I, I = Lv(b, 30) >>> 0, b = w, w = K;
    }
    n[0] = n[0] + w >>> 0, n[1] = n[1] + b >>> 0, n[2] = n[2] + I >>> 0, n[3] = n[3] + A >>> 0, n[4] = n[4] + x >>> 0;
  }
  return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, n[0] & 255, n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, n[1] & 255, n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, n[2] & 255, n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, n[3] & 255, n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, n[4] & 255];
}
var Yq = WD("v5", 80, Gq);
const Zq = Yq, Jq = "00000000-0000-0000-0000-000000000000";
function Xq(e) {
  if (!r_(e))
    throw TypeError("Invalid UUID");
  return parseInt(e.substr(14, 1), 16);
}
const Qq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: Jq,
  parse: $D,
  stringify: i_,
  v1: Rq,
  v3: Vq,
  v4: qq,
  v5: Zq,
  validate: r_,
  version: Xq
}, Symbol.toStringTag, { value: "Module" })), VD = /* @__PURE__ */ Qc(Qq), eH = VD.v4, tH = function(e, t, n, r) {
  if (typeof e != "string")
    throw new TypeError(e + " must be a string");
  r = r || {};
  const i = typeof r.version == "number" ? r.version : 2;
  if (i !== 1 && i !== 2)
    throw new TypeError(i + " must be 1 or 2");
  const o = {
    method: e
  };
  if (i === 2 && (o.jsonrpc = "2.0"), t) {
    if (typeof t != "object" && !Array.isArray(t))
      throw new TypeError(t + " must be an object, array or omitted");
    o.params = t;
  }
  if (typeof n > "u") {
    const a = typeof r.generator == "function" ? r.generator : function() {
      return eH();
    };
    o.id = a(o, r);
  } else
    i === 2 && n === null ? r.notificationIdNull && (o.id = null) : o.id = n;
  return o;
};
var nH = tH;
const rH = VD.v4, iH = nH, nd = function(e, t) {
  if (!(this instanceof nd))
    return new nd(e, t);
  t || (t = {}), this.options = {
    reviver: typeof t.reviver < "u" ? t.reviver : null,
    replacer: typeof t.replacer < "u" ? t.replacer : null,
    generator: typeof t.generator < "u" ? t.generator : function() {
      return rH();
    },
    version: typeof t.version < "u" ? t.version : 2,
    notificationIdNull: typeof t.notificationIdNull == "boolean" ? t.notificationIdNull : !1
  }, this.callServer = e;
};
var oH = nd;
nd.prototype.request = function(e, t, n, r) {
  const i = this;
  let o = null;
  const a = Array.isArray(e) && typeof t == "function";
  if (this.options.version === 1 && a)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (a || !a && e && typeof e == "object" && typeof t == "function")
    r = t, o = e;
  else {
    typeof n == "function" && (r = n, n = void 0);
    const l = typeof r == "function";
    try {
      o = iH(e, t, n, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (u) {
      if (l)
        return r(u);
      throw u;
    }
    if (!l)
      return o;
  }
  let c;
  try {
    c = JSON.stringify(o, this.options.replacer);
  } catch (l) {
    return r(l);
  }
  return this.callServer(c, function(l, u) {
    i._parseResponse(l, u, r);
  }), o;
};
nd.prototype._parseResponse = function(e, t, n) {
  if (e) {
    n(e);
    return;
  }
  if (!t)
    return n();
  let r;
  try {
    r = JSON.parse(t, this.options.reviver);
  } catch (i) {
    return n(i);
  }
  if (n.length === 3)
    if (Array.isArray(r)) {
      const i = function(a) {
        return typeof a.error < "u";
      }, o = function(a) {
        return !i(a);
      };
      return n(null, r.filter(i), r.filter(o));
    } else
      return n(null, r.error, r.result);
  n(null, r);
};
const aH = /* @__PURE__ */ Vi(oH);
var qD = {}, HD = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(HD);
var GD = HD.exports, $v = { exports: {} }, Wv = { exports: {} }, k2;
function jd() {
  return k2 || (k2 = 1, function(e) {
    function t(n) {
      "@babel/helpers - typeof";
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Wv)), Wv.exports;
}
var T2;
function sH() {
  return T2 || (T2 = 1, function(e) {
    var t = jd().default;
    function n() {
      e.exports = n = function() {
        return r;
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
      var r = {}, i = Object.prototype, o = i.hasOwnProperty, a = Object.defineProperty || function(y, v, E) {
        y[v] = E.value;
      }, s = typeof Symbol == "function" ? Symbol : {}, c = s.iterator || "@@iterator", l = s.asyncIterator || "@@asyncIterator", u = s.toStringTag || "@@toStringTag";
      function f(y, v, E) {
        return Object.defineProperty(y, v, {
          value: E,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), y[v];
      }
      try {
        f({}, "");
      } catch {
        f = function(E, B, F) {
          return E[B] = F;
        };
      }
      function d(y, v, E, B) {
        var F = v && v.prototype instanceof w ? v : w, q = Object.create(F.prototype), U = new M(B || []);
        return a(q, "_invoke", {
          value: O(y, E, U)
        }), q;
      }
      function h(y, v, E) {
        try {
          return {
            type: "normal",
            arg: y.call(v, E)
          };
        } catch (B) {
          return {
            type: "throw",
            arg: B
          };
        }
      }
      r.wrap = d;
      var g = {};
      function w() {
      }
      function b() {
      }
      function I() {
      }
      var A = {};
      f(A, c, function() {
        return this;
      });
      var x = Object.getPrototypeOf, N = x && x(x(S([])));
      N && N !== i && o.call(N, c) && (A = N);
      var j = I.prototype = w.prototype = Object.create(A);
      function K(y) {
        ["next", "throw", "return"].forEach(function(v) {
          f(y, v, function(E) {
            return this._invoke(v, E);
          });
        });
      }
      function W(y, v) {
        function E(F, q, U, m) {
          var D = h(y[F], y, q);
          if (D.type !== "throw") {
            var Y = D.arg, Q = Y.value;
            return Q && t(Q) == "object" && o.call(Q, "__await") ? v.resolve(Q.__await).then(function(G) {
              E("next", G, U, m);
            }, function(G) {
              E("throw", G, U, m);
            }) : v.resolve(Q).then(function(G) {
              Y.value = G, U(Y);
            }, function(G) {
              return E("throw", G, U, m);
            });
          }
          m(D.arg);
        }
        var B;
        a(this, "_invoke", {
          value: function(q, U) {
            function m() {
              return new v(function(D, Y) {
                E(q, U, D, Y);
              });
            }
            return B = B ? B.then(m, m) : m();
          }
        });
      }
      function O(y, v, E) {
        var B = "suspendedStart";
        return function(F, q) {
          if (B === "executing")
            throw new Error("Generator is already running");
          if (B === "completed") {
            if (F === "throw")
              throw q;
            return p();
          }
          for (E.method = F, E.arg = q; ; ) {
            var U = E.delegate;
            if (U) {
              var m = k(U, E);
              if (m) {
                if (m === g)
                  continue;
                return m;
              }
            }
            if (E.method === "next")
              E.sent = E._sent = E.arg;
            else if (E.method === "throw") {
              if (B === "suspendedStart")
                throw B = "completed", E.arg;
              E.dispatchException(E.arg);
            } else
              E.method === "return" && E.abrupt("return", E.arg);
            B = "executing";
            var D = h(y, v, E);
            if (D.type === "normal") {
              if (B = E.done ? "completed" : "suspendedYield", D.arg === g)
                continue;
              return {
                value: D.arg,
                done: E.done
              };
            }
            D.type === "throw" && (B = "completed", E.method = "throw", E.arg = D.arg);
          }
        };
      }
      function k(y, v) {
        var E = v.method, B = y.iterator[E];
        if (B === void 0)
          return v.delegate = null, E === "throw" && y.iterator.return && (v.method = "return", v.arg = void 0, k(y, v), v.method === "throw") || E !== "return" && (v.method = "throw", v.arg = new TypeError("The iterator does not provide a '" + E + "' method")), g;
        var F = h(B, y.iterator, v.arg);
        if (F.type === "throw")
          return v.method = "throw", v.arg = F.arg, v.delegate = null, g;
        var q = F.arg;
        return q ? q.done ? (v[y.resultName] = q.value, v.next = y.nextLoc, v.method !== "return" && (v.method = "next", v.arg = void 0), v.delegate = null, g) : q : (v.method = "throw", v.arg = new TypeError("iterator result is not an object"), v.delegate = null, g);
      }
      function z(y) {
        var v = {
          tryLoc: y[0]
        };
        1 in y && (v.catchLoc = y[1]), 2 in y && (v.finallyLoc = y[2], v.afterLoc = y[3]), this.tryEntries.push(v);
      }
      function C(y) {
        var v = y.completion || {};
        v.type = "normal", delete v.arg, y.completion = v;
      }
      function M(y) {
        this.tryEntries = [{
          tryLoc: "root"
        }], y.forEach(z, this), this.reset(!0);
      }
      function S(y) {
        if (y) {
          var v = y[c];
          if (v)
            return v.call(y);
          if (typeof y.next == "function")
            return y;
          if (!isNaN(y.length)) {
            var E = -1, B = function F() {
              for (; ++E < y.length; )
                if (o.call(y, E))
                  return F.value = y[E], F.done = !1, F;
              return F.value = void 0, F.done = !0, F;
            };
            return B.next = B;
          }
        }
        return {
          next: p
        };
      }
      function p() {
        return {
          value: void 0,
          done: !0
        };
      }
      return b.prototype = I, a(j, "constructor", {
        value: I,
        configurable: !0
      }), a(I, "constructor", {
        value: b,
        configurable: !0
      }), b.displayName = f(I, u, "GeneratorFunction"), r.isGeneratorFunction = function(y) {
        var v = typeof y == "function" && y.constructor;
        return !!v && (v === b || (v.displayName || v.name) === "GeneratorFunction");
      }, r.mark = function(y) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(y, I) : (y.__proto__ = I, f(y, u, "GeneratorFunction")), y.prototype = Object.create(j), y;
      }, r.awrap = function(y) {
        return {
          __await: y
        };
      }, K(W.prototype), f(W.prototype, l, function() {
        return this;
      }), r.AsyncIterator = W, r.async = function(y, v, E, B, F) {
        F === void 0 && (F = Promise);
        var q = new W(d(y, v, E, B), F);
        return r.isGeneratorFunction(v) ? q : q.next().then(function(U) {
          return U.done ? U.value : q.next();
        });
      }, K(j), f(j, u, "Generator"), f(j, c, function() {
        return this;
      }), f(j, "toString", function() {
        return "[object Generator]";
      }), r.keys = function(y) {
        var v = Object(y), E = [];
        for (var B in v)
          E.push(B);
        return E.reverse(), function F() {
          for (; E.length; ) {
            var q = E.pop();
            if (q in v)
              return F.value = q, F.done = !1, F;
          }
          return F.done = !0, F;
        };
      }, r.values = S, M.prototype = {
        constructor: M,
        reset: function(v) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(C), !v)
            for (var E in this)
              E.charAt(0) === "t" && o.call(this, E) && !isNaN(+E.slice(1)) && (this[E] = void 0);
        },
        stop: function() {
          this.done = !0;
          var v = this.tryEntries[0].completion;
          if (v.type === "throw")
            throw v.arg;
          return this.rval;
        },
        dispatchException: function(v) {
          if (this.done)
            throw v;
          var E = this;
          function B(Y, Q) {
            return U.type = "throw", U.arg = v, E.next = Y, Q && (E.method = "next", E.arg = void 0), !!Q;
          }
          for (var F = this.tryEntries.length - 1; F >= 0; --F) {
            var q = this.tryEntries[F], U = q.completion;
            if (q.tryLoc === "root")
              return B("end");
            if (q.tryLoc <= this.prev) {
              var m = o.call(q, "catchLoc"), D = o.call(q, "finallyLoc");
              if (m && D) {
                if (this.prev < q.catchLoc)
                  return B(q.catchLoc, !0);
                if (this.prev < q.finallyLoc)
                  return B(q.finallyLoc);
              } else if (m) {
                if (this.prev < q.catchLoc)
                  return B(q.catchLoc, !0);
              } else {
                if (!D)
                  throw new Error("try statement without catch or finally");
                if (this.prev < q.finallyLoc)
                  return B(q.finallyLoc);
              }
            }
          }
        },
        abrupt: function(v, E) {
          for (var B = this.tryEntries.length - 1; B >= 0; --B) {
            var F = this.tryEntries[B];
            if (F.tryLoc <= this.prev && o.call(F, "finallyLoc") && this.prev < F.finallyLoc) {
              var q = F;
              break;
            }
          }
          q && (v === "break" || v === "continue") && q.tryLoc <= E && E <= q.finallyLoc && (q = null);
          var U = q ? q.completion : {};
          return U.type = v, U.arg = E, q ? (this.method = "next", this.next = q.finallyLoc, g) : this.complete(U);
        },
        complete: function(v, E) {
          if (v.type === "throw")
            throw v.arg;
          return v.type === "break" || v.type === "continue" ? this.next = v.arg : v.type === "return" ? (this.rval = this.arg = v.arg, this.method = "return", this.next = "end") : v.type === "normal" && E && (this.next = E), g;
        },
        finish: function(v) {
          for (var E = this.tryEntries.length - 1; E >= 0; --E) {
            var B = this.tryEntries[E];
            if (B.finallyLoc === v)
              return this.complete(B.completion, B.afterLoc), C(B), g;
          }
        },
        catch: function(v) {
          for (var E = this.tryEntries.length - 1; E >= 0; --E) {
            var B = this.tryEntries[E];
            if (B.tryLoc === v) {
              var F = B.completion;
              if (F.type === "throw") {
                var q = F.arg;
                C(B);
              }
              return q;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(v, E, B) {
          return this.delegate = {
            iterator: S(v),
            resultName: E,
            nextLoc: B
          }, this.method === "next" && (this.arg = void 0), g;
        }
      }, r;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }($v)), $v.exports;
}
var Kv, x2;
function cH() {
  if (x2)
    return Kv;
  x2 = 1;
  var e = sH()();
  Kv = e;
  try {
    regeneratorRuntime = e;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
  return Kv;
}
var Vv = { exports: {} }, M2;
function uH() {
  return M2 || (M2 = 1, function(e) {
    function t(r, i, o, a, s, c, l) {
      try {
        var u = r[c](l), f = u.value;
      } catch (d) {
        o(d);
        return;
      }
      u.done ? i(f) : Promise.resolve(f).then(a, s);
    }
    function n(r) {
      return function() {
        var i = this, o = arguments;
        return new Promise(function(a, s) {
          var c = r.apply(i, o);
          function l(f) {
            t(c, a, s, l, u, "next", f);
          }
          function u(f) {
            t(c, a, s, l, u, "throw", f);
          }
          l(void 0);
        });
      };
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Vv)), Vv.exports;
}
var qv = { exports: {} }, O2;
function YD() {
  return O2 || (O2 = 1, function(e) {
    function t(n, r) {
      if (!(n instanceof r))
        throw new TypeError("Cannot call a class as a function");
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(qv)), qv.exports;
}
var Hv = { exports: {} }, Gv = { exports: {} }, Yv = { exports: {} }, P2;
function lH() {
  return P2 || (P2 = 1, function(e) {
    var t = jd().default;
    function n(r, i) {
      if (t(r) !== "object" || r === null)
        return r;
      var o = r[Symbol.toPrimitive];
      if (o !== void 0) {
        var a = o.call(r, i || "default");
        if (t(a) !== "object")
          return a;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (i === "string" ? String : Number)(r);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Yv)), Yv.exports;
}
var B2;
function fH() {
  return B2 || (B2 = 1, function(e) {
    var t = jd().default, n = lH();
    function r(i) {
      var o = n(i, "string");
      return t(o) === "symbol" ? o : String(o);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Gv)), Gv.exports;
}
var C2;
function ZD() {
  return C2 || (C2 = 1, function(e) {
    var t = fH();
    function n(i, o) {
      for (var a = 0; a < o.length; a++) {
        var s = o[a];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(i, t(s.key), s);
      }
    }
    function r(i, o, a) {
      return o && n(i.prototype, o), a && n(i, a), Object.defineProperty(i, "prototype", {
        writable: !1
      }), i;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Hv)), Hv.exports;
}
var Zv = { exports: {} }, Jv = { exports: {} }, D2;
function dH() {
  return D2 || (D2 = 1, function(e) {
    function t(n, r) {
      return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, a) {
        return o.__proto__ = a, o;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n, r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Jv)), Jv.exports;
}
var R2;
function JD() {
  return R2 || (R2 = 1, function(e) {
    var t = dH();
    function n(r, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Super expression must either be null or a function");
      r.prototype = Object.create(i && i.prototype, {
        constructor: {
          value: r,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(r, "prototype", {
        writable: !1
      }), i && t(r, i);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Zv)), Zv.exports;
}
var Xv = { exports: {} }, Qv = { exports: {} }, N2;
function hH() {
  return N2 || (N2 = 1, function(e) {
    function t(n) {
      if (n === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Qv)), Qv.exports;
}
var j2;
function XD() {
  return j2 || (j2 = 1, function(e) {
    var t = jd().default, n = hH();
    function r(i, o) {
      if (o && (t(o) === "object" || typeof o == "function"))
        return o;
      if (o !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return n(i);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Xv)), Xv.exports;
}
var e1 = { exports: {} }, U2;
function QD() {
  return U2 || (U2 = 1, function(e) {
    function t(n) {
      return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
        return i.__proto__ || Object.getPrototypeOf(i);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(e1)), e1.exports;
}
(function(e) {
  var t = GD;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = t(cH()), r = t(uH()), i = t(jd()), o = t(YD()), a = t(ZD()), s = t(JD()), c = t(XD()), l = t(QD()), u = jI();
  function f(w) {
    var b = d();
    return function() {
      var A = (0, l.default)(w), x;
      if (b) {
        var N = (0, l.default)(this).constructor;
        x = Reflect.construct(A, arguments, N);
      } else
        x = A.apply(this, arguments);
      return (0, c.default)(this, x);
    };
  }
  function d() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var h = function(w, b) {
    var I = {};
    for (var A in w)
      Object.prototype.hasOwnProperty.call(w, A) && b.indexOf(A) < 0 && (I[A] = w[A]);
    if (w != null && typeof Object.getOwnPropertySymbols == "function")
      for (var x = 0, A = Object.getOwnPropertySymbols(w); x < A.length; x++)
        b.indexOf(A[x]) < 0 && Object.prototype.propertyIsEnumerable.call(w, A[x]) && (I[A[x]] = w[A[x]]);
    return I;
  }, g = /* @__PURE__ */ function(w) {
    (0, s.default)(I, w);
    var b = f(I);
    function I(A) {
      var x, N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ws://localhost:8080", j = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, K = arguments.length > 3 ? arguments[3] : void 0;
      (0, o.default)(this, I);
      var W = j.autoconnect, O = W === void 0 ? !0 : W, k = j.reconnect, z = k === void 0 ? !0 : k, C = j.reconnect_interval, M = C === void 0 ? 1e3 : C, S = j.max_reconnects, p = S === void 0 ? 5 : S, y = h(j, ["autoconnect", "reconnect", "reconnect_interval", "max_reconnects"]);
      return x = b.call(this), x.webSocketFactory = A, x.queue = {}, x.rpc_id = 0, x.address = N, x.autoconnect = O, x.ready = !1, x.reconnect = z, x.reconnect_timer_id = void 0, x.reconnect_interval = M, x.max_reconnects = p, x.rest_options = y, x.current_reconnects = 0, x.generate_request_id = K || function() {
        return ++x.rpc_id;
      }, x.autoconnect && x._connect(x.address, Object.assign({
        autoconnect: x.autoconnect,
        reconnect: x.reconnect,
        reconnect_interval: x.reconnect_interval,
        max_reconnects: x.max_reconnects
      }, x.rest_options)), x;
    }
    return (0, a.default)(I, [{
      key: "connect",
      value: function() {
        this.socket || this._connect(this.address, Object.assign({
          autoconnect: this.autoconnect,
          reconnect: this.reconnect,
          reconnect_interval: this.reconnect_interval,
          max_reconnects: this.max_reconnects
        }, this.rest_options));
      }
      /**
       * Calls a registered RPC method on server.
       * @method
       * @param {String} method - RPC method name
       * @param {Object|Array} params - optional method parameters
       * @param {Number} timeout - RPC reply timeout value
       * @param {Object} ws_opts - options passed to ws
       * @return {Promise}
       */
    }, {
      key: "call",
      value: function(x, N, j, K) {
        var W = this;
        return !K && (0, i.default)(j) === "object" && (K = j, j = null), new Promise(function(O, k) {
          if (!W.ready)
            return k(new Error("socket not ready"));
          var z = W.generate_request_id(x, N), C = {
            jsonrpc: "2.0",
            method: x,
            params: N || null,
            id: z
          };
          W.socket.send(JSON.stringify(C), K, function(M) {
            if (M)
              return k(M);
            W.queue[z] = {
              promise: [O, k]
            }, j && (W.queue[z].timeout = setTimeout(function() {
              delete W.queue[z], k(new Error("reply timeout"));
            }, j));
          });
        });
      }
      /**
       * Logins with the other side of the connection.
       * @method
       * @param {Object} params - Login credentials object
       * @return {Promise}
       */
    }, {
      key: "login",
      value: function() {
        var A = (0, r.default)(/* @__PURE__ */ n.default.mark(function N(j) {
          var K;
          return n.default.wrap(function(O) {
            for (; ; )
              switch (O.prev = O.next) {
                case 0:
                  return O.next = 2, this.call("rpc.login", j);
                case 2:
                  if (K = O.sent, K) {
                    O.next = 5;
                    break;
                  }
                  throw new Error("authentication failed");
                case 5:
                  return O.abrupt("return", K);
                case 6:
                case "end":
                  return O.stop();
              }
          }, N, this);
        }));
        function x(N) {
          return A.apply(this, arguments);
        }
        return x;
      }()
      /**
       * Fetches a list of client's methods registered on server.
       * @method
       * @return {Array}
       */
    }, {
      key: "listMethods",
      value: function() {
        var A = (0, r.default)(/* @__PURE__ */ n.default.mark(function N() {
          return n.default.wrap(function(K) {
            for (; ; )
              switch (K.prev = K.next) {
                case 0:
                  return K.next = 2, this.call("__listMethods");
                case 2:
                  return K.abrupt("return", K.sent);
                case 3:
                case "end":
                  return K.stop();
              }
          }, N, this);
        }));
        function x() {
          return A.apply(this, arguments);
        }
        return x;
      }()
      /**
       * Sends a JSON-RPC 2.0 notification to server.
       * @method
       * @param {String} method - RPC method name
       * @param {Object} params - optional method parameters
       * @return {Promise}
       */
    }, {
      key: "notify",
      value: function(x, N) {
        var j = this;
        return new Promise(function(K, W) {
          if (!j.ready)
            return W(new Error("socket not ready"));
          var O = {
            jsonrpc: "2.0",
            method: x,
            params: N || null
          };
          j.socket.send(JSON.stringify(O), function(k) {
            if (k)
              return W(k);
            K();
          });
        });
      }
      /**
       * Subscribes for a defined event.
       * @method
       * @param {String|Array} event - event name
       * @return {Undefined}
       * @throws {Error}
       */
    }, {
      key: "subscribe",
      value: function() {
        var A = (0, r.default)(/* @__PURE__ */ n.default.mark(function N(j) {
          var K;
          return n.default.wrap(function(O) {
            for (; ; )
              switch (O.prev = O.next) {
                case 0:
                  return typeof j == "string" && (j = [j]), O.next = 3, this.call("rpc.on", j);
                case 3:
                  if (K = O.sent, !(typeof j == "string" && K[j] !== "ok")) {
                    O.next = 6;
                    break;
                  }
                  throw new Error("Failed subscribing to an event '" + j + "' with: " + K[j]);
                case 6:
                  return O.abrupt("return", K);
                case 7:
                case "end":
                  return O.stop();
              }
          }, N, this);
        }));
        function x(N) {
          return A.apply(this, arguments);
        }
        return x;
      }()
      /**
       * Unsubscribes from a defined event.
       * @method
       * @param {String|Array} event - event name
       * @return {Undefined}
       * @throws {Error}
       */
    }, {
      key: "unsubscribe",
      value: function() {
        var A = (0, r.default)(/* @__PURE__ */ n.default.mark(function N(j) {
          var K;
          return n.default.wrap(function(O) {
            for (; ; )
              switch (O.prev = O.next) {
                case 0:
                  return typeof j == "string" && (j = [j]), O.next = 3, this.call("rpc.off", j);
                case 3:
                  if (K = O.sent, !(typeof j == "string" && K[j] !== "ok")) {
                    O.next = 6;
                    break;
                  }
                  throw new Error("Failed unsubscribing from an event with: " + K);
                case 6:
                  return O.abrupt("return", K);
                case 7:
                case "end":
                  return O.stop();
              }
          }, N, this);
        }));
        function x(N) {
          return A.apply(this, arguments);
        }
        return x;
      }()
      /**
       * Closes a WebSocket connection gracefully.
       * @method
       * @param {Number} code - socket close code
       * @param {String} data - optional data to be sent before closing
       * @return {Undefined}
       */
    }, {
      key: "close",
      value: function(x, N) {
        this.socket.close(x || 1e3, N);
      }
      /**
       * Connection/Message handler.
       * @method
       * @private
       * @param {String} address - WebSocket API address
       * @param {Object} options - ws options object
       * @return {Undefined}
       */
    }, {
      key: "_connect",
      value: function(x, N) {
        var j = this;
        clearTimeout(this.reconnect_timer_id), this.socket = this.webSocketFactory(x, N), this.socket.addEventListener("open", function() {
          j.ready = !0, j.emit("open"), j.current_reconnects = 0;
        }), this.socket.addEventListener("message", function(K) {
          var W = K.data;
          W instanceof ArrayBuffer && (W = Buffer.from(W).toString());
          try {
            W = JSON.parse(W);
          } catch {
            return;
          }
          if (W.notification && j.listeners(W.notification).length) {
            if (!Object.keys(W.params).length)
              return j.emit(W.notification);
            var O = [W.notification];
            if (W.params.constructor === Object)
              O.push(W.params);
            else
              for (var k = 0; k < W.params.length; k++)
                O.push(W.params[k]);
            return Promise.resolve().then(function() {
              j.emit.apply(j, O);
            });
          }
          if (!j.queue[W.id])
            return W.method && W.params ? Promise.resolve().then(function() {
              j.emit(W.method, W.params);
            }) : void 0;
          "error" in W == "result" in W && j.queue[W.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.')), j.queue[W.id].timeout && clearTimeout(j.queue[W.id].timeout), W.error ? j.queue[W.id].promise[1](W.error) : j.queue[W.id].promise[0](W.result), delete j.queue[W.id];
        }), this.socket.addEventListener("error", function(K) {
          return j.emit("error", K);
        }), this.socket.addEventListener("close", function(K) {
          var W = K.code, O = K.reason;
          j.ready && setTimeout(function() {
            return j.emit("close", W, O);
          }, 0), j.ready = !1, j.socket = void 0, W !== 1e3 && (j.current_reconnects++, j.reconnect && (j.max_reconnects > j.current_reconnects || j.max_reconnects === 0) && (j.reconnect_timer_id = setTimeout(function() {
            return j._connect(x, N);
          }, j.reconnect_interval)));
        });
      }
    }]), I;
  }(u.EventEmitter);
  e.default = g;
})(qD);
const pH = /* @__PURE__ */ Vi(qD);
var eR = {};
(function(e) {
  var t = GD;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = f;
  var n = t(YD()), r = t(ZD()), i = t(JD()), o = t(XD()), a = t(QD()), s = jI();
  function c(d) {
    var h = l();
    return function() {
      var w = (0, a.default)(d), b;
      if (h) {
        var I = (0, a.default)(this).constructor;
        b = Reflect.construct(w, arguments, I);
      } else
        b = w.apply(this, arguments);
      return (0, o.default)(this, b);
    };
  }
  function l() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var u = /* @__PURE__ */ function(d) {
    (0, i.default)(g, d);
    var h = c(g);
    function g(w, b, I) {
      var A;
      return (0, n.default)(this, g), A = h.call(this), A.socket = new window.WebSocket(w, I), A.socket.onopen = function() {
        return A.emit("open");
      }, A.socket.onmessage = function(x) {
        return A.emit("message", x.data);
      }, A.socket.onerror = function(x) {
        return A.emit("error", x);
      }, A.socket.onclose = function(x) {
        A.emit("close", x.code, x.reason);
      }, A;
    }
    return (0, r.default)(g, [{
      key: "send",
      value: function(b, I, A) {
        var x = A || I;
        try {
          this.socket.send(b), x();
        } catch (N) {
          x(N);
        }
      }
      /**
       * Closes an underlying socket
       * @method
       * @param {Number} code - status code explaining why the connection is being closed
       * @param {String} reason - a description why the connection is closing
       * @return {Undefined}
       * @throws {Error}
       */
    }, {
      key: "close",
      value: function(b, I) {
        this.socket.close(b, I);
      }
    }, {
      key: "addEventListener",
      value: function(b, I, A) {
        this.socket.addEventListener(b, I, A);
      }
    }]), g;
  }(s.EventEmitter);
  function f(d, h) {
    return new u(d, h);
  }
})(eR);
const yH = /* @__PURE__ */ Vi(eR), [tR, nR, rR] = [[], [], []], gH = BigInt(0), uf = BigInt(1), bH = BigInt(2), mH = BigInt(7), _H = BigInt(256), wH = BigInt(113);
for (let e = 0, t = uf, n = 1, r = 0; e < 24; e++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], tR.push(2 * (5 * r + n)), nR.push((e + 1) * (e + 2) / 2 % 64);
  let i = gH;
  for (let o = 0; o < 7; o++)
    t = (t << uf ^ (t >> mH) * wH) % _H, t & bH && (i ^= uf << (uf << BigInt(o)) - uf);
  rR.push(i);
}
const [vH, SH] = Ct.split(rR, !0), z2 = (e, t, n) => n > 32 ? Ct.rotlBH(e, t, n) : Ct.rotlSH(e, t, n), F2 = (e, t, n) => n > 32 ? Ct.rotlBL(e, t, n) : Ct.rotlSL(e, t, n);
function EH(e, t = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - t; r < 24; r++) {
    for (let a = 0; a < 10; a++)
      n[a] = e[a] ^ e[a + 10] ^ e[a + 20] ^ e[a + 30] ^ e[a + 40];
    for (let a = 0; a < 10; a += 2) {
      const s = (a + 8) % 10, c = (a + 2) % 10, l = n[c], u = n[c + 1], f = z2(l, u, 1) ^ n[s], d = F2(l, u, 1) ^ n[s + 1];
      for (let h = 0; h < 50; h += 10)
        e[a + h] ^= f, e[a + h + 1] ^= d;
    }
    let i = e[2], o = e[3];
    for (let a = 0; a < 24; a++) {
      const s = nR[a], c = z2(i, o, s), l = F2(i, o, s), u = tR[a];
      i = e[u], o = e[u + 1], e[u] = c, e[u + 1] = l;
    }
    for (let a = 0; a < 50; a += 10) {
      for (let s = 0; s < 10; s++)
        n[s] = e[a + s];
      for (let s = 0; s < 10; s++)
        e[a + s] ^= ~n[(s + 2) % 10] & n[(s + 4) % 10];
    }
    e[0] ^= vH[r], e[1] ^= SH[r];
  }
  n.fill(0);
}
let iR = class oR extends uk {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, n, r, i = !1, o = 24) {
    if (super(), this.blockLen = t, this.suffix = n, this.outputLen = r, this.enableXOF = i, this.rounds = o, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, ji.number(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = vV(this.state);
  }
  keccak() {
    EH(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    ji.exists(this);
    const { blockLen: n, state: r } = this;
    t = Od(t);
    const i = t.length;
    for (let o = 0; o < i; ) {
      const a = Math.min(n - this.pos, i - o);
      for (let s = 0; s < a; s++)
        r[this.pos++] ^= t[o++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: n, pos: r, blockLen: i } = this;
    t[r] ^= n, n & 128 && r === i - 1 && this.keccak(), t[i - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    ji.exists(this, !1), ji.bytes(t), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let i = 0, o = t.length; i < o; ) {
      this.posOut >= r && this.keccak();
      const a = Math.min(r - this.posOut, o - i);
      t.set(n.subarray(this.posOut, this.posOut + a), i), this.posOut += a, i += a;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return ji.number(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (ji.output(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: n, suffix: r, outputLen: i, rounds: o, enableXOF: a } = this;
    return t || (t = new oR(n, r, i, a, o)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = o, t.suffix = r, t.outputLen = i, t.enableXOF = a, t.destroyed = this.destroyed, t;
  }
};
const ic = (e, t, n) => eu(() => new iR(t, e, n));
ic(6, 144, 224 / 8);
ic(6, 136, 256 / 8);
ic(6, 104, 384 / 8);
ic(6, 72, 512 / 8);
ic(1, 144, 224 / 8);
const L2 = ic(1, 136, 256 / 8);
ic(1, 104, 384 / 8);
ic(1, 72, 512 / 8);
const aR = (e, t, n) => AV((r = {}) => new iR(t, e, r.dkLen === void 0 ? n : r.dkLen, !0));
aR(31, 168, 128 / 8);
aR(31, 136, 256 / 8);
let sR = class extends uk {
  constructor(t, n) {
    super(), this.finished = !1, this.destroyed = !1, ji.hash(t);
    const r = Od(n);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new TypeError("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const i = this.blockLen, o = new Uint8Array(i);
    o.set(r.length > i ? t.create().update(r).digest() : r);
    for (let a = 0; a < o.length; a++)
      o[a] ^= 54;
    this.iHash.update(o), this.oHash = t.create();
    for (let a = 0; a < o.length; a++)
      o[a] ^= 106;
    this.oHash.update(o), o.fill(0);
  }
  update(t) {
    return ji.exists(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    ji.exists(this), ji.bytes(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: n, iHash: r, finished: i, destroyed: o, blockLen: a, outputLen: s } = this;
    return t = t, t.finished = i, t.destroyed = o, t.blockLen = a, t.outputLen = s, t.oHash = n._cloneInto(t.oHash), t.iHash = r._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
};
const cR = (e, t, n) => new sR(e, t).update(n).digest();
cR.create = (e, t) => new sR(e, t);
/*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */
const gn = BigInt(0), rr = BigInt(1), Os = BigInt(2), Wf = BigInt(3), $2 = BigInt(8), kr = Object.freeze({
  a: gn,
  b: BigInt(7),
  P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
  n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
  h: rr,
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
}), W2 = (e, t) => (e + t / Os) / t, mg = {
  beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
  splitScalar(e) {
    const { n: t } = kr, n = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), r = -rr * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), o = n, a = BigInt("0x100000000000000000000000000000000"), s = W2(o * e, t), c = W2(-r * e, t);
    let l = ut(e - s * n - c * i, t), u = ut(-s * r - c * o, t);
    const f = l > a, d = u > a;
    if (f && (l = t - l), d && (u = t - u), l > a || u > a)
      throw new Error("splitScalarEndo: Endomorphism failed, k=" + e);
    return { k1neg: f, k1: l, k2neg: d, k2: u };
  }
}, To = 32, dl = 32, AH = 32, K2 = To + 1, V2 = 2 * To + 1;
function q2(e) {
  const { a: t, b: n } = kr, r = ut(e * e), i = ut(r * e);
  return ut(i + t * e + n);
}
const _g = kr.a === gn;
class uR extends Error {
  constructor(t) {
    super(t);
  }
}
function H2(e) {
  if (!(e instanceof En))
    throw new TypeError("JacobianPoint expected");
}
class En {
  constructor(t, n, r) {
    this.x = t, this.y = n, this.z = r;
  }
  static fromAffine(t) {
    if (!(t instanceof hr))
      throw new TypeError("JacobianPoint#fromAffine: expected Point");
    return t.equals(hr.ZERO) ? En.ZERO : new En(t.x, t.y, rr);
  }
  static toAffineBatch(t) {
    const n = MH(t.map((r) => r.z));
    return t.map((r, i) => r.toAffine(n[i]));
  }
  static normalizeZ(t) {
    return En.toAffineBatch(t).map(En.fromAffine);
  }
  equals(t) {
    H2(t);
    const { x: n, y: r, z: i } = this, { x: o, y: a, z: s } = t, c = ut(i * i), l = ut(s * s), u = ut(n * l), f = ut(o * c), d = ut(ut(r * s) * l), h = ut(ut(a * i) * c);
    return u === f && d === h;
  }
  negate() {
    return new En(this.x, ut(-this.y), this.z);
  }
  double() {
    const { x: t, y: n, z: r } = this, i = ut(t * t), o = ut(n * n), a = ut(o * o), s = t + o, c = ut(Os * (ut(s * s) - i - a)), l = ut(Wf * i), u = ut(l * l), f = ut(u - Os * c), d = ut(l * (c - f) - $2 * a), h = ut(Os * n * r);
    return new En(f, d, h);
  }
  add(t) {
    H2(t);
    const { x: n, y: r, z: i } = this, { x: o, y: a, z: s } = t;
    if (o === gn || a === gn)
      return this;
    if (n === gn || r === gn)
      return t;
    const c = ut(i * i), l = ut(s * s), u = ut(n * l), f = ut(o * c), d = ut(ut(r * s) * l), h = ut(ut(a * i) * c), g = ut(f - u), w = ut(h - d);
    if (g === gn)
      return w === gn ? this.double() : En.ZERO;
    const b = ut(g * g), I = ut(g * b), A = ut(u * b), x = ut(w * w - I - Os * A), N = ut(w * (A - x) - d * I), j = ut(i * s * g);
    return new En(x, N, j);
  }
  subtract(t) {
    return this.add(t.negate());
  }
  multiplyUnsafe(t) {
    const n = En.ZERO;
    if (typeof t == "bigint" && t === gn)
      return n;
    let r = Z2(t);
    if (r === rr)
      return this;
    if (!_g) {
      let f = n, d = this;
      for (; r > gn; )
        r & rr && (f = f.add(d)), d = d.double(), r >>= rr;
      return f;
    }
    let { k1neg: i, k1: o, k2neg: a, k2: s } = mg.splitScalar(r), c = n, l = n, u = this;
    for (; o > gn || s > gn; )
      o & rr && (c = c.add(u)), s & rr && (l = l.add(u)), u = u.double(), o >>= rr, s >>= rr;
    return i && (c = c.negate()), a && (l = l.negate()), l = new En(ut(l.x * mg.beta), l.y, l.z), c.add(l);
  }
  precomputeWindow(t) {
    const n = _g ? 128 / t + 1 : 256 / t + 1, r = [];
    let i = this, o = i;
    for (let a = 0; a < n; a++) {
      o = i, r.push(o);
      for (let s = 1; s < 2 ** (t - 1); s++)
        o = o.add(i), r.push(o);
      i = o.double();
    }
    return r;
  }
  wNAF(t, n) {
    !n && this.equals(En.BASE) && (n = hr.BASE);
    const r = n && n._WINDOW_SIZE || 1;
    if (256 % r)
      throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
    let i = n && cA.get(n);
    i || (i = this.precomputeWindow(r), n && r !== 1 && (i = En.normalizeZ(i), cA.set(n, i)));
    let o = En.ZERO, a = En.BASE;
    const s = 1 + (_g ? 128 / r : 256 / r), c = 2 ** (r - 1), l = BigInt(2 ** r - 1), u = 2 ** r, f = BigInt(r);
    for (let d = 0; d < s; d++) {
      const h = d * c;
      let g = Number(t & l);
      t >>= f, g > c && (g -= u, t += rr);
      const w = h, b = h + Math.abs(g) - 1, I = d % 2 !== 0, A = g < 0;
      g === 0 ? a = a.add(wg(I, i[w])) : o = o.add(wg(A, i[b]));
    }
    return { p: o, f: a };
  }
  multiply(t, n) {
    let r = Z2(t), i, o;
    if (_g) {
      const { k1neg: a, k1: s, k2neg: c, k2: l } = mg.splitScalar(r);
      let { p: u, f } = this.wNAF(s, n), { p: d, f: h } = this.wNAF(l, n);
      u = wg(a, u), d = wg(c, d), d = new En(ut(d.x * mg.beta), d.y, d.z), i = u.add(d), o = f.add(h);
    } else {
      const { p: a, f: s } = this.wNAF(r, n);
      i = a, o = s;
    }
    return En.normalizeZ([i, o])[0];
  }
  toAffine(t) {
    const { x: n, y: r, z: i } = this, o = this.equals(En.ZERO);
    t == null && (t = o ? $2 : Ud(i));
    const a = t, s = ut(a * a), c = ut(s * a), l = ut(n * s), u = ut(r * c), f = ut(i * a);
    if (o)
      return hr.ZERO;
    if (f !== rr)
      throw new Error("invZ was invalid");
    return new hr(l, u);
  }
}
En.BASE = new En(kr.Gx, kr.Gy, rr);
En.ZERO = new En(gn, rr, gn);
function wg(e, t) {
  const n = t.negate();
  return e ? n : t;
}
const cA = /* @__PURE__ */ new WeakMap();
class hr {
  constructor(t, n) {
    this.x = t, this.y = n;
  }
  _setWindowSize(t) {
    this._WINDOW_SIZE = t, cA.delete(this);
  }
  hasEvenY() {
    return this.y % Os === gn;
  }
  static fromCompressedHex(t) {
    const n = t.length === 32, r = js(n ? t : t.subarray(1));
    if (!t1(r))
      throw new Error("Point is not on curve");
    const i = q2(r);
    let o = xH(i);
    const a = (o & rr) === rr;
    n ? a && (o = ut(-o)) : (t[0] & 1) === 1 !== a && (o = ut(-o));
    const s = new hr(r, o);
    return s.assertValidity(), s;
  }
  static fromUncompressedHex(t) {
    const n = js(t.subarray(1, To + 1)), r = js(t.subarray(To + 1, To * 2 + 1)), i = new hr(n, r);
    return i.assertValidity(), i;
  }
  static fromHex(t) {
    const n = rd(t), r = n.length, i = n[0];
    if (r === To)
      return this.fromCompressedHex(n);
    if (r === K2 && (i === 2 || i === 3))
      return this.fromCompressedHex(n);
    if (r === V2 && i === 4)
      return this.fromUncompressedHex(n);
    throw new Error(`Point.fromHex: received invalid point. Expected 32-${K2} compressed bytes or ${V2} uncompressed bytes, not ${r}`);
  }
  static fromPrivateKey(t) {
    return hr.BASE.multiply(Kb(t));
  }
  static fromSignature(t, n, r) {
    const { r: i, s: o } = CH(n);
    if (![0, 1, 2, 3].includes(r))
      throw new Error("Cannot recover: invalid recovery bit");
    const a = lR(rd(t)), { n: s } = kr, c = r === 2 || r === 3 ? i + s : i, l = Ud(c, s), u = ut(-a * l, s), f = ut(o * l, s), d = r & 1 ? "03" : "02", h = hr.fromHex(d + Hu(c)), g = hr.BASE.multiplyAndAddUnsafe(h, u, f);
    if (!g)
      throw new Error("Cannot recover signature: point at infinify");
    return g.assertValidity(), g;
  }
  toRawBytes(t = !1) {
    return Ac(this.toHex(t));
  }
  toHex(t = !1) {
    const n = Hu(this.x);
    return t ? `${this.hasEvenY() ? "02" : "03"}${n}` : `04${n}${Hu(this.y)}`;
  }
  toHexX() {
    return this.toHex(!0).slice(2);
  }
  toRawX() {
    return this.toRawBytes(!0).slice(1);
  }
  assertValidity() {
    const t = "Point is not on elliptic curve", { x: n, y: r } = this;
    if (!t1(n) || !t1(r))
      throw new Error(t);
    const i = ut(r * r), o = q2(n);
    if (ut(i - o) !== gn)
      throw new Error(t);
  }
  equals(t) {
    return this.x === t.x && this.y === t.y;
  }
  negate() {
    return new hr(this.x, ut(-this.y));
  }
  double() {
    return En.fromAffine(this).double().toAffine();
  }
  add(t) {
    return En.fromAffine(this).add(En.fromAffine(t)).toAffine();
  }
  subtract(t) {
    return this.add(t.negate());
  }
  multiply(t) {
    return En.fromAffine(this).multiply(t, this).toAffine();
  }
  multiplyAndAddUnsafe(t, n, r) {
    const i = En.fromAffine(this), o = n === gn || n === rr || this !== hr.BASE ? i.multiplyUnsafe(n) : i.multiply(n), a = En.fromAffine(t).multiplyUnsafe(r), s = o.add(a);
    return s.equals(En.ZERO) ? void 0 : s.toAffine();
  }
}
hr.BASE = new hr(kr.Gx, kr.Gy);
hr.ZERO = new hr(gn, gn);
function G2(e) {
  return Number.parseInt(e[0], 16) >= 8 ? "00" + e : e;
}
function Y2(e) {
  if (e.length < 2 || e[0] !== 2)
    throw new Error(`Invalid signature integer tag: ${hl(e)}`);
  const t = e[1], n = e.subarray(2, t + 2);
  if (!t || n.length !== t)
    throw new Error("Invalid signature integer: wrong length");
  if (n[0] === 0 && n[1] <= 127)
    throw new Error("Invalid signature integer: trailing length");
  return { data: js(n), left: e.subarray(t + 2) };
}
function IH(e) {
  if (e.length < 2 || e[0] != 48)
    throw new Error(`Invalid signature tag: ${hl(e)}`);
  if (e[1] !== e.length - 2)
    throw new Error("Invalid signature: incorrect length");
  const { data: t, left: n } = Y2(e.subarray(2)), { data: r, left: i } = Y2(n);
  if (i.length)
    throw new Error(`Invalid signature: left bytes after parsing: ${hl(i)}`);
  return { r: t, s: r };
}
class Ns {
  constructor(t, n) {
    this.r = t, this.s = n, this.assertValidity();
  }
  static fromCompact(t) {
    const n = t instanceof Uint8Array, r = "Signature.fromCompact";
    if (typeof t != "string" && !n)
      throw new TypeError(`${r}: Expected string or Uint8Array`);
    const i = n ? hl(t) : t;
    if (i.length !== 128)
      throw new Error(`${r}: Expected 64-byte hex`);
    return new Ns(Wb(i.slice(0, 64)), Wb(i.slice(64, 128)));
  }
  static fromDER(t) {
    const n = t instanceof Uint8Array;
    if (typeof t != "string" && !n)
      throw new TypeError("Signature.fromDER: Expected string or Uint8Array");
    const { r, s: i } = IH(n ? t : Ac(t));
    return new Ns(r, i);
  }
  static fromHex(t) {
    return this.fromDER(t);
  }
  assertValidity() {
    const { r: t, s: n } = this;
    if (!id(t))
      throw new Error("Invalid Signature: r must be 0 < r < n");
    if (!id(n))
      throw new Error("Invalid Signature: s must be 0 < s < n");
  }
  hasHighS() {
    const t = kr.n >> rr;
    return this.s > t;
  }
  normalizeS() {
    return this.hasHighS() ? new Ns(this.r, ut(-this.s, kr.n)) : this;
  }
  toDERRawBytes() {
    return Ac(this.toDERHex());
  }
  toDERHex() {
    const t = G2(lf(this.s)), n = G2(lf(this.r)), r = t.length / 2, i = n.length / 2, o = lf(r), a = lf(i);
    return `30${lf(i + r + 4)}02${a}${n}02${o}${t}`;
  }
  toRawBytes() {
    return this.toDERRawBytes();
  }
  toHex() {
    return this.toDERHex();
  }
  toCompactRawBytes() {
    return Ac(this.toCompactHex());
  }
  toCompactHex() {
    return Hu(this.r) + Hu(this.s);
  }
}
function ks(...e) {
  if (!e.every((r) => r instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (e.length === 1)
    return e[0];
  const t = e.reduce((r, i) => r + i.length, 0), n = new Uint8Array(t);
  for (let r = 0, i = 0; r < e.length; r++) {
    const o = e[r];
    n.set(o, i), i += o.length;
  }
  return n;
}
const kH = Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function hl(e) {
  if (!(e instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += kH[e[n]];
  return t;
}
const TH = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
function Hu(e) {
  if (typeof e != "bigint")
    throw new Error("Expected bigint");
  if (!(gn <= e && e < TH))
    throw new Error("Expected number 0 <= n < 2^256");
  return e.toString(16).padStart(64, "0");
}
function uA(e) {
  const t = Ac(Hu(e));
  if (t.length !== 32)
    throw new Error("Error: expected 32 bytes");
  return t;
}
function lf(e) {
  const t = e.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function Wb(e) {
  if (typeof e != "string")
    throw new TypeError("hexToNumber: expected string, got " + typeof e);
  return BigInt(`0x${e}`);
}
function Ac(e) {
  if (typeof e != "string")
    throw new TypeError("hexToBytes: expected string, got " + typeof e);
  if (e.length % 2)
    throw new Error("hexToBytes: received invalid unpadded hex" + e.length);
  const t = new Uint8Array(e.length / 2);
  for (let n = 0; n < t.length; n++) {
    const r = n * 2, i = e.slice(r, r + 2), o = Number.parseInt(i, 16);
    if (Number.isNaN(o) || o < 0)
      throw new Error("Invalid byte sequence");
    t[n] = o;
  }
  return t;
}
function js(e) {
  return Wb(hl(e));
}
function rd(e) {
  return e instanceof Uint8Array ? Uint8Array.from(e) : Ac(e);
}
function Z2(e) {
  if (typeof e == "number" && Number.isSafeInteger(e) && e > 0)
    return BigInt(e);
  if (typeof e == "bigint" && id(e))
    return e;
  throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
}
function ut(e, t = kr.P) {
  const n = e % t;
  return n >= gn ? n : t + n;
}
function Ji(e, t) {
  const { P: n } = kr;
  let r = e;
  for (; t-- > gn; )
    r *= r, r %= n;
  return r;
}
function xH(e) {
  const { P: t } = kr, n = BigInt(6), r = BigInt(11), i = BigInt(22), o = BigInt(23), a = BigInt(44), s = BigInt(88), c = e * e * e % t, l = c * c * e % t, u = Ji(l, Wf) * l % t, f = Ji(u, Wf) * l % t, d = Ji(f, Os) * c % t, h = Ji(d, r) * d % t, g = Ji(h, i) * h % t, w = Ji(g, a) * g % t, b = Ji(w, s) * w % t, I = Ji(b, a) * g % t, A = Ji(I, Wf) * l % t, x = Ji(A, o) * h % t, N = Ji(x, n) * c % t, j = Ji(N, Os);
  if (j * j % t !== e)
    throw new Error("Cannot find square root");
  return j;
}
function Ud(e, t = kr.P) {
  if (e === gn || t <= gn)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let n = ut(e, t), r = t, i = gn, o = rr;
  for (; n !== gn; ) {
    const s = r / n, c = r % n, l = i - o * s;
    r = n, n = c, i = o, o = l;
  }
  if (r !== rr)
    throw new Error("invert: does not exist");
  return ut(i, t);
}
function MH(e, t = kr.P) {
  const n = new Array(e.length), r = e.reduce((o, a, s) => a === gn ? o : (n[s] = o, ut(o * a, t)), rr), i = Ud(r, t);
  return e.reduceRight((o, a, s) => a === gn ? o : (n[s] = ut(o * n[s], t), ut(o * a, t)), i), n;
}
function OH(e) {
  const t = e.length * 8 - dl * 8, n = js(e);
  return t > 0 ? n >> BigInt(t) : n;
}
function lR(e, t = !1) {
  const n = OH(e);
  if (t)
    return n;
  const { n: r } = kr;
  return n >= r ? n - r : n;
}
let Gu, Kf;
class PH {
  constructor(t, n) {
    if (this.hashLen = t, this.qByteLen = n, typeof t != "number" || t < 2)
      throw new Error("hashLen must be a number");
    if (typeof n != "number" || n < 2)
      throw new Error("qByteLen must be a number");
    this.v = new Uint8Array(t).fill(1), this.k = new Uint8Array(t).fill(0), this.counter = 0;
  }
  hmac(...t) {
    return Ua.hmacSha256(this.k, ...t);
  }
  hmacSync(...t) {
    return Kf(this.k, ...t);
  }
  checkSync() {
    if (typeof Kf != "function")
      throw new uR("hmacSha256Sync needs to be set");
  }
  incr() {
    if (this.counter >= 1e3)
      throw new Error("Tried 1,000 k values for sign(), all were invalid");
    this.counter += 1;
  }
  async reseed(t = new Uint8Array()) {
    this.k = await this.hmac(this.v, Uint8Array.from([0]), t), this.v = await this.hmac(this.v), t.length !== 0 && (this.k = await this.hmac(this.v, Uint8Array.from([1]), t), this.v = await this.hmac(this.v));
  }
  reseedSync(t = new Uint8Array()) {
    this.checkSync(), this.k = this.hmacSync(this.v, Uint8Array.from([0]), t), this.v = this.hmacSync(this.v), t.length !== 0 && (this.k = this.hmacSync(this.v, Uint8Array.from([1]), t), this.v = this.hmacSync(this.v));
  }
  async generate() {
    this.incr();
    let t = 0;
    const n = [];
    for (; t < this.qByteLen; ) {
      this.v = await this.hmac(this.v);
      const r = this.v.slice();
      n.push(r), t += this.v.length;
    }
    return ks(...n);
  }
  generateSync() {
    this.checkSync(), this.incr();
    let t = 0;
    const n = [];
    for (; t < this.qByteLen; ) {
      this.v = this.hmacSync(this.v);
      const r = this.v.slice();
      n.push(r), t += this.v.length;
    }
    return ks(...n);
  }
}
function id(e) {
  return gn < e && e < kr.n;
}
function t1(e) {
  return gn < e && e < kr.P;
}
function BH(e, t, n, r = !0) {
  const { n: i } = kr, o = lR(e, !0);
  if (!id(o))
    return;
  const a = Ud(o, i), s = hr.BASE.multiply(o), c = ut(s.x, i);
  if (c === gn)
    return;
  const l = ut(a * ut(t + n * c, i), i);
  if (l === gn)
    return;
  let u = new Ns(c, l), f = (s.x === u.r ? 0 : 2) | Number(s.y & rr);
  return r && u.hasHighS() && (u = u.normalizeS(), f ^= 1), { sig: u, recovery: f };
}
function Kb(e) {
  let t;
  if (typeof e == "bigint")
    t = e;
  else if (typeof e == "number" && Number.isSafeInteger(e) && e > 0)
    t = BigInt(e);
  else if (typeof e == "string") {
    if (e.length !== 2 * dl)
      throw new Error("Expected 32 bytes of private key");
    t = Wb(e);
  } else if (e instanceof Uint8Array) {
    if (e.length !== dl)
      throw new Error("Expected 32 bytes of private key");
    t = js(e);
  } else
    throw new TypeError("Expected valid private key");
  if (!id(t))
    throw new Error("Expected private key: 0 < key < n");
  return t;
}
function CH(e) {
  if (e instanceof Ns)
    return e.assertValidity(), e;
  try {
    return Ns.fromDER(e);
  } catch {
    return Ns.fromCompact(e);
  }
}
function DH(e, t = !1) {
  return hr.fromPrivateKey(e).toRawBytes(t);
}
function fR(e) {
  const t = e.length > To ? e.slice(0, To) : e;
  return js(t);
}
function RH(e) {
  const t = fR(e), n = ut(t, kr.n);
  return dR(n < gn ? t : n);
}
function dR(e) {
  return uA(e);
}
function NH(e, t, n) {
  if (e == null)
    throw new Error(`sign: expected valid message hash, not "${e}"`);
  const r = rd(e), i = Kb(t), o = [dR(i), RH(r)];
  if (n != null) {
    n === !0 && (n = Ua.randomBytes(To));
    const c = rd(n);
    if (c.length !== To)
      throw new Error(`sign: Expected ${To} bytes of extra data`);
    o.push(c);
  }
  const a = ks(...o), s = fR(r);
  return { seed: a, m: s, d: i };
}
function jH(e, t) {
  const { sig: n, recovery: r } = e, { der: i, recovered: o } = Object.assign({ canonical: !0, der: !0 }, t), a = i ? n.toDERRawBytes() : n.toCompactRawBytes();
  return o ? [a, r] : a;
}
function UH(e, t, n = {}) {
  const { seed: r, m: i, d: o } = NH(e, t, n.extraEntropy), a = new PH(AH, dl);
  a.reseedSync(r);
  let s;
  for (; !(s = BH(a.generateSync(), i, o, n.canonical)); )
    a.reseedSync();
  return jH(s, n);
}
hr.BASE._setWindowSize(8);
const Oi = {
  node: CI,
  web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
}, vg = {}, Ua = {
  bytesToHex: hl,
  hexToBytes: Ac,
  concatBytes: ks,
  mod: ut,
  invert: Ud,
  isValidPrivateKey(e) {
    try {
      return Kb(e), !0;
    } catch {
      return !1;
    }
  },
  _bigintTo32Bytes: uA,
  _normalizePrivateKey: Kb,
  hashToPrivateKey: (e) => {
    e = rd(e);
    const t = dl + 8;
    if (e.length < t || e.length > 1024)
      throw new Error("Expected valid bytes of private key as per FIPS 186");
    const n = ut(js(e), kr.n - rr) + rr;
    return uA(n);
  },
  randomBytes: (e = 32) => {
    if (Oi.web)
      return Oi.web.getRandomValues(new Uint8Array(e));
    if (Oi.node) {
      const { randomBytes: t } = Oi.node;
      return Uint8Array.from(t(e));
    } else
      throw new Error("The environment doesn't have randomBytes function");
  },
  randomPrivateKey: () => Ua.hashToPrivateKey(Ua.randomBytes(dl + 8)),
  precompute(e = 8, t = hr.BASE) {
    const n = t === hr.BASE ? t : new hr(t.x, t.y);
    return n._setWindowSize(e), n.multiply(Wf), n;
  },
  sha256: async (...e) => {
    if (Oi.web) {
      const t = await Oi.web.subtle.digest("SHA-256", ks(...e));
      return new Uint8Array(t);
    } else if (Oi.node) {
      const { createHash: t } = Oi.node, n = t("sha256");
      return e.forEach((r) => n.update(r)), Uint8Array.from(n.digest());
    } else
      throw new Error("The environment doesn't have sha256 function");
  },
  hmacSha256: async (e, ...t) => {
    if (Oi.web) {
      const n = await Oi.web.subtle.importKey("raw", e, { name: "HMAC", hash: { name: "SHA-256" } }, !1, ["sign"]), r = ks(...t), i = await Oi.web.subtle.sign("HMAC", n, r);
      return new Uint8Array(i);
    } else if (Oi.node) {
      const { createHmac: n } = Oi.node, r = n("sha256", e);
      return t.forEach((i) => r.update(i)), Uint8Array.from(r.digest());
    } else
      throw new Error("The environment doesn't have hmac-sha256 function");
  },
  sha256Sync: void 0,
  hmacSha256Sync: void 0,
  taggedHash: async (e, ...t) => {
    let n = vg[e];
    if (n === void 0) {
      const r = await Ua.sha256(Uint8Array.from(e, (i) => i.charCodeAt(0)));
      n = ks(r, r), vg[e] = n;
    }
    return Ua.sha256(n, ...t);
  },
  taggedHashSync: (e, ...t) => {
    if (typeof Gu != "function")
      throw new uR("sha256Sync is undefined, you need to set it");
    let n = vg[e];
    if (n === void 0) {
      const r = Gu(Uint8Array.from(e, (i) => i.charCodeAt(0)));
      n = ks(r, r), vg[e] = n;
    }
    return Gu(n, ...t);
  },
  _JacobianPoint: En
};
Object.defineProperties(Ua, {
  sha256Sync: {
    configurable: !1,
    get() {
      return Gu;
    },
    set(e) {
      Gu || (Gu = e);
    }
  },
  hmacSha256Sync: {
    configurable: !1,
    get() {
      return Kf;
    },
    set(e) {
      Kf || (Kf = e);
    }
  }
});
Pc.sha512Sync = (...e) => XV(Pc.concatBytes(...e));
const zH = Pc.randomPrivateKey, J2 = () => {
  const e = Pc.randomPrivateKey(), t = Vb(e), n = new Uint8Array(64);
  return n.set(e), n.set(t, 32), {
    publicKey: t,
    secretKey: n
  };
}, Vb = hk.getPublicKey;
function X2(e) {
  try {
    return Pr.fromHex(
      e,
      !0
      /* strict */
    ), !0;
  } catch {
    return !1;
  }
}
const Ik = (e, t) => hk.sign(e, t.slice(0, 32)), FH = hk.verify, qt = (e) => it.Buffer.isBuffer(e) ? e : e instanceof Uint8Array ? it.Buffer.from(e.buffer, e.byteOffset, e.byteLength) : it.Buffer.from(e);
let kk = class {
  constructor(t) {
    Object.assign(this, t);
  }
  encode() {
    return it.Buffer.from(V3(Vf, this));
  }
  static decode(t) {
    return q3(Vf, this, t);
  }
  static decodeUnchecked(t) {
    return F3(Vf, this, t);
  }
};
class LH extends kk {
  constructor(t) {
    if (super(t), this.enum = "", Object.keys(t).length !== 1)
      throw new Error("Enum can only take single value");
    Object.keys(t).map((n) => {
      this.enum = n;
    });
  }
}
const Vf = /* @__PURE__ */ new Map();
let hR;
const pR = 32, $i = 32;
function $H(e) {
  return e._bn !== void 0;
}
let Q2 = 1;
hR = Symbol.toStringTag;
class Ae extends kk {
  /** @internal */
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(t) {
    if (super({}), this._bn = void 0, $H(t))
      this._bn = t._bn;
    else {
      if (typeof t == "string") {
        const n = Er.decode(t);
        if (n.length != $i)
          throw new Error("Invalid public key input");
        this._bn = new il(n);
      } else
        this._bn = new il(t);
      if (this._bn.byteLength() > $i)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */
  static unique() {
    const t = new Ae(Q2);
    return Q2 += 1, new Ae(t.toBuffer());
  }
  /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(t) {
    return this._bn.eq(t._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return Er.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const t = this.toBuffer();
    return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  }
  /**
   * Return the Buffer representation of the public key in big endian
   */
  toBuffer() {
    const t = this._bn.toArrayLike(it.Buffer);
    if (t.length === $i)
      return t;
    const n = it.Buffer.alloc(32);
    return t.copy(n, 32 - t.length), n;
  }
  get [hR]() {
    return `PublicKey(${this.toString()})`;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(t, n, r) {
    const i = it.Buffer.concat([t.toBuffer(), it.Buffer.from(n), r.toBuffer()]), o = aA(i);
    return new Ae(o);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(t, n) {
    let r = it.Buffer.alloc(0);
    t.forEach(function(o) {
      if (o.length > pR)
        throw new TypeError("Max seed length exceeded");
      r = it.Buffer.concat([r, qt(o)]);
    }), r = it.Buffer.concat([r, n.toBuffer(), it.Buffer.from("ProgramDerivedAddress")]);
    const i = aA(r);
    if (X2(i))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new Ae(i);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */
  /* eslint-disable require-await */
  static async createProgramAddress(t, n) {
    return this.createProgramAddressSync(t, n);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(t, n) {
    let r = 255, i;
    for (; r != 0; ) {
      try {
        const o = t.concat(it.Buffer.from([r]));
        i = this.createProgramAddressSync(o, n);
      } catch (o) {
        if (o instanceof TypeError)
          throw o;
        r--;
        continue;
      }
      return [i, r];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */
  static async findProgramAddress(t, n) {
    return this.findProgramAddressSync(t, n);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(t) {
    const n = new Ae(t);
    return X2(n.toBytes());
  }
}
Ae.default = new Ae("11111111111111111111111111111111");
Vf.set(Ae, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
class WH {
  /** @internal */
  /** @internal */
  /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */
  constructor(t) {
    if (this._publicKey = void 0, this._secretKey = void 0, t) {
      const n = qt(t);
      if (t.length !== 64)
        throw new Error("bad secret key size");
      this._publicKey = n.slice(32, 64), this._secretKey = n.slice(0, 32);
    } else
      this._secretKey = qt(zH()), this._publicKey = qt(Vb(this._secretKey));
  }
  /**
   * The public key for this account
   */
  get publicKey() {
    return new Ae(this._publicKey);
  }
  /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */
  get secretKey() {
    return it.Buffer.concat([this._secretKey, this._publicKey], 64);
  }
}
const KH = new Ae("BPFLoader1111111111111111111111111111111111"), Us = 1280 - 40 - 8, a_ = 127, pl = 64;
class Tk extends Error {
  constructor(t) {
    super(`Signature ${t} has expired: block height exceeded.`), this.signature = void 0, this.signature = t;
  }
}
Object.defineProperty(Tk.prototype, "name", {
  value: "TransactionExpiredBlockheightExceededError"
});
class xk extends Error {
  constructor(t, n) {
    super(`Transaction was not confirmed in ${n.toFixed(2)} seconds. It is unknown if it succeeded or failed. Check signature ${t} using the Solana Explorer or CLI tools.`), this.signature = void 0, this.signature = t;
  }
}
Object.defineProperty(xk.prototype, "name", {
  value: "TransactionExpiredTimeoutError"
});
class Ru extends Error {
  constructor(t) {
    super(`Signature ${t} has expired: the nonce is no longer valid.`), this.signature = void 0, this.signature = t;
  }
}
Object.defineProperty(Ru.prototype, "name", {
  value: "TransactionExpiredNonceInvalidError"
});
class od {
  constructor(t, n) {
    this.staticAccountKeys = void 0, this.accountKeysFromLookups = void 0, this.staticAccountKeys = t, this.accountKeysFromLookups = n;
  }
  keySegments() {
    const t = [this.staticAccountKeys];
    return this.accountKeysFromLookups && (t.push(this.accountKeysFromLookups.writable), t.push(this.accountKeysFromLookups.readonly)), t;
  }
  get(t) {
    for (const n of this.keySegments()) {
      if (t < n.length)
        return n[t];
      t -= n.length;
    }
  }
  get length() {
    return this.keySegments().flat().length;
  }
  compileInstructions(t) {
    if (this.length > 255 + 1)
      throw new Error("Account index overflow encountered during compilation");
    const r = /* @__PURE__ */ new Map();
    this.keySegments().flat().forEach((o, a) => {
      r.set(o.toBase58(), a);
    });
    const i = (o) => {
      const a = r.get(o.toBase58());
      if (a === void 0)
        throw new Error("Encountered an unknown instruction account key during compilation");
      return a;
    };
    return t.map((o) => ({
      programIdIndex: i(o.programId),
      accountKeyIndexes: o.keys.map((a) => i(a.pubkey)),
      data: o.data
    }));
  }
}
const Qt = (e = "publicKey") => Nn(32, e), VH = (e = "signature") => Nn(64, e), bc = (e = "string") => {
  const t = ht([ft("length"), ft("lengthPadding"), Nn(Ds(ft(), -8), "chars")], e), n = t.decode.bind(t), r = t.encode.bind(t), i = t;
  return i.decode = (o, a) => n(o, a).chars.toString(), i.encode = (o, a, s) => {
    const c = {
      chars: it.Buffer.from(o, "utf8")
    };
    return r(c, a, s);
  }, i.alloc = (o) => ft().span + ft().span + it.Buffer.from(o, "utf8").length, i;
}, qH = (e = "authorized") => ht([Qt("staker"), Qt("withdrawer")], e), HH = (e = "lockup") => ht([Di("unixTimestamp"), Di("epoch"), Qt("custodian")], e), GH = (e = "voteInit") => ht([Qt("nodePubkey"), Qt("authorizedVoter"), Qt("authorizedWithdrawer"), an("commission")], e), YH = (e = "voteAuthorizeWithSeedArgs") => ht([ft("voteAuthorizationType"), Qt("currentAuthorityDerivedKeyOwnerPubkey"), bc("currentAuthorityDerivedKeySeed"), Qt("newAuthorized")], e);
function yR(e, t) {
  const n = (i) => {
    if (i.span >= 0)
      return i.span;
    if (typeof i.alloc == "function")
      return i.alloc(t[i.property]);
    if ("count" in i && "elementLayout" in i) {
      const o = t[i.property];
      if (Array.isArray(o))
        return o.length * n(i.elementLayout);
    } else if ("fields" in i)
      return yR({
        layout: i
      }, t[i.property]);
    return 0;
  };
  let r = 0;
  return e.layout.fields.forEach((i) => {
    r += n(i);
  }), r;
}
function wi(e) {
  let t = 0, n = 0;
  for (; ; ) {
    let r = e.shift();
    if (t |= (r & 127) << n * 7, n += 1, !(r & 128))
      break;
  }
  return t;
}
function Ri(e, t) {
  let n = t;
  for (; ; ) {
    let r = n & 127;
    if (n >>= 7, n == 0) {
      e.push(r);
      break;
    } else
      r |= 128, e.push(r);
  }
}
function _n(e, t) {
  if (!e)
    throw new Error(t || "Assertion failed");
}
class s_ {
  constructor(t, n) {
    this.payer = void 0, this.keyMetaMap = void 0, this.payer = t, this.keyMetaMap = n;
  }
  static compile(t, n) {
    const r = /* @__PURE__ */ new Map(), i = (a) => {
      const s = a.toBase58();
      let c = r.get(s);
      return c === void 0 && (c = {
        isSigner: !1,
        isWritable: !1,
        isInvoked: !1
      }, r.set(s, c)), c;
    }, o = i(n);
    o.isSigner = !0, o.isWritable = !0;
    for (const a of t) {
      i(a.programId).isInvoked = !0;
      for (const s of a.keys) {
        const c = i(s.pubkey);
        c.isSigner || (c.isSigner = s.isSigner), c.isWritable || (c.isWritable = s.isWritable);
      }
    }
    return new s_(n, r);
  }
  getMessageComponents() {
    const t = [...this.keyMetaMap.entries()];
    _n(t.length <= 256, "Max static account keys length exceeded");
    const n = t.filter(([, c]) => c.isSigner && c.isWritable), r = t.filter(([, c]) => c.isSigner && !c.isWritable), i = t.filter(([, c]) => !c.isSigner && c.isWritable), o = t.filter(([, c]) => !c.isSigner && !c.isWritable), a = {
      numRequiredSignatures: n.length + r.length,
      numReadonlySignedAccounts: r.length,
      numReadonlyUnsignedAccounts: o.length
    };
    {
      _n(n.length > 0, "Expected at least one writable signer key");
      const [c] = n[0];
      _n(c === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
    }
    const s = [...n.map(([c]) => new Ae(c)), ...r.map(([c]) => new Ae(c)), ...i.map(([c]) => new Ae(c)), ...o.map(([c]) => new Ae(c))];
    return [a, s];
  }
  extractTableLookup(t) {
    const [n, r] = this.drainKeysFoundInLookupTable(t.state.addresses, (a) => !a.isSigner && !a.isInvoked && a.isWritable), [i, o] = this.drainKeysFoundInLookupTable(t.state.addresses, (a) => !a.isSigner && !a.isInvoked && !a.isWritable);
    if (!(n.length === 0 && i.length === 0))
      return [{
        accountKey: t.key,
        writableIndexes: n,
        readonlyIndexes: i
      }, {
        writable: r,
        readonly: o
      }];
  }
  /** @internal */
  drainKeysFoundInLookupTable(t, n) {
    const r = new Array(), i = new Array();
    for (const [o, a] of this.keyMetaMap.entries())
      if (n(a)) {
        const s = new Ae(o), c = t.findIndex((l) => l.equals(s));
        c >= 0 && (_n(c < 256, "Max lookup table index exceeded"), r.push(c), i.push(s), this.keyMetaMap.delete(o));
      }
    return [r, i];
  }
}
class zo {
  constructor(t) {
    this.header = void 0, this.accountKeys = void 0, this.recentBlockhash = void 0, this.instructions = void 0, this.indexToProgramIds = /* @__PURE__ */ new Map(), this.header = t.header, this.accountKeys = t.accountKeys.map((n) => new Ae(n)), this.recentBlockhash = t.recentBlockhash, this.instructions = t.instructions, this.instructions.forEach((n) => this.indexToProgramIds.set(n.programIdIndex, this.accountKeys[n.programIdIndex]));
  }
  get version() {
    return "legacy";
  }
  get staticAccountKeys() {
    return this.accountKeys;
  }
  get compiledInstructions() {
    return this.instructions.map((t) => ({
      programIdIndex: t.programIdIndex,
      accountKeyIndexes: t.accounts,
      data: Er.decode(t.data)
    }));
  }
  get addressTableLookups() {
    return [];
  }
  getAccountKeys() {
    return new od(this.staticAccountKeys);
  }
  static compile(t) {
    const n = s_.compile(t.instructions, t.payerKey), [r, i] = n.getMessageComponents(), a = new od(i).compileInstructions(t.instructions).map((s) => ({
      programIdIndex: s.programIdIndex,
      accounts: s.accountKeyIndexes,
      data: Er.encode(s.data)
    }));
    return new zo({
      header: r,
      accountKeys: i,
      recentBlockhash: t.recentBlockhash,
      instructions: a
    });
  }
  isAccountSigner(t) {
    return t < this.header.numRequiredSignatures;
  }
  isAccountWritable(t) {
    const n = this.header.numRequiredSignatures;
    if (t >= this.header.numRequiredSignatures) {
      const r = t - n, o = this.accountKeys.length - n - this.header.numReadonlyUnsignedAccounts;
      return r < o;
    } else {
      const r = n - this.header.numReadonlySignedAccounts;
      return t < r;
    }
  }
  isProgramId(t) {
    return this.indexToProgramIds.has(t);
  }
  programIds() {
    return [...this.indexToProgramIds.values()];
  }
  nonProgramIds() {
    return this.accountKeys.filter((t, n) => !this.isProgramId(n));
  }
  serialize() {
    const t = this.accountKeys.length;
    let n = [];
    Ri(n, t);
    const r = this.instructions.map((f) => {
      const {
        accounts: d,
        programIdIndex: h
      } = f, g = Array.from(Er.decode(f.data));
      let w = [];
      Ri(w, d.length);
      let b = [];
      return Ri(b, g.length), {
        programIdIndex: h,
        keyIndicesCount: it.Buffer.from(w),
        keyIndices: d,
        dataLength: it.Buffer.from(b),
        data: g
      };
    });
    let i = [];
    Ri(i, r.length);
    let o = it.Buffer.alloc(Us);
    it.Buffer.from(i).copy(o);
    let a = i.length;
    r.forEach((f) => {
      const h = ht([an("programIdIndex"), Nn(f.keyIndicesCount.length, "keyIndicesCount"), Yr(an("keyIndex"), f.keyIndices.length, "keyIndices"), Nn(f.dataLength.length, "dataLength"), Yr(an("userdatum"), f.data.length, "data")]).encode(f, o, a);
      a += h;
    }), o = o.slice(0, a);
    const s = ht([Nn(1, "numRequiredSignatures"), Nn(1, "numReadonlySignedAccounts"), Nn(1, "numReadonlyUnsignedAccounts"), Nn(n.length, "keyCount"), Yr(Qt("key"), t, "keys"), Qt("recentBlockhash")]), c = {
      numRequiredSignatures: it.Buffer.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: it.Buffer.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: it.Buffer.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: it.Buffer.from(n),
      keys: this.accountKeys.map((f) => qt(f.toBytes())),
      recentBlockhash: Er.decode(this.recentBlockhash)
    };
    let l = it.Buffer.alloc(2048);
    const u = s.encode(c, l);
    return o.copy(l, u), l.slice(0, u + o.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(t) {
    let n = [...t];
    const r = n.shift();
    if (r !== (r & a_))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const i = n.shift(), o = n.shift(), a = wi(n);
    let s = [];
    for (let d = 0; d < a; d++) {
      const h = n.slice(0, $i);
      n = n.slice($i), s.push(new Ae(it.Buffer.from(h)));
    }
    const c = n.slice(0, $i);
    n = n.slice($i);
    const l = wi(n);
    let u = [];
    for (let d = 0; d < l; d++) {
      const h = n.shift(), g = wi(n), w = n.slice(0, g);
      n = n.slice(g);
      const b = wi(n), I = n.slice(0, b), A = Er.encode(it.Buffer.from(I));
      n = n.slice(b), u.push({
        programIdIndex: h,
        accounts: w,
        data: A
      });
    }
    const f = {
      header: {
        numRequiredSignatures: r,
        numReadonlySignedAccounts: i,
        numReadonlyUnsignedAccounts: o
      },
      recentBlockhash: Er.encode(it.Buffer.from(c)),
      accountKeys: s,
      instructions: u
    };
    return new zo(f);
  }
}
class Bc {
  constructor(t) {
    this.header = void 0, this.staticAccountKeys = void 0, this.recentBlockhash = void 0, this.compiledInstructions = void 0, this.addressTableLookups = void 0, this.header = t.header, this.staticAccountKeys = t.staticAccountKeys, this.recentBlockhash = t.recentBlockhash, this.compiledInstructions = t.compiledInstructions, this.addressTableLookups = t.addressTableLookups;
  }
  get version() {
    return 0;
  }
  get numAccountKeysFromLookups() {
    let t = 0;
    for (const n of this.addressTableLookups)
      t += n.readonlyIndexes.length + n.writableIndexes.length;
    return t;
  }
  getAccountKeys(t) {
    let n;
    if (t && "accountKeysFromLookups" in t && t.accountKeysFromLookups) {
      if (this.numAccountKeysFromLookups != t.accountKeysFromLookups.writable.length + t.accountKeysFromLookups.readonly.length)
        throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
      n = t.accountKeysFromLookups;
    } else if (t && "addressLookupTableAccounts" in t && t.addressLookupTableAccounts)
      n = this.resolveAddressTableLookups(t.addressLookupTableAccounts);
    else if (this.addressTableLookups.length > 0)
      throw new Error("Failed to get account keys because address table lookups were not resolved");
    return new od(this.staticAccountKeys, n);
  }
  isAccountSigner(t) {
    return t < this.header.numRequiredSignatures;
  }
  isAccountWritable(t) {
    const n = this.header.numRequiredSignatures, r = this.staticAccountKeys.length;
    if (t >= r) {
      const i = t - r, o = this.addressTableLookups.reduce((a, s) => a + s.writableIndexes.length, 0);
      return i < o;
    } else if (t >= this.header.numRequiredSignatures) {
      const i = t - n, a = r - n - this.header.numReadonlyUnsignedAccounts;
      return i < a;
    } else {
      const i = n - this.header.numReadonlySignedAccounts;
      return t < i;
    }
  }
  resolveAddressTableLookups(t) {
    const n = {
      writable: [],
      readonly: []
    };
    for (const r of this.addressTableLookups) {
      const i = t.find((o) => o.key.equals(r.accountKey));
      if (!i)
        throw new Error(`Failed to find address lookup table account for table key ${r.accountKey.toBase58()}`);
      for (const o of r.writableIndexes)
        if (o < i.state.addresses.length)
          n.writable.push(i.state.addresses[o]);
        else
          throw new Error(`Failed to find address for index ${o} in address lookup table ${r.accountKey.toBase58()}`);
      for (const o of r.readonlyIndexes)
        if (o < i.state.addresses.length)
          n.readonly.push(i.state.addresses[o]);
        else
          throw new Error(`Failed to find address for index ${o} in address lookup table ${r.accountKey.toBase58()}`);
    }
    return n;
  }
  static compile(t) {
    const n = s_.compile(t.instructions, t.payerKey), r = new Array(), i = {
      writable: new Array(),
      readonly: new Array()
    }, o = t.addressLookupTableAccounts || [];
    for (const u of o) {
      const f = n.extractTableLookup(u);
      if (f !== void 0) {
        const [d, {
          writable: h,
          readonly: g
        }] = f;
        r.push(d), i.writable.push(...h), i.readonly.push(...g);
      }
    }
    const [a, s] = n.getMessageComponents(), l = new od(s, i).compileInstructions(t.instructions);
    return new Bc({
      header: a,
      staticAccountKeys: s,
      recentBlockhash: t.recentBlockhash,
      compiledInstructions: l,
      addressTableLookups: r
    });
  }
  serialize() {
    const t = Array();
    Ri(t, this.staticAccountKeys.length);
    const n = this.serializeInstructions(), r = Array();
    Ri(r, this.compiledInstructions.length);
    const i = this.serializeAddressTableLookups(), o = Array();
    Ri(o, this.addressTableLookups.length);
    const a = ht([an("prefix"), ht([an("numRequiredSignatures"), an("numReadonlySignedAccounts"), an("numReadonlyUnsignedAccounts")], "header"), Nn(t.length, "staticAccountKeysLength"), Yr(Qt(), this.staticAccountKeys.length, "staticAccountKeys"), Qt("recentBlockhash"), Nn(r.length, "instructionsLength"), Nn(n.length, "serializedInstructions"), Nn(o.length, "addressTableLookupsLength"), Nn(i.length, "serializedAddressTableLookups")]), s = new Uint8Array(Us), c = 128, l = a.encode({
      prefix: c,
      header: this.header,
      staticAccountKeysLength: new Uint8Array(t),
      staticAccountKeys: this.staticAccountKeys.map((u) => u.toBytes()),
      recentBlockhash: Er.decode(this.recentBlockhash),
      instructionsLength: new Uint8Array(r),
      serializedInstructions: n,
      addressTableLookupsLength: new Uint8Array(o),
      serializedAddressTableLookups: i
    }, s);
    return s.slice(0, l);
  }
  serializeInstructions() {
    let t = 0;
    const n = new Uint8Array(Us);
    for (const r of this.compiledInstructions) {
      const i = Array();
      Ri(i, r.accountKeyIndexes.length);
      const o = Array();
      Ri(o, r.data.length);
      const a = ht([an("programIdIndex"), Nn(i.length, "encodedAccountKeyIndexesLength"), Yr(an(), r.accountKeyIndexes.length, "accountKeyIndexes"), Nn(o.length, "encodedDataLength"), Nn(r.data.length, "data")]);
      t += a.encode({
        programIdIndex: r.programIdIndex,
        encodedAccountKeyIndexesLength: new Uint8Array(i),
        accountKeyIndexes: r.accountKeyIndexes,
        encodedDataLength: new Uint8Array(o),
        data: r.data
      }, n, t);
    }
    return n.slice(0, t);
  }
  serializeAddressTableLookups() {
    let t = 0;
    const n = new Uint8Array(Us);
    for (const r of this.addressTableLookups) {
      const i = Array();
      Ri(i, r.writableIndexes.length);
      const o = Array();
      Ri(o, r.readonlyIndexes.length);
      const a = ht([Qt("accountKey"), Nn(i.length, "encodedWritableIndexesLength"), Yr(an(), r.writableIndexes.length, "writableIndexes"), Nn(o.length, "encodedReadonlyIndexesLength"), Yr(an(), r.readonlyIndexes.length, "readonlyIndexes")]);
      t += a.encode({
        accountKey: r.accountKey.toBytes(),
        encodedWritableIndexesLength: new Uint8Array(i),
        writableIndexes: r.writableIndexes,
        encodedReadonlyIndexesLength: new Uint8Array(o),
        readonlyIndexes: r.readonlyIndexes
      }, n, t);
    }
    return n.slice(0, t);
  }
  static deserialize(t) {
    let n = [...t];
    const r = n.shift(), i = r & a_;
    _n(r !== i, "Expected versioned message but received legacy message");
    const o = i;
    _n(o === 0, `Expected versioned message with version 0 but found version ${o}`);
    const a = {
      numRequiredSignatures: n.shift(),
      numReadonlySignedAccounts: n.shift(),
      numReadonlyUnsignedAccounts: n.shift()
    }, s = [], c = wi(n);
    for (let g = 0; g < c; g++)
      s.push(new Ae(n.splice(0, $i)));
    const l = Er.encode(n.splice(0, $i)), u = wi(n), f = [];
    for (let g = 0; g < u; g++) {
      const w = n.shift(), b = wi(n), I = n.splice(0, b), A = wi(n), x = new Uint8Array(n.splice(0, A));
      f.push({
        programIdIndex: w,
        accountKeyIndexes: I,
        data: x
      });
    }
    const d = wi(n), h = [];
    for (let g = 0; g < d; g++) {
      const w = new Ae(n.splice(0, $i)), b = wi(n), I = n.splice(0, b), A = wi(n), x = n.splice(0, A);
      h.push({
        accountKey: w,
        writableIndexes: I,
        readonlyIndexes: x
      });
    }
    return new Bc({
      header: a,
      staticAccountKeys: s,
      recentBlockhash: l,
      compiledInstructions: f,
      addressTableLookups: h
    });
  }
}
const Mk = {
  deserializeMessageVersion(e) {
    const t = e[0], n = t & a_;
    return n === t ? "legacy" : n;
  },
  deserialize: (e) => {
    const t = Mk.deserializeMessageVersion(e);
    if (t === "legacy")
      return zo.from(e);
    if (t === 0)
      return Bc.deserialize(e);
    throw new Error(`Transaction message version ${t} deserialization is not supported`);
  }
};
let Eo;
(function(e) {
  e[e.BLOCKHEIGHT_EXCEEDED = 0] = "BLOCKHEIGHT_EXCEEDED", e[e.PROCESSED = 1] = "PROCESSED", e[e.TIMED_OUT = 2] = "TIMED_OUT", e[e.NONCE_INVALID = 3] = "NONCE_INVALID";
})(Eo || (Eo = {}));
const ZH = it.Buffer.alloc(pl).fill(0);
class jn {
  /**
   * Public keys to include in this transaction
   * Boolean represents whether this pubkey needs to sign the transaction
   */
  /**
   * Program Id to execute
   */
  /**
   * Program input
   */
  constructor(t) {
    this.keys = void 0, this.programId = void 0, this.data = it.Buffer.alloc(0), this.programId = t.programId, this.keys = t.keys, t.data && (this.data = t.data);
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      keys: this.keys.map(({
        pubkey: t,
        isSigner: n,
        isWritable: r
      }) => ({
        pubkey: t.toJSON(),
        isSigner: n,
        isWritable: r
      })),
      programId: this.programId.toJSON(),
      data: [...this.data]
    };
  }
}
let On = class lA {
  /**
   * Signatures for the transaction.  Typically created by invoking the
   * `sign()` method
   */
  /**
   * The first (payer) Transaction signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer
   */
  /**
   * Construct an empty Transaction
   */
  constructor(t) {
    if (this.signatures = [], this.feePayer = void 0, this.instructions = [], this.recentBlockhash = void 0, this.lastValidBlockHeight = void 0, this.nonceInfo = void 0, this.minNonceContextSlot = void 0, this._message = void 0, this._json = void 0, !!t)
      if (t.feePayer && (this.feePayer = t.feePayer), t.signatures && (this.signatures = t.signatures), Object.prototype.hasOwnProperty.call(t, "nonceInfo")) {
        const {
          minContextSlot: n,
          nonceInfo: r
        } = t;
        this.minNonceContextSlot = n, this.nonceInfo = r;
      } else if (Object.prototype.hasOwnProperty.call(t, "lastValidBlockHeight")) {
        const {
          blockhash: n,
          lastValidBlockHeight: r
        } = t;
        this.recentBlockhash = n, this.lastValidBlockHeight = r;
      } else {
        const {
          recentBlockhash: n,
          nonceInfo: r
        } = t;
        r && (this.nonceInfo = r), this.recentBlockhash = n;
      }
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      recentBlockhash: this.recentBlockhash || null,
      feePayer: this.feePayer ? this.feePayer.toJSON() : null,
      nonceInfo: this.nonceInfo ? {
        nonce: this.nonceInfo.nonce,
        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
      } : null,
      instructions: this.instructions.map((t) => t.toJSON()),
      signers: this.signatures.map(({
        publicKey: t
      }) => t.toJSON())
    };
  }
  /**
   * Add one or more instructions to this Transaction
   */
  add(...t) {
    if (t.length === 0)
      throw new Error("No instructions");
    return t.forEach((n) => {
      "instructions" in n ? this.instructions = this.instructions.concat(n.instructions) : "data" in n && "programId" in n && "keys" in n ? this.instructions.push(n) : this.instructions.push(new jn(n));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json))
      return this._message;
    let t, n;
    if (this.nonceInfo ? (t = this.nonceInfo.nonce, this.instructions[0] != this.nonceInfo.nonceInstruction ? n = [this.nonceInfo.nonceInstruction, ...this.instructions] : n = this.instructions) : (t = this.recentBlockhash, n = this.instructions), !t)
      throw new Error("Transaction recentBlockhash required");
    n.length < 1 && console.warn("No instructions provided");
    let r;
    if (this.feePayer)
      r = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      r = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    for (let w = 0; w < n.length; w++)
      if (n[w].programId === void 0)
        throw new Error(`Transaction instruction index ${w} has undefined program id`);
    const i = [], o = [];
    n.forEach((w) => {
      w.keys.forEach((I) => {
        o.push({
          ...I
        });
      });
      const b = w.programId.toString();
      i.includes(b) || i.push(b);
    }), i.forEach((w) => {
      o.push({
        pubkey: new Ae(w),
        isSigner: !1,
        isWritable: !1
      });
    });
    const a = [];
    o.forEach((w) => {
      const b = w.pubkey.toString(), I = a.findIndex((A) => A.pubkey.toString() === b);
      I > -1 ? (a[I].isWritable = a[I].isWritable || w.isWritable, a[I].isSigner = a[I].isSigner || w.isSigner) : a.push(w);
    }), a.sort(function(w, b) {
      return w.isSigner !== b.isSigner ? w.isSigner ? -1 : 1 : w.isWritable !== b.isWritable ? w.isWritable ? -1 : 1 : w.pubkey.toBase58().localeCompare(b.pubkey.toBase58());
    });
    const s = a.findIndex((w) => w.pubkey.equals(r));
    if (s > -1) {
      const [w] = a.splice(s, 1);
      w.isSigner = !0, w.isWritable = !0, a.unshift(w);
    } else
      a.unshift({
        pubkey: r,
        isSigner: !0,
        isWritable: !0
      });
    for (const w of this.signatures) {
      const b = a.findIndex((I) => I.pubkey.equals(w.publicKey));
      if (b > -1)
        a[b].isSigner || (a[b].isSigner = !0, console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release."));
      else
        throw new Error(`unknown signer: ${w.publicKey.toString()}`);
    }
    let c = 0, l = 0, u = 0;
    const f = [], d = [];
    a.forEach(({
      pubkey: w,
      isSigner: b,
      isWritable: I
    }) => {
      b ? (f.push(w.toString()), c += 1, I || (l += 1)) : (d.push(w.toString()), I || (u += 1));
    });
    const h = f.concat(d), g = n.map((w) => {
      const {
        data: b,
        programId: I
      } = w;
      return {
        programIdIndex: h.indexOf(I.toString()),
        accounts: w.keys.map((A) => h.indexOf(A.pubkey.toString())),
        data: Er.encode(b)
      };
    });
    return g.forEach((w) => {
      _n(w.programIdIndex >= 0), w.accounts.forEach((b) => _n(b >= 0));
    }), new zo({
      header: {
        numRequiredSignatures: c,
        numReadonlySignedAccounts: l,
        numReadonlyUnsignedAccounts: u
      },
      accountKeys: h,
      recentBlockhash: t,
      instructions: g
    });
  }
  /**
   * @internal
   */
  _compile() {
    const t = this.compileMessage(), n = t.accountKeys.slice(0, t.header.numRequiredSignatures);
    return this.signatures.length === n.length && this.signatures.every((i, o) => n[o].equals(i.publicKey)) || (this.signatures = n.map((r) => ({
      signature: null,
      publicKey: r
    }))), t;
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this._compile().serialize();
  }
  /**
   * Get the estimated fee associated with a transaction
   */
  async getEstimatedFee(t) {
    return (await t.getFeeForMessage(this.compileMessage())).value;
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */
  setSigners(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const n = /* @__PURE__ */ new Set();
    this.signatures = t.filter((r) => {
      const i = r.toString();
      return n.has(i) ? !1 : (n.add(i), !0);
    }).map((r) => ({
      signature: null,
      publicKey: r
    }));
  }
  /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   */
  sign(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const n = /* @__PURE__ */ new Set(), r = [];
    for (const o of t) {
      const a = o.publicKey.toString();
      n.has(a) || (n.add(a), r.push(o));
    }
    this.signatures = r.map((o) => ({
      signature: null,
      publicKey: o.publicKey
    }));
    const i = this._compile();
    this._partialSign(i, ...r);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   */
  partialSign(...t) {
    if (t.length === 0)
      throw new Error("No signers");
    const n = /* @__PURE__ */ new Set(), r = [];
    for (const o of t) {
      const a = o.publicKey.toString();
      n.has(a) || (n.add(a), r.push(o));
    }
    const i = this._compile();
    this._partialSign(i, ...r);
  }
  /**
   * @internal
   */
  _partialSign(t, ...n) {
    const r = t.serialize();
    n.forEach((i) => {
      const o = Ik(r, i.secretKey);
      this._addSignature(i.publicKey, qt(o));
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   */
  addSignature(t, n) {
    this._compile(), this._addSignature(t, n);
  }
  /**
   * @internal
   */
  _addSignature(t, n) {
    _n(n.length === 64);
    const r = this.signatures.findIndex((i) => t.equals(i.publicKey));
    if (r < 0)
      throw new Error(`unknown signer: ${t.toString()}`);
    this.signatures[r].signature = it.Buffer.from(n);
  }
  /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   */
  verifySignatures(t) {
    return this._verifySignatures(this.serializeMessage(), t === void 0 ? !0 : t);
  }
  /**
   * @internal
   */
  _verifySignatures(t, n) {
    for (const {
      signature: r,
      publicKey: i
    } of this.signatures)
      if (r === null) {
        if (n)
          return !1;
      } else if (!FH(r, t, i.toBytes()))
        return !1;
    return !0;
  }
  /**
   * Serialize the Transaction in the wire format.
   */
  serialize(t) {
    const {
      requireAllSignatures: n,
      verifySignatures: r
    } = Object.assign({
      requireAllSignatures: !0,
      verifySignatures: !0
    }, t), i = this.serializeMessage();
    if (r && !this._verifySignatures(i, n))
      throw new Error("Signature verification failed");
    return this._serialize(i);
  }
  /**
   * @internal
   */
  _serialize(t) {
    const {
      signatures: n
    } = this, r = [];
    Ri(r, n.length);
    const i = r.length + n.length * 64 + t.length, o = it.Buffer.alloc(i);
    return _n(n.length < 256), it.Buffer.from(r).copy(o, 0), n.forEach(({
      signature: a
    }, s) => {
      a !== null && (_n(a.length === 64, "signature has invalid length"), it.Buffer.from(a).copy(o, r.length + s * 64));
    }), t.copy(o, r.length + n.length * 64), _n(o.length <= Us, `Transaction too large: ${o.length} > ${Us}`), o;
  }
  /**
   * Deprecated method
   * @internal
   */
  get keys() {
    return _n(this.instructions.length === 1), this.instructions[0].keys.map((t) => t.pubkey);
  }
  /**
   * Deprecated method
   * @internal
   */
  get programId() {
    return _n(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @internal
   */
  get data() {
    return _n(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   */
  static from(t) {
    let n = [...t];
    const r = wi(n);
    let i = [];
    for (let o = 0; o < r; o++) {
      const a = n.slice(0, pl);
      n = n.slice(pl), i.push(Er.encode(it.Buffer.from(a)));
    }
    return lA.populate(zo.from(n), i);
  }
  /**
   * Populate Transaction object from message and signatures
   */
  static populate(t, n = []) {
    const r = new lA();
    return r.recentBlockhash = t.recentBlockhash, t.header.numRequiredSignatures > 0 && (r.feePayer = t.accountKeys[0]), n.forEach((i, o) => {
      const a = {
        signature: i == Er.encode(ZH) ? null : Er.decode(i),
        publicKey: t.accountKeys[o]
      };
      r.signatures.push(a);
    }), t.instructions.forEach((i) => {
      const o = i.accounts.map((a) => {
        const s = t.accountKeys[a];
        return {
          pubkey: s,
          isSigner: r.signatures.some((c) => c.publicKey.toString() === s.toString()) || t.isAccountSigner(a),
          isWritable: t.isAccountWritable(a)
        };
      });
      r.instructions.push(new jn({
        keys: o,
        programId: t.accountKeys[i.programIdIndex],
        data: Er.decode(i.data)
      }));
    }), r._message = t, r._json = r.toJSON(), r;
  }
};
class Ok {
  constructor(t) {
    this.payerKey = void 0, this.instructions = void 0, this.recentBlockhash = void 0, this.payerKey = t.payerKey, this.instructions = t.instructions, this.recentBlockhash = t.recentBlockhash;
  }
  static decompile(t, n) {
    const {
      header: r,
      compiledInstructions: i,
      recentBlockhash: o
    } = t, {
      numRequiredSignatures: a,
      numReadonlySignedAccounts: s,
      numReadonlyUnsignedAccounts: c
    } = r, l = a - s;
    _n(l > 0, "Message header is invalid");
    const u = t.staticAccountKeys.length - a - c;
    _n(u >= 0, "Message header is invalid");
    const f = t.getAccountKeys(n), d = f.get(0);
    if (d === void 0)
      throw new Error("Failed to decompile message because no account keys were found");
    const h = [];
    for (const g of i) {
      const w = [];
      for (const I of g.accountKeyIndexes) {
        const A = f.get(I);
        if (A === void 0)
          throw new Error(`Failed to find key for account key index ${I}`);
        const x = I < a;
        let N;
        x ? N = I < l : I < f.staticAccountKeys.length ? N = I - a < u : N = I - f.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
        f.accountKeysFromLookups.writable.length, w.push({
          pubkey: A,
          isSigner: I < r.numRequiredSignatures,
          isWritable: N
        });
      }
      const b = f.get(g.programIdIndex);
      if (b === void 0)
        throw new Error(`Failed to find program id for program id index ${g.programIdIndex}`);
      h.push(new jn({
        programId: b,
        data: qt(g.data),
        keys: w
      }));
    }
    return new Ok({
      payerKey: d,
      instructions: h,
      recentBlockhash: o
    });
  }
  compileToLegacyMessage() {
    return zo.compile({
      payerKey: this.payerKey,
      recentBlockhash: this.recentBlockhash,
      instructions: this.instructions
    });
  }
  compileToV0Message(t) {
    return Bc.compile({
      payerKey: this.payerKey,
      recentBlockhash: this.recentBlockhash,
      instructions: this.instructions,
      addressLookupTableAccounts: t
    });
  }
}
class Pk {
  get version() {
    return this.message.version;
  }
  constructor(t, n) {
    if (this.signatures = void 0, this.message = void 0, n !== void 0)
      _n(n.length === t.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures"), this.signatures = n;
    else {
      const r = [];
      for (let i = 0; i < t.header.numRequiredSignatures; i++)
        r.push(new Uint8Array(pl));
      this.signatures = r;
    }
    this.message = t;
  }
  serialize() {
    const t = this.message.serialize(), n = Array();
    Ri(n, this.signatures.length);
    const r = ht([Nn(n.length, "encodedSignaturesLength"), Yr(VH(), this.signatures.length, "signatures"), Nn(t.length, "serializedMessage")]), i = new Uint8Array(2048), o = r.encode({
      encodedSignaturesLength: new Uint8Array(n),
      signatures: this.signatures,
      serializedMessage: t
    }, i);
    return i.slice(0, o);
  }
  static deserialize(t) {
    let n = [...t];
    const r = [], i = wi(n);
    for (let a = 0; a < i; a++)
      r.push(new Uint8Array(n.splice(0, pl)));
    const o = Mk.deserialize(new Uint8Array(n));
    return new Pk(o, r);
  }
  sign(t) {
    const n = this.message.serialize(), r = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
    for (const i of t) {
      const o = r.findIndex((a) => a.equals(i.publicKey));
      _n(o >= 0, `Cannot sign with non signer key ${i.publicKey.toBase58()}`), this.signatures[o] = Ik(n, i.secretKey);
    }
  }
  addSignature(t, n) {
    _n(n.byteLength === 64, "Signature must be 64 bytes long");
    const i = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures).findIndex((o) => o.equals(t));
    _n(i >= 0, `Can not add signature; \`${t.toBase58()}\` is not required to sign this transaction`), this.signatures[i] = n;
  }
}
const Io = new Ae("SysvarC1ock11111111111111111111111111111111"), JH = new Ae("SysvarEpochSchedu1e111111111111111111111111"), XH = new Ae("Sysvar1nstructions1111111111111111111111111"), rb = new Ae("SysvarRecentB1ockHashes11111111111111111111"), Cc = new Ae("SysvarRent111111111111111111111111111111111"), QH = new Ae("SysvarRewards111111111111111111111111111111"), eG = new Ae("SysvarS1otHashes111111111111111111111111111"), tG = new Ae("SysvarS1otHistory11111111111111111111111111"), ib = new Ae("SysvarStakeHistory1111111111111111111111111");
async function ob(e, t, n, r) {
  const i = r && {
    skipPreflight: r.skipPreflight,
    preflightCommitment: r.preflightCommitment || r.commitment,
    maxRetries: r.maxRetries,
    minContextSlot: r.minContextSlot
  }, o = await e.sendTransaction(t, n, i);
  let a;
  if (t.recentBlockhash != null && t.lastValidBlockHeight != null)
    a = (await e.confirmTransaction({
      abortSignal: r == null ? void 0 : r.abortSignal,
      signature: o,
      blockhash: t.recentBlockhash,
      lastValidBlockHeight: t.lastValidBlockHeight
    }, r && r.commitment)).value;
  else if (t.minNonceContextSlot != null && t.nonceInfo != null) {
    const {
      nonceInstruction: s
    } = t.nonceInfo, c = s.keys[0].pubkey;
    a = (await e.confirmTransaction({
      abortSignal: r == null ? void 0 : r.abortSignal,
      minContextSlot: t.minNonceContextSlot,
      nonceAccountPubkey: c,
      nonceValue: t.nonceInfo.nonce,
      signature: o
    }, r && r.commitment)).value;
  } else
    (r == null ? void 0 : r.abortSignal) != null && console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable."), a = (await e.confirmTransaction(o, r && r.commitment)).value;
  if (a.err)
    throw new Error(`Transaction ${o} failed (${JSON.stringify(a)})`);
  return o;
}
function yc(e) {
  return new Promise((t) => setTimeout(t, e));
}
function yn(e, t) {
  const n = e.layout.span >= 0 ? e.layout.span : yR(e, t), r = it.Buffer.alloc(n), i = Object.assign({
    instruction: e.index
  }, t);
  return e.layout.encode(i, r), r;
}
function kn(e, t) {
  let n;
  try {
    n = e.layout.decode(t);
  } catch (r) {
    throw new Error("invalid instruction; " + r);
  }
  if (n.instruction !== e.index)
    throw new Error(`invalid instruction; instruction index mismatch ${n.instruction} != ${e.index}`);
  return n;
}
const gR = Vr("lamportsPerSignature"), bR = ht([ft("version"), ft("state"), Qt("authorizedPubkey"), Qt("nonce"), ht([gR], "feeCalculator")]), fA = bR.span;
class c_ {
  /**
   * @internal
   */
  constructor(t) {
    this.authorizedPubkey = void 0, this.nonce = void 0, this.feeCalculator = void 0, this.authorizedPubkey = t.authorizedPubkey, this.nonce = t.nonce, this.feeCalculator = t.feeCalculator;
  }
  /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */
  static fromAccountData(t) {
    const n = bR.decode(qt(t), 0);
    return new c_({
      authorizedPubkey: new Ae(n.authorizedPubkey),
      nonce: new Ae(n.nonce).toString(),
      feeCalculator: n.feeCalculator
    });
  }
}
const nG = (e) => {
  const t = e.decode.bind(e), n = e.encode.bind(e);
  return {
    decode: t,
    encode: n
  };
}, rG = (e) => (t) => {
  const n = Nn(e, t), {
    encode: r,
    decode: i
  } = nG(n), o = n;
  return o.decode = (a, s) => {
    const c = i(a, s);
    return jD(it.Buffer.from(c));
  }, o.encode = (a, s, c) => {
    const l = vk(a, e);
    return r(l, s, c);
  }, o;
}, yl = rG(8);
class iG {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a system instruction and retrieve the instruction type.
   */
  static decodeInstructionType(t) {
    this.checkProgramId(t.programId);
    const r = ft("instruction").decode(t.data);
    let i;
    for (const [o, a] of Object.entries(Vn))
      if (a.index == r) {
        i = o;
        break;
      }
    if (!i)
      throw new Error("Instruction type incorrect; not a SystemInstruction");
    return i;
  }
  /**
   * Decode a create account system instruction and retrieve the instruction params.
   */
  static decodeCreateAccount(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 2);
    const {
      lamports: n,
      space: r,
      programId: i
    } = kn(Vn.Create, t.data);
    return {
      fromPubkey: t.keys[0].pubkey,
      newAccountPubkey: t.keys[1].pubkey,
      lamports: n,
      space: r,
      programId: new Ae(i)
    };
  }
  /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */
  static decodeTransfer(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 2);
    const {
      lamports: n
    } = kn(Vn.Transfer, t.data);
    return {
      fromPubkey: t.keys[0].pubkey,
      toPubkey: t.keys[1].pubkey,
      lamports: n
    };
  }
  /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */
  static decodeTransferWithSeed(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 3);
    const {
      lamports: n,
      seed: r,
      programId: i
    } = kn(Vn.TransferWithSeed, t.data);
    return {
      fromPubkey: t.keys[0].pubkey,
      basePubkey: t.keys[1].pubkey,
      toPubkey: t.keys[2].pubkey,
      lamports: n,
      seed: r,
      programId: new Ae(i)
    };
  }
  /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */
  static decodeAllocate(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 1);
    const {
      space: n
    } = kn(Vn.Allocate, t.data);
    return {
      accountPubkey: t.keys[0].pubkey,
      space: n
    };
  }
  /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */
  static decodeAllocateWithSeed(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 1);
    const {
      base: n,
      seed: r,
      space: i,
      programId: o
    } = kn(Vn.AllocateWithSeed, t.data);
    return {
      accountPubkey: t.keys[0].pubkey,
      basePubkey: new Ae(n),
      seed: r,
      space: i,
      programId: new Ae(o)
    };
  }
  /**
   * Decode an assign system instruction and retrieve the instruction params.
   */
  static decodeAssign(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 1);
    const {
      programId: n
    } = kn(Vn.Assign, t.data);
    return {
      accountPubkey: t.keys[0].pubkey,
      programId: new Ae(n)
    };
  }
  /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */
  static decodeAssignWithSeed(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 1);
    const {
      base: n,
      seed: r,
      programId: i
    } = kn(Vn.AssignWithSeed, t.data);
    return {
      accountPubkey: t.keys[0].pubkey,
      basePubkey: new Ae(n),
      seed: r,
      programId: new Ae(i)
    };
  }
  /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */
  static decodeCreateWithSeed(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 2);
    const {
      base: n,
      seed: r,
      lamports: i,
      space: o,
      programId: a
    } = kn(Vn.CreateWithSeed, t.data);
    return {
      fromPubkey: t.keys[0].pubkey,
      newAccountPubkey: t.keys[1].pubkey,
      basePubkey: new Ae(n),
      seed: r,
      lamports: i,
      space: o,
      programId: new Ae(a)
    };
  }
  /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */
  static decodeNonceInitialize(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 3);
    const {
      authorized: n
    } = kn(Vn.InitializeNonceAccount, t.data);
    return {
      noncePubkey: t.keys[0].pubkey,
      authorizedPubkey: new Ae(n)
    };
  }
  /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */
  static decodeNonceAdvance(t) {
    return this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 3), kn(Vn.AdvanceNonceAccount, t.data), {
      noncePubkey: t.keys[0].pubkey,
      authorizedPubkey: t.keys[2].pubkey
    };
  }
  /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */
  static decodeNonceWithdraw(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 5);
    const {
      lamports: n
    } = kn(Vn.WithdrawNonceAccount, t.data);
    return {
      noncePubkey: t.keys[0].pubkey,
      toPubkey: t.keys[1].pubkey,
      authorizedPubkey: t.keys[4].pubkey,
      lamports: n
    };
  }
  /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */
  static decodeNonceAuthorize(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 2);
    const {
      authorized: n
    } = kn(Vn.AuthorizeNonceAccount, t.data);
    return {
      noncePubkey: t.keys[0].pubkey,
      authorizedPubkey: t.keys[1].pubkey,
      newAuthorizedPubkey: new Ae(n)
    };
  }
  /**
   * @internal
   */
  static checkProgramId(t) {
    if (!t.equals(Rr.programId))
      throw new Error("invalid instruction; programId is not SystemProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(t, n) {
    if (t.length < n)
      throw new Error(`invalid instruction; found ${t.length} keys, expected at least ${n}`);
  }
}
const Vn = Object.freeze({
  Create: {
    index: 0,
    layout: ht([ft("instruction"), Di("lamports"), Di("space"), Qt("programId")])
  },
  Assign: {
    index: 1,
    layout: ht([ft("instruction"), Qt("programId")])
  },
  Transfer: {
    index: 2,
    layout: ht([ft("instruction"), yl("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: ht([ft("instruction"), Qt("base"), bc("seed"), Di("lamports"), Di("space"), Qt("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: ht([ft("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: ht([ft("instruction"), Di("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: ht([ft("instruction"), Qt("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: ht([ft("instruction"), Qt("authorized")])
  },
  Allocate: {
    index: 8,
    layout: ht([ft("instruction"), Di("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: ht([ft("instruction"), Qt("base"), bc("seed"), Di("space"), Qt("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: ht([ft("instruction"), Qt("base"), bc("seed"), Qt("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: ht([ft("instruction"), yl("lamports"), bc("seed"), Qt("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: ht([ft("instruction")])
  }
});
class Rr {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the System program
   */
  /**
   * Generate a transaction instruction that creates a new account
   */
  static createAccount(t) {
    const n = Vn.Create, r = yn(n, {
      lamports: t.lamports,
      space: t.space,
      programId: qt(t.programId.toBuffer())
    });
    return new jn({
      keys: [{
        pubkey: t.fromPubkey,
        isSigner: !0,
        isWritable: !0
      }, {
        pubkey: t.newAccountPubkey,
        isSigner: !0,
        isWritable: !0
      }],
      programId: this.programId,
      data: r
    });
  }
  /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */
  static transfer(t) {
    let n, r;
    if ("basePubkey" in t) {
      const i = Vn.TransferWithSeed;
      n = yn(i, {
        lamports: BigInt(t.lamports),
        seed: t.seed,
        programId: qt(t.programId.toBuffer())
      }), r = [{
        pubkey: t.fromPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: t.basePubkey,
        isSigner: !0,
        isWritable: !1
      }, {
        pubkey: t.toPubkey,
        isSigner: !1,
        isWritable: !0
      }];
    } else {
      const i = Vn.Transfer;
      n = yn(i, {
        lamports: BigInt(t.lamports)
      }), r = [{
        pubkey: t.fromPubkey,
        isSigner: !0,
        isWritable: !0
      }, {
        pubkey: t.toPubkey,
        isSigner: !1,
        isWritable: !0
      }];
    }
    return new jn({
      keys: r,
      programId: this.programId,
      data: n
    });
  }
  /**
   * Generate a transaction instruction that assigns an account to a program
   */
  static assign(t) {
    let n, r;
    if ("basePubkey" in t) {
      const i = Vn.AssignWithSeed;
      n = yn(i, {
        base: qt(t.basePubkey.toBuffer()),
        seed: t.seed,
        programId: qt(t.programId.toBuffer())
      }), r = [{
        pubkey: t.accountPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: t.basePubkey,
        isSigner: !0,
        isWritable: !1
      }];
    } else {
      const i = Vn.Assign;
      n = yn(i, {
        programId: qt(t.programId.toBuffer())
      }), r = [{
        pubkey: t.accountPubkey,
        isSigner: !0,
        isWritable: !0
      }];
    }
    return new jn({
      keys: r,
      programId: this.programId,
      data: n
    });
  }
  /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */
  static createAccountWithSeed(t) {
    const n = Vn.CreateWithSeed, r = yn(n, {
      base: qt(t.basePubkey.toBuffer()),
      seed: t.seed,
      lamports: t.lamports,
      space: t.space,
      programId: qt(t.programId.toBuffer())
    });
    let i = [{
      pubkey: t.fromPubkey,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: t.newAccountPubkey,
      isSigner: !1,
      isWritable: !0
    }];
    return t.basePubkey != t.fromPubkey && i.push({
      pubkey: t.basePubkey,
      isSigner: !0,
      isWritable: !1
    }), new jn({
      keys: i,
      programId: this.programId,
      data: r
    });
  }
  /**
   * Generate a transaction that creates a new Nonce account
   */
  static createNonceAccount(t) {
    const n = new On();
    "basePubkey" in t && "seed" in t ? n.add(Rr.createAccountWithSeed({
      fromPubkey: t.fromPubkey,
      newAccountPubkey: t.noncePubkey,
      basePubkey: t.basePubkey,
      seed: t.seed,
      lamports: t.lamports,
      space: fA,
      programId: this.programId
    })) : n.add(Rr.createAccount({
      fromPubkey: t.fromPubkey,
      newAccountPubkey: t.noncePubkey,
      lamports: t.lamports,
      space: fA,
      programId: this.programId
    }));
    const r = {
      noncePubkey: t.noncePubkey,
      authorizedPubkey: t.authorizedPubkey
    };
    return n.add(this.nonceInitialize(r)), n;
  }
  /**
   * Generate an instruction to initialize a Nonce account
   */
  static nonceInitialize(t) {
    const n = Vn.InitializeNonceAccount, r = yn(n, {
      authorized: qt(t.authorizedPubkey.toBuffer())
    }), i = {
      keys: [{
        pubkey: t.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: rb,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Cc,
        isSigner: !1,
        isWritable: !1
      }],
      programId: this.programId,
      data: r
    };
    return new jn(i);
  }
  /**
   * Generate an instruction to advance the nonce in a Nonce account
   */
  static nonceAdvance(t) {
    const n = Vn.AdvanceNonceAccount, r = yn(n), i = {
      keys: [{
        pubkey: t.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: rb,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: t.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: r
    };
    return new jn(i);
  }
  /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */
  static nonceWithdraw(t) {
    const n = Vn.WithdrawNonceAccount, r = yn(n, {
      lamports: t.lamports
    });
    return new jn({
      keys: [{
        pubkey: t.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: t.toPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: rb,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Cc,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: t.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: r
    });
  }
  /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */
  static nonceAuthorize(t) {
    const n = Vn.AuthorizeNonceAccount, r = yn(n, {
      authorized: qt(t.newAuthorizedPubkey.toBuffer())
    });
    return new jn({
      keys: [{
        pubkey: t.noncePubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: t.authorizedPubkey,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: r
    });
  }
  /**
   * Generate a transaction instruction that allocates space in an account without funding
   */
  static allocate(t) {
    let n, r;
    if ("basePubkey" in t) {
      const i = Vn.AllocateWithSeed;
      n = yn(i, {
        base: qt(t.basePubkey.toBuffer()),
        seed: t.seed,
        space: t.space,
        programId: qt(t.programId.toBuffer())
      }), r = [{
        pubkey: t.accountPubkey,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: t.basePubkey,
        isSigner: !0,
        isWritable: !1
      }];
    } else {
      const i = Vn.Allocate;
      n = yn(i, {
        space: t.space
      }), r = [{
        pubkey: t.accountPubkey,
        isSigner: !0,
        isWritable: !0
      }];
    }
    return new jn({
      keys: r,
      programId: this.programId,
      data: n
    });
  }
}
Rr.programId = new Ae("11111111111111111111111111111111");
const oG = Us - 300;
class Dc {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Amount of program data placed in each load Transaction
   */
  /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */
  static getMinNumSignatures(t) {
    return 2 * // Every transaction requires two signatures (payer + program)
    (Math.ceil(t / Dc.chunkSize) + 1 + // Add one for Create transaction
    1);
  }
  /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */
  static async load(t, n, r, i, o) {
    {
      const f = await t.getMinimumBalanceForRentExemption(o.length), d = await t.getAccountInfo(r.publicKey, "confirmed");
      let h = null;
      if (d !== null) {
        if (d.executable)
          return console.error("Program load failed, account is already executable"), !1;
        d.data.length !== o.length && (h = h || new On(), h.add(Rr.allocate({
          accountPubkey: r.publicKey,
          space: o.length
        }))), d.owner.equals(i) || (h = h || new On(), h.add(Rr.assign({
          accountPubkey: r.publicKey,
          programId: i
        }))), d.lamports < f && (h = h || new On(), h.add(Rr.transfer({
          fromPubkey: n.publicKey,
          toPubkey: r.publicKey,
          lamports: f - d.lamports
        })));
      } else
        h = new On().add(Rr.createAccount({
          fromPubkey: n.publicKey,
          newAccountPubkey: r.publicKey,
          lamports: f > 0 ? f : 1,
          space: o.length,
          programId: i
        }));
      h !== null && await ob(t, h, [n, r], {
        commitment: "confirmed"
      });
    }
    const a = ht([ft("instruction"), ft("offset"), ft("bytesLength"), ft("bytesLengthPadding"), Yr(an("byte"), Ds(ft(), -8), "bytes")]), s = Dc.chunkSize;
    let c = 0, l = o, u = [];
    for (; l.length > 0; ) {
      const f = l.slice(0, s), d = it.Buffer.alloc(s + 16);
      a.encode({
        instruction: 0,
        // Load instruction
        offset: c,
        bytes: f,
        bytesLength: 0,
        bytesLengthPadding: 0
      }, d);
      const h = new On().add({
        keys: [{
          pubkey: r.publicKey,
          isSigner: !0,
          isWritable: !0
        }],
        programId: i,
        data: d
      });
      u.push(ob(t, h, [n, r], {
        commitment: "confirmed"
      })), t._rpcEndpoint.includes("solana.com") && await yc(1e3 / 4), c += s, l = l.slice(s);
    }
    await Promise.all(u);
    {
      const f = ht([ft("instruction")]), d = it.Buffer.alloc(f.span);
      f.encode({
        instruction: 1
        // Finalize instruction
      }, d);
      const h = new On().add({
        keys: [{
          pubkey: r.publicKey,
          isSigner: !0,
          isWritable: !0
        }, {
          pubkey: Cc,
          isSigner: !1,
          isWritable: !1
        }],
        programId: i,
        data: d
      });
      await ob(t, h, [n, r], {
        commitment: "confirmed"
      });
    }
    return !0;
  }
}
Dc.chunkSize = oG;
const aG = new Ae("BPFLoader2111111111111111111111111111111111");
class sG {
  /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */
  static getMinNumSignatures(t) {
    return Dc.getMinNumSignatures(t);
  }
  /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */
  static load(t, n, r, i, o) {
    return Dc.load(t, n, r, o, i);
  }
}
var cG = Object.prototype.toString, uG = Object.keys || function(e) {
  var t = [];
  for (var n in e)
    t.push(n);
  return t;
};
function Mf(e, t) {
  var n, r, i, o, a, s, c;
  if (e === !0)
    return "true";
  if (e === !1)
    return "false";
  switch (typeof e) {
    case "object":
      if (e === null)
        return null;
      if (e.toJSON && typeof e.toJSON == "function")
        return Mf(e.toJSON(), t);
      if (c = cG.call(e), c === "[object Array]") {
        for (i = "[", r = e.length - 1, n = 0; n < r; n++)
          i += Mf(e[n], !0) + ",";
        return r > -1 && (i += Mf(e[n], !0)), i + "]";
      } else if (c === "[object Object]") {
        for (o = uG(e).sort(), r = o.length, i = "", n = 0; n < r; )
          a = o[n], s = Mf(e[a], !1), s !== void 0 && (i && (i += ","), i += JSON.stringify(a) + ":" + s), n++;
        return "{" + i + "}";
      } else
        return JSON.stringify(e);
    case "function":
    case "undefined":
      return t ? null : void 0;
    case "string":
      return JSON.stringify(e);
    default:
      return isFinite(e) ? e : null;
  }
}
var lG = function(e) {
  var t = Mf(e, !1);
  if (t !== void 0)
    return "" + t;
}, eM = lG;
const ff = 32;
function n1(e) {
  let t = 0;
  for (; e > 1; )
    e /= 2, t++;
  return t;
}
function fG(e) {
  return e === 0 ? 1 : (e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e |= e >> 32, e + 1);
}
class mR {
  /** The maximum number of slots in each epoch */
  /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */
  /** Indicates whether epochs start short and grow */
  /** The first epoch with `slotsPerEpoch` slots */
  /** The first slot of `firstNormalEpoch` */
  constructor(t, n, r, i, o) {
    this.slotsPerEpoch = void 0, this.leaderScheduleSlotOffset = void 0, this.warmup = void 0, this.firstNormalEpoch = void 0, this.firstNormalSlot = void 0, this.slotsPerEpoch = t, this.leaderScheduleSlotOffset = n, this.warmup = r, this.firstNormalEpoch = i, this.firstNormalSlot = o;
  }
  getEpoch(t) {
    return this.getEpochAndSlotIndex(t)[0];
  }
  getEpochAndSlotIndex(t) {
    if (t < this.firstNormalSlot) {
      const n = n1(fG(t + ff + 1)) - n1(ff) - 1, r = this.getSlotsInEpoch(n), i = t - (r - ff);
      return [n, i];
    } else {
      const n = t - this.firstNormalSlot, r = Math.floor(n / this.slotsPerEpoch), i = this.firstNormalEpoch + r, o = n % this.slotsPerEpoch;
      return [i, o];
    }
  }
  getFirstSlotInEpoch(t) {
    return t <= this.firstNormalEpoch ? (Math.pow(2, t) - 1) * ff : (t - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
  }
  getLastSlotInEpoch(t) {
    return this.getFirstSlotInEpoch(t) + this.getSlotsInEpoch(t) - 1;
  }
  getSlotsInEpoch(t) {
    return t < this.firstNormalEpoch ? Math.pow(2, t + n1(ff)) : this.slotsPerEpoch;
  }
}
class gl extends Error {
  constructor(t, n) {
    super(t), this.logs = void 0, this.logs = n;
  }
}
const dG = {
  JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
  JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
  JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
  JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
  JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
  JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
  JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
  JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
  JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
  JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
  JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
  JSON_RPC_SCAN_ERROR: -32012,
  JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
  JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
  JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
  JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class bt extends Error {
  constructor({
    code: t,
    message: n,
    data: r
  }, i) {
    super(i != null ? `${i}: ${n}` : n), this.code = void 0, this.data = void 0, this.code = t, this.data = r, this.name = "SolanaJSONRPCError";
  }
}
var hG = globalThis.fetch;
class pG extends pH {
  constructor(t, n, r) {
    const i = (o) => {
      const a = yH(o, {
        autoconnect: !0,
        max_reconnects: 5,
        reconnect: !0,
        reconnect_interval: 1e3,
        ...n
      });
      return "socket" in a ? this.underlyingSocket = a.socket : this.underlyingSocket = a, a;
    };
    super(i, t, n, r), this.underlyingSocket = void 0;
  }
  call(...t) {
    var r;
    const n = (r = this.underlyingSocket) == null ? void 0 : r.readyState;
    return n === 1 ? super.call(...t) : Promise.reject(new Error("Tried to call a JSON-RPC method `" + t[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + n + ")"));
  }
  notify(...t) {
    var r;
    const n = (r = this.underlyingSocket) == null ? void 0 : r.readyState;
    return n === 1 ? super.notify(...t) : Promise.reject(new Error("Tried to send a JSON-RPC notification `" + t[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + n + ")"));
  }
}
const yG = 160, gG = 64, bG = yG / gG, mG = 1e3 / bG;
function _G(e, t) {
  let n;
  try {
    n = e.layout.decode(t);
  } catch (r) {
    throw new Error("invalid instruction; " + r);
  }
  if (n.typeIndex !== e.index)
    throw new Error(`invalid account data; account type mismatch ${n.typeIndex} != ${e.index}`);
  return n;
}
const tM = 56;
class dA {
  constructor(t) {
    this.key = void 0, this.state = void 0, this.key = t.key, this.state = t.state;
  }
  isActive() {
    const t = BigInt("0xffffffffffffffff");
    return this.state.deactivationSlot === t;
  }
  static deserialize(t) {
    const n = _G(wG, t), r = t.length - tM;
    _n(r >= 0, "lookup table is invalid"), _n(r % 32 === 0, "lookup table is invalid");
    const i = r / 32, {
      addresses: o
    } = ht([Yr(Qt(), i, "addresses")]).decode(t.slice(tM));
    return {
      deactivationSlot: n.deactivationSlot,
      lastExtendedSlot: n.lastExtendedSlot,
      lastExtendedSlotStartIndex: n.lastExtendedStartIndex,
      authority: n.authority.length !== 0 ? new Ae(n.authority[0]) : void 0,
      addresses: o.map((a) => new Ae(a))
    };
  }
}
const wG = {
  index: 1,
  layout: ht([
    ft("typeIndex"),
    yl("deactivationSlot"),
    Vr("lastExtendedSlot"),
    an("lastExtendedStartIndex"),
    an(),
    // option
    Yr(Qt(), Ds(an(), -1), "authority")
  ])
}, vG = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function SG(e) {
  const t = e.match(vG);
  if (t == null)
    throw TypeError(`Failed to validate endpoint URL \`${e}\``);
  const [
    n,
    // eslint-disable-line @typescript-eslint/no-unused-vars
    r,
    i,
    o
  ] = t, a = e.startsWith("https:") ? "wss:" : "ws:", s = i == null ? null : parseInt(i.slice(1), 10), c = (
    // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explictly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    s == null ? "" : `:${s + 1}`
  );
  return `${a}//${r}${c}${o}`;
}
const Br = Nd(Ek(Ae), Ke(), (e) => new Ae(e)), _R = Ak([Ke(), dr("base64")]), Bk = Nd(Ek(it.Buffer), _R, (e) => it.Buffer.from(e[0], "base64")), wR = 30 * 1e3;
function EG(e) {
  if (/^https?:/.test(e) === !1)
    throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
  return e;
}
function cr(e) {
  let t, n;
  if (typeof e == "string")
    t = e;
  else if (e) {
    const {
      commitment: r,
      ...i
    } = e;
    t = r, n = i;
  }
  return {
    commitment: t,
    config: n
  };
}
function vR(e) {
  return Ii([Oe({
    jsonrpc: dr("2.0"),
    id: Ke(),
    result: e
  }), Oe({
    jsonrpc: dr("2.0"),
    id: Ke(),
    error: Oe({
      code: Rd(),
      message: Ke(),
      data: xt(Pq())
    })
  })]);
}
const AG = vR(Rd());
function Vt(e) {
  return Nd(vR(e), AG, (t) => "error" in t ? t : {
    ...t,
    result: Ve(t.result, e)
  });
}
function Or(e) {
  return Vt(Oe({
    context: Oe({
      slot: pe()
    }),
    value: e
  }));
}
function u_(e) {
  return Oe({
    context: Oe({
      slot: pe()
    }),
    value: e
  });
}
function r1(e, t) {
  return e === 0 ? new Bc({
    header: t.header,
    staticAccountKeys: t.accountKeys.map((n) => new Ae(n)),
    recentBlockhash: t.recentBlockhash,
    compiledInstructions: t.instructions.map((n) => ({
      programIdIndex: n.programIdIndex,
      accountKeyIndexes: n.accounts,
      data: Er.decode(n.data)
    })),
    addressTableLookups: t.addressTableLookups
  }) : new zo(t);
}
const IG = Oe({
  foundation: pe(),
  foundationTerm: pe(),
  initial: pe(),
  taper: pe(),
  terminal: pe()
}), kG = Vt(Ze(Je(Oe({
  epoch: pe(),
  effectiveSlot: pe(),
  amount: pe(),
  postBalance: pe(),
  commission: xt(Je(pe()))
})))), TG = Ze(Oe({
  slot: pe(),
  prioritizationFee: pe()
})), xG = Oe({
  total: pe(),
  validator: pe(),
  foundation: pe(),
  epoch: pe()
}), MG = Oe({
  epoch: pe(),
  slotIndex: pe(),
  slotsInEpoch: pe(),
  absoluteSlot: pe(),
  blockHeight: xt(pe()),
  transactionCount: xt(pe())
}), OG = Oe({
  slotsPerEpoch: pe(),
  leaderScheduleSlotOffset: pe(),
  warmup: Va(),
  firstNormalEpoch: pe(),
  firstNormalSlot: pe()
}), PG = FD(Ke(), Ze(pe())), ru = Je(Ii([Oe({}), Ke()])), BG = Oe({
  err: ru
}), CG = dr("receivedSignature"), DG = Oe({
  "solana-core": Ke(),
  "feature-set": xt(pe())
}), nM = Or(Oe({
  err: Je(Ii([Oe({}), Ke()])),
  logs: Je(Ze(Ke())),
  accounts: xt(Je(Ze(Je(Oe({
    executable: Va(),
    owner: Ke(),
    lamports: pe(),
    data: Ze(Ke()),
    rentEpoch: xt(pe())
  }))))),
  unitsConsumed: xt(pe()),
  returnData: xt(Je(Oe({
    programId: Ke(),
    data: Ak([Ke(), dr("base64")])
  })))
})), RG = Or(Oe({
  byIdentity: FD(Ke(), Ze(pe())),
  range: Oe({
    firstSlot: pe(),
    lastSlot: pe()
  })
}));
function NG(e, t, n, r, i, o) {
  const a = n || hG;
  let s;
  o != null && console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
  let c;
  return r && (c = async (u, f) => {
    const d = await new Promise((h, g) => {
      try {
        r(u, f, (w, b) => h([w, b]));
      } catch (w) {
        g(w);
      }
    });
    return await a(...d);
  }), new aH(async (u, f) => {
    const d = {
      method: "POST",
      body: u,
      agent: s,
      headers: Object.assign({
        "Content-Type": "application/json"
      }, t || {}, NY)
    };
    try {
      let h = 5, g, w = 500;
      for (; c ? g = await c(e, d) : g = await a(e, d), !(g.status !== 429 || i === !0 || (h -= 1, h === 0)); )
        console.log(`Server responded with ${g.status} ${g.statusText}.  Retrying after ${w}ms delay...`), await yc(w), w *= 2;
      const b = await g.text();
      g.ok ? f(null, b) : f(new Error(`${g.status} ${g.statusText}: ${b}`));
    } catch (h) {
      h instanceof Error && f(h);
    }
  }, {});
}
function jG(e) {
  return (t, n) => new Promise((r, i) => {
    e.request(t, n, (o, a) => {
      if (o) {
        i(o);
        return;
      }
      r(a);
    });
  });
}
function UG(e) {
  return (t) => new Promise((n, r) => {
    t.length === 0 && n([]);
    const i = t.map((o) => e.request(o.methodName, o.args));
    e.request(i, (o, a) => {
      if (o) {
        r(o);
        return;
      }
      n(a);
    });
  });
}
const zG = Vt(IG), FG = Vt(xG), LG = Vt(TG), $G = Vt(MG), WG = Vt(OG), KG = Vt(PG), VG = Vt(pe()), qG = Or(Oe({
  total: pe(),
  circulating: pe(),
  nonCirculating: pe(),
  nonCirculatingAccounts: Ze(Br)
})), hA = Oe({
  amount: Ke(),
  uiAmount: Je(pe()),
  decimals: pe(),
  uiAmountString: xt(Ke())
}), HG = Or(Ze(Oe({
  address: Br,
  amount: Ke(),
  uiAmount: Je(pe()),
  decimals: pe(),
  uiAmountString: xt(Ke())
}))), GG = Or(Ze(Oe({
  pubkey: Br,
  account: Oe({
    executable: Va(),
    owner: Br,
    lamports: pe(),
    data: Bk,
    rentEpoch: pe()
  })
}))), pA = Oe({
  program: Ke(),
  parsed: Rd(),
  space: pe()
}), YG = Or(Ze(Oe({
  pubkey: Br,
  account: Oe({
    executable: Va(),
    owner: Br,
    lamports: pe(),
    data: pA,
    rentEpoch: pe()
  })
}))), ZG = Or(Ze(Oe({
  lamports: pe(),
  address: Br
}))), ad = Oe({
  executable: Va(),
  owner: Br,
  lamports: pe(),
  data: Bk,
  rentEpoch: pe()
}), JG = Oe({
  pubkey: Br,
  account: ad
}), XG = Nd(Ii([Ek(it.Buffer), pA]), Ii([_R, pA]), (e) => Array.isArray(e) ? Ve(e, Bk) : e), yA = Oe({
  executable: Va(),
  owner: Br,
  lamports: pe(),
  data: XG,
  rentEpoch: pe()
}), QG = Oe({
  pubkey: Br,
  account: yA
}), eY = Oe({
  state: Ii([dr("active"), dr("inactive"), dr("activating"), dr("deactivating")]),
  active: pe(),
  inactive: pe()
}), tY = Vt(Ze(Oe({
  signature: Ke(),
  slot: pe(),
  err: ru,
  memo: Je(Ke()),
  blockTime: xt(Je(pe()))
}))), nY = Vt(Ze(Oe({
  signature: Ke(),
  slot: pe(),
  err: ru,
  memo: Je(Ke()),
  blockTime: xt(Je(pe()))
}))), rY = Oe({
  subscription: pe(),
  result: u_(ad)
}), iY = Oe({
  pubkey: Br,
  account: ad
}), oY = Oe({
  subscription: pe(),
  result: u_(iY)
}), aY = Oe({
  parent: pe(),
  slot: pe(),
  root: pe()
}), sY = Oe({
  subscription: pe(),
  result: aY
}), cY = Ii([Oe({
  type: Ii([dr("firstShredReceived"), dr("completed"), dr("optimisticConfirmation"), dr("root")]),
  slot: pe(),
  timestamp: pe()
}), Oe({
  type: dr("createdBank"),
  parent: pe(),
  slot: pe(),
  timestamp: pe()
}), Oe({
  type: dr("frozen"),
  slot: pe(),
  timestamp: pe(),
  stats: Oe({
    numTransactionEntries: pe(),
    numSuccessfulTransactions: pe(),
    numFailedTransactions: pe(),
    maxTransactionsPerEntry: pe()
  })
}), Oe({
  type: dr("dead"),
  slot: pe(),
  timestamp: pe(),
  err: Ke()
})]), uY = Oe({
  subscription: pe(),
  result: cY
}), lY = Oe({
  subscription: pe(),
  result: u_(Ii([BG, CG]))
}), fY = Oe({
  subscription: pe(),
  result: pe()
}), dY = Oe({
  pubkey: Ke(),
  gossip: Je(Ke()),
  tpu: Je(Ke()),
  rpc: Je(Ke()),
  version: Je(Ke())
}), rM = Oe({
  votePubkey: Ke(),
  nodePubkey: Ke(),
  activatedStake: pe(),
  epochVoteAccount: Va(),
  epochCredits: Ze(Ak([pe(), pe(), pe()])),
  commission: pe(),
  lastVote: pe(),
  rootSlot: Je(pe())
}), hY = Vt(Oe({
  current: Ze(rM),
  delinquent: Ze(rM)
})), pY = Ii([dr("processed"), dr("confirmed"), dr("finalized")]), yY = Oe({
  slot: pe(),
  confirmations: Je(pe()),
  err: ru,
  confirmationStatus: xt(pY)
}), gY = Or(Ze(Je(yY))), bY = Vt(pe()), SR = Oe({
  accountKey: Br,
  writableIndexes: Ze(pe()),
  readonlyIndexes: Ze(pe())
}), Ck = Oe({
  signatures: Ze(Ke()),
  message: Oe({
    accountKeys: Ze(Ke()),
    header: Oe({
      numRequiredSignatures: pe(),
      numReadonlySignedAccounts: pe(),
      numReadonlyUnsignedAccounts: pe()
    }),
    instructions: Ze(Oe({
      accounts: Ze(pe()),
      data: Ke(),
      programIdIndex: pe()
    })),
    recentBlockhash: Ke(),
    addressTableLookups: xt(Ze(SR))
  })
}), ER = Oe({
  pubkey: Br,
  signer: Va(),
  writable: Va(),
  source: xt(Ii([dr("transaction"), dr("lookupTable")]))
}), AR = Oe({
  accountKeys: Ze(ER),
  signatures: Ze(Ke())
}), IR = Oe({
  parsed: Rd(),
  program: Ke(),
  programId: Br
}), kR = Oe({
  accounts: Ze(Br),
  data: Ke(),
  programId: Br
}), mY = Ii([kR, IR]), _Y = Ii([Oe({
  parsed: Rd(),
  program: Ke(),
  programId: Ke()
}), Oe({
  accounts: Ze(Ke()),
  data: Ke(),
  programId: Ke()
})]), TR = Nd(mY, _Y, (e) => "accounts" in e ? Ve(e, kR) : Ve(e, IR)), xR = Oe({
  signatures: Ze(Ke()),
  message: Oe({
    accountKeys: Ze(ER),
    instructions: Ze(TR),
    recentBlockhash: Ke(),
    addressTableLookups: xt(Je(Ze(SR)))
  })
}), qb = Oe({
  accountIndex: pe(),
  mint: Ke(),
  owner: xt(Ke()),
  uiTokenAmount: hA
}), MR = Oe({
  writable: Ze(Br),
  readonly: Ze(Br)
}), l_ = Oe({
  err: ru,
  fee: pe(),
  innerInstructions: xt(Je(Ze(Oe({
    index: pe(),
    instructions: Ze(Oe({
      accounts: Ze(pe()),
      data: Ke(),
      programIdIndex: pe()
    }))
  })))),
  preBalances: Ze(pe()),
  postBalances: Ze(pe()),
  logMessages: xt(Je(Ze(Ke()))),
  preTokenBalances: xt(Je(Ze(qb))),
  postTokenBalances: xt(Je(Ze(qb))),
  loadedAddresses: xt(MR),
  computeUnitsConsumed: xt(pe())
}), Dk = Oe({
  err: ru,
  fee: pe(),
  innerInstructions: xt(Je(Ze(Oe({
    index: pe(),
    instructions: Ze(TR)
  })))),
  preBalances: Ze(pe()),
  postBalances: Ze(pe()),
  logMessages: xt(Je(Ze(Ke()))),
  preTokenBalances: xt(Je(Ze(qb))),
  postTokenBalances: xt(Je(Ze(qb))),
  loadedAddresses: xt(MR),
  computeUnitsConsumed: xt(pe())
}), Ll = Ii([dr(0), dr("legacy")]), iu = Oe({
  pubkey: Ke(),
  lamports: pe(),
  postBalance: Je(pe()),
  rewardType: Je(Ke()),
  commission: xt(Je(pe()))
}), wY = Vt(Je(Oe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: pe(),
  transactions: Ze(Oe({
    transaction: Ck,
    meta: Je(l_),
    version: xt(Ll)
  })),
  rewards: xt(Ze(iu)),
  blockTime: Je(pe()),
  blockHeight: Je(pe())
}))), vY = Vt(Je(Oe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: pe(),
  rewards: xt(Ze(iu)),
  blockTime: Je(pe()),
  blockHeight: Je(pe())
}))), SY = Vt(Je(Oe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: pe(),
  transactions: Ze(Oe({
    transaction: AR,
    meta: Je(l_),
    version: xt(Ll)
  })),
  rewards: xt(Ze(iu)),
  blockTime: Je(pe()),
  blockHeight: Je(pe())
}))), EY = Vt(Je(Oe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: pe(),
  transactions: Ze(Oe({
    transaction: xR,
    meta: Je(Dk),
    version: xt(Ll)
  })),
  rewards: xt(Ze(iu)),
  blockTime: Je(pe()),
  blockHeight: Je(pe())
}))), AY = Vt(Je(Oe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: pe(),
  transactions: Ze(Oe({
    transaction: AR,
    meta: Je(Dk),
    version: xt(Ll)
  })),
  rewards: xt(Ze(iu)),
  blockTime: Je(pe()),
  blockHeight: Je(pe())
}))), IY = Vt(Je(Oe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: pe(),
  rewards: xt(Ze(iu)),
  blockTime: Je(pe()),
  blockHeight: Je(pe())
}))), kY = Vt(Je(Oe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: pe(),
  transactions: Ze(Oe({
    transaction: Ck,
    meta: Je(l_)
  })),
  rewards: xt(Ze(iu)),
  blockTime: Je(pe())
}))), iM = Vt(Je(Oe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: pe(),
  signatures: Ze(Ke()),
  blockTime: Je(pe())
}))), i1 = Vt(Je(Oe({
  slot: pe(),
  meta: l_,
  blockTime: xt(Je(pe())),
  transaction: Ck,
  version: xt(Ll)
}))), Sg = Vt(Je(Oe({
  slot: pe(),
  transaction: xR,
  meta: Je(Dk),
  blockTime: xt(Je(pe())),
  version: xt(Ll)
}))), TY = Or(Oe({
  blockhash: Ke(),
  feeCalculator: Oe({
    lamportsPerSignature: pe()
  })
})), xY = Or(Oe({
  blockhash: Ke(),
  lastValidBlockHeight: pe()
})), MY = Oe({
  slot: pe(),
  numTransactions: pe(),
  numSlots: pe(),
  samplePeriodSecs: pe()
}), OY = Vt(Ze(MY)), PY = Or(Je(Oe({
  feeCalculator: Oe({
    lamportsPerSignature: pe()
  })
}))), BY = Vt(Ke()), CY = Vt(Ke()), DY = Oe({
  err: ru,
  logs: Ze(Ke()),
  signature: Ke()
}), RY = Oe({
  result: u_(DY),
  subscription: pe()
}), NY = {
  "solana-client": "js/0.0.0-development"
};
class Rk {
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal
   * A number that we increment every time an active connection closes.
   * Used to determine whether the same socket connection that was open
   * when an async operation started is the same one that's active when
   * its continuation fires.
   *
   */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /** @internal */
  /**
   * Special case.
   * After a signature is processed, RPCs automatically dispose of the
   * subscription on the server side. We need to track which of these
   * subscriptions have been disposed in such a way, so that we know
   * whether the client is dealing with a not-yet-processed signature
   * (in which case we must tear down the server subscription) or an
   * already-processed signature (in which case the client can simply
   * clear out the subscription locally without telling the server).
   *
   * NOTE: There is a proposal to eliminate this special case, here:
   * https://github.com/solana-labs/solana/issues/18892
   */
  /** @internal */
  /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */
  constructor(t, n) {
    this._commitment = void 0, this._confirmTransactionInitialTimeout = void 0, this._rpcEndpoint = void 0, this._rpcWsEndpoint = void 0, this._rpcClient = void 0, this._rpcRequest = void 0, this._rpcBatchRequest = void 0, this._rpcWebSocket = void 0, this._rpcWebSocketConnected = !1, this._rpcWebSocketHeartbeat = null, this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketGeneration = 0, this._disableBlockhashCaching = !1, this._pollingBlockhash = !1, this._blockhashInfo = {
      latestBlockhash: null,
      lastFetch: 0,
      transactionSignatures: [],
      simulatedSignatures: []
    }, this._nextClientSubscriptionId = 0, this._subscriptionDisposeFunctionsByClientSubscriptionId = {}, this._subscriptionHashByClientSubscriptionId = {}, this._subscriptionStateChangeCallbacksByHash = {}, this._subscriptionCallbacksByServerSubscriptionId = {}, this._subscriptionsByHash = {}, this._subscriptionsAutoDisposedByRpc = /* @__PURE__ */ new Set(), this.getBlockHeight = (() => {
      const l = {};
      return async (u) => {
        const {
          commitment: f,
          config: d
        } = cr(u), h = this._buildArgs([], f, void 0, d), g = eM(h);
        return l[g] = l[g] ?? (async () => {
          try {
            const w = await this._rpcRequest("getBlockHeight", h), b = Ve(w, Vt(pe()));
            if ("error" in b)
              throw new bt(b.error, "failed to get block height information");
            return b.result;
          } finally {
            delete l[g];
          }
        })(), await l[g];
      };
    })();
    let r, i, o, a, s, c;
    n && typeof n == "string" ? this._commitment = n : n && (this._commitment = n.commitment, this._confirmTransactionInitialTimeout = n.confirmTransactionInitialTimeout, r = n.wsEndpoint, i = n.httpHeaders, o = n.fetch, a = n.fetchMiddleware, s = n.disableRetryOnRateLimit, c = n.httpAgent), this._rpcEndpoint = EG(t), this._rpcWsEndpoint = r || SG(t), this._rpcClient = NG(t, i, o, a, s, c), this._rpcRequest = jG(this._rpcClient), this._rpcBatchRequest = UG(this._rpcClient), this._rpcWebSocket = new pG(this._rpcWsEndpoint, {
      autoconnect: !1,
      max_reconnects: 1 / 0
    }), this._rpcWebSocket.on("open", this._wsOnOpen.bind(this)), this._rpcWebSocket.on("error", this._wsOnError.bind(this)), this._rpcWebSocket.on("close", this._wsOnClose.bind(this)), this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this)), this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this)), this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this)), this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this)), this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this)), this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this)), this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
  }
  /**
   * The default commitment used for requests
   */
  get commitment() {
    return this._commitment;
  }
  /**
   * The RPC endpoint
   */
  get rpcEndpoint() {
    return this._rpcEndpoint;
  }
  /**
   * Fetch the balance for the specified public key, return with context
   */
  async getBalanceAndContext(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = this._buildArgs([t.toBase58()], r, void 0, i), a = await this._rpcRequest("getBalance", o), s = Ve(a, Or(pe()));
    if ("error" in s)
      throw new bt(s.error, `failed to get balance for ${t.toBase58()}`);
    return s.result;
  }
  /**
   * Fetch the balance for the specified public key
   */
  async getBalance(t, n) {
    return await this.getBalanceAndContext(t, n).then((r) => r.value).catch((r) => {
      throw new Error("failed to get balance of account " + t.toBase58() + ": " + r);
    });
  }
  /**
   * Fetch the estimated production time of a block
   */
  async getBlockTime(t) {
    const n = await this._rpcRequest("getBlockTime", [t]), r = Ve(n, Vt(Je(pe())));
    if ("error" in r)
      throw new bt(r.error, `failed to get block time for slot ${t}`);
    return r.result;
  }
  /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */
  async getMinimumLedgerSlot() {
    const t = await this._rpcRequest("minimumLedgerSlot", []), n = Ve(t, Vt(pe()));
    if ("error" in n)
      throw new bt(n.error, "failed to get minimum ledger slot");
    return n.result;
  }
  /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */
  async getFirstAvailableBlock() {
    const t = await this._rpcRequest("getFirstAvailableBlock", []), n = Ve(t, VG);
    if ("error" in n)
      throw new bt(n.error, "failed to get first available block");
    return n.result;
  }
  /**
   * Fetch information about the current supply
   */
  async getSupply(t) {
    let n = {};
    typeof t == "string" ? n = {
      commitment: t
    } : t ? n = {
      ...t,
      commitment: t && t.commitment || this.commitment
    } : n = {
      commitment: this.commitment
    };
    const r = await this._rpcRequest("getSupply", [n]), i = Ve(r, qG);
    if ("error" in i)
      throw new bt(i.error, "failed to get supply");
    return i.result;
  }
  /**
   * Fetch the current supply of a token mint
   */
  async getTokenSupply(t, n) {
    const r = this._buildArgs([t.toBase58()], n), i = await this._rpcRequest("getTokenSupply", r), o = Ve(i, Or(hA));
    if ("error" in o)
      throw new bt(o.error, "failed to get token supply");
    return o.result;
  }
  /**
   * Fetch the current balance of a token account
   */
  async getTokenAccountBalance(t, n) {
    const r = this._buildArgs([t.toBase58()], n), i = await this._rpcRequest("getTokenAccountBalance", r), o = Ve(i, Or(hA));
    if ("error" in o)
      throw new bt(o.error, "failed to get token account balance");
    return o.result;
  }
  /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>>}
   */
  async getTokenAccountsByOwner(t, n, r) {
    const {
      commitment: i,
      config: o
    } = cr(r);
    let a = [t.toBase58()];
    "mint" in n ? a.push({
      mint: n.mint.toBase58()
    }) : a.push({
      programId: n.programId.toBase58()
    });
    const s = this._buildArgs(a, i, "base64", o), c = await this._rpcRequest("getTokenAccountsByOwner", s), l = Ve(c, GG);
    if ("error" in l)
      throw new bt(l.error, `failed to get token accounts owned by account ${t.toBase58()}`);
    return l.result;
  }
  /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */
  async getParsedTokenAccountsByOwner(t, n, r) {
    let i = [t.toBase58()];
    "mint" in n ? i.push({
      mint: n.mint.toBase58()
    }) : i.push({
      programId: n.programId.toBase58()
    });
    const o = this._buildArgs(i, r, "jsonParsed"), a = await this._rpcRequest("getTokenAccountsByOwner", o), s = Ve(a, YG);
    if ("error" in s)
      throw new bt(s.error, `failed to get token accounts owned by account ${t.toBase58()}`);
    return s.result;
  }
  /**
   * Fetch the 20 largest accounts with their current balances
   */
  async getLargestAccounts(t) {
    const n = {
      ...t,
      commitment: t && t.commitment || this.commitment
    }, r = n.filter || n.commitment ? [n] : [], i = await this._rpcRequest("getLargestAccounts", r), o = Ve(i, ZG);
    if ("error" in o)
      throw new bt(o.error, "failed to get largest accounts");
    return o.result;
  }
  /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */
  async getTokenLargestAccounts(t, n) {
    const r = this._buildArgs([t.toBase58()], n), i = await this._rpcRequest("getTokenLargestAccounts", r), o = Ve(i, HG);
    if ("error" in o)
      throw new bt(o.error, "failed to get token largest accounts");
    return o.result;
  }
  /**
   * Fetch all the account info for the specified public key, return with context
   */
  async getAccountInfoAndContext(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = this._buildArgs([t.toBase58()], r, "base64", i), a = await this._rpcRequest("getAccountInfo", o), s = Ve(a, Or(Je(ad)));
    if ("error" in s)
      throw new bt(s.error, `failed to get info about account ${t.toBase58()}`);
    return s.result;
  }
  /**
   * Fetch parsed account info for the specified public key
   */
  async getParsedAccountInfo(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = this._buildArgs([t.toBase58()], r, "jsonParsed", i), a = await this._rpcRequest("getAccountInfo", o), s = Ve(a, Or(Je(yA)));
    if ("error" in s)
      throw new bt(s.error, `failed to get info about account ${t.toBase58()}`);
    return s.result;
  }
  /**
   * Fetch all the account info for the specified public key
   */
  async getAccountInfo(t, n) {
    try {
      return (await this.getAccountInfoAndContext(t, n)).value;
    } catch (r) {
      throw new Error("failed to get info about account " + t.toBase58() + ": " + r);
    }
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleParsedAccounts(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = t.map((l) => l.toBase58()), a = this._buildArgs([o], r, "jsonParsed", i), s = await this._rpcRequest("getMultipleAccounts", a), c = Ve(s, Or(Ze(Je(yA))));
    if ("error" in c)
      throw new bt(c.error, `failed to get info for accounts ${o}`);
    return c.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */
  async getMultipleAccountsInfoAndContext(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = t.map((l) => l.toBase58()), a = this._buildArgs([o], r, "base64", i), s = await this._rpcRequest("getMultipleAccounts", a), c = Ve(s, Or(Ze(Je(ad))));
    if ("error" in c)
      throw new bt(c.error, `failed to get info for accounts ${o}`);
    return c.result;
  }
  /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */
  async getMultipleAccountsInfo(t, n) {
    return (await this.getMultipleAccountsInfoAndContext(t, n)).value;
  }
  /**
   * Returns epoch activation information for a stake account that has been delegated
   */
  async getStakeActivation(t, n, r) {
    const {
      commitment: i,
      config: o
    } = cr(n), a = this._buildArgs([t.toBase58()], i, void 0, {
      ...o,
      epoch: r ?? (o == null ? void 0 : o.epoch)
    }), s = await this._rpcRequest("getStakeActivation", a), c = Ve(s, Vt(eY));
    if ("error" in c)
      throw new bt(c.error, `failed to get Stake Activation ${t.toBase58()}`);
    return c.result;
  }
  /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */
  async getProgramAccounts(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), {
      encoding: o,
      ...a
    } = i || {}, s = this._buildArgs([t.toBase58()], r, o || "base64", a), c = await this._rpcRequest("getProgramAccounts", s), l = Ve(c, Vt(Ze(JG)));
    if ("error" in l)
      throw new bt(l.error, `failed to get accounts owned by program ${t.toBase58()}`);
    return l.result;
  }
  /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */
  async getParsedProgramAccounts(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = this._buildArgs([t.toBase58()], r, "jsonParsed", i), a = await this._rpcRequest("getProgramAccounts", o), s = Ve(a, Vt(Ze(QG)));
    if ("error" in s)
      throw new bt(s.error, `failed to get accounts owned by program ${t.toBase58()}`);
    return s.result;
  }
  // eslint-disable-next-line no-dupe-class-members
  async confirmTransaction(t, n) {
    var o;
    let r;
    if (typeof t == "string")
      r = t;
    else {
      const a = t;
      if ((o = a.abortSignal) != null && o.aborted)
        return Promise.reject(a.abortSignal.reason);
      r = a.signature;
    }
    let i;
    try {
      i = Er.decode(r);
    } catch {
      throw new Error("signature must be base58 encoded: " + r);
    }
    return _n(i.length === 64, "signature has invalid length"), typeof t == "string" ? await this.confirmTransactionUsingLegacyTimeoutStrategy({
      commitment: n || this.commitment,
      signature: r
    }) : "lastValidBlockHeight" in t ? await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
      commitment: n || this.commitment,
      strategy: t
    }) : await this.confirmTransactionUsingDurableNonceStrategy({
      commitment: n || this.commitment,
      strategy: t
    });
  }
  getCancellationPromise(t) {
    return new Promise((n, r) => {
      t != null && (t.aborted ? r(t.reason) : t.addEventListener("abort", () => {
        r(t.reason);
      }));
    });
  }
  getTransactionConfirmationPromise({
    commitment: t,
    signature: n
  }) {
    let r, i, o = !1;
    const a = new Promise((c, l) => {
      try {
        r = this.onSignature(n, (f, d) => {
          r = void 0;
          const h = {
            context: d,
            value: f
          };
          c({
            __type: Eo.PROCESSED,
            response: h
          });
        }, t);
        const u = new Promise((f) => {
          r == null ? f() : i = this._onSubscriptionStateChange(r, (d) => {
            d === "subscribed" && f();
          });
        });
        (async () => {
          if (await u, o)
            return;
          const f = await this.getSignatureStatus(n);
          if (o || f == null)
            return;
          const {
            context: d,
            value: h
          } = f;
          if (h != null)
            if (h != null && h.err)
              l(h.err);
            else {
              switch (t) {
                case "confirmed":
                case "single":
                case "singleGossip": {
                  if (h.confirmationStatus === "processed")
                    return;
                  break;
                }
                case "finalized":
                case "max":
                case "root": {
                  if (h.confirmationStatus === "processed" || h.confirmationStatus === "confirmed")
                    return;
                  break;
                }
                case "processed":
                case "recent":
              }
              o = !0, c({
                __type: Eo.PROCESSED,
                response: {
                  context: d,
                  value: h
                }
              });
            }
        })();
      } catch (u) {
        l(u);
      }
    });
    return {
      abortConfirmation: () => {
        i && (i(), i = void 0), r != null && (this.removeSignatureListener(r), r = void 0);
      },
      confirmationPromise: a
    };
  }
  async confirmTransactionUsingBlockHeightExceedanceStrategy({
    commitment: t,
    strategy: {
      abortSignal: n,
      lastValidBlockHeight: r,
      signature: i
    }
  }) {
    let o = !1;
    const a = new Promise((f) => {
      const d = async () => {
        try {
          return await this.getBlockHeight(t);
        } catch {
          return -1;
        }
      };
      (async () => {
        let h = await d();
        if (!o) {
          for (; h <= r; )
            if (await yc(1e3), o || (h = await d(), o))
              return;
          f({
            __type: Eo.BLOCKHEIGHT_EXCEEDED
          });
        }
      })();
    }), {
      abortConfirmation: s,
      confirmationPromise: c
    } = this.getTransactionConfirmationPromise({
      commitment: t,
      signature: i
    }), l = this.getCancellationPromise(n);
    let u;
    try {
      const f = await Promise.race([l, c, a]);
      if (f.__type === Eo.PROCESSED)
        u = f.response;
      else
        throw new Tk(i);
    } finally {
      o = !0, s();
    }
    return u;
  }
  async confirmTransactionUsingDurableNonceStrategy({
    commitment: t,
    strategy: {
      abortSignal: n,
      minContextSlot: r,
      nonceAccountPubkey: i,
      nonceValue: o,
      signature: a
    }
  }) {
    let s = !1;
    const c = new Promise((h) => {
      let g = o, w = null;
      const b = async () => {
        try {
          const {
            context: I,
            value: A
          } = await this.getNonceAndContext(i, {
            commitment: t,
            minContextSlot: r
          });
          return w = I.slot, A == null ? void 0 : A.nonce;
        } catch {
          return g;
        }
      };
      (async () => {
        if (g = await b(), !s)
          for (; ; ) {
            if (o !== g) {
              h({
                __type: Eo.NONCE_INVALID,
                slotInWhichNonceDidAdvance: w
              });
              return;
            }
            if (await yc(2e3), s || (g = await b(), s))
              return;
          }
      })();
    }), {
      abortConfirmation: l,
      confirmationPromise: u
    } = this.getTransactionConfirmationPromise({
      commitment: t,
      signature: a
    }), f = this.getCancellationPromise(n);
    let d;
    try {
      const h = await Promise.race([f, u, c]);
      if (h.__type === Eo.PROCESSED)
        d = h.response;
      else {
        let g;
        for (; ; ) {
          const w = await this.getSignatureStatus(a);
          if (w == null)
            break;
          if (w.context.slot < (h.slotInWhichNonceDidAdvance ?? r)) {
            await yc(400);
            continue;
          }
          g = w;
          break;
        }
        if (g != null && g.value) {
          const w = t || "finalized", {
            confirmationStatus: b
          } = g.value;
          switch (w) {
            case "processed":
            case "recent":
              if (b !== "processed" && b !== "confirmed" && b !== "finalized")
                throw new Ru(a);
              break;
            case "confirmed":
            case "single":
            case "singleGossip":
              if (b !== "confirmed" && b !== "finalized")
                throw new Ru(a);
              break;
            case "finalized":
            case "max":
            case "root":
              if (b !== "finalized")
                throw new Ru(a);
              break;
            default:
              ((I) => {
              })(w);
          }
          d = {
            context: g.context,
            value: {
              err: g.value.err
            }
          };
        } else
          throw new Ru(a);
      }
    } finally {
      s = !0, l();
    }
    return d;
  }
  async confirmTransactionUsingLegacyTimeoutStrategy({
    commitment: t,
    signature: n
  }) {
    let r;
    const i = new Promise((c) => {
      let l = this._confirmTransactionInitialTimeout || 6e4;
      switch (t) {
        case "processed":
        case "recent":
        case "single":
        case "confirmed":
        case "singleGossip": {
          l = this._confirmTransactionInitialTimeout || 3e4;
          break;
        }
      }
      r = setTimeout(() => c({
        __type: Eo.TIMED_OUT,
        timeoutMs: l
      }), l);
    }), {
      abortConfirmation: o,
      confirmationPromise: a
    } = this.getTransactionConfirmationPromise({
      commitment: t,
      signature: n
    });
    let s;
    try {
      const c = await Promise.race([a, i]);
      if (c.__type === Eo.PROCESSED)
        s = c.response;
      else
        throw new xk(n, c.timeoutMs / 1e3);
    } finally {
      clearTimeout(r), o();
    }
    return s;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getClusterNodes() {
    const t = await this._rpcRequest("getClusterNodes", []), n = Ve(t, Vt(Ze(dY)));
    if ("error" in n)
      throw new bt(n.error, "failed to get cluster nodes");
    return n.result;
  }
  /**
   * Return the list of nodes that are currently participating in the cluster
   */
  async getVoteAccounts(t) {
    const n = this._buildArgs([], t), r = await this._rpcRequest("getVoteAccounts", n), i = Ve(r, hY);
    if ("error" in i)
      throw new bt(i.error, "failed to get vote accounts");
    return i.result;
  }
  /**
   * Fetch the current slot that the node is processing
   */
  async getSlot(t) {
    const {
      commitment: n,
      config: r
    } = cr(t), i = this._buildArgs([], n, void 0, r), o = await this._rpcRequest("getSlot", i), a = Ve(o, Vt(pe()));
    if ("error" in a)
      throw new bt(a.error, "failed to get slot");
    return a.result;
  }
  /**
   * Fetch the current slot leader of the cluster
   */
  async getSlotLeader(t) {
    const {
      commitment: n,
      config: r
    } = cr(t), i = this._buildArgs([], n, void 0, r), o = await this._rpcRequest("getSlotLeader", i), a = Ve(o, Vt(Ke()));
    if ("error" in a)
      throw new bt(a.error, "failed to get slot leader");
    return a.result;
  }
  /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */
  async getSlotLeaders(t, n) {
    const r = [t, n], i = await this._rpcRequest("getSlotLeaders", r), o = Ve(i, Vt(Ze(Br)));
    if ("error" in o)
      throw new bt(o.error, "failed to get slot leaders");
    return o.result;
  }
  /**
   * Fetch the current status of a signature
   */
  async getSignatureStatus(t, n) {
    const {
      context: r,
      value: i
    } = await this.getSignatureStatuses([t], n);
    _n(i.length === 1);
    const o = i[0];
    return {
      context: r,
      value: o
    };
  }
  /**
   * Fetch the current statuses of a batch of signatures
   */
  async getSignatureStatuses(t, n) {
    const r = [t];
    n && r.push(n);
    const i = await this._rpcRequest("getSignatureStatuses", r), o = Ve(i, gY);
    if ("error" in o)
      throw new bt(o.error, "failed to get signature status");
    return o.result;
  }
  /**
   * Fetch the current transaction count of the cluster
   */
  async getTransactionCount(t) {
    const {
      commitment: n,
      config: r
    } = cr(t), i = this._buildArgs([], n, void 0, r), o = await this._rpcRequest("getTransactionCount", i), a = Ve(o, Vt(pe()));
    if ("error" in a)
      throw new bt(a.error, "failed to get transaction count");
    return a.result;
  }
  /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */
  async getTotalSupply(t) {
    return (await this.getSupply({
      commitment: t,
      excludeNonCirculatingAccountsList: !0
    })).value.total;
  }
  /**
   * Fetch the cluster InflationGovernor parameters
   */
  async getInflationGovernor(t) {
    const n = this._buildArgs([], t), r = await this._rpcRequest("getInflationGovernor", n), i = Ve(r, zG);
    if ("error" in i)
      throw new bt(i.error, "failed to get inflation");
    return i.result;
  }
  /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */
  async getInflationReward(t, n, r) {
    const {
      commitment: i,
      config: o
    } = cr(r), a = this._buildArgs([t.map((l) => l.toBase58())], i, void 0, {
      ...o,
      epoch: n ?? (o == null ? void 0 : o.epoch)
    }), s = await this._rpcRequest("getInflationReward", a), c = Ve(s, kG);
    if ("error" in c)
      throw new bt(c.error, "failed to get inflation reward");
    return c.result;
  }
  /**
   * Fetch the specific inflation values for the current epoch
   */
  async getInflationRate() {
    const t = await this._rpcRequest("getInflationRate", []), n = Ve(t, FG);
    if ("error" in n)
      throw new bt(n.error, "failed to get inflation rate");
    return n.result;
  }
  /**
   * Fetch the Epoch Info parameters
   */
  async getEpochInfo(t) {
    const {
      commitment: n,
      config: r
    } = cr(t), i = this._buildArgs([], n, void 0, r), o = await this._rpcRequest("getEpochInfo", i), a = Ve(o, $G);
    if ("error" in a)
      throw new bt(a.error, "failed to get epoch info");
    return a.result;
  }
  /**
   * Fetch the Epoch Schedule parameters
   */
  async getEpochSchedule() {
    const t = await this._rpcRequest("getEpochSchedule", []), n = Ve(t, WG);
    if ("error" in n)
      throw new bt(n.error, "failed to get epoch schedule");
    const r = n.result;
    return new mR(r.slotsPerEpoch, r.leaderScheduleSlotOffset, r.warmup, r.firstNormalEpoch, r.firstNormalSlot);
  }
  /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */
  async getLeaderSchedule() {
    const t = await this._rpcRequest("getLeaderSchedule", []), n = Ve(t, KG);
    if ("error" in n)
      throw new bt(n.error, "failed to get leader schedule");
    return n.result;
  }
  /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */
  async getMinimumBalanceForRentExemption(t, n) {
    const r = this._buildArgs([t], n), i = await this._rpcRequest("getMinimumBalanceForRentExemption", r), o = Ve(i, bY);
    return "error" in o ? (console.warn("Unable to fetch minimum balance for rent exemption"), 0) : o.result;
  }
  /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhashAndContext(t) {
    const n = this._buildArgs([], t), r = await this._rpcRequest("getRecentBlockhash", n), i = Ve(r, TY);
    if ("error" in i)
      throw new bt(i.error, "failed to get recent blockhash");
    return i.result;
  }
  /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */
  async getRecentPerformanceSamples(t) {
    const n = await this._rpcRequest("getRecentPerformanceSamples", t ? [t] : []), r = Ve(n, OY);
    if ("error" in r)
      throw new bt(r.error, "failed to get recent performance samples");
    return r.result;
  }
  /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */
  async getFeeCalculatorForBlockhash(t, n) {
    const r = this._buildArgs([t], n), i = await this._rpcRequest("getFeeCalculatorForBlockhash", r), o = Ve(i, PY);
    if ("error" in o)
      throw new bt(o.error, "failed to get fee calculator");
    const {
      context: a,
      value: s
    } = o.result;
    return {
      context: a,
      value: s !== null ? s.feeCalculator : null
    };
  }
  /**
   * Fetch the fee for a message from the cluster, return with context
   */
  async getFeeForMessage(t, n) {
    const r = qt(t.serialize()).toString("base64"), i = this._buildArgs([r], n), o = await this._rpcRequest("getFeeForMessage", i), a = Ve(o, Or(Je(pe())));
    if ("error" in a)
      throw new bt(a.error, "failed to get fee for message");
    if (a.result === null)
      throw new Error("invalid blockhash");
    return a.result;
  }
  /**
   * Fetch a list of prioritization fees from recent blocks.
   */
  async getRecentPrioritizationFees(t) {
    var a;
    const n = (a = t == null ? void 0 : t.lockedWritableAccounts) == null ? void 0 : a.map((s) => s.toBase58()), r = this._buildArgs(n != null && n.length ? [n] : []), i = await this._rpcRequest("getRecentPrioritizationFees", r), o = Ve(i, LG);
    if ("error" in o)
      throw new bt(o.error, "failed to get recent prioritization fees");
    return o.result;
  }
  /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */
  async getRecentBlockhash(t) {
    try {
      return (await this.getRecentBlockhashAndContext(t)).value;
    } catch (n) {
      throw new Error("failed to get recent blockhash: " + n);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhash(t) {
    try {
      return (await this.getLatestBlockhashAndContext(t)).value;
    } catch (n) {
      throw new Error("failed to get recent blockhash: " + n);
    }
  }
  /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */
  async getLatestBlockhashAndContext(t) {
    const {
      commitment: n,
      config: r
    } = cr(t), i = this._buildArgs([], n, void 0, r), o = await this._rpcRequest("getLatestBlockhash", i), a = Ve(o, xY);
    if ("error" in a)
      throw new bt(a.error, "failed to get latest blockhash");
    return a.result;
  }
  /**
   * Fetch the node version
   */
  async getVersion() {
    const t = await this._rpcRequest("getVersion", []), n = Ve(t, Vt(DG));
    if ("error" in n)
      throw new bt(n.error, "failed to get version");
    return n.result;
  }
  /**
   * Fetch the genesis hash
   */
  async getGenesisHash() {
    const t = await this._rpcRequest("getGenesisHash", []), n = Ve(t, Vt(Ke()));
    if ("error" in n)
      throw new bt(n.error, "failed to get genesis hash");
    return n.result;
  }
  /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch a processed block from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getBlock(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = this._buildArgsAtLeastConfirmed([t], r, void 0, i), a = await this._rpcRequest("getBlock", o);
    try {
      switch (i == null ? void 0 : i.transactionDetails) {
        case "accounts": {
          const s = Ve(a, SY);
          if ("error" in s)
            throw s.error;
          return s.result;
        }
        case "none": {
          const s = Ve(a, vY);
          if ("error" in s)
            throw s.error;
          return s.result;
        }
        default: {
          const s = Ve(a, wY);
          if ("error" in s)
            throw s.error;
          const {
            result: c
          } = s;
          return c ? {
            ...c,
            transactions: c.transactions.map(({
              transaction: l,
              meta: u,
              version: f
            }) => ({
              meta: u,
              transaction: {
                ...l,
                message: r1(f, l.message)
              },
              version: f
            }))
          } : null;
        }
      }
    } catch (s) {
      throw new bt(s, "failed to get confirmed block");
    }
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */
  // eslint-disable-next-line no-dupe-class-members
  async getParsedBlock(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = this._buildArgsAtLeastConfirmed([t], r, "jsonParsed", i), a = await this._rpcRequest("getBlock", o);
    try {
      switch (i == null ? void 0 : i.transactionDetails) {
        case "accounts": {
          const s = Ve(a, AY);
          if ("error" in s)
            throw s.error;
          return s.result;
        }
        case "none": {
          const s = Ve(a, IY);
          if ("error" in s)
            throw s.error;
          return s.result;
        }
        default: {
          const s = Ve(a, EY);
          if ("error" in s)
            throw s.error;
          return s.result;
        }
      }
    } catch (s) {
      throw new bt(s, "failed to get block");
    }
  }
  /*
   * Returns the current block height of the node
   */
  /*
   * Returns recent block production information from the current or previous epoch
   */
  async getBlockProduction(t) {
    let n, r;
    if (typeof t == "string")
      r = t;
    else if (t) {
      const {
        commitment: s,
        ...c
      } = t;
      r = s, n = c;
    }
    const i = this._buildArgs([], r, "base64", n), o = await this._rpcRequest("getBlockProduction", i), a = Ve(o, RG);
    if ("error" in a)
      throw new bt(a.error, "failed to get block production information");
    return a.result;
  }
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransaction(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = this._buildArgsAtLeastConfirmed([t], r, void 0, i), a = await this._rpcRequest("getTransaction", o), s = Ve(a, i1);
    if ("error" in s)
      throw new bt(s.error, "failed to get transaction");
    const c = s.result;
    return c && {
      ...c,
      transaction: {
        ...c.transaction,
        message: r1(c.version, c.transaction.message)
      }
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */
  async getParsedTransaction(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = this._buildArgsAtLeastConfirmed([t], r, "jsonParsed", i), a = await this._rpcRequest("getTransaction", o), s = Ve(a, Sg);
    if ("error" in s)
      throw new bt(s.error, "failed to get transaction");
    return s.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */
  async getParsedTransactions(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = t.map((c) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([c], r, "jsonParsed", i)
    }));
    return (await this._rpcBatchRequest(o)).map((c) => {
      const l = Ve(c, Sg);
      if ("error" in l)
        throw new bt(l.error, "failed to get transactions");
      return l.result;
    });
  }
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */
  /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */
  // eslint-disable-next-line no-dupe-class-members
  async getTransactions(t, n) {
    const {
      commitment: r,
      config: i
    } = cr(n), o = t.map((c) => ({
      methodName: "getTransaction",
      args: this._buildArgsAtLeastConfirmed([c], r, void 0, i)
    }));
    return (await this._rpcBatchRequest(o)).map((c) => {
      const l = Ve(c, i1);
      if ("error" in l)
        throw new bt(l.error, "failed to get transactions");
      const u = l.result;
      return u && {
        ...u,
        transaction: {
          ...u.transaction,
          message: r1(u.version, u.transaction.message)
        }
      };
    });
  }
  /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */
  async getConfirmedBlock(t, n) {
    const r = this._buildArgsAtLeastConfirmed([t], n), i = await this._rpcRequest("getConfirmedBlock", r), o = Ve(i, kY);
    if ("error" in o)
      throw new bt(o.error, "failed to get confirmed block");
    const a = o.result;
    if (!a)
      throw new Error("Confirmed block " + t + " not found");
    const s = {
      ...a,
      transactions: a.transactions.map(({
        transaction: c,
        meta: l
      }) => {
        const u = new zo(c.message);
        return {
          meta: l,
          transaction: {
            ...c,
            message: u
          }
        };
      })
    };
    return {
      ...s,
      transactions: s.transactions.map(({
        transaction: c,
        meta: l
      }) => ({
        meta: l,
        transaction: On.populate(c.message, c.signatures)
      }))
    };
  }
  /**
   * Fetch confirmed blocks between two slots
   */
  async getBlocks(t, n, r) {
    const i = this._buildArgsAtLeastConfirmed(n !== void 0 ? [t, n] : [t], r), o = await this._rpcRequest("getBlocks", i), a = Ve(o, Vt(Ze(pe())));
    if ("error" in a)
      throw new bt(a.error, "failed to get blocks");
    return a.result;
  }
  /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */
  async getBlockSignatures(t, n) {
    const r = this._buildArgsAtLeastConfirmed([t], n, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), i = await this._rpcRequest("getBlock", r), o = Ve(i, iM);
    if ("error" in o)
      throw new bt(o.error, "failed to get block");
    const a = o.result;
    if (!a)
      throw new Error("Block " + t + " not found");
    return a;
  }
  /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */
  async getConfirmedBlockSignatures(t, n) {
    const r = this._buildArgsAtLeastConfirmed([t], n, void 0, {
      transactionDetails: "signatures",
      rewards: !1
    }), i = await this._rpcRequest("getConfirmedBlock", r), o = Ve(i, iM);
    if ("error" in o)
      throw new bt(o.error, "failed to get confirmed block");
    const a = o.result;
    if (!a)
      throw new Error("Confirmed block " + t + " not found");
    return a;
  }
  /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */
  async getConfirmedTransaction(t, n) {
    const r = this._buildArgsAtLeastConfirmed([t], n), i = await this._rpcRequest("getConfirmedTransaction", r), o = Ve(i, i1);
    if ("error" in o)
      throw new bt(o.error, "failed to get transaction");
    const a = o.result;
    if (!a)
      return a;
    const s = new zo(a.transaction.message), c = a.transaction.signatures;
    return {
      ...a,
      transaction: On.populate(s, c)
    };
  }
  /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */
  async getParsedConfirmedTransaction(t, n) {
    const r = this._buildArgsAtLeastConfirmed([t], n, "jsonParsed"), i = await this._rpcRequest("getConfirmedTransaction", r), o = Ve(i, Sg);
    if ("error" in o)
      throw new bt(o.error, "failed to get confirmed transaction");
    return o.result;
  }
  /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */
  async getParsedConfirmedTransactions(t, n) {
    const r = t.map((a) => ({
      methodName: "getConfirmedTransaction",
      args: this._buildArgsAtLeastConfirmed([a], n, "jsonParsed")
    }));
    return (await this._rpcBatchRequest(r)).map((a) => {
      const s = Ve(a, Sg);
      if ("error" in s)
        throw new bt(s.error, "failed to get confirmed transactions");
      return s.result;
    });
  }
  /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */
  async getConfirmedSignaturesForAddress(t, n, r) {
    let i = {}, o = await this.getFirstAvailableBlock();
    for (; !("until" in i) && (n--, !(n <= 0 || n < o)); )
      try {
        const c = await this.getConfirmedBlockSignatures(n, "finalized");
        c.signatures.length > 0 && (i.until = c.signatures[c.signatures.length - 1].toString());
      } catch (c) {
        if (c instanceof Error && c.message.includes("skipped"))
          continue;
        throw c;
      }
    let a = await this.getSlot("finalized");
    for (; !("before" in i) && (r++, !(r > a)); )
      try {
        const c = await this.getConfirmedBlockSignatures(r);
        c.signatures.length > 0 && (i.before = c.signatures[c.signatures.length - 1].toString());
      } catch (c) {
        if (c instanceof Error && c.message.includes("skipped"))
          continue;
        throw c;
      }
    return (await this.getConfirmedSignaturesForAddress2(t, i)).map((c) => c.signature);
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getConfirmedSignaturesForAddress2(t, n, r) {
    const i = this._buildArgsAtLeastConfirmed([t.toBase58()], r, void 0, n), o = await this._rpcRequest("getConfirmedSignaturesForAddress2", i), a = Ve(o, tY);
    if ("error" in a)
      throw new bt(a.error, "failed to get confirmed signatures for address");
    return a.result;
  }
  /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */
  async getSignaturesForAddress(t, n, r) {
    const i = this._buildArgsAtLeastConfirmed([t.toBase58()], r, void 0, n), o = await this._rpcRequest("getSignaturesForAddress", i), a = Ve(o, nY);
    if ("error" in a)
      throw new bt(a.error, "failed to get signatures for address");
    return a.result;
  }
  async getAddressLookupTable(t, n) {
    const {
      context: r,
      value: i
    } = await this.getAccountInfoAndContext(t, n);
    let o = null;
    return i !== null && (o = new dA({
      key: t,
      state: dA.deserialize(i.data)
    })), {
      context: r,
      value: o
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */
  async getNonceAndContext(t, n) {
    const {
      context: r,
      value: i
    } = await this.getAccountInfoAndContext(t, n);
    let o = null;
    return i !== null && (o = c_.fromAccountData(i.data)), {
      context: r,
      value: o
    };
  }
  /**
   * Fetch the contents of a Nonce account from the cluster
   */
  async getNonce(t, n) {
    return await this.getNonceAndContext(t, n).then((r) => r.value).catch((r) => {
      throw new Error("failed to get nonce for account " + t.toBase58() + ": " + r);
    });
  }
  /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */
  async requestAirdrop(t, n) {
    const r = await this._rpcRequest("requestAirdrop", [t.toBase58(), n]), i = Ve(r, BY);
    if ("error" in i)
      throw new bt(i.error, `airdrop to ${t.toBase58()} failed`);
    return i.result;
  }
  /**
   * @internal
   */
  async _blockhashWithExpiryBlockHeight(t) {
    if (!t) {
      for (; this._pollingBlockhash; )
        await yc(100);
      const r = Date.now() - this._blockhashInfo.lastFetch >= wR;
      if (this._blockhashInfo.latestBlockhash !== null && !r)
        return this._blockhashInfo.latestBlockhash;
    }
    return await this._pollNewBlockhash();
  }
  /**
   * @internal
   */
  async _pollNewBlockhash() {
    this._pollingBlockhash = !0;
    try {
      const t = Date.now(), n = this._blockhashInfo.latestBlockhash, r = n ? n.blockhash : null;
      for (let i = 0; i < 50; i++) {
        const o = await this.getLatestBlockhash("finalized");
        if (r !== o.blockhash)
          return this._blockhashInfo = {
            latestBlockhash: o,
            lastFetch: Date.now(),
            transactionSignatures: [],
            simulatedSignatures: []
          }, o;
        await yc(mG / 2);
      }
      throw new Error(`Unable to obtain a new blockhash after ${Date.now() - t}ms`);
    } finally {
      this._pollingBlockhash = !1;
    }
  }
  /**
   * get the stake minimum delegation
   */
  async getStakeMinimumDelegation(t) {
    const {
      commitment: n,
      config: r
    } = cr(t), i = this._buildArgs([], n, "base64", r), o = await this._rpcRequest("getStakeMinimumDelegation", i), a = Ve(o, Or(pe()));
    if ("error" in a)
      throw new bt(a.error, "failed to get stake minimum delegation");
    return a.result;
  }
  /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */
  /**
   * Simulate a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async simulateTransaction(t, n, r) {
    if ("message" in t) {
      const w = t.serialize(), b = it.Buffer.from(w).toString("base64");
      if (Array.isArray(n) || r !== void 0)
        throw new Error("Invalid arguments");
      const I = n || {};
      I.encoding = "base64", "commitment" in I || (I.commitment = this.commitment);
      const A = [b, I], x = await this._rpcRequest("simulateTransaction", A), N = Ve(x, nM);
      if ("error" in N)
        throw new Error("failed to simulate transaction: " + N.error.message);
      return N.result;
    }
    let i;
    if (t instanceof On) {
      let g = t;
      i = new On(), i.feePayer = g.feePayer, i.instructions = t.instructions, i.nonceInfo = g.nonceInfo, i.signatures = g.signatures;
    } else
      i = On.populate(t), i._message = i._json = void 0;
    if (n !== void 0 && !Array.isArray(n))
      throw new Error("Invalid arguments");
    const o = n;
    if (i.nonceInfo && o)
      i.sign(...o);
    else {
      let g = this._disableBlockhashCaching;
      for (; ; ) {
        const w = await this._blockhashWithExpiryBlockHeight(g);
        if (i.lastValidBlockHeight = w.lastValidBlockHeight, i.recentBlockhash = w.blockhash, !o)
          break;
        if (i.sign(...o), !i.signature)
          throw new Error("!signature");
        const b = i.signature.toString("base64");
        if (!this._blockhashInfo.simulatedSignatures.includes(b) && !this._blockhashInfo.transactionSignatures.includes(b)) {
          this._blockhashInfo.simulatedSignatures.push(b);
          break;
        } else
          g = !0;
      }
    }
    const a = i._compile(), s = a.serialize(), l = i._serialize(s).toString("base64"), u = {
      encoding: "base64",
      commitment: this.commitment
    };
    if (r) {
      const g = (Array.isArray(r) ? r : a.nonProgramIds()).map((w) => w.toBase58());
      u.accounts = {
        encoding: "base64",
        addresses: g
      };
    }
    o && (u.sigVerify = !0);
    const f = [l, u], d = await this._rpcRequest("simulateTransaction", f), h = Ve(d, nM);
    if ("error" in h) {
      let g;
      if ("data" in h.error && (g = h.error.data.logs, g && Array.isArray(g))) {
        const w = `
    `, b = w + g.join(w);
        console.error(h.error.message, b);
      }
      throw new gl("failed to simulate transaction: " + h.error.message, g);
    }
    return h.result;
  }
  /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */
  /**
   * Sign and send a transaction
   */
  // eslint-disable-next-line no-dupe-class-members
  async sendTransaction(t, n, r) {
    if ("version" in t) {
      if (n && Array.isArray(n))
        throw new Error("Invalid arguments");
      const a = t.serialize();
      return await this.sendRawTransaction(a, n);
    }
    if (n === void 0 || !Array.isArray(n))
      throw new Error("Invalid arguments");
    const i = n;
    if (t.nonceInfo)
      t.sign(...i);
    else {
      let a = this._disableBlockhashCaching;
      for (; ; ) {
        const s = await this._blockhashWithExpiryBlockHeight(a);
        if (t.lastValidBlockHeight = s.lastValidBlockHeight, t.recentBlockhash = s.blockhash, t.sign(...i), !t.signature)
          throw new Error("!signature");
        const c = t.signature.toString("base64");
        if (this._blockhashInfo.transactionSignatures.includes(c))
          a = !0;
        else {
          this._blockhashInfo.transactionSignatures.push(c);
          break;
        }
      }
    }
    const o = t.serialize();
    return await this.sendRawTransaction(o, r);
  }
  /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */
  async sendRawTransaction(t, n) {
    const r = qt(t).toString("base64");
    return await this.sendEncodedTransaction(r, n);
  }
  /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */
  async sendEncodedTransaction(t, n) {
    const r = {
      encoding: "base64"
    }, i = n && n.skipPreflight, o = n && n.preflightCommitment || this.commitment;
    n && n.maxRetries != null && (r.maxRetries = n.maxRetries), n && n.minContextSlot != null && (r.minContextSlot = n.minContextSlot), i && (r.skipPreflight = i), o && (r.preflightCommitment = o);
    const a = [t, r], s = await this._rpcRequest("sendTransaction", a), c = Ve(s, CY);
    if ("error" in c) {
      let l;
      throw "data" in c.error && (l = c.error.data.logs), new gl("failed to send transaction: " + c.error.message, l);
    }
    return c.result;
  }
  /**
   * @internal
   */
  _wsOnOpen() {
    this._rpcWebSocketConnected = !0, this._rpcWebSocketHeartbeat = setInterval(() => {
      (async () => {
        try {
          await this._rpcWebSocket.notify("ping");
        } catch {
        }
      })();
    }, 5e3), this._updateSubscriptions();
  }
  /**
   * @internal
   */
  _wsOnError(t) {
    this._rpcWebSocketConnected = !1, console.error("ws error:", t.message);
  }
  /**
   * @internal
   */
  _wsOnClose(t) {
    if (this._rpcWebSocketConnected = !1, this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER, this._rpcWebSocketIdleTimeout && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null), this._rpcWebSocketHeartbeat && (clearInterval(this._rpcWebSocketHeartbeat), this._rpcWebSocketHeartbeat = null), t === 1e3) {
      this._updateSubscriptions();
      return;
    }
    this._subscriptionCallbacksByServerSubscriptionId = {}, Object.entries(this._subscriptionsByHash).forEach(([n, r]) => {
      this._setSubscription(n, {
        ...r,
        state: "pending"
      });
    });
  }
  /**
   * @internal
   */
  _setSubscription(t, n) {
    var i;
    const r = (i = this._subscriptionsByHash[t]) == null ? void 0 : i.state;
    if (this._subscriptionsByHash[t] = n, r !== n.state) {
      const o = this._subscriptionStateChangeCallbacksByHash[t];
      o && o.forEach((a) => {
        try {
          a(n.state);
        } catch {
        }
      });
    }
  }
  /**
   * @internal
   */
  _onSubscriptionStateChange(t, n) {
    var r;
    const i = this._subscriptionHashByClientSubscriptionId[t];
    if (i == null)
      return () => {
      };
    const o = (r = this._subscriptionStateChangeCallbacksByHash)[i] || (r[i] = /* @__PURE__ */ new Set());
    return o.add(n), () => {
      o.delete(n), o.size === 0 && delete this._subscriptionStateChangeCallbacksByHash[i];
    };
  }
  /**
   * @internal
   */
  async _updateSubscriptions() {
    if (Object.keys(this._subscriptionsByHash).length === 0) {
      this._rpcWebSocketConnected && (this._rpcWebSocketConnected = !1, this._rpcWebSocketIdleTimeout = setTimeout(() => {
        this._rpcWebSocketIdleTimeout = null;
        try {
          this._rpcWebSocket.close();
        } catch (r) {
          r instanceof Error && console.log(`Error when closing socket connection: ${r.message}`);
        }
      }, 500));
      return;
    }
    if (this._rpcWebSocketIdleTimeout !== null && (clearTimeout(this._rpcWebSocketIdleTimeout), this._rpcWebSocketIdleTimeout = null, this._rpcWebSocketConnected = !0), !this._rpcWebSocketConnected) {
      this._rpcWebSocket.connect();
      return;
    }
    const t = this._rpcWebSocketGeneration, n = () => t === this._rpcWebSocketGeneration;
    await Promise.all(
      // Don't be tempted to change this to `Object.entries`. We call
      // `_updateSubscriptions` recursively when processing the state,
      // so it's important that we look up the *current* version of
      // each subscription, every time we process a hash.
      Object.keys(this._subscriptionsByHash).map(async (r) => {
        const i = this._subscriptionsByHash[r];
        if (i !== void 0)
          switch (i.state) {
            case "pending":
            case "unsubscribed":
              if (i.callbacks.size === 0) {
                delete this._subscriptionsByHash[r], i.state === "unsubscribed" && delete this._subscriptionCallbacksByServerSubscriptionId[i.serverSubscriptionId], await this._updateSubscriptions();
                return;
              }
              await (async () => {
                const {
                  args: o,
                  method: a
                } = i;
                try {
                  this._setSubscription(r, {
                    ...i,
                    state: "subscribing"
                  });
                  const s = await this._rpcWebSocket.call(a, o);
                  this._setSubscription(r, {
                    ...i,
                    serverSubscriptionId: s,
                    state: "subscribed"
                  }), this._subscriptionCallbacksByServerSubscriptionId[s] = i.callbacks, await this._updateSubscriptions();
                } catch (s) {
                  if (s instanceof Error && console.error(`${a} error for argument`, o, s.message), !n())
                    return;
                  this._setSubscription(r, {
                    ...i,
                    state: "pending"
                  }), await this._updateSubscriptions();
                }
              })();
              break;
            case "subscribed":
              i.callbacks.size === 0 && await (async () => {
                const {
                  serverSubscriptionId: o,
                  unsubscribeMethod: a
                } = i;
                if (this._subscriptionsAutoDisposedByRpc.has(o))
                  this._subscriptionsAutoDisposedByRpc.delete(o);
                else {
                  this._setSubscription(r, {
                    ...i,
                    state: "unsubscribing"
                  }), this._setSubscription(r, {
                    ...i,
                    state: "unsubscribing"
                  });
                  try {
                    await this._rpcWebSocket.call(a, [o]);
                  } catch (s) {
                    if (s instanceof Error && console.error(`${a} error:`, s.message), !n())
                      return;
                    this._setSubscription(r, {
                      ...i,
                      state: "subscribed"
                    }), await this._updateSubscriptions();
                    return;
                  }
                }
                this._setSubscription(r, {
                  ...i,
                  state: "unsubscribed"
                }), await this._updateSubscriptions();
              })();
              break;
          }
      })
    );
  }
  /**
   * @internal
   */
  _handleServerNotification(t, n) {
    const r = this._subscriptionCallbacksByServerSubscriptionId[t];
    r !== void 0 && r.forEach((i) => {
      try {
        i(
          ...n
        );
      } catch (o) {
        console.error(o);
      }
    });
  }
  /**
   * @internal
   */
  _wsOnAccountNotification(t) {
    const {
      result: n,
      subscription: r
    } = Ve(t, rY);
    this._handleServerNotification(r, [n.value, n.context]);
  }
  /**
   * @internal
   */
  _makeSubscription(t, n) {
    const r = this._nextClientSubscriptionId++, i = eM([t.method, n]), o = this._subscriptionsByHash[i];
    return o === void 0 ? this._subscriptionsByHash[i] = {
      ...t,
      args: n,
      callbacks: /* @__PURE__ */ new Set([t.callback]),
      state: "pending"
    } : o.callbacks.add(t.callback), this._subscriptionHashByClientSubscriptionId[r] = i, this._subscriptionDisposeFunctionsByClientSubscriptionId[r] = async () => {
      delete this._subscriptionDisposeFunctionsByClientSubscriptionId[r], delete this._subscriptionHashByClientSubscriptionId[r];
      const a = this._subscriptionsByHash[i];
      _n(a !== void 0, `Could not find a \`Subscription\` when tearing down client subscription #${r}`), a.callbacks.delete(t.callback), await this._updateSubscriptions();
    }, this._updateSubscriptions(), r;
  }
  /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */
  onAccountChange(t, n, r) {
    const i = this._buildArgs(
      [t.toBase58()],
      r || this._commitment || "finalized",
      // Apply connection/server default.
      "base64"
    );
    return this._makeSubscription({
      callback: n,
      method: "accountSubscribe",
      unsubscribeMethod: "accountUnsubscribe"
    }, i);
  }
  /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeAccountChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "account change");
  }
  /**
   * @internal
   */
  _wsOnProgramAccountNotification(t) {
    const {
      result: n,
      subscription: r
    } = Ve(t, oY);
    this._handleServerNotification(r, [{
      accountId: n.value.pubkey,
      accountInfo: n.value.account
    }, n.context]);
  }
  /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */
  onProgramAccountChange(t, n, r, i) {
    const o = this._buildArgs(
      [t.toBase58()],
      r || this._commitment || "finalized",
      // Apply connection/server default.
      "base64",
      i ? {
        filters: i
      } : void 0
      /* extra */
    );
    return this._makeSubscription({
      callback: n,
      method: "programSubscribe",
      unsubscribeMethod: "programUnsubscribe"
    }, o);
  }
  /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeProgramAccountChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "program account change");
  }
  /**
   * Registers a callback to be invoked whenever logs are emitted.
   */
  onLogs(t, n, r) {
    const i = this._buildArgs(
      [typeof t == "object" ? {
        mentions: [t.toString()]
      } : t],
      r || this._commitment || "finalized"
      // Apply connection/server default.
    );
    return this._makeSubscription({
      callback: n,
      method: "logsSubscribe",
      unsubscribeMethod: "logsUnsubscribe"
    }, i);
  }
  /**
   * Deregister a logs callback.
   *
   * @param id client subscription id to deregister.
   */
  async removeOnLogsListener(t) {
    await this._unsubscribeClientSubscription(t, "logs");
  }
  /**
   * @internal
   */
  _wsOnLogsNotification(t) {
    const {
      result: n,
      subscription: r
    } = Ve(t, RY);
    this._handleServerNotification(r, [n.value, n.context]);
  }
  /**
   * @internal
   */
  _wsOnSlotNotification(t) {
    const {
      result: n,
      subscription: r
    } = Ve(t, sY);
    this._handleServerNotification(r, [n]);
  }
  /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */
  onSlotChange(t) {
    return this._makeSubscription(
      {
        callback: t,
        method: "slotSubscribe",
        unsubscribeMethod: "slotUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSlotChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "slot change");
  }
  /**
   * @internal
   */
  _wsOnSlotUpdatesNotification(t) {
    const {
      result: n,
      subscription: r
    } = Ve(t, uY);
    this._handleServerNotification(r, [n]);
  }
  /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */
  onSlotUpdate(t) {
    return this._makeSubscription(
      {
        callback: t,
        method: "slotsUpdatesSubscribe",
        unsubscribeMethod: "slotsUpdatesUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a slot update notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSlotUpdateListener(t) {
    await this._unsubscribeClientSubscription(t, "slot update");
  }
  /**
   * @internal
   */
  async _unsubscribeClientSubscription(t, n) {
    const r = this._subscriptionDisposeFunctionsByClientSubscriptionId[t];
    r ? await r() : console.warn(`Ignored unsubscribe request because an active subscription with id \`${t}\` for '${n}' events could not be found.`);
  }
  _buildArgs(t, n, r, i) {
    const o = n || this._commitment;
    if (o || r || i) {
      let a = {};
      r && (a.encoding = r), o && (a.commitment = o), i && (a = Object.assign(a, i)), t.push(a);
    }
    return t;
  }
  /**
   * @internal
   */
  _buildArgsAtLeastConfirmed(t, n, r, i) {
    const o = n || this._commitment;
    if (o && !["confirmed", "finalized"].includes(o))
      throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
    return this._buildArgs(t, n, r, i);
  }
  /**
   * @internal
   */
  _wsOnSignatureNotification(t) {
    const {
      result: n,
      subscription: r
    } = Ve(t, lY);
    n.value !== "receivedSignature" && this._subscriptionsAutoDisposedByRpc.add(r), this._handleServerNotification(r, n.value === "receivedSignature" ? [{
      type: "received"
    }, n.context] : [{
      type: "status",
      result: n.value
    }, n.context]);
  }
  /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */
  onSignature(t, n, r) {
    const i = this._buildArgs(
      [t],
      r || this._commitment || "finalized"
      // Apply connection/server default.
    ), o = this._makeSubscription({
      callback: (a, s) => {
        if (a.type === "status") {
          n(a.result, s);
          try {
            this.removeSignatureListener(o);
          } catch {
          }
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, i);
    return o;
  }
  /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */
  onSignatureWithOptions(t, n, r) {
    const {
      commitment: i,
      ...o
    } = {
      ...r,
      commitment: r && r.commitment || this._commitment || "finalized"
      // Apply connection/server default.
    }, a = this._buildArgs([t], i, void 0, o), s = this._makeSubscription({
      callback: (c, l) => {
        n(c, l);
        try {
          this.removeSignatureListener(s);
        } catch {
        }
      },
      method: "signatureSubscribe",
      unsubscribeMethod: "signatureUnsubscribe"
    }, a);
    return s;
  }
  /**
   * Deregister a signature notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeSignatureListener(t) {
    await this._unsubscribeClientSubscription(t, "signature result");
  }
  /**
   * @internal
   */
  _wsOnRootNotification(t) {
    const {
      result: n,
      subscription: r
    } = Ve(t, fY);
    this._handleServerNotification(r, [n]);
  }
  /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */
  onRootChange(t) {
    return this._makeSubscription(
      {
        callback: t,
        method: "rootSubscribe",
        unsubscribeMethod: "rootUnsubscribe"
      },
      []
      /* args */
    );
  }
  /**
   * Deregister a root notification callback
   *
   * @param id client subscription id to deregister
   */
  async removeRootChangeListener(t) {
    await this._unsubscribeClientSubscription(t, "root change");
  }
}
class Yu {
  /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param keypair ed25519 keypair
   */
  constructor(t) {
    this._keypair = void 0, this._keypair = t ?? J2();
  }
  /**
   * Generate a new random keypair
   */
  static generate() {
    return new Yu(J2());
  }
  /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options: skip secret key validation
   */
  static fromSecretKey(t, n) {
    if (t.byteLength !== 64)
      throw new Error("bad secret key size");
    const r = t.slice(32, 64);
    if (!n || !n.skipValidation) {
      const i = t.slice(0, 32), o = Vb(i);
      for (let a = 0; a < 32; a++)
        if (r[a] !== o[a])
          throw new Error("provided secretKey is invalid");
    }
    return new Yu({
      publicKey: r,
      secretKey: t
    });
  }
  /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   */
  static fromSeed(t) {
    const n = Vb(t), r = new Uint8Array(64);
    return r.set(t), r.set(n, 32), new Yu({
      publicKey: n,
      secretKey: r
    });
  }
  /**
   * The public key for this keypair
   */
  get publicKey() {
    return new Ae(this._keypair.publicKey);
  }
  /**
   * The raw secret key for this keypair
   */
  get secretKey() {
    return new Uint8Array(this._keypair.secretKey);
  }
}
const Ra = Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: ht([ft("instruction"), yl("recentSlot"), an("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: ht([ft("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: ht([ft("instruction"), yl(), Yr(Qt(), Ds(ft(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: ht([ft("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: ht([ft("instruction")])
  }
});
class jY {
  /**
   * @internal
   */
  constructor() {
  }
  static decodeInstructionType(t) {
    this.checkProgramId(t.programId);
    const r = ft("instruction").decode(t.data);
    let i;
    for (const [o, a] of Object.entries(Ra))
      if (a.index == r) {
        i = o;
        break;
      }
    if (!i)
      throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
    return i;
  }
  static decodeCreateLookupTable(t) {
    this.checkProgramId(t.programId), this.checkKeysLength(t.keys, 4);
    const {
      recentSlot: n
    } = kn(Ra.CreateLookupTable, t.data);
    return {
      authority: t.keys[1].pubkey,
      payer: t.keys[2].pubkey,
      recentSlot: Number(n)
    };
  }
  static decodeExtendLookupTable(t) {
    if (this.checkProgramId(t.programId), t.keys.length < 2)
      throw new Error(`invalid instruction; found ${t.keys.length} keys, expected at least 2`);
    const {
      addresses: n
    } = kn(Ra.ExtendLookupTable, t.data);
    return {
      lookupTable: t.keys[0].pubkey,
      authority: t.keys[1].pubkey,
      payer: t.keys.length > 2 ? t.keys[2].pubkey : void 0,
      addresses: n.map((r) => new Ae(r))
    };
  }
  static decodeCloseLookupTable(t) {
    return this.checkProgramId(t.programId), this.checkKeysLength(t.keys, 3), {
      lookupTable: t.keys[0].pubkey,
      authority: t.keys[1].pubkey,
      recipient: t.keys[2].pubkey
    };
  }
  static decodeFreezeLookupTable(t) {
    return this.checkProgramId(t.programId), this.checkKeysLength(t.keys, 2), {
      lookupTable: t.keys[0].pubkey,
      authority: t.keys[1].pubkey
    };
  }
  static decodeDeactivateLookupTable(t) {
    return this.checkProgramId(t.programId), this.checkKeysLength(t.keys, 2), {
      lookupTable: t.keys[0].pubkey,
      authority: t.keys[1].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(t) {
    if (!t.equals(Nk.programId))
      throw new Error("invalid instruction; programId is not AddressLookupTable Program");
  }
  /**
   * @internal
   */
  static checkKeysLength(t, n) {
    if (t.length < n)
      throw new Error(`invalid instruction; found ${t.length} keys, expected at least ${n}`);
  }
}
class Nk {
  /**
   * @internal
   */
  constructor() {
  }
  static createLookupTable(t) {
    const [n, r] = Ae.findProgramAddressSync([t.authority.toBuffer(), vk(BigInt(t.recentSlot), 8)], this.programId), i = Ra.CreateLookupTable, o = yn(i, {
      recentSlot: BigInt(t.recentSlot),
      bumpSeed: r
    }), a = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: t.authority,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: t.payer,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: Rr.programId,
      isSigner: !1,
      isWritable: !1
    }];
    return [new jn({
      programId: this.programId,
      keys: a,
      data: o
    }), n];
  }
  static freezeLookupTable(t) {
    const n = Ra.FreezeLookupTable, r = yn(n), i = [{
      pubkey: t.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: t.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return new jn({
      programId: this.programId,
      keys: i,
      data: r
    });
  }
  static extendLookupTable(t) {
    const n = Ra.ExtendLookupTable, r = yn(n, {
      addresses: t.addresses.map((o) => o.toBytes())
    }), i = [{
      pubkey: t.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: t.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return t.payer && i.push({
      pubkey: t.payer,
      isSigner: !0,
      isWritable: !0
    }, {
      pubkey: Rr.programId,
      isSigner: !1,
      isWritable: !1
    }), new jn({
      programId: this.programId,
      keys: i,
      data: r
    });
  }
  static deactivateLookupTable(t) {
    const n = Ra.DeactivateLookupTable, r = yn(n), i = [{
      pubkey: t.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: t.authority,
      isSigner: !0,
      isWritable: !1
    }];
    return new jn({
      programId: this.programId,
      keys: i,
      data: r
    });
  }
  static closeLookupTable(t) {
    const n = Ra.CloseLookupTable, r = yn(n), i = [{
      pubkey: t.lookupTable,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: t.authority,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: t.recipient,
      isSigner: !1,
      isWritable: !0
    }];
    return new jn({
      programId: this.programId,
      keys: i,
      data: r
    });
  }
}
Nk.programId = new Ae("AddressLookupTab1e1111111111111111111111111");
class UY {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */
  static decodeInstructionType(t) {
    this.checkProgramId(t.programId);
    const r = an("instruction").decode(t.data);
    let i;
    for (const [o, a] of Object.entries(ra))
      if (a.index == r) {
        i = o;
        break;
      }
    if (!i)
      throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
    return i;
  }
  /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */
  static decodeRequestUnits(t) {
    this.checkProgramId(t.programId);
    const {
      units: n,
      additionalFee: r
    } = kn(ra.RequestUnits, t.data);
    return {
      units: n,
      additionalFee: r
    };
  }
  /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */
  static decodeRequestHeapFrame(t) {
    this.checkProgramId(t.programId);
    const {
      bytes: n
    } = kn(ra.RequestHeapFrame, t.data);
    return {
      bytes: n
    };
  }
  /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */
  static decodeSetComputeUnitLimit(t) {
    this.checkProgramId(t.programId);
    const {
      units: n
    } = kn(ra.SetComputeUnitLimit, t.data);
    return {
      units: n
    };
  }
  /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */
  static decodeSetComputeUnitPrice(t) {
    this.checkProgramId(t.programId);
    const {
      microLamports: n
    } = kn(ra.SetComputeUnitPrice, t.data);
    return {
      microLamports: n
    };
  }
  /**
   * @internal
   */
  static checkProgramId(t) {
    if (!t.equals(jk.programId))
      throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
  }
}
const ra = Object.freeze({
  RequestUnits: {
    index: 0,
    layout: ht([an("instruction"), ft("units"), ft("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: ht([an("instruction"), ft("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: ht([an("instruction"), ft("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: ht([an("instruction"), yl("microLamports")])
  }
});
class jk {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Compute Budget program
   */
  /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */
  static requestUnits(t) {
    const n = ra.RequestUnits, r = yn(n, t);
    return new jn({
      keys: [],
      programId: this.programId,
      data: r
    });
  }
  static requestHeapFrame(t) {
    const n = ra.RequestHeapFrame, r = yn(n, t);
    return new jn({
      keys: [],
      programId: this.programId,
      data: r
    });
  }
  static setComputeUnitLimit(t) {
    const n = ra.SetComputeUnitLimit, r = yn(n, t);
    return new jn({
      keys: [],
      programId: this.programId,
      data: r
    });
  }
  static setComputeUnitPrice(t) {
    const n = ra.SetComputeUnitPrice, r = yn(n, {
      microLamports: BigInt(t.microLamports)
    });
    return new jn({
      keys: [],
      programId: this.programId,
      data: r
    });
  }
}
jk.programId = new Ae("ComputeBudget111111111111111111111111111111");
const oM = 64, aM = 32, sM = 64, cM = ht([an("numSignatures"), an("padding"), io("signatureOffset"), io("signatureInstructionIndex"), io("publicKeyOffset"), io("publicKeyInstructionIndex"), io("messageDataOffset"), io("messageDataSize"), io("messageInstructionIndex")]);
class f_ {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the ed25519 program
   */
  /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */
  static createInstructionWithPublicKey(t) {
    const {
      publicKey: n,
      message: r,
      signature: i,
      instructionIndex: o
    } = t;
    _n(n.length === aM, `Public Key must be ${aM} bytes but received ${n.length} bytes`), _n(i.length === sM, `Signature must be ${sM} bytes but received ${i.length} bytes`);
    const a = cM.span, s = a + n.length, c = s + i.length, l = 1, u = it.Buffer.alloc(c + r.length), f = o ?? 65535;
    return cM.encode({
      numSignatures: l,
      padding: 0,
      signatureOffset: s,
      signatureInstructionIndex: f,
      publicKeyOffset: a,
      publicKeyInstructionIndex: f,
      messageDataOffset: c,
      messageDataSize: r.length,
      messageInstructionIndex: f
    }, u), u.fill(n, a), u.fill(i, s), u.fill(r, c), new jn({
      keys: [],
      programId: f_.programId,
      data: u
    });
  }
  /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */
  static createInstructionWithPrivateKey(t) {
    const {
      privateKey: n,
      message: r,
      instructionIndex: i
    } = t;
    _n(n.length === oM, `Private key must be ${oM} bytes but received ${n.length} bytes`);
    try {
      const o = Yu.fromSecretKey(n), a = o.publicKey.toBytes(), s = Ik(r, o.secretKey);
      return this.createInstructionWithPublicKey({
        publicKey: a,
        message: r,
        signature: s,
        instructionIndex: i
      });
    } catch (o) {
      throw new Error(`Error creating instruction; ${o}`);
    }
  }
}
f_.programId = new Ae("Ed25519SigVerify111111111111111111111111111");
Ua.hmacSha256Sync = (e, ...t) => {
  const n = cR.create(aA, e);
  return t.forEach((r) => n.update(r)), n.digest();
};
const zY = (e, t) => UH(e, t, {
  der: !1,
  recovered: !0
});
Ua.isValidPrivateKey;
const FY = DH, uM = 32, o1 = 20, lM = 64, LY = 11, a1 = ht([an("numSignatures"), io("signatureOffset"), an("signatureInstructionIndex"), io("ethAddressOffset"), an("ethAddressInstructionIndex"), io("messageDataOffset"), io("messageDataSize"), an("messageInstructionIndex"), Nn(20, "ethAddress"), Nn(64, "signature"), an("recoveryId")]);
class Zu {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the secp256k1 program
   */
  /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */
  static publicKeyToEthAddress(t) {
    _n(t.length === lM, `Public key must be ${lM} bytes but received ${t.length} bytes`);
    try {
      return it.Buffer.from(L2(qt(t))).slice(-o1);
    } catch (n) {
      throw new Error(`Error constructing Ethereum address: ${n}`);
    }
  }
  /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */
  static createInstructionWithPublicKey(t) {
    const {
      publicKey: n,
      message: r,
      signature: i,
      recoveryId: o,
      instructionIndex: a
    } = t;
    return Zu.createInstructionWithEthAddress({
      ethAddress: Zu.publicKeyToEthAddress(n),
      message: r,
      signature: i,
      recoveryId: o,
      instructionIndex: a
    });
  }
  /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */
  static createInstructionWithEthAddress(t) {
    const {
      ethAddress: n,
      message: r,
      signature: i,
      recoveryId: o,
      instructionIndex: a = 0
    } = t;
    let s;
    typeof n == "string" ? n.startsWith("0x") ? s = it.Buffer.from(n.substr(2), "hex") : s = it.Buffer.from(n, "hex") : s = n, _n(s.length === o1, `Address must be ${o1} bytes but received ${s.length} bytes`);
    const c = 1 + LY, l = c, u = c + s.length, f = u + i.length + 1, d = 1, h = it.Buffer.alloc(a1.span + r.length);
    return a1.encode({
      numSignatures: d,
      signatureOffset: u,
      signatureInstructionIndex: a,
      ethAddressOffset: l,
      ethAddressInstructionIndex: a,
      messageDataOffset: f,
      messageDataSize: r.length,
      messageInstructionIndex: a,
      signature: qt(i),
      ethAddress: qt(s),
      recoveryId: o
    }, h), h.fill(qt(r), a1.span), new jn({
      keys: [],
      programId: Zu.programId,
      data: h
    });
  }
  /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */
  static createInstructionWithPrivateKey(t) {
    const {
      privateKey: n,
      message: r,
      instructionIndex: i
    } = t;
    _n(n.length === uM, `Private key must be ${uM} bytes but received ${n.length} bytes`);
    try {
      const o = qt(n), a = FY(
        o,
        !1
        /* isCompressed */
      ).slice(1), s = it.Buffer.from(L2(qt(r))), [c, l] = zY(s, o);
      return this.createInstructionWithPublicKey({
        publicKey: a,
        message: r,
        signature: c,
        recoveryId: l,
        instructionIndex: i
      });
    } catch (o) {
      throw new Error(`Error creating instruction; ${o}`);
    }
  }
}
Zu.programId = new Ae("KeccakSecp256k11111111111111111111111111111");
const OR = new Ae("StakeConfig11111111111111111111111111111111");
class PR {
  /** stake authority */
  /** withdraw authority */
  /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */
  constructor(t, n) {
    this.staker = void 0, this.withdrawer = void 0, this.staker = t, this.withdrawer = n;
  }
}
class sd {
  /** Unix timestamp of lockup expiration */
  /** Epoch of lockup expiration */
  /** Lockup custodian authority */
  /**
   * Create a new Lockup object
   */
  constructor(t, n, r) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = t, this.epoch = n, this.custodian = r;
  }
  /**
   * Default, inactive Lockup value
   */
}
sd.default = new sd(0, 0, Ae.default);
class $Y {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a stake instruction and retrieve the instruction type.
   */
  static decodeInstructionType(t) {
    this.checkProgramId(t.programId);
    const r = ft("instruction").decode(t.data);
    let i;
    for (const [o, a] of Object.entries(Fr))
      if (a.index == r) {
        i = o;
        break;
      }
    if (!i)
      throw new Error("Instruction type incorrect; not a StakeInstruction");
    return i;
  }
  /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */
  static decodeInitialize(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 2);
    const {
      authorized: n,
      lockup: r
    } = kn(Fr.Initialize, t.data);
    return {
      stakePubkey: t.keys[0].pubkey,
      authorized: new PR(new Ae(n.staker), new Ae(n.withdrawer)),
      lockup: new sd(r.unixTimestamp, r.epoch, new Ae(r.custodian))
    };
  }
  /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */
  static decodeDelegate(t) {
    return this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 6), kn(Fr.Delegate, t.data), {
      stakePubkey: t.keys[0].pubkey,
      votePubkey: t.keys[1].pubkey,
      authorizedPubkey: t.keys[5].pubkey
    };
  }
  /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */
  static decodeAuthorize(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 3);
    const {
      newAuthorized: n,
      stakeAuthorizationType: r
    } = kn(Fr.Authorize, t.data), i = {
      stakePubkey: t.keys[0].pubkey,
      authorizedPubkey: t.keys[2].pubkey,
      newAuthorizedPubkey: new Ae(n),
      stakeAuthorizationType: {
        index: r
      }
    };
    return t.keys.length > 3 && (i.custodianPubkey = t.keys[3].pubkey), i;
  }
  /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */
  static decodeAuthorizeWithSeed(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 2);
    const {
      newAuthorized: n,
      stakeAuthorizationType: r,
      authoritySeed: i,
      authorityOwner: o
    } = kn(Fr.AuthorizeWithSeed, t.data), a = {
      stakePubkey: t.keys[0].pubkey,
      authorityBase: t.keys[1].pubkey,
      authoritySeed: i,
      authorityOwner: new Ae(o),
      newAuthorizedPubkey: new Ae(n),
      stakeAuthorizationType: {
        index: r
      }
    };
    return t.keys.length > 3 && (a.custodianPubkey = t.keys[3].pubkey), a;
  }
  /**
   * Decode a split stake instruction and retrieve the instruction params.
   */
  static decodeSplit(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 3);
    const {
      lamports: n
    } = kn(Fr.Split, t.data);
    return {
      stakePubkey: t.keys[0].pubkey,
      splitStakePubkey: t.keys[1].pubkey,
      authorizedPubkey: t.keys[2].pubkey,
      lamports: n
    };
  }
  /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */
  static decodeMerge(t) {
    return this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 3), kn(Fr.Merge, t.data), {
      stakePubkey: t.keys[0].pubkey,
      sourceStakePubKey: t.keys[1].pubkey,
      authorizedPubkey: t.keys[4].pubkey
    };
  }
  /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */
  static decodeWithdraw(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 5);
    const {
      lamports: n
    } = kn(Fr.Withdraw, t.data), r = {
      stakePubkey: t.keys[0].pubkey,
      toPubkey: t.keys[1].pubkey,
      authorizedPubkey: t.keys[4].pubkey,
      lamports: n
    };
    return t.keys.length > 5 && (r.custodianPubkey = t.keys[5].pubkey), r;
  }
  /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */
  static decodeDeactivate(t) {
    return this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 3), kn(Fr.Deactivate, t.data), {
      stakePubkey: t.keys[0].pubkey,
      authorizedPubkey: t.keys[2].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(t) {
    if (!t.equals(d_.programId))
      throw new Error("invalid instruction; programId is not StakeProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(t, n) {
    if (t.length < n)
      throw new Error(`invalid instruction; found ${t.length} keys, expected at least ${n}`);
  }
}
const Fr = Object.freeze({
  Initialize: {
    index: 0,
    layout: ht([ft("instruction"), qH(), HH()])
  },
  Authorize: {
    index: 1,
    layout: ht([ft("instruction"), Qt("newAuthorized"), ft("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: ht([ft("instruction")])
  },
  Split: {
    index: 3,
    layout: ht([ft("instruction"), Di("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: ht([ft("instruction"), Di("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: ht([ft("instruction")])
  },
  Merge: {
    index: 7,
    layout: ht([ft("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: ht([ft("instruction"), Qt("newAuthorized"), ft("stakeAuthorizationType"), bc("authoritySeed"), Qt("authorityOwner")])
  }
}), WY = Object.freeze({
  Staker: {
    index: 0
  },
  Withdrawer: {
    index: 1
  }
});
class d_ {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Stake program
   */
  /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */
  static initialize(t) {
    const {
      stakePubkey: n,
      authorized: r,
      lockup: i
    } = t, o = i || sd.default, a = Fr.Initialize, s = yn(a, {
      authorized: {
        staker: qt(r.staker.toBuffer()),
        withdrawer: qt(r.withdrawer.toBuffer())
      },
      lockup: {
        unixTimestamp: o.unixTimestamp,
        epoch: o.epoch,
        custodian: qt(o.custodian.toBuffer())
      }
    }), c = {
      keys: [{
        pubkey: n,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Cc,
        isSigner: !1,
        isWritable: !1
      }],
      programId: this.programId,
      data: s
    };
    return new jn(c);
  }
  /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */
  static createAccountWithSeed(t) {
    const n = new On();
    n.add(Rr.createAccountWithSeed({
      fromPubkey: t.fromPubkey,
      newAccountPubkey: t.stakePubkey,
      basePubkey: t.basePubkey,
      seed: t.seed,
      lamports: t.lamports,
      space: this.space,
      programId: this.programId
    }));
    const {
      stakePubkey: r,
      authorized: i,
      lockup: o
    } = t;
    return n.add(this.initialize({
      stakePubkey: r,
      authorized: i,
      lockup: o
    }));
  }
  /**
   * Generate a Transaction that creates a new Stake account
   */
  static createAccount(t) {
    const n = new On();
    n.add(Rr.createAccount({
      fromPubkey: t.fromPubkey,
      newAccountPubkey: t.stakePubkey,
      lamports: t.lamports,
      space: this.space,
      programId: this.programId
    }));
    const {
      stakePubkey: r,
      authorized: i,
      lockup: o
    } = t;
    return n.add(this.initialize({
      stakePubkey: r,
      authorized: i,
      lockup: o
    }));
  }
  /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */
  static delegate(t) {
    const {
      stakePubkey: n,
      authorizedPubkey: r,
      votePubkey: i
    } = t, o = Fr.Delegate, a = yn(o);
    return new On().add({
      keys: [{
        pubkey: n,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: i,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Io,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: ib,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: OR,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: r,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: a
    });
  }
  /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */
  static authorize(t) {
    const {
      stakePubkey: n,
      authorizedPubkey: r,
      newAuthorizedPubkey: i,
      stakeAuthorizationType: o,
      custodianPubkey: a
    } = t, s = Fr.Authorize, c = yn(s, {
      newAuthorized: qt(i.toBuffer()),
      stakeAuthorizationType: o.index
    }), l = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Io,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: r,
      isSigner: !0,
      isWritable: !1
    }];
    return a && l.push({
      pubkey: a,
      isSigner: !1,
      isWritable: !1
    }), new On().add({
      keys: l,
      programId: this.programId,
      data: c
    });
  }
  /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */
  static authorizeWithSeed(t) {
    const {
      stakePubkey: n,
      authorityBase: r,
      authoritySeed: i,
      authorityOwner: o,
      newAuthorizedPubkey: a,
      stakeAuthorizationType: s,
      custodianPubkey: c
    } = t, l = Fr.AuthorizeWithSeed, u = yn(l, {
      newAuthorized: qt(a.toBuffer()),
      stakeAuthorizationType: s.index,
      authoritySeed: i,
      authorityOwner: qt(o.toBuffer())
    }), f = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: r,
      isSigner: !0,
      isWritable: !1
    }, {
      pubkey: Io,
      isSigner: !1,
      isWritable: !1
    }];
    return c && f.push({
      pubkey: c,
      isSigner: !1,
      isWritable: !1
    }), new On().add({
      keys: f,
      programId: this.programId,
      data: u
    });
  }
  /**
   * @internal
   */
  static splitInstruction(t) {
    const {
      stakePubkey: n,
      authorizedPubkey: r,
      splitStakePubkey: i,
      lamports: o
    } = t, a = Fr.Split, s = yn(a, {
      lamports: o
    });
    return new jn({
      keys: [{
        pubkey: n,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: i,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: r,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: s
    });
  }
  /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */
  static split(t) {
    const n = new On();
    return n.add(Rr.createAccount({
      fromPubkey: t.authorizedPubkey,
      newAccountPubkey: t.splitStakePubkey,
      lamports: 0,
      space: this.space,
      programId: this.programId
    })), n.add(this.splitInstruction(t));
  }
  /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */
  static splitWithSeed(t) {
    const {
      stakePubkey: n,
      authorizedPubkey: r,
      splitStakePubkey: i,
      basePubkey: o,
      seed: a,
      lamports: s
    } = t, c = new On();
    return c.add(Rr.allocate({
      accountPubkey: i,
      basePubkey: o,
      seed: a,
      space: this.space,
      programId: this.programId
    })), c.add(this.splitInstruction({
      stakePubkey: n,
      authorizedPubkey: r,
      splitStakePubkey: i,
      lamports: s
    }));
  }
  /**
   * Generate a Transaction that merges Stake accounts.
   */
  static merge(t) {
    const {
      stakePubkey: n,
      sourceStakePubKey: r,
      authorizedPubkey: i
    } = t, o = Fr.Merge, a = yn(o);
    return new On().add({
      keys: [{
        pubkey: n,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Io,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: ib,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: i,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: a
    });
  }
  /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */
  static withdraw(t) {
    const {
      stakePubkey: n,
      authorizedPubkey: r,
      toPubkey: i,
      lamports: o,
      custodianPubkey: a
    } = t, s = Fr.Withdraw, c = yn(s, {
      lamports: o
    }), l = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: i,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Io,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: ib,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: r,
      isSigner: !0,
      isWritable: !1
    }];
    return a && l.push({
      pubkey: a,
      isSigner: !1,
      isWritable: !1
    }), new On().add({
      keys: l,
      programId: this.programId,
      data: c
    });
  }
  /**
   * Generate a Transaction that deactivates Stake tokens.
   */
  static deactivate(t) {
    const {
      stakePubkey: n,
      authorizedPubkey: r
    } = t, i = Fr.Deactivate, o = yn(i);
    return new On().add({
      keys: [{
        pubkey: n,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Io,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: r,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: o
    });
  }
}
d_.programId = new Ae("Stake11111111111111111111111111111111111111");
d_.space = 200;
class BR {
  /** [0, 100] */
  constructor(t, n, r, i) {
    this.nodePubkey = void 0, this.authorizedVoter = void 0, this.authorizedWithdrawer = void 0, this.commission = void 0, this.nodePubkey = t, this.authorizedVoter = n, this.authorizedWithdrawer = r, this.commission = i;
  }
}
class KY {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Decode a vote instruction and retrieve the instruction type.
   */
  static decodeInstructionType(t) {
    this.checkProgramId(t.programId);
    const r = ft("instruction").decode(t.data);
    let i;
    for (const [o, a] of Object.entries(Na))
      if (a.index == r) {
        i = o;
        break;
      }
    if (!i)
      throw new Error("Instruction type incorrect; not a VoteInstruction");
    return i;
  }
  /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */
  static decodeInitializeAccount(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 4);
    const {
      voteInit: n
    } = kn(Na.InitializeAccount, t.data);
    return {
      votePubkey: t.keys[0].pubkey,
      nodePubkey: t.keys[3].pubkey,
      voteInit: new BR(new Ae(n.nodePubkey), new Ae(n.authorizedVoter), new Ae(n.authorizedWithdrawer), n.commission)
    };
  }
  /**
   * Decode an authorize instruction and retrieve the instruction params.
   */
  static decodeAuthorize(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 3);
    const {
      newAuthorized: n,
      voteAuthorizationType: r
    } = kn(Na.Authorize, t.data);
    return {
      votePubkey: t.keys[0].pubkey,
      authorizedPubkey: t.keys[2].pubkey,
      newAuthorizedPubkey: new Ae(n),
      voteAuthorizationType: {
        index: r
      }
    };
  }
  /**
   * Decode an authorize instruction and retrieve the instruction params.
   */
  static decodeAuthorizeWithSeed(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 3);
    const {
      voteAuthorizeWithSeedArgs: {
        currentAuthorityDerivedKeyOwnerPubkey: n,
        currentAuthorityDerivedKeySeed: r,
        newAuthorized: i,
        voteAuthorizationType: o
      }
    } = kn(Na.AuthorizeWithSeed, t.data);
    return {
      currentAuthorityDerivedKeyBasePubkey: t.keys[2].pubkey,
      currentAuthorityDerivedKeyOwnerPubkey: new Ae(n),
      currentAuthorityDerivedKeySeed: r,
      newAuthorizedPubkey: new Ae(i),
      voteAuthorizationType: {
        index: o
      },
      votePubkey: t.keys[0].pubkey
    };
  }
  /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */
  static decodeWithdraw(t) {
    this.checkProgramId(t.programId), this.checkKeyLength(t.keys, 3);
    const {
      lamports: n
    } = kn(Na.Withdraw, t.data);
    return {
      votePubkey: t.keys[0].pubkey,
      authorizedWithdrawerPubkey: t.keys[2].pubkey,
      lamports: n,
      toPubkey: t.keys[1].pubkey
    };
  }
  /**
   * @internal
   */
  static checkProgramId(t) {
    if (!t.equals($l.programId))
      throw new Error("invalid instruction; programId is not VoteProgram");
  }
  /**
   * @internal
   */
  static checkKeyLength(t, n) {
    if (t.length < n)
      throw new Error(`invalid instruction; found ${t.length} keys, expected at least ${n}`);
  }
}
const Na = Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: ht([ft("instruction"), GH()])
  },
  Authorize: {
    index: 1,
    layout: ht([ft("instruction"), Qt("newAuthorized"), ft("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: ht([ft("instruction"), Di("lamports")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: ht([ft("instruction"), YH()])
  }
}), VY = Object.freeze({
  Voter: {
    index: 0
  },
  Withdrawer: {
    index: 1
  }
});
class $l {
  /**
   * @internal
   */
  constructor() {
  }
  /**
   * Public key that identifies the Vote program
   */
  /**
   * Generate an Initialize instruction.
   */
  static initializeAccount(t) {
    const {
      votePubkey: n,
      nodePubkey: r,
      voteInit: i
    } = t, o = Na.InitializeAccount, a = yn(o, {
      voteInit: {
        nodePubkey: qt(i.nodePubkey.toBuffer()),
        authorizedVoter: qt(i.authorizedVoter.toBuffer()),
        authorizedWithdrawer: qt(i.authorizedWithdrawer.toBuffer()),
        commission: i.commission
      }
    }), s = {
      keys: [{
        pubkey: n,
        isSigner: !1,
        isWritable: !0
      }, {
        pubkey: Cc,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: Io,
        isSigner: !1,
        isWritable: !1
      }, {
        pubkey: r,
        isSigner: !0,
        isWritable: !1
      }],
      programId: this.programId,
      data: a
    };
    return new jn(s);
  }
  /**
   * Generate a transaction that creates a new Vote account.
   */
  static createAccount(t) {
    const n = new On();
    return n.add(Rr.createAccount({
      fromPubkey: t.fromPubkey,
      newAccountPubkey: t.votePubkey,
      lamports: t.lamports,
      space: this.space,
      programId: this.programId
    })), n.add(this.initializeAccount({
      votePubkey: t.votePubkey,
      nodePubkey: t.voteInit.nodePubkey,
      voteInit: t.voteInit
    }));
  }
  /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */
  static authorize(t) {
    const {
      votePubkey: n,
      authorizedPubkey: r,
      newAuthorizedPubkey: i,
      voteAuthorizationType: o
    } = t, a = Na.Authorize, s = yn(a, {
      newAuthorized: qt(i.toBuffer()),
      voteAuthorizationType: o.index
    }), c = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Io,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: r,
      isSigner: !0,
      isWritable: !1
    }];
    return new On().add({
      keys: c,
      programId: this.programId,
      data: s
    });
  }
  /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */
  static authorizeWithSeed(t) {
    const {
      currentAuthorityDerivedKeyBasePubkey: n,
      currentAuthorityDerivedKeyOwnerPubkey: r,
      currentAuthorityDerivedKeySeed: i,
      newAuthorizedPubkey: o,
      voteAuthorizationType: a,
      votePubkey: s
    } = t, c = Na.AuthorizeWithSeed, l = yn(c, {
      voteAuthorizeWithSeedArgs: {
        currentAuthorityDerivedKeyOwnerPubkey: qt(r.toBuffer()),
        currentAuthorityDerivedKeySeed: i,
        newAuthorized: qt(o.toBuffer()),
        voteAuthorizationType: a.index
      }
    }), u = [{
      pubkey: s,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: Io,
      isSigner: !1,
      isWritable: !1
    }, {
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }];
    return new On().add({
      keys: u,
      programId: this.programId,
      data: l
    });
  }
  /**
   * Generate a transaction to withdraw from a Vote account.
   */
  static withdraw(t) {
    const {
      votePubkey: n,
      authorizedWithdrawerPubkey: r,
      lamports: i,
      toPubkey: o
    } = t, a = Na.Withdraw, s = yn(a, {
      lamports: i
    }), c = [{
      pubkey: n,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: o,
      isSigner: !1,
      isWritable: !0
    }, {
      pubkey: r,
      isSigner: !0,
      isWritable: !1
    }];
    return new On().add({
      keys: c,
      programId: this.programId,
      data: s
    });
  }
  /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */
  static safeWithdraw(t, n, r) {
    if (t.lamports > n - r)
      throw new Error("Withdraw will leave vote account with insuffcient funds.");
    return $l.withdraw(t);
  }
}
$l.programId = new Ae("Vote111111111111111111111111111111111111111");
$l.space = 3731;
const CR = new Ae("Va1idator1nfo111111111111111111111111111111"), qY = Oe({
  name: Ke(),
  website: xt(Ke()),
  details: xt(Ke()),
  keybaseUsername: xt(Ke())
});
class Uk {
  /**
   * validator public key
   */
  /**
   * validator information
   */
  /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */
  constructor(t, n) {
    this.key = void 0, this.info = void 0, this.key = t, this.info = n;
  }
  /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */
  static fromConfigData(t) {
    let n = [...t];
    if (wi(n) !== 2)
      return null;
    const i = [];
    for (let o = 0; o < 2; o++) {
      const a = new Ae(n.slice(0, $i));
      n = n.slice($i);
      const s = n.slice(0, 1)[0] === 1;
      n = n.slice(1), i.push({
        publicKey: a,
        isSigner: s
      });
    }
    if (i[0].publicKey.equals(CR) && i[1].isSigner) {
      const o = bc().decode(it.Buffer.from(n)), a = JSON.parse(o);
      return UD(a, qY), new Uk(i[1].publicKey, a);
    }
    return null;
  }
}
const HY = new Ae("Vote111111111111111111111111111111111111111"), GY = ht([
  Qt("nodePubkey"),
  Qt("authorizedWithdrawer"),
  an("commission"),
  Vr(),
  // votes.length
  Yr(ht([Vr("slot"), ft("confirmationCount")]), Ds(ft(), -8), "votes"),
  an("rootSlotValid"),
  Vr("rootSlot"),
  Vr(),
  // authorizedVoters.length
  Yr(ht([Vr("epoch"), Qt("authorizedVoter")]), Ds(ft(), -8), "authorizedVoters"),
  ht([Yr(ht([Qt("authorizedPubkey"), Vr("epochOfLastAuthorizedSwitch"), Vr("targetEpoch")]), 32, "buf"), Vr("idx"), an("isEmpty")], "priorVoters"),
  Vr(),
  // epochCredits.length
  Yr(ht([Vr("epoch"), Vr("credits"), Vr("prevCredits")]), Ds(ft(), -8), "epochCredits"),
  ht([Vr("slot"), Vr("timestamp")], "lastTimestamp")
]);
class zk {
  /**
   * @internal
   */
  constructor(t) {
    this.nodePubkey = void 0, this.authorizedWithdrawer = void 0, this.commission = void 0, this.rootSlot = void 0, this.votes = void 0, this.authorizedVoters = void 0, this.priorVoters = void 0, this.epochCredits = void 0, this.lastTimestamp = void 0, this.nodePubkey = t.nodePubkey, this.authorizedWithdrawer = t.authorizedWithdrawer, this.commission = t.commission, this.rootSlot = t.rootSlot, this.votes = t.votes, this.authorizedVoters = t.authorizedVoters, this.priorVoters = t.priorVoters, this.epochCredits = t.epochCredits, this.lastTimestamp = t.lastTimestamp;
  }
  /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */
  static fromAccountData(t) {
    const r = GY.decode(qt(t), 4);
    let i = r.rootSlot;
    return r.rootSlotValid || (i = null), new zk({
      nodePubkey: new Ae(r.nodePubkey),
      authorizedWithdrawer: new Ae(r.authorizedWithdrawer),
      commission: r.commission,
      votes: r.votes,
      rootSlot: i,
      authorizedVoters: r.authorizedVoters.map(YY),
      priorVoters: ZY(r.priorVoters),
      epochCredits: r.epochCredits,
      lastTimestamp: r.lastTimestamp
    });
  }
}
function YY({
  authorizedVoter: e,
  epoch: t
}) {
  return {
    epoch: t,
    authorizedVoter: new Ae(e)
  };
}
function fM({
  authorizedPubkey: e,
  epochOfLastAuthorizedSwitch: t,
  targetEpoch: n
}) {
  return {
    authorizedPubkey: new Ae(e),
    epochOfLastAuthorizedSwitch: t,
    targetEpoch: n
  };
}
function ZY({
  buf: e,
  idx: t,
  isEmpty: n
}) {
  return n ? [] : [...e.slice(t + 1).map(fM), ...e.slice(0, t).map(fM)];
}
const dM = {
  http: {
    devnet: "http://api.devnet.solana.com",
    testnet: "http://api.testnet.solana.com",
    "mainnet-beta": "http://api.mainnet-beta.solana.com/"
  },
  https: {
    devnet: "https://api.devnet.solana.com",
    testnet: "https://api.testnet.solana.com",
    "mainnet-beta": "https://api.mainnet-beta.solana.com/"
  }
};
function DR(e, t) {
  const n = t === !1 ? "http" : "https";
  if (!e)
    return dM[n].devnet;
  const r = dM[n][e];
  if (!r)
    throw new Error(`Unknown ${n} cluster: ${e}`);
  return r;
}
async function JY(e, t, n, r) {
  let i, o;
  n && Object.prototype.hasOwnProperty.call(n, "lastValidBlockHeight") || n && Object.prototype.hasOwnProperty.call(n, "nonceValue") ? (i = n, o = r) : o = n;
  const a = o && {
    skipPreflight: o.skipPreflight,
    preflightCommitment: o.preflightCommitment || o.commitment,
    minContextSlot: o.minContextSlot
  }, s = await e.sendRawTransaction(t, a), c = o && o.commitment, u = (await (i ? e.confirmTransaction(i, c) : e.confirmTransaction(s, c))).value;
  if (u.err)
    throw new Error(`Raw transaction ${s} failed (${JSON.stringify(u)})`);
  return s;
}
const XY = 1e9, QY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Account: WH,
  AddressLookupTableAccount: dA,
  AddressLookupTableInstruction: jY,
  AddressLookupTableProgram: Nk,
  Authorized: PR,
  BLOCKHASH_CACHE_TIMEOUT_MS: wR,
  BPF_LOADER_DEPRECATED_PROGRAM_ID: KH,
  BPF_LOADER_PROGRAM_ID: aG,
  BpfLoader: sG,
  COMPUTE_BUDGET_INSTRUCTION_LAYOUTS: ra,
  ComputeBudgetInstruction: UY,
  ComputeBudgetProgram: jk,
  Connection: Rk,
  Ed25519Program: f_,
  Enum: LH,
  EpochSchedule: mR,
  FeeCalculatorLayout: gR,
  Keypair: Yu,
  LAMPORTS_PER_SOL: XY,
  LOOKUP_TABLE_INSTRUCTION_LAYOUTS: Ra,
  Loader: Dc,
  Lockup: sd,
  MAX_SEED_LENGTH: pR,
  Message: zo,
  MessageAccountKeys: od,
  MessageV0: Bc,
  NONCE_ACCOUNT_LENGTH: fA,
  NonceAccount: c_,
  PACKET_DATA_SIZE: Us,
  PUBLIC_KEY_LENGTH: $i,
  PublicKey: Ae,
  SIGNATURE_LENGTH_IN_BYTES: pl,
  SOLANA_SCHEMA: Vf,
  STAKE_CONFIG_ID: OR,
  STAKE_INSTRUCTION_LAYOUTS: Fr,
  SYSTEM_INSTRUCTION_LAYOUTS: Vn,
  SYSVAR_CLOCK_PUBKEY: Io,
  SYSVAR_EPOCH_SCHEDULE_PUBKEY: JH,
  SYSVAR_INSTRUCTIONS_PUBKEY: XH,
  SYSVAR_RECENT_BLOCKHASHES_PUBKEY: rb,
  SYSVAR_RENT_PUBKEY: Cc,
  SYSVAR_REWARDS_PUBKEY: QH,
  SYSVAR_SLOT_HASHES_PUBKEY: eG,
  SYSVAR_SLOT_HISTORY_PUBKEY: tG,
  SYSVAR_STAKE_HISTORY_PUBKEY: ib,
  Secp256k1Program: Zu,
  SendTransactionError: gl,
  SolanaJSONRPCError: bt,
  SolanaJSONRPCErrorCode: dG,
  StakeAuthorizationLayout: WY,
  StakeInstruction: $Y,
  StakeProgram: d_,
  Struct: kk,
  SystemInstruction: iG,
  SystemProgram: Rr,
  Transaction: On,
  TransactionExpiredBlockheightExceededError: Tk,
  TransactionExpiredNonceInvalidError: Ru,
  TransactionExpiredTimeoutError: xk,
  TransactionInstruction: jn,
  TransactionMessage: Ok,
  get TransactionStatus() {
    return Eo;
  },
  VALIDATOR_INFO_KEY: CR,
  VERSION_PREFIX_MASK: a_,
  VOTE_PROGRAM_ID: HY,
  ValidatorInfo: Uk,
  VersionedMessage: Mk,
  VersionedTransaction: Pk,
  VoteAccount: zk,
  VoteAuthorizationLayout: VY,
  VoteInit: BR,
  VoteInstruction: KY,
  VoteProgram: $l,
  clusterApiUrl: DR,
  sendAndConfirmRawTransaction: JY,
  sendAndConfirmTransaction: ob
}, Symbol.toStringTag, { value: "Module" }));
var Fk = { exports: {} };
const eZ = /[\p{Lu}]/u, tZ = /[\p{Ll}]/u, hM = /^[\p{Lu}](?![\p{Lu}])/gu, RR = /([\p{Alpha}\p{N}_]|$)/u, NR = /[_.\- ]+/, nZ = new RegExp("^" + NR.source), pM = new RegExp(NR.source + RR.source, "gu"), yM = new RegExp("\\d+" + RR.source, "gu"), rZ = (e, t, n) => {
  let r = !1, i = !1, o = !1;
  for (let a = 0; a < e.length; a++) {
    const s = e[a];
    r && eZ.test(s) ? (e = e.slice(0, a) + "-" + e.slice(a), r = !1, o = i, i = !0, a++) : i && o && tZ.test(s) ? (e = e.slice(0, a - 1) + "-" + e.slice(a - 1), o = i, i = !1, r = !0) : (r = t(s) === s && n(s) !== s, o = i, i = n(s) === s && t(s) !== s);
  }
  return e;
}, iZ = (e, t) => (hM.lastIndex = 0, e.replace(hM, (n) => t(n))), oZ = (e, t) => (pM.lastIndex = 0, yM.lastIndex = 0, e.replace(pM, (n, r) => t(r)).replace(yM, (n) => t(n))), jR = (e, t) => {
  if (!(typeof e == "string" || Array.isArray(e)))
    throw new TypeError("Expected the input to be `string | string[]`");
  if (t = {
    pascalCase: !1,
    preserveConsecutiveUppercase: !1,
    ...t
  }, Array.isArray(e) ? e = e.map((o) => o.trim()).filter((o) => o.length).join("-") : e = e.trim(), e.length === 0)
    return "";
  const n = t.locale === !1 ? (o) => o.toLowerCase() : (o) => o.toLocaleLowerCase(t.locale), r = t.locale === !1 ? (o) => o.toUpperCase() : (o) => o.toLocaleUpperCase(t.locale);
  return e.length === 1 ? t.pascalCase ? r(e) : n(e) : (e !== n(e) && (e = rZ(e, n, r)), e = e.replace(nZ, ""), t.preserveConsecutiveUppercase ? e = iZ(e, n) : e = n(e), t.pascalCase && (e = r(e.charAt(0)) + e.slice(1)), oZ(e, r));
};
Fk.exports = jR;
Fk.exports.default = jR;
var aZ = Fk.exports;
const nr = /* @__PURE__ */ Vi(aZ);
var Ut = {}, Qe = {};
let Bn = class {
  constructor(t, n) {
    if (!Number.isInteger(t))
      throw new TypeError("span must be an integer");
    this.span = t, this.property = n;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */
  decode(t, n) {
    throw new Error("Layout is abstract");
  }
  /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */
  encode(t, n, r) {
    throw new Error("Layout is abstract");
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(t, n) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(t) {
    const n = Object.create(this.constructor.prototype);
    return Object.assign(n, this), n.property = t, n;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(t) {
  }
};
Qe.Layout = Bn;
function Lk(e, t) {
  return t.property ? e + "[" + t.property + "]" : e;
}
Qe.nameWithProperty = Lk;
function sZ(e, t) {
  if (typeof e != "function")
    throw new TypeError("Class must be constructor");
  if (e.hasOwnProperty("layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(t && t instanceof Bn))
    throw new TypeError("layout must be a Layout");
  if (t.hasOwnProperty("boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  e.layout_ = t, t.boundConstructor_ = e, t.makeDestinationObject = () => new e(), Object.defineProperty(e.prototype, "encode", {
    value: function(n, r) {
      return t.encode(this, n, r);
    },
    writable: !0
  }), Object.defineProperty(e, "decode", {
    value: function(n, r) {
      return t.decode(n, r);
    },
    writable: !0
  });
}
Qe.bindConstructorLayout = sZ;
let Ei = class extends Bn {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
};
class UR extends Ei {
  constructor(t, n) {
    if (t === void 0 && (t = 1), !Number.isInteger(t) || 0 >= t)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, n), this.elementSpan = t;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const r = t.length - n;
    return Math.floor(r / this.elementSpan);
  }
  /** @override */
  encode(t, n, r) {
    return 0;
  }
}
let $k = class extends Ei {
  constructor(t, n, r) {
    if (!(t instanceof Bn))
      throw new TypeError("layout must be a Layout");
    if (n === void 0)
      n = 0;
    else if (!Number.isInteger(n))
      throw new TypeError("offset must be integer or undefined");
    super(t.span, r || t.property), this.layout = t, this.offset = n;
  }
  /** @override */
  isCount() {
    return this.layout instanceof Sa || this.layout instanceof Xa;
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), this.layout.decode(t, n + this.offset);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), this.layout.encode(t, n, r + this.offset);
  }
}, Sa = class extends Bn {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readUIntLE(n, this.span);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), n.writeUIntLE(t, r, this.span), this.span;
  }
}, Xa = class extends Bn {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readUIntBE(n, this.span);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), n.writeUIntBE(t, r, this.span), this.span;
  }
};
class ou extends Bn {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readIntLE(n, this.span);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), n.writeIntLE(t, r, this.span), this.span;
  }
}
class Wl extends Bn {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readIntBE(n, this.span);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), n.writeIntBE(t, r, this.span), this.span;
  }
}
const gA = Math.pow(2, 32);
function h_(e) {
  const t = Math.floor(e / gA), n = e - t * gA;
  return { hi32: t, lo32: n };
}
function p_(e, t) {
  return e * gA + t;
}
let cZ = class extends Bn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const r = t.readUInt32LE(n), i = t.readUInt32LE(n + 4);
    return p_(i, r);
  }
  /** @override */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = h_(t);
    return n.writeUInt32LE(i.lo32, r), n.writeUInt32LE(i.hi32, r + 4), 8;
  }
};
class uZ extends Bn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const r = t.readUInt32BE(n), i = t.readUInt32BE(n + 4);
    return p_(r, i);
  }
  /** @override */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = h_(t);
    return n.writeUInt32BE(i.hi32, r), n.writeUInt32BE(i.lo32, r + 4), 8;
  }
}
let lZ = class extends Bn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const r = t.readUInt32LE(n), i = t.readInt32LE(n + 4);
    return p_(i, r);
  }
  /** @override */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = h_(t);
    return n.writeUInt32LE(i.lo32, r), n.writeInt32LE(i.hi32, r + 4), 8;
  }
};
class fZ extends Bn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const r = t.readInt32BE(n), i = t.readUInt32BE(n + 4);
    return p_(r, i);
  }
  /** @override */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = h_(t);
    return n.writeInt32BE(i.hi32, r), n.writeUInt32BE(i.lo32, r + 4), 8;
  }
}
class zR extends Bn {
  constructor(t) {
    super(4, t);
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readFloatLE(n);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), n.writeFloatLE(t, r), 4;
  }
}
class FR extends Bn {
  constructor(t) {
    super(4, t);
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readFloatBE(n);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), n.writeFloatBE(t, r), 4;
  }
}
class LR extends Bn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readDoubleLE(n);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), n.writeDoubleLE(t, r), 8;
  }
}
class $R extends Bn {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readDoubleBE(n);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), n.writeDoubleBE(t, r), 8;
  }
}
class WR extends Bn {
  constructor(t, n, r) {
    if (!(t instanceof Bn))
      throw new TypeError("elementLayout must be a Layout");
    if (!(n instanceof Ei && n.isCount() || Number.isInteger(n) && 0 <= n))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let i = -1;
    !(n instanceof Ei) && 0 < t.span && (i = n * t.span), super(i, r), this.elementLayout = t, this.count = n;
  }
  /** @override */
  getSpan(t, n) {
    if (0 <= this.span)
      return this.span;
    n === void 0 && (n = 0);
    let r = 0, i = this.count;
    if (i instanceof Ei && (i = i.decode(t, n)), 0 < this.elementLayout.span)
      r = i * this.elementLayout.span;
    else {
      let o = 0;
      for (; o < i; )
        r += this.elementLayout.getSpan(t, n + r), ++o;
    }
    return r;
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const r = [];
    let i = 0, o = this.count;
    for (o instanceof Ei && (o = o.decode(t, n)); i < o; )
      r.push(this.elementLayout.decode(t, n)), n += this.elementLayout.getSpan(t, n), i += 1;
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = this.elementLayout, o = t.reduce((a, s) => a + i.encode(s, n, r + a), 0);
    return this.count instanceof Ei && this.count.encode(t.length, n, r), o;
  }
}
let KR = class extends Bn {
  constructor(t, n, r) {
    if (!(Array.isArray(t) && t.reduce((o, a) => o && a instanceof Bn, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof n == "boolean" && r === void 0 && (r = n, n = void 0);
    for (const o of t)
      if (0 > o.span && o.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let i = -1;
    try {
      i = t.reduce((o, a) => o + a.getSpan(), 0);
    } catch {
    }
    super(i, n), this.fields = t, this.decodePrefixes = !!r;
  }
  /** @override */
  getSpan(t, n) {
    if (0 <= this.span)
      return this.span;
    n === void 0 && (n = 0);
    let r = 0;
    try {
      r = this.fields.reduce((i, o) => {
        const a = o.getSpan(t, n);
        return n += a, i + a;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return r;
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const r = this.makeDestinationObject();
    for (const i of this.fields)
      if (i.property !== void 0 && (r[i.property] = i.decode(t, n)), n += i.getSpan(t, n), this.decodePrefixes && t.length === n)
        break;
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = r;
    let o = 0, a = 0;
    for (const s of this.fields) {
      let c = s.span;
      if (a = 0 < c ? c : 0, s.property !== void 0) {
        const l = t[s.property];
        l !== void 0 && (a = s.encode(l, n, r), 0 > c && (c = s.getSpan(n, r)));
      }
      o = r, r += c;
    }
    return o + a - i;
  }
  /** @override */
  fromArray(t) {
    const n = this.makeDestinationObject();
    for (const r of this.fields)
      r.property !== void 0 && 0 < t.length && (n[r.property] = t.shift());
    return n;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const n of this.fields)
      if (n.property === t)
        return n;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    let n = 0;
    for (const r of this.fields) {
      if (r.property === t)
        return n;
      0 > r.span ? n = -1 : 0 <= n && (n += r.span);
    }
  }
}, Wk = class {
  constructor(t) {
    this.property = t;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode() {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode() {
    throw new Error("UnionDiscriminator is abstract");
  }
}, Hb = class extends Wk {
  constructor(t, n) {
    if (!(t instanceof Ei && t.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(n || t.property || "variant"), this.layout = t;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(t, n) {
    return this.layout.decode(t, n);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(t, n, r) {
    return this.layout.encode(t, n, r);
  }
}, Kk = class extends Bn {
  constructor(t, n, r) {
    const i = t instanceof Sa || t instanceof Xa;
    if (i)
      t = new Hb(new $k(t));
    else if (t instanceof Ei && t.isCount())
      t = new Hb(t);
    else if (!(t instanceof Wk))
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (n === void 0 && (n = null), !(n === null || n instanceof Bn))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (n !== null) {
      if (0 > n.span)
        throw new Error("defaultLayout must have constant span");
      n.property === void 0 && (n = n.replicate("content"));
    }
    let o = -1;
    n && (o = n.span, 0 <= o && i && (o += t.layout.span)), super(o, r), this.discriminator = t, this.usesPrefixDiscriminator = i, this.defaultLayout = n, this.registry = {};
    let a = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(s) {
      return a(s);
    }, this.configGetSourceVariant = function(s) {
      a = s.bind(this);
    };
  }
  /** @override */
  getSpan(t, n) {
    if (0 <= this.span)
      return this.span;
    n === void 0 && (n = 0);
    const r = this.getVariant(t, n);
    if (!r)
      throw new Error("unable to determine span for unrecognized variant");
    return r.getSpan(t, n);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(t) {
    if (t.hasOwnProperty(this.discriminator.property)) {
      if (this.defaultLayout && t.hasOwnProperty(this.defaultLayout.property))
        return;
      const n = this.registry[t[this.discriminator.property]];
      if (n && (!n.layout || t.hasOwnProperty(n.property)))
        return n;
    } else
      for (const n in this.registry) {
        const r = this.registry[n];
        if (t.hasOwnProperty(r.property))
          return r;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(t, n) {
    n === void 0 && (n = 0);
    let r;
    const i = this.discriminator, o = i.decode(t, n);
    let a = this.registry[o];
    if (a === void 0) {
      let s = 0;
      a = this.defaultLayout, this.usesPrefixDiscriminator && (s = i.layout.span), r = this.makeDestinationObject(), r[i.property] = o, r[a.property] = this.defaultLayout.decode(t, n + s);
    } else
      r = a.decode(t, n);
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = this.getSourceVariant(t);
    if (i === void 0) {
      const o = this.discriminator, a = this.defaultLayout;
      let s = 0;
      return this.usesPrefixDiscriminator && (s = o.layout.span), o.encode(t[o.property], n, r), s + a.encode(
        t[a.property],
        n,
        r + s
      );
    }
    return i.encode(t, n, r);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(t, n, r) {
    const i = new VR(this, t, n, r);
    return this.registry[t] = i, i;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(t, n) {
    let r = t;
    return Buffer.isBuffer(t) && (n === void 0 && (n = 0), r = this.discriminator.decode(t, n)), this.registry[r];
  }
}, VR = class extends Bn {
  constructor(t, n, r, i) {
    if (!(t instanceof Kk))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(n) || 0 > n)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof r == "string" && i === void 0 && (i = r, r = null), r) {
      if (!(r instanceof Bn))
        throw new TypeError("layout must be a Layout");
      if (t.defaultLayout !== null && 0 <= r.span && r.span > t.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof i != "string")
        throw new TypeError("variant must have a String property");
    }
    let o = t.span;
    0 > t.span && (o = r ? r.span : 0, 0 <= o && t.usesPrefixDiscriminator && (o += t.discriminator.layout.span)), super(o, i), this.union = t, this.variant = n, this.layout = r || null;
  }
  /** @override */
  getSpan(t, n) {
    if (0 <= this.span)
      return this.span;
    n === void 0 && (n = 0);
    let r = 0;
    return this.union.usesPrefixDiscriminator && (r = this.union.discriminator.layout.span), r + this.layout.getSpan(t, n + r);
  }
  /** @override */
  decode(t, n) {
    const r = this.makeDestinationObject();
    if (n === void 0 && (n = 0), this !== this.union.getVariant(t, n))
      throw new Error("variant mismatch");
    let i = 0;
    return this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout ? r[this.property] = this.layout.decode(t, n + i) : this.property ? r[this.property] = !0 : this.union.usesPrefixDiscriminator && (r[this.union.discriminator.property] = this.variant), r;
  }
  /** @override */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    let i = 0;
    if (this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout && !t.hasOwnProperty(this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, n, r);
    let o = i;
    if (this.layout && (this.layout.encode(t[this.property], n, r + i), o += this.layout.getSpan(n, r + i), 0 <= this.union.span && o > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return o;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(t) {
    if (this.layout)
      return this.layout.fromArray(t);
  }
};
function Mu(e) {
  return 0 > e && (e += 4294967296), e;
}
class Vk extends Bn {
  constructor(t, n, r) {
    if (!(t instanceof Sa || t instanceof Xa))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof n == "string" && r === void 0 && (r = n, n = void 0), 4 < t.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(t.span, r), this.word = t, this.msb = !!n, this.fields = [];
    let i = 0;
    this._packedSetValue = function(o) {
      return i = Mu(o), this;
    }, this._packedGetValue = function() {
      return i;
    };
  }
  /** @override */
  decode(t, n) {
    const r = this.makeDestinationObject();
    n === void 0 && (n = 0);
    const i = this.word.decode(t, n);
    this._packedSetValue(i);
    for (const o of this.fields)
      o.property !== void 0 && (r[o.property] = o.decode(i));
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = this.word.decode(n, r);
    this._packedSetValue(i);
    for (const o of this.fields)
      if (o.property !== void 0) {
        const a = t[o.property];
        a !== void 0 && o.encode(a);
      }
    return this.word.encode(this._packedGetValue(), n, r);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(t, n) {
    const r = new qf(this, t, n);
    return this.fields.push(r), r;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  addBoolean(t) {
    const n = new qR(this, t);
    return this.fields.push(n), n;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const n of this.fields)
      if (n.property === t)
        return n;
  }
}
class qf {
  constructor(t, n, r) {
    if (!(t instanceof Vk))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(n) || 0 >= n)
      throw new TypeError("bits must be positive integer");
    const i = 8 * t.span, o = t.fields.reduce((a, s) => a + s.bits, 0);
    if (n + o > i)
      throw new Error("bits too long for span remainder (" + (i - o) + " of " + i + " remain)");
    this.container = t, this.bits = n, this.valueMask = (1 << n) - 1, n === 32 && (this.valueMask = 4294967295), this.start = o, this.container.msb && (this.start = i - o - n), this.wordMask = Mu(this.valueMask << this.start), this.property = r;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode() {
    const t = this.container._packedGetValue();
    return Mu(t & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(t) {
    if (!Number.isInteger(t) || t !== Mu(t & this.valueMask))
      throw new TypeError(Lk("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const n = this.container._packedGetValue(), r = Mu(t << this.start);
    this.container._packedSetValue(Mu(n & ~this.wordMask) | r);
  }
}
let qR = class extends qf {
  constructor(t, n) {
    super(t, 1, n);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(t, n) {
    return !!qf.prototype.decode.call(this, t, n);
  }
  /** @override */
  encode(t) {
    return typeof t == "boolean" && (t = +t), qf.prototype.encode.call(this, t);
  }
}, HR = class extends Bn {
  constructor(t, n) {
    if (!(t instanceof Ei && t.isCount() || Number.isInteger(t) && 0 <= t))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let r = -1;
    t instanceof Ei || (r = t), super(r, n), this.length = t;
  }
  /** @override */
  getSpan(t, n) {
    let r = this.span;
    return 0 > r && (r = this.length.decode(t, n)), r;
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    let r = this.span;
    return 0 > r && (r = this.length.decode(t, n)), t.slice(n, n + r);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, n, r) {
    let i = this.length;
    if (this.length instanceof Ei && (i = t.length), !(Buffer.isBuffer(t) && i === t.length))
      throw new TypeError(Lk("Blob.encode", this) + " requires (length " + i + ") Buffer as src");
    if (r + i > n.length)
      throw new RangeError("encoding overruns Buffer");
    return n.write(t.toString("hex"), r, i, "hex"), this.length instanceof Ei && this.length.encode(i, n, r), i;
  }
};
class GR extends Bn {
  constructor(t) {
    super(-1, t);
  }
  /** @override */
  getSpan(t, n) {
    if (!Buffer.isBuffer(t))
      throw new TypeError("b must be a Buffer");
    n === void 0 && (n = 0);
    let r = n;
    for (; r < t.length && t[r] !== 0; )
      r += 1;
    return 1 + r - n;
  }
  /** @override */
  decode(t, n, r) {
    n === void 0 && (n = 0);
    let i = this.getSpan(t, n);
    return t.slice(n, n + i - 1).toString("utf-8");
  }
  /** @override */
  encode(t, n, r) {
    r === void 0 && (r = 0), typeof t != "string" && (t = t.toString());
    const i = new Buffer(t, "utf8"), o = i.length;
    if (r + o > n.length)
      throw new RangeError("encoding overruns Buffer");
    return i.copy(n, r), n[r + o] = 0, o + 1;
  }
}
class YR extends Bn {
  constructor(t, n) {
    if (typeof t == "string" && n === void 0 && (n = t, t = void 0), t === void 0)
      t = -1;
    else if (!Number.isInteger(t))
      throw new TypeError("maxSpan must be an integer");
    super(-1, n), this.maxSpan = t;
  }
  /** @override */
  getSpan(t, n) {
    if (!Buffer.isBuffer(t))
      throw new TypeError("b must be a Buffer");
    return n === void 0 && (n = 0), t.length - n;
  }
  /** @override */
  decode(t, n, r) {
    n === void 0 && (n = 0);
    let i = this.getSpan(t, n);
    if (0 <= this.maxSpan && this.maxSpan < i)
      throw new RangeError("text length exceeds maxSpan");
    return t.slice(n, n + i).toString("utf-8");
  }
  /** @override */
  encode(t, n, r) {
    r === void 0 && (r = 0), typeof t != "string" && (t = t.toString());
    const i = new Buffer(t, "utf8"), o = i.length;
    if (0 <= this.maxSpan && this.maxSpan < o)
      throw new RangeError("text length exceeds maxSpan");
    if (r + o > n.length)
      throw new RangeError("encoding overruns Buffer");
    return i.copy(n, r), o;
  }
}
class ZR extends Bn {
  constructor(t, n) {
    super(0, n), this.value = t;
  }
  /** @override */
  decode(t, n, r) {
    return this.value;
  }
  /** @override */
  encode(t, n, r) {
    return 0;
  }
}
Qe.ExternalLayout = Ei;
Qe.GreedyCount = UR;
Qe.OffsetLayout = $k;
Qe.UInt = Sa;
Qe.UIntBE = Xa;
Qe.Int = ou;
Qe.IntBE = Wl;
Qe.Float = zR;
Qe.FloatBE = FR;
Qe.Double = LR;
Qe.DoubleBE = $R;
Qe.Sequence = WR;
Qe.Structure = KR;
Qe.UnionDiscriminator = Wk;
Qe.UnionLayoutDiscriminator = Hb;
Qe.Union = Kk;
Qe.VariantLayout = VR;
Qe.BitStructure = Vk;
Qe.BitField = qf;
Qe.Boolean = qR;
Qe.Blob = HR;
Qe.CString = GR;
Qe.UTF8 = YR;
Qe.Constant = ZR;
Qe.greedy = (e, t) => new UR(e, t);
Qe.offset = (e, t, n) => new $k(e, t, n);
Qe.u8 = (e) => new Sa(1, e);
Qe.u16 = (e) => new Sa(2, e);
Qe.u24 = (e) => new Sa(3, e);
Qe.u32 = (e) => new Sa(4, e);
Qe.u40 = (e) => new Sa(5, e);
Qe.u48 = (e) => new Sa(6, e);
Qe.nu64 = (e) => new cZ(e);
Qe.u16be = (e) => new Xa(2, e);
Qe.u24be = (e) => new Xa(3, e);
Qe.u32be = (e) => new Xa(4, e);
Qe.u40be = (e) => new Xa(5, e);
Qe.u48be = (e) => new Xa(6, e);
Qe.nu64be = (e) => new uZ(e);
Qe.s8 = (e) => new ou(1, e);
Qe.s16 = (e) => new ou(2, e);
Qe.s24 = (e) => new ou(3, e);
Qe.s32 = (e) => new ou(4, e);
Qe.s40 = (e) => new ou(5, e);
Qe.s48 = (e) => new ou(6, e);
Qe.ns64 = (e) => new lZ(e);
Qe.s16be = (e) => new Wl(2, e);
Qe.s24be = (e) => new Wl(3, e);
Qe.s32be = (e) => new Wl(4, e);
Qe.s40be = (e) => new Wl(5, e);
Qe.s48be = (e) => new Wl(6, e);
Qe.ns64be = (e) => new fZ(e);
Qe.f32 = (e) => new zR(e);
Qe.f32be = (e) => new FR(e);
Qe.f64 = (e) => new LR(e);
Qe.f64be = (e) => new $R(e);
Qe.struct = (e, t, n) => new KR(e, t, n);
Qe.bits = (e, t, n) => new Vk(e, t, n);
Qe.seq = (e, t, n) => new WR(e, t, n);
Qe.union = (e, t, n) => new Kk(e, t, n);
Qe.unionLayoutDiscriminator = (e, t) => new Hb(e, t);
Qe.blob = (e, t) => new HR(e, t);
Qe.cstr = (e) => new GR(e);
Qe.utf8 = (e, t) => new YR(e, t);
Qe.const = (e, t) => new ZR(e, t);
const we = /* @__PURE__ */ Qc(QY);
(function(e) {
  var t = _ && _.__importDefault || function(M) {
    return M && M.__esModule ? M : { default: M };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.map = e.array = e.rustEnum = e.str = e.vecU8 = e.tagged = e.vec = e.bool = e.option = e.publicKey = e.i256 = e.u256 = e.i128 = e.u128 = e.i64 = e.u64 = e.struct = e.f64 = e.f32 = e.i32 = e.u32 = e.i16 = e.u16 = e.i8 = e.u8 = void 0;
  const n = Qe, r = we, i = t(Ka);
  var o = Qe;
  Object.defineProperty(e, "u8", { enumerable: !0, get: function() {
    return o.u8;
  } }), Object.defineProperty(e, "i8", { enumerable: !0, get: function() {
    return o.s8;
  } }), Object.defineProperty(e, "u16", { enumerable: !0, get: function() {
    return o.u16;
  } }), Object.defineProperty(e, "i16", { enumerable: !0, get: function() {
    return o.s16;
  } }), Object.defineProperty(e, "u32", { enumerable: !0, get: function() {
    return o.u32;
  } }), Object.defineProperty(e, "i32", { enumerable: !0, get: function() {
    return o.s32;
  } }), Object.defineProperty(e, "f32", { enumerable: !0, get: function() {
    return o.f32;
  } }), Object.defineProperty(e, "f64", { enumerable: !0, get: function() {
    return o.f64;
  } }), Object.defineProperty(e, "struct", { enumerable: !0, get: function() {
    return o.struct;
  } });
  class a extends n.Layout {
    constructor(S, p, y) {
      super(S, y), this.blob = (0, n.blob)(S), this.signed = p;
    }
    decode(S, p = 0) {
      const y = new i.default(this.blob.decode(S, p), 10, "le");
      return this.signed ? y.fromTwos(this.span * 8).clone() : y;
    }
    encode(S, p, y = 0) {
      return this.signed && (S = S.toTwos(this.span * 8)), this.blob.encode(S.toArrayLike(Buffer, "le", this.span), p, y);
    }
  }
  function s(M) {
    return new a(8, !1, M);
  }
  e.u64 = s;
  function c(M) {
    return new a(8, !0, M);
  }
  e.i64 = c;
  function l(M) {
    return new a(16, !1, M);
  }
  e.u128 = l;
  function u(M) {
    return new a(16, !0, M);
  }
  e.i128 = u;
  function f(M) {
    return new a(32, !1, M);
  }
  e.u256 = f;
  function d(M) {
    return new a(32, !0, M);
  }
  e.i256 = d;
  class h extends n.Layout {
    constructor(S, p, y, v) {
      super(S.span, v), this.layout = S, this.decoder = p, this.encoder = y;
    }
    decode(S, p) {
      return this.decoder(this.layout.decode(S, p));
    }
    encode(S, p, y) {
      return this.layout.encode(this.encoder(S), p, y);
    }
    getSpan(S, p) {
      return this.layout.getSpan(S, p);
    }
  }
  function g(M) {
    return new h((0, n.blob)(32), (S) => new r.PublicKey(S), (S) => S.toBuffer(), M);
  }
  e.publicKey = g;
  class w extends n.Layout {
    constructor(S, p) {
      super(-1, p), this.layout = S, this.discriminator = (0, n.u8)();
    }
    encode(S, p, y = 0) {
      return S == null ? this.discriminator.encode(0, p, y) : (this.discriminator.encode(1, p, y), this.layout.encode(S, p, y + 1) + 1);
    }
    decode(S, p = 0) {
      const y = this.discriminator.decode(S, p);
      if (y === 0)
        return null;
      if (y === 1)
        return this.layout.decode(S, p + 1);
      throw new Error("Invalid option " + this.property);
    }
    getSpan(S, p = 0) {
      const y = this.discriminator.decode(S, p);
      if (y === 0)
        return 1;
      if (y === 1)
        return this.layout.getSpan(S, p + 1) + 1;
      throw new Error("Invalid option " + this.property);
    }
  }
  function b(M, S) {
    return new w(M, S);
  }
  e.option = b;
  function I(M) {
    return new h((0, n.u8)(), A, x, M);
  }
  e.bool = I;
  function A(M) {
    if (M === 0)
      return !1;
    if (M === 1)
      return !0;
    throw new Error("Invalid bool: " + M);
  }
  function x(M) {
    return M ? 1 : 0;
  }
  function N(M, S) {
    const p = (0, n.u32)("length"), y = (0, n.struct)([
      p,
      (0, n.seq)(M, (0, n.offset)(p, -p.span), "values")
    ]);
    return new h(y, ({ values: v }) => v, (v) => ({ values: v }), S);
  }
  e.vec = N;
  function j(M, S, p) {
    const y = (0, n.struct)([
      s("tag"),
      S.replicate("data")
    ]);
    function v({ tag: E, data: B }) {
      if (!E.eq(M))
        throw new Error("Invalid tag, expected: " + M.toString("hex") + ", got: " + E.toString("hex"));
      return B;
    }
    return new h(y, v, (E) => ({ tag: M, data: E }), p);
  }
  e.tagged = j;
  function K(M) {
    const S = (0, n.u32)("length"), p = (0, n.struct)([
      S,
      (0, n.blob)((0, n.offset)(S, -S.span), "data")
    ]);
    return new h(p, ({ data: y }) => y, (y) => ({ data: y }), M);
  }
  e.vecU8 = K;
  function W(M) {
    return new h(K(), (S) => S.toString("utf-8"), (S) => Buffer.from(S, "utf-8"), M);
  }
  e.str = W;
  function O(M, S, p) {
    const y = (0, n.union)(p ?? (0, n.u8)(), S);
    return M.forEach((v, E) => y.addVariant(E, v, v.property)), y;
  }
  e.rustEnum = O;
  function k(M, S, p) {
    const y = (0, n.struct)([
      (0, n.seq)(M, S, "values")
    ]);
    return new h(y, ({ values: v }) => v, (v) => ({ values: v }), p);
  }
  e.array = k;
  class z extends n.Layout {
    constructor(S, p, y) {
      super(S.span + p.span, y), this.keyLayout = S, this.valueLayout = p;
    }
    decode(S, p) {
      p = p || 0;
      const y = this.keyLayout.decode(S, p), v = this.valueLayout.decode(S, p + this.keyLayout.getSpan(S, p));
      return [y, v];
    }
    encode(S, p, y) {
      y = y || 0;
      const v = this.keyLayout.encode(S[0], p, y), E = this.valueLayout.encode(S[1], p, y + v);
      return v + E;
    }
    getSpan(S, p) {
      return this.keyLayout.getSpan(S, p) + this.valueLayout.getSpan(S, p);
    }
  }
  function C(M, S, p) {
    const y = (0, n.u32)("length"), v = (0, n.struct)([
      y,
      (0, n.seq)(new z(M, S), (0, n.offset)(y, -y.span), "values")
    ]);
    return new h(v, ({ values: E }) => new Map(E), (E) => ({ values: Array.from(E.entries()) }), p);
  }
  e.map = C;
})(Ut);
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
const dZ = 4, gM = 0, bM = 1, hZ = 2;
function Kl(e) {
  let t = e.length;
  for (; --t >= 0; )
    e[t] = 0;
}
const pZ = 0, JR = 1, yZ = 2, gZ = 3, bZ = 258, qk = 29, zd = 256, cd = zd + 1 + qk, Ju = 30, Hk = 19, XR = 2 * cd + 1, mc = 15, s1 = 16, mZ = 7, Gk = 256, QR = 16, e8 = 17, t8 = 18, bA = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), ab = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), _Z = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), n8 = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), wZ = 512, Ba = new Array((cd + 2) * 2);
Kl(Ba);
const Hf = new Array(Ju * 2);
Kl(Hf);
const ud = new Array(wZ);
Kl(ud);
const ld = new Array(bZ - gZ + 1);
Kl(ld);
const Yk = new Array(qk);
Kl(Yk);
const Gb = new Array(Ju);
Kl(Gb);
function c1(e, t, n, r, i) {
  this.static_tree = e, this.extra_bits = t, this.extra_base = n, this.elems = r, this.max_length = i, this.has_stree = e && e.length;
}
let r8, i8, o8;
function u1(e, t) {
  this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
}
const a8 = (e) => e < 256 ? ud[e] : ud[256 + (e >>> 7)], fd = (e, t) => {
  e.pending_buf[e.pending++] = t & 255, e.pending_buf[e.pending++] = t >>> 8 & 255;
}, Ai = (e, t, n) => {
  e.bi_valid > s1 - n ? (e.bi_buf |= t << e.bi_valid & 65535, fd(e, e.bi_buf), e.bi_buf = t >> s1 - e.bi_valid, e.bi_valid += n - s1) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += n);
}, ia = (e, t, n) => {
  Ai(
    e,
    n[t * 2],
    n[t * 2 + 1]
    /*.Len*/
  );
}, s8 = (e, t) => {
  let n = 0;
  do
    n |= e & 1, e >>>= 1, n <<= 1;
  while (--t > 0);
  return n >>> 1;
}, vZ = (e) => {
  e.bi_valid === 16 ? (fd(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
}, SZ = (e, t) => {
  const n = t.dyn_tree, r = t.max_code, i = t.stat_desc.static_tree, o = t.stat_desc.has_stree, a = t.stat_desc.extra_bits, s = t.stat_desc.extra_base, c = t.stat_desc.max_length;
  let l, u, f, d, h, g, w = 0;
  for (d = 0; d <= mc; d++)
    e.bl_count[d] = 0;
  for (n[e.heap[e.heap_max] * 2 + 1] = 0, l = e.heap_max + 1; l < XR; l++)
    u = e.heap[l], d = n[n[u * 2 + 1] * 2 + 1] + 1, d > c && (d = c, w++), n[u * 2 + 1] = d, !(u > r) && (e.bl_count[d]++, h = 0, u >= s && (h = a[u - s]), g = n[u * 2], e.opt_len += g * (d + h), o && (e.static_len += g * (i[u * 2 + 1] + h)));
  if (w !== 0) {
    do {
      for (d = c - 1; e.bl_count[d] === 0; )
        d--;
      e.bl_count[d]--, e.bl_count[d + 1] += 2, e.bl_count[c]--, w -= 2;
    } while (w > 0);
    for (d = c; d !== 0; d--)
      for (u = e.bl_count[d]; u !== 0; )
        f = e.heap[--l], !(f > r) && (n[f * 2 + 1] !== d && (e.opt_len += (d - n[f * 2 + 1]) * n[f * 2], n[f * 2 + 1] = d), u--);
  }
}, c8 = (e, t, n) => {
  const r = new Array(mc + 1);
  let i = 0, o, a;
  for (o = 1; o <= mc; o++)
    i = i + n[o - 1] << 1, r[o] = i;
  for (a = 0; a <= t; a++) {
    let s = e[a * 2 + 1];
    s !== 0 && (e[a * 2] = s8(r[s]++, s));
  }
}, EZ = () => {
  let e, t, n, r, i;
  const o = new Array(mc + 1);
  for (n = 0, r = 0; r < qk - 1; r++)
    for (Yk[r] = n, e = 0; e < 1 << bA[r]; e++)
      ld[n++] = r;
  for (ld[n - 1] = r, i = 0, r = 0; r < 16; r++)
    for (Gb[r] = i, e = 0; e < 1 << ab[r]; e++)
      ud[i++] = r;
  for (i >>= 7; r < Ju; r++)
    for (Gb[r] = i << 7, e = 0; e < 1 << ab[r] - 7; e++)
      ud[256 + i++] = r;
  for (t = 0; t <= mc; t++)
    o[t] = 0;
  for (e = 0; e <= 143; )
    Ba[e * 2 + 1] = 8, e++, o[8]++;
  for (; e <= 255; )
    Ba[e * 2 + 1] = 9, e++, o[9]++;
  for (; e <= 279; )
    Ba[e * 2 + 1] = 7, e++, o[7]++;
  for (; e <= 287; )
    Ba[e * 2 + 1] = 8, e++, o[8]++;
  for (c8(Ba, cd + 1, o), e = 0; e < Ju; e++)
    Hf[e * 2 + 1] = 5, Hf[e * 2] = s8(e, 5);
  r8 = new c1(Ba, bA, zd + 1, cd, mc), i8 = new c1(Hf, ab, 0, Ju, mc), o8 = new c1(new Array(0), _Z, 0, Hk, mZ);
}, u8 = (e) => {
  let t;
  for (t = 0; t < cd; t++)
    e.dyn_ltree[t * 2] = 0;
  for (t = 0; t < Ju; t++)
    e.dyn_dtree[t * 2] = 0;
  for (t = 0; t < Hk; t++)
    e.bl_tree[t * 2] = 0;
  e.dyn_ltree[Gk * 2] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
}, l8 = (e) => {
  e.bi_valid > 8 ? fd(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}, mM = (e, t, n, r) => {
  const i = t * 2, o = n * 2;
  return e[i] < e[o] || e[i] === e[o] && r[t] <= r[n];
}, l1 = (e, t, n) => {
  const r = e.heap[n];
  let i = n << 1;
  for (; i <= e.heap_len && (i < e.heap_len && mM(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !mM(t, r, e.heap[i], e.depth)); )
    e.heap[n] = e.heap[i], n = i, i <<= 1;
  e.heap[n] = r;
}, _M = (e, t, n) => {
  let r, i, o = 0, a, s;
  if (e.sym_next !== 0)
    do
      r = e.pending_buf[e.sym_buf + o++] & 255, r += (e.pending_buf[e.sym_buf + o++] & 255) << 8, i = e.pending_buf[e.sym_buf + o++], r === 0 ? ia(e, i, t) : (a = ld[i], ia(e, a + zd + 1, t), s = bA[a], s !== 0 && (i -= Yk[a], Ai(e, i, s)), r--, a = a8(r), ia(e, a, n), s = ab[a], s !== 0 && (r -= Gb[a], Ai(e, r, s)));
    while (o < e.sym_next);
  ia(e, Gk, t);
}, mA = (e, t) => {
  const n = t.dyn_tree, r = t.stat_desc.static_tree, i = t.stat_desc.has_stree, o = t.stat_desc.elems;
  let a, s, c = -1, l;
  for (e.heap_len = 0, e.heap_max = XR, a = 0; a < o; a++)
    n[a * 2] !== 0 ? (e.heap[++e.heap_len] = c = a, e.depth[a] = 0) : n[a * 2 + 1] = 0;
  for (; e.heap_len < 2; )
    l = e.heap[++e.heap_len] = c < 2 ? ++c : 0, n[l * 2] = 1, e.depth[l] = 0, e.opt_len--, i && (e.static_len -= r[l * 2 + 1]);
  for (t.max_code = c, a = e.heap_len >> 1; a >= 1; a--)
    l1(e, n, a);
  l = o;
  do
    a = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[
      1
      /*SMALLEST*/
    ] = e.heap[e.heap_len--], l1(
      e,
      n,
      1
      /*SMALLEST*/
    ), s = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[--e.heap_max] = a, e.heap[--e.heap_max] = s, n[l * 2] = n[a * 2] + n[s * 2], e.depth[l] = (e.depth[a] >= e.depth[s] ? e.depth[a] : e.depth[s]) + 1, n[a * 2 + 1] = n[s * 2 + 1] = l, e.heap[
      1
      /*SMALLEST*/
    ] = l++, l1(
      e,
      n,
      1
      /*SMALLEST*/
    );
  while (e.heap_len >= 2);
  e.heap[--e.heap_max] = e.heap[
    1
    /*SMALLEST*/
  ], SZ(e, t), c8(n, c, e.bl_count);
}, wM = (e, t, n) => {
  let r, i = -1, o, a = t[0 * 2 + 1], s = 0, c = 7, l = 4;
  for (a === 0 && (c = 138, l = 3), t[(n + 1) * 2 + 1] = 65535, r = 0; r <= n; r++)
    o = a, a = t[(r + 1) * 2 + 1], !(++s < c && o === a) && (s < l ? e.bl_tree[o * 2] += s : o !== 0 ? (o !== i && e.bl_tree[o * 2]++, e.bl_tree[QR * 2]++) : s <= 10 ? e.bl_tree[e8 * 2]++ : e.bl_tree[t8 * 2]++, s = 0, i = o, a === 0 ? (c = 138, l = 3) : o === a ? (c = 6, l = 3) : (c = 7, l = 4));
}, vM = (e, t, n) => {
  let r, i = -1, o, a = t[0 * 2 + 1], s = 0, c = 7, l = 4;
  for (a === 0 && (c = 138, l = 3), r = 0; r <= n; r++)
    if (o = a, a = t[(r + 1) * 2 + 1], !(++s < c && o === a)) {
      if (s < l)
        do
          ia(e, o, e.bl_tree);
        while (--s !== 0);
      else
        o !== 0 ? (o !== i && (ia(e, o, e.bl_tree), s--), ia(e, QR, e.bl_tree), Ai(e, s - 3, 2)) : s <= 10 ? (ia(e, e8, e.bl_tree), Ai(e, s - 3, 3)) : (ia(e, t8, e.bl_tree), Ai(e, s - 11, 7));
      s = 0, i = o, a === 0 ? (c = 138, l = 3) : o === a ? (c = 6, l = 3) : (c = 7, l = 4);
    }
}, AZ = (e) => {
  let t;
  for (wM(e, e.dyn_ltree, e.l_desc.max_code), wM(e, e.dyn_dtree, e.d_desc.max_code), mA(e, e.bl_desc), t = Hk - 1; t >= 3 && e.bl_tree[n8[t] * 2 + 1] === 0; t--)
    ;
  return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
}, IZ = (e, t, n, r) => {
  let i;
  for (Ai(e, t - 257, 5), Ai(e, n - 1, 5), Ai(e, r - 4, 4), i = 0; i < r; i++)
    Ai(e, e.bl_tree[n8[i] * 2 + 1], 3);
  vM(e, e.dyn_ltree, t - 1), vM(e, e.dyn_dtree, n - 1);
}, kZ = (e) => {
  let t = 4093624447, n;
  for (n = 0; n <= 31; n++, t >>>= 1)
    if (t & 1 && e.dyn_ltree[n * 2] !== 0)
      return gM;
  if (e.dyn_ltree[9 * 2] !== 0 || e.dyn_ltree[10 * 2] !== 0 || e.dyn_ltree[13 * 2] !== 0)
    return bM;
  for (n = 32; n < zd; n++)
    if (e.dyn_ltree[n * 2] !== 0)
      return bM;
  return gM;
};
let SM = !1;
const TZ = (e) => {
  SM || (EZ(), SM = !0), e.l_desc = new u1(e.dyn_ltree, r8), e.d_desc = new u1(e.dyn_dtree, i8), e.bl_desc = new u1(e.bl_tree, o8), e.bi_buf = 0, e.bi_valid = 0, u8(e);
}, f8 = (e, t, n, r) => {
  Ai(e, (pZ << 1) + (r ? 1 : 0), 3), l8(e), fd(e, n), fd(e, ~n), n && e.pending_buf.set(e.window.subarray(t, t + n), e.pending), e.pending += n;
}, xZ = (e) => {
  Ai(e, JR << 1, 3), ia(e, Gk, Ba), vZ(e);
}, MZ = (e, t, n, r) => {
  let i, o, a = 0;
  e.level > 0 ? (e.strm.data_type === hZ && (e.strm.data_type = kZ(e)), mA(e, e.l_desc), mA(e, e.d_desc), a = AZ(e), i = e.opt_len + 3 + 7 >>> 3, o = e.static_len + 3 + 7 >>> 3, o <= i && (i = o)) : i = o = n + 5, n + 4 <= i && t !== -1 ? f8(e, t, n, r) : e.strategy === dZ || o === i ? (Ai(e, (JR << 1) + (r ? 1 : 0), 3), _M(e, Ba, Hf)) : (Ai(e, (yZ << 1) + (r ? 1 : 0), 3), IZ(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), _M(e, e.dyn_ltree, e.dyn_dtree)), u8(e), r && l8(e);
}, OZ = (e, t, n) => (e.pending_buf[e.sym_buf + e.sym_next++] = t, e.pending_buf[e.sym_buf + e.sym_next++] = t >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = n, t === 0 ? e.dyn_ltree[n * 2]++ : (e.matches++, t--, e.dyn_ltree[(ld[n] + zd + 1) * 2]++, e.dyn_dtree[a8(t) * 2]++), e.sym_next === e.sym_end);
var PZ = TZ, BZ = f8, CZ = MZ, DZ = OZ, RZ = xZ, NZ = {
  _tr_init: PZ,
  _tr_stored_block: BZ,
  _tr_flush_block: CZ,
  _tr_tally: DZ,
  _tr_align: RZ
};
const jZ = (e, t, n, r) => {
  let i = e & 65535 | 0, o = e >>> 16 & 65535 | 0, a = 0;
  for (; n !== 0; ) {
    a = n > 2e3 ? 2e3 : n, n -= a;
    do
      i = i + t[r++] | 0, o = o + i | 0;
    while (--a);
    i %= 65521, o %= 65521;
  }
  return i | o << 16 | 0;
};
var dd = jZ;
const UZ = () => {
  let e, t = [];
  for (var n = 0; n < 256; n++) {
    e = n;
    for (var r = 0; r < 8; r++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    t[n] = e;
  }
  return t;
}, zZ = new Uint32Array(UZ()), FZ = (e, t, n, r) => {
  const i = zZ, o = r + n;
  e ^= -1;
  for (let a = r; a < o; a++)
    e = e >>> 8 ^ i[(e ^ t[a]) & 255];
  return e ^ -1;
};
var zr = FZ, bl = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, Fd = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init: LZ, _tr_stored_block: _A, _tr_flush_block: $Z, _tr_tally: zs, _tr_align: WZ } = NZ, {
  Z_NO_FLUSH: Fs,
  Z_PARTIAL_FLUSH: KZ,
  Z_FULL_FLUSH: VZ,
  Z_FINISH: co,
  Z_BLOCK: EM,
  Z_OK: qr,
  Z_STREAM_END: AM,
  Z_STREAM_ERROR: fa,
  Z_DATA_ERROR: qZ,
  Z_BUF_ERROR: f1,
  Z_DEFAULT_COMPRESSION: HZ,
  Z_FILTERED: GZ,
  Z_HUFFMAN_ONLY: Eg,
  Z_RLE: YZ,
  Z_FIXED: ZZ,
  Z_DEFAULT_STRATEGY: JZ,
  Z_UNKNOWN: XZ,
  Z_DEFLATED: y_
} = Fd, QZ = 9, eJ = 15, tJ = 8, nJ = 29, rJ = 256, wA = rJ + 1 + nJ, iJ = 30, oJ = 19, aJ = 2 * wA + 1, sJ = 15, on = 3, Ps = 258, da = Ps + on + 1, cJ = 32, ml = 42, Zk = 57, vA = 69, SA = 73, EA = 91, AA = 103, _c = 113, Of = 666, di = 1, Vl = 2, Rc = 3, ql = 4, uJ = 3, wc = (e, t) => (e.msg = bl[t], t), IM = (e) => e * 2 - (e > 4 ? 9 : 0), Ts = (e) => {
  let t = e.length;
  for (; --t >= 0; )
    e[t] = 0;
}, lJ = (e) => {
  let t, n, r, i = e.w_size;
  t = e.hash_size, r = t;
  do
    n = e.head[--r], e.head[r] = n >= i ? n - i : 0;
  while (--t);
  t = i, r = t;
  do
    n = e.prev[--r], e.prev[r] = n >= i ? n - i : 0;
  while (--t);
};
let fJ = (e, t, n) => (t << e.hash_shift ^ n) & e.hash_mask, Ls = fJ;
const Ci = (e) => {
  const t = e.state;
  let n = t.pending;
  n > e.avail_out && (n = e.avail_out), n !== 0 && (e.output.set(t.pending_buf.subarray(t.pending_out, t.pending_out + n), e.next_out), e.next_out += n, t.pending_out += n, e.total_out += n, e.avail_out -= n, t.pending -= n, t.pending === 0 && (t.pending_out = 0));
}, Wi = (e, t) => {
  $Z(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, Ci(e.strm);
}, Sn = (e, t) => {
  e.pending_buf[e.pending++] = t;
}, df = (e, t) => {
  e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = t & 255;
}, IA = (e, t, n, r) => {
  let i = e.avail_in;
  return i > r && (i = r), i === 0 ? 0 : (e.avail_in -= i, t.set(e.input.subarray(e.next_in, e.next_in + i), n), e.state.wrap === 1 ? e.adler = dd(e.adler, t, i, n) : e.state.wrap === 2 && (e.adler = zr(e.adler, t, i, n)), e.next_in += i, e.total_in += i, i);
}, d8 = (e, t) => {
  let n = e.max_chain_length, r = e.strstart, i, o, a = e.prev_length, s = e.nice_match;
  const c = e.strstart > e.w_size - da ? e.strstart - (e.w_size - da) : 0, l = e.window, u = e.w_mask, f = e.prev, d = e.strstart + Ps;
  let h = l[r + a - 1], g = l[r + a];
  e.prev_length >= e.good_match && (n >>= 2), s > e.lookahead && (s = e.lookahead);
  do
    if (i = t, !(l[i + a] !== g || l[i + a - 1] !== h || l[i] !== l[r] || l[++i] !== l[r + 1])) {
      r += 2, i++;
      do
        ;
      while (l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && r < d);
      if (o = Ps - (d - r), r = d - Ps, o > a) {
        if (e.match_start = t, a = o, o >= s)
          break;
        h = l[r + a - 1], g = l[r + a];
      }
    }
  while ((t = f[t & u]) > c && --n !== 0);
  return a <= e.lookahead ? a : e.lookahead;
}, _l = (e) => {
  const t = e.w_size;
  let n, r, i;
  do {
    if (r = e.window_size - e.lookahead - e.strstart, e.strstart >= t + (t - da) && (e.window.set(e.window.subarray(t, t + t - r), 0), e.match_start -= t, e.strstart -= t, e.block_start -= t, e.insert > e.strstart && (e.insert = e.strstart), lJ(e), r += t), e.strm.avail_in === 0)
      break;
    if (n = IA(e.strm, e.window, e.strstart + e.lookahead, r), e.lookahead += n, e.lookahead + e.insert >= on)
      for (i = e.strstart - e.insert, e.ins_h = e.window[i], e.ins_h = Ls(e, e.ins_h, e.window[i + 1]); e.insert && (e.ins_h = Ls(e, e.ins_h, e.window[i + on - 1]), e.prev[i & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = i, i++, e.insert--, !(e.lookahead + e.insert < on)); )
        ;
  } while (e.lookahead < da && e.strm.avail_in !== 0);
}, h8 = (e, t) => {
  let n = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5, r, i, o, a = 0, s = e.strm.avail_in;
  do {
    if (r = 65535, o = e.bi_valid + 42 >> 3, e.strm.avail_out < o || (o = e.strm.avail_out - o, i = e.strstart - e.block_start, r > i + e.strm.avail_in && (r = i + e.strm.avail_in), r > o && (r = o), r < n && (r === 0 && t !== co || t === Fs || r !== i + e.strm.avail_in)))
      break;
    a = t === co && r === i + e.strm.avail_in ? 1 : 0, _A(e, 0, 0, a), e.pending_buf[e.pending - 4] = r, e.pending_buf[e.pending - 3] = r >> 8, e.pending_buf[e.pending - 2] = ~r, e.pending_buf[e.pending - 1] = ~r >> 8, Ci(e.strm), i && (i > r && (i = r), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + i), e.strm.next_out), e.strm.next_out += i, e.strm.avail_out -= i, e.strm.total_out += i, e.block_start += i, r -= i), r && (IA(e.strm, e.strm.output, e.strm.next_out, r), e.strm.next_out += r, e.strm.avail_out -= r, e.strm.total_out += r);
  } while (a === 0);
  return s -= e.strm.avail_in, s && (s >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= s && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - s, e.strm.next_in), e.strstart), e.strstart += s, e.insert += s > e.w_size - e.insert ? e.w_size - e.insert : s), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), a ? ql : t !== Fs && t !== co && e.strm.avail_in === 0 && e.strstart === e.block_start ? Vl : (o = e.window_size - e.strstart, e.strm.avail_in > o && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, o += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), o > e.strm.avail_in && (o = e.strm.avail_in), o && (IA(e.strm, e.window, e.strstart, o), e.strstart += o, e.insert += o > e.w_size - e.insert ? e.w_size - e.insert : o), e.high_water < e.strstart && (e.high_water = e.strstart), o = e.bi_valid + 42 >> 3, o = e.pending_buf_size - o > 65535 ? 65535 : e.pending_buf_size - o, n = o > e.w_size ? e.w_size : o, i = e.strstart - e.block_start, (i >= n || (i || t === co) && t !== Fs && e.strm.avail_in === 0 && i <= o) && (r = i > o ? o : i, a = t === co && e.strm.avail_in === 0 && r === i ? 1 : 0, _A(e, e.block_start, r, a), e.block_start += r, Ci(e.strm)), a ? Rc : di);
}, d1 = (e, t) => {
  let n, r;
  for (; ; ) {
    if (e.lookahead < da) {
      if (_l(e), e.lookahead < da && t === Fs)
        return di;
      if (e.lookahead === 0)
        break;
    }
    if (n = 0, e.lookahead >= on && (e.ins_h = Ls(e, e.ins_h, e.window[e.strstart + on - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), n !== 0 && e.strstart - n <= e.w_size - da && (e.match_length = d8(e, n)), e.match_length >= on)
      if (r = zs(e, e.strstart - e.match_start, e.match_length - on), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= on) {
        e.match_length--;
        do
          e.strstart++, e.ins_h = Ls(e, e.ins_h, e.window[e.strstart + on - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
        while (--e.match_length !== 0);
        e.strstart++;
      } else
        e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = Ls(e, e.ins_h, e.window[e.strstart + 1]);
    else
      r = zs(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
    if (r && (Wi(e, !1), e.strm.avail_out === 0))
      return di;
  }
  return e.insert = e.strstart < on - 1 ? e.strstart : on - 1, t === co ? (Wi(e, !0), e.strm.avail_out === 0 ? Rc : ql) : e.sym_next && (Wi(e, !1), e.strm.avail_out === 0) ? di : Vl;
}, _u = (e, t) => {
  let n, r, i;
  for (; ; ) {
    if (e.lookahead < da) {
      if (_l(e), e.lookahead < da && t === Fs)
        return di;
      if (e.lookahead === 0)
        break;
    }
    if (n = 0, e.lookahead >= on && (e.ins_h = Ls(e, e.ins_h, e.window[e.strstart + on - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = on - 1, n !== 0 && e.prev_length < e.max_lazy_match && e.strstart - n <= e.w_size - da && (e.match_length = d8(e, n), e.match_length <= 5 && (e.strategy === GZ || e.match_length === on && e.strstart - e.match_start > 4096) && (e.match_length = on - 1)), e.prev_length >= on && e.match_length <= e.prev_length) {
      i = e.strstart + e.lookahead - on, r = zs(e, e.strstart - 1 - e.prev_match, e.prev_length - on), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
      do
        ++e.strstart <= i && (e.ins_h = Ls(e, e.ins_h, e.window[e.strstart + on - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
      while (--e.prev_length !== 0);
      if (e.match_available = 0, e.match_length = on - 1, e.strstart++, r && (Wi(e, !1), e.strm.avail_out === 0))
        return di;
    } else if (e.match_available) {
      if (r = zs(e, 0, e.window[e.strstart - 1]), r && Wi(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0)
        return di;
    } else
      e.match_available = 1, e.strstart++, e.lookahead--;
  }
  return e.match_available && (r = zs(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < on - 1 ? e.strstart : on - 1, t === co ? (Wi(e, !0), e.strm.avail_out === 0 ? Rc : ql) : e.sym_next && (Wi(e, !1), e.strm.avail_out === 0) ? di : Vl;
}, dJ = (e, t) => {
  let n, r, i, o;
  const a = e.window;
  for (; ; ) {
    if (e.lookahead <= Ps) {
      if (_l(e), e.lookahead <= Ps && t === Fs)
        return di;
      if (e.lookahead === 0)
        break;
    }
    if (e.match_length = 0, e.lookahead >= on && e.strstart > 0 && (i = e.strstart - 1, r = a[i], r === a[++i] && r === a[++i] && r === a[++i])) {
      o = e.strstart + Ps;
      do
        ;
      while (r === a[++i] && r === a[++i] && r === a[++i] && r === a[++i] && r === a[++i] && r === a[++i] && r === a[++i] && r === a[++i] && i < o);
      e.match_length = Ps - (o - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
    }
    if (e.match_length >= on ? (n = zs(e, 1, e.match_length - on), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (n = zs(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), n && (Wi(e, !1), e.strm.avail_out === 0))
      return di;
  }
  return e.insert = 0, t === co ? (Wi(e, !0), e.strm.avail_out === 0 ? Rc : ql) : e.sym_next && (Wi(e, !1), e.strm.avail_out === 0) ? di : Vl;
}, hJ = (e, t) => {
  let n;
  for (; ; ) {
    if (e.lookahead === 0 && (_l(e), e.lookahead === 0)) {
      if (t === Fs)
        return di;
      break;
    }
    if (e.match_length = 0, n = zs(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, n && (Wi(e, !1), e.strm.avail_out === 0))
      return di;
  }
  return e.insert = 0, t === co ? (Wi(e, !0), e.strm.avail_out === 0 ? Rc : ql) : e.sym_next && (Wi(e, !1), e.strm.avail_out === 0) ? di : Vl;
};
function Zo(e, t, n, r, i) {
  this.good_length = e, this.max_lazy = t, this.nice_length = n, this.max_chain = r, this.func = i;
}
const Pf = [
  /*      good lazy nice chain */
  new Zo(0, 0, 0, 0, h8),
  /* 0 store only */
  new Zo(4, 4, 8, 4, d1),
  /* 1 max speed, no lazy matches */
  new Zo(4, 5, 16, 8, d1),
  /* 2 */
  new Zo(4, 6, 32, 32, d1),
  /* 3 */
  new Zo(4, 4, 16, 16, _u),
  /* 4 lazy matches */
  new Zo(8, 16, 32, 32, _u),
  /* 5 */
  new Zo(8, 16, 128, 128, _u),
  /* 6 */
  new Zo(8, 32, 128, 256, _u),
  /* 7 */
  new Zo(32, 128, 258, 1024, _u),
  /* 8 */
  new Zo(32, 258, 258, 4096, _u)
  /* 9 max compression */
], pJ = (e) => {
  e.window_size = 2 * e.w_size, Ts(e.head), e.max_lazy_match = Pf[e.level].max_lazy, e.good_match = Pf[e.level].good_length, e.nice_match = Pf[e.level].nice_length, e.max_chain_length = Pf[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = on - 1, e.match_available = 0, e.ins_h = 0;
};
function yJ() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = y_, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(aJ * 2), this.dyn_dtree = new Uint16Array((2 * iJ + 1) * 2), this.bl_tree = new Uint16Array((2 * oJ + 1) * 2), Ts(this.dyn_ltree), Ts(this.dyn_dtree), Ts(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(sJ + 1), this.heap = new Uint16Array(2 * wA + 1), Ts(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * wA + 1), Ts(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const Ld = (e) => {
  if (!e)
    return 1;
  const t = e.state;
  return !t || t.strm !== e || t.status !== ml && //#ifdef GZIP
  t.status !== Zk && //#endif
  t.status !== vA && t.status !== SA && t.status !== EA && t.status !== AA && t.status !== _c && t.status !== Of ? 1 : 0;
}, p8 = (e) => {
  if (Ld(e))
    return wc(e, fa);
  e.total_in = e.total_out = 0, e.data_type = XZ;
  const t = e.state;
  return t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = //#ifdef GZIP
  t.wrap === 2 ? Zk : (
    //#endif
    t.wrap ? ml : _c
  ), e.adler = t.wrap === 2 ? 0 : 1, t.last_flush = -2, LZ(t), qr;
}, y8 = (e) => {
  const t = p8(e);
  return t === qr && pJ(e.state), t;
}, gJ = (e, t) => Ld(e) || e.state.wrap !== 2 ? fa : (e.state.gzhead = t, qr), g8 = (e, t, n, r, i, o) => {
  if (!e)
    return fa;
  let a = 1;
  if (t === HZ && (t = 6), r < 0 ? (a = 0, r = -r) : r > 15 && (a = 2, r -= 16), i < 1 || i > QZ || n !== y_ || r < 8 || r > 15 || t < 0 || t > 9 || o < 0 || o > ZZ || r === 8 && a !== 1)
    return wc(e, fa);
  r === 8 && (r = 9);
  const s = new yJ();
  return e.state = s, s.strm = e, s.status = ml, s.wrap = a, s.gzhead = null, s.w_bits = r, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = i + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + on - 1) / on), s.window = new Uint8Array(s.w_size * 2), s.head = new Uint16Array(s.hash_size), s.prev = new Uint16Array(s.w_size), s.lit_bufsize = 1 << i + 6, s.pending_buf_size = s.lit_bufsize * 4, s.pending_buf = new Uint8Array(s.pending_buf_size), s.sym_buf = s.lit_bufsize, s.sym_end = (s.lit_bufsize - 1) * 3, s.level = t, s.strategy = o, s.method = n, y8(e);
}, bJ = (e, t) => g8(e, t, y_, eJ, tJ, JZ), mJ = (e, t) => {
  if (Ld(e) || t > EM || t < 0)
    return e ? wc(e, fa) : fa;
  const n = e.state;
  if (!e.output || e.avail_in !== 0 && !e.input || n.status === Of && t !== co)
    return wc(e, e.avail_out === 0 ? f1 : fa);
  const r = n.last_flush;
  if (n.last_flush = t, n.pending !== 0) {
    if (Ci(e), e.avail_out === 0)
      return n.last_flush = -1, qr;
  } else if (e.avail_in === 0 && IM(t) <= IM(r) && t !== co)
    return wc(e, f1);
  if (n.status === Of && e.avail_in !== 0)
    return wc(e, f1);
  if (n.status === ml && n.wrap === 0 && (n.status = _c), n.status === ml) {
    let i = y_ + (n.w_bits - 8 << 4) << 8, o = -1;
    if (n.strategy >= Eg || n.level < 2 ? o = 0 : n.level < 6 ? o = 1 : n.level === 6 ? o = 2 : o = 3, i |= o << 6, n.strstart !== 0 && (i |= cJ), i += 31 - i % 31, df(n, i), n.strstart !== 0 && (df(n, e.adler >>> 16), df(n, e.adler & 65535)), e.adler = 1, n.status = _c, Ci(e), n.pending !== 0)
      return n.last_flush = -1, qr;
  }
  if (n.status === Zk) {
    if (e.adler = 0, Sn(n, 31), Sn(n, 139), Sn(n, 8), n.gzhead)
      Sn(
        n,
        (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)
      ), Sn(n, n.gzhead.time & 255), Sn(n, n.gzhead.time >> 8 & 255), Sn(n, n.gzhead.time >> 16 & 255), Sn(n, n.gzhead.time >> 24 & 255), Sn(n, n.level === 9 ? 2 : n.strategy >= Eg || n.level < 2 ? 4 : 0), Sn(n, n.gzhead.os & 255), n.gzhead.extra && n.gzhead.extra.length && (Sn(n, n.gzhead.extra.length & 255), Sn(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = zr(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = vA;
    else if (Sn(n, 0), Sn(n, 0), Sn(n, 0), Sn(n, 0), Sn(n, 0), Sn(n, n.level === 9 ? 2 : n.strategy >= Eg || n.level < 2 ? 4 : 0), Sn(n, uJ), n.status = _c, Ci(e), n.pending !== 0)
      return n.last_flush = -1, qr;
  }
  if (n.status === vA) {
    if (n.gzhead.extra) {
      let i = n.pending, o = (n.gzhead.extra.length & 65535) - n.gzindex;
      for (; n.pending + o > n.pending_buf_size; ) {
        let s = n.pending_buf_size - n.pending;
        if (n.pending_buf.set(n.gzhead.extra.subarray(n.gzindex, n.gzindex + s), n.pending), n.pending = n.pending_buf_size, n.gzhead.hcrc && n.pending > i && (e.adler = zr(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex += s, Ci(e), n.pending !== 0)
          return n.last_flush = -1, qr;
        i = 0, o -= s;
      }
      let a = new Uint8Array(n.gzhead.extra);
      n.pending_buf.set(a.subarray(n.gzindex, n.gzindex + o), n.pending), n.pending += o, n.gzhead.hcrc && n.pending > i && (e.adler = zr(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex = 0;
    }
    n.status = SA;
  }
  if (n.status === SA) {
    if (n.gzhead.name) {
      let i = n.pending, o;
      do {
        if (n.pending === n.pending_buf_size) {
          if (n.gzhead.hcrc && n.pending > i && (e.adler = zr(e.adler, n.pending_buf, n.pending - i, i)), Ci(e), n.pending !== 0)
            return n.last_flush = -1, qr;
          i = 0;
        }
        n.gzindex < n.gzhead.name.length ? o = n.gzhead.name.charCodeAt(n.gzindex++) & 255 : o = 0, Sn(n, o);
      } while (o !== 0);
      n.gzhead.hcrc && n.pending > i && (e.adler = zr(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex = 0;
    }
    n.status = EA;
  }
  if (n.status === EA) {
    if (n.gzhead.comment) {
      let i = n.pending, o;
      do {
        if (n.pending === n.pending_buf_size) {
          if (n.gzhead.hcrc && n.pending > i && (e.adler = zr(e.adler, n.pending_buf, n.pending - i, i)), Ci(e), n.pending !== 0)
            return n.last_flush = -1, qr;
          i = 0;
        }
        n.gzindex < n.gzhead.comment.length ? o = n.gzhead.comment.charCodeAt(n.gzindex++) & 255 : o = 0, Sn(n, o);
      } while (o !== 0);
      n.gzhead.hcrc && n.pending > i && (e.adler = zr(e.adler, n.pending_buf, n.pending - i, i));
    }
    n.status = AA;
  }
  if (n.status === AA) {
    if (n.gzhead.hcrc) {
      if (n.pending + 2 > n.pending_buf_size && (Ci(e), n.pending !== 0))
        return n.last_flush = -1, qr;
      Sn(n, e.adler & 255), Sn(n, e.adler >> 8 & 255), e.adler = 0;
    }
    if (n.status = _c, Ci(e), n.pending !== 0)
      return n.last_flush = -1, qr;
  }
  if (e.avail_in !== 0 || n.lookahead !== 0 || t !== Fs && n.status !== Of) {
    let i = n.level === 0 ? h8(n, t) : n.strategy === Eg ? hJ(n, t) : n.strategy === YZ ? dJ(n, t) : Pf[n.level].func(n, t);
    if ((i === Rc || i === ql) && (n.status = Of), i === di || i === Rc)
      return e.avail_out === 0 && (n.last_flush = -1), qr;
    if (i === Vl && (t === KZ ? WZ(n) : t !== EM && (_A(n, 0, 0, !1), t === VZ && (Ts(n.head), n.lookahead === 0 && (n.strstart = 0, n.block_start = 0, n.insert = 0))), Ci(e), e.avail_out === 0))
      return n.last_flush = -1, qr;
  }
  return t !== co ? qr : n.wrap <= 0 ? AM : (n.wrap === 2 ? (Sn(n, e.adler & 255), Sn(n, e.adler >> 8 & 255), Sn(n, e.adler >> 16 & 255), Sn(n, e.adler >> 24 & 255), Sn(n, e.total_in & 255), Sn(n, e.total_in >> 8 & 255), Sn(n, e.total_in >> 16 & 255), Sn(n, e.total_in >> 24 & 255)) : (df(n, e.adler >>> 16), df(n, e.adler & 65535)), Ci(e), n.wrap > 0 && (n.wrap = -n.wrap), n.pending !== 0 ? qr : AM);
}, _J = (e) => {
  if (Ld(e))
    return fa;
  const t = e.state.status;
  return e.state = null, t === _c ? wc(e, qZ) : qr;
}, wJ = (e, t) => {
  let n = t.length;
  if (Ld(e))
    return fa;
  const r = e.state, i = r.wrap;
  if (i === 2 || i === 1 && r.status !== ml || r.lookahead)
    return fa;
  if (i === 1 && (e.adler = dd(e.adler, t, n, 0)), r.wrap = 0, n >= r.w_size) {
    i === 0 && (Ts(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0);
    let c = new Uint8Array(r.w_size);
    c.set(t.subarray(n - r.w_size, n), 0), t = c, n = r.w_size;
  }
  const o = e.avail_in, a = e.next_in, s = e.input;
  for (e.avail_in = n, e.next_in = 0, e.input = t, _l(r); r.lookahead >= on; ) {
    let c = r.strstart, l = r.lookahead - (on - 1);
    do
      r.ins_h = Ls(r, r.ins_h, r.window[c + on - 1]), r.prev[c & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = c, c++;
    while (--l);
    r.strstart = c, r.lookahead = on - 1, _l(r);
  }
  return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = on - 1, r.match_available = 0, e.next_in = a, e.input = s, e.avail_in = o, r.wrap = i, qr;
};
var vJ = bJ, SJ = g8, EJ = y8, AJ = p8, IJ = gJ, kJ = mJ, TJ = _J, xJ = wJ, MJ = "pako deflate (from Nodeca project)", Gf = {
  deflateInit: vJ,
  deflateInit2: SJ,
  deflateReset: EJ,
  deflateResetKeep: AJ,
  deflateSetHeader: IJ,
  deflate: kJ,
  deflateEnd: TJ,
  deflateSetDictionary: xJ,
  deflateInfo: MJ
};
const OJ = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
var PJ = function(e) {
  const t = Array.prototype.slice.call(arguments, 1);
  for (; t.length; ) {
    const n = t.shift();
    if (n) {
      if (typeof n != "object")
        throw new TypeError(n + "must be non-object");
      for (const r in n)
        OJ(n, r) && (e[r] = n[r]);
    }
  }
  return e;
}, BJ = (e) => {
  let t = 0;
  for (let r = 0, i = e.length; r < i; r++)
    t += e[r].length;
  const n = new Uint8Array(t);
  for (let r = 0, i = 0, o = e.length; r < o; r++) {
    let a = e[r];
    n.set(a, i), i += a.length;
  }
  return n;
}, g_ = {
  assign: PJ,
  flattenChunks: BJ
};
let b8 = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  b8 = !1;
}
const hd = new Uint8Array(256);
for (let e = 0; e < 256; e++)
  hd[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
hd[254] = hd[254] = 1;
var CJ = (e) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(e);
  let t, n, r, i, o, a = e.length, s = 0;
  for (i = 0; i < a; i++)
    n = e.charCodeAt(i), (n & 64512) === 55296 && i + 1 < a && (r = e.charCodeAt(i + 1), (r & 64512) === 56320 && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++)), s += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
  for (t = new Uint8Array(s), o = 0, i = 0; o < s; i++)
    n = e.charCodeAt(i), (n & 64512) === 55296 && i + 1 < a && (r = e.charCodeAt(i + 1), (r & 64512) === 56320 && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++)), n < 128 ? t[o++] = n : n < 2048 ? (t[o++] = 192 | n >>> 6, t[o++] = 128 | n & 63) : n < 65536 ? (t[o++] = 224 | n >>> 12, t[o++] = 128 | n >>> 6 & 63, t[o++] = 128 | n & 63) : (t[o++] = 240 | n >>> 18, t[o++] = 128 | n >>> 12 & 63, t[o++] = 128 | n >>> 6 & 63, t[o++] = 128 | n & 63);
  return t;
};
const DJ = (e, t) => {
  if (t < 65534 && e.subarray && b8)
    return String.fromCharCode.apply(null, e.length === t ? e : e.subarray(0, t));
  let n = "";
  for (let r = 0; r < t; r++)
    n += String.fromCharCode(e[r]);
  return n;
};
var RJ = (e, t) => {
  const n = t || e.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(e.subarray(0, t));
  let r, i;
  const o = new Array(n * 2);
  for (i = 0, r = 0; r < n; ) {
    let a = e[r++];
    if (a < 128) {
      o[i++] = a;
      continue;
    }
    let s = hd[a];
    if (s > 4) {
      o[i++] = 65533, r += s - 1;
      continue;
    }
    for (a &= s === 2 ? 31 : s === 3 ? 15 : 7; s > 1 && r < n; )
      a = a << 6 | e[r++] & 63, s--;
    if (s > 1) {
      o[i++] = 65533;
      continue;
    }
    a < 65536 ? o[i++] = a : (a -= 65536, o[i++] = 55296 | a >> 10 & 1023, o[i++] = 56320 | a & 1023);
  }
  return DJ(o, i);
}, NJ = (e, t) => {
  t = t || e.length, t > e.length && (t = e.length);
  let n = t - 1;
  for (; n >= 0 && (e[n] & 192) === 128; )
    n--;
  return n < 0 || n === 0 ? t : n + hd[e[n]] > t ? n : t;
}, pd = {
  string2buf: CJ,
  buf2string: RJ,
  utf8border: NJ
};
function jJ() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var m8 = jJ;
const _8 = Object.prototype.toString, {
  Z_NO_FLUSH: UJ,
  Z_SYNC_FLUSH: zJ,
  Z_FULL_FLUSH: FJ,
  Z_FINISH: LJ,
  Z_OK: Yb,
  Z_STREAM_END: $J,
  Z_DEFAULT_COMPRESSION: WJ,
  Z_DEFAULT_STRATEGY: KJ,
  Z_DEFLATED: VJ
} = Fd;
function Jk(e) {
  this.options = g_.assign({
    level: WJ,
    method: VJ,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: KJ
  }, e || {});
  let t = this.options;
  t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new m8(), this.strm.avail_out = 0;
  let n = Gf.deflateInit2(
    this.strm,
    t.level,
    t.method,
    t.windowBits,
    t.memLevel,
    t.strategy
  );
  if (n !== Yb)
    throw new Error(bl[n]);
  if (t.header && Gf.deflateSetHeader(this.strm, t.header), t.dictionary) {
    let r;
    if (typeof t.dictionary == "string" ? r = pd.string2buf(t.dictionary) : _8.call(t.dictionary) === "[object ArrayBuffer]" ? r = new Uint8Array(t.dictionary) : r = t.dictionary, n = Gf.deflateSetDictionary(this.strm, r), n !== Yb)
      throw new Error(bl[n]);
    this._dict_set = !0;
  }
}
Jk.prototype.push = function(e, t) {
  const n = this.strm, r = this.options.chunkSize;
  let i, o;
  if (this.ended)
    return !1;
  for (t === ~~t ? o = t : o = t === !0 ? LJ : UJ, typeof e == "string" ? n.input = pd.string2buf(e) : _8.call(e) === "[object ArrayBuffer]" ? n.input = new Uint8Array(e) : n.input = e, n.next_in = 0, n.avail_in = n.input.length; ; ) {
    if (n.avail_out === 0 && (n.output = new Uint8Array(r), n.next_out = 0, n.avail_out = r), (o === zJ || o === FJ) && n.avail_out <= 6) {
      this.onData(n.output.subarray(0, n.next_out)), n.avail_out = 0;
      continue;
    }
    if (i = Gf.deflate(n, o), i === $J)
      return n.next_out > 0 && this.onData(n.output.subarray(0, n.next_out)), i = Gf.deflateEnd(this.strm), this.onEnd(i), this.ended = !0, i === Yb;
    if (n.avail_out === 0) {
      this.onData(n.output);
      continue;
    }
    if (o > 0 && n.next_out > 0) {
      this.onData(n.output.subarray(0, n.next_out)), n.avail_out = 0;
      continue;
    }
    if (n.avail_in === 0)
      break;
  }
  return !0;
};
Jk.prototype.onData = function(e) {
  this.chunks.push(e);
};
Jk.prototype.onEnd = function(e) {
  e === Yb && (this.result = g_.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
const Ag = 16209, qJ = 16191;
var HJ = function(t, n) {
  let r, i, o, a, s, c, l, u, f, d, h, g, w, b, I, A, x, N, j, K, W, O, k, z;
  const C = t.state;
  r = t.next_in, k = t.input, i = r + (t.avail_in - 5), o = t.next_out, z = t.output, a = o - (n - t.avail_out), s = o + (t.avail_out - 257), c = C.dmax, l = C.wsize, u = C.whave, f = C.wnext, d = C.window, h = C.hold, g = C.bits, w = C.lencode, b = C.distcode, I = (1 << C.lenbits) - 1, A = (1 << C.distbits) - 1;
  e:
    do {
      g < 15 && (h += k[r++] << g, g += 8, h += k[r++] << g, g += 8), x = w[h & I];
      t:
        for (; ; ) {
          if (N = x >>> 24, h >>>= N, g -= N, N = x >>> 16 & 255, N === 0)
            z[o++] = x & 65535;
          else if (N & 16) {
            j = x & 65535, N &= 15, N && (g < N && (h += k[r++] << g, g += 8), j += h & (1 << N) - 1, h >>>= N, g -= N), g < 15 && (h += k[r++] << g, g += 8, h += k[r++] << g, g += 8), x = b[h & A];
            n:
              for (; ; ) {
                if (N = x >>> 24, h >>>= N, g -= N, N = x >>> 16 & 255, N & 16) {
                  if (K = x & 65535, N &= 15, g < N && (h += k[r++] << g, g += 8, g < N && (h += k[r++] << g, g += 8)), K += h & (1 << N) - 1, K > c) {
                    t.msg = "invalid distance too far back", C.mode = Ag;
                    break e;
                  }
                  if (h >>>= N, g -= N, N = o - a, K > N) {
                    if (N = K - N, N > u && C.sane) {
                      t.msg = "invalid distance too far back", C.mode = Ag;
                      break e;
                    }
                    if (W = 0, O = d, f === 0) {
                      if (W += l - N, N < j) {
                        j -= N;
                        do
                          z[o++] = d[W++];
                        while (--N);
                        W = o - K, O = z;
                      }
                    } else if (f < N) {
                      if (W += l + f - N, N -= f, N < j) {
                        j -= N;
                        do
                          z[o++] = d[W++];
                        while (--N);
                        if (W = 0, f < j) {
                          N = f, j -= N;
                          do
                            z[o++] = d[W++];
                          while (--N);
                          W = o - K, O = z;
                        }
                      }
                    } else if (W += f - N, N < j) {
                      j -= N;
                      do
                        z[o++] = d[W++];
                      while (--N);
                      W = o - K, O = z;
                    }
                    for (; j > 2; )
                      z[o++] = O[W++], z[o++] = O[W++], z[o++] = O[W++], j -= 3;
                    j && (z[o++] = O[W++], j > 1 && (z[o++] = O[W++]));
                  } else {
                    W = o - K;
                    do
                      z[o++] = z[W++], z[o++] = z[W++], z[o++] = z[W++], j -= 3;
                    while (j > 2);
                    j && (z[o++] = z[W++], j > 1 && (z[o++] = z[W++]));
                  }
                } else if (N & 64) {
                  t.msg = "invalid distance code", C.mode = Ag;
                  break e;
                } else {
                  x = b[(x & 65535) + (h & (1 << N) - 1)];
                  continue n;
                }
                break;
              }
          } else if (N & 64)
            if (N & 32) {
              C.mode = qJ;
              break e;
            } else {
              t.msg = "invalid literal/length code", C.mode = Ag;
              break e;
            }
          else {
            x = w[(x & 65535) + (h & (1 << N) - 1)];
            continue t;
          }
          break;
        }
    } while (r < i && o < s);
  j = g >> 3, r -= j, g -= j << 3, h &= (1 << g) - 1, t.next_in = r, t.next_out = o, t.avail_in = r < i ? 5 + (i - r) : 5 - (r - i), t.avail_out = o < s ? 257 + (s - o) : 257 - (o - s), C.hold = h, C.bits = g;
};
const wu = 15, kM = 852, TM = 592, xM = 0, h1 = 1, MM = 2, GJ = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), YJ = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), ZJ = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), JJ = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), XJ = (e, t, n, r, i, o, a, s) => {
  const c = s.bits;
  let l = 0, u = 0, f = 0, d = 0, h = 0, g = 0, w = 0, b = 0, I = 0, A = 0, x, N, j, K, W, O = null, k;
  const z = new Uint16Array(wu + 1), C = new Uint16Array(wu + 1);
  let M = null, S, p, y;
  for (l = 0; l <= wu; l++)
    z[l] = 0;
  for (u = 0; u < r; u++)
    z[t[n + u]]++;
  for (h = c, d = wu; d >= 1 && z[d] === 0; d--)
    ;
  if (h > d && (h = d), d === 0)
    return i[o++] = 1 << 24 | 64 << 16 | 0, i[o++] = 1 << 24 | 64 << 16 | 0, s.bits = 1, 0;
  for (f = 1; f < d && z[f] === 0; f++)
    ;
  for (h < f && (h = f), b = 1, l = 1; l <= wu; l++)
    if (b <<= 1, b -= z[l], b < 0)
      return -1;
  if (b > 0 && (e === xM || d !== 1))
    return -1;
  for (C[1] = 0, l = 1; l < wu; l++)
    C[l + 1] = C[l] + z[l];
  for (u = 0; u < r; u++)
    t[n + u] !== 0 && (a[C[t[n + u]]++] = u);
  if (e === xM ? (O = M = a, k = 20) : e === h1 ? (O = GJ, M = YJ, k = 257) : (O = ZJ, M = JJ, k = 0), A = 0, u = 0, l = f, W = o, g = h, w = 0, j = -1, I = 1 << h, K = I - 1, e === h1 && I > kM || e === MM && I > TM)
    return 1;
  for (; ; ) {
    S = l - w, a[u] + 1 < k ? (p = 0, y = a[u]) : a[u] >= k ? (p = M[a[u] - k], y = O[a[u] - k]) : (p = 32 + 64, y = 0), x = 1 << l - w, N = 1 << g, f = N;
    do
      N -= x, i[W + (A >> w) + N] = S << 24 | p << 16 | y | 0;
    while (N !== 0);
    for (x = 1 << l - 1; A & x; )
      x >>= 1;
    if (x !== 0 ? (A &= x - 1, A += x) : A = 0, u++, --z[l] === 0) {
      if (l === d)
        break;
      l = t[n + a[u]];
    }
    if (l > h && (A & K) !== j) {
      for (w === 0 && (w = h), W += f, g = l - w, b = 1 << g; g + w < d && (b -= z[g + w], !(b <= 0)); )
        g++, b <<= 1;
      if (I += 1 << g, e === h1 && I > kM || e === MM && I > TM)
        return 1;
      j = A & K, i[j] = h << 24 | g << 16 | W - o | 0;
    }
  }
  return A !== 0 && (i[W + A] = l - w << 24 | 64 << 16 | 0), s.bits = h, 0;
};
var Yf = XJ;
const QJ = 0, w8 = 1, v8 = 2, {
  Z_FINISH: OM,
  Z_BLOCK: eX,
  Z_TREES: Ig,
  Z_OK: Nc,
  Z_STREAM_END: tX,
  Z_NEED_DICT: nX,
  Z_STREAM_ERROR: ho,
  Z_DATA_ERROR: S8,
  Z_MEM_ERROR: E8,
  Z_BUF_ERROR: rX,
  Z_DEFLATED: PM
} = Fd, b_ = 16180, BM = 16181, CM = 16182, DM = 16183, RM = 16184, NM = 16185, jM = 16186, UM = 16187, zM = 16188, FM = 16189, Zb = 16190, Ea = 16191, p1 = 16192, LM = 16193, y1 = 16194, $M = 16195, WM = 16196, KM = 16197, VM = 16198, kg = 16199, Tg = 16200, qM = 16201, HM = 16202, GM = 16203, YM = 16204, ZM = 16205, g1 = 16206, JM = 16207, XM = 16208, tr = 16209, A8 = 16210, I8 = 16211, iX = 852, oX = 592, aX = 15, sX = aX, QM = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function cX() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const au = (e) => {
  if (!e)
    return 1;
  const t = e.state;
  return !t || t.strm !== e || t.mode < b_ || t.mode > I8 ? 1 : 0;
}, k8 = (e) => {
  if (au(e))
    return ho;
  const t = e.state;
  return e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = t.wrap & 1), t.mode = b_, t.last = 0, t.havedict = 0, t.flags = -1, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Int32Array(iX), t.distcode = t.distdyn = new Int32Array(oX), t.sane = 1, t.back = -1, Nc;
}, T8 = (e) => {
  if (au(e))
    return ho;
  const t = e.state;
  return t.wsize = 0, t.whave = 0, t.wnext = 0, k8(e);
}, x8 = (e, t) => {
  let n;
  if (au(e))
    return ho;
  const r = e.state;
  return t < 0 ? (n = 0, t = -t) : (n = (t >> 4) + 5, t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? ho : (r.window !== null && r.wbits !== t && (r.window = null), r.wrap = n, r.wbits = t, T8(e));
}, M8 = (e, t) => {
  if (!e)
    return ho;
  const n = new cX();
  e.state = n, n.strm = e, n.window = null, n.mode = b_;
  const r = x8(e, t);
  return r !== Nc && (e.state = null), r;
}, uX = (e) => M8(e, sX);
let eO = !0, b1, m1;
const lX = (e) => {
  if (eO) {
    b1 = new Int32Array(512), m1 = new Int32Array(32);
    let t = 0;
    for (; t < 144; )
      e.lens[t++] = 8;
    for (; t < 256; )
      e.lens[t++] = 9;
    for (; t < 280; )
      e.lens[t++] = 7;
    for (; t < 288; )
      e.lens[t++] = 8;
    for (Yf(w8, e.lens, 0, 288, b1, 0, e.work, { bits: 9 }), t = 0; t < 32; )
      e.lens[t++] = 5;
    Yf(v8, e.lens, 0, 32, m1, 0, e.work, { bits: 5 }), eO = !1;
  }
  e.lencode = b1, e.lenbits = 9, e.distcode = m1, e.distbits = 5;
}, O8 = (e, t, n, r) => {
  let i;
  const o = e.state;
  return o.window === null && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new Uint8Array(o.wsize)), r >= o.wsize ? (o.window.set(t.subarray(n - o.wsize, n), 0), o.wnext = 0, o.whave = o.wsize) : (i = o.wsize - o.wnext, i > r && (i = r), o.window.set(t.subarray(n - r, n - r + i), o.wnext), r -= i, r ? (o.window.set(t.subarray(n - r, n), 0), o.wnext = r, o.whave = o.wsize) : (o.wnext += i, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += i))), 0;
}, fX = (e, t) => {
  let n, r, i, o, a, s, c, l, u, f, d, h, g, w, b = 0, I, A, x, N, j, K, W, O;
  const k = new Uint8Array(4);
  let z, C;
  const M = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (au(e) || !e.output || !e.input && e.avail_in !== 0)
    return ho;
  n = e.state, n.mode === Ea && (n.mode = p1), a = e.next_out, i = e.output, c = e.avail_out, o = e.next_in, r = e.input, s = e.avail_in, l = n.hold, u = n.bits, f = s, d = c, O = Nc;
  e:
    for (; ; )
      switch (n.mode) {
        case b_:
          if (n.wrap === 0) {
            n.mode = p1;
            break;
          }
          for (; u < 16; ) {
            if (s === 0)
              break e;
            s--, l += r[o++] << u, u += 8;
          }
          if (n.wrap & 2 && l === 35615) {
            n.wbits === 0 && (n.wbits = 15), n.check = 0, k[0] = l & 255, k[1] = l >>> 8 & 255, n.check = zr(n.check, k, 2, 0), l = 0, u = 0, n.mode = BM;
            break;
          }
          if (n.head && (n.head.done = !1), !(n.wrap & 1) || /* check if zlib header allowed */
          (((l & 255) << 8) + (l >> 8)) % 31) {
            e.msg = "incorrect header check", n.mode = tr;
            break;
          }
          if ((l & 15) !== PM) {
            e.msg = "unknown compression method", n.mode = tr;
            break;
          }
          if (l >>>= 4, u -= 4, W = (l & 15) + 8, n.wbits === 0 && (n.wbits = W), W > 15 || W > n.wbits) {
            e.msg = "invalid window size", n.mode = tr;
            break;
          }
          n.dmax = 1 << n.wbits, n.flags = 0, e.adler = n.check = 1, n.mode = l & 512 ? FM : Ea, l = 0, u = 0;
          break;
        case BM:
          for (; u < 16; ) {
            if (s === 0)
              break e;
            s--, l += r[o++] << u, u += 8;
          }
          if (n.flags = l, (n.flags & 255) !== PM) {
            e.msg = "unknown compression method", n.mode = tr;
            break;
          }
          if (n.flags & 57344) {
            e.msg = "unknown header flags set", n.mode = tr;
            break;
          }
          n.head && (n.head.text = l >> 8 & 1), n.flags & 512 && n.wrap & 4 && (k[0] = l & 255, k[1] = l >>> 8 & 255, n.check = zr(n.check, k, 2, 0)), l = 0, u = 0, n.mode = CM;
        case CM:
          for (; u < 32; ) {
            if (s === 0)
              break e;
            s--, l += r[o++] << u, u += 8;
          }
          n.head && (n.head.time = l), n.flags & 512 && n.wrap & 4 && (k[0] = l & 255, k[1] = l >>> 8 & 255, k[2] = l >>> 16 & 255, k[3] = l >>> 24 & 255, n.check = zr(n.check, k, 4, 0)), l = 0, u = 0, n.mode = DM;
        case DM:
          for (; u < 16; ) {
            if (s === 0)
              break e;
            s--, l += r[o++] << u, u += 8;
          }
          n.head && (n.head.xflags = l & 255, n.head.os = l >> 8), n.flags & 512 && n.wrap & 4 && (k[0] = l & 255, k[1] = l >>> 8 & 255, n.check = zr(n.check, k, 2, 0)), l = 0, u = 0, n.mode = RM;
        case RM:
          if (n.flags & 1024) {
            for (; u < 16; ) {
              if (s === 0)
                break e;
              s--, l += r[o++] << u, u += 8;
            }
            n.length = l, n.head && (n.head.extra_len = l), n.flags & 512 && n.wrap & 4 && (k[0] = l & 255, k[1] = l >>> 8 & 255, n.check = zr(n.check, k, 2, 0)), l = 0, u = 0;
          } else
            n.head && (n.head.extra = null);
          n.mode = NM;
        case NM:
          if (n.flags & 1024 && (h = n.length, h > s && (h = s), h && (n.head && (W = n.head.extra_len - n.length, n.head.extra || (n.head.extra = new Uint8Array(n.head.extra_len)), n.head.extra.set(
            r.subarray(
              o,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              o + h
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            W
          )), n.flags & 512 && n.wrap & 4 && (n.check = zr(n.check, r, h, o)), s -= h, o += h, n.length -= h), n.length))
            break e;
          n.length = 0, n.mode = jM;
        case jM:
          if (n.flags & 2048) {
            if (s === 0)
              break e;
            h = 0;
            do
              W = r[o + h++], n.head && W && n.length < 65536 && (n.head.name += String.fromCharCode(W));
            while (W && h < s);
            if (n.flags & 512 && n.wrap & 4 && (n.check = zr(n.check, r, h, o)), s -= h, o += h, W)
              break e;
          } else
            n.head && (n.head.name = null);
          n.length = 0, n.mode = UM;
        case UM:
          if (n.flags & 4096) {
            if (s === 0)
              break e;
            h = 0;
            do
              W = r[o + h++], n.head && W && n.length < 65536 && (n.head.comment += String.fromCharCode(W));
            while (W && h < s);
            if (n.flags & 512 && n.wrap & 4 && (n.check = zr(n.check, r, h, o)), s -= h, o += h, W)
              break e;
          } else
            n.head && (n.head.comment = null);
          n.mode = zM;
        case zM:
          if (n.flags & 512) {
            for (; u < 16; ) {
              if (s === 0)
                break e;
              s--, l += r[o++] << u, u += 8;
            }
            if (n.wrap & 4 && l !== (n.check & 65535)) {
              e.msg = "header crc mismatch", n.mode = tr;
              break;
            }
            l = 0, u = 0;
          }
          n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), e.adler = n.check = 0, n.mode = Ea;
          break;
        case FM:
          for (; u < 32; ) {
            if (s === 0)
              break e;
            s--, l += r[o++] << u, u += 8;
          }
          e.adler = n.check = QM(l), l = 0, u = 0, n.mode = Zb;
        case Zb:
          if (n.havedict === 0)
            return e.next_out = a, e.avail_out = c, e.next_in = o, e.avail_in = s, n.hold = l, n.bits = u, nX;
          e.adler = n.check = 1, n.mode = Ea;
        case Ea:
          if (t === eX || t === Ig)
            break e;
        case p1:
          if (n.last) {
            l >>>= u & 7, u -= u & 7, n.mode = g1;
            break;
          }
          for (; u < 3; ) {
            if (s === 0)
              break e;
            s--, l += r[o++] << u, u += 8;
          }
          switch (n.last = l & 1, l >>>= 1, u -= 1, l & 3) {
            case 0:
              n.mode = LM;
              break;
            case 1:
              if (lX(n), n.mode = kg, t === Ig) {
                l >>>= 2, u -= 2;
                break e;
              }
              break;
            case 2:
              n.mode = WM;
              break;
            case 3:
              e.msg = "invalid block type", n.mode = tr;
          }
          l >>>= 2, u -= 2;
          break;
        case LM:
          for (l >>>= u & 7, u -= u & 7; u < 32; ) {
            if (s === 0)
              break e;
            s--, l += r[o++] << u, u += 8;
          }
          if ((l & 65535) !== (l >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", n.mode = tr;
            break;
          }
          if (n.length = l & 65535, l = 0, u = 0, n.mode = y1, t === Ig)
            break e;
        case y1:
          n.mode = $M;
        case $M:
          if (h = n.length, h) {
            if (h > s && (h = s), h > c && (h = c), h === 0)
              break e;
            i.set(r.subarray(o, o + h), a), s -= h, o += h, c -= h, a += h, n.length -= h;
            break;
          }
          n.mode = Ea;
          break;
        case WM:
          for (; u < 14; ) {
            if (s === 0)
              break e;
            s--, l += r[o++] << u, u += 8;
          }
          if (n.nlen = (l & 31) + 257, l >>>= 5, u -= 5, n.ndist = (l & 31) + 1, l >>>= 5, u -= 5, n.ncode = (l & 15) + 4, l >>>= 4, u -= 4, n.nlen > 286 || n.ndist > 30) {
            e.msg = "too many length or distance symbols", n.mode = tr;
            break;
          }
          n.have = 0, n.mode = KM;
        case KM:
          for (; n.have < n.ncode; ) {
            for (; u < 3; ) {
              if (s === 0)
                break e;
              s--, l += r[o++] << u, u += 8;
            }
            n.lens[M[n.have++]] = l & 7, l >>>= 3, u -= 3;
          }
          for (; n.have < 19; )
            n.lens[M[n.have++]] = 0;
          if (n.lencode = n.lendyn, n.lenbits = 7, z = { bits: n.lenbits }, O = Yf(QJ, n.lens, 0, 19, n.lencode, 0, n.work, z), n.lenbits = z.bits, O) {
            e.msg = "invalid code lengths set", n.mode = tr;
            break;
          }
          n.have = 0, n.mode = VM;
        case VM:
          for (; n.have < n.nlen + n.ndist; ) {
            for (; b = n.lencode[l & (1 << n.lenbits) - 1], I = b >>> 24, A = b >>> 16 & 255, x = b & 65535, !(I <= u); ) {
              if (s === 0)
                break e;
              s--, l += r[o++] << u, u += 8;
            }
            if (x < 16)
              l >>>= I, u -= I, n.lens[n.have++] = x;
            else {
              if (x === 16) {
                for (C = I + 2; u < C; ) {
                  if (s === 0)
                    break e;
                  s--, l += r[o++] << u, u += 8;
                }
                if (l >>>= I, u -= I, n.have === 0) {
                  e.msg = "invalid bit length repeat", n.mode = tr;
                  break;
                }
                W = n.lens[n.have - 1], h = 3 + (l & 3), l >>>= 2, u -= 2;
              } else if (x === 17) {
                for (C = I + 3; u < C; ) {
                  if (s === 0)
                    break e;
                  s--, l += r[o++] << u, u += 8;
                }
                l >>>= I, u -= I, W = 0, h = 3 + (l & 7), l >>>= 3, u -= 3;
              } else {
                for (C = I + 7; u < C; ) {
                  if (s === 0)
                    break e;
                  s--, l += r[o++] << u, u += 8;
                }
                l >>>= I, u -= I, W = 0, h = 11 + (l & 127), l >>>= 7, u -= 7;
              }
              if (n.have + h > n.nlen + n.ndist) {
                e.msg = "invalid bit length repeat", n.mode = tr;
                break;
              }
              for (; h--; )
                n.lens[n.have++] = W;
            }
          }
          if (n.mode === tr)
            break;
          if (n.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", n.mode = tr;
            break;
          }
          if (n.lenbits = 9, z = { bits: n.lenbits }, O = Yf(w8, n.lens, 0, n.nlen, n.lencode, 0, n.work, z), n.lenbits = z.bits, O) {
            e.msg = "invalid literal/lengths set", n.mode = tr;
            break;
          }
          if (n.distbits = 6, n.distcode = n.distdyn, z = { bits: n.distbits }, O = Yf(v8, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, z), n.distbits = z.bits, O) {
            e.msg = "invalid distances set", n.mode = tr;
            break;
          }
          if (n.mode = kg, t === Ig)
            break e;
        case kg:
          n.mode = Tg;
        case Tg:
          if (s >= 6 && c >= 258) {
            e.next_out = a, e.avail_out = c, e.next_in = o, e.avail_in = s, n.hold = l, n.bits = u, HJ(e, d), a = e.next_out, i = e.output, c = e.avail_out, o = e.next_in, r = e.input, s = e.avail_in, l = n.hold, u = n.bits, n.mode === Ea && (n.back = -1);
            break;
          }
          for (n.back = 0; b = n.lencode[l & (1 << n.lenbits) - 1], I = b >>> 24, A = b >>> 16 & 255, x = b & 65535, !(I <= u); ) {
            if (s === 0)
              break e;
            s--, l += r[o++] << u, u += 8;
          }
          if (A && !(A & 240)) {
            for (N = I, j = A, K = x; b = n.lencode[K + ((l & (1 << N + j) - 1) >> N)], I = b >>> 24, A = b >>> 16 & 255, x = b & 65535, !(N + I <= u); ) {
              if (s === 0)
                break e;
              s--, l += r[o++] << u, u += 8;
            }
            l >>>= N, u -= N, n.back += N;
          }
          if (l >>>= I, u -= I, n.back += I, n.length = x, A === 0) {
            n.mode = ZM;
            break;
          }
          if (A & 32) {
            n.back = -1, n.mode = Ea;
            break;
          }
          if (A & 64) {
            e.msg = "invalid literal/length code", n.mode = tr;
            break;
          }
          n.extra = A & 15, n.mode = qM;
        case qM:
          if (n.extra) {
            for (C = n.extra; u < C; ) {
              if (s === 0)
                break e;
              s--, l += r[o++] << u, u += 8;
            }
            n.length += l & (1 << n.extra) - 1, l >>>= n.extra, u -= n.extra, n.back += n.extra;
          }
          n.was = n.length, n.mode = HM;
        case HM:
          for (; b = n.distcode[l & (1 << n.distbits) - 1], I = b >>> 24, A = b >>> 16 & 255, x = b & 65535, !(I <= u); ) {
            if (s === 0)
              break e;
            s--, l += r[o++] << u, u += 8;
          }
          if (!(A & 240)) {
            for (N = I, j = A, K = x; b = n.distcode[K + ((l & (1 << N + j) - 1) >> N)], I = b >>> 24, A = b >>> 16 & 255, x = b & 65535, !(N + I <= u); ) {
              if (s === 0)
                break e;
              s--, l += r[o++] << u, u += 8;
            }
            l >>>= N, u -= N, n.back += N;
          }
          if (l >>>= I, u -= I, n.back += I, A & 64) {
            e.msg = "invalid distance code", n.mode = tr;
            break;
          }
          n.offset = x, n.extra = A & 15, n.mode = GM;
        case GM:
          if (n.extra) {
            for (C = n.extra; u < C; ) {
              if (s === 0)
                break e;
              s--, l += r[o++] << u, u += 8;
            }
            n.offset += l & (1 << n.extra) - 1, l >>>= n.extra, u -= n.extra, n.back += n.extra;
          }
          if (n.offset > n.dmax) {
            e.msg = "invalid distance too far back", n.mode = tr;
            break;
          }
          n.mode = YM;
        case YM:
          if (c === 0)
            break e;
          if (h = d - c, n.offset > h) {
            if (h = n.offset - h, h > n.whave && n.sane) {
              e.msg = "invalid distance too far back", n.mode = tr;
              break;
            }
            h > n.wnext ? (h -= n.wnext, g = n.wsize - h) : g = n.wnext - h, h > n.length && (h = n.length), w = n.window;
          } else
            w = i, g = a - n.offset, h = n.length;
          h > c && (h = c), c -= h, n.length -= h;
          do
            i[a++] = w[g++];
          while (--h);
          n.length === 0 && (n.mode = Tg);
          break;
        case ZM:
          if (c === 0)
            break e;
          i[a++] = n.length, c--, n.mode = Tg;
          break;
        case g1:
          if (n.wrap) {
            for (; u < 32; ) {
              if (s === 0)
                break e;
              s--, l |= r[o++] << u, u += 8;
            }
            if (d -= c, e.total_out += d, n.total += d, n.wrap & 4 && d && (e.adler = n.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            n.flags ? zr(n.check, i, d, a - d) : dd(n.check, i, d, a - d)), d = c, n.wrap & 4 && (n.flags ? l : QM(l)) !== n.check) {
              e.msg = "incorrect data check", n.mode = tr;
              break;
            }
            l = 0, u = 0;
          }
          n.mode = JM;
        case JM:
          if (n.wrap && n.flags) {
            for (; u < 32; ) {
              if (s === 0)
                break e;
              s--, l += r[o++] << u, u += 8;
            }
            if (n.wrap & 4 && l !== (n.total & 4294967295)) {
              e.msg = "incorrect length check", n.mode = tr;
              break;
            }
            l = 0, u = 0;
          }
          n.mode = XM;
        case XM:
          O = tX;
          break e;
        case tr:
          O = S8;
          break e;
        case A8:
          return E8;
        case I8:
        default:
          return ho;
      }
  return e.next_out = a, e.avail_out = c, e.next_in = o, e.avail_in = s, n.hold = l, n.bits = u, (n.wsize || d !== e.avail_out && n.mode < tr && (n.mode < g1 || t !== OM)) && O8(e, e.output, e.next_out, d - e.avail_out), f -= e.avail_in, d -= e.avail_out, e.total_in += f, e.total_out += d, n.total += d, n.wrap & 4 && d && (e.adler = n.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  n.flags ? zr(n.check, i, d, e.next_out - d) : dd(n.check, i, d, e.next_out - d)), e.data_type = n.bits + (n.last ? 64 : 0) + (n.mode === Ea ? 128 : 0) + (n.mode === kg || n.mode === y1 ? 256 : 0), (f === 0 && d === 0 || t === OM) && O === Nc && (O = rX), O;
}, dX = (e) => {
  if (au(e))
    return ho;
  let t = e.state;
  return t.window && (t.window = null), e.state = null, Nc;
}, hX = (e, t) => {
  if (au(e))
    return ho;
  const n = e.state;
  return n.wrap & 2 ? (n.head = t, t.done = !1, Nc) : ho;
}, pX = (e, t) => {
  const n = t.length;
  let r, i, o;
  return au(e) || (r = e.state, r.wrap !== 0 && r.mode !== Zb) ? ho : r.mode === Zb && (i = 1, i = dd(i, t, n, 0), i !== r.check) ? S8 : (o = O8(e, t, n, n), o ? (r.mode = A8, E8) : (r.havedict = 1, Nc));
};
var yX = T8, gX = x8, bX = k8, mX = uX, _X = M8, wX = fX, vX = dX, SX = hX, EX = pX, AX = "pako inflate (from Nodeca project)", Ca = {
  inflateReset: yX,
  inflateReset2: gX,
  inflateResetKeep: bX,
  inflateInit: mX,
  inflateInit2: _X,
  inflate: wX,
  inflateEnd: vX,
  inflateGetHeader: SX,
  inflateSetDictionary: EX,
  inflateInfo: AX
};
function IX() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var kX = IX;
const P8 = Object.prototype.toString, {
  Z_NO_FLUSH: TX,
  Z_FINISH: xX,
  Z_OK: yd,
  Z_STREAM_END: _1,
  Z_NEED_DICT: w1,
  Z_STREAM_ERROR: MX,
  Z_DATA_ERROR: tO,
  Z_MEM_ERROR: OX
} = Fd;
function $d(e) {
  this.options = g_.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, e || {});
  const t = this.options;
  t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, t.windowBits === 0 && (t.windowBits = -15)), t.windowBits >= 0 && t.windowBits < 16 && !(e && e.windowBits) && (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && (t.windowBits & 15 || (t.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new m8(), this.strm.avail_out = 0;
  let n = Ca.inflateInit2(
    this.strm,
    t.windowBits
  );
  if (n !== yd)
    throw new Error(bl[n]);
  if (this.header = new kX(), Ca.inflateGetHeader(this.strm, this.header), t.dictionary && (typeof t.dictionary == "string" ? t.dictionary = pd.string2buf(t.dictionary) : P8.call(t.dictionary) === "[object ArrayBuffer]" && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (n = Ca.inflateSetDictionary(this.strm, t.dictionary), n !== yd)))
    throw new Error(bl[n]);
}
$d.prototype.push = function(e, t) {
  const n = this.strm, r = this.options.chunkSize, i = this.options.dictionary;
  let o, a, s;
  if (this.ended)
    return !1;
  for (t === ~~t ? a = t : a = t === !0 ? xX : TX, P8.call(e) === "[object ArrayBuffer]" ? n.input = new Uint8Array(e) : n.input = e, n.next_in = 0, n.avail_in = n.input.length; ; ) {
    for (n.avail_out === 0 && (n.output = new Uint8Array(r), n.next_out = 0, n.avail_out = r), o = Ca.inflate(n, a), o === w1 && i && (o = Ca.inflateSetDictionary(n, i), o === yd ? o = Ca.inflate(n, a) : o === tO && (o = w1)); n.avail_in > 0 && o === _1 && n.state.wrap > 0 && e[n.next_in] !== 0; )
      Ca.inflateReset(n), o = Ca.inflate(n, a);
    switch (o) {
      case MX:
      case tO:
      case w1:
      case OX:
        return this.onEnd(o), this.ended = !0, !1;
    }
    if (s = n.avail_out, n.next_out && (n.avail_out === 0 || o === _1))
      if (this.options.to === "string") {
        let c = pd.utf8border(n.output, n.next_out), l = n.next_out - c, u = pd.buf2string(n.output, c);
        n.next_out = l, n.avail_out = r - l, l && n.output.set(n.output.subarray(c, c + l), 0), this.onData(u);
      } else
        this.onData(n.output.length === n.next_out ? n.output : n.output.subarray(0, n.next_out));
    if (!(o === yd && s === 0)) {
      if (o === _1)
        return o = Ca.inflateEnd(this.strm), this.onEnd(o), this.ended = !0, !0;
      if (n.avail_in === 0)
        break;
    }
  }
  return !0;
};
$d.prototype.onData = function(e) {
  this.chunks.push(e);
};
$d.prototype.onEnd = function(e) {
  e === yd && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = g_.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function Xk(e, t) {
  const n = new $d(t);
  if (n.push(e), n.err)
    throw n.msg || bl[n.err];
  return n.result;
}
function PX(e, t) {
  return t = t || {}, t.raw = !0, Xk(e, t);
}
var BX = $d, CX = Xk, DX = PX, RX = Xk, NX = Fd, jX = {
  Inflate: BX,
  inflate: CX,
  inflateRaw: DX,
  ungzip: RX,
  constants: NX
};
const { Inflate: rbe, inflate: UX, inflateRaw: ibe, ungzip: obe } = jX;
var zX = UX, v1 = { exports: {} }, S1 = {}, wl = {}, B8 = {}, C8 = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, n = Symbol("test"), r = Object(n);
  if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
    return !1;
  var i = 42;
  t[n] = i;
  for (n in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var o = Object.getOwnPropertySymbols(t);
  if (o.length !== 1 || o[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var a = Object.getOwnPropertyDescriptor(t, n);
    if (a.value !== i || a.enumerable !== !0)
      return !1;
  }
  return !0;
}, FX = C8, m_ = function() {
  return FX() && !!Symbol.toStringTag;
}, E1, nO;
function LX() {
  if (nO)
    return E1;
  nO = 1;
  var e = typeof Symbol < "u" && Symbol, t = C8;
  return E1 = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, E1;
}
var A1, rO;
function $X() {
  if (rO)
    return A1;
  rO = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Array.prototype.slice, n = Object.prototype.toString, r = "[object Function]";
  return A1 = function(o) {
    var a = this;
    if (typeof a != "function" || n.call(a) !== r)
      throw new TypeError(e + a);
    for (var s = t.call(arguments, 1), c, l = function() {
      if (this instanceof c) {
        var g = a.apply(
          this,
          s.concat(t.call(arguments))
        );
        return Object(g) === g ? g : this;
      } else
        return a.apply(
          o,
          s.concat(t.call(arguments))
        );
    }, u = Math.max(0, a.length - s.length), f = [], d = 0; d < u; d++)
      f.push("$" + d);
    if (c = Function("binder", "return function (" + f.join(",") + "){ return binder.apply(this,arguments); }")(l), a.prototype) {
      var h = function() {
      };
      h.prototype = a.prototype, c.prototype = new h(), h.prototype = null;
    }
    return c;
  }, A1;
}
var I1, iO;
function Qk() {
  if (iO)
    return I1;
  iO = 1;
  var e = $X();
  return I1 = Function.prototype.bind || e, I1;
}
var k1, oO;
function WX() {
  if (oO)
    return k1;
  oO = 1;
  var e = Qk();
  return k1 = e.call(Function.call, Object.prototype.hasOwnProperty), k1;
}
var T1, aO;
function __() {
  if (aO)
    return T1;
  aO = 1;
  var e, t = SyntaxError, n = Function, r = TypeError, i = function(C) {
    try {
      return n('"use strict"; return (' + C + ").constructor;")();
    } catch {
    }
  }, o = Object.getOwnPropertyDescriptor;
  if (o)
    try {
      o({}, "");
    } catch {
      o = null;
    }
  var a = function() {
    throw new r();
  }, s = o ? function() {
    try {
      return arguments.callee, a;
    } catch {
      try {
        return o(arguments, "callee").get;
      } catch {
        return a;
      }
    }
  }() : a, c = LX()(), l = Object.getPrototypeOf || function(C) {
    return C.__proto__;
  }, u = {}, f = typeof Uint8Array > "u" ? e : l(Uint8Array), d = {
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": c ? l([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": u,
    "%AsyncGenerator%": u,
    "%AsyncGeneratorFunction%": u,
    "%AsyncIteratorPrototype%": u,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": n,
    "%GeneratorFunction%": u,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": c ? l(l([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !c ? e : l((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !c ? e : l((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": c ? l(""[Symbol.iterator]()) : e,
    "%Symbol%": c ? Symbol : e,
    "%SyntaxError%": t,
    "%ThrowTypeError%": s,
    "%TypedArray%": f,
    "%TypeError%": r,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet
  };
  try {
    null.error;
  } catch (C) {
    var h = l(l(C));
    d["%Error.prototype%"] = h;
  }
  var g = function C(M) {
    var S;
    if (M === "%AsyncFunction%")
      S = i("async function () {}");
    else if (M === "%GeneratorFunction%")
      S = i("function* () {}");
    else if (M === "%AsyncGeneratorFunction%")
      S = i("async function* () {}");
    else if (M === "%AsyncGenerator%") {
      var p = C("%AsyncGeneratorFunction%");
      p && (S = p.prototype);
    } else if (M === "%AsyncIteratorPrototype%") {
      var y = C("%AsyncGenerator%");
      y && (S = l(y.prototype));
    }
    return d[M] = S, S;
  }, w = {
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, b = Qk(), I = WX(), A = b.call(Function.call, Array.prototype.concat), x = b.call(Function.apply, Array.prototype.splice), N = b.call(Function.call, String.prototype.replace), j = b.call(Function.call, String.prototype.slice), K = b.call(Function.call, RegExp.prototype.exec), W = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, O = /\\(\\)?/g, k = function(M) {
    var S = j(M, 0, 1), p = j(M, -1);
    if (S === "%" && p !== "%")
      throw new t("invalid intrinsic syntax, expected closing `%`");
    if (p === "%" && S !== "%")
      throw new t("invalid intrinsic syntax, expected opening `%`");
    var y = [];
    return N(M, W, function(v, E, B, F) {
      y[y.length] = B ? N(F, O, "$1") : E || v;
    }), y;
  }, z = function(M, S) {
    var p = M, y;
    if (I(w, p) && (y = w[p], p = "%" + y[0] + "%"), I(d, p)) {
      var v = d[p];
      if (v === u && (v = g(p)), typeof v > "u" && !S)
        throw new r("intrinsic " + M + " exists, but is not available. Please file an issue!");
      return {
        alias: y,
        name: p,
        value: v
      };
    }
    throw new t("intrinsic " + M + " does not exist!");
  };
  return T1 = function(M, S) {
    if (typeof M != "string" || M.length === 0)
      throw new r("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof S != "boolean")
      throw new r('"allowMissing" argument must be a boolean');
    if (K(/^%?[^%]*%?$/, M) === null)
      throw new t("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var p = k(M), y = p.length > 0 ? p[0] : "", v = z("%" + y + "%", S), E = v.name, B = v.value, F = !1, q = v.alias;
    q && (y = q[0], x(p, A([0, 1], q)));
    for (var U = 1, m = !0; U < p.length; U += 1) {
      var D = p[U], Y = j(D, 0, 1), Q = j(D, -1);
      if ((Y === '"' || Y === "'" || Y === "`" || Q === '"' || Q === "'" || Q === "`") && Y !== Q)
        throw new t("property names with quotes must have matching quotes");
      if ((D === "constructor" || !m) && (F = !0), y += "." + D, E = "%" + y + "%", I(d, E))
        B = d[E];
      else if (B != null) {
        if (!(D in B)) {
          if (!S)
            throw new r("base intrinsic for " + M + " exists, but the property is not available.");
          return;
        }
        if (o && U + 1 >= p.length) {
          var G = o(B, D);
          m = !!G, m && "get" in G && !("originalValue" in G.get) ? B = G.get : B = B[D];
        } else
          m = I(B, D), B = B[D];
        m && !F && (d[E] = B);
      }
    }
    return B;
  }, T1;
}
var x1 = { exports: {} }, sO;
function eT() {
  return sO || (sO = 1, function(e) {
    var t = Qk(), n = __(), r = n("%Function.prototype.apply%"), i = n("%Function.prototype.call%"), o = n("%Reflect.apply%", !0) || t.call(i, r), a = n("%Object.getOwnPropertyDescriptor%", !0), s = n("%Object.defineProperty%", !0), c = n("%Math.max%");
    if (s)
      try {
        s({}, "a", { value: 1 });
      } catch {
        s = null;
      }
    e.exports = function(f) {
      var d = o(t, i, arguments);
      if (a && s) {
        var h = a(d, "length");
        h.configurable && s(
          d,
          "length",
          { value: 1 + c(0, f.length - (arguments.length - 1)) }
        );
      }
      return d;
    };
    var l = function() {
      return o(t, r, arguments);
    };
    s ? s(e.exports, "apply", { value: l }) : e.exports.apply = l;
  }(x1)), x1.exports;
}
var D8 = __(), R8 = eT(), KX = R8(D8("String.prototype.indexOf")), tT = function(t, n) {
  var r = D8(t, !!n);
  return typeof r == "function" && KX(t, ".prototype.") > -1 ? R8(r) : r;
}, VX = m_(), qX = tT, kA = qX("Object.prototype.toString"), w_ = function(t) {
  return VX && t && typeof t == "object" && Symbol.toStringTag in t ? !1 : kA(t) === "[object Arguments]";
}, N8 = function(t) {
  return w_(t) ? !0 : t !== null && typeof t == "object" && typeof t.length == "number" && t.length >= 0 && kA(t) !== "[object Array]" && kA(t.callee) === "[object Function]";
}, HX = function() {
  return w_(arguments);
}();
w_.isLegacyArguments = N8;
var GX = HX ? w_ : N8, YX = Object.prototype.toString, ZX = Function.prototype.toString, JX = /^\s*(?:function)?\*/, j8 = m_(), M1 = Object.getPrototypeOf, XX = function() {
  if (!j8)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, O1, QX = function(t) {
  if (typeof t != "function")
    return !1;
  if (JX.test(ZX.call(t)))
    return !0;
  if (!j8) {
    var n = YX.call(t);
    return n === "[object GeneratorFunction]";
  }
  if (!M1)
    return !1;
  if (typeof O1 > "u") {
    var r = XX();
    O1 = r ? M1(r) : !1;
  }
  return M1(t) === O1;
}, U8 = Function.prototype.toString, Nu = typeof Reflect == "object" && Reflect !== null && Reflect.apply, TA, sb;
if (typeof Nu == "function" && typeof Object.defineProperty == "function")
  try {
    TA = Object.defineProperty({}, "length", {
      get: function() {
        throw sb;
      }
    }), sb = {}, Nu(function() {
      throw 42;
    }, null, TA);
  } catch (e) {
    e !== sb && (Nu = null);
  }
else
  Nu = null;
var eQ = /^\s*class\b/, xA = function(t) {
  try {
    var n = U8.call(t);
    return eQ.test(n);
  } catch {
    return !1;
  }
}, P1 = function(t) {
  try {
    return xA(t) ? !1 : (U8.call(t), !0);
  } catch {
    return !1;
  }
}, cb = Object.prototype.toString, tQ = "[object Object]", nQ = "[object Function]", rQ = "[object GeneratorFunction]", iQ = "[object HTMLAllCollection]", oQ = "[object HTML document.all class]", aQ = "[object HTMLCollection]", sQ = typeof Symbol == "function" && !!Symbol.toStringTag, cQ = !(0 in [,]), MA = function() {
  return !1;
};
if (typeof document == "object") {
  var uQ = document.all;
  cb.call(uQ) === cb.call(document.all) && (MA = function(t) {
    if ((cQ || !t) && (typeof t > "u" || typeof t == "object"))
      try {
        var n = cb.call(t);
        return (n === iQ || n === oQ || n === aQ || n === tQ) && t("") == null;
      } catch {
      }
    return !1;
  });
}
var lQ = Nu ? function(t) {
  if (MA(t))
    return !0;
  if (!t || typeof t != "function" && typeof t != "object")
    return !1;
  try {
    Nu(t, null, TA);
  } catch (n) {
    if (n !== sb)
      return !1;
  }
  return !xA(t) && P1(t);
} : function(t) {
  if (MA(t))
    return !0;
  if (!t || typeof t != "function" && typeof t != "object")
    return !1;
  if (sQ)
    return P1(t);
  if (xA(t))
    return !1;
  var n = cb.call(t);
  return n !== nQ && n !== rQ && !/^\[object HTML/.test(n) ? !1 : P1(t);
}, fQ = lQ, dQ = Object.prototype.toString, z8 = Object.prototype.hasOwnProperty, hQ = function(t, n, r) {
  for (var i = 0, o = t.length; i < o; i++)
    z8.call(t, i) && (r == null ? n(t[i], i, t) : n.call(r, t[i], i, t));
}, pQ = function(t, n, r) {
  for (var i = 0, o = t.length; i < o; i++)
    r == null ? n(t.charAt(i), i, t) : n.call(r, t.charAt(i), i, t);
}, yQ = function(t, n, r) {
  for (var i in t)
    z8.call(t, i) && (r == null ? n(t[i], i, t) : n.call(r, t[i], i, t));
}, gQ = function(t, n, r) {
  if (!fQ(n))
    throw new TypeError("iterator must be a function");
  var i;
  arguments.length >= 3 && (i = r), dQ.call(t) === "[object Array]" ? hQ(t, n, i) : typeof t == "string" ? pQ(t, n, i) : yQ(t, n, i);
}, F8 = gQ, B1 = [
  "BigInt64Array",
  "BigUint64Array",
  "Float32Array",
  "Float64Array",
  "Int16Array",
  "Int32Array",
  "Int8Array",
  "Uint16Array",
  "Uint32Array",
  "Uint8Array",
  "Uint8ClampedArray"
], bQ = typeof globalThis > "u" ? _ : globalThis, L8 = function() {
  for (var t = [], n = 0; n < B1.length; n++)
    typeof bQ[B1[n]] == "function" && (t[t.length] = B1[n]);
  return t;
}, mQ = __(), ub = mQ("%Object.getOwnPropertyDescriptor%", !0);
if (ub)
  try {
    ub([], "length");
  } catch {
    ub = null;
  }
var $8 = ub, W8 = F8, _Q = L8, nT = tT, wQ = nT("Object.prototype.toString"), K8 = m_(), lb = $8, vQ = typeof globalThis > "u" ? _ : globalThis, V8 = _Q(), SQ = nT("Array.prototype.indexOf", !0) || function(t, n) {
  for (var r = 0; r < t.length; r += 1)
    if (t[r] === n)
      return r;
  return -1;
}, EQ = nT("String.prototype.slice"), q8 = {}, C1 = Object.getPrototypeOf;
K8 && lb && C1 && W8(V8, function(e) {
  var t = new vQ[e]();
  if (Symbol.toStringTag in t) {
    var n = C1(t), r = lb(n, Symbol.toStringTag);
    if (!r) {
      var i = C1(n);
      r = lb(i, Symbol.toStringTag);
    }
    q8[e] = r.get;
  }
});
var AQ = function(t) {
  var n = !1;
  return W8(q8, function(r, i) {
    if (!n)
      try {
        n = r.call(t) === i;
      } catch {
      }
  }), n;
}, H8 = function(t) {
  if (!t || typeof t != "object")
    return !1;
  if (!K8 || !(Symbol.toStringTag in t)) {
    var n = EQ(wQ(t), 8, -1);
    return SQ(V8, n) > -1;
  }
  return lb ? AQ(t) : !1;
}, G8 = F8, IQ = L8, Y8 = tT, D1 = $8, kQ = Y8("Object.prototype.toString"), Z8 = m_(), cO = typeof globalThis > "u" ? _ : globalThis, TQ = IQ(), xQ = Y8("String.prototype.slice"), J8 = {}, R1 = Object.getPrototypeOf;
Z8 && D1 && R1 && G8(TQ, function(e) {
  if (typeof cO[e] == "function") {
    var t = new cO[e]();
    if (Symbol.toStringTag in t) {
      var n = R1(t), r = D1(n, Symbol.toStringTag);
      if (!r) {
        var i = R1(n);
        r = D1(i, Symbol.toStringTag);
      }
      J8[e] = r.get;
    }
  }
});
var MQ = function(t) {
  var n = !1;
  return G8(J8, function(r, i) {
    if (!n)
      try {
        var o = r.call(t);
        o === i && (n = o);
      } catch {
      }
  }), n;
}, OQ = H8, PQ = function(t) {
  return OQ(t) ? !Z8 || !(Symbol.toStringTag in t) ? xQ(kQ(t), 8, -1) : MQ(t) : !1;
};
(function(e) {
  var t = GX, n = QX, r = PQ, i = H8;
  function o(ve) {
    return ve.call.bind(ve);
  }
  var a = typeof BigInt < "u", s = typeof Symbol < "u", c = o(Object.prototype.toString), l = o(Number.prototype.valueOf), u = o(String.prototype.valueOf), f = o(Boolean.prototype.valueOf);
  if (a)
    var d = o(BigInt.prototype.valueOf);
  if (s)
    var h = o(Symbol.prototype.valueOf);
  function g(ve, mt) {
    if (typeof ve != "object")
      return !1;
    try {
      return mt(ve), !0;
    } catch {
      return !1;
    }
  }
  e.isArgumentsObject = t, e.isGeneratorFunction = n, e.isTypedArray = i;
  function w(ve) {
    return typeof Promise < "u" && ve instanceof Promise || ve !== null && typeof ve == "object" && typeof ve.then == "function" && typeof ve.catch == "function";
  }
  e.isPromise = w;
  function b(ve) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(ve) : i(ve) || D(ve);
  }
  e.isArrayBufferView = b;
  function I(ve) {
    return r(ve) === "Uint8Array";
  }
  e.isUint8Array = I;
  function A(ve) {
    return r(ve) === "Uint8ClampedArray";
  }
  e.isUint8ClampedArray = A;
  function x(ve) {
    return r(ve) === "Uint16Array";
  }
  e.isUint16Array = x;
  function N(ve) {
    return r(ve) === "Uint32Array";
  }
  e.isUint32Array = N;
  function j(ve) {
    return r(ve) === "Int8Array";
  }
  e.isInt8Array = j;
  function K(ve) {
    return r(ve) === "Int16Array";
  }
  e.isInt16Array = K;
  function W(ve) {
    return r(ve) === "Int32Array";
  }
  e.isInt32Array = W;
  function O(ve) {
    return r(ve) === "Float32Array";
  }
  e.isFloat32Array = O;
  function k(ve) {
    return r(ve) === "Float64Array";
  }
  e.isFloat64Array = k;
  function z(ve) {
    return r(ve) === "BigInt64Array";
  }
  e.isBigInt64Array = z;
  function C(ve) {
    return r(ve) === "BigUint64Array";
  }
  e.isBigUint64Array = C;
  function M(ve) {
    return c(ve) === "[object Map]";
  }
  M.working = typeof Map < "u" && M(/* @__PURE__ */ new Map());
  function S(ve) {
    return typeof Map > "u" ? !1 : M.working ? M(ve) : ve instanceof Map;
  }
  e.isMap = S;
  function p(ve) {
    return c(ve) === "[object Set]";
  }
  p.working = typeof Set < "u" && p(/* @__PURE__ */ new Set());
  function y(ve) {
    return typeof Set > "u" ? !1 : p.working ? p(ve) : ve instanceof Set;
  }
  e.isSet = y;
  function v(ve) {
    return c(ve) === "[object WeakMap]";
  }
  v.working = typeof WeakMap < "u" && v(/* @__PURE__ */ new WeakMap());
  function E(ve) {
    return typeof WeakMap > "u" ? !1 : v.working ? v(ve) : ve instanceof WeakMap;
  }
  e.isWeakMap = E;
  function B(ve) {
    return c(ve) === "[object WeakSet]";
  }
  B.working = typeof WeakSet < "u" && B(/* @__PURE__ */ new WeakSet());
  function F(ve) {
    return B(ve);
  }
  e.isWeakSet = F;
  function q(ve) {
    return c(ve) === "[object ArrayBuffer]";
  }
  q.working = typeof ArrayBuffer < "u" && q(new ArrayBuffer());
  function U(ve) {
    return typeof ArrayBuffer > "u" ? !1 : q.working ? q(ve) : ve instanceof ArrayBuffer;
  }
  e.isArrayBuffer = U;
  function m(ve) {
    return c(ve) === "[object DataView]";
  }
  m.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && m(new DataView(new ArrayBuffer(1), 0, 1));
  function D(ve) {
    return typeof DataView > "u" ? !1 : m.working ? m(ve) : ve instanceof DataView;
  }
  e.isDataView = D;
  var Y = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function Q(ve) {
    return c(ve) === "[object SharedArrayBuffer]";
  }
  function G(ve) {
    return typeof Y > "u" ? !1 : (typeof Q.working > "u" && (Q.working = Q(new Y())), Q.working ? Q(ve) : ve instanceof Y);
  }
  e.isSharedArrayBuffer = G;
  function he(ve) {
    return c(ve) === "[object AsyncFunction]";
  }
  e.isAsyncFunction = he;
  function se(ve) {
    return c(ve) === "[object Map Iterator]";
  }
  e.isMapIterator = se;
  function _e(ve) {
    return c(ve) === "[object Set Iterator]";
  }
  e.isSetIterator = _e;
  function Me(ve) {
    return c(ve) === "[object Generator]";
  }
  e.isGeneratorObject = Me;
  function Pe(ve) {
    return c(ve) === "[object WebAssembly.Module]";
  }
  e.isWebAssemblyCompiledModule = Pe;
  function Be(ve) {
    return g(ve, l);
  }
  e.isNumberObject = Be;
  function at(ve) {
    return g(ve, u);
  }
  e.isStringObject = at;
  function Fe(ve) {
    return g(ve, f);
  }
  e.isBooleanObject = Fe;
  function Re(ve) {
    return a && g(ve, d);
  }
  e.isBigIntObject = Re;
  function Nt(ve) {
    return s && g(ve, h);
  }
  e.isSymbolObject = Nt;
  function qe(ve) {
    return Be(ve) || at(ve) || Fe(ve) || Re(ve) || Nt(ve);
  }
  e.isBoxedPrimitive = qe;
  function _t(ve) {
    return typeof Uint8Array < "u" && (U(ve) || G(ve));
  }
  e.isAnyArrayBuffer = _t, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(ve) {
    Object.defineProperty(e, ve, {
      enumerable: !1,
      value: function() {
        throw new Error(ve + " is not supported in userland");
      }
    });
  });
})(B8);
var BQ = function(t) {
  return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
};
(function(e) {
  var t = Object.getOwnPropertyDescriptors || function(D) {
    for (var Y = Object.keys(D), Q = {}, G = 0; G < Y.length; G++)
      Q[Y[G]] = Object.getOwnPropertyDescriptor(D, Y[G]);
    return Q;
  }, n = /%[sdj%]/g;
  e.format = function(m) {
    if (!j(m)) {
      for (var D = [], Y = 0; Y < arguments.length; Y++)
        D.push(a(arguments[Y]));
      return D.join(" ");
    }
    for (var Y = 1, Q = arguments, G = Q.length, he = String(m).replace(n, function(_e) {
      if (_e === "%%")
        return "%";
      if (Y >= G)
        return _e;
      switch (_e) {
        case "%s":
          return String(Q[Y++]);
        case "%d":
          return Number(Q[Y++]);
        case "%j":
          try {
            return JSON.stringify(Q[Y++]);
          } catch {
            return "[Circular]";
          }
        default:
          return _e;
      }
    }), se = Q[Y]; Y < G; se = Q[++Y])
      A(se) || !k(se) ? he += " " + se : he += " " + a(se);
    return he;
  }, e.deprecate = function(m, D) {
    if (typeof process < "u" && process.noDeprecation === !0)
      return m;
    if (typeof process > "u")
      return function() {
        return e.deprecate(m, D).apply(this, arguments);
      };
    var Y = !1;
    function Q() {
      if (!Y) {
        if (process.throwDeprecation)
          throw new Error(D);
        process.traceDeprecation ? console.trace(D) : console.error(D), Y = !0;
      }
      return m.apply(this, arguments);
    }
    return Q;
  };
  var r = {}, i = /^$/;
  if (process.env.NODE_DEBUG) {
    var o = process.env.NODE_DEBUG;
    o = o.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), i = new RegExp("^" + o + "$", "i");
  }
  e.debuglog = function(m) {
    if (m = m.toUpperCase(), !r[m])
      if (i.test(m)) {
        var D = process.pid;
        r[m] = function() {
          var Y = e.format.apply(e, arguments);
          console.error("%s %d: %s", m, D, Y);
        };
      } else
        r[m] = function() {
        };
    return r[m];
  };
  function a(m, D) {
    var Y = {
      seen: [],
      stylize: c
    };
    return arguments.length >= 3 && (Y.depth = arguments[2]), arguments.length >= 4 && (Y.colors = arguments[3]), I(D) ? Y.showHidden = D : D && e._extend(Y, D), W(Y.showHidden) && (Y.showHidden = !1), W(Y.depth) && (Y.depth = 2), W(Y.colors) && (Y.colors = !1), W(Y.customInspect) && (Y.customInspect = !0), Y.colors && (Y.stylize = s), u(Y, m, Y.depth);
  }
  e.inspect = a, a.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, a.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function s(m, D) {
    var Y = a.styles[D];
    return Y ? "\x1B[" + a.colors[Y][0] + "m" + m + "\x1B[" + a.colors[Y][1] + "m" : m;
  }
  function c(m, D) {
    return m;
  }
  function l(m) {
    var D = {};
    return m.forEach(function(Y, Q) {
      D[Y] = !0;
    }), D;
  }
  function u(m, D, Y) {
    if (m.customInspect && D && M(D.inspect) && // Filter out the util module, it's inspect function is special
    D.inspect !== e.inspect && // Also filter out any prototype objects using the circular check.
    !(D.constructor && D.constructor.prototype === D)) {
      var Q = D.inspect(Y, m);
      return j(Q) || (Q = u(m, Q, Y)), Q;
    }
    var G = f(m, D);
    if (G)
      return G;
    var he = Object.keys(D), se = l(he);
    if (m.showHidden && (he = Object.getOwnPropertyNames(D)), C(D) && (he.indexOf("message") >= 0 || he.indexOf("description") >= 0))
      return d(D);
    if (he.length === 0) {
      if (M(D)) {
        var _e = D.name ? ": " + D.name : "";
        return m.stylize("[Function" + _e + "]", "special");
      }
      if (O(D))
        return m.stylize(RegExp.prototype.toString.call(D), "regexp");
      if (z(D))
        return m.stylize(Date.prototype.toString.call(D), "date");
      if (C(D))
        return d(D);
    }
    var Me = "", Pe = !1, Be = ["{", "}"];
    if (b(D) && (Pe = !0, Be = ["[", "]"]), M(D)) {
      var at = D.name ? ": " + D.name : "";
      Me = " [Function" + at + "]";
    }
    if (O(D) && (Me = " " + RegExp.prototype.toString.call(D)), z(D) && (Me = " " + Date.prototype.toUTCString.call(D)), C(D) && (Me = " " + d(D)), he.length === 0 && (!Pe || D.length == 0))
      return Be[0] + Me + Be[1];
    if (Y < 0)
      return O(D) ? m.stylize(RegExp.prototype.toString.call(D), "regexp") : m.stylize("[Object]", "special");
    m.seen.push(D);
    var Fe;
    return Pe ? Fe = h(m, D, Y, se, he) : Fe = he.map(function(Re) {
      return g(m, D, Y, se, Re, Pe);
    }), m.seen.pop(), w(Fe, Me, Be);
  }
  function f(m, D) {
    if (W(D))
      return m.stylize("undefined", "undefined");
    if (j(D)) {
      var Y = "'" + JSON.stringify(D).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return m.stylize(Y, "string");
    }
    if (N(D))
      return m.stylize("" + D, "number");
    if (I(D))
      return m.stylize("" + D, "boolean");
    if (A(D))
      return m.stylize("null", "null");
  }
  function d(m) {
    return "[" + Error.prototype.toString.call(m) + "]";
  }
  function h(m, D, Y, Q, G) {
    for (var he = [], se = 0, _e = D.length; se < _e; ++se)
      B(D, String(se)) ? he.push(g(
        m,
        D,
        Y,
        Q,
        String(se),
        !0
      )) : he.push("");
    return G.forEach(function(Me) {
      Me.match(/^\d+$/) || he.push(g(
        m,
        D,
        Y,
        Q,
        Me,
        !0
      ));
    }), he;
  }
  function g(m, D, Y, Q, G, he) {
    var se, _e, Me;
    if (Me = Object.getOwnPropertyDescriptor(D, G) || { value: D[G] }, Me.get ? Me.set ? _e = m.stylize("[Getter/Setter]", "special") : _e = m.stylize("[Getter]", "special") : Me.set && (_e = m.stylize("[Setter]", "special")), B(Q, G) || (se = "[" + G + "]"), _e || (m.seen.indexOf(Me.value) < 0 ? (A(Y) ? _e = u(m, Me.value, null) : _e = u(m, Me.value, Y - 1), _e.indexOf(`
`) > -1 && (he ? _e = _e.split(`
`).map(function(Pe) {
      return "  " + Pe;
    }).join(`
`).slice(2) : _e = `
` + _e.split(`
`).map(function(Pe) {
      return "   " + Pe;
    }).join(`
`))) : _e = m.stylize("[Circular]", "special")), W(se)) {
      if (he && G.match(/^\d+$/))
        return _e;
      se = JSON.stringify("" + G), se.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (se = se.slice(1, -1), se = m.stylize(se, "name")) : (se = se.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), se = m.stylize(se, "string"));
    }
    return se + ": " + _e;
  }
  function w(m, D, Y) {
    var Q = m.reduce(function(G, he) {
      return he.indexOf(`
`) >= 0, G + he.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return Q > 60 ? Y[0] + (D === "" ? "" : D + `
 `) + " " + m.join(`,
  `) + " " + Y[1] : Y[0] + D + " " + m.join(", ") + " " + Y[1];
  }
  e.types = B8;
  function b(m) {
    return Array.isArray(m);
  }
  e.isArray = b;
  function I(m) {
    return typeof m == "boolean";
  }
  e.isBoolean = I;
  function A(m) {
    return m === null;
  }
  e.isNull = A;
  function x(m) {
    return m == null;
  }
  e.isNullOrUndefined = x;
  function N(m) {
    return typeof m == "number";
  }
  e.isNumber = N;
  function j(m) {
    return typeof m == "string";
  }
  e.isString = j;
  function K(m) {
    return typeof m == "symbol";
  }
  e.isSymbol = K;
  function W(m) {
    return m === void 0;
  }
  e.isUndefined = W;
  function O(m) {
    return k(m) && p(m) === "[object RegExp]";
  }
  e.isRegExp = O, e.types.isRegExp = O;
  function k(m) {
    return typeof m == "object" && m !== null;
  }
  e.isObject = k;
  function z(m) {
    return k(m) && p(m) === "[object Date]";
  }
  e.isDate = z, e.types.isDate = z;
  function C(m) {
    return k(m) && (p(m) === "[object Error]" || m instanceof Error);
  }
  e.isError = C, e.types.isNativeError = C;
  function M(m) {
    return typeof m == "function";
  }
  e.isFunction = M;
  function S(m) {
    return m === null || typeof m == "boolean" || typeof m == "number" || typeof m == "string" || typeof m == "symbol" || // ES6 symbol
    typeof m > "u";
  }
  e.isPrimitive = S, e.isBuffer = BQ;
  function p(m) {
    return Object.prototype.toString.call(m);
  }
  function y(m) {
    return m < 10 ? "0" + m.toString(10) : m.toString(10);
  }
  var v = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function E() {
    var m = /* @__PURE__ */ new Date(), D = [
      y(m.getHours()),
      y(m.getMinutes()),
      y(m.getSeconds())
    ].join(":");
    return [m.getDate(), v[m.getMonth()], D].join(" ");
  }
  e.log = function() {
    console.log("%s - %s", E(), e.format.apply(e, arguments));
  }, e.inherits = ZC, e._extend = function(m, D) {
    if (!D || !k(D))
      return m;
    for (var Y = Object.keys(D), Q = Y.length; Q--; )
      m[Y[Q]] = D[Y[Q]];
    return m;
  };
  function B(m, D) {
    return Object.prototype.hasOwnProperty.call(m, D);
  }
  var F = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  e.promisify = function(D) {
    if (typeof D != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (F && D[F]) {
      var Y = D[F];
      if (typeof Y != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(Y, F, {
        value: Y,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Y;
    }
    function Y() {
      for (var Q, G, he = new Promise(function(Me, Pe) {
        Q = Me, G = Pe;
      }), se = [], _e = 0; _e < arguments.length; _e++)
        se.push(arguments[_e]);
      se.push(function(Me, Pe) {
        Me ? G(Me) : Q(Pe);
      });
      try {
        D.apply(this, se);
      } catch (Me) {
        G(Me);
      }
      return he;
    }
    return Object.setPrototypeOf(Y, Object.getPrototypeOf(D)), F && Object.defineProperty(Y, F, {
      value: Y,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      Y,
      t(D)
    );
  }, e.promisify.custom = F;
  function q(m, D) {
    if (!m) {
      var Y = new Error("Promise was rejected with a falsy value");
      Y.reason = m, m = Y;
    }
    return D(m);
  }
  function U(m) {
    if (typeof m != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function D() {
      for (var Y = [], Q = 0; Q < arguments.length; Q++)
        Y.push(arguments[Q]);
      var G = Y.pop();
      if (typeof G != "function")
        throw new TypeError("The last argument must be of type Function");
      var he = this, se = function() {
        return G.apply(he, arguments);
      };
      m.apply(this, Y).then(
        function(_e) {
          process.nextTick(se.bind(null, null, _e));
        },
        function(_e) {
          process.nextTick(q.bind(null, _e, se));
        }
      );
    }
    return Object.setPrototypeOf(D, Object.getPrototypeOf(m)), Object.defineProperties(
      D,
      t(m)
    ), D;
  }
  e.callbackify = U;
})(wl);
var uO;
function X8() {
  if (uO)
    return S1;
  uO = 1;
  function e(w) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(I) {
      return typeof I;
    } : e = function(I) {
      return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
    }, e(w);
  }
  function t(w, b) {
    if (!(w instanceof b))
      throw new TypeError("Cannot call a class as a function");
  }
  function n(w, b) {
    return b && (e(b) === "object" || typeof b == "function") ? b : r(w);
  }
  function r(w) {
    if (w === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return w;
  }
  function i(w) {
    return i = Object.setPrototypeOf ? Object.getPrototypeOf : function(I) {
      return I.__proto__ || Object.getPrototypeOf(I);
    }, i(w);
  }
  function o(w, b) {
    if (typeof b != "function" && b !== null)
      throw new TypeError("Super expression must either be null or a function");
    w.prototype = Object.create(b && b.prototype, { constructor: { value: w, writable: !0, configurable: !0 } }), b && a(w, b);
  }
  function a(w, b) {
    return a = Object.setPrototypeOf || function(A, x) {
      return A.__proto__ = x, A;
    }, a(w, b);
  }
  var s = {}, c, l;
  function u(w, b, I) {
    I || (I = Error);
    function A(N, j, K) {
      return typeof b == "string" ? b : b(N, j, K);
    }
    var x = /* @__PURE__ */ function(N) {
      o(j, N);
      function j(K, W, O) {
        var k;
        return t(this, j), k = n(this, i(j).call(this, A(K, W, O))), k.code = w, k;
      }
      return j;
    }(I);
    s[w] = x;
  }
  function f(w, b) {
    if (Array.isArray(w)) {
      var I = w.length;
      return w = w.map(function(A) {
        return String(A);
      }), I > 2 ? "one of ".concat(b, " ").concat(w.slice(0, I - 1).join(", "), ", or ") + w[I - 1] : I === 2 ? "one of ".concat(b, " ").concat(w[0], " or ").concat(w[1]) : "of ".concat(b, " ").concat(w[0]);
    } else
      return "of ".concat(b, " ").concat(String(w));
  }
  function d(w, b, I) {
    return w.substr(!I || I < 0 ? 0 : +I, b.length) === b;
  }
  function h(w, b, I) {
    return (I === void 0 || I > w.length) && (I = w.length), w.substring(I - b.length, I) === b;
  }
  function g(w, b, I) {
    return typeof I != "number" && (I = 0), I + b.length > w.length ? !1 : w.indexOf(b, I) !== -1;
  }
  return u("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), u("ERR_INVALID_ARG_TYPE", function(w, b, I) {
    c === void 0 && (c = ki()), c(typeof w == "string", "'name' must be a string");
    var A;
    typeof b == "string" && d(b, "not ") ? (A = "must not be", b = b.replace(/^not /, "")) : A = "must be";
    var x;
    if (h(w, " argument"))
      x = "The ".concat(w, " ").concat(A, " ").concat(f(b, "type"));
    else {
      var N = g(w, ".") ? "property" : "argument";
      x = 'The "'.concat(w, '" ').concat(N, " ").concat(A, " ").concat(f(b, "type"));
    }
    return x += ". Received type ".concat(e(I)), x;
  }, TypeError), u("ERR_INVALID_ARG_VALUE", function(w, b) {
    var I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    l === void 0 && (l = wl);
    var A = l.inspect(b);
    return A.length > 128 && (A = "".concat(A.slice(0, 128), "...")), "The argument '".concat(w, "' ").concat(I, ". Received ").concat(A);
  }, TypeError), u("ERR_INVALID_RETURN_VALUE", function(w, b, I) {
    var A;
    return I && I.constructor && I.constructor.name ? A = "instance of ".concat(I.constructor.name) : A = "type ".concat(e(I)), "Expected ".concat(w, ' to be returned from the "').concat(b, '"') + " function but got ".concat(A, ".");
  }, TypeError), u("ERR_MISSING_ARGS", function() {
    for (var w = arguments.length, b = new Array(w), I = 0; I < w; I++)
      b[I] = arguments[I];
    c === void 0 && (c = ki()), c(b.length > 0, "At least one arg needs to be specified");
    var A = "The ", x = b.length;
    switch (b = b.map(function(N) {
      return '"'.concat(N, '"');
    }), x) {
      case 1:
        A += "".concat(b[0], " argument");
        break;
      case 2:
        A += "".concat(b[0], " and ").concat(b[1], " arguments");
        break;
      default:
        A += b.slice(0, x - 1).join(", "), A += ", and ".concat(b[x - 1], " arguments");
        break;
    }
    return "".concat(A, " must be specified");
  }, TypeError), S1.codes = s, S1;
}
var N1, lO;
function CQ() {
  if (lO)
    return N1;
  lO = 1;
  function e(y) {
    for (var v = 1; v < arguments.length; v++) {
      var E = arguments[v] != null ? arguments[v] : {}, B = Object.keys(E);
      typeof Object.getOwnPropertySymbols == "function" && (B = B.concat(Object.getOwnPropertySymbols(E).filter(function(F) {
        return Object.getOwnPropertyDescriptor(E, F).enumerable;
      }))), B.forEach(function(F) {
        t(y, F, E[F]);
      });
    }
    return y;
  }
  function t(y, v, E) {
    return v in y ? Object.defineProperty(y, v, { value: E, enumerable: !0, configurable: !0, writable: !0 }) : y[v] = E, y;
  }
  function n(y, v) {
    if (!(y instanceof v))
      throw new TypeError("Cannot call a class as a function");
  }
  function r(y, v) {
    for (var E = 0; E < v.length; E++) {
      var B = v[E];
      B.enumerable = B.enumerable || !1, B.configurable = !0, "value" in B && (B.writable = !0), Object.defineProperty(y, B.key, B);
    }
  }
  function i(y, v, E) {
    return v && r(y.prototype, v), E && r(y, E), y;
  }
  function o(y, v) {
    return v && (g(v) === "object" || typeof v == "function") ? v : a(y);
  }
  function a(y) {
    if (y === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return y;
  }
  function s(y, v) {
    if (typeof v != "function" && v !== null)
      throw new TypeError("Super expression must either be null or a function");
    y.prototype = Object.create(v && v.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), v && d(y, v);
  }
  function c(y) {
    var v = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return c = function(B) {
      if (B === null || !f(B))
        return B;
      if (typeof B != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof v < "u") {
        if (v.has(B))
          return v.get(B);
        v.set(B, F);
      }
      function F() {
        return u(B, arguments, h(this).constructor);
      }
      return F.prototype = Object.create(B.prototype, { constructor: { value: F, enumerable: !1, writable: !0, configurable: !0 } }), d(F, B);
    }, c(y);
  }
  function l() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function u(y, v, E) {
    return l() ? u = Reflect.construct : u = function(F, q, U) {
      var m = [null];
      m.push.apply(m, q);
      var D = Function.bind.apply(F, m), Y = new D();
      return U && d(Y, U.prototype), Y;
    }, u.apply(null, arguments);
  }
  function f(y) {
    return Function.toString.call(y).indexOf("[native code]") !== -1;
  }
  function d(y, v) {
    return d = Object.setPrototypeOf || function(B, F) {
      return B.__proto__ = F, B;
    }, d(y, v);
  }
  function h(y) {
    return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(E) {
      return E.__proto__ || Object.getPrototypeOf(E);
    }, h(y);
  }
  function g(y) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? g = function(E) {
      return typeof E;
    } : g = function(E) {
      return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
    }, g(y);
  }
  var w = wl, b = w.inspect, I = X8(), A = I.codes.ERR_INVALID_ARG_TYPE;
  function x(y, v, E) {
    return (E === void 0 || E > y.length) && (E = y.length), y.substring(E - v.length, E) === v;
  }
  function N(y, v) {
    if (v = Math.floor(v), y.length == 0 || v == 0)
      return "";
    var E = y.length * v;
    for (v = Math.floor(Math.log(v) / Math.log(2)); v; )
      y += y, v--;
    return y += y.substring(0, E - y.length), y;
  }
  var j = "", K = "", W = "", O = "", k = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
  }, z = 10;
  function C(y) {
    var v = Object.keys(y), E = Object.create(Object.getPrototypeOf(y));
    return v.forEach(function(B) {
      E[B] = y[B];
    }), Object.defineProperty(E, "message", {
      value: y.message
    }), E;
  }
  function M(y) {
    return b(y, {
      compact: !1,
      customInspect: !1,
      depth: 1e3,
      maxArrayLength: 1 / 0,
      // Assert compares only enumerable properties (with a few exceptions).
      showHidden: !1,
      // Having a long line as error is better than wrapping the line for
      // comparison for now.
      // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
      // have meta information about the inspected properties (i.e., know where
      // in what line the property starts and ends).
      breakLength: 1 / 0,
      // Assert does not detect proxies currently.
      showProxy: !1,
      sorted: !0,
      // Inspect getters as we also check them when comparing entries.
      getters: !0
    });
  }
  function S(y, v, E) {
    var B = "", F = "", q = 0, U = "", m = !1, D = M(y), Y = D.split(`
`), Q = M(v).split(`
`), G = 0, he = "";
    if (E === "strictEqual" && g(y) === "object" && g(v) === "object" && y !== null && v !== null && (E = "strictEqualObject"), Y.length === 1 && Q.length === 1 && Y[0] !== Q[0]) {
      var se = Y[0].length + Q[0].length;
      if (se <= z) {
        if ((g(y) !== "object" || y === null) && (g(v) !== "object" || v === null) && (y !== 0 || v !== 0))
          return "".concat(k[E], `

`) + "".concat(Y[0], " !== ").concat(Q[0], `
`);
      } else if (E !== "strictEqualObject") {
        var _e = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
        if (se < _e) {
          for (; Y[0][G] === Q[0][G]; )
            G++;
          G > 2 && (he = `
  `.concat(N(" ", G), "^"), G = 0);
        }
      }
    }
    for (var Me = Y[Y.length - 1], Pe = Q[Q.length - 1]; Me === Pe && (G++ < 2 ? U = `
  `.concat(Me).concat(U) : B = Me, Y.pop(), Q.pop(), !(Y.length === 0 || Q.length === 0)); )
      Me = Y[Y.length - 1], Pe = Q[Q.length - 1];
    var Be = Math.max(Y.length, Q.length);
    if (Be === 0) {
      var at = D.split(`
`);
      if (at.length > 30)
        for (at[26] = "".concat(j, "...").concat(O); at.length > 27; )
          at.pop();
      return "".concat(k.notIdentical, `

`).concat(at.join(`
`), `
`);
    }
    G > 3 && (U = `
`.concat(j, "...").concat(O).concat(U), m = !0), B !== "" && (U = `
  `.concat(B).concat(U), B = "");
    var Fe = 0, Re = k[E] + `
`.concat(K, "+ actual").concat(O, " ").concat(W, "- expected").concat(O), Nt = " ".concat(j, "...").concat(O, " Lines skipped");
    for (G = 0; G < Be; G++) {
      var qe = G - q;
      if (Y.length < G + 1)
        qe > 1 && G > 2 && (qe > 4 ? (F += `
`.concat(j, "...").concat(O), m = !0) : qe > 3 && (F += `
  `.concat(Q[G - 2]), Fe++), F += `
  `.concat(Q[G - 1]), Fe++), q = G, B += `
`.concat(W, "-").concat(O, " ").concat(Q[G]), Fe++;
      else if (Q.length < G + 1)
        qe > 1 && G > 2 && (qe > 4 ? (F += `
`.concat(j, "...").concat(O), m = !0) : qe > 3 && (F += `
  `.concat(Y[G - 2]), Fe++), F += `
  `.concat(Y[G - 1]), Fe++), q = G, F += `
`.concat(K, "+").concat(O, " ").concat(Y[G]), Fe++;
      else {
        var _t = Q[G], ve = Y[G], mt = ve !== _t && (!x(ve, ",") || ve.slice(0, -1) !== _t);
        mt && x(_t, ",") && _t.slice(0, -1) === ve && (mt = !1, ve += ","), mt ? (qe > 1 && G > 2 && (qe > 4 ? (F += `
`.concat(j, "...").concat(O), m = !0) : qe > 3 && (F += `
  `.concat(Y[G - 2]), Fe++), F += `
  `.concat(Y[G - 1]), Fe++), q = G, F += `
`.concat(K, "+").concat(O, " ").concat(ve), B += `
`.concat(W, "-").concat(O, " ").concat(_t), Fe += 2) : (F += B, B = "", (qe === 1 || G === 0) && (F += `
  `.concat(ve), Fe++));
      }
      if (Fe > 20 && G < Be - 2)
        return "".concat(Re).concat(Nt, `
`).concat(F, `
`).concat(j, "...").concat(O).concat(B, `
`) + "".concat(j, "...").concat(O);
    }
    return "".concat(Re).concat(m ? Nt : "", `
`).concat(F).concat(B).concat(U).concat(he);
  }
  var p = /* @__PURE__ */ function(y) {
    s(v, y);
    function v(E) {
      var B;
      if (n(this, v), g(E) !== "object" || E === null)
        throw new A("options", "Object", E);
      var F = E.message, q = E.operator, U = E.stackStartFn, m = E.actual, D = E.expected, Y = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, F != null)
        B = o(this, h(v).call(this, String(F)));
      else if (process.stderr && process.stderr.isTTY && (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1 ? (j = "\x1B[34m", K = "\x1B[32m", O = "\x1B[39m", W = "\x1B[31m") : (j = "", K = "", O = "", W = "")), g(m) === "object" && m !== null && g(D) === "object" && D !== null && "stack" in m && m instanceof Error && "stack" in D && D instanceof Error && (m = C(m), D = C(D)), q === "deepStrictEqual" || q === "strictEqual")
        B = o(this, h(v).call(this, S(m, D, q)));
      else if (q === "notDeepStrictEqual" || q === "notStrictEqual") {
        var Q = k[q], G = M(m).split(`
`);
        if (q === "notStrictEqual" && g(m) === "object" && m !== null && (Q = k.notStrictEqualObject), G.length > 30)
          for (G[26] = "".concat(j, "...").concat(O); G.length > 27; )
            G.pop();
        G.length === 1 ? B = o(this, h(v).call(this, "".concat(Q, " ").concat(G[0]))) : B = o(this, h(v).call(this, "".concat(Q, `

`).concat(G.join(`
`), `
`)));
      } else {
        var he = M(m), se = "", _e = k[q];
        q === "notDeepEqual" || q === "notEqual" ? (he = "".concat(k[q], `

`).concat(he), he.length > 1024 && (he = "".concat(he.slice(0, 1021), "..."))) : (se = "".concat(M(D)), he.length > 512 && (he = "".concat(he.slice(0, 509), "...")), se.length > 512 && (se = "".concat(se.slice(0, 509), "...")), q === "deepEqual" || q === "equal" ? he = "".concat(_e, `

`).concat(he, `

should equal

`) : se = " ".concat(q, " ").concat(se)), B = o(this, h(v).call(this, "".concat(he).concat(se)));
      }
      return Error.stackTraceLimit = Y, B.generatedMessage = !F, Object.defineProperty(a(B), "name", {
        value: "AssertionError [ERR_ASSERTION]",
        enumerable: !1,
        writable: !0,
        configurable: !0
      }), B.code = "ERR_ASSERTION", B.actual = m, B.expected = D, B.operator = q, Error.captureStackTrace && Error.captureStackTrace(a(B), U), B.stack, B.name = "AssertionError", o(B);
    }
    return i(v, [{
      key: "toString",
      value: function() {
        return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
      }
    }, {
      key: b.custom,
      value: function(B, F) {
        return b(this, e({}, F, {
          customInspect: !1,
          depth: 0
        }));
      }
    }]), v;
  }(c(Error));
  return N1 = p, N1;
}
var j1, fO;
function DQ() {
  if (fO)
    return j1;
  fO = 1;
  function e(n, r) {
    if (n == null)
      throw new TypeError("Cannot convert first argument to object");
    for (var i = Object(n), o = 1; o < arguments.length; o++) {
      var a = arguments[o];
      if (a != null)
        for (var s = Object.keys(Object(a)), c = 0, l = s.length; c < l; c++) {
          var u = s[c], f = Object.getOwnPropertyDescriptor(a, u);
          f !== void 0 && f.enumerable && (i[u] = a[u]);
        }
    }
    return i;
  }
  function t() {
    Object.assign || Object.defineProperty(Object, "assign", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: e
    });
  }
  return j1 = {
    assign: e,
    polyfill: t
  }, j1;
}
var U1, dO;
function Q8() {
  if (dO)
    return U1;
  dO = 1;
  var e = Object.prototype.toString;
  return U1 = function(n) {
    var r = e.call(n), i = r === "[object Arguments]";
    return i || (i = r !== "[object Array]" && n !== null && typeof n == "object" && typeof n.length == "number" && n.length >= 0 && e.call(n.callee) === "[object Function]"), i;
  }, U1;
}
var z1, hO;
function RQ() {
  if (hO)
    return z1;
  hO = 1;
  var e;
  if (!Object.keys) {
    var t = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Q8(), i = Object.prototype.propertyIsEnumerable, o = !i.call({ toString: null }, "toString"), a = i.call(function() {
    }, "prototype"), s = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], c = function(d) {
      var h = d.constructor;
      return h && h.prototype === d;
    }, l = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, u = function() {
      if (typeof window > "u")
        return !1;
      for (var d in window)
        try {
          if (!l["$" + d] && t.call(window, d) && window[d] !== null && typeof window[d] == "object")
            try {
              c(window[d]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), f = function(d) {
      if (typeof window > "u" || !u)
        return c(d);
      try {
        return c(d);
      } catch {
        return !1;
      }
    };
    e = function(h) {
      var g = h !== null && typeof h == "object", w = n.call(h) === "[object Function]", b = r(h), I = g && n.call(h) === "[object String]", A = [];
      if (!g && !w && !b)
        throw new TypeError("Object.keys called on a non-object");
      var x = a && w;
      if (I && h.length > 0 && !t.call(h, 0))
        for (var N = 0; N < h.length; ++N)
          A.push(String(N));
      if (b && h.length > 0)
        for (var j = 0; j < h.length; ++j)
          A.push(String(j));
      else
        for (var K in h)
          !(x && K === "prototype") && t.call(h, K) && A.push(String(K));
      if (o)
        for (var W = f(h), O = 0; O < s.length; ++O)
          !(W && s[O] === "constructor") && t.call(h, s[O]) && A.push(s[O]);
      return A;
    };
  }
  return z1 = e, z1;
}
var F1, pO;
function NQ() {
  if (pO)
    return F1;
  pO = 1;
  var e = Array.prototype.slice, t = Q8(), n = Object.keys, r = n ? function(a) {
    return n(a);
  } : RQ(), i = Object.keys;
  return r.shim = function() {
    if (Object.keys) {
      var a = function() {
        var s = Object.keys(arguments);
        return s && s.length === arguments.length;
      }(1, 2);
      a || (Object.keys = function(c) {
        return t(c) ? i(e.call(c)) : i(c);
      });
    } else
      Object.keys = r;
    return Object.keys || r;
  }, F1 = r, F1;
}
var L1, yO;
function jQ() {
  if (yO)
    return L1;
  yO = 1;
  var e = __(), t = e("%Object.defineProperty%", !0), n = function() {
    if (t)
      try {
        return t({}, "a", { value: 1 }), !0;
      } catch {
        return !1;
      }
    return !1;
  };
  return n.hasArrayLengthDefineBug = function() {
    if (!n())
      return null;
    try {
      return t([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, L1 = n, L1;
}
var $1, gO;
function v_() {
  if (gO)
    return $1;
  gO = 1;
  var e = NQ(), t = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", n = Object.prototype.toString, r = Array.prototype.concat, i = Object.defineProperty, o = function(u) {
    return typeof u == "function" && n.call(u) === "[object Function]";
  }, a = jQ()(), s = i && a, c = function(u, f, d, h) {
    if (f in u) {
      if (h === !0) {
        if (u[f] === d)
          return;
      } else if (!o(h) || !h())
        return;
    }
    s ? i(u, f, {
      configurable: !0,
      enumerable: !1,
      value: d,
      writable: !0
    }) : u[f] = d;
  }, l = function(u, f) {
    var d = arguments.length > 2 ? arguments[2] : {}, h = e(f);
    t && (h = r.call(h, Object.getOwnPropertySymbols(f)));
    for (var g = 0; g < h.length; g += 1)
      c(u, h[g], f[h[g]], d[h[g]]);
  };
  return l.supportsDescriptors = !!s, $1 = l, $1;
}
var W1, bO;
function e6() {
  if (bO)
    return W1;
  bO = 1;
  var e = function(t) {
    return t !== t;
  };
  return W1 = function(n, r) {
    return n === 0 && r === 0 ? 1 / n === 1 / r : !!(n === r || e(n) && e(r));
  }, W1;
}
var K1, mO;
function t6() {
  if (mO)
    return K1;
  mO = 1;
  var e = e6();
  return K1 = function() {
    return typeof Object.is == "function" ? Object.is : e;
  }, K1;
}
var V1, _O;
function UQ() {
  if (_O)
    return V1;
  _O = 1;
  var e = t6(), t = v_();
  return V1 = function() {
    var r = e();
    return t(Object, { is: r }, {
      is: function() {
        return Object.is !== r;
      }
    }), r;
  }, V1;
}
var q1, wO;
function n6() {
  if (wO)
    return q1;
  wO = 1;
  var e = v_(), t = eT(), n = e6(), r = t6(), i = UQ(), o = t(r(), Object);
  return e(o, {
    getPolyfill: r,
    implementation: n,
    shim: i
  }), q1 = o, q1;
}
var H1, vO;
function r6() {
  return vO || (vO = 1, H1 = function(t) {
    return t !== t;
  }), H1;
}
var G1, SO;
function i6() {
  if (SO)
    return G1;
  SO = 1;
  var e = r6();
  return G1 = function() {
    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : e;
  }, G1;
}
var Y1, EO;
function zQ() {
  if (EO)
    return Y1;
  EO = 1;
  var e = v_(), t = i6();
  return Y1 = function() {
    var r = t();
    return e(Number, { isNaN: r }, {
      isNaN: function() {
        return Number.isNaN !== r;
      }
    }), r;
  }, Y1;
}
var Z1, AO;
function FQ() {
  if (AO)
    return Z1;
  AO = 1;
  var e = eT(), t = v_(), n = r6(), r = i6(), i = zQ(), o = e(r(), Number);
  return t(o, {
    getPolyfill: r,
    implementation: n,
    shim: i
  }), Z1 = o, Z1;
}
var J1, IO;
function LQ() {
  if (IO)
    return J1;
  IO = 1;
  function e(ue, fe) {
    return r(ue) || n(ue, fe) || t();
  }
  function t() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  function n(ue, fe) {
    var me = [], De = !0, ze = !1, L = void 0;
    try {
      for (var T = ue[Symbol.iterator](), R; !(De = (R = T.next()).done) && (me.push(R.value), !(fe && me.length === fe)); De = !0)
        ;
    } catch (J) {
      ze = !0, L = J;
    } finally {
      try {
        !De && T.return != null && T.return();
      } finally {
        if (ze)
          throw L;
      }
    }
    return me;
  }
  function r(ue) {
    if (Array.isArray(ue))
      return ue;
  }
  function i(ue) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(me) {
      return typeof me;
    } : i = function(me) {
      return me && typeof Symbol == "function" && me.constructor === Symbol && me !== Symbol.prototype ? "symbol" : typeof me;
    }, i(ue);
  }
  var o = /a/g.flags !== void 0, a = function(fe) {
    var me = [];
    return fe.forEach(function(De) {
      return me.push(De);
    }), me;
  }, s = function(fe) {
    var me = [];
    return fe.forEach(function(De, ze) {
      return me.push([ze, De]);
    }), me;
  }, c = Object.is ? Object.is : n6(), l = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, u = Number.isNaN ? Number.isNaN : FQ();
  function f(ue) {
    return ue.call.bind(ue);
  }
  var d = f(Object.prototype.hasOwnProperty), h = f(Object.prototype.propertyIsEnumerable), g = f(Object.prototype.toString), w = wl.types, b = w.isAnyArrayBuffer, I = w.isArrayBufferView, A = w.isDate, x = w.isMap, N = w.isRegExp, j = w.isSet, K = w.isNativeError, W = w.isBoxedPrimitive, O = w.isNumberObject, k = w.isStringObject, z = w.isBooleanObject, C = w.isBigIntObject, M = w.isSymbolObject, S = w.isFloat32Array, p = w.isFloat64Array;
  function y(ue) {
    if (ue.length === 0 || ue.length > 10)
      return !0;
    for (var fe = 0; fe < ue.length; fe++) {
      var me = ue.charCodeAt(fe);
      if (me < 48 || me > 57)
        return !0;
    }
    return ue.length === 10 && ue >= Math.pow(2, 32);
  }
  function v(ue) {
    return Object.keys(ue).filter(y).concat(l(ue).filter(Object.prototype.propertyIsEnumerable.bind(ue)));
  }
  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   */
  function E(ue, fe) {
    if (ue === fe)
      return 0;
    for (var me = ue.length, De = fe.length, ze = 0, L = Math.min(me, De); ze < L; ++ze)
      if (ue[ze] !== fe[ze]) {
        me = ue[ze], De = fe[ze];
        break;
      }
    return me < De ? -1 : De < me ? 1 : 0;
  }
  var B = !0, F = !1, q = 0, U = 1, m = 2, D = 3;
  function Y(ue, fe) {
    return o ? ue.source === fe.source && ue.flags === fe.flags : RegExp.prototype.toString.call(ue) === RegExp.prototype.toString.call(fe);
  }
  function Q(ue, fe) {
    if (ue.byteLength !== fe.byteLength)
      return !1;
    for (var me = 0; me < ue.byteLength; me++)
      if (ue[me] !== fe[me])
        return !1;
    return !0;
  }
  function G(ue, fe) {
    return ue.byteLength !== fe.byteLength ? !1 : E(new Uint8Array(ue.buffer, ue.byteOffset, ue.byteLength), new Uint8Array(fe.buffer, fe.byteOffset, fe.byteLength)) === 0;
  }
  function he(ue, fe) {
    return ue.byteLength === fe.byteLength && E(new Uint8Array(ue), new Uint8Array(fe)) === 0;
  }
  function se(ue, fe) {
    return O(ue) ? O(fe) && c(Number.prototype.valueOf.call(ue), Number.prototype.valueOf.call(fe)) : k(ue) ? k(fe) && String.prototype.valueOf.call(ue) === String.prototype.valueOf.call(fe) : z(ue) ? z(fe) && Boolean.prototype.valueOf.call(ue) === Boolean.prototype.valueOf.call(fe) : C(ue) ? C(fe) && BigInt.prototype.valueOf.call(ue) === BigInt.prototype.valueOf.call(fe) : M(fe) && Symbol.prototype.valueOf.call(ue) === Symbol.prototype.valueOf.call(fe);
  }
  function _e(ue, fe, me, De) {
    if (ue === fe)
      return ue !== 0 ? !0 : me ? c(ue, fe) : !0;
    if (me) {
      if (i(ue) !== "object")
        return typeof ue == "number" && u(ue) && u(fe);
      if (i(fe) !== "object" || ue === null || fe === null || Object.getPrototypeOf(ue) !== Object.getPrototypeOf(fe))
        return !1;
    } else {
      if (ue === null || i(ue) !== "object")
        return fe === null || i(fe) !== "object" ? ue == fe : !1;
      if (fe === null || i(fe) !== "object")
        return !1;
    }
    var ze = g(ue), L = g(fe);
    if (ze !== L)
      return !1;
    if (Array.isArray(ue)) {
      if (ue.length !== fe.length)
        return !1;
      var T = v(ue), R = v(fe);
      return T.length !== R.length ? !1 : Pe(ue, fe, me, De, U, T);
    }
    if (ze === "[object Object]" && (!x(ue) && x(fe) || !j(ue) && j(fe)))
      return !1;
    if (A(ue)) {
      if (!A(fe) || Date.prototype.getTime.call(ue) !== Date.prototype.getTime.call(fe))
        return !1;
    } else if (N(ue)) {
      if (!N(fe) || !Y(ue, fe))
        return !1;
    } else if (K(ue) || ue instanceof Error) {
      if (ue.message !== fe.message || ue.name !== fe.name)
        return !1;
    } else if (I(ue)) {
      if (!me && (S(ue) || p(ue))) {
        if (!Q(ue, fe))
          return !1;
      } else if (!G(ue, fe))
        return !1;
      var J = v(ue), te = v(fe);
      return J.length !== te.length ? !1 : Pe(ue, fe, me, De, q, J);
    } else {
      if (j(ue))
        return !j(fe) || ue.size !== fe.size ? !1 : Pe(ue, fe, me, De, m);
      if (x(ue))
        return !x(fe) || ue.size !== fe.size ? !1 : Pe(ue, fe, me, De, D);
      if (b(ue)) {
        if (!he(ue, fe))
          return !1;
      } else if (W(ue) && !se(ue, fe))
        return !1;
    }
    return Pe(ue, fe, me, De, q);
  }
  function Me(ue, fe) {
    return fe.filter(function(me) {
      return h(ue, me);
    });
  }
  function Pe(ue, fe, me, De, ze, L) {
    if (arguments.length === 5) {
      L = Object.keys(ue);
      var T = Object.keys(fe);
      if (L.length !== T.length)
        return !1;
    }
    for (var R = 0; R < L.length; R++)
      if (!d(fe, L[R]))
        return !1;
    if (me && arguments.length === 5) {
      var J = l(ue);
      if (J.length !== 0) {
        var te = 0;
        for (R = 0; R < J.length; R++) {
          var re = J[R];
          if (h(ue, re)) {
            if (!h(fe, re))
              return !1;
            L.push(re), te++;
          } else if (h(fe, re))
            return !1;
        }
        var de = l(fe);
        if (J.length !== de.length && Me(fe, de).length !== te)
          return !1;
      } else {
        var et = l(fe);
        if (et.length !== 0 && Me(fe, et).length !== 0)
          return !1;
      }
    }
    if (L.length === 0 && (ze === q || ze === U && ue.length === 0 || ue.size === 0))
      return !0;
    if (De === void 0)
      De = {
        val1: /* @__PURE__ */ new Map(),
        val2: /* @__PURE__ */ new Map(),
        position: 0
      };
    else {
      var st = De.val1.get(ue);
      if (st !== void 0) {
        var tt = De.val2.get(fe);
        if (tt !== void 0)
          return st === tt;
      }
      De.position++;
    }
    De.val1.set(ue, De.position), De.val2.set(fe, De.position);
    var Yt = ve(ue, fe, me, L, De, ze);
    return De.val1.delete(ue), De.val2.delete(fe), Yt;
  }
  function Be(ue, fe, me, De) {
    for (var ze = a(ue), L = 0; L < ze.length; L++) {
      var T = ze[L];
      if (_e(fe, T, me, De))
        return ue.delete(T), !0;
    }
    return !1;
  }
  function at(ue) {
    switch (i(ue)) {
      case "undefined":
        return null;
      case "object":
        return;
      case "symbol":
        return !1;
      case "string":
        ue = +ue;
      case "number":
        if (u(ue))
          return !1;
    }
    return !0;
  }
  function Fe(ue, fe, me) {
    var De = at(me);
    return De ?? (fe.has(De) && !ue.has(De));
  }
  function Re(ue, fe, me, De, ze) {
    var L = at(me);
    if (L != null)
      return L;
    var T = fe.get(L);
    return T === void 0 && !fe.has(L) || !_e(De, T, !1, ze) ? !1 : !ue.has(L) && _e(De, T, !1, ze);
  }
  function Nt(ue, fe, me, De) {
    for (var ze = null, L = a(ue), T = 0; T < L.length; T++) {
      var R = L[T];
      if (i(R) === "object" && R !== null)
        ze === null && (ze = /* @__PURE__ */ new Set()), ze.add(R);
      else if (!fe.has(R)) {
        if (me || !Fe(ue, fe, R))
          return !1;
        ze === null && (ze = /* @__PURE__ */ new Set()), ze.add(R);
      }
    }
    if (ze !== null) {
      for (var J = a(fe), te = 0; te < J.length; te++) {
        var re = J[te];
        if (i(re) === "object" && re !== null) {
          if (!Be(ze, re, me, De))
            return !1;
        } else if (!me && !ue.has(re) && !Be(ze, re, me, De))
          return !1;
      }
      return ze.size === 0;
    }
    return !0;
  }
  function qe(ue, fe, me, De, ze, L) {
    for (var T = a(ue), R = 0; R < T.length; R++) {
      var J = T[R];
      if (_e(me, J, ze, L) && _e(De, fe.get(J), ze, L))
        return ue.delete(J), !0;
    }
    return !1;
  }
  function _t(ue, fe, me, De) {
    for (var ze = null, L = s(ue), T = 0; T < L.length; T++) {
      var R = e(L[T], 2), J = R[0], te = R[1];
      if (i(J) === "object" && J !== null)
        ze === null && (ze = /* @__PURE__ */ new Set()), ze.add(J);
      else {
        var re = fe.get(J);
        if (re === void 0 && !fe.has(J) || !_e(te, re, me, De)) {
          if (me || !Re(ue, fe, J, te, De))
            return !1;
          ze === null && (ze = /* @__PURE__ */ new Set()), ze.add(J);
        }
      }
    }
    if (ze !== null) {
      for (var de = s(fe), et = 0; et < de.length; et++) {
        var st = e(de[et], 2), J = st[0], tt = st[1];
        if (i(J) === "object" && J !== null) {
          if (!qe(ze, ue, J, tt, me, De))
            return !1;
        } else if (!me && (!ue.has(J) || !_e(ue.get(J), tt, !1, De)) && !qe(ze, ue, J, tt, !1, De))
          return !1;
      }
      return ze.size === 0;
    }
    return !0;
  }
  function ve(ue, fe, me, De, ze, L) {
    var T = 0;
    if (L === m) {
      if (!Nt(ue, fe, me, ze))
        return !1;
    } else if (L === D) {
      if (!_t(ue, fe, me, ze))
        return !1;
    } else if (L === U)
      for (; T < ue.length; T++)
        if (d(ue, T)) {
          if (!d(fe, T) || !_e(ue[T], fe[T], me, ze))
            return !1;
        } else {
          if (d(fe, T))
            return !1;
          for (var R = Object.keys(ue); T < R.length; T++) {
            var J = R[T];
            if (!d(fe, J) || !_e(ue[J], fe[J], me, ze))
              return !1;
          }
          return R.length === Object.keys(fe).length;
        }
    for (T = 0; T < De.length; T++) {
      var te = De[T];
      if (!_e(ue[te], fe[te], me, ze))
        return !1;
    }
    return !0;
  }
  function mt(ue, fe) {
    return _e(ue, fe, F);
  }
  function Gt(ue, fe) {
    return _e(ue, fe, B);
  }
  return J1 = {
    isDeepEqual: mt,
    isDeepStrictEqual: Gt
  }, J1;
}
var kO;
function ki() {
  if (kO)
    return v1.exports;
  kO = 1;
  function e(U) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(D) {
      return typeof D;
    } : e = function(D) {
      return D && typeof Symbol == "function" && D.constructor === Symbol && D !== Symbol.prototype ? "symbol" : typeof D;
    }, e(U);
  }
  function t(U, m) {
    if (!(U instanceof m))
      throw new TypeError("Cannot call a class as a function");
  }
  var n = X8(), r = n.codes, i = r.ERR_AMBIGUOUS_ARGUMENT, o = r.ERR_INVALID_ARG_TYPE, a = r.ERR_INVALID_ARG_VALUE, s = r.ERR_INVALID_RETURN_VALUE, c = r.ERR_MISSING_ARGS, l = CQ(), u = wl, f = u.inspect, d = wl.types, h = d.isPromise, g = d.isRegExp, w = Object.assign ? Object.assign : DQ().assign, b = Object.is ? Object.is : n6(), I, A;
  function x() {
    var U = LQ();
    I = U.isDeepEqual, A = U.isDeepStrictEqual;
  }
  var N = !1, j = v1.exports = z, K = {};
  function W(U) {
    throw U.message instanceof Error ? U.message : new l(U);
  }
  function O(U, m, D, Y, Q) {
    var G = arguments.length, he;
    if (G === 0)
      he = "Failed";
    else if (G === 1)
      D = U, U = void 0;
    else {
      if (N === !1) {
        N = !0;
        var se = process.emitWarning ? process.emitWarning : console.warn.bind(console);
        se("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
      }
      G === 2 && (Y = "!=");
    }
    if (D instanceof Error)
      throw D;
    var _e = {
      actual: U,
      expected: m,
      operator: Y === void 0 ? "fail" : Y,
      stackStartFn: Q || O
    };
    D !== void 0 && (_e.message = D);
    var Me = new l(_e);
    throw he && (Me.message = he, Me.generatedMessage = !0), Me;
  }
  j.fail = O, j.AssertionError = l;
  function k(U, m, D, Y) {
    if (!D) {
      var Q = !1;
      if (m === 0)
        Q = !0, Y = "No value argument passed to `assert.ok()`";
      else if (Y instanceof Error)
        throw Y;
      var G = new l({
        actual: D,
        expected: !0,
        message: Y,
        operator: "==",
        stackStartFn: U
      });
      throw G.generatedMessage = Q, G;
    }
  }
  function z() {
    for (var U = arguments.length, m = new Array(U), D = 0; D < U; D++)
      m[D] = arguments[D];
    k.apply(void 0, [z, m.length].concat(m));
  }
  j.ok = z, j.equal = function U(m, D, Y) {
    if (arguments.length < 2)
      throw new c("actual", "expected");
    m != D && W({
      actual: m,
      expected: D,
      message: Y,
      operator: "==",
      stackStartFn: U
    });
  }, j.notEqual = function U(m, D, Y) {
    if (arguments.length < 2)
      throw new c("actual", "expected");
    m == D && W({
      actual: m,
      expected: D,
      message: Y,
      operator: "!=",
      stackStartFn: U
    });
  }, j.deepEqual = function U(m, D, Y) {
    if (arguments.length < 2)
      throw new c("actual", "expected");
    I === void 0 && x(), I(m, D) || W({
      actual: m,
      expected: D,
      message: Y,
      operator: "deepEqual",
      stackStartFn: U
    });
  }, j.notDeepEqual = function U(m, D, Y) {
    if (arguments.length < 2)
      throw new c("actual", "expected");
    I === void 0 && x(), I(m, D) && W({
      actual: m,
      expected: D,
      message: Y,
      operator: "notDeepEqual",
      stackStartFn: U
    });
  }, j.deepStrictEqual = function U(m, D, Y) {
    if (arguments.length < 2)
      throw new c("actual", "expected");
    I === void 0 && x(), A(m, D) || W({
      actual: m,
      expected: D,
      message: Y,
      operator: "deepStrictEqual",
      stackStartFn: U
    });
  }, j.notDeepStrictEqual = C;
  function C(U, m, D) {
    if (arguments.length < 2)
      throw new c("actual", "expected");
    I === void 0 && x(), A(U, m) && W({
      actual: U,
      expected: m,
      message: D,
      operator: "notDeepStrictEqual",
      stackStartFn: C
    });
  }
  j.strictEqual = function U(m, D, Y) {
    if (arguments.length < 2)
      throw new c("actual", "expected");
    b(m, D) || W({
      actual: m,
      expected: D,
      message: Y,
      operator: "strictEqual",
      stackStartFn: U
    });
  }, j.notStrictEqual = function U(m, D, Y) {
    if (arguments.length < 2)
      throw new c("actual", "expected");
    b(m, D) && W({
      actual: m,
      expected: D,
      message: Y,
      operator: "notStrictEqual",
      stackStartFn: U
    });
  };
  var M = function U(m, D, Y) {
    var Q = this;
    t(this, U), D.forEach(function(G) {
      G in m && (Y !== void 0 && typeof Y[G] == "string" && g(m[G]) && m[G].test(Y[G]) ? Q[G] = Y[G] : Q[G] = m[G]);
    });
  };
  function S(U, m, D, Y, Q, G) {
    if (!(D in U) || !A(U[D], m[D])) {
      if (!Y) {
        var he = new M(U, Q), se = new M(m, Q, U), _e = new l({
          actual: he,
          expected: se,
          operator: "deepStrictEqual",
          stackStartFn: G
        });
        throw _e.actual = U, _e.expected = m, _e.operator = G.name, _e;
      }
      W({
        actual: U,
        expected: m,
        message: Y,
        operator: G.name,
        stackStartFn: G
      });
    }
  }
  function p(U, m, D, Y) {
    if (typeof m != "function") {
      if (g(m))
        return m.test(U);
      if (arguments.length === 2)
        throw new o("expected", ["Function", "RegExp"], m);
      if (e(U) !== "object" || U === null) {
        var Q = new l({
          actual: U,
          expected: m,
          message: D,
          operator: "deepStrictEqual",
          stackStartFn: Y
        });
        throw Q.operator = Y.name, Q;
      }
      var G = Object.keys(m);
      if (m instanceof Error)
        G.push("name", "message");
      else if (G.length === 0)
        throw new a("error", m, "may not be an empty object");
      return I === void 0 && x(), G.forEach(function(he) {
        typeof U[he] == "string" && g(m[he]) && m[he].test(U[he]) || S(U, m, he, D, G, Y);
      }), !0;
    }
    return m.prototype !== void 0 && U instanceof m ? !0 : Error.isPrototypeOf(m) ? !1 : m.call({}, U) === !0;
  }
  function y(U) {
    if (typeof U != "function")
      throw new o("fn", "Function", U);
    try {
      U();
    } catch (m) {
      return m;
    }
    return K;
  }
  function v(U) {
    return h(U) || U !== null && e(U) === "object" && typeof U.then == "function" && typeof U.catch == "function";
  }
  function E(U) {
    return Promise.resolve().then(function() {
      var m;
      if (typeof U == "function") {
        if (m = U(), !v(m))
          throw new s("instance of Promise", "promiseFn", m);
      } else if (v(U))
        m = U;
      else
        throw new o("promiseFn", ["Function", "Promise"], U);
      return Promise.resolve().then(function() {
        return m;
      }).then(function() {
        return K;
      }).catch(function(D) {
        return D;
      });
    });
  }
  function B(U, m, D, Y) {
    if (typeof D == "string") {
      if (arguments.length === 4)
        throw new o("error", ["Object", "Error", "Function", "RegExp"], D);
      if (e(m) === "object" && m !== null) {
        if (m.message === D)
          throw new i("error/message", 'The error message "'.concat(m.message, '" is identical to the message.'));
      } else if (m === D)
        throw new i("error/message", 'The error "'.concat(m, '" is identical to the message.'));
      Y = D, D = void 0;
    } else if (D != null && e(D) !== "object" && typeof D != "function")
      throw new o("error", ["Object", "Error", "Function", "RegExp"], D);
    if (m === K) {
      var Q = "";
      D && D.name && (Q += " (".concat(D.name, ")")), Q += Y ? ": ".concat(Y) : ".";
      var G = U.name === "rejects" ? "rejection" : "exception";
      W({
        actual: void 0,
        expected: D,
        operator: U.name,
        message: "Missing expected ".concat(G).concat(Q),
        stackStartFn: U
      });
    }
    if (D && !p(m, D, Y, U))
      throw m;
  }
  function F(U, m, D, Y) {
    if (m !== K) {
      if (typeof D == "string" && (Y = D, D = void 0), !D || p(m, D)) {
        var Q = Y ? ": ".concat(Y) : ".", G = U.name === "doesNotReject" ? "rejection" : "exception";
        W({
          actual: m,
          expected: D,
          operator: U.name,
          message: "Got unwanted ".concat(G).concat(Q, `
`) + 'Actual message: "'.concat(m && m.message, '"'),
          stackStartFn: U
        });
      }
      throw m;
    }
  }
  j.throws = function U(m) {
    for (var D = arguments.length, Y = new Array(D > 1 ? D - 1 : 0), Q = 1; Q < D; Q++)
      Y[Q - 1] = arguments[Q];
    B.apply(void 0, [U, y(m)].concat(Y));
  }, j.rejects = function U(m) {
    for (var D = arguments.length, Y = new Array(D > 1 ? D - 1 : 0), Q = 1; Q < D; Q++)
      Y[Q - 1] = arguments[Q];
    return E(m).then(function(G) {
      return B.apply(void 0, [U, G].concat(Y));
    });
  }, j.doesNotThrow = function U(m) {
    for (var D = arguments.length, Y = new Array(D > 1 ? D - 1 : 0), Q = 1; Q < D; Q++)
      Y[Q - 1] = arguments[Q];
    F.apply(void 0, [U, y(m)].concat(Y));
  }, j.doesNotReject = function U(m) {
    for (var D = arguments.length, Y = new Array(D > 1 ? D - 1 : 0), Q = 1; Q < D; Q++)
      Y[Q - 1] = arguments[Q];
    return E(m).then(function(G) {
      return F.apply(void 0, [U, G].concat(Y));
    });
  }, j.ifError = function U(m) {
    if (m != null) {
      var D = "ifError got unwanted exception: ";
      e(m) === "object" && typeof m.message == "string" ? m.message.length === 0 && m.constructor ? D += m.constructor.name : D += m.message : D += f(m);
      var Y = new l({
        actual: m,
        expected: null,
        operator: "ifError",
        message: D,
        stackStartFn: U
      }), Q = m.stack;
      if (typeof Q == "string") {
        var G = Q.split(`
`);
        G.shift();
        for (var he = Y.stack.split(`
`), se = 0; se < G.length; se++) {
          var _e = he.indexOf(G[se]);
          if (_e !== -1) {
            he = he.slice(0, _e);
            break;
          }
        }
        Y.stack = "".concat(he.join(`
`), `
`).concat(G.join(`
`));
      }
      throw Y;
    }
  };
  function q() {
    for (var U = arguments.length, m = new Array(U), D = 0; D < U; D++)
      m[D] = arguments[D];
    k.apply(void 0, [q, m.length].concat(m));
  }
  return j.strict = w(q, j, {
    equal: j.strictEqual,
    deepEqual: j.deepStrictEqual,
    notEqual: j.notStrictEqual,
    notDeepEqual: j.notDeepStrictEqual
  }), j.strict.strict = j.strict, v1.exports;
}
var OA = ki();
function $Q(e, t) {
  return Array.apply(0, new Array(Math.ceil(e.length / t))).map((n, r) => e.slice(r * t, (r + 1) * t));
}
const hf = (e) => "version" in e;
function WQ(e) {
  return new TextDecoder("utf-8").decode(e);
}
function KQ(e) {
  return new TextEncoder().encode(e);
}
function TO(e) {
  return Er.encode(e);
}
function VQ(e) {
  return it.Buffer.from(N3(e));
}
function qQ(e) {
  const t = /* @__PURE__ */ new Map();
  return e.errors && e.errors.forEach((n) => {
    var r;
    let i = (r = n.msg) !== null && r !== void 0 ? r : n.name;
    t.set(n.code, i);
  }), t;
}
function HQ(e, ...t) {
  if (e.args.length != t.length)
    throw new Error("Invalid argument length");
  const n = {};
  let r = 0;
  return e.args.forEach((i) => {
    n[i.name] = t[r], r += 1;
  }), n;
}
function o6(e, t = {}) {
  e.forEach((n) => {
    if ("accounts" in n)
      o6(n.accounts, t[n.name]);
    else if (t[n.name] === void 0)
      throw new Error(`Invalid arguments: ${n.name} not provided.`);
  });
}
function uo(e) {
  return e instanceof Ae ? e : new Ae(e);
}
class GQ extends TypeError {
  constructor(t, n) {
    let r;
    const {
      message: i,
      ...o
    } = t, {
      path: a
    } = t, s = a.length === 0 ? i : "At path: " + a.join(".") + " -- " + i;
    super(s), this.value = void 0, this.key = void 0, this.type = void 0, this.refinement = void 0, this.path = void 0, this.branch = void 0, this.failures = void 0, Object.assign(this, o), this.name = this.constructor.name, this.failures = () => {
      var c;
      return (c = r) != null ? c : r = [t, ...n()];
    };
  }
}
function YQ(e) {
  return Xu(e) && typeof e[Symbol.iterator] == "function";
}
function Xu(e) {
  return typeof e == "object" && e != null;
}
function Gs(e) {
  return typeof e == "string" ? JSON.stringify(e) : "" + e;
}
function ZQ(e) {
  const {
    done: t,
    value: n
  } = e.next();
  return t ? void 0 : n;
}
function JQ(e, t, n, r) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = {
    message: e
  });
  const {
    path: i,
    branch: o
  } = t, {
    type: a
  } = n, {
    refinement: s,
    message: c = "Expected a value of type `" + a + "`" + (s ? " with refinement `" + s + "`" : "") + ", but received: `" + Gs(r) + "`"
  } = e;
  return {
    value: r,
    type: a,
    refinement: s,
    key: i[i.length - 1],
    path: i,
    branch: o,
    ...e,
    message: c
  };
}
function* xO(e, t, n, r) {
  YQ(e) || (e = [e]);
  for (const i of e) {
    const o = JQ(i, t, n, r);
    o && (yield o);
  }
}
function* rT(e, t, n) {
  n === void 0 && (n = {});
  const {
    path: r = [],
    branch: i = [e],
    coerce: o = !1,
    mask: a = !1
  } = n, s = {
    path: r,
    branch: i
  };
  if (o && (e = t.coercer(e, s), a && t.type !== "type" && Xu(t.schema) && Xu(e) && !Array.isArray(e)))
    for (const l in e)
      t.schema[l] === void 0 && delete e[l];
  let c = !0;
  for (const l of t.validator(e, s))
    c = !1, yield [l, void 0];
  for (let [l, u, f] of t.entries(e, s)) {
    const d = rT(u, f, {
      path: l === void 0 ? r : [...r, l],
      branch: l === void 0 ? i : [...i, u],
      coerce: o,
      mask: a
    });
    for (const h of d)
      h[0] ? (c = !1, yield [h[0], void 0]) : o && (u = h[1], l === void 0 ? e = u : e instanceof Map ? e.set(l, u) : e instanceof Set ? e.add(u) : Xu(e) && (e[l] = u));
  }
  if (c)
    for (const l of t.refiner(e, s))
      c = !1, yield [l, void 0];
  c && (yield [void 0, e]);
}
class oc {
  constructor(t) {
    this.TYPE = void 0, this.type = void 0, this.schema = void 0, this.coercer = void 0, this.validator = void 0, this.refiner = void 0, this.entries = void 0;
    const {
      type: n,
      schema: r,
      validator: i,
      refiner: o,
      coercer: a = (c) => c,
      entries: s = function* () {
      }
    } = t;
    this.type = n, this.schema = r, this.entries = s, this.coercer = a, i ? this.validator = (c, l) => {
      const u = i(c, l);
      return xO(u, l, this, c);
    } : this.validator = () => [], o ? this.refiner = (c, l) => {
      const u = o(c, l);
      return xO(u, l, this, c);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(t) {
    return XQ(t, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(t) {
    return iT(t, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(t) {
    return a6(t, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(t) {
    return QQ(t, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(t, n) {
    return n === void 0 && (n = {}), Wd(t, this, n);
  }
}
function XQ(e, t) {
  const n = Wd(e, t);
  if (n[0])
    throw n[0];
}
function iT(e, t) {
  const n = Wd(e, t, {
    coerce: !0
  });
  if (n[0])
    throw n[0];
  return n[1];
}
function QQ(e, t) {
  const n = Wd(e, t, {
    coerce: !0,
    mask: !0
  });
  if (n[0])
    throw n[0];
  return n[1];
}
function a6(e, t) {
  return !Wd(e, t)[0];
}
function Wd(e, t, n) {
  n === void 0 && (n = {});
  const r = rT(e, t, n), i = ZQ(r);
  return i[0] ? [new GQ(i[0], function* () {
    for (const a of r)
      a[0] && (yield a[0]);
  }), void 0] : [void 0, i[1]];
}
function Kd(e, t) {
  return new oc({
    type: e,
    schema: null,
    validator: t
  });
}
function eee() {
  return Kd("any", () => !0);
}
function X1(e) {
  return new oc({
    type: "array",
    schema: e,
    *entries(t) {
      if (e && Array.isArray(t))
        for (const [n, r] of t.entries())
          yield [n, r, e];
    },
    coercer(t) {
      return Array.isArray(t) ? t.slice() : t;
    },
    validator(t) {
      return Array.isArray(t) || "Expected an array value, but received: " + Gs(t);
    }
  });
}
function tee() {
  return Kd("boolean", (e) => typeof e == "boolean");
}
function MO(e) {
  const t = Gs(e), n = typeof e;
  return new oc({
    type: "literal",
    schema: n === "string" || n === "number" || n === "boolean" ? e : null,
    validator(r) {
      return r === e || "Expected the literal `" + t + "`, but received: " + Gs(r);
    }
  });
}
function xg(e) {
  return new oc({
    ...e,
    validator: (t, n) => t === null || e.validator(t, n),
    refiner: (t, n) => t === null || e.refiner(t, n)
  });
}
function fb() {
  return Kd("number", (e) => typeof e == "number" && !isNaN(e) || "Expected a number, but received: " + Gs(e));
}
function db(e) {
  return new oc({
    ...e,
    validator: (t, n) => t === void 0 || e.validator(t, n),
    refiner: (t, n) => t === void 0 || e.refiner(t, n)
  });
}
function vc() {
  return Kd("string", (e) => typeof e == "string" || "Expected a string, but received: " + Gs(e));
}
function $s(e) {
  const t = Object.keys(e);
  return new oc({
    type: "type",
    schema: e,
    *entries(n) {
      if (Xu(n))
        for (const r of t)
          yield [r, n[r], e[r]];
    },
    validator(n) {
      return Xu(n) || "Expected an object, but received: " + Gs(n);
    }
  });
}
function s6(e) {
  const t = e.map((n) => n.type).join(" | ");
  return new oc({
    type: "union",
    schema: null,
    coercer(n, r) {
      return (e.find((o) => {
        const [a] = o.validate(n, {
          coerce: !0
        });
        return !a;
      }) || oT()).coercer(n, r);
    },
    validator(n, r) {
      const i = [];
      for (const o of e) {
        const [...a] = rT(n, o, r), [s] = a;
        if (s[0])
          for (const [c] of a)
            c && i.push(c);
        else
          return [];
      }
      return ["Expected the value to satisfy a union of `" + t + "`, but received: " + Gs(n), ...i];
    }
  });
}
function oT() {
  return Kd("unknown", () => !0);
}
function nee(e, t, n) {
  return new oc({
    ...e,
    coercer: (r, i) => a6(r, t) ? e.coercer(n(r, i), i) : e.coercer(r, i)
  });
}
const OO = 99;
async function ree(e, t, n) {
  if (t.length <= OO)
    return await PO(e, t, n);
  {
    const r = $Q(t, OO);
    return (await Promise.all(r.map((o) => PO(e, o, n)))).flat();
  }
}
async function PO(e, t, n) {
  const r = n ?? e.commitment, { value: i, context: o } = await e.getMultipleAccountsInfoAndContext(t, r);
  return i.map((s, c) => s === null ? null : {
    publicKey: t[c],
    account: s,
    context: o
  });
}
async function iee(e, t, n, r, i) {
  var o;
  n && n.length > 0 && t.sign(...n);
  const a = t._compile(), s = a.serialize(), l = t._serialize(s).toString("base64"), u = {
    encoding: "base64",
    commitment: r ?? e.commitment
  };
  if (i) {
    const g = (Array.isArray(i) ? i : a.nonProgramIds()).map((w) => w.toBase58());
    u.accounts = {
      encoding: "base64",
      addresses: g
    };
  }
  n && (u.sigVerify = !0);
  const f = [l, u], d = await e._rpcRequest("simulateTransaction", f), h = iT(d, cee);
  if ("error" in h) {
    let g;
    if ("data" in h.error && (g = (o = h.error.data) === null || o === void 0 ? void 0 : o.logs, g && Array.isArray(g))) {
      const w = `
    `, b = w + g.join(w);
      console.error(h.error.message, b);
    }
    throw new gl("failed to simulate transaction: " + h.error.message, g);
  }
  return h.result;
}
function oee(e) {
  return nee(c6(e), aee, (t) => "error" in t ? t : {
    ...t,
    result: iT(t.result, e)
  });
}
const aee = c6(oT());
function c6(e) {
  return s6([
    $s({
      jsonrpc: MO("2.0"),
      id: vc(),
      result: e
    }),
    $s({
      jsonrpc: MO("2.0"),
      id: vc(),
      error: $s({
        code: oT(),
        message: vc(),
        data: db(eee())
      })
    })
  ]);
}
function see(e) {
  return oee($s({
    context: $s({
      slot: fb()
    }),
    value: e
  }));
}
const cee = see($s({
  err: xg(s6([$s({}), vc()])),
  logs: xg(X1(vc())),
  accounts: db(xg(X1(xg($s({
    executable: tee(),
    owner: vc(),
    lamports: fb(),
    data: X1(vc()),
    rentEpoch: db(fb())
  }))))),
  unitsConsumed: db(fb())
}));
class uee {
  /**
   * @param connection The cluster connection where the program is deployed.
   * @param wallet     The wallet used to pay for and sign all transactions.
   * @param opts       Transaction confirmation options to use by default.
   */
  constructor(t, n, r) {
    this.connection = t, this.wallet = n, this.opts = r, this.publicKey = n == null ? void 0 : n.publicKey;
  }
  static defaultOptions() {
    return {
      preflightCommitment: "processed",
      commitment: "processed"
    };
  }
  /**
   * Returns a `Provider` with a wallet read from the local filesystem.
   *
   * @param url  The network cluster url.
   * @param opts The default transaction confirmation options.
   *
   * (This api is for Node only.)
   */
  static local(t, n) {
    throw new Error("Provider local is not available on browser.");
  }
  /**
   * Returns a `Provider` read from the `ANCHOR_PROVIDER_URL` environment
   * variable
   *
   * (This api is for Node only.)
   */
  static env() {
    throw new Error("Provider env is not available on browser.");
  }
  /**
   * Sends the given transaction, paid for and signed by the provider's wallet.
   *
   * @param tx      The transaction to send.
   * @param signers The signers of the transaction.
   * @param opts    Transaction confirmation options.
   */
  async sendAndConfirm(t, n, r) {
    var i, o, a, s;
    if (r === void 0 && (r = this.opts), hf(t))
      n && t.sign(n);
    else if (t.feePayer = (i = t.feePayer) !== null && i !== void 0 ? i : this.wallet.publicKey, t.recentBlockhash = (await this.connection.getLatestBlockhash(r.preflightCommitment)).blockhash, n)
      for (const l of n)
        t.partialSign(l);
    t = await this.wallet.signTransaction(t);
    const c = t.serialize();
    try {
      return await BO(this.connection, c, r);
    } catch (l) {
      if (l instanceof PA) {
        const u = TO(hf(t) ? ((o = t.signatures) === null || o === void 0 ? void 0 : o[0]) || new Uint8Array() : (a = t.signature) !== null && a !== void 0 ? a : new Uint8Array()), f = await this.connection.getTransaction(u, {
          commitment: "confirmed"
        });
        if (f) {
          const d = (s = f.meta) === null || s === void 0 ? void 0 : s.logMessages;
          throw d ? new gl(l.message, d) : l;
        } else
          throw l;
      } else
        throw l;
    }
  }
  /**
   * Similar to `send`, but for an array of transactions and signers.
   * All transactions need to be of the same type, it doesn't support a mix of `VersionedTransaction`s and `Transaction`s.
   *
   * @param txWithSigners Array of transactions and signers.
   * @param opts          Transaction confirmation options.
   */
  async sendAll(t, n) {
    var r, i, o;
    n === void 0 && (n = this.opts);
    const a = (await this.connection.getLatestBlockhash(n.preflightCommitment)).blockhash;
    let s = t.map((u) => {
      var f, d;
      if (hf(u.tx)) {
        let h = u.tx;
        return u.signers && h.sign(u.signers), h;
      } else {
        let h = u.tx, g = (f = u.signers) !== null && f !== void 0 ? f : [];
        return h.feePayer = (d = h.feePayer) !== null && d !== void 0 ? d : this.wallet.publicKey, h.recentBlockhash = a, g.forEach((w) => {
          h.partialSign(w);
        }), h;
      }
    });
    const c = await this.wallet.signAllTransactions(s), l = [];
    for (let u = 0; u < s.length; u += 1) {
      const f = c[u], d = f.serialize();
      try {
        l.push(await BO(this.connection, d, n));
      } catch (h) {
        if (h instanceof PA) {
          const g = TO(hf(f) ? ((r = f.signatures) === null || r === void 0 ? void 0 : r[0]) || new Uint8Array() : (i = f.signature) !== null && i !== void 0 ? i : new Uint8Array()), w = await this.connection.getTransaction(g, {
            commitment: "confirmed"
          });
          if (w) {
            const b = (o = w.meta) === null || o === void 0 ? void 0 : o.logMessages;
            throw b ? new gl(h.message, b) : h;
          } else
            throw h;
        } else
          throw h;
      }
    }
    return l;
  }
  /**
   * Simulates the given transaction, returning emitted logs from execution.
   *
   * @param tx      The transaction to send.
   * @param signers The signers of the transaction. If unset, the transaction
   *                will be simulated with the "sigVerify: false" option. This
   *                allows for simulation of transactions without asking the
   *                wallet for a signature.
   * @param opts    Transaction confirmation options.
   */
  async simulate(t, n, r, i) {
    let o = (await this.connection.getLatestBlockhash(r ?? this.connection.commitment)).blockhash, a;
    if (hf(t) ? (n && (t.sign(n), t = await this.wallet.signTransaction(t)), a = await this.connection.simulateTransaction(t, { commitment: r })) : (t.feePayer = t.feePayer || this.wallet.publicKey, t.recentBlockhash = o, n && (t = await this.wallet.signTransaction(t)), a = await iee(this.connection, t, n, r, i)), a.value.err)
      throw new lee(a.value);
    return a.value;
  }
}
class lee extends Error {
  constructor(t, n) {
    super(n), this.simulationResponse = t;
  }
}
async function BO(e, t, n) {
  const r = n && {
    skipPreflight: n.skipPreflight,
    preflightCommitment: n.preflightCommitment || n.commitment
  }, i = await e.sendRawTransaction(t, r), o = (await e.confirmTransaction(i, n && n.commitment)).value;
  if (o.err)
    throw new PA(`Raw transaction ${i} failed (${JSON.stringify(o)})`);
  return i;
}
class PA extends Error {
  constructor(t) {
    super(t);
  }
}
function BA() {
  return uee.local();
}
const fee = /* @__PURE__ */ new Map();
function u6(e) {
  return fee.get(e) !== void 0;
}
class Jb extends Error {
  constructor(t) {
    super(t), this.name = "IdlError";
  }
}
class Vd {
  constructor(t) {
    this.stack = t;
  }
  static parse(t) {
    var n;
    const r = /^Program (\w*) invoke/, i = /^Program \w* success/, o = [];
    for (let a = 0; a < t.length; a++) {
      if (i.exec(t[a])) {
        o.pop();
        continue;
      }
      const s = (n = r.exec(t[a])) === null || n === void 0 ? void 0 : n[1];
      s && o.push(new Ae(s));
    }
    return new Vd(o);
  }
}
let dee = class hb extends Error {
  constructor(t, n, r, i, o, a) {
    super(r.join(`
`).replace("Program log: ", "")), this.errorLogs = r, this.logs = i, this.error = { errorCode: t, errorMessage: n, comparedValues: a, origin: o }, this._programErrorStack = Vd.parse(i);
  }
  static parse(t) {
    if (!t)
      return null;
    const n = t.findIndex((d) => d.startsWith("Program log: AnchorError"));
    if (n === -1)
      return null;
    const r = t[n], i = [r];
    let o;
    if (n + 1 < t.length) {
      if (t[n + 1] === "Program log: Left:") {
        const d = /^Program log: (.*)$/, h = d.exec(t[n + 2])[1], g = d.exec(t[n + 4])[1];
        o = [
          new Ae(h),
          new Ae(g)
        ], i.push(...t.slice(n + 1, n + 5));
      } else if (t[n + 1].startsWith("Program log: Left:")) {
        const d = /^Program log: (Left|Right): (.*)$/, h = d.exec(t[n + 1])[2], g = d.exec(t[n + 2])[2];
        i.push(...t.slice(n + 1, n + 3)), o = [h, g];
      }
    }
    const s = /^Program log: AnchorError occurred\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec(r), l = /^Program log: AnchorError thrown in (.*):(\d*)\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec(r), f = /^Program log: AnchorError caused by account: (.*)\. Error Code: (.*)\. Error Number: (\d*)\. Error Message: (.*)\./.exec(r);
    if (s) {
      const [d, h, g] = s.slice(1, 4), w = {
        code: d,
        number: parseInt(h)
      };
      return new hb(w, g, i, t, void 0, o);
    } else if (l) {
      const [d, h, g, w, b] = l.slice(1, 6), I = {
        code: g,
        number: parseInt(w)
      }, A = { file: d, line: parseInt(h) };
      return new hb(I, b, i, t, A, o);
    } else if (f) {
      const [d, h, g, w] = f.slice(1, 5), b = d, I = {
        code: h,
        number: parseInt(g)
      };
      return new hb(I, w, i, t, b, o);
    } else
      return null;
  }
  get program() {
    return this._programErrorStack.stack[this._programErrorStack.stack.length - 1];
  }
  get programErrorStack() {
    return this._programErrorStack.stack;
  }
  toString() {
    return this.message;
  }
};
class Xb extends Error {
  constructor(t, n, r) {
    super(), this.code = t, this.msg = n, this.logs = r, r && (this._programErrorStack = Vd.parse(r));
  }
  static parse(t, n) {
    const r = t.toString();
    let i;
    if (r.includes("custom program error:")) {
      let s = r.split("custom program error: ");
      if (s.length !== 2)
        return null;
      i = s[1];
    } else {
      const s = r.match(/"Custom":([0-9]+)}/g);
      if (!s || s.length > 1)
        return null;
      i = s[0].match(/([0-9]+)/g)[0];
    }
    let o;
    try {
      o = parseInt(i);
    } catch {
      return null;
    }
    let a = n.get(o);
    return a !== void 0 ? new Xb(o, a, t.logs) : (a = hee.get(o), a !== void 0 ? new Xb(o, a, t.logs) : null);
  }
  get program() {
    var t;
    return (t = this._programErrorStack) === null || t === void 0 ? void 0 : t.stack[this._programErrorStack.stack.length - 1];
  }
  get programErrorStack() {
    var t;
    return (t = this._programErrorStack) === null || t === void 0 ? void 0 : t.stack;
  }
  toString() {
    return this.msg;
  }
}
function l6(e, t) {
  u6("debug-logs") && console.log("Translating error:", e);
  const n = dee.parse(e.logs);
  if (n)
    return n;
  const r = Xb.parse(e, t);
  if (r)
    return r;
  if (e.logs) {
    const i = {
      get: function(o, a) {
        return a === "programErrorStack" ? o.programErrorStack.stack : a === "program" ? o.programErrorStack.stack[e.programErrorStack.stack.length - 1] : Reflect.get(...arguments);
      }
    };
    return e.programErrorStack = Vd.parse(e.logs), new Proxy(e, i);
  }
  return e;
}
const vt = {
  // Instructions.
  InstructionMissing: 100,
  InstructionFallbackNotFound: 101,
  InstructionDidNotDeserialize: 102,
  InstructionDidNotSerialize: 103,
  // IDL instructions.
  IdlInstructionStub: 1e3,
  IdlInstructionInvalidProgram: 1001,
  // Constraints.
  ConstraintMut: 2e3,
  ConstraintHasOne: 2001,
  ConstraintSigner: 2002,
  ConstraintRaw: 2003,
  ConstraintOwner: 2004,
  ConstraintRentExempt: 2005,
  ConstraintSeeds: 2006,
  ConstraintExecutable: 2007,
  ConstraintState: 2008,
  ConstraintAssociated: 2009,
  ConstraintAssociatedInit: 2010,
  ConstraintClose: 2011,
  ConstraintAddress: 2012,
  ConstraintZero: 2013,
  ConstraintTokenMint: 2014,
  ConstraintTokenOwner: 2015,
  ConstraintMintMintAuthority: 2016,
  ConstraintMintFreezeAuthority: 2017,
  ConstraintMintDecimals: 2018,
  ConstraintSpace: 2019,
  ConstraintAccountIsNone: 2020,
  // Require.
  RequireViolated: 2500,
  RequireEqViolated: 2501,
  RequireKeysEqViolated: 2502,
  RequireNeqViolated: 2503,
  RequireKeysNeqViolated: 2504,
  RequireGtViolated: 2505,
  RequireGteViolated: 2506,
  // Accounts.
  AccountDiscriminatorAlreadySet: 3e3,
  AccountDiscriminatorNotFound: 3001,
  AccountDiscriminatorMismatch: 3002,
  AccountDidNotDeserialize: 3003,
  AccountDidNotSerialize: 3004,
  AccountNotEnoughKeys: 3005,
  AccountNotMutable: 3006,
  AccountOwnedByWrongProgram: 3007,
  InvalidProgramId: 3008,
  InvalidProgramExecutable: 3009,
  AccountNotSigner: 3010,
  AccountNotSystemOwned: 3011,
  AccountNotInitialized: 3012,
  AccountNotProgramData: 3013,
  AccountNotAssociatedTokenAccount: 3014,
  AccountSysvarMismatch: 3015,
  AccountReallocExceedsLimit: 3016,
  AccountDuplicateReallocs: 3017,
  // Miscellaneous
  DeclaredProgramIdMismatch: 4100,
  // Used for APIs that shouldn't be used anymore.
  Deprecated: 5e3
}, hee = /* @__PURE__ */ new Map([
  // Instructions.
  [
    vt.InstructionMissing,
    "8 byte instruction identifier not provided"
  ],
  [
    vt.InstructionFallbackNotFound,
    "Fallback functions are not supported"
  ],
  [
    vt.InstructionDidNotDeserialize,
    "The program could not deserialize the given instruction"
  ],
  [
    vt.InstructionDidNotSerialize,
    "The program could not serialize the given instruction"
  ],
  // Idl instructions.
  [
    vt.IdlInstructionStub,
    "The program was compiled without idl instructions"
  ],
  [
    vt.IdlInstructionInvalidProgram,
    "The transaction was given an invalid program for the IDL instruction"
  ],
  // Constraints.
  [vt.ConstraintMut, "A mut constraint was violated"],
  [vt.ConstraintHasOne, "A has one constraint was violated"],
  [vt.ConstraintSigner, "A signer constraint was violated"],
  [vt.ConstraintRaw, "A raw constraint was violated"],
  [vt.ConstraintOwner, "An owner constraint was violated"],
  [
    vt.ConstraintRentExempt,
    "A rent exemption constraint was violated"
  ],
  [vt.ConstraintSeeds, "A seeds constraint was violated"],
  [vt.ConstraintExecutable, "An executable constraint was violated"],
  [
    vt.ConstraintState,
    "Deprecated Error, feel free to replace with something else"
  ],
  [vt.ConstraintAssociated, "An associated constraint was violated"],
  [
    vt.ConstraintAssociatedInit,
    "An associated init constraint was violated"
  ],
  [vt.ConstraintClose, "A close constraint was violated"],
  [vt.ConstraintAddress, "An address constraint was violated"],
  [vt.ConstraintZero, "Expected zero account discriminant"],
  [vt.ConstraintTokenMint, "A token mint constraint was violated"],
  [vt.ConstraintTokenOwner, "A token owner constraint was violated"],
  [
    vt.ConstraintMintMintAuthority,
    "A mint mint authority constraint was violated"
  ],
  [
    vt.ConstraintMintFreezeAuthority,
    "A mint freeze authority constraint was violated"
  ],
  [
    vt.ConstraintMintDecimals,
    "A mint decimals constraint was violated"
  ],
  [vt.ConstraintSpace, "A space constraint was violated"],
  [
    vt.ConstraintAccountIsNone,
    "A required account for the constraint is None"
  ],
  // Require.
  [vt.RequireViolated, "A require expression was violated"],
  [vt.RequireEqViolated, "A require_eq expression was violated"],
  [
    vt.RequireKeysEqViolated,
    "A require_keys_eq expression was violated"
  ],
  [vt.RequireNeqViolated, "A require_neq expression was violated"],
  [
    vt.RequireKeysNeqViolated,
    "A require_keys_neq expression was violated"
  ],
  [vt.RequireGtViolated, "A require_gt expression was violated"],
  [vt.RequireGteViolated, "A require_gte expression was violated"],
  // Accounts.
  [
    vt.AccountDiscriminatorAlreadySet,
    "The account discriminator was already set on this account"
  ],
  [
    vt.AccountDiscriminatorNotFound,
    "No 8 byte discriminator was found on the account"
  ],
  [
    vt.AccountDiscriminatorMismatch,
    "8 byte discriminator did not match what was expected"
  ],
  [vt.AccountDidNotDeserialize, "Failed to deserialize the account"],
  [vt.AccountDidNotSerialize, "Failed to serialize the account"],
  [
    vt.AccountNotEnoughKeys,
    "Not enough account keys given to the instruction"
  ],
  [vt.AccountNotMutable, "The given account is not mutable"],
  [
    vt.AccountOwnedByWrongProgram,
    "The given account is owned by a different program than expected"
  ],
  [vt.InvalidProgramId, "Program ID was not as expected"],
  [vt.InvalidProgramExecutable, "Program account is not executable"],
  [vt.AccountNotSigner, "The given account did not sign"],
  [
    vt.AccountNotSystemOwned,
    "The given account is not owned by the system program"
  ],
  [
    vt.AccountNotInitialized,
    "The program expected this account to be already initialized"
  ],
  [
    vt.AccountNotProgramData,
    "The given account is not a program data account"
  ],
  [
    vt.AccountNotAssociatedTokenAccount,
    "The given account is not the associated token account"
  ],
  [
    vt.AccountSysvarMismatch,
    "The given public key does not match the required sysvar"
  ],
  [
    vt.AccountReallocExceedsLimit,
    "The account reallocation exceeds the MAX_PERMITTED_DATA_INCREASE limit"
  ],
  [
    vt.AccountDuplicateReallocs,
    "The account was duplicated for more than one reallocation"
  ],
  // Miscellaneous
  [
    vt.DeclaredProgramIdMismatch,
    "The declared program id does not match the actual program id"
  ],
  // Deprecated
  [
    vt.Deprecated,
    "The API being used is deprecated and should no longer be used"
  ]
]);
var CA = function() {
  return CA = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, CA.apply(this, arguments);
}, DA = function() {
  return DA = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, DA.apply(this, arguments);
};
function pee(e) {
  return e.toLowerCase();
}
var yee = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], gee = /[^A-Z0-9]+/gi;
function bee(e, t) {
  t === void 0 && (t = {});
  for (var n = t.splitRegexp, r = n === void 0 ? yee : n, i = t.stripRegexp, o = i === void 0 ? gee : i, a = t.transform, s = a === void 0 ? pee : a, c = t.delimiter, l = c === void 0 ? " " : c, u = CO(CO(e, r, "$1\0$2"), o, "\0"), f = 0, d = u.length; u.charAt(f) === "\0"; )
    f++;
  for (; u.charAt(d - 1) === "\0"; )
    d--;
  return u.slice(f, d).split("\0").map(s).join(l);
}
function CO(e, t, n) {
  return t instanceof RegExp ? e.replace(t, n) : t.reduce(function(r, i) {
    return r.replace(i, n);
  }, e);
}
function mee(e, t) {
  return t === void 0 && (t = {}), bee(e, DA({ delimiter: "." }, t));
}
function _ee(e, t) {
  return t === void 0 && (t = {}), mee(e, CA({ delimiter: "_" }, t));
}
class Ni {
  static fieldLayout(t, n) {
    const r = t.name !== void 0 ? nr(t.name) : void 0;
    switch (t.type) {
      case "bool":
        return Ut.bool(r);
      case "u8":
        return Ut.u8(r);
      case "i8":
        return Ut.i8(r);
      case "u16":
        return Ut.u16(r);
      case "i16":
        return Ut.i16(r);
      case "u32":
        return Ut.u32(r);
      case "i32":
        return Ut.i32(r);
      case "f32":
        return Ut.f32(r);
      case "u64":
        return Ut.u64(r);
      case "i64":
        return Ut.i64(r);
      case "f64":
        return Ut.f64(r);
      case "u128":
        return Ut.u128(r);
      case "i128":
        return Ut.i128(r);
      case "u256":
        return Ut.u256(r);
      case "i256":
        return Ut.i256(r);
      case "bytes":
        return Ut.vecU8(r);
      case "string":
        return Ut.str(r);
      case "publicKey":
        return Ut.publicKey(r);
      default: {
        if ("vec" in t.type)
          return Ut.vec(Ni.fieldLayout({
            name: void 0,
            type: t.type.vec
          }, n), r);
        if ("option" in t.type)
          return Ut.option(Ni.fieldLayout({
            name: void 0,
            type: t.type.option
          }, n), r);
        if ("defined" in t.type) {
          const i = t.type.defined;
          if (n === void 0)
            throw new Jb("User defined types not provided");
          const o = n.filter((a) => a.name === i);
          if (o.length !== 1)
            throw new Jb(`Type not found: ${JSON.stringify(t)}`);
          return Ni.typeDefLayout(o[0], n, r);
        } else if ("array" in t.type) {
          let i = t.type.array[0], o = t.type.array[1], a = Ni.fieldLayout({
            name: void 0,
            type: i
          }, n);
          return Ut.array(a, o, r);
        } else
          throw new Error(`Not yet implemented: ${t}`);
      }
    }
  }
  static typeDefLayout(t, n = [], r) {
    if (t.type.kind === "struct") {
      const i = t.type.fields.map((o) => Ni.fieldLayout(o, n));
      return Ut.struct(i, r);
    } else if (t.type.kind === "enum") {
      let i = t.type.variants.map((o) => {
        const a = nr(o.name);
        if (o.fields === void 0)
          return Ut.struct([], a);
        const s = o.fields.map((c, l) => c.hasOwnProperty("name") ? Ni.fieldLayout(c, n) : Ni.fieldLayout({ type: c, name: l.toString() }, n));
        return Ut.struct(s, a);
      });
      return r !== void 0 ? Ut.rustEnum(i).replicate(r) : Ut.rustEnum(i, r);
    } else
      throw new Error(`Unknown type kint: ${t}`);
  }
}
const DO = "global";
class aT {
  constructor(t) {
    this.idl = t, this.ixLayout = aT.parseIxLayout(t);
    const n = /* @__PURE__ */ new Map();
    t.instructions.forEach((r) => {
      const i = RO(DO, r.name);
      n.set(Er.encode(i), {
        layout: this.ixLayout.get(r.name),
        name: r.name
      });
    }), this.sighashLayouts = n;
  }
  /**
   * Encodes a program instruction.
   */
  encode(t, n) {
    return this._encode(DO, t, n);
  }
  _encode(t, n, r) {
    const i = it.Buffer.alloc(1e3), o = nr(n), a = this.ixLayout.get(o);
    if (!a)
      throw new Error(`Unknown method: ${o}`);
    const s = a.encode(r, i), c = i.slice(0, s);
    return it.Buffer.concat([RO(t, n), c]);
  }
  static parseIxLayout(t) {
    const n = t.instructions.map((r) => {
      let i = r.args.map((a) => {
        var s, c;
        return Ni.fieldLayout(a, Array.from([...(s = t.accounts) !== null && s !== void 0 ? s : [], ...(c = t.types) !== null && c !== void 0 ? c : []]));
      });
      const o = nr(r.name);
      return [o, Ut.struct(i, o)];
    });
    return new Map(n);
  }
  /**
   * Decodes a program instruction.
   */
  decode(t, n = "hex") {
    typeof t == "string" && (t = n === "hex" ? it.Buffer.from(t, "hex") : Er.decode(t));
    let r = Er.encode(t.slice(0, 8)), i = t.slice(8);
    const o = this.sighashLayouts.get(r);
    return o ? {
      data: o.layout.decode(i),
      name: o.name
    } : null;
  }
  /**
   * Returns a formatted table of all the fields in the given instruction data.
   */
  format(t, n) {
    return Oa.format(t, n, this.idl);
  }
}
class Oa {
  static format(t, n, r) {
    const i = r.instructions.filter((c) => t.name === c.name)[0];
    if (i === void 0)
      return console.error("Invalid instruction given"), null;
    const o = i.args.map((c) => ({
      name: c.name,
      type: Oa.formatIdlType(c.type),
      data: Oa.formatIdlData(c, t.data[c.name], r.types)
    })), a = Oa.flattenIdlAccounts(i.accounts), s = n.map((c, l) => l < a.length ? {
      name: a[l].name,
      ...c
    } : {
      name: void 0,
      ...c
    });
    return {
      args: o,
      accounts: s
    };
  }
  static formatIdlType(t) {
    if (typeof t == "string")
      return t;
    if ("vec" in t)
      return `Vec<${this.formatIdlType(t.vec)}>`;
    if ("option" in t)
      return `Option<${this.formatIdlType(t.option)}>`;
    if ("defined" in t)
      return t.defined;
    if ("array" in t)
      return `Array<${t.array[0]}; ${t.array[1]}>`;
    throw new Error(`Unknown IDL type: ${t}`);
  }
  static formatIdlData(t, n, r) {
    if (typeof t.type == "string")
      return n.toString();
    if (t.type.hasOwnProperty("vec"))
      return "[" + n.map((i) => this.formatIdlData({ name: "", type: t.type.vec }, i)).join(", ") + "]";
    if (t.type.hasOwnProperty("option"))
      return n === null ? "null" : this.formatIdlData({ name: "", type: t.type.option }, n, r);
    if (t.type.hasOwnProperty("defined")) {
      if (r === void 0)
        throw new Error("User defined types not provided");
      const i = r.filter((o) => o.name === t.type.defined);
      if (i.length !== 1)
        throw new Error(`Type not found: ${t.type.defined}`);
      return Oa.formatIdlDataDefined(i[0], n, r);
    }
    return "unknown";
  }
  static formatIdlDataDefined(t, n, r) {
    if (t.type.kind === "struct") {
      const i = t.type;
      return "{ " + Object.keys(n).map((a) => {
        const s = i.fields.filter((c) => c.name === a)[0];
        if (s === void 0)
          throw new Error("Unable to find type");
        return a + ": " + Oa.formatIdlData(s, n[a], r);
      }).join(", ") + " }";
    } else {
      if (t.type.variants.length === 0)
        return "{}";
      if (t.type.variants[0].name) {
        const i = t.type.variants, o = Object.keys(n)[0], a = n[o], s = Object.keys(a).map((l) => {
          var u;
          const f = a[l], d = (u = i[o]) === null || u === void 0 ? void 0 : u.filter((h) => h.name === l)[0];
          if (d === void 0)
            throw new Error("Unable to find variant");
          return l + ": " + Oa.formatIdlData(d, f, r);
        }).join(", "), c = nr(o, { pascalCase: !0 });
        return s.length === 0 ? c : `${c} { ${s} }`;
      } else
        return "Tuple formatting not yet implemented";
    }
  }
  static flattenIdlAccounts(t, n) {
    return t.map((r) => {
      const i = wee(r.name);
      if (r.hasOwnProperty("accounts")) {
        const o = n ? `${n} > ${i}` : i;
        return Oa.flattenIdlAccounts(r.accounts, o);
      } else
        return {
          ...r,
          name: n ? `${n} > ${i}` : i
        };
    }).flat();
  }
}
function wee(e) {
  const t = e.replace(/([A-Z])/g, " $1");
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function RO(e, t) {
  let n = _ee(t), r = `${e}:${n}`;
  return it.Buffer.from(Jm.sha256.digest(r)).slice(0, 8);
}
function f6(e, t) {
  if (t.type.kind === "enum") {
    let n = t.type.variants.map((r) => r.fields === void 0 ? 0 : r.fields.map((i) => {
      if (!(typeof i == "object" && "name" in i))
        throw new Error("Tuple enum variants not yet implemented.");
      return Zf(e, i.type);
    }).reduce((i, o) => i + o));
    return Math.max(...n) + 1;
  }
  return t.type.fields === void 0 ? 0 : t.type.fields.map((n) => Zf(e, n.type)).reduce((n, r) => n + r, 0);
}
function Zf(e, t) {
  var n, r;
  switch (t) {
    case "bool":
      return 1;
    case "u8":
      return 1;
    case "i8":
      return 1;
    case "i16":
      return 2;
    case "u16":
      return 2;
    case "u32":
      return 4;
    case "i32":
      return 4;
    case "f32":
      return 4;
    case "u64":
      return 8;
    case "i64":
      return 8;
    case "f64":
      return 8;
    case "u128":
      return 16;
    case "i128":
      return 16;
    case "u256":
      return 32;
    case "i256":
      return 32;
    case "bytes":
      return 1;
    case "string":
      return 1;
    case "publicKey":
      return 32;
    default:
      if ("vec" in t)
        return 1;
      if ("option" in t)
        return 1 + Zf(e, t.option);
      if ("coption" in t)
        return 4 + Zf(e, t.coption);
      if ("defined" in t) {
        const i = (r = (n = e.types) === null || n === void 0 ? void 0 : n.filter((a) => a.name === t.defined)) !== null && r !== void 0 ? r : [];
        if (i.length !== 1)
          throw new Jb(`Type not found: ${JSON.stringify(t)}`);
        let o = i[0];
        return f6(e, o);
      }
      if ("array" in t) {
        let i = t.array[0], o = t.array[1];
        return Zf(e, i) * o;
      }
      throw new Error(`Invalid type ${JSON.stringify(t)}`);
  }
}
const Q1 = 8;
class ju {
  constructor(t) {
    if (t.accounts === void 0) {
      this.accountLayouts = /* @__PURE__ */ new Map();
      return;
    }
    const n = t.accounts.map((r) => [r.name, Ni.typeDefLayout(r, t.types)]);
    this.accountLayouts = new Map(n), this.idl = t;
  }
  async encode(t, n) {
    const r = it.Buffer.alloc(1e3), i = this.accountLayouts.get(t);
    if (!i)
      throw new Error(`Unknown account: ${t}`);
    const o = i.encode(n, r);
    let a = r.slice(0, o), s = ju.accountDiscriminator(t);
    return it.Buffer.concat([s, a]);
  }
  decode(t, n) {
    if (ju.accountDiscriminator(t).compare(n.slice(0, 8)))
      throw new Error("Invalid account discriminator");
    return this.decodeUnchecked(t, n);
  }
  decodeAny(t) {
    const n = t.slice(0, 8), r = Array.from(this.accountLayouts.keys()).find((i) => ju.accountDiscriminator(i).equals(n));
    if (!r)
      throw new Error("Account descriminator not found");
    return this.decodeUnchecked(r, t);
  }
  decodeUnchecked(t, n) {
    const r = n.slice(Q1), i = this.accountLayouts.get(t);
    if (!i)
      throw new Error(`Unknown account: ${t}`);
    return i.decode(r);
  }
  memcmp(t, n) {
    const r = ju.accountDiscriminator(t);
    return {
      offset: 0,
      bytes: Er.encode(n ? it.Buffer.concat([r, n]) : r)
    };
  }
  size(t) {
    var n;
    return Q1 + ((n = f6(this.idl, t)) !== null && n !== void 0 ? n : 0);
  }
  /**
   * Calculates and returns a unique 8 byte discriminator prepended to all anchor accounts.
   *
   * @param name The name of the account to calculate the discriminator.
   */
  static accountDiscriminator(t) {
    return it.Buffer.from(Jm.sha256.digest(`account:${nr(t, {
      pascalCase: !0,
      preserveConsecutiveUppercase: !0
    })}`)).slice(0, Q1);
  }
}
class vee {
  constructor(t) {
    if (t.events === void 0) {
      this.layouts = /* @__PURE__ */ new Map();
      return;
    }
    const n = t.events.map((r) => {
      let i = {
        name: r.name,
        type: {
          kind: "struct",
          fields: r.fields.map((o) => ({ name: o.name, type: o.type }))
        }
      };
      return [r.name, Ni.typeDefLayout(i, t.types)];
    });
    this.layouts = new Map(n), this.discriminators = new Map(t.events === void 0 ? [] : t.events.map((r) => [
      kx(See(r.name)),
      r.name
    ]));
  }
  decode(t) {
    let n;
    try {
      n = it.Buffer.from(N3(t));
    } catch {
      return null;
    }
    const r = kx(n.slice(0, 8)), i = this.discriminators.get(r);
    if (i === void 0)
      return null;
    const o = this.layouts.get(i);
    if (!o)
      throw new Error(`Unknown event: ${i}`);
    return { data: o.decode(n.slice(8)), name: i };
  }
}
function See(e) {
  return it.Buffer.from(Jm.sha256.digest(`event:${e}`)).slice(0, 8);
}
class Eee {
  constructor(t) {
    if (t.types === void 0) {
      this.typeLayouts = /* @__PURE__ */ new Map();
      return;
    }
    const n = t.types.map((r) => [r.name, Ni.typeDefLayout(r, t.types)]);
    this.typeLayouts = new Map(n), this.idl = t;
  }
  encode(t, n) {
    const r = it.Buffer.alloc(1e3), i = this.typeLayouts.get(t);
    if (!i)
      throw new Error(`Unknown type: ${t}`);
    const o = i.encode(n, r);
    return r.slice(0, o);
  }
  decode(t, n) {
    const r = this.typeLayouts.get(t);
    if (!r)
      throw new Error(`Unknown type: ${t}`);
    return r.decode(n);
  }
}
class d6 {
  constructor(t) {
    this.instruction = new aT(t), this.accounts = new ju(t), this.events = new vee(t), this.types = new Eee(t);
  }
}
var Aee = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
class Ti {
  constructor(t, n) {
    if (!Number.isInteger(t))
      throw new TypeError("span must be an integer");
    this.span = t, this.property = n;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */
  decode(t, n) {
    throw new Error("Layout is abstract");
  }
  /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */
  encode(t, n, r) {
    throw new Error("Layout is abstract");
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(t, n) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(t) {
    const n = Object.create(this.constructor.prototype);
    return Object.assign(n, this), n.property = t, n;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(t) {
  }
}
var S_ = Ti;
function Iee(e, t) {
  return t.property ? e + "[" + t.property + "]" : e;
}
class Sc extends Ti {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}
class h6 extends Sc {
  constructor(t, n, r) {
    if (!(t instanceof Ti))
      throw new TypeError("layout must be a Layout");
    if (n === void 0)
      n = 0;
    else if (!Number.isInteger(n))
      throw new TypeError("offset must be integer or undefined");
    super(t.span, r || t.property), this.layout = t, this.offset = n;
  }
  /** @override */
  isCount() {
    return this.layout instanceof E_ || this.layout instanceof p6;
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), this.layout.decode(t, n + this.offset);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), this.layout.encode(t, n, r + this.offset);
  }
}
class E_ extends Ti {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readUIntLE(n, this.span);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), n.writeUIntLE(t, r, this.span), this.span;
  }
}
class p6 extends Ti {
  constructor(t, n) {
    if (super(t, n), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(t, n) {
    return n === void 0 && (n = 0), t.readUIntBE(n, this.span);
  }
  /** @override */
  encode(t, n, r) {
    return r === void 0 && (r = 0), n.writeUIntBE(t, r, this.span), this.span;
  }
}
const RA = Math.pow(2, 32);
function y6(e) {
  const t = Math.floor(e / RA), n = e - t * RA;
  return { hi32: t, lo32: n };
}
function g6(e, t) {
  return e * RA + t;
}
class kee extends Ti {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const r = t.readUInt32LE(n), i = t.readUInt32LE(n + 4);
    return g6(i, r);
  }
  /** @override */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = y6(t);
    return n.writeUInt32LE(i.lo32, r), n.writeUInt32LE(i.hi32, r + 4), 8;
  }
}
class Tee extends Ti {
  constructor(t) {
    super(8, t);
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const r = t.readUInt32LE(n), i = t.readInt32LE(n + 4);
    return g6(i, r);
  }
  /** @override */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = y6(t);
    return n.writeUInt32LE(i.lo32, r), n.writeInt32LE(i.hi32, r + 4), 8;
  }
}
class xee extends Ti {
  constructor(t, n, r) {
    if (!(Array.isArray(t) && t.reduce((o, a) => o && a instanceof Ti, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof n == "boolean" && r === void 0 && (r = n, n = void 0);
    for (const o of t)
      if (0 > o.span && o.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let i = -1;
    try {
      i = t.reduce((o, a) => o + a.getSpan(), 0);
    } catch {
    }
    super(i, n), this.fields = t, this.decodePrefixes = !!r;
  }
  /** @override */
  getSpan(t, n) {
    if (0 <= this.span)
      return this.span;
    n === void 0 && (n = 0);
    let r = 0;
    try {
      r = this.fields.reduce((i, o) => {
        const a = o.getSpan(t, n);
        return n += a, i + a;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return r;
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    const r = this.makeDestinationObject();
    for (const i of this.fields)
      if (i.property !== void 0 && (r[i.property] = i.decode(t, n)), n += i.getSpan(t, n), this.decodePrefixes && t.length === n)
        break;
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = r;
    let o = 0, a = 0;
    for (const s of this.fields) {
      let c = s.span;
      if (a = 0 < c ? c : 0, s.property !== void 0) {
        const l = t[s.property];
        l !== void 0 && (a = s.encode(l, n, r), 0 > c && (c = s.getSpan(n, r)));
      }
      o = r, r += c;
    }
    return o + a - i;
  }
  /** @override */
  fromArray(t) {
    const n = this.makeDestinationObject();
    for (const r of this.fields)
      r.property !== void 0 && 0 < t.length && (n[r.property] = t.shift());
    return n;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    for (const n of this.fields)
      if (n.property === t)
        return n;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(t) {
    if (typeof t != "string")
      throw new TypeError("property must be string");
    let n = 0;
    for (const r of this.fields) {
      if (r.property === t)
        return n;
      0 > r.span ? n = -1 : 0 <= n && (n += r.span);
    }
  }
}
class b6 {
  constructor(t) {
    this.property = t;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode() {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode() {
    throw new Error("UnionDiscriminator is abstract");
  }
}
class NO extends b6 {
  constructor(t, n) {
    if (!(t instanceof Sc && t.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(n || t.property || "variant"), this.layout = t;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(t, n) {
    return this.layout.decode(t, n);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(t, n, r) {
    return this.layout.encode(t, n, r);
  }
}
class m6 extends Ti {
  constructor(t, n, r) {
    const i = t instanceof E_ || t instanceof p6;
    if (i)
      t = new NO(new h6(t));
    else if (t instanceof Sc && t.isCount())
      t = new NO(t);
    else if (!(t instanceof b6))
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (n === void 0 && (n = null), !(n === null || n instanceof Ti))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (n !== null) {
      if (0 > n.span)
        throw new Error("defaultLayout must have constant span");
      n.property === void 0 && (n = n.replicate("content"));
    }
    let o = -1;
    n && (o = n.span, 0 <= o && i && (o += t.layout.span)), super(o, r), this.discriminator = t, this.usesPrefixDiscriminator = i, this.defaultLayout = n, this.registry = {};
    let a = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(s) {
      return a(s);
    }, this.configGetSourceVariant = function(s) {
      a = s.bind(this);
    };
  }
  /** @override */
  getSpan(t, n) {
    if (0 <= this.span)
      return this.span;
    n === void 0 && (n = 0);
    const r = this.getVariant(t, n);
    if (!r)
      throw new Error("unable to determine span for unrecognized variant");
    return r.getSpan(t, n);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(t) {
    if (t.hasOwnProperty(this.discriminator.property)) {
      if (this.defaultLayout && t.hasOwnProperty(this.defaultLayout.property))
        return;
      const n = this.registry[t[this.discriminator.property]];
      if (n && (!n.layout || t.hasOwnProperty(n.property)))
        return n;
    } else
      for (const n in this.registry) {
        const r = this.registry[n];
        if (t.hasOwnProperty(r.property))
          return r;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(t, n) {
    n === void 0 && (n = 0);
    let r;
    const i = this.discriminator, o = i.decode(t, n);
    let a = this.registry[o];
    if (a === void 0) {
      let s = 0;
      a = this.defaultLayout, this.usesPrefixDiscriminator && (s = i.layout.span), r = this.makeDestinationObject(), r[i.property] = o, r[a.property] = this.defaultLayout.decode(t, n + s);
    } else
      r = a.decode(t, n);
    return r;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    const i = this.getSourceVariant(t);
    if (i === void 0) {
      const o = this.discriminator, a = this.defaultLayout;
      let s = 0;
      return this.usesPrefixDiscriminator && (s = o.layout.span), o.encode(t[o.property], n, r), s + a.encode(
        t[a.property],
        n,
        r + s
      );
    }
    return i.encode(t, n, r);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(t, n, r) {
    const i = new Mee(this, t, n, r);
    return this.registry[t] = i, i;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(t, n) {
    let r = t;
    return Buffer.isBuffer(t) && (n === void 0 && (n = 0), r = this.discriminator.decode(t, n)), this.registry[r];
  }
}
class Mee extends Ti {
  constructor(t, n, r, i) {
    if (!(t instanceof m6))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(n) || 0 > n)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof r == "string" && i === void 0 && (i = r, r = null), r) {
      if (!(r instanceof Ti))
        throw new TypeError("layout must be a Layout");
      if (t.defaultLayout !== null && 0 <= r.span && r.span > t.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof i != "string")
        throw new TypeError("variant must have a String property");
    }
    let o = t.span;
    0 > t.span && (o = r ? r.span : 0, 0 <= o && t.usesPrefixDiscriminator && (o += t.discriminator.layout.span)), super(o, i), this.union = t, this.variant = n, this.layout = r || null;
  }
  /** @override */
  getSpan(t, n) {
    if (0 <= this.span)
      return this.span;
    n === void 0 && (n = 0);
    let r = 0;
    return this.union.usesPrefixDiscriminator && (r = this.union.discriminator.layout.span), r + this.layout.getSpan(t, n + r);
  }
  /** @override */
  decode(t, n) {
    const r = this.makeDestinationObject();
    if (n === void 0 && (n = 0), this !== this.union.getVariant(t, n))
      throw new Error("variant mismatch");
    let i = 0;
    return this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout ? r[this.property] = this.layout.decode(t, n + i) : this.property ? r[this.property] = !0 : this.union.usesPrefixDiscriminator && (r[this.union.discriminator.property] = this.variant), r;
  }
  /** @override */
  encode(t, n, r) {
    r === void 0 && (r = 0);
    let i = 0;
    if (this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout && !t.hasOwnProperty(this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, n, r);
    let o = i;
    if (this.layout && (this.layout.encode(t[this.property], n, r + i), o += this.layout.getSpan(n, r + i), 0 <= this.union.span && o > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return o;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(t) {
    if (this.layout)
      return this.layout.fromArray(t);
  }
}
class Oee extends Ti {
  constructor(t, n) {
    if (!(t instanceof Sc && t.isCount() || Number.isInteger(t) && 0 <= t))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let r = -1;
    t instanceof Sc || (r = t), super(r, n), this.length = t;
  }
  /** @override */
  getSpan(t, n) {
    let r = this.span;
    return 0 > r && (r = this.length.decode(t, n)), r;
  }
  /** @override */
  decode(t, n) {
    n === void 0 && (n = 0);
    let r = this.span;
    return 0 > r && (r = this.length.decode(t, n)), t.slice(n, n + r);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(t, n, r) {
    let i = this.length;
    if (this.length instanceof Sc && (i = t.length), !(Buffer.isBuffer(t) && i === t.length))
      throw new TypeError(Iee("Blob.encode", this) + " requires (length " + i + ") Buffer as src");
    if (r + i > n.length)
      throw new RangeError("encoding overruns Buffer");
    return n.write(t.toString("hex"), r, i, "hex"), this.length instanceof Sc && this.length.encode(i, n, r), i;
  }
}
var Pee = (e, t, n) => new h6(e, t, n), Bee = (e) => new E_(1, e), ja = (e) => new E_(4, e), Cee = (e) => new kee(e), qa = (e) => new Tee(e), Nr = (e, t, n) => new xee(e, t, n), _6 = (e, t, n) => new m6(e, t, n), qd = (e, t) => new Oee(e, t);
class Dee extends S_ {
  constructor(t) {
    super(-1, t), this.property = t, this.layout = Nr([
      ja("length"),
      ja("lengthPadding"),
      qd(Pee(ja(), -8), "chars")
    ], this.property);
  }
  encode(t, n, r = 0) {
    if (t == null)
      return this.layout.span;
    const i = {
      chars: Buffer.from(t, "utf8")
    };
    return this.layout.encode(i, n, r);
  }
  decode(t, n = 0) {
    return this.layout.decode(t, n).chars.toString();
  }
  getSpan(t, n = 0) {
    return ja().span + ja().span + new il(new Uint8Array(t).slice(n, n + 4), 10, "le").toNumber();
  }
}
function A_(e) {
  return new Dee(e);
}
function po(e) {
  return qd(32, e);
}
const Gi = _6(ja("instruction"));
Gi.addVariant(0, Nr([
  qa("lamports"),
  qa("space"),
  po("owner")
]), "createAccount");
Gi.addVariant(1, Nr([po("owner")]), "assign");
Gi.addVariant(2, Nr([qa("lamports")]), "transfer");
Gi.addVariant(3, Nr([
  po("base"),
  A_("seed"),
  qa("lamports"),
  qa("space"),
  po("owner")
]), "createAccountWithSeed");
Gi.addVariant(4, Nr([po("authorized")]), "advanceNonceAccount");
Gi.addVariant(5, Nr([qa("lamports")]), "withdrawNonceAccount");
Gi.addVariant(6, Nr([po("authorized")]), "initializeNonceAccount");
Gi.addVariant(7, Nr([po("authorized")]), "authorizeNonceAccount");
Gi.addVariant(8, Nr([qa("space")]), "allocate");
Gi.addVariant(9, Nr([
  po("base"),
  A_("seed"),
  qa("space"),
  po("owner")
]), "allocateWithSeed");
Gi.addVariant(10, Nr([
  po("base"),
  A_("seed"),
  po("owner")
]), "assignWithSeed");
Gi.addVariant(11, Nr([
  qa("lamports"),
  A_("seed"),
  po("owner")
]), "transferWithSeed");
Math.max(...Object.values(Gi.registry).map((e) => e.span));
class Ree extends S_ {
  constructor(t, n, r, i) {
    super(t.span, i), this.layout = t, this.decoder = n, this.encoder = r;
  }
  decode(t, n) {
    return this.decoder(this.layout.decode(t, n));
  }
  encode(t, n, r) {
    return this.layout.encode(this.encoder(t), n, r);
  }
  getSpan(t, n) {
    return this.layout.getSpan(t, n);
  }
}
function jO(e) {
  return new Ree(qd(32), (t) => new Ae(t), (t) => t.toBuffer(), e);
}
Nr([
  ja("version"),
  ja("state"),
  jO("authorizedPubkey"),
  jO("nonce"),
  Nr([Cee("lamportsPerSignature")], "feeCalculator")
]);
function Nee(e, ...t) {
  let n = [it.Buffer.from([97, 110, 99, 104, 111, 114])];
  t.forEach((i) => {
    n.push(i instanceof it.Buffer ? i : uo(i).toBuffer());
  });
  const [r] = Ae.findProgramAddressSync(n, uo(e));
  return r;
}
const jee = new Ae("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), Uee = new Ae("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
var UO = { exports: {} };
(function(e, t) {
  var n = typeof self < "u" ? self : Aee, r = function() {
    function o() {
      this.fetch = !1, this.DOMException = n.DOMException;
    }
    return o.prototype = n, new o();
  }();
  (function(o) {
    (function(a) {
      var s = {
        searchParams: "URLSearchParams" in o,
        iterable: "Symbol" in o && "iterator" in Symbol,
        blob: "FileReader" in o && "Blob" in o && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in o,
        arrayBuffer: "ArrayBuffer" in o
      };
      function c(p) {
        return p && DataView.prototype.isPrototypeOf(p);
      }
      if (s.arrayBuffer)
        var l = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], u = ArrayBuffer.isView || function(p) {
          return p && l.indexOf(Object.prototype.toString.call(p)) > -1;
        };
      function f(p) {
        if (typeof p != "string" && (p = String(p)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(p))
          throw new TypeError("Invalid character in header field name");
        return p.toLowerCase();
      }
      function d(p) {
        return typeof p != "string" && (p = String(p)), p;
      }
      function h(p) {
        var y = {
          next: function() {
            var v = p.shift();
            return { done: v === void 0, value: v };
          }
        };
        return s.iterable && (y[Symbol.iterator] = function() {
          return y;
        }), y;
      }
      function g(p) {
        this.map = {}, p instanceof g ? p.forEach(function(y, v) {
          this.append(v, y);
        }, this) : Array.isArray(p) ? p.forEach(function(y) {
          this.append(y[0], y[1]);
        }, this) : p && Object.getOwnPropertyNames(p).forEach(function(y) {
          this.append(y, p[y]);
        }, this);
      }
      g.prototype.append = function(p, y) {
        p = f(p), y = d(y);
        var v = this.map[p];
        this.map[p] = v ? v + ", " + y : y;
      }, g.prototype.delete = function(p) {
        delete this.map[f(p)];
      }, g.prototype.get = function(p) {
        return p = f(p), this.has(p) ? this.map[p] : null;
      }, g.prototype.has = function(p) {
        return this.map.hasOwnProperty(f(p));
      }, g.prototype.set = function(p, y) {
        this.map[f(p)] = d(y);
      }, g.prototype.forEach = function(p, y) {
        for (var v in this.map)
          this.map.hasOwnProperty(v) && p.call(y, this.map[v], v, this);
      }, g.prototype.keys = function() {
        var p = [];
        return this.forEach(function(y, v) {
          p.push(v);
        }), h(p);
      }, g.prototype.values = function() {
        var p = [];
        return this.forEach(function(y) {
          p.push(y);
        }), h(p);
      }, g.prototype.entries = function() {
        var p = [];
        return this.forEach(function(y, v) {
          p.push([v, y]);
        }), h(p);
      }, s.iterable && (g.prototype[Symbol.iterator] = g.prototype.entries);
      function w(p) {
        if (p.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        p.bodyUsed = !0;
      }
      function b(p) {
        return new Promise(function(y, v) {
          p.onload = function() {
            y(p.result);
          }, p.onerror = function() {
            v(p.error);
          };
        });
      }
      function I(p) {
        var y = new FileReader(), v = b(y);
        return y.readAsArrayBuffer(p), v;
      }
      function A(p) {
        var y = new FileReader(), v = b(y);
        return y.readAsText(p), v;
      }
      function x(p) {
        for (var y = new Uint8Array(p), v = new Array(y.length), E = 0; E < y.length; E++)
          v[E] = String.fromCharCode(y[E]);
        return v.join("");
      }
      function N(p) {
        if (p.slice)
          return p.slice(0);
        var y = new Uint8Array(p.byteLength);
        return y.set(new Uint8Array(p)), y.buffer;
      }
      function j() {
        return this.bodyUsed = !1, this._initBody = function(p) {
          this._bodyInit = p, p ? typeof p == "string" ? this._bodyText = p : s.blob && Blob.prototype.isPrototypeOf(p) ? this._bodyBlob = p : s.formData && FormData.prototype.isPrototypeOf(p) ? this._bodyFormData = p : s.searchParams && URLSearchParams.prototype.isPrototypeOf(p) ? this._bodyText = p.toString() : s.arrayBuffer && s.blob && c(p) ? (this._bodyArrayBuffer = N(p.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : s.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(p) || u(p)) ? this._bodyArrayBuffer = N(p) : this._bodyText = p = Object.prototype.toString.call(p) : this._bodyText = "", this.headers.get("content-type") || (typeof p == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : s.searchParams && URLSearchParams.prototype.isPrototypeOf(p) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, s.blob && (this.blob = function() {
          var p = w(this);
          if (p)
            return p;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? w(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(I);
        }), this.text = function() {
          var p = w(this);
          if (p)
            return p;
          if (this._bodyBlob)
            return A(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(x(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, s.formData && (this.formData = function() {
          return this.text().then(k);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var K = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function W(p) {
        var y = p.toUpperCase();
        return K.indexOf(y) > -1 ? y : p;
      }
      function O(p, y) {
        y = y || {};
        var v = y.body;
        if (p instanceof O) {
          if (p.bodyUsed)
            throw new TypeError("Already read");
          this.url = p.url, this.credentials = p.credentials, y.headers || (this.headers = new g(p.headers)), this.method = p.method, this.mode = p.mode, this.signal = p.signal, !v && p._bodyInit != null && (v = p._bodyInit, p.bodyUsed = !0);
        } else
          this.url = String(p);
        if (this.credentials = y.credentials || this.credentials || "same-origin", (y.headers || !this.headers) && (this.headers = new g(y.headers)), this.method = W(y.method || this.method || "GET"), this.mode = y.mode || this.mode || null, this.signal = y.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && v)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(v);
      }
      O.prototype.clone = function() {
        return new O(this, { body: this._bodyInit });
      };
      function k(p) {
        var y = new FormData();
        return p.trim().split("&").forEach(function(v) {
          if (v) {
            var E = v.split("="), B = E.shift().replace(/\+/g, " "), F = E.join("=").replace(/\+/g, " ");
            y.append(decodeURIComponent(B), decodeURIComponent(F));
          }
        }), y;
      }
      function z(p) {
        var y = new g(), v = p.replace(/\r?\n[\t ]+/g, " ");
        return v.split(/\r?\n/).forEach(function(E) {
          var B = E.split(":"), F = B.shift().trim();
          if (F) {
            var q = B.join(":").trim();
            y.append(F, q);
          }
        }), y;
      }
      j.call(O.prototype);
      function C(p, y) {
        y || (y = {}), this.type = "default", this.status = y.status === void 0 ? 200 : y.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in y ? y.statusText : "OK", this.headers = new g(y.headers), this.url = y.url || "", this._initBody(p);
      }
      j.call(C.prototype), C.prototype.clone = function() {
        return new C(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new g(this.headers),
          url: this.url
        });
      }, C.error = function() {
        var p = new C(null, { status: 0, statusText: "" });
        return p.type = "error", p;
      };
      var M = [301, 302, 303, 307, 308];
      C.redirect = function(p, y) {
        if (M.indexOf(y) === -1)
          throw new RangeError("Invalid status code");
        return new C(null, { status: y, headers: { location: p } });
      }, a.DOMException = o.DOMException;
      try {
        new a.DOMException();
      } catch {
        a.DOMException = function(y, v) {
          this.message = y, this.name = v;
          var E = Error(y);
          this.stack = E.stack;
        }, a.DOMException.prototype = Object.create(Error.prototype), a.DOMException.prototype.constructor = a.DOMException;
      }
      function S(p, y) {
        return new Promise(function(v, E) {
          var B = new O(p, y);
          if (B.signal && B.signal.aborted)
            return E(new a.DOMException("Aborted", "AbortError"));
          var F = new XMLHttpRequest();
          function q() {
            F.abort();
          }
          F.onload = function() {
            var U = {
              status: F.status,
              statusText: F.statusText,
              headers: z(F.getAllResponseHeaders() || "")
            };
            U.url = "responseURL" in F ? F.responseURL : U.headers.get("X-Request-URL");
            var m = "response" in F ? F.response : F.responseText;
            v(new C(m, U));
          }, F.onerror = function() {
            E(new TypeError("Network request failed"));
          }, F.ontimeout = function() {
            E(new TypeError("Network request failed"));
          }, F.onabort = function() {
            E(new a.DOMException("Aborted", "AbortError"));
          }, F.open(B.method, B.url, !0), B.credentials === "include" ? F.withCredentials = !0 : B.credentials === "omit" && (F.withCredentials = !1), "responseType" in F && s.blob && (F.responseType = "blob"), B.headers.forEach(function(U, m) {
            F.setRequestHeader(m, U);
          }), B.signal && (B.signal.addEventListener("abort", q), F.onreadystatechange = function() {
            F.readyState === 4 && B.signal.removeEventListener("abort", q);
          }), F.send(typeof B._bodyInit > "u" ? null : B._bodyInit);
        });
      }
      return S.polyfill = !0, o.fetch || (o.fetch = S, o.Headers = g, o.Request = O, o.Response = C), a.Headers = g, a.Request = O, a.Response = C, a.fetch = S, Object.defineProperty(a, "__esModule", { value: !0 }), a;
    })({});
  })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
  var i = r;
  t = i.fetch, t.default = i.fetch, t.fetch = i.fetch, t.Headers = i.Headers, t.Request = i.Request, t.Response = i.Response, e.exports = t;
})(UO, UO.exports);
Ut.rustEnum([
  Ut.struct([], "uninitialized"),
  Ut.struct([Ut.option(Ut.publicKey(), "authorityAddress")], "buffer"),
  Ut.struct([Ut.publicKey("programdataAddress")], "program"),
  Ut.struct([
    Ut.u64("slot"),
    Ut.option(Ut.publicKey(), "upgradeAuthorityAddress")
  ], "programData")
], void 0, Ut.u32());
function zee(e) {
  return "accounts" in e;
}
async function Fee(e) {
  const t = (await Ae.findProgramAddress([], e))[0];
  return await Ae.createWithSeed(t, Lee(), e);
}
function Lee() {
  return "anchor:idl";
}
const $ee = Ut.struct([
  Ut.publicKey("authority"),
  Ut.vecU8("data")
]);
function Wee(e) {
  return $ee.decode(e);
}
function I_(e, t) {
  var n, r;
  let i = {};
  const o = e.args ? e.args.length : 0;
  if (t.length > o) {
    if (t.length !== o + 1)
      throw new Error(`provided too many arguments ${t} to instruction ${e == null ? void 0 : e.name} expecting: ${(r = (n = e.args) === null || n === void 0 ? void 0 : n.map((a) => a.name)) !== null && r !== void 0 ? r : []}`);
    i = t.pop();
  }
  return [t, i];
}
class Qb {
  static build(t, n, r) {
    if (t.name === "_inner")
      throw new Jb("the _inner name is reserved");
    const i = (...o) => {
      const [a, s] = I_(t, [...o]);
      o6(t.accounts, s.accounts), Kee(t, ...o);
      const c = i.accounts(s.accounts);
      return s.remainingAccounts !== void 0 && c.push(...s.remainingAccounts), u6("debug-logs") && console.log("Outgoing account metas:", c), new jn({
        keys: c,
        programId: r,
        data: n(t.name, HQ(t, ...a))
      });
    };
    return i.accounts = (o) => Qb.accountsArray(o, t.accounts, r, t.name), i;
  }
  static accountsArray(t, n, r, i) {
    return t ? n.map((o) => {
      if (("accounts" in o ? o.accounts : void 0) !== void 0) {
        const s = t[o.name];
        return Qb.accountsArray(s, o.accounts, r, i).flat();
      } else {
        const s = o;
        let c;
        try {
          c = uo(t[o.name]);
        } catch {
          throw new Error(`Wrong input type for account "${o.name}" in the instruction accounts object${i !== void 0 ? ' for instruction "' + i + '"' : ""}. Expected PublicKey or string.`);
        }
        const l = s.isOptional && c.equals(r), u = s.isMut && !l, f = s.isSigner && !l;
        return {
          pubkey: c,
          isWritable: u,
          isSigner: f
        };
      }
    }).flat() : [];
  }
}
function Kee(e, ...t) {
}
class Vee {
  static build(t, n) {
    return (...i) => {
      var o, a, s;
      const [, c] = I_(t, [...i]), l = new On();
      if (c.preInstructions && c.instructions)
        throw new Error("instructions is deprecated, use preInstructions");
      return (o = c.preInstructions) === null || o === void 0 || o.forEach((u) => l.add(u)), (a = c.instructions) === null || a === void 0 || a.forEach((u) => l.add(u)), l.add(n(...i)), (s = c.postInstructions) === null || s === void 0 || s.forEach((u) => l.add(u)), l;
    };
  }
}
class qee {
  static build(t, n, r, i) {
    return async (...a) => {
      var s;
      const c = n(...a), [, l] = I_(t, [...a]);
      if (i.sendAndConfirm === void 0)
        throw new Error("This function requires 'Provider.sendAndConfirm' to be implemented.");
      try {
        return await i.sendAndConfirm(c, (s = l.signers) !== null && s !== void 0 ? s : [], l.options);
      } catch (u) {
        throw l6(u, r);
      }
    };
  }
}
class Hee {
  static build(t, n, r, i) {
    var o;
    const a = {};
    return (o = t.accounts) === null || o === void 0 || o.forEach((s) => {
      const c = nr(s.name);
      a[c] = new Gee(t, s, r, i, n);
    }), a;
  }
}
class Gee {
  /**
   * Returns the number of bytes in this account.
   */
  get size() {
    return this._size;
  }
  /**
   * Returns the program ID owning all accounts.
   */
  get programId() {
    return this._programId;
  }
  /**
   * Returns the client's wallet and network provider.
   */
  get provider() {
    return this._provider;
  }
  /**
   * Returns the coder.
   */
  get coder() {
    return this._coder;
  }
  /**
   * Returns the idl account.
   */
  get idlAccount() {
    return this._idlAccount;
  }
  constructor(t, n, r, i, o) {
    this._idlAccount = n, this._programId = r, this._provider = i ?? BA(), this._coder = o ?? new d6(t), this._size = this._coder.accounts.size(n);
  }
  /**
   * Returns a deserialized account, returning null if it doesn't exist.
   *
   * @param address The address of the account to fetch.
   */
  async fetchNullable(t, n) {
    const { data: r } = await this.fetchNullableAndContext(t, n);
    return r;
  }
  /**
   * Returns a deserialized account along with the associated rpc response context, returning null if it doesn't exist.
   *
   * @param address The address of the account to fetch.
   */
  async fetchNullableAndContext(t, n) {
    const r = await this.getAccountInfoAndContext(t, n), { value: i, context: o } = r;
    return {
      data: i && i.data.length !== 0 ? this._coder.accounts.decode(this._idlAccount.name, i.data) : null,
      context: o
    };
  }
  /**
   * Returns a deserialized account.
   *
   * @param address The address of the account to fetch.
   */
  async fetch(t, n) {
    const { data: r } = await this.fetchNullableAndContext(t, n);
    if (r === null)
      throw new Error(`Account does not exist or has no data ${t.toString()}`);
    return r;
  }
  /**
   * Returns a deserialized account along with the associated rpc response context.
   *
   * @param address The address of the account to fetch.
   */
  async fetchAndContext(t, n) {
    const { data: r, context: i } = await this.fetchNullableAndContext(t, n);
    if (r === null)
      throw new Error(`Account does not exist ${t.toString()}`);
    return { data: r, context: i };
  }
  /**
   * Returns multiple deserialized accounts.
   * Accounts not found or with wrong discriminator are returned as null.
   *
   * @param addresses The addresses of the accounts to fetch.
   */
  async fetchMultiple(t, n) {
    return (await this.fetchMultipleAndContext(t, n)).map((i) => i ? i.data : null);
  }
  /**
   * Returns multiple deserialized accounts.
   * Accounts not found or with wrong discriminator are returned as null.
   *
   * @param addresses The addresses of the accounts to fetch.
   */
  async fetchMultipleAndContext(t, n) {
    return (await ree(this._provider.connection, t.map((i) => uo(i)), n)).map((i) => {
      if (i == null)
        return null;
      const { account: o, context: a } = i;
      return {
        data: this._coder.accounts.decode(this._idlAccount.name, o.data),
        context: a
      };
    });
  }
  /**
   * Returns all instances of this account type for the program.
   *
   * @param filters User-provided filters to narrow the results from `connection.getProgramAccounts`.
   *
   *                When filters are not defined this method returns all
   *                the account instances.
   *
   *                When filters are of type `Buffer`, the filters are appended
   *                after the discriminator.
   *
   *                When filters are of type `GetProgramAccountsFilter[]`,
   *                filters are appended after the discriminator filter.
   */
  async all(t) {
    const n = this.coder.accounts.memcmp(this._idlAccount.name, t instanceof Buffer ? t : void 0), r = [];
    return (n == null ? void 0 : n.offset) != null && (n == null ? void 0 : n.bytes) != null && r.push({
      memcmp: { offset: n.offset, bytes: n.bytes }
    }), (n == null ? void 0 : n.dataSize) != null && r.push({ dataSize: n.dataSize }), (await this._provider.connection.getProgramAccounts(this._programId, {
      commitment: this._provider.connection.commitment,
      filters: [...r, ...Array.isArray(t) ? t : []]
    })).map(({ pubkey: o, account: a }) => ({
      publicKey: o,
      account: this._coder.accounts.decode(this._idlAccount.name, a.data)
    }));
  }
  /**
   * Returns an `EventEmitter` emitting a "change" event whenever the account
   * changes.
   */
  subscribe(t, n) {
    const r = pf.get(t.toString());
    if (r)
      return r.ee;
    const i = new G3();
    t = uo(t);
    const o = this._provider.connection.onAccountChange(t, (a) => {
      const s = this._coder.accounts.decode(this._idlAccount.name, a.data);
      i.emit("change", s);
    }, n);
    return pf.set(t.toString(), {
      ee: i,
      listener: o
    }), i;
  }
  /**
   * Unsubscribes from the account at the given address.
   */
  async unsubscribe(t) {
    let n = pf.get(t.toString());
    if (!n) {
      console.warn("Address is not subscribed");
      return;
    }
    pf && await this._provider.connection.removeAccountChangeListener(n.listener).then(() => {
      pf.delete(t.toString());
    }).catch(console.error);
  }
  /**
   * Returns an instruction for creating this account.
   */
  async createInstruction(t, n) {
    const r = this.size;
    if (this._provider.publicKey === void 0)
      throw new Error("This function requires the Provider interface implementor to have a 'publicKey' field.");
    return Rr.createAccount({
      fromPubkey: this._provider.publicKey,
      newAccountPubkey: t.publicKey,
      space: n ?? r,
      lamports: await this._provider.connection.getMinimumBalanceForRentExemption(n ?? r),
      programId: this._programId
    });
  }
  /**
   * @deprecated since version 14.0.
   *
   * Function returning the associated account. Args are keys to associate.
   * Order matters.
   */
  async associated(...t) {
    const n = await this.associatedAddress(...t);
    return await this.fetch(n);
  }
  /**
   * @deprecated since version 14.0.
   *
   * Function returning the associated address. Args are keys to associate.
   * Order matters.
   */
  async associatedAddress(...t) {
    return await Nee(this._programId, ...t);
  }
  async getAccountInfo(t, n) {
    return await this._provider.connection.getAccountInfo(uo(t), n);
  }
  async getAccountInfoAndContext(t, n) {
    return await this._provider.connection.getAccountInfoAndContext(uo(t), n);
  }
}
const pf = /* @__PURE__ */ new Map(), NA = "Program log: ", w6 = "Program data: ", Yee = NA.length, Zee = w6.length;
class Jee {
  constructor(t, n, r) {
    this._programId = t, this._provider = n, this._eventParser = new v6(t, r), this._eventCallbacks = /* @__PURE__ */ new Map(), this._eventListeners = /* @__PURE__ */ new Map(), this._listenerIdCount = 0;
  }
  addEventListener(t, n) {
    var r;
    let i = this._listenerIdCount;
    return this._listenerIdCount += 1, this._eventListeners.has(t) || this._eventListeners.set(t, []), this._eventListeners.set(t, ((r = this._eventListeners.get(t)) !== null && r !== void 0 ? r : []).concat(i)), this._eventCallbacks.set(i, [t, n]), this._onLogsSubscriptionId !== void 0 || (this._onLogsSubscriptionId = this._provider.connection.onLogs(this._programId, (o, a) => {
      if (!o.err)
        for (const s of this._eventParser.parseLogs(o.logs)) {
          const c = this._eventListeners.get(s.name);
          c && c.forEach((l) => {
            const u = this._eventCallbacks.get(l);
            if (u) {
              const [, f] = u;
              f(s.data, a.slot, o.signature);
            }
          });
        }
    })), i;
  }
  async removeEventListener(t) {
    const n = this._eventCallbacks.get(t);
    if (!n)
      throw new Error(`Event listener ${t} doesn't exist!`);
    const [r] = n;
    let i = this._eventListeners.get(r);
    if (!i)
      throw new Error(`Event listeners don't exist for ${r}!`);
    this._eventCallbacks.delete(t), i = i.filter((o) => o !== t), this._eventListeners.set(r, i), i.length === 0 && this._eventListeners.delete(r), this._eventCallbacks.size == 0 && (OA.ok(this._eventListeners.size === 0), this._onLogsSubscriptionId !== void 0 && (await this._provider.connection.removeOnLogsListener(this._onLogsSubscriptionId), this._onLogsSubscriptionId = void 0));
  }
}
class v6 {
  constructor(t, n) {
    this.coder = n, this.programId = t;
  }
  // Each log given, represents an array of messages emitted by
  // a single transaction, which can execute many different programs across
  // CPI boundaries. However, the subscription is only interested in the
  // events emitted by *this* program. In achieving this, we keep track of the
  // program execution context by parsing each log and looking for a CPI
  // `invoke` call. If one exists, we know a new program is executing. So we
  // push the programId onto a stack and switch the program context. This
  // allows us to track, for a given log, which program was executing during
  // its emission, thereby allowing us to know if a given log event was
  // emitted by *this* program. If it was, then we parse the raw string and
  // emit the event if the string matches the event being subscribed to.
  *parseLogs(t, n = !1) {
    const r = new Qee(t), i = new Xee();
    let o = r.next();
    for (; o !== null; ) {
      let [a, s, c] = this.handleLog(i, o, n);
      a && (yield a), s && i.push(s), c && i.pop(), o = r.next();
    }
  }
  // Main log handler. Returns a three element array of the event, the
  // next program that was invoked for CPI, and a boolean indicating if
  // a program has completed execution (and thus should be popped off the
  // execution stack).
  handleLog(t, n, r) {
    return t.stack.length > 0 && t.program() === this.programId.toString() ? this.handleProgramLog(n, r) : [null, ...this.handleSystemLog(n)];
  }
  // Handles logs from *this* program.
  handleProgramLog(t, n) {
    if (t.startsWith(NA) || t.startsWith(w6)) {
      const r = t.startsWith(NA) ? t.slice(Yee) : t.slice(Zee), i = this.coder.events.decode(r);
      if (n && i === null)
        throw new Error(`Unable to decode event ${r}`);
      return [i, null, !1];
    } else
      return [null, ...this.handleSystemLog(t)];
  }
  // Handles logs when the current program being executing is *not* this.
  handleSystemLog(t) {
    const n = t.split(":")[0];
    return n.match(/^Program (.*) success/g) !== null ? [null, !0] : n.startsWith(`Program ${this.programId.toString()} invoke`) ? [this.programId.toString(), !1] : n.includes("invoke") ? ["cpi", !1] : [null, !1];
  }
}
class Xee {
  constructor() {
    this.stack = [];
  }
  program() {
    return OA.ok(this.stack.length > 0), this.stack[this.stack.length - 1];
  }
  push(t) {
    this.stack.push(t);
  }
  pop() {
    OA.ok(this.stack.length > 0), this.stack.pop();
  }
}
class Qee {
  constructor(t) {
    this.logs = t;
  }
  next() {
    if (this.logs.length === 0)
      return null;
    let t = this.logs[0];
    return this.logs = this.logs.slice(1), t;
  }
}
class ete {
  static build(t, n, r, i, o, a, s) {
    return async (...l) => {
      var u;
      const f = n(...l), [, d] = I_(t, [...l]);
      let h;
      if (i.simulate === void 0)
        throw new Error("This function requires 'Provider.simulate' to be implemented.");
      try {
        h = await i.simulate(f, d.signers, (u = d.options) === null || u === void 0 ? void 0 : u.commitment);
      } catch (b) {
        throw l6(b, r);
      }
      if (h === void 0)
        throw new Error("Unable to simulate transaction");
      const g = h.logs;
      if (!g)
        throw new Error("Simulated logs not found");
      const w = [];
      if (s.events) {
        let b = new v6(a, o);
        for (const I of b.parseLogs(g))
          w.push(I);
      }
      return { events: w, raw: g };
    };
  }
}
function eS(e) {
  return new S6(qd(8), (t) => nte.fromBuffer(t), (t) => t.toBuffer(), e);
}
function Mg(e) {
  return new S6(qd(32), (t) => new Ae(t), (t) => t.toBuffer(), e);
}
function tS(e, t) {
  return new tte(e, t);
}
class S6 extends S_ {
  constructor(t, n, r, i) {
    super(t.span, i), this.layout = t, this.decoder = n, this.encoder = r;
  }
  decode(t, n) {
    return this.decoder(this.layout.decode(t, n));
  }
  encode(t, n, r) {
    return this.layout.encode(this.encoder(t), n, r);
  }
  getSpan(t, n) {
    return this.layout.getSpan(t, n);
  }
}
class tte extends S_ {
  constructor(t, n) {
    super(-1, n), this.layout = t, this.discriminator = ja();
  }
  encode(t, n, r = 0) {
    return t == null ? this.layout.span + this.discriminator.encode(0, n, r) : (this.discriminator.encode(1, n, r), this.layout.encode(t, n, r + 4) + 4);
  }
  decode(t, n = 0) {
    const r = this.discriminator.decode(t, n);
    if (r === 0)
      return null;
    if (r === 1)
      return this.layout.decode(t, n + 4);
    throw new Error("Invalid coption " + this.layout.property);
  }
  getSpan(t, n = 0) {
    return this.layout.getSpan(t, n + 4) + 4;
  }
}
let nte = class E6 extends il {
  /**
   * Convert to Buffer representation
   */
  toBuffer() {
    const t = super.toArray().reverse(), n = Buffer.from(t);
    if (n.length === 8)
      return n;
    if (n.length >= 8)
      throw new Error("u64 too large");
    const r = Buffer.alloc(8);
    return n.copy(r), r;
  }
  /**
   * Construct a u64 from Buffer representation
   */
  static fromBuffer(t) {
    if (t.length !== 8)
      throw new Error(`Invalid buffer length: ${t.length}`);
    return new E6([...t].reverse().map((n) => `00${n.toString(16)}`.slice(-2)).join(""), 16);
  }
};
const rte = Nr([
  Mg("mint"),
  Mg("owner"),
  eS("amount"),
  tS(Mg(), "delegate"),
  ((e) => {
    const t = _6(Bee("discriminator"), null, e);
    return t.addVariant(0, Nr([]), "uninitialized"), t.addVariant(1, Nr([]), "initialized"), t.addVariant(2, Nr([]), "frozen"), t;
  })("state"),
  tS(eS(), "isNative"),
  eS("delegatedAmount"),
  tS(Mg(), "closeAuthority")
]);
function ite(e) {
  return rte.decode(e);
}
class gd {
  constructor(t, n, r, i, o, a, s, c) {
    this._accounts = n, this._provider = r, this._programId = i, this._idlIx = o, this._idlTypes = s, this._customResolver = c, this._args = t, this._accountStore = new ote(r, a, this._programId);
  }
  args(t) {
    this._args = t;
  }
  // Note: We serially resolve PDAs one by one rather than doing them
  //       in parallel because there can be dependencies between
  //       addresses. That is, one PDA can be used as a seed in another.
  async resolve() {
    for (await this.resolveConst(this._idlIx.accounts), this._resolveEventCpi(this._idlIx.accounts); await this.resolvePdas(this._idlIx.accounts) + await this.resolveRelations(this._idlIx.accounts) + await this.resolveCustom() > 0; )
      ;
  }
  async resolveCustom() {
    if (this._customResolver) {
      const { accounts: t, resolved: n } = await this._customResolver({
        args: this._args,
        accounts: this._accounts,
        provider: this._provider,
        programId: this._programId,
        idlIx: this._idlIx
      });
      return this._accounts = t, n;
    }
    return 0;
  }
  resolveOptionalsHelper(t, n) {
    const r = {};
    for (const i of n) {
      const o = i.name, a = t[o];
      a !== void 0 && (A6(a) ? zee(i) ? r[o] = this.resolveOptionalsHelper(a, i.accounts) : r[o] = I6(a, !0) : a !== null ? r[o] = uo(a) : i.isOptional && (r[o] = this._programId));
    }
    return r;
  }
  resolveOptionals(t) {
    Object.assign(this._accounts, this.resolveOptionalsHelper(t, this._idlIx.accounts));
  }
  get(t) {
    const n = t.reduce((r, i) => r && r[i], this._accounts);
    if (n && n.toBase58)
      return n;
  }
  set(t, n) {
    let r = this._accounts;
    t.forEach((i, o) => {
      o == t.length - 1 && (r[i] = n), r[i] = r[i] || {}, r = r[i];
    });
  }
  async resolveConst(t, n = []) {
    for (let r = 0; r < t.length; r += 1) {
      const i = t[r], o = i.accounts;
      o && await this.resolveConst(o, [
        ...n,
        nr(i.name)
      ]);
      const a = i, s = nr(i.name);
      if (a.isSigner && !this.get([...n, s])) {
        if (this._provider.wallet === void 0)
          throw new Error("This function requires the Provider interface implementor to have a 'wallet' field.");
        this.set([...n, s], this._provider.wallet.publicKey);
      }
      Reflect.has(gd.CONST_ACCOUNTS, s) && !this.get([...n, s]) && this.set([...n, s], gd.CONST_ACCOUNTS[s]);
    }
  }
  /**
   * Resolve event CPI accounts `eventAuthority` and `program`.
   *
   * Accounts will only be resolved if they are declared next to each other to
   * reduce the chance of name collision.
   */
  _resolveEventCpi(t, n = []) {
    for (const r in t) {
      const i = t[r], o = i.accounts;
      o && this._resolveEventCpi(o, [
        ...n,
        nr(i.name)
      ]);
      const a = +r + 1;
      if (a === t.length)
        return;
      const s = nr(t[r].name), c = nr(t[a].name);
      if (s === "eventAuthority" && c === "program") {
        const l = [...n, s], u = [...n, c];
        this.get(l) || this.set(l, Ae.findProgramAddressSync([Buffer.from("__event_authority")], this._programId)[0]), this.get(u) || this.set(u, this._programId);
        return;
      }
    }
  }
  async resolvePdas(t, n = []) {
    let r = 0;
    for (let i = 0; i < t.length; i += 1) {
      const o = t[i], a = o.accounts;
      a && (r += await this.resolvePdas(a, [
        ...n,
        nr(o.name)
      ]));
      const s = o, c = nr(o.name);
      s.pda && s.pda.seeds.length > 0 && !this.get([...n, c]) && await this.autoPopulatePda(s, n) && (r += 1);
    }
    return r;
  }
  async resolveRelations(t, n = []) {
    let r = 0;
    for (let i = 0; i < t.length; i += 1) {
      const o = t[i], a = o.accounts;
      a && (r += await this.resolveRelations(a, [
        ...n,
        nr(o.name)
      ]));
      const s = o.relations || [], c = nr(o.name), l = [...n, c], u = this.get(l);
      if (u) {
        const f = s.filter((d) => !this.get([...n, nr(d)]));
        if (r += f.length, f.length > 0) {
          const d = await this._accountStore.fetchAccount({
            publicKey: u
          });
          await Promise.all(f.map(async (h) => {
            const g = nr(h);
            return this.set([...n, g], d[g]), d[g];
          }));
        }
      }
    }
    return r;
  }
  async autoPopulatePda(t, n = []) {
    if (!t.pda || !t.pda.seeds)
      throw new Error("Must have seeds");
    const r = await Promise.all(t.pda.seeds.map((a) => this.toBuffer(a, n)));
    if (r.some((a) => typeof a > "u"))
      return;
    const i = await this.parseProgramId(t, n);
    if (!i)
      return;
    const [o] = await Ae.findProgramAddress(r, i);
    this.set([...n, nr(t.name)], o);
  }
  async parseProgramId(t, n = []) {
    var r;
    if (!(!((r = t.pda) === null || r === void 0) && r.programId))
      return this._programId;
    switch (t.pda.programId.kind) {
      case "const":
        return new Ae(this.toBufferConst(t.pda.programId.value));
      case "arg":
        return this.argValue(t.pda.programId);
      case "account":
        return await this.accountValue(t.pda.programId, n);
      default:
        throw new Error(`Unexpected program seed kind: ${t.pda.programId.kind}`);
    }
  }
  async toBuffer(t, n = []) {
    switch (t.kind) {
      case "const":
        return this.toBufferConst(t);
      case "arg":
        return await this.toBufferArg(t);
      case "account":
        return await this.toBufferAccount(t, n);
      default:
        throw new Error(`Unexpected seed kind: ${t.kind}`);
    }
  }
  /**
   * Recursively get the type at some path of either a primitive or a user defined struct.
   */
  getType(t, n = []) {
    if (n.length > 0 && t.defined) {
      const r = this._idlTypes.find((a) => a.name === t.defined);
      if (!r)
        throw new Error(`Cannot find type ${t.defined}`);
      const o = r.type.fields.find((a) => a.name === n[0]);
      return this.getType(o.type, n.slice(1));
    }
    return t;
  }
  toBufferConst(t) {
    return this.toBufferValue(this.getType(t.type, (t.path || "").split(".").slice(1)), t.value);
  }
  async toBufferArg(t) {
    const n = this.argValue(t);
    if (!(typeof n > "u"))
      return this.toBufferValue(this.getType(t.type, (t.path || "").split(".").slice(1)), n);
  }
  argValue(t) {
    const n = t.path.split("."), r = nr(n[0]), i = this._idlIx.args.findIndex((o) => o.name === r);
    if (i === -1)
      throw new Error(`Unable to find argument for seed: ${r}`);
    return n.slice(1).reduce((o, a) => (o || {})[a], this._args[i]);
  }
  async toBufferAccount(t, n = []) {
    const r = await this.accountValue(t, n);
    if (r)
      return this.toBufferValue(t.type, r);
  }
  async accountValue(t, n = []) {
    const r = t.path.split("."), i = r[0], o = this.get([...n, nr(i)]);
    if (o === null)
      throw new Error("fieldPubkey is null");
    if (r.length === 1)
      return o;
    const a = await this._accountStore.fetchAccount({
      publicKey: o,
      name: t.account
    });
    return this.parseAccountValue(a, r.slice(1));
  }
  parseAccountValue(t, n) {
    let r;
    for (; n.length > 0; )
      r = t[nr(n[0])], n = n.slice(1);
    return r;
  }
  // Converts the given idl valaue into a Buffer. The values here must be
  // primitives. E.g. no structs.
  //
  // TODO: add more types here as needed.
  toBufferValue(t, n) {
    switch (t) {
      case "u8":
        return Buffer.from([n]);
      case "u16":
        let r = Buffer.alloc(2);
        return r.writeUInt16LE(n), r;
      case "u32":
        let i = Buffer.alloc(4);
        return i.writeUInt32LE(n), i;
      case "u64":
        let o = Buffer.alloc(8);
        return o.writeBigUInt64LE(BigInt(n)), o;
      case "string":
        return Buffer.from(KQ(n));
      case "publicKey":
        return n.toBuffer();
      default:
        if (t.array)
          return Buffer.from(n);
        throw new Error(`Unexpected seed type: ${t}`);
    }
  }
}
gd.CONST_ACCOUNTS = {
  associatedTokenProgram: Uee,
  rent: Cc,
  systemProgram: Rr.programId,
  tokenProgram: jee,
  clock: Io
};
class ote {
  // todo: don't use the progrma use the account namespace.
  constructor(t, n, r) {
    this._provider = t, this._programId = r, this._cache = /* @__PURE__ */ new Map(), this._idls = {}, this._idls[r.toBase58()] = n;
  }
  async ensureIdl(t) {
    if (!this._idls[t.toBase58()]) {
      const n = await vl.fetchIdl(t, this._provider);
      if (n) {
        const r = new vl(n, t, this._provider);
        this._idls[t.toBase58()] = r.account;
      }
    }
    return this._idls[t.toBase58()];
  }
  async fetchAccount({ publicKey: t, name: n, programId: r = this._programId }) {
    const i = t.toString();
    if (!this._cache.has(i))
      if (n === "TokenAccount") {
        const o = await this._provider.connection.getAccountInfo(t);
        if (o === null)
          throw new Error(`invalid account info for ${i}`);
        const a = ite(o.data);
        this._cache.set(i, a);
      } else if (n) {
        const o = await this.ensureIdl(r);
        if (o) {
          const a = o[nr(n)];
          if (a) {
            const s = await a.fetch(t);
            this._cache.set(i, s);
          }
        }
      } else {
        const o = await this._provider.connection.getAccountInfo(t);
        if (o === null)
          throw new Error(`invalid account info for ${i}`);
        const a = o.data, s = await this.ensureIdl(o.owner);
        if (s) {
          const c = Object.values(s)[0];
          if (!c)
            throw new Error("No accounts for this program");
          const l = c.coder.accounts.decodeAny(a);
          this._cache.set(i, l);
        }
      }
    return this._cache.get(i);
  }
}
class ate {
  static build(t, n, r, i, o, a, s, c, l, u, f) {
    return (...d) => new ste(d, i, o, a, s, c, t, n, r, l, u, f);
  }
}
function A6(e) {
  return typeof e == "object" && e !== null && !("_bn" in e);
}
function I6(e, t) {
  const n = {};
  for (const r in e) {
    const i = e[r];
    if (i === null) {
      if (t)
        throw new Error("Failed to resolve optionals due to IDL type mismatch with input accounts!");
      continue;
    }
    n[r] = A6(i) ? I6(i, !0) : uo(i);
  }
  return n;
}
class ste {
  constructor(t, n, r, i, o, a, s, c, l, u, f, d) {
    this._ixFn = n, this._txFn = r, this._rpcFn = i, this._simulateFn = o, this._viewFn = a, this._programId = c, this._accounts = {}, this._remainingAccounts = [], this._signers = [], this._preInstructions = [], this._postInstructions = [], this._autoResolveAccounts = !0, this._args = t, this._accountsResolver = new gd(t, this._accounts, s, c, l, u, f, d);
  }
  args(t) {
    this._args = t, this._accountsResolver.args(t);
  }
  async pubkeys() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._accounts;
  }
  accounts(t) {
    return this._autoResolveAccounts = !0, this._accountsResolver.resolveOptionals(t), this;
  }
  accountsStrict(t) {
    return this._autoResolveAccounts = !1, this._accountsResolver.resolveOptionals(t), this;
  }
  signers(t) {
    return this._signers = this._signers.concat(t), this;
  }
  remainingAccounts(t) {
    return this._remainingAccounts = this._remainingAccounts.concat(t), this;
  }
  preInstructions(t) {
    return this._preInstructions = this._preInstructions.concat(t), this;
  }
  postInstructions(t) {
    return this._postInstructions = this._postInstructions.concat(t), this;
  }
  async rpc(t) {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._rpcFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions,
      options: t
    });
  }
  async rpcAndKeys(t) {
    return {
      pubkeys: await this.pubkeys(),
      signature: await this.rpc(t)
    };
  }
  async view(t) {
    if (this._autoResolveAccounts && await this._accountsResolver.resolve(), !this._viewFn)
      throw new Error("Method does not support views");
    return this._viewFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions,
      options: t
    });
  }
  async simulate(t) {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._simulateFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions,
      options: t
    });
  }
  async instruction() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._ixFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions
    });
  }
  /**
   * Convenient shortcut to get instructions and pubkeys via
   * const { pubkeys, instructions } = await prepare();
   */
  async prepare() {
    return {
      instruction: await this.instruction(),
      pubkeys: await this.pubkeys(),
      signers: await this._signers
    };
  }
  async transaction() {
    return this._autoResolveAccounts && await this._accountsResolver.resolve(), this._txFn(...this._args, {
      accounts: this._accounts,
      signers: this._signers,
      remainingAccounts: this._remainingAccounts,
      preInstructions: this._preInstructions,
      postInstructions: this._postInstructions
    });
  }
}
class cte {
  static build(t, n, r, i) {
    const o = n.accounts.find((c) => c.isMut), a = !!n.returns;
    return o || !a ? void 0 : async (...c) => {
      var l, u;
      let f = await r(...c);
      const d = `Program return: ${t} `;
      let h = f.raw.find((I) => I.startsWith(d));
      if (!h)
        throw new Error("View expected return log");
      let g = VQ(h.slice(d.length)), w = n.returns;
      if (!w)
        throw new Error("View expected return type");
      return Ni.fieldLayout({ type: w }, Array.from([...(l = i.accounts) !== null && l !== void 0 ? l : [], ...(u = i.types) !== null && u !== void 0 ? u : []])).decode(g);
    };
  }
}
class ute {
  /**
   * Generates all namespaces for a given program.
   */
  static build(t, n, r, i, o) {
    const a = {}, s = {}, c = {}, l = {}, u = {}, f = {}, d = qQ(t), h = t.accounts ? Hee.build(t, n, r, i) : {};
    return t.instructions.forEach((g) => {
      const w = Qb.build(g, (K, W) => n.instruction.encode(K, W), r), b = Vee.build(g, w), I = qee.build(g, b, d, i), A = ete.build(g, b, d, i, n, r, t), x = cte.build(r, g, A, t), N = ate.build(i, r, g, w, b, I, A, x, h, t.types || [], o && o(g)), j = nr(g.name);
      s[j] = w, c[j] = b, a[j] = I, l[j] = A, u[j] = N, x && (f[j] = x);
    }), [
      a,
      s,
      c,
      h,
      l,
      u,
      f
    ];
  }
}
class vl {
  /**
   * Address of the program.
   */
  get programId() {
    return this._programId;
  }
  /**
   * IDL defining the program's interface.
   */
  get idl() {
    return this._idl;
  }
  /**
   * Coder for serializing requests.
   */
  get coder() {
    return this._coder;
  }
  /**
   * Wallet and network provider.
   */
  get provider() {
    return this._provider;
  }
  /**
   * @param idl       The interface definition.
   * @param programId The on-chain address of the program.
   * @param provider  The network and wallet context to use. If not provided
   *                  then uses [[getProvider]].
   * @param getCustomResolver A function that returns a custom account resolver
   *                          for the given instruction. This is useful for resolving
   *                          public keys of missing accounts when building instructions
   */
  constructor(t, n, r, i, o) {
    n = uo(n), r || (r = BA()), this._idl = t, this._provider = r, this._programId = n, this._coder = i ?? new d6(t), this._events = new Jee(this._programId, r, this._coder);
    const [a, s, c, l, u, f, d] = ute.build(t, this._coder, n, r, o ?? (() => {
    }));
    this.rpc = a, this.instruction = s, this.transaction = c, this.account = l, this.simulate = u, this.methods = f, this.views = d;
  }
  /**
   * Generates a Program client by fetching the IDL from the network.
   *
   * In order to use this method, an IDL must have been previously initialized
   * via the anchor CLI's `anchor idl init` command.
   *
   * @param programId The on-chain address of the program.
   * @param provider  The network and wallet context.
   */
  static async at(t, n) {
    const r = uo(t), i = await vl.fetchIdl(r, n);
    if (!i)
      throw new Error(`IDL not found for program: ${t.toString()}`);
    return new vl(i, r, n);
  }
  /**
   * Fetches an idl from the blockchain.
   *
   * In order to use this method, an IDL must have been previously initialized
   * via the anchor CLI's `anchor idl init` command.
   *
   * @param programId The on-chain address of the program.
   * @param provider  The network and wallet context.
   */
  static async fetchIdl(t, n) {
    n = n ?? BA();
    const r = uo(t), i = await Fee(r), o = await n.connection.getAccountInfo(i);
    if (!o)
      return null;
    let a = Wee(o.data.slice(8));
    const s = zX(a.data);
    return JSON.parse(WQ(s));
  }
  /**
   * Invokes the given callback every time the given event is emitted.
   *
   * @param eventName The PascalCase name of the event, provided by the IDL.
   * @param callback  The function to invoke whenever the event is emitted from
   *                  program logs.
   */
  addEventListener(t, n) {
    return this._events.addEventListener(t, n);
  }
  /**
   * Unsubscribes from the given eventName.
   */
  async removeEventListener(t) {
    return await this._events.removeEventListener(t);
  }
}
new Ae("11111111111111111111111111111111");
const lte = new Ae("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
new Ae("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
new Ae("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
new Ae("So11111111111111111111111111111111111111112");
new Ae("9pan9bMn5HatX4EJdBwg9VgCa7Uz5HL8N1m5D3NdXejP");
const Hl = (e) => {
  const t = e.decode.bind(e), n = e.encode.bind(e);
  return { decode: t, encode: n };
}, Hd = (e) => (t) => {
  const n = Nn(e, t), { encode: r, decode: i } = Hl(n), o = n;
  return o.decode = (a, s) => {
    const c = i(a, s);
    return jD(Buffer.from(c));
  }, o.encode = (a, s, c) => {
    const l = vk(a, e);
    return r(l, s, c);
  }, o;
}, Gd = (e) => (t) => {
  const n = Nn(e, t), { encode: r, decode: i } = Hl(n), o = n;
  return o.decode = (a, s) => {
    const c = i(a, s);
    return Sq(Buffer.from(c));
  }, o.encode = (a, s, c) => {
    const l = Iq(a, e);
    return r(l, s, c);
  }, o;
}, pb = Hd(8), fte = Gd(8), k6 = Hd(16), dte = Gd(16), hte = Hd(24), pte = Gd(24), yte = Hd(32), gte = Gd(32);
var bte = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, nS = Math.ceil, Qo = Math.floor, mi = "[BigNumber Error] ", zO = mi + "Number primitive has more than 15 significant digits: ", wo = 1e14, jt = 14, rS = 9007199254740991, iS = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], cs = 1e7, jr = 1e9;
function T6(e) {
  var t, n, r, i = A.prototype = { constructor: A, toString: null, valueOf: null }, o = new A(1), a = 20, s = 4, c = -7, l = 21, u = -1e7, f = 1e7, d = !1, h = 1, g = 0, w = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, b = "0123456789abcdefghijklmnopqrstuvwxyz", I = !0;
  function A(O, k) {
    var z, C, M, S, p, y, v, E, B = this;
    if (!(B instanceof A))
      return new A(O, k);
    if (k == null) {
      if (O && O._isBigNumber === !0) {
        B.s = O.s, !O.c || O.e > f ? B.c = B.e = null : O.e < u ? B.c = [B.e = 0] : (B.e = O.e, B.c = O.c.slice());
        return;
      }
      if ((y = typeof O == "number") && O * 0 == 0) {
        if (B.s = 1 / O < 0 ? (O = -O, -1) : 1, O === ~~O) {
          for (S = 0, p = O; p >= 10; p /= 10, S++)
            ;
          S > f ? B.c = B.e = null : (B.e = S, B.c = [O]);
          return;
        }
        E = String(O);
      } else {
        if (!bte.test(E = String(O)))
          return r(B, E, y);
        B.s = E.charCodeAt(0) == 45 ? (E = E.slice(1), -1) : 1;
      }
      (S = E.indexOf(".")) > -1 && (E = E.replace(".", "")), (p = E.search(/e/i)) > 0 ? (S < 0 && (S = p), S += +E.slice(p + 1), E = E.substring(0, p)) : S < 0 && (S = E.length);
    } else {
      if (ur(k, 2, b.length, "Base"), k == 10 && I)
        return B = new A(O), K(B, a + B.e + 1, s);
      if (E = String(O), y = typeof O == "number") {
        if (O * 0 != 0)
          return r(B, E, y, k);
        if (B.s = 1 / O < 0 ? (E = E.slice(1), -1) : 1, A.DEBUG && E.replace(/^0\.0*|\./, "").length > 15)
          throw Error(zO + O);
      } else
        B.s = E.charCodeAt(0) === 45 ? (E = E.slice(1), -1) : 1;
      for (z = b.slice(0, k), S = p = 0, v = E.length; p < v; p++)
        if (z.indexOf(C = E.charAt(p)) < 0) {
          if (C == ".") {
            if (p > S) {
              S = v;
              continue;
            }
          } else if (!M && (E == E.toUpperCase() && (E = E.toLowerCase()) || E == E.toLowerCase() && (E = E.toUpperCase()))) {
            M = !0, p = -1, S = 0;
            continue;
          }
          return r(B, String(O), y, k);
        }
      y = !1, E = n(E, k, 10, B.s), (S = E.indexOf(".")) > -1 ? E = E.replace(".", "") : S = E.length;
    }
    for (p = 0; E.charCodeAt(p) === 48; p++)
      ;
    for (v = E.length; E.charCodeAt(--v) === 48; )
      ;
    if (E = E.slice(p, ++v)) {
      if (v -= p, y && A.DEBUG && v > 15 && (O > rS || O !== Qo(O)))
        throw Error(zO + B.s * O);
      if ((S = S - p - 1) > f)
        B.c = B.e = null;
      else if (S < u)
        B.c = [B.e = 0];
      else {
        if (B.e = S, B.c = [], p = (S + 1) % jt, S < 0 && (p += jt), p < v) {
          for (p && B.c.push(+E.slice(0, p)), v -= jt; p < v; )
            B.c.push(+E.slice(p, p += jt));
          p = jt - (E = E.slice(p)).length;
        } else
          p -= v;
        for (; p--; E += "0")
          ;
        B.c.push(+E);
      }
    } else
      B.c = [B.e = 0];
  }
  A.clone = T6, A.ROUND_UP = 0, A.ROUND_DOWN = 1, A.ROUND_CEIL = 2, A.ROUND_FLOOR = 3, A.ROUND_HALF_UP = 4, A.ROUND_HALF_DOWN = 5, A.ROUND_HALF_EVEN = 6, A.ROUND_HALF_CEIL = 7, A.ROUND_HALF_FLOOR = 8, A.EUCLID = 9, A.config = A.set = function(O) {
    var k, z;
    if (O != null)
      if (typeof O == "object") {
        if (O.hasOwnProperty(k = "DECIMAL_PLACES") && (z = O[k], ur(z, 0, jr, k), a = z), O.hasOwnProperty(k = "ROUNDING_MODE") && (z = O[k], ur(z, 0, 8, k), s = z), O.hasOwnProperty(k = "EXPONENTIAL_AT") && (z = O[k], z && z.pop ? (ur(z[0], -jr, 0, k), ur(z[1], 0, jr, k), c = z[0], l = z[1]) : (ur(z, -jr, jr, k), c = -(l = z < 0 ? -z : z))), O.hasOwnProperty(k = "RANGE"))
          if (z = O[k], z && z.pop)
            ur(z[0], -jr, -1, k), ur(z[1], 1, jr, k), u = z[0], f = z[1];
          else if (ur(z, -jr, jr, k), z)
            u = -(f = z < 0 ? -z : z);
          else
            throw Error(mi + k + " cannot be zero: " + z);
        if (O.hasOwnProperty(k = "CRYPTO"))
          if (z = O[k], z === !!z)
            if (z)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                d = z;
              else
                throw d = !z, Error(mi + "crypto unavailable");
            else
              d = z;
          else
            throw Error(mi + k + " not true or false: " + z);
        if (O.hasOwnProperty(k = "MODULO_MODE") && (z = O[k], ur(z, 0, 9, k), h = z), O.hasOwnProperty(k = "POW_PRECISION") && (z = O[k], ur(z, 0, jr, k), g = z), O.hasOwnProperty(k = "FORMAT"))
          if (z = O[k], typeof z == "object")
            w = z;
          else
            throw Error(mi + k + " not an object: " + z);
        if (O.hasOwnProperty(k = "ALPHABET"))
          if (z = O[k], typeof z == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(z))
            I = z.slice(0, 10) == "0123456789", b = z;
          else
            throw Error(mi + k + " invalid: " + z);
      } else
        throw Error(mi + "Object expected: " + O);
    return {
      DECIMAL_PLACES: a,
      ROUNDING_MODE: s,
      EXPONENTIAL_AT: [c, l],
      RANGE: [u, f],
      CRYPTO: d,
      MODULO_MODE: h,
      POW_PRECISION: g,
      FORMAT: w,
      ALPHABET: b
    };
  }, A.isBigNumber = function(O) {
    if (!O || O._isBigNumber !== !0)
      return !1;
    if (!A.DEBUG)
      return !0;
    var k, z, C = O.c, M = O.e, S = O.s;
    e:
      if ({}.toString.call(C) == "[object Array]") {
        if ((S === 1 || S === -1) && M >= -jr && M <= jr && M === Qo(M)) {
          if (C[0] === 0) {
            if (M === 0 && C.length === 1)
              return !0;
            break e;
          }
          if (k = (M + 1) % jt, k < 1 && (k += jt), String(C[0]).length == k) {
            for (k = 0; k < C.length; k++)
              if (z = C[k], z < 0 || z >= wo || z !== Qo(z))
                break e;
            if (z !== 0)
              return !0;
          }
        }
      } else if (C === null && M === null && (S === null || S === 1 || S === -1))
        return !0;
    throw Error(mi + "Invalid BigNumber: " + O);
  }, A.maximum = A.max = function() {
    return N(arguments, i.lt);
  }, A.minimum = A.min = function() {
    return N(arguments, i.gt);
  }, A.random = function() {
    var O = 9007199254740992, k = Math.random() * O & 2097151 ? function() {
      return Qo(Math.random() * O);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(z) {
      var C, M, S, p, y, v = 0, E = [], B = new A(o);
      if (z == null ? z = a : ur(z, 0, jr), p = nS(z / jt), d)
        if (crypto.getRandomValues) {
          for (C = crypto.getRandomValues(new Uint32Array(p *= 2)); v < p; )
            y = C[v] * 131072 + (C[v + 1] >>> 11), y >= 9e15 ? (M = crypto.getRandomValues(new Uint32Array(2)), C[v] = M[0], C[v + 1] = M[1]) : (E.push(y % 1e14), v += 2);
          v = p / 2;
        } else if (crypto.randomBytes) {
          for (C = crypto.randomBytes(p *= 7); v < p; )
            y = (C[v] & 31) * 281474976710656 + C[v + 1] * 1099511627776 + C[v + 2] * 4294967296 + C[v + 3] * 16777216 + (C[v + 4] << 16) + (C[v + 5] << 8) + C[v + 6], y >= 9e15 ? crypto.randomBytes(7).copy(C, v) : (E.push(y % 1e14), v += 7);
          v = p / 7;
        } else
          throw d = !1, Error(mi + "crypto unavailable");
      if (!d)
        for (; v < p; )
          y = k(), y < 9e15 && (E[v++] = y % 1e14);
      for (p = E[--v], z %= jt, p && z && (y = iS[jt - z], E[v] = Qo(p / y) * y); E[v] === 0; E.pop(), v--)
        ;
      if (v < 0)
        E = [S = 0];
      else {
        for (S = -1; E[0] === 0; E.splice(0, 1), S -= jt)
          ;
        for (v = 1, y = E[0]; y >= 10; y /= 10, v++)
          ;
        v < jt && (S -= jt - v);
      }
      return B.e = S, B.c = E, B;
    };
  }(), A.sum = function() {
    for (var O = 1, k = arguments, z = new A(k[0]); O < k.length; )
      z = z.plus(k[O++]);
    return z;
  }, n = function() {
    var O = "0123456789";
    function k(z, C, M, S) {
      for (var p, y = [0], v, E = 0, B = z.length; E < B; ) {
        for (v = y.length; v--; y[v] *= C)
          ;
        for (y[0] += S.indexOf(z.charAt(E++)), p = 0; p < y.length; p++)
          y[p] > M - 1 && (y[p + 1] == null && (y[p + 1] = 0), y[p + 1] += y[p] / M | 0, y[p] %= M);
      }
      return y.reverse();
    }
    return function(z, C, M, S, p) {
      var y, v, E, B, F, q, U, m, D = z.indexOf("."), Y = a, Q = s;
      for (D >= 0 && (B = g, g = 0, z = z.replace(".", ""), m = new A(C), q = m.pow(z.length - D), g = B, m.c = k(
        Aa(Xi(q.c), q.e, "0"),
        10,
        M,
        O
      ), m.e = m.c.length), U = k(z, C, M, p ? (y = b, O) : (y = O, b)), E = B = U.length; U[--B] == 0; U.pop())
        ;
      if (!U[0])
        return y.charAt(0);
      if (D < 0 ? --E : (q.c = U, q.e = E, q.s = S, q = t(q, m, Y, Q, M), U = q.c, F = q.r, E = q.e), v = E + Y + 1, D = U[v], B = M / 2, F = F || v < 0 || U[v + 1] != null, F = Q < 4 ? (D != null || F) && (Q == 0 || Q == (q.s < 0 ? 3 : 2)) : D > B || D == B && (Q == 4 || F || Q == 6 && U[v - 1] & 1 || Q == (q.s < 0 ? 8 : 7)), v < 1 || !U[0])
        z = F ? Aa(y.charAt(1), -Y, y.charAt(0)) : y.charAt(0);
      else {
        if (U.length = v, F)
          for (--M; ++U[--v] > M; )
            U[v] = 0, v || (++E, U = [1].concat(U));
        for (B = U.length; !U[--B]; )
          ;
        for (D = 0, z = ""; D <= B; z += y.charAt(U[D++]))
          ;
        z = Aa(z, E, y.charAt(0));
      }
      return z;
    };
  }(), t = function() {
    function O(C, M, S) {
      var p, y, v, E, B = 0, F = C.length, q = M % cs, U = M / cs | 0;
      for (C = C.slice(); F--; )
        v = C[F] % cs, E = C[F] / cs | 0, p = U * v + E * q, y = q * v + p % cs * cs + B, B = (y / S | 0) + (p / cs | 0) + U * E, C[F] = y % S;
      return B && (C = [B].concat(C)), C;
    }
    function k(C, M, S, p) {
      var y, v;
      if (S != p)
        v = S > p ? 1 : -1;
      else
        for (y = v = 0; y < S; y++)
          if (C[y] != M[y]) {
            v = C[y] > M[y] ? 1 : -1;
            break;
          }
      return v;
    }
    function z(C, M, S, p) {
      for (var y = 0; S--; )
        C[S] -= y, y = C[S] < M[S] ? 1 : 0, C[S] = y * p + C[S] - M[S];
      for (; !C[0] && C.length > 1; C.splice(0, 1))
        ;
    }
    return function(C, M, S, p, y) {
      var v, E, B, F, q, U, m, D, Y, Q, G, he, se, _e, Me, Pe, Be, at = C.s == M.s ? 1 : -1, Fe = C.c, Re = M.c;
      if (!Fe || !Fe[0] || !Re || !Re[0])
        return new A(
          // Return NaN if either NaN, or both Infinity or 0.
          !C.s || !M.s || (Fe ? Re && Fe[0] == Re[0] : !Re) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            Fe && Fe[0] == 0 || !Re ? at * 0 : at / 0
          )
        );
      for (D = new A(at), Y = D.c = [], E = C.e - M.e, at = S + E + 1, y || (y = wo, E = eo(C.e / jt) - eo(M.e / jt), at = at / jt | 0), B = 0; Re[B] == (Fe[B] || 0); B++)
        ;
      if (Re[B] > (Fe[B] || 0) && E--, at < 0)
        Y.push(1), F = !0;
      else {
        for (_e = Fe.length, Pe = Re.length, B = 0, at += 2, q = Qo(y / (Re[0] + 1)), q > 1 && (Re = O(Re, q, y), Fe = O(Fe, q, y), Pe = Re.length, _e = Fe.length), se = Pe, Q = Fe.slice(0, Pe), G = Q.length; G < Pe; Q[G++] = 0)
          ;
        Be = Re.slice(), Be = [0].concat(Be), Me = Re[0], Re[1] >= y / 2 && Me++;
        do {
          if (q = 0, v = k(Re, Q, Pe, G), v < 0) {
            if (he = Q[0], Pe != G && (he = he * y + (Q[1] || 0)), q = Qo(he / Me), q > 1)
              for (q >= y && (q = y - 1), U = O(Re, q, y), m = U.length, G = Q.length; k(U, Q, m, G) == 1; )
                q--, z(U, Pe < m ? Be : Re, m, y), m = U.length, v = 1;
            else
              q == 0 && (v = q = 1), U = Re.slice(), m = U.length;
            if (m < G && (U = [0].concat(U)), z(Q, U, G, y), G = Q.length, v == -1)
              for (; k(Re, Q, Pe, G) < 1; )
                q++, z(Q, Pe < G ? Be : Re, G, y), G = Q.length;
          } else
            v === 0 && (q++, Q = [0]);
          Y[B++] = q, Q[0] ? Q[G++] = Fe[se] || 0 : (Q = [Fe[se]], G = 1);
        } while ((se++ < _e || Q[0] != null) && at--);
        F = Q[0] != null, Y[0] || Y.splice(0, 1);
      }
      if (y == wo) {
        for (B = 1, at = Y[0]; at >= 10; at /= 10, B++)
          ;
        K(D, S + (D.e = B + E * jt - 1) + 1, p, F);
      } else
        D.e = E, D.r = +F;
      return D;
    };
  }();
  function x(O, k, z, C) {
    var M, S, p, y, v;
    if (z == null ? z = s : ur(z, 0, 8), !O.c)
      return O.toString();
    if (M = O.c[0], p = O.e, k == null)
      v = Xi(O.c), v = C == 1 || C == 2 && (p <= c || p >= l) ? Pg(v, p) : Aa(v, p, "0");
    else if (O = K(new A(O), k, z), S = O.e, v = Xi(O.c), y = v.length, C == 1 || C == 2 && (k <= S || S <= c)) {
      for (; y < k; v += "0", y++)
        ;
      v = Pg(v, S);
    } else if (k -= p, v = Aa(v, S, "0"), S + 1 > y) {
      if (--k > 0)
        for (v += "."; k--; v += "0")
          ;
    } else if (k += S - y, k > 0)
      for (S + 1 == y && (v += "."); k--; v += "0")
        ;
    return O.s < 0 && M ? "-" + v : v;
  }
  function N(O, k) {
    for (var z, C = 1, M = new A(O[0]); C < O.length; C++)
      if (z = new A(O[C]), z.s)
        k.call(M, z) && (M = z);
      else {
        M = z;
        break;
      }
    return M;
  }
  function j(O, k, z) {
    for (var C = 1, M = k.length; !k[--M]; k.pop())
      ;
    for (M = k[0]; M >= 10; M /= 10, C++)
      ;
    return (z = C + z * jt - 1) > f ? O.c = O.e = null : z < u ? O.c = [O.e = 0] : (O.e = z, O.c = k), O;
  }
  r = function() {
    var O = /^(-?)0([xbo])(?=\w[\w.]*$)/i, k = /^([^.]+)\.$/, z = /^\.([^.]+)$/, C = /^-?(Infinity|NaN)$/, M = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(S, p, y, v) {
      var E, B = y ? p : p.replace(M, "");
      if (C.test(B))
        S.s = isNaN(B) ? null : B < 0 ? -1 : 1;
      else {
        if (!y && (B = B.replace(O, function(F, q, U) {
          return E = (U = U.toLowerCase()) == "x" ? 16 : U == "b" ? 2 : 8, !v || v == E ? q : F;
        }), v && (E = v, B = B.replace(k, "$1").replace(z, "0.$1")), p != B))
          return new A(B, E);
        if (A.DEBUG)
          throw Error(mi + "Not a" + (v ? " base " + v : "") + " number: " + p);
        S.s = null;
      }
      S.c = S.e = null;
    };
  }();
  function K(O, k, z, C) {
    var M, S, p, y, v, E, B, F = O.c, q = iS;
    if (F) {
      e: {
        for (M = 1, y = F[0]; y >= 10; y /= 10, M++)
          ;
        if (S = k - M, S < 0)
          S += jt, p = k, v = F[E = 0], B = v / q[M - p - 1] % 10 | 0;
        else if (E = nS((S + 1) / jt), E >= F.length)
          if (C) {
            for (; F.length <= E; F.push(0))
              ;
            v = B = 0, M = 1, S %= jt, p = S - jt + 1;
          } else
            break e;
        else {
          for (v = y = F[E], M = 1; y >= 10; y /= 10, M++)
            ;
          S %= jt, p = S - jt + M, B = p < 0 ? 0 : v / q[M - p - 1] % 10 | 0;
        }
        if (C = C || k < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        F[E + 1] != null || (p < 0 ? v : v % q[M - p - 1]), C = z < 4 ? (B || C) && (z == 0 || z == (O.s < 0 ? 3 : 2)) : B > 5 || B == 5 && (z == 4 || C || z == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (S > 0 ? p > 0 ? v / q[M - p] : 0 : F[E - 1]) % 10 & 1 || z == (O.s < 0 ? 8 : 7)), k < 1 || !F[0])
          return F.length = 0, C ? (k -= O.e + 1, F[0] = q[(jt - k % jt) % jt], O.e = -k || 0) : F[0] = O.e = 0, O;
        if (S == 0 ? (F.length = E, y = 1, E--) : (F.length = E + 1, y = q[jt - S], F[E] = p > 0 ? Qo(v / q[M - p] % q[p]) * y : 0), C)
          for (; ; )
            if (E == 0) {
              for (S = 1, p = F[0]; p >= 10; p /= 10, S++)
                ;
              for (p = F[0] += y, y = 1; p >= 10; p /= 10, y++)
                ;
              S != y && (O.e++, F[0] == wo && (F[0] = 1));
              break;
            } else {
              if (F[E] += y, F[E] != wo)
                break;
              F[E--] = 0, y = 1;
            }
        for (S = F.length; F[--S] === 0; F.pop())
          ;
      }
      O.e > f ? O.c = O.e = null : O.e < u && (O.c = [O.e = 0]);
    }
    return O;
  }
  function W(O) {
    var k, z = O.e;
    return z === null ? O.toString() : (k = Xi(O.c), k = z <= c || z >= l ? Pg(k, z) : Aa(k, z, "0"), O.s < 0 ? "-" + k : k);
  }
  return i.absoluteValue = i.abs = function() {
    var O = new A(this);
    return O.s < 0 && (O.s = 1), O;
  }, i.comparedTo = function(O, k) {
    return vu(this, new A(O, k));
  }, i.decimalPlaces = i.dp = function(O, k) {
    var z, C, M, S = this;
    if (O != null)
      return ur(O, 0, jr), k == null ? k = s : ur(k, 0, 8), K(new A(S), O + S.e + 1, k);
    if (!(z = S.c))
      return null;
    if (C = ((M = z.length - 1) - eo(this.e / jt)) * jt, M = z[M])
      for (; M % 10 == 0; M /= 10, C--)
        ;
    return C < 0 && (C = 0), C;
  }, i.dividedBy = i.div = function(O, k) {
    return t(this, new A(O, k), a, s);
  }, i.dividedToIntegerBy = i.idiv = function(O, k) {
    return t(this, new A(O, k), 0, 1);
  }, i.exponentiatedBy = i.pow = function(O, k) {
    var z, C, M, S, p, y, v, E, B, F = this;
    if (O = new A(O), O.c && !O.isInteger())
      throw Error(mi + "Exponent not an integer: " + W(O));
    if (k != null && (k = new A(k)), y = O.e > 14, !F.c || !F.c[0] || F.c[0] == 1 && !F.e && F.c.length == 1 || !O.c || !O.c[0])
      return B = new A(Math.pow(+W(F), y ? O.s * (2 - Og(O)) : +W(O))), k ? B.mod(k) : B;
    if (v = O.s < 0, k) {
      if (k.c ? !k.c[0] : !k.s)
        return new A(NaN);
      C = !v && F.isInteger() && k.isInteger(), C && (F = F.mod(k));
    } else {
      if (O.e > 9 && (F.e > 0 || F.e < -1 || (F.e == 0 ? F.c[0] > 1 || y && F.c[1] >= 24e7 : F.c[0] < 8e13 || y && F.c[0] <= 9999975e7)))
        return S = F.s < 0 && Og(O) ? -0 : 0, F.e > -1 && (S = 1 / S), new A(v ? 1 / S : S);
      g && (S = nS(g / jt + 2));
    }
    for (y ? (z = new A(0.5), v && (O.s = 1), E = Og(O)) : (M = Math.abs(+W(O)), E = M % 2), B = new A(o); ; ) {
      if (E) {
        if (B = B.times(F), !B.c)
          break;
        S ? B.c.length > S && (B.c.length = S) : C && (B = B.mod(k));
      }
      if (M) {
        if (M = Qo(M / 2), M === 0)
          break;
        E = M % 2;
      } else if (O = O.times(z), K(O, O.e + 1, 1), O.e > 14)
        E = Og(O);
      else {
        if (M = +W(O), M === 0)
          break;
        E = M % 2;
      }
      F = F.times(F), S ? F.c && F.c.length > S && (F.c.length = S) : C && (F = F.mod(k));
    }
    return C ? B : (v && (B = o.div(B)), k ? B.mod(k) : S ? K(B, g, s, p) : B);
  }, i.integerValue = function(O) {
    var k = new A(this);
    return O == null ? O = s : ur(O, 0, 8), K(k, k.e + 1, O);
  }, i.isEqualTo = i.eq = function(O, k) {
    return vu(this, new A(O, k)) === 0;
  }, i.isFinite = function() {
    return !!this.c;
  }, i.isGreaterThan = i.gt = function(O, k) {
    return vu(this, new A(O, k)) > 0;
  }, i.isGreaterThanOrEqualTo = i.gte = function(O, k) {
    return (k = vu(this, new A(O, k))) === 1 || k === 0;
  }, i.isInteger = function() {
    return !!this.c && eo(this.e / jt) > this.c.length - 2;
  }, i.isLessThan = i.lt = function(O, k) {
    return vu(this, new A(O, k)) < 0;
  }, i.isLessThanOrEqualTo = i.lte = function(O, k) {
    return (k = vu(this, new A(O, k))) === -1 || k === 0;
  }, i.isNaN = function() {
    return !this.s;
  }, i.isNegative = function() {
    return this.s < 0;
  }, i.isPositive = function() {
    return this.s > 0;
  }, i.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, i.minus = function(O, k) {
    var z, C, M, S, p = this, y = p.s;
    if (O = new A(O, k), k = O.s, !y || !k)
      return new A(NaN);
    if (y != k)
      return O.s = -k, p.plus(O);
    var v = p.e / jt, E = O.e / jt, B = p.c, F = O.c;
    if (!v || !E) {
      if (!B || !F)
        return B ? (O.s = -k, O) : new A(F ? p : NaN);
      if (!B[0] || !F[0])
        return F[0] ? (O.s = -k, O) : new A(B[0] ? p : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          s == 3 ? -0 : 0
        ));
    }
    if (v = eo(v), E = eo(E), B = B.slice(), y = v - E) {
      for ((S = y < 0) ? (y = -y, M = B) : (E = v, M = F), M.reverse(), k = y; k--; M.push(0))
        ;
      M.reverse();
    } else
      for (C = (S = (y = B.length) < (k = F.length)) ? y : k, y = k = 0; k < C; k++)
        if (B[k] != F[k]) {
          S = B[k] < F[k];
          break;
        }
    if (S && (M = B, B = F, F = M, O.s = -O.s), k = (C = F.length) - (z = B.length), k > 0)
      for (; k--; B[z++] = 0)
        ;
    for (k = wo - 1; C > y; ) {
      if (B[--C] < F[C]) {
        for (z = C; z && !B[--z]; B[z] = k)
          ;
        --B[z], B[C] += wo;
      }
      B[C] -= F[C];
    }
    for (; B[0] == 0; B.splice(0, 1), --E)
      ;
    return B[0] ? j(O, B, E) : (O.s = s == 3 ? -1 : 1, O.c = [O.e = 0], O);
  }, i.modulo = i.mod = function(O, k) {
    var z, C, M = this;
    return O = new A(O, k), !M.c || !O.s || O.c && !O.c[0] ? new A(NaN) : !O.c || M.c && !M.c[0] ? new A(M) : (h == 9 ? (C = O.s, O.s = 1, z = t(M, O, 0, 3), O.s = C, z.s *= C) : z = t(M, O, 0, h), O = M.minus(z.times(O)), !O.c[0] && h == 1 && (O.s = M.s), O);
  }, i.multipliedBy = i.times = function(O, k) {
    var z, C, M, S, p, y, v, E, B, F, q, U, m, D, Y, Q = this, G = Q.c, he = (O = new A(O, k)).c;
    if (!G || !he || !G[0] || !he[0])
      return !Q.s || !O.s || G && !G[0] && !he || he && !he[0] && !G ? O.c = O.e = O.s = null : (O.s *= Q.s, !G || !he ? O.c = O.e = null : (O.c = [0], O.e = 0)), O;
    for (C = eo(Q.e / jt) + eo(O.e / jt), O.s *= Q.s, v = G.length, F = he.length, v < F && (m = G, G = he, he = m, M = v, v = F, F = M), M = v + F, m = []; M--; m.push(0))
      ;
    for (D = wo, Y = cs, M = F; --M >= 0; ) {
      for (z = 0, q = he[M] % Y, U = he[M] / Y | 0, p = v, S = M + p; S > M; )
        E = G[--p] % Y, B = G[p] / Y | 0, y = U * E + B * q, E = q * E + y % Y * Y + m[S] + z, z = (E / D | 0) + (y / Y | 0) + U * B, m[S--] = E % D;
      m[S] = z;
    }
    return z ? ++C : m.splice(0, 1), j(O, m, C);
  }, i.negated = function() {
    var O = new A(this);
    return O.s = -O.s || null, O;
  }, i.plus = function(O, k) {
    var z, C = this, M = C.s;
    if (O = new A(O, k), k = O.s, !M || !k)
      return new A(NaN);
    if (M != k)
      return O.s = -k, C.minus(O);
    var S = C.e / jt, p = O.e / jt, y = C.c, v = O.c;
    if (!S || !p) {
      if (!y || !v)
        return new A(M / 0);
      if (!y[0] || !v[0])
        return v[0] ? O : new A(y[0] ? C : M * 0);
    }
    if (S = eo(S), p = eo(p), y = y.slice(), M = S - p) {
      for (M > 0 ? (p = S, z = v) : (M = -M, z = y), z.reverse(); M--; z.push(0))
        ;
      z.reverse();
    }
    for (M = y.length, k = v.length, M - k < 0 && (z = v, v = y, y = z, k = M), M = 0; k; )
      M = (y[--k] = y[k] + v[k] + M) / wo | 0, y[k] = wo === y[k] ? 0 : y[k] % wo;
    return M && (y = [M].concat(y), ++p), j(O, y, p);
  }, i.precision = i.sd = function(O, k) {
    var z, C, M, S = this;
    if (O != null && O !== !!O)
      return ur(O, 1, jr), k == null ? k = s : ur(k, 0, 8), K(new A(S), O, k);
    if (!(z = S.c))
      return null;
    if (M = z.length - 1, C = M * jt + 1, M = z[M]) {
      for (; M % 10 == 0; M /= 10, C--)
        ;
      for (M = z[0]; M >= 10; M /= 10, C++)
        ;
    }
    return O && S.e + 1 > C && (C = S.e + 1), C;
  }, i.shiftedBy = function(O) {
    return ur(O, -rS, rS), this.times("1e" + O);
  }, i.squareRoot = i.sqrt = function() {
    var O, k, z, C, M, S = this, p = S.c, y = S.s, v = S.e, E = a + 4, B = new A("0.5");
    if (y !== 1 || !p || !p[0])
      return new A(!y || y < 0 && (!p || p[0]) ? NaN : p ? S : 1 / 0);
    if (y = Math.sqrt(+W(S)), y == 0 || y == 1 / 0 ? (k = Xi(p), (k.length + v) % 2 == 0 && (k += "0"), y = Math.sqrt(+k), v = eo((v + 1) / 2) - (v < 0 || v % 2), y == 1 / 0 ? k = "5e" + v : (k = y.toExponential(), k = k.slice(0, k.indexOf("e") + 1) + v), z = new A(k)) : z = new A(y + ""), z.c[0]) {
      for (v = z.e, y = v + E, y < 3 && (y = 0); ; )
        if (M = z, z = B.times(M.plus(t(S, M, E, 1))), Xi(M.c).slice(0, y) === (k = Xi(z.c)).slice(0, y))
          if (z.e < v && --y, k = k.slice(y - 3, y + 1), k == "9999" || !C && k == "4999") {
            if (!C && (K(M, M.e + a + 2, 0), M.times(M).eq(S))) {
              z = M;
              break;
            }
            E += 4, y += 4, C = 1;
          } else {
            (!+k || !+k.slice(1) && k.charAt(0) == "5") && (K(z, z.e + a + 2, 1), O = !z.times(z).eq(S));
            break;
          }
    }
    return K(z, z.e + a + 1, s, O);
  }, i.toExponential = function(O, k) {
    return O != null && (ur(O, 0, jr), O++), x(this, O, k, 1);
  }, i.toFixed = function(O, k) {
    return O != null && (ur(O, 0, jr), O = O + this.e + 1), x(this, O, k);
  }, i.toFormat = function(O, k, z) {
    var C, M = this;
    if (z == null)
      O != null && k && typeof k == "object" ? (z = k, k = null) : O && typeof O == "object" ? (z = O, O = k = null) : z = w;
    else if (typeof z != "object")
      throw Error(mi + "Argument not an object: " + z);
    if (C = M.toFixed(O, k), M.c) {
      var S, p = C.split("."), y = +z.groupSize, v = +z.secondaryGroupSize, E = z.groupSeparator || "", B = p[0], F = p[1], q = M.s < 0, U = q ? B.slice(1) : B, m = U.length;
      if (v && (S = y, y = v, v = S, m -= S), y > 0 && m > 0) {
        for (S = m % y || y, B = U.substr(0, S); S < m; S += y)
          B += E + U.substr(S, y);
        v > 0 && (B += E + U.slice(S)), q && (B = "-" + B);
      }
      C = F ? B + (z.decimalSeparator || "") + ((v = +z.fractionGroupSize) ? F.replace(
        new RegExp("\\d{" + v + "}\\B", "g"),
        "$&" + (z.fractionGroupSeparator || "")
      ) : F) : B;
    }
    return (z.prefix || "") + C + (z.suffix || "");
  }, i.toFraction = function(O) {
    var k, z, C, M, S, p, y, v, E, B, F, q, U = this, m = U.c;
    if (O != null && (y = new A(O), !y.isInteger() && (y.c || y.s !== 1) || y.lt(o)))
      throw Error(mi + "Argument " + (y.isInteger() ? "out of range: " : "not an integer: ") + W(y));
    if (!m)
      return new A(U);
    for (k = new A(o), E = z = new A(o), C = v = new A(o), q = Xi(m), S = k.e = q.length - U.e - 1, k.c[0] = iS[(p = S % jt) < 0 ? jt + p : p], O = !O || y.comparedTo(k) > 0 ? S > 0 ? k : E : y, p = f, f = 1 / 0, y = new A(q), v.c[0] = 0; B = t(y, k, 0, 1), M = z.plus(B.times(C)), M.comparedTo(O) != 1; )
      z = C, C = M, E = v.plus(B.times(M = E)), v = M, k = y.minus(B.times(M = k)), y = M;
    return M = t(O.minus(z), C, 0, 1), v = v.plus(M.times(E)), z = z.plus(M.times(C)), v.s = E.s = U.s, S = S * 2, F = t(E, C, S, s).minus(U).abs().comparedTo(
      t(v, z, S, s).minus(U).abs()
    ) < 1 ? [E, C] : [v, z], f = p, F;
  }, i.toNumber = function() {
    return +W(this);
  }, i.toPrecision = function(O, k) {
    return O != null && ur(O, 1, jr), x(this, O, k, 2);
  }, i.toString = function(O) {
    var k, z = this, C = z.s, M = z.e;
    return M === null ? C ? (k = "Infinity", C < 0 && (k = "-" + k)) : k = "NaN" : (O == null ? k = M <= c || M >= l ? Pg(Xi(z.c), M) : Aa(Xi(z.c), M, "0") : O === 10 && I ? (z = K(new A(z), a + M + 1, s), k = Aa(Xi(z.c), z.e, "0")) : (ur(O, 2, b.length, "Base"), k = n(Aa(Xi(z.c), M, "0"), 10, O, C, !0)), C < 0 && z.c[0] && (k = "-" + k)), k;
  }, i.valueOf = i.toJSON = function() {
    return W(this);
  }, i._isBigNumber = !0, i[Symbol.toStringTag] = "BigNumber", i[Symbol.for("nodejs.util.inspect.custom")] = i.valueOf, e != null && A.set(e), A;
}
function eo(e) {
  var t = e | 0;
  return e > 0 || e === t ? t : t - 1;
}
function Xi(e) {
  for (var t, n, r = 1, i = e.length, o = e[0] + ""; r < i; ) {
    for (t = e[r++] + "", n = jt - t.length; n--; t = "0" + t)
      ;
    o += t;
  }
  for (i = o.length; o.charCodeAt(--i) === 48; )
    ;
  return o.slice(0, i + 1 || 1);
}
function vu(e, t) {
  var n, r, i = e.c, o = t.c, a = e.s, s = t.s, c = e.e, l = t.e;
  if (!a || !s)
    return null;
  if (n = i && !i[0], r = o && !o[0], n || r)
    return n ? r ? 0 : -s : a;
  if (a != s)
    return a;
  if (n = a < 0, r = c == l, !i || !o)
    return r ? 0 : !i ^ n ? 1 : -1;
  if (!r)
    return c > l ^ n ? 1 : -1;
  for (s = (c = i.length) < (l = o.length) ? c : l, a = 0; a < s; a++)
    if (i[a] != o[a])
      return i[a] > o[a] ^ n ? 1 : -1;
  return c == l ? 0 : c > l ^ n ? 1 : -1;
}
function ur(e, t, n, r) {
  if (e < t || e > n || e !== Qo(e))
    throw Error(mi + (r || "Argument") + (typeof e == "number" ? e < t || e > n ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
}
function Og(e) {
  var t = e.c.length - 1;
  return eo(e.e / jt) == t && e.c[t] % 2 != 0;
}
function Pg(e, t) {
  return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
}
function Aa(e, t, n) {
  var r, i;
  if (t < 0) {
    for (i = n + "."; ++t; i += n)
      ;
    e = i + e;
  } else if (r = e.length, ++t > r) {
    for (i = n, t -= r; --t; i += n)
      ;
    e += i;
  } else
    t < r && (e = e.slice(0, t) + "." + e.slice(t));
  return e;
}
var x6 = T6();
const jA = new x6("1e+18"), mte = (e) => {
  const t = k6(e), { encode: n, decode: r } = Hl(t), i = t;
  return i.decode = (o, a) => {
    const s = r(o, a).toString();
    return new x6(s).div(jA);
  }, i.encode = (o, a, s) => {
    const c = BigInt(o.times(jA).integerValue().toString());
    return n(c, a, s);
  }, i;
}, _te = (e) => {
  const t = an(e), { encode: n, decode: r } = Hl(t), i = t;
  return i.decode = (o, a) => !!r(o, a), i.encode = (o, a, s) => {
    const c = Number(o);
    return n(c, a, s);
  }, i;
}, Bf = (e) => {
  const t = Nn(32, e), { encode: n, decode: r } = Hl(t), i = t;
  return i.decode = (o, a) => {
    const s = r(o, a);
    return new Ae(s);
  }, i.encode = (o, a, s) => {
    const c = o.toBuffer();
    return n(c, a, s);
  }, i;
}, wte = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WAD: jA,
  bigInt: Hd,
  bigIntBE: Gd,
  bool: _te,
  decimal: mte,
  encodeDecode: Hl,
  publicKey: Bf,
  u128: k6,
  u128be: dte,
  u192: hte,
  u192be: pte,
  u256: yte,
  u256be: gte,
  u64: pb,
  u64be: fte
}, Symbol.toStringTag, { value: "Module" }));
var UA;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initialized = 1] = "Initialized", e[e.Frozen = 2] = "Frozen";
})(UA || (UA = {}));
const M6 = ht([
  Bf("mint"),
  Bf("owner"),
  pb("amount"),
  ft("delegateOption"),
  Bf("delegate"),
  an("state"),
  ft("isNativeOption"),
  pb("isNative"),
  pb("delegatedAmount"),
  ft("closeAuthorityOption"),
  Bf("closeAuthority")
]);
M6.span;
const O6 = "0.1.0", P6 = "ntnft", B6 = [
  {
    name: "hasValidToken",
    accounts: [
      {
        name: "status",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "addr",
        type: "publicKey"
      }
    ],
    returns: "bool"
  },
  {
    name: "mintWithArgs",
    accounts: [
      {
        name: "collection",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wallet",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "metadata",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mint",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "associatedAccount",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "mintAuthority",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "feePayer",
        isMut: !0,
        isSigner: !0
      },
      {
        name: "priceFeed",
        isMut: !0,
        isSigner: !1,
        docs: [
          "TODO: We need to ensure we have the right price_feed, store in the collection?"
        ]
      },
      {
        name: "tokenProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "tokenMetadataProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "rent",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "secondsToPay",
        type: "u64"
      },
      {
        name: "metadataCid",
        type: "string"
      }
    ]
  },
  {
    name: "initStatus",
    accounts: [
      {
        name: "collection",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "receiver",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "status",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "authority",
        isMut: !1,
        isSigner: !0
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "data",
        type: {
          defined: "KycDaoNftStatusData"
        }
      }
    ]
  },
  {
    name: "updateStatus",
    accounts: [
      {
        name: "collection",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "status",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "authority",
        isMut: !1,
        isSigner: !0
      }
    ],
    args: [
      {
        name: "data",
        type: {
          defined: "KycDaoNftStatusData"
        }
      }
    ]
  },
  {
    name: "initializeKycdaonftCollection",
    accounts: [
      {
        name: "kycdaoNftCollection",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wallet",
        isMut: !1,
        isSigner: !1,
        docs: [
          "TODO: Why do we need the constraint check on wallet here?"
        ]
      },
      {
        name: "authority",
        isMut: !0,
        isSigner: !0,
        docs: [
          "TODO: Why do we need the constraint check on authority here?"
        ]
      },
      {
        name: "systemProgram",
        isMut: !1,
        isSigner: !1
      }
    ],
    args: [
      {
        name: "bump",
        type: "u8"
      },
      {
        name: "data",
        type: {
          defined: "KycDaoNftCollectionData"
        }
      }
    ]
  },
  {
    name: "updateKycdaonftCollection",
    accounts: [
      {
        name: "kycdaoNftCollection",
        isMut: !0,
        isSigner: !1
      },
      {
        name: "wallet",
        isMut: !1,
        isSigner: !1
      },
      {
        name: "authority",
        isMut: !1,
        isSigner: !0
      }
    ],
    args: [
      {
        name: "bump",
        type: "u8"
      },
      {
        name: "data",
        type: {
          defined: "KycDaoNftCollectionData"
        }
      }
    ]
  }
], C6 = [
  {
    name: "KycDaoNftCollection",
    type: {
      kind: "struct",
      fields: [
        {
          name: "authority",
          type: "publicKey"
        },
        {
          name: "wallet",
          type: "publicKey"
        },
        {
          name: "data",
          type: {
            defined: "KycDaoNftCollectionData"
          }
        }
      ]
    }
  },
  {
    name: "KycDaoNftStatus",
    type: {
      kind: "struct",
      fields: [
        {
          name: "data",
          type: {
            defined: "KycDaoNftStatusData"
          }
        }
      ]
    }
  }
], D6 = [
  {
    name: "KycDaoNftCollectionData",
    type: {
      kind: "struct",
      fields: [
        {
          name: "pricePerYear",
          type: "u64"
        },
        {
          name: "nftsMinted",
          type: "u64"
        },
        {
          name: "symbol",
          type: "string"
        },
        {
          name: "name",
          type: "string"
        },
        {
          name: "baseUrl",
          type: "string"
        }
      ]
    }
  },
  {
    name: "KycDaoNftStatusData",
    type: {
      kind: "struct",
      fields: [
        {
          name: "isValid",
          type: "bool"
        },
        {
          name: "expiry",
          type: "u64"
        },
        {
          name: "verificationTier",
          type: "string"
        }
      ]
    }
  }
], R6 = [
  {
    code: 6e3,
    name: "InvalidDataProvided",
    msg: "SECP256K1 program or length doesn't match"
  },
  {
    code: 6001,
    name: "SignatureVerificationFailed",
    msg: "The signature data provided to validate the metadata is incorrect"
  },
  {
    code: 6002,
    name: "NotEnoughSOL",
    msg: "You don't have enough SOL to mint this NFT"
  },
  {
    code: 6003,
    name: "CandyMachineEmpty",
    msg: "There are no more NFTs to mint in this collection"
  },
  {
    code: 6004,
    name: "InvalidAuthority",
    msg: "The authority provided is not valid"
  },
  {
    code: 6005,
    name: "InvalidAuthMint",
    msg: "The authMint provided is not valid"
  }
], vte = {
  version: O6,
  name: P6,
  instructions: B6,
  accounts: C6,
  types: D6,
  errors: R6
}, Ste = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accounts: C6,
  default: vte,
  errors: R6,
  instructions: B6,
  name: P6,
  types: D6,
  version: O6
}, Symbol.toStringTag, { value: "Module" })), Ete = "KYCDAO_STATUS_KYC_SEED", FO = new Ae("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s");
new Ae("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
const Ate = async (e, t) => Ae.findProgramAddressSync([Buffer.from(Ete), e.toBuffer()], t), Ite = async (e) => Ae.findProgramAddressSync([Buffer.from("metadata"), FO.toBuffer(), e.toBuffer()], FO)[0];
var N6 = {}, k_ = {}, j6 = {}, vi = {}, T_ = {};
Object.defineProperty(T_, "__esModule", { value: !0 });
T_.errorCodeFromLogs = void 0;
const kte = /Custom program error: (0x[a-f0-9]+)/i;
function Tte(e) {
  for (const t of e) {
    const n = t.match(kte);
    if (n == null)
      continue;
    const r = n[1];
    try {
      return parseInt(r);
    } catch {
    }
  }
  return null;
}
T_.errorCodeFromLogs = Tte;
var U6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.LangErrorMessage = e.LangErrorCode = void 0, e.LangErrorCode = {
    // Instructions.
    InstructionMissing: 100,
    InstructionFallbackNotFound: 101,
    InstructionDidNotDeserialize: 102,
    InstructionDidNotSerialize: 103,
    // IDL instructions.
    IdlInstructionStub: 1e3,
    IdlInstructionInvalidProgram: 1001,
    // Constraints.
    ConstraintMut: 2e3,
    ConstraintHasOne: 2001,
    ConstraintSigner: 2002,
    ConstraintRaw: 2003,
    ConstraintOwner: 2004,
    ConstraintRentExempt: 2005,
    ConstraintSeeds: 2006,
    ConstraintExecutable: 2007,
    ConstraintState: 2008,
    ConstraintAssociated: 2009,
    ConstraintAssociatedInit: 2010,
    ConstraintClose: 2011,
    ConstraintAddress: 2012,
    ConstraintZero: 2013,
    ConstraintTokenMint: 2014,
    ConstraintTokenOwner: 2015,
    ConstraintMintMintAuthority: 2016,
    ConstraintMintFreezeAuthority: 2017,
    ConstraintMintDecimals: 2018,
    ConstraintSpace: 2019,
    // Accounts.
    AccountDiscriminatorAlreadySet: 3e3,
    AccountDiscriminatorNotFound: 3001,
    AccountDiscriminatorMismatch: 3002,
    AccountDidNotDeserialize: 3003,
    AccountDidNotSerialize: 3004,
    AccountNotEnoughKeys: 3005,
    AccountNotMutable: 3006,
    AccountOwnedByWrongProgram: 3007,
    InvalidProgramId: 3008,
    InvalidProgramExecutable: 3009,
    AccountNotSigner: 3010,
    AccountNotSystemOwned: 3011,
    AccountNotInitialized: 3012,
    AccountNotProgramData: 3013,
    // State.
    StateInvalidAddress: 4e3,
    // Used for APIs that shouldn't be used anymore.
    Deprecated: 5e3
  }, e.LangErrorMessage = /* @__PURE__ */ new Map([
    // Instructions.
    [
      e.LangErrorCode.InstructionMissing,
      "8 byte instruction identifier not provided"
    ],
    [
      e.LangErrorCode.InstructionFallbackNotFound,
      "Fallback functions are not supported"
    ],
    [
      e.LangErrorCode.InstructionDidNotDeserialize,
      "The program could not deserialize the given instruction"
    ],
    [
      e.LangErrorCode.InstructionDidNotSerialize,
      "The program could not serialize the given instruction"
    ],
    // Idl instructions.
    [
      e.LangErrorCode.IdlInstructionStub,
      "The program was compiled without idl instructions"
    ],
    [
      e.LangErrorCode.IdlInstructionInvalidProgram,
      "The transaction was given an invalid program for the IDL instruction"
    ],
    // Constraints.
    [e.LangErrorCode.ConstraintMut, "A mut constraint was violated"],
    [e.LangErrorCode.ConstraintHasOne, "A has_one constraint was violated"],
    [e.LangErrorCode.ConstraintSigner, "A signer constraint was violated"],
    [e.LangErrorCode.ConstraintRaw, "A raw constraint was violated"],
    [e.LangErrorCode.ConstraintOwner, "An owner constraint was violated"],
    [e.LangErrorCode.ConstraintRentExempt, "A rent exempt constraint was violated"],
    [e.LangErrorCode.ConstraintSeeds, "A seeds constraint was violated"],
    [e.LangErrorCode.ConstraintExecutable, "An executable constraint was violated"],
    [e.LangErrorCode.ConstraintState, "A state constraint was violated"],
    [e.LangErrorCode.ConstraintAssociated, "An associated constraint was violated"],
    [
      e.LangErrorCode.ConstraintAssociatedInit,
      "An associated init constraint was violated"
    ],
    [e.LangErrorCode.ConstraintClose, "A close constraint was violated"],
    [e.LangErrorCode.ConstraintAddress, "An address constraint was violated"],
    [e.LangErrorCode.ConstraintZero, "Expected zero account discriminant"],
    [e.LangErrorCode.ConstraintTokenMint, "A token mint constraint was violated"],
    [e.LangErrorCode.ConstraintTokenOwner, "A token owner constraint was violated"],
    [
      e.LangErrorCode.ConstraintMintMintAuthority,
      "A mint mint authority constraint was violated"
    ],
    [
      e.LangErrorCode.ConstraintMintFreezeAuthority,
      "A mint freeze authority constraint was violated"
    ],
    [
      e.LangErrorCode.ConstraintMintDecimals,
      "A mint decimals constraint was violated"
    ],
    [e.LangErrorCode.ConstraintSpace, "A space constraint was violated"],
    // Accounts.
    [
      e.LangErrorCode.AccountDiscriminatorAlreadySet,
      "The account discriminator was already set on this account"
    ],
    [
      e.LangErrorCode.AccountDiscriminatorNotFound,
      "No 8 byte discriminator was found on the account"
    ],
    [
      e.LangErrorCode.AccountDiscriminatorMismatch,
      "8 byte discriminator did not match what was expected"
    ],
    [e.LangErrorCode.AccountDidNotDeserialize, "Failed to deserialize the account"],
    [e.LangErrorCode.AccountDidNotSerialize, "Failed to serialize the account"],
    [
      e.LangErrorCode.AccountNotEnoughKeys,
      "Not enough account keys given to the instruction"
    ],
    [e.LangErrorCode.AccountNotMutable, "The given account is not mutable"],
    [
      e.LangErrorCode.AccountOwnedByWrongProgram,
      "The given account is owned by a different program than expected"
    ],
    [e.LangErrorCode.InvalidProgramId, "Program ID was not as expected"],
    [e.LangErrorCode.InvalidProgramExecutable, "Program account is not executable"],
    [e.LangErrorCode.AccountNotSigner, "The given account did not sign"],
    [
      e.LangErrorCode.AccountNotSystemOwned,
      "The given account is not owned by the system program"
    ],
    [
      e.LangErrorCode.AccountNotInitialized,
      "The program expected this account to be already initialized"
    ],
    [
      e.LangErrorCode.AccountNotProgramData,
      "The given account is not a program data account"
    ],
    // State.
    [
      e.LangErrorCode.StateInvalidAddress,
      "The given state account does not have the correct address"
    ],
    // Misc.
    [
      e.LangErrorCode.Deprecated,
      "The API being used is deprecated and should no longer be used"
    ]
  ]);
})(U6);
var x_ = {};
Object.defineProperty(x_, "__esModule", { value: !0 });
x_.tokenLendingErrors = void 0;
x_.tokenLendingErrors = /* @__PURE__ */ new Map([
  [
    0,
    {
      code: 0,
      message: 'Failed to unpack instruction data"',
      name: "InstructionUnpackError"
    }
  ],
  [
    1,
    {
      code: 1,
      message: 'Account is already initialized"',
      name: "AlreadyInitialized"
    }
  ],
  [
    2,
    {
      code: 2,
      message: 'Lamport balance below rent-exempt threshold"',
      name: "NotRentExempt"
    }
  ],
  [
    3,
    {
      code: 3,
      message: 'Market authority is invalid"',
      name: "InvalidMarketAuthority"
    }
  ],
  [
    4,
    {
      code: 4,
      message: 'Market owner is invalid"',
      name: "InvalidMarketOwner"
    }
  ],
  [
    5,
    {
      code: 5,
      message: 'Input account owner is not the program address"',
      name: "InvalidAccountOwner"
    }
  ],
  [
    6,
    {
      code: 6,
      message: 'Input token account is not owned by the correct token program id"',
      name: "InvalidTokenOwner"
    }
  ],
  [
    7,
    {
      code: 7,
      message: 'Input token account is not valid"',
      name: "InvalidTokenAccount"
    }
  ],
  [
    8,
    {
      code: 8,
      message: 'Input token mint account is not valid"',
      name: "InvalidTokenMint"
    }
  ],
  [
    9,
    {
      code: 9,
      message: 'Input token program account is not valid"',
      name: "InvalidTokenProgram"
    }
  ],
  [
    10,
    {
      code: 10,
      message: 'Input amount is invalid"',
      name: "InvalidAmount"
    }
  ],
  [
    11,
    {
      code: 11,
      message: 'Input config value is invalid"',
      name: "InvalidConfig"
    }
  ],
  [
    12,
    {
      code: 12,
      message: 'Input account must be a signer"',
      name: "InvalidSigner"
    }
  ],
  [
    13,
    {
      code: 13,
      message: 'Invalid account input"',
      name: "InvalidAccountInput"
    }
  ],
  [
    14,
    {
      code: 14,
      message: 'Math operation overflow"',
      name: "MathOverflow"
    }
  ],
  [
    15,
    {
      code: 15,
      message: 'Token initialize mint failed"',
      name: "TokenInitializeMintFailed"
    }
  ],
  [
    16,
    {
      code: 16,
      message: 'Token initialize account failed"',
      name: "TokenInitializeAccountFailed"
    }
  ],
  [
    17,
    {
      code: 17,
      message: 'Token transfer failed"',
      name: "TokenTransferFailed"
    }
  ],
  [
    18,
    {
      code: 18,
      message: 'Token mint to failed"',
      name: "TokenMintToFailed"
    }
  ],
  [
    19,
    {
      code: 19,
      message: 'Token burn failed"',
      name: "TokenBurnFailed"
    }
  ],
  [
    20,
    {
      code: 20,
      message: 'Insufficient liquidity available"',
      name: "InsufficientLiquidity"
    }
  ],
  [
    21,
    {
      code: 21,
      message: 'Input reserve has collateral disabled"',
      name: "ReserveCollateralDisabled"
    }
  ],
  [
    22,
    {
      code: 22,
      message: 'Reserve state needs to be refreshed"',
      name: "ReserveStale"
    }
  ],
  [
    23,
    {
      code: 23,
      message: 'Withdraw amount too small"',
      name: "WithdrawTooSmall"
    }
  ],
  [
    24,
    {
      code: 24,
      message: 'Withdraw amount too large"',
      name: "WithdrawTooLarge"
    }
  ],
  [
    25,
    {
      code: 25,
      message: 'Borrow amount too small to receive liquidity after fees"',
      name: "BorrowTooSmall"
    }
  ],
  [
    26,
    {
      code: 26,
      message: 'Borrow amount too large for deposited collateral"',
      name: "BorrowTooLarge"
    }
  ],
  [
    27,
    {
      code: 27,
      message: 'Repay amount too small to transfer liquidity"',
      name: "RepayTooSmall"
    }
  ],
  [
    28,
    {
      code: 28,
      message: 'Liquidation amount too small to receive collateral"',
      name: "LiquidationTooSmall"
    }
  ],
  [
    29,
    {
      code: 29,
      message: 'Cannot liquidate healthy obligations"',
      name: "ObligationHealthy"
    }
  ],
  [
    30,
    {
      code: 30,
      message: 'Obligation state needs to be refreshed"',
      name: "ObligationStale"
    }
  ],
  [
    31,
    {
      code: 31,
      message: 'Obligation reserve limit exceeded"',
      name: "ObligationReserveLimit"
    }
  ],
  [
    32,
    {
      code: 32,
      message: 'Obligation owner is invalid"',
      name: "InvalidObligationOwner"
    }
  ],
  [
    33,
    {
      code: 33,
      message: 'Obligation deposits are empty"',
      name: "ObligationDepositsEmpty"
    }
  ],
  [
    34,
    {
      code: 34,
      message: 'Obligation borrows are empty"',
      name: "ObligationBorrowsEmpty"
    }
  ],
  [
    35,
    {
      code: 35,
      message: 'Obligation deposits have zero value"',
      name: "ObligationDepositsZero"
    }
  ],
  [
    36,
    {
      code: 36,
      message: 'Obligation borrows have zero value"',
      name: "ObligationBorrowsZero"
    }
  ],
  [
    37,
    {
      code: 37,
      message: 'Invalid obligation collateral"',
      name: "InvalidObligationCollateral"
    }
  ],
  [
    38,
    {
      code: 38,
      message: 'Invalid obligation liquidity"',
      name: "InvalidObligationLiquidity"
    }
  ],
  [
    39,
    {
      code: 39,
      message: 'Obligation collateral is empty"',
      name: "ObligationCollateralEmpty"
    }
  ],
  [
    40,
    {
      code: 40,
      message: 'Obligation liquidity is empty"',
      name: "ObligationLiquidityEmpty"
    }
  ],
  [
    41,
    {
      code: 41,
      message: 'Interest rate is negative"',
      name: "NegativeInterestRate"
    }
  ],
  [
    42,
    {
      code: 42,
      message: 'Input oracle config is invalid"',
      name: "InvalidOracleConfig"
    }
  ],
  [
    43,
    {
      code: 43,
      message: 'Input flash loan receiver program account is not valid"',
      name: "InvalidFlashLoanReceiverProgram"
    }
  ],
  [
    44,
    {
      code: 44,
      message: 'Not enough liquidity after flash loan"',
      name: "NotEnoughLiquidityAfterFlashLoan"
    }
  ]
]);
var xte = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n), Object.defineProperty(e, r, { enumerable: !0, get: function() {
    return t[n];
  } });
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Mte = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Ote = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && xte(t, e, n);
  return Mte(t, e), t;
};
Object.defineProperty(vi, "__esModule", { value: !0 });
vi.TokenLendingError = vi.AnchorError = vi.CustomProgramError = vi.CusperUnknownError = vi.initCusper = vi.ErrorResolver = void 0;
const Pte = T_, LO = Ote(U6), Bte = x_;
class z6 {
  constructor(t) {
    this.resolveErrorFromCode = t;
  }
  /**
   * Attempts to resolve the provided error code to a known or custom error.
   *
   * @param captureBoundaryFn is used to exclude everything after (including)
   * that function from the stack trace if possible
   * @param fallbackToUnknown unless `false` a {@link CusperUnknownError} is
   * returned when resolution fails
   */
  errorFromCode(t, n, r = !0) {
    let i = this.resolveErrorFromCode != null ? this.resolveErrorFromCode(t) : null;
    if (i != null)
      return this.passPreparedError(i, n ?? this.errorFromCode);
    if (i = Sl.fromCode(t), i != null)
      return this.passPreparedError(i, n ?? this.errorFromCode);
    if (i = El.fromCode(t), i != null)
      return this.passPreparedError(i, n ?? this.errorFromCode);
    if (r)
      return i = new zA(t, "CusperUnknownError", "cusper does not know this error"), this.passPreparedError(i, n ?? this.errorFromCode);
  }
  /**
   * Attempts to parse the error code from the provied logs and then resolve it
   * to a known or custom error.
   * @param fallbackToUnknown unless `false` a {@link CusperUnknownError} is
   * returned when resolution fails
   */
  errorFromProgramLogs(t, n = !0) {
    const r = (0, Pte.errorCodeFromLogs)(t);
    return r == null ? null : this.errorFromCode(r, this.errorFromProgramLogs, n);
  }
  /**
   * Throws an error that it attempts to resolve from the logs of the provided error.
   * If no error can be resolved it throws a {@link CusperUnknownError} instead
   */
  throwError(t) {
    const n = t.logs != null && this.errorFromProgramLogs(t.logs, !0) || new zA(-1, "Error created without logs and thus without error code");
    throw this.passPreparedError(n, this.throwError);
  }
  passPreparedError(t, n) {
    return t == null ? null : (typeof Error.captureStackTrace == "function" && Error.captureStackTrace(t, n), t);
  }
}
vi.ErrorResolver = z6;
function Cte(e) {
  return new z6(e);
}
vi.initCusper = Cte;
class zA extends Error {
  constructor(t, ...n) {
    super(...n), this.code = t, this.name = "CusperUnknownError";
  }
}
vi.CusperUnknownError = zA;
class Dte extends Error {
  /**
   * Creates an instance of a {@link CustomProgramError}.
   *
   * @param code the error code for which this error was resolved
   * @param name the name of the error
   */
  constructor(t, n, ...r) {
    super(...r), this.code = t, this.name = `CustomProgramError#${n}`;
  }
}
vi.CustomProgramError = Dte;
class Sl extends Error {
  constructor(t, n, ...r) {
    super(...r), this.code = t, this.name = `AnchorError#${n}`;
  }
  static fromCode(t) {
    const n = Sl.errorMap.get(t);
    return n != null ? new Sl(n.code, n.name, n.message) : null;
  }
  toString() {
    return `${this.name}: ${this.message}`;
  }
}
vi.AnchorError = Sl;
Sl.errorMap = Object.entries(LO.LangErrorCode).reduce((e, [t, n]) => (e.set(n, {
  code: n,
  name: t,
  message: LO.LangErrorMessage.get(n)
}), e), /* @__PURE__ */ new Map());
class El extends Error {
  constructor(t, n, ...r) {
    super(...r), this.code = t, this.name = `TokenLendingError#${n}`;
  }
  static fromCode(t) {
    const n = El.errorMap.get(t);
    return n != null ? new El(n.code, n.name, n.message) : null;
  }
  toString() {
    return `${this.name}: ${this.message}`;
  }
}
vi.TokenLendingError = El;
El.errorMap = Bte.tokenLendingErrors;
var F6 = {};
Object.defineProperty(F6, "__esModule", { value: !0 });
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o), Object.defineProperty(r, a, { enumerable: !0, get: function() {
      return i[o];
    } });
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(vi, e), n(F6, e);
})(j6);
var oS = {}, aS = {}, FA = {}, Se = {}, Lr = {}, Tn = {};
Object.defineProperty(Tn, "__esModule", { value: !0 });
Tn.isElementCollectionFixedSizeBeet = Tn.isFixableBeet = Tn.assertFixedSizeBeet = Tn.isFixedSizeBeet = Tn.BEET_TYPE_ARG_INNER = Tn.BEET_TYPE_ARG_LEN = Tn.BEET_PACKAGE = void 0;
const Rte = ki();
Tn.BEET_PACKAGE = "@metaplex-foundation/beet";
Tn.BEET_TYPE_ARG_LEN = "len";
Tn.BEET_TYPE_ARG_INNER = "Beet<{innner}>";
function L6(e) {
  return Object.keys(e).includes("byteSize");
}
Tn.isFixedSizeBeet = L6;
function Nte(e, t = `${e} should have been a fixed beet`) {
  (0, Rte.strict)(L6(e), t);
}
Tn.assertFixedSizeBeet = Nte;
function jte(e) {
  return typeof e.toFixedFromData == "function" && typeof e.toFixedFromValue == "function";
}
Tn.isFixableBeet = jte;
function Ute(e) {
  const t = Object.keys(e);
  return t.includes("length") && t.includes("elementByteSize") && t.includes("lenPrefixByteSize");
}
Tn.isElementCollectionFixedSizeBeet = Ute;
var Ys = {};
(function(e) {
  var t = _ && _.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.numbersTypeMap = e.bool = e.i512 = e.i256 = e.i128 = e.i64 = e.i32 = e.i16 = e.i8 = e.u512 = e.u256 = e.u128 = e.u64 = e.u32 = e.u16 = e.u8 = void 0;
  const n = t(Ka), r = Tn;
  e.u8 = {
    write: function(a, s, c) {
      a.writeUInt8(c, s);
    },
    read: function(a, s) {
      return a.readUInt8(s);
    },
    byteSize: 1,
    description: "u8"
  }, e.u16 = {
    write: function(a, s, c) {
      a.writeUInt16LE(c, s);
    },
    read: function(a, s) {
      return a.readUInt16LE(s);
    },
    byteSize: 2,
    description: "u16"
  }, e.u32 = {
    write: function(a, s, c) {
      a.writeUInt32LE(c, s);
    },
    read: function(a, s) {
      return a.readUInt32LE(s);
    },
    byteSize: 4,
    description: "u32"
  };
  function i(a, s) {
    return {
      write: function(c, l, u) {
        const d = (n.default.isBN(u) ? u : new n.default(u)).toArray("le", this.byteSize);
        Buffer.from(d).copy(c, l, 0, this.byteSize);
      },
      read: function(c, l) {
        const u = c.slice(l, l + this.byteSize);
        return new n.default(u, "le");
      },
      byteSize: a,
      description: s
    };
  }
  e.u64 = i(8, "u64"), e.u128 = i(16, "u128"), e.u256 = i(32, "u256"), e.u512 = i(64, "u512"), e.i8 = {
    write: function(a, s, c) {
      a.writeInt8(c, s);
    },
    read: function(a, s) {
      return a.readInt8(s);
    },
    byteSize: 1,
    description: "i8"
  }, e.i16 = {
    write: function(a, s, c) {
      a.writeInt16LE(c, s);
    },
    read: function(a, s) {
      return a.readInt16LE(s);
    },
    byteSize: 2,
    description: "i16"
  }, e.i32 = {
    write: function(a, s, c) {
      a.writeInt32LE(c, s);
    },
    read: function(a, s) {
      return a.readInt32LE(s);
    },
    byteSize: 4,
    description: "i32"
  };
  function o(a, s) {
    const c = a * 8;
    return {
      write: function(l, u, f) {
        const h = (n.default.isBN(f) ? f : new n.default(f)).toTwos(c).toArray("le", this.byteSize);
        Buffer.from(h).copy(l, u, 0, this.byteSize);
      },
      read: function(l, u) {
        const f = l.slice(u, u + this.byteSize);
        return new n.default(f, "le").fromTwos(c);
      },
      byteSize: a,
      description: s
    };
  }
  e.i64 = o(8, "i64"), e.i128 = o(16, "i128"), e.i256 = o(32, "i256"), e.i512 = o(64, "i512"), e.bool = {
    write: function(a, s, c) {
      const l = c ? 1 : 0;
      e.u8.write(a, s, l);
    },
    read: function(a, s) {
      return e.u8.read(a, s) === 1;
    },
    byteSize: 1,
    description: "bool"
  }, e.numbersTypeMap = {
    // <= 32-bit numbers and boolean
    u8: { beet: "u8", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "number" },
    u16: { beet: "u16", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "number" },
    u32: { beet: "u32", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "number" },
    i8: { beet: "i8", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "number" },
    i16: { beet: "i16", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "number" },
    i32: { beet: "i32", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "number" },
    bool: { beet: "bool", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "boolean" },
    // Big Number, they use, the 'bignum' type which is defined in this package
    u64: { beet: "u64", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "bignum", pack: r.BEET_PACKAGE },
    u128: { beet: "u128", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "bignum", pack: r.BEET_PACKAGE },
    u256: { beet: "u256", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "bignum", pack: r.BEET_PACKAGE },
    u512: { beet: "u512", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "bignum", pack: r.BEET_PACKAGE },
    i64: { beet: "i64", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "bignum", pack: r.BEET_PACKAGE },
    i128: { beet: "i128", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "bignum", pack: r.BEET_PACKAGE },
    i256: { beet: "i256", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "bignum", pack: r.BEET_PACKAGE },
    i512: { beet: "i512", isFixable: !1, sourcePack: r.BEET_PACKAGE, ts: "bignum", pack: r.BEET_PACKAGE }
  };
})(Ys);
var Qn = {}, $O = {
  white: 37,
  black: 30,
  blue: 34,
  cyan: 36,
  green: 32,
  magenta: 35,
  red: 31,
  yellow: 33,
  brightBlack: 90,
  brightRed: 91,
  brightGreen: 92,
  brightYellow: 93,
  brightBlue: 94,
  brightMagenta: 95,
  brightCyan: 96,
  brightWhite: 97
}, WO = {
  bgBlack: 40,
  bgRed: 41,
  bgGreen: 42,
  bgYellow: 43,
  bgBlue: 44,
  bgMagenta: 45,
  bgCyan: 46,
  bgWhite: 47,
  bgBrightBlack: 100,
  bgBrightRed: 101,
  bgBrightGreen: 102,
  bgBrightYellow: 103,
  bgBrightBlue: 104,
  bgBrightMagenta: 105,
  bgBrightCyan: 106,
  bgBrightWhite: 107
}, sT = {}, cT = {}, Yd = {};
Object.keys($O).forEach(function(e) {
  var t = sT[e] = "\x1B[" + $O[e] + "m", n = cT[e] = "\x1B[39m";
  Yd[e] = function(r) {
    return t + r + n;
  };
});
Object.keys(WO).forEach(function(e) {
  var t = sT[e] = "\x1B[" + WO[e] + "m", n = cT[e] = "\x1B[49m";
  Yd[e] = function(r) {
    return t + r + n;
  };
});
var $6 = Yd;
Yd.open = sT;
Yd.close = cT;
var W6 = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qn, "__esModule", { value: !0 });
Qn.UnreachableCaseError = Qn.stringify = Qn.bytes = Qn.beetBytes = Qn.logTrace = Qn.logDebug = Qn.logInfo = Qn.logError = void 0;
const M_ = W6(ak()), zte = W6($6), KO = Tn, { brightBlack: K6 } = zte.default;
Qn.logError = (0, M_.default)("beet:error");
Qn.logInfo = (0, M_.default)("beet:info");
Qn.logDebug = (0, M_.default)("beet:debug");
Qn.logTrace = (0, M_.default)("beet:trace");
function Fte(e, t = !1) {
  let n;
  if ((0, KO.isFixableBeet)(e))
    n = "? B";
  else if ((0, KO.isElementCollectionFixedSizeBeet)(e)) {
    const r = t ? "length" : e.length, i = e.lenPrefixByteSize;
    n = i > 0 ? `${i} + (${e.elementByteSize} * ${r}) B  (${e.byteSize} B)` : `(${e.elementByteSize} * ${r}) B (${e.byteSize} B)`;
  } else
    n = `${e.byteSize} B`;
  return K6(n);
}
Qn.beetBytes = Fte;
function Lte(e) {
  return K6(`${e} B`);
}
Qn.bytes = Lte;
function $te(e) {
  return e.toString === "function" ? e.toString() : e;
}
Qn.stringify = $te;
class Wte extends Error {
  constructor(t) {
    super(`Unreachable case: ${t}`);
  }
}
Qn.UnreachableCaseError = Wte;
var ga = {};
Object.defineProperty(ga, "__esModule", { value: !0 });
ga.fixBeetFromValue = ga.fixBeetFromData = void 0;
const em = Tn, V6 = Qn;
function Kte(e, t, n) {
  if ((0, em.isFixedSizeBeet)(e))
    return e;
  if ((0, em.isFixableBeet)(e))
    return e.toFixedFromData(t, n);
  throw new V6.UnreachableCaseError(e);
}
ga.fixBeetFromData = Kte;
function Vte(e, t) {
  if ((0, em.isFixedSizeBeet)(e))
    return e;
  if ((0, em.isFixableBeet)(e))
    return e.toFixedFromValue(t);
  throw new V6.UnreachableCaseError(e);
}
ga.fixBeetFromValue = Vte;
Object.defineProperty(Lr, "__esModule", { value: !0 });
Lr.collectionsTypeMap = Lr.uint8Array = Lr.fixedSizeUint8Array = Lr.fixedSizeBuffer = Lr.array = Lr.fixedSizeArray = Lr.uniformFixedSizeArray = void 0;
const Su = Tn, jc = ki(), Zs = Ys, Eu = Tn, q6 = Qn, VO = ga;
function qte(e, t, n = !1) {
  const r = e.byteSize * t, i = n ? 4 + r : r;
  return {
    write: function(o, a, s) {
      jc.strict.equal(s.length, t, `array length ${s.length} should match len ${t}`), n && (Zs.u32.write(o, a, t), a += 4);
      for (let c = 0; c < t; c++)
        e.write(o, a + c * e.byteSize, s[c]);
    },
    read: function(o, a) {
      if (n) {
        const c = Zs.u32.read(o, a);
        jc.strict.equal(c, t, "invalid byte size"), a += 4;
      }
      const s = new Array(t);
      for (let c = 0; c < t; c++)
        s[c] = e.read(o, a + c * e.byteSize);
      return s;
    },
    byteSize: i,
    length: t,
    elementByteSize: e.byteSize,
    lenPrefixByteSize: 4,
    description: `Array<${e.description}>(${t})`
  };
}
Lr.uniformFixedSizeArray = qte;
function LA(e, t) {
  const n = e.length, r = n === 0 ? "<EMPTY>" : e[0].description;
  return {
    write: function(i, o, a) {
      jc.strict.equal(a.length, n, `array length ${a.length} should match len ${n}`), Zs.u32.write(i, o, n);
      let s = o + 4;
      for (let c = 0; c < n; c++) {
        const l = e[c];
        l.write(i, s, a[c]), s += l.byteSize;
      }
    },
    read: function(i, o) {
      const a = Zs.u32.read(i, o);
      jc.strict.equal(a, n, "invalid byte size");
      let s = o + 4;
      const c = new Array(n);
      for (let l = 0; l < n; l++) {
        const u = e[l];
        c[l] = u.read(i, s), s += u.byteSize;
      }
      return c;
    },
    byteSize: 4 + t,
    length: n,
    description: `Array<${r}>(${n})[ 4 + ${t} ]`
  };
}
Lr.fixedSizeArray = LA;
function Hte(e) {
  return {
    toFixedFromData(t, n) {
      const r = Zs.u32.read(t, n);
      (0, q6.logTrace)(`${this.description}[${r}]`);
      const i = n + 4;
      let o = i;
      const a = new Array(r);
      for (let s = 0; s < r; s++) {
        const c = (0, VO.fixBeetFromData)(e, t, o);
        a[s] = c, o += c.byteSize;
      }
      return LA(a, o - i);
    },
    toFixedFromValue(t) {
      (0, jc.strict)(Array.isArray(t), `${t} should be an array`);
      let n = 0;
      const r = new Array(t.length);
      for (let i = 0; i < t.length; i++) {
        const o = (0, VO.fixBeetFromValue)(e, t[i]);
        r[i] = o, n += o.byteSize;
      }
      return LA(r, n);
    },
    description: "array"
  };
}
Lr.array = Hte;
function H6(e) {
  return {
    write: function(t, n, r) {
      r.copy(t, n, 0, e);
    },
    read: function(t, n) {
      return t.slice(n, n + e);
    },
    byteSize: e,
    description: `Buffer(${e})`
  };
}
Lr.fixedSizeBuffer = H6;
function $A(e, t = !1) {
  const n = H6(e), r = t ? e + 4 : e;
  return {
    write: function(i, o, a) {
      jc.strict.equal(a.byteLength, e, `Uint8Array length ${a.byteLength} should match len ${e}`), t && (Zs.u32.write(i, o, e), o += 4);
      const s = Buffer.from(a);
      n.write(i, o, s);
    },
    read: function(i, o) {
      if (t) {
        const s = Zs.u32.read(i, o);
        jc.strict.equal(s, e, "invalid byte size"), o += 4;
      }
      const a = n.read(i, o);
      return Uint8Array.from(a);
    },
    byteSize: r,
    description: `Uint8Array(${e})`
  };
}
Lr.fixedSizeUint8Array = $A;
Lr.uint8Array = {
  toFixedFromData(e, t) {
    const n = Zs.u32.read(e, t);
    return (0, q6.logTrace)(`${this.description}[${n}]`), $A(n, !0);
  },
  toFixedFromValue(e) {
    const t = e.byteLength;
    return $A(t, !0);
  },
  description: "Uint8Array"
};
Lr.collectionsTypeMap = {
  Array: {
    beet: "array",
    isFixable: !0,
    sourcePack: Eu.BEET_PACKAGE,
    ts: "Array",
    arg: Su.BEET_TYPE_ARG_LEN
  },
  FixedSizeArray: {
    beet: "fixedSizeArray",
    isFixable: !1,
    sourcePack: Eu.BEET_PACKAGE,
    ts: "Array",
    arg: Su.BEET_TYPE_ARG_LEN
  },
  UniformFixedSizeArray: {
    beet: "uniformFixedSizeArray",
    isFixable: !1,
    sourcePack: Eu.BEET_PACKAGE,
    ts: "Array",
    arg: Su.BEET_TYPE_ARG_LEN
  },
  Buffer: {
    beet: "fixedSizeBuffer",
    isFixable: !1,
    sourcePack: Eu.BEET_PACKAGE,
    ts: "Buffer",
    arg: Su.BEET_TYPE_ARG_LEN
  },
  FixedSizeUint8Array: {
    beet: "fixedSizeUint8Array",
    isFixable: !1,
    sourcePack: Eu.BEET_PACKAGE,
    ts: "Uint8Array",
    arg: Su.BEET_TYPE_ARG_LEN
  },
  Uint8Array: {
    beet: "uint8Array",
    isFixable: !0,
    sourcePack: Eu.BEET_PACKAGE,
    ts: "Uint8Array",
    arg: Su.BEET_TYPE_ARG_LEN
  }
};
var li = {};
Object.defineProperty(li, "__esModule", { value: !0 });
li.compositesTypeMap = li.coption = li.coptionSome = li.coptionNone = li.isNoneBuffer = li.isSomeBuffer = void 0;
const bd = ki(), WA = Tn, qO = Tn, G6 = Qn, HO = ga, Y6 = 0, Z6 = 1;
function uT(e, t) {
  return e[t] === Z6;
}
li.isSomeBuffer = uT;
function lT(e, t) {
  return e[t] === Y6;
}
li.isNoneBuffer = lT;
function KA(e) {
  return (0, G6.logTrace)(`coptionNone(${e})`), {
    write: function(t, n, r) {
      (0, bd.strict)(r == null, "coptionNone can only handle `null` values"), t[n] = Y6;
    },
    read: function(t, n) {
      return (0, bd.strict)(lT(t, n), "coptionNone can only handle `NONE` data"), null;
    },
    byteSize: 1,
    description: `COption<None(${e})>`
  };
}
li.coptionNone = KA;
function VA(e) {
  const t = 1 + e.byteSize, n = {
    write: function(r, i, o) {
      (0, WA.assertFixedSizeBeet)(e, `coption inner type ${e.description} needs to be fixed before calling write`), (0, bd.strict)(o != null, "coptionSome cannot handle `null` values"), r[i] = Z6, e.write(r, i + 1, o);
    },
    read: function(r, i) {
      return (0, WA.assertFixedSizeBeet)(e, `coption inner type ${e.description} needs to be fixed before calling read`), (0, bd.strict)(uT(r, i), "coptionSome can only handle `SOME` data"), e.read(r, i + 1);
    },
    description: `COption<${e.description}>[1 + ${e.byteSize}]`,
    byteSize: t,
    inner: e
  };
  return (0, G6.logTrace)(n.description), n;
}
li.coptionSome = VA;
function Gte(e) {
  return {
    toFixedFromData(t, n) {
      if (uT(t, n)) {
        const r = (0, HO.fixBeetFromData)(e, t, n + 1);
        return VA(r);
      } else
        return (0, bd.strict)(lT(t, n), `Expected ${t} to hold a COption`), KA(e.description);
    },
    toFixedFromValue(t) {
      return t == null ? KA(e.description) : VA((0, HO.fixBeetFromValue)(e, t));
    },
    description: `COption<${e.description}>`
  };
}
li.coption = Gte;
li.compositesTypeMap = {
  option: {
    beet: "coption",
    isFixable: !0,
    sourcePack: qO.BEET_PACKAGE,
    ts: "COption<Inner>",
    arg: WA.BEET_TYPE_ARG_INNER,
    pack: qO.BEET_PACKAGE
  }
};
var qA = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.stringTypeMap = e.utf8String = e.fixedSizeUtf8String = void 0;
  const t = Tn, n = ki(), r = Ys, i = Qn, o = (a) => ({
    write: function(s, c, l) {
      const u = Buffer.from(l, "utf8");
      n.strict.equal(u.byteLength, a, `${l} has invalid byte size`), r.u32.write(s, c, a), u.copy(s, c + 4, 0, a);
    },
    read: function(s, c) {
      const l = r.u32.read(s, c);
      return n.strict.equal(l, a, "invalid byte size"), s.slice(c + 4, c + 4 + a).toString("utf8");
    },
    elementByteSize: 1,
    length: a,
    lenPrefixByteSize: 4,
    byteSize: 4 + a,
    description: `Utf8String(4 + ${a})`
  });
  e.fixedSizeUtf8String = o, e.utf8String = {
    toFixedFromData(a, s) {
      const c = r.u32.read(a, s);
      return (0, i.logTrace)(`${this.description}[${c}]`), (0, e.fixedSizeUtf8String)(c);
    },
    toFixedFromValue(a) {
      const s = Buffer.from(a).byteLength;
      return (0, e.fixedSizeUtf8String)(s);
    },
    description: "Utf8String"
  }, e.stringTypeMap = {
    fixedSizeString: {
      beet: "fixedSizeUtf8String",
      isFixable: !1,
      sourcePack: t.BEET_PACKAGE,
      ts: "string",
      arg: t.BEET_TYPE_ARG_LEN
    },
    string: {
      beet: "utf8String",
      isFixable: !0,
      sourcePack: t.BEET_PACKAGE,
      ts: "string"
    }
  };
})(qA);
var xo = {}, ha = {}, Uc = {};
Object.defineProperty(Uc, "__esModule", { value: !0 });
Uc.BeetReader = Uc.BeetWriter = void 0;
const Yte = ki();
class Zte {
  constructor(t) {
    this.buf = Buffer.alloc(t), this._offset = 0;
  }
  get buffer() {
    return this.buf;
  }
  get offset() {
    return this._offset;
  }
  maybeResize(t) {
    this._offset + t > this.buf.length && Yte.strict.fail(`We shouldn't ever need to resize, but ${this._offset + t} > ${this.buf.length}`);
  }
  write(t, n) {
    this.maybeResize(t.byteSize), t.write(this.buf, this._offset, n), this._offset += t.byteSize;
  }
  writeStruct(t, n) {
    for (const [r, i] of n) {
      const o = t[r];
      this.write(i, o);
    }
  }
}
Uc.BeetWriter = Zte;
class Jte {
  constructor(t, n = 0) {
    this.buffer = t, this._offset = n;
  }
  get offset() {
    return this._offset;
  }
  read(t) {
    const n = t.read(this.buffer, this._offset);
    return this._offset += t.byteSize, n;
  }
  readStruct(t) {
    const n = {};
    for (const [r, i] of t)
      n[r] = this.read(i);
    return n;
  }
}
Uc.BeetReader = Jte;
Object.defineProperty(ha, "__esModule", { value: !0 });
ha.BeetArgsStruct = ha.isBeetStruct = ha.BeetStruct = void 0;
const GO = Uc, Ia = Qn;
class Js {
  /**
   * Creates an instance of the BeetStruct.
   *
   * @param fields de/serializers for each field of the {@link Class}
   * @param construct the function that creates an instance of {@link Class}
   * from the args
   * @param description identifies this struct for diagnostics/debugging
   * purposes
   */
  constructor(t, n, r = Js.description) {
    if (this.fields = t, this.construct = n, this.description = r, this.byteSize = this.getByteSize(), Ia.logDebug.enabled) {
      const i = t.map(([o, a]) => `${String(o)}: ${a.description} ${(0, Ia.beetBytes)(a)}`).join(`
  `);
      (0, Ia.logDebug)(`struct ${r} {
  ${i}
} ${(0, Ia.beetBytes)(this)}`);
    }
  }
  /**
   * Along with `write` this allows structs to be treated as {@link Beet}s and
   * thus supports composing/nesting them the same way.
   * @private
   */
  read(t, n) {
    const [r] = this.deserialize(t, n);
    return r;
  }
  /**
   * Along with `read` this allows structs to be treated as {@link Beet}s and
   * thus supports composing/nesting them the same way.
   * @private
   */
  write(t, n, r) {
    const [i, o] = this.serialize(r);
    i.copy(t, n, 0, o);
  }
  /**
   * Deserializes an instance of the Class from the provided buffer starting to
   * read at the provided offset.
   *
   * @returns `[instance of Class, offset into buffer after deserialization completed]`
   */
  deserialize(t, n = 0) {
    Ia.logTrace.enabled && ((0, Ia.logTrace)("deserializing [%s] from %d bytes buffer", this.description, t.byteLength), (0, Ia.logTrace)(t), (0, Ia.logTrace)(t.toJSON().data));
    const r = new GO.BeetReader(t, n), i = r.readStruct(this.fields);
    return [this.construct(i), r.offset];
  }
  /**
   * Serializes the provided instance into a new {@link Buffer}
   *
   * @param instance of the struct to serialize
   * @param byteSize allows to override the size fo the created Buffer and
   * defaults to the size of the struct to serialize
   */
  serialize(t, n = this.byteSize) {
    (0, Ia.logTrace)("serializing [%s] %o to %d bytes buffer", this.description, t, n);
    const r = new GO.BeetWriter(n);
    return r.writeStruct(t, this.fields), [r.buffer, r.offset];
  }
  getByteSize() {
    return this.fields.reduce((t, [n, r]) => t + r.byteSize, 0);
  }
  get type() {
    return Js.TYPE;
  }
}
ha.BeetStruct = Js;
Js.description = "BeetStruct";
Js.TYPE = "BeetStruct";
function Xte(e) {
  return e.type === Js.TYPE;
}
ha.isBeetStruct = Xte;
class O_ extends Js {
  constructor(t, n = O_.description) {
    super(t, (r) => r, n);
  }
}
ha.BeetArgsStruct = O_;
O_.description = "BeetArgsStruct";
var Fa = {}, Qte = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Fa, "__esModule", { value: !0 });
Fa.FixableBeetArgsStruct = Fa.isFixableBeetStruct = Fa.FixableBeetStruct = void 0;
const YO = ga, Bg = ha, ene = Tn, tne = ki(), sS = Qn, nne = Qte($6), { brightBlack: rne } = nne.default;
class aa {
  /**
   * Creates an instance of the {@link FixableBeetStruct}.
   *
   * @param fields fixed or fixable de/serializers for each field of the {@link Class}
   * @param construct the function that creates an instance of {@link Class}
   * from the args
   * @param description identifies this struct for diagnostics/debugging
   * purposes
   */
  constructor(t, n, r = aa.description) {
    this.fields = t, this.construct = n, this.description = r;
    let i = 0;
    if (sS.logDebug.enabled) {
      const o = t.map(([s, c]) => ((0, ene.isFixedSizeBeet)(c) && (i += c.byteSize), `${s}: ${c.description} ${(0, sS.beetBytes)(c)}`)).join(`
  `), a = `> ${i} B`;
      (0, sS.logDebug)(`struct ${r} {
  ${o}
} ${rne(a)}`);
    }
  }
  /**
   * Deserializes an instance of the Class from the provided buffer starting to
   * read at the provided offset.
   *
   * @returns `[instance of Class, offset into buffer after deserialization completed]`
   */
  deserialize(t, n = 0) {
    return this.toFixedFromData(t, n).deserialize(t, n);
  }
  /**
   * Serializes the provided instance into a new {@link Buffer}
   *
   * **NOTE:** that the `instance` is traversed and each of its fields accessed
   * twice, once to derive a _fixed size_ {@link BeetStruct} and then use it to
   * serialize the `instance`.
   * Therefore ensure that none of the properties that are part of the struct
   * have side effects, i.e. via `Getter`s.
   *
   * @param instance of the struct to serialize
   * @param byteSize allows to override the size fo the created Buffer and
   * defaults to the size of the struct to serialize
   */
  serialize(t, n) {
    return this.toFixedFromValue(t).serialize(t, n);
  }
  toFixedFromData(t, n) {
    let r = n;
    const i = new Array(this.fields.length);
    for (let o = 0; o < this.fields.length; o++) {
      const [a, s] = this.fields[o], c = (0, YO.fixBeetFromData)(s, t, r);
      i[o] = [a, c], r += c.byteSize;
    }
    return this.description !== aa.description ? new Bg.BeetStruct(i, this.construct, this.description) : new Bg.BeetStruct(i, this.construct);
  }
  toFixedFromValue(t) {
    const n = Object.keys(t), r = new Array(this.fields.length);
    for (let i = 0; i < this.fields.length; i++) {
      const [o, a] = this.fields[i];
      (0, tne.strict)(n.includes(o), `Value with keys [ ${n} ] should include struct key '${o}' but doesn't.`);
      const s = t[o], c = (0, YO.fixBeetFromValue)(a, s);
      r[i] = [o, c];
    }
    return this.description !== aa.description ? new Bg.BeetStruct(r, this.construct, this.description) : new Bg.BeetStruct(r, this.construct);
  }
  get type() {
    return aa.TYPE;
  }
}
Fa.FixableBeetStruct = aa;
aa.description = "FixableBeetStruct";
aa.TYPE = "FixableBeetStruct";
function ine(e) {
  return e.type === aa.TYPE;
}
Fa.isFixableBeetStruct = ine;
class P_ extends aa {
  constructor(t, n = P_.description) {
    super(t, (r) => r, n);
  }
}
Fa.FixableBeetArgsStruct = P_;
P_.description = "FixableBeetArgsStruct";
var Xs = {};
Object.defineProperty(Xs, "__esModule", { value: !0 });
Xs.unitTypeMap = Xs.unit = void 0;
const one = Tn;
Xs.unit = {
  write: function(e, t, n) {
  },
  read: function(e, t) {
  },
  byteSize: 0,
  description: "unit"
};
Xs.unitTypeMap = {
  unit: {
    beet: "unit",
    isFixable: !1,
    sourcePack: one.BEET_PACKAGE,
    ts: "void"
  }
};
Object.defineProperty(xo, "__esModule", { value: !0 });
xo.enumsTypeMap = xo.dataEnum = xo.uniformDataEnum = xo.fixedScalarEnum = void 0;
const Ss = Tn, Mo = Ys, Uu = ki(), ane = ha, sne = Fa, cne = Xs;
function ZO(e, t) {
  return t ? `${e}` : e;
}
function une(e) {
  const t = Object.keys(e);
  return {
    write(n, r, i) {
      const o = typeof i == "number", a = ZO(i, o);
      if (t.includes(a) || Uu.strict.fail(`${i} should be a variant of the provided enum type, i.e. [ ${Object.values(e).join(", ")} ], but isn't`), o)
        Mo.u8.write(n, r, i);
      else {
        const s = e[a];
        Mo.u8.write(n, r, s);
      }
    },
    read(n, r) {
      const i = Mo.u8.read(n, r), o = typeof i == "number", a = ZO(i, o);
      return t.includes(a) || Uu.strict.fail(`${i} should be a of a variant of the provided enum type, i.e. [ ${Object.values(e).join(", ")} ], but isn't`), o ? i : e[a];
    },
    byteSize: Mo.u8.byteSize,
    description: "Enum"
  };
}
xo.fixedScalarEnum = une;
function lne(e) {
  return {
    write: function(t, n, r) {
      Mo.u8.write(t, n, r.kind), e.write(t, n + 1, r.data);
    },
    read: function(t, n) {
      const r = Mo.u8.read(t, n), i = e.read(t, n + 1);
      return { kind: r, data: i };
    },
    byteSize: 1 + e.byteSize,
    description: `UniformDataEnum<${e.description}>`
  };
}
xo.uniformDataEnum = lne;
function JO(e, t, n) {
  return {
    write(r, i, o) {
      Mo.u8.write(r, i, t), e.write(r, i + Mo.u8.byteSize, o);
    },
    read(r, i) {
      const o = e.read(r, i + Mo.u8.byteSize);
      return { __kind: n, ...o };
    },
    byteSize: e.byteSize + Mo.u8.byteSize,
    description: `EnumData<${e.description}>`
  };
}
function fne(e) {
  for (const [t, n] of e)
    (0, Uu.strict)((0, ane.isBeetStruct)(n) || (0, sne.isFixableBeetStruct)(n) || // scalar variant
    n === cne.unit, "dataEnum: variants must be a data beet struct or a scalar unit");
  return {
    toFixedFromData(t, n) {
      const r = Mo.u8.read(t, n), i = e[r];
      (0, Uu.strict)(i != null, `Discriminant ${r} out of range for ${e.length} variants`);
      const [o, a] = i, s = (0, Ss.isFixedSizeBeet)(a) ? a : a.toFixedFromData(t, n + 1);
      return JO(s, r, o);
    },
    toFixedFromValue(t) {
      if (t.__kind == null) {
        const l = Object.keys(t).join(", "), u = e.map(([f]) => f).join(", ");
        Uu.strict.fail(`Value with fields [ ${l} ] is missing __kind, which needs to be set to one of [ ${u} ]`);
      }
      const n = e.findIndex(([l]) => l === t.__kind);
      if (n < 0) {
        const l = e.map(([u]) => u).join(", ");
        Uu.strict.fail(`${t.__kind} is not a valid kind, needs to be one of [ ${l} ]`);
      }
      const r = e[n], { __kind: i, ...o } = t, [a, s] = r, c = (0, Ss.isFixedSizeBeet)(s) ? s : s.toFixedFromValue(o);
      return JO(c, n, a);
    },
    description: `DataEnum<${e.length} variants>`
  };
}
xo.dataEnum = fne;
xo.enumsTypeMap = {
  fixedScalarEnum: {
    beet: "fixedScalarEnum",
    isFixable: !1,
    sourcePack: Ss.BEET_PACKAGE,
    ts: "<TypeName>",
    arg: Ss.BEET_TYPE_ARG_INNER,
    pack: Ss.BEET_PACKAGE
  },
  dataEnum: {
    beet: "dataEnum",
    isFixable: !1,
    sourcePack: Ss.BEET_PACKAGE,
    ts: "DataEnum<Kind, Inner>",
    arg: Ss.BEET_TYPE_ARG_INNER,
    pack: Ss.BEET_PACKAGE
  }
};
var zc = {};
Object.defineProperty(zc, "__esModule", { value: !0 });
zc.aliasesTypeMap = zc.bytes = void 0;
const J6 = Lr;
zc.bytes = J6.uint8Array;
zc.aliasesTypeMap = {
  // @ts-ignore
  bytes: J6.collectionsTypeMap.Uint8Array
};
var La = {};
Object.defineProperty(La, "__esModule", { value: !0 });
La.tuplesTypeMap = La.tuple = La.fixedSizeTuple = void 0;
const XO = Tn, HA = ki(), QO = ga;
function GA(e) {
  const t = e.length, n = e.map((o) => o.description), r = e.map((o) => o.byteSize), i = r.reduce((o, a) => o + a, 0);
  return {
    write: function(o, a, s) {
      HA.strict.equal(s.length, t, `tuple value element size ${s.length} should match len ${t}`);
      let c = a;
      for (let l = 0; l < t; l++) {
        const u = s[l], f = e[l];
        f.write(o, c, u), c += f.byteSize;
      }
    },
    read: function(o, a) {
      const s = [];
      let c = a;
      for (let l = 0; l < t; l++) {
        const u = e[l];
        s[l] = u.read(o, c), c += u.byteSize;
      }
      return s;
    },
    byteSize: i,
    length: t,
    description: `FixedSizeTuple<${n.join(",")}>[ ${r.join(", ")} ]`
  };
}
La.fixedSizeTuple = GA;
function dne(e) {
  const t = e.length, n = e.map((r) => r.description);
  return {
    toFixedFromData(r, i) {
      let o = i;
      const a = new Array(t);
      for (let s = 0; s < t; s++) {
        const c = (0, QO.fixBeetFromData)(e[s], r, o);
        a[s] = c, o += c.byteSize;
      }
      return GA(a);
    },
    toFixedFromValue(r) {
      (0, HA.strict)(Array.isArray(r), `${r} should be an array of tuple values`), HA.strict.equal(r.length, t, `There should be ${t} tuple values, but there are ${r.length}`);
      const i = new Array(t);
      for (let o = 0; o < r.length; o++) {
        const a = (0, QO.fixBeetFromValue)(e[o], r[o]);
        i[o] = a;
      }
      return GA(i);
    },
    description: `Tuple<${n.join(",")}>`
  };
}
La.tuple = dne;
La.tuplesTypeMap = {
  Tuple: {
    beet: "tuple",
    isFixable: !0,
    sourcePack: XO.BEET_PACKAGE,
    ts: "[__tuple_elements__]"
  },
  FixedSizeTuple: {
    beet: "fixedSizeTuple",
    isFixable: !1,
    sourcePack: XO.BEET_PACKAGE,
    ts: "[__tuple_elements__]"
  }
};
var Fc = {};
Object.defineProperty(Fc, "__esModule", { value: !0 });
Fc.mapsTypeMap = Fc.map = void 0;
const md = Tn, YA = Ys, hne = Qn, cS = ki();
function Cg(e, t, n, r) {
  const i = (0, md.isFixedSizeBeet)(e), o = (0, md.isFixedSizeBeet)(t);
  function a() {
    if (i && o) {
      const l = e.byteSize + t.byteSize;
      return {
        elementByteSize: l,
        byteSize: 4 + r * l
      };
    } else if (i) {
      let l = 0;
      for (const [f, d] of n.values())
        l += d.byteSize;
      return {
        elementByteSize: e.byteSize + Math.ceil(l / r),
        byteSize: 4 + e.byteSize * r + l
      };
    } else if (o) {
      let l = 0;
      for (const [f, d] of n.values())
        l += f.byteSize;
      return {
        elementByteSize: Math.ceil(l / r) + t.byteSize,
        byteSize: 4 + l + t.byteSize * r
      };
    } else {
      let l = 0, u = 0;
      for (const [d, h] of n.values())
        l += d.byteSize, u += h.byteSize;
      return {
        elementByteSize: Math.ceil(l / r + u / r),
        byteSize: 4 + l + u
      };
    }
  }
  const { elementByteSize: s, byteSize: c } = a();
  return {
    write: function(l, u, f) {
      let d = u + 4, h = 0;
      for (const [g, w] of f.entries()) {
        let b = i ? e : null, I = o ? t : null;
        if (b == null || I == null) {
          const A = n.get(g);
          (0, cS.strict)(A != null, `Should be able to find beet els for ${(0, hne.stringify)(g)}, but could not`), b ?? (b = A[0]), I ?? (I = A[1]);
        }
        b.write(l, d, g), d += b.byteSize, I.write(l, d, w), d += I.byteSize, h++;
      }
      YA.u32.write(l, u, h), cS.strict.equal(h, r, `Expected map to have size ${r}, but has ${h}.`);
    },
    read: function(l, u) {
      const f = YA.u32.read(l, u);
      cS.strict.equal(f, r, `Expected map to have size ${r}, but has ${f}.`);
      let d = u + 4;
      const h = /* @__PURE__ */ new Map();
      for (let g = 0; g < f; g++) {
        const w = i ? e : e.toFixedFromData(l, d), b = w.read(l, d);
        d += w.byteSize;
        const I = o ? t : t.toFixedFromData(l, d), A = I.read(l, d);
        d += I.byteSize, h.set(b, A);
      }
      return h;
    },
    elementByteSize: s,
    byteSize: c,
    length: r,
    lenPrefixByteSize: 4,
    description: `Map<${e.description}, ${t.description}>`
  };
}
function pne(e, t) {
  const n = (0, md.isFixedSizeBeet)(e), r = (0, md.isFixedSizeBeet)(t);
  return {
    toFixedFromData(i, o) {
      const a = YA.u32.read(i, o);
      let s = o + 4;
      if (n && r)
        return Cg(e, t, /* @__PURE__ */ new Map(), a);
      const c = /* @__PURE__ */ new Map();
      for (let l = 0; l < a; l++) {
        const u = n ? e : e.toFixedFromData(i, s), f = u.read(i, s);
        s += u.byteSize;
        const d = r ? t : t.toFixedFromData(i, s);
        s += d.byteSize, c.set(f, [u, d]);
      }
      return Cg(e, t, c, a);
    },
    toFixedFromValue(i) {
      const o = i.size;
      if (n && r)
        return Cg(e, t, /* @__PURE__ */ new Map(), o);
      const a = /* @__PURE__ */ new Map();
      for (const [s, c] of i) {
        const l = n ? e : e.toFixedFromValue(s), u = r ? t : t.toFixedFromValue(c);
        a.set(s, [l, u]);
      }
      return Cg(e, t, a, o);
    },
    description: `FixableMap<${e.description}, ${t.description}>`
  };
}
Fc.map = pne;
Fc.mapsTypeMap = {
  Map: {
    beet: "map",
    isFixable: !0,
    sourcePack: md.BEET_PACKAGE,
    ts: "Map"
  }
};
var Lc = {};
Object.defineProperty(Lc, "__esModule", { value: !0 });
Lc.setsTypeMap = Lc.set = void 0;
const fT = Tn, ZA = Ys, yne = Qn, uS = ki();
function Dg(e, t, n) {
  const r = (0, fT.isFixedSizeBeet)(e);
  function i() {
    if (r) {
      const s = e.byteSize;
      return {
        elementByteSize: s,
        byteSize: 4 + n * s
      };
    } else {
      let s = 0;
      for (const l of t.values())
        s += l.byteSize;
      return {
        elementByteSize: Math.ceil(s / n),
        byteSize: 4 + s
      };
    }
  }
  const { elementByteSize: o, byteSize: a } = i();
  return {
    write: function(s, c, l) {
      let u = c + 4, f = 0;
      for (const d of l.keys()) {
        let h = r ? e : null;
        if (h == null) {
          const g = t.get(d);
          (0, uS.strict)(g != null, `Should be able to find beet el for ${(0, yne.stringify)(d)}, but could not`), h ?? (h = g);
        }
        h.write(s, u, d), u += h.byteSize, f++;
      }
      ZA.u32.write(s, c, f), uS.strict.equal(f, n, `Expected set to have size ${n}, but has ${f}.`);
    },
    read: function(s, c) {
      const l = ZA.u32.read(s, c);
      uS.strict.equal(l, n, `Expected set to have size ${n}, but has ${l}.`);
      let u = c + 4;
      const f = /* @__PURE__ */ new Set();
      for (let d = 0; d < l; d++) {
        const h = r ? e : e.toFixedFromData(s, u), g = h.read(s, u);
        u += h.byteSize, f.add(g);
      }
      return f;
    },
    elementByteSize: o,
    byteSize: a,
    length: n,
    lenPrefixByteSize: 4,
    description: `Set<${e.description}>`
  };
}
function gne(e) {
  const t = (0, fT.isFixedSizeBeet)(e);
  return {
    toFixedFromData(n, r) {
      const i = ZA.u32.read(n, r);
      let o = r + 4;
      if (t)
        return Dg(e, /* @__PURE__ */ new Map(), i);
      const a = /* @__PURE__ */ new Map();
      for (let s = 0; s < i; s++) {
        const c = t ? e : e.toFixedFromData(n, o), l = c.read(n, o);
        o += c.byteSize, a.set(l, c);
      }
      return Dg(e, a, i);
    },
    toFixedFromValue(n) {
      const r = n.size;
      if (t)
        return Dg(e, /* @__PURE__ */ new Map(), r);
      const i = /* @__PURE__ */ new Map();
      for (const o of n) {
        const a = t ? e : e.toFixedFromValue(o);
        i.set(o, a);
      }
      return Dg(e, i, r);
    },
    description: `FixableSet<${e.description}>`
  };
}
Lc.set = gne;
Lc.setsTypeMap = {
  Set: {
    beet: "set",
    isFixable: !0,
    sourcePack: fT.BEET_PACKAGE,
    ts: "Set"
  }
};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(h, g, w, b) {
    b === void 0 && (b = w);
    var I = Object.getOwnPropertyDescriptor(g, w);
    (!I || ("get" in I ? !g.__esModule : I.writable || I.configurable)) && (I = { enumerable: !0, get: function() {
      return g[w];
    } }), Object.defineProperty(h, b, I);
  } : function(h, g, w, b) {
    b === void 0 && (b = w), h[b] = g[w];
  }), n = _ && _.__exportStar || function(h, g) {
    for (var w in h)
      w !== "default" && !Object.prototype.hasOwnProperty.call(g, w) && t(g, h, w);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.supportedTypeMap = void 0;
  const r = Lr, i = li, o = Ys, a = qA, s = xo, c = zc, l = La, u = Fc, f = Xs, d = Lc;
  n(zc, e), n(Lr, e), n(li, e), n(xo, e), n(Fc, e), n(Ys, e), n(Lc, e), n(qA, e), n(La, e), n(Xs, e), n(ga, e), n(Uc, e), n(ha, e), n(Fa, e), n(Tn, e), e.supportedTypeMap = {
    ...r.collectionsTypeMap,
    ...a.stringTypeMap,
    ...i.compositesTypeMap,
    ...s.enumsTypeMap,
    ...o.numbersTypeMap,
    ...c.aliasesTypeMap,
    ...l.tuplesTypeMap,
    ...u.mapsTypeMap,
    ...d.setsTypeMap,
    ...f.unitTypeMap
  };
})(Se);
var zn = {}, $c = {};
Object.defineProperty($c, "__esModule", { value: !0 });
$c.keysTypeMap = $c.publicKey = void 0;
const bne = we, mne = Se, _ne = "@metaplex-foundation/beet-solana", wne = "@solana/web3.js", lS = (0, mne.fixedSizeUint8Array)(32);
$c.publicKey = {
  write: function(e, t, n) {
    const r = n.toBytes();
    lS.write(e, t, r);
  },
  read: function(e, t) {
    const n = lS.read(e, t);
    return new bne.PublicKey(n);
  },
  byteSize: lS.byteSize,
  description: "PublicKey"
};
$c.keysTypeMap = {
  publicKey: {
    beet: "publicKey",
    isFixable: !1,
    sourcePack: _ne,
    ts: "PublicKey",
    pack: wne
  }
};
var B_ = {}, sa = {}, vne = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(sa, "__esModule", { value: !0 });
sa.logTrace = sa.logDebug = sa.logInfo = sa.logError = void 0;
const C_ = vne(ak());
sa.logError = (0, C_.default)("beet:error");
sa.logInfo = (0, C_.default)("beet:info");
sa.logDebug = (0, C_.default)("beet:debug");
sa.logTrace = (0, C_.default)("beet:trace");
var D_ = {};
function Sne(e) {
  if (e.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var t = new Uint8Array(256), n = 0; n < t.length; n++)
    t[n] = 255;
  for (var r = 0; r < e.length; r++) {
    var i = e.charAt(r), o = i.charCodeAt(0);
    if (t[o] !== 255)
      throw new TypeError(i + " is ambiguous");
    t[o] = r;
  }
  var a = e.length, s = e.charAt(0), c = Math.log(a) / Math.log(256), l = Math.log(256) / Math.log(a);
  function u(h) {
    if (h instanceof Uint8Array || (ArrayBuffer.isView(h) ? h = new Uint8Array(h.buffer, h.byteOffset, h.byteLength) : Array.isArray(h) && (h = Uint8Array.from(h))), !(h instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (h.length === 0)
      return "";
    for (var g = 0, w = 0, b = 0, I = h.length; b !== I && h[b] === 0; )
      b++, g++;
    for (var A = (I - b) * l + 1 >>> 0, x = new Uint8Array(A); b !== I; ) {
      for (var N = h[b], j = 0, K = A - 1; (N !== 0 || j < w) && K !== -1; K--, j++)
        N += 256 * x[K] >>> 0, x[K] = N % a >>> 0, N = N / a >>> 0;
      if (N !== 0)
        throw new Error("Non-zero carry");
      w = j, b++;
    }
    for (var W = A - w; W !== A && x[W] === 0; )
      W++;
    for (var O = s.repeat(g); W < A; ++W)
      O += e.charAt(x[W]);
    return O;
  }
  function f(h) {
    if (typeof h != "string")
      throw new TypeError("Expected String");
    if (h.length === 0)
      return new Uint8Array();
    for (var g = 0, w = 0, b = 0; h[g] === s; )
      w++, g++;
    for (var I = (h.length - g) * c + 1 >>> 0, A = new Uint8Array(I); h[g]; ) {
      var x = t[h.charCodeAt(g)];
      if (x === 255)
        return;
      for (var N = 0, j = I - 1; (x !== 0 || N < b) && j !== -1; j--, N++)
        x += a * A[j] >>> 0, A[j] = x % 256 >>> 0, x = x / 256 >>> 0;
      if (x !== 0)
        throw new Error("Non-zero carry");
      b = N, g++;
    }
    for (var K = I - b; K !== I && A[K] === 0; )
      K++;
    for (var W = new Uint8Array(w + (I - K)), O = w; K !== I; )
      W[O++] = A[K++];
    return W;
  }
  function d(h) {
    var g = f(h);
    if (g)
      return g;
    throw new Error("Non-base" + a + " character");
  }
  return {
    encode: u,
    decodeUnsafe: f,
    decode: d
  };
}
var Ene = Sne;
const Ane = Ene, Ine = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var X6 = Ane(Ine);
const kne = /* @__PURE__ */ Vi(X6);
var Tne = _ && _.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(D_, "__esModule", { value: !0 });
D_.encodeFixedBeet = void 0;
const xne = Tne(X6);
function Mne(e, t) {
  const n = Buffer.alloc(e.byteSize);
  return e.write(n, 0, t), xne.default.encode(n);
}
D_.encodeFixedBeet = Mne;
Object.defineProperty(B_, "__esModule", { value: !0 });
B_.GpaBuilder = void 0;
const fS = Se, yf = ki(), One = sa, eP = D_;
class tm {
  constructor(t, n, r) {
    this.programId = t, this.beets = n, this.accountSize = r, this.config = {};
  }
  _addFilter(t) {
    return this.config.filters == null && (this.config.filters = []), this.config.filters.push(t), this;
  }
  _addInnerFilter(t, n, r) {
    (0, One.logTrace)(`gpa.addInnerFilter: ${t}.${n}`);
    const i = this.beets.get(t);
    (0, yf.strict)(i != null, "Outer filter key needs to be an existing field name");
    const o = i.beet;
    let a = i.offset;
    const s = (0, fS.isFixedSizeBeet)(o) ? o : o.toFixedFromValue(r);
    let c;
    for (const [u, f] of s.fields) {
      if (u === n) {
        c = f;
        break;
      }
      a += f.byteSize;
    }
    (0, yf.strict)(c != null, `${n} is not a field of the ${t} struct`);
    const l = (0, eP.encodeFixedBeet)(c, r);
    return this._addFilter({ memcmp: { offset: a, bytes: l } }), this;
  }
  /**
   * Adds a _memcmp_ filter for a field inside a field which is a struct value.
   * The provided keys need to be separated by a `.` and only one level of
   * nesting is supported at this point.
   *
   * The filter is applied to the inner value.
   *
   * ## Example
   *
   * ### Given:
   *
   * ```typescript
   * type Inner = {
   *   a: number
   * }
   * type Outer = {
   *   idx: number
   *   inner: Inner
   * }
   * ```
   * ### Apply a filter on `a` of the `Inner` type:
   *
   * ```typescript
   * gpaBuilder.addInnerFilter('inner.a', 2)
   * ```
   *
   * @param keys - the names of the fields by which to filter, i.e. `'outer.inner'`
   * @param val - the field value that the filter should match
   */
  addInnerFilter(t, n) {
    const r = t.split(".");
    yf.strict.equal(r.length, 2, "inner filters can go only one level deep, i.e. 'outer.inner' is ok, but 'outer.inner.deep' is not");
    const [i, o] = r;
    return this._addInnerFilter(i, o, n);
  }
  /**
   * Adds a _memcmp_ filter for the provided {@link key} of the struct.
   *
   * @param key - the name of the field by which to filter
   * @param val - the field value that the filter should match
   */
  addFilter(t, n) {
    const r = this.beets.get(t);
    (0, yf.strict)(r != null, "Filter key needs to be an existing field name");
    const i = (0, fS.isFixedSizeBeet)(r.beet) ? r.beet : r.beet.toFixedFromValue(n), o = (0, eP.encodeFixedBeet)(i, n);
    return this._addFilter({ memcmp: { offset: r.offset, bytes: o } }), this;
  }
  /**
   * Adds a `dataSize` filter which will match on account's sizes.
   * You have to provide that {@link size} for accounts that don't have a fixed size.
   * For _fixed_ size accounts that size is determined for you.
   *
   * @param size - the account size to match for
   */
  dataSize(t) {
    return t = t ?? this.accountSize, (0, yf.strict)(t != null, "for accounts of dynamic size the dataSize arg needs to be provided"), this._addFilter({ dataSize: t });
  }
  /**
   * Attempts to find the accounts matching the configured filters.
   *
   * @param connection used to query the program accounts on the cluster
   */
  run(t) {
    return t.getProgramAccounts(this.programId, this.config);
  }
  /**
   * Creates a GPA builder that supports adding up to four filters for
   * fixed size fields.
   *
   * Once a non-fixed field is encountered, the remaining fields following it
   * will not be included as a filter option since their position in the
   * bytes array will change depending on the content of the non-fixed field.
   *
   * @param programId - the id of the program that owns the accounts we are querying
   * @param beetFields - the beet fields that make up the structure of the account data
   */
  static fromBeetFields(t, n) {
    const r = /* @__PURE__ */ new Map();
    let i = 0, o = !1;
    for (const [s, c] of n) {
      if (r.set(s, { beet: c, offset: i }), !(0, fS.isFixedSizeBeet)(c)) {
        o = !0;
        break;
      }
      i += c.byteSize;
    }
    const a = o ? void 0 : i;
    return new tm(t, r, a);
  }
  /**
   * Convenience wrapper around {@link GpaBuilder.fromBeetFields} that allows
   * providing a struct which contains the beet fields.
   *
   * @param programId - the id of the program that owns the accounts we are querying
   * @param struct - containing the beet `fields` specifying the layout of the account
   */
  static fromStruct(t, n) {
    return tm.fromBeetFields(t, n.fields);
  }
}
B_.GpaBuilder = tm;
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(i, o, a, s) {
    s === void 0 && (s = a);
    var c = Object.getOwnPropertyDescriptor(o, a);
    (!c || ("get" in c ? !o.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
      return o[a];
    } }), Object.defineProperty(i, s, c);
  } : function(i, o, a, s) {
    s === void 0 && (s = a), i[s] = o[a];
  }), n = _ && _.__exportStar || function(i, o) {
    for (var a in i)
      a !== "default" && !Object.prototype.hasOwnProperty.call(o, a) && t(o, i, a);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.supportedTypeMap = void 0;
  const r = $c;
  n($c, e), n(B_, e), e.supportedTypeMap = r.keysTypeMap;
})(zn);
var ui = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.keyBeet = e.Key = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.Uninitialized = 0] = "Uninitialized", a[a.EditionV1 = 1] = "EditionV1", a[a.MasterEditionV1 = 2] = "MasterEditionV1", a[a.ReservationListV1 = 3] = "ReservationListV1", a[a.MetadataV1 = 4] = "MetadataV1", a[a.ReservationListV2 = 5] = "ReservationListV2", a[a.MasterEditionV2 = 6] = "MasterEditionV2", a[a.EditionMarker = 7] = "EditionMarker", a[a.UseAuthorityRecord = 8] = "UseAuthorityRecord", a[a.CollectionAuthorityRecord = 9] = "CollectionAuthorityRecord", a[a.TokenOwnedEscrow = 10] = "TokenOwnedEscrow", a[a.TokenRecord = 11] = "TokenRecord", a[a.MetadataDelegate = 12] = "MetadataDelegate";
  })(o = e.Key || (e.Key = {})), e.keyBeet = i.fixedScalarEnum(o);
})(ui);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.collectionAuthorityRecordBeet = e.CollectionAuthorityRecord = void 0;
  const i = r(we), o = r(Se), a = r(zn), s = ui;
  class c {
    constructor(u, f, d) {
      this.key = u, this.bump = f, this.updateAuthority = d;
    }
    static fromArgs(u) {
      return new c(u.key, u.bump, u.updateAuthority);
    }
    static fromAccountInfo(u, f = 0) {
      return c.deserialize(u.data, f);
    }
    static async fromAccountAddress(u, f, d) {
      const h = await u.getAccountInfo(f, d);
      if (h == null)
        throw new Error(`Unable to find CollectionAuthorityRecord account at ${f}`);
      return c.fromAccountInfo(h, 0)[0];
    }
    static gpaBuilder(u = new i.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
      return a.GpaBuilder.fromStruct(u, e.collectionAuthorityRecordBeet);
    }
    static deserialize(u, f = 0) {
      return e.collectionAuthorityRecordBeet.deserialize(u, f);
    }
    serialize() {
      return e.collectionAuthorityRecordBeet.serialize(this);
    }
    static byteSize(u) {
      const f = c.fromArgs(u);
      return e.collectionAuthorityRecordBeet.toFixedFromValue(f).byteSize;
    }
    static async getMinimumBalanceForRentExemption(u, f, d) {
      return f.getMinimumBalanceForRentExemption(c.byteSize(u), d);
    }
    pretty() {
      return {
        key: "Key." + s.Key[this.key],
        bump: this.bump,
        updateAuthority: this.updateAuthority
      };
    }
  }
  e.CollectionAuthorityRecord = c, e.collectionAuthorityRecordBeet = new o.FixableBeetStruct([
    ["key", s.keyBeet],
    ["bump", o.u8],
    ["updateAuthority", o.coption(a.publicKey)]
  ], c.fromArgs, "CollectionAuthorityRecord");
})(FA);
var JA = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.editionBeet = e.Edition = void 0;
  const i = r(we), o = r(Se), a = r(zn), s = ui;
  class c {
    constructor(u, f, d) {
      this.key = u, this.parent = f, this.edition = d;
    }
    static fromArgs(u) {
      return new c(u.key, u.parent, u.edition);
    }
    static fromAccountInfo(u, f = 0) {
      return c.deserialize(u.data, f);
    }
    static async fromAccountAddress(u, f, d) {
      const h = await u.getAccountInfo(f, d);
      if (h == null)
        throw new Error(`Unable to find Edition account at ${f}`);
      return c.fromAccountInfo(h, 0)[0];
    }
    static gpaBuilder(u = new i.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
      return a.GpaBuilder.fromStruct(u, e.editionBeet);
    }
    static deserialize(u, f = 0) {
      return e.editionBeet.deserialize(u, f);
    }
    serialize() {
      return e.editionBeet.serialize(this);
    }
    static get byteSize() {
      return e.editionBeet.byteSize;
    }
    static async getMinimumBalanceForRentExemption(u, f) {
      return u.getMinimumBalanceForRentExemption(c.byteSize, f);
    }
    static hasCorrectByteSize(u, f = 0) {
      return u.byteLength - f === c.byteSize;
    }
    pretty() {
      return {
        key: "Key." + s.Key[this.key],
        parent: this.parent.toBase58(),
        edition: (() => {
          const u = this.edition;
          if (typeof u.toNumber == "function")
            try {
              return u.toNumber();
            } catch {
              return u;
            }
          return u;
        })()
      };
    }
  }
  e.Edition = c, e.editionBeet = new o.BeetStruct([
    ["key", s.keyBeet],
    ["parent", a.publicKey],
    ["edition", o.u64]
  ], c.fromArgs, "Edition");
})(JA);
var XA = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.editionMarkerBeet = e.EditionMarker = void 0;
  const i = r(Se), o = r(we), a = r(zn), s = ui;
  class c {
    constructor(u, f) {
      this.key = u, this.ledger = f;
    }
    static fromArgs(u) {
      return new c(u.key, u.ledger);
    }
    static fromAccountInfo(u, f = 0) {
      return c.deserialize(u.data, f);
    }
    static async fromAccountAddress(u, f, d) {
      const h = await u.getAccountInfo(f, d);
      if (h == null)
        throw new Error(`Unable to find EditionMarker account at ${f}`);
      return c.fromAccountInfo(h, 0)[0];
    }
    static gpaBuilder(u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
      return a.GpaBuilder.fromStruct(u, e.editionMarkerBeet);
    }
    static deserialize(u, f = 0) {
      return e.editionMarkerBeet.deserialize(u, f);
    }
    serialize() {
      return e.editionMarkerBeet.serialize(this);
    }
    static get byteSize() {
      return e.editionMarkerBeet.byteSize;
    }
    static async getMinimumBalanceForRentExemption(u, f) {
      return u.getMinimumBalanceForRentExemption(c.byteSize, f);
    }
    static hasCorrectByteSize(u, f = 0) {
      return u.byteLength - f === c.byteSize;
    }
    pretty() {
      return {
        key: "Key." + s.Key[this.key],
        ledger: this.ledger
      };
    }
  }
  e.EditionMarker = c, e.editionMarkerBeet = new i.BeetStruct([
    ["key", s.keyBeet],
    ["ledger", i.uniformFixedSizeArray(i.u8, 31)]
  ], c.fromArgs, "EditionMarker");
})(XA);
var QA = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.masterEditionV1Beet = e.MasterEditionV1 = void 0;
  const i = r(Se), o = r(we), a = r(zn), s = ui;
  class c {
    constructor(u, f, d, h, g) {
      this.key = u, this.supply = f, this.maxSupply = d, this.printingMint = h, this.oneTimePrintingAuthorizationMint = g;
    }
    static fromArgs(u) {
      return new c(u.key, u.supply, u.maxSupply, u.printingMint, u.oneTimePrintingAuthorizationMint);
    }
    static fromAccountInfo(u, f = 0) {
      return c.deserialize(u.data, f);
    }
    static async fromAccountAddress(u, f, d) {
      const h = await u.getAccountInfo(f, d);
      if (h == null)
        throw new Error(`Unable to find MasterEditionV1 account at ${f}`);
      return c.fromAccountInfo(h, 0)[0];
    }
    static gpaBuilder(u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
      return a.GpaBuilder.fromStruct(u, e.masterEditionV1Beet);
    }
    static deserialize(u, f = 0) {
      return e.masterEditionV1Beet.deserialize(u, f);
    }
    serialize() {
      return e.masterEditionV1Beet.serialize(this);
    }
    static byteSize(u) {
      const f = c.fromArgs(u);
      return e.masterEditionV1Beet.toFixedFromValue(f).byteSize;
    }
    static async getMinimumBalanceForRentExemption(u, f, d) {
      return f.getMinimumBalanceForRentExemption(c.byteSize(u), d);
    }
    pretty() {
      return {
        key: "Key." + s.Key[this.key],
        supply: (() => {
          const u = this.supply;
          if (typeof u.toNumber == "function")
            try {
              return u.toNumber();
            } catch {
              return u;
            }
          return u;
        })(),
        maxSupply: this.maxSupply,
        printingMint: this.printingMint.toBase58(),
        oneTimePrintingAuthorizationMint: this.oneTimePrintingAuthorizationMint.toBase58()
      };
    }
  }
  e.MasterEditionV1 = c, e.masterEditionV1Beet = new i.FixableBeetStruct([
    ["key", s.keyBeet],
    ["supply", i.u64],
    ["maxSupply", i.coption(i.u64)],
    ["printingMint", a.publicKey],
    ["oneTimePrintingAuthorizationMint", a.publicKey]
  ], c.fromArgs, "MasterEditionV1");
})(QA);
var eI = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.masterEditionV2Beet = e.MasterEditionV2 = void 0;
  const i = r(Se), o = r(we), a = r(zn), s = ui;
  class c {
    constructor(u, f, d) {
      this.key = u, this.supply = f, this.maxSupply = d;
    }
    static fromArgs(u) {
      return new c(u.key, u.supply, u.maxSupply);
    }
    static fromAccountInfo(u, f = 0) {
      return c.deserialize(u.data, f);
    }
    static async fromAccountAddress(u, f, d) {
      const h = await u.getAccountInfo(f, d);
      if (h == null)
        throw new Error(`Unable to find MasterEditionV2 account at ${f}`);
      return c.fromAccountInfo(h, 0)[0];
    }
    static gpaBuilder(u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
      return a.GpaBuilder.fromStruct(u, e.masterEditionV2Beet);
    }
    static deserialize(u, f = 0) {
      return e.masterEditionV2Beet.deserialize(u, f);
    }
    serialize() {
      return e.masterEditionV2Beet.serialize(this);
    }
    static byteSize(u) {
      const f = c.fromArgs(u);
      return e.masterEditionV2Beet.toFixedFromValue(f).byteSize;
    }
    static async getMinimumBalanceForRentExemption(u, f, d) {
      return f.getMinimumBalanceForRentExemption(c.byteSize(u), d);
    }
    pretty() {
      return {
        key: "Key." + s.Key[this.key],
        supply: (() => {
          const u = this.supply;
          if (typeof u.toNumber == "function")
            try {
              return u.toNumber();
            } catch {
              return u;
            }
          return u;
        })(),
        maxSupply: this.maxSupply
      };
    }
  }
  e.MasterEditionV2 = c, e.masterEditionV2Beet = new i.FixableBeetStruct([
    ["key", s.keyBeet],
    ["supply", i.u64],
    ["maxSupply", i.coption(i.u64)]
  ], c.fromArgs, "MasterEditionV2");
})(eI);
var dS = {}, su = {}, cu = {}, Pne = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Bne = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Q6 = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Pne(t, e, n);
  return Bne(t, e), t;
};
Object.defineProperty(cu, "__esModule", { value: !0 });
cu.creatorBeet = void 0;
const Cne = Q6(zn), hS = Q6(Se);
cu.creatorBeet = new hS.BeetArgsStruct([
  ["address", Cne.publicKey],
  ["verified", hS.bool],
  ["share", hS.u8]
], "Creator");
var Dne = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Rne = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Nne = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Dne(t, e, n);
  return Rne(t, e), t;
};
Object.defineProperty(su, "__esModule", { value: !0 });
su.dataBeet = void 0;
const cc = Nne(Se), jne = cu;
su.dataBeet = new cc.FixableBeetArgsStruct([
  ["name", cc.utf8String],
  ["symbol", cc.utf8String],
  ["uri", cc.utf8String],
  ["sellerFeeBasisPoints", cc.u16],
  ["creators", cc.coption(cc.array(jne.creatorBeet))]
], "Data");
var Gl = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tokenStandardBeet = e.TokenStandard = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.NonFungible = 0] = "NonFungible", a[a.FungibleAsset = 1] = "FungibleAsset", a[a.Fungible = 2] = "Fungible", a[a.NonFungibleEdition = 3] = "NonFungibleEdition", a[a.ProgrammableNonFungible = 4] = "ProgrammableNonFungible";
  })(o = e.TokenStandard || (e.TokenStandard = {})), e.tokenStandardBeet = i.fixedScalarEnum(o);
})(Gl);
var Qa = {}, Une = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), zne = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), eN = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Une(t, e, n);
  return zne(t, e), t;
};
Object.defineProperty(Qa, "__esModule", { value: !0 });
Qa.collectionBeet = void 0;
const tP = eN(Se), Fne = eN(zn);
Qa.collectionBeet = new tP.BeetArgsStruct([
  ["verified", tP.bool],
  ["key", Fne.publicKey]
], "Collection");
var es = {}, dT = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.useMethodBeet = e.UseMethod = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.Burn = 0] = "Burn", a[a.Multiple = 1] = "Multiple", a[a.Single = 2] = "Single";
  })(o = e.UseMethod || (e.UseMethod = {})), e.useMethodBeet = i.fixedScalarEnum(o);
})(dT);
var Lne = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), $ne = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Wne = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Lne(t, e, n);
  return $ne(t, e), t;
};
Object.defineProperty(es, "__esModule", { value: !0 });
es.usesBeet = void 0;
const pS = Wne(Se), Kne = dT;
es.usesBeet = new pS.BeetArgsStruct([
  ["useMethod", Kne.useMethodBeet],
  ["remaining", pS.u64],
  ["total", pS.u64]
], "Uses");
var Fo = {}, Vne = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), qne = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Hne = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Vne(t, e, n);
  return qne(t, e), t;
};
Object.defineProperty(Fo, "__esModule", { value: !0 });
Fo.collectionDetailsBeet = Fo.isCollectionDetailsV1 = void 0;
const yS = Hne(Se), Gne = (e) => e.__kind === "V1";
Fo.isCollectionDetailsV1 = Gne;
Fo.collectionDetailsBeet = yS.dataEnum([
  [
    "V1",
    new yS.BeetArgsStruct([["size", yS.u64]], 'CollectionDetailsRecord["V1"]')
  ]
]);
var Qs = {}, Yne = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Zne = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), tN = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Yne(t, e, n);
  return Zne(t, e), t;
};
Object.defineProperty(Qs, "__esModule", { value: !0 });
Qs.programmableConfigBeet = Qs.isProgrammableConfigV1 = void 0;
const gS = tN(Se), Jne = tN(zn), Xne = (e) => e.__kind === "V1";
Qs.isProgrammableConfigV1 = Xne;
Qs.programmableConfigBeet = gS.dataEnum([
  [
    "V1",
    new gS.FixableBeetArgsStruct([["ruleSet", gS.coption(Jne.publicKey)]], 'ProgrammableConfigRecord["V1"]')
  ]
]);
var gf = {}, nP;
function Qne() {
  if (nP)
    return gf;
  nP = 1;
  var e = _ && _.__createBinding || (Object.create ? function(b, I, A, x) {
    x === void 0 && (x = A);
    var N = Object.getOwnPropertyDescriptor(I, A);
    (!N || ("get" in N ? !I.__esModule : N.writable || N.configurable)) && (N = { enumerable: !0, get: function() {
      return I[A];
    } }), Object.defineProperty(b, x, N);
  } : function(b, I, A, x) {
    x === void 0 && (x = A), b[x] = I[A];
  }), t = _ && _.__setModuleDefault || (Object.create ? function(b, I) {
    Object.defineProperty(b, "default", { enumerable: !0, value: I });
  } : function(b, I) {
    b.default = I;
  }), n = _ && _.__importStar || function(b) {
    if (b && b.__esModule)
      return b;
    var I = {};
    if (b != null)
      for (var A in b)
        A !== "default" && Object.prototype.hasOwnProperty.call(b, A) && e(I, b, A);
    return t(I, b), I;
  };
  Object.defineProperty(gf, "__esModule", { value: !0 }), gf.deserialize = void 0;
  const r = n(Se), i = n(zn), o = tI(), a = Qa, s = Fo, c = Qs, l = su, u = ui, f = Gl, d = es, h = r.coptionNone("").byteSize;
  function g(b, I = 0) {
    let A = I;
    const x = u.keyBeet.read(b, A);
    A += u.keyBeet.byteSize;
    const N = i.publicKey.read(b, A);
    A += i.publicKey.byteSize;
    const j = i.publicKey.read(b, A);
    A += i.publicKey.byteSize;
    const [K, W] = l.dataBeet.deserialize(b, A);
    A = W;
    const O = r.bool.read(b, A);
    A += r.bool.byteSize;
    const k = r.bool.read(b, A);
    A += r.bool.byteSize;
    const z = r.coption(r.u8).toFixedFromData(b, A), C = z.read(b, A);
    A += z.byteSize;
    const [M, S, p] = w(r.coption(f.tokenStandardBeet), b, A);
    A += S;
    const [y, v, E] = p ? [null, h, !0] : w(r.coption(a.collectionBeet), b, A);
    A += v;
    const [B, F, q] = p || E ? [null, h, !0] : w(r.coption(d.usesBeet), b, A);
    A += F;
    const [U, m, D] = p || E || q ? [null, h, !0] : w(r.coption(s.collectionDetailsBeet), b, A);
    A += m;
    const [Y, Q, G] = p || E || q ? [null, h, !0] : w(r.coption(c.programmableConfigBeet), b, A);
    A += Q;
    const he = p || E || q || D || G, se = {
      key: x,
      updateAuthority: N,
      mint: j,
      data: K,
      primarySaleHappened: O,
      isMutable: k,
      editionNonce: C,
      tokenStandard: he ? null : M,
      collection: he ? null : y,
      uses: he ? null : B,
      collectionDetails: he ? null : U,
      programmableConfig: he ? null : Y
    };
    return [o.Metadata.fromArgs(se), A];
  }
  gf.deserialize = g;
  function w(b, I, A) {
    try {
      const x = b.toFixedFromData(I, A);
      return [x.read(I, A), x.byteSize, !1];
    } catch {
      return [null, h, !0];
    }
  }
  return gf;
}
var rP;
function tI() {
  return rP || (rP = 1, function(e) {
    var t = _ && _.__createBinding || (Object.create ? function(x, N, j, K) {
      K === void 0 && (K = j);
      var W = Object.getOwnPropertyDescriptor(N, j);
      (!W || ("get" in W ? !N.__esModule : W.writable || W.configurable)) && (W = { enumerable: !0, get: function() {
        return N[j];
      } }), Object.defineProperty(x, K, W);
    } : function(x, N, j, K) {
      K === void 0 && (K = j), x[K] = N[j];
    }), n = _ && _.__setModuleDefault || (Object.create ? function(x, N) {
      Object.defineProperty(x, "default", { enumerable: !0, value: N });
    } : function(x, N) {
      x.default = N;
    }), r = _ && _.__importStar || function(x) {
      if (x && x.__esModule)
        return x;
      var N = {};
      if (x != null)
        for (var j in x)
          j !== "default" && Object.prototype.hasOwnProperty.call(x, j) && t(N, x, j);
      return n(N, x), N;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.metadataBeet = e.Metadata = void 0;
    const i = r(we), o = r(Se), a = r(zn), s = ui, c = su, l = Gl, u = Qa, f = es, d = Fo, h = Qs, g = r(Qne());
    class w {
      constructor(N, j, K, W, O, k, z, C, M, S, p, y) {
        this.key = N, this.updateAuthority = j, this.mint = K, this.data = W, this.primarySaleHappened = O, this.isMutable = k, this.editionNonce = z, this.tokenStandard = C, this.collection = M, this.uses = S, this.collectionDetails = p, this.programmableConfig = y;
      }
      static fromArgs(N) {
        return new w(N.key, N.updateAuthority, N.mint, N.data, N.primarySaleHappened, N.isMutable, N.editionNonce, N.tokenStandard, N.collection, N.uses, N.collectionDetails, N.programmableConfig);
      }
      static fromAccountInfo(N, j = 0) {
        return w.deserialize(N.data, j);
      }
      static async fromAccountAddress(N, j, K) {
        const W = await N.getAccountInfo(j, K);
        if (W == null)
          throw new Error(`Unable to find Metadata account at ${j}`);
        return w.fromAccountInfo(W, 0)[0];
      }
      static gpaBuilder(N = new i.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
        return a.GpaBuilder.fromStruct(N, e.metadataBeet);
      }
      static deserialize(N, j = 0) {
        return A(N, j);
      }
      serialize() {
        return I(this);
      }
      static byteSize(N) {
        const j = w.fromArgs(N);
        return e.metadataBeet.toFixedFromValue(j).byteSize;
      }
      static async getMinimumBalanceForRentExemption(N, j, K) {
        return j.getMinimumBalanceForRentExemption(w.byteSize(N), K);
      }
      pretty() {
        return {
          key: "Key." + s.Key[this.key],
          updateAuthority: this.updateAuthority.toBase58(),
          mint: this.mint.toBase58(),
          data: this.data,
          primarySaleHappened: this.primarySaleHappened,
          isMutable: this.isMutable,
          editionNonce: this.editionNonce,
          tokenStandard: this.tokenStandard,
          collection: this.collection,
          uses: this.uses,
          collectionDetails: this.collectionDetails,
          programmableConfig: this.programmableConfig
        };
      }
    }
    e.Metadata = w, e.metadataBeet = new o.FixableBeetStruct([
      ["key", s.keyBeet],
      ["updateAuthority", a.publicKey],
      ["mint", a.publicKey],
      ["data", c.dataBeet],
      ["primarySaleHappened", o.bool],
      ["isMutable", o.bool],
      ["editionNonce", o.coption(o.u8)],
      ["tokenStandard", o.coption(l.tokenStandardBeet)],
      ["collection", o.coption(u.collectionBeet)],
      ["uses", o.coption(f.usesBeet)],
      ["collectionDetails", o.coption(d.collectionDetailsBeet)],
      ["programmableConfig", o.coption(h.programmableConfigBeet)]
    ], w.fromArgs, "Metadata");
    const b = g, I = typeof b.serialize == "function" ? b.serialize.bind(b) : e.metadataBeet.serialize.bind(e.metadataBeet), A = typeof b.deserialize == "function" ? b.deserialize.bind(b) : e.metadataBeet.deserialize.bind(e.metadataBeet);
  }(dS)), dS;
}
var nI = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.metadataDelegateRecordBeet = e.MetadataDelegateRecord = void 0;
  const i = r(we), o = r(Se), a = r(zn), s = ui;
  class c {
    constructor(u, f, d, h, g) {
      this.key = u, this.bump = f, this.mint = d, this.delegate = h, this.updateAuthority = g;
    }
    static fromArgs(u) {
      return new c(u.key, u.bump, u.mint, u.delegate, u.updateAuthority);
    }
    static fromAccountInfo(u, f = 0) {
      return c.deserialize(u.data, f);
    }
    static async fromAccountAddress(u, f, d) {
      const h = await u.getAccountInfo(f, d);
      if (h == null)
        throw new Error(`Unable to find MetadataDelegateRecord account at ${f}`);
      return c.fromAccountInfo(h, 0)[0];
    }
    static gpaBuilder(u = new i.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
      return a.GpaBuilder.fromStruct(u, e.metadataDelegateRecordBeet);
    }
    static deserialize(u, f = 0) {
      return e.metadataDelegateRecordBeet.deserialize(u, f);
    }
    serialize() {
      return e.metadataDelegateRecordBeet.serialize(this);
    }
    static get byteSize() {
      return e.metadataDelegateRecordBeet.byteSize;
    }
    static async getMinimumBalanceForRentExemption(u, f) {
      return u.getMinimumBalanceForRentExemption(c.byteSize, f);
    }
    static hasCorrectByteSize(u, f = 0) {
      return u.byteLength - f === c.byteSize;
    }
    pretty() {
      return {
        key: "Key." + s.Key[this.key],
        bump: this.bump,
        mint: this.mint.toBase58(),
        delegate: this.delegate.toBase58(),
        updateAuthority: this.updateAuthority.toBase58()
      };
    }
  }
  e.MetadataDelegateRecord = c, e.metadataDelegateRecordBeet = new o.BeetStruct([
    ["key", s.keyBeet],
    ["bump", o.u8],
    ["mint", a.publicKey],
    ["delegate", a.publicKey],
    ["updateAuthority", a.publicKey]
  ], c.fromArgs, "MetadataDelegateRecord");
})(nI);
var rI = {}, Zd = {}, ere = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), tre = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), nN = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && ere(t, e, n);
  return tre(t, e), t;
};
Object.defineProperty(Zd, "__esModule", { value: !0 });
Zd.reservationV1Beet = void 0;
const nre = nN(zn), bS = nN(Se);
Zd.reservationV1Beet = new bS.BeetArgsStruct([
  ["address", nre.publicKey],
  ["spotsRemaining", bS.u8],
  ["totalSpots", bS.u8]
], "ReservationV1");
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(u, f, d, h) {
    h === void 0 && (h = d);
    var g = Object.getOwnPropertyDescriptor(f, d);
    (!g || ("get" in g ? !f.__esModule : g.writable || g.configurable)) && (g = { enumerable: !0, get: function() {
      return f[d];
    } }), Object.defineProperty(u, h, g);
  } : function(u, f, d, h) {
    h === void 0 && (h = d), u[h] = f[d];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(u, f) {
    Object.defineProperty(u, "default", { enumerable: !0, value: f });
  } : function(u, f) {
    u.default = f;
  }), r = _ && _.__importStar || function(u) {
    if (u && u.__esModule)
      return u;
    var f = {};
    if (u != null)
      for (var d in u)
        d !== "default" && Object.prototype.hasOwnProperty.call(u, d) && t(f, u, d);
    return n(f, u), f;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.reservationListV1Beet = e.ReservationListV1 = void 0;
  const i = r(we), o = r(Se), a = r(zn), s = ui, c = Zd;
  class l {
    constructor(f, d, h, g) {
      this.key = f, this.masterEdition = d, this.supplySnapshot = h, this.reservations = g;
    }
    static fromArgs(f) {
      return new l(f.key, f.masterEdition, f.supplySnapshot, f.reservations);
    }
    static fromAccountInfo(f, d = 0) {
      return l.deserialize(f.data, d);
    }
    static async fromAccountAddress(f, d, h) {
      const g = await f.getAccountInfo(d, h);
      if (g == null)
        throw new Error(`Unable to find ReservationListV1 account at ${d}`);
      return l.fromAccountInfo(g, 0)[0];
    }
    static gpaBuilder(f = new i.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
      return a.GpaBuilder.fromStruct(f, e.reservationListV1Beet);
    }
    static deserialize(f, d = 0) {
      return e.reservationListV1Beet.deserialize(f, d);
    }
    serialize() {
      return e.reservationListV1Beet.serialize(this);
    }
    static byteSize(f) {
      const d = l.fromArgs(f);
      return e.reservationListV1Beet.toFixedFromValue(d).byteSize;
    }
    static async getMinimumBalanceForRentExemption(f, d, h) {
      return d.getMinimumBalanceForRentExemption(l.byteSize(f), h);
    }
    pretty() {
      return {
        key: "Key." + s.Key[this.key],
        masterEdition: this.masterEdition.toBase58(),
        supplySnapshot: this.supplySnapshot,
        reservations: this.reservations
      };
    }
  }
  e.ReservationListV1 = l, e.reservationListV1Beet = new o.FixableBeetStruct([
    ["key", s.keyBeet],
    ["masterEdition", a.publicKey],
    ["supplySnapshot", o.coption(o.u64)],
    ["reservations", o.array(c.reservationV1Beet)]
  ], l.fromArgs, "ReservationListV1");
})(rI);
var iI = {}, Jd = {}, rre = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), ire = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), rN = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && rre(t, e, n);
  return ire(t, e), t;
};
Object.defineProperty(Jd, "__esModule", { value: !0 });
Jd.reservationBeet = void 0;
const mS = rN(Se), ore = rN(zn);
Jd.reservationBeet = new mS.BeetArgsStruct([
  ["address", ore.publicKey],
  ["spotsRemaining", mS.u64],
  ["totalSpots", mS.u64]
], "Reservation");
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(u, f, d, h) {
    h === void 0 && (h = d);
    var g = Object.getOwnPropertyDescriptor(f, d);
    (!g || ("get" in g ? !f.__esModule : g.writable || g.configurable)) && (g = { enumerable: !0, get: function() {
      return f[d];
    } }), Object.defineProperty(u, h, g);
  } : function(u, f, d, h) {
    h === void 0 && (h = d), u[h] = f[d];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(u, f) {
    Object.defineProperty(u, "default", { enumerable: !0, value: f });
  } : function(u, f) {
    u.default = f;
  }), r = _ && _.__importStar || function(u) {
    if (u && u.__esModule)
      return u;
    var f = {};
    if (u != null)
      for (var d in u)
        d !== "default" && Object.prototype.hasOwnProperty.call(u, d) && t(f, u, d);
    return n(f, u), f;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.reservationListV2Beet = e.ReservationListV2 = void 0;
  const i = r(we), o = r(Se), a = r(zn), s = ui, c = Jd;
  class l {
    constructor(f, d, h, g, w, b) {
      this.key = f, this.masterEdition = d, this.supplySnapshot = h, this.reservations = g, this.totalReservationSpots = w, this.currentReservationSpots = b;
    }
    static fromArgs(f) {
      return new l(f.key, f.masterEdition, f.supplySnapshot, f.reservations, f.totalReservationSpots, f.currentReservationSpots);
    }
    static fromAccountInfo(f, d = 0) {
      return l.deserialize(f.data, d);
    }
    static async fromAccountAddress(f, d, h) {
      const g = await f.getAccountInfo(d, h);
      if (g == null)
        throw new Error(`Unable to find ReservationListV2 account at ${d}`);
      return l.fromAccountInfo(g, 0)[0];
    }
    static gpaBuilder(f = new i.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
      return a.GpaBuilder.fromStruct(f, e.reservationListV2Beet);
    }
    static deserialize(f, d = 0) {
      return e.reservationListV2Beet.deserialize(f, d);
    }
    serialize() {
      return e.reservationListV2Beet.serialize(this);
    }
    static byteSize(f) {
      const d = l.fromArgs(f);
      return e.reservationListV2Beet.toFixedFromValue(d).byteSize;
    }
    static async getMinimumBalanceForRentExemption(f, d, h) {
      return d.getMinimumBalanceForRentExemption(l.byteSize(f), h);
    }
    pretty() {
      return {
        key: "Key." + s.Key[this.key],
        masterEdition: this.masterEdition.toBase58(),
        supplySnapshot: this.supplySnapshot,
        reservations: this.reservations,
        totalReservationSpots: (() => {
          const f = this.totalReservationSpots;
          if (typeof f.toNumber == "function")
            try {
              return f.toNumber();
            } catch {
              return f;
            }
          return f;
        })(),
        currentReservationSpots: (() => {
          const f = this.currentReservationSpots;
          if (typeof f.toNumber == "function")
            try {
              return f.toNumber();
            } catch {
              return f;
            }
          return f;
        })()
      };
    }
  }
  e.ReservationListV2 = l, e.reservationListV2Beet = new o.FixableBeetStruct([
    ["key", s.keyBeet],
    ["masterEdition", a.publicKey],
    ["supplySnapshot", o.coption(o.u64)],
    ["reservations", o.array(c.reservationBeet)],
    ["totalReservationSpots", o.u64],
    ["currentReservationSpots", o.u64]
  ], l.fromArgs, "ReservationListV2");
})(iI);
var oI = {}, $a = {}, are = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), sre = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), iN = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && are(t, e, n);
  return sre(t, e), t;
};
Object.defineProperty($a, "__esModule", { value: !0 });
$a.escrowAuthorityBeet = $a.isEscrowAuthorityCreator = $a.isEscrowAuthorityTokenOwner = void 0;
const Rg = iN(Se), cre = iN(zn), ure = (e) => e.__kind === "TokenOwner";
$a.isEscrowAuthorityTokenOwner = ure;
const lre = (e) => e.__kind === "Creator";
$a.isEscrowAuthorityCreator = lre;
$a.escrowAuthorityBeet = Rg.dataEnum([
  ["TokenOwner", Rg.unit],
  [
    "Creator",
    new Rg.BeetArgsStruct([["fields", Rg.fixedSizeTuple([cre.publicKey])]], 'EscrowAuthorityRecord["Creator"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(u, f, d, h) {
    h === void 0 && (h = d);
    var g = Object.getOwnPropertyDescriptor(f, d);
    (!g || ("get" in g ? !f.__esModule : g.writable || g.configurable)) && (g = { enumerable: !0, get: function() {
      return f[d];
    } }), Object.defineProperty(u, h, g);
  } : function(u, f, d, h) {
    h === void 0 && (h = d), u[h] = f[d];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(u, f) {
    Object.defineProperty(u, "default", { enumerable: !0, value: f });
  } : function(u, f) {
    u.default = f;
  }), r = _ && _.__importStar || function(u) {
    if (u && u.__esModule)
      return u;
    var f = {};
    if (u != null)
      for (var d in u)
        d !== "default" && Object.prototype.hasOwnProperty.call(u, d) && t(f, u, d);
    return n(f, u), f;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tokenOwnedEscrowBeet = e.TokenOwnedEscrow = void 0;
  const i = r(we), o = r(zn), a = r(Se), s = ui, c = $a;
  class l {
    constructor(f, d, h, g) {
      this.key = f, this.baseToken = d, this.authority = h, this.bump = g;
    }
    static fromArgs(f) {
      return new l(f.key, f.baseToken, f.authority, f.bump);
    }
    static fromAccountInfo(f, d = 0) {
      return l.deserialize(f.data, d);
    }
    static async fromAccountAddress(f, d, h) {
      const g = await f.getAccountInfo(d, h);
      if (g == null)
        throw new Error(`Unable to find TokenOwnedEscrow account at ${d}`);
      return l.fromAccountInfo(g, 0)[0];
    }
    static gpaBuilder(f = new i.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
      return o.GpaBuilder.fromStruct(f, e.tokenOwnedEscrowBeet);
    }
    static deserialize(f, d = 0) {
      return e.tokenOwnedEscrowBeet.deserialize(f, d);
    }
    serialize() {
      return e.tokenOwnedEscrowBeet.serialize(this);
    }
    static byteSize(f) {
      const d = l.fromArgs(f);
      return e.tokenOwnedEscrowBeet.toFixedFromValue(d).byteSize;
    }
    static async getMinimumBalanceForRentExemption(f, d, h) {
      return d.getMinimumBalanceForRentExemption(l.byteSize(f), h);
    }
    pretty() {
      return {
        key: "Key." + s.Key[this.key],
        baseToken: this.baseToken.toBase58(),
        authority: this.authority.__kind,
        bump: this.bump
      };
    }
  }
  e.TokenOwnedEscrow = l, e.tokenOwnedEscrowBeet = new a.FixableBeetStruct([
    ["key", s.keyBeet],
    ["baseToken", o.publicKey],
    ["authority", c.escrowAuthorityBeet],
    ["bump", a.u8]
  ], l.fromArgs, "TokenOwnedEscrow");
})(oI);
var _S = {}, hT = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tokenStateBeet = e.TokenState = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.Unlocked = 0] = "Unlocked", a[a.Locked = 1] = "Locked", a[a.Listed = 2] = "Listed";
  })(o = e.TokenState || (e.TokenState = {})), e.tokenStateBeet = i.fixedScalarEnum(o);
})(hT);
var pT = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.tokenDelegateRoleBeet = e.TokenDelegateRole = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.Sale = 0] = "Sale", a[a.Transfer = 1] = "Transfer", a[a.Utility = 2] = "Utility", a[a.Staking = 3] = "Staking", a[a.Standard = 4] = "Standard", a[a.LockedTransfer = 5] = "LockedTransfer", a[a.Migration = 6] = "Migration";
  })(o = e.TokenDelegateRole || (e.TokenDelegateRole = {})), e.tokenDelegateRoleBeet = i.fixedScalarEnum(o);
})(pT);
var bf = {}, R_ = {}, fre = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), dre = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), hre = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && fre(t, e, n);
  return dre(t, e), t;
};
Object.defineProperty(R_, "__esModule", { value: !0 });
R_.tryReadOption = void 0;
const pre = hre(Se), yre = pre.coptionNone("").byteSize;
function gre(e, t, n) {
  if (t.subarray(n).length == 0)
    return [null, yre, !0];
  const r = e.toFixedFromData(t, n);
  return [r.read(t, n), r.byteSize, !1];
}
R_.tryReadOption = gre;
var iP;
function bre() {
  if (iP)
    return bf;
  iP = 1;
  var e = _ && _.__createBinding || (Object.create ? function(u, f, d, h) {
    h === void 0 && (h = d);
    var g = Object.getOwnPropertyDescriptor(f, d);
    (!g || ("get" in g ? !f.__esModule : g.writable || g.configurable)) && (g = { enumerable: !0, get: function() {
      return f[d];
    } }), Object.defineProperty(u, h, g);
  } : function(u, f, d, h) {
    h === void 0 && (h = d), u[h] = f[d];
  }), t = _ && _.__setModuleDefault || (Object.create ? function(u, f) {
    Object.defineProperty(u, "default", { enumerable: !0, value: f });
  } : function(u, f) {
    u.default = f;
  }), n = _ && _.__importStar || function(u) {
    if (u && u.__esModule)
      return u;
    var f = {};
    if (u != null)
      for (var d in u)
        d !== "default" && Object.prototype.hasOwnProperty.call(u, d) && e(f, u, d);
    return t(f, u), f;
  };
  Object.defineProperty(bf, "__esModule", { value: !0 }), bf.deserialize = void 0;
  const r = n(Se), i = n(zn), o = ui, a = aI(), s = kT(), c = R_;
  function l(u, f = 0) {
    let d = f;
    const h = o.keyBeet.read(u, d);
    d += o.keyBeet.byteSize;
    const g = r.u8.read(u, d);
    d += r.u8.byteSize;
    const w = s.tokenStateBeet.read(u, d);
    d += s.tokenStateBeet.byteSize;
    const [b, I] = (0, c.tryReadOption)(r.coption(r.u64), u, d);
    d += I;
    const [A, x] = (0, c.tryReadOption)(r.coption(i.publicKey), u, d);
    d += x;
    const [N, j] = (0, c.tryReadOption)(r.coption(s.tokenDelegateRoleBeet), u, d);
    d += j;
    const [K, W, O] = (0, c.tryReadOption)(r.coption(i.publicKey), u, d);
    d += W;
    const k = {
      key: h,
      bump: g,
      state: w,
      ruleSetRevision: b,
      delegate: A,
      delegateRole: N,
      lockedTransfer: O ? null : K
    };
    return [a.TokenRecord.fromArgs(k), d];
  }
  return bf.deserialize = l, bf;
}
var oP;
function aI() {
  return oP || (oP = 1, function(e) {
    var t = _ && _.__createBinding || (Object.create ? function(w, b, I, A) {
      A === void 0 && (A = I);
      var x = Object.getOwnPropertyDescriptor(b, I);
      (!x || ("get" in x ? !b.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
        return b[I];
      } }), Object.defineProperty(w, A, x);
    } : function(w, b, I, A) {
      A === void 0 && (A = I), w[A] = b[I];
    }), n = _ && _.__setModuleDefault || (Object.create ? function(w, b) {
      Object.defineProperty(w, "default", { enumerable: !0, value: b });
    } : function(w, b) {
      w.default = b;
    }), r = _ && _.__importStar || function(w) {
      if (w && w.__esModule)
        return w;
      var b = {};
      if (w != null)
        for (var I in w)
          I !== "default" && Object.prototype.hasOwnProperty.call(w, I) && t(b, w, I);
      return n(b, w), b;
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.tokenRecordBeet = e.TokenRecord = void 0;
    const i = r(Se), o = r(we), a = r(zn), s = ui, c = hT, l = pT, u = r(bre());
    class f {
      constructor(b, I, A, x, N, j, K) {
        this.key = b, this.bump = I, this.state = A, this.ruleSetRevision = x, this.delegate = N, this.delegateRole = j, this.lockedTransfer = K;
      }
      static fromArgs(b) {
        return new f(b.key, b.bump, b.state, b.ruleSetRevision, b.delegate, b.delegateRole, b.lockedTransfer);
      }
      static fromAccountInfo(b, I = 0) {
        return f.deserialize(b.data, I);
      }
      static async fromAccountAddress(b, I, A) {
        const x = await b.getAccountInfo(I, A);
        if (x == null)
          throw new Error(`Unable to find TokenRecord account at ${I}`);
        return f.fromAccountInfo(x, 0)[0];
      }
      static gpaBuilder(b = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
        return a.GpaBuilder.fromStruct(b, e.tokenRecordBeet);
      }
      static deserialize(b, I = 0) {
        return g(b, I);
      }
      serialize() {
        return h(this);
      }
      static byteSize(b) {
        const I = f.fromArgs(b);
        return e.tokenRecordBeet.toFixedFromValue(I).byteSize;
      }
      static async getMinimumBalanceForRentExemption(b, I, A) {
        return I.getMinimumBalanceForRentExemption(f.byteSize(b), A);
      }
      pretty() {
        return {
          key: "Key." + s.Key[this.key],
          bump: this.bump,
          state: "TokenState." + c.TokenState[this.state],
          ruleSetRevision: this.ruleSetRevision,
          delegate: this.delegate,
          delegateRole: this.delegateRole,
          lockedTransfer: this.lockedTransfer
        };
      }
    }
    e.TokenRecord = f, e.tokenRecordBeet = new i.FixableBeetStruct([
      ["key", s.keyBeet],
      ["bump", i.u8],
      ["state", c.tokenStateBeet],
      ["ruleSetRevision", i.coption(i.u64)],
      ["delegate", i.coption(a.publicKey)],
      ["delegateRole", i.coption(l.tokenDelegateRoleBeet)],
      ["lockedTransfer", i.coption(a.publicKey)]
    ], f.fromArgs, "TokenRecord");
    const d = u, h = typeof d.serialize == "function" ? d.serialize.bind(d) : e.tokenRecordBeet.serialize.bind(e.tokenRecordBeet), g = typeof d.deserialize == "function" ? d.deserialize.bind(d) : e.tokenRecordBeet.deserialize.bind(e.tokenRecordBeet);
  }(_S)), _S;
}
var sI = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.useAuthorityRecordBeet = e.UseAuthorityRecord = void 0;
  const i = r(Se), o = r(we), a = r(zn), s = ui;
  class c {
    constructor(u, f, d) {
      this.key = u, this.allowedUses = f, this.bump = d;
    }
    static fromArgs(u) {
      return new c(u.key, u.allowedUses, u.bump);
    }
    static fromAccountInfo(u, f = 0) {
      return c.deserialize(u.data, f);
    }
    static async fromAccountAddress(u, f, d) {
      const h = await u.getAccountInfo(f, d);
      if (h == null)
        throw new Error(`Unable to find UseAuthorityRecord account at ${f}`);
      return c.fromAccountInfo(h, 0)[0];
    }
    static gpaBuilder(u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
      return a.GpaBuilder.fromStruct(u, e.useAuthorityRecordBeet);
    }
    static deserialize(u, f = 0) {
      return e.useAuthorityRecordBeet.deserialize(u, f);
    }
    serialize() {
      return e.useAuthorityRecordBeet.serialize(this);
    }
    static get byteSize() {
      return e.useAuthorityRecordBeet.byteSize;
    }
    static async getMinimumBalanceForRentExemption(u, f) {
      return u.getMinimumBalanceForRentExemption(c.byteSize, f);
    }
    static hasCorrectByteSize(u, f = 0) {
      return u.byteLength - f === c.byteSize;
    }
    pretty() {
      return {
        key: "Key." + s.Key[this.key],
        allowedUses: (() => {
          const u = this.allowedUses;
          if (typeof u.toNumber == "function")
            try {
              return u.toNumber();
            } catch {
              return u;
            }
          return u;
        })(),
        bump: this.bump
      };
    }
  }
  e.UseAuthorityRecord = c, e.useAuthorityRecordBeet = new i.BeetStruct([
    ["key", s.keyBeet],
    ["allowedUses", i.u64],
    ["bump", i.u8]
  ], c.fromArgs, "UseAuthorityRecord");
})(sI);
var aP;
function mre() {
  return aP || (aP = 1, function(e) {
    var t = _ && _.__createBinding || (Object.create ? function(w, b, I, A) {
      A === void 0 && (A = I);
      var x = Object.getOwnPropertyDescriptor(b, I);
      (!x || ("get" in x ? !b.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
        return b[I];
      } }), Object.defineProperty(w, A, x);
    } : function(w, b, I, A) {
      A === void 0 && (A = I), w[A] = b[I];
    }), n = _ && _.__exportStar || function(w, b) {
      for (var I in w)
        I !== "default" && !Object.prototype.hasOwnProperty.call(b, I) && t(b, w, I);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.accountProviders = void 0, n(FA, e), n(JA, e), n(XA, e), n(QA, e), n(eI, e), n(tI(), e), n(nI, e), n(rI, e), n(iI, e), n(oI, e), n(aI(), e), n(sI, e);
    const r = FA, i = nI, o = JA, a = XA, s = oI, c = eI, l = QA, u = tI(), f = aI(), d = iI, h = rI, g = sI;
    e.accountProviders = {
      CollectionAuthorityRecord: r.CollectionAuthorityRecord,
      MetadataDelegateRecord: i.MetadataDelegateRecord,
      Edition: o.Edition,
      EditionMarker: a.EditionMarker,
      TokenOwnedEscrow: s.TokenOwnedEscrow,
      MasterEditionV2: c.MasterEditionV2,
      MasterEditionV1: l.MasterEditionV1,
      Metadata: u.Metadata,
      TokenRecord: f.TokenRecord,
      ReservationListV2: d.ReservationListV2,
      ReservationListV1: h.ReservationListV1,
      UseAuthorityRecord: g.UseAuthorityRecord
    };
  }(aS)), aS;
}
var V = {};
Object.defineProperty(V, "__esModule", { value: !0 });
V.ReservationAlreadyMadeError = V.ReservationNotSetError = V.ReservationDoesNotExistError = V.ReservationExistsError = V.ShareTotalMustBe100Error = V.NoBalanceInAccountForAuthorizationError = V.OwnerMismatchError = V.PrimarySaleCanOnlyBeFlippedToTrueError = V.InvalidBasisPointsError = V.CreatorNotFoundError = V.NoCreatorsPresentOnMetadataError = V.MustBeOneOfCreatorsError = V.CreatorsMustBeAtleastOneError = V.CreatorsTooLongError = V.DisabledError = V.AuthorizationTokenAccountOwnerMismatchError = V.PrintingMintAuthorizationAccountMismatchError = V.NotEnoughTokensError = V.TokenAccountMintMismatchV2Error = V.TokenAccountMintMismatchError = V.OneTimePrintingAuthMintMismatchError = V.PrintingMintMismatchError = V.DerivedKeyInvalidError = V.TokenAccountOneTimeAuthMintMismatchError = V.TokenBurnFailedError = V.EditionMintDecimalsShouldBeZeroError = V.OneTimePrintingAuthorizationMintDecimalsShouldBeZeroError = V.PrintingMintDecimalsShouldBeZeroError = V.EditionAlreadyMintedError = V.DestinationMintMismatchError = V.MasterRecordMismatchError = V.TokenMintToFailedError = V.MaxEditionsMintedAlreadyError = V.EditionsMustHaveExactlyOneTokenError = V.MintMismatchError = V.UpdateAuthorityMustBeEqualToMetadataAuthorityAndSignerError = V.UriTooLongError = V.SymbolTooLongError = V.NameTooLongError = V.InvalidMintAuthorityError = V.NotMintAuthorityError = V.UpdateAuthorityIsNotSignerError = V.UpdateAuthorityIncorrectError = V.InvalidEditionKeyError = V.InvalidMetadataKeyError = V.UninitializedError = V.AlreadyInitializedError = V.NotRentExemptError = V.InstructionPackErrorError = V.InstructionUnpackErrorError = void 0;
V.RevokeCollectionAuthoritySignerIncorrectError = V.InvalidUserError = V.EditionOverrideCannotBeZeroError = V.NotAllowedToChangeSellerFeeBasisPointsError = V.CannotWipeVerifiedCreatorsError = V.CannotRemoveVerifiedCreatorError = V.CannotAdjustVerifiedCreatorError = V.InvalidDelegateError = V.InvalidFreezeAuthorityError = V.InvalidCollectionAuthorityRecordError = V.InvalidUseAuthorityRecordError = V.CollectionAuthorityDoesNotExistError = V.CollectionAuthorityRecordAlreadyExistsError = V.NotEnoughUsesError = V.UnusableError = V.UseAuthorityRecordAlreadyRevokedError = V.UseAuthorityRecordAlreadyExistsError = V.CollectionMustBeAUniqueMasterEditionError = V.InvalidCollectionUpdateAuthorityError = V.CollectionNotFoundError = V.CannotChangeUsesAfterFirstUseError = V.CannotChangeUseMethodAfterFirstUseError = V.InvalidUseMethodError = V.MustBeBurnedError = V.RemovedError = V.CollectionCannotBeVerifiedInThisInstructionError = V.IsMutableCanOnlyBeFlippedToFalseError = V.ReservationArrayShouldBeSizeOneError = V.InvalidEditionIndexError = V.OneTimeAuthMintSupplyMustBeZeroForConversionError = V.PrintingMintSupplyMustBeZeroForConversionError = V.InvalidOwnerError = V.InvalidOperationError = V.TriedToReplaceAnExistingReservationError = V.ReservationNotCompleteError = V.BeyondAlottedAddressSizeError = V.DataTypeMismatchError = V.InvalidTokenProgramError = V.ReservationSpotsRemainingShouldMatchTotalSpotsAtStartError = V.DuplicateCreatorAddressError = V.DataIsImmutableError = V.PrintingWouldBreachMaximumSupplyError = V.IncorrectOwnerError = V.SpotMismatchError = V.CannotUnverifyAnotherCreatorError = V.CannotVerifyAnotherCreatorError = V.AddressNotInReservationError = V.ReservationBreachesMaximumSupplyError = V.NumericalOverflowErrorError = V.BeyondMaxAddressSizeError = void 0;
V.MissingSplTokenProgramError = V.MissingTokenAccountError = V.OnlySaleDelegateCanTransferError = V.InvalidSystemWalletError = V.FeatureNotSupportedError = V.MissingArgumentInBuilderError = V.MissingAccountInBuilderError = V.DelegateNotFoundError = V.DelegateAlreadyExistsError = V.InvalidProgrammableConfigError = V.MissingProgrammableConfigError = V.MissingAuthorizationRulesError = V.InvalidAuthorizationRulesError = V.InvalidMintForTokenStandardError = V.InvalidTokenStandardError = V.MintIsNotSignerError = V.EscrowParentHasDelegateError = V.InvalidBubblegumSignerError = V.InvalidCollectionSizeChangeError = V.NoFreezeAuthoritySetError = V.BorshSerializationErrorError = V.InsufficientTokensError = V.MustBeNonFungibleError = V.InvalidSystemProgramError = V.MustBeEscrowAuthorityError = V.InvalidEscrowBumpSeedError = V.MustUnverifyError = V.EditionNumberGreaterThanMaxSupplyError = V.PrintEditionDoesNotMatchMasterEditionError = V.ReservationListDeprecatedError = V.InvalidEditionMarkerError = V.InvalidPrintEditionError = V.InvalidMasterEditionError = V.NotAPrintEditionError = V.AlreadyUnverifiedError = V.AlreadyVerifiedError = V.CollectionMasterEditionAccountInvalidError = V.CannotUpdateVerifiedCollectionError = V.BorshDeserializationErrorError = V.MasterEditionHasPrintsError = V.NotAMasterEditionError = V.MissingEditionAccountError = V.CouldNotDetermineTokenStandardError = V.NotACollectionParentError = V.NotVerifiedMemberOfCollectionError = V.NotAMemberOfCollectionError = V.MissingCollectionMetadataError = V.SizedCollectionError = V.UnsizedCollectionError = V.TokenCloseFailedError = void 0;
V.errorFromName = V.errorFromCode = V.InvalidMetadataFlagsError = V.InvalidFeeAccountError = V.MissingDelegateRecordError = V.InvalidInstructionError = V.InvalidCloseAuthorityError = V.InvalidTokenRecordError = V.MissingCollectionMasterEditionError = V.MissingCollectionMintError = V.InsufficientTokenBalanceError = V.InvalidUpdateArgsError = V.InvalidParentAccountsError = V.InvalidInstructionsSysvarError = V.InvalidAssociatedTokenAccountProgramError = V.MissingEditionError = V.CannotBurnWithDelegateError = V.MissingEditionMarkerAccountError = V.MissingMasterEditionTokenAccountError = V.MissingMasterEditionMintAccountError = V.InvalidAmountError = V.CannotUpdateAssetWithDelegateError = V.DataIncrementLimitExceededError = V.InvalidLockedTransferAddressError = V.MissingLockedTransferAddressError = V.InvalidDelegateArgsError = V.AmountMustBeGreaterThanZeroError = V.MissingMasterEditionAccountError = V.MissingPrintSupplyError = V.InvalidDelegateRoleError = V.IncorrectTokenStateError = V.InvalidMasterEditionAccountLengthError = V.MissingTokenOwnerAccountError = V.DataIsEmptyOrZeroedError = V.MintSupplyMustBeZeroError = V.MissingTokenRecordError = V.InvalidAuthorityTypeError = V.MissingDelegateRoleError = V.UnlockedTokenError = V.LockedTokenError = V.KeyMismatchError = V.InstructionNotSupportedError = V.InvalidTransferAuthorityError = V.InvalidDelegateRoleForTransferError = V.MissingAuthorizationRulesProgramError = void 0;
const oe = /* @__PURE__ */ new Map(), ae = /* @__PURE__ */ new Map();
class Xd extends Error {
  constructor() {
    super("Failed to unpack instruction data"), this.code = 0, this.name = "InstructionUnpackError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Xd);
  }
}
V.InstructionUnpackErrorError = Xd;
oe.set(0, () => new Xd());
ae.set("InstructionUnpackError", () => new Xd());
class Qd extends Error {
  constructor() {
    super("Failed to pack instruction data"), this.code = 1, this.name = "InstructionPackError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Qd);
  }
}
V.InstructionPackErrorError = Qd;
oe.set(1, () => new Qd());
ae.set("InstructionPackError", () => new Qd());
class eh extends Error {
  constructor() {
    super("Lamport balance below rent-exempt threshold"), this.code = 2, this.name = "NotRentExempt", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, eh);
  }
}
V.NotRentExemptError = eh;
oe.set(2, () => new eh());
ae.set("NotRentExempt", () => new eh());
class th extends Error {
  constructor() {
    super("Already initialized"), this.code = 3, this.name = "AlreadyInitialized", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, th);
  }
}
V.AlreadyInitializedError = th;
oe.set(3, () => new th());
ae.set("AlreadyInitialized", () => new th());
class nh extends Error {
  constructor() {
    super("Uninitialized"), this.code = 4, this.name = "Uninitialized", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, nh);
  }
}
V.UninitializedError = nh;
oe.set(4, () => new nh());
ae.set("Uninitialized", () => new nh());
class rh extends Error {
  constructor() {
    super(" Metadata's key must match seed of ['metadata', program id, mint] provided"), this.code = 5, this.name = "InvalidMetadataKey", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, rh);
  }
}
V.InvalidMetadataKeyError = rh;
oe.set(5, () => new rh());
ae.set("InvalidMetadataKey", () => new rh());
class ih extends Error {
  constructor() {
    super("Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"), this.code = 6, this.name = "InvalidEditionKey", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ih);
  }
}
V.InvalidEditionKeyError = ih;
oe.set(6, () => new ih());
ae.set("InvalidEditionKey", () => new ih());
class oh extends Error {
  constructor() {
    super("Update Authority given does not match"), this.code = 7, this.name = "UpdateAuthorityIncorrect", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, oh);
  }
}
V.UpdateAuthorityIncorrectError = oh;
oe.set(7, () => new oh());
ae.set("UpdateAuthorityIncorrect", () => new oh());
class ah extends Error {
  constructor() {
    super("Update Authority needs to be signer to update metadata"), this.code = 8, this.name = "UpdateAuthorityIsNotSigner", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ah);
  }
}
V.UpdateAuthorityIsNotSignerError = ah;
oe.set(8, () => new ah());
ae.set("UpdateAuthorityIsNotSigner", () => new ah());
class sh extends Error {
  constructor() {
    super("You must be the mint authority and signer on this transaction"), this.code = 9, this.name = "NotMintAuthority", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, sh);
  }
}
V.NotMintAuthorityError = sh;
oe.set(9, () => new sh());
ae.set("NotMintAuthority", () => new sh());
class ch extends Error {
  constructor() {
    super("Mint authority provided does not match the authority on the mint"), this.code = 10, this.name = "InvalidMintAuthority", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ch);
  }
}
V.InvalidMintAuthorityError = ch;
oe.set(10, () => new ch());
ae.set("InvalidMintAuthority", () => new ch());
class uh extends Error {
  constructor() {
    super("Name too long"), this.code = 11, this.name = "NameTooLong", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, uh);
  }
}
V.NameTooLongError = uh;
oe.set(11, () => new uh());
ae.set("NameTooLong", () => new uh());
class lh extends Error {
  constructor() {
    super("Symbol too long"), this.code = 12, this.name = "SymbolTooLong", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, lh);
  }
}
V.SymbolTooLongError = lh;
oe.set(12, () => new lh());
ae.set("SymbolTooLong", () => new lh());
class fh extends Error {
  constructor() {
    super("URI too long"), this.code = 13, this.name = "UriTooLong", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, fh);
  }
}
V.UriTooLongError = fh;
oe.set(13, () => new fh());
ae.set("UriTooLong", () => new fh());
class dh extends Error {
  constructor() {
    super("Update authority must be equivalent to the metadata's authority and also signer of this transaction"), this.code = 14, this.name = "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, dh);
  }
}
V.UpdateAuthorityMustBeEqualToMetadataAuthorityAndSignerError = dh;
oe.set(14, () => new dh());
ae.set("UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner", () => new dh());
class hh extends Error {
  constructor() {
    super("Mint given does not match mint on Metadata"), this.code = 15, this.name = "MintMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, hh);
  }
}
V.MintMismatchError = hh;
oe.set(15, () => new hh());
ae.set("MintMismatch", () => new hh());
class ph extends Error {
  constructor() {
    super("Editions must have exactly one token"), this.code = 16, this.name = "EditionsMustHaveExactlyOneToken", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ph);
  }
}
V.EditionsMustHaveExactlyOneTokenError = ph;
oe.set(16, () => new ph());
ae.set("EditionsMustHaveExactlyOneToken", () => new ph());
class yh extends Error {
  constructor() {
    super("Maximum editions printed already"), this.code = 17, this.name = "MaxEditionsMintedAlready", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, yh);
  }
}
V.MaxEditionsMintedAlreadyError = yh;
oe.set(17, () => new yh());
ae.set("MaxEditionsMintedAlready", () => new yh());
class gh extends Error {
  constructor() {
    super("Token mint to failed"), this.code = 18, this.name = "TokenMintToFailed", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, gh);
  }
}
V.TokenMintToFailedError = gh;
oe.set(18, () => new gh());
ae.set("TokenMintToFailed", () => new gh());
class bh extends Error {
  constructor() {
    super("The master edition record passed must match the master record on the edition given"), this.code = 19, this.name = "MasterRecordMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, bh);
  }
}
V.MasterRecordMismatchError = bh;
oe.set(19, () => new bh());
ae.set("MasterRecordMismatch", () => new bh());
class mh extends Error {
  constructor() {
    super("The destination account does not have the right mint"), this.code = 20, this.name = "DestinationMintMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, mh);
  }
}
V.DestinationMintMismatchError = mh;
oe.set(20, () => new mh());
ae.set("DestinationMintMismatch", () => new mh());
class _h extends Error {
  constructor() {
    super("An edition can only mint one of its kind!"), this.code = 21, this.name = "EditionAlreadyMinted", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, _h);
  }
}
V.EditionAlreadyMintedError = _h;
oe.set(21, () => new _h());
ae.set("EditionAlreadyMinted", () => new _h());
class wh extends Error {
  constructor() {
    super("Printing mint decimals should be zero"), this.code = 22, this.name = "PrintingMintDecimalsShouldBeZero", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, wh);
  }
}
V.PrintingMintDecimalsShouldBeZeroError = wh;
oe.set(22, () => new wh());
ae.set("PrintingMintDecimalsShouldBeZero", () => new wh());
class vh extends Error {
  constructor() {
    super("OneTimePrintingAuthorization mint decimals should be zero"), this.code = 23, this.name = "OneTimePrintingAuthorizationMintDecimalsShouldBeZero", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, vh);
  }
}
V.OneTimePrintingAuthorizationMintDecimalsShouldBeZeroError = vh;
oe.set(23, () => new vh());
ae.set("OneTimePrintingAuthorizationMintDecimalsShouldBeZero", () => new vh());
class Sh extends Error {
  constructor() {
    super("EditionMintDecimalsShouldBeZero"), this.code = 24, this.name = "EditionMintDecimalsShouldBeZero", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Sh);
  }
}
V.EditionMintDecimalsShouldBeZeroError = Sh;
oe.set(24, () => new Sh());
ae.set("EditionMintDecimalsShouldBeZero", () => new Sh());
class Eh extends Error {
  constructor() {
    super("Token burn failed"), this.code = 25, this.name = "TokenBurnFailed", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Eh);
  }
}
V.TokenBurnFailedError = Eh;
oe.set(25, () => new Eh());
ae.set("TokenBurnFailed", () => new Eh());
class Ah extends Error {
  constructor() {
    super("The One Time authorization mint does not match that on the token account!"), this.code = 26, this.name = "TokenAccountOneTimeAuthMintMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ah);
  }
}
V.TokenAccountOneTimeAuthMintMismatchError = Ah;
oe.set(26, () => new Ah());
ae.set("TokenAccountOneTimeAuthMintMismatch", () => new Ah());
class Ih extends Error {
  constructor() {
    super("Derived key invalid"), this.code = 27, this.name = "DerivedKeyInvalid", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ih);
  }
}
V.DerivedKeyInvalidError = Ih;
oe.set(27, () => new Ih());
ae.set("DerivedKeyInvalid", () => new Ih());
class kh extends Error {
  constructor() {
    super("The Printing mint does not match that on the master edition!"), this.code = 28, this.name = "PrintingMintMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, kh);
  }
}
V.PrintingMintMismatchError = kh;
oe.set(28, () => new kh());
ae.set("PrintingMintMismatch", () => new kh());
class Th extends Error {
  constructor() {
    super("The One Time Printing Auth mint does not match that on the master edition!"), this.code = 29, this.name = "OneTimePrintingAuthMintMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Th);
  }
}
V.OneTimePrintingAuthMintMismatchError = Th;
oe.set(29, () => new Th());
ae.set("OneTimePrintingAuthMintMismatch", () => new Th());
class xh extends Error {
  constructor() {
    super("The mint of the token account does not match the Printing mint!"), this.code = 30, this.name = "TokenAccountMintMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, xh);
  }
}
V.TokenAccountMintMismatchError = xh;
oe.set(30, () => new xh());
ae.set("TokenAccountMintMismatch", () => new xh());
class Mh extends Error {
  constructor() {
    super("The mint of the token account does not match the master metadata mint!"), this.code = 31, this.name = "TokenAccountMintMismatchV2", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Mh);
  }
}
V.TokenAccountMintMismatchV2Error = Mh;
oe.set(31, () => new Mh());
ae.set("TokenAccountMintMismatchV2", () => new Mh());
class Oh extends Error {
  constructor() {
    super("Not enough tokens to mint a limited edition"), this.code = 32, this.name = "NotEnoughTokens", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Oh);
  }
}
V.NotEnoughTokensError = Oh;
oe.set(32, () => new Oh());
ae.set("NotEnoughTokens", () => new Oh());
class Ph extends Error {
  constructor() {
    super("The mint on your authorization token holding account does not match your Printing mint!"), this.code = 33, this.name = "PrintingMintAuthorizationAccountMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ph);
  }
}
V.PrintingMintAuthorizationAccountMismatchError = Ph;
oe.set(33, () => new Ph());
ae.set("PrintingMintAuthorizationAccountMismatch", () => new Ph());
class Bh extends Error {
  constructor() {
    super("The authorization token account has a different owner than the update authority for the master edition!"), this.code = 34, this.name = "AuthorizationTokenAccountOwnerMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Bh);
  }
}
V.AuthorizationTokenAccountOwnerMismatchError = Bh;
oe.set(34, () => new Bh());
ae.set("AuthorizationTokenAccountOwnerMismatch", () => new Bh());
class Ch extends Error {
  constructor() {
    super("This feature is currently disabled."), this.code = 35, this.name = "Disabled", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ch);
  }
}
V.DisabledError = Ch;
oe.set(35, () => new Ch());
ae.set("Disabled", () => new Ch());
class Dh extends Error {
  constructor() {
    super("Creators list too long"), this.code = 36, this.name = "CreatorsTooLong", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Dh);
  }
}
V.CreatorsTooLongError = Dh;
oe.set(36, () => new Dh());
ae.set("CreatorsTooLong", () => new Dh());
class Rh extends Error {
  constructor() {
    super("Creators must be at least one if set"), this.code = 37, this.name = "CreatorsMustBeAtleastOne", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Rh);
  }
}
V.CreatorsMustBeAtleastOneError = Rh;
oe.set(37, () => new Rh());
ae.set("CreatorsMustBeAtleastOne", () => new Rh());
class Nh extends Error {
  constructor() {
    super("If using a creators array, you must be one of the creators listed"), this.code = 38, this.name = "MustBeOneOfCreators", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Nh);
  }
}
V.MustBeOneOfCreatorsError = Nh;
oe.set(38, () => new Nh());
ae.set("MustBeOneOfCreators", () => new Nh());
class jh extends Error {
  constructor() {
    super("This metadata does not have creators"), this.code = 39, this.name = "NoCreatorsPresentOnMetadata", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, jh);
  }
}
V.NoCreatorsPresentOnMetadataError = jh;
oe.set(39, () => new jh());
ae.set("NoCreatorsPresentOnMetadata", () => new jh());
class Uh extends Error {
  constructor() {
    super("This creator address was not found"), this.code = 40, this.name = "CreatorNotFound", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Uh);
  }
}
V.CreatorNotFoundError = Uh;
oe.set(40, () => new Uh());
ae.set("CreatorNotFound", () => new Uh());
class zh extends Error {
  constructor() {
    super("Basis points cannot be more than 10000"), this.code = 41, this.name = "InvalidBasisPoints", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, zh);
  }
}
V.InvalidBasisPointsError = zh;
oe.set(41, () => new zh());
ae.set("InvalidBasisPoints", () => new zh());
class Fh extends Error {
  constructor() {
    super("Primary sale can only be flipped to true and is immutable"), this.code = 42, this.name = "PrimarySaleCanOnlyBeFlippedToTrue", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Fh);
  }
}
V.PrimarySaleCanOnlyBeFlippedToTrueError = Fh;
oe.set(42, () => new Fh());
ae.set("PrimarySaleCanOnlyBeFlippedToTrue", () => new Fh());
class Lh extends Error {
  constructor() {
    super("Owner does not match that on the account given"), this.code = 43, this.name = "OwnerMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Lh);
  }
}
V.OwnerMismatchError = Lh;
oe.set(43, () => new Lh());
ae.set("OwnerMismatch", () => new Lh());
class $h extends Error {
  constructor() {
    super("This account has no tokens to be used for authorization"), this.code = 44, this.name = "NoBalanceInAccountForAuthorization", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, $h);
  }
}
V.NoBalanceInAccountForAuthorizationError = $h;
oe.set(44, () => new $h());
ae.set("NoBalanceInAccountForAuthorization", () => new $h());
class Wh extends Error {
  constructor() {
    super("Share total must equal 100 for creator array"), this.code = 45, this.name = "ShareTotalMustBe100", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Wh);
  }
}
V.ShareTotalMustBe100Error = Wh;
oe.set(45, () => new Wh());
ae.set("ShareTotalMustBe100", () => new Wh());
class Kh extends Error {
  constructor() {
    super("This reservation list already exists!"), this.code = 46, this.name = "ReservationExists", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Kh);
  }
}
V.ReservationExistsError = Kh;
oe.set(46, () => new Kh());
ae.set("ReservationExists", () => new Kh());
class Vh extends Error {
  constructor() {
    super("This reservation list does not exist!"), this.code = 47, this.name = "ReservationDoesNotExist", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Vh);
  }
}
V.ReservationDoesNotExistError = Vh;
oe.set(47, () => new Vh());
ae.set("ReservationDoesNotExist", () => new Vh());
class qh extends Error {
  constructor() {
    super("This reservation list exists but was never set with reservations"), this.code = 48, this.name = "ReservationNotSet", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, qh);
  }
}
V.ReservationNotSetError = qh;
oe.set(48, () => new qh());
ae.set("ReservationNotSet", () => new qh());
class Hh extends Error {
  constructor() {
    super("This reservation list has already been set!"), this.code = 49, this.name = "ReservationAlreadyMade", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Hh);
  }
}
V.ReservationAlreadyMadeError = Hh;
oe.set(49, () => new Hh());
ae.set("ReservationAlreadyMade", () => new Hh());
class Gh extends Error {
  constructor() {
    super("Provided more addresses than max allowed in single reservation"), this.code = 50, this.name = "BeyondMaxAddressSize", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Gh);
  }
}
V.BeyondMaxAddressSizeError = Gh;
oe.set(50, () => new Gh());
ae.set("BeyondMaxAddressSize", () => new Gh());
class Yh extends Error {
  constructor() {
    super("NumericalOverflowError"), this.code = 51, this.name = "NumericalOverflowError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Yh);
  }
}
V.NumericalOverflowErrorError = Yh;
oe.set(51, () => new Yh());
ae.set("NumericalOverflowError", () => new Yh());
class Zh extends Error {
  constructor() {
    super("This reservation would go beyond the maximum supply of the master edition!"), this.code = 52, this.name = "ReservationBreachesMaximumSupply", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Zh);
  }
}
V.ReservationBreachesMaximumSupplyError = Zh;
oe.set(52, () => new Zh());
ae.set("ReservationBreachesMaximumSupply", () => new Zh());
class Jh extends Error {
  constructor() {
    super("Address not in reservation!"), this.code = 53, this.name = "AddressNotInReservation", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Jh);
  }
}
V.AddressNotInReservationError = Jh;
oe.set(53, () => new Jh());
ae.set("AddressNotInReservation", () => new Jh());
class Xh extends Error {
  constructor() {
    super("You cannot unilaterally verify another creator, they must sign"), this.code = 54, this.name = "CannotVerifyAnotherCreator", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Xh);
  }
}
V.CannotVerifyAnotherCreatorError = Xh;
oe.set(54, () => new Xh());
ae.set("CannotVerifyAnotherCreator", () => new Xh());
class Qh extends Error {
  constructor() {
    super("You cannot unilaterally unverify another creator"), this.code = 55, this.name = "CannotUnverifyAnotherCreator", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Qh);
  }
}
V.CannotUnverifyAnotherCreatorError = Qh;
oe.set(55, () => new Qh());
ae.set("CannotUnverifyAnotherCreator", () => new Qh());
class ep extends Error {
  constructor() {
    super("In initial reservation setting, spots remaining should equal total spots"), this.code = 56, this.name = "SpotMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ep);
  }
}
V.SpotMismatchError = ep;
oe.set(56, () => new ep());
ae.set("SpotMismatch", () => new ep());
class tp extends Error {
  constructor() {
    super("Incorrect account owner"), this.code = 57, this.name = "IncorrectOwner", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, tp);
  }
}
V.IncorrectOwnerError = tp;
oe.set(57, () => new tp());
ae.set("IncorrectOwner", () => new tp());
class np extends Error {
  constructor() {
    super("printing these tokens would breach the maximum supply limit of the master edition"), this.code = 58, this.name = "PrintingWouldBreachMaximumSupply", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, np);
  }
}
V.PrintingWouldBreachMaximumSupplyError = np;
oe.set(58, () => new np());
ae.set("PrintingWouldBreachMaximumSupply", () => new np());
class rp extends Error {
  constructor() {
    super("Data is immutable"), this.code = 59, this.name = "DataIsImmutable", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, rp);
  }
}
V.DataIsImmutableError = rp;
oe.set(59, () => new rp());
ae.set("DataIsImmutable", () => new rp());
class ip extends Error {
  constructor() {
    super("No duplicate creator addresses"), this.code = 60, this.name = "DuplicateCreatorAddress", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ip);
  }
}
V.DuplicateCreatorAddressError = ip;
oe.set(60, () => new ip());
ae.set("DuplicateCreatorAddress", () => new ip());
class op extends Error {
  constructor() {
    super("Reservation spots remaining should match total spots when first being created"), this.code = 61, this.name = "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, op);
  }
}
V.ReservationSpotsRemainingShouldMatchTotalSpotsAtStartError = op;
oe.set(61, () => new op());
ae.set("ReservationSpotsRemainingShouldMatchTotalSpotsAtStart", () => new op());
class ap extends Error {
  constructor() {
    super("Invalid token program"), this.code = 62, this.name = "InvalidTokenProgram", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ap);
  }
}
V.InvalidTokenProgramError = ap;
oe.set(62, () => new ap());
ae.set("InvalidTokenProgram", () => new ap());
class sp extends Error {
  constructor() {
    super("Data type mismatch"), this.code = 63, this.name = "DataTypeMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, sp);
  }
}
V.DataTypeMismatchError = sp;
oe.set(63, () => new sp());
ae.set("DataTypeMismatch", () => new sp());
class cp extends Error {
  constructor() {
    super("Beyond alotted address size in reservation!"), this.code = 64, this.name = "BeyondAlottedAddressSize", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, cp);
  }
}
V.BeyondAlottedAddressSizeError = cp;
oe.set(64, () => new cp());
ae.set("BeyondAlottedAddressSize", () => new cp());
class up extends Error {
  constructor() {
    super("The reservation has only been partially alotted"), this.code = 65, this.name = "ReservationNotComplete", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, up);
  }
}
V.ReservationNotCompleteError = up;
oe.set(65, () => new up());
ae.set("ReservationNotComplete", () => new up());
class lp extends Error {
  constructor() {
    super("You cannot splice over an existing reservation!"), this.code = 66, this.name = "TriedToReplaceAnExistingReservation", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, lp);
  }
}
V.TriedToReplaceAnExistingReservationError = lp;
oe.set(66, () => new lp());
ae.set("TriedToReplaceAnExistingReservation", () => new lp());
class fp extends Error {
  constructor() {
    super("Invalid operation"), this.code = 67, this.name = "InvalidOperation", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, fp);
  }
}
V.InvalidOperationError = fp;
oe.set(67, () => new fp());
ae.set("InvalidOperation", () => new fp());
class dp extends Error {
  constructor() {
    super("Invalid Owner"), this.code = 68, this.name = "InvalidOwner", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, dp);
  }
}
V.InvalidOwnerError = dp;
oe.set(68, () => new dp());
ae.set("InvalidOwner", () => new dp());
class hp extends Error {
  constructor() {
    super("Printing mint supply must be zero for conversion"), this.code = 69, this.name = "PrintingMintSupplyMustBeZeroForConversion", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, hp);
  }
}
V.PrintingMintSupplyMustBeZeroForConversionError = hp;
oe.set(69, () => new hp());
ae.set("PrintingMintSupplyMustBeZeroForConversion", () => new hp());
class pp extends Error {
  constructor() {
    super("One Time Auth mint supply must be zero for conversion"), this.code = 70, this.name = "OneTimeAuthMintSupplyMustBeZeroForConversion", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, pp);
  }
}
V.OneTimeAuthMintSupplyMustBeZeroForConversionError = pp;
oe.set(70, () => new pp());
ae.set("OneTimeAuthMintSupplyMustBeZeroForConversion", () => new pp());
class yp extends Error {
  constructor() {
    super("You tried to insert one edition too many into an edition mark pda"), this.code = 71, this.name = "InvalidEditionIndex", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, yp);
  }
}
V.InvalidEditionIndexError = yp;
oe.set(71, () => new yp());
ae.set("InvalidEditionIndex", () => new yp());
class gp extends Error {
  constructor() {
    super("In the legacy system the reservation needs to be of size one for cpu limit reasons"), this.code = 72, this.name = "ReservationArrayShouldBeSizeOne", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, gp);
  }
}
V.ReservationArrayShouldBeSizeOneError = gp;
oe.set(72, () => new gp());
ae.set("ReservationArrayShouldBeSizeOne", () => new gp());
class bp extends Error {
  constructor() {
    super("Is Mutable can only be flipped to false"), this.code = 73, this.name = "IsMutableCanOnlyBeFlippedToFalse", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, bp);
  }
}
V.IsMutableCanOnlyBeFlippedToFalseError = bp;
oe.set(73, () => new bp());
ae.set("IsMutableCanOnlyBeFlippedToFalse", () => new bp());
class mp extends Error {
  constructor() {
    super("Collection cannot be verified in this instruction"), this.code = 74, this.name = "CollectionCannotBeVerifiedInThisInstruction", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, mp);
  }
}
V.CollectionCannotBeVerifiedInThisInstructionError = mp;
oe.set(74, () => new mp());
ae.set("CollectionCannotBeVerifiedInThisInstruction", () => new mp());
class _p extends Error {
  constructor() {
    super("This instruction was deprecated in a previous release and is now removed"), this.code = 75, this.name = "Removed", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, _p);
  }
}
V.RemovedError = _p;
oe.set(75, () => new _p());
ae.set("Removed", () => new _p());
class wp extends Error {
  constructor() {
    super("This token use method is burn and there are no remaining uses, it must be burned"), this.code = 76, this.name = "MustBeBurned", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, wp);
  }
}
V.MustBeBurnedError = wp;
oe.set(76, () => new wp());
ae.set("MustBeBurned", () => new wp());
class vp extends Error {
  constructor() {
    super("This use method is invalid"), this.code = 77, this.name = "InvalidUseMethod", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, vp);
  }
}
V.InvalidUseMethodError = vp;
oe.set(77, () => new vp());
ae.set("InvalidUseMethod", () => new vp());
class Sp extends Error {
  constructor() {
    super("Cannot Change Use Method after the first use"), this.code = 78, this.name = "CannotChangeUseMethodAfterFirstUse", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Sp);
  }
}
V.CannotChangeUseMethodAfterFirstUseError = Sp;
oe.set(78, () => new Sp());
ae.set("CannotChangeUseMethodAfterFirstUse", () => new Sp());
class Ep extends Error {
  constructor() {
    super("Cannot Change Remaining or Available uses after the first use"), this.code = 79, this.name = "CannotChangeUsesAfterFirstUse", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ep);
  }
}
V.CannotChangeUsesAfterFirstUseError = Ep;
oe.set(79, () => new Ep());
ae.set("CannotChangeUsesAfterFirstUse", () => new Ep());
class Ap extends Error {
  constructor() {
    super("Collection Not Found on Metadata"), this.code = 80, this.name = "CollectionNotFound", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ap);
  }
}
V.CollectionNotFoundError = Ap;
oe.set(80, () => new Ap());
ae.set("CollectionNotFound", () => new Ap());
class Ip extends Error {
  constructor() {
    super("Collection Update Authority is invalid"), this.code = 81, this.name = "InvalidCollectionUpdateAuthority", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ip);
  }
}
V.InvalidCollectionUpdateAuthorityError = Ip;
oe.set(81, () => new Ip());
ae.set("InvalidCollectionUpdateAuthority", () => new Ip());
class kp extends Error {
  constructor() {
    super("Collection Must Be a Unique Master Edition v2"), this.code = 82, this.name = "CollectionMustBeAUniqueMasterEdition", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, kp);
  }
}
V.CollectionMustBeAUniqueMasterEditionError = kp;
oe.set(82, () => new kp());
ae.set("CollectionMustBeAUniqueMasterEdition", () => new kp());
class Tp extends Error {
  constructor() {
    super("The Use Authority Record Already Exists, to modify it Revoke, then Approve"), this.code = 83, this.name = "UseAuthorityRecordAlreadyExists", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Tp);
  }
}
V.UseAuthorityRecordAlreadyExistsError = Tp;
oe.set(83, () => new Tp());
ae.set("UseAuthorityRecordAlreadyExists", () => new Tp());
class xp extends Error {
  constructor() {
    super("The Use Authority Record is empty or already revoked"), this.code = 84, this.name = "UseAuthorityRecordAlreadyRevoked", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, xp);
  }
}
V.UseAuthorityRecordAlreadyRevokedError = xp;
oe.set(84, () => new xp());
ae.set("UseAuthorityRecordAlreadyRevoked", () => new xp());
class Mp extends Error {
  constructor() {
    super("This token has no uses"), this.code = 85, this.name = "Unusable", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Mp);
  }
}
V.UnusableError = Mp;
oe.set(85, () => new Mp());
ae.set("Unusable", () => new Mp());
class Op extends Error {
  constructor() {
    super("There are not enough Uses left on this token."), this.code = 86, this.name = "NotEnoughUses", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Op);
  }
}
V.NotEnoughUsesError = Op;
oe.set(86, () => new Op());
ae.set("NotEnoughUses", () => new Op());
class Pp extends Error {
  constructor() {
    super("This Collection Authority Record Already Exists."), this.code = 87, this.name = "CollectionAuthorityRecordAlreadyExists", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Pp);
  }
}
V.CollectionAuthorityRecordAlreadyExistsError = Pp;
oe.set(87, () => new Pp());
ae.set("CollectionAuthorityRecordAlreadyExists", () => new Pp());
class Bp extends Error {
  constructor() {
    super("This Collection Authority Record Does Not Exist."), this.code = 88, this.name = "CollectionAuthorityDoesNotExist", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Bp);
  }
}
V.CollectionAuthorityDoesNotExistError = Bp;
oe.set(88, () => new Bp());
ae.set("CollectionAuthorityDoesNotExist", () => new Bp());
class Cp extends Error {
  constructor() {
    super("This Use Authority Record is invalid."), this.code = 89, this.name = "InvalidUseAuthorityRecord", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Cp);
  }
}
V.InvalidUseAuthorityRecordError = Cp;
oe.set(89, () => new Cp());
ae.set("InvalidUseAuthorityRecord", () => new Cp());
class Dp extends Error {
  constructor() {
    super("This Collection Authority Record is invalid."), this.code = 90, this.name = "InvalidCollectionAuthorityRecord", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Dp);
  }
}
V.InvalidCollectionAuthorityRecordError = Dp;
oe.set(90, () => new Dp());
ae.set("InvalidCollectionAuthorityRecord", () => new Dp());
class Rp extends Error {
  constructor() {
    super("Metadata does not match the freeze authority on the mint"), this.code = 91, this.name = "InvalidFreezeAuthority", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Rp);
  }
}
V.InvalidFreezeAuthorityError = Rp;
oe.set(91, () => new Rp());
ae.set("InvalidFreezeAuthority", () => new Rp());
class Np extends Error {
  constructor() {
    super("All tokens in this account have not been delegated to this user."), this.code = 92, this.name = "InvalidDelegate", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Np);
  }
}
V.InvalidDelegateError = Np;
oe.set(92, () => new Np());
ae.set("InvalidDelegate", () => new Np());
class jp extends Error {
  constructor() {
    super("Creator can not be adjusted once they are verified."), this.code = 93, this.name = "CannotAdjustVerifiedCreator", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, jp);
  }
}
V.CannotAdjustVerifiedCreatorError = jp;
oe.set(93, () => new jp());
ae.set("CannotAdjustVerifiedCreator", () => new jp());
class Up extends Error {
  constructor() {
    super("Verified creators cannot be removed."), this.code = 94, this.name = "CannotRemoveVerifiedCreator", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Up);
  }
}
V.CannotRemoveVerifiedCreatorError = Up;
oe.set(94, () => new Up());
ae.set("CannotRemoveVerifiedCreator", () => new Up());
class zp extends Error {
  constructor() {
    super("Can not wipe verified creators."), this.code = 95, this.name = "CannotWipeVerifiedCreators", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, zp);
  }
}
V.CannotWipeVerifiedCreatorsError = zp;
oe.set(95, () => new zp());
ae.set("CannotWipeVerifiedCreators", () => new zp());
class Fp extends Error {
  constructor() {
    super("Not allowed to change seller fee basis points."), this.code = 96, this.name = "NotAllowedToChangeSellerFeeBasisPoints", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Fp);
  }
}
V.NotAllowedToChangeSellerFeeBasisPointsError = Fp;
oe.set(96, () => new Fp());
ae.set("NotAllowedToChangeSellerFeeBasisPoints", () => new Fp());
class Lp extends Error {
  constructor() {
    super("Edition override cannot be zero"), this.code = 97, this.name = "EditionOverrideCannotBeZero", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Lp);
  }
}
V.EditionOverrideCannotBeZeroError = Lp;
oe.set(97, () => new Lp());
ae.set("EditionOverrideCannotBeZero", () => new Lp());
class $p extends Error {
  constructor() {
    super("Invalid User"), this.code = 98, this.name = "InvalidUser", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, $p);
  }
}
V.InvalidUserError = $p;
oe.set(98, () => new $p());
ae.set("InvalidUser", () => new $p());
class Wp extends Error {
  constructor() {
    super("Revoke Collection Authority signer is incorrect"), this.code = 99, this.name = "RevokeCollectionAuthoritySignerIncorrect", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Wp);
  }
}
V.RevokeCollectionAuthoritySignerIncorrectError = Wp;
oe.set(99, () => new Wp());
ae.set("RevokeCollectionAuthoritySignerIncorrect", () => new Wp());
class Kp extends Error {
  constructor() {
    super("Token close failed"), this.code = 100, this.name = "TokenCloseFailed", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Kp);
  }
}
V.TokenCloseFailedError = Kp;
oe.set(100, () => new Kp());
ae.set("TokenCloseFailed", () => new Kp());
class Vp extends Error {
  constructor() {
    super("Can't use this function on unsized collection"), this.code = 101, this.name = "UnsizedCollection", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Vp);
  }
}
V.UnsizedCollectionError = Vp;
oe.set(101, () => new Vp());
ae.set("UnsizedCollection", () => new Vp());
class qp extends Error {
  constructor() {
    super("Can't use this function on a sized collection"), this.code = 102, this.name = "SizedCollection", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, qp);
  }
}
V.SizedCollectionError = qp;
oe.set(102, () => new qp());
ae.set("SizedCollection", () => new qp());
class Hp extends Error {
  constructor() {
    super("Missing collection metadata account"), this.code = 103, this.name = "MissingCollectionMetadata", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Hp);
  }
}
V.MissingCollectionMetadataError = Hp;
oe.set(103, () => new Hp());
ae.set("MissingCollectionMetadata", () => new Hp());
class Gp extends Error {
  constructor() {
    super("This NFT is not a member of the specified collection."), this.code = 104, this.name = "NotAMemberOfCollection", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Gp);
  }
}
V.NotAMemberOfCollectionError = Gp;
oe.set(104, () => new Gp());
ae.set("NotAMemberOfCollection", () => new Gp());
class Yp extends Error {
  constructor() {
    super("This NFT is not a verified member of the specified collection."), this.code = 105, this.name = "NotVerifiedMemberOfCollection", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Yp);
  }
}
V.NotVerifiedMemberOfCollectionError = Yp;
oe.set(105, () => new Yp());
ae.set("NotVerifiedMemberOfCollection", () => new Yp());
class Zp extends Error {
  constructor() {
    super("This NFT is not a collection parent NFT."), this.code = 106, this.name = "NotACollectionParent", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Zp);
  }
}
V.NotACollectionParentError = Zp;
oe.set(106, () => new Zp());
ae.set("NotACollectionParent", () => new Zp());
class Jp extends Error {
  constructor() {
    super("Could not determine a TokenStandard type."), this.code = 107, this.name = "CouldNotDetermineTokenStandard", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Jp);
  }
}
V.CouldNotDetermineTokenStandardError = Jp;
oe.set(107, () => new Jp());
ae.set("CouldNotDetermineTokenStandard", () => new Jp());
class Xp extends Error {
  constructor() {
    super("This mint account has an edition but none was provided."), this.code = 108, this.name = "MissingEditionAccount", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Xp);
  }
}
V.MissingEditionAccountError = Xp;
oe.set(108, () => new Xp());
ae.set("MissingEditionAccount", () => new Xp());
class Qp extends Error {
  constructor() {
    super("This edition is not a Master Edition"), this.code = 109, this.name = "NotAMasterEdition", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Qp);
  }
}
V.NotAMasterEditionError = Qp;
oe.set(109, () => new Qp());
ae.set("NotAMasterEdition", () => new Qp());
class ey extends Error {
  constructor() {
    super("This Master Edition has existing prints"), this.code = 110, this.name = "MasterEditionHasPrints", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ey);
  }
}
V.MasterEditionHasPrintsError = ey;
oe.set(110, () => new ey());
ae.set("MasterEditionHasPrints", () => new ey());
class ty extends Error {
  constructor() {
    super("Borsh Deserialization Error"), this.code = 111, this.name = "BorshDeserializationError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ty);
  }
}
V.BorshDeserializationErrorError = ty;
oe.set(111, () => new ty());
ae.set("BorshDeserializationError", () => new ty());
class ny extends Error {
  constructor() {
    super("Cannot update a verified collection in this command"), this.code = 112, this.name = "CannotUpdateVerifiedCollection", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ny);
  }
}
V.CannotUpdateVerifiedCollectionError = ny;
oe.set(112, () => new ny());
ae.set("CannotUpdateVerifiedCollection", () => new ny());
class ry extends Error {
  constructor() {
    super("Edition account doesnt match collection "), this.code = 113, this.name = "CollectionMasterEditionAccountInvalid", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ry);
  }
}
V.CollectionMasterEditionAccountInvalidError = ry;
oe.set(113, () => new ry());
ae.set("CollectionMasterEditionAccountInvalid", () => new ry());
class iy extends Error {
  constructor() {
    super("Item is already verified."), this.code = 114, this.name = "AlreadyVerified", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, iy);
  }
}
V.AlreadyVerifiedError = iy;
oe.set(114, () => new iy());
ae.set("AlreadyVerified", () => new iy());
class oy extends Error {
  constructor() {
    super("Item is already unverified."), this.code = 115, this.name = "AlreadyUnverified", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, oy);
  }
}
V.AlreadyUnverifiedError = oy;
oe.set(115, () => new oy());
ae.set("AlreadyUnverified", () => new oy());
class ay extends Error {
  constructor() {
    super("This edition is not a Print Edition"), this.code = 116, this.name = "NotAPrintEdition", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ay);
  }
}
V.NotAPrintEditionError = ay;
oe.set(116, () => new ay());
ae.set("NotAPrintEdition", () => new ay());
class sy extends Error {
  constructor() {
    super("Invalid Master Edition"), this.code = 117, this.name = "InvalidMasterEdition", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, sy);
  }
}
V.InvalidMasterEditionError = sy;
oe.set(117, () => new sy());
ae.set("InvalidMasterEdition", () => new sy());
class cy extends Error {
  constructor() {
    super("Invalid Print Edition"), this.code = 118, this.name = "InvalidPrintEdition", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, cy);
  }
}
V.InvalidPrintEditionError = cy;
oe.set(118, () => new cy());
ae.set("InvalidPrintEdition", () => new cy());
class uy extends Error {
  constructor() {
    super("Invalid Edition Marker"), this.code = 119, this.name = "InvalidEditionMarker", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, uy);
  }
}
V.InvalidEditionMarkerError = uy;
oe.set(119, () => new uy());
ae.set("InvalidEditionMarker", () => new uy());
class ly extends Error {
  constructor() {
    super("Reservation List is Deprecated"), this.code = 120, this.name = "ReservationListDeprecated", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ly);
  }
}
V.ReservationListDeprecatedError = ly;
oe.set(120, () => new ly());
ae.set("ReservationListDeprecated", () => new ly());
class fy extends Error {
  constructor() {
    super("Print Edition does not match Master Edition"), this.code = 121, this.name = "PrintEditionDoesNotMatchMasterEdition", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, fy);
  }
}
V.PrintEditionDoesNotMatchMasterEditionError = fy;
oe.set(121, () => new fy());
ae.set("PrintEditionDoesNotMatchMasterEdition", () => new fy());
class dy extends Error {
  constructor() {
    super("Edition Number greater than max supply"), this.code = 122, this.name = "EditionNumberGreaterThanMaxSupply", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, dy);
  }
}
V.EditionNumberGreaterThanMaxSupplyError = dy;
oe.set(122, () => new dy());
ae.set("EditionNumberGreaterThanMaxSupply", () => new dy());
class hy extends Error {
  constructor() {
    super("Must unverify before migrating collections."), this.code = 123, this.name = "MustUnverify", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, hy);
  }
}
V.MustUnverifyError = hy;
oe.set(123, () => new hy());
ae.set("MustUnverify", () => new hy());
class py extends Error {
  constructor() {
    super("Invalid Escrow Account Bump Seed"), this.code = 124, this.name = "InvalidEscrowBumpSeed", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, py);
  }
}
V.InvalidEscrowBumpSeedError = py;
oe.set(124, () => new py());
ae.set("InvalidEscrowBumpSeed", () => new py());
class yy extends Error {
  constructor() {
    super("Must Escrow Authority"), this.code = 125, this.name = "MustBeEscrowAuthority", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, yy);
  }
}
V.MustBeEscrowAuthorityError = yy;
oe.set(125, () => new yy());
ae.set("MustBeEscrowAuthority", () => new yy());
class gy extends Error {
  constructor() {
    super("Invalid System Program"), this.code = 126, this.name = "InvalidSystemProgram", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, gy);
  }
}
V.InvalidSystemProgramError = gy;
oe.set(126, () => new gy());
ae.set("InvalidSystemProgram", () => new gy());
class by extends Error {
  constructor() {
    super("Must be a Non Fungible Token"), this.code = 127, this.name = "MustBeNonFungible", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, by);
  }
}
V.MustBeNonFungibleError = by;
oe.set(127, () => new by());
ae.set("MustBeNonFungible", () => new by());
class my extends Error {
  constructor() {
    super("Insufficient tokens for transfer"), this.code = 128, this.name = "InsufficientTokens", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, my);
  }
}
V.InsufficientTokensError = my;
oe.set(128, () => new my());
ae.set("InsufficientTokens", () => new my());
class _y extends Error {
  constructor() {
    super("Borsh Serialization Error"), this.code = 129, this.name = "BorshSerializationError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, _y);
  }
}
V.BorshSerializationErrorError = _y;
oe.set(129, () => new _y());
ae.set("BorshSerializationError", () => new _y());
class wy extends Error {
  constructor() {
    super("Cannot create NFT with no Freeze Authority."), this.code = 130, this.name = "NoFreezeAuthoritySet", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, wy);
  }
}
V.NoFreezeAuthoritySetError = wy;
oe.set(130, () => new wy());
ae.set("NoFreezeAuthoritySet", () => new wy());
class vy extends Error {
  constructor() {
    super("Invalid collection size change"), this.code = 131, this.name = "InvalidCollectionSizeChange", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, vy);
  }
}
V.InvalidCollectionSizeChangeError = vy;
oe.set(131, () => new vy());
ae.set("InvalidCollectionSizeChange", () => new vy());
class Sy extends Error {
  constructor() {
    super("Invalid bubblegum signer"), this.code = 132, this.name = "InvalidBubblegumSigner", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Sy);
  }
}
V.InvalidBubblegumSignerError = Sy;
oe.set(132, () => new Sy());
ae.set("InvalidBubblegumSigner", () => new Sy());
class Ey extends Error {
  constructor() {
    super("Escrow parent cannot have a delegate"), this.code = 133, this.name = "EscrowParentHasDelegate", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ey);
  }
}
V.EscrowParentHasDelegateError = Ey;
oe.set(133, () => new Ey());
ae.set("EscrowParentHasDelegate", () => new Ey());
class Ay extends Error {
  constructor() {
    super("Mint needs to be signer to initialize the account"), this.code = 134, this.name = "MintIsNotSigner", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ay);
  }
}
V.MintIsNotSignerError = Ay;
oe.set(134, () => new Ay());
ae.set("MintIsNotSigner", () => new Ay());
class Iy extends Error {
  constructor() {
    super("Invalid token standard"), this.code = 135, this.name = "InvalidTokenStandard", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Iy);
  }
}
V.InvalidTokenStandardError = Iy;
oe.set(135, () => new Iy());
ae.set("InvalidTokenStandard", () => new Iy());
class ky extends Error {
  constructor() {
    super("Invalid mint account for specified token standard"), this.code = 136, this.name = "InvalidMintForTokenStandard", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ky);
  }
}
V.InvalidMintForTokenStandardError = ky;
oe.set(136, () => new ky());
ae.set("InvalidMintForTokenStandard", () => new ky());
class Ty extends Error {
  constructor() {
    super("Invalid authorization rules account"), this.code = 137, this.name = "InvalidAuthorizationRules", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ty);
  }
}
V.InvalidAuthorizationRulesError = Ty;
oe.set(137, () => new Ty());
ae.set("InvalidAuthorizationRules", () => new Ty());
class xy extends Error {
  constructor() {
    super("Missing authorization rules account"), this.code = 138, this.name = "MissingAuthorizationRules", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, xy);
  }
}
V.MissingAuthorizationRulesError = xy;
oe.set(138, () => new xy());
ae.set("MissingAuthorizationRules", () => new xy());
class My extends Error {
  constructor() {
    super("Missing programmable configuration"), this.code = 139, this.name = "MissingProgrammableConfig", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, My);
  }
}
V.MissingProgrammableConfigError = My;
oe.set(139, () => new My());
ae.set("MissingProgrammableConfig", () => new My());
class Oy extends Error {
  constructor() {
    super("Invalid programmable configuration"), this.code = 140, this.name = "InvalidProgrammableConfig", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Oy);
  }
}
V.InvalidProgrammableConfigError = Oy;
oe.set(140, () => new Oy());
ae.set("InvalidProgrammableConfig", () => new Oy());
class Py extends Error {
  constructor() {
    super("Delegate already exists"), this.code = 141, this.name = "DelegateAlreadyExists", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Py);
  }
}
V.DelegateAlreadyExistsError = Py;
oe.set(141, () => new Py());
ae.set("DelegateAlreadyExists", () => new Py());
class By extends Error {
  constructor() {
    super("Delegate not found"), this.code = 142, this.name = "DelegateNotFound", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, By);
  }
}
V.DelegateNotFoundError = By;
oe.set(142, () => new By());
ae.set("DelegateNotFound", () => new By());
class Cy extends Error {
  constructor() {
    super("Required account not set in instruction builder"), this.code = 143, this.name = "MissingAccountInBuilder", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Cy);
  }
}
V.MissingAccountInBuilderError = Cy;
oe.set(143, () => new Cy());
ae.set("MissingAccountInBuilder", () => new Cy());
class Dy extends Error {
  constructor() {
    super("Required argument not set in instruction builder"), this.code = 144, this.name = "MissingArgumentInBuilder", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Dy);
  }
}
V.MissingArgumentInBuilderError = Dy;
oe.set(144, () => new Dy());
ae.set("MissingArgumentInBuilder", () => new Dy());
class Ry extends Error {
  constructor() {
    super("Feature not supported currently"), this.code = 145, this.name = "FeatureNotSupported", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ry);
  }
}
V.FeatureNotSupportedError = Ry;
oe.set(145, () => new Ry());
ae.set("FeatureNotSupported", () => new Ry());
class Ny extends Error {
  constructor() {
    super("Invalid system wallet"), this.code = 146, this.name = "InvalidSystemWallet", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ny);
  }
}
V.InvalidSystemWalletError = Ny;
oe.set(146, () => new Ny());
ae.set("InvalidSystemWallet", () => new Ny());
class jy extends Error {
  constructor() {
    super("Only the sale delegate can transfer while its set"), this.code = 147, this.name = "OnlySaleDelegateCanTransfer", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, jy);
  }
}
V.OnlySaleDelegateCanTransferError = jy;
oe.set(147, () => new jy());
ae.set("OnlySaleDelegateCanTransfer", () => new jy());
class Uy extends Error {
  constructor() {
    super("Missing token account"), this.code = 148, this.name = "MissingTokenAccount", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Uy);
  }
}
V.MissingTokenAccountError = Uy;
oe.set(148, () => new Uy());
ae.set("MissingTokenAccount", () => new Uy());
class zy extends Error {
  constructor() {
    super("Missing SPL token program"), this.code = 149, this.name = "MissingSplTokenProgram", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, zy);
  }
}
V.MissingSplTokenProgramError = zy;
oe.set(149, () => new zy());
ae.set("MissingSplTokenProgram", () => new zy());
class Fy extends Error {
  constructor() {
    super("Missing authorization rules program"), this.code = 150, this.name = "MissingAuthorizationRulesProgram", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Fy);
  }
}
V.MissingAuthorizationRulesProgramError = Fy;
oe.set(150, () => new Fy());
ae.set("MissingAuthorizationRulesProgram", () => new Fy());
class Ly extends Error {
  constructor() {
    super("Invalid delegate role for transfer"), this.code = 151, this.name = "InvalidDelegateRoleForTransfer", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ly);
  }
}
V.InvalidDelegateRoleForTransferError = Ly;
oe.set(151, () => new Ly());
ae.set("InvalidDelegateRoleForTransfer", () => new Ly());
class $y extends Error {
  constructor() {
    super("Invalid transfer authority"), this.code = 152, this.name = "InvalidTransferAuthority", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, $y);
  }
}
V.InvalidTransferAuthorityError = $y;
oe.set(152, () => new $y());
ae.set("InvalidTransferAuthority", () => new $y());
class Wy extends Error {
  constructor() {
    super("Instruction not supported for ProgrammableNonFungible assets"), this.code = 153, this.name = "InstructionNotSupported", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Wy);
  }
}
V.InstructionNotSupportedError = Wy;
oe.set(153, () => new Wy());
ae.set("InstructionNotSupported", () => new Wy());
class Ky extends Error {
  constructor() {
    super("Public key does not match expected value"), this.code = 154, this.name = "KeyMismatch", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Ky);
  }
}
V.KeyMismatchError = Ky;
oe.set(154, () => new Ky());
ae.set("KeyMismatch", () => new Ky());
class Vy extends Error {
  constructor() {
    super("Token is locked"), this.code = 155, this.name = "LockedToken", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Vy);
  }
}
V.LockedTokenError = Vy;
oe.set(155, () => new Vy());
ae.set("LockedToken", () => new Vy());
class qy extends Error {
  constructor() {
    super("Token is unlocked"), this.code = 156, this.name = "UnlockedToken", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, qy);
  }
}
V.UnlockedTokenError = qy;
oe.set(156, () => new qy());
ae.set("UnlockedToken", () => new qy());
class Hy extends Error {
  constructor() {
    super("Missing delegate role"), this.code = 157, this.name = "MissingDelegateRole", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Hy);
  }
}
V.MissingDelegateRoleError = Hy;
oe.set(157, () => new Hy());
ae.set("MissingDelegateRole", () => new Hy());
class Gy extends Error {
  constructor() {
    super("Invalid authority type"), this.code = 158, this.name = "InvalidAuthorityType", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Gy);
  }
}
V.InvalidAuthorityTypeError = Gy;
oe.set(158, () => new Gy());
ae.set("InvalidAuthorityType", () => new Gy());
class Yy extends Error {
  constructor() {
    super("Missing token record account"), this.code = 159, this.name = "MissingTokenRecord", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Yy);
  }
}
V.MissingTokenRecordError = Yy;
oe.set(159, () => new Yy());
ae.set("MissingTokenRecord", () => new Yy());
class Zy extends Error {
  constructor() {
    super("Mint supply must be zero for programmable assets"), this.code = 160, this.name = "MintSupplyMustBeZero", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Zy);
  }
}
V.MintSupplyMustBeZeroError = Zy;
oe.set(160, () => new Zy());
ae.set("MintSupplyMustBeZero", () => new Zy());
class Jy extends Error {
  constructor() {
    super("Data is empty or zeroed"), this.code = 161, this.name = "DataIsEmptyOrZeroed", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Jy);
  }
}
V.DataIsEmptyOrZeroedError = Jy;
oe.set(161, () => new Jy());
ae.set("DataIsEmptyOrZeroed", () => new Jy());
class Xy extends Error {
  constructor() {
    super("Missing token owner"), this.code = 162, this.name = "MissingTokenOwnerAccount", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Xy);
  }
}
V.MissingTokenOwnerAccountError = Xy;
oe.set(162, () => new Xy());
ae.set("MissingTokenOwnerAccount", () => new Xy());
class Qy extends Error {
  constructor() {
    super("Master edition account has an invalid length"), this.code = 163, this.name = "InvalidMasterEditionAccountLength", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, Qy);
  }
}
V.InvalidMasterEditionAccountLengthError = Qy;
oe.set(163, () => new Qy());
ae.set("InvalidMasterEditionAccountLength", () => new Qy());
class e0 extends Error {
  constructor() {
    super("Incorrect token state"), this.code = 164, this.name = "IncorrectTokenState", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, e0);
  }
}
V.IncorrectTokenStateError = e0;
oe.set(164, () => new e0());
ae.set("IncorrectTokenState", () => new e0());
class t0 extends Error {
  constructor() {
    super("Invalid delegate role"), this.code = 165, this.name = "InvalidDelegateRole", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, t0);
  }
}
V.InvalidDelegateRoleError = t0;
oe.set(165, () => new t0());
ae.set("InvalidDelegateRole", () => new t0());
class n0 extends Error {
  constructor() {
    super("Print supply is required for non-fungibles"), this.code = 166, this.name = "MissingPrintSupply", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, n0);
  }
}
V.MissingPrintSupplyError = n0;
oe.set(166, () => new n0());
ae.set("MissingPrintSupply", () => new n0());
class r0 extends Error {
  constructor() {
    super("Missing master edition account"), this.code = 167, this.name = "MissingMasterEditionAccount", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, r0);
  }
}
V.MissingMasterEditionAccountError = r0;
oe.set(167, () => new r0());
ae.set("MissingMasterEditionAccount", () => new r0());
class i0 extends Error {
  constructor() {
    super("Amount must be greater than zero"), this.code = 168, this.name = "AmountMustBeGreaterThanZero", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, i0);
  }
}
V.AmountMustBeGreaterThanZeroError = i0;
oe.set(168, () => new i0());
ae.set("AmountMustBeGreaterThanZero", () => new i0());
class o0 extends Error {
  constructor() {
    super("Invalid delegate args"), this.code = 169, this.name = "InvalidDelegateArgs", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, o0);
  }
}
V.InvalidDelegateArgsError = o0;
oe.set(169, () => new o0());
ae.set("InvalidDelegateArgs", () => new o0());
class a0 extends Error {
  constructor() {
    super("Missing address for locked transfer"), this.code = 170, this.name = "MissingLockedTransferAddress", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, a0);
  }
}
V.MissingLockedTransferAddressError = a0;
oe.set(170, () => new a0());
ae.set("MissingLockedTransferAddress", () => new a0());
class s0 extends Error {
  constructor() {
    super("Invalid destination address for locked transfer"), this.code = 171, this.name = "InvalidLockedTransferAddress", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, s0);
  }
}
V.InvalidLockedTransferAddressError = s0;
oe.set(171, () => new s0());
ae.set("InvalidLockedTransferAddress", () => new s0());
class c0 extends Error {
  constructor() {
    super("Exceeded account realloc increase limit"), this.code = 172, this.name = "DataIncrementLimitExceeded", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, c0);
  }
}
V.DataIncrementLimitExceededError = c0;
oe.set(172, () => new c0());
ae.set("DataIncrementLimitExceeded", () => new c0());
class u0 extends Error {
  constructor() {
    super("Cannot update the rule set of a programmable asset that has a delegate"), this.code = 173, this.name = "CannotUpdateAssetWithDelegate", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, u0);
  }
}
V.CannotUpdateAssetWithDelegateError = u0;
oe.set(173, () => new u0());
ae.set("CannotUpdateAssetWithDelegate", () => new u0());
class l0 extends Error {
  constructor() {
    super("Invalid token amount for this operation or token standard"), this.code = 174, this.name = "InvalidAmount", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, l0);
  }
}
V.InvalidAmountError = l0;
oe.set(174, () => new l0());
ae.set("InvalidAmount", () => new l0());
class f0 extends Error {
  constructor() {
    super("Missing master edition mint account"), this.code = 175, this.name = "MissingMasterEditionMintAccount", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, f0);
  }
}
V.MissingMasterEditionMintAccountError = f0;
oe.set(175, () => new f0());
ae.set("MissingMasterEditionMintAccount", () => new f0());
class d0 extends Error {
  constructor() {
    super("Missing master edition token account"), this.code = 176, this.name = "MissingMasterEditionTokenAccount", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, d0);
  }
}
V.MissingMasterEditionTokenAccountError = d0;
oe.set(176, () => new d0());
ae.set("MissingMasterEditionTokenAccount", () => new d0());
class h0 extends Error {
  constructor() {
    super("Missing edition marker account"), this.code = 177, this.name = "MissingEditionMarkerAccount", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, h0);
  }
}
V.MissingEditionMarkerAccountError = h0;
oe.set(177, () => new h0());
ae.set("MissingEditionMarkerAccount", () => new h0());
class p0 extends Error {
  constructor() {
    super("Cannot burn while persistent delegate is set"), this.code = 178, this.name = "CannotBurnWithDelegate", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, p0);
  }
}
V.CannotBurnWithDelegateError = p0;
oe.set(178, () => new p0());
ae.set("CannotBurnWithDelegate", () => new p0());
class y0 extends Error {
  constructor() {
    super("Missing edition account"), this.code = 179, this.name = "MissingEdition", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, y0);
  }
}
V.MissingEditionError = y0;
oe.set(179, () => new y0());
ae.set("MissingEdition", () => new y0());
class g0 extends Error {
  constructor() {
    super("Invalid Associated Token Account Program"), this.code = 180, this.name = "InvalidAssociatedTokenAccountProgram", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, g0);
  }
}
V.InvalidAssociatedTokenAccountProgramError = g0;
oe.set(180, () => new g0());
ae.set("InvalidAssociatedTokenAccountProgram", () => new g0());
class b0 extends Error {
  constructor() {
    super("Invalid InstructionsSysvar"), this.code = 181, this.name = "InvalidInstructionsSysvar", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, b0);
  }
}
V.InvalidInstructionsSysvarError = b0;
oe.set(181, () => new b0());
ae.set("InvalidInstructionsSysvar", () => new b0());
class m0 extends Error {
  constructor() {
    super("Invalid or Unneeded parent accounts"), this.code = 182, this.name = "InvalidParentAccounts", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, m0);
  }
}
V.InvalidParentAccountsError = m0;
oe.set(182, () => new m0());
ae.set("InvalidParentAccounts", () => new m0());
class _0 extends Error {
  constructor() {
    super("Authority cannot apply all update args"), this.code = 183, this.name = "InvalidUpdateArgs", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, _0);
  }
}
V.InvalidUpdateArgsError = _0;
oe.set(183, () => new _0());
ae.set("InvalidUpdateArgs", () => new _0());
class w0 extends Error {
  constructor() {
    super("Token account does not have enough tokens"), this.code = 184, this.name = "InsufficientTokenBalance", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, w0);
  }
}
V.InsufficientTokenBalanceError = w0;
oe.set(184, () => new w0());
ae.set("InsufficientTokenBalance", () => new w0());
class v0 extends Error {
  constructor() {
    super("Missing collection account"), this.code = 185, this.name = "MissingCollectionMint", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, v0);
  }
}
V.MissingCollectionMintError = v0;
oe.set(185, () => new v0());
ae.set("MissingCollectionMint", () => new v0());
class S0 extends Error {
  constructor() {
    super("Missing collection master edition account"), this.code = 186, this.name = "MissingCollectionMasterEdition", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, S0);
  }
}
V.MissingCollectionMasterEditionError = S0;
oe.set(186, () => new S0());
ae.set("MissingCollectionMasterEdition", () => new S0());
class E0 extends Error {
  constructor() {
    super("Invalid token record account"), this.code = 187, this.name = "InvalidTokenRecord", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, E0);
  }
}
V.InvalidTokenRecordError = E0;
oe.set(187, () => new E0());
ae.set("InvalidTokenRecord", () => new E0());
class A0 extends Error {
  constructor() {
    super("The close authority needs to be revoked by the Utility Delegate"), this.code = 188, this.name = "InvalidCloseAuthority", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, A0);
  }
}
V.InvalidCloseAuthorityError = A0;
oe.set(188, () => new A0());
ae.set("InvalidCloseAuthority", () => new A0());
class I0 extends Error {
  constructor() {
    super("Invalid or removed instruction"), this.code = 189, this.name = "InvalidInstruction", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, I0);
  }
}
V.InvalidInstructionError = I0;
oe.set(189, () => new I0());
ae.set("InvalidInstruction", () => new I0());
class k0 extends Error {
  constructor() {
    super("Missing delegate record"), this.code = 190, this.name = "MissingDelegateRecord", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, k0);
  }
}
V.MissingDelegateRecordError = k0;
oe.set(190, () => new k0());
ae.set("MissingDelegateRecord", () => new k0());
class T0 extends Error {
  constructor() {
    super(""), this.code = 191, this.name = "InvalidFeeAccount", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, T0);
  }
}
V.InvalidFeeAccountError = T0;
oe.set(191, () => new T0());
ae.set("InvalidFeeAccount", () => new T0());
class x0 extends Error {
  constructor() {
    super(""), this.code = 192, this.name = "InvalidMetadataFlags", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, x0);
  }
}
V.InvalidMetadataFlagsError = x0;
oe.set(192, () => new x0());
ae.set("InvalidMetadataFlags", () => new x0());
function _re(e) {
  const t = oe.get(e);
  return t != null ? t() : null;
}
V.errorFromCode = _re;
function wre(e) {
  const t = ae.get(e);
  return t != null ? t() : null;
}
V.errorFromName = wre;
var oN = {}, aN = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createApproveCollectionAuthorityInstruction = e.approveCollectionAuthorityInstructionDiscriminator = e.ApproveCollectionAuthorityStruct = void 0;
  const i = r(Se), o = r(we);
  e.ApproveCollectionAuthorityStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "ApproveCollectionAuthorityInstructionArgs"), e.approveCollectionAuthorityInstructionDiscriminator = 23;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var l;
    const [u] = e.ApproveCollectionAuthorityStruct.serialize({
      instructionDiscriminator: e.approveCollectionAuthorityInstructionDiscriminator
    }), f = [
      {
        pubkey: s.collectionAuthorityRecord,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.newCollectionAuthority,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.updateAuthority,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (l = s.systemProgram) !== null && l !== void 0 ? l : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return s.rent != null && f.push({
      pubkey: s.rent,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: c,
      keys: f,
      data: u
    });
  }
  e.createApproveCollectionAuthorityInstruction = a;
})(aN);
var sN = {}, yi = {}, cN = {}, N_ = {}, ot = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.programSupportsExtensions = e.NATIVE_MINT_2022 = e.NATIVE_MINT = e.ASSOCIATED_TOKEN_PROGRAM_ID = e.TOKEN_2022_PROGRAM_ID = e.TOKEN_PROGRAM_ID = void 0;
  const t = we;
  e.TOKEN_PROGRAM_ID = new t.PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), e.TOKEN_2022_PROGRAM_ID = new t.PublicKey("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb"), e.ASSOCIATED_TOKEN_PROGRAM_ID = new t.PublicKey("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"), e.NATIVE_MINT = new t.PublicKey("So11111111111111111111111111111111111111112"), e.NATIVE_MINT_2022 = new t.PublicKey("9pan9bMn5HatX4EJdBwg9VgCa7Uz5HL8N1m5D3NdXejP");
  function n(r) {
    return r !== e.TOKEN_PROGRAM_ID;
  }
  e.programSupportsExtensions = n;
})(ot);
var j_ = {};
const Fn = /* @__PURE__ */ Qc(wte);
var dt = {};
Object.defineProperty(dt, "__esModule", { value: !0 });
dt.TokenUnsupportedInstructionError = dt.TokenInvalidInstructionTypeError = dt.TokenInvalidInstructionDataError = dt.TokenInvalidInstructionKeysError = dt.TokenInvalidInstructionProgramError = dt.TokenOwnerOffCurveError = dt.TokenInvalidOwnerError = dt.TokenInvalidMintError = dt.TokenInvalidAccountSizeError = dt.TokenInvalidAccountOwnerError = dt.TokenInvalidAccountError = dt.TokenAccountNotFoundError = dt.TokenError = void 0;
class Yi extends Error {
  constructor(t) {
    super(t);
  }
}
dt.TokenError = Yi;
class vre extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenAccountNotFoundError";
  }
}
dt.TokenAccountNotFoundError = vre;
class Sre extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountError";
  }
}
dt.TokenInvalidAccountError = Sre;
class Ere extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountOwnerError";
  }
}
dt.TokenInvalidAccountOwnerError = Ere;
class Are extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenInvalidAccountSizeError";
  }
}
dt.TokenInvalidAccountSizeError = Are;
class Ire extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenInvalidMintError";
  }
}
dt.TokenInvalidMintError = Ire;
class kre extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenInvalidOwnerError";
  }
}
dt.TokenInvalidOwnerError = kre;
class Tre extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenOwnerOffCurveError";
  }
}
dt.TokenOwnerOffCurveError = Tre;
class xre extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenInvalidInstructionProgramError";
  }
}
dt.TokenInvalidInstructionProgramError = xre;
class Mre extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenInvalidInstructionKeysError";
  }
}
dt.TokenInvalidInstructionKeysError = Mre;
class Ore extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenInvalidInstructionDataError";
  }
}
dt.TokenInvalidInstructionDataError = Ore;
class Pre extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenInvalidInstructionTypeError";
  }
}
dt.TokenInvalidInstructionTypeError = Pre;
class Bre extends Yi {
  constructor() {
    super(...arguments), this.name = "TokenUnsupportedInstructionError";
  }
}
dt.TokenUnsupportedInstructionError = Bre;
var nn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.TokenInstruction = void 0, function(t) {
    t[t.InitializeMint = 0] = "InitializeMint", t[t.InitializeAccount = 1] = "InitializeAccount", t[t.InitializeMultisig = 2] = "InitializeMultisig", t[t.Transfer = 3] = "Transfer", t[t.Approve = 4] = "Approve", t[t.Revoke = 5] = "Revoke", t[t.SetAuthority = 6] = "SetAuthority", t[t.MintTo = 7] = "MintTo", t[t.Burn = 8] = "Burn", t[t.CloseAccount = 9] = "CloseAccount", t[t.FreezeAccount = 10] = "FreezeAccount", t[t.ThawAccount = 11] = "ThawAccount", t[t.TransferChecked = 12] = "TransferChecked", t[t.ApproveChecked = 13] = "ApproveChecked", t[t.MintToChecked = 14] = "MintToChecked", t[t.BurnChecked = 15] = "BurnChecked", t[t.InitializeAccount2 = 16] = "InitializeAccount2", t[t.SyncNative = 17] = "SyncNative", t[t.InitializeAccount3 = 18] = "InitializeAccount3", t[t.InitializeMultisig2 = 19] = "InitializeMultisig2", t[t.InitializeMint2 = 20] = "InitializeMint2", t[t.GetAccountDataSize = 21] = "GetAccountDataSize", t[t.InitializeImmutableOwner = 22] = "InitializeImmutableOwner", t[t.AmountToUiAmount = 23] = "AmountToUiAmount", t[t.UiAmountToAmount = 24] = "UiAmountToAmount", t[t.InitializeMintCloseAuthority = 25] = "InitializeMintCloseAuthority", t[t.TransferFeeExtension = 26] = "TransferFeeExtension", t[t.ConfidentialTransferExtension = 27] = "ConfidentialTransferExtension", t[t.DefaultAccountStateExtension = 28] = "DefaultAccountStateExtension", t[t.Reallocate = 29] = "Reallocate", t[t.MemoTransferExtension = 30] = "MemoTransferExtension", t[t.CreateNativeMint = 31] = "CreateNativeMint", t[t.InitializeNonTransferableMint = 32] = "InitializeNonTransferableMint", t[t.InterestBearingMintExtension = 33] = "InterestBearingMintExtension", t[t.CpiGuardExtension = 34] = "CpiGuardExtension", t[t.InitializePermanentDelegate = 35] = "InitializePermanentDelegate";
  }(e.TokenInstruction || (e.TokenInstruction = {}));
})(nn);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeAmountToUiAmountInstructionUnchecked = e.decodeAmountToUiAmountInstruction = e.createAmountToUiAmountInstruction = e.amountToUiAmountInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = nn;
  e.amountToUiAmountInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, n.u64)("amount")
  ]);
  function s(u, f, d = i.TOKEN_PROGRAM_ID) {
    const h = [{ pubkey: u, isSigner: !1, isWritable: !1 }], g = Buffer.alloc(e.amountToUiAmountInstructionData.span);
    return e.amountToUiAmountInstructionData.encode({
      instruction: a.TokenInstruction.AmountToUiAmount,
      amount: BigInt(f)
    }, g), new r.TransactionInstruction({ keys: h, programId: d, data: g });
  }
  e.createAmountToUiAmountInstruction = s;
  function c(u, f = i.TOKEN_PROGRAM_ID) {
    if (!u.programId.equals(f))
      throw new o.TokenInvalidInstructionProgramError();
    if (u.data.length !== e.amountToUiAmountInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { mint: d }, data: h } = l(u);
    if (h.instruction !== a.TokenInstruction.AmountToUiAmount)
      throw new o.TokenInvalidInstructionTypeError();
    if (!d)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: f,
      keys: {
        mint: d
      },
      data: h
    };
  }
  e.decodeAmountToUiAmountInstruction = c;
  function l({ programId: u, keys: [f], data: d }) {
    return {
      programId: u,
      keys: {
        mint: f
      },
      data: e.amountToUiAmountInstructionData.decode(d)
    };
  }
  e.decodeAmountToUiAmountInstructionUnchecked = l;
})(j_);
var Cre = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(N_, "__esModule", { value: !0 });
N_.amountToUiAmount = void 0;
const Dre = we, Rre = ot, Nre = j_;
function jre(e, t, n, r, i = Rre.TOKEN_PROGRAM_ID) {
  return Cre(this, void 0, void 0, function* () {
    const o = new Dre.Transaction().add((0, Nre.createAmountToUiAmountInstruction)(n, r, i)), { returnData: a, err: s } = (yield e.simulateTransaction(o, [t], !1)).value;
    return a != null && a.data ? Buffer.from(a.data[0], a.data[1]).toString("utf-8") : s;
  });
}
N_.amountToUiAmount = jre;
var U_ = {}, z_ = {}, Ar = {};
Object.defineProperty(Ar, "__esModule", { value: !0 });
Ar.addSigners = void 0;
const Ure = we;
function zre(e, t, n) {
  if (n.length) {
    e.push({ pubkey: t, isSigner: !1, isWritable: !1 });
    for (const r of n)
      e.push({
        pubkey: r instanceof Ure.PublicKey ? r : r.publicKey,
        isSigner: !0,
        isWritable: !1
      });
  } else
    e.push({ pubkey: t, isSigner: !0, isWritable: !1 });
  return e;
}
Ar.addSigners = zre;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeApproveInstructionUnchecked = e.decodeApproveInstruction = e.createApproveInstruction = e.approveInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = Ar, s = nn;
  e.approveInstructionData = (0, t.struct)([(0, t.u8)("instruction"), (0, n.u64)("amount")]);
  function c(f, d, h, g, w = [], b = i.TOKEN_PROGRAM_ID) {
    const I = (0, a.addSigners)([
      { pubkey: f, isSigner: !1, isWritable: !0 },
      { pubkey: d, isSigner: !1, isWritable: !1 }
    ], h, w), A = Buffer.alloc(e.approveInstructionData.span);
    return e.approveInstructionData.encode({
      instruction: s.TokenInstruction.Approve,
      amount: BigInt(g)
    }, A), new r.TransactionInstruction({ keys: I, programId: b, data: A });
  }
  e.createApproveInstruction = c;
  function l(f, d = i.TOKEN_PROGRAM_ID) {
    if (!f.programId.equals(d))
      throw new o.TokenInvalidInstructionProgramError();
    if (f.data.length !== e.approveInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { account: h, delegate: g, owner: w, multiSigners: b }, data: I } = u(f);
    if (I.instruction !== s.TokenInstruction.Approve)
      throw new o.TokenInvalidInstructionTypeError();
    if (!h || !g || !w)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: d,
      keys: {
        account: h,
        delegate: g,
        owner: w,
        multiSigners: b
      },
      data: I
    };
  }
  e.decodeApproveInstruction = l;
  function u({ programId: f, keys: [d, h, g, ...w], data: b }) {
    return {
      programId: f,
      keys: {
        account: d,
        delegate: h,
        owner: g,
        multiSigners: w
      },
      data: e.approveInstructionData.decode(b)
    };
  }
  e.decodeApproveInstructionUnchecked = u;
})(z_);
var Tr = {};
Object.defineProperty(Tr, "__esModule", { value: !0 });
Tr.getSigners = void 0;
const Fre = we;
function Lre(e, t) {
  return e instanceof Fre.PublicKey ? [e, t] : [e.publicKey, [e]];
}
Tr.getSigners = Lre;
var $re = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(U_, "__esModule", { value: !0 });
U_.approve = void 0;
const sP = we, Wre = ot, Kre = z_, Vre = Tr;
function qre(e, t, n, r, i, o, a = [], s, c = Wre.TOKEN_PROGRAM_ID) {
  return $re(this, void 0, void 0, function* () {
    const [l, u] = (0, Vre.getSigners)(i, a), f = new sP.Transaction().add((0, Kre.createApproveInstruction)(n, r, l, o, a, c));
    return yield (0, sP.sendAndConfirmTransaction)(e, f, [t, ...u], s);
  });
}
U_.approve = qre;
var F_ = {}, L_ = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeApproveCheckedInstructionUnchecked = e.decodeApproveCheckedInstruction = e.createApproveCheckedInstruction = e.approveCheckedInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = Ar, s = nn;
  e.approveCheckedInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, n.u64)("amount"),
    (0, t.u8)("decimals")
  ]);
  function c(f, d, h, g, w, b, I = [], A = i.TOKEN_PROGRAM_ID) {
    const x = (0, a.addSigners)([
      { pubkey: f, isSigner: !1, isWritable: !0 },
      { pubkey: d, isSigner: !1, isWritable: !1 },
      { pubkey: h, isSigner: !1, isWritable: !1 }
    ], g, I), N = Buffer.alloc(e.approveCheckedInstructionData.span);
    return e.approveCheckedInstructionData.encode({
      instruction: s.TokenInstruction.ApproveChecked,
      amount: BigInt(w),
      decimals: b
    }, N), new r.TransactionInstruction({ keys: x, programId: A, data: N });
  }
  e.createApproveCheckedInstruction = c;
  function l(f, d = i.TOKEN_PROGRAM_ID) {
    if (!f.programId.equals(d))
      throw new o.TokenInvalidInstructionProgramError();
    if (f.data.length !== e.approveCheckedInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { account: h, mint: g, delegate: w, owner: b, multiSigners: I }, data: A } = u(f);
    if (A.instruction !== s.TokenInstruction.ApproveChecked)
      throw new o.TokenInvalidInstructionTypeError();
    if (!h || !g || !w || !b)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: d,
      keys: {
        account: h,
        mint: g,
        delegate: w,
        owner: b,
        multiSigners: I
      },
      data: A
    };
  }
  e.decodeApproveCheckedInstruction = l;
  function u({ programId: f, keys: [d, h, g, w, ...b], data: I }) {
    return {
      programId: f,
      keys: {
        account: d,
        mint: h,
        delegate: g,
        owner: w,
        multiSigners: b
      },
      data: e.approveCheckedInstructionData.decode(I)
    };
  }
  e.decodeApproveCheckedInstructionUnchecked = u;
})(L_);
var Hre = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(F_, "__esModule", { value: !0 });
F_.approveChecked = void 0;
const cP = we, Gre = ot, Yre = L_, Zre = Tr;
function Jre(e, t, n, r, i, o, a, s, c = [], l, u = Gre.TOKEN_PROGRAM_ID) {
  return Hre(this, void 0, void 0, function* () {
    const [f, d] = (0, Zre.getSigners)(o, c), h = new cP.Transaction().add((0, Yre.createApproveCheckedInstruction)(r, n, i, f, a, s, c, u));
    return yield (0, cP.sendAndConfirmTransaction)(e, h, [t, ...d], l);
  });
}
F_.approveChecked = Jre;
var $_ = {}, W_ = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeBurnInstructionUnchecked = e.decodeBurnInstruction = e.createBurnInstruction = e.burnInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = Ar, s = nn;
  e.burnInstructionData = (0, t.struct)([(0, t.u8)("instruction"), (0, n.u64)("amount")]);
  function c(f, d, h, g, w = [], b = i.TOKEN_PROGRAM_ID) {
    const I = (0, a.addSigners)([
      { pubkey: f, isSigner: !1, isWritable: !0 },
      { pubkey: d, isSigner: !1, isWritable: !0 }
    ], h, w), A = Buffer.alloc(e.burnInstructionData.span);
    return e.burnInstructionData.encode({
      instruction: s.TokenInstruction.Burn,
      amount: BigInt(g)
    }, A), new r.TransactionInstruction({ keys: I, programId: b, data: A });
  }
  e.createBurnInstruction = c;
  function l(f, d = i.TOKEN_PROGRAM_ID) {
    if (!f.programId.equals(d))
      throw new o.TokenInvalidInstructionProgramError();
    if (f.data.length !== e.burnInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { account: h, mint: g, owner: w, multiSigners: b }, data: I } = u(f);
    if (I.instruction !== s.TokenInstruction.Burn)
      throw new o.TokenInvalidInstructionTypeError();
    if (!h || !g || !w)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: d,
      keys: {
        account: h,
        mint: g,
        owner: w,
        multiSigners: b
      },
      data: I
    };
  }
  e.decodeBurnInstruction = l;
  function u({ programId: f, keys: [d, h, g, ...w], data: b }) {
    return {
      programId: f,
      keys: {
        account: d,
        mint: h,
        owner: g,
        multiSigners: w
      },
      data: e.burnInstructionData.decode(b)
    };
  }
  e.decodeBurnInstructionUnchecked = u;
})(W_);
var Xre = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty($_, "__esModule", { value: !0 });
$_.burn = void 0;
const uP = we, Qre = ot, eie = W_, tie = Tr;
function nie(e, t, n, r, i, o, a = [], s, c = Qre.TOKEN_PROGRAM_ID) {
  return Xre(this, void 0, void 0, function* () {
    const [l, u] = (0, tie.getSigners)(i, a), f = new uP.Transaction().add((0, eie.createBurnInstruction)(n, r, l, o, a, c));
    return yield (0, uP.sendAndConfirmTransaction)(e, f, [t, ...u], s);
  });
}
$_.burn = nie;
var K_ = {}, V_ = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeBurnCheckedInstructionUnchecked = e.decodeBurnCheckedInstruction = e.createBurnCheckedInstruction = e.burnCheckedInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = Ar, s = nn;
  e.burnCheckedInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, n.u64)("amount"),
    (0, t.u8)("decimals")
  ]);
  function c(f, d, h, g, w, b = [], I = i.TOKEN_PROGRAM_ID) {
    const A = (0, a.addSigners)([
      { pubkey: f, isSigner: !1, isWritable: !0 },
      { pubkey: d, isSigner: !1, isWritable: !0 }
    ], h, b), x = Buffer.alloc(e.burnCheckedInstructionData.span);
    return e.burnCheckedInstructionData.encode({
      instruction: s.TokenInstruction.BurnChecked,
      amount: BigInt(g),
      decimals: w
    }, x), new r.TransactionInstruction({ keys: A, programId: I, data: x });
  }
  e.createBurnCheckedInstruction = c;
  function l(f, d = i.TOKEN_PROGRAM_ID) {
    if (!f.programId.equals(d))
      throw new o.TokenInvalidInstructionProgramError();
    if (f.data.length !== e.burnCheckedInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { account: h, mint: g, owner: w, multiSigners: b }, data: I } = u(f);
    if (I.instruction !== s.TokenInstruction.BurnChecked)
      throw new o.TokenInvalidInstructionTypeError();
    if (!h || !g || !w)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: d,
      keys: {
        account: h,
        mint: g,
        owner: w,
        multiSigners: b
      },
      data: I
    };
  }
  e.decodeBurnCheckedInstruction = l;
  function u({ programId: f, keys: [d, h, g, ...w], data: b }) {
    return {
      programId: f,
      keys: {
        account: d,
        mint: h,
        owner: g,
        multiSigners: w
      },
      data: e.burnCheckedInstructionData.decode(b)
    };
  }
  e.decodeBurnCheckedInstructionUnchecked = u;
})(V_);
var rie = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(K_, "__esModule", { value: !0 });
K_.burnChecked = void 0;
const lP = we, iie = ot, oie = V_, aie = Tr;
function sie(e, t, n, r, i, o, a, s = [], c, l = iie.TOKEN_PROGRAM_ID) {
  return rie(this, void 0, void 0, function* () {
    const [u, f] = (0, aie.getSigners)(i, s), d = new lP.Transaction().add((0, oie.createBurnCheckedInstruction)(n, r, u, o, a, s, l));
    return yield (0, lP.sendAndConfirmTransaction)(e, d, [t, ...f], c);
  });
}
K_.burnChecked = sie;
var q_ = {}, H_ = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeCloseAccountInstructionUnchecked = e.decodeCloseAccountInstruction = e.createCloseAccountInstruction = e.closeAccountInstructionData = void 0;
  const t = ie, n = we, r = ot, i = dt, o = Ar, a = nn;
  e.closeAccountInstructionData = (0, t.struct)([(0, t.u8)("instruction")]);
  function s(u, f, d, h = [], g = r.TOKEN_PROGRAM_ID) {
    const w = (0, o.addSigners)([
      { pubkey: u, isSigner: !1, isWritable: !0 },
      { pubkey: f, isSigner: !1, isWritable: !0 }
    ], d, h), b = Buffer.alloc(e.closeAccountInstructionData.span);
    return e.closeAccountInstructionData.encode({ instruction: a.TokenInstruction.CloseAccount }, b), new n.TransactionInstruction({ keys: w, programId: g, data: b });
  }
  e.createCloseAccountInstruction = s;
  function c(u, f = r.TOKEN_PROGRAM_ID) {
    if (!u.programId.equals(f))
      throw new i.TokenInvalidInstructionProgramError();
    if (u.data.length !== e.closeAccountInstructionData.span)
      throw new i.TokenInvalidInstructionDataError();
    const { keys: { account: d, destination: h, authority: g, multiSigners: w }, data: b } = l(u);
    if (b.instruction !== a.TokenInstruction.CloseAccount)
      throw new i.TokenInvalidInstructionTypeError();
    if (!d || !h || !g)
      throw new i.TokenInvalidInstructionKeysError();
    return {
      programId: f,
      keys: {
        account: d,
        destination: h,
        authority: g,
        multiSigners: w
      },
      data: b
    };
  }
  e.decodeCloseAccountInstruction = c;
  function l({ programId: u, keys: [f, d, h, ...g], data: w }) {
    return {
      programId: u,
      keys: {
        account: f,
        destination: d,
        authority: h,
        multiSigners: g
      },
      data: e.closeAccountInstructionData.decode(w)
    };
  }
  e.decodeCloseAccountInstructionUnchecked = l;
})(H_);
var cie = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(q_, "__esModule", { value: !0 });
q_.closeAccount = void 0;
const fP = we, uie = ot, lie = H_, fie = Tr;
function die(e, t, n, r, i, o = [], a, s = uie.TOKEN_PROGRAM_ID) {
  return cie(this, void 0, void 0, function* () {
    const [c, l] = (0, fie.getSigners)(i, o), u = new fP.Transaction().add((0, lie.createCloseAccountInstruction)(n, r, c, o, s));
    return yield (0, fP.sendAndConfirmTransaction)(e, u, [t, ...l], a);
  });
}
q_.closeAccount = die;
var M0 = {}, wS = {}, vS = {}, O0 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ACCOUNT_TYPE_SIZE = e.AccountType = void 0, function(t) {
    t[t.Uninitialized = 0] = "Uninitialized", t[t.Mint = 1] = "Mint", t[t.Account = 2] = "Account";
  }(e.AccountType || (e.AccountType = {})), e.ACCOUNT_TYPE_SIZE = 1;
})(O0);
var Yl = {};
(function(e) {
  var t = _ && _.__awaiter || function(l, u, f, d) {
    function h(g) {
      return g instanceof f ? g : new f(function(w) {
        w(g);
      });
    }
    return new (f || (f = Promise))(function(g, w) {
      function b(x) {
        try {
          A(d.next(x));
        } catch (N) {
          w(N);
        }
      }
      function I(x) {
        try {
          A(d.throw(x));
        } catch (N) {
          w(N);
        }
      }
      function A(x) {
        x.done ? g(x.value) : h(x.value).then(b, I);
      }
      A((d = d.apply(l, u || [])).next());
    });
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getMinimumBalanceForRentExemptMultisig = e.unpackMultisig = e.getMultisig = e.MULTISIG_SIZE = e.MultisigLayout = void 0;
  const n = ie, r = Fn, i = ot, o = dt;
  e.MultisigLayout = (0, n.struct)([
    (0, n.u8)("m"),
    (0, n.u8)("n"),
    (0, r.bool)("isInitialized"),
    (0, r.publicKey)("signer1"),
    (0, r.publicKey)("signer2"),
    (0, r.publicKey)("signer3"),
    (0, r.publicKey)("signer4"),
    (0, r.publicKey)("signer5"),
    (0, r.publicKey)("signer6"),
    (0, r.publicKey)("signer7"),
    (0, r.publicKey)("signer8"),
    (0, r.publicKey)("signer9"),
    (0, r.publicKey)("signer10"),
    (0, r.publicKey)("signer11")
  ]), e.MULTISIG_SIZE = e.MultisigLayout.span;
  function a(l, u, f, d = i.TOKEN_PROGRAM_ID) {
    return t(this, void 0, void 0, function* () {
      const h = yield l.getAccountInfo(u, f);
      return s(u, h, d);
    });
  }
  e.getMultisig = a;
  function s(l, u, f = i.TOKEN_PROGRAM_ID) {
    if (!u)
      throw new o.TokenAccountNotFoundError();
    if (!u.owner.equals(f))
      throw new o.TokenInvalidAccountOwnerError();
    if (u.data.length != e.MULTISIG_SIZE)
      throw new o.TokenInvalidAccountSizeError();
    const d = e.MultisigLayout.decode(u.data);
    return Object.assign({ address: l }, d);
  }
  e.unpackMultisig = s;
  function c(l, u) {
    return t(this, void 0, void 0, function* () {
      return yield l.getMinimumBalanceForRentExemption(e.MULTISIG_SIZE, u);
    });
  }
  e.getMinimumBalanceForRentExemptMultisig = c;
})(Yl);
var dP;
function P0() {
  return dP || (dP = 1, function(e) {
    var t = _ && _.__awaiter || function(w, b, I, A) {
      function x(N) {
        return N instanceof I ? N : new I(function(j) {
          j(N);
        });
      }
      return new (I || (I = Promise))(function(N, j) {
        function K(k) {
          try {
            O(A.next(k));
          } catch (z) {
            j(z);
          }
        }
        function W(k) {
          try {
            O(A.throw(k));
          } catch (z) {
            j(z);
          }
        }
        function O(k) {
          k.done ? N(k.value) : x(k.value).then(K, W);
        }
        O((A = A.apply(w, b || [])).next());
      });
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.unpackAccount = e.getMinimumBalanceForRentExemptAccountWithExtensions = e.getMinimumBalanceForRentExemptAccount = e.getMultipleAccounts = e.getAccount = e.ACCOUNT_SIZE = e.AccountLayout = e.AccountState = void 0;
    const n = ie, r = Fn, i = ot, o = dt, a = O0, s = Mi(), c = Yl;
    var l;
    (function(w) {
      w[w.Uninitialized = 0] = "Uninitialized", w[w.Initialized = 1] = "Initialized", w[w.Frozen = 2] = "Frozen";
    })(l = e.AccountState || (e.AccountState = {})), e.AccountLayout = (0, n.struct)([
      (0, r.publicKey)("mint"),
      (0, r.publicKey)("owner"),
      (0, r.u64)("amount"),
      (0, n.u32)("delegateOption"),
      (0, r.publicKey)("delegate"),
      (0, n.u8)("state"),
      (0, n.u32)("isNativeOption"),
      (0, r.u64)("isNative"),
      (0, r.u64)("delegatedAmount"),
      (0, n.u32)("closeAuthorityOption"),
      (0, r.publicKey)("closeAuthority")
    ]), e.ACCOUNT_SIZE = e.AccountLayout.span;
    function u(w, b, I, A = i.TOKEN_PROGRAM_ID) {
      return t(this, void 0, void 0, function* () {
        const x = yield w.getAccountInfo(b, I);
        return g(b, x, A);
      });
    }
    e.getAccount = u;
    function f(w, b, I, A = i.TOKEN_PROGRAM_ID) {
      return t(this, void 0, void 0, function* () {
        const x = yield w.getMultipleAccountsInfo(b, I);
        return b.map((N, j) => g(N, x[j], A));
      });
    }
    e.getMultipleAccounts = f;
    function d(w, b) {
      return t(this, void 0, void 0, function* () {
        return yield h(w, [], b);
      });
    }
    e.getMinimumBalanceForRentExemptAccount = d;
    function h(w, b, I) {
      return t(this, void 0, void 0, function* () {
        const A = (0, s.getAccountLen)(b);
        return yield w.getMinimumBalanceForRentExemption(A, I);
      });
    }
    e.getMinimumBalanceForRentExemptAccountWithExtensions = h;
    function g(w, b, I = i.TOKEN_PROGRAM_ID) {
      if (!b)
        throw new o.TokenAccountNotFoundError();
      if (!b.owner.equals(I))
        throw new o.TokenInvalidAccountOwnerError();
      if (b.data.length < e.ACCOUNT_SIZE)
        throw new o.TokenInvalidAccountSizeError();
      const A = e.AccountLayout.decode(b.data.slice(0, e.ACCOUNT_SIZE));
      let x = Buffer.alloc(0);
      if (b.data.length > e.ACCOUNT_SIZE) {
        if (b.data.length === c.MULTISIG_SIZE)
          throw new o.TokenInvalidAccountSizeError();
        if (b.data[e.ACCOUNT_SIZE] != a.AccountType.Account)
          throw new o.TokenInvalidAccountError();
        x = b.data.slice(e.ACCOUNT_SIZE + a.ACCOUNT_TYPE_SIZE);
      }
      return {
        address: w,
        mint: A.mint,
        owner: A.owner,
        amount: A.amount,
        delegate: A.delegateOption ? A.delegate : null,
        delegatedAmount: A.delegatedAmount,
        isInitialized: A.state !== l.Uninitialized,
        isFrozen: A.state === l.Frozen,
        isNative: !!A.isNativeOption,
        rentExemptReserve: A.isNativeOption ? A.isNative : null,
        closeAuthority: A.closeAuthorityOption ? A.closeAuthority : null,
        tlvData: x
      };
    }
    e.unpackAccount = g;
  }(vS)), vS;
}
var SS = {}, hP;
function ac() {
  return hP || (hP = 1, function(e) {
    var t = _ && _.__awaiter || function(I, A, x, N) {
      function j(K) {
        return K instanceof x ? K : new x(function(W) {
          W(K);
        });
      }
      return new (x || (x = Promise))(function(K, W) {
        function O(C) {
          try {
            z(N.next(C));
          } catch (M) {
            W(M);
          }
        }
        function k(C) {
          try {
            z(N.throw(C));
          } catch (M) {
            W(M);
          }
        }
        function z(C) {
          C.done ? K(C.value) : j(C.value).then(O, k);
        }
        z((N = N.apply(I, A || [])).next());
      });
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getAssociatedTokenAddressSync = e.getAssociatedTokenAddress = e.getMinimumBalanceForRentExemptMintWithExtensions = e.getMinimumBalanceForRentExemptMint = e.unpackMint = e.getMint = e.MINT_SIZE = e.MintLayout = void 0;
    const n = ie, r = Fn, i = we, o = ot, a = dt, s = O0, c = Mi(), l = P0(), u = Yl;
    e.MintLayout = (0, n.struct)([
      (0, n.u32)("mintAuthorityOption"),
      (0, r.publicKey)("mintAuthority"),
      (0, r.u64)("supply"),
      (0, n.u8)("decimals"),
      (0, r.bool)("isInitialized"),
      (0, n.u32)("freezeAuthorityOption"),
      (0, r.publicKey)("freezeAuthority")
    ]), e.MINT_SIZE = e.MintLayout.span;
    function f(I, A, x, N = o.TOKEN_PROGRAM_ID) {
      return t(this, void 0, void 0, function* () {
        const j = yield I.getAccountInfo(A, x);
        return d(A, j, N);
      });
    }
    e.getMint = f;
    function d(I, A, x = o.TOKEN_PROGRAM_ID) {
      if (!A)
        throw new a.TokenAccountNotFoundError();
      if (!A.owner.equals(x))
        throw new a.TokenInvalidAccountOwnerError();
      if (A.data.length < e.MINT_SIZE)
        throw new a.TokenInvalidAccountSizeError();
      const N = e.MintLayout.decode(A.data.slice(0, e.MINT_SIZE));
      let j = Buffer.alloc(0);
      if (A.data.length > e.MINT_SIZE) {
        if (A.data.length <= l.ACCOUNT_SIZE)
          throw new a.TokenInvalidAccountSizeError();
        if (A.data.length === u.MULTISIG_SIZE)
          throw new a.TokenInvalidAccountSizeError();
        if (A.data[l.ACCOUNT_SIZE] != s.AccountType.Mint)
          throw new a.TokenInvalidMintError();
        j = A.data.slice(l.ACCOUNT_SIZE + s.ACCOUNT_TYPE_SIZE);
      }
      return {
        address: I,
        mintAuthority: N.mintAuthorityOption ? N.mintAuthority : null,
        supply: N.supply,
        decimals: N.decimals,
        isInitialized: N.isInitialized,
        freezeAuthority: N.freezeAuthorityOption ? N.freezeAuthority : null,
        tlvData: j
      };
    }
    e.unpackMint = d;
    function h(I, A) {
      return t(this, void 0, void 0, function* () {
        return yield g(I, [], A);
      });
    }
    e.getMinimumBalanceForRentExemptMint = h;
    function g(I, A, x) {
      return t(this, void 0, void 0, function* () {
        const N = (0, c.getMintLen)(A);
        return yield I.getMinimumBalanceForRentExemption(N, x);
      });
    }
    e.getMinimumBalanceForRentExemptMintWithExtensions = g;
    function w(I, A, x = !1, N = o.TOKEN_PROGRAM_ID, j = o.ASSOCIATED_TOKEN_PROGRAM_ID) {
      return t(this, void 0, void 0, function* () {
        if (!x && !i.PublicKey.isOnCurve(A.toBuffer()))
          throw new a.TokenOwnerOffCurveError();
        const [K] = yield i.PublicKey.findProgramAddress([A.toBuffer(), N.toBuffer(), I.toBuffer()], j);
        return K;
      });
    }
    e.getAssociatedTokenAddress = w;
    function b(I, A, x = !1, N = o.TOKEN_PROGRAM_ID, j = o.ASSOCIATED_TOKEN_PROGRAM_ID) {
      if (!x && !i.PublicKey.isOnCurve(A.toBuffer()))
        throw new a.TokenOwnerOffCurveError();
      const [K] = i.PublicKey.findProgramAddressSync([A.toBuffer(), N.toBuffer(), I.toBuffer()], j);
      return K;
    }
    e.getAssociatedTokenAddressSync = b;
  }(SS)), SS;
}
var ES = {}, Al = {}, yT = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createDisableCpiGuardInstruction = e.createEnableCpiGuardInstruction = e.cpiGuardInstructionData = e.CpiGuardInstruction = void 0;
  const t = ie, n = we, r = ot, i = dt, o = Ar, a = nn;
  var s;
  (function(f) {
    f[f.Enable = 0] = "Enable", f[f.Disable = 1] = "Disable";
  })(s = e.CpiGuardInstruction || (e.CpiGuardInstruction = {})), e.cpiGuardInstructionData = (0, t.struct)([(0, t.u8)("instruction"), (0, t.u8)("cpiGuardInstruction")]);
  function c(f, d, h = [], g = r.TOKEN_2022_PROGRAM_ID) {
    return u(s.Enable, f, d, h, g);
  }
  e.createEnableCpiGuardInstruction = c;
  function l(f, d, h = [], g = r.TOKEN_2022_PROGRAM_ID) {
    return u(s.Disable, f, d, h, g);
  }
  e.createDisableCpiGuardInstruction = l;
  function u(f, d, h, g, w) {
    if (!(0, r.programSupportsExtensions)(w))
      throw new i.TokenUnsupportedInstructionError();
    const b = (0, o.addSigners)([{ pubkey: d, isSigner: !1, isWritable: !0 }], h, g), I = Buffer.alloc(e.cpiGuardInstructionData.span);
    return e.cpiGuardInstructionData.encode({
      instruction: a.TokenInstruction.CpiGuardExtension,
      cpiGuardInstruction: f
    }, I), new n.TransactionInstruction({ keys: b, programId: w, data: I });
  }
})(yT);
var uN = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(Al, "__esModule", { value: !0 });
Al.disableCpiGuard = Al.enableCpiGuard = void 0;
const nm = we, lN = Tr, fN = ot, dN = yT;
function hie(e, t, n, r, i = [], o, a = fN.TOKEN_2022_PROGRAM_ID) {
  return uN(this, void 0, void 0, function* () {
    const [s, c] = (0, lN.getSigners)(r, i), l = new nm.Transaction().add((0, dN.createEnableCpiGuardInstruction)(n, s, c, a));
    return yield (0, nm.sendAndConfirmTransaction)(e, l, [t, ...c], o);
  });
}
Al.enableCpiGuard = hie;
function pie(e, t, n, r, i = [], o, a = fN.TOKEN_2022_PROGRAM_ID) {
  return uN(this, void 0, void 0, function* () {
    const [s, c] = (0, lN.getSigners)(r, i), l = new nm.Transaction().add((0, dN.createDisableCpiGuardInstruction)(n, s, c, a));
    return yield (0, nm.sendAndConfirmTransaction)(e, l, [t, ...c], o);
  });
}
Al.disableCpiGuard = pie;
var AS = {}, pP;
function yie() {
  return pP || (pP = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getCpiGuard = e.CPI_GUARD_SIZE = e.CpiGuardLayout = void 0;
    const t = ie, n = Fn, r = Mi();
    e.CpiGuardLayout = (0, t.struct)([(0, n.bool)("lockCpi")]), e.CPI_GUARD_SIZE = e.CpiGuardLayout.span;
    function i(o) {
      const a = (0, r.getExtensionData)(r.ExtensionType.CpiGuard, o.tlvData);
      return a !== null ? e.CpiGuardLayout.decode(a) : null;
    }
    e.getCpiGuard = i;
  }(AS)), AS;
}
var yP;
function hN() {
  return yP || (yP = 1, function(e) {
    var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
      a === void 0 && (a = o);
      var s = Object.getOwnPropertyDescriptor(i, o);
      (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return i[o];
      } }), Object.defineProperty(r, a, s);
    } : function(r, i, o, a) {
      a === void 0 && (a = o), r[a] = i[o];
    }), n = _ && _.__exportStar || function(r, i) {
      for (var o in r)
        o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), n(Al, e), n(yT, e), n(yie(), e);
  }(ES)), ES;
}
var IS = {}, Il = {}, gT = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUpdateDefaultAccountStateInstruction = e.createInitializeDefaultAccountStateInstruction = e.defaultAccountStateInstructionData = e.DefaultAccountStateInstruction = void 0;
  const t = ie, n = we, r = ot, i = dt, o = Ar, a = nn;
  var s;
  (function(u) {
    u[u.Initialize = 0] = "Initialize", u[u.Update = 1] = "Update";
  })(s = e.DefaultAccountStateInstruction || (e.DefaultAccountStateInstruction = {})), e.defaultAccountStateInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("defaultAccountStateInstruction"),
    (0, t.u8)("accountState")
  ]);
  function c(u, f, d = r.TOKEN_2022_PROGRAM_ID) {
    if (!(0, r.programSupportsExtensions)(d))
      throw new i.TokenUnsupportedInstructionError();
    const h = [{ pubkey: u, isSigner: !1, isWritable: !0 }], g = Buffer.alloc(e.defaultAccountStateInstructionData.span);
    return e.defaultAccountStateInstructionData.encode({
      instruction: a.TokenInstruction.DefaultAccountStateExtension,
      defaultAccountStateInstruction: s.Initialize,
      accountState: f
    }, g), new n.TransactionInstruction({ keys: h, programId: d, data: g });
  }
  e.createInitializeDefaultAccountStateInstruction = c;
  function l(u, f, d, h = [], g = r.TOKEN_2022_PROGRAM_ID) {
    if (!(0, r.programSupportsExtensions)(g))
      throw new i.TokenUnsupportedInstructionError();
    const w = (0, o.addSigners)([{ pubkey: u, isSigner: !1, isWritable: !0 }], d, h), b = Buffer.alloc(e.defaultAccountStateInstructionData.span);
    return e.defaultAccountStateInstructionData.encode({
      instruction: a.TokenInstruction.DefaultAccountStateExtension,
      defaultAccountStateInstruction: s.Update,
      accountState: f
    }, b), new n.TransactionInstruction({ keys: w, programId: g, data: b });
  }
  e.createUpdateDefaultAccountStateInstruction = l;
})(gT);
var pN = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(Il, "__esModule", { value: !0 });
Il.updateDefaultAccountState = Il.initializeDefaultAccountState = void 0;
const rm = we, gie = Tr, yN = ot, gN = gT;
function bie(e, t, n, r, i, o = yN.TOKEN_2022_PROGRAM_ID) {
  return pN(this, void 0, void 0, function* () {
    const a = new rm.Transaction().add((0, gN.createInitializeDefaultAccountStateInstruction)(n, r, o));
    return yield (0, rm.sendAndConfirmTransaction)(e, a, [t], i);
  });
}
Il.initializeDefaultAccountState = bie;
function mie(e, t, n, r, i, o = [], a, s = yN.TOKEN_2022_PROGRAM_ID) {
  return pN(this, void 0, void 0, function* () {
    const [c, l] = (0, gie.getSigners)(i, o), u = new rm.Transaction().add((0, gN.createUpdateDefaultAccountStateInstruction)(n, r, c, l, s));
    return yield (0, rm.sendAndConfirmTransaction)(e, u, [t, ...l], a);
  });
}
Il.updateDefaultAccountState = mie;
var kS = {}, gP;
function _ie() {
  return gP || (gP = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getDefaultAccountState = e.DEFAULT_ACCOUNT_STATE_SIZE = e.DefaultAccountStateLayout = void 0;
    const t = ie, n = Mi();
    e.DefaultAccountStateLayout = (0, t.struct)([(0, t.u8)("state")]), e.DEFAULT_ACCOUNT_STATE_SIZE = e.DefaultAccountStateLayout.span;
    function r(i) {
      const o = (0, n.getExtensionData)(n.ExtensionType.DefaultAccountState, i.tlvData);
      return o !== null ? e.DefaultAccountStateLayout.decode(o) : null;
    }
    e.getDefaultAccountState = r;
  }(kS)), kS;
}
var bP;
function bN() {
  return bP || (bP = 1, function(e) {
    var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
      a === void 0 && (a = o);
      var s = Object.getOwnPropertyDescriptor(i, o);
      (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return i[o];
      } }), Object.defineProperty(r, a, s);
    } : function(r, i, o, a) {
      a === void 0 && (a = o), r[a] = i[o];
    }), n = _ && _.__exportStar || function(r, i) {
      for (var o in r)
        o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), n(Il, e), n(gT, e), n(_ie(), e);
  }(IS)), IS;
}
var TS = {}, mP;
function mN() {
  return mP || (mP = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getImmutableOwner = e.IMMUTABLE_OWNER_SIZE = e.ImmutableOwnerLayout = void 0;
    const t = ie, n = Mi();
    e.ImmutableOwnerLayout = (0, t.struct)([]), e.IMMUTABLE_OWNER_SIZE = e.ImmutableOwnerLayout.span;
    function r(i) {
      const o = (0, n.getExtensionData)(n.ExtensionType.ImmutableOwner, i.tlvData);
      return o !== null ? e.ImmutableOwnerLayout.decode(o) : null;
    }
    e.getImmutableOwner = r;
  }(TS)), TS;
}
var xS = {}, _P;
function _N() {
  return _P || (_P = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getInterestBearingMintConfigState = e.INTEREST_BEARING_MINT_CONFIG_STATE_SIZE = e.InterestBearingMintConfigStateLayout = void 0;
    const t = ie, n = Fn, r = Mi();
    e.InterestBearingMintConfigStateLayout = (0, t.struct)([
      (0, n.publicKey)("rateAuthority"),
      (0, t.ns64)("initializationTimestamp"),
      (0, t.s16)("preUpdateAverageRate"),
      (0, t.ns64)("lastUpdateTimestamp"),
      (0, t.s16)("currentRate")
    ]), e.INTEREST_BEARING_MINT_CONFIG_STATE_SIZE = e.InterestBearingMintConfigStateLayout.span;
    function i(o) {
      const a = (0, r.getExtensionData)(r.ExtensionType.InterestBearingConfig, o.tlvData);
      return a !== null ? e.InterestBearingMintConfigStateLayout.decode(a) : null;
    }
    e.getInterestBearingMintConfigState = i;
  }(xS)), xS;
}
var MS = {}, kl = {}, bT = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createDisableRequiredMemoTransfersInstruction = e.createEnableRequiredMemoTransfersInstruction = e.memoTransferInstructionData = e.MemoTransferInstruction = void 0;
  const t = ie, n = we, r = ot, i = dt, o = Ar, a = nn;
  var s;
  (function(f) {
    f[f.Enable = 0] = "Enable", f[f.Disable = 1] = "Disable";
  })(s = e.MemoTransferInstruction || (e.MemoTransferInstruction = {})), e.memoTransferInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("memoTransferInstruction")
  ]);
  function c(f, d, h = [], g = r.TOKEN_2022_PROGRAM_ID) {
    return u(s.Enable, f, d, h, g);
  }
  e.createEnableRequiredMemoTransfersInstruction = c;
  function l(f, d, h = [], g = r.TOKEN_2022_PROGRAM_ID) {
    return u(s.Disable, f, d, h, g);
  }
  e.createDisableRequiredMemoTransfersInstruction = l;
  function u(f, d, h, g, w) {
    if (!(0, r.programSupportsExtensions)(w))
      throw new i.TokenUnsupportedInstructionError();
    const b = (0, o.addSigners)([{ pubkey: d, isSigner: !1, isWritable: !0 }], h, g), I = Buffer.alloc(e.memoTransferInstructionData.span);
    return e.memoTransferInstructionData.encode({
      instruction: a.TokenInstruction.MemoTransferExtension,
      memoTransferInstruction: f
    }, I), new n.TransactionInstruction({ keys: b, programId: w, data: I });
  }
})(bT);
var wN = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(kl, "__esModule", { value: !0 });
kl.disableRequiredMemoTransfers = kl.enableRequiredMemoTransfers = void 0;
const im = we, vN = Tr, SN = ot, EN = bT;
function wie(e, t, n, r, i = [], o, a = SN.TOKEN_2022_PROGRAM_ID) {
  return wN(this, void 0, void 0, function* () {
    const [s, c] = (0, vN.getSigners)(r, i), l = new im.Transaction().add((0, EN.createEnableRequiredMemoTransfersInstruction)(n, s, c, a));
    return yield (0, im.sendAndConfirmTransaction)(e, l, [t, ...c], o);
  });
}
kl.enableRequiredMemoTransfers = wie;
function vie(e, t, n, r, i = [], o, a = SN.TOKEN_2022_PROGRAM_ID) {
  return wN(this, void 0, void 0, function* () {
    const [s, c] = (0, vN.getSigners)(r, i), l = new im.Transaction().add((0, EN.createDisableRequiredMemoTransfersInstruction)(n, s, c, a));
    return yield (0, im.sendAndConfirmTransaction)(e, l, [t, ...c], o);
  });
}
kl.disableRequiredMemoTransfers = vie;
var OS = {}, wP;
function Sie() {
  return wP || (wP = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getMemoTransfer = e.MEMO_TRANSFER_SIZE = e.MemoTransferLayout = void 0;
    const t = ie, n = Fn, r = Mi();
    e.MemoTransferLayout = (0, t.struct)([(0, n.bool)("requireIncomingTransferMemos")]), e.MEMO_TRANSFER_SIZE = e.MemoTransferLayout.span;
    function i(o) {
      const a = (0, r.getExtensionData)(r.ExtensionType.MemoTransfer, o.tlvData);
      return a !== null ? e.MemoTransferLayout.decode(a) : null;
    }
    e.getMemoTransfer = i;
  }(OS)), OS;
}
var vP;
function AN() {
  return vP || (vP = 1, function(e) {
    var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
      a === void 0 && (a = o);
      var s = Object.getOwnPropertyDescriptor(i, o);
      (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return i[o];
      } }), Object.defineProperty(r, a, s);
    } : function(r, i, o, a) {
      a === void 0 && (a = o), r[a] = i[o];
    }), n = _ && _.__exportStar || function(r, i) {
      for (var o in r)
        o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), n(kl, e), n(bT, e), n(Sie(), e);
  }(MS)), MS;
}
var PS = {}, SP;
function IN() {
  return SP || (SP = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getMintCloseAuthority = e.MINT_CLOSE_AUTHORITY_SIZE = e.MintCloseAuthorityLayout = void 0;
    const t = ie, n = Fn, r = Mi();
    e.MintCloseAuthorityLayout = (0, t.struct)([(0, n.publicKey)("closeAuthority")]), e.MINT_CLOSE_AUTHORITY_SIZE = e.MintCloseAuthorityLayout.span;
    function i(o) {
      const a = (0, r.getExtensionData)(r.ExtensionType.MintCloseAuthority, o.tlvData);
      return a !== null ? e.MintCloseAuthorityLayout.decode(a) : null;
    }
    e.getMintCloseAuthority = i;
  }(PS)), PS;
}
var BS = {}, EP;
function kN() {
  return EP || (EP = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getNonTransferableAccount = e.getNonTransferable = e.NON_TRANSFERABLE_ACCOUNT_SIZE = e.NON_TRANSFERABLE_SIZE = e.NonTransferableLayout = void 0;
    const t = ie, n = Mi();
    e.NonTransferableLayout = (0, t.struct)([]), e.NON_TRANSFERABLE_SIZE = e.NonTransferableLayout.span, e.NON_TRANSFERABLE_ACCOUNT_SIZE = e.NonTransferableLayout.span;
    function r(o) {
      const a = (0, n.getExtensionData)(n.ExtensionType.NonTransferable, o.tlvData);
      return a !== null ? e.NonTransferableLayout.decode(a) : null;
    }
    e.getNonTransferable = r;
    function i(o) {
      const a = (0, n.getExtensionData)(n.ExtensionType.NonTransferableAccount, o.tlvData);
      return a !== null ? e.NonTransferableLayout.decode(a) : null;
    }
    e.getNonTransferableAccount = i;
  }(BS)), BS;
}
var CS = {}, AP;
function TN() {
  return AP || (AP = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getPermanentDelegate = e.PERMANENT_DELEGATE_SIZE = e.PermanentDelegateLayout = void 0;
    const t = ie, n = Fn, r = Mi();
    e.PermanentDelegateLayout = (0, t.struct)([(0, n.publicKey)("delegate")]), e.PERMANENT_DELEGATE_SIZE = e.PermanentDelegateLayout.span;
    function i(o) {
      const a = (0, r.getExtensionData)(r.ExtensionType.PermanentDelegate, o.tlvData);
      return a !== null ? e.PermanentDelegateLayout.decode(a) : null;
    }
    e.getPermanentDelegate = i;
  }(CS)), CS;
}
var DS = {}, ca = {}, mT = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeHarvestWithheldTokensToMintInstructionUnchecked = e.decodeHarvestWithheldTokensToMintInstruction = e.createHarvestWithheldTokensToMintInstruction = e.harvestWithheldTokensToMintInstructionData = e.decodeWithdrawWithheldTokensFromAccountsInstructionUnchecked = e.decodeWithdrawWithheldTokensFromAccountsInstruction = e.createWithdrawWithheldTokensFromAccountsInstruction = e.withdrawWithheldTokensFromAccountsInstructionData = e.decodeWithdrawWithheldTokensFromMintInstructionUnchecked = e.decodeWithdrawWithheldTokensFromMintInstruction = e.createWithdrawWithheldTokensFromMintInstruction = e.withdrawWithheldTokensFromMintInstructionData = e.decodeTransferCheckedWithFeeInstructionUnchecked = e.decodeTransferCheckedWithFeeInstruction = e.createTransferCheckedWithFeeInstruction = e.transferCheckedWithFeeInstructionData = e.decodeInitializeTransferFeeConfigInstructionUnchecked = e.decodeInitializeTransferFeeConfigInstruction = e.createInitializeTransferFeeConfigInstruction = e.initializeTransferFeeConfigInstructionData = e.TransferFeeInstruction = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = Ar, s = nn;
  var c;
  (function(O) {
    O[O.InitializeTransferFeeConfig = 0] = "InitializeTransferFeeConfig", O[O.TransferCheckedWithFee = 1] = "TransferCheckedWithFee", O[O.WithdrawWithheldTokensFromMint = 2] = "WithdrawWithheldTokensFromMint", O[O.WithdrawWithheldTokensFromAccounts = 3] = "WithdrawWithheldTokensFromAccounts", O[O.HarvestWithheldTokensToMint = 4] = "HarvestWithheldTokensToMint", O[O.SetTransferFee = 5] = "SetTransferFee";
  })(c = e.TransferFeeInstruction || (e.TransferFeeInstruction = {})), e.initializeTransferFeeConfigInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("transferFeeInstruction"),
    (0, t.u8)("transferFeeConfigAuthorityOption"),
    (0, n.publicKey)("transferFeeConfigAuthority"),
    (0, t.u8)("withdrawWithheldAuthorityOption"),
    (0, n.publicKey)("withdrawWithheldAuthority"),
    (0, t.u16)("transferFeeBasisPoints"),
    (0, n.u64)("maximumFee")
  ]);
  function l(O, k, z, C, M, S = i.TOKEN_2022_PROGRAM_ID) {
    if (!(0, i.programSupportsExtensions)(S))
      throw new o.TokenUnsupportedInstructionError();
    const p = [{ pubkey: O, isSigner: !1, isWritable: !0 }], y = Buffer.alloc(e.initializeTransferFeeConfigInstructionData.span);
    return e.initializeTransferFeeConfigInstructionData.encode({
      instruction: s.TokenInstruction.TransferFeeExtension,
      transferFeeInstruction: c.InitializeTransferFeeConfig,
      transferFeeConfigAuthorityOption: k ? 1 : 0,
      transferFeeConfigAuthority: k || new r.PublicKey(0),
      withdrawWithheldAuthorityOption: z ? 1 : 0,
      withdrawWithheldAuthority: z || new r.PublicKey(0),
      transferFeeBasisPoints: C,
      maximumFee: M
    }, y), new r.TransactionInstruction({ keys: p, programId: S, data: y });
  }
  e.createInitializeTransferFeeConfigInstruction = l;
  function u(O, k) {
    if (!O.programId.equals(k))
      throw new o.TokenInvalidInstructionProgramError();
    if (O.data.length !== e.initializeTransferFeeConfigInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { mint: z }, data: C } = f(O);
    if (C.instruction !== s.TokenInstruction.TransferFeeExtension || C.transferFeeInstruction !== c.InitializeTransferFeeConfig)
      throw new o.TokenInvalidInstructionTypeError();
    if (!z)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: k,
      keys: {
        mint: z
      },
      data: C
    };
  }
  e.decodeInitializeTransferFeeConfigInstruction = u;
  function f({ programId: O, keys: [k], data: z }) {
    const { instruction: C, transferFeeInstruction: M, transferFeeConfigAuthorityOption: S, transferFeeConfigAuthority: p, withdrawWithheldAuthorityOption: y, withdrawWithheldAuthority: v, transferFeeBasisPoints: E, maximumFee: B } = e.initializeTransferFeeConfigInstructionData.decode(z);
    return {
      programId: O,
      keys: {
        mint: k
      },
      data: {
        instruction: C,
        transferFeeInstruction: M,
        transferFeeConfigAuthority: S ? p : null,
        withdrawWithheldAuthority: y ? v : null,
        transferFeeBasisPoints: E,
        maximumFee: B
      }
    };
  }
  e.decodeInitializeTransferFeeConfigInstructionUnchecked = f, e.transferCheckedWithFeeInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("transferFeeInstruction"),
    (0, n.u64)("amount"),
    (0, t.u8)("decimals"),
    (0, n.u64)("fee")
  ]);
  function d(O, k, z, C, M, S, p, y = [], v = i.TOKEN_2022_PROGRAM_ID) {
    if (!(0, i.programSupportsExtensions)(v))
      throw new o.TokenUnsupportedInstructionError();
    const E = Buffer.alloc(e.transferCheckedWithFeeInstructionData.span);
    e.transferCheckedWithFeeInstructionData.encode({
      instruction: s.TokenInstruction.TransferFeeExtension,
      transferFeeInstruction: c.TransferCheckedWithFee,
      amount: M,
      decimals: S,
      fee: p
    }, E);
    const B = (0, a.addSigners)([
      { pubkey: O, isSigner: !1, isWritable: !0 },
      { pubkey: k, isSigner: !1, isWritable: !1 },
      { pubkey: z, isSigner: !1, isWritable: !0 }
    ], C, y);
    return new r.TransactionInstruction({ keys: B, programId: v, data: E });
  }
  e.createTransferCheckedWithFeeInstruction = d;
  function h(O, k) {
    if (!O.programId.equals(k))
      throw new o.TokenInvalidInstructionProgramError();
    if (O.data.length !== e.transferCheckedWithFeeInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { source: z, mint: C, destination: M, authority: S, signers: p }, data: y } = g(O);
    if (y.instruction !== s.TokenInstruction.TransferFeeExtension || y.transferFeeInstruction !== c.TransferCheckedWithFee)
      throw new o.TokenInvalidInstructionTypeError();
    if (!C)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: k,
      keys: {
        source: z,
        mint: C,
        destination: M,
        authority: S,
        signers: p || null
      },
      data: y
    };
  }
  e.decodeTransferCheckedWithFeeInstruction = h;
  function g({ programId: O, keys: [k, z, C, M, ...S], data: p }) {
    const { instruction: y, transferFeeInstruction: v, amount: E, decimals: B, fee: F } = e.transferCheckedWithFeeInstructionData.decode(p);
    return {
      programId: O,
      keys: {
        source: k,
        mint: z,
        destination: C,
        authority: M,
        signers: S
      },
      data: {
        instruction: y,
        transferFeeInstruction: v,
        amount: E,
        decimals: B,
        fee: F
      }
    };
  }
  e.decodeTransferCheckedWithFeeInstructionUnchecked = g, e.withdrawWithheldTokensFromMintInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("transferFeeInstruction")
  ]);
  function w(O, k, z, C = [], M = i.TOKEN_2022_PROGRAM_ID) {
    if (!(0, i.programSupportsExtensions)(M))
      throw new o.TokenUnsupportedInstructionError();
    const S = Buffer.alloc(e.withdrawWithheldTokensFromMintInstructionData.span);
    e.withdrawWithheldTokensFromMintInstructionData.encode({
      instruction: s.TokenInstruction.TransferFeeExtension,
      transferFeeInstruction: c.WithdrawWithheldTokensFromMint
    }, S);
    const p = (0, a.addSigners)([
      { pubkey: O, isSigner: !1, isWritable: !0 },
      { pubkey: k, isSigner: !1, isWritable: !0 }
    ], z, C);
    return new r.TransactionInstruction({ keys: p, programId: M, data: S });
  }
  e.createWithdrawWithheldTokensFromMintInstruction = w;
  function b(O, k) {
    if (!O.programId.equals(k))
      throw new o.TokenInvalidInstructionProgramError();
    if (O.data.length !== e.withdrawWithheldTokensFromMintInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { mint: z, destination: C, authority: M, signers: S }, data: p } = I(O);
    if (p.instruction !== s.TokenInstruction.TransferFeeExtension || p.transferFeeInstruction !== c.WithdrawWithheldTokensFromMint)
      throw new o.TokenInvalidInstructionTypeError();
    if (!z)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: k,
      keys: {
        mint: z,
        destination: C,
        authority: M,
        signers: S || null
      },
      data: p
    };
  }
  e.decodeWithdrawWithheldTokensFromMintInstruction = b;
  function I({ programId: O, keys: [k, z, C, ...M], data: S }) {
    const { instruction: p, transferFeeInstruction: y } = e.withdrawWithheldTokensFromMintInstructionData.decode(S);
    return {
      programId: O,
      keys: {
        mint: k,
        destination: z,
        authority: C,
        signers: M
      },
      data: {
        instruction: p,
        transferFeeInstruction: y
      }
    };
  }
  e.decodeWithdrawWithheldTokensFromMintInstructionUnchecked = I, e.withdrawWithheldTokensFromAccountsInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("transferFeeInstruction"),
    (0, t.u8)("numTokenAccounts")
  ]);
  function A(O, k, z, C, M, S = i.TOKEN_2022_PROGRAM_ID) {
    if (!(0, i.programSupportsExtensions)(S))
      throw new o.TokenUnsupportedInstructionError();
    const p = Buffer.alloc(e.withdrawWithheldTokensFromAccountsInstructionData.span);
    e.withdrawWithheldTokensFromAccountsInstructionData.encode({
      instruction: s.TokenInstruction.TransferFeeExtension,
      transferFeeInstruction: c.WithdrawWithheldTokensFromAccounts,
      numTokenAccounts: M.length
    }, p);
    const y = (0, a.addSigners)([
      { pubkey: O, isSigner: !1, isWritable: !0 },
      { pubkey: k, isSigner: !1, isWritable: !0 }
    ], z, C);
    for (const v of M)
      y.push({ pubkey: v, isSigner: !1, isWritable: !0 });
    return new r.TransactionInstruction({ keys: y, programId: S, data: p });
  }
  e.createWithdrawWithheldTokensFromAccountsInstruction = A;
  function x(O, k) {
    if (!O.programId.equals(k))
      throw new o.TokenInvalidInstructionProgramError();
    if (O.data.length !== e.withdrawWithheldTokensFromAccountsInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { mint: z, destination: C, authority: M, signers: S, sources: p }, data: y } = N(O);
    if (y.instruction !== s.TokenInstruction.TransferFeeExtension || y.transferFeeInstruction !== c.WithdrawWithheldTokensFromAccounts)
      throw new o.TokenInvalidInstructionTypeError();
    if (!z)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: k,
      keys: {
        mint: z,
        destination: C,
        authority: M,
        signers: S || null,
        sources: p || null
      },
      data: y
    };
  }
  e.decodeWithdrawWithheldTokensFromAccountsInstruction = x;
  function N({ programId: O, keys: k, data: z }) {
    const { instruction: C, transferFeeInstruction: M, numTokenAccounts: S } = e.withdrawWithheldTokensFromAccountsInstructionData.decode(z), [p, y, v, E, B] = [
      k[0],
      k[1],
      k[2],
      k.slice(3, 3 + S),
      k.slice(-1 * S)
    ];
    return {
      programId: O,
      keys: {
        mint: p,
        destination: y,
        authority: v,
        signers: E,
        sources: B
      },
      data: {
        instruction: C,
        transferFeeInstruction: M,
        numTokenAccounts: S
      }
    };
  }
  e.decodeWithdrawWithheldTokensFromAccountsInstructionUnchecked = N, e.harvestWithheldTokensToMintInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("transferFeeInstruction")
  ]);
  function j(O, k, z = i.TOKEN_2022_PROGRAM_ID) {
    if (!(0, i.programSupportsExtensions)(z))
      throw new o.TokenUnsupportedInstructionError();
    const C = Buffer.alloc(e.harvestWithheldTokensToMintInstructionData.span);
    e.harvestWithheldTokensToMintInstructionData.encode({
      instruction: s.TokenInstruction.TransferFeeExtension,
      transferFeeInstruction: c.HarvestWithheldTokensToMint
    }, C);
    const M = [];
    M.push({ pubkey: O, isSigner: !1, isWritable: !0 });
    for (const S of k)
      M.push({ pubkey: S, isSigner: !1, isWritable: !0 });
    return new r.TransactionInstruction({ keys: M, programId: z, data: C });
  }
  e.createHarvestWithheldTokensToMintInstruction = j;
  function K(O, k) {
    if (!O.programId.equals(k))
      throw new o.TokenInvalidInstructionProgramError();
    if (O.data.length !== e.harvestWithheldTokensToMintInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { mint: z, sources: C }, data: M } = W(O);
    if (M.instruction !== s.TokenInstruction.TransferFeeExtension || M.transferFeeInstruction !== c.HarvestWithheldTokensToMint)
      throw new o.TokenInvalidInstructionTypeError();
    if (!z)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: k,
      keys: {
        mint: z,
        sources: C
      },
      data: M
    };
  }
  e.decodeHarvestWithheldTokensToMintInstruction = K;
  function W({ programId: O, keys: [k, ...z], data: C }) {
    const { instruction: M, transferFeeInstruction: S } = e.harvestWithheldTokensToMintInstructionData.decode(C);
    return {
      programId: O,
      keys: {
        mint: k,
        sources: z
      },
      data: {
        instruction: M,
        transferFeeInstruction: S
      }
    };
  }
  e.decodeHarvestWithheldTokensToMintInstructionUnchecked = W;
})(mT);
var G_ = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(ca, "__esModule", { value: !0 });
ca.harvestWithheldTokensToMint = ca.withdrawWithheldTokensFromAccounts = ca.withdrawWithheldTokensFromMint = ca.transferCheckedWithFee = void 0;
const ec = we, _T = Tr, Y_ = ot, Z_ = mT;
function Eie(e, t, n, r, i, o, a, s, c, l = [], u, f = Y_.TOKEN_2022_PROGRAM_ID) {
  return G_(this, void 0, void 0, function* () {
    const [d, h] = (0, _T.getSigners)(o, l), g = new ec.Transaction().add((0, Z_.createTransferCheckedWithFeeInstruction)(n, r, i, d, a, s, c, l, f));
    return yield (0, ec.sendAndConfirmTransaction)(e, g, [t, ...h], u);
  });
}
ca.transferCheckedWithFee = Eie;
function Aie(e, t, n, r, i, o = [], a, s = Y_.TOKEN_2022_PROGRAM_ID) {
  return G_(this, void 0, void 0, function* () {
    const [c, l] = (0, _T.getSigners)(i, o), u = new ec.Transaction().add((0, Z_.createWithdrawWithheldTokensFromMintInstruction)(n, r, c, l, s));
    return yield (0, ec.sendAndConfirmTransaction)(e, u, [t, ...l], a);
  });
}
ca.withdrawWithheldTokensFromMint = Aie;
function Iie(e, t, n, r, i, o, a, s, c = Y_.TOKEN_2022_PROGRAM_ID) {
  return G_(this, void 0, void 0, function* () {
    const [l, u] = (0, _T.getSigners)(i, o), f = new ec.Transaction().add((0, Z_.createWithdrawWithheldTokensFromAccountsInstruction)(n, r, l, u, a, c));
    return yield (0, ec.sendAndConfirmTransaction)(e, f, [t, ...u], s);
  });
}
ca.withdrawWithheldTokensFromAccounts = Iie;
function kie(e, t, n, r, i, o = Y_.TOKEN_2022_PROGRAM_ID) {
  return G_(this, void 0, void 0, function* () {
    const a = new ec.Transaction().add((0, Z_.createHarvestWithheldTokensToMintInstruction)(n, r, o));
    return yield (0, ec.sendAndConfirmTransaction)(e, a, [t], i);
  });
}
ca.harvestWithheldTokensToMint = kie;
var RS = {}, IP;
function Tie() {
  return IP || (IP = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getTransferFeeAmount = e.getTransferFeeConfig = e.TRANSFER_FEE_AMOUNT_SIZE = e.TransferFeeAmountLayout = e.TRANSFER_FEE_CONFIG_SIZE = e.TransferFeeConfigLayout = e.transferFeeLayout = e.ONE_IN_BASIS_POINTS = e.MAX_FEE_BASIS_POINTS = void 0;
    const t = ie, n = Fn, r = Mi();
    e.MAX_FEE_BASIS_POINTS = 1e4, e.ONE_IN_BASIS_POINTS = e.MAX_FEE_BASIS_POINTS;
    function i(s) {
      return (0, t.struct)([(0, n.u64)("epoch"), (0, n.u64)("maximumFee"), (0, t.u16)("transferFeeBasisPoints")], s);
    }
    e.transferFeeLayout = i, e.TransferFeeConfigLayout = (0, t.struct)([
      (0, n.publicKey)("transferFeeConfigAuthority"),
      (0, n.publicKey)("withdrawWithheldAuthority"),
      (0, n.u64)("withheldAmount"),
      i("olderTransferFee"),
      i("newerTransferFee")
    ]), e.TRANSFER_FEE_CONFIG_SIZE = e.TransferFeeConfigLayout.span, e.TransferFeeAmountLayout = (0, t.struct)([(0, n.u64)("withheldAmount")]), e.TRANSFER_FEE_AMOUNT_SIZE = e.TransferFeeAmountLayout.span;
    function o(s) {
      const c = (0, r.getExtensionData)(r.ExtensionType.TransferFeeConfig, s.tlvData);
      return c !== null ? e.TransferFeeConfigLayout.decode(c) : null;
    }
    e.getTransferFeeConfig = o;
    function a(s) {
      const c = (0, r.getExtensionData)(r.ExtensionType.TransferFeeAmount, s.tlvData);
      return c !== null ? e.TransferFeeAmountLayout.decode(c) : null;
    }
    e.getTransferFeeAmount = a;
  }(RS)), RS;
}
var kP;
function xN() {
  return kP || (kP = 1, function(e) {
    var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
      a === void 0 && (a = o);
      var s = Object.getOwnPropertyDescriptor(i, o);
      (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
        return i[o];
      } }), Object.defineProperty(r, a, s);
    } : function(r, i, o, a) {
      a === void 0 && (a = o), r[a] = i[o];
    }), n = _ && _.__exportStar || function(r, i) {
      for (var o in r)
        o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), n(ca, e), n(mT, e), n(Tie(), e);
  }(DS)), DS;
}
var TP;
function Mi() {
  return TP || (TP = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getAccountLenForMint = e.getExtensionTypes = e.getExtensionData = e.getAccountLen = e.getMintLen = e.getAccountTypeOfMintType = e.isAccountExtension = e.isMintExtension = e.getTypeLen = e.LENGTH_SIZE = e.TYPE_SIZE = e.ExtensionType = void 0;
    const t = P0(), n = ac(), r = Yl, i = O0, o = hN(), a = bN(), s = mN(), c = _N(), l = AN(), u = IN(), f = kN(), d = TN(), h = xN();
    var g;
    (function(k) {
      k[k.Uninitialized = 0] = "Uninitialized", k[k.TransferFeeConfig = 1] = "TransferFeeConfig", k[k.TransferFeeAmount = 2] = "TransferFeeAmount", k[k.MintCloseAuthority = 3] = "MintCloseAuthority", k[k.ConfidentialTransferMint = 4] = "ConfidentialTransferMint", k[k.ConfidentialTransferAccount = 5] = "ConfidentialTransferAccount", k[k.DefaultAccountState = 6] = "DefaultAccountState", k[k.ImmutableOwner = 7] = "ImmutableOwner", k[k.MemoTransfer = 8] = "MemoTransfer", k[k.NonTransferable = 9] = "NonTransferable", k[k.InterestBearingConfig = 10] = "InterestBearingConfig", k[k.CpiGuard = 11] = "CpiGuard", k[k.PermanentDelegate = 12] = "PermanentDelegate", k[k.NonTransferableAccount = 13] = "NonTransferableAccount";
    })(g = e.ExtensionType || (e.ExtensionType = {})), e.TYPE_SIZE = 2, e.LENGTH_SIZE = 2;
    function w(k) {
      switch (k) {
        case g.Uninitialized:
          return 0;
        case g.TransferFeeConfig:
          return h.TRANSFER_FEE_CONFIG_SIZE;
        case g.TransferFeeAmount:
          return h.TRANSFER_FEE_AMOUNT_SIZE;
        case g.MintCloseAuthority:
          return u.MINT_CLOSE_AUTHORITY_SIZE;
        case g.ConfidentialTransferMint:
          return 97;
        case g.ConfidentialTransferAccount:
          return 286;
        case g.CpiGuard:
          return o.CPI_GUARD_SIZE;
        case g.DefaultAccountState:
          return a.DEFAULT_ACCOUNT_STATE_SIZE;
        case g.ImmutableOwner:
          return s.IMMUTABLE_OWNER_SIZE;
        case g.MemoTransfer:
          return l.MEMO_TRANSFER_SIZE;
        case g.NonTransferable:
          return f.NON_TRANSFERABLE_SIZE;
        case g.InterestBearingConfig:
          return c.INTEREST_BEARING_MINT_CONFIG_STATE_SIZE;
        case g.PermanentDelegate:
          return d.PERMANENT_DELEGATE_SIZE;
        case g.NonTransferableAccount:
          return f.NON_TRANSFERABLE_ACCOUNT_SIZE;
        default:
          throw Error(`Unknown extension type: ${k}`);
      }
    }
    e.getTypeLen = w;
    function b(k) {
      switch (k) {
        case g.TransferFeeConfig:
        case g.MintCloseAuthority:
        case g.ConfidentialTransferMint:
        case g.DefaultAccountState:
        case g.NonTransferable:
        case g.InterestBearingConfig:
        case g.PermanentDelegate:
          return !0;
        case g.Uninitialized:
        case g.TransferFeeAmount:
        case g.ConfidentialTransferAccount:
        case g.ImmutableOwner:
        case g.MemoTransfer:
        case g.CpiGuard:
        case g.NonTransferableAccount:
          return !1;
        default:
          throw Error(`Unknown extension type: ${k}`);
      }
    }
    e.isMintExtension = b;
    function I(k) {
      switch (k) {
        case g.TransferFeeAmount:
        case g.ConfidentialTransferAccount:
        case g.ImmutableOwner:
        case g.MemoTransfer:
        case g.CpiGuard:
        case g.NonTransferableAccount:
          return !0;
        case g.Uninitialized:
        case g.TransferFeeConfig:
        case g.MintCloseAuthority:
        case g.ConfidentialTransferMint:
        case g.DefaultAccountState:
        case g.NonTransferable:
        case g.InterestBearingConfig:
        case g.PermanentDelegate:
          return !1;
        default:
          throw Error(`Unknown extension type: ${k}`);
      }
    }
    e.isAccountExtension = I;
    function A(k) {
      switch (k) {
        case g.TransferFeeConfig:
          return g.TransferFeeAmount;
        case g.ConfidentialTransferMint:
          return g.ConfidentialTransferAccount;
        case g.NonTransferable:
          return g.NonTransferableAccount;
        case g.TransferFeeAmount:
        case g.ConfidentialTransferAccount:
        case g.CpiGuard:
        case g.DefaultAccountState:
        case g.ImmutableOwner:
        case g.MemoTransfer:
        case g.MintCloseAuthority:
        case g.Uninitialized:
        case g.InterestBearingConfig:
        case g.PermanentDelegate:
        case g.NonTransferableAccount:
          return g.Uninitialized;
      }
    }
    e.getAccountTypeOfMintType = A;
    function x(k, z) {
      if (k.length === 0)
        return z;
      {
        const C = t.ACCOUNT_SIZE + i.ACCOUNT_TYPE_SIZE + k.filter((M, S) => S === k.indexOf(M)).map((M) => w(M) + e.TYPE_SIZE + e.LENGTH_SIZE).reduce((M, S) => M + S);
        return C === r.MULTISIG_SIZE ? C + e.TYPE_SIZE : C;
      }
    }
    function N(k) {
      return x(k, n.MINT_SIZE);
    }
    e.getMintLen = N;
    function j(k) {
      return x(k, t.ACCOUNT_SIZE);
    }
    e.getAccountLen = j;
    function K(k, z) {
      let C = 0;
      for (; C + e.TYPE_SIZE + e.LENGTH_SIZE <= z.length; ) {
        const M = z.readUInt16LE(C), S = z.readUInt16LE(C + e.TYPE_SIZE), p = C + e.TYPE_SIZE + e.LENGTH_SIZE;
        if (M == k)
          return z.slice(p, p + S);
        C = p + S;
      }
      return null;
    }
    e.getExtensionData = K;
    function W(k) {
      const z = [];
      let C = 0;
      for (; C < k.length; ) {
        const M = k.readUInt16LE(C);
        z.push(M);
        const S = k.readUInt16LE(C + e.TYPE_SIZE);
        C += e.TYPE_SIZE + e.LENGTH_SIZE + S;
      }
      return z;
    }
    e.getExtensionTypes = W;
    function O(k) {
      const C = W(k.tlvData).map(A);
      return j(C);
    }
    e.getAccountLenForMint = O;
  }(wS)), wS;
}
var B0 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeInitializeAccountInstructionUnchecked = e.decodeInitializeAccountInstruction = e.createInitializeAccountInstruction = e.initializeAccountInstructionData = void 0;
  const t = ie, n = we, r = ot, i = dt, o = nn;
  e.initializeAccountInstructionData = (0, t.struct)([(0, t.u8)("instruction")]);
  function a(l, u, f, d = r.TOKEN_PROGRAM_ID) {
    const h = [
      { pubkey: l, isSigner: !1, isWritable: !0 },
      { pubkey: u, isSigner: !1, isWritable: !1 },
      { pubkey: f, isSigner: !1, isWritable: !1 },
      { pubkey: n.SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
    ], g = Buffer.alloc(e.initializeAccountInstructionData.span);
    return e.initializeAccountInstructionData.encode({ instruction: o.TokenInstruction.InitializeAccount }, g), new n.TransactionInstruction({ keys: h, programId: d, data: g });
  }
  e.createInitializeAccountInstruction = a;
  function s(l, u = r.TOKEN_PROGRAM_ID) {
    if (!l.programId.equals(u))
      throw new i.TokenInvalidInstructionProgramError();
    if (l.data.length !== e.initializeAccountInstructionData.span)
      throw new i.TokenInvalidInstructionDataError();
    const { keys: { account: f, mint: d, owner: h, rent: g }, data: w } = c(l);
    if (w.instruction !== o.TokenInstruction.InitializeAccount)
      throw new i.TokenInvalidInstructionTypeError();
    if (!f || !d || !h || !g)
      throw new i.TokenInvalidInstructionKeysError();
    return {
      programId: u,
      keys: {
        account: f,
        mint: d,
        owner: h,
        rent: g
      },
      data: w
    };
  }
  e.decodeInitializeAccountInstruction = s;
  function c({ programId: l, keys: [u, f, d, h], data: g }) {
    return {
      programId: l,
      keys: {
        account: u,
        mint: f,
        owner: d,
        rent: h
      },
      data: e.initializeAccountInstructionData.decode(g)
    };
  }
  e.decodeInitializeAccountInstructionUnchecked = c;
})(B0);
var C0 = {}, ba = {};
Object.defineProperty(ba, "__esModule", { value: !0 });
ba.createAssociatedTokenAccountIdempotentInstruction = ba.createAssociatedTokenAccountInstruction = void 0;
const xP = we, Tl = ot;
function xie(e, t, n, r, i = Tl.TOKEN_PROGRAM_ID, o = Tl.ASSOCIATED_TOKEN_PROGRAM_ID) {
  return MN(e, t, n, r, Buffer.alloc(0), i, o);
}
ba.createAssociatedTokenAccountInstruction = xie;
function Mie(e, t, n, r, i = Tl.TOKEN_PROGRAM_ID, o = Tl.ASSOCIATED_TOKEN_PROGRAM_ID) {
  return MN(e, t, n, r, Buffer.from([1]), i, o);
}
ba.createAssociatedTokenAccountIdempotentInstruction = Mie;
function MN(e, t, n, r, i, o = Tl.TOKEN_PROGRAM_ID, a = Tl.ASSOCIATED_TOKEN_PROGRAM_ID) {
  const s = [
    { pubkey: e, isSigner: !0, isWritable: !0 },
    { pubkey: t, isSigner: !1, isWritable: !0 },
    { pubkey: n, isSigner: !1, isWritable: !1 },
    { pubkey: r, isSigner: !1, isWritable: !1 },
    { pubkey: xP.SystemProgram.programId, isSigner: !1, isWritable: !1 },
    { pubkey: o, isSigner: !1, isWritable: !1 }
  ];
  return new xP.TransactionInstruction({
    keys: s,
    programId: a,
    data: i
  });
}
var Oie = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(C0, "__esModule", { value: !0 });
C0.createAssociatedTokenAccount = void 0;
const MP = we, OP = ot, Pie = ba, Bie = ac();
function Cie(e, t, n, r, i, o = OP.TOKEN_PROGRAM_ID, a = OP.ASSOCIATED_TOKEN_PROGRAM_ID) {
  return Oie(this, void 0, void 0, function* () {
    const s = (0, Bie.getAssociatedTokenAddressSync)(n, r, !1, o, a), c = new MP.Transaction().add((0, Pie.createAssociatedTokenAccountInstruction)(t.publicKey, s, r, n, o, a));
    return yield (0, MP.sendAndConfirmTransaction)(e, c, [t], i), s;
  });
}
C0.createAssociatedTokenAccount = Cie;
var Die = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(M0, "__esModule", { value: !0 });
M0.createAccount = void 0;
const NS = we, Rie = ot, Nie = Mi(), jie = B0, Uie = ac(), zie = C0;
function Fie(e, t, n, r, i, o, a = Rie.TOKEN_PROGRAM_ID) {
  return Die(this, void 0, void 0, function* () {
    if (!i)
      return yield (0, zie.createAssociatedTokenAccount)(e, t, n, r, o, a);
    const s = yield (0, Uie.getMint)(e, n, o == null ? void 0 : o.commitment, a), c = (0, Nie.getAccountLenForMint)(s), l = yield e.getMinimumBalanceForRentExemption(c), u = new NS.Transaction().add(NS.SystemProgram.createAccount({
      fromPubkey: t.publicKey,
      newAccountPubkey: i.publicKey,
      space: c,
      lamports: l,
      programId: a
    }), (0, jie.createInitializeAccountInstruction)(i.publicKey, n, r, a));
    return yield (0, NS.sendAndConfirmTransaction)(e, u, [t, i], o), i.publicKey;
  });
}
M0.createAccount = Fie;
var J_ = {}, Lie = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(J_, "__esModule", { value: !0 });
J_.createAssociatedTokenAccountIdempotent = void 0;
const PP = we, BP = ot, $ie = ba, Wie = ac();
function Kie(e, t, n, r, i, o = BP.TOKEN_PROGRAM_ID, a = BP.ASSOCIATED_TOKEN_PROGRAM_ID) {
  return Lie(this, void 0, void 0, function* () {
    const s = (0, Wie.getAssociatedTokenAddressSync)(n, r, !1, o, a), c = new PP.Transaction().add((0, $ie.createAssociatedTokenAccountIdempotentInstruction)(t.publicKey, s, r, n, o, a));
    return yield (0, PP.sendAndConfirmTransaction)(e, c, [t], i), s;
  });
}
J_.createAssociatedTokenAccountIdempotent = Kie;
var X_ = {}, Q_ = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeInitializeMint2InstructionUnchecked = e.decodeInitializeMint2Instruction = e.createInitializeMint2Instruction = e.initializeMint2InstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = nn;
  e.initializeMint2InstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("decimals"),
    (0, n.publicKey)("mintAuthority"),
    (0, t.u8)("freezeAuthorityOption"),
    (0, n.publicKey)("freezeAuthority")
  ]);
  function s(u, f, d, h, g = i.TOKEN_PROGRAM_ID) {
    const w = [{ pubkey: u, isSigner: !1, isWritable: !0 }], b = Buffer.alloc(e.initializeMint2InstructionData.span);
    return e.initializeMint2InstructionData.encode({
      instruction: a.TokenInstruction.InitializeMint2,
      decimals: f,
      mintAuthority: d,
      freezeAuthorityOption: h ? 1 : 0,
      freezeAuthority: h || new r.PublicKey(0)
    }, b), new r.TransactionInstruction({ keys: w, programId: g, data: b });
  }
  e.createInitializeMint2Instruction = s;
  function c(u, f = i.TOKEN_PROGRAM_ID) {
    if (!u.programId.equals(f))
      throw new o.TokenInvalidInstructionProgramError();
    if (u.data.length !== e.initializeMint2InstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { mint: d }, data: h } = l(u);
    if (h.instruction !== a.TokenInstruction.InitializeMint2)
      throw new o.TokenInvalidInstructionTypeError();
    if (!d)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: f,
      keys: {
        mint: d
      },
      data: h
    };
  }
  e.decodeInitializeMint2Instruction = c;
  function l({ programId: u, keys: [f], data: d }) {
    const { instruction: h, decimals: g, mintAuthority: w, freezeAuthorityOption: b, freezeAuthority: I } = e.initializeMint2InstructionData.decode(d);
    return {
      programId: u,
      keys: {
        mint: f
      },
      data: {
        instruction: h,
        decimals: g,
        mintAuthority: w,
        freezeAuthority: b ? I : null
      }
    };
  }
  e.decodeInitializeMint2InstructionUnchecked = l;
})(Q_);
var Vie = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(X_, "__esModule", { value: !0 });
X_.createMint = void 0;
const Ng = we, qie = ot, Hie = Q_, CP = ac();
function Gie(e, t, n, r, i, o = Ng.Keypair.generate(), a, s = qie.TOKEN_PROGRAM_ID) {
  return Vie(this, void 0, void 0, function* () {
    const c = yield (0, CP.getMinimumBalanceForRentExemptMint)(e), l = new Ng.Transaction().add(Ng.SystemProgram.createAccount({
      fromPubkey: t.publicKey,
      newAccountPubkey: o.publicKey,
      space: CP.MINT_SIZE,
      lamports: c,
      programId: s
    }), (0, Hie.createInitializeMint2Instruction)(o.publicKey, i, n, r, s));
    return yield (0, Ng.sendAndConfirmTransaction)(e, l, [t, o], a), o.publicKey;
  });
}
X_.createMint = Gie;
var ew = {}, tw = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeInitializeMultisigInstructionUnchecked = e.decodeInitializeMultisigInstruction = e.createInitializeMultisigInstruction = e.initializeMultisigInstructionData = void 0;
  const t = ie, n = we, r = ot, i = dt, o = nn;
  e.initializeMultisigInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("m")
  ]);
  function a(l, u, f, d = r.TOKEN_PROGRAM_ID) {
    const h = [
      { pubkey: l, isSigner: !1, isWritable: !0 },
      { pubkey: n.SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
    ];
    for (const w of u)
      h.push({
        pubkey: w instanceof n.PublicKey ? w : w.publicKey,
        isSigner: !1,
        isWritable: !1
      });
    const g = Buffer.alloc(e.initializeMultisigInstructionData.span);
    return e.initializeMultisigInstructionData.encode({
      instruction: o.TokenInstruction.InitializeMultisig,
      m: f
    }, g), new n.TransactionInstruction({ keys: h, programId: d, data: g });
  }
  e.createInitializeMultisigInstruction = a;
  function s(l, u = r.TOKEN_PROGRAM_ID) {
    if (!l.programId.equals(u))
      throw new i.TokenInvalidInstructionProgramError();
    if (l.data.length !== e.initializeMultisigInstructionData.span)
      throw new i.TokenInvalidInstructionDataError();
    const { keys: { account: f, rent: d, signers: h }, data: g } = c(l);
    if (g.instruction !== o.TokenInstruction.InitializeMultisig)
      throw new i.TokenInvalidInstructionTypeError();
    if (!f || !d || !h.length)
      throw new i.TokenInvalidInstructionKeysError();
    return {
      programId: u,
      keys: {
        account: f,
        rent: d,
        signers: h
      },
      data: g
    };
  }
  e.decodeInitializeMultisigInstruction = s;
  function c({ programId: l, keys: [u, f, ...d], data: h }) {
    return {
      programId: l,
      keys: {
        account: u,
        rent: f,
        signers: d
      },
      data: e.initializeMultisigInstructionData.decode(h)
    };
  }
  e.decodeInitializeMultisigInstructionUnchecked = c;
})(tw);
var Yie = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(ew, "__esModule", { value: !0 });
ew.createMultisig = void 0;
const jg = we, Zie = ot, Jie = tw, DP = Yl;
function Xie(e, t, n, r, i = jg.Keypair.generate(), o, a = Zie.TOKEN_PROGRAM_ID) {
  return Yie(this, void 0, void 0, function* () {
    const s = yield (0, DP.getMinimumBalanceForRentExemptMultisig)(e), c = new jg.Transaction().add(jg.SystemProgram.createAccount({
      fromPubkey: t.publicKey,
      newAccountPubkey: i.publicKey,
      space: DP.MULTISIG_SIZE,
      lamports: s,
      programId: a
    }), (0, Jie.createInitializeMultisigInstruction)(i.publicKey, n, r, a));
    return yield (0, jg.sendAndConfirmTransaction)(e, c, [t, i], o), i.publicKey;
  });
}
ew.createMultisig = Xie;
var nw = {}, wT = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createCreateNativeMintInstruction = e.createNativeMintInstructionData = void 0;
  const t = ie, n = we, r = ot, i = dt, o = nn;
  e.createNativeMintInstructionData = (0, t.struct)([(0, t.u8)("instruction")]);
  function a(s, c = r.NATIVE_MINT_2022, l = r.TOKEN_2022_PROGRAM_ID) {
    if (!(0, r.programSupportsExtensions)(l))
      throw new i.TokenUnsupportedInstructionError();
    const u = [
      { pubkey: s, isSigner: !0, isWritable: !0 },
      { pubkey: c, isSigner: !1, isWritable: !0 },
      { pubkey: n.SystemProgram.programId, isSigner: !1, isWritable: !1 }
    ], f = Buffer.alloc(e.createNativeMintInstructionData.span);
    return e.createNativeMintInstructionData.encode({ instruction: o.TokenInstruction.CreateNativeMint }, f), new n.TransactionInstruction({ keys: u, programId: l, data: f });
  }
  e.createCreateNativeMintInstruction = a;
})(wT);
var Qie = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(nw, "__esModule", { value: !0 });
nw.createNativeMint = void 0;
const RP = we, NP = ot, eoe = wT;
function toe(e, t, n, r = NP.NATIVE_MINT_2022, i = NP.TOKEN_2022_PROGRAM_ID) {
  return Qie(this, void 0, void 0, function* () {
    const o = new RP.Transaction().add((0, eoe.createCreateNativeMintInstruction)(t.publicKey, r, i));
    yield (0, RP.sendAndConfirmTransaction)(e, o, [t], n);
  });
}
nw.createNativeMint = toe;
var rw = {}, D0 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeSyncNativeInstructionUnchecked = e.decodeSyncNativeInstruction = e.createSyncNativeInstruction = e.syncNativeInstructionData = void 0;
  const t = ie, n = we, r = ot, i = dt, o = nn;
  e.syncNativeInstructionData = (0, t.struct)([(0, t.u8)("instruction")]);
  function a(l, u = r.TOKEN_PROGRAM_ID) {
    const f = [{ pubkey: l, isSigner: !1, isWritable: !0 }], d = Buffer.alloc(e.syncNativeInstructionData.span);
    return e.syncNativeInstructionData.encode({ instruction: o.TokenInstruction.SyncNative }, d), new n.TransactionInstruction({ keys: f, programId: u, data: d });
  }
  e.createSyncNativeInstruction = a;
  function s(l, u = r.TOKEN_PROGRAM_ID) {
    if (!l.programId.equals(u))
      throw new i.TokenInvalidInstructionProgramError();
    if (l.data.length !== e.syncNativeInstructionData.span)
      throw new i.TokenInvalidInstructionDataError();
    const { keys: { account: f }, data: d } = c(l);
    if (d.instruction !== o.TokenInstruction.SyncNative)
      throw new i.TokenInvalidInstructionTypeError();
    if (!f)
      throw new i.TokenInvalidInstructionKeysError();
    return {
      programId: u,
      keys: {
        account: f
      },
      data: d
    };
  }
  e.decodeSyncNativeInstruction = s;
  function c({ programId: l, keys: [u], data: f }) {
    return {
      programId: l,
      keys: {
        account: u
      },
      data: e.syncNativeInstructionData.decode(f)
    };
  }
  e.decodeSyncNativeInstructionUnchecked = c;
})(D0);
var noe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(rw, "__esModule", { value: !0 });
rw.createWrappedNativeAccount = void 0;
const uc = we, Ug = ot, roe = ba, ioe = B0, ooe = D0, jP = P0(), aoe = ac(), soe = M0;
function coe(e, t, n, r, i, o, a = Ug.TOKEN_PROGRAM_ID, s = Ug.NATIVE_MINT) {
  return noe(this, void 0, void 0, function* () {
    if (!r)
      return yield (0, soe.createAccount)(e, t, s, n, i, o, a);
    if (!i) {
      const u = (0, aoe.getAssociatedTokenAddressSync)(s, n, !1, a, Ug.ASSOCIATED_TOKEN_PROGRAM_ID), f = new uc.Transaction().add((0, roe.createAssociatedTokenAccountInstruction)(t.publicKey, u, n, s, a, Ug.ASSOCIATED_TOKEN_PROGRAM_ID), uc.SystemProgram.transfer({
        fromPubkey: t.publicKey,
        toPubkey: u,
        lamports: r
      }), (0, ooe.createSyncNativeInstruction)(u, a));
      return yield (0, uc.sendAndConfirmTransaction)(e, f, [t], o), u;
    }
    const c = yield (0, jP.getMinimumBalanceForRentExemptAccount)(e), l = new uc.Transaction().add(uc.SystemProgram.createAccount({
      fromPubkey: t.publicKey,
      newAccountPubkey: i.publicKey,
      space: jP.ACCOUNT_SIZE,
      lamports: c,
      programId: a
    }), uc.SystemProgram.transfer({
      fromPubkey: t.publicKey,
      toPubkey: i.publicKey,
      lamports: r
    }), (0, ioe.createInitializeAccountInstruction)(i.publicKey, s, n, a));
    return yield (0, uc.sendAndConfirmTransaction)(e, l, [t, i], o), i.publicKey;
  });
}
rw.createWrappedNativeAccount = coe;
var iw = {}, ow = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeFreezeAccountInstructionUnchecked = e.decodeFreezeAccountInstruction = e.createFreezeAccountInstruction = e.freezeAccountInstructionData = void 0;
  const t = ie, n = we, r = ot, i = dt, o = Ar, a = nn;
  e.freezeAccountInstructionData = (0, t.struct)([(0, t.u8)("instruction")]);
  function s(u, f, d, h = [], g = r.TOKEN_PROGRAM_ID) {
    const w = (0, o.addSigners)([
      { pubkey: u, isSigner: !1, isWritable: !0 },
      { pubkey: f, isSigner: !1, isWritable: !1 }
    ], d, h), b = Buffer.alloc(e.freezeAccountInstructionData.span);
    return e.freezeAccountInstructionData.encode({ instruction: a.TokenInstruction.FreezeAccount }, b), new n.TransactionInstruction({ keys: w, programId: g, data: b });
  }
  e.createFreezeAccountInstruction = s;
  function c(u, f = r.TOKEN_PROGRAM_ID) {
    if (!u.programId.equals(f))
      throw new i.TokenInvalidInstructionProgramError();
    if (u.data.length !== e.freezeAccountInstructionData.span)
      throw new i.TokenInvalidInstructionDataError();
    const { keys: { account: d, mint: h, authority: g, multiSigners: w }, data: b } = l(u);
    if (b.instruction !== a.TokenInstruction.FreezeAccount)
      throw new i.TokenInvalidInstructionTypeError();
    if (!d || !h || !g)
      throw new i.TokenInvalidInstructionKeysError();
    return {
      programId: f,
      keys: {
        account: d,
        mint: h,
        authority: g,
        multiSigners: w
      },
      data: b
    };
  }
  e.decodeFreezeAccountInstruction = c;
  function l({ programId: u, keys: [f, d, h, ...g], data: w }) {
    return {
      programId: u,
      keys: {
        account: f,
        mint: d,
        authority: h,
        multiSigners: g
      },
      data: e.freezeAccountInstructionData.decode(w)
    };
  }
  e.decodeFreezeAccountInstructionUnchecked = l;
})(ow);
var uoe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(iw, "__esModule", { value: !0 });
iw.freezeAccount = void 0;
const UP = we, loe = ot, foe = ow, doe = Tr;
function hoe(e, t, n, r, i, o = [], a, s = loe.TOKEN_PROGRAM_ID) {
  return uoe(this, void 0, void 0, function* () {
    const [c, l] = (0, doe.getSigners)(i, o), u = new UP.Transaction().add((0, foe.createFreezeAccountInstruction)(n, r, c, o, s));
    return yield (0, UP.sendAndConfirmTransaction)(e, u, [t, ...l], a);
  });
}
iw.freezeAccount = hoe;
var aw = {}, poe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(aw, "__esModule", { value: !0 });
aw.getOrCreateAssociatedTokenAccount = void 0;
const zP = we, FP = ot, zg = dt, yoe = ba, LP = P0(), goe = ac();
function boe(e, t, n, r, i = !1, o, a, s = FP.TOKEN_PROGRAM_ID, c = FP.ASSOCIATED_TOKEN_PROGRAM_ID) {
  return poe(this, void 0, void 0, function* () {
    const l = (0, goe.getAssociatedTokenAddressSync)(n, r, i, s, c);
    let u;
    try {
      u = yield (0, LP.getAccount)(e, l, o, s);
    } catch (f) {
      if (f instanceof zg.TokenAccountNotFoundError || f instanceof zg.TokenInvalidAccountOwnerError) {
        try {
          const d = new zP.Transaction().add((0, yoe.createAssociatedTokenAccountInstruction)(t.publicKey, l, r, n, s, c));
          yield (0, zP.sendAndConfirmTransaction)(e, d, [t], a);
        } catch {
        }
        u = yield (0, LP.getAccount)(e, l, o, s);
      } else
        throw f;
    }
    if (!u.mint.equals(n))
      throw new zg.TokenInvalidMintError();
    if (!u.owner.equals(r))
      throw new zg.TokenInvalidOwnerError();
    return u;
  });
}
aw.getOrCreateAssociatedTokenAccount = boe;
var sw = {}, cw = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeMintToInstructionUnchecked = e.decodeMintToInstruction = e.createMintToInstruction = e.mintToInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = Ar, s = nn;
  e.mintToInstructionData = (0, t.struct)([(0, t.u8)("instruction"), (0, n.u64)("amount")]);
  function c(f, d, h, g, w = [], b = i.TOKEN_PROGRAM_ID) {
    const I = (0, a.addSigners)([
      { pubkey: f, isSigner: !1, isWritable: !0 },
      { pubkey: d, isSigner: !1, isWritable: !0 }
    ], h, w), A = Buffer.alloc(e.mintToInstructionData.span);
    return e.mintToInstructionData.encode({
      instruction: s.TokenInstruction.MintTo,
      amount: BigInt(g)
    }, A), new r.TransactionInstruction({ keys: I, programId: b, data: A });
  }
  e.createMintToInstruction = c;
  function l(f, d = i.TOKEN_PROGRAM_ID) {
    if (!f.programId.equals(d))
      throw new o.TokenInvalidInstructionProgramError();
    if (f.data.length !== e.mintToInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { mint: h, destination: g, authority: w, multiSigners: b }, data: I } = u(f);
    if (I.instruction !== s.TokenInstruction.MintTo)
      throw new o.TokenInvalidInstructionTypeError();
    if (!h || !g || !w)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: d,
      keys: {
        mint: h,
        destination: g,
        authority: w,
        multiSigners: b
      },
      data: I
    };
  }
  e.decodeMintToInstruction = l;
  function u({ programId: f, keys: [d, h, g, ...w], data: b }) {
    return {
      programId: f,
      keys: {
        mint: d,
        destination: h,
        authority: g,
        multiSigners: w
      },
      data: e.mintToInstructionData.decode(b)
    };
  }
  e.decodeMintToInstructionUnchecked = u;
})(cw);
var moe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(sw, "__esModule", { value: !0 });
sw.mintTo = void 0;
const $P = we, _oe = ot, woe = cw, voe = Tr;
function Soe(e, t, n, r, i, o, a = [], s, c = _oe.TOKEN_PROGRAM_ID) {
  return moe(this, void 0, void 0, function* () {
    const [l, u] = (0, voe.getSigners)(i, a), f = new $P.Transaction().add((0, woe.createMintToInstruction)(n, r, l, o, a, c));
    return yield (0, $P.sendAndConfirmTransaction)(e, f, [t, ...u], s);
  });
}
sw.mintTo = Soe;
var uw = {}, lw = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeMintToCheckedInstructionUnchecked = e.decodeMintToCheckedInstruction = e.createMintToCheckedInstruction = e.mintToCheckedInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = Ar, s = nn;
  e.mintToCheckedInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, n.u64)("amount"),
    (0, t.u8)("decimals")
  ]);
  function c(f, d, h, g, w, b = [], I = i.TOKEN_PROGRAM_ID) {
    const A = (0, a.addSigners)([
      { pubkey: f, isSigner: !1, isWritable: !0 },
      { pubkey: d, isSigner: !1, isWritable: !0 }
    ], h, b), x = Buffer.alloc(e.mintToCheckedInstructionData.span);
    return e.mintToCheckedInstructionData.encode({
      instruction: s.TokenInstruction.MintToChecked,
      amount: BigInt(g),
      decimals: w
    }, x), new r.TransactionInstruction({ keys: A, programId: I, data: x });
  }
  e.createMintToCheckedInstruction = c;
  function l(f, d = i.TOKEN_PROGRAM_ID) {
    if (!f.programId.equals(d))
      throw new o.TokenInvalidInstructionProgramError();
    if (f.data.length !== e.mintToCheckedInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { mint: h, destination: g, authority: w, multiSigners: b }, data: I } = u(f);
    if (I.instruction !== s.TokenInstruction.MintToChecked)
      throw new o.TokenInvalidInstructionTypeError();
    if (!h || !g || !w)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: d,
      keys: {
        mint: h,
        destination: g,
        authority: w,
        multiSigners: b
      },
      data: I
    };
  }
  e.decodeMintToCheckedInstruction = l;
  function u({ programId: f, keys: [d, h, g, ...w], data: b }) {
    return {
      programId: f,
      keys: {
        mint: d,
        destination: h,
        authority: g,
        multiSigners: w
      },
      data: e.mintToCheckedInstructionData.decode(b)
    };
  }
  e.decodeMintToCheckedInstructionUnchecked = u;
})(lw);
var Eoe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(uw, "__esModule", { value: !0 });
uw.mintToChecked = void 0;
const WP = we, Aoe = ot, Ioe = lw, koe = Tr;
function Toe(e, t, n, r, i, o, a, s = [], c, l = Aoe.TOKEN_PROGRAM_ID) {
  return Eoe(this, void 0, void 0, function* () {
    const [u, f] = (0, koe.getSigners)(i, s), d = new WP.Transaction().add((0, Ioe.createMintToCheckedInstruction)(n, r, u, o, a, s, l));
    return yield (0, WP.sendAndConfirmTransaction)(e, d, [t, ...f], c);
  });
}
uw.mintToChecked = Toe;
var fw = {}, dw = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeRevokeInstructionUnchecked = e.decodeRevokeInstruction = e.createRevokeInstruction = e.revokeInstructionData = void 0;
  const t = ie, n = we, r = ot, i = dt, o = Ar, a = nn;
  e.revokeInstructionData = (0, t.struct)([(0, t.u8)("instruction")]);
  function s(u, f, d = [], h = r.TOKEN_PROGRAM_ID) {
    const g = (0, o.addSigners)([{ pubkey: u, isSigner: !1, isWritable: !0 }], f, d), w = Buffer.alloc(e.revokeInstructionData.span);
    return e.revokeInstructionData.encode({ instruction: a.TokenInstruction.Revoke }, w), new n.TransactionInstruction({ keys: g, programId: h, data: w });
  }
  e.createRevokeInstruction = s;
  function c(u, f = r.TOKEN_PROGRAM_ID) {
    if (!u.programId.equals(f))
      throw new i.TokenInvalidInstructionProgramError();
    if (u.data.length !== e.revokeInstructionData.span)
      throw new i.TokenInvalidInstructionDataError();
    const { keys: { account: d, owner: h, multiSigners: g }, data: w } = l(u);
    if (w.instruction !== a.TokenInstruction.Revoke)
      throw new i.TokenInvalidInstructionTypeError();
    if (!d || !h)
      throw new i.TokenInvalidInstructionKeysError();
    return {
      programId: f,
      keys: {
        account: d,
        owner: h,
        multiSigners: g
      },
      data: w
    };
  }
  e.decodeRevokeInstruction = c;
  function l({ programId: u, keys: [f, d, ...h], data: g }) {
    return {
      programId: u,
      keys: {
        account: f,
        owner: d,
        multiSigners: h
      },
      data: e.revokeInstructionData.decode(g)
    };
  }
  e.decodeRevokeInstructionUnchecked = l;
})(dw);
var xoe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(fw, "__esModule", { value: !0 });
fw.revoke = void 0;
const KP = we, Moe = ot, Ooe = dw, Poe = Tr;
function Boe(e, t, n, r, i = [], o, a = Moe.TOKEN_PROGRAM_ID) {
  return xoe(this, void 0, void 0, function* () {
    const [s, c] = (0, Poe.getSigners)(r, i), l = new KP.Transaction().add((0, Ooe.createRevokeInstruction)(n, s, i, a));
    return yield (0, KP.sendAndConfirmTransaction)(e, l, [t, ...c], o);
  });
}
fw.revoke = Boe;
var hw = {}, pw = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeSetAuthorityInstructionUnchecked = e.decodeSetAuthorityInstruction = e.createSetAuthorityInstruction = e.setAuthorityInstructionData = e.AuthorityType = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = Ar, s = nn;
  (function(f) {
    f[f.MintTokens = 0] = "MintTokens", f[f.FreezeAccount = 1] = "FreezeAccount", f[f.AccountOwner = 2] = "AccountOwner", f[f.CloseAccount = 3] = "CloseAccount";
  })(e.AuthorityType || (e.AuthorityType = {})), e.setAuthorityInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("authorityType"),
    (0, t.u8)("newAuthorityOption"),
    (0, n.publicKey)("newAuthority")
  ]);
  function c(f, d, h, g, w = [], b = i.TOKEN_PROGRAM_ID) {
    const I = (0, a.addSigners)([{ pubkey: f, isSigner: !1, isWritable: !0 }], d, w), A = Buffer.alloc(e.setAuthorityInstructionData.span);
    return e.setAuthorityInstructionData.encode({
      instruction: s.TokenInstruction.SetAuthority,
      authorityType: h,
      newAuthorityOption: g ? 1 : 0,
      newAuthority: g || new r.PublicKey(0)
    }, A), new r.TransactionInstruction({ keys: I, programId: b, data: A });
  }
  e.createSetAuthorityInstruction = c;
  function l(f, d = i.TOKEN_PROGRAM_ID) {
    if (!f.programId.equals(d))
      throw new o.TokenInvalidInstructionProgramError();
    if (f.data.length !== e.setAuthorityInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { account: h, currentAuthority: g, multiSigners: w }, data: b } = u(f);
    if (b.instruction !== s.TokenInstruction.SetAuthority)
      throw new o.TokenInvalidInstructionTypeError();
    if (!h || !g)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: d,
      keys: {
        account: h,
        currentAuthority: g,
        multiSigners: w
      },
      data: b
    };
  }
  e.decodeSetAuthorityInstruction = l;
  function u({ programId: f, keys: [d, h, ...g], data: w }) {
    const { instruction: b, authorityType: I, newAuthorityOption: A, newAuthority: x } = e.setAuthorityInstructionData.decode(w);
    return {
      programId: f,
      keys: {
        account: d,
        currentAuthority: h,
        multiSigners: g
      },
      data: {
        instruction: b,
        authorityType: I,
        newAuthority: A ? x : null
      }
    };
  }
  e.decodeSetAuthorityInstructionUnchecked = u;
})(pw);
var Coe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(hw, "__esModule", { value: !0 });
hw.setAuthority = void 0;
const VP = we, Doe = ot, Roe = pw, Noe = Tr;
function joe(e, t, n, r, i, o, a = [], s, c = Doe.TOKEN_PROGRAM_ID) {
  return Coe(this, void 0, void 0, function* () {
    const [l, u] = (0, Noe.getSigners)(r, a), f = new VP.Transaction().add((0, Roe.createSetAuthorityInstruction)(n, l, i, o, a, c));
    return yield (0, VP.sendAndConfirmTransaction)(e, f, [t, ...u], s);
  });
}
hw.setAuthority = joe;
var yw = {}, Uoe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(yw, "__esModule", { value: !0 });
yw.syncNative = void 0;
const qP = we, zoe = ot, Foe = D0;
function Loe(e, t, n, r, i = zoe.TOKEN_PROGRAM_ID) {
  return Uoe(this, void 0, void 0, function* () {
    const o = new qP.Transaction().add((0, Foe.createSyncNativeInstruction)(n, i));
    return yield (0, qP.sendAndConfirmTransaction)(e, o, [t], r);
  });
}
yw.syncNative = Loe;
var gw = {}, bw = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeThawAccountInstructionUnchecked = e.decodeThawAccountInstruction = e.createThawAccountInstruction = e.thawAccountInstructionData = void 0;
  const t = ie, n = we, r = ot, i = dt, o = Ar, a = nn;
  e.thawAccountInstructionData = (0, t.struct)([(0, t.u8)("instruction")]);
  function s(u, f, d, h = [], g = r.TOKEN_PROGRAM_ID) {
    const w = (0, o.addSigners)([
      { pubkey: u, isSigner: !1, isWritable: !0 },
      { pubkey: f, isSigner: !1, isWritable: !1 }
    ], d, h), b = Buffer.alloc(e.thawAccountInstructionData.span);
    return e.thawAccountInstructionData.encode({ instruction: a.TokenInstruction.ThawAccount }, b), new n.TransactionInstruction({ keys: w, programId: g, data: b });
  }
  e.createThawAccountInstruction = s;
  function c(u, f = r.TOKEN_PROGRAM_ID) {
    if (!u.programId.equals(f))
      throw new i.TokenInvalidInstructionProgramError();
    if (u.data.length !== e.thawAccountInstructionData.span)
      throw new i.TokenInvalidInstructionDataError();
    const { keys: { account: d, mint: h, authority: g, multiSigners: w }, data: b } = l(u);
    if (b.instruction !== a.TokenInstruction.ThawAccount)
      throw new i.TokenInvalidInstructionTypeError();
    if (!d || !h || !g)
      throw new i.TokenInvalidInstructionKeysError();
    return {
      programId: f,
      keys: {
        account: d,
        mint: h,
        authority: g,
        multiSigners: w
      },
      data: b
    };
  }
  e.decodeThawAccountInstruction = c;
  function l({ programId: u, keys: [f, d, h, ...g], data: w }) {
    return {
      programId: u,
      keys: {
        account: f,
        mint: d,
        authority: h,
        multiSigners: g
      },
      data: e.thawAccountInstructionData.decode(w)
    };
  }
  e.decodeThawAccountInstructionUnchecked = l;
})(bw);
var $oe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(gw, "__esModule", { value: !0 });
gw.thawAccount = void 0;
const HP = we, Woe = ot, Koe = bw, Voe = Tr;
function qoe(e, t, n, r, i, o = [], a, s = Woe.TOKEN_PROGRAM_ID) {
  return $oe(this, void 0, void 0, function* () {
    const [c, l] = (0, Voe.getSigners)(i, o), u = new HP.Transaction().add((0, Koe.createThawAccountInstruction)(n, r, c, o, s));
    return yield (0, HP.sendAndConfirmTransaction)(e, u, [t, ...l], a);
  });
}
gw.thawAccount = qoe;
var mw = {}, _w = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeTransferInstructionUnchecked = e.decodeTransferInstruction = e.createTransferInstruction = e.transferInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = Ar, s = nn;
  e.transferInstructionData = (0, t.struct)([(0, t.u8)("instruction"), (0, n.u64)("amount")]);
  function c(f, d, h, g, w = [], b = i.TOKEN_PROGRAM_ID) {
    const I = (0, a.addSigners)([
      { pubkey: f, isSigner: !1, isWritable: !0 },
      { pubkey: d, isSigner: !1, isWritable: !0 }
    ], h, w), A = Buffer.alloc(e.transferInstructionData.span);
    return e.transferInstructionData.encode({
      instruction: s.TokenInstruction.Transfer,
      amount: BigInt(g)
    }, A), new r.TransactionInstruction({ keys: I, programId: b, data: A });
  }
  e.createTransferInstruction = c;
  function l(f, d = i.TOKEN_PROGRAM_ID) {
    if (!f.programId.equals(d))
      throw new o.TokenInvalidInstructionProgramError();
    if (f.data.length !== e.transferInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { source: h, destination: g, owner: w, multiSigners: b }, data: I } = u(f);
    if (I.instruction !== s.TokenInstruction.Transfer)
      throw new o.TokenInvalidInstructionTypeError();
    if (!h || !g || !w)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: d,
      keys: {
        source: h,
        destination: g,
        owner: w,
        multiSigners: b
      },
      data: I
    };
  }
  e.decodeTransferInstruction = l;
  function u({ programId: f, keys: [d, h, g, ...w], data: b }) {
    return {
      programId: f,
      keys: {
        source: d,
        destination: h,
        owner: g,
        multiSigners: w
      },
      data: e.transferInstructionData.decode(b)
    };
  }
  e.decodeTransferInstructionUnchecked = u;
})(_w);
var Hoe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(mw, "__esModule", { value: !0 });
mw.transfer = void 0;
const GP = we, Goe = ot, Yoe = _w, Zoe = Tr;
function Joe(e, t, n, r, i, o, a = [], s, c = Goe.TOKEN_PROGRAM_ID) {
  return Hoe(this, void 0, void 0, function* () {
    const [l, u] = (0, Zoe.getSigners)(i, a), f = new GP.Transaction().add((0, Yoe.createTransferInstruction)(n, r, l, o, a, c));
    return yield (0, GP.sendAndConfirmTransaction)(e, f, [t, ...u], s);
  });
}
mw.transfer = Joe;
var ww = {}, vw = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeTransferCheckedInstructionUnchecked = e.decodeTransferCheckedInstruction = e.createTransferCheckedInstruction = e.transferCheckedInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = Ar, s = nn;
  e.transferCheckedInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, n.u64)("amount"),
    (0, t.u8)("decimals")
  ]);
  function c(f, d, h, g, w, b, I = [], A = i.TOKEN_PROGRAM_ID) {
    const x = (0, a.addSigners)([
      { pubkey: f, isSigner: !1, isWritable: !0 },
      { pubkey: d, isSigner: !1, isWritable: !1 },
      { pubkey: h, isSigner: !1, isWritable: !0 }
    ], g, I), N = Buffer.alloc(e.transferCheckedInstructionData.span);
    return e.transferCheckedInstructionData.encode({
      instruction: s.TokenInstruction.TransferChecked,
      amount: BigInt(w),
      decimals: b
    }, N), new r.TransactionInstruction({ keys: x, programId: A, data: N });
  }
  e.createTransferCheckedInstruction = c;
  function l(f, d = i.TOKEN_PROGRAM_ID) {
    if (!f.programId.equals(d))
      throw new o.TokenInvalidInstructionProgramError();
    if (f.data.length !== e.transferCheckedInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { source: h, mint: g, destination: w, owner: b, multiSigners: I }, data: A } = u(f);
    if (A.instruction !== s.TokenInstruction.TransferChecked)
      throw new o.TokenInvalidInstructionTypeError();
    if (!h || !g || !w || !b)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: d,
      keys: {
        source: h,
        mint: g,
        destination: w,
        owner: b,
        multiSigners: I
      },
      data: A
    };
  }
  e.decodeTransferCheckedInstruction = l;
  function u({ programId: f, keys: [d, h, g, w, ...b], data: I }) {
    return {
      programId: f,
      keys: {
        source: d,
        mint: h,
        destination: g,
        owner: w,
        multiSigners: b
      },
      data: e.transferCheckedInstructionData.decode(I)
    };
  }
  e.decodeTransferCheckedInstructionUnchecked = u;
})(vw);
var Xoe = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(ww, "__esModule", { value: !0 });
ww.transferChecked = void 0;
const YP = we, Qoe = ot, eae = vw, tae = Tr;
function nae(e, t, n, r, i, o, a, s, c = [], l, u = Qoe.TOKEN_PROGRAM_ID) {
  return Xoe(this, void 0, void 0, function* () {
    const [f, d] = (0, tae.getSigners)(o, c), h = new YP.Transaction().add((0, eae.createTransferCheckedInstruction)(n, r, i, f, a, s, c, u));
    return yield (0, YP.sendAndConfirmTransaction)(e, h, [t, ...d], l);
  });
}
ww.transferChecked = nae;
var Sw = {}, pa = {};
Object.defineProperty(pa, "__esModule", { value: !0 });
pa.decodeUiAmountToAmountInstructionUnchecked = pa.decodeUiAmountToAmountInstruction = pa.createUiAmountToAmountInstruction = void 0;
const Wa = ie, rae = we, ON = ot, Fg = dt, PN = nn;
function iae(e, t, n = ON.TOKEN_PROGRAM_ID) {
  const r = [{ pubkey: e, isSigner: !1, isWritable: !1 }], i = Buffer.from(t, "utf8"), o = (0, Wa.struct)([
    (0, Wa.u8)("instruction"),
    (0, Wa.blob)(i.length, "amount")
  ]), a = Buffer.alloc(o.span);
  return o.encode({
    instruction: PN.TokenInstruction.UiAmountToAmount,
    amount: i
  }, a), new rae.TransactionInstruction({ keys: r, programId: n, data: a });
}
pa.createUiAmountToAmountInstruction = iae;
function oae(e, t = ON.TOKEN_PROGRAM_ID) {
  if (!e.programId.equals(t))
    throw new Fg.TokenInvalidInstructionProgramError();
  const n = (0, Wa.struct)([
    (0, Wa.u8)("instruction"),
    (0, Wa.blob)(e.data.length - 1, "amount")
  ]);
  if (e.data.length !== n.span)
    throw new Fg.TokenInvalidInstructionDataError();
  const { keys: { mint: r }, data: i } = BN(e);
  if (i.instruction !== PN.TokenInstruction.UiAmountToAmount)
    throw new Fg.TokenInvalidInstructionTypeError();
  if (!r)
    throw new Fg.TokenInvalidInstructionKeysError();
  return {
    programId: t,
    keys: {
      mint: r
    },
    data: i
  };
}
pa.decodeUiAmountToAmountInstruction = oae;
function BN({ programId: e, keys: [t], data: n }) {
  const r = (0, Wa.struct)([
    (0, Wa.u8)("instruction"),
    (0, Wa.blob)(n.length - 1, "amount")
  ]);
  return {
    programId: e,
    keys: {
      mint: t
    },
    data: r.decode(n)
  };
}
pa.decodeUiAmountToAmountInstructionUnchecked = BN;
var aae = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(Sw, "__esModule", { value: !0 });
Sw.uiAmountToAmount = void 0;
const sae = Fn, cae = we, uae = ot, lae = pa;
function fae(e, t, n, r, i = uae.TOKEN_PROGRAM_ID) {
  return aae(this, void 0, void 0, function* () {
    const o = new cae.Transaction().add((0, lae.createUiAmountToAmountInstruction)(n, r, i)), { returnData: a, err: s } = (yield e.simulateTransaction(o, [t], !1)).value;
    if (a) {
      const c = Buffer.from(a.data[0], a.data[1]);
      return (0, sae.u64)().decode(c);
    }
    return s;
  });
}
Sw.uiAmountToAmount = fae;
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(N_, e), n(U_, e), n(F_, e), n($_, e), n(K_, e), n(q_, e), n(M0, e), n(C0, e), n(J_, e), n(X_, e), n(ew, e), n(nw, e), n(rw, e), n(iw, e), n(aw, e), n(sw, e), n(uw, e), n(fw, e), n(hw, e), n(yw, e), n(gw, e), n(mw, e), n(ww, e), n(Sw, e);
})(cN);
var CN = {}, DN = {}, xl = {}, Ew = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeInitializeMintInstructionUnchecked = e.decodeInitializeMintInstruction = e.createInitializeMintInstruction = e.initializeMintInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = nn;
  e.initializeMintInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("decimals"),
    (0, n.publicKey)("mintAuthority"),
    (0, t.u8)("freezeAuthorityOption"),
    (0, n.publicKey)("freezeAuthority")
  ]);
  function s(u, f, d, h, g = i.TOKEN_PROGRAM_ID) {
    const w = [
      { pubkey: u, isSigner: !1, isWritable: !0 },
      { pubkey: r.SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
    ], b = Buffer.alloc(e.initializeMintInstructionData.span);
    return e.initializeMintInstructionData.encode({
      instruction: a.TokenInstruction.InitializeMint,
      decimals: f,
      mintAuthority: d,
      freezeAuthorityOption: h ? 1 : 0,
      freezeAuthority: h || new r.PublicKey(0)
    }, b), new r.TransactionInstruction({ keys: w, programId: g, data: b });
  }
  e.createInitializeMintInstruction = s;
  function c(u, f = i.TOKEN_PROGRAM_ID) {
    if (!u.programId.equals(f))
      throw new o.TokenInvalidInstructionProgramError();
    if (u.data.length !== e.initializeMintInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { mint: d, rent: h }, data: g } = l(u);
    if (g.instruction !== a.TokenInstruction.InitializeMint)
      throw new o.TokenInvalidInstructionTypeError();
    if (!d || !h)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: f,
      keys: {
        mint: d,
        rent: h
      },
      data: g
    };
  }
  e.decodeInitializeMintInstruction = c;
  function l({ programId: u, keys: [f, d], data: h }) {
    const { instruction: g, decimals: w, mintAuthority: b, freezeAuthorityOption: I, freezeAuthority: A } = e.initializeMintInstructionData.decode(h);
    return {
      programId: u,
      keys: {
        mint: f,
        rent: d
      },
      data: {
        instruction: g,
        decimals: w,
        mintAuthority: b,
        freezeAuthority: I ? A : null
      }
    };
  }
  e.decodeInitializeMintInstructionUnchecked = l;
})(Ew);
var vT = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUpdateRateInterestBearingMintInstruction = e.createInitializeInterestBearingMintInstruction = e.interestBearingMintUpdateRateInstructionData = e.interestBearingMintInitializeInstructionData = e.InterestBearingMintInstruction = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = Ar, a = nn;
  var s;
  (function(u) {
    u[u.Initialize = 0] = "Initialize", u[u.UpdateRate = 1] = "UpdateRate";
  })(s = e.InterestBearingMintInstruction || (e.InterestBearingMintInstruction = {})), e.interestBearingMintInitializeInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("interestBearingMintInstruction"),
    // TODO: Make this an optional public key
    (0, n.publicKey)("rateAuthority"),
    (0, t.s16)("rate")
  ]), e.interestBearingMintUpdateRateInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("interestBearingMintInstruction"),
    (0, t.s16)("rate")
  ]);
  function c(u, f, d, h = i.TOKEN_2022_PROGRAM_ID) {
    const g = [{ pubkey: u, isSigner: !1, isWritable: !0 }], w = Buffer.alloc(e.interestBearingMintInitializeInstructionData.span);
    return e.interestBearingMintInitializeInstructionData.encode({
      instruction: a.TokenInstruction.InterestBearingMintExtension,
      interestBearingMintInstruction: s.Initialize,
      rateAuthority: f,
      rate: d
    }, w), new r.TransactionInstruction({ keys: g, programId: h, data: w });
  }
  e.createInitializeInterestBearingMintInstruction = c;
  function l(u, f, d, h = [], g = i.TOKEN_2022_PROGRAM_ID) {
    const w = (0, o.addSigners)([
      { pubkey: u, isSigner: !1, isWritable: !0 },
      { pubkey: f, isSigner: !h.length, isWritable: !1 }
    ], f, h), b = Buffer.alloc(e.interestBearingMintUpdateRateInstructionData.span);
    return e.interestBearingMintUpdateRateInstructionData.encode({
      instruction: a.TokenInstruction.InterestBearingMintExtension,
      interestBearingMintInstruction: s.UpdateRate,
      rate: d
    }, b), new r.TransactionInstruction({ keys: w, programId: g, data: b });
  }
  e.createUpdateRateInterestBearingMintInstruction = l;
})(vT);
var RN = _ && _.__awaiter || function(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        a(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        a(f);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
};
Object.defineProperty(xl, "__esModule", { value: !0 });
xl.updateRateInterestBearingMint = xl.createInterestBearingMint = void 0;
const zu = we, dae = Tr, NN = ot, hae = Ew, ZP = Mi(), jN = vT;
function pae(e, t, n, r, i, o, a, s = zu.Keypair.generate(), c, l = NN.TOKEN_2022_PROGRAM_ID) {
  return RN(this, void 0, void 0, function* () {
    const u = (0, ZP.getMintLen)([ZP.ExtensionType.InterestBearingConfig]), f = yield e.getMinimumBalanceForRentExemption(u), d = new zu.Transaction().add(zu.SystemProgram.createAccount({
      fromPubkey: t.publicKey,
      newAccountPubkey: s.publicKey,
      space: u,
      lamports: f,
      programId: l
    }), (0, jN.createInitializeInterestBearingMintInstruction)(s.publicKey, i, o, l), (0, hae.createInitializeMintInstruction)(s.publicKey, a, n, r, l));
    return yield (0, zu.sendAndConfirmTransaction)(e, d, [t, s], c), s.publicKey;
  });
}
xl.createInterestBearingMint = pae;
function yae(e, t, n, r, i, o = [], a, s = NN.TOKEN_2022_PROGRAM_ID) {
  return RN(this, void 0, void 0, function* () {
    const [c, l] = (0, dae.getSigners)(r, o), u = new zu.Transaction().add((0, jN.createUpdateRateInterestBearingMintInstruction)(n, c, i, l, s));
    return yield (0, zu.sendAndConfirmTransaction)(e, u, [t, r, ...l], a);
  });
}
xl.updateRateInterestBearingMint = yae;
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(xl, e), n(vT, e), n(_N(), e);
})(DN);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(O0, e), n(hN(), e), n(bN(), e), n(Mi(), e), n(mN(), e), n(DN, e), n(AN(), e), n(IN(), e), n(kN(), e), n(xN(), e), n(TN(), e);
})(CN);
var UN = {}, Mt = {}, ST = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeInitializeAccount2InstructionUnchecked = e.decodeInitializeAccount2Instruction = e.createInitializeAccount2Instruction = e.initializeAccount2InstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = nn;
  e.initializeAccount2InstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, n.publicKey)("owner")
  ]);
  function s(u, f, d, h = i.TOKEN_PROGRAM_ID) {
    const g = [
      { pubkey: u, isSigner: !1, isWritable: !0 },
      { pubkey: f, isSigner: !1, isWritable: !1 },
      { pubkey: r.SYSVAR_RENT_PUBKEY, isSigner: !1, isWritable: !1 }
    ], w = Buffer.alloc(e.initializeAccount2InstructionData.span);
    return e.initializeAccount2InstructionData.encode({ instruction: a.TokenInstruction.InitializeAccount2, owner: d }, w), new r.TransactionInstruction({ keys: g, programId: h, data: w });
  }
  e.createInitializeAccount2Instruction = s;
  function c(u, f = i.TOKEN_PROGRAM_ID) {
    if (!u.programId.equals(f))
      throw new o.TokenInvalidInstructionProgramError();
    if (u.data.length !== e.initializeAccount2InstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { account: d, mint: h, rent: g }, data: w } = l(u);
    if (w.instruction !== a.TokenInstruction.InitializeAccount2)
      throw new o.TokenInvalidInstructionTypeError();
    if (!d || !h || !g)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: f,
      keys: {
        account: d,
        mint: h,
        rent: g
      },
      data: w
    };
  }
  e.decodeInitializeAccount2Instruction = c;
  function l({ programId: u, keys: [f, d, h], data: g }) {
    return {
      programId: u,
      keys: {
        account: f,
        mint: d,
        rent: h
      },
      data: e.initializeAccount2InstructionData.decode(g)
    };
  }
  e.decodeInitializeAccount2InstructionUnchecked = l;
})(ST);
var ET = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeInitializeAccount3InstructionUnchecked = e.decodeInitializeAccount3Instruction = e.createInitializeAccount3Instruction = e.initializeAccount3InstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = nn;
  e.initializeAccount3InstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, n.publicKey)("owner")
  ]);
  function s(u, f, d, h = i.TOKEN_PROGRAM_ID) {
    const g = [
      { pubkey: u, isSigner: !1, isWritable: !0 },
      { pubkey: f, isSigner: !1, isWritable: !1 }
    ], w = Buffer.alloc(e.initializeAccount3InstructionData.span);
    return e.initializeAccount3InstructionData.encode({ instruction: a.TokenInstruction.InitializeAccount3, owner: d }, w), new r.TransactionInstruction({ keys: g, programId: h, data: w });
  }
  e.createInitializeAccount3Instruction = s;
  function c(u, f = i.TOKEN_PROGRAM_ID) {
    if (!u.programId.equals(f))
      throw new o.TokenInvalidInstructionProgramError();
    if (u.data.length !== e.initializeAccount3InstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { account: d, mint: h }, data: g } = l(u);
    if (g.instruction !== a.TokenInstruction.InitializeAccount3)
      throw new o.TokenInvalidInstructionTypeError();
    if (!d || !h)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: f,
      keys: {
        account: d,
        mint: h
      },
      data: g
    };
  }
  e.decodeInitializeAccount3Instruction = c;
  function l({ programId: u, keys: [f, d], data: h }) {
    return {
      programId: u,
      keys: {
        account: f,
        mint: d
      },
      data: e.initializeAccount3InstructionData.decode(h)
    };
  }
  e.decodeInitializeAccount3InstructionUnchecked = l;
})(ET);
Object.defineProperty(Mt, "__esModule", { value: !0 });
Mt.isUiamountToAmountInstruction = Mt.isAmountToUiAmountInstruction = Mt.isInitializeMint2Instruction = Mt.isInitializeAccount3Instruction = Mt.isSyncNativeInstruction = Mt.isInitializeAccount2Instruction = Mt.isBurnCheckedInstruction = Mt.isMintToCheckedInstruction = Mt.isApproveCheckedInstruction = Mt.isTransferCheckedInstruction = Mt.isThawAccountInstruction = Mt.isFreezeAccountInstruction = Mt.isCloseAccountInstruction = Mt.isBurnInstruction = Mt.isMintToInstruction = Mt.isSetAuthorityInstruction = Mt.isRevokeInstruction = Mt.isApproveInstruction = Mt.isTransferInstruction = Mt.isInitializeMultisigInstruction = Mt.isInitializeAccountInstruction = Mt.isInitializeMintInstruction = Mt.decodeInstruction = void 0;
const gae = ie, bae = ot, jS = dt, mae = j_, _ae = z_, wae = L_, vae = W_, Sae = V_, Eae = H_, Aae = ow, Iae = B0, kae = ST, Tae = ET, xae = Ew, Mae = Q_, Oae = tw, Pae = cw, Bae = lw, Cae = dw, Dae = pw, Rae = D0, Nae = bw, jae = _w, Uae = vw, Rt = nn, zae = pa;
function Fae(e, t = bae.TOKEN_PROGRAM_ID) {
  if (!e.data.length)
    throw new jS.TokenInvalidInstructionDataError();
  const n = (0, gae.u8)().decode(e.data);
  if (n === Rt.TokenInstruction.InitializeMint)
    return (0, xae.decodeInitializeMintInstruction)(e, t);
  if (n === Rt.TokenInstruction.InitializeAccount)
    return (0, Iae.decodeInitializeAccountInstruction)(e, t);
  if (n === Rt.TokenInstruction.InitializeMultisig)
    return (0, Oae.decodeInitializeMultisigInstruction)(e, t);
  if (n === Rt.TokenInstruction.Transfer)
    return (0, jae.decodeTransferInstruction)(e, t);
  if (n === Rt.TokenInstruction.Approve)
    return (0, _ae.decodeApproveInstruction)(e, t);
  if (n === Rt.TokenInstruction.Revoke)
    return (0, Cae.decodeRevokeInstruction)(e, t);
  if (n === Rt.TokenInstruction.SetAuthority)
    return (0, Dae.decodeSetAuthorityInstruction)(e, t);
  if (n === Rt.TokenInstruction.MintTo)
    return (0, Pae.decodeMintToInstruction)(e, t);
  if (n === Rt.TokenInstruction.Burn)
    return (0, vae.decodeBurnInstruction)(e, t);
  if (n === Rt.TokenInstruction.CloseAccount)
    return (0, Eae.decodeCloseAccountInstruction)(e, t);
  if (n === Rt.TokenInstruction.FreezeAccount)
    return (0, Aae.decodeFreezeAccountInstruction)(e, t);
  if (n === Rt.TokenInstruction.ThawAccount)
    return (0, Nae.decodeThawAccountInstruction)(e, t);
  if (n === Rt.TokenInstruction.TransferChecked)
    return (0, Uae.decodeTransferCheckedInstruction)(e, t);
  if (n === Rt.TokenInstruction.ApproveChecked)
    return (0, wae.decodeApproveCheckedInstruction)(e, t);
  if (n === Rt.TokenInstruction.MintToChecked)
    return (0, Bae.decodeMintToCheckedInstruction)(e, t);
  if (n === Rt.TokenInstruction.BurnChecked)
    return (0, Sae.decodeBurnCheckedInstruction)(e, t);
  if (n === Rt.TokenInstruction.InitializeAccount2)
    return (0, kae.decodeInitializeAccount2Instruction)(e, t);
  if (n === Rt.TokenInstruction.SyncNative)
    return (0, Rae.decodeSyncNativeInstruction)(e, t);
  if (n === Rt.TokenInstruction.InitializeAccount3)
    return (0, Tae.decodeInitializeAccount3Instruction)(e, t);
  if (n === Rt.TokenInstruction.InitializeMint2)
    return (0, Mae.decodeInitializeMint2Instruction)(e, t);
  if (n === Rt.TokenInstruction.AmountToUiAmount)
    return (0, mae.decodeAmountToUiAmountInstruction)(e, t);
  if (n === Rt.TokenInstruction.UiAmountToAmount)
    return (0, zae.decodeUiAmountToAmountInstruction)(e, t);
  throw n === Rt.TokenInstruction.InitializeMultisig2 ? new jS.TokenInvalidInstructionTypeError() : new jS.TokenInvalidInstructionTypeError();
}
Mt.decodeInstruction = Fae;
function Lae(e) {
  return e.data.instruction === Rt.TokenInstruction.InitializeMint;
}
Mt.isInitializeMintInstruction = Lae;
function $ae(e) {
  return e.data.instruction === Rt.TokenInstruction.InitializeAccount;
}
Mt.isInitializeAccountInstruction = $ae;
function Wae(e) {
  return e.data.instruction === Rt.TokenInstruction.InitializeMultisig;
}
Mt.isInitializeMultisigInstruction = Wae;
function Kae(e) {
  return e.data.instruction === Rt.TokenInstruction.Transfer;
}
Mt.isTransferInstruction = Kae;
function Vae(e) {
  return e.data.instruction === Rt.TokenInstruction.Approve;
}
Mt.isApproveInstruction = Vae;
function qae(e) {
  return e.data.instruction === Rt.TokenInstruction.Revoke;
}
Mt.isRevokeInstruction = qae;
function Hae(e) {
  return e.data.instruction === Rt.TokenInstruction.SetAuthority;
}
Mt.isSetAuthorityInstruction = Hae;
function Gae(e) {
  return e.data.instruction === Rt.TokenInstruction.MintTo;
}
Mt.isMintToInstruction = Gae;
function Yae(e) {
  return e.data.instruction === Rt.TokenInstruction.Burn;
}
Mt.isBurnInstruction = Yae;
function Zae(e) {
  return e.data.instruction === Rt.TokenInstruction.CloseAccount;
}
Mt.isCloseAccountInstruction = Zae;
function Jae(e) {
  return e.data.instruction === Rt.TokenInstruction.FreezeAccount;
}
Mt.isFreezeAccountInstruction = Jae;
function Xae(e) {
  return e.data.instruction === Rt.TokenInstruction.ThawAccount;
}
Mt.isThawAccountInstruction = Xae;
function Qae(e) {
  return e.data.instruction === Rt.TokenInstruction.TransferChecked;
}
Mt.isTransferCheckedInstruction = Qae;
function ese(e) {
  return e.data.instruction === Rt.TokenInstruction.ApproveChecked;
}
Mt.isApproveCheckedInstruction = ese;
function tse(e) {
  return e.data.instruction === Rt.TokenInstruction.MintToChecked;
}
Mt.isMintToCheckedInstruction = tse;
function nse(e) {
  return e.data.instruction === Rt.TokenInstruction.BurnChecked;
}
Mt.isBurnCheckedInstruction = nse;
function rse(e) {
  return e.data.instruction === Rt.TokenInstruction.InitializeAccount2;
}
Mt.isInitializeAccount2Instruction = rse;
function ise(e) {
  return e.data.instruction === Rt.TokenInstruction.SyncNative;
}
Mt.isSyncNativeInstruction = ise;
function ose(e) {
  return e.data.instruction === Rt.TokenInstruction.InitializeAccount3;
}
Mt.isInitializeAccount3Instruction = ose;
function ase(e) {
  return e.data.instruction === Rt.TokenInstruction.InitializeMint2;
}
Mt.isInitializeMint2Instruction = ase;
function sse(e) {
  return e.data.instruction === Rt.TokenInstruction.AmountToUiAmount;
}
Mt.isAmountToUiAmountInstruction = sse;
function cse(e) {
  return e.data.instruction === Rt.TokenInstruction.UiAmountToAmount;
}
Mt.isUiamountToAmountInstruction = cse;
var zN = {};
Object.defineProperty(zN, "__esModule", { value: !0 });
var FN = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeInitializeImmutableOwnerInstructionUnchecked = e.decodeInitializeImmutableOwnerInstruction = e.createInitializeImmutableOwnerInstruction = e.initializeImmutableOwnerInstructionData = void 0;
  const t = ie, n = we, r = dt, i = nn;
  e.initializeImmutableOwnerInstructionData = (0, t.struct)([
    (0, t.u8)("instruction")
  ]);
  function o(c, l) {
    const u = [{ pubkey: c, isSigner: !1, isWritable: !0 }], f = Buffer.alloc(e.initializeImmutableOwnerInstructionData.span);
    return e.initializeImmutableOwnerInstructionData.encode({
      instruction: i.TokenInstruction.InitializeImmutableOwner
    }, f), new n.TransactionInstruction({ keys: u, programId: l, data: f });
  }
  e.createInitializeImmutableOwnerInstruction = o;
  function a(c, l) {
    if (!c.programId.equals(l))
      throw new r.TokenInvalidInstructionProgramError();
    if (c.data.length !== e.initializeImmutableOwnerInstructionData.span)
      throw new r.TokenInvalidInstructionDataError();
    const { keys: { account: u }, data: f } = s(c);
    if (f.instruction !== i.TokenInstruction.InitializeImmutableOwner)
      throw new r.TokenInvalidInstructionTypeError();
    if (!u)
      throw new r.TokenInvalidInstructionKeysError();
    return {
      programId: l,
      keys: {
        account: u
      },
      data: f
    };
  }
  e.decodeInitializeImmutableOwnerInstruction = a;
  function s({ programId: c, keys: [l], data: u }) {
    const { instruction: f } = e.initializeImmutableOwnerInstructionData.decode(u);
    return {
      programId: c,
      keys: {
        account: l
      },
      data: {
        instruction: f
      }
    };
  }
  e.decodeInitializeImmutableOwnerInstructionUnchecked = s;
})(FN);
var LN = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeInitializeMintCloseAuthorityInstructionUnchecked = e.decodeInitializeMintCloseAuthorityInstruction = e.createInitializeMintCloseAuthorityInstruction = e.initializeMintCloseAuthorityInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = ot, o = dt, a = nn;
  e.initializeMintCloseAuthorityInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, t.u8)("closeAuthorityOption"),
    (0, n.publicKey)("closeAuthority")
  ]);
  function s(u, f, d) {
    if (!(0, i.programSupportsExtensions)(d))
      throw new o.TokenUnsupportedInstructionError();
    const h = [{ pubkey: u, isSigner: !1, isWritable: !0 }], g = Buffer.alloc(e.initializeMintCloseAuthorityInstructionData.span);
    return e.initializeMintCloseAuthorityInstructionData.encode({
      instruction: a.TokenInstruction.InitializeMintCloseAuthority,
      closeAuthorityOption: f ? 1 : 0,
      closeAuthority: f || new r.PublicKey(0)
    }, g), new r.TransactionInstruction({ keys: h, programId: d, data: g });
  }
  e.createInitializeMintCloseAuthorityInstruction = s;
  function c(u, f) {
    if (!u.programId.equals(f))
      throw new o.TokenInvalidInstructionProgramError();
    if (u.data.length !== e.initializeMintCloseAuthorityInstructionData.span)
      throw new o.TokenInvalidInstructionDataError();
    const { keys: { mint: d }, data: h } = l(u);
    if (h.instruction !== a.TokenInstruction.InitializeMintCloseAuthority)
      throw new o.TokenInvalidInstructionTypeError();
    if (!d)
      throw new o.TokenInvalidInstructionKeysError();
    return {
      programId: f,
      keys: {
        mint: d
      },
      data: h
    };
  }
  e.decodeInitializeMintCloseAuthorityInstruction = c;
  function l({ programId: u, keys: [f], data: d }) {
    const { instruction: h, closeAuthorityOption: g, closeAuthority: w } = e.initializeMintCloseAuthorityInstructionData.decode(d);
    return {
      programId: u,
      keys: {
        mint: f
      },
      data: {
        instruction: h,
        closeAuthority: g ? w : null
      }
    };
  }
  e.decodeInitializeMintCloseAuthorityInstructionUnchecked = l;
})(LN);
var Aw = {};
Object.defineProperty(Aw, "__esModule", { value: !0 });
Aw.createReallocateInstruction = void 0;
const Lg = ie, JP = we, XP = ot, use = dt, lse = Ar, fse = nn;
function dse(e, t, n, r, i = [], o = XP.TOKEN_2022_PROGRAM_ID) {
  if (!(0, XP.programSupportsExtensions)(o))
    throw new use.TokenUnsupportedInstructionError();
  const a = [
    { pubkey: e, isSigner: !1, isWritable: !0 },
    { pubkey: t, isSigner: !0, isWritable: !0 },
    { pubkey: JP.SystemProgram.programId, isSigner: !1, isWritable: !1 }
  ], s = (0, lse.addSigners)(a, r, i), c = (0, Lg.struct)([
    (0, Lg.u8)("instruction"),
    (0, Lg.seq)((0, Lg.u16)(), n.length, "extensionTypes")
  ]), l = Buffer.alloc(c.span);
  return c.encode({ instruction: fse.TokenInstruction.Reallocate, extensionTypes: n }, l), new JP.TransactionInstruction({ keys: s, programId: o, data: l });
}
Aw.createReallocateInstruction = dse;
var $N = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createInitializeNonTransferableMintInstruction = e.initializeNonTransferableMintInstructionData = void 0;
  const t = ie, n = we, r = ot, i = dt, o = nn;
  e.initializeNonTransferableMintInstructionData = (0, t.struct)([
    (0, t.u8)("instruction")
  ]);
  function a(s, c) {
    if (!(0, r.programSupportsExtensions)(c))
      throw new i.TokenUnsupportedInstructionError();
    const l = [{ pubkey: s, isSigner: !1, isWritable: !0 }], u = Buffer.alloc(e.initializeNonTransferableMintInstructionData.span);
    return e.initializeNonTransferableMintInstructionData.encode({
      instruction: o.TokenInstruction.InitializeNonTransferableMint
    }, u), new n.TransactionInstruction({ keys: l, programId: c, data: u });
  }
  e.createInitializeNonTransferableMintInstruction = a;
})($N);
var WN = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeInitializePermanentDelegateInstructionUnchecked = e.decodeInitializePermanentDelegateInstruction = e.createInitializePermanentDelegateInstruction = e.initializePermanentDelegateInstructionData = void 0;
  const t = ie, n = Fn, r = we, i = we, o = ot, a = dt, s = nn;
  e.initializePermanentDelegateInstructionData = (0, t.struct)([
    (0, t.u8)("instruction"),
    (0, n.publicKey)("delegate")
  ]);
  function c(f, d, h) {
    if (!(0, o.programSupportsExtensions)(h))
      throw new a.TokenUnsupportedInstructionError();
    const g = [{ pubkey: f, isSigner: !1, isWritable: !0 }], w = Buffer.alloc(e.initializePermanentDelegateInstructionData.span);
    return e.initializePermanentDelegateInstructionData.encode({
      instruction: s.TokenInstruction.InitializePermanentDelegate,
      delegate: d || new r.PublicKey(0)
    }, w), new i.TransactionInstruction({ keys: g, programId: h, data: w });
  }
  e.createInitializePermanentDelegateInstruction = c;
  function l(f, d) {
    if (!f.programId.equals(d))
      throw new a.TokenInvalidInstructionProgramError();
    if (f.data.length !== e.initializePermanentDelegateInstructionData.span)
      throw new a.TokenInvalidInstructionDataError();
    const { keys: { mint: h }, data: g } = u(f);
    if (g.instruction !== s.TokenInstruction.InitializePermanentDelegate)
      throw new a.TokenInvalidInstructionTypeError();
    if (!h)
      throw new a.TokenInvalidInstructionKeysError();
    return {
      programId: d,
      keys: {
        mint: h
      },
      data: g
    };
  }
  e.decodeInitializePermanentDelegateInstruction = l;
  function u({ programId: f, keys: [d], data: h }) {
    const { instruction: g, delegate: w } = e.initializePermanentDelegateInstructionData.decode(h);
    return {
      programId: f,
      keys: {
        mint: d
      },
      data: {
        instruction: g,
        delegate: w
      }
    };
  }
  e.decodeInitializePermanentDelegateInstructionUnchecked = u;
})(WN);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(ba, e), n(Mt, e), n(nn, e), n(Ew, e), n(B0, e), n(tw, e), n(_w, e), n(z_, e), n(dw, e), n(pw, e), n(cw, e), n(W_, e), n(H_, e), n(ow, e), n(bw, e), n(vw, e), n(L_, e), n(lw, e), n(V_, e), n(ST, e), n(D0, e), n(ET, e), n(zN, e), n(Q_, e), n(FN, e), n(j_, e), n(pa, e), n(LN, e), n(Aw, e), n(wT, e), n($N, e), n(WN, e);
})(UN);
var KN = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(P0(), e), n(ac(), e), n(Yl, e);
})(KN);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(cN, e), n(ot, e), n(dt, e), n(CN, e), n(UN, e), n(KN, e);
})(yi);
var R0 = {}, hse = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), pse = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), yse = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && hse(t, e, n);
  return pse(t, e), t;
};
Object.defineProperty(R0, "__esModule", { value: !0 });
R0.approveUseAuthorityArgsBeet = void 0;
const QP = yse(Se);
R0.approveUseAuthorityArgsBeet = new QP.BeetArgsStruct([["numberOfUses", QP.u64]], "ApproveUseAuthorityArgs");
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createApproveUseAuthorityInstruction = e.approveUseAuthorityInstructionDiscriminator = e.ApproveUseAuthorityStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we), s = R0;
  e.ApproveUseAuthorityStruct = new o.BeetArgsStruct([
    ["instructionDiscriminator", o.u8],
    ["approveUseAuthorityArgs", s.approveUseAuthorityArgsBeet]
  ], "ApproveUseAuthorityInstructionArgs"), e.approveUseAuthorityInstructionDiscriminator = 20;
  function c(l, u, f = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var d, h;
    const [g] = e.ApproveUseAuthorityStruct.serialize({
      instructionDiscriminator: e.approveUseAuthorityInstructionDiscriminator,
      ...u
    }), w = [
      {
        pubkey: l.useAuthorityRecord,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.owner,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: l.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: l.user,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.ownerTokenAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.burner,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = l.tokenProgram) !== null && d !== void 0 ? d : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = l.systemProgram) !== null && h !== void 0 ? h : a.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return l.rent != null && w.push({
      pubkey: l.rent,
      isWritable: !1,
      isSigner: !1
    }), new a.TransactionInstruction({
      programId: f,
      keys: w,
      data: g
    });
  }
  e.createApproveUseAuthorityInstruction = c;
})(sN);
var VN = {}, Zl = {}, gse = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), bse = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), mse = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && gse(t, e, n);
  return bse(t, e), t;
};
Object.defineProperty(Zl, "__esModule", { value: !0 });
Zl.setCollectionSizeArgsBeet = void 0;
const eB = mse(Se);
Zl.setCollectionSizeArgsBeet = new eB.BeetArgsStruct([["size", eB.u64]], "SetCollectionSizeArgs");
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createBubblegumSetCollectionSizeInstruction = e.bubblegumSetCollectionSizeInstructionDiscriminator = e.BubblegumSetCollectionSizeStruct = void 0;
  const i = r(Se), o = r(we), a = Zl;
  e.BubblegumSetCollectionSizeStruct = new i.BeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["setCollectionSizeArgs", a.setCollectionSizeArgsBeet]
  ], "BubblegumSetCollectionSizeInstructionArgs"), e.bubblegumSetCollectionSizeInstructionDiscriminator = 36;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [f] = e.BubblegumSetCollectionSizeStruct.serialize({
      instructionDiscriminator: e.bubblegumSetCollectionSizeInstructionDiscriminator,
      ...l
    }), d = [
      {
        pubkey: c.collectionMetadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.collectionAuthority,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: c.collectionMint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.bubblegumSigner,
        isWritable: !1,
        isSigner: !0
      }
    ];
    return c.collectionAuthorityRecord != null && d.push({
      pubkey: c.collectionAuthorityRecord,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: u,
      keys: d,
      data: f
    });
  }
  e.createBubblegumSetCollectionSizeInstruction = s;
})(VN);
var qN = {}, Wc = {}, _se = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), wse = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), vse = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && _se(t, e, n);
  return wse(t, e), t;
};
Object.defineProperty(Wc, "__esModule", { value: !0 });
Wc.burnArgsBeet = Wc.isBurnArgsV1 = void 0;
const US = vse(Se), Sse = (e) => e.__kind === "V1";
Wc.isBurnArgsV1 = Sse;
Wc.burnArgsBeet = US.dataEnum([
  [
    "V1",
    new US.BeetArgsStruct([["amount", US.u64]], 'BurnArgsRecord["V1"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createBurnInstruction = e.burnInstructionDiscriminator = e.BurnStruct = void 0;
  const i = r(Se), o = r(we), a = Wc;
  e.BurnStruct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["burnArgs", a.burnArgsBeet]
  ], "BurnInstructionArgs"), e.burnInstructionDiscriminator = 41;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g, w, b, I, A;
    const [x] = e.BurnStruct.serialize({
      instructionDiscriminator: e.burnInstructionDiscriminator,
      ...l
    }), N = [
      {
        pubkey: c.authority,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: (f = c.collectionMetadata) !== null && f !== void 0 ? f : u,
        isWritable: c.collectionMetadata != null,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (d = c.edition) !== null && d !== void 0 ? d : u,
        isWritable: c.edition != null,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.token,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (h = c.masterEdition) !== null && h !== void 0 ? h : u,
        isWritable: c.masterEdition != null,
        isSigner: !1
      },
      {
        pubkey: (g = c.masterEditionMint) !== null && g !== void 0 ? g : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (w = c.masterEditionToken) !== null && w !== void 0 ? w : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (b = c.editionMarker) !== null && b !== void 0 ? b : u,
        isWritable: c.editionMarker != null,
        isSigner: !1
      },
      {
        pubkey: (I = c.tokenRecord) !== null && I !== void 0 ? I : u,
        isWritable: c.tokenRecord != null,
        isSigner: !1
      },
      {
        pubkey: (A = c.systemProgram) !== null && A !== void 0 ? A : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.splTokenProgram,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: N,
      data: x
    });
  }
  e.createBurnInstruction = s;
})(qN);
var HN = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createBurnEditionNftInstruction = e.burnEditionNftInstructionDiscriminator = e.BurnEditionNftStruct = void 0;
  const i = r(Se), o = r(we);
  e.BurnEditionNftStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "BurnEditionNftInstructionArgs"), e.burnEditionNftInstructionDiscriminator = 37;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.BurnEditionNftStruct.serialize({
      instructionDiscriminator: e.burnEditionNftInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.owner,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.printEditionMint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.masterEditionMint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.printEditionTokenAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.masterEditionTokenAccount,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.masterEditionAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.printEditionAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.editionMarkerAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.splTokenProgram,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createBurnEditionNftInstruction = a;
})(HN);
var GN = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createBurnNftInstruction = e.burnNftInstructionDiscriminator = e.BurnNftStruct = void 0;
  const i = r(Se), o = r(we);
  e.BurnNftStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "BurnNftInstructionArgs"), e.burnNftInstructionDiscriminator = 29;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.BurnNftStruct.serialize({
      instructionDiscriminator: e.burnNftInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.owner,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.mint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.tokenAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.masterEditionAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.splTokenProgram,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return s.collectionMetadata != null && u.push({
      pubkey: s.collectionMetadata,
      isWritable: !0,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createBurnNftInstruction = a;
})(GN);
var YN = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createCloseEscrowAccountInstruction = e.closeEscrowAccountInstructionDiscriminator = e.CloseEscrowAccountStruct = void 0;
  const i = r(Se), o = r(we);
  e.CloseEscrowAccountStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "CloseEscrowAccountInstructionArgs"), e.closeEscrowAccountInstructionDiscriminator = 39;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var l;
    const [u] = e.CloseEscrowAccountStruct.serialize({
      instructionDiscriminator: e.closeEscrowAccountInstructionDiscriminator
    }), f = [
      {
        pubkey: s.escrow,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.tokenAccount,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.edition,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: (l = s.systemProgram) !== null && l !== void 0 ? l : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: f,
      data: u
    });
  }
  e.createCloseEscrowAccountInstruction = a;
})(YN);
var ZN = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createCollectInstruction = e.collectInstructionDiscriminator = e.CollectStruct = void 0;
  const i = r(Se), o = r(we);
  e.CollectStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "CollectInstructionArgs"), e.collectInstructionDiscriminator = 54;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.CollectStruct.serialize({
      instructionDiscriminator: e.collectInstructionDiscriminator
    }), u = [
      {
        pubkey: s.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: s.pdaAccount,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createCollectInstruction = a;
})(ZN);
var JN = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createConvertMasterEditionV1ToV2Instruction = e.convertMasterEditionV1ToV2InstructionDiscriminator = e.ConvertMasterEditionV1ToV2Struct = void 0;
  const i = r(Se), o = r(we);
  e.ConvertMasterEditionV1ToV2Struct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "ConvertMasterEditionV1ToV2InstructionArgs"), e.convertMasterEditionV1ToV2InstructionDiscriminator = 12;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.ConvertMasterEditionV1ToV2Struct.serialize({
      instructionDiscriminator: e.convertMasterEditionV1ToV2InstructionDiscriminator
    }), u = [
      {
        pubkey: s.masterEdition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.oneTimeAuth,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.printingMint,
        isWritable: !0,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createConvertMasterEditionV1ToV2Instruction = a;
})(JN);
var XN = {}, Kc = {}, N0 = {}, Ese = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Ase = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), QN = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Ese(t, e, n);
  return Ase(t, e), t;
};
Object.defineProperty(N0, "__esModule", { value: !0 });
N0.assetDataBeet = void 0;
const Pi = QN(Se), Ise = QN(zn), kse = cu, Tse = Gl, xse = Qa, Mse = es, Ose = Fo;
N0.assetDataBeet = new Pi.FixableBeetArgsStruct([
  ["name", Pi.utf8String],
  ["symbol", Pi.utf8String],
  ["uri", Pi.utf8String],
  ["sellerFeeBasisPoints", Pi.u16],
  ["creators", Pi.coption(Pi.array(kse.creatorBeet))],
  ["primarySaleHappened", Pi.bool],
  ["isMutable", Pi.bool],
  ["tokenStandard", Tse.tokenStandardBeet],
  ["collection", Pi.coption(xse.collectionBeet)],
  ["uses", Pi.coption(Mse.usesBeet)],
  ["collectionDetails", Pi.coption(Ose.collectionDetailsBeet)],
  ["ruleSet", Pi.coption(Ise.publicKey)]
], "AssetData");
var Oo = {}, Pse = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Bse = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Cse = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Pse(t, e, n);
  return Bse(t, e), t;
};
Object.defineProperty(Oo, "__esModule", { value: !0 });
Oo.printSupplyBeet = Oo.isPrintSupplyUnlimited = Oo.isPrintSupplyLimited = Oo.isPrintSupplyZero = void 0;
const Au = Cse(Se), Dse = (e) => e.__kind === "Zero";
Oo.isPrintSupplyZero = Dse;
const Rse = (e) => e.__kind === "Limited";
Oo.isPrintSupplyLimited = Rse;
const Nse = (e) => e.__kind === "Unlimited";
Oo.isPrintSupplyUnlimited = Nse;
Oo.printSupplyBeet = Au.dataEnum([
  ["Zero", Au.unit],
  [
    "Limited",
    new Au.BeetArgsStruct([["fields", Au.fixedSizeTuple([Au.u64])]], 'PrintSupplyRecord["Limited"]')
  ],
  ["Unlimited", Au.unit]
]);
var jse = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Use = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), zse = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && jse(t, e, n);
  return Use(t, e), t;
};
Object.defineProperty(Kc, "__esModule", { value: !0 });
Kc.createArgsBeet = Kc.isCreateArgsV1 = void 0;
const mf = zse(Se), Fse = N0, Lse = Oo, $se = (e) => e.__kind === "V1";
Kc.isCreateArgsV1 = $se;
Kc.createArgsBeet = mf.dataEnum([
  [
    "V1",
    new mf.FixableBeetArgsStruct([
      ["assetData", Fse.assetDataBeet],
      ["decimals", mf.coption(mf.u8)],
      ["printSupply", mf.coption(Lse.printSupplyBeet)]
    ], 'CreateArgsRecord["V1"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createCreateInstruction = e.createInstructionDiscriminator = e.CreateStruct = void 0;
  const i = r(Se), o = r(we), a = Kc;
  e.CreateStruct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["createArgs", a.createArgsBeet]
  ], "CreateInstructionArgs"), e.createInstructionDiscriminator = 42;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d;
    const [h] = e.CreateStruct.serialize({
      instructionDiscriminator: e.createInstructionDiscriminator,
      ...l
    }), g = [
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (f = c.masterEdition) !== null && f !== void 0 ? f : u,
        isWritable: c.masterEdition != null,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: c.updateAuthority,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = c.systemProgram) !== null && d !== void 0 ? d : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.splTokenProgram,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: g,
      data: h
    });
  }
  e.createCreateInstruction = s;
})(XN);
var e5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createCreateEscrowAccountInstruction = e.createEscrowAccountInstructionDiscriminator = e.CreateEscrowAccountStruct = void 0;
  const i = r(Se), o = r(we);
  e.CreateEscrowAccountStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "CreateEscrowAccountInstructionArgs"), e.createEscrowAccountInstructionDiscriminator = 38;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var l;
    const [u] = e.CreateEscrowAccountStruct.serialize({
      instructionDiscriminator: e.createEscrowAccountInstructionDiscriminator
    }), f = [
      {
        pubkey: s.escrow,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.tokenAccount,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.edition,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: (l = s.systemProgram) !== null && l !== void 0 ? l : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return s.authority != null && f.push({
      pubkey: s.authority,
      isWritable: !1,
      isSigner: !0
    }), new o.TransactionInstruction({
      programId: c,
      keys: f,
      data: u
    });
  }
  e.createCreateEscrowAccountInstruction = a;
})(e5);
var t5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createCreateMasterEditionInstruction = e.createMasterEditionInstructionDiscriminator = e.CreateMasterEditionStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we);
  e.CreateMasterEditionStruct = new o.BeetArgsStruct([["instructionDiscriminator", o.u8]], "CreateMasterEditionInstructionArgs"), e.createMasterEditionInstructionDiscriminator = 10;
  function s(c, l = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var u, f, d;
    const [h] = e.CreateMasterEditionStruct.serialize({
      instructionDiscriminator: e.createMasterEditionInstructionDiscriminator
    }), g = [
      {
        pubkey: c.edition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.updateAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.mintAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: c.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (u = c.tokenProgram) !== null && u !== void 0 ? u : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (f = c.systemProgram) !== null && f !== void 0 ? f : a.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = c.rent) !== null && d !== void 0 ? d : a.SYSVAR_RENT_PUBKEY,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new a.TransactionInstruction({
      programId: l,
      keys: g,
      data: h
    });
  }
  e.createCreateMasterEditionInstruction = s;
})(t5);
var n5 = {}, j0 = {}, Wse = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Kse = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Vse = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Wse(t, e, n);
  return Kse(t, e), t;
};
Object.defineProperty(j0, "__esModule", { value: !0 });
j0.createMasterEditionArgsBeet = void 0;
const zS = Vse(Se);
j0.createMasterEditionArgsBeet = new zS.FixableBeetArgsStruct([["maxSupply", zS.coption(zS.u64)]], "CreateMasterEditionArgs");
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createCreateMasterEditionV3Instruction = e.createMasterEditionV3InstructionDiscriminator = e.CreateMasterEditionV3Struct = void 0;
  const i = r(yi), o = r(Se), a = r(we), s = j0;
  e.CreateMasterEditionV3Struct = new o.FixableBeetArgsStruct([
    ["instructionDiscriminator", o.u8],
    ["createMasterEditionArgs", s.createMasterEditionArgsBeet]
  ], "CreateMasterEditionV3InstructionArgs"), e.createMasterEditionV3InstructionDiscriminator = 17;
  function c(l, u, f = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var d, h;
    const [g] = e.CreateMasterEditionV3Struct.serialize({
      instructionDiscriminator: e.createMasterEditionV3InstructionDiscriminator,
      ...u
    }), w = [
      {
        pubkey: l.edition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.mint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.updateAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: l.mintAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: l.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: l.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (d = l.tokenProgram) !== null && d !== void 0 ? d : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = l.systemProgram) !== null && h !== void 0 ? h : a.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return l.rent != null && w.push({
      pubkey: l.rent,
      isWritable: !1,
      isSigner: !1
    }), new a.TransactionInstruction({
      programId: f,
      keys: w,
      data: g
    });
  }
  e.createCreateMasterEditionV3Instruction = c;
})(n5);
var r5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createCreateMetadataAccountInstruction = e.createMetadataAccountInstructionDiscriminator = e.CreateMetadataAccountStruct = void 0;
  const i = r(Se), o = r(we);
  e.CreateMetadataAccountStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "CreateMetadataAccountInstructionArgs"), e.createMetadataAccountInstructionDiscriminator = 0;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var l, u;
    const [f] = e.CreateMetadataAccountStruct.serialize({
      instructionDiscriminator: e.createMetadataAccountInstructionDiscriminator
    }), d = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.mintAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: s.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.updateAuthority,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (l = s.systemProgram) !== null && l !== void 0 ? l : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (u = s.rent) !== null && u !== void 0 ? u : o.SYSVAR_RENT_PUBKEY,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: d,
      data: f
    });
  }
  e.createCreateMetadataAccountInstruction = a;
})(r5);
var i5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createCreateMetadataAccountV2Instruction = e.createMetadataAccountV2InstructionDiscriminator = e.CreateMetadataAccountV2Struct = void 0;
  const i = r(Se), o = r(we);
  e.CreateMetadataAccountV2Struct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "CreateMetadataAccountV2InstructionArgs"), e.createMetadataAccountV2InstructionDiscriminator = 16;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var l;
    const [u] = e.CreateMetadataAccountV2Struct.serialize({
      instructionDiscriminator: e.createMetadataAccountV2InstructionDiscriminator
    }), f = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.mintAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: s.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.updateAuthority,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (l = s.systemProgram) !== null && l !== void 0 ? l : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return s.rent != null && f.push({
      pubkey: s.rent,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: c,
      keys: f,
      data: u
    });
  }
  e.createCreateMetadataAccountV2Instruction = a;
})(i5);
var o5 = {}, U0 = {}, Jl = {}, qse = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Hse = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Gse = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && qse(t, e, n);
  return Hse(t, e), t;
};
Object.defineProperty(Jl, "__esModule", { value: !0 });
Jl.dataV2Beet = void 0;
const ka = Gse(Se), Yse = cu, Zse = Qa, Jse = es;
Jl.dataV2Beet = new ka.FixableBeetArgsStruct([
  ["name", ka.utf8String],
  ["symbol", ka.utf8String],
  ["uri", ka.utf8String],
  ["sellerFeeBasisPoints", ka.u16],
  ["creators", ka.coption(ka.array(Yse.creatorBeet))],
  ["collection", ka.coption(Zse.collectionBeet)],
  ["uses", ka.coption(Jse.usesBeet)]
], "DataV2");
var Xse = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Qse = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), ece = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Xse(t, e, n);
  return Qse(t, e), t;
};
Object.defineProperty(U0, "__esModule", { value: !0 });
U0.createMetadataAccountArgsV3Beet = void 0;
const FS = ece(Se), tce = Jl, nce = Fo;
U0.createMetadataAccountArgsV3Beet = new FS.FixableBeetArgsStruct([
  ["data", tce.dataV2Beet],
  ["isMutable", FS.bool],
  ["collectionDetails", FS.coption(nce.collectionDetailsBeet)]
], "CreateMetadataAccountArgsV3");
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createCreateMetadataAccountV3Instruction = e.createMetadataAccountV3InstructionDiscriminator = e.CreateMetadataAccountV3Struct = void 0;
  const i = r(Se), o = r(we), a = U0;
  e.CreateMetadataAccountV3Struct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["createMetadataAccountArgsV3", a.createMetadataAccountArgsV3Beet]
  ], "CreateMetadataAccountV3InstructionArgs"), e.createMetadataAccountV3InstructionDiscriminator = 33;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f;
    const [d] = e.CreateMetadataAccountV3Struct.serialize({
      instructionDiscriminator: e.createMetadataAccountV3InstructionDiscriminator,
      ...l
    }), h = [
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.mintAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: c.updateAuthority,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (f = c.systemProgram) !== null && f !== void 0 ? f : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return c.rent != null && h.push({
      pubkey: c.rent,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: u,
      keys: h,
      data: d
    });
  }
  e.createCreateMetadataAccountV3Instruction = s;
})(o5);
var a5 = {}, An = {}, Wo = {}, z0 = {}, Fi = {}, F0 = {}, rce = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), ice = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), oce = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && rce(t, e, n);
  return ice(t, e), t;
};
Object.defineProperty(F0, "__esModule", { value: !0 });
F0.seedsVecBeet = void 0;
const LS = oce(Se);
F0.seedsVecBeet = new LS.FixableBeetArgsStruct([["seeds", LS.array(LS.bytes)]], "SeedsVec");
var L0 = {}, ace = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), sce = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), cce = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && ace(t, e, n);
  return sce(t, e), t;
};
Object.defineProperty(L0, "__esModule", { value: !0 });
L0.leafInfoBeet = void 0;
const Iu = cce(Se);
L0.leafInfoBeet = new Iu.FixableBeetArgsStruct([
  ["leaf", Iu.uniformFixedSizeArray(Iu.u8, 32)],
  ["proof", Iu.array(Iu.uniformFixedSizeArray(Iu.u8, 32))]
], "LeafInfo");
var uce = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), lce = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), s5 = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && uce(t, e, n);
  return lce(t, e), t;
};
Object.defineProperty(Fi, "__esModule", { value: !0 });
Fi.payloadTypeBeet = Fi.isPayloadTypeNumber = Fi.isPayloadTypeMerkleProof = Fi.isPayloadTypeSeeds = Fi.isPayloadTypePubkey = void 0;
const Jo = s5(Se), fce = s5(zn), dce = F0, hce = L0, pce = (e) => e.__kind === "Pubkey";
Fi.isPayloadTypePubkey = pce;
const yce = (e) => e.__kind === "Seeds";
Fi.isPayloadTypeSeeds = yce;
const gce = (e) => e.__kind === "MerkleProof";
Fi.isPayloadTypeMerkleProof = gce;
const bce = (e) => e.__kind === "Number";
Fi.isPayloadTypeNumber = bce;
Fi.payloadTypeBeet = Jo.dataEnum([
  [
    "Pubkey",
    new Jo.BeetArgsStruct([["fields", Jo.fixedSizeTuple([fce.publicKey])]], 'PayloadTypeRecord["Pubkey"]')
  ],
  [
    "Seeds",
    new Jo.FixableBeetArgsStruct([["fields", Jo.tuple([dce.seedsVecBeet])]], 'PayloadTypeRecord["Seeds"]')
  ],
  [
    "MerkleProof",
    new Jo.FixableBeetArgsStruct([["fields", Jo.tuple([hce.leafInfoBeet])]], 'PayloadTypeRecord["MerkleProof"]')
  ],
  [
    "Number",
    new Jo.BeetArgsStruct([["fields", Jo.fixedSizeTuple([Jo.u64])]], 'PayloadTypeRecord["Number"]')
  ]
]);
var mce = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), _ce = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), wce = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && mce(t, e, n);
  return _ce(t, e), t;
};
Object.defineProperty(z0, "__esModule", { value: !0 });
z0.payloadBeet = void 0;
const $S = wce(Se), vce = Fi;
z0.payloadBeet = new $S.FixableBeetArgsStruct([["map", $S.map($S.utf8String, vce.payloadTypeBeet)]], "Payload");
var Sce = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Ece = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Ace = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Sce(t, e, n);
  return Ece(t, e), t;
};
Object.defineProperty(Wo, "__esModule", { value: !0 });
Wo.authorizationDataBeet = void 0;
const Ice = Ace(Se), kce = z0;
Wo.authorizationDataBeet = new Ice.FixableBeetArgsStruct([["payload", kce.payloadBeet]], "AuthorizationData");
var Tce = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), xce = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), c5 = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Tce(t, e, n);
  return xce(t, e), t;
};
Object.defineProperty(An, "__esModule", { value: !0 });
An.delegateArgsBeet = An.isDelegateArgsProgrammableConfigItemV1 = An.isDelegateArgsCollectionItemV1 = An.isDelegateArgsDataItemV1 = An.isDelegateArgsAuthorityItemV1 = An.isDelegateArgsProgrammableConfigV1 = An.isDelegateArgsLockedTransferV1 = An.isDelegateArgsStandardV1 = An.isDelegateArgsStakingV1 = An.isDelegateArgsUtilityV1 = An.isDelegateArgsDataV1 = An.isDelegateArgsTransferV1 = An.isDelegateArgsSaleV1 = An.isDelegateArgsCollectionV1 = void 0;
const mn = c5(Se), Mce = c5(zn), Qi = Wo, Oce = (e) => e.__kind === "CollectionV1";
An.isDelegateArgsCollectionV1 = Oce;
const Pce = (e) => e.__kind === "SaleV1";
An.isDelegateArgsSaleV1 = Pce;
const Bce = (e) => e.__kind === "TransferV1";
An.isDelegateArgsTransferV1 = Bce;
const Cce = (e) => e.__kind === "DataV1";
An.isDelegateArgsDataV1 = Cce;
const Dce = (e) => e.__kind === "UtilityV1";
An.isDelegateArgsUtilityV1 = Dce;
const Rce = (e) => e.__kind === "StakingV1";
An.isDelegateArgsStakingV1 = Rce;
const Nce = (e) => e.__kind === "StandardV1";
An.isDelegateArgsStandardV1 = Nce;
const jce = (e) => e.__kind === "LockedTransferV1";
An.isDelegateArgsLockedTransferV1 = jce;
const Uce = (e) => e.__kind === "ProgrammableConfigV1";
An.isDelegateArgsProgrammableConfigV1 = Uce;
const zce = (e) => e.__kind === "AuthorityItemV1";
An.isDelegateArgsAuthorityItemV1 = zce;
const Fce = (e) => e.__kind === "DataItemV1";
An.isDelegateArgsDataItemV1 = Fce;
const Lce = (e) => e.__kind === "CollectionItemV1";
An.isDelegateArgsCollectionItemV1 = Lce;
const $ce = (e) => e.__kind === "ProgrammableConfigItemV1";
An.isDelegateArgsProgrammableConfigItemV1 = $ce;
An.delegateArgsBeet = mn.dataEnum([
  [
    "CollectionV1",
    new mn.FixableBeetArgsStruct([["authorizationData", mn.coption(Qi.authorizationDataBeet)]], 'DelegateArgsRecord["CollectionV1"]')
  ],
  [
    "SaleV1",
    new mn.FixableBeetArgsStruct([
      ["amount", mn.u64],
      ["authorizationData", mn.coption(Qi.authorizationDataBeet)]
    ], 'DelegateArgsRecord["SaleV1"]')
  ],
  [
    "TransferV1",
    new mn.FixableBeetArgsStruct([
      ["amount", mn.u64],
      ["authorizationData", mn.coption(Qi.authorizationDataBeet)]
    ], 'DelegateArgsRecord["TransferV1"]')
  ],
  [
    "DataV1",
    new mn.FixableBeetArgsStruct([["authorizationData", mn.coption(Qi.authorizationDataBeet)]], 'DelegateArgsRecord["DataV1"]')
  ],
  [
    "UtilityV1",
    new mn.FixableBeetArgsStruct([
      ["amount", mn.u64],
      ["authorizationData", mn.coption(Qi.authorizationDataBeet)]
    ], 'DelegateArgsRecord["UtilityV1"]')
  ],
  [
    "StakingV1",
    new mn.FixableBeetArgsStruct([
      ["amount", mn.u64],
      ["authorizationData", mn.coption(Qi.authorizationDataBeet)]
    ], 'DelegateArgsRecord["StakingV1"]')
  ],
  [
    "StandardV1",
    new mn.BeetArgsStruct([["amount", mn.u64]], 'DelegateArgsRecord["StandardV1"]')
  ],
  [
    "LockedTransferV1",
    new mn.FixableBeetArgsStruct([
      ["amount", mn.u64],
      ["lockedAddress", Mce.publicKey],
      ["authorizationData", mn.coption(Qi.authorizationDataBeet)]
    ], 'DelegateArgsRecord["LockedTransferV1"]')
  ],
  [
    "ProgrammableConfigV1",
    new mn.FixableBeetArgsStruct([["authorizationData", mn.coption(Qi.authorizationDataBeet)]], 'DelegateArgsRecord["ProgrammableConfigV1"]')
  ],
  [
    "AuthorityItemV1",
    new mn.FixableBeetArgsStruct([["authorizationData", mn.coption(Qi.authorizationDataBeet)]], 'DelegateArgsRecord["AuthorityItemV1"]')
  ],
  [
    "DataItemV1",
    new mn.FixableBeetArgsStruct([["authorizationData", mn.coption(Qi.authorizationDataBeet)]], 'DelegateArgsRecord["DataItemV1"]')
  ],
  [
    "CollectionItemV1",
    new mn.FixableBeetArgsStruct([["authorizationData", mn.coption(Qi.authorizationDataBeet)]], 'DelegateArgsRecord["CollectionItemV1"]')
  ],
  [
    "ProgrammableConfigItemV1",
    new mn.FixableBeetArgsStruct([["authorizationData", mn.coption(Qi.authorizationDataBeet)]], 'DelegateArgsRecord["ProgrammableConfigItemV1"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createDelegateInstruction = e.delegateInstructionDiscriminator = e.DelegateStruct = void 0;
  const i = r(Se), o = r(we), a = An;
  e.DelegateStruct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["delegateArgs", a.delegateArgsBeet]
  ], "DelegateInstructionArgs"), e.delegateInstructionDiscriminator = 44;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g, w, b, I, A;
    const [x] = e.DelegateStruct.serialize({
      instructionDiscriminator: e.delegateInstructionDiscriminator,
      ...l
    }), N = [
      {
        pubkey: (f = c.delegateRecord) !== null && f !== void 0 ? f : u,
        isWritable: c.delegateRecord != null,
        isSigner: !1
      },
      {
        pubkey: c.delegate,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (d = c.masterEdition) !== null && d !== void 0 ? d : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = c.tokenRecord) !== null && h !== void 0 ? h : u,
        isWritable: c.tokenRecord != null,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (g = c.token) !== null && g !== void 0 ? g : u,
        isWritable: c.token != null,
        isSigner: !1
      },
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: (w = c.systemProgram) !== null && w !== void 0 ? w : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (b = c.splTokenProgram) !== null && b !== void 0 ? b : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (I = c.authorizationRulesProgram) !== null && I !== void 0 ? I : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (A = c.authorizationRules) !== null && A !== void 0 ? A : u,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: N,
      data: x
    });
  }
  e.createDelegateInstruction = s;
})(a5);
var u5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createDeprecatedCreateMasterEditionInstruction = e.deprecatedCreateMasterEditionInstructionDiscriminator = e.DeprecatedCreateMasterEditionStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we);
  e.DeprecatedCreateMasterEditionStruct = new o.BeetArgsStruct([["instructionDiscriminator", o.u8]], "DeprecatedCreateMasterEditionInstructionArgs"), e.deprecatedCreateMasterEditionInstructionDiscriminator = 2;
  function s(c, l = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var u, f, d;
    const [h] = e.DeprecatedCreateMasterEditionStruct.serialize({
      instructionDiscriminator: e.deprecatedCreateMasterEditionInstructionDiscriminator
    }), g = [
      {
        pubkey: c.edition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.printingMint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.oneTimePrintingAuthorizationMint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.updateAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.printingMintAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.mintAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.payer,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: (u = c.tokenProgram) !== null && u !== void 0 ? u : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (f = c.systemProgram) !== null && f !== void 0 ? f : a.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = c.rent) !== null && d !== void 0 ? d : a.SYSVAR_RENT_PUBKEY,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.oneTimePrintingAuthorizationMintAuthority,
        isWritable: !1,
        isSigner: !0
      }
    ];
    return new a.TransactionInstruction({
      programId: l,
      keys: g,
      data: h
    });
  }
  e.createDeprecatedCreateMasterEditionInstruction = s;
})(u5);
var l5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createDeprecatedCreateReservationListInstruction = e.deprecatedCreateReservationListInstructionDiscriminator = e.DeprecatedCreateReservationListStruct = void 0;
  const i = r(Se), o = r(we);
  e.DeprecatedCreateReservationListStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "DeprecatedCreateReservationListInstructionArgs"), e.deprecatedCreateReservationListInstructionDiscriminator = 6;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var l, u;
    const [f] = e.DeprecatedCreateReservationListStruct.serialize({
      instructionDiscriminator: e.deprecatedCreateReservationListInstructionDiscriminator
    }), d = [
      {
        pubkey: s.reservationList,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.payer,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: s.updateAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: s.masterEdition,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.resource,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (l = s.systemProgram) !== null && l !== void 0 ? l : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (u = s.rent) !== null && u !== void 0 ? u : o.SYSVAR_RENT_PUBKEY,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: d,
      data: f
    });
  }
  e.createDeprecatedCreateReservationListInstruction = a;
})(l5);
var f5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createDeprecatedMintNewEditionFromMasterEditionViaPrintingTokenInstruction = e.deprecatedMintNewEditionFromMasterEditionViaPrintingTokenInstructionDiscriminator = e.DeprecatedMintNewEditionFromMasterEditionViaPrintingTokenStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we);
  e.DeprecatedMintNewEditionFromMasterEditionViaPrintingTokenStruct = new o.BeetArgsStruct([["instructionDiscriminator", o.u8]], "DeprecatedMintNewEditionFromMasterEditionViaPrintingTokenInstructionArgs"), e.deprecatedMintNewEditionFromMasterEditionViaPrintingTokenInstructionDiscriminator = 3;
  function s(c, l = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var u, f, d;
    const [h] = e.DeprecatedMintNewEditionFromMasterEditionViaPrintingTokenStruct.serialize({
      instructionDiscriminator: e.deprecatedMintNewEditionFromMasterEditionViaPrintingTokenInstructionDiscriminator
    }), g = [
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.edition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.masterEdition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.mintAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.printingMint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.masterTokenAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.editionMarker,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.burnAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.payer,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.masterUpdateAuthority,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.masterMetadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (u = c.tokenProgram) !== null && u !== void 0 ? u : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (f = c.systemProgram) !== null && f !== void 0 ? f : a.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = c.rent) !== null && d !== void 0 ? d : a.SYSVAR_RENT_PUBKEY,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return c.reservationList != null && g.push({
      pubkey: c.reservationList,
      isWritable: !0,
      isSigner: !1
    }), new a.TransactionInstruction({
      programId: l,
      keys: g,
      data: h
    });
  }
  e.createDeprecatedMintNewEditionFromMasterEditionViaPrintingTokenInstruction = s;
})(f5);
var d5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createDeprecatedMintPrintingTokensInstruction = e.deprecatedMintPrintingTokensInstructionDiscriminator = e.DeprecatedMintPrintingTokensStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we);
  e.DeprecatedMintPrintingTokensStruct = new o.BeetArgsStruct([["instructionDiscriminator", o.u8]], "DeprecatedMintPrintingTokensInstructionArgs"), e.deprecatedMintPrintingTokensInstructionDiscriminator = 9;
  function s(c, l = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var u, f;
    const [d] = e.DeprecatedMintPrintingTokensStruct.serialize({
      instructionDiscriminator: e.deprecatedMintPrintingTokensInstructionDiscriminator
    }), h = [
      {
        pubkey: c.destination,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.printingMint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.updateAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.masterEdition,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (u = c.tokenProgram) !== null && u !== void 0 ? u : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (f = c.rent) !== null && f !== void 0 ? f : a.SYSVAR_RENT_PUBKEY,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new a.TransactionInstruction({
      programId: l,
      keys: h,
      data: d
    });
  }
  e.createDeprecatedMintPrintingTokensInstruction = s;
})(d5);
var h5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createDeprecatedMintPrintingTokensViaTokenInstruction = e.deprecatedMintPrintingTokensViaTokenInstructionDiscriminator = e.DeprecatedMintPrintingTokensViaTokenStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we);
  e.DeprecatedMintPrintingTokensViaTokenStruct = new o.BeetArgsStruct([["instructionDiscriminator", o.u8]], "DeprecatedMintPrintingTokensViaTokenInstructionArgs"), e.deprecatedMintPrintingTokensViaTokenInstructionDiscriminator = 8;
  function s(c, l = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var u, f;
    const [d] = e.DeprecatedMintPrintingTokensViaTokenStruct.serialize({
      instructionDiscriminator: e.deprecatedMintPrintingTokensViaTokenInstructionDiscriminator
    }), h = [
      {
        pubkey: c.destination,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.token,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.oneTimePrintingAuthorizationMint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.printingMint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.burnAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.masterEdition,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (u = c.tokenProgram) !== null && u !== void 0 ? u : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (f = c.rent) !== null && f !== void 0 ? f : a.SYSVAR_RENT_PUBKEY,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new a.TransactionInstruction({
      programId: l,
      keys: h,
      data: d
    });
  }
  e.createDeprecatedMintPrintingTokensViaTokenInstruction = s;
})(h5);
var p5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createDeprecatedSetReservationListInstruction = e.deprecatedSetReservationListInstructionDiscriminator = e.DeprecatedSetReservationListStruct = void 0;
  const i = r(Se), o = r(we);
  e.DeprecatedSetReservationListStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "DeprecatedSetReservationListInstructionArgs"), e.deprecatedSetReservationListInstructionDiscriminator = 5;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.DeprecatedSetReservationListStruct.serialize({
      instructionDiscriminator: e.deprecatedSetReservationListInstructionDiscriminator
    }), u = [
      {
        pubkey: s.masterEdition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.reservationList,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.resource,
        isWritable: !1,
        isSigner: !0
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createDeprecatedSetReservationListInstruction = a;
})(p5);
var y5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createFreezeDelegatedAccountInstruction = e.freezeDelegatedAccountInstructionDiscriminator = e.FreezeDelegatedAccountStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we);
  e.FreezeDelegatedAccountStruct = new o.BeetArgsStruct([["instructionDiscriminator", o.u8]], "FreezeDelegatedAccountInstructionArgs"), e.freezeDelegatedAccountInstructionDiscriminator = 26;
  function s(c, l = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var u;
    const [f] = e.FreezeDelegatedAccountStruct.serialize({
      instructionDiscriminator: e.freezeDelegatedAccountInstructionDiscriminator
    }), d = [
      {
        pubkey: c.delegate,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: c.tokenAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.edition,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (u = c.tokenProgram) !== null && u !== void 0 ? u : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new a.TransactionInstruction({
      programId: l,
      keys: d,
      data: f
    });
  }
  e.createFreezeDelegatedAccountInstruction = s;
})(y5);
var g5 = {}, Vc = {}, Wce = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Kce = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Vce = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Wce(t, e, n);
  return Kce(t, e), t;
};
Object.defineProperty(Vc, "__esModule", { value: !0 });
Vc.lockArgsBeet = Vc.isLockArgsV1 = void 0;
const WS = Vce(Se), qce = Wo, Hce = (e) => e.__kind === "V1";
Vc.isLockArgsV1 = Hce;
Vc.lockArgsBeet = WS.dataEnum([
  [
    "V1",
    new WS.FixableBeetArgsStruct([["authorizationData", WS.coption(qce.authorizationDataBeet)]], 'LockArgsRecord["V1"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createLockInstruction = e.lockInstructionDiscriminator = e.LockStruct = void 0;
  const i = r(Se), o = r(we), a = Vc;
  e.LockStruct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["lockArgs", a.lockArgsBeet]
  ], "LockInstructionArgs"), e.lockInstructionDiscriminator = 46;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g, w, b, I;
    const [A] = e.LockStruct.serialize({
      instructionDiscriminator: e.lockInstructionDiscriminator,
      ...l
    }), x = [
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: (f = c.tokenOwner) !== null && f !== void 0 ? f : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.token,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (d = c.edition) !== null && d !== void 0 ? d : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = c.tokenRecord) !== null && h !== void 0 ? h : u,
        isWritable: c.tokenRecord != null,
        isSigner: !1
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: (g = c.systemProgram) !== null && g !== void 0 ? g : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (w = c.splTokenProgram) !== null && w !== void 0 ? w : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (b = c.authorizationRulesProgram) !== null && b !== void 0 ? b : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (I = c.authorizationRules) !== null && I !== void 0 ? I : u,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: x,
      data: A
    });
  }
  e.createLockInstruction = s;
})(g5);
var b5 = {}, qc = {}, AT = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.migrationTypeBeet = e.MigrationType = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.CollectionV1 = 0] = "CollectionV1", a[a.ProgrammableV1 = 1] = "ProgrammableV1";
  })(o = e.MigrationType || (e.MigrationType = {})), e.migrationTypeBeet = i.fixedScalarEnum(o);
})(AT);
var Gce = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Yce = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), m5 = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Gce(t, e, n);
  return Yce(t, e), t;
};
Object.defineProperty(qc, "__esModule", { value: !0 });
qc.migrateArgsBeet = qc.isMigrateArgsV1 = void 0;
const KS = m5(Se), Zce = m5(zn), Jce = AT, Xce = (e) => e.__kind === "V1";
qc.isMigrateArgsV1 = Xce;
qc.migrateArgsBeet = KS.dataEnum([
  [
    "V1",
    new KS.FixableBeetArgsStruct([
      ["migrationType", Jce.migrationTypeBeet],
      ["ruleSet", KS.coption(Zce.publicKey)]
    ], 'MigrateArgsRecord["V1"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createMigrateInstruction = e.migrateInstructionDiscriminator = e.MigrateStruct = void 0;
  const i = r(Se), o = r(we), a = qc;
  e.MigrateStruct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["migrateArgs", a.migrateArgsBeet]
  ], "MigrateInstructionArgs"), e.migrateInstructionDiscriminator = 48;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h;
    const [g] = e.MigrateStruct.serialize({
      instructionDiscriminator: e.migrateInstructionDiscriminator,
      ...l
    }), w = [
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.edition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.token,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.tokenOwner,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.collectionMetadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.delegateRecord,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.tokenRecord,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (f = c.systemProgram) !== null && f !== void 0 ? f : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.splTokenProgram,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = c.authorizationRulesProgram) !== null && d !== void 0 ? d : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = c.authorizationRules) !== null && h !== void 0 ? h : u,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: w,
      data: g
    });
  }
  e.createMigrateInstruction = s;
})(b5);
var _5 = {}, Hc = {}, Qce = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), eue = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), tue = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Qce(t, e, n);
  return eue(t, e), t;
};
Object.defineProperty(Hc, "__esModule", { value: !0 });
Hc.mintArgsBeet = Hc.isMintArgsV1 = void 0;
const $g = tue(Se), nue = Wo, rue = (e) => e.__kind === "V1";
Hc.isMintArgsV1 = rue;
Hc.mintArgsBeet = $g.dataEnum([
  [
    "V1",
    new $g.FixableBeetArgsStruct([
      ["amount", $g.u64],
      ["authorizationData", $g.coption(nue.authorizationDataBeet)]
    ], 'MintArgsRecord["V1"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createMintInstruction = e.mintInstructionDiscriminator = e.MintStruct = void 0;
  const i = r(Se), o = r(we), a = Hc;
  e.MintStruct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["mintArgs", a.mintArgsBeet]
  ], "MintInstructionArgs"), e.mintInstructionDiscriminator = 43;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g, w, b, I;
    const [A] = e.MintStruct.serialize({
      instructionDiscriminator: e.mintInstructionDiscriminator,
      ...l
    }), x = [
      {
        pubkey: c.token,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (f = c.tokenOwner) !== null && f !== void 0 ? f : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = c.masterEdition) !== null && d !== void 0 ? d : u,
        isWritable: c.masterEdition != null,
        isSigner: !1
      },
      {
        pubkey: (h = c.tokenRecord) !== null && h !== void 0 ? h : u,
        isWritable: c.tokenRecord != null,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: (g = c.delegateRecord) !== null && g !== void 0 ? g : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: (w = c.systemProgram) !== null && w !== void 0 ? w : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.splTokenProgram,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.splAtaProgram,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (b = c.authorizationRulesProgram) !== null && b !== void 0 ? b : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (I = c.authorizationRules) !== null && I !== void 0 ? I : u,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: x,
      data: A
    });
  }
  e.createMintInstruction = s;
})(_5);
var w5 = {}, Xl = {}, iue = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), oue = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), aue = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && iue(t, e, n);
  return oue(t, e), t;
};
Object.defineProperty(Xl, "__esModule", { value: !0 });
Xl.mintNewEditionFromMasterEditionViaTokenArgsBeet = void 0;
const tB = aue(Se);
Xl.mintNewEditionFromMasterEditionViaTokenArgsBeet = new tB.BeetArgsStruct([["edition", tB.u64]], "MintNewEditionFromMasterEditionViaTokenArgs");
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createMintNewEditionFromMasterEditionViaTokenInstruction = e.mintNewEditionFromMasterEditionViaTokenInstructionDiscriminator = e.MintNewEditionFromMasterEditionViaTokenStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we), s = Xl;
  e.MintNewEditionFromMasterEditionViaTokenStruct = new o.BeetArgsStruct([
    ["instructionDiscriminator", o.u8],
    [
      "mintNewEditionFromMasterEditionViaTokenArgs",
      s.mintNewEditionFromMasterEditionViaTokenArgsBeet
    ]
  ], "MintNewEditionFromMasterEditionViaTokenInstructionArgs"), e.mintNewEditionFromMasterEditionViaTokenInstructionDiscriminator = 11;
  function c(l, u, f = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var d, h;
    const [g] = e.MintNewEditionFromMasterEditionViaTokenStruct.serialize({
      instructionDiscriminator: e.mintNewEditionFromMasterEditionViaTokenInstructionDiscriminator,
      ...u
    }), w = [
      {
        pubkey: l.newMetadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.newEdition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.masterEdition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.newMint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.editionMarkPda,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.newMintAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: l.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: l.tokenAccountOwner,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: l.tokenAccount,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.newMetadataUpdateAuthority,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = l.tokenProgram) !== null && d !== void 0 ? d : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = l.systemProgram) !== null && h !== void 0 ? h : a.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return l.rent != null && w.push({
      pubkey: l.rent,
      isWritable: !1,
      isSigner: !1
    }), new a.TransactionInstruction({
      programId: f,
      keys: w,
      data: g
    });
  }
  e.createMintNewEditionFromMasterEditionViaTokenInstruction = c;
})(w5);
var v5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createMintNewEditionFromMasterEditionViaVaultProxyInstruction = e.mintNewEditionFromMasterEditionViaVaultProxyInstructionDiscriminator = e.MintNewEditionFromMasterEditionViaVaultProxyStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we), s = Xl;
  e.MintNewEditionFromMasterEditionViaVaultProxyStruct = new o.BeetArgsStruct([
    ["instructionDiscriminator", o.u8],
    [
      "mintNewEditionFromMasterEditionViaTokenArgs",
      s.mintNewEditionFromMasterEditionViaTokenArgsBeet
    ]
  ], "MintNewEditionFromMasterEditionViaVaultProxyInstructionArgs"), e.mintNewEditionFromMasterEditionViaVaultProxyInstructionDiscriminator = 13;
  function c(l, u, f = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var d, h;
    const [g] = e.MintNewEditionFromMasterEditionViaVaultProxyStruct.serialize({
      instructionDiscriminator: e.mintNewEditionFromMasterEditionViaVaultProxyInstructionDiscriminator,
      ...u
    }), w = [
      {
        pubkey: l.newMetadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.newEdition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.masterEdition,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.newMint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.editionMarkPda,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.newMintAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: l.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: l.vaultAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: l.safetyDepositStore,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.safetyDepositBox,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.vault,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.newMetadataUpdateAuthority,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = l.tokenProgram) !== null && d !== void 0 ? d : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.tokenVaultProgram,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = l.systemProgram) !== null && h !== void 0 ? h : a.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return l.rent != null && w.push({
      pubkey: l.rent,
      isWritable: !1,
      isSigner: !1
    }), new a.TransactionInstruction({
      programId: f,
      keys: w,
      data: g
    });
  }
  e.createMintNewEditionFromMasterEditionViaVaultProxyInstruction = c;
})(v5);
var S5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createPuffMetadataInstruction = e.puffMetadataInstructionDiscriminator = e.PuffMetadataStruct = void 0;
  const i = r(Se), o = r(we);
  e.PuffMetadataStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "PuffMetadataInstructionArgs"), e.puffMetadataInstructionDiscriminator = 14;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.PuffMetadataStruct.serialize({
      instructionDiscriminator: e.puffMetadataInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createPuffMetadataInstruction = a;
})(S5);
var E5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createRemoveCreatorVerificationInstruction = e.removeCreatorVerificationInstructionDiscriminator = e.RemoveCreatorVerificationStruct = void 0;
  const i = r(Se), o = r(we);
  e.RemoveCreatorVerificationStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "RemoveCreatorVerificationInstructionArgs"), e.removeCreatorVerificationInstructionDiscriminator = 28;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.RemoveCreatorVerificationStruct.serialize({
      instructionDiscriminator: e.removeCreatorVerificationInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.creator,
        isWritable: !1,
        isSigner: !0
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createRemoveCreatorVerificationInstruction = a;
})(E5);
var A5 = {}, IT = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.revokeArgsBeet = e.RevokeArgs = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.CollectionV1 = 0] = "CollectionV1", a[a.SaleV1 = 1] = "SaleV1", a[a.TransferV1 = 2] = "TransferV1", a[a.DataV1 = 3] = "DataV1", a[a.UtilityV1 = 4] = "UtilityV1", a[a.StakingV1 = 5] = "StakingV1", a[a.StandardV1 = 6] = "StandardV1", a[a.LockedTransferV1 = 7] = "LockedTransferV1", a[a.ProgrammableConfigV1 = 8] = "ProgrammableConfigV1", a[a.MigrationV1 = 9] = "MigrationV1", a[a.AuthorityItemV1 = 10] = "AuthorityItemV1", a[a.DataItemV1 = 11] = "DataItemV1", a[a.CollectionItemV1 = 12] = "CollectionItemV1", a[a.ProgrammableConfigItemV1 = 13] = "ProgrammableConfigItemV1";
  })(o = e.RevokeArgs || (e.RevokeArgs = {})), e.revokeArgsBeet = i.fixedScalarEnum(o);
})(IT);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createRevokeInstruction = e.revokeInstructionDiscriminator = e.RevokeStruct = void 0;
  const i = r(Se), o = r(we), a = IT;
  e.RevokeStruct = new i.BeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["revokeArgs", a.revokeArgsBeet]
  ], "RevokeInstructionArgs"), e.revokeInstructionDiscriminator = 45;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g, w, b, I, A;
    const [x] = e.RevokeStruct.serialize({
      instructionDiscriminator: e.revokeInstructionDiscriminator,
      ...l
    }), N = [
      {
        pubkey: (f = c.delegateRecord) !== null && f !== void 0 ? f : u,
        isWritable: c.delegateRecord != null,
        isSigner: !1
      },
      {
        pubkey: c.delegate,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (d = c.masterEdition) !== null && d !== void 0 ? d : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = c.tokenRecord) !== null && h !== void 0 ? h : u,
        isWritable: c.tokenRecord != null,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (g = c.token) !== null && g !== void 0 ? g : u,
        isWritable: c.token != null,
        isSigner: !1
      },
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: (w = c.systemProgram) !== null && w !== void 0 ? w : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (b = c.splTokenProgram) !== null && b !== void 0 ? b : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (I = c.authorizationRulesProgram) !== null && I !== void 0 ? I : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (A = c.authorizationRules) !== null && A !== void 0 ? A : u,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: N,
      data: x
    });
  }
  e.createRevokeInstruction = s;
})(A5);
var I5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createRevokeCollectionAuthorityInstruction = e.revokeCollectionAuthorityInstructionDiscriminator = e.RevokeCollectionAuthorityStruct = void 0;
  const i = r(Se), o = r(we);
  e.RevokeCollectionAuthorityStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "RevokeCollectionAuthorityInstructionArgs"), e.revokeCollectionAuthorityInstructionDiscriminator = 24;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.RevokeCollectionAuthorityStruct.serialize({
      instructionDiscriminator: e.revokeCollectionAuthorityInstructionDiscriminator
    }), u = [
      {
        pubkey: s.collectionAuthorityRecord,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.delegateAuthority,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.revokeAuthority,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.mint,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createRevokeCollectionAuthorityInstruction = a;
})(I5);
var k5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createRevokeUseAuthorityInstruction = e.revokeUseAuthorityInstructionDiscriminator = e.RevokeUseAuthorityStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we);
  e.RevokeUseAuthorityStruct = new o.BeetArgsStruct([["instructionDiscriminator", o.u8]], "RevokeUseAuthorityInstructionArgs"), e.revokeUseAuthorityInstructionDiscriminator = 21;
  function s(c, l = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var u, f;
    const [d] = e.RevokeUseAuthorityStruct.serialize({
      instructionDiscriminator: e.revokeUseAuthorityInstructionDiscriminator
    }), h = [
      {
        pubkey: c.useAuthorityRecord,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.owner,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: c.user,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.ownerTokenAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (u = c.tokenProgram) !== null && u !== void 0 ? u : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (f = c.systemProgram) !== null && f !== void 0 ? f : a.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return c.rent != null && h.push({
      pubkey: c.rent,
      isWritable: !1,
      isSigner: !1
    }), new a.TransactionInstruction({
      programId: l,
      keys: h,
      data: d
    });
  }
  e.createRevokeUseAuthorityInstruction = s;
})(k5);
var T5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createSetAndVerifyCollectionInstruction = e.setAndVerifyCollectionInstructionDiscriminator = e.SetAndVerifyCollectionStruct = void 0;
  const i = r(Se), o = r(we);
  e.SetAndVerifyCollectionStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "SetAndVerifyCollectionInstructionArgs"), e.setAndVerifyCollectionInstructionDiscriminator = 25;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.SetAndVerifyCollectionStruct.serialize({
      instructionDiscriminator: e.setAndVerifyCollectionInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.collectionAuthority,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.updateAuthority,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collectionMint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collection,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collectionMasterEditionAccount,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return s.collectionAuthorityRecord != null && u.push({
      pubkey: s.collectionAuthorityRecord,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createSetAndVerifyCollectionInstruction = a;
})(T5);
var x5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createSetAndVerifySizedCollectionItemInstruction = e.setAndVerifySizedCollectionItemInstructionDiscriminator = e.SetAndVerifySizedCollectionItemStruct = void 0;
  const i = r(Se), o = r(we);
  e.SetAndVerifySizedCollectionItemStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "SetAndVerifySizedCollectionItemInstructionArgs"), e.setAndVerifySizedCollectionItemInstructionDiscriminator = 32;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.SetAndVerifySizedCollectionItemStruct.serialize({
      instructionDiscriminator: e.setAndVerifySizedCollectionItemInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.collectionAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: s.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.updateAuthority,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collectionMint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collection,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.collectionMasterEditionAccount,
        isWritable: !0,
        isSigner: !1
      }
    ];
    return s.collectionAuthorityRecord != null && u.push({
      pubkey: s.collectionAuthorityRecord,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createSetAndVerifySizedCollectionItemInstruction = a;
})(x5);
var M5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createSetCollectionSizeInstruction = e.setCollectionSizeInstructionDiscriminator = e.SetCollectionSizeStruct = void 0;
  const i = r(Se), o = r(we), a = Zl;
  e.SetCollectionSizeStruct = new i.BeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["setCollectionSizeArgs", a.setCollectionSizeArgsBeet]
  ], "SetCollectionSizeInstructionArgs"), e.setCollectionSizeInstructionDiscriminator = 34;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [f] = e.SetCollectionSizeStruct.serialize({
      instructionDiscriminator: e.setCollectionSizeInstructionDiscriminator,
      ...l
    }), d = [
      {
        pubkey: c.collectionMetadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.collectionAuthority,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: c.collectionMint,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return c.collectionAuthorityRecord != null && d.push({
      pubkey: c.collectionAuthorityRecord,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: u,
      keys: d,
      data: f
    });
  }
  e.createSetCollectionSizeInstruction = s;
})(M5);
var O5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createSetTokenStandardInstruction = e.setTokenStandardInstructionDiscriminator = e.SetTokenStandardStruct = void 0;
  const i = r(Se), o = r(we);
  e.SetTokenStandardStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "SetTokenStandardInstructionArgs"), e.setTokenStandardInstructionDiscriminator = 35;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.SetTokenStandardStruct.serialize({
      instructionDiscriminator: e.setTokenStandardInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.updateAuthority,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.mint,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return s.edition != null && u.push({
      pubkey: s.edition,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createSetTokenStandardInstruction = a;
})(O5);
var P5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createSignMetadataInstruction = e.signMetadataInstructionDiscriminator = e.SignMetadataStruct = void 0;
  const i = r(Se), o = r(we);
  e.SignMetadataStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "SignMetadataInstructionArgs"), e.signMetadataInstructionDiscriminator = 7;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.SignMetadataStruct.serialize({
      instructionDiscriminator: e.signMetadataInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.creator,
        isWritable: !1,
        isSigner: !0
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createSignMetadataInstruction = a;
})(P5);
var B5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createThawDelegatedAccountInstruction = e.thawDelegatedAccountInstructionDiscriminator = e.ThawDelegatedAccountStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we);
  e.ThawDelegatedAccountStruct = new o.BeetArgsStruct([["instructionDiscriminator", o.u8]], "ThawDelegatedAccountInstructionArgs"), e.thawDelegatedAccountInstructionDiscriminator = 27;
  function s(c, l = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var u;
    const [f] = e.ThawDelegatedAccountStruct.serialize({
      instructionDiscriminator: e.thawDelegatedAccountInstructionDiscriminator
    }), d = [
      {
        pubkey: c.delegate,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: c.tokenAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.edition,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (u = c.tokenProgram) !== null && u !== void 0 ? u : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new a.TransactionInstruction({
      programId: l,
      keys: d,
      data: f
    });
  }
  e.createThawDelegatedAccountInstruction = s;
})(B5);
var C5 = {}, Gc = {}, sue = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), cue = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), uue = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && sue(t, e, n);
  return cue(t, e), t;
};
Object.defineProperty(Gc, "__esModule", { value: !0 });
Gc.transferArgsBeet = Gc.isTransferArgsV1 = void 0;
const Wg = uue(Se), lue = Wo, fue = (e) => e.__kind === "V1";
Gc.isTransferArgsV1 = fue;
Gc.transferArgsBeet = Wg.dataEnum([
  [
    "V1",
    new Wg.FixableBeetArgsStruct([
      ["amount", Wg.u64],
      ["authorizationData", Wg.coption(lue.authorizationDataBeet)]
    ], 'TransferArgsRecord["V1"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createTransferInstruction = e.transferInstructionDiscriminator = e.TransferStruct = void 0;
  const i = r(Se), o = r(we), a = Gc;
  e.TransferStruct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["transferArgs", a.transferArgsBeet]
  ], "TransferInstructionArgs"), e.transferInstructionDiscriminator = 49;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g, w, b;
    const [I] = e.TransferStruct.serialize({
      instructionDiscriminator: e.transferInstructionDiscriminator,
      ...l
    }), A = [
      {
        pubkey: c.token,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.tokenOwner,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.destination,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.destinationOwner,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (f = c.edition) !== null && f !== void 0 ? f : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = c.ownerTokenRecord) !== null && d !== void 0 ? d : u,
        isWritable: c.ownerTokenRecord != null,
        isSigner: !1
      },
      {
        pubkey: (h = c.destinationTokenRecord) !== null && h !== void 0 ? h : u,
        isWritable: c.destinationTokenRecord != null,
        isSigner: !1
      },
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: (g = c.systemProgram) !== null && g !== void 0 ? g : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.splTokenProgram,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.splAtaProgram,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (w = c.authorizationRulesProgram) !== null && w !== void 0 ? w : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (b = c.authorizationRules) !== null && b !== void 0 ? b : u,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: A,
      data: I
    });
  }
  e.createTransferInstruction = s;
})(C5);
var D5 = {}, $0 = {}, due = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), hue = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), pue = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && due(t, e, n);
  return hue(t, e), t;
};
Object.defineProperty($0, "__esModule", { value: !0 });
$0.transferOutOfEscrowArgsBeet = void 0;
const nB = pue(Se);
$0.transferOutOfEscrowArgsBeet = new nB.BeetArgsStruct([["amount", nB.u64]], "TransferOutOfEscrowArgs");
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createTransferOutOfEscrowInstruction = e.transferOutOfEscrowInstructionDiscriminator = e.TransferOutOfEscrowStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we), s = $0;
  e.TransferOutOfEscrowStruct = new o.BeetArgsStruct([
    ["instructionDiscriminator", o.u8],
    ["transferOutOfEscrowArgs", s.transferOutOfEscrowArgsBeet]
  ], "TransferOutOfEscrowInstructionArgs"), e.transferOutOfEscrowInstructionDiscriminator = 40;
  function c(l, u, f = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var d, h, g;
    const [w] = e.TransferOutOfEscrowStruct.serialize({
      instructionDiscriminator: e.transferOutOfEscrowInstructionDiscriminator,
      ...u
    }), b = [
      {
        pubkey: l.escrow,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: l.attributeMint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.attributeSrc,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.attributeDst,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.escrowMint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.escrowAccount,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = l.systemProgram) !== null && d !== void 0 ? d : a.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = l.ataProgram) !== null && h !== void 0 ? h : i.ASSOCIATED_TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (g = l.tokenProgram) !== null && g !== void 0 ? g : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: l.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return l.authority != null && b.push({
      pubkey: l.authority,
      isWritable: !1,
      isSigner: !0
    }), new a.TransactionInstruction({
      programId: f,
      keys: b,
      data: w
    });
  }
  e.createTransferOutOfEscrowInstruction = c;
})(D5);
var R5 = {}, Yc = {}, yue = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), gue = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), bue = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && yue(t, e, n);
  return gue(t, e), t;
};
Object.defineProperty(Yc, "__esModule", { value: !0 });
Yc.unlockArgsBeet = Yc.isUnlockArgsV1 = void 0;
const VS = bue(Se), mue = Wo, _ue = (e) => e.__kind === "V1";
Yc.isUnlockArgsV1 = _ue;
Yc.unlockArgsBeet = VS.dataEnum([
  [
    "V1",
    new VS.FixableBeetArgsStruct([["authorizationData", VS.coption(mue.authorizationDataBeet)]], 'UnlockArgsRecord["V1"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUnlockInstruction = e.unlockInstructionDiscriminator = e.UnlockStruct = void 0;
  const i = r(Se), o = r(we), a = Yc;
  e.UnlockStruct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["unlockArgs", a.unlockArgsBeet]
  ], "UnlockInstructionArgs"), e.unlockInstructionDiscriminator = 47;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g, w, b, I;
    const [A] = e.UnlockStruct.serialize({
      instructionDiscriminator: e.unlockInstructionDiscriminator,
      ...l
    }), x = [
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: (f = c.tokenOwner) !== null && f !== void 0 ? f : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.token,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (d = c.edition) !== null && d !== void 0 ? d : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = c.tokenRecord) !== null && h !== void 0 ? h : u,
        isWritable: c.tokenRecord != null,
        isSigner: !1
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: (g = c.systemProgram) !== null && g !== void 0 ? g : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (w = c.splTokenProgram) !== null && w !== void 0 ? w : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (b = c.authorizationRulesProgram) !== null && b !== void 0 ? b : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (I = c.authorizationRules) !== null && I !== void 0 ? I : u,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: x,
      data: A
    });
  }
  e.createUnlockInstruction = s;
})(R5);
var N5 = {}, Iw = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.verificationArgsBeet = e.VerificationArgs = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.CreatorV1 = 0] = "CreatorV1", a[a.CollectionV1 = 1] = "CollectionV1";
  })(o = e.VerificationArgs || (e.VerificationArgs = {})), e.verificationArgsBeet = i.fixedScalarEnum(o);
})(Iw);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUnverifyInstruction = e.unverifyInstructionDiscriminator = e.UnverifyStruct = void 0;
  const i = r(Se), o = r(we), a = Iw;
  e.UnverifyStruct = new i.BeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["verificationArgs", a.verificationArgsBeet]
  ], "UnverifyInstructionArgs"), e.unverifyInstructionDiscriminator = 53;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g;
    const [w] = e.UnverifyStruct.serialize({
      instructionDiscriminator: e.unverifyInstructionDiscriminator,
      ...l
    }), b = [
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: (f = c.delegateRecord) !== null && f !== void 0 ? f : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (d = c.collectionMint) !== null && d !== void 0 ? d : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = c.collectionMetadata) !== null && h !== void 0 ? h : u,
        isWritable: c.collectionMetadata != null,
        isSigner: !1
      },
      {
        pubkey: (g = c.systemProgram) !== null && g !== void 0 ? g : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: b,
      data: w
    });
  }
  e.createUnverifyInstruction = s;
})(N5);
var j5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUnverifyCollectionInstruction = e.unverifyCollectionInstructionDiscriminator = e.UnverifyCollectionStruct = void 0;
  const i = r(Se), o = r(we);
  e.UnverifyCollectionStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "UnverifyCollectionInstructionArgs"), e.unverifyCollectionInstructionDiscriminator = 22;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.UnverifyCollectionStruct.serialize({
      instructionDiscriminator: e.unverifyCollectionInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.collectionAuthority,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.collectionMint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collection,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collectionMasterEditionAccount,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return s.collectionAuthorityRecord != null && u.push({
      pubkey: s.collectionAuthorityRecord,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createUnverifyCollectionInstruction = a;
})(j5);
var U5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUnverifySizedCollectionItemInstruction = e.unverifySizedCollectionItemInstructionDiscriminator = e.UnverifySizedCollectionItemStruct = void 0;
  const i = r(Se), o = r(we);
  e.UnverifySizedCollectionItemStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "UnverifySizedCollectionItemInstructionArgs"), e.unverifySizedCollectionItemInstructionDiscriminator = 31;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.UnverifySizedCollectionItemStruct.serialize({
      instructionDiscriminator: e.unverifySizedCollectionItemInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.collectionAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: s.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.collectionMint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collection,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.collectionMasterEditionAccount,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return s.collectionAuthorityRecord != null && u.push({
      pubkey: s.collectionAuthorityRecord,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createUnverifySizedCollectionItemInstruction = a;
})(U5);
var z5 = {}, lr = {}, Po = {}, wue = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), vue = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Sue = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && wue(t, e, n);
  return vue(t, e), t;
};
Object.defineProperty(Po, "__esModule", { value: !0 });
Po.collectionToggleBeet = Po.isCollectionToggleSet = Po.isCollectionToggleClear = Po.isCollectionToggleNone = void 0;
const _f = Sue(Se), Eue = Qa, Aue = (e) => e.__kind === "None";
Po.isCollectionToggleNone = Aue;
const Iue = (e) => e.__kind === "Clear";
Po.isCollectionToggleClear = Iue;
const kue = (e) => e.__kind === "Set";
Po.isCollectionToggleSet = kue;
Po.collectionToggleBeet = _f.dataEnum([
  ["None", _f.unit],
  ["Clear", _f.unit],
  [
    "Set",
    new _f.BeetArgsStruct([["fields", _f.fixedSizeTuple([Eue.collectionBeet])]], 'CollectionToggleRecord["Set"]')
  ]
]);
var Bo = {}, Tue = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), xue = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Mue = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Tue(t, e, n);
  return xue(t, e), t;
};
Object.defineProperty(Bo, "__esModule", { value: !0 });
Bo.collectionDetailsToggleBeet = Bo.isCollectionDetailsToggleSet = Bo.isCollectionDetailsToggleClear = Bo.isCollectionDetailsToggleNone = void 0;
const wf = Mue(Se), Oue = Fo, Pue = (e) => e.__kind === "None";
Bo.isCollectionDetailsToggleNone = Pue;
const Bue = (e) => e.__kind === "Clear";
Bo.isCollectionDetailsToggleClear = Bue;
const Cue = (e) => e.__kind === "Set";
Bo.isCollectionDetailsToggleSet = Cue;
Bo.collectionDetailsToggleBeet = wf.dataEnum([
  ["None", wf.unit],
  ["Clear", wf.unit],
  [
    "Set",
    new wf.FixableBeetArgsStruct([["fields", wf.tuple([Oue.collectionDetailsBeet])]], 'CollectionDetailsToggleRecord["Set"]')
  ]
]);
var Co = {}, Due = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Rue = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), Nue = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Due(t, e, n);
  return Rue(t, e), t;
};
Object.defineProperty(Co, "__esModule", { value: !0 });
Co.usesToggleBeet = Co.isUsesToggleSet = Co.isUsesToggleClear = Co.isUsesToggleNone = void 0;
const vf = Nue(Se), jue = es, Uue = (e) => e.__kind === "None";
Co.isUsesToggleNone = Uue;
const zue = (e) => e.__kind === "Clear";
Co.isUsesToggleClear = zue;
const Fue = (e) => e.__kind === "Set";
Co.isUsesToggleSet = Fue;
Co.usesToggleBeet = vf.dataEnum([
  ["None", vf.unit],
  ["Clear", vf.unit],
  [
    "Set",
    new vf.BeetArgsStruct([["fields", vf.fixedSizeTuple([jue.usesBeet])]], 'UsesToggleRecord["Set"]')
  ]
]);
var Do = {}, Lue = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), $ue = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), F5 = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Lue(t, e, n);
  return $ue(t, e), t;
};
Object.defineProperty(Do, "__esModule", { value: !0 });
Do.ruleSetToggleBeet = Do.isRuleSetToggleSet = Do.isRuleSetToggleClear = Do.isRuleSetToggleNone = void 0;
const Sf = F5(Se), Wue = F5(zn), Kue = (e) => e.__kind === "None";
Do.isRuleSetToggleNone = Kue;
const Vue = (e) => e.__kind === "Clear";
Do.isRuleSetToggleClear = Vue;
const que = (e) => e.__kind === "Set";
Do.isRuleSetToggleSet = que;
Do.ruleSetToggleBeet = Sf.dataEnum([
  ["None", Sf.unit],
  ["Clear", Sf.unit],
  [
    "Set",
    new Sf.BeetArgsStruct([["fields", Sf.fixedSizeTuple([Wue.publicKey])]], 'RuleSetToggleRecord["Set"]')
  ]
]);
var Hue = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), Gue = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), L5 = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && Hue(t, e, n);
  return Gue(t, e), t;
};
Object.defineProperty(lr, "__esModule", { value: !0 });
lr.updateArgsBeet = lr.isUpdateArgsAsProgrammableConfigItemDelegateV2 = lr.isUpdateArgsAsCollectionItemDelegateV2 = lr.isUpdateArgsAsDataItemDelegateV2 = lr.isUpdateArgsAsProgrammableConfigDelegateV2 = lr.isUpdateArgsAsDataDelegateV2 = lr.isUpdateArgsAsCollectionDelegateV2 = lr.isUpdateArgsAsAuthorityItemDelegateV2 = lr.isUpdateArgsAsUpdateAuthorityV2 = lr.isUpdateArgsV1 = void 0;
const Wt = L5(Se), qS = L5(zn), Kg = su, Vg = Po, rB = Bo, iB = Co, qg = Do, Ta = Wo, oB = Gl, Yue = (e) => e.__kind === "V1";
lr.isUpdateArgsV1 = Yue;
const Zue = (e) => e.__kind === "AsUpdateAuthorityV2";
lr.isUpdateArgsAsUpdateAuthorityV2 = Zue;
const Jue = (e) => e.__kind === "AsAuthorityItemDelegateV2";
lr.isUpdateArgsAsAuthorityItemDelegateV2 = Jue;
const Xue = (e) => e.__kind === "AsCollectionDelegateV2";
lr.isUpdateArgsAsCollectionDelegateV2 = Xue;
const Que = (e) => e.__kind === "AsDataDelegateV2";
lr.isUpdateArgsAsDataDelegateV2 = Que;
const ele = (e) => e.__kind === "AsProgrammableConfigDelegateV2";
lr.isUpdateArgsAsProgrammableConfigDelegateV2 = ele;
const tle = (e) => e.__kind === "AsDataItemDelegateV2";
lr.isUpdateArgsAsDataItemDelegateV2 = tle;
const nle = (e) => e.__kind === "AsCollectionItemDelegateV2";
lr.isUpdateArgsAsCollectionItemDelegateV2 = nle;
const rle = (e) => e.__kind === "AsProgrammableConfigItemDelegateV2";
lr.isUpdateArgsAsProgrammableConfigItemDelegateV2 = rle;
lr.updateArgsBeet = Wt.dataEnum([
  [
    "V1",
    new Wt.FixableBeetArgsStruct([
      ["newUpdateAuthority", Wt.coption(qS.publicKey)],
      ["data", Wt.coption(Kg.dataBeet)],
      ["primarySaleHappened", Wt.coption(Wt.bool)],
      ["isMutable", Wt.coption(Wt.bool)],
      ["collection", Vg.collectionToggleBeet],
      ["collectionDetails", rB.collectionDetailsToggleBeet],
      ["uses", iB.usesToggleBeet],
      ["ruleSet", qg.ruleSetToggleBeet],
      ["authorizationData", Wt.coption(Ta.authorizationDataBeet)]
    ], 'UpdateArgsRecord["V1"]')
  ],
  [
    "AsUpdateAuthorityV2",
    new Wt.FixableBeetArgsStruct([
      ["newUpdateAuthority", Wt.coption(qS.publicKey)],
      ["data", Wt.coption(Kg.dataBeet)],
      ["primarySaleHappened", Wt.coption(Wt.bool)],
      ["isMutable", Wt.coption(Wt.bool)],
      ["collection", Vg.collectionToggleBeet],
      ["collectionDetails", rB.collectionDetailsToggleBeet],
      ["uses", iB.usesToggleBeet],
      ["ruleSet", qg.ruleSetToggleBeet],
      ["tokenStandard", Wt.coption(oB.tokenStandardBeet)],
      ["authorizationData", Wt.coption(Ta.authorizationDataBeet)]
    ], 'UpdateArgsRecord["AsUpdateAuthorityV2"]')
  ],
  [
    "AsAuthorityItemDelegateV2",
    new Wt.FixableBeetArgsStruct([
      ["newUpdateAuthority", Wt.coption(qS.publicKey)],
      ["primarySaleHappened", Wt.coption(Wt.bool)],
      ["isMutable", Wt.coption(Wt.bool)],
      ["tokenStandard", Wt.coption(oB.tokenStandardBeet)],
      ["authorizationData", Wt.coption(Ta.authorizationDataBeet)]
    ], 'UpdateArgsRecord["AsAuthorityItemDelegateV2"]')
  ],
  [
    "AsCollectionDelegateV2",
    new Wt.FixableBeetArgsStruct([
      ["collection", Vg.collectionToggleBeet],
      ["authorizationData", Wt.coption(Ta.authorizationDataBeet)]
    ], 'UpdateArgsRecord["AsCollectionDelegateV2"]')
  ],
  [
    "AsDataDelegateV2",
    new Wt.FixableBeetArgsStruct([
      ["data", Wt.coption(Kg.dataBeet)],
      ["authorizationData", Wt.coption(Ta.authorizationDataBeet)]
    ], 'UpdateArgsRecord["AsDataDelegateV2"]')
  ],
  [
    "AsProgrammableConfigDelegateV2",
    new Wt.FixableBeetArgsStruct([
      ["ruleSet", qg.ruleSetToggleBeet],
      ["authorizationData", Wt.coption(Ta.authorizationDataBeet)]
    ], 'UpdateArgsRecord["AsProgrammableConfigDelegateV2"]')
  ],
  [
    "AsDataItemDelegateV2",
    new Wt.FixableBeetArgsStruct([
      ["data", Wt.coption(Kg.dataBeet)],
      ["authorizationData", Wt.coption(Ta.authorizationDataBeet)]
    ], 'UpdateArgsRecord["AsDataItemDelegateV2"]')
  ],
  [
    "AsCollectionItemDelegateV2",
    new Wt.FixableBeetArgsStruct([
      ["collection", Vg.collectionToggleBeet],
      ["authorizationData", Wt.coption(Ta.authorizationDataBeet)]
    ], 'UpdateArgsRecord["AsCollectionItemDelegateV2"]')
  ],
  [
    "AsProgrammableConfigItemDelegateV2",
    new Wt.FixableBeetArgsStruct([
      ["ruleSet", qg.ruleSetToggleBeet],
      ["authorizationData", Wt.coption(Ta.authorizationDataBeet)]
    ], 'UpdateArgsRecord["AsProgrammableConfigItemDelegateV2"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUpdateInstruction = e.updateInstructionDiscriminator = e.UpdateStruct = void 0;
  const i = r(Se), o = r(we), a = lr;
  e.UpdateStruct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["updateArgs", a.updateArgsBeet]
  ], "UpdateInstructionArgs"), e.updateInstructionDiscriminator = 50;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g, w, b;
    const [I] = e.UpdateStruct.serialize({
      instructionDiscriminator: e.updateInstructionDiscriminator,
      ...l
    }), A = [
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: (f = c.delegateRecord) !== null && f !== void 0 ? f : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = c.token) !== null && d !== void 0 ? d : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (h = c.edition) !== null && h !== void 0 ? h : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: (g = c.systemProgram) !== null && g !== void 0 ? g : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (w = c.authorizationRulesProgram) !== null && w !== void 0 ? w : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (b = c.authorizationRules) !== null && b !== void 0 ? b : u,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: A,
      data: I
    });
  }
  e.createUpdateInstruction = s;
})(z5);
var $5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUpdateMetadataAccountInstruction = e.updateMetadataAccountInstructionDiscriminator = e.UpdateMetadataAccountStruct = void 0;
  const i = r(Se), o = r(we);
  e.UpdateMetadataAccountStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "UpdateMetadataAccountInstructionArgs"), e.updateMetadataAccountInstructionDiscriminator = 1;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.UpdateMetadataAccountStruct.serialize({
      instructionDiscriminator: e.updateMetadataAccountInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.updateAuthority,
        isWritable: !1,
        isSigner: !0
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createUpdateMetadataAccountInstruction = a;
})($5);
var W5 = {}, W0 = {}, ile = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), ole = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), K5 = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && ile(t, e, n);
  return ole(t, e), t;
};
Object.defineProperty(W0, "__esModule", { value: !0 });
W0.updateMetadataAccountArgsV2Beet = void 0;
const lc = K5(Se), ale = K5(zn), sle = Jl;
W0.updateMetadataAccountArgsV2Beet = new lc.FixableBeetArgsStruct([
  ["data", lc.coption(sle.dataV2Beet)],
  ["updateAuthority", lc.coption(ale.publicKey)],
  ["primarySaleHappened", lc.coption(lc.bool)],
  ["isMutable", lc.coption(lc.bool)]
], "UpdateMetadataAccountArgsV2");
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUpdateMetadataAccountV2Instruction = e.updateMetadataAccountV2InstructionDiscriminator = e.UpdateMetadataAccountV2Struct = void 0;
  const i = r(Se), o = r(we), a = W0;
  e.UpdateMetadataAccountV2Struct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["updateMetadataAccountArgsV2", a.updateMetadataAccountArgsV2Beet]
  ], "UpdateMetadataAccountV2InstructionArgs"), e.updateMetadataAccountV2InstructionDiscriminator = 15;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [f] = e.UpdateMetadataAccountV2Struct.serialize({
      instructionDiscriminator: e.updateMetadataAccountV2InstructionDiscriminator,
      ...l
    }), d = [
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: c.updateAuthority,
        isWritable: !1,
        isSigner: !0
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: d,
      data: f
    });
  }
  e.createUpdateMetadataAccountV2Instruction = s;
})(W5);
var V5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUpdatePrimarySaleHappenedViaTokenInstruction = e.updatePrimarySaleHappenedViaTokenInstructionDiscriminator = e.UpdatePrimarySaleHappenedViaTokenStruct = void 0;
  const i = r(Se), o = r(we);
  e.UpdatePrimarySaleHappenedViaTokenStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "UpdatePrimarySaleHappenedViaTokenInstructionArgs"), e.updatePrimarySaleHappenedViaTokenInstructionDiscriminator = 4;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.UpdatePrimarySaleHappenedViaTokenStruct.serialize({
      instructionDiscriminator: e.updatePrimarySaleHappenedViaTokenInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.owner,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: s.token,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createUpdatePrimarySaleHappenedViaTokenInstruction = a;
})(V5);
var q5 = {}, Zc = {}, cle = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), ule = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), lle = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && cle(t, e, n);
  return ule(t, e), t;
};
Object.defineProperty(Zc, "__esModule", { value: !0 });
Zc.useArgsBeet = Zc.isUseArgsV1 = void 0;
const HS = lle(Se), fle = Wo, dle = (e) => e.__kind === "V1";
Zc.isUseArgsV1 = dle;
Zc.useArgsBeet = HS.dataEnum([
  [
    "V1",
    new HS.FixableBeetArgsStruct([["authorizationData", HS.coption(fle.authorizationDataBeet)]], 'UseArgsRecord["V1"]')
  ]
]);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUseInstruction = e.useInstructionDiscriminator = e.UseStruct = void 0;
  const i = r(Se), o = r(we), a = Zc;
  e.UseStruct = new i.FixableBeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["useArgs", a.useArgsBeet]
  ], "UseInstructionArgs"), e.useInstructionDiscriminator = 51;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g, w, b, I;
    const [A] = e.UseStruct.serialize({
      instructionDiscriminator: e.useInstructionDiscriminator,
      ...l
    }), x = [
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: (f = c.delegateRecord) !== null && f !== void 0 ? f : u,
        isWritable: c.delegateRecord != null,
        isSigner: !1
      },
      {
        pubkey: (d = c.token) !== null && d !== void 0 ? d : u,
        isWritable: c.token != null,
        isSigner: !1
      },
      {
        pubkey: c.mint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (h = c.edition) !== null && h !== void 0 ? h : u,
        isWritable: c.edition != null,
        isSigner: !1
      },
      {
        pubkey: c.payer,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: (g = c.systemProgram) !== null && g !== void 0 ? g : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (w = c.splTokenProgram) !== null && w !== void 0 ? w : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (b = c.authorizationRulesProgram) !== null && b !== void 0 ? b : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (I = c.authorizationRules) !== null && I !== void 0 ? I : u,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: x,
      data: A
    });
  }
  e.createUseInstruction = s;
})(q5);
var H5 = {}, K0 = {}, hle = _ && _.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var i = Object.getOwnPropertyDescriptor(t, n);
  (!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, i);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), ple = _ && _.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), yle = _ && _.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && hle(t, e, n);
  return ple(t, e), t;
};
Object.defineProperty(K0, "__esModule", { value: !0 });
K0.utilizeArgsBeet = void 0;
const aB = yle(Se);
K0.utilizeArgsBeet = new aB.BeetArgsStruct([["numberOfUses", aB.u64]], "UtilizeArgs");
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(l, u, f, d) {
    d === void 0 && (d = f);
    var h = Object.getOwnPropertyDescriptor(u, f);
    (!h || ("get" in h ? !u.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return u[f];
    } }), Object.defineProperty(l, d, h);
  } : function(l, u, f, d) {
    d === void 0 && (d = f), l[d] = u[f];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), r = _ && _.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var u = {};
    if (l != null)
      for (var f in l)
        f !== "default" && Object.prototype.hasOwnProperty.call(l, f) && t(u, l, f);
    return n(u, l), u;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createUtilizeInstruction = e.utilizeInstructionDiscriminator = e.UtilizeStruct = void 0;
  const i = r(yi), o = r(Se), a = r(we), s = K0;
  e.UtilizeStruct = new o.BeetArgsStruct([
    ["instructionDiscriminator", o.u8],
    ["utilizeArgs", s.utilizeArgsBeet]
  ], "UtilizeInstructionArgs"), e.utilizeInstructionDiscriminator = 19;
  function c(l, u, f = new a.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var d, h, g, w;
    const [b] = e.UtilizeStruct.serialize({
      instructionDiscriminator: e.utilizeInstructionDiscriminator,
      ...u
    }), I = [
      {
        pubkey: l.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.tokenAccount,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.mint,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: l.useAuthority,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: l.owner,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (d = l.tokenProgram) !== null && d !== void 0 ? d : i.TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = l.ataProgram) !== null && h !== void 0 ? h : i.ASSOCIATED_TOKEN_PROGRAM_ID,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (g = l.systemProgram) !== null && g !== void 0 ? g : a.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (w = l.rent) !== null && w !== void 0 ? w : a.SYSVAR_RENT_PUBKEY,
        isWritable: !1,
        isSigner: !1
      }
    ];
    if (l.useAuthorityRecord != null && I.push({
      pubkey: l.useAuthorityRecord,
      isWritable: !0,
      isSigner: !1
    }), l.burner != null) {
      if (l.useAuthorityRecord == null)
        throw new Error("When providing 'burner' then 'accounts.useAuthorityRecord' need(s) to be provided as well.");
      I.push({
        pubkey: l.burner,
        isWritable: !1,
        isSigner: !1
      });
    }
    return new a.TransactionInstruction({
      programId: f,
      keys: I,
      data: b
    });
  }
  e.createUtilizeInstruction = c;
})(H5);
var G5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(c, l, u, f) {
    f === void 0 && (f = u);
    var d = Object.getOwnPropertyDescriptor(l, u);
    (!d || ("get" in d ? !l.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return l[u];
    } }), Object.defineProperty(c, f, d);
  } : function(c, l, u, f) {
    f === void 0 && (f = u), c[f] = l[u];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(c, l) {
    Object.defineProperty(c, "default", { enumerable: !0, value: l });
  } : function(c, l) {
    c.default = l;
  }), r = _ && _.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var l = {};
    if (c != null)
      for (var u in c)
        u !== "default" && Object.prototype.hasOwnProperty.call(c, u) && t(l, c, u);
    return n(l, c), l;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createVerifyInstruction = e.verifyInstructionDiscriminator = e.VerifyStruct = void 0;
  const i = r(Se), o = r(we), a = Iw;
  e.VerifyStruct = new i.BeetArgsStruct([
    ["instructionDiscriminator", i.u8],
    ["verificationArgs", a.verificationArgsBeet]
  ], "VerifyInstructionArgs"), e.verifyInstructionDiscriminator = 52;
  function s(c, l, u = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    var f, d, h, g, w;
    const [b] = e.VerifyStruct.serialize({
      instructionDiscriminator: e.verifyInstructionDiscriminator,
      ...l
    }), I = [
      {
        pubkey: c.authority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: (f = c.delegateRecord) !== null && f !== void 0 ? f : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: (d = c.collectionMint) !== null && d !== void 0 ? d : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (h = c.collectionMetadata) !== null && h !== void 0 ? h : u,
        isWritable: c.collectionMetadata != null,
        isSigner: !1
      },
      {
        pubkey: (g = c.collectionMasterEdition) !== null && g !== void 0 ? g : u,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: (w = c.systemProgram) !== null && w !== void 0 ? w : o.SystemProgram.programId,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: c.sysvarInstructions,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return new o.TransactionInstruction({
      programId: u,
      keys: I,
      data: b
    });
  }
  e.createVerifyInstruction = s;
})(G5);
var Y5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createVerifyCollectionInstruction = e.verifyCollectionInstructionDiscriminator = e.VerifyCollectionStruct = void 0;
  const i = r(Se), o = r(we);
  e.VerifyCollectionStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "VerifyCollectionInstructionArgs"), e.verifyCollectionInstructionDiscriminator = 18;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.VerifyCollectionStruct.serialize({
      instructionDiscriminator: e.verifyCollectionInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.collectionAuthority,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.collectionMint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collection,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collectionMasterEditionAccount,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return s.collectionAuthorityRecord != null && u.push({
      pubkey: s.collectionAuthorityRecord,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createVerifyCollectionInstruction = a;
})(Y5);
var Z5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(s, c, l, u) {
    u === void 0 && (u = l);
    var f = Object.getOwnPropertyDescriptor(c, l);
    (!f || ("get" in f ? !c.__esModule : f.writable || f.configurable)) && (f = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, u, f);
  } : function(s, c, l, u) {
    u === void 0 && (u = l), s[u] = c[l];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(s, c) {
    Object.defineProperty(s, "default", { enumerable: !0, value: c });
  } : function(s, c) {
    s.default = c;
  }), r = _ && _.__importStar || function(s) {
    if (s && s.__esModule)
      return s;
    var c = {};
    if (s != null)
      for (var l in s)
        l !== "default" && Object.prototype.hasOwnProperty.call(s, l) && t(c, s, l);
    return n(c, s), c;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.createVerifySizedCollectionItemInstruction = e.verifySizedCollectionItemInstructionDiscriminator = e.VerifySizedCollectionItemStruct = void 0;
  const i = r(Se), o = r(we);
  e.VerifySizedCollectionItemStruct = new i.BeetArgsStruct([["instructionDiscriminator", i.u8]], "VerifySizedCollectionItemInstructionArgs"), e.verifySizedCollectionItemInstructionDiscriminator = 30;
  function a(s, c = new o.PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")) {
    const [l] = e.VerifySizedCollectionItemStruct.serialize({
      instructionDiscriminator: e.verifySizedCollectionItemInstructionDiscriminator
    }), u = [
      {
        pubkey: s.metadata,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.collectionAuthority,
        isWritable: !1,
        isSigner: !0
      },
      {
        pubkey: s.payer,
        isWritable: !0,
        isSigner: !0
      },
      {
        pubkey: s.collectionMint,
        isWritable: !1,
        isSigner: !1
      },
      {
        pubkey: s.collection,
        isWritable: !0,
        isSigner: !1
      },
      {
        pubkey: s.collectionMasterEditionAccount,
        isWritable: !1,
        isSigner: !1
      }
    ];
    return s.collectionAuthorityRecord != null && u.push({
      pubkey: s.collectionAuthorityRecord,
      isWritable: !1,
      isSigner: !1
    }), new o.TransactionInstruction({
      programId: c,
      keys: u,
      data: l
    });
  }
  e.createVerifySizedCollectionItemInstruction = a;
})(Z5);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(aN, e), n(sN, e), n(VN, e), n(qN, e), n(HN, e), n(GN, e), n(YN, e), n(ZN, e), n(JN, e), n(XN, e), n(e5, e), n(t5, e), n(n5, e), n(r5, e), n(i5, e), n(o5, e), n(a5, e), n(u5, e), n(l5, e), n(f5, e), n(d5, e), n(h5, e), n(p5, e), n(y5, e), n(g5, e), n(b5, e), n(_5, e), n(w5, e), n(v5, e), n(S5, e), n(E5, e), n(A5, e), n(I5, e), n(k5, e), n(T5, e), n(x5, e), n(M5, e), n(O5, e), n(P5, e), n(B5, e), n(C5, e), n(D5, e), n(R5, e), n(N5, e), n(j5, e), n(U5, e), n(z5, e), n($5, e), n(W5, e), n(V5, e), n(q5, e), n(H5, e), n(G5, e), n(Y5, e), n(Z5, e);
})(oN);
var J5 = {}, X5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.authorityTypeBeet = e.AuthorityType = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.None = 0] = "None", a[a.Metadata = 1] = "Metadata", a[a.Holder = 2] = "Holder", a[a.MetadataDelegate = 3] = "MetadataDelegate", a[a.TokenDelegate = 4] = "TokenDelegate";
  })(o = e.AuthorityType || (e.AuthorityType = {})), e.authorityTypeBeet = i.fixedScalarEnum(o);
})(X5);
var Q5 = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.metadataDelegateRoleBeet = e.MetadataDelegateRole = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.AuthorityItem = 0] = "AuthorityItem", a[a.Collection = 1] = "Collection", a[a.Use = 2] = "Use", a[a.Data = 3] = "Data", a[a.ProgrammableConfig = 4] = "ProgrammableConfig", a[a.DataItem = 5] = "DataItem", a[a.CollectionItem = 6] = "CollectionItem", a[a.ProgrammableConfigItem = 7] = "ProgrammableConfigItem";
  })(o = e.MetadataDelegateRole || (e.MetadataDelegateRole = {})), e.metadataDelegateRoleBeet = i.fixedScalarEnum(o);
})(Q5);
var ej = {};
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(a, s, c, l) {
    l === void 0 && (l = c);
    var u = Object.getOwnPropertyDescriptor(s, c);
    (!u || ("get" in u ? !s.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(a, l, u);
  } : function(a, s, c, l) {
    l === void 0 && (l = c), a[l] = s[c];
  }), n = _ && _.__setModuleDefault || (Object.create ? function(a, s) {
    Object.defineProperty(a, "default", { enumerable: !0, value: s });
  } : function(a, s) {
    a.default = s;
  }), r = _ && _.__importStar || function(a) {
    if (a && a.__esModule)
      return a;
    var s = {};
    if (a != null)
      for (var c in a)
        c !== "default" && Object.prototype.hasOwnProperty.call(a, c) && t(s, a, c);
    return n(s, a), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.payloadKeyBeet = e.PayloadKey = void 0;
  const i = r(Se);
  var o;
  (function(a) {
    a[a.Amount = 0] = "Amount", a[a.Authority = 1] = "Authority", a[a.AuthoritySeeds = 2] = "AuthoritySeeds", a[a.Delegate = 3] = "Delegate", a[a.DelegateSeeds = 4] = "DelegateSeeds", a[a.Destination = 5] = "Destination", a[a.DestinationSeeds = 6] = "DestinationSeeds", a[a.Holder = 7] = "Holder", a[a.Source = 8] = "Source", a[a.SourceSeeds = 9] = "SourceSeeds";
  })(o = e.PayloadKey || (e.PayloadKey = {})), e.payloadKeyBeet = i.fixedScalarEnum(o);
})(ej);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(R0, e), n(N0, e), n(X5, e), n(Wo, e), n(Wc, e), n(Qa, e), n(Fo, e), n(Bo, e), n(Po, e), n(Kc, e), n(j0, e), n(U0, e), n(cu, e), n(su, e), n(Jl, e), n(An, e), n($a, e), n(ui, e), n(L0, e), n(Vc, e), n(Q5, e), n(qc, e), n(AT, e), n(Hc, e), n(Xl, e), n(z0, e), n(ej, e), n(Fi, e), n(Oo, e), n(Qs, e), n(Jd, e), n(Zd, e), n(IT, e), n(Do, e), n(F0, e), n(Zl, e), n(pT, e), n(Gl, e), n(hT, e), n(Gc, e), n($0, e), n(Yc, e), n(lr, e), n(W0, e), n(Zc, e), n(dT, e), n(es, e), n(Co, e), n(K0, e), n(Iw, e);
})(J5);
var sB;
function kT() {
  return sB || (sB = 1, function(e) {
    var t = _ && _.__createBinding || (Object.create ? function(i, o, a, s) {
      s === void 0 && (s = a);
      var c = Object.getOwnPropertyDescriptor(o, a);
      (!c || ("get" in c ? !o.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
        return o[a];
      } }), Object.defineProperty(i, s, c);
    } : function(i, o, a, s) {
      s === void 0 && (s = a), i[s] = o[a];
    }), n = _ && _.__exportStar || function(i, o) {
      for (var a in i)
        a !== "default" && !Object.prototype.hasOwnProperty.call(o, a) && t(o, i, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.PROGRAM_ID = e.PROGRAM_ADDRESS = void 0;
    const r = we;
    n(mre(), e), n(V, e), n(oN, e), n(J5, e), e.PROGRAM_ADDRESS = "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s", e.PROGRAM_ID = new r.PublicKey(e.PROGRAM_ADDRESS);
  }(oS)), oS;
}
Object.defineProperty(k_, "__esModule", { value: !0 });
k_.cusper = void 0;
const gle = j6, ble = kT();
k_.cusper = (0, gle.initCusper)(ble.errorFromCode);
(function(e) {
  var t = _ && _.__createBinding || (Object.create ? function(r, i, o, a) {
    a === void 0 && (a = o);
    var s = Object.getOwnPropertyDescriptor(i, o);
    (!s || ("get" in s ? !i.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return i[o];
    } }), Object.defineProperty(r, a, s);
  } : function(r, i, o, a) {
    a === void 0 && (a = o), r[a] = i[o];
  }), n = _ && _.__exportStar || function(r, i) {
    for (var o in r)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, r, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(k_, e), n(kT(), e);
})(N6);
var mle = globalThis && globalThis.__decorate || function(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(e, t, n, r);
  else
    for (var s = e.length - 1; s >= 0; s--)
      (a = e[s]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, n, o) : a(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
}, GS = globalThis && globalThis.__metadata || function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
class TT {
  constructor(t, n) {
    this.contractAddress = t;
    const r = new Rk(n, "confirmed");
    this.connection = r, this.program = new vl(Ste, t, { connection: r });
  }
  async getValidNftsCore(t) {
    return await this.hasValidNft(t.address) ? {
      networkAndAddress: t,
      hasValidNft: !0,
      tokens: [await this.getTokenMetadata(t.address)]
    } : {
      networkAndAddress: t,
      hasValidNft: !1
    };
  }
  async getTransaction(t) {
    var n, r;
    try {
      const i = await this.connection.getTransaction(t, {
        commitment: "finalized",
        maxSupportedTransactionVersion: 0
      });
      if (i === null)
        throw new lt(`Transaction ${t} doesn't exist`);
      {
        const o = (n = i.meta) === null || n === void 0 ? void 0 : n.postTokenBalances, a = ((r = i.meta) === null || r === void 0 ? void 0 : r.err) === null ? "Success" : "Unknown";
        if (o && o.length === 1) {
          const s = o[0].uiTokenAmount;
          if (s.uiAmount === 1 && s.decimals === 0) {
            const c = o[0].mint;
            return {
              status: a,
              data: c.toString()
            };
          } else
            return {
              status: a
            };
        } else
          return {
            status: a
          };
      }
    } catch (i) {
      throw new lt(`Unexpected error while checking Solana transaction: ${i}`);
    }
  }
  async getTokenMetadata(t) {
    const n = new Ae(t), r = await this.connection.getTokenAccountsByOwner(n, {
      programId: lte
    });
    for (const i of r.value) {
      const o = M6.decode(i.account.data);
      if (Number(o.amount) == 1 && o.state == UA.Frozen) {
        const a = new Ae(o.mint), s = await Ite(a), c = await N6.Metadata.fromAccountAddress(this.connection, s);
        if (c.data.name.replace(/\0/g, "") == "KYCDAO NFT")
          return await (await fetch(c.data.uri)).json();
      }
    }
    throw new Error(`No valid NFT found for ${t}`);
  }
  async hasValidNft(t) {
    const n = new Ae(t), r = new Ae(this.contractAddress), [i, o] = await Ate(n, r);
    if (!await this.connection.getAccountInfo(i))
      return !1;
    const s = await this.program.account.kycDaoNftStatus.fetch(i);
    return s.data.isValid && s.data.expiry > new il(Date.now() / 1e3);
  }
  async getValidNfts(t) {
    try {
      return this.getValidNftsCore(t);
    } catch (n) {
      let r;
      n instanceof $o ? r = n : r = new lt(String(n));
      const i = r.toString();
      return {
        networkAndAddress: t,
        error: i
      };
    }
  }
}
mle([
  Gn(),
  GS("design:type", Function),
  GS("design:paramtypes", [Object]),
  GS("design:returntype", Promise)
], TT.prototype, "getValidNftsCore", null);
var Ui = {}, $r = {};
Object.defineProperty($r, "__esModule", { value: !0 });
$r.output = $r.exists = $r.hash = $r.bytes = $r.bool = $r.number = void 0;
function om(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
$r.number = om;
function tj(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
$r.bool = tj;
function xT(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
$r.bytes = xT;
function nj(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  om(e.outputLen), om(e.blockLen);
}
$r.hash = nj;
function rj(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
$r.exists = rj;
function ij(e, t) {
  xT(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
$r.output = ij;
const _le = {
  number: om,
  bool: tj,
  bytes: xT,
  hash: nj,
  exists: rj,
  output: ij
};
$r.default = _le;
var Ml = {}, oj = {}, uu = {};
const wle = {
  node: void 0,
  web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
}, vle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crypto: wle
}, Symbol.toStringTag, { value: "Module" })), Sle = /* @__PURE__ */ Qc(vle);
(function(e) {
  /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(e, "__esModule", { value: !0 }), e.randomBytes = e.wrapConstructorWithOpts = e.wrapConstructor = e.checkOpts = e.Hash = e.concatBytes = e.toBytes = e.utf8ToBytes = e.asyncLoop = e.nextTick = e.hexToBytes = e.bytesToHex = e.isLE = e.rotr = e.createView = e.u32 = e.u8 = void 0;
  const t = Sle, n = (N) => new Uint8Array(N.buffer, N.byteOffset, N.byteLength);
  e.u8 = n;
  const r = (N) => new Uint32Array(N.buffer, N.byteOffset, Math.floor(N.byteLength / 4));
  e.u32 = r;
  const i = (N) => new DataView(N.buffer, N.byteOffset, N.byteLength);
  e.createView = i;
  const o = (N, j) => N << 32 - j | N >>> j;
  if (e.rotr = o, e.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, !e.isLE)
    throw new Error("Non little-endian hardware is not supported");
  const a = Array.from({ length: 256 }, (N, j) => j.toString(16).padStart(2, "0"));
  function s(N) {
    if (!(N instanceof Uint8Array))
      throw new Error("Uint8Array expected");
    let j = "";
    for (let K = 0; K < N.length; K++)
      j += a[N[K]];
    return j;
  }
  e.bytesToHex = s;
  function c(N) {
    if (typeof N != "string")
      throw new TypeError("hexToBytes: expected string, got " + typeof N);
    if (N.length % 2)
      throw new Error("hexToBytes: received invalid unpadded hex");
    const j = new Uint8Array(N.length / 2);
    for (let K = 0; K < j.length; K++) {
      const W = K * 2, O = N.slice(W, W + 2), k = Number.parseInt(O, 16);
      if (Number.isNaN(k) || k < 0)
        throw new Error("Invalid byte sequence");
      j[K] = k;
    }
    return j;
  }
  e.hexToBytes = c;
  const l = async () => {
  };
  e.nextTick = l;
  async function u(N, j, K) {
    let W = Date.now();
    for (let O = 0; O < N; O++) {
      K(O);
      const k = Date.now() - W;
      k >= 0 && k < j || (await (0, e.nextTick)(), W += k);
    }
  }
  e.asyncLoop = u;
  function f(N) {
    if (typeof N != "string")
      throw new TypeError(`utf8ToBytes expected string, got ${typeof N}`);
    return new TextEncoder().encode(N);
  }
  e.utf8ToBytes = f;
  function d(N) {
    if (typeof N == "string" && (N = f(N)), !(N instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof N})`);
    return N;
  }
  e.toBytes = d;
  function h(...N) {
    if (!N.every((W) => W instanceof Uint8Array))
      throw new Error("Uint8Array list expected");
    if (N.length === 1)
      return N[0];
    const j = N.reduce((W, O) => W + O.length, 0), K = new Uint8Array(j);
    for (let W = 0, O = 0; W < N.length; W++) {
      const k = N[W];
      K.set(k, O), O += k.length;
    }
    return K;
  }
  e.concatBytes = h;
  class g {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  }
  e.Hash = g;
  const w = (N) => Object.prototype.toString.call(N) === "[object Object]" && N.constructor === Object;
  function b(N, j) {
    if (j !== void 0 && (typeof j != "object" || !w(j)))
      throw new TypeError("Options should be object or undefined");
    return Object.assign(N, j);
  }
  e.checkOpts = b;
  function I(N) {
    const j = (W) => N().update(d(W)).digest(), K = N();
    return j.outputLen = K.outputLen, j.blockLen = K.blockLen, j.create = () => N(), j;
  }
  e.wrapConstructor = I;
  function A(N) {
    const j = (W, O) => N(O).update(d(W)).digest(), K = N({});
    return j.outputLen = K.outputLen, j.blockLen = K.blockLen, j.create = (W) => N(W), j;
  }
  e.wrapConstructorWithOpts = A;
  function x(N = 32) {
    if (t.crypto.web)
      return t.crypto.web.getRandomValues(new Uint8Array(N));
    if (t.crypto.node)
      return new Uint8Array(t.crypto.node.randomBytes(N).buffer);
    throw new Error("The environment doesn't have randomBytes function");
  }
  e.randomBytes = x;
})(uu);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.hmac = void 0;
  const t = $r, n = uu;
  class r extends n.Hash {
    constructor(a, s) {
      super(), this.finished = !1, this.destroyed = !1, t.default.hash(a);
      const c = (0, n.toBytes)(s);
      if (this.iHash = a.create(), typeof this.iHash.update != "function")
        throw new TypeError("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const l = this.blockLen, u = new Uint8Array(l);
      u.set(c.length > l ? a.create().update(c).digest() : c);
      for (let f = 0; f < u.length; f++)
        u[f] ^= 54;
      this.iHash.update(u), this.oHash = a.create();
      for (let f = 0; f < u.length; f++)
        u[f] ^= 106;
      this.oHash.update(u), u.fill(0);
    }
    update(a) {
      return t.default.exists(this), this.iHash.update(a), this;
    }
    digestInto(a) {
      t.default.exists(this), t.default.bytes(a, this.outputLen), this.finished = !0, this.iHash.digestInto(a), this.oHash.update(a), this.oHash.digestInto(a), this.destroy();
    }
    digest() {
      const a = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(a), a;
    }
    _cloneInto(a) {
      a || (a = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: s, iHash: c, finished: l, destroyed: u, blockLen: f, outputLen: d } = this;
      return a = a, a.finished = l, a.destroyed = u, a.blockLen = f, a.outputLen = d, a.oHash = s._cloneInto(a.oHash), a.iHash = c._cloneInto(a.iHash), a;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  }
  const i = (o, a, s) => new r(o, a).update(s).digest();
  e.hmac = i, e.hmac.create = (o, a) => new r(o, a);
})(oj);
Object.defineProperty(Ml, "__esModule", { value: !0 });
Ml.pbkdf2Async = Ml.pbkdf2 = void 0;
const Hg = $r, Ele = oj, Qu = uu;
function aj(e, t, n, r) {
  Hg.default.hash(e);
  const i = (0, Qu.checkOpts)({ dkLen: 32, asyncTick: 10 }, r), { c: o, dkLen: a, asyncTick: s } = i;
  if (Hg.default.number(o), Hg.default.number(a), Hg.default.number(s), o < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const c = (0, Qu.toBytes)(t), l = (0, Qu.toBytes)(n), u = new Uint8Array(a), f = Ele.hmac.create(e, c), d = f._cloneInto().update(l);
  return { c: o, dkLen: a, asyncTick: s, DK: u, PRF: f, PRFSalt: d };
}
function sj(e, t, n, r, i) {
  return e.destroy(), t.destroy(), r && r.destroy(), i.fill(0), n;
}
function Ale(e, t, n, r) {
  const { c: i, dkLen: o, DK: a, PRF: s, PRFSalt: c } = aj(e, t, n, r);
  let l;
  const u = new Uint8Array(4), f = (0, Qu.createView)(u), d = new Uint8Array(s.outputLen);
  for (let h = 1, g = 0; g < o; h++, g += s.outputLen) {
    const w = a.subarray(g, g + s.outputLen);
    f.setInt32(0, h, !1), (l = c._cloneInto(l)).update(u).digestInto(d), w.set(d.subarray(0, w.length));
    for (let b = 1; b < i; b++) {
      s._cloneInto(l).update(d).digestInto(d);
      for (let I = 0; I < w.length; I++)
        w[I] ^= d[I];
    }
  }
  return sj(s, c, a, l, d);
}
Ml.pbkdf2 = Ale;
async function Ile(e, t, n, r) {
  const { c: i, dkLen: o, asyncTick: a, DK: s, PRF: c, PRFSalt: l } = aj(e, t, n, r);
  let u;
  const f = new Uint8Array(4), d = (0, Qu.createView)(f), h = new Uint8Array(c.outputLen);
  for (let g = 1, w = 0; w < o; g++, w += c.outputLen) {
    const b = s.subarray(w, w + c.outputLen);
    d.setInt32(0, g, !1), (u = l._cloneInto(u)).update(f).digestInto(h), b.set(h.subarray(0, b.length)), await (0, Qu.asyncLoop)(i - 1, a, (I) => {
      c._cloneInto(u).update(h).digestInto(h);
      for (let A = 0; A < b.length; A++)
        b[A] ^= h[A];
    });
  }
  return sj(c, l, s, u, h);
}
Ml.pbkdf2Async = Ile;
var kw = {}, V0 = {};
Object.defineProperty(V0, "__esModule", { value: !0 });
V0.SHA2 = void 0;
const YS = $r, Ef = uu;
function kle(e, t, n, r) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, n, r);
  const i = BigInt(32), o = BigInt(4294967295), a = Number(n >> i & o), s = Number(n & o), c = r ? 4 : 0, l = r ? 0 : 4;
  e.setUint32(t + c, a, r), e.setUint32(t + l, s, r);
}
let Tle = class extends Ef.Hash {
  constructor(t, n, r, i) {
    super(), this.blockLen = t, this.outputLen = n, this.padOffset = r, this.isLE = i, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = (0, Ef.createView)(this.buffer);
  }
  update(t) {
    YS.default.exists(this);
    const { view: n, buffer: r, blockLen: i } = this;
    t = (0, Ef.toBytes)(t);
    const o = t.length;
    for (let a = 0; a < o; ) {
      const s = Math.min(i - this.pos, o - a);
      if (s === i) {
        const c = (0, Ef.createView)(t);
        for (; i <= o - a; a += i)
          this.process(c, a);
        continue;
      }
      r.set(t.subarray(a, a + s), this.pos), this.pos += s, a += s, this.pos === i && (this.process(n, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    YS.default.exists(this), YS.default.output(t, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: i, isLE: o } = this;
    let { pos: a } = this;
    n[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > i - a && (this.process(r, 0), a = 0);
    for (let c = a; c < i; c++)
      n[c] = 0;
    kle(r, i - 8, BigInt(this.length * 8), o), this.process(r, 0);
    const s = (0, Ef.createView)(t);
    this.get().forEach((c, l) => s.setUint32(4 * l, c, o));
  }
  digest() {
    const { buffer: t, outputLen: n } = this;
    this.digestInto(t);
    const r = t.slice(0, n);
    return this.destroy(), r;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: n, buffer: r, length: i, finished: o, destroyed: a, pos: s } = this;
    return t.length = i, t.pos = s, t.finished = o, t.destroyed = a, i % n && t.buffer.set(r), t;
  }
};
V0.SHA2 = Tle;
Object.defineProperty(kw, "__esModule", { value: !0 });
kw.sha256 = void 0;
const xle = V0, So = uu, Mle = (e, t, n) => e & t ^ ~e & n, Ole = (e, t, n) => e & t ^ e & n ^ t & n, Ple = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), us = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), ls = new Uint32Array(64);
let Ble = class extends xle.SHA2 {
  constructor() {
    super(64, 32, 8, !1), this.A = us[0] | 0, this.B = us[1] | 0, this.C = us[2] | 0, this.D = us[3] | 0, this.E = us[4] | 0, this.F = us[5] | 0, this.G = us[6] | 0, this.H = us[7] | 0;
  }
  get() {
    const { A: t, B: n, C: r, D: i, E: o, F: a, G: s, H: c } = this;
    return [t, n, r, i, o, a, s, c];
  }
  // prettier-ignore
  set(t, n, r, i, o, a, s, c) {
    this.A = t | 0, this.B = n | 0, this.C = r | 0, this.D = i | 0, this.E = o | 0, this.F = a | 0, this.G = s | 0, this.H = c | 0;
  }
  process(t, n) {
    for (let f = 0; f < 16; f++, n += 4)
      ls[f] = t.getUint32(n, !1);
    for (let f = 16; f < 64; f++) {
      const d = ls[f - 15], h = ls[f - 2], g = (0, So.rotr)(d, 7) ^ (0, So.rotr)(d, 18) ^ d >>> 3, w = (0, So.rotr)(h, 17) ^ (0, So.rotr)(h, 19) ^ h >>> 10;
      ls[f] = w + ls[f - 7] + g + ls[f - 16] | 0;
    }
    let { A: r, B: i, C: o, D: a, E: s, F: c, G: l, H: u } = this;
    for (let f = 0; f < 64; f++) {
      const d = (0, So.rotr)(s, 6) ^ (0, So.rotr)(s, 11) ^ (0, So.rotr)(s, 25), h = u + d + Mle(s, c, l) + Ple[f] + ls[f] | 0, w = ((0, So.rotr)(r, 2) ^ (0, So.rotr)(r, 13) ^ (0, So.rotr)(r, 22)) + Ole(r, i, o) | 0;
      u = l, l = c, c = s, s = a + h | 0, a = o, o = i, i = r, r = h + w | 0;
    }
    r = r + this.A | 0, i = i + this.B | 0, o = o + this.C | 0, a = a + this.D | 0, s = s + this.E | 0, c = c + this.F | 0, l = l + this.G | 0, u = u + this.H | 0, this.set(r, i, o, a, s, c, l, u);
  }
  roundClean() {
    ls.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
};
kw.sha256 = (0, So.wrapConstructor)(() => new Ble());
var ua = {}, cj = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.add = e.toBig = e.split = e.fromBig = void 0;
  const t = BigInt(2 ** 32 - 1), n = BigInt(32);
  function r(z, C = !1) {
    return C ? { h: Number(z & t), l: Number(z >> n & t) } : { h: Number(z >> n & t) | 0, l: Number(z & t) | 0 };
  }
  e.fromBig = r;
  function i(z, C = !1) {
    let M = new Uint32Array(z.length), S = new Uint32Array(z.length);
    for (let p = 0; p < z.length; p++) {
      const { h: y, l: v } = r(z[p], C);
      [M[p], S[p]] = [y, v];
    }
    return [M, S];
  }
  e.split = i;
  const o = (z, C) => BigInt(z >>> 0) << n | BigInt(C >>> 0);
  e.toBig = o;
  const a = (z, C, M) => z >>> M, s = (z, C, M) => z << 32 - M | C >>> M, c = (z, C, M) => z >>> M | C << 32 - M, l = (z, C, M) => z << 32 - M | C >>> M, u = (z, C, M) => z << 64 - M | C >>> M - 32, f = (z, C, M) => z >>> M - 32 | C << 64 - M, d = (z, C) => C, h = (z, C) => z, g = (z, C, M) => z << M | C >>> 32 - M, w = (z, C, M) => C << M | z >>> 32 - M, b = (z, C, M) => C << M - 32 | z >>> 64 - M, I = (z, C, M) => z << M - 32 | C >>> 64 - M;
  function A(z, C, M, S) {
    const p = (C >>> 0) + (S >>> 0);
    return { h: z + M + (p / 2 ** 32 | 0) | 0, l: p | 0 };
  }
  e.add = A;
  const x = (z, C, M) => (z >>> 0) + (C >>> 0) + (M >>> 0), N = (z, C, M, S) => C + M + S + (z / 2 ** 32 | 0) | 0, j = (z, C, M, S) => (z >>> 0) + (C >>> 0) + (M >>> 0) + (S >>> 0), K = (z, C, M, S, p) => C + M + S + p + (z / 2 ** 32 | 0) | 0, W = (z, C, M, S, p) => (z >>> 0) + (C >>> 0) + (M >>> 0) + (S >>> 0) + (p >>> 0), O = (z, C, M, S, p, y) => C + M + S + p + y + (z / 2 ** 32 | 0) | 0, k = {
    fromBig: r,
    split: i,
    toBig: e.toBig,
    shrSH: a,
    shrSL: s,
    rotrSH: c,
    rotrSL: l,
    rotrBH: u,
    rotrBL: f,
    rotr32H: d,
    rotr32L: h,
    rotlSH: g,
    rotlSL: w,
    rotlBH: b,
    rotlBL: I,
    add: A,
    add3L: x,
    add3H: N,
    add4L: j,
    add4H: K,
    add5H: O,
    add5L: W
  };
  e.default = k;
})(cj);
Object.defineProperty(ua, "__esModule", { value: !0 });
ua.sha384 = ua.sha512_256 = ua.sha512 = ua.SHA512 = void 0;
const Cle = V0, Kt = cj, MT = uu, [Dle, Rle] = Kt.default.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), fs = new Uint32Array(80), ds = new Uint32Array(80);
let Tw = class extends Cle.SHA2 {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: n, Bh: r, Bl: i, Ch: o, Cl: a, Dh: s, Dl: c, Eh: l, El: u, Fh: f, Fl: d, Gh: h, Gl: g, Hh: w, Hl: b } = this;
    return [t, n, r, i, o, a, s, c, l, u, f, d, h, g, w, b];
  }
  // prettier-ignore
  set(t, n, r, i, o, a, s, c, l, u, f, d, h, g, w, b) {
    this.Ah = t | 0, this.Al = n | 0, this.Bh = r | 0, this.Bl = i | 0, this.Ch = o | 0, this.Cl = a | 0, this.Dh = s | 0, this.Dl = c | 0, this.Eh = l | 0, this.El = u | 0, this.Fh = f | 0, this.Fl = d | 0, this.Gh = h | 0, this.Gl = g | 0, this.Hh = w | 0, this.Hl = b | 0;
  }
  process(t, n) {
    for (let x = 0; x < 16; x++, n += 4)
      fs[x] = t.getUint32(n), ds[x] = t.getUint32(n += 4);
    for (let x = 16; x < 80; x++) {
      const N = fs[x - 15] | 0, j = ds[x - 15] | 0, K = Kt.default.rotrSH(N, j, 1) ^ Kt.default.rotrSH(N, j, 8) ^ Kt.default.shrSH(N, j, 7), W = Kt.default.rotrSL(N, j, 1) ^ Kt.default.rotrSL(N, j, 8) ^ Kt.default.shrSL(N, j, 7), O = fs[x - 2] | 0, k = ds[x - 2] | 0, z = Kt.default.rotrSH(O, k, 19) ^ Kt.default.rotrBH(O, k, 61) ^ Kt.default.shrSH(O, k, 6), C = Kt.default.rotrSL(O, k, 19) ^ Kt.default.rotrBL(O, k, 61) ^ Kt.default.shrSL(O, k, 6), M = Kt.default.add4L(W, C, ds[x - 7], ds[x - 16]), S = Kt.default.add4H(M, K, z, fs[x - 7], fs[x - 16]);
      fs[x] = S | 0, ds[x] = M | 0;
    }
    let { Ah: r, Al: i, Bh: o, Bl: a, Ch: s, Cl: c, Dh: l, Dl: u, Eh: f, El: d, Fh: h, Fl: g, Gh: w, Gl: b, Hh: I, Hl: A } = this;
    for (let x = 0; x < 80; x++) {
      const N = Kt.default.rotrSH(f, d, 14) ^ Kt.default.rotrSH(f, d, 18) ^ Kt.default.rotrBH(f, d, 41), j = Kt.default.rotrSL(f, d, 14) ^ Kt.default.rotrSL(f, d, 18) ^ Kt.default.rotrBL(f, d, 41), K = f & h ^ ~f & w, W = d & g ^ ~d & b, O = Kt.default.add5L(A, j, W, Rle[x], ds[x]), k = Kt.default.add5H(O, I, N, K, Dle[x], fs[x]), z = O | 0, C = Kt.default.rotrSH(r, i, 28) ^ Kt.default.rotrBH(r, i, 34) ^ Kt.default.rotrBH(r, i, 39), M = Kt.default.rotrSL(r, i, 28) ^ Kt.default.rotrBL(r, i, 34) ^ Kt.default.rotrBL(r, i, 39), S = r & o ^ r & s ^ o & s, p = i & a ^ i & c ^ a & c;
      I = w | 0, A = b | 0, w = h | 0, b = g | 0, h = f | 0, g = d | 0, { h: f, l: d } = Kt.default.add(l | 0, u | 0, k | 0, z | 0), l = s | 0, u = c | 0, s = o | 0, c = a | 0, o = r | 0, a = i | 0;
      const y = Kt.default.add3L(z, M, p);
      r = Kt.default.add3H(y, k, C, S), i = y | 0;
    }
    ({ h: r, l: i } = Kt.default.add(this.Ah | 0, this.Al | 0, r | 0, i | 0)), { h: o, l: a } = Kt.default.add(this.Bh | 0, this.Bl | 0, o | 0, a | 0), { h: s, l: c } = Kt.default.add(this.Ch | 0, this.Cl | 0, s | 0, c | 0), { h: l, l: u } = Kt.default.add(this.Dh | 0, this.Dl | 0, l | 0, u | 0), { h: f, l: d } = Kt.default.add(this.Eh | 0, this.El | 0, f | 0, d | 0), { h, l: g } = Kt.default.add(this.Fh | 0, this.Fl | 0, h | 0, g | 0), { h: w, l: b } = Kt.default.add(this.Gh | 0, this.Gl | 0, w | 0, b | 0), { h: I, l: A } = Kt.default.add(this.Hh | 0, this.Hl | 0, I | 0, A | 0), this.set(r, i, o, a, s, c, l, u, f, d, h, g, w, b, I, A);
  }
  roundClean() {
    fs.fill(0), ds.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
};
ua.SHA512 = Tw;
let Nle = class extends Tw {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}, jle = class extends Tw {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
};
ua.sha512 = (0, MT.wrapConstructor)(() => new Tw());
ua.sha512_256 = (0, MT.wrapConstructor)(() => new Nle());
ua.sha384 = (0, MT.wrapConstructor)(() => new jle());
var uj = {};
(function(e) {
  /*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(e, "__esModule", { value: !0 }), e.bytes = e.stringToBytes = e.str = e.bytesToString = e.hex = e.utf8 = e.bech32m = e.bech32 = e.base58check = e.base58xmr = e.base58xrp = e.base58flickr = e.base58 = e.base64url = e.base64 = e.base32crockford = e.base32hex = e.base32 = e.base16 = e.utils = e.assertNumber = void 0;
  function t(C) {
    if (!Number.isSafeInteger(C))
      throw new Error(`Wrong integer: ${C}`);
  }
  e.assertNumber = t;
  function n(...C) {
    const M = (y, v) => (E) => y(v(E)), S = Array.from(C).reverse().reduce((y, v) => y ? M(y, v.encode) : v.encode, void 0), p = C.reduce((y, v) => y ? M(y, v.decode) : v.decode, void 0);
    return { encode: S, decode: p };
  }
  function r(C) {
    return {
      encode: (M) => {
        if (!Array.isArray(M) || M.length && typeof M[0] != "number")
          throw new Error("alphabet.encode input should be an array of numbers");
        return M.map((S) => {
          if (t(S), S < 0 || S >= C.length)
            throw new Error(`Digit index outside alphabet: ${S} (alphabet: ${C.length})`);
          return C[S];
        });
      },
      decode: (M) => {
        if (!Array.isArray(M) || M.length && typeof M[0] != "string")
          throw new Error("alphabet.decode input should be array of strings");
        return M.map((S) => {
          if (typeof S != "string")
            throw new Error(`alphabet.decode: not string element=${S}`);
          const p = C.indexOf(S);
          if (p === -1)
            throw new Error(`Unknown letter: "${S}". Allowed: ${C}`);
          return p;
        });
      }
    };
  }
  function i(C = "") {
    if (typeof C != "string")
      throw new Error("join separator should be string");
    return {
      encode: (M) => {
        if (!Array.isArray(M) || M.length && typeof M[0] != "string")
          throw new Error("join.encode input should be array of strings");
        for (let S of M)
          if (typeof S != "string")
            throw new Error(`join.encode: non-string input=${S}`);
        return M.join(C);
      },
      decode: (M) => {
        if (typeof M != "string")
          throw new Error("join.decode input should be string");
        return M.split(C);
      }
    };
  }
  function o(C, M = "=") {
    if (t(C), typeof M != "string")
      throw new Error("padding chr should be string");
    return {
      encode(S) {
        if (!Array.isArray(S) || S.length && typeof S[0] != "string")
          throw new Error("padding.encode input should be array of strings");
        for (let p of S)
          if (typeof p != "string")
            throw new Error(`padding.encode: non-string input=${p}`);
        for (; S.length * C % 8; )
          S.push(M);
        return S;
      },
      decode(S) {
        if (!Array.isArray(S) || S.length && typeof S[0] != "string")
          throw new Error("padding.encode input should be array of strings");
        for (let y of S)
          if (typeof y != "string")
            throw new Error(`padding.decode: non-string input=${y}`);
        let p = S.length;
        if (p * C % 8)
          throw new Error("Invalid padding: string should have whole number of bytes");
        for (; p > 0 && S[p - 1] === M; p--)
          if (!((p - 1) * C % 8))
            throw new Error("Invalid padding: string has too much padding");
        return S.slice(0, p);
      }
    };
  }
  function a(C) {
    if (typeof C != "function")
      throw new Error("normalize fn should be function");
    return { encode: (M) => M, decode: (M) => C(M) };
  }
  function s(C, M, S) {
    if (M < 2)
      throw new Error(`convertRadix: wrong from=${M}, base cannot be less than 2`);
    if (S < 2)
      throw new Error(`convertRadix: wrong to=${S}, base cannot be less than 2`);
    if (!Array.isArray(C))
      throw new Error("convertRadix: data should be array");
    if (!C.length)
      return [];
    let p = 0;
    const y = [], v = Array.from(C);
    for (v.forEach((E) => {
      if (t(E), E < 0 || E >= M)
        throw new Error(`Wrong integer: ${E}`);
    }); ; ) {
      let E = 0, B = !0;
      for (let F = p; F < v.length; F++) {
        const q = v[F], U = M * E + q;
        if (!Number.isSafeInteger(U) || M * E / M !== E || U - q !== M * E)
          throw new Error("convertRadix: carry overflow");
        if (E = U % S, v[F] = Math.floor(U / S), !Number.isSafeInteger(v[F]) || v[F] * S + E !== U)
          throw new Error("convertRadix: carry overflow");
        if (B)
          v[F] ? B = !1 : p = F;
        else
          continue;
      }
      if (y.push(E), B)
        break;
    }
    for (let E = 0; E < C.length - 1 && C[E] === 0; E++)
      y.push(0);
    return y.reverse();
  }
  const c = (C, M) => M ? c(M, C % M) : C, l = (C, M) => C + (M - c(C, M));
  function u(C, M, S, p) {
    if (!Array.isArray(C))
      throw new Error("convertRadix2: data should be array");
    if (M <= 0 || M > 32)
      throw new Error(`convertRadix2: wrong from=${M}`);
    if (S <= 0 || S > 32)
      throw new Error(`convertRadix2: wrong to=${S}`);
    if (l(M, S) > 32)
      throw new Error(`convertRadix2: carry overflow from=${M} to=${S} carryBits=${l(M, S)}`);
    let y = 0, v = 0;
    const E = 2 ** S - 1, B = [];
    for (const F of C) {
      if (t(F), F >= 2 ** M)
        throw new Error(`convertRadix2: invalid data word=${F} from=${M}`);
      if (y = y << M | F, v + M > 32)
        throw new Error(`convertRadix2: carry overflow pos=${v} from=${M}`);
      for (v += M; v >= S; v -= S)
        B.push((y >> v - S & E) >>> 0);
      y &= 2 ** v - 1;
    }
    if (y = y << S - v & E, !p && v >= M)
      throw new Error("Excess padding");
    if (!p && y)
      throw new Error(`Non-zero padding: ${y}`);
    return p && v > 0 && B.push(y >>> 0), B;
  }
  function f(C) {
    return t(C), {
      encode: (M) => {
        if (!(M instanceof Uint8Array))
          throw new Error("radix.encode input should be Uint8Array");
        return s(Array.from(M), 2 ** 8, C);
      },
      decode: (M) => {
        if (!Array.isArray(M) || M.length && typeof M[0] != "number")
          throw new Error("radix.decode input should be array of strings");
        return Uint8Array.from(s(M, C, 2 ** 8));
      }
    };
  }
  function d(C, M = !1) {
    if (t(C), C <= 0 || C > 32)
      throw new Error("radix2: bits should be in (0..32]");
    if (l(8, C) > 32 || l(C, 8) > 32)
      throw new Error("radix2: carry overflow");
    return {
      encode: (S) => {
        if (!(S instanceof Uint8Array))
          throw new Error("radix2.encode input should be Uint8Array");
        return u(Array.from(S), 8, C, !M);
      },
      decode: (S) => {
        if (!Array.isArray(S) || S.length && typeof S[0] != "number")
          throw new Error("radix2.decode input should be array of strings");
        return Uint8Array.from(u(S, C, 8, M));
      }
    };
  }
  function h(C) {
    if (typeof C != "function")
      throw new Error("unsafeWrapper fn should be function");
    return function(...M) {
      try {
        return C.apply(null, M);
      } catch {
      }
    };
  }
  function g(C, M) {
    if (t(C), typeof M != "function")
      throw new Error("checksum fn should be function");
    return {
      encode(S) {
        if (!(S instanceof Uint8Array))
          throw new Error("checksum.encode: input should be Uint8Array");
        const p = M(S).slice(0, C), y = new Uint8Array(S.length + C);
        return y.set(S), y.set(p, S.length), y;
      },
      decode(S) {
        if (!(S instanceof Uint8Array))
          throw new Error("checksum.decode: input should be Uint8Array");
        const p = S.slice(0, -C), y = M(p).slice(0, C), v = S.slice(-C);
        for (let E = 0; E < C; E++)
          if (y[E] !== v[E])
            throw new Error("Invalid checksum");
        return p;
      }
    };
  }
  e.utils = { alphabet: r, chain: n, checksum: g, radix: f, radix2: d, join: i, padding: o }, e.base16 = n(d(4), r("0123456789ABCDEF"), i("")), e.base32 = n(d(5), r("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), o(5), i("")), e.base32hex = n(d(5), r("0123456789ABCDEFGHIJKLMNOPQRSTUV"), o(5), i("")), e.base32crockford = n(d(5), r("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), i(""), a((C) => C.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1"))), e.base64 = n(d(6), r("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), o(6), i("")), e.base64url = n(d(6), r("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), o(6), i(""));
  const w = (C) => n(f(58), r(C), i(""));
  e.base58 = w("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), e.base58flickr = w("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"), e.base58xrp = w("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
  const b = [0, 2, 3, 5, 6, 7, 9, 10, 11];
  e.base58xmr = {
    encode(C) {
      let M = "";
      for (let S = 0; S < C.length; S += 8) {
        const p = C.subarray(S, S + 8);
        M += e.base58.encode(p).padStart(b[p.length], "1");
      }
      return M;
    },
    decode(C) {
      let M = [];
      for (let S = 0; S < C.length; S += 11) {
        const p = C.slice(S, S + 11), y = b.indexOf(p.length), v = e.base58.decode(p);
        for (let E = 0; E < v.length - y; E++)
          if (v[E] !== 0)
            throw new Error("base58xmr: wrong padding");
        M = M.concat(Array.from(v.slice(v.length - y)));
      }
      return Uint8Array.from(M);
    }
  };
  const I = (C) => n(g(4, (M) => C(C(M))), e.base58);
  e.base58check = I;
  const A = n(r("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), i("")), x = [996825010, 642813549, 513874426, 1027748829, 705979059];
  function N(C) {
    const M = C >> 25;
    let S = (C & 33554431) << 5;
    for (let p = 0; p < x.length; p++)
      (M >> p & 1) === 1 && (S ^= x[p]);
    return S;
  }
  function j(C, M, S = 1) {
    const p = C.length;
    let y = 1;
    for (let v = 0; v < p; v++) {
      const E = C.charCodeAt(v);
      if (E < 33 || E > 126)
        throw new Error(`Invalid prefix (${C})`);
      y = N(y) ^ E >> 5;
    }
    y = N(y);
    for (let v = 0; v < p; v++)
      y = N(y) ^ C.charCodeAt(v) & 31;
    for (let v of M)
      y = N(y) ^ v;
    for (let v = 0; v < 6; v++)
      y = N(y);
    return y ^= S, A.encode(u([y % 2 ** 30], 30, 5, !1));
  }
  function K(C) {
    const M = C === "bech32" ? 1 : 734539939, S = d(5), p = S.decode, y = S.encode, v = h(p);
    function E(U, m, D = 90) {
      if (typeof U != "string")
        throw new Error(`bech32.encode prefix should be string, not ${typeof U}`);
      if (!Array.isArray(m) || m.length && typeof m[0] != "number")
        throw new Error(`bech32.encode words should be array of numbers, not ${typeof m}`);
      const Y = U.length + 7 + m.length;
      if (D !== !1 && Y > D)
        throw new TypeError(`Length ${Y} exceeds limit ${D}`);
      return U = U.toLowerCase(), `${U}1${A.encode(m)}${j(U, m, M)}`;
    }
    function B(U, m = 90) {
      if (typeof U != "string")
        throw new Error(`bech32.decode input should be string, not ${typeof U}`);
      if (U.length < 8 || m !== !1 && U.length > m)
        throw new TypeError(`Wrong string length: ${U.length} (${U}). Expected (8..${m})`);
      const D = U.toLowerCase();
      if (U !== D && U !== U.toUpperCase())
        throw new Error("String must be lowercase or uppercase");
      U = D;
      const Y = U.lastIndexOf("1");
      if (Y === 0 || Y === -1)
        throw new Error('Letter "1" must be present between prefix and data only');
      const Q = U.slice(0, Y), G = U.slice(Y + 1);
      if (G.length < 6)
        throw new Error("Data must be at least 6 characters long");
      const he = A.decode(G).slice(0, -6), se = j(Q, he, M);
      if (!G.endsWith(se))
        throw new Error(`Invalid checksum in ${U}: expected "${se}"`);
      return { prefix: Q, words: he };
    }
    const F = h(B);
    function q(U) {
      const { prefix: m, words: D } = B(U, !1);
      return { prefix: m, words: D, bytes: p(D) };
    }
    return { encode: E, decode: B, decodeToBytes: q, decodeUnsafe: F, fromWords: p, fromWordsUnsafe: v, toWords: y };
  }
  e.bech32 = K("bech32"), e.bech32m = K("bech32m"), e.utf8 = {
    encode: (C) => new TextDecoder().decode(C),
    decode: (C) => new TextEncoder().encode(C)
  }, e.hex = n(d(4), r("0123456789abcdef"), i(""), a((C) => {
    if (typeof C != "string" || C.length % 2)
      throw new TypeError(`hex.decode: expected string, got ${typeof C} with length ${C.length}`);
    return C.toLowerCase();
  }));
  const W = {
    utf8: e.utf8,
    hex: e.hex,
    base16: e.base16,
    base32: e.base32,
    base64: e.base64,
    base64url: e.base64url,
    base58: e.base58,
    base58xmr: e.base58xmr
  }, O = `Invalid encoding type. Available types: ${Object.keys(W).join(", ")}`, k = (C, M) => {
    if (typeof C != "string" || !W.hasOwnProperty(C))
      throw new TypeError(O);
    if (!(M instanceof Uint8Array))
      throw new TypeError("bytesToString() expects Uint8Array");
    return W[C].encode(M);
  };
  e.bytesToString = k, e.str = e.bytesToString;
  const z = (C, M) => {
    if (!W.hasOwnProperty(C))
      throw new TypeError(O);
    if (typeof M != "string")
      throw new TypeError("stringToBytes() expects string");
    return W[C].decode(M);
  };
  e.stringToBytes = z, e.bytes = e.stringToBytes;
})(uj);
Object.defineProperty(Ui, "__esModule", { value: !0 });
var lj = Ui.mnemonicToSeedSync = Ui.mnemonicToSeed = Ui.validateMnemonic = Ui.entropyToMnemonic = Ui.mnemonicToEntropy = Ui.generateMnemonic = void 0;
/*! scure-bip39 - MIT License (c) 2022 Patricio Palladino, Paul Miller (paulmillr.com) */
const fj = $r, dj = Ml, Ule = kw, hj = ua, zle = uu, Gg = uj, Fle = (e) => e[0] === "あいこくしん";
function pj(e) {
  if (typeof e != "string")
    throw new TypeError(`Invalid mnemonic type: ${typeof e}`);
  return e.normalize("NFKD");
}
function OT(e) {
  const t = pj(e), n = t.split(" ");
  if (![12, 15, 18, 21, 24].includes(n.length))
    throw new Error("Invalid mnemonic");
  return { nfkd: t, words: n };
}
function yj(e) {
  fj.default.bytes(e, 16, 20, 24, 28, 32);
}
function Lle(e, t = 128) {
  if (fj.default.number(t), t % 32 !== 0 || t > 256)
    throw new TypeError("Invalid entropy");
  return mj((0, zle.randomBytes)(t / 8), e);
}
Ui.generateMnemonic = Lle;
const $le = (e) => {
  const t = 8 - e.length / 4;
  return new Uint8Array([(0, Ule.sha256)(e)[0] >> t << t]);
};
function gj(e) {
  if (!Array.isArray(e) || e.length !== 2 ** 11 || typeof e[0] != "string")
    throw new Error("Worlist: expected array of 2048 strings");
  return e.forEach((t) => {
    if (typeof t != "string")
      throw new Error(`Wordlist: non-string element: ${t}`);
  }), Gg.utils.chain(Gg.utils.checksum(1, $le), Gg.utils.radix2(11, !0), Gg.utils.alphabet(e));
}
function bj(e, t) {
  const { words: n } = OT(e), r = gj(t).decode(n);
  return yj(r), r;
}
Ui.mnemonicToEntropy = bj;
function mj(e, t) {
  return yj(e), gj(t).encode(e).join(Fle(t) ? "　" : " ");
}
Ui.entropyToMnemonic = mj;
function Wle(e, t) {
  try {
    bj(e, t);
  } catch {
    return !1;
  }
  return !0;
}
Ui.validateMnemonic = Wle;
const _j = (e) => pj(`mnemonic${e}`);
function Kle(e, t = "") {
  return (0, dj.pbkdf2Async)(hj.sha512, OT(e).nfkd, _j(t), { c: 2048, dkLen: 64 });
}
Ui.mnemonicToSeed = Kle;
function Vle(e, t = "") {
  return (0, dj.pbkdf2)(hj.sha512, OT(e).nfkd, _j(t), { c: 2048, dkLen: 64 });
}
lj = Ui.mnemonicToSeedSync = Vle;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const qle = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), ZS = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), Xo = (e, t) => e << 32 - t | e >>> t, Hle = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!Hle)
  throw new Error("Non little-endian hardware is not supported");
const Gle = Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function wj(e) {
  if (!(e instanceof Uint8Array))
    throw new Error("Uint8Array expected");
  let t = "";
  for (let n = 0; n < e.length; n++)
    t += Gle[e[n]];
  return t;
}
function vj(e) {
  if (typeof e != "string")
    throw new TypeError("hexToBytes: expected string, got " + typeof e);
  if (e.length % 2)
    throw new Error("hexToBytes: received invalid unpadded hex");
  const t = new Uint8Array(e.length / 2);
  for (let n = 0; n < t.length; n++) {
    const r = n * 2, i = e.slice(r, r + 2), o = Number.parseInt(i, 16);
    if (Number.isNaN(o) || o < 0)
      throw new Error("Invalid byte sequence");
    t[n] = o;
  }
  return t;
}
function Yle(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function q0(e) {
  if (typeof e == "string" && (e = Yle(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
class PT {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function H0(e) {
  const t = (r) => e().update(q0(r)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
function Zle(e) {
  const t = (r, i) => e(i).update(q0(r)).digest(), n = e({});
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = (r) => e(r), t;
}
function cI(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function Jle(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function Sj(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function Xle(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  cI(e.outputLen), cI(e.blockLen);
}
function Qle(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function efe(e, t) {
  Sj(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const zi = {
  number: cI,
  bool: Jle,
  bytes: Sj,
  hash: Xle,
  exists: Qle,
  output: efe
};
function tfe(e, t, n, r) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, n, r);
  const i = BigInt(32), o = BigInt(4294967295), a = Number(n >> i & o), s = Number(n & o), c = r ? 4 : 0, l = r ? 0 : 4;
  e.setUint32(t + c, a, r), e.setUint32(t + l, s, r);
}
class Ej extends PT {
  constructor(t, n, r, i) {
    super(), this.blockLen = t, this.outputLen = n, this.padOffset = r, this.isLE = i, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = ZS(this.buffer);
  }
  update(t) {
    zi.exists(this);
    const { view: n, buffer: r, blockLen: i } = this;
    t = q0(t);
    const o = t.length;
    for (let a = 0; a < o; ) {
      const s = Math.min(i - this.pos, o - a);
      if (s === i) {
        const c = ZS(t);
        for (; i <= o - a; a += i)
          this.process(c, a);
        continue;
      }
      r.set(t.subarray(a, a + s), this.pos), this.pos += s, a += s, this.pos === i && (this.process(n, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    zi.exists(this), zi.output(t, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: i, isLE: o } = this;
    let { pos: a } = this;
    n[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > i - a && (this.process(r, 0), a = 0);
    for (let c = a; c < i; c++)
      n[c] = 0;
    tfe(r, i - 8, BigInt(this.length * 8), o), this.process(r, 0);
    const s = ZS(t);
    this.get().forEach((c, l) => s.setUint32(4 * l, c, o));
  }
  digest() {
    const { buffer: t, outputLen: n } = this;
    this.digestInto(t);
    const r = t.slice(0, n);
    return this.destroy(), r;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: n, buffer: r, length: i, finished: o, destroyed: a, pos: s } = this;
    return t.length = i, t.pos = s, t.finished = o, t.destroyed = a, i % n && t.buffer.set(r), t;
  }
}
const nfe = (e, t, n) => e & t ^ ~e & n, rfe = (e, t, n) => e & t ^ e & n ^ t & n, ife = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), hs = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), ps = new Uint32Array(64);
class ofe extends Ej {
  constructor() {
    super(64, 32, 8, !1), this.A = hs[0] | 0, this.B = hs[1] | 0, this.C = hs[2] | 0, this.D = hs[3] | 0, this.E = hs[4] | 0, this.F = hs[5] | 0, this.G = hs[6] | 0, this.H = hs[7] | 0;
  }
  get() {
    const { A: t, B: n, C: r, D: i, E: o, F: a, G: s, H: c } = this;
    return [t, n, r, i, o, a, s, c];
  }
  // prettier-ignore
  set(t, n, r, i, o, a, s, c) {
    this.A = t | 0, this.B = n | 0, this.C = r | 0, this.D = i | 0, this.E = o | 0, this.F = a | 0, this.G = s | 0, this.H = c | 0;
  }
  process(t, n) {
    for (let f = 0; f < 16; f++, n += 4)
      ps[f] = t.getUint32(n, !1);
    for (let f = 16; f < 64; f++) {
      const d = ps[f - 15], h = ps[f - 2], g = Xo(d, 7) ^ Xo(d, 18) ^ d >>> 3, w = Xo(h, 17) ^ Xo(h, 19) ^ h >>> 10;
      ps[f] = w + ps[f - 7] + g + ps[f - 16] | 0;
    }
    let { A: r, B: i, C: o, D: a, E: s, F: c, G: l, H: u } = this;
    for (let f = 0; f < 64; f++) {
      const d = Xo(s, 6) ^ Xo(s, 11) ^ Xo(s, 25), h = u + d + nfe(s, c, l) + ife[f] + ps[f] | 0, w = (Xo(r, 2) ^ Xo(r, 13) ^ Xo(r, 22)) + rfe(r, i, o) | 0;
      u = l, l = c, c = s, s = a + h | 0, a = o, o = i, i = r, r = h + w | 0;
    }
    r = r + this.A | 0, i = i + this.B | 0, o = o + this.C | 0, a = a + this.D | 0, s = s + this.E | 0, c = c + this.F | 0, l = l + this.G | 0, u = u + this.H | 0, this.set(r, i, o, a, s, c, l, u);
  }
  roundClean() {
    ps.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const afe = H0(() => new ofe()), Yg = BigInt(2 ** 32 - 1), uI = BigInt(32);
function Aj(e, t = !1) {
  return t ? { h: Number(e & Yg), l: Number(e >> uI & Yg) } : { h: Number(e >> uI & Yg) | 0, l: Number(e & Yg) | 0 };
}
function sfe(e, t = !1) {
  let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
  for (let i = 0; i < e.length; i++) {
    const { h: o, l: a } = Aj(e[i], t);
    [n[i], r[i]] = [o, a];
  }
  return [n, r];
}
const cfe = (e, t) => BigInt(e >>> 0) << uI | BigInt(t >>> 0), ufe = (e, t, n) => e >>> n, lfe = (e, t, n) => e << 32 - n | t >>> n, ffe = (e, t, n) => e >>> n | t << 32 - n, dfe = (e, t, n) => e << 32 - n | t >>> n, hfe = (e, t, n) => e << 64 - n | t >>> n - 32, pfe = (e, t, n) => e >>> n - 32 | t << 64 - n, yfe = (e, t) => t, gfe = (e, t) => e, bfe = (e, t, n) => e << n | t >>> 32 - n, mfe = (e, t, n) => t << n | e >>> 32 - n, _fe = (e, t, n) => t << n - 32 | e >>> 64 - n, wfe = (e, t, n) => e << n - 32 | t >>> 64 - n;
function vfe(e, t, n, r) {
  const i = (t >>> 0) + (r >>> 0);
  return { h: e + n + (i / 2 ** 32 | 0) | 0, l: i | 0 };
}
const Sfe = (e, t, n) => (e >>> 0) + (t >>> 0) + (n >>> 0), Efe = (e, t, n, r) => t + n + r + (e / 2 ** 32 | 0) | 0, Afe = (e, t, n, r) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0), Ife = (e, t, n, r, i) => t + n + r + i + (e / 2 ** 32 | 0) | 0, kfe = (e, t, n, r, i) => (e >>> 0) + (t >>> 0) + (n >>> 0) + (r >>> 0) + (i >>> 0), Tfe = (e, t, n, r, i, o) => t + n + r + i + o + (e / 2 ** 32 | 0) | 0, Dt = {
  fromBig: Aj,
  split: sfe,
  toBig: cfe,
  shrSH: ufe,
  shrSL: lfe,
  rotrSH: ffe,
  rotrSL: dfe,
  rotrBH: hfe,
  rotrBL: pfe,
  rotr32H: yfe,
  rotr32L: gfe,
  rotlSH: bfe,
  rotlSL: mfe,
  rotlBH: _fe,
  rotlBL: wfe,
  add: vfe,
  add3L: Sfe,
  add3H: Efe,
  add4L: Afe,
  add4H: Ife,
  add5H: Tfe,
  add5L: kfe
}, [Ij, kj, Tj] = [[], [], []], xfe = BigInt(0), Af = BigInt(1), Mfe = BigInt(2), Ofe = BigInt(7), Pfe = BigInt(256), Bfe = BigInt(113);
for (let e = 0, t = Af, n = 1, r = 0; e < 24; e++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], Ij.push(2 * (5 * r + n)), kj.push((e + 1) * (e + 2) / 2 % 64);
  let i = xfe;
  for (let o = 0; o < 7; o++)
    t = (t << Af ^ (t >> Ofe) * Bfe) % Pfe, t & Mfe && (i ^= Af << (Af << BigInt(o)) - Af);
  Tj.push(i);
}
const [Cfe, Dfe] = Dt.split(Tj, !0), cB = (e, t, n) => n > 32 ? Dt.rotlBH(e, t, n) : Dt.rotlSH(e, t, n), uB = (e, t, n) => n > 32 ? Dt.rotlBL(e, t, n) : Dt.rotlSL(e, t, n);
function Rfe(e, t = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - t; r < 24; r++) {
    for (let a = 0; a < 10; a++)
      n[a] = e[a] ^ e[a + 10] ^ e[a + 20] ^ e[a + 30] ^ e[a + 40];
    for (let a = 0; a < 10; a += 2) {
      const s = (a + 8) % 10, c = (a + 2) % 10, l = n[c], u = n[c + 1], f = cB(l, u, 1) ^ n[s], d = uB(l, u, 1) ^ n[s + 1];
      for (let h = 0; h < 50; h += 10)
        e[a + h] ^= f, e[a + h + 1] ^= d;
    }
    let i = e[2], o = e[3];
    for (let a = 0; a < 24; a++) {
      const s = kj[a], c = cB(i, o, s), l = uB(i, o, s), u = Ij[a];
      i = e[u], o = e[u + 1], e[u] = c, e[u + 1] = l;
    }
    for (let a = 0; a < 50; a += 10) {
      for (let s = 0; s < 10; s++)
        n[s] = e[a + s];
      for (let s = 0; s < 10; s++)
        e[a + s] ^= ~n[(s + 2) % 10] & n[(s + 4) % 10];
    }
    e[0] ^= Cfe[r], e[1] ^= Dfe[r];
  }
  n.fill(0);
}
class xw extends PT {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, n, r, i = !1, o = 24) {
    if (super(), this.blockLen = t, this.suffix = n, this.outputLen = r, this.enableXOF = i, this.rounds = o, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, zi.number(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = qle(this.state);
  }
  keccak() {
    Rfe(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    zi.exists(this);
    const { blockLen: n, state: r } = this;
    t = q0(t);
    const i = t.length;
    for (let o = 0; o < i; ) {
      const a = Math.min(n - this.pos, i - o);
      for (let s = 0; s < a; s++)
        r[this.pos++] ^= t[o++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: n, pos: r, blockLen: i } = this;
    t[r] ^= n, n & 128 && r === i - 1 && this.keccak(), t[i - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    zi.exists(this, !1), zi.bytes(t), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let i = 0, o = t.length; i < o; ) {
      this.posOut >= r && this.keccak();
      const a = Math.min(r - this.posOut, o - i);
      t.set(n.subarray(this.posOut, this.posOut + a), i), this.posOut += a, i += a;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return zi.number(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (zi.output(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: n, suffix: r, outputLen: i, rounds: o, enableXOF: a } = this;
    return t || (t = new xw(n, r, i, a, o)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = o, t.suffix = r, t.outputLen = i, t.enableXOF = a, t.destroyed = this.destroyed, t;
  }
}
const sc = (e, t, n) => H0(() => new xw(t, e, n));
sc(6, 144, 224 / 8);
const Ol = sc(6, 136, 256 / 8);
sc(6, 104, 384 / 8);
sc(6, 72, 512 / 8);
sc(1, 144, 224 / 8);
sc(1, 136, 256 / 8);
sc(1, 104, 384 / 8);
sc(1, 72, 512 / 8);
const xj = (e, t, n) => Zle((r = {}) => new xw(t, e, r.dkLen === void 0 ? n : r.dkLen, !0));
xj(31, 168, 128 / 8);
xj(31, 136, 256 / 8);
class Mj extends PT {
  constructor(t, n) {
    super(), this.finished = !1, this.destroyed = !1, zi.hash(t);
    const r = q0(n);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new TypeError("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const i = this.blockLen, o = new Uint8Array(i);
    o.set(r.length > i ? t.create().update(r).digest() : r);
    for (let a = 0; a < o.length; a++)
      o[a] ^= 54;
    this.iHash.update(o), this.oHash = t.create();
    for (let a = 0; a < o.length; a++)
      o[a] ^= 106;
    this.oHash.update(o), o.fill(0);
  }
  update(t) {
    return zi.exists(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    zi.exists(this), zi.bytes(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: n, iHash: r, finished: i, destroyed: o, blockLen: a, outputLen: s } = this;
    return t = t, t.finished = i, t.destroyed = o, t.blockLen = a, t.outputLen = s, t.oHash = n._cloneInto(t.oHash), t.iHash = r._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const BT = (e, t, n) => new Mj(e, t).update(n).digest();
BT.create = (e, t) => new Mj(e, t);
const [Nfe, jfe] = Dt.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), ys = new Uint32Array(80), gs = new Uint32Array(80);
class CT extends Ej {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  // prettier-ignore
  get() {
    const { Ah: t, Al: n, Bh: r, Bl: i, Ch: o, Cl: a, Dh: s, Dl: c, Eh: l, El: u, Fh: f, Fl: d, Gh: h, Gl: g, Hh: w, Hl: b } = this;
    return [t, n, r, i, o, a, s, c, l, u, f, d, h, g, w, b];
  }
  // prettier-ignore
  set(t, n, r, i, o, a, s, c, l, u, f, d, h, g, w, b) {
    this.Ah = t | 0, this.Al = n | 0, this.Bh = r | 0, this.Bl = i | 0, this.Ch = o | 0, this.Cl = a | 0, this.Dh = s | 0, this.Dl = c | 0, this.Eh = l | 0, this.El = u | 0, this.Fh = f | 0, this.Fl = d | 0, this.Gh = h | 0, this.Gl = g | 0, this.Hh = w | 0, this.Hl = b | 0;
  }
  process(t, n) {
    for (let x = 0; x < 16; x++, n += 4)
      ys[x] = t.getUint32(n), gs[x] = t.getUint32(n += 4);
    for (let x = 16; x < 80; x++) {
      const N = ys[x - 15] | 0, j = gs[x - 15] | 0, K = Dt.rotrSH(N, j, 1) ^ Dt.rotrSH(N, j, 8) ^ Dt.shrSH(N, j, 7), W = Dt.rotrSL(N, j, 1) ^ Dt.rotrSL(N, j, 8) ^ Dt.shrSL(N, j, 7), O = ys[x - 2] | 0, k = gs[x - 2] | 0, z = Dt.rotrSH(O, k, 19) ^ Dt.rotrBH(O, k, 61) ^ Dt.shrSH(O, k, 6), C = Dt.rotrSL(O, k, 19) ^ Dt.rotrBL(O, k, 61) ^ Dt.shrSL(O, k, 6), M = Dt.add4L(W, C, gs[x - 7], gs[x - 16]), S = Dt.add4H(M, K, z, ys[x - 7], ys[x - 16]);
      ys[x] = S | 0, gs[x] = M | 0;
    }
    let { Ah: r, Al: i, Bh: o, Bl: a, Ch: s, Cl: c, Dh: l, Dl: u, Eh: f, El: d, Fh: h, Fl: g, Gh: w, Gl: b, Hh: I, Hl: A } = this;
    for (let x = 0; x < 80; x++) {
      const N = Dt.rotrSH(f, d, 14) ^ Dt.rotrSH(f, d, 18) ^ Dt.rotrBH(f, d, 41), j = Dt.rotrSL(f, d, 14) ^ Dt.rotrSL(f, d, 18) ^ Dt.rotrBL(f, d, 41), K = f & h ^ ~f & w, W = d & g ^ ~d & b, O = Dt.add5L(A, j, W, jfe[x], gs[x]), k = Dt.add5H(O, I, N, K, Nfe[x], ys[x]), z = O | 0, C = Dt.rotrSH(r, i, 28) ^ Dt.rotrBH(r, i, 34) ^ Dt.rotrBH(r, i, 39), M = Dt.rotrSL(r, i, 28) ^ Dt.rotrBL(r, i, 34) ^ Dt.rotrBL(r, i, 39), S = r & o ^ r & s ^ o & s, p = i & a ^ i & c ^ a & c;
      I = w | 0, A = b | 0, w = h | 0, b = g | 0, h = f | 0, g = d | 0, { h: f, l: d } = Dt.add(l | 0, u | 0, k | 0, z | 0), l = s | 0, u = c | 0, s = o | 0, c = a | 0, o = r | 0, a = i | 0;
      const y = Dt.add3L(z, M, p);
      r = Dt.add3H(y, k, C, S), i = y | 0;
    }
    ({ h: r, l: i } = Dt.add(this.Ah | 0, this.Al | 0, r | 0, i | 0)), { h: o, l: a } = Dt.add(this.Bh | 0, this.Bl | 0, o | 0, a | 0), { h: s, l: c } = Dt.add(this.Ch | 0, this.Cl | 0, s | 0, c | 0), { h: l, l: u } = Dt.add(this.Dh | 0, this.Dl | 0, l | 0, u | 0), { h: f, l: d } = Dt.add(this.Eh | 0, this.El | 0, f | 0, d | 0), { h, l: g } = Dt.add(this.Fh | 0, this.Fl | 0, h | 0, g | 0), { h: w, l: b } = Dt.add(this.Gh | 0, this.Gl | 0, w | 0, b | 0), { h: I, l: A } = Dt.add(this.Hh | 0, this.Hl | 0, I | 0, A | 0), this.set(r, i, o, a, s, c, l, u, f, d, h, g, w, b, I, A);
  }
  roundClean() {
    ys.fill(0), gs.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
class Ufe extends CT {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
class zfe extends CT {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
}
const Oj = H0(() => new CT());
H0(() => new Ufe());
H0(() => new zfe());
var DT = { exports: {} }, Pj = function(t, n) {
  return function() {
    for (var i = new Array(arguments.length), o = 0; o < i.length; o++)
      i[o] = arguments[o];
    return t.apply(n, i);
  };
}, Ffe = Pj, RT = Object.prototype.toString, NT = function(e) {
  return function(t) {
    var n = RT.call(t);
    return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function lu(e) {
  return e = e.toLowerCase(), function(n) {
    return NT(n) === e;
  };
}
function jT(e) {
  return Array.isArray(e);
}
function am(e) {
  return typeof e > "u";
}
function Lfe(e) {
  return e !== null && !am(e) && e.constructor !== null && !am(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
var Bj = lu("ArrayBuffer");
function $fe(e) {
  var t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Bj(e.buffer), t;
}
function Wfe(e) {
  return typeof e == "string";
}
function Kfe(e) {
  return typeof e == "number";
}
function Cj(e) {
  return e !== null && typeof e == "object";
}
function yb(e) {
  if (NT(e) !== "object")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
var Vfe = lu("Date"), qfe = lu("File"), Hfe = lu("Blob"), Gfe = lu("FileList");
function UT(e) {
  return RT.call(e) === "[object Function]";
}
function Yfe(e) {
  return Cj(e) && UT(e.pipe);
}
function Zfe(e) {
  var t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || RT.call(e) === t || UT(e.toString) && e.toString() === t);
}
var Jfe = lu("URLSearchParams");
function Xfe(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function Qfe() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function zT(e, t) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), jT(e))
      for (var n = 0, r = e.length; n < r; n++)
        t.call(null, e[n], n, e);
    else
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && t.call(null, e[i], i, e);
}
function lI() {
  var e = {};
  function t(i, o) {
    yb(e[o]) && yb(i) ? e[o] = lI(e[o], i) : yb(i) ? e[o] = lI({}, i) : jT(i) ? e[o] = i.slice() : e[o] = i;
  }
  for (var n = 0, r = arguments.length; n < r; n++)
    zT(arguments[n], t);
  return e;
}
function ede(e, t, n) {
  return zT(t, function(i, o) {
    n && typeof i == "function" ? e[o] = Ffe(i, n) : e[o] = i;
  }), e;
}
function tde(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
function nde(e, t, n, r) {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, n && Object.assign(e.prototype, n);
}
function rde(e, t, n) {
  var r, i, o, a = {};
  t = t || {};
  do {
    for (r = Object.getOwnPropertyNames(e), i = r.length; i-- > 0; )
      o = r[i], a[o] || (t[o] = e[o], a[o] = !0);
    e = Object.getPrototypeOf(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}
function ide(e, t, n) {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  var r = e.indexOf(t, n);
  return r !== -1 && r === n;
}
function ode(e) {
  if (!e)
    return null;
  var t = e.length;
  if (am(t))
    return null;
  for (var n = new Array(t); t-- > 0; )
    n[t] = e[t];
  return n;
}
var ade = function(e) {
  return function(t) {
    return e && t instanceof e;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), Qr = {
  isArray: jT,
  isArrayBuffer: Bj,
  isBuffer: Lfe,
  isFormData: Zfe,
  isArrayBufferView: $fe,
  isString: Wfe,
  isNumber: Kfe,
  isObject: Cj,
  isPlainObject: yb,
  isUndefined: am,
  isDate: Vfe,
  isFile: qfe,
  isBlob: Hfe,
  isFunction: UT,
  isStream: Yfe,
  isURLSearchParams: Jfe,
  isStandardBrowserEnv: Qfe,
  forEach: zT,
  merge: lI,
  extend: ede,
  trim: Xfe,
  stripBOM: tde,
  inherits: nde,
  toFlatObject: rde,
  kindOf: NT,
  kindOfTest: lu,
  endsWith: ide,
  toArray: ode,
  isTypedArray: ade,
  isFileList: Gfe
}, ku = Qr;
function lB(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Dj = function(t, n, r) {
  if (!n)
    return t;
  var i;
  if (r)
    i = r(n);
  else if (ku.isURLSearchParams(n))
    i = n.toString();
  else {
    var o = [];
    ku.forEach(n, function(c, l) {
      c === null || typeof c > "u" || (ku.isArray(c) ? l = l + "[]" : c = [c], ku.forEach(c, function(f) {
        ku.isDate(f) ? f = f.toISOString() : ku.isObject(f) && (f = JSON.stringify(f)), o.push(lB(l) + "=" + lB(f));
      }));
    }), i = o.join("&");
  }
  if (i) {
    var a = t.indexOf("#");
    a !== -1 && (t = t.slice(0, a)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}, sde = Qr;
function Mw() {
  this.handlers = [];
}
Mw.prototype.use = function(t, n, r) {
  return this.handlers.push({
    fulfilled: t,
    rejected: n,
    synchronous: r ? r.synchronous : !1,
    runWhen: r ? r.runWhen : null
  }), this.handlers.length - 1;
};
Mw.prototype.eject = function(t) {
  this.handlers[t] && (this.handlers[t] = null);
};
Mw.prototype.forEach = function(t) {
  sde.forEach(this.handlers, function(r) {
    r !== null && t(r);
  });
};
var cde = Mw, ude = Qr, lde = function(t, n) {
  ude.forEach(t, function(i, o) {
    o !== n && o.toUpperCase() === n.toUpperCase() && (t[n] = i, delete t[o]);
  });
}, Rj = Qr;
function Pl(e, t, n, r, i) {
  Error.call(this), this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i);
}
Rj.inherits(Pl, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var Nj = Pl.prototype, jj = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(e) {
  jj[e] = { value: e };
});
Object.defineProperties(Pl, jj);
Object.defineProperty(Nj, "isAxiosError", { value: !0 });
Pl.from = function(e, t, n, r, i, o) {
  var a = Object.create(Nj);
  return Rj.toFlatObject(e, a, function(c) {
    return c !== Error.prototype;
  }), Pl.call(a, e.message, t, n, r, i), a.name = e.name, o && Object.assign(a, o), a;
};
var Ql = Pl, Uj = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, vo = Qr;
function fde(e, t) {
  t = t || new FormData();
  var n = [];
  function r(o) {
    return o === null ? "" : vo.isDate(o) ? o.toISOString() : vo.isArrayBuffer(o) || vo.isTypedArray(o) ? typeof Blob == "function" ? new Blob([o]) : Buffer.from(o) : o;
  }
  function i(o, a) {
    if (vo.isPlainObject(o) || vo.isArray(o)) {
      if (n.indexOf(o) !== -1)
        throw Error("Circular reference detected in " + a);
      n.push(o), vo.forEach(o, function(c, l) {
        if (!vo.isUndefined(c)) {
          var u = a ? a + "." + l : l, f;
          if (c && !a && typeof c == "object") {
            if (vo.endsWith(l, "{}"))
              c = JSON.stringify(c);
            else if (vo.endsWith(l, "[]") && (f = vo.toArray(c))) {
              f.forEach(function(d) {
                !vo.isUndefined(d) && t.append(u, r(d));
              });
              return;
            }
          }
          i(c, u);
        }
      }), n.pop();
    } else
      t.append(a, r(o));
  }
  return i(e), t;
}
var zj = fde, JS, fB;
function dde() {
  if (fB)
    return JS;
  fB = 1;
  var e = Ql;
  return JS = function(n, r, i) {
    var o = i.config.validateStatus;
    !i.status || !o || o(i.status) ? n(i) : r(new e(
      "Request failed with status code " + i.status,
      [e.ERR_BAD_REQUEST, e.ERR_BAD_RESPONSE][Math.floor(i.status / 100) - 4],
      i.config,
      i.request,
      i
    ));
  }, JS;
}
var XS, dB;
function hde() {
  if (dB)
    return XS;
  dB = 1;
  var e = Qr;
  return XS = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(r, i, o, a, s, c) {
          var l = [];
          l.push(r + "=" + encodeURIComponent(i)), e.isNumber(o) && l.push("expires=" + new Date(o).toGMTString()), e.isString(a) && l.push("path=" + a), e.isString(s) && l.push("domain=" + s), c === !0 && l.push("secure"), document.cookie = l.join("; ");
        },
        read: function(r) {
          var i = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
          return i ? decodeURIComponent(i[3]) : null;
        },
        remove: function(r) {
          this.write(r, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), XS;
}
var pde = function(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}, yde = function(t, n) {
  return n ? t.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : t;
}, gde = pde, bde = yde, Fj = function(t, n) {
  return t && !gde(n) ? bde(t, n) : n;
}, QS, hB;
function mde() {
  if (hB)
    return QS;
  hB = 1;
  var e = Qr, t = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return QS = function(r) {
    var i = {}, o, a, s;
    return r && e.forEach(r.split(`
`), function(l) {
      if (s = l.indexOf(":"), o = e.trim(l.substr(0, s)).toLowerCase(), a = e.trim(l.substr(s + 1)), o) {
        if (i[o] && t.indexOf(o) >= 0)
          return;
        o === "set-cookie" ? i[o] = (i[o] ? i[o] : []).concat([a]) : i[o] = i[o] ? i[o] + ", " + a : a;
      }
    }), i;
  }, QS;
}
var eE, pB;
function _de() {
  if (pB)
    return eE;
  pB = 1;
  var e = Qr;
  return eE = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var n = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a"), i;
      function o(a) {
        var s = a;
        return n && (r.setAttribute("href", s), s = r.href), r.setAttribute("href", s), {
          href: r.href,
          protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
          host: r.host,
          search: r.search ? r.search.replace(/^\?/, "") : "",
          hash: r.hash ? r.hash.replace(/^#/, "") : "",
          hostname: r.hostname,
          port: r.port,
          pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
        };
      }
      return i = o(window.location.href), function(s) {
        var c = e.isString(s) ? o(s) : s;
        return c.protocol === i.protocol && c.host === i.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), eE;
}
var tE, yB;
function Ow() {
  if (yB)
    return tE;
  yB = 1;
  var e = Ql, t = Qr;
  function n(r) {
    e.call(this, r ?? "canceled", e.ERR_CANCELED), this.name = "CanceledError";
  }
  return t.inherits(n, e, {
    __CANCEL__: !0
  }), tE = n, tE;
}
var nE, gB;
function wde() {
  return gB || (gB = 1, nE = function(t) {
    var n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
    return n && n[1] || "";
  }), nE;
}
var rE, bB;
function mB() {
  if (bB)
    return rE;
  bB = 1;
  var e = Qr, t = dde(), n = hde(), r = Dj, i = Fj, o = mde(), a = _de(), s = Uj, c = Ql, l = Ow(), u = wde();
  return rE = function(d) {
    return new Promise(function(g, w) {
      var b = d.data, I = d.headers, A = d.responseType, x;
      function N() {
        d.cancelToken && d.cancelToken.unsubscribe(x), d.signal && d.signal.removeEventListener("abort", x);
      }
      e.isFormData(b) && e.isStandardBrowserEnv() && delete I["Content-Type"];
      var j = new XMLHttpRequest();
      if (d.auth) {
        var K = d.auth.username || "", W = d.auth.password ? unescape(encodeURIComponent(d.auth.password)) : "";
        I.Authorization = "Basic " + btoa(K + ":" + W);
      }
      var O = i(d.baseURL, d.url);
      j.open(d.method.toUpperCase(), r(O, d.params, d.paramsSerializer), !0), j.timeout = d.timeout;
      function k() {
        if (j) {
          var M = "getAllResponseHeaders" in j ? o(j.getAllResponseHeaders()) : null, S = !A || A === "text" || A === "json" ? j.responseText : j.response, p = {
            data: S,
            status: j.status,
            statusText: j.statusText,
            headers: M,
            config: d,
            request: j
          };
          t(function(v) {
            g(v), N();
          }, function(v) {
            w(v), N();
          }, p), j = null;
        }
      }
      if ("onloadend" in j ? j.onloadend = k : j.onreadystatechange = function() {
        !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.indexOf("file:") === 0) || setTimeout(k);
      }, j.onabort = function() {
        j && (w(new c("Request aborted", c.ECONNABORTED, d, j)), j = null);
      }, j.onerror = function() {
        w(new c("Network Error", c.ERR_NETWORK, d, j, j)), j = null;
      }, j.ontimeout = function() {
        var S = d.timeout ? "timeout of " + d.timeout + "ms exceeded" : "timeout exceeded", p = d.transitional || s;
        d.timeoutErrorMessage && (S = d.timeoutErrorMessage), w(new c(
          S,
          p.clarifyTimeoutError ? c.ETIMEDOUT : c.ECONNABORTED,
          d,
          j
        )), j = null;
      }, e.isStandardBrowserEnv()) {
        var z = (d.withCredentials || a(O)) && d.xsrfCookieName ? n.read(d.xsrfCookieName) : void 0;
        z && (I[d.xsrfHeaderName] = z);
      }
      "setRequestHeader" in j && e.forEach(I, function(S, p) {
        typeof b > "u" && p.toLowerCase() === "content-type" ? delete I[p] : j.setRequestHeader(p, S);
      }), e.isUndefined(d.withCredentials) || (j.withCredentials = !!d.withCredentials), A && A !== "json" && (j.responseType = d.responseType), typeof d.onDownloadProgress == "function" && j.addEventListener("progress", d.onDownloadProgress), typeof d.onUploadProgress == "function" && j.upload && j.upload.addEventListener("progress", d.onUploadProgress), (d.cancelToken || d.signal) && (x = function(M) {
        j && (w(!M || M && M.type ? new l() : M), j.abort(), j = null);
      }, d.cancelToken && d.cancelToken.subscribe(x), d.signal && (d.signal.aborted ? x() : d.signal.addEventListener("abort", x))), b || (b = null);
      var C = u(O);
      if (C && ["http", "https", "file"].indexOf(C) === -1) {
        w(new c("Unsupported protocol " + C + ":", c.ERR_BAD_REQUEST, d));
        return;
      }
      j.send(b);
    });
  }, rE;
}
var iE, _B;
function vde() {
  return _B || (_B = 1, iE = null), iE;
}
var Ur = Qr, wB = lde, vB = Ql, Sde = Uj, Ede = zj, Ade = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function SB(e, t) {
  !Ur.isUndefined(e) && Ur.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
}
function Ide() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (e = mB()), e;
}
function kde(e, t, n) {
  if (Ur.isString(e))
    try {
      return (t || JSON.parse)(e), Ur.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
var Pw = {
  transitional: Sde,
  adapter: Ide(),
  transformRequest: [function(t, n) {
    if (wB(n, "Accept"), wB(n, "Content-Type"), Ur.isFormData(t) || Ur.isArrayBuffer(t) || Ur.isBuffer(t) || Ur.isStream(t) || Ur.isFile(t) || Ur.isBlob(t))
      return t;
    if (Ur.isArrayBufferView(t))
      return t.buffer;
    if (Ur.isURLSearchParams(t))
      return SB(n, "application/x-www-form-urlencoded;charset=utf-8"), t.toString();
    var r = Ur.isObject(t), i = n && n["Content-Type"], o;
    if ((o = Ur.isFileList(t)) || r && i === "multipart/form-data") {
      var a = this.env && this.env.FormData;
      return Ede(o ? { "files[]": t } : t, a && new a());
    } else if (r || i === "application/json")
      return SB(n, "application/json"), kde(t);
    return t;
  }],
  transformResponse: [function(t) {
    var n = this.transitional || Pw.transitional, r = n && n.silentJSONParsing, i = n && n.forcedJSONParsing, o = !r && this.responseType === "json";
    if (o || i && Ur.isString(t) && t.length)
      try {
        return JSON.parse(t);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? vB.from(a, vB.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: vde()
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
Ur.forEach(["delete", "get", "head"], function(t) {
  Pw.headers[t] = {};
});
Ur.forEach(["post", "put", "patch"], function(t) {
  Pw.headers[t] = Ur.merge(Ade);
});
var FT = Pw, Tde = Qr, xde = FT, Mde = function(t, n, r) {
  var i = this || xde;
  return Tde.forEach(r, function(a) {
    t = a.call(i, t, n);
  }), t;
}, oE, EB;
function Lj() {
  return EB || (EB = 1, oE = function(t) {
    return !!(t && t.__CANCEL__);
  }), oE;
}
var AB = Qr, aE = Mde, Ode = Lj(), Pde = FT, Bde = Ow();
function sE(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Bde();
}
var Cde = function(t) {
  sE(t), t.headers = t.headers || {}, t.data = aE.call(
    t,
    t.data,
    t.headers,
    t.transformRequest
  ), t.headers = AB.merge(
    t.headers.common || {},
    t.headers[t.method] || {},
    t.headers
  ), AB.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(i) {
      delete t.headers[i];
    }
  );
  var n = t.adapter || Pde.adapter;
  return n(t).then(function(i) {
    return sE(t), i.data = aE.call(
      t,
      i.data,
      i.headers,
      t.transformResponse
    ), i;
  }, function(i) {
    return Ode(i) || (sE(t), i && i.response && (i.response.data = aE.call(
      t,
      i.response.data,
      i.response.headers,
      t.transformResponse
    ))), Promise.reject(i);
  });
}, Bi = Qr, $j = function(t, n) {
  n = n || {};
  var r = {};
  function i(u, f) {
    return Bi.isPlainObject(u) && Bi.isPlainObject(f) ? Bi.merge(u, f) : Bi.isPlainObject(f) ? Bi.merge({}, f) : Bi.isArray(f) ? f.slice() : f;
  }
  function o(u) {
    if (Bi.isUndefined(n[u])) {
      if (!Bi.isUndefined(t[u]))
        return i(void 0, t[u]);
    } else
      return i(t[u], n[u]);
  }
  function a(u) {
    if (!Bi.isUndefined(n[u]))
      return i(void 0, n[u]);
  }
  function s(u) {
    if (Bi.isUndefined(n[u])) {
      if (!Bi.isUndefined(t[u]))
        return i(void 0, t[u]);
    } else
      return i(void 0, n[u]);
  }
  function c(u) {
    if (u in n)
      return i(t[u], n[u]);
    if (u in t)
      return i(void 0, t[u]);
  }
  var l = {
    url: a,
    method: a,
    data: a,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: c
  };
  return Bi.forEach(Object.keys(t).concat(Object.keys(n)), function(f) {
    var d = l[f] || o, h = d(f);
    Bi.isUndefined(h) && d !== c || (r[f] = h);
  }), r;
}, cE, IB;
function Wj() {
  return IB || (IB = 1, cE = {
    version: "0.27.2"
  }), cE;
}
var Dde = Wj().version, Es = Ql, LT = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, t) {
  LT[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var kB = {};
LT.transitional = function(t, n, r) {
  function i(o, a) {
    return "[Axios v" + Dde + "] Transitional option '" + o + "'" + a + (r ? ". " + r : "");
  }
  return function(o, a, s) {
    if (t === !1)
      throw new Es(
        i(a, " has been removed" + (n ? " in " + n : "")),
        Es.ERR_DEPRECATED
      );
    return n && !kB[a] && (kB[a] = !0, console.warn(
      i(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, a, s) : !0;
  };
};
function Rde(e, t, n) {
  if (typeof e != "object")
    throw new Es("options must be an object", Es.ERR_BAD_OPTION_VALUE);
  for (var r = Object.keys(e), i = r.length; i-- > 0; ) {
    var o = r[i], a = t[o];
    if (a) {
      var s = e[o], c = s === void 0 || a(s, o, e);
      if (c !== !0)
        throw new Es("option " + o + " must be " + c, Es.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Es("Unknown option " + o, Es.ERR_BAD_OPTION);
  }
}
var Nde = {
  assertOptions: Rde,
  validators: LT
}, Kj = Qr, jde = Dj, TB = cde, xB = Cde, Bw = $j, Ude = Fj, Vj = Nde, Tu = Vj.validators;
function Bl(e) {
  this.defaults = e, this.interceptors = {
    request: new TB(),
    response: new TB()
  };
}
Bl.prototype.request = function(t, n) {
  typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Bw(this.defaults, n), n.method ? n.method = n.method.toLowerCase() : this.defaults.method ? n.method = this.defaults.method.toLowerCase() : n.method = "get";
  var r = n.transitional;
  r !== void 0 && Vj.assertOptions(r, {
    silentJSONParsing: Tu.transitional(Tu.boolean),
    forcedJSONParsing: Tu.transitional(Tu.boolean),
    clarifyTimeoutError: Tu.transitional(Tu.boolean)
  }, !1);
  var i = [], o = !0;
  this.interceptors.request.forEach(function(h) {
    typeof h.runWhen == "function" && h.runWhen(n) === !1 || (o = o && h.synchronous, i.unshift(h.fulfilled, h.rejected));
  });
  var a = [];
  this.interceptors.response.forEach(function(h) {
    a.push(h.fulfilled, h.rejected);
  });
  var s;
  if (!o) {
    var c = [xB, void 0];
    for (Array.prototype.unshift.apply(c, i), c = c.concat(a), s = Promise.resolve(n); c.length; )
      s = s.then(c.shift(), c.shift());
    return s;
  }
  for (var l = n; i.length; ) {
    var u = i.shift(), f = i.shift();
    try {
      l = u(l);
    } catch (d) {
      f(d);
      break;
    }
  }
  try {
    s = xB(l);
  } catch (d) {
    return Promise.reject(d);
  }
  for (; a.length; )
    s = s.then(a.shift(), a.shift());
  return s;
};
Bl.prototype.getUri = function(t) {
  t = Bw(this.defaults, t);
  var n = Ude(t.baseURL, t.url);
  return jde(n, t.params, t.paramsSerializer);
};
Kj.forEach(["delete", "get", "head", "options"], function(t) {
  Bl.prototype[t] = function(n, r) {
    return this.request(Bw(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
Kj.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(o, a, s) {
      return this.request(Bw(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: a
      }));
    };
  }
  Bl.prototype[t] = n(), Bl.prototype[t + "Form"] = n(!0);
});
var zde = Bl, uE, MB;
function Fde() {
  if (MB)
    return uE;
  MB = 1;
  var e = Ow();
  function t(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    var r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    var i = this;
    this.promise.then(function(o) {
      if (i._listeners) {
        var a, s = i._listeners.length;
        for (a = 0; a < s; a++)
          i._listeners[a](o);
        i._listeners = null;
      }
    }), this.promise.then = function(o) {
      var a, s = new Promise(function(c) {
        i.subscribe(c), a = c;
      }).then(o);
      return s.cancel = function() {
        i.unsubscribe(a);
      }, s;
    }, n(function(a) {
      i.reason || (i.reason = new e(a), r(i.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.prototype.subscribe = function(r) {
    if (this.reason) {
      r(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(r) : this._listeners = [r];
  }, t.prototype.unsubscribe = function(r) {
    if (this._listeners) {
      var i = this._listeners.indexOf(r);
      i !== -1 && this._listeners.splice(i, 1);
    }
  }, t.source = function() {
    var r, i = new t(function(a) {
      r = a;
    });
    return {
      token: i,
      cancel: r
    };
  }, uE = t, uE;
}
var lE, OB;
function Lde() {
  return OB || (OB = 1, lE = function(t) {
    return function(r) {
      return t.apply(null, r);
    };
  }), lE;
}
var fE, PB;
function $de() {
  if (PB)
    return fE;
  PB = 1;
  var e = Qr;
  return fE = function(n) {
    return e.isObject(n) && n.isAxiosError === !0;
  }, fE;
}
var BB = Qr, Wde = Pj, gb = zde, Kde = $j, Vde = FT;
function qj(e) {
  var t = new gb(e), n = Wde(gb.prototype.request, t);
  return BB.extend(n, gb.prototype, t), BB.extend(n, t), n.create = function(i) {
    return qj(Kde(e, i));
  }, n;
}
var xi = qj(Vde);
xi.Axios = gb;
xi.CanceledError = Ow();
xi.CancelToken = Fde();
xi.isCancel = Lj();
xi.VERSION = Wj().version;
xi.toFormData = zj;
xi.AxiosError = Ql;
xi.Cancel = xi.CanceledError;
xi.all = function(t) {
  return Promise.all(t);
};
xi.spread = Lde();
xi.isAxiosError = $de();
DT.exports = xi;
DT.exports.default = xi;
var qde = DT.exports, Hde = qde;
const Gde = /* @__PURE__ */ Vi(Hde);
async function Yde(e) {
  var t;
  const { params: n, method: r, url: i, headers: o, body: a, overrides: s } = e, c = {
    headers: o,
    method: r,
    url: i,
    params: n,
    data: a,
    withCredentials: (t = s == null ? void 0 : s.WITH_CREDENTIALS) != null ? t : !0
  };
  try {
    const l = await Gde(c);
    return {
      status: l.status,
      statusText: l.statusText,
      data: l.data,
      headers: l.headers,
      config: l.config
    };
  } catch (l) {
    const u = l;
    if (u.response)
      return u.response;
    throw l;
  }
}
var Zde = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
  function i(c, l, u) {
    this.fn = c, this.context = l, this.once = u || !1;
  }
  function o(c, l, u, f, d) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var h = new i(u, f || c, d), g = n ? n + l : l;
    return c._events[g] ? c._events[g].fn ? c._events[g] = [c._events[g], h] : c._events[g].push(h) : (c._events[g] = h, c._eventsCount++), c;
  }
  function a(c, l) {
    --c._eventsCount === 0 ? c._events = new r() : delete c._events[l];
  }
  function s() {
    this._events = new r(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var l = [], u, f;
    if (this._eventsCount === 0)
      return l;
    for (f in u = this._events)
      t.call(u, f) && l.push(n ? f.slice(1) : f);
    return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(u)) : l;
  }, s.prototype.listeners = function(l) {
    var u = n ? n + l : l, f = this._events[u];
    if (!f)
      return [];
    if (f.fn)
      return [f.fn];
    for (var d = 0, h = f.length, g = new Array(h); d < h; d++)
      g[d] = f[d].fn;
    return g;
  }, s.prototype.listenerCount = function(l) {
    var u = n ? n + l : l, f = this._events[u];
    return f ? f.fn ? 1 : f.length : 0;
  }, s.prototype.emit = function(l, u, f, d, h, g) {
    var w = n ? n + l : l;
    if (!this._events[w])
      return !1;
    var b = this._events[w], I = arguments.length, A, x;
    if (b.fn) {
      switch (b.once && this.removeListener(l, b.fn, void 0, !0), I) {
        case 1:
          return b.fn.call(b.context), !0;
        case 2:
          return b.fn.call(b.context, u), !0;
        case 3:
          return b.fn.call(b.context, u, f), !0;
        case 4:
          return b.fn.call(b.context, u, f, d), !0;
        case 5:
          return b.fn.call(b.context, u, f, d, h), !0;
        case 6:
          return b.fn.call(b.context, u, f, d, h, g), !0;
      }
      for (x = 1, A = new Array(I - 1); x < I; x++)
        A[x - 1] = arguments[x];
      b.fn.apply(b.context, A);
    } else {
      var N = b.length, j;
      for (x = 0; x < N; x++)
        switch (b[x].once && this.removeListener(l, b[x].fn, void 0, !0), I) {
          case 1:
            b[x].fn.call(b[x].context);
            break;
          case 2:
            b[x].fn.call(b[x].context, u);
            break;
          case 3:
            b[x].fn.call(b[x].context, u, f);
            break;
          case 4:
            b[x].fn.call(b[x].context, u, f, d);
            break;
          default:
            if (!A)
              for (j = 1, A = new Array(I - 1); j < I; j++)
                A[j - 1] = arguments[j];
            b[x].fn.apply(b[x].context, A);
        }
    }
    return !0;
  }, s.prototype.on = function(l, u, f) {
    return o(this, l, u, f, !1);
  }, s.prototype.once = function(l, u, f) {
    return o(this, l, u, f, !0);
  }, s.prototype.removeListener = function(l, u, f, d) {
    var h = n ? n + l : l;
    if (!this._events[h])
      return this;
    if (!u)
      return a(this, h), this;
    var g = this._events[h];
    if (g.fn)
      g.fn === u && (!d || g.once) && (!f || g.context === f) && a(this, h);
    else {
      for (var w = 0, b = [], I = g.length; w < I; w++)
        (g[w].fn !== u || d && !g[w].once || f && g[w].context !== f) && b.push(g[w]);
      b.length ? this._events[h] = b.length === 1 ? b[0] : b : a(this, h);
    }
    return this;
  }, s.prototype.removeAllListeners = function(l) {
    var u;
    return l ? (u = n ? n + l : l, this._events[u] && a(this, u)) : (this._events = new r(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s;
})(Zde);
var Hj = Object.defineProperty, Jde = Object.getOwnPropertyDescriptor, Cw = (e, t) => {
  for (var n in t)
    Hj(e, n, { get: t[n], enumerable: !0 });
}, xn = (e, t, n, r) => {
  for (var i = r > 1 ? void 0 : r ? Jde(t, n) : t, o = e.length - 1, a; o >= 0; o--)
    (a = e[o]) && (i = (r ? a(t, n, i) : a(i)) || i);
  return r && i && Hj(t, n, i), i;
}, Xde = /^m(\/[0-9]+')+$/, Gj = (e) => e.replace("'", ""), Qde = "ed25519 seed", ehe = 2147483648, the = (e) => {
  const n = BT.create(Oj, Qde).update(vj(e)).digest(), r = n.slice(0, 32), i = n.slice(32);
  return {
    key: r,
    chainCode: i
  };
}, nhe = ({ key: e, chainCode: t }, n) => {
  const r = new ArrayBuffer(4);
  new DataView(r).setUint32(0, n);
  const i = new Uint8Array(r), o = new Uint8Array([0]), a = new Uint8Array([...o, ...e, ...i]), s = BT.create(Oj, t).update(a).digest(), c = s.slice(0, 32), l = s.slice(32);
  return {
    key: c,
    chainCode: l
  };
}, rhe = (e) => Xde.test(e) ? !e.split("/").slice(1).map(Gj).some(Number.isNaN) : !1, ihe = (e, t, n = ehe) => {
  if (!rhe(e))
    throw new Error("Invalid derivation path");
  const { key: r, chainCode: i } = the(t);
  return e.split("/").slice(1).map(Gj).map((a) => parseInt(a, 10)).reduce((a, s) => nhe(a, s + n), { key: r, chainCode: i });
}, ohe = "1.17.0";
async function ahe(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
var CB = "/v1";
function she(e) {
  let t = `${e}`;
  return t.endsWith("/") && (t = t.substring(0, t.length - 1)), t.endsWith(CB) || (t = `${t}${CB}`), t;
}
var Yj = 2e5, Zj = 20, che = 20, uhe = "0x1::aptos_coin::AptosCoin";
function Dw(e) {
  let t, n, r;
  return typeof e == "object" ? (t = e.hashFunction, n = e.ttlMs, r = e.tags) : t = e, (i, o, a) => {
    if (a.value != null)
      a.value = DB(a.value, t, n, r);
    else if (a.get != null)
      a.get = DB(a.get, t, n, r);
    else
      throw new Error("Only put a Memoize() decorator on a method or get accessor.");
  };
}
function Jj(e, t) {
  return Dw({
    ttlMs: e,
    hashFunction: t
  });
}
var bb = /* @__PURE__ */ new Map();
function lhe(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e) {
    const r = bb.get(n);
    if (r)
      for (const i of r)
        t.has(i) || (i.clear(), t.add(i));
  }
  return t.size;
}
function DB(e, t, n = 0, r) {
  const i = Symbol("__memoized_map__");
  return function(...o) {
    let a;
    const s = this;
    s.hasOwnProperty(i) || Object.defineProperty(s, i, {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: /* @__PURE__ */ new Map()
    });
    const c = s[i];
    if (Array.isArray(r))
      for (const l of r)
        bb.has(l) ? bb.get(l).push(c) : bb.set(l, [c]);
    if (t || o.length > 0 || n > 0) {
      let l;
      t === !0 ? l = o.map((d) => d.toString()).join("!") : t ? l = t.apply(s, o) : l = o[0];
      const u = `${l}__timestamp`;
      let f = !1;
      if (n > 0)
        if (!c.has(u))
          f = !0;
        else {
          const d = c.get(u);
          f = Date.now() - d > n;
        }
      c.has(l) && !f ? a = c.get(l) : (a = e.apply(s, o), c.set(l, a), n > 0 && c.set(u, Date.now()));
    } else {
      const l = s;
      c.has(l) ? a = c.get(l) : (a = e.apply(s, o), c.set(l, a));
    }
    return a;
  };
}
var Xj = class extends Error {
  constructor(e, t, n) {
    super(n), this.name = "AptosApiError", this.url = t.url, this.status = t.status, this.statusText = t.statusText, this.data = t.data, this.request = e;
  }
}, fhe = {
  400: "Bad Request",
  401: "Unauthorized",
  403: "Forbidden",
  404: "Not Found",
  429: "Too Many Requests",
  500: "Internal Server Error",
  502: "Bad Gateway",
  503: "Service Unavailable"
};
async function dhe(e, t, n, r, i, o) {
  const a = {
    ...o == null ? void 0 : o.HEADERS,
    "x-aptos-client": `aptos-ts-sdk/${ohe}`,
    "content-type": r ?? "application/json"
  };
  return o != null && o.TOKEN && (a.Authorization = `Bearer ${o == null ? void 0 : o.TOKEN}`), await Yde({ url: e, method: t, body: n, params: i, headers: a, overrides: o });
}
async function Qj(e) {
  const { url: t, endpoint: n, method: r, body: i, contentType: o, params: a, overrides: s } = e, c = `${t}/${n ?? ""}`, l = await dhe(c, r, i, o, a, s), u = {
    status: l.status,
    statusText: l.statusText,
    data: l.data,
    headers: l.headers,
    config: l.config,
    url: c
  };
  if (u.status >= 200 && u.status < 300)
    return u;
  const f = fhe[u.status];
  throw new Xj(e, u, f ?? "Generic Error");
}
async function bi(e) {
  return await Qj({ ...e, method: "GET" });
}
async function Cf(e) {
  return await Qj({ ...e, method: "POST" });
}
async function RB(e) {
  const t = [];
  let n;
  const r = e.params;
  for (; ; ) {
    r.start = n;
    const i = await bi({
      url: e.url,
      endpoint: e.endpoint,
      params: r,
      originMethod: e.originMethod,
      overrides: e.overrides
    });
    if (n = i.headers["x-aptos-cursor"], delete i.headers, t.push(...i.data), n == null)
      break;
  }
  return t;
}
var hhe = {
  mainnet: "https://indexer.mainnet.aptoslabs.com/v1/graphql",
  testnet: "https://indexer-testnet.staging.gcp.aptosdev.com/v1/graphql",
  devnet: "https://indexer-devnet.staging.gcp.aptosdev.com/v1/graphql"
}, phe = {
  mainnet: "https://fullnode.mainnet.aptoslabs.com/v1",
  testnet: "https://fullnode.testnet.aptoslabs.com/v1",
  devnet: "https://fullnode.devnet.aptoslabs.com/v1",
  local: "http://localhost:8080/v1"
}, mb = /* @__PURE__ */ ((e) => (e.MAINNET = "mainnet", e.TESTNET = "testnet", e.DEVNET = "devnet", e.LOCAL = "local", e))(mb || {}), wt = class {
  static fromBuffer(e) {
    return wt.fromUint8Array(e);
  }
  static fromUint8Array(e) {
    return new wt(wj(e));
  }
  static ensure(e) {
    return typeof e == "string" ? new wt(e) : e;
  }
  constructor(e) {
    e.startsWith("0x") ? this.hexString = e : this.hexString = `0x${e}`;
  }
  hex() {
    return this.hexString;
  }
  noPrefix() {
    return this.hexString.slice(2);
  }
  toString() {
    return this.hex();
  }
  toShortString() {
    return `0x${this.hexString.replace(/^0x0*/, "")}`;
  }
  toUint8Array() {
    return Uint8Array.from(vj(this.noPrefix()));
  }
}, Kn = {};
Cw(Kn, {
  AccountAddress: () => In,
  AccountAuthenticator: () => Ws,
  AccountAuthenticatorEd25519: () => VT,
  AccountAuthenticatorMultiEd25519: () => qT,
  ArgumentABI: () => X0,
  AuthenticationKey: () => Xc,
  ChainId: () => Ww,
  ChangeSet: () => Che,
  Ed25519PublicKey: () => ao,
  Ed25519Signature: () => ta,
  EntryFunction: () => Ic,
  EntryFunctionABI: () => Cl,
  FeePayerRawTransaction: () => Fw,
  Identifier: () => Jr,
  Module: () => rU,
  ModuleId: () => Jc,
  MultiAgentRawTransaction: () => zw,
  MultiEd25519PublicKey: () => G0,
  MultiEd25519Signature: () => Rw,
  MultiSig: () => ZT,
  MultiSigTransactionPayload: () => YT,
  RawTransaction: () => gu,
  RawTransactionWithData: () => JT,
  RotationProofChallenge: () => Rhe,
  Script: () => Uw,
  ScriptABI: () => Qw,
  SignedTransaction: () => Y0,
  StructTag: () => nc,
  Transaction: () => iU,
  TransactionArgument: () => Ko,
  TransactionArgumentAddress: () => Zw,
  TransactionArgumentBool: () => Xw,
  TransactionArgumentU128: () => Gw,
  TransactionArgumentU16: () => Vw,
  TransactionArgumentU256: () => Yw,
  TransactionArgumentU32: () => qw,
  TransactionArgumentU64: () => Hw,
  TransactionArgumentU8: () => Kw,
  TransactionArgumentU8Vector: () => Jw,
  TransactionAuthenticator: () => ef,
  TransactionAuthenticatorEd25519: () => Nw,
  TransactionAuthenticatorFeePayer: () => KT,
  TransactionAuthenticatorMultiAgent: () => WT,
  TransactionAuthenticatorMultiEd25519: () => jw,
  TransactionPayload: () => Z0,
  TransactionPayloadEntryFunction: () => $w,
  TransactionPayloadMultisig: () => XT,
  TransactionPayloadScript: () => Lw,
  TransactionScriptABI: () => ev,
  TypeArgumentABI: () => J0,
  TypeTag: () => Xr,
  TypeTagAddress: () => tc,
  TypeTagBool: () => du,
  TypeTagParser: () => af,
  TypeTagParserError: () => nU,
  TypeTagSigner: () => HT,
  TypeTagStruct: () => yu,
  TypeTagU128: () => pu,
  TypeTagU16: () => tf,
  TypeTagU256: () => rf,
  TypeTagU32: () => nf,
  TypeTagU64: () => hu,
  TypeTagU8: () => Ga,
  TypeTagVector: () => of,
  UserTransaction: () => QT,
  WriteSet: () => Dhe,
  objectStructTag: () => Mhe,
  optionStructTag: () => xhe,
  stringStructTag: () => GT
});
var yhe = {};
Cw(yhe, {
  Deserializer: () => $T,
  Serializer: () => yr,
  bcsSerializeBool: () => Ihe,
  bcsSerializeBytes: () => _s,
  bcsSerializeFixedBytes: () => The,
  bcsSerializeStr: () => khe,
  bcsSerializeU128: () => Ehe,
  bcsSerializeU16: () => vhe,
  bcsSerializeU256: () => Ahe,
  bcsSerializeU32: () => She,
  bcsSerializeU8: () => fI,
  bcsSerializeUint64: () => whe,
  bcsToBytes: () => Ha,
  deserializeVector: () => pi,
  serializeVector: () => Zr,
  serializeVectorWithFunc: () => _he
});
var ghe = 2 ** 8 - 1, bhe = 2 ** 16 - 1, _d = 2 ** 32 - 1, eU = BigInt(2 ** 64) - BigInt(1), tU = BigInt(2 ** 128) - BigInt(1), mhe = BigInt(2 ** 256) - BigInt(1), yr = class {
  constructor() {
    this.buffer = new ArrayBuffer(64), this.offset = 0;
  }
  ensureBufferWillHandleSize(e) {
    for (; this.buffer.byteLength < this.offset + e; ) {
      const t = new ArrayBuffer(this.buffer.byteLength * 2);
      new Uint8Array(t).set(new Uint8Array(this.buffer)), this.buffer = t;
    }
  }
  serialize(e) {
    this.ensureBufferWillHandleSize(e.length), new Uint8Array(this.buffer, this.offset).set(e), this.offset += e.length;
  }
  serializeWithFunction(e, t, n) {
    this.ensureBufferWillHandleSize(t);
    const r = new DataView(this.buffer, this.offset);
    e.apply(r, [0, n, !0]), this.offset += t;
  }
  serializeStr(e) {
    const t = new TextEncoder();
    this.serializeBytes(t.encode(e));
  }
  serializeBytes(e) {
    this.serializeU32AsUleb128(e.length), this.serialize(e);
  }
  serializeFixedBytes(e) {
    this.serialize(e);
  }
  serializeBool(e) {
    if (typeof e != "boolean")
      throw new Error("Value needs to be a boolean");
    const t = e ? 1 : 0;
    this.serialize(new Uint8Array([t]));
  }
  serializeU8(e) {
    this.serialize(new Uint8Array([e]));
  }
  serializeU16(e) {
    this.serializeWithFunction(DataView.prototype.setUint16, 2, e);
  }
  serializeU32(e) {
    this.serializeWithFunction(DataView.prototype.setUint32, 4, e);
  }
  serializeU64(e) {
    const t = BigInt(e.toString()) & BigInt(_d), n = BigInt(e.toString()) >> BigInt(32);
    this.serializeU32(Number(t)), this.serializeU32(Number(n));
  }
  serializeU128(e) {
    const t = BigInt(e.toString()) & eU, n = BigInt(e.toString()) >> BigInt(64);
    this.serializeU64(t), this.serializeU64(n);
  }
  serializeU256(e) {
    const t = BigInt(e.toString()) & tU, n = BigInt(e.toString()) >> BigInt(128);
    this.serializeU128(t), this.serializeU128(n);
  }
  serializeU32AsUleb128(e) {
    let t = e;
    const n = [];
    for (; t >>> 7; )
      n.push(t & 127 | 128), t >>>= 7;
    n.push(t), this.serialize(new Uint8Array(n));
  }
  getBytes() {
    return new Uint8Array(this.buffer).slice(0, this.offset);
  }
};
xn([
  fu(0, ghe)
], yr.prototype, "serializeU8", 1);
xn([
  fu(0, bhe)
], yr.prototype, "serializeU16", 1);
xn([
  fu(0, _d)
], yr.prototype, "serializeU32", 1);
xn([
  fu(BigInt(0), eU)
], yr.prototype, "serializeU64", 1);
xn([
  fu(BigInt(0), tU)
], yr.prototype, "serializeU128", 1);
xn([
  fu(BigInt(0), mhe)
], yr.prototype, "serializeU256", 1);
xn([
  fu(0, _d)
], yr.prototype, "serializeU32AsUleb128", 1);
function fu(e, t, n) {
  return (r, i, o) => {
    const a = o.value;
    return o.value = function(c) {
      const l = BigInt(c.toString());
      if (l > BigInt(t.toString()) || l < BigInt(e.toString()))
        throw new Error(n || "Value is out of range");
      a.apply(this, [c]);
    }, o;
  };
}
var $T = class {
  constructor(e) {
    this.buffer = new ArrayBuffer(e.length), new Uint8Array(this.buffer).set(e, 0), this.offset = 0;
  }
  read(e) {
    if (this.offset + e > this.buffer.byteLength)
      throw new Error("Reached to the end of buffer");
    const t = this.buffer.slice(this.offset, this.offset + e);
    return this.offset += e, t;
  }
  deserializeStr() {
    const e = this.deserializeBytes();
    return new TextDecoder().decode(e);
  }
  deserializeBytes() {
    const e = this.deserializeUleb128AsU32();
    return new Uint8Array(this.read(e));
  }
  deserializeFixedBytes(e) {
    return new Uint8Array(this.read(e));
  }
  deserializeBool() {
    const e = new Uint8Array(this.read(1))[0];
    if (e !== 1 && e !== 0)
      throw new Error("Invalid boolean value");
    return e === 1;
  }
  deserializeU8() {
    return new DataView(this.read(1)).getUint8(0);
  }
  deserializeU16() {
    return new DataView(this.read(2)).getUint16(0, !0);
  }
  deserializeU32() {
    return new DataView(this.read(4)).getUint32(0, !0);
  }
  deserializeU64() {
    const e = this.deserializeU32(), t = this.deserializeU32();
    return BigInt(BigInt(t) << BigInt(32) | BigInt(e));
  }
  deserializeU128() {
    const e = this.deserializeU64(), t = this.deserializeU64();
    return BigInt(t << BigInt(64) | e);
  }
  deserializeU256() {
    const e = this.deserializeU128(), t = this.deserializeU128();
    return BigInt(t << BigInt(128) | e);
  }
  deserializeUleb128AsU32() {
    let e = BigInt(0), t = 0;
    for (; e < _d; ) {
      const n = this.deserializeU8();
      if (e |= BigInt(n & 127) << BigInt(t), !(n & 128))
        break;
      t += 7;
    }
    if (e > _d)
      throw new Error("Overflow while parsing uleb128-encoded uint32 value");
    return Number(e);
  }
};
function Zr(e, t) {
  t.serializeU32AsUleb128(e.length), e.forEach((n) => {
    n.serialize(t);
  });
}
function _he(e, t) {
  const n = new yr();
  n.serializeU32AsUleb128(e.length);
  const r = n[t];
  return e.forEach((i) => {
    r.call(n, i);
  }), n.getBytes();
}
function pi(e, t) {
  const n = e.deserializeUleb128AsU32(), r = [];
  for (let i = 0; i < n; i += 1)
    r.push(t.deserialize(e));
  return r;
}
function Ha(e) {
  const t = new yr();
  return e.serialize(t), t.getBytes();
}
function whe(e) {
  const t = new yr();
  return t.serializeU64(e), t.getBytes();
}
function fI(e) {
  const t = new yr();
  return t.serializeU8(e), t.getBytes();
}
function vhe(e) {
  const t = new yr();
  return t.serializeU16(e), t.getBytes();
}
function She(e) {
  const t = new yr();
  return t.serializeU32(e), t.getBytes();
}
function Ehe(e) {
  const t = new yr();
  return t.serializeU128(e), t.getBytes();
}
function Ahe(e) {
  const t = new yr();
  return t.serializeU256(e), t.getBytes();
}
function Ihe(e) {
  const t = new yr();
  return t.serializeBool(e), t.getBytes();
}
function khe(e) {
  const t = new yr();
  return t.serializeStr(e), t.getBytes();
}
function _s(e) {
  const t = new yr();
  return t.serializeBytes(e), t.getBytes();
}
function The(e) {
  const t = new yr();
  return t.serializeFixedBytes(e), t.getBytes();
}
var to = class {
  constructor(e) {
    if (e.length !== to.LENGTH)
      throw new Error("Expected address of length 32");
    this.address = e;
  }
  static fromHex(e) {
    let t = wt.ensure(e);
    t.noPrefix().length % 2 !== 0 && (t = new wt(`0${t.noPrefix()}`));
    const n = t.toUint8Array();
    if (n.length > to.LENGTH)
      throw new Error("Hex string is too long. Address's length is 32 bytes.");
    if (n.length === to.LENGTH)
      return new to(n);
    const r = new Uint8Array(to.LENGTH);
    return r.set(n, to.LENGTH - n.length), new to(r);
  }
  static isValid(e) {
    if (e === "")
      return !1;
    let t = wt.ensure(e);
    return t.noPrefix().length % 2 !== 0 && (t = new wt(`0${t.noPrefix()}`)), t.toUint8Array().length <= to.LENGTH;
  }
  toHexString() {
    return wt.fromUint8Array(this.address).hex();
  }
  serialize(e) {
    e.serializeFixedBytes(this.address);
  }
  static deserialize(e) {
    return new to(e.deserializeFixedBytes(to.LENGTH));
  }
  static standardizeAddress(e) {
    const t = e.toLowerCase();
    return `0x${(t.startsWith("0x") ? t.slice(2) : t).padStart(64, "0")}`;
  }
}, In = to;
In.LENGTH = 32;
In.CORE_CODE_ADDRESS = to.fromHex("0x1");
var _b = class {
  constructor(e) {
    if (e.length !== _b.LENGTH)
      throw new Error(`Ed25519PublicKey length should be ${_b.LENGTH}`);
    this.value = e;
  }
  toBytes() {
    return this.value;
  }
  serialize(e) {
    e.serializeBytes(this.value);
  }
  static deserialize(e) {
    const t = e.deserializeBytes();
    return new _b(t);
  }
}, ao = _b;
ao.LENGTH = 32;
var wb = class {
  constructor(e) {
    if (this.value = e, e.length !== wb.LENGTH)
      throw new Error(`Ed25519Signature length should be ${wb.LENGTH}`);
  }
  serialize(e) {
    e.serializeBytes(this.value);
  }
  static deserialize(e) {
    const t = e.deserializeBytes();
    return new wb(t);
  }
}, ta = wb;
ta.LENGTH = 64;
var dI = 32, G0 = class {
  constructor(e, t) {
    if (this.public_keys = e, this.threshold = t, t > dI)
      throw new Error(`"threshold" cannot be larger than ${dI}`);
  }
  toBytes() {
    const e = new Uint8Array(this.public_keys.length * ao.LENGTH + 1);
    return this.public_keys.forEach((t, n) => {
      e.set(t.value, n * ao.LENGTH);
    }), e[this.public_keys.length * ao.LENGTH] = this.threshold, e;
  }
  serialize(e) {
    e.serializeBytes(this.toBytes());
  }
  static deserialize(e) {
    const t = e.deserializeBytes(), n = t[t.length - 1], r = [];
    for (let i = 0; i < t.length - 1; i += ao.LENGTH) {
      const o = i;
      r.push(new ao(t.subarray(o, o + ao.LENGTH)));
    }
    return new G0(r, n);
  }
}, Df = class {
  constructor(e, t) {
    if (this.signatures = e, this.bitmap = t, t.length !== Df.BITMAP_LEN)
      throw new Error(`"bitmap" length should be ${Df.BITMAP_LEN}`);
  }
  toBytes() {
    const e = new Uint8Array(this.signatures.length * ta.LENGTH + Df.BITMAP_LEN);
    return this.signatures.forEach((t, n) => {
      e.set(t.value, n * ta.LENGTH);
    }), e.set(this.bitmap, this.signatures.length * ta.LENGTH), e;
  }
  static createBitmap(e) {
    const n = new Uint8Array([0, 0, 0, 0]), r = /* @__PURE__ */ new Set();
    return e.forEach((i) => {
      if (i >= dI)
        throw new Error(`Invalid bit value ${i}.`);
      if (r.has(i))
        throw new Error("Duplicated bits detected.");
      r.add(i);
      const o = Math.floor(i / 8);
      let a = n[o];
      a |= 128 >> i % 8, n[o] = a;
    }), n;
  }
  serialize(e) {
    e.serializeBytes(this.toBytes());
  }
  static deserialize(e) {
    const t = e.deserializeBytes(), n = t.subarray(t.length - 4), r = [];
    for (let i = 0; i < t.length - n.length; i += ta.LENGTH) {
      const o = i;
      r.push(new ta(t.subarray(o, o + ta.LENGTH)));
    }
    return new Df(r, n);
  }
}, Rw = Df;
Rw.BITMAP_LEN = 4;
var ef = class {
  static deserialize(e) {
    const t = e.deserializeUleb128AsU32();
    switch (t) {
      case 0:
        return Nw.load(e);
      case 1:
        return jw.load(e);
      case 2:
        return WT.load(e);
      case 3:
        return KT.load(e);
      default:
        throw new Error(`Unknown variant index for TransactionAuthenticator: ${t}`);
    }
  }
}, Nw = class extends ef {
  constructor(e, t) {
    super(), this.public_key = e, this.signature = t;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.public_key.serialize(e), this.signature.serialize(e);
  }
  static load(e) {
    const t = ao.deserialize(e), n = ta.deserialize(e);
    return new Nw(t, n);
  }
}, jw = class extends ef {
  constructor(e, t) {
    super(), this.public_key = e, this.signature = t;
  }
  serialize(e) {
    e.serializeU32AsUleb128(1), this.public_key.serialize(e), this.signature.serialize(e);
  }
  static load(e) {
    const t = G0.deserialize(e), n = Rw.deserialize(e);
    return new jw(t, n);
  }
}, WT = class extends ef {
  constructor(e, t, n) {
    super(), this.sender = e, this.secondary_signer_addresses = t, this.secondary_signers = n;
  }
  serialize(e) {
    e.serializeU32AsUleb128(2), this.sender.serialize(e), Zr(this.secondary_signer_addresses, e), Zr(this.secondary_signers, e);
  }
  static load(e) {
    const t = Ws.deserialize(e), n = pi(e, In), r = pi(e, Ws);
    return new WT(t, n, r);
  }
}, KT = class extends ef {
  constructor(e, t, n, r) {
    super(), this.sender = e, this.secondary_signer_addresses = t, this.secondary_signers = n, this.fee_payer = r;
  }
  serialize(e) {
    e.serializeU32AsUleb128(3), this.sender.serialize(e), Zr(this.secondary_signer_addresses, e), Zr(this.secondary_signers, e), this.fee_payer.address.serialize(e), this.fee_payer.authenticator.serialize(e);
  }
  static load(e) {
    const t = Ws.deserialize(e), n = pi(e, In), r = pi(e, Ws), i = In.deserialize(e), o = Ws.deserialize(e), a = { address: i, authenticator: o };
    return new KT(t, n, r, a);
  }
}, Ws = class {
  static deserialize(e) {
    const t = e.deserializeUleb128AsU32();
    switch (t) {
      case 0:
        return VT.load(e);
      case 1:
        return qT.load(e);
      default:
        throw new Error(`Unknown variant index for AccountAuthenticator: ${t}`);
    }
  }
}, VT = class extends Ws {
  constructor(e, t) {
    super(), this.public_key = e, this.signature = t;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.public_key.serialize(e), this.signature.serialize(e);
  }
  static load(e) {
    const t = ao.deserialize(e), n = ta.deserialize(e);
    return new VT(t, n);
  }
}, qT = class extends Ws {
  constructor(e, t) {
    super(), this.public_key = e, this.signature = t;
  }
  serialize(e) {
    e.serializeU32AsUleb128(1), this.public_key.serialize(e), this.signature.serialize(e);
  }
  static load(e) {
    const t = G0.deserialize(e), n = Rw.deserialize(e);
    return new qT(t, n);
  }
}, Jr = class {
  constructor(e) {
    this.value = e;
  }
  serialize(e) {
    e.serializeStr(this.value);
  }
  static deserialize(e) {
    const t = e.deserializeStr();
    return new Jr(t);
  }
}, Xr = class {
  static deserialize(e) {
    const t = e.deserializeUleb128AsU32();
    switch (t) {
      case 0:
        return du.load(e);
      case 1:
        return Ga.load(e);
      case 2:
        return hu.load(e);
      case 3:
        return pu.load(e);
      case 4:
        return tc.load(e);
      case 5:
        return HT.load(e);
      case 6:
        return of.load(e);
      case 7:
        return yu.load(e);
      case 8:
        return tf.load(e);
      case 9:
        return nf.load(e);
      case 10:
        return rf.load(e);
      default:
        throw new Error(`Unknown variant index for TypeTag: ${t}`);
    }
  }
}, du = class extends Xr {
  serialize(e) {
    e.serializeU32AsUleb128(0);
  }
  static load(e) {
    return new du();
  }
}, Ga = class extends Xr {
  serialize(e) {
    e.serializeU32AsUleb128(1);
  }
  static load(e) {
    return new Ga();
  }
}, tf = class extends Xr {
  serialize(e) {
    e.serializeU32AsUleb128(8);
  }
  static load(e) {
    return new tf();
  }
}, nf = class extends Xr {
  serialize(e) {
    e.serializeU32AsUleb128(9);
  }
  static load(e) {
    return new nf();
  }
}, hu = class extends Xr {
  serialize(e) {
    e.serializeU32AsUleb128(2);
  }
  static load(e) {
    return new hu();
  }
}, pu = class extends Xr {
  serialize(e) {
    e.serializeU32AsUleb128(3);
  }
  static load(e) {
    return new pu();
  }
}, rf = class extends Xr {
  serialize(e) {
    e.serializeU32AsUleb128(10);
  }
  static load(e) {
    return new rf();
  }
}, tc = class extends Xr {
  serialize(e) {
    e.serializeU32AsUleb128(4);
  }
  static load(e) {
    return new tc();
  }
}, HT = class extends Xr {
  serialize(e) {
    e.serializeU32AsUleb128(5);
  }
  static load(e) {
    return new HT();
  }
}, of = class extends Xr {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(6), this.value.serialize(e);
  }
  static load(e) {
    const t = Xr.deserialize(e);
    return new of(t);
  }
}, yu = class extends Xr {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(7), this.value.serialize(e);
  }
  static load(e) {
    const t = nc.deserialize(e);
    return new yu(t);
  }
  isStringTypeTag() {
    return this.value.module_name.value === "string" && this.value.name.value === "String" && this.value.address.toHexString() === In.CORE_CODE_ADDRESS.toHexString();
  }
}, nc = class {
  constructor(e, t, n, r) {
    this.address = e, this.module_name = t, this.name = n, this.type_args = r;
  }
  static fromString(e) {
    const t = new af(e).parseTypeTag();
    return new nc(
      t.value.address,
      t.value.module_name,
      t.value.name,
      t.value.type_args
    );
  }
  serialize(e) {
    this.address.serialize(e), this.module_name.serialize(e), this.name.serialize(e), Zr(this.type_args, e);
  }
  static deserialize(e) {
    const t = In.deserialize(e), n = Jr.deserialize(e), r = Jr.deserialize(e), i = pi(e, Xr);
    return new nc(t, n, r, i);
  }
}, GT = new nc(
  In.fromHex("0x1"),
  new Jr("string"),
  new Jr("String"),
  []
);
function xhe(e) {
  return new nc(In.fromHex("0x1"), new Jr("option"), new Jr("Option"), [e]);
}
function Mhe(e) {
  return new nc(In.fromHex("0x1"), new Jr("object"), new Jr("Object"), [e]);
}
function ws(e) {
  throw new nU(e);
}
function NB(e) {
  return !!e.match(/\s/);
}
function jB(e) {
  return !!e.match(/[_A-Za-z0-9]/g);
}
function Ohe(e) {
  return !!e.match(/T\d+/g);
}
function Phe(e, t) {
  const n = e[t];
  if (n === ":") {
    if (e.slice(t, t + 2) === "::")
      return [["COLON", "::"], 2];
    ws("Unrecognized token.");
  } else {
    if (n === "<")
      return [["LT", "<"], 1];
    if (n === ">")
      return [["GT", ">"], 1];
    if (n === ",")
      return [["COMMA", ","], 1];
    if (NB(n)) {
      let r = "";
      for (let i = t; i < e.length; i += 1) {
        const o = e[i];
        if (NB(o))
          r = `${r}${o}`;
        else
          break;
      }
      return [["SPACE", r], r.length];
    } else if (jB(n)) {
      let r = "";
      for (let i = t; i < e.length; i += 1) {
        const o = e[i];
        if (jB(o))
          r = `${r}${o}`;
        else
          break;
      }
      return Ohe(r) ? [["GENERIC", r], r.length] : [["IDENT", r], r.length];
    }
  }
  throw new Error("Unrecognized token.");
}
function Bhe(e) {
  let t = 0;
  const n = [];
  for (; t < e.length; ) {
    const [r, i] = Phe(e, t);
    r[0] !== "SPACE" && n.push(r), t += i;
  }
  return n;
}
var af = class {
  constructor(e, t) {
    this.typeTags = [], this.tokens = Bhe(e), this.typeTags = t || [];
  }
  consume(e) {
    const t = this.tokens.shift();
    (!t || t[1] !== e) && ws("Invalid type tag.");
  }
  consumeWholeGeneric() {
    for (this.consume("<"); this.tokens[0][1] !== ">"; )
      this.tokens[0][1] === "<" && this.consumeWholeGeneric(), this.tokens.shift();
    this.consume(">");
  }
  parseCommaList(e, t) {
    const n = [];
    for (this.tokens.length <= 0 && ws("Invalid type tag."); this.tokens[0][1] !== e && (n.push(this.parseTypeTag()), !(this.tokens.length > 0 && this.tokens[0][1] === e || (this.consume(","), this.tokens.length > 0 && this.tokens[0][1] === e && t))); )
      this.tokens.length <= 0 && ws("Invalid type tag.");
    return n;
  }
  parseTypeTag() {
    this.tokens.length === 0 && ws("Invalid type tag.");
    const [e, t] = this.tokens.shift();
    if (t === "u8")
      return new Ga();
    if (t === "u16")
      return new tf();
    if (t === "u32")
      return new nf();
    if (t === "u64")
      return new hu();
    if (t === "u128")
      return new pu();
    if (t === "u256")
      return new rf();
    if (t === "bool")
      return new du();
    if (t === "address")
      return new tc();
    if (t === "vector") {
      this.consume("<");
      const n = this.parseTypeTag();
      return this.consume(">"), new of(n);
    }
    if (t === "string")
      return GT;
    if (e === "IDENT" && (t.startsWith("0x") || t.startsWith("0X"))) {
      const n = In.fromHex(t);
      this.consume("::");
      const [r, i] = this.tokens.shift();
      r !== "IDENT" && ws("Invalid type tag."), this.consume("::");
      const [o, a] = this.tokens.shift();
      if (o !== "IDENT" && ws("Invalid type tag."), In.CORE_CODE_ADDRESS.toHexString() === n.toHexString() && i === "object" && a === "Object")
        return this.consumeWholeGeneric(), new tc();
      let s = [];
      this.tokens.length > 0 && this.tokens[0][1] === "<" && (this.consume("<"), s = this.parseCommaList(">", !0), this.consume(">"));
      const c = new nc(n, new Jr(i), new Jr(a), s);
      return new yu(c);
    }
    if (e === "GENERIC") {
      this.typeTags.length === 0 && ws("Can't convert generic type since no typeTags were specified.");
      const n = parseInt(t.substring(1), 10);
      return new af(this.typeTags[n]).parseTypeTag();
    }
    throw new Error("Invalid type tag.");
  }
}, nU = class extends Error {
  constructor(e) {
    super(e), this.name = "TypeTagParserError";
  }
}, gu = class {
  constructor(e, t, n, r, i, o, a) {
    this.sender = e, this.sequence_number = t, this.payload = n, this.max_gas_amount = r, this.gas_unit_price = i, this.expiration_timestamp_secs = o, this.chain_id = a;
  }
  serialize(e) {
    this.sender.serialize(e), e.serializeU64(this.sequence_number), this.payload.serialize(e), e.serializeU64(this.max_gas_amount), e.serializeU64(this.gas_unit_price), e.serializeU64(this.expiration_timestamp_secs), this.chain_id.serialize(e);
  }
  static deserialize(e) {
    const t = In.deserialize(e), n = e.deserializeU64(), r = Z0.deserialize(e), i = e.deserializeU64(), o = e.deserializeU64(), a = e.deserializeU64(), s = Ww.deserialize(e);
    return new gu(
      t,
      n,
      r,
      i,
      o,
      a,
      s
    );
  }
}, Uw = class {
  constructor(e, t, n) {
    this.code = e, this.ty_args = t, this.args = n;
  }
  serialize(e) {
    e.serializeBytes(this.code), Zr(this.ty_args, e), Zr(this.args, e);
  }
  static deserialize(e) {
    const t = e.deserializeBytes(), n = pi(e, Xr), r = pi(e, Ko);
    return new Uw(t, n, r);
  }
}, Ic = class {
  constructor(e, t, n, r) {
    this.module_name = e, this.function_name = t, this.ty_args = n, this.args = r;
  }
  static natural(e, t, n, r) {
    return new Ic(Jc.fromStr(e), new Jr(t), n, r);
  }
  static natual(e, t, n, r) {
    return Ic.natural(e, t, n, r);
  }
  serialize(e) {
    this.module_name.serialize(e), this.function_name.serialize(e), Zr(this.ty_args, e), e.serializeU32AsUleb128(this.args.length), this.args.forEach((t) => {
      e.serializeBytes(t);
    });
  }
  static deserialize(e) {
    const t = Jc.deserialize(e), n = Jr.deserialize(e), r = pi(e, Xr), i = e.deserializeUleb128AsU32(), o = [];
    for (let s = 0; s < i; s += 1)
      o.push(e.deserializeBytes());
    const a = o;
    return new Ic(t, n, r, a);
  }
}, YT = class {
  constructor(e) {
    this.transaction_payload = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.transaction_payload.serialize(e);
  }
  static deserialize(e) {
    return e.deserializeUleb128AsU32(), new YT(Ic.deserialize(e));
  }
}, ZT = class {
  constructor(e, t) {
    this.multisig_address = e, this.transaction_payload = t;
  }
  serialize(e) {
    this.multisig_address.serialize(e), this.transaction_payload === void 0 ? e.serializeBool(!1) : (e.serializeBool(!0), this.transaction_payload.serialize(e));
  }
  static deserialize(e) {
    const t = In.deserialize(e), n = e.deserializeBool();
    let r;
    return n && (r = YT.deserialize(e)), new ZT(t, r);
  }
}, rU = class {
  constructor(e) {
    this.code = e;
  }
  serialize(e) {
    e.serializeBytes(this.code);
  }
  static deserialize(e) {
    const t = e.deserializeBytes();
    return new rU(t);
  }
}, Jc = class {
  constructor(e, t) {
    this.address = e, this.name = t;
  }
  static fromStr(e) {
    const t = e.split("::");
    if (t.length !== 2)
      throw new Error("Invalid module id.");
    return new Jc(In.fromHex(new wt(t[0])), new Jr(t[1]));
  }
  serialize(e) {
    this.address.serialize(e), this.name.serialize(e);
  }
  static deserialize(e) {
    const t = In.deserialize(e), n = Jr.deserialize(e);
    return new Jc(t, n);
  }
}, Che = class {
  serialize(e) {
    throw new Error("Not implemented.");
  }
  static deserialize(e) {
    throw new Error("Not implemented.");
  }
}, Dhe = class {
  serialize(e) {
    throw new Error("Not implmented.");
  }
  static deserialize(e) {
    throw new Error("Not implmented.");
  }
}, Y0 = class {
  constructor(e, t) {
    this.raw_txn = e, this.authenticator = t;
  }
  serialize(e) {
    this.raw_txn.serialize(e), this.authenticator.serialize(e);
  }
  static deserialize(e) {
    const t = gu.deserialize(e), n = ef.deserialize(e);
    return new Y0(t, n);
  }
}, JT = class {
  static deserialize(e) {
    const t = e.deserializeUleb128AsU32();
    switch (t) {
      case 0:
        return zw.load(e);
      case 1:
        return Fw.load(e);
      default:
        throw new Error(`Unknown variant index for RawTransactionWithData: ${t}`);
    }
  }
}, zw = class extends JT {
  constructor(e, t) {
    super(), this.raw_txn = e, this.secondary_signer_addresses = t;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.raw_txn.serialize(e), Zr(this.secondary_signer_addresses, e);
  }
  static load(e) {
    const t = gu.deserialize(e), n = pi(e, In);
    return new zw(t, n);
  }
}, Fw = class extends JT {
  constructor(e, t, n) {
    super(), this.raw_txn = e, this.secondary_signer_addresses = t, this.fee_payer_address = n;
  }
  serialize(e) {
    e.serializeU32AsUleb128(1), this.raw_txn.serialize(e), Zr(this.secondary_signer_addresses, e), this.fee_payer_address.serialize(e);
  }
  static load(e) {
    const t = gu.deserialize(e), n = pi(e, In), r = In.deserialize(e);
    return new Fw(t, n, r);
  }
}, Z0 = class {
  static deserialize(e) {
    const t = e.deserializeUleb128AsU32();
    switch (t) {
      case 0:
        return Lw.load(e);
      case 2:
        return $w.load(e);
      case 3:
        return XT.load(e);
      default:
        throw new Error(`Unknown variant index for TransactionPayload: ${t}`);
    }
  }
}, Lw = class extends Z0 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.value.serialize(e);
  }
  static load(e) {
    const t = Uw.deserialize(e);
    return new Lw(t);
  }
}, $w = class extends Z0 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(2), this.value.serialize(e);
  }
  static load(e) {
    const t = Ic.deserialize(e);
    return new $w(t);
  }
}, XT = class extends Z0 {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(3), this.value.serialize(e);
  }
  static load(e) {
    const t = ZT.deserialize(e);
    return new XT(t);
  }
}, Ww = class {
  constructor(e) {
    this.value = e;
  }
  serialize(e) {
    e.serializeU8(this.value);
  }
  static deserialize(e) {
    const t = e.deserializeU8();
    return new Ww(t);
  }
}, Ko = class {
  static deserialize(e) {
    const t = e.deserializeUleb128AsU32();
    switch (t) {
      case 0:
        return Kw.load(e);
      case 1:
        return Hw.load(e);
      case 2:
        return Gw.load(e);
      case 3:
        return Zw.load(e);
      case 4:
        return Jw.load(e);
      case 5:
        return Xw.load(e);
      case 6:
        return Vw.load(e);
      case 7:
        return qw.load(e);
      case 8:
        return Yw.load(e);
      default:
        throw new Error(`Unknown variant index for TransactionArgument: ${t}`);
    }
  }
}, Kw = class extends Ko {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), e.serializeU8(this.value);
  }
  static load(e) {
    const t = e.deserializeU8();
    return new Kw(t);
  }
}, Vw = class extends Ko {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(6), e.serializeU16(this.value);
  }
  static load(e) {
    const t = e.deserializeU16();
    return new Vw(t);
  }
}, qw = class extends Ko {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(7), e.serializeU32(this.value);
  }
  static load(e) {
    const t = e.deserializeU32();
    return new qw(t);
  }
}, Hw = class extends Ko {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(1), e.serializeU64(this.value);
  }
  static load(e) {
    const t = e.deserializeU64();
    return new Hw(t);
  }
}, Gw = class extends Ko {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(2), e.serializeU128(this.value);
  }
  static load(e) {
    const t = e.deserializeU128();
    return new Gw(t);
  }
}, Yw = class extends Ko {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(8), e.serializeU256(this.value);
  }
  static load(e) {
    const t = e.deserializeU256();
    return new Yw(t);
  }
}, Zw = class extends Ko {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(3), this.value.serialize(e);
  }
  static load(e) {
    const t = In.deserialize(e);
    return new Zw(t);
  }
}, Jw = class extends Ko {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(4), e.serializeBytes(this.value);
  }
  static load(e) {
    const t = e.deserializeBytes();
    return new Jw(t);
  }
}, Xw = class extends Ko {
  constructor(e) {
    super(), this.value = e;
  }
  serialize(e) {
    e.serializeU32AsUleb128(5), e.serializeBool(this.value);
  }
  static load(e) {
    const t = e.deserializeBool();
    return new Xw(t);
  }
}, iU = class {
  getHashSalt() {
    const e = Ol.create();
    return e.update("APTOS::Transaction"), e.digest();
  }
  static deserialize(e) {
    const t = e.deserializeUleb128AsU32();
    switch (t) {
      case 0:
        return QT.load(e);
      default:
        throw new Error(`Unknown variant index for Transaction: ${t}`);
    }
  }
}, QT = class extends iU {
  constructor(e) {
    super(), this.value = e;
  }
  hash() {
    const e = Ol.create();
    return e.update(this.getHashSalt()), e.update(Ha(this)), e.digest();
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), this.value.serialize(e);
  }
  static load(e) {
    return new QT(Y0.deserialize(e));
  }
}, J0 = class {
  constructor(e) {
    this.name = e;
  }
  serialize(e) {
    e.serializeStr(this.name);
  }
  static deserialize(e) {
    const t = e.deserializeStr();
    return new J0(t);
  }
}, X0 = class {
  constructor(e, t) {
    this.name = e, this.type_tag = t;
  }
  serialize(e) {
    e.serializeStr(this.name), this.type_tag.serialize(e);
  }
  static deserialize(e) {
    const t = e.deserializeStr(), n = Xr.deserialize(e);
    return new X0(t, n);
  }
}, Qw = class {
  static deserialize(e) {
    const t = e.deserializeUleb128AsU32();
    switch (t) {
      case 0:
        return ev.load(e);
      case 1:
        return Cl.load(e);
      default:
        throw new Error(`Unknown variant index for TransactionPayload: ${t}`);
    }
  }
}, ev = class extends Qw {
  constructor(e, t, n, r, i) {
    super(), this.name = e, this.doc = t, this.code = n, this.ty_args = r, this.args = i;
  }
  serialize(e) {
    e.serializeU32AsUleb128(0), e.serializeStr(this.name), e.serializeStr(this.doc), e.serializeBytes(this.code), Zr(this.ty_args, e), Zr(this.args, e);
  }
  static load(e) {
    const t = e.deserializeStr(), n = e.deserializeStr(), r = e.deserializeBytes(), i = pi(e, J0), o = pi(e, X0);
    return new ev(t, n, r, i, o);
  }
}, Cl = class extends Qw {
  constructor(e, t, n, r, i) {
    super(), this.name = e, this.module_name = t, this.doc = n, this.ty_args = r, this.args = i;
  }
  serialize(e) {
    e.serializeU32AsUleb128(1), e.serializeStr(this.name), this.module_name.serialize(e), e.serializeStr(this.doc), Zr(this.ty_args, e), Zr(this.args, e);
  }
  static load(e) {
    const t = e.deserializeStr(), n = Jc.deserialize(e), r = e.deserializeStr(), i = pi(e, J0), o = pi(e, X0);
    return new Cl(t, n, r, i, o);
  }
}, Ou = class {
  constructor(e) {
    if (e.length !== Ou.LENGTH)
      throw new Error("Expected a byte array of length 32");
    this.bytes = e;
  }
  static fromMultiEd25519PublicKey(e) {
    const t = e.toBytes(), n = new Uint8Array(t.length + 1);
    n.set(t), n.set([Ou.MULTI_ED25519_SCHEME], t.length);
    const r = Ol.create();
    return r.update(n), new Ou(r.digest());
  }
  static fromEd25519PublicKey(e) {
    const t = e.value, n = new Uint8Array(t.length + 1);
    n.set(t), n.set([Ou.ED25519_SCHEME], t.length);
    const r = Ol.create();
    return r.update(n), new Ou(r.digest());
  }
  derivedAddress() {
    return wt.fromUint8Array(this.bytes);
  }
}, Xc = Ou;
Xc.LENGTH = 32;
Xc.MULTI_ED25519_SCHEME = 1;
Xc.ED25519_SCHEME = 0;
Xc.DERIVE_RESOURCE_ACCOUNT_SCHEME = 255;
var Rhe = class {
  constructor(e, t, n, r, i, o, a) {
    this.accountAddress = e, this.moduleName = t, this.structName = n, this.sequenceNumber = r, this.originator = i, this.currentAuthKey = o, this.newPublicKey = a;
  }
  serialize(e) {
    this.accountAddress.serialize(e), e.serializeStr(this.moduleName), e.serializeStr(this.structName), e.serializeU64(this.sequenceNumber), this.originator.serialize(e), this.currentAuthKey.serialize(e), e.serializeBytes(this.newPublicKey);
  }
}, vb = class {
  static fromAptosAccountObject(e) {
    return new vb(wt.ensure(e.privateKeyHex).toUint8Array(), e.address);
  }
  static isValidPath(e) {
    return /^m\/44'\/637'\/[0-9]+'\/[0-9]+'\/[0-9]+'+$/.test(e);
  }
  static fromDerivePath(e, t) {
    if (!vb.isValidPath(e))
      throw new Error("Invalid derivation path");
    const n = t.trim().split(/\s+/).map((i) => i.toLowerCase()).join(" "), { key: r } = ihe(e, wj(lj(n)));
    return new vb(r);
  }
  constructor(e, t) {
    e ? this.signingKey = fg.sign.keyPair.fromSeed(e.slice(0, 32)) : this.signingKey = fg.sign.keyPair(), this.accountAddress = wt.ensure(t || this.authKey().hex());
  }
  address() {
    return this.accountAddress;
  }
  authKey() {
    const e = new ao(this.signingKey.publicKey);
    return Xc.fromEd25519PublicKey(e).derivedAddress();
  }
  static getResourceAccountAddress(e, t) {
    const n = Ha(In.fromHex(e)), r = new Uint8Array([...n, ...t, Xc.DERIVE_RESOURCE_ACCOUNT_SCHEME]), i = Ol.create();
    return i.update(r), wt.fromUint8Array(i.digest());
  }
  static getCollectionID(e, t) {
    const n = new TextEncoder().encode(`${e}::${t}`), r = afe.create();
    return r.update(n), wt.fromUint8Array(r.digest());
  }
  pubKey() {
    return wt.fromUint8Array(this.signingKey.publicKey);
  }
  signBuffer(e) {
    const t = fg.sign.detached(e, this.signingKey.secretKey);
    return wt.fromUint8Array(t);
  }
  signHexString(e) {
    const t = wt.ensure(e).toUint8Array();
    return this.signBuffer(t);
  }
  verifySignature(e, t) {
    const n = wt.ensure(e).toUint8Array(), r = wt.ensure(t).toUint8Array();
    return fg.sign.detached.verify(n, r, this.signingKey.publicKey);
  }
  toPrivateKeyObject() {
    return {
      address: this.address().hex(),
      publicKeyHex: this.pubKey().hex(),
      privateKeyHex: wt.fromUint8Array(this.signingKey.secretKey.slice(0, 32)).hex()
    };
  }
}, hI = vb;
xn([
  Dw()
], hI.prototype, "authKey", 1);
var ex = `
    fragment CurrentTokenOwnershipFields on current_token_ownerships_v2 {
  token_standard
  is_fungible_v2
  is_soulbound_v2
  property_version_v1
  table_type_v1
  token_properties_mutated_v1
  amount
  last_transaction_timestamp
  last_transaction_version
  storage_id
  owner_address
  current_token_data {
    token_name
    token_data_id
    token_uri
    token_properties
    supply
    maximum
    last_transaction_version
    last_transaction_timestamp
    largest_property_version_v1
    current_collection {
      collection_name
      creator_address
      description
      uri
      collection_id
      last_transaction_version
      current_supply
      mutable_description
      total_minted_v2
      table_handle_v1
      mutable_uri
    }
  }
}
    `, Nhe = `
    fragment TokenDataFields on current_token_datas {
  creator_address
  collection_name
  description
  metadata_uri
  name
  token_data_id_hash
  collection_data_id_hash
}
    `, jhe = `
    fragment CollectionDataFields on current_collection_datas {
  metadata_uri
  supply
  description
  collection_name
  collection_data_id_hash
  table_handle
  creator_address
}
    `, Uhe = `
    query getAccountCoinsData($owner_address: String, $offset: Int, $limit: Int) {
  current_coin_balances(
    where: {owner_address: {_eq: $owner_address}}
    offset: $offset
    limit: $limit
  ) {
    amount
    coin_type
    coin_info {
      name
      decimals
      symbol
    }
  }
}
    `, zhe = `
    query getAccountCurrentTokens($address: String!, $offset: Int, $limit: Int) {
  current_token_ownerships(
    where: {owner_address: {_eq: $address}, amount: {_gt: 0}}
    order_by: [{last_transaction_version: desc}, {creator_address: asc}, {collection_name: asc}, {name: asc}]
    offset: $offset
    limit: $limit
  ) {
    amount
    current_token_data {
      ...TokenDataFields
    }
    current_collection_data {
      ...CollectionDataFields
    }
    last_transaction_version
    property_version
  }
}
    ${Nhe}
${jhe}`, Fhe = `
    query getAccountTokensCount($where_condition: current_token_ownerships_v2_bool_exp, $offset: Int, $limit: Int) {
  current_token_ownerships_v2_aggregate(
    where: $where_condition
    offset: $offset
    limit: $limit
  ) {
    aggregate {
      count
    }
  }
}
    `, Lhe = `
    query getAccountTransactionsCount($address: String) {
  move_resources_aggregate(
    where: {address: {_eq: $address}}
    distinct_on: transaction_version
  ) {
    aggregate {
      count
    }
  }
}
    `, $he = `
    query getAccountTransactionsData($address: String, $limit: Int, $offset: Int) {
  move_resources(
    where: {address: {_eq: $address}}
    order_by: {transaction_version: desc}
    distinct_on: transaction_version
    limit: $limit
    offset: $offset
  ) {
    transaction_version
  }
}
    `, Whe = `
    query getCollectionData($where_condition: current_collections_v2_bool_exp!, $offset: Int, $limit: Int, $order_by: [current_collections_v2_order_by!]) {
  current_collections_v2(
    where: $where_condition
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    collection_id
    token_standard
    collection_name
    creator_address
    current_supply
    description
    uri
  }
}
    `, Khe = `
    query getCollectionsWithOwnedTokens($where_condition: current_collection_ownership_v2_view_bool_exp!, $offset: Int, $limit: Int, $order_by: [current_collection_ownership_v2_view_order_by!]) {
  current_collection_ownership_v2_view(
    where: $where_condition
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    current_collection {
      creator_address
      collection_name
      token_standard
      collection_id
      description
      table_handle_v1
      uri
      total_minted_v2
      max_supply
    }
    distinct_tokens
    last_transaction_version
  }
}
    `, Vhe = `
    query getDelegatedStakingActivities($delegatorAddress: String, $poolAddress: String) {
  delegated_staking_activities(
    where: {delegator_address: {_eq: $delegatorAddress}, pool_address: {_eq: $poolAddress}}
  ) {
    amount
    delegator_address
    event_index
    event_type
    pool_address
    transaction_version
  }
}
    `, qhe = `
    query getIndexerLedgerInfo {
  ledger_infos {
    chain_id
  }
}
    `, Hhe = `
    query getNumberOfDelegators($poolAddress: String) {
  num_active_delegator_per_pool(
    where: {pool_address: {_eq: $poolAddress}, num_active_delegator: {_gt: "0"}}
    distinct_on: pool_address
  ) {
    num_active_delegator
  }
}
    `, Ghe = `
    query getOwnedTokens($where_condition: current_token_ownerships_v2_bool_exp!, $offset: Int, $limit: Int, $order_by: [current_token_ownerships_v2_order_by!]) {
  current_token_ownerships_v2(
    where: $where_condition
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    ...CurrentTokenOwnershipFields
  }
}
    ${ex}`, Yhe = `
    query getOwnedTokensByTokenData($where_condition: current_token_ownerships_v2_bool_exp!, $offset: Int, $limit: Int, $order_by: [current_token_ownerships_v2_order_by!]) {
  current_token_ownerships_v2(
    where: $where_condition
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    ...CurrentTokenOwnershipFields
  }
}
    ${ex}`, Zhe = `
    query getTokenActivities($where_condition: token_activities_v2_bool_exp!, $offset: Int, $limit: Int, $order_by: [token_activities_v2_order_by!]) {
  token_activities_v2(
    where: $where_condition
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    after_value
    before_value
    entry_function_id_str
    event_account_address
    event_index
    from_address
    is_fungible_v2
    property_version_v1
    to_address
    token_amount
    token_data_id
    token_standard
    transaction_timestamp
    transaction_version
    type
  }
}
    `, Jhe = `
    query getTokenActivitiesCount($token_id: String) {
  token_activities_v2_aggregate(where: {token_data_id: {_eq: $token_id}}) {
    aggregate {
      count
    }
  }
}
    `, Xhe = `
    query getTokenCurrentOwnerData($where_condition: current_token_ownerships_v2_bool_exp!, $offset: Int, $limit: Int, $order_by: [current_token_ownerships_v2_order_by!]) {
  current_token_ownerships_v2(
    where: $where_condition
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    owner_address
  }
}
    `, Qhe = `
    query getTokenData($where_condition: current_token_datas_v2_bool_exp, $offset: Int, $limit: Int, $order_by: [current_token_datas_v2_order_by!]) {
  current_token_datas_v2(
    where: $where_condition
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    token_data_id
    token_name
    token_uri
    token_properties
    token_standard
    largest_property_version_v1
    maximum
    is_fungible_v2
    supply
    last_transaction_version
    last_transaction_timestamp
    current_collection {
      collection_id
      collection_name
      creator_address
      uri
      current_supply
    }
  }
}
    `, epe = `
    query getTokenOwnedFromCollection($where_condition: current_token_ownerships_v2_bool_exp!, $offset: Int, $limit: Int, $order_by: [current_token_ownerships_v2_order_by!]) {
  current_token_ownerships_v2(
    where: $where_condition
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    ...CurrentTokenOwnershipFields
  }
}
    ${ex}`, tpe = `
    query getTokenOwnersData($where_condition: current_token_ownerships_v2_bool_exp!, $offset: Int, $limit: Int, $order_by: [current_token_ownerships_v2_order_by!]) {
  current_token_ownerships_v2(
    where: $where_condition
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    owner_address
  }
}
    `, npe = `
    query getTopUserTransactions($limit: Int) {
  user_transactions(limit: $limit, order_by: {version: desc}) {
    version
  }
}
    `, rpe = `
    query getUserTransactions($limit: Int, $start_version: bigint, $offset: Int) {
  user_transactions(
    limit: $limit
    order_by: {version: desc}
    where: {version: {_lte: $start_version}}
    offset: $offset
  ) {
    version
  }
}
    `;
function tv(e, t, n) {
  if (!(t != null && t.includes(typeof e)))
    throw new Error(
      n || `Invalid arg: ${e} type should be ${t instanceof Array ? t.join(" or ") : t}`
    );
}
function oU(e) {
  if (tv(e, ["boolean", "string"]), typeof e == "boolean")
    return e;
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  throw new Error("Invalid boolean string.");
}
function el(e) {
  if (tv(e, ["number", "string"]), typeof e == "number")
    return e;
  const t = Number.parseInt(e, 10);
  if (Number.isNaN(t))
    throw new Error("Invalid number string.");
  return t;
}
function tl(e) {
  return tv(e, ["number", "bigint", "string"]), BigInt(e);
}
function ipe(e, t, n) {
  tx(e, t, n);
}
function tx(e, t, n, r) {
  if (t instanceof du)
    n.serializeBool(oU(e));
  else if (t instanceof Ga)
    n.serializeU8(el(e));
  else if (t instanceof tf)
    n.serializeU16(el(e));
  else if (t instanceof nf)
    n.serializeU32(el(e));
  else if (t instanceof hu)
    n.serializeU64(tl(e));
  else if (t instanceof pu)
    n.serializeU128(tl(e));
  else if (t instanceof rf)
    n.serializeU256(tl(e));
  else if (t instanceof tc)
    aU(e, n);
  else if (t instanceof of)
    ope(e, t, n);
  else if (t instanceof yu)
    ape(e, t, n);
  else
    throw new Error("Unsupported arg type.");
}
function aU(e, t) {
  let n;
  if (typeof e == "string" || e instanceof wt)
    n = In.fromHex(e);
  else if (e instanceof In)
    n = e;
  else
    throw new Error("Invalid account address.");
  n.serialize(t);
}
function ope(e, t, n, r) {
  if (t.value instanceof Ga) {
    if (e instanceof Uint8Array) {
      n.serializeBytes(e);
      return;
    }
    if (e instanceof wt) {
      n.serializeBytes(e.toUint8Array());
      return;
    }
    if (typeof e == "string") {
      n.serializeStr(e);
      return;
    }
  }
  if (!Array.isArray(e))
    throw new Error("Invalid vector args.");
  n.serializeU32AsUleb128(e.length), e.forEach((i) => tx(i, t.value, n));
}
function ape(e, t, n, r) {
  const { address: i, module_name: o, name: a, type_args: s } = t.value, c = `${wt.fromUint8Array(i.address).toShortString()}::${o.value}::${a.value}`;
  if (c === "0x1::string::String")
    tv(e, ["string"]), n.serializeStr(e);
  else if (c === "0x1::object::Object")
    aU(e, n);
  else if (c === "0x1::option::Option") {
    if (s.length !== 1)
      throw new Error(`Option has the wrong number of type arguments ${s.length}`);
    spe(e, s[0], n);
  } else
    throw new Error("Unsupported struct type in function argument");
}
function spe(e, t, n, r) {
  e == null ? n.serializeU32AsUleb128(0) : (n.serializeU32AsUleb128(1), tx(e, t, n));
}
function cpe(e, t) {
  if (t instanceof du)
    return new Xw(oU(e));
  if (t instanceof Ga)
    return new Kw(el(e));
  if (t instanceof tf)
    return new Vw(el(e));
  if (t instanceof nf)
    return new qw(el(e));
  if (t instanceof hu)
    return new Hw(tl(e));
  if (t instanceof pu)
    return new Gw(tl(e));
  if (t instanceof rf)
    return new Yw(tl(e));
  if (t instanceof tc) {
    let n;
    if (typeof e == "string" || e instanceof wt)
      n = In.fromHex(e);
    else if (e instanceof In)
      n = e;
    else
      throw new Error("Invalid account address.");
    return new Zw(n);
  }
  if (t instanceof of && t.value instanceof Ga) {
    if (!(e instanceof Uint8Array))
      throw new Error(`${e} should be an instance of Uint8Array`);
    return new Jw(e);
  }
  throw new Error("Unknown type for TransactionArgument.");
}
var upe = "APTOS::RawTransaction", UB = "APTOS::RawTransactionWithData", wd = class {
  constructor(e, t) {
    this.rawTxnBuilder = t, this.signingFunction = e;
  }
  build(e, t, n) {
    if (!this.rawTxnBuilder)
      throw new Error("this.rawTxnBuilder doesn't exist.");
    return this.rawTxnBuilder.build(e, t, n);
  }
  static getSigningMessage(e) {
    const t = Ol.create();
    if (e instanceof gu)
      t.update(upe);
    else if (e instanceof zw)
      t.update(UB);
    else if (e instanceof Fw)
      t.update(UB);
    else
      throw new Error("Unknown transaction type.");
    const n = t.digest(), r = Ha(e), i = new Uint8Array(n.length + r.length);
    return i.set(n), i.set(r, n.length), i;
  }
}, dE = class extends wd {
  constructor(e, t, n) {
    super(e, n), this.publicKey = t;
  }
  rawToSigned(e) {
    const t = wd.getSigningMessage(e), n = this.signingFunction(t), r = new Nw(
      new ao(this.publicKey),
      n
    );
    return new Y0(e, r);
  }
  sign(e) {
    return Ha(this.rawToSigned(e));
  }
}, lpe = class extends wd {
  constructor(e, t) {
    super(e), this.publicKey = t;
  }
  rawToSigned(e) {
    const t = wd.getSigningMessage(e), n = this.signingFunction(t), r = new jw(this.publicKey, n);
    return new Y0(e, r);
  }
  sign(e) {
    return Ha(this.rawToSigned(e));
  }
}, pI = class {
  constructor(e, t) {
    this.abiMap = /* @__PURE__ */ new Map(), e.forEach((n) => {
      const r = new $T(n), i = Qw.deserialize(r);
      let o;
      if (i instanceof Cl) {
        const a = i, { address: s, name: c } = a.module_name;
        o = `${wt.fromUint8Array(s.address).toShortString()}::${c.value}::${a.name}`;
      } else
        o = i.name;
      if (this.abiMap.has(o))
        throw new Error("Found conflicting ABI interfaces");
      this.abiMap.set(o, i);
    }), this.builderConfig = {
      maxGasAmount: BigInt(Yj),
      expSecFromNow: Zj,
      ...t
    };
  }
  static toBCSArgs(e, t) {
    if (e.length !== t.length)
      throw new Error("Wrong number of args provided.");
    return t.map((n, r) => {
      const i = new yr();
      return ipe(n, e[r].type_tag, i), i.getBytes();
    });
  }
  static toTransactionArguments(e, t) {
    if (e.length !== t.length)
      throw new Error("Wrong number of args provided.");
    return t.map((n, r) => cpe(n, e[r].type_tag));
  }
  setSequenceNumber(e) {
    this.builderConfig.sequenceNumber = BigInt(e);
  }
  buildTransactionPayload(e, t, n) {
    const r = t.map((a) => new af(a).parseTypeTag());
    let i;
    if (!this.abiMap.has(e))
      throw new Error(`Cannot find function: ${e}`);
    const o = this.abiMap.get(e);
    if (o instanceof Cl) {
      const a = o, s = pI.toBCSArgs(a.args, n);
      i = new $w(
        new Ic(a.module_name, new Jr(a.name), r, s)
      );
    } else if (o instanceof ev) {
      const a = o, s = pI.toTransactionArguments(a.args, n);
      i = new Lw(new Uw(a.code, r, s));
    } else
      throw new Error("Unknown ABI format.");
    return i;
  }
  build(e, t, n) {
    const { sender: r, sequenceNumber: i, gasUnitPrice: o, maxGasAmount: a, expSecFromNow: s, chainId: c } = this.builderConfig;
    if (!o)
      throw new Error("No gasUnitPrice provided.");
    const l = r instanceof In ? r : In.fromHex(r), u = BigInt(Math.floor(Date.now() / 1e3) + Number(s)), f = this.buildTransactionPayload(e, t, n);
    if (f)
      return new gu(
        l,
        BigInt(i),
        f,
        BigInt(a),
        BigInt(o),
        u,
        new Ww(Number(c))
      );
    throw new Error("Invalid ABI.");
  }
}, sU = class {
  constructor(e, t) {
    this.aptosClient = e, this.builderConfig = t;
  }
  async fetchABI(e) {
    const n = (await this.aptosClient.getAccountModules(e)).map((i) => i.abi).flatMap(
      (i) => i.exposed_functions.filter((o) => o.is_entry).map(
        (o) => ({
          fullName: `${i.address}::${i.name}::${o.name}`,
          ...o
        })
      )
    ), r = /* @__PURE__ */ new Map();
    return n.forEach((i) => {
      r.set(i.fullName, i);
    }), r;
  }
  async build(e, t, n) {
    if (e = ((x) => x.replace(/^0[xX]0*/g, "0x"))(e), e.split("::").length !== 3)
      throw new Error(
        "'func' needs to be a fully qualified function name in format <address>::<module>::<function>, e.g. 0x1::coin::transfer"
      );
    const [o, a] = e.split("::"), s = await this.fetchABI(o);
    if (!s.has(e))
      throw new Error(`${e} doesn't exist.`);
    const c = s.get(e), u = c.params.filter((x) => x !== "signer" && x !== "&signer").map(
      (x, N) => new X0(`var${N}`, new af(x, t).parseTypeTag())
    ), f = new Cl(
      c.name,
      Jc.fromStr(`${o}::${a}`),
      "",
      c.generic_type_params.map((x, N) => new J0(`${N}`)),
      u
    ), { sender: d, ...h } = this.builderConfig, g = d instanceof In ? wt.fromUint8Array(d.address) : d, [{ sequence_number: w }, b, { gas_estimate: I }] = await Promise.all([
      h != null && h.sequenceNumber ? Promise.resolve({ sequence_number: h == null ? void 0 : h.sequenceNumber }) : this.aptosClient.getAccount(g),
      h != null && h.chainId ? Promise.resolve(h == null ? void 0 : h.chainId) : this.aptosClient.getChainId(),
      h != null && h.gasUnitPrice ? Promise.resolve({ gas_estimate: h == null ? void 0 : h.gasUnitPrice }) : this.aptosClient.estimateGasPrice()
    ]);
    return new pI([Ha(f)], {
      sender: d,
      sequenceNumber: w,
      chainId: b,
      gasUnitPrice: BigInt(I),
      ...h
    }).build(e, t, n);
  }
};
xn([
  Jj(10 * 60 * 1e3)
], sU.prototype, "fetchABI", 1);
var Pu = class {
  constructor(e, t, n = !1) {
    if (!e)
      throw new Error("Node URL cannot be empty.");
    n ? this.nodeUrl = e : this.nodeUrl = she(e), this.config = t == null ? {} : { ...t };
  }
  async getAccount(e) {
    const { data: t } = await bi({
      url: this.nodeUrl,
      endpoint: `accounts/${wt.ensure(e).hex()}`,
      originMethod: "getAccount",
      overrides: { ...this.config }
    });
    return t;
  }
  async getAccountTransactions(e, t) {
    const { data: n } = await bi({
      url: this.nodeUrl,
      endpoint: `accounts/${wt.ensure(e).hex()}/transactions`,
      originMethod: "getAccountTransactions",
      params: { start: t == null ? void 0 : t.start, limit: t == null ? void 0 : t.limit },
      overrides: { ...this.config }
    });
    return n;
  }
  async getAccountModules(e, t) {
    return await RB({
      url: this.nodeUrl,
      endpoint: `accounts/${e}/modules`,
      params: { ledger_version: t == null ? void 0 : t.ledgerVersion, limit: 1e3 },
      originMethod: "getAccountModules",
      overrides: { ...this.config }
    });
  }
  async getAccountModule(e, t, n) {
    const { data: r } = await bi({
      url: this.nodeUrl,
      endpoint: `accounts/${wt.ensure(e).hex()}/module/${t}`,
      originMethod: "getAccountModule",
      params: { ledger_version: n == null ? void 0 : n.ledgerVersion },
      overrides: { ...this.config }
    });
    return r;
  }
  async getAccountResources(e, t) {
    return await RB({
      url: this.nodeUrl,
      endpoint: `accounts/${e}/resources`,
      params: { ledger_version: t == null ? void 0 : t.ledgerVersion, limit: 9999 },
      originMethod: "getAccountResources",
      overrides: { ...this.config }
    });
  }
  async getAccountResource(e, t, n) {
    const { data: r } = await bi({
      url: this.nodeUrl,
      endpoint: `accounts/${wt.ensure(e).hex()}/resource/${t}`,
      originMethod: "getAccountResource",
      params: { ledger_version: n == null ? void 0 : n.ledgerVersion },
      overrides: { ...this.config }
    });
    return r;
  }
  static generateBCSTransaction(e, t) {
    return new dE((r) => {
      const i = e.signBuffer(r);
      return new Kn.Ed25519Signature(i.toUint8Array());
    }, e.pubKey().toUint8Array()).sign(t);
  }
  static generateBCSSimulation(e, t) {
    return new dE((r) => {
      const i = new Uint8Array(64);
      return new Kn.Ed25519Signature(i);
    }, e.pubKey().toUint8Array()).sign(t);
  }
  async generateTransaction(e, t, n) {
    const r = { sender: e };
    if (n != null && n.sequence_number && (r.sequenceNumber = n.sequence_number), n != null && n.gas_unit_price && (r.gasUnitPrice = n.gas_unit_price), n != null && n.max_gas_amount && (r.maxGasAmount = n.max_gas_amount), n != null && n.expiration_timestamp_secs) {
      const o = Number.parseInt(n.expiration_timestamp_secs, 10);
      r.expSecFromNow = o - Math.floor(Date.now() / 1e3);
    }
    return new sU(this, r).build(t.function, t.type_arguments, t.arguments);
  }
  async generateFeePayerTransaction(e, t, n, r = [], i) {
    const o = await this.generateTransaction(e, t, i), a = r.map((c) => In.fromHex(c));
    return new Kn.FeePayerRawTransaction(o, a, In.fromHex(n));
  }
  async submitFeePayerTransaction(e, t, n, r = []) {
    const i = new Kn.TransactionAuthenticatorFeePayer(
      t,
      e.secondary_signer_addresses,
      r,
      { address: e.fee_payer_address, authenticator: n }
    ), o = Ha(
      new Kn.SignedTransaction(e.raw_txn, i)
    );
    return await this.submitSignedBCSTransaction(o);
  }
  async signMultiTransaction(e, t) {
    const n = new Kn.Ed25519Signature(
      e.signBuffer(wd.getSigningMessage(t)).toUint8Array()
    ), r = new Kn.AccountAuthenticatorEd25519(
      new Kn.Ed25519PublicKey(e.signingKey.publicKey),
      n
    );
    return Promise.resolve(r);
  }
  async signTransaction(e, t) {
    return Promise.resolve(Pu.generateBCSTransaction(e, t));
  }
  async getEventsByCreationNumber(e, t, n) {
    const { data: r } = await bi({
      url: this.nodeUrl,
      endpoint: `accounts/${wt.ensure(e).hex()}/events/${t}`,
      originMethod: "getEventsByCreationNumber",
      params: { start: n == null ? void 0 : n.start, limit: n == null ? void 0 : n.limit },
      overrides: { ...this.config }
    });
    return r;
  }
  async getEventsByEventHandle(e, t, n, r) {
    const { data: i } = await bi({
      url: this.nodeUrl,
      endpoint: `accounts/${wt.ensure(e).hex()}/events/${t}/${n}`,
      originMethod: "getEventsByEventHandle",
      params: { start: r == null ? void 0 : r.start, limit: r == null ? void 0 : r.limit },
      overrides: { ...this.config }
    });
    return i;
  }
  async submitTransaction(e) {
    return this.submitSignedBCSTransaction(e);
  }
  async simulateTransaction(e, t, n) {
    let r;
    return e instanceof hI ? r = Pu.generateBCSSimulation(e, t) : e instanceof G0 ? r = new lpe(() => {
      const { threshold: o } = e, a = [], s = [];
      for (let l = 0; l < o; l += 1)
        a.push(l), s.push(new Kn.Ed25519Signature(new Uint8Array(64)));
      const c = Kn.MultiEd25519Signature.createBitmap(a);
      return new Kn.MultiEd25519Signature(s, c);
    }, e).sign(t) : r = new dE(() => {
      const o = new Uint8Array(64);
      return new Kn.Ed25519Signature(o);
    }, e.toBytes()).sign(t), this.submitBCSSimulation(r, n);
  }
  async submitSignedBCSTransaction(e) {
    const { data: t } = await Cf({
      url: this.nodeUrl,
      body: e,
      endpoint: "transactions",
      originMethod: "submitSignedBCSTransaction",
      contentType: "application/x.aptos.signed_transaction+bcs",
      overrides: { ...this.config }
    });
    return t;
  }
  async submitBCSSimulation(e, t) {
    var n, r, i;
    const o = {
      estimate_gas_unit_price: (n = t == null ? void 0 : t.estimateGasUnitPrice) != null ? n : !1,
      estimate_max_gas_amount: (r = t == null ? void 0 : t.estimateMaxGasAmount) != null ? r : !1,
      estimate_prioritized_gas_unit_price: (i = t == null ? void 0 : t.estimatePrioritizedGasUnitPrice) != null ? i : !1
    }, { data: a } = await Cf({
      url: this.nodeUrl,
      body: e,
      endpoint: "transactions/simulate",
      params: o,
      originMethod: "submitBCSSimulation",
      contentType: "application/x.aptos.signed_transaction+bcs",
      overrides: { ...this.config }
    });
    return a;
  }
  async getTransactions(e) {
    var t;
    const { data: n } = await bi({
      url: this.nodeUrl,
      endpoint: "transactions",
      originMethod: "getTransactions",
      params: { start: (t = e == null ? void 0 : e.start) == null ? void 0 : t.toString(), limit: e == null ? void 0 : e.limit },
      overrides: { ...this.config }
    });
    return n;
  }
  async getTransactionByHash(e) {
    const { data: t } = await bi({
      url: this.nodeUrl,
      endpoint: `transactions/by_hash/${e}`,
      originMethod: "getTransactionByHash",
      overrides: { ...this.config }
    });
    return t;
  }
  async getTransactionByVersion(e) {
    const { data: t } = await bi({
      url: this.nodeUrl,
      endpoint: `transactions/by_version/${e}`,
      originMethod: "getTransactionByVersion",
      overrides: { ...this.config }
    });
    return t;
  }
  async transactionPending(e) {
    try {
      return (await this.getTransactionByHash(e)).type === "pending_transaction";
    } catch (t) {
      if ((t == null ? void 0 : t.status) === 404)
        return !0;
      throw t;
    }
  }
  async waitForTransactionWithResult(e, t) {
    var n, r;
    const i = (n = t == null ? void 0 : t.timeoutSecs) != null ? n : che, o = (r = t == null ? void 0 : t.checkSuccess) != null ? r : !1;
    let a = !0, s = 0, c;
    for (; a && !(s >= i); ) {
      try {
        if (c = await this.getTransactionByHash(e), a = c.type === "pending_transaction", !a)
          break;
      } catch (l) {
        const u = l instanceof nx, f = u && l.status !== 404 && l.status >= 400 && l.status < 500;
        if (!u || f)
          throw l;
      }
      await ahe(1e3), s += 1;
    }
    if (c === void 0)
      throw new Error(`Waiting for transaction ${e} failed`);
    if (a)
      throw new fpe(
        `Waiting for transaction ${e} timed out after ${i} seconds`,
        c
      );
    if (!o)
      return c;
    if (!(c != null && c.success))
      throw new dpe(
        `Transaction ${e} failed with an error: ${c.vm_status}`,
        c
      );
    return c;
  }
  async waitForTransaction(e, t) {
    await this.waitForTransactionWithResult(e, t);
  }
  async getLedgerInfo() {
    const { data: e } = await bi({
      url: this.nodeUrl,
      originMethod: "getLedgerInfo",
      overrides: { ...this.config }
    });
    return e;
  }
  async getChainId() {
    return (await this.getLedgerInfo()).chain_id;
  }
  async getTableItem(e, t, n) {
    var r;
    return (await Cf({
      url: this.nodeUrl,
      body: t,
      endpoint: `tables/${e}/item`,
      originMethod: "getTableItem",
      params: { ledger_version: (r = n == null ? void 0 : n.ledgerVersion) == null ? void 0 : r.toString() },
      overrides: { ...this.config }
    })).data;
  }
  async generateRawTransaction(e, t, n) {
    const [{ sequence_number: r }, i, { gas_estimate: o }] = await Promise.all([
      n != null && n.providedSequenceNumber ? Promise.resolve({ sequence_number: n.providedSequenceNumber }) : this.getAccount(e),
      this.getChainId(),
      n != null && n.gasUnitPrice ? Promise.resolve({ gas_estimate: n.gasUnitPrice }) : this.estimateGasPrice()
    ]), { maxGasAmount: a, gasUnitPrice: s, expireTimestamp: c } = {
      maxGasAmount: BigInt(Yj),
      gasUnitPrice: BigInt(o),
      expireTimestamp: BigInt(Math.floor(Date.now() / 1e3) + Zj),
      ...n
    };
    return new Kn.RawTransaction(
      Kn.AccountAddress.fromHex(e),
      BigInt(r),
      t,
      a,
      s,
      c,
      new Kn.ChainId(i)
    );
  }
  async generateSignSubmitTransaction(e, t, n) {
    const r = await this.generateRawTransaction(e.address(), t, n), i = Pu.generateBCSTransaction(e, r);
    return (await this.submitSignedBCSTransaction(i)).hash;
  }
  async signAndSubmitTransaction(e, t) {
    const n = Pu.generateBCSTransaction(e, t);
    return (await this.submitSignedBCSTransaction(n)).hash;
  }
  async publishPackage(e, t, n, r) {
    const i = new yr();
    Zr(n, i);
    const o = new Kn.TransactionPayloadEntryFunction(
      Kn.EntryFunction.natural(
        "0x1::code",
        "publish_package_txn",
        [],
        [_s(t), i.getBytes()]
      )
    );
    return this.generateSignSubmitTransaction(e, o, r);
  }
  async createResourceAccountAndPublishPackage(e, t, n, r, i) {
    const o = new yr();
    Zr(r, o);
    const a = new Kn.TransactionPayloadEntryFunction(
      Kn.EntryFunction.natural(
        "0x1::resource_account",
        "create_resource_account_and_publish_package",
        [],
        [_s(t), _s(n), o.getBytes()]
      )
    );
    return this.generateSignSubmitTransaction(e, a, i);
  }
  async generateSignSubmitWaitForTransaction(e, t, n) {
    const r = await this.generateSignSubmitTransaction(e, t, n);
    return this.waitForTransactionWithResult(r, n);
  }
  async estimateGasPrice() {
    const { data: e } = await bi({
      url: this.nodeUrl,
      endpoint: "estimate_gas_price",
      originMethod: "estimateGasPrice",
      overrides: { ...this.config }
    });
    return e;
  }
  async estimateMaxGasAmount(e) {
    const t = `0x1::coin::CoinStore<${uhe}>`, [{ gas_estimate: n }, r] = await Promise.all([
      this.estimateGasPrice(),
      this.getAccountResources(e)
    ]), i = r.find((a) => a.type === t);
    return BigInt(i.data.coin.value) / BigInt(n);
  }
  async rotateAuthKeyEd25519(e, t, n) {
    const { sequence_number: r, authentication_key: i } = await this.getAccount(
      e.address()
    ), o = new hI(t), a = new Kn.RotationProofChallenge(
      Kn.AccountAddress.CORE_CODE_ADDRESS,
      "account",
      "RotationProofChallenge",
      BigInt(r),
      Kn.AccountAddress.fromHex(e.address()),
      new Kn.AccountAddress(new wt(i).toUint8Array()),
      o.pubKey().toUint8Array()
    ), s = wt.fromUint8Array(Ha(a)), c = e.signHexString(s), l = o.signHexString(s), u = new Kn.TransactionPayloadEntryFunction(
      Kn.EntryFunction.natural(
        "0x1::account",
        "rotate_authentication_key",
        [],
        [
          fI(0),
          _s(e.pubKey().toUint8Array()),
          fI(0),
          _s(o.pubKey().toUint8Array()),
          _s(c.toUint8Array()),
          _s(l.toUint8Array())
        ]
      )
    ), f = await this.generateRawTransaction(e.address(), u, n), d = Pu.generateBCSTransaction(e, f);
    return this.submitSignedBCSTransaction(d);
  }
  async lookupOriginalAddress(e) {
    const t = await this.getAccountResource("0x1", "0x1::account::OriginatingAddress"), {
      address_map: { handle: n }
    } = t.data, r = await this.getTableItem(n, {
      key_type: "address",
      value_type: "address",
      key: wt.ensure(e).hex()
    });
    return new wt(r);
  }
  async getBlockByHeight(e, t) {
    const { data: n } = await bi({
      url: this.nodeUrl,
      endpoint: `blocks/by_height/${e}`,
      originMethod: "getBlockByHeight",
      params: { with_transactions: t },
      overrides: { ...this.config }
    });
    return n;
  }
  async getBlockByVersion(e, t) {
    const { data: n } = await bi({
      url: this.nodeUrl,
      endpoint: `blocks/by_version/${e}`,
      originMethod: "getBlockByVersion",
      params: { with_transactions: t },
      overrides: { ...this.config }
    });
    return n;
  }
  async view(e, t) {
    const { data: n } = await Cf({
      url: this.nodeUrl,
      body: e,
      endpoint: "view",
      originMethod: "getTableItem",
      params: { ledger_version: t },
      overrides: { ...this.config }
    });
    return n;
  }
  clearCache(e) {
    lhe(e);
  }
}, br = Pu;
xn([
  Cr
], br.prototype, "getAccount", 1);
xn([
  Cr
], br.prototype, "getAccountTransactions", 1);
xn([
  Cr,
  Jj(10 * 60 * 1e3)
], br.prototype, "getAccountModules", 1);
xn([
  Cr
], br.prototype, "getAccountModule", 1);
xn([
  Cr
], br.prototype, "getAccountResources", 1);
xn([
  Cr
], br.prototype, "getAccountResource", 1);
xn([
  Cr
], br.prototype, "getEventsByCreationNumber", 1);
xn([
  Cr
], br.prototype, "getEventsByEventHandle", 1);
xn([
  Cr
], br.prototype, "submitSignedBCSTransaction", 1);
xn([
  Cr
], br.prototype, "submitBCSSimulation", 1);
xn([
  Cr
], br.prototype, "getTransactions", 1);
xn([
  Cr
], br.prototype, "getTransactionByHash", 1);
xn([
  Cr
], br.prototype, "getTransactionByVersion", 1);
xn([
  Cr
], br.prototype, "getLedgerInfo", 1);
xn([
  Dw()
], br.prototype, "getChainId", 1);
xn([
  Cr
], br.prototype, "getTableItem", 1);
xn([
  Cr,
  Dw({
    ttlMs: 5 * 60 * 1e3,
    tags: ["gas_estimates"]
  })
], br.prototype, "estimateGasPrice", 1);
xn([
  Cr
], br.prototype, "estimateMaxGasAmount", 1);
xn([
  Cr
], br.prototype, "getBlockByHeight", 1);
xn([
  Cr
], br.prototype, "getBlockByVersion", 1);
xn([
  Cr
], br.prototype, "view", 1);
var fpe = class extends Error {
  constructor(e, t) {
    super(e), this.lastSubmittedTransaction = t;
  }
}, dpe = class extends Error {
  constructor(e, t) {
    super(e), this.transaction = t;
  }
}, nx = class extends Error {
  constructor(e, t, n, r) {
    super(t), this.status = e, this.message = t, this.errorCode = n, this.vmErrorCode = r;
  }
};
function Cr(e, t, n) {
  const r = n.value;
  return n.value = async function(...o) {
    var a, s;
    try {
      return await r.apply(this, [...o]);
    } catch (c) {
      throw c instanceof Xj ? new nx(
        c.status,
        JSON.stringify({ message: c.message, ...c.data }),
        (a = c.data) == null ? void 0 : a.error_code,
        (s = c.data) == null ? void 0 : s.vm_error_code
      ) : c;
    }
  }, n;
}
var Mr = class {
  constructor(e, t) {
    this.endpoint = e, this.config = t;
  }
  static validateAddress(e) {
    if (e.length < 66)
      throw new Error(`${e} is less than 66 chars long.`);
  }
  async queryIndexer(e) {
    const t = await Cf({
      url: this.endpoint,
      body: e,
      overrides: { WITH_CREDENTIALS: !1, ...this.config }
    });
    if (t.data.errors)
      throw new nx(
        t.data.errors[0].extensions.code,
        JSON.stringify({
          message: t.data.errors[0].message,
          error_code: t.data.errors[0].extensions.code
        })
      );
    return t.data.data;
  }
  async getIndexerLedgerInfo() {
    const e = {
      query: qhe
    };
    return this.queryIndexer(e);
  }
  async getAccountNFTs(e, t) {
    const n = wt.ensure(e).hex();
    Mr.validateAddress(n);
    const r = {
      query: zhe,
      variables: { address: n, offset: t == null ? void 0 : t.offset, limit: t == null ? void 0 : t.limit }
    };
    return this.queryIndexer(r);
  }
  async getTokenActivities(e, t) {
    var n, r;
    const i = wt.ensure(e).hex();
    Mr.validateAddress(i);
    const o = {
      token_data_id: { _eq: i }
    };
    t != null && t.tokenStandard && (o.token_standard = { _eq: t == null ? void 0 : t.tokenStandard });
    const a = {
      query: Zhe,
      variables: {
        where_condition: o,
        offset: (n = t == null ? void 0 : t.options) == null ? void 0 : n.offset,
        limit: (r = t == null ? void 0 : t.options) == null ? void 0 : r.limit,
        order_by: t == null ? void 0 : t.orderBy
      }
    };
    return this.queryIndexer(a);
  }
  async getTokenActivitiesCount(e) {
    const t = {
      query: Jhe,
      variables: { token_id: e }
    };
    return this.queryIndexer(t);
  }
  async getAccountTokensCount(e, t) {
    var n, r;
    const i = {
      owner_address: { _eq: e },
      amount: { _gt: "0" }
    };
    t != null && t.tokenStandard && (i.token_standard = { _eq: t == null ? void 0 : t.tokenStandard });
    const o = wt.ensure(e).hex();
    Mr.validateAddress(o);
    const a = {
      query: Fhe,
      variables: {
        where_condition: i,
        offset: (n = t == null ? void 0 : t.options) == null ? void 0 : n.offset,
        limit: (r = t == null ? void 0 : t.options) == null ? void 0 : r.limit
      }
    };
    return this.queryIndexer(a);
  }
  async getTokenData(e, t) {
    var n, r;
    const i = wt.ensure(e).hex();
    Mr.validateAddress(i);
    const o = {
      token_data_id: { _eq: i }
    };
    t != null && t.tokenStandard && (o.token_standard = { _eq: t == null ? void 0 : t.tokenStandard });
    const a = {
      query: Qhe,
      variables: {
        where_condition: o,
        offset: (n = t == null ? void 0 : t.options) == null ? void 0 : n.offset,
        limit: (r = t == null ? void 0 : t.options) == null ? void 0 : r.limit,
        order_by: t == null ? void 0 : t.orderBy
      }
    };
    return this.queryIndexer(a);
  }
  async getTokenOwnersData(e, t, n) {
    var r, i;
    const o = wt.ensure(e).hex();
    Mr.validateAddress(o);
    const a = {
      token_data_id: { _eq: o }
    };
    t && (a.property_version_v1 = { _eq: t }), n != null && n.tokenStandard && (a.token_standard = { _eq: n == null ? void 0 : n.tokenStandard });
    const s = {
      query: tpe,
      variables: {
        where_condition: a,
        offset: (r = n == null ? void 0 : n.options) == null ? void 0 : r.offset,
        limit: (i = n == null ? void 0 : n.options) == null ? void 0 : i.limit,
        order_by: n == null ? void 0 : n.orderBy
      }
    };
    return this.queryIndexer(s);
  }
  async getTokenCurrentOwnerData(e, t, n) {
    var r, i;
    const o = wt.ensure(e).hex();
    Mr.validateAddress(o);
    const a = {
      token_data_id: { _eq: o },
      amount: { _gt: "0" }
    };
    t && (a.property_version_v1 = { _eq: t }), n != null && n.tokenStandard && (a.token_standard = { _eq: n == null ? void 0 : n.tokenStandard });
    const s = {
      query: Xhe,
      variables: {
        where_condition: a,
        offset: (r = n == null ? void 0 : n.options) == null ? void 0 : r.offset,
        limit: (i = n == null ? void 0 : n.options) == null ? void 0 : i.limit,
        order_by: n == null ? void 0 : n.orderBy
      }
    };
    return this.queryIndexer(s);
  }
  async getOwnedTokens(e, t) {
    var n, r;
    const i = wt.ensure(e).hex();
    Mr.validateAddress(i);
    const o = {
      owner_address: { _eq: i },
      amount: { _gt: 0 }
    };
    t != null && t.tokenStandard && (o.token_standard = { _eq: t == null ? void 0 : t.tokenStandard });
    const a = {
      query: Ghe,
      variables: {
        where_condition: o,
        offset: (n = t == null ? void 0 : t.options) == null ? void 0 : n.offset,
        limit: (r = t == null ? void 0 : t.options) == null ? void 0 : r.limit,
        order_by: t == null ? void 0 : t.orderBy
      }
    };
    return this.queryIndexer(a);
  }
  async getOwnedTokensByTokenData(e, t) {
    var n, r;
    const i = wt.ensure(e).hex();
    Mr.validateAddress(i);
    const o = {
      token_data_id: { _eq: i },
      amount: { _gt: 0 }
    };
    t != null && t.tokenStandard && (o.token_standard = { _eq: t == null ? void 0 : t.tokenStandard });
    const a = {
      query: Yhe,
      variables: {
        where_condition: o,
        offset: (n = t == null ? void 0 : t.options) == null ? void 0 : n.offset,
        limit: (r = t == null ? void 0 : t.options) == null ? void 0 : r.limit,
        order_by: t == null ? void 0 : t.orderBy
      }
    };
    return this.queryIndexer(a);
  }
  async getTokenOwnedFromCollectionAddress(e, t, n) {
    var r, i;
    const o = wt.ensure(e).hex();
    Mr.validateAddress(o);
    const a = wt.ensure(t).hex();
    Mr.validateAddress(a);
    const s = {
      owner_address: { _eq: o },
      current_token_data: { collection_id: { _eq: a } },
      amount: { _gt: 0 }
    };
    n != null && n.tokenStandard && (s.token_standard = { _eq: n == null ? void 0 : n.tokenStandard });
    const c = {
      query: epe,
      variables: {
        where_condition: s,
        offset: (r = n == null ? void 0 : n.options) == null ? void 0 : r.offset,
        limit: (i = n == null ? void 0 : n.options) == null ? void 0 : i.limit,
        order_by: n == null ? void 0 : n.orderBy
      }
    };
    return this.queryIndexer(c);
  }
  async getTokenOwnedFromCollectionNameAndCreatorAddress(e, t, n, r) {
    const i = await this.getCollectionAddress(n, t, r);
    return await this.getTokenOwnedFromCollectionAddress(e, i, r);
  }
  async getCollectionData(e, t, n) {
    var r, i;
    const o = wt.ensure(e).hex();
    Mr.validateAddress(o);
    const a = {
      collection_name: { _eq: t },
      creator_address: { _eq: o }
    };
    n != null && n.tokenStandard && (a.token_standard = { _eq: n == null ? void 0 : n.tokenStandard });
    const s = {
      query: Whe,
      variables: {
        where_condition: a,
        offset: (r = n == null ? void 0 : n.options) == null ? void 0 : r.offset,
        limit: (i = n == null ? void 0 : n.options) == null ? void 0 : i.limit,
        order_by: n == null ? void 0 : n.orderBy
      }
    };
    return this.queryIndexer(s);
  }
  async getCollectionAddress(e, t, n) {
    return (await this.getCollectionData(e, t, n)).current_collections_v2[0].collection_id;
  }
  async getCollectionsWithOwnedTokens(e, t) {
    var n, r;
    const i = wt.ensure(e).hex();
    Mr.validateAddress(i);
    const o = {
      owner_address: { _eq: i }
    };
    t != null && t.tokenStandard && (o.current_collection = { token_standard: { _eq: t == null ? void 0 : t.tokenStandard } });
    const a = {
      query: Khe,
      variables: {
        where_condition: o,
        offset: (n = t == null ? void 0 : t.options) == null ? void 0 : n.offset,
        limit: (r = t == null ? void 0 : t.options) == null ? void 0 : r.limit,
        order_by: t == null ? void 0 : t.orderBy
      }
    };
    return this.queryIndexer(a);
  }
  async getAccountTransactionsCount(e) {
    const t = wt.ensure(e).hex();
    Mr.validateAddress(t);
    const n = {
      query: Lhe,
      variables: { address: t }
    };
    return this.queryIndexer(n);
  }
  async getAccountTransactionsData(e, t) {
    const n = wt.ensure(e).hex();
    Mr.validateAddress(n);
    const r = {
      query: $he,
      variables: { address: n, offset: t == null ? void 0 : t.offset, limit: t == null ? void 0 : t.limit }
    };
    return this.queryIndexer(r);
  }
  async getTopUserTransactions(e) {
    const t = {
      query: npe,
      variables: { limit: e }
    };
    return this.queryIndexer(t);
  }
  async getUserTransactions(e, t) {
    const n = {
      query: rpe,
      variables: { start_version: e, offset: t == null ? void 0 : t.offset, limit: t == null ? void 0 : t.limit }
    };
    return this.queryIndexer(n);
  }
  async getDelegatedStakingActivities(e, t) {
    const n = wt.ensure(e).hex(), r = wt.ensure(t).hex();
    Mr.validateAddress(n), Mr.validateAddress(r);
    const i = {
      query: Vhe,
      variables: {
        delegatorAddress: n,
        poolAddress: r
      }
    };
    return this.queryIndexer(i);
  }
  async getNumberOfDelegators(e) {
    const t = wt.ensure(e).hex();
    Mr.validateAddress(t);
    const n = {
      query: Hhe,
      variables: { poolAddress: t }
    };
    return this.queryIndexer(n);
  }
  async getAccountCoinsData(e, t) {
    const n = wt.ensure(e).hex();
    Mr.validateAddress(n);
    const r = {
      query: Uhe,
      variables: { owner_address: n, offset: t == null ? void 0 : t.offset, limit: t == null ? void 0 : t.limit }
    };
    return this.queryIndexer(r);
  }
}, rx = class {
  constructor(e, t, n = !1) {
    let r = null, i = null;
    if (typeof e == "object" && hpe(e) ? (r = e.fullnodeUrl, i = e.indexerUrl, this.network = "CUSTOM") : (r = phe[e], i = hhe[e], this.network = e), this.network === "CUSTOM" && !r)
      throw new Error("fullnode url is not provided");
    i && (this.indexerClient = new Mr(i, t)), this.aptosClient = new br(r, t, n);
  }
};
function cU(e, t, n) {
  Object.getOwnPropertyNames(t.prototype).forEach((r) => {
    const i = Object.getOwnPropertyDescriptor(t.prototype, r);
    i && (i.value = function(...o) {
      return this[n][r](...o);
    }, Object.defineProperty(e.prototype, r, i));
  }), Object.getOwnPropertyNames(t).forEach((r) => {
    const i = Object.getOwnPropertyDescriptor(t, r);
    i && (i.value = function(...o) {
      return this[n][r](...o);
    }, !e.hasOwnProperty.call(e, r) && Object.defineProperty(e, r, i));
  });
}
cU(rx, br, "aptosClient");
cU(rx, Mr, "indexerClient");
function hpe(e) {
  return e.fullnodeUrl !== void 0 && typeof e.fullnodeUrl == "string";
}
var uU = class {
  constructor(e, t) {
    this.type = e, this.value = t;
  }
}, lU = class {
  constructor() {
    this.data = {};
  }
  setProperty(e, t) {
    this.data[e] = t;
  }
};
function ppe(e) {
  let t;
  return e === "string" || e === "String" ? t = new yu(GT) : t = new af(e).parseTypeTag(), t;
}
function fU(e) {
  const t = e.map.data, n = new lU();
  return t.forEach((r) => {
    const { key: i } = r, o = r.value.value, a = r.value.type, s = ppe(a), c = ype(s, o), l = new uU(a, c);
    n.setProperty(i, l);
  }), n;
}
function ype(e, t) {
  const n = new $T(new wt(t).toUint8Array());
  let r = "";
  return e instanceof Ga ? r = n.deserializeU8().toString() : e instanceof hu ? r = n.deserializeU64().toString() : e instanceof pu ? r = n.deserializeU128().toString() : e instanceof du ? r = n.deserializeBool() ? "true" : "false" : e instanceof tc ? r = wt.fromUint8Array(n.deserializeFixedBytes(32)).hex() : e instanceof yu && e.isStringTypeTag() ? r = n.deserializeStr() : r = t, r;
}
var gpe = {};
Cw(gpe, {
  PropertyMap: () => lU,
  PropertyValue: () => uU,
  Token: () => mpe,
  TokenData: () => bpe
});
var bpe = class {
  constructor(e, t, n, r, i, o, a, s) {
    this.collection = e, this.description = t, this.name = n, this.maximum = r, this.supply = i, this.uri = o, this.default_properties = fU(a), this.mutability_config = s;
  }
}, mpe = class {
  constructor(e, t, n) {
    this.id = e, this.amount = t, this.token_properties = fU(n);
  }
}, _pe = {};
Cw(_pe, {
  AptosErrorCode: () => dU,
  MoveFunctionVisibility: () => hU,
  RoleType: () => pU
});
var dU = /* @__PURE__ */ ((e) => (e.ACCOUNT_NOT_FOUND = "account_not_found", e.RESOURCE_NOT_FOUND = "resource_not_found", e.MODULE_NOT_FOUND = "module_not_found", e.STRUCT_FIELD_NOT_FOUND = "struct_field_not_found", e.VERSION_NOT_FOUND = "version_not_found", e.TRANSACTION_NOT_FOUND = "transaction_not_found", e.TABLE_ITEM_NOT_FOUND = "table_item_not_found", e.BLOCK_NOT_FOUND = "block_not_found", e.STATE_VALUE_NOT_FOUND = "state_value_not_found", e.VERSION_PRUNED = "version_pruned", e.BLOCK_PRUNED = "block_pruned", e.INVALID_INPUT = "invalid_input", e.INVALID_TRANSACTION_UPDATE = "invalid_transaction_update", e.SEQUENCE_NUMBER_TOO_OLD = "sequence_number_too_old", e.VM_ERROR = "vm_error", e.HEALTH_CHECK_FAILED = "health_check_failed", e.MEMPOOL_IS_FULL = "mempool_is_full", e.INTERNAL_ERROR = "internal_error", e.WEB_FRAMEWORK_ERROR = "web_framework_error", e.BCS_NOT_SUPPORTED = "bcs_not_supported", e.API_DISABLED = "api_disabled", e))(dU || {}), hU = /* @__PURE__ */ ((e) => (e.PRIVATE = "private", e.PUBLIC = "public", e.FRIEND = "friend", e))(hU || {}), pU = /* @__PURE__ */ ((e) => (e.VALIDATOR = "validator", e.FULL_NODE = "full_node", e))(pU || {});
const wpe = {
  AptosDevnet: mb.DEVNET,
  AptosMainnet: mb.MAINNET,
  AptosTestnet: mb.TESTNET
};
class vpe {
  get blockchainNetwork() {
    return this._blockchainNetwork;
  }
  async address() {
    var t;
    const n = await ((t = this._wallet) === null || t === void 0 ? void 0 : t.account());
    return n == null ? void 0 : n.address;
  }
  async publicKey() {
    var t;
    const n = await ((t = this._wallet) === null || t === void 0 ? void 0 : t.account());
    return n == null ? void 0 : n.publicKey;
  }
  constructor(t) {
    this._blockchainNetwork = t;
  }
  async connected() {
    var t;
    return await ((t = this._wallet) === null || t === void 0 ? void 0 : t.isConnected()) || !1;
  }
  async connect() {
    if ("aptos" in window)
      this._wallet = window.aptos, await this._wallet.connect();
    else
      throw new lt("Aptos wallet not installed");
  }
  async disconnect() {
    var t;
    await ((t = this._wallet) === null || t === void 0 ? void 0 : t.disconnect());
  }
  async signMessage(t) {
    if (!this._wallet)
      throw new lt("Aptos wallet not initialized");
    return {
      signature: (await this._wallet.signMessage({
        message: t,
        nonce: "0"
      })).signature,
      publicKey: await this.publicKey(),
      network: this._blockchainNetwork
    };
  }
  async mint(t, n) {
    if (!this._wallet)
      throw new lt("Aptos wallet not initialized");
    t = t.startsWith("0x") ? t : `0x${t}`;
    const r = Uint8Array.from(Buffer.from(n.signature, "hex")), i = [
      n.metadata_cid,
      n.expiry,
      n.seconds_to_pay,
      n.verification_tier,
      r
    ];
    return (await this._wallet.signAndSubmitTransaction({
      function: `${t}::kycdao_sbt::mint_with_signature`,
      type_arguments: [],
      arguments: i
    })).hash;
  }
}
var Spe = globalThis && globalThis.__decorate || function(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(e, t, n, r);
  else
    for (var s = e.length - 1; s >= 0; s--)
      (a = e[s]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, n, o) : a(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
}, hE = globalThis && globalThis.__metadata || function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
class ix {
  constructor(t, n) {
    this.contractAddress = t, this.provider = new rx(wpe[n]);
  }
  async getTransaction(t) {
    try {
      if (await this.provider.transactionPending(t))
        return {
          status: "Started"
        };
      const n = await this.provider.getTransactionByHash(t);
      if (n.success) {
        const r = n.events.find((i) => i.type === "0x4::collection::MintEvent");
        return {
          status: "Success",
          data: r ? r.data.token : null
        };
      } else
        return {
          status: "Failure"
        };
    } catch {
      throw new lt(`Transaction ${t} doesn't exist`);
    }
  }
  async hasValidNft(t) {
    return (await this.provider.view({
      function: this.contractAddress + "::kycdao_sbt::has_valid_token",
      type_arguments: [],
      arguments: [t]
    }))[0];
  }
  async tokenAddrForOwner(t) {
    return (await this.provider.view({
      function: this.contractAddress + "::kycdao_sbt::get_token_addr_from_acct",
      type_arguments: [],
      arguments: [t]
    }))[0];
  }
  async getTokenData(t) {
    const r = (await this.provider.getTokenData(t, { tokenStandard: "v2" })).current_token_datas_v2[0], o = await (await fetch(r.token_uri)).json();
    return {
      name: o.name,
      description: o.description,
      image: Bb(o.image)
    };
  }
  async getValidNftsCore(t) {
    if (await this.hasValidNft(t.address)) {
      const r = await this.tokenAddrForOwner(t.address), i = await this.getTokenData(r);
      return {
        networkAndAddress: t,
        hasValidNft: !0,
        tokens: [i]
      };
    } else
      return {
        networkAndAddress: t,
        hasValidNft: !1
      };
  }
  async getValidNfts(t) {
    try {
      return this.getValidNftsCore(t);
    } catch (n) {
      let r;
      n instanceof $o ? r = n : r = new lt(String(n));
      const i = r.toString();
      return {
        networkAndAddress: t,
        error: i
      };
    }
  }
}
Spe([
  Gn(),
  hE("design:type", Function),
  hE("design:paramtypes", [Object]),
  hE("design:returntype", Promise)
], ix.prototype, "getValidNftsCore", null);
class Epe {
  constructor(t, n, r, i) {
    switch (t) {
      case "Ethereum": {
        this.provider = new ck(n, r);
        break;
      }
      case "Near": {
        this.provider = new uD(n, r);
        break;
      }
      case "Solana": {
        this.provider = new TT(n, r);
        break;
      }
      case "Aptos": {
        this.provider = new ix(n, i);
        break;
      }
      default:
        throw new bs(t);
    }
  }
  async hasValidNft(t) {
    return this.provider.hasValidNft(t);
  }
  async getValidNfts(t) {
    return this.provider.getValidNfts(t);
  }
}
const Ape = "Phantom";
class Ipe extends uF {
  constructor(t = {}) {
    super(), this.name = Ape, this.url = "https://phantom.app", this.icon = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjM0IiB3aWR0aD0iMzQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iLjUiIHgyPSIuNSIgeTE9IjAiIHkyPSIxIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiM1MzRiYjEiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM1NTFiZjkiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iYiIgeDE9Ii41IiB4Mj0iLjUiIHkxPSIwIiB5Mj0iMSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmZmIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmZmIiBzdG9wLW9wYWNpdHk9Ii44MiIvPjwvbGluZWFyR3JhZGllbnQ+PGNpcmNsZSBjeD0iMTciIGN5PSIxNyIgZmlsbD0idXJsKCNhKSIgcj0iMTciLz48cGF0aCBkPSJtMjkuMTcwMiAxNy4yMDcxaC0yLjk5NjljMC02LjEwNzQtNC45NjgzLTExLjA1ODE3LTExLjA5NzUtMTEuMDU4MTctNi4wNTMyNSAwLTEwLjk3NDYzIDQuODI5NTctMTEuMDk1MDggMTAuODMyMzctLjEyNDYxIDYuMjA1IDUuNzE3NTIgMTEuNTkzMiAxMS45NDUzOCAxMS41OTMyaC43ODM0YzUuNDkwNiAwIDEyLjg0OTctNC4yODI5IDEzLjk5OTUtOS41MDEzLjIxMjMtLjk2MTktLjU1MDItMS44NjYxLTEuNTM4OC0xLjg2NjF6bS0xOC41NDc5LjI3MjFjMCAuODE2Ny0uNjcwMzggMS40ODQ3LTEuNDkwMDEgMS40ODQ3LS44MTk2NCAwLTEuNDg5OTgtLjY2ODMtMS40ODk5OC0xLjQ4NDd2LTIuNDAxOWMwLS44MTY3LjY3MDM0LTEuNDg0NyAxLjQ4OTk4LTEuNDg0Ny44MTk2MyAwIDEuNDkwMDEuNjY4IDEuNDkwMDEgMS40ODQ3em01LjE3MzggMGMwIC44MTY3LS42NzAzIDEuNDg0Ny0xLjQ4OTkgMS40ODQ3LS44MTk3IDAtMS40OS0uNjY4My0xLjQ5LTEuNDg0N3YtMi40MDE5YzAtLjgxNjcuNjcwNi0xLjQ4NDcgMS40OS0xLjQ4NDcuODE5NiAwIDEuNDg5OS42NjggMS40ODk5IDEuNDg0N3oiIGZpbGw9InVybCgjYikiLz48L3N2Zz4K", this.supportedTransactionVersions = /* @__PURE__ */ new Set(["legacy", 0]), this._readyState = typeof window > "u" || typeof document > "u" ? ro.Unsupported : ro.NotDetected, this._disconnected = () => {
      const n = this._wallet;
      n && (n.off("disconnect", this._disconnected), n.off("accountChanged", this._accountChanged), this._wallet = null, this._publicKey = null, this.emit("error", new tF()), this.emit("disconnect"));
    }, this._accountChanged = (n) => {
      const r = this._publicKey;
      if (r) {
        try {
          n = new Ae(n.toBytes());
        } catch (i) {
          this.emit("error", new xx(i == null ? void 0 : i.message, i));
          return;
        }
        r.equals(n) || (this._publicKey = n, this.emit("connect", n));
      }
    }, this._connecting = !1, this._wallet = null, this._publicKey = null, this._readyState !== ro.Unsupported && (sF() ? (this._readyState = ro.Loadable, this.emit("readyStateChange", this._readyState)) : aF(() => {
      var n, r, i;
      return (r = (n = window.phantom) == null ? void 0 : n.solana) != null && r.isPhantom || (i = window.solana) != null && i.isPhantom ? (this._readyState = ro.Installed, this.emit("readyStateChange", this._readyState), !0) : !1;
    }));
  }
  get publicKey() {
    return this._publicKey;
  }
  get connecting() {
    return this._connecting;
  }
  get readyState() {
    return this._readyState;
  }
  async autoConnect() {
    this.readyState === ro.Installed && await this.connect();
  }
  async connect() {
    var t;
    try {
      if (this.connected || this.connecting)
        return;
      if (this.readyState === ro.Loadable) {
        const i = encodeURIComponent(window.location.href), o = encodeURIComponent(window.location.origin);
        window.location.href = `https://phantom.app/ul/browse/${i}?ref=${o}`;
        return;
      }
      if (this.readyState !== ro.Installed)
        throw new Qz();
      this._connecting = !0;
      const n = ((t = window.phantom) == null ? void 0 : t.solana) || window.solana;
      if (!n.isConnected)
        try {
          await n.connect();
        } catch (i) {
          throw new eF(i == null ? void 0 : i.message, i);
        }
      if (!n.publicKey)
        throw new rF();
      let r;
      try {
        r = new Ae(n.publicKey.toBytes());
      } catch (i) {
        throw new xx(i == null ? void 0 : i.message, i);
      }
      n.on("disconnect", this._disconnected), n.on("accountChanged", this._accountChanged), this._wallet = n, this._publicKey = r, this.emit("connect", r);
    } catch (n) {
      throw this.emit("error", n), n;
    } finally {
      this._connecting = !1;
    }
  }
  async disconnect() {
    const t = this._wallet;
    if (t) {
      t.off("disconnect", this._disconnected), t.off("accountChanged", this._accountChanged), this._wallet = null, this._publicKey = null;
      try {
        await t.disconnect();
      } catch (n) {
        this.emit("error", new nF(n == null ? void 0 : n.message, n));
      }
    }
    this.emit("disconnect");
  }
  async sendTransaction(t, n, r = {}) {
    try {
      const i = this._wallet;
      if (!i)
        throw new If();
      try {
        const { signers: o, ...a } = r;
        jE(t) ? o != null && o.length && t.sign(o) : (t = await this.prepareTransaction(t, n, a), o != null && o.length && t.partialSign(...o)), a.preflightCommitment = a.preflightCommitment || n.commitment;
        const { signature: s } = await i.signAndSendTransaction(t, a);
        return s;
      } catch (o) {
        throw o instanceof go ? o : new kf(o == null ? void 0 : o.message, o);
      }
    } catch (i) {
      throw this.emit("error", i), i;
    }
  }
  async signTransaction(t) {
    try {
      const n = this._wallet;
      if (!n)
        throw new If();
      try {
        return await n.signTransaction(t) || t;
      } catch (r) {
        throw new Cu(r == null ? void 0 : r.message, r);
      }
    } catch (n) {
      throw this.emit("error", n), n;
    }
  }
  async signAllTransactions(t) {
    try {
      const n = this._wallet;
      if (!n)
        throw new If();
      try {
        return await n.signAllTransactions(t) || t;
      } catch (r) {
        throw new Cu(r == null ? void 0 : r.message, r);
      }
    } catch (n) {
      throw this.emit("error", n), n;
    }
  }
  async signMessage(t) {
    try {
      const n = this._wallet;
      if (!n)
        throw new If();
      try {
        const { signature: r } = await n.signMessage(t);
        return r;
      } catch (r) {
        throw new iF(r == null ? void 0 : r.message, r);
      }
    } catch (n) {
      throw this.emit("error", n), n;
    }
  }
}
const kpe = {
  SolanaDevnet: jf.Devnet,
  SolanaMainnet: jf.Mainnet,
  SolanaTestnet: jf.Testnet
};
class Tpe {
  get blockchainNetwork() {
    return this._blockchainNetwork;
  }
  set adapter(t) {
    this._adapter = t;
  }
  get address() {
    var t, n;
    return (n = (t = this._adapter) === null || t === void 0 ? void 0 : t.publicKey) === null || n === void 0 ? void 0 : n.toBase58();
  }
  constructor(t) {
    this._blockchainNetwork = t, this._network = kpe[t], this._connection = new Rk(DR(this._network), "processed");
  }
  get ready() {
    return !!this._adapter && (this._adapter.readyState === ro.Installed || this._adapter.readyState === ro.Loadable);
  }
  get connected() {
    var t;
    return !!(!((t = this._adapter) === null || t === void 0) && t.connected);
  }
  async connect() {
    var t;
    if (this.ready && !this.connected)
      return (t = this._adapter) === null || t === void 0 ? void 0 : t.connect();
  }
  async disconnect() {
    var t;
    if (this.ready && this.connected)
      return (t = this._adapter) === null || t === void 0 ? void 0 : t.disconnect();
  }
  async signMessage(t) {
    if (!Pb(this._adapter))
      throw new lt("Solana wallet adapter not initialized");
    if (typeof this._adapter.signMessage != "function")
      throw new lt("Initialized wallet provider is unable to sign messages");
    const n = await this._adapter.signMessage(Buffer.from(t, "utf-8"));
    return kne.encode(n);
  }
  async mint(t, n) {
    if (!this._adapter)
      throw new lt("Solana wallet adapter not initialized");
    return t.startsWith("0x") && (t = t.slice(2)), await this._adapter.sendTransaction(n, this._connection);
  }
}
var xr = globalThis && globalThis.__decorate || function(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(e, t, n, r);
  else
    for (var s = e.length - 1; s >= 0; s--)
      (a = e[s]) && (o = (i < 3 ? a(o) : i > 3 ? a(t, n, o) : a(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
}, pt = globalThis && globalThis.__metadata || function(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
};
const Rf = Array.from(_$);
class Hn extends l$ {
  getNetworkDetails(t) {
    const n = this.networkDetails[t];
    if (!n)
      throw new lt(`Network details not found for ${t}`);
    return n;
  }
  get sdkStatus() {
    var t, n, r;
    return {
      baseUrl: this.baseUrl,
      demoMode: this.demoMode,
      availableBlockchainNetworks: this.blockchainNetworks,
      availableVerificationTypes: this.verificationTypes,
      evmProviderConfigured: !!this.evmProvider,
      nearNetworkConnected: ((t = this.near) === null || t === void 0 ? void 0 : t.blockchainNetwork) || null,
      solanaNetworkConnected: ((n = this.solana) === null || n === void 0 ? void 0 : n.blockchainNetwork) || null,
      aptosNetworkConnected: ((r = this.aptos) === null || r === void 0 ? void 0 : r.blockchainNetwork) || null
    };
  }
  get connectedWallet() {
    return this._chainAndAddress;
  }
  get walletConnected() {
    return !!this._chainAndAddress;
  }
  get loggedIn() {
    return !!this.user;
  }
  get subscribed() {
    if (!this.user)
      throw new Xn("UserNotLoggedIn");
    return !!this.user.subscription_expiry;
  }
  isVerifiedForType(t) {
    var n;
    return ((n = this.user) === null || n === void 0 ? void 0 : n.verification_requests.some((r) => r.verification_type === t && r.status === "Verified")) || !1;
  }
  getVerificationStatusByType() {
    const t = {}, n = Object.values(Du);
    for (const r of n)
      t[r] = this.isVerifiedForType(r);
    return t;
  }
  getSmartContractAddress(t, n) {
    var r, i, o;
    return (o = (i = (r = this.apiStatus) === null || r === void 0 ? void 0 : r.smart_contracts_info[t]) === null || i === void 0 ? void 0 : i[n]) === null || o === void 0 ? void 0 : o.address;
  }
  getBlockchainAccount(t) {
    var n;
    const r = (n = this.user) === null || n === void 0 ? void 0 : n.blockchain_accounts;
    if (!(r != null && r.length))
      throw new lt("User has no blockchain accounts.");
    const { blockchain: i, address: o } = t, a = r.filter((s) => Mx(i, s.address, o));
    if (a.length > 1)
      throw new lt("Multiple blockchain accounts found for the same wallet address.");
    if (!a.length)
      throw new lt("Wallet address is not registered to the current user.");
    return a[0];
  }
  getValidAuthorizationCode() {
    var t;
    if (this._chainAndAddress && this.user)
      try {
        return (t = this.getBlockchainAccount(this._chainAndAddress).tokens.find((r) => r.authorization_tx_id && !r.minted_at)) === null || t === void 0 ? void 0 : t.authorization_code;
      } catch {
        return;
      }
  }
  async getTx(t, n) {
    var r, i, o, a;
    switch (t.blockchain) {
      case "Near": {
        if (!this.near)
          throw new un("Near SDK not initialized.");
        const s = new YI.JsonRpcProvider({ url: this.near.archival });
        try {
          const c = await s.txStatus(n, this.near.contractName);
          return typeof c.status != "string" ? c.status.SuccessValue !== void 0 ? {
            status: "Success",
            data: c
          } : c.status.Failure !== void 0 ? {
            status: "Failure",
            data: c
          } : {
            status: "Unknown",
            data: c
          } : {
            status: c.status,
            data: c
          };
        } catch (c) {
          throw new lt(`Unexpected error while checking Near transaction: ${c}.`);
        }
      }
      case "Ethereum": {
        if (!this.evmProvider)
          throw new un("EVM provider not configured.");
        const s = await this.evmProvider.getTransactionReceipt(n);
        return s ? s.status === 1 ? {
          status: "Success",
          data: s
        } : {
          status: "Failure",
          data: s
        } : {
          status: "Unknown"
        };
      }
      case "Solana": {
        if (!this.solana)
          throw new un("Solana support is not enabled.");
        const s = this.getNetworkDetails(t.blockchainNetwork).rpc_urls[0], c = (a = (o = (i = (r = this.apiStatus) === null || r === void 0 ? void 0 : r.smart_contracts_info) === null || i === void 0 ? void 0 : i[t.blockchainNetwork]) === null || o === void 0 ? void 0 : o[Du.KYC]) === null || a === void 0 ? void 0 : a.address;
        if (!c)
          throw new lt("No contract address found for Solana.");
        return await new TT(c, s).getTransaction(n);
      }
      case "Aptos": {
        if (!this.aptos)
          throw new un("Aptos support is not enabled.");
        return await new ix("", this.aptos.blockchainNetwork).getTransaction(n);
      }
      default:
        throw new bs(t.blockchain);
    }
  }
  async waitForTransaction(t, n) {
    try {
      return await zE(() => this.getTx(t, n), 5e3, 12 * 3, {
        resolvePredicate: (r) => r.status === "Success" || r.status === "Failure",
        retryOnErrorPredicate: (r) => r instanceof Error ? r.message.includes(`Transaction ${n} doesn't exist`) : !1,
        useExponentialBackoff: !1
      });
    } catch (r) {
      throw r instanceof Error && r.message === "TIMEOUT" ? new Pa("TransactionNotFound") : r;
    }
  }
  validateBlockchainNetworks(t, n) {
    const r = "kycDAO SDK", i = Object.values(p$), [o, a] = yv([...new Set(n)], (d) => i.includes(d));
    if (a.length > 0 && console.warn(`Invalid network name(s) were found in configuration and will be ignored: ${a.join(", ")}. Valid values are: ${i.join(", ")}.`), !o.length)
      throw new un(`No valid network names were found in configuration. Configured values: ${n.join(", ")}; Valid values are: ${i.join(", ")}.`);
    const [s, c] = yv(o, (d) => t.includes(d));
    if (c.length > 0 && console.warn(`${r} - The following configured networks are unavailable on the connected server: ${c.join(", ")}. Avaliable networks are: ${t.join(", ")}.`), !(() => {
      let d;
      for (const h of s) {
        const g = this.getNetworkDetails(h).blockchain;
        if (!d)
          d = g;
        else if (g !== d)
          return !1;
      }
      return !0;
    })())
      throw new un("Only networks of a single chain type/protocol can be enabled at a time.");
    if (!s.length)
      throw new un(`No available networks were found in configuration. Available networks are: ${t.join(", ")}.`);
    if (s.filter((d) => d.startsWith("Near")).length > 1)
      throw new un("Only one Near network can be configured at a time.");
    if (s.filter((d) => d.startsWith("Solana")).length > 1)
      throw new un("Only one Solana network can be configured at a time.");
    return s;
  }
  static validateVerificationTypes(t) {
    const n = "kycDAO SDK", r = Object.values(Du), [i, o] = yv([...new Set(t)], (a) => r.includes(a));
    if (o.length > 0 && console.warn(`${n} - Invalid verification type(s) were found in configuration and will be ignored: ${o.join(", ")}. Valid values are: ${r.join(", ")}.`), !i.length)
      throw new un(`No valid verification types were found in configuration. Valid values are: ${r.join(", ")}.`);
    return i;
  }
  static validateEvmProvider(t, n) {
    if (Object.values(XE).some((o) => t.includes(o))) {
      if (n === void 0) {
        console.warn("EVM provider is missing from the SDK configuration while at least one EVM network has been enabled");
        return;
      }
      if (Pb(n) && typeof n.request == "function" && typeof n.on == "function")
        return n;
      throw new un("The configured EVM provider is not compliant with the required standards.");
    }
  }
  validateEmail(t) {
    const n = new RegExp("^[^@]+@([\\w-]+\\.)+[\\w-]{2,}$");
    if (!t.match(n))
      throw new Xn("InvalidEmailAddress");
  }
  validateVerificationData(t) {
    if (!t.termsAccepted)
      throw new Xn("TermsAndConditionsNotAccepted");
    const n = Object.values(Du), r = t.verificationType;
    if (!n.includes(r))
      throw new un(`Invalid verificationType. Valid values are: ${n.join(", ")}.`);
    if (!this.verificationTypes.includes(r))
      throw new un(`Invalid verificationType. "${r}" was not enabled during SDK initialization.`);
    this.validateEmail(t.email);
    const i = t.taxResidency, o = Rf.find((a) => a.iso_cca2.toUpperCase() === i.toUpperCase() || a.name.toLowerCase() === i.toLowerCase());
    if (o)
      o.name.toLowerCase() === i.toLowerCase() && (t.taxResidency = o.iso_cca2);
    else
      throw new Xn("InvalidTaxResidency");
    return t;
  }
  syncUserAndSessionWithWallet() {
    if (this.user) {
      let t = !1;
      if (this._chainAndAddress) {
        const { blockchain: n, address: r } = this._chainAndAddress;
        t = this.user.blockchain_accounts.some((i) => i.blockchain === n && Mx(n, i.address, r));
      }
      t || (this.user = void 0, this.session = void 0);
    } else
      this.session && (eb(this.session.chain_and_address, this._chainAndAddress) || (this.session = void 0));
  }
  async refreshSession() {
    const t = async (n) => {
      const r = await this.post("session", n);
      this.session = r, this.user = r.user;
    };
    try {
      const n = await this.get("session");
      return this.session = n, this.user = n.user, this.syncUserAndSessionWithWallet(), !this.session && this._chainAndAddress && await t(this._chainAndAddress), this.session;
    } catch (n) {
      if (n instanceof Nb && n.statusCode === 401)
        return this._chainAndAddress ? await t(this._chainAndAddress) : (this.session = void 0, this.user = void 0), this.session;
      throw console.error(`Unexpected error during kycDAO session refresh: ${n}`), n;
    }
  }
  initNear(t) {
    if (!t.startsWith("Near"))
      throw new lt(`Not a  Near network: ${t}`);
    const n = this.getSmartContractAddress(t, "KYC");
    if (!n)
      throw new lt("Smart contract name configuration missing.");
    let r = y$, i = b$;
    t === "NearMainnet" && (r = g$, i = m$);
    const o = new KU.BrowserLocalStorageKeyStore();
    r.keyStore = o;
    const a = new VU(r), s = new qU(a, "kycDAO");
    this.near = {
      blockchainNetwork: t,
      keyStore: o,
      config: r,
      api: a,
      wallet: s,
      archival: i,
      contractName: n
    };
  }
  async handleNearWalletCallback(t, n, r) {
    if (!this.near)
      throw new lt("Near callback detected but the Near SDK is  not initialized.");
    if (this.near.wallet.isSignedIn()) {
      const i = this.near.wallet.getAccountId();
      this._chainAndAddress = {
        blockchain: "Near",
        blockchainNetwork: this.near.blockchainNetwork,
        address: i
      }, await this.refreshSession();
      let o;
      switch (t) {
        case "NearLogin":
          break;
        case "NearMint": {
          const a = n.get("authCode");
          if (a) {
            const s = Object.assign({}, this._chainAndAddress), c = await this.getTx(s, r);
            if (c.status !== "Success")
              throw new Pa("TransactionFailed");
            const l = c.data;
            if (typeof l.status == "string" || !l.status.SuccessValue)
              throw new lt("NearMint callback detected but transaction outcome does not have a SuccessValue (token ID).");
            {
              const u = l.status.SuccessValue, f = JSON.parse(Buffer.from(u, "base64").toString()).token_id, d = await this.post("token", {
                authorization_code: a,
                token_id: f,
                minting_tx_id: r
              }), h = this.getNetworkDetails(s.blockchainNetwork);
              o = Ox(h, r, f, d);
            }
          } else
            throw new lt("authCode parameter is empty or missing from NearMint callback URL.");
          break;
        }
        case "NearUserRejectedError":
          break;
        default:
          throw new bs(t);
      }
      return o;
    }
  }
  async handleRedirect() {
    const t = "Wallet callback handling error", n = {
      account_id: "NearLogin",
      errorCode: "NearUserRejectedError",
      transactionHashes: "NearMint"
    }, r = Object.keys(n), i = new URLSearchParams(window.location.search), a = [...i].filter(([c, l]) => r.includes(c)), s = new URL(window.location.href);
    if (r.concat(["authCode", "errorMessage"]).forEach((c) => s.searchParams.delete(c)), window.history.replaceState({}, document.title, s), a.length > 1) {
      console.error(`${t} - Multiple URL query parameters identified: ${a.map(([c, l]) => c)}.`);
      return;
    }
    if (a.length === 1) {
      const c = a[0], l = c[0], u = c[1], f = n[l];
      let d;
      return f.startsWith("Near") && (d = await this.handleNearWalletCallback(f, i, u)), { event: f, mintingResult: d };
    }
  }
  constructor(t) {
    t.environment && console.warn("The environment parameter in the kycDAO SDK configuration is deprecated, please use the demoMode switch instead!"), t.enabledVerificationTypes = Hn.validateVerificationTypes(t.enabledVerificationTypes), super(t), this.networkDetails = {}, this.demoMode = !!t.demoMode, this.verificationTypes = t.enabledVerificationTypes, this.blockchainNetworks = [], this.verificationStatus = {
      personaSessionData: void 0
    }, this.sentry = new u$();
  }
  static async initialize(t) {
    var n;
    const r = new Hn(t);
    r.apiStatus = await r.get("status"), (await r.get("networks")).forEach((f) => {
      r.networkDetails[f.id] = f;
    });
    const o = t.blockchainNetworkConfiguration;
    if (o) {
      let f;
      for (f in o) {
        const d = r.getNetworkDetails(f), h = o[f], g = h != null && h.rpcUrl ? [h.rpcUrl] : d.rpc_urls;
        r.networkDetails[f] = Object.assign(Object.assign({}, d), { rpc_urls: g });
      }
    }
    r.blockchainNetworks = r.validateBlockchainNetworks(r.apiStatus.enabled_networks, t.enabledBlockchainNetworks);
    const a = Hn.validateEvmProvider(r.blockchainNetworks, t.evmProvider);
    a ? (a.on("chainChanged", (f) => {
      const d = r.networkDetails, h = Uf(d).find((w) => r.getNetworkDetails(w).chain_id === f), g = h && r.blockchainNetworks.includes(h);
      r._chainAndAddress && r._chainAndAddress.blockchain === "Ethereum" && g && (r._chainAndAddress.blockchainNetwork = h);
    }), r.evmProvider = new cD(a, Object.values(r.networkDetails))) : r.blockchainNetworks = r.blockchainNetworks.filter((f) => !Object.keys(XE).includes(f));
    const s = r.blockchainNetworks.find((f) => f.startsWith("Near"));
    s && r.initNear(s);
    const c = r.blockchainNetworks.find((f) => f.startsWith("Solana"));
    c && (r.solana = new Tpe(c));
    const l = r.blockchainNetworks.find((f) => f.startsWith("Aptos"));
    l && (r.aptos = new vpe(l));
    const u = await r.handleRedirect();
    return {
      kycDao: r,
      redirectEvent: u == null ? void 0 : u.event,
      transactionUrl: (n = u == null ? void 0 : u.mintingResult) === null || n === void 0 ? void 0 : n.transactionUrl,
      mintingResult: u == null ? void 0 : u.mintingResult,
      sdkStatus: r.sdkStatus
    };
  }
  async getServerStatus() {
    let t, n;
    try {
      const r = await this.get("status");
      n = !0, t = `${r.current_time}`;
    } catch (r) {
      n = !1, r instanceof Error ? t = r.message : t = `Error: ${r}`;
    }
    return {
      serverBaseUrl: this.baseUrl,
      apiStatus: t,
      isOk: n
    };
  }
  getChainAndAddressForNftCheck(t) {
    const n = t == null ? void 0 : t.networkAndAddress, r = n ? Object.assign(Object.assign({}, n), { blockchain: this.getNetworkDetails(n.blockchainNetwork).blockchain }) : this._chainAndAddress;
    if (!r)
      throw new Xn("WalletNotConnected", "BlockchainNetwork and address not set yet. Either connect a wallet with kycDAO first or specify them in the parameters.");
    if (!r.address)
      throw new lt("Wallet address cannot be empty.");
    return r;
  }
  getRpcProviderForWallet(t, n) {
    var r, i, o, a;
    const { blockchain: s, blockchainNetwork: c } = n, l = this.getNetworkDetails(c).rpc_urls[0], u = (a = (o = (i = (r = this.apiStatus) === null || r === void 0 ? void 0 : r.smart_contracts_info) === null || i === void 0 ? void 0 : i[c]) === null || o === void 0 ? void 0 : o[t]) === null || a === void 0 ? void 0 : a.address;
    if (!u)
      throw new lt("Smart contract address not found.");
    return new Epe(s, u, l, c);
  }
  async checkValidNft(t, n) {
    return this.getRpcProviderForWallet(t, n).hasValidNft(n.address);
  }
  async hasValidNft(t, n) {
    const r = this.getChainAndAddressForNftCheck(n);
    return await this.checkValidNft(t, r);
  }
  async getValidNfts(t, n) {
    const r = this.getChainAndAddressForNftCheck(n);
    return await this.getRpcProviderForWallet(t, r).getValidNfts(r);
  }
  async checkVerifiedNetworks(t, n) {
    const r = this.getChainAndAddressForNftCheck(n), i = this.getNetworkDetails(r.blockchainNetwork), a = Uf(this.networkDetails).filter((l) => {
      const u = this.getNetworkDetails(l);
      return this.blockchainNetworks.includes(l) && u.blockchain === i.blockchain && u.testnet === i.testnet;
    }).map((l) => {
      const u = {
        blockchainNetwork: l,
        address: r.address
      };
      return new Promise((f, d) => {
        this.checkValidNft(t, Object.assign(Object.assign({}, r), { blockchainNetwork: l })).then((h) => {
          f({ networkAndAddress: u, hasValidNft: h });
        }).catch((h) => {
          f({ networkAndAddress: u, error: String(h) });
        });
      });
    });
    return (await Promise.allSettled(a)).filter(hF).map((l) => l.value);
  }
  async switchOrAddNetworkChecked(t) {
    if (!this.evmProvider)
      throw new lt("EVM provider not found.");
    await this.evmProvider.switchOrAddNetwork(t);
    const n = await this.evmProvider.getChainId();
    if (Number(n) !== t.chain_id)
      throw new lt(`EVM network switching failed: switchNetwork call did not throw an error, but wallet returns wrong chainId (${n}), expected ${t.chain_id}.`);
  }
  isUserRejectError(t) {
    return t instanceof ea && t.errorCode === "RejectedByUser";
  }
  async ensureValidProviderNetwork(t, n = !1) {
    const r = this.networkDetails;
    let i;
    switch (t) {
      case "Ethereum": {
        if (!this.evmProvider)
          throw new un("EVM provider not configured.");
        const o = await this.evmProvider.getChainId();
        if (i = Uf(r).find((a) => this.getNetworkDetails(a).chain_id === Number(o)), !i || !this.blockchainNetworks.includes(i))
          if (n && this.blockchainNetworks.length === 1) {
            const a = this.blockchainNetworks[0], s = this.getNetworkDetails(a);
            if (s.blockchain === "Ethereum" && s.chain_id) {
              try {
                await this.switchOrAddNetworkChecked(s);
              } catch (c) {
                throw this.isUserRejectError(c) ? c : (console.log("Automatic EVM network switching failed:", c), new Xn("NetworkSwitchingFailed", "Automatic EVM network switching failed: feature not supported by the wallet."));
              }
              i = a;
            } else
              throw new lt("Network configuration error.");
          } else
            throw i ? new Xn("NetworkNotEnabled", `Selected EVM network in wallet (${o}) is not enabled in the SDK.`) : new Xn("NetworkNotSupported", "Selected EVM network in wallet is not supported by the SDK.");
        break;
      }
      case "Near": {
        if (!this.near)
          throw new un("Near SDK not initialized.");
        i = this.near.blockchainNetwork;
        break;
      }
      case "Solana": {
        if (!this.solana)
          throw new un("Solana support is not enabled.");
        i = this.solana.blockchainNetwork;
        break;
      }
      case "Aptos": {
        if (!this.aptos)
          throw new un("Aptos support is not enabled.");
        i = this.aptos.blockchainNetwork;
        break;
      }
      default:
        throw new bs(t);
    }
    return i;
  }
  async checkProviderNetwork() {
    if (!this._chainAndAddress)
      throw new Xn("WalletNotConnected");
    return this.ensureValidProviderNetwork(this._chainAndAddress.blockchain);
  }
  async switchProviderNetwork(t) {
    if (!this._chainAndAddress)
      throw new Xn("WalletNotConnected");
    if (!this.blockchainNetworks.includes(t))
      throw new Xn("NetworkNotEnabled");
    const n = this.getNetworkDetails(t);
    if (this._chainAndAddress.blockchain !== n.blockchain)
      throw new Xn("NetworkSwitchingFailed", "Selected network has a different blockchain than the currently connected wallet.");
    const r = n.blockchain;
    switch (r) {
      case "Ethereum": {
        if (!this.evmProvider)
          throw new un("EVM provider not configured.");
        const i = n.chain_id;
        if (!i)
          throw new lt("Network configuration error.");
        const o = await this.evmProvider.getChainId();
        if (Number(o) !== i)
          try {
            await this.switchOrAddNetworkChecked(n);
          } catch (a) {
            throw this.isUserRejectError(a) ? a : (console.log("EVM network switching failed:", a), new Xn("NetworkSwitchingFailed", "EVM network switching failed: feature not supported by the wallet."));
          }
        break;
      }
      default:
        throw new lt(`Unsupported action for ${r} blockchain.`);
    }
  }
  async connectWallet(t) {
    switch (this._mintingState = void 0, t) {
      case "Ethereum": {
        if (!this.evmProvider)
          throw new un("EVM provider not configured.");
        let n;
        if (this.evmProvider.isWalletConnect() ? n = await this.evmProvider.walletConnectEnable() : (n = await this.evmProvider.getAccounts(), n.length || (n = await this.evmProvider.requestAccounts())), !n.length)
          throw new Xn("WalletNotConnected", "Failed to get user accounts/permissions from EVM provider (browser extension)");
        const r = await this.ensureValidProviderNetwork(t, !0);
        this._chainAndAddress = {
          blockchain: "Ethereum",
          blockchainNetwork: r,
          address: n[0]
        };
        break;
      }
      case "Near":
        if (!this.near)
          throw new un("Near SDK not initialized.");
        if (this.near.wallet.isSignedIn()) {
          const n = this.near.wallet.getAccountId();
          this._chainAndAddress = {
            blockchain: "Near",
            blockchainNetwork: this.near.blockchainNetwork,
            address: n
          };
        } else
          return await this.near.wallet.requestSignIn({ contractId: this.near.contractName }), new Promise(() => {
          });
        break;
      case "Solana": {
        if (!this.solana)
          throw new un("Solana support is not enabled.");
        this.solana.adapter = new Ipe(), await this.solana.connect();
        const n = this.solana.address;
        if (!n)
          throw new lt("Wallet address not found.");
        const r = this.solana.blockchainNetwork;
        this._chainAndAddress = {
          blockchain: "Solana",
          blockchainNetwork: r,
          address: n
        };
        break;
      }
      case "Aptos": {
        if (!this.aptos)
          throw new un("Aptos support is not enabled.");
        await this.aptos.connect();
        const n = await this.aptos.address();
        if (!n)
          throw new lt("Wallet address not found.");
        const r = this.aptos.blockchainNetwork;
        this._chainAndAddress = {
          blockchain: "Aptos",
          blockchainNetwork: r,
          address: n
        };
        break;
      }
      default:
        throw new bs(t);
    }
    await this.refreshSession();
  }
  async disconnectWallet() {
    if (this._chainAndAddress) {
      switch (this._chainAndAddress.blockchain) {
        case "Ethereum":
          if (!this.evmProvider)
            throw new un("EVM provider not configured.");
          if (this.evmProvider.isWalletConnect())
            await this.evmProvider.walletConnectDisconnect();
          else
            throw new lt(`Unsupported blockchain: ${this._chainAndAddress.blockchain}.`);
          break;
        case "Near":
          if (this.near)
            this.near.wallet.signOut();
          else
            throw new un("Near SDK not initialized.");
          break;
        case "Solana": {
          if (this.solana)
            await this.solana.disconnect();
          else
            throw new un("Solana support is not enabled.");
          break;
        }
        case "Aptos": {
          if (this.aptos)
            await this.aptos.disconnect();
          else
            throw new un("Aptos support is not enabled.");
          break;
        }
        default:
          throw new bs(this._chainAndAddress.blockchain);
      }
      this._chainAndAddress = void 0, this.user = void 0, this.session = void 0, this._mintingState = void 0;
    }
  }
  async registerOrLogin() {
    if (this._chainAndAddress) {
      if (this.session = await this.post("session", this._chainAndAddress), !this.session.user) {
        let t;
        switch (this._chainAndAddress.blockchain) {
          case "Near": {
            if (!this.near)
              throw new un("Near SDK not initialized.");
            const i = `kycDAO-login-${this.session.nonce}`;
            t = (await this.near.keyStore.getKey(this.near.wallet.account().connection.networkId, this.near.wallet.getAccountId())).sign(Buffer.from(i, "utf-8"));
            break;
          }
          case "Ethereum": {
            if (!this.evmProvider)
              throw new un("EVM provider not configured.");
            const i = this.session.eip_4361_message;
            t = await this.evmProvider.personalSign(i, this._chainAndAddress.address);
            break;
          }
          case "Solana": {
            if (!this.solana)
              throw new un("Solana support is not enabled..");
            const i = `kycDAO-login-${this.session.nonce}`;
            t = await this.solana.signMessage(i);
            break;
          }
          case "Aptos": {
            if (!this.aptos)
              throw new un("Aptos support is not enabled.");
            const i = `kycDAO-login-${this.session.nonce}`;
            t = await this.aptos.signMessage(i);
            break;
          }
          default:
            throw new bs(this._chainAndAddress.blockchain);
        }
        const n = (() => typeof t == "string" ? { signature: t } : "network" in t ? {
          signature: t.signature,
          public_key: t.publicKey,
          network: t.network
        } : {
          signature: `ed25519:${D3.base_encode(t.signature)}`,
          public_key: t.publicKey.toString()
        })(), r = await this.post("user", n);
        this.user = r;
        return;
      }
      this.user = this.session.user;
      return;
    }
    throw new Xn("WalletNotConnected");
  }
  async updateEmail(t) {
    this.validateEmail(t);
    const n = { email: t }, r = await this.put("user", n);
    this.user = r;
  }
  async checkEmailConfirmed() {
    var t, n, r;
    if (!(!((t = this.user) === null || t === void 0) && t.email_confirmed) && (await this.refreshSession(), !this.session))
      throw new Xn("UserNotLoggedIn");
    return {
      address: (n = this.user) === null || n === void 0 ? void 0 : n.email,
      isConfirmed: !!(!((r = this.user) === null || r === void 0) && r.email_confirmed)
    };
  }
  async resendEmailConfirmationCode() {
    return await this.post("user/email_confirmation");
  }
  loadPersona(t, n) {
    var r;
    if (!(!((r = this.apiStatus) === null || r === void 0) && r.persona))
      throw new lt("Persona configuration not found.");
    const i = {
      environment: this.apiStatus.persona.sandbox ? "sandbox" : "production",
      templateId: this.apiStatus.persona.template_id
    }, o = this.verificationStatus.personaSessionData, s = o && o.referenceId === t.ext_id ? {
      inquiryId: o.inquiryId,
      sessionToken: o.sessionToken,
      templateId: void 0
    } : { referenceId: t.ext_id }, { frameAncestors: c, messageTargetOrigin: l, onCancel: u, onComplete: f, onError: d } = n || {}, h = { frameAncestors: c, messageTargetOrigin: l }, g = Object.assign(Object.assign(Object.assign(Object.assign({}, i), s), h), { onReady: () => w.open(), onComplete: (b) => {
      this.verificationStatus.personaSessionData = void 0, typeof f == "function" && f();
    }, onCancel: (b) => {
      b.inquiryId ? this.verificationStatus.personaSessionData = {
        referenceId: t.ext_id,
        inquiryId: b.inquiryId,
        sessionToken: b.sessionToken
      } : this.verificationStatus.personaSessionData = void 0, typeof u == "function" && u();
    }, onError: (b) => {
      this.verificationStatus.personaSessionData = void 0;
      const I = `Persona verification error: ${b.code}`;
      console.error(I), typeof d == "function" && d(I);
    } }), w = new Jz.Client(g);
  }
  async startVerification(t, n) {
    t = this.validateVerificationData(t);
    const r = {
      email: t.email,
      legal_entity: t.isLegalEntity,
      residency: t.taxResidency
    }, i = await this.put("user", r);
    if (this.user = i, this.demoMode || !this.isVerifiedForType(t.verificationType))
      t.verificationType === "KYC" && this.loadPersona(i, n == null ? void 0 : n.personaOptions);
    else
      throw new Xn("UserAlreadyVerified");
  }
  async checkVerificationStatus() {
    const t = this.getVerificationStatusByType();
    if (!!Object.values(t).some((r) => !r)) {
      if (await this.refreshSession(), !this.session)
        throw new Xn("UserNotLoggedIn");
      return this.getVerificationStatusByType();
    }
    return t;
  }
  getNftImageUrl() {
    return this.url("token/identicon");
  }
  async regenerateNftImage() {
    await this.request("token/identicon", { method: "POST" });
  }
  async getNftImageOptions() {
    if (await this.refreshSession(), !this.user)
      throw new Xn("UserNotLoggedIn");
    return Object.fromEntries(Object.entries(this.user.available_images).map(([t, n]) => [
      t,
      n.url
    ]));
  }
  async regenerateNftImageOptions() {
    return await this.request("token/identicon", { method: "POST" }), await this.getNftImageOptions();
  }
  async authorizeMinting(t, n) {
    const r = t.blockchainNetwork, i = n.subscriptionYears ? `P${n.subscriptionYears}Y` : void 0, a = {
      blockchain_account_id: this.getBlockchainAccount(t).id,
      network: r,
      selected_image_id: n.imageId,
      subscription_duration: i
    };
    try {
      const s = await this.post("authorize_minting", a), c = s.token.authorization_tx_id;
      if (c) {
        if ((await this.waitForTransaction(t, c)).status === "Failure")
          throw new Pa("TransactionFailed");
      } else if (!s.transaction && !s.mint_details)
        throw new lt("Either Transaction ID or MintDetails not found");
      return s;
    } catch (s) {
      throw s instanceof Nb && s.errorCode === "NetworkPriceTooHigh" ? new Xn("NetworkPriceTooHigh") : s;
    }
  }
  async checkMetadataUrl(t) {
    var n;
    const r = await fetch(t), o = ((n = r.headers.get("content-type")) === null || n === void 0 ? void 0 : n.includes("application/json")) ? await r.json() : null;
    return !r.ok || !Pb(o) || typeof o.name != "string" || typeof o.description != "string" || typeof o.image != "string";
  }
  async mint(t, n, r) {
    const i = this.getSmartContractAddress(t.blockchainNetwork, r), o = n.token.authorization_code, a = n.metadata_url;
    let s, c;
    switch (t.blockchain) {
      case "Near": {
        if (!this.near)
          throw new un("Near SDK not initialized.");
        const l = new HU(this.near.wallet.account(), this.near.contractName, {
          viewMethods: ["get_required_mint_cost_for_code"],
          changeMethods: ["mint_with_code"]
        }), u = l.get_required_mint_cost_for_code;
        if (!u)
          throw new lt("Mint cost function not callable");
        const f = new Ka.BN("100000000000000000000000"), d = await u({
          auth_code: Number(o),
          dst: t.address
        }), h = new Ka.BN(d).muln(1.1).add(f), w = `${window.location.search.startsWith("?") ? "&" : "?"}authCode=${o}`, b = `${window.location.origin}${window.location.pathname}${window.location.search}${w}${window.location.hash}`, I = l.mint_with_code;
        if (!I)
          throw new lt("Mint function not callable");
        return await I({
          args: { auth_code: Number(o) },
          gas: "300000000000000",
          amount: h.toString(),
          callbackUrl: b
        }), new Promise(() => {
        });
      }
      case "Ethereum": {
        if (!this.evmProvider)
          throw new un("EVM provider not configured.");
        if (!i)
          throw new lt("Smart contract address not found");
        if (s = await this.evmProvider.mint(i, t.address, o), s) {
          const l = await this.waitForTransaction(t, s);
          if (l.status === "Failure")
            throw new Pa("TransactionFailed");
          const u = l.data;
          c = await this.evmProvider.getTokenIdFromReceipt(u);
        }
        break;
      }
      case "Solana": {
        if (!this.solana)
          throw new un("Solana support is not enabled.");
        if (!i)
          throw new lt("Smart contract address not found");
        if (!a)
          throw new lt("Token metadata not found");
        if (await this.checkMetadataUrl(a))
          throw new lt("Token metadata is invalid");
        if (n.transaction) {
          const l = On.from(Buffer.from(n.transaction, "hex"));
          s = await this.solana.mint(t.address, l);
          const u = await this.waitForTransaction(t, s);
          if (u.status === "Failure")
            throw new Pa("TransactionFailed");
          c = u.data;
        } else
          throw new lt("Backend transaction not found");
        break;
      }
      case "Aptos": {
        if (!this.aptos)
          throw new un("Aptos support is not enabled.");
        if (!i)
          throw new lt("Smart contract address not found");
        if (!a)
          throw new lt("Token metadata not found");
        if (await this.checkMetadataUrl(a))
          throw new lt("Token metadata is invalid");
        if (n.mint_details) {
          s = await this.aptos.mint(i, n.mint_details);
          const l = await this.waitForTransaction(t, s);
          if (l.status === "Failure")
            throw new Pa("TransactionFailed");
          c = l.data;
        } else
          throw new lt("Backend signature not found");
        break;
      }
      default:
        throw new bs(t.blockchain);
    }
    if (s && c) {
      const l = await this.post("token", {
        authorization_code: o,
        token_id: c,
        minting_tx_id: s
      }), u = this.getNetworkDetails(t.blockchainNetwork);
      return Ox(u, s, c, l);
    }
  }
  async startMinting(t) {
    var n;
    let r = t.verificationType;
    if (!this._chainAndAddress)
      throw new Xn("WalletNotConnected");
    if (!t.disclaimerAccepted)
      throw new Xn("DisclaimerNotAccepted");
    const i = Object.assign({}, this._chainAndAddress);
    if (i.blockchainNetwork = await this.ensureValidProviderNetwork(i.blockchain, !0), await this.refreshSession(), r || (r = "KYC"), !this.isVerifiedForType(r))
      throw new Xn("UserNotVerified");
    !((n = this.user) === null || n === void 0) && n.disclaimer_accepted || await this.post("disclaimer", { accept: !0 });
    let a = (() => {
      if (!this._mintingState)
        return;
      const c = Object.assign({}, this._mintingState);
      if (!eb(c.chainAndAddress, i)) {
        this._mintingState = void 0;
        return;
      }
      if (eb(c.mintingData, t))
        return c.mintAuthResponse;
    })();
    a || (a = await this.authorizeMinting(i, t), this._mintingState = {
      chainAndAddress: i,
      mintingData: t,
      mintAuthResponse: a
    });
    const s = await this.mint(i, a, r);
    return this._mintingState = void 0, s;
  }
}
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", Promise)
], Hn.prototype, "getServerStatus", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", [String, Object]),
  pt("design:returntype", Promise)
], Hn.prototype, "hasValidNft", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", [String, Object]),
  pt("design:returntype", Promise)
], Hn.prototype, "getValidNfts", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", [String, Object]),
  pt("design:returntype", Promise)
], Hn.prototype, "checkVerifiedNetworks", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", [Object]),
  pt("design:returntype", Promise)
], Hn.prototype, "switchOrAddNetworkChecked", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", Promise)
], Hn.prototype, "checkProviderNetwork", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", [String]),
  pt("design:returntype", Promise)
], Hn.prototype, "switchProviderNetwork", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", [String]),
  pt("design:returntype", Promise)
], Hn.prototype, "connectWallet", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", Promise)
], Hn.prototype, "disconnectWallet", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", Promise)
], Hn.prototype, "registerOrLogin", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", [String]),
  pt("design:returntype", Promise)
], Hn.prototype, "updateEmail", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", Promise)
], Hn.prototype, "checkEmailConfirmed", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", Promise)
], Hn.prototype, "resendEmailConfirmationCode", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", [Object, Object]),
  pt("design:returntype", Promise)
], Hn.prototype, "startVerification", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", Promise)
], Hn.prototype, "checkVerificationStatus", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", String)
], Hn.prototype, "getNftImageUrl", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", Promise)
], Hn.prototype, "regenerateNftImage", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", Promise)
], Hn.prototype, "getNftImageOptions", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", []),
  pt("design:returntype", Promise)
], Hn.prototype, "regenerateNftImageOptions", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", [Object]),
  pt("design:returntype", Promise)
], Hn.prototype, "startMinting", null);
xr([
  Gn(),
  pt("design:type", Function),
  pt("design:paramtypes", [Object]),
  pt("design:returntype", Promise)
], Hn, "initialize", null);
const yU = (e) => {
  var n;
  const t = (n = e.match("(Solana|Ethereum|Near|Aptos)")) == null ? void 0 : n[0];
  if (!t)
    switch (e) {
      case "PolygonMainnet":
      case "PolygonMumbai":
      case "CeloMainnet":
      case "CeloAlfajores":
      case "EthereumMainnet":
      case "EthereumGoerli":
      case "BaseGoerli":
      case "ArbitrumGoerli":
      case "ZKSyncGoerli":
        return "Ethereum";
    }
  if (t !== "Solana" && t !== "Near" && t !== "Aptos" && t !== "Ethereum")
    throw Error("Unknown network!");
  return t;
}, xpe = ir`
  transition-property: all;
`, Ki = ir`
  ${xpe};
  transition-duration: 0.2s;
`, gU = ir`
  font-family: Material Icons;
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  font-feature-settings: liga;
  -webkit-font-smoothing: antialiased;
`, rc = ir`
  color: black;
  line-height: 100%;
  -webkit-font-smoothing: antialiased;
  font-family: neue-machina;
`, gr = Ge.h1`
  ${rc};
  margin-bottom: ${({ marginBottom: e }) => e || "1em"};
  font-size: 1.6rem;
  margin-top: 0;
`;
Ge.h2`
  ${rc};
  margin-bottom: 1em;
`;
const bU = Ge.h3`
  ${rc};
  color: black;
  font-size: 12pt;
  margin-bottom: 1em;
`, tn = Ge.p`
  font-size: 12pt;
  ${rc};
  color: black;
  margin-bottom: 1em;
  margin-top: 0;
  font-weight: 400;
`, Dl = Ge(tn)`
  font-family: var(--kyc-sdk-primary-font);
  margin-bottom: 1em;
  font-size: 12px;

  -webkit-font-smoothing: antialiased;
`, pE = Ge.li`
  ${rc};
  margin-left: 2em;
  font-size: 12pt;

  ${tn} {
    margin-bottom: 1em;
    ${rc}
  }
`, yE = Ge.b`
  font-size: 12pt;
  ${rc};
  margin-bottom: 1em;
  margin-top: 0;
`, mU = Ge.ul`
  padding: 1rem 0;
  width: fit-content;
  list-style: disc;
`, sm = (e) => ir`
  transform: translateX(${e});
`, Mpe = Ge(gr)`
  text-align: center;
`, zB = Ge.a`
  ${rc};
  font-family: var(--light-font);
  font-size: 12px;
  text-decoration: underline;
  color: var(--kyc-sdk-dark-blue);
  :visited {
    color: var(--kyc-sdk-dark-blue);
  }
`, _U = t3(
  ({ children: e, inactive: t, onClick: n, ...r }, i) => /* @__PURE__ */ ee("button", { ref: i, ...r, onClick: t ? void 0 : n, children: e })
);
_U.displayName = "KycDaoButton";
const Ya = Ge(_U)`
  height: var(--kyc-sdk-button-height);
  display: inline-flex;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;

  position: relative;
  box-shadow: 0 0 0 0 rgba(white, 0);
  background: #ecf0fe;
  color: var(--kyc-sdk-dark-purple);
  border-radius: var(--kyc-sdk-border-radius-light);
  font-size: 12pt;
  cursor: pointer;
  @extend ${Ki};

  ${({ fullWidth: e }) => e && ir`
      width: 100%;
    `}

  span {
    font-family: var(--kyc-sdk-primary-font);
    font-weight: 400;
    font-size: 16px;
    margin-left: 0;
  }

  :disabled {
    background: var(--kyc-sdk-inactive);
    pointer-events: none;
    border: 2px solid black;

    span,
    i {
      color: black;
    }
  }

  ${({ mode: e }) => {
  switch (e) {
    case "black":
      return ir`
          :enabled {
            background: black;
            border: 2px solid black;
          }

          span,
          i {
            font-weight: 400;
            color: white;
          }

          &:hover {
            background: var(--kyc-sdk-cybergreen);
            box-shadow: 0 0 0 0 var(--kyc-sdk-cybergreen-35);

            span,
            i {
              color: black;
            }
          }

          &:focus {
            background: var(--kyc-sdk-cybergreen);
            box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-35);

            span,
            i {
              color: black;
            }
          }

          &:active {
            background: var(--darken-green);
            box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-35);
          }
        `;
    case "green":
      return ir`
          background: var(--kyc-sdk-cyberpunk);

          span,
          i {
            font-weight: 400;
            color: white;
          }

          &:hover {
            background: var(--kyc-sdk-cyberpunk);
            box-shadow: 0 0 0 10px var(--kyc-sdk-normal-blue-35);

            span {
              font-weight: 400;
              color: var(--kyc-sdk-dark-blue);
            }
          }

          &:focus {
            background: var(--kyc-sdk-cyberpunk);
            box-shadow: 0 0 0 5px var(--kyc-sdk-cyberpunk-35);
          }

          &:active {
            box-shadow: 0 0 0 5px var(--kyc-sdk-dark-blue-35);
          }
        `;
    case "underline":
      return ir`
          color: red;
          position: relative;
          display: inline-flex;
          width: max-content;
          border: none;

          &:enabled {
            background: rgb(0, 0, 0, 0);
            color: black;
          }

          &:enabled:after {
            content: "";
            display: inline-flex;
            height: 2px;
            width: 100%;
            background-color: var(--kyc-sdk-cybergreen);
            position: absolute;
            bottom: 6px;
            @extend ${Ki};
          }

          &:disabled:after {
            content: "";
            display: inline-flex;
            height: 2px;
            width: 100%;
            background-color: grey;
            position: absolute;
            bottom: 6px;
          }

          span {
            display: flex;
            align-items: center;
          }

          span:disabled {
            color: grey;
          }

          i:disabled {
            color: grey;
          }

          &:hover {
            :after {
              height: 8px;
            }
          }

          &:disabled {
            background-color: transparent;
            border: none;
            color: grey;
          }
        `;
    case "clean":
      return ir`
          color: white;
          &:hover {
            background: var(--kyc-sdk-cybergreen);
            box-shadow: 0 0 0 0px var(--kyc-sdk-cybergreen-35);

            span,
            i {
              color: black;
            }
          }
        `;
  }
}}
`, wU = Ge.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  position: relative;
  z-index: 10;
  background: #fefefe;
`, vU = Ge.div`
  display: flex;
  align-items: center;
  margin-left: -0.5rem;
`, FB = Ge.button`
  width: 2rem;
  height: 2rem;
  background: none;
  border: none;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--kyc-sdk-border-radius-light);
  ${Ki};
  ${gU};

  ${({ hidden: e }) => e && {
  opacity: "0.3"
}}

  &:hover:enabled:not([hidden]) {
    cursor: pointer;
    background: var(--kyc-sdk-cybergreen-35);
  }

  &:active:enabled:not([hidden]) {
    color: #09b678;
    cursor: pointer;
    background: var(--kyc-sdk-cybergreen-35);
  }
`, ox = Ge.button`
  border: none;
  background: transparent;
  align-items: center;
  display: flex;
  width: 2rem;
  height: 2rem;
  justify-content: center;
  border-radius: 999rem;
  font-size: 24px;
  color: black;
  box-sizing: content-box;
  padding: 0;
  ${Ki};
  ${gU};

  ${({ hidden: e }) => e && {
  visibility: "hidden"
}}

  &:hover:enabled:not([hidden]) {
    background: var(--kyc-sdk-cybergreen-35);
    cursor: pointer;
  }

  &:active:enabled:not([hidden]) {
    color: var(--kyc-sdk-dark-green);
    cursor: pointer;
    background: var(--kyc-sdk-cybergreen-35);
  }
`, LB = () => {
  const {
    data: { closeButtonState: e, nextButtonState: t, prevButtonState: n, currentModal: r },
    dispatch: i
  } = ln(Wn), o = Le(() => {
    i({
      payload: { button: Pt.prev },
      type: ke.OnClickHeaderButton
    });
  }, [i]), a = Le(() => {
    i({
      payload: { button: Pt.next },
      type: ke.OnClickHeaderButton
    });
  }, [i]), s = Le(() => {
    i({
      payload: { button: Pt.close },
      type: ke.OnClickHeaderButton
    });
  }, [i]);
  return /* @__PURE__ */ We(wU, { children: [
    /* @__PURE__ */ We(vU, { children: [
      /* @__PURE__ */ ee(
        FB,
        {
          disabled: n === "disabled" || !!r,
          hidden: n === "hidden",
          onClick: o,
          children: "chevron_left"
        }
      ),
      /* @__PURE__ */ ee(
        FB,
        {
          disabled: t === "disabled" || !!r,
          hidden: t === "hidden",
          onClick: a,
          children: "chevron_right"
        }
      )
    ] }),
    /* @__PURE__ */ ee(
      ox,
      {
        disabled: e === "disabled" || !!r,
        hidden: e === "hidden",
        onClick: s,
        children: "close"
      }
    )
  ] });
}, Zg = /[!$(){}[\]:;<+?\\>]/g, vd = ({
  disabled: e,
  placeholder: t,
  onChange: n,
  id: r,
  className: i,
  value: o = "",
  autoCompleteData: a,
  autoFocus: s,
  inputRef: c = $U(),
  onInputBlurred: l,
  onInputFocused: u,
  type: f,
  style: d
}) => {
  const [h, g] = pr(
    !!s && !!a
  ), w = ya(null), [b, I] = pr(!!s), A = Le(
    ({ target: { value: W } }) => {
      n && n(W), a && g(
        a.filter(
          (O) => O.match(new RegExp(W.replace(Zg, ""), "ig"))
        ).length > 0
      );
    },
    [n, a]
  );
  Ht(() => {
    const W = ({ target: O }) => {
      w.current && !w.current.contains(O) && g(!1);
    };
    return document.addEventListener("mousedown", W), () => document.removeEventListener("mousedown", W);
  }, [w]), Ht(() => {
    const W = () => {
      !h && a && g(
        a.filter(
          (k) => k.match(new RegExp(o.replace(Zg, ""), "ig"))
        ).length > 0
      );
    }, { current: O } = c;
    return O == null || O.addEventListener("focus", W), () => {
      O == null || O.addEventListener("focus", W);
    };
  }, [h, c, a, o]);
  const x = Le(
    (W) => () => {
      n && n(W), g(!1);
    },
    [n]
  ), N = Le(() => {
    var W;
    n && o && n(""), (W = c.current) == null || W.focus();
  }, [n, o, c]);
  Ht(() => {
    var W, O;
    !e && s ? (W = c.current) == null || W.focus({ preventScroll: !0 }) : e && s && ((O = c.current) == null || O.blur());
  }, [e, s, c]);
  const j = Le(() => {
    l && l(), I(!1);
  }, [l]), K = Le(() => {
    u && u(), I(!0);
  }, [u]);
  return /* @__PURE__ */ We(
    Ppe,
    {
      active: b,
      showAutoComplete: h,
      style: d,
      children: [
        h && a && /* @__PURE__ */ ee("div", { children: /* @__PURE__ */ ee(Ope, { ref: w, children: a.filter(
          (W) => W.match(new RegExp(o.replace(Zg, ""), "ig"))
        ).map((W) => o !== "" ? /* @__PURE__ */ ee(
          $B,
          {
            dangerouslySetInnerHTML: {
              __html: W.replace(
                new RegExp(
                  `(${o.replace(Zg, "")})`,
                  "ig"
                ),
                "<strong>$1</strong>"
              )
            },
            onClick: x(W)
          },
          W
        ) : /* @__PURE__ */ ee($B, { onClick: x(W), children: W }, W)) }) }),
        /* @__PURE__ */ ee(
          SU,
          {
            showAutoComplete: h,
            onBlur: j,
            onFocus: K,
            ref: c,
            id: r,
            className: i,
            type: f || "text",
            placeholder: t,
            onChange: A,
            disabled: e,
            value: o
          }
        ),
        o.length > 0 && /* @__PURE__ */ ee(EU, { active: b, className: "material-icons", onClick: N, children: "close" })
      ]
    }
  );
}, SU = Ge.input`
  position: relative;
  height: var(--kyc-sdk-button-height);
  display: inline-flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-left: 1.5em;
  align-items: center;
  margin: 1rem 0px;
  margin-bottom: 0;
  border: 2px solid black;
  outline: none;
  ${({ showAutoComplete: e }) => e ? ir`
          border-radius: 0 0 var(--kyc-sdk-border-radius-light)
            var(--kyc-sdk-border-radius-light);
          margin-top: 0;
          box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-50);
        ` : ir`
          border-radius: var(--kyc-sdk-border-radius-light);
        `}
  box-shadow: 0 0 0 0 rgba(white, 0);
  background: var(--kyc-sdk-cybergreen-35);
  color: black;
  font-size: 12pt;
  font-family: var(--kyc-sdk-primary-font);
  width: 100%;

  ::placeholder {
    color: black;
    font-family: var(--kyc-sdk-primary-font);
  }

  &:hover {
    border: 2px solid var(--kyc-sdk-cybergreen);
    box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-50);
    ${({ showAutoComplete: e }) => e && ir`
        border-radius: 0 0 var(--kyc-sdk-border-radius-light)
          var(--kyc-sdk-border-radius-light);
      `}
    background: var(--kyc-sdk-cybergreen-35);
  }

  &:focus {
    border: 2px solid var(--kyc-sdk-cybergreen);
    box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-50);
    ${({ showAutoComplete: e }) => e && ir`
        border-radius: 0 0 var(--kyc-sdk-border-radius-light)
          var(--kyc-sdk-border-radius-light);
      `}
    color: white;
    background: black;

    ::placeholder {
      color: white;
      font-family: var(--kyc-sdk-primary-font);
    }
  }

  &:active {
    border: 2px solid var(--kyc-sdk-cybergreen);
    box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-50);
    ${({ showAutoComplete: e }) => e && ir`
        border-radius: 0 0 var(--kyc-sdk-border-radius-light)
          var(--kyc-sdk-border-radius-light);
      `}
    color: white;
    background: black;

    ::placeholder {
      color: white;
      font-family: var(--kyc-sdk-primary-font);
    }
  }
`, EU = Ge.div`
  position: absolute;
  right: 0.25em;
  padding: 0.25em;
  font-size: 2em;
  display: flex;
  bottom: 0.25em;
  line-height: 2em;
  color: var(--kyc-sdk-cybergreen);
  cursor: pointer;
  border-radius: var(--kyc-sdk-border-radius-full);
  background: transparent;
  justify-content: center;
  align-items: center;

  color: ${({ active: e }) => e ? `var(--kyc-sdk-cybergreen); ${Ki};` : "black"};

  &:hover:not([disabled]) {
    ${Ki};
    background: var(--kyc-sdk-cybergreen-35);
  }

  &[disabled] {
    color: lightgrey;
    cursor: default;
  }
`, $B = Ge.div`
  height: 2.5em;
  cursor: pointer;
  font-size: 12pt;
  line-height: 2.5em;
  padding-left: 1.5em;
  border-bottom: 1px solid var(--kyc-sdk-normal-blue-15);
  font-family: var(--kyc-sdk-primary-font);
  font-weight: 400;
  color: black;
  justify-content: left;
  white-space: pre;
  display: flex;
  width: 100%;

  strong {
    font-family: var(--kyc-sdk-primary-font);
    font-weight: 800;
    justify-content: center;
  }

  &:hover {
    background: var(--kyc-sdk-cybergreen-35);
    color: black;
  }
`, Ope = Ge.div`
  width: 100%;
  max-height: 40vh;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;

  @media only screen and (min-width: 992px) {
    max-height: 35vh;
  }

  border: 2px solid black;
  border-bottom: 0;
  border-radius: var(--kyc-sdk-border-radius-light);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline: none;
  box-sizing: border-box;
`, Ppe = Ge.div`
  margin-bottom: 1em;
  @extend ${Ki};
  box-sizing: content-box;
  position: relative;

  &:has(${SU}:hover) > ${EU} {
    color: var(--kyc-sdk-cybergreen);
  }
`, AU = bI(void 0), ax = A3`
	0% {
		opacity: 1;
	}

	25% {
		opacity: 0;
	}

	50% {
		opacity: 1;
	}

	75% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
`, Bpe = Ge.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  ${Ki};

  svg path {
    fill: var(--kyc-sdk-cybergreen);
  }
`, Cpe = Ge.svg`
  position: relative;
  animation: ${ax} 2s infinite;
  animation-delay: 0s;
`, Dpe = Ge.svg`
  @extend ${Ki};
  animation: ${ax} 2s infinite;
  animation-delay: 0.6s;
  position: relative;
  top: -10px;
`, Rpe = Ge.svg`
  position: relative;
  top: -20px;
  @extend ${Ki};
  animation: ${ax} 2s infinite;
  animation-delay: 0.12s;
`;
function IU() {
  return /* @__PURE__ */ We(Bpe, { children: [
    /* @__PURE__ */ ee(
      Cpe,
      {
        width: "43",
        height: "26",
        viewBox: "0 0 43 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ ee(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M42.701 3.71317L38.9878 0L21.3503 17.6375L16.7088 12.9961L12.9956 16.7092L21.3503 25.0639L42.701 3.71317ZM0 3.71321L9.28292 12.9961L12.9961 9.28296L3.71317 4.60767e-05L0 3.71321Z",
            fill: "#3D65F2"
          }
        )
      }
    ),
    /* @__PURE__ */ ee(
      Dpe,
      {
        width: "43",
        height: "26",
        viewBox: "0 0 43 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ ee(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M-0.000108705 3.71317L3.71306 0L21.3506 17.6375L25.9921 12.9961L29.7052 16.7092L21.3506 25.0639L-0.000108705 3.71317ZM42.7017 3.71321L33.4187 12.9961L29.7056 9.28296L38.9885 4.35823e-05L42.7017 3.71321Z",
            fill: "#3D65F2"
          }
        )
      }
    ),
    /* @__PURE__ */ ee(
      Rpe,
      {
        width: "43",
        height: "26",
        viewBox: "0 0 43 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ ee(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M42.701 3.71317L38.9878 0L21.3503 17.6375L16.7088 12.9961L12.9956 16.7092L21.3503 25.0639L42.701 3.71317ZM0 3.71321L9.28292 12.9961L12.9961 9.28296L3.71317 4.60767e-05L0 3.71321Z",
            fill: "#3D65F2"
          }
        )
      }
    )
  ] });
}
const Npe = Ge.span`
  background: var(--kyc-sdk-cybergreen);
  display: inline-flex;
  justify-content: center;
  margin-right: 8px;
  flex: 1;
  padding: 8px 10px;
  border-radius: 4px;
  max-width: 18px;
  box-sizing: content-box;
`;
function Vo() {
  return /* @__PURE__ */ ee(Npe, { children: /* @__PURE__ */ We(
    "svg",
    {
      width: "16",
      height: "21",
      viewBox: "0 0 16 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ ee(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.0007 1.39121L14.6095 0L8.00129 6.60825L6.26227 4.86924L4.87106 6.26045L8.00129 9.39067L16.0007 1.39121ZM0.00195312 1.39146L3.47998 4.86948L4.87119 3.47827L1.39316 0.00024517L0.00195312 1.39146Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ ee(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.9982 12.9811L14.607 11.5898L7.99872 18.1981L6.25971 16.4591L4.8685 17.8503L7.99872 20.9805L15.9982 12.9811ZM0 12.9817L3.47803 16.4598L4.86924 15.0686L1.39121 11.5905L0 12.9817Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ ee(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.999 7.07871L12.521 10.5567L11.1298 9.16553L14.6078 5.6875L15.999 7.07871ZM0.000940445 7.07903L1.39215 5.68782L8.0004 12.2961L9.73941 10.5571L11.1306 11.9483L8.0004 15.0785L0.000940445 7.07903Z",
            fill: "black"
          }
        )
      ]
    }
  ) });
}
const mo = () => ln(AU), Jg = Ge.div`
  height: 100%;
  width: 100%;
  position: absolute;
  inset: 0;
  backdrop-filter: brightness(50%);
  z-index: 10;
`, nv = Ge.div`
  box-shadow: 0 0 0 0 rgba(white, 0);
  position: absolute;
  bottom: 0em;
  margin: 1em;
  width: stretch;
  background: #fefefe;
  border-radius: 4px;
`, rv = Ge.div`
  box-sizing: border-box;
  flex-direction: row;
  display: flex;
  margin: 1em;
  align-items: center;
  justify-content: space-between;

  p {
    color: black;
    margin-left: 1em;
    font-family: var(--kyc-sdk-primary-font);
    margin-block: auto;
  }
`, iv = Ge.div`
  margin: 1rem;
  box-sizing: border-box;

  p {
    color: black;
    font-family: var(--kyc-sdk-primary-font);

    b {
      font-weight: 800;
      color: black;
    }
  }
`, jpe = Ge.button`
  cursor: pointer;
  line-height: 100%;
  width: 2rem;
  height: 2rem;
  border: none;
  box-sizing: content-box;
  padding: 0;
  border-radius: 100%;
  background: transparent;

  &:hover {
    background: var(--kyc-sdk-cybergreen-35);
  }
`, ov = Ge.i`
  background: ${({ background: e }) => e};
  color: ${({ color: e }) => e};
  border-radius: 100%;
  height: 1.5em;
  width: 1.5em;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`, kU = Ge.div`
  box-sizing: border-box;
  padding: 0 1rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .kyc-dao-web-sdk-button {
    padding: 0;
  }
`, av = Ge.div`
  flex-direction: row;
  display: flex;
`, Upe = () => {
  const {
    data: { email: e },
    dispatch: t
  } = ln(Wn), n = Ja(), r = mo(), i = Le(() => {
    r == null || r.kycDao.resendEmailConfirmationCode().catch((a) => {
      n("fatal", a);
    });
  }, [r, n]), o = Le(() => {
    t({ type: ke.setModal, payload: null });
  }, [t]);
  return /* @__PURE__ */ We(nv, { children: [
    /* @__PURE__ */ ee(rv, { children: /* @__PURE__ */ We(av, { children: [
      /* @__PURE__ */ ee(
        ov,
        {
          background: "var(--kyc-sdk-cybergreen-35)",
          className: "material-icons",
          children: "hourglass_bottom"
        }
      ),
      /* @__PURE__ */ ee(tn, { children: "waiting for email confirmation" })
    ] }) }),
    /* @__PURE__ */ We(iv, { children: [
      /* @__PURE__ */ ee(Dl, { children: "Please confirm your email via the magic link sent to the following address:" }),
      /* @__PURE__ */ ee(tn, { children: e })
    ] }),
    /* @__PURE__ */ We(kU, { children: [
      /* @__PURE__ */ We(Ya, { mode: "underline", onClick: i, children: [
        /* @__PURE__ */ ee("i", { className: "material-icons", children: "refresh" }),
        /* @__PURE__ */ ee("span", { children: "Resend" })
      ] }),
      /* @__PURE__ */ We(Ya, { mode: "underline", onClick: o, children: [
        /* @__PURE__ */ ee("i", { className: "material-icons", children: "refresh" }),
        /* @__PURE__ */ ee("span", { children: "change email" })
      ] })
    ] })
  ] });
}, zpe = () => {
  const {
    data: { errorModalHeader: e, errorModalBody: t },
    dispatch: n
  } = ln(Wn), r = Le(() => {
    n({ type: ke.setModal, payload: null });
  }, [n]);
  return /* @__PURE__ */ We(nv, { children: [
    /* @__PURE__ */ We(rv, { children: [
      /* @__PURE__ */ We(av, { children: [
        /* @__PURE__ */ ee(
          ov,
          {
            background: "var(--kyc-sdk-red)",
            className: "material-icons",
            children: "error"
          }
        ),
        /* @__PURE__ */ ee(tn, { children: e })
      ] }),
      /* @__PURE__ */ ee(jpe, { className: "material-icons", onClick: r, children: "close" })
    ] }),
    /* @__PURE__ */ ee(iv, { children: /* @__PURE__ */ ee(Dl, { children: t }) })
  ] });
}, sx = () => {
  const e = mo(), t = ln(Wn), n = Ja();
  return async function(i, o) {
    if (e) {
      const {
        data: { termsAccepted: a, currentPage: s },
        dispatch: c
      } = t;
      c({
        type: ke.setModal,
        payload: "minting"
      });
      try {
        const l = await e.kycDao.startMinting({
          disclaimerAccepted: a || e.kycDao.subscribed,
          verificationType: Du.KYC,
          imageId: i,
          subscriptionYears: o
        });
        if (l) {
          const { imageUrl: u, transactionUrl: f } = l;
          c({
            type: ke.setChainExplorerUrl,
            payload: f
          }), c({
            type: ke.setNftImageUrl,
            payload: u
          });
        } else
          throw Error("Something went wrong");
        c({
          type: ke.setModal,
          payload: null
        }), c({
          type: ke.changePage,
          payload: { prev: s, current: Ue.finalStep }
        }), c({
          type: ke.SetProcessSucess,
          payload: !0
        });
      } catch (l) {
        n("minting", l);
      }
    }
  };
}, Fpe = () => {
  const e = sx(), {
    data: { subscriptionYears: t, imageId: n, errorModalBody: r },
    dispatch: i
  } = ln(Wn), o = Le(() => {
    n && e(n, t);
  }, [e, t, n]), a = Le(() => {
    i({ type: ke.setModal, payload: null });
  }, [i]);
  return /* @__PURE__ */ We(nv, { children: [
    /* @__PURE__ */ We(rv, { children: [
      /* @__PURE__ */ We(av, { children: [
        /* @__PURE__ */ ee(
          ov,
          {
            background: "var(--kyc-sdk-red)",
            className: "material-icons",
            children: "error"
          }
        ),
        /* @__PURE__ */ ee(tn, { children: "Minting failed" })
      ] }),
      /* @__PURE__ */ ee(ox, { className: "material-icons", onClick: a, children: "close" })
    ] }),
    /* @__PURE__ */ We(iv, { children: [
      /* @__PURE__ */ ee(Dl, { children: "Minting failed because of an error. Please try mint kycNFT again." }),
      r && /* @__PURE__ */ ee(Dl, { children: r })
    ] }),
    /* @__PURE__ */ ee(kU, { children: /* @__PURE__ */ We(Ya, { mode: "underline", onClick: o, children: [
      /* @__PURE__ */ ee("i", { className: "material-icons", children: "refresh" }),
      /* @__PURE__ */ ee("span", { children: "Retry" })
    ] }) })
  ] });
}, Lpe = Ge(gr)`
  justify-content: center;
  display: flex;
  margin-bottom: 1em;
`, $pe = () => /* @__PURE__ */ We(nv, { children: [
  /* @__PURE__ */ ee(rv, { children: /* @__PURE__ */ We(av, { children: [
    /* @__PURE__ */ ee(
      ov,
      {
        background: "var(--kyc-sdk-cybergreen-35)",
        className: "material-icons",
        children: "error"
      }
    ),
    /* @__PURE__ */ ee(tn, { children: "Mint authorization in progress" })
  ] }) }),
  /* @__PURE__ */ ee(iv, { children: /* @__PURE__ */ ee(Dl, { children: "Your kycNFT is getting ready! It may take up to a minute, please hold tight. Once authorized, it’s your turn to mint." }) }),
  /* @__PURE__ */ ee(IU, {}),
  /* @__PURE__ */ ee(Lpe, { children: "Loading" })
] }), WB = () => {
  const {
    data: { currentModal: e }
  } = ln(Wn);
  switch (e) {
    case "emailVerification":
      return /* @__PURE__ */ ee(Jg, { children: /* @__PURE__ */ ee(Upe, {}) });
    case "minting":
      return /* @__PURE__ */ ee(Jg, { children: /* @__PURE__ */ ee($pe, {}) });
    case "mintingFailed":
      return /* @__PURE__ */ ee(Jg, { children: /* @__PURE__ */ ee(Fpe, {}) });
    case "genericError":
      return /* @__PURE__ */ ee(Jg, { children: /* @__PURE__ */ ee(zpe, {}) });
    default:
      return null;
  }
}, Wpe = ({ height: e, showSize: t, width: n }) => /* @__PURE__ */ ee("div", { children: t ? `${n}&times;${e}` : "" }), Kpe = Ge(Wpe)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: grey;
  color: white;
  user-select: none;
  font-size: 3vw;
  width: ${({ width: e }) => e};
  height: ${({ height: e }) => e};
  cursor: ${({ onClick: e }) => e ? "pointer" : "default"};
`, Vpe = "Left", qpe = "Right", Hpe = "Up", Gpe = "Down", Fu = {
  delta: 10,
  preventScrollOnSwipe: !1,
  rotationAngle: 0,
  trackMouse: !1,
  trackTouch: !0,
  swipeDuration: 1 / 0,
  touchEventOptions: { passive: !0 }
}, yI = {
  first: !0,
  initial: [0, 0],
  start: 0,
  swiping: !1,
  xy: [0, 0]
}, KB = "mousemove", VB = "mouseup", Ype = "touchend", Zpe = "touchmove", Jpe = "touchstart";
function Xpe(e, t, n, r) {
  return e > t ? n > 0 ? qpe : Vpe : r > 0 ? Gpe : Hpe;
}
function qB(e, t) {
  if (t === 0)
    return e;
  const n = Math.PI / 180 * t, r = e[0] * Math.cos(n) + e[1] * Math.sin(n), i = e[1] * Math.cos(n) - e[0] * Math.sin(n);
  return [r, i];
}
function Qpe(e, t) {
  const n = (u) => {
    const f = "touches" in u;
    f && u.touches.length > 1 || e((d, h) => {
      h.trackMouse && !f && (document.addEventListener(KB, r), document.addEventListener(VB, a));
      const { clientX: g, clientY: w } = f ? u.touches[0] : u, b = qB([g, w], h.rotationAngle);
      return h.onTouchStartOrOnMouseDown && h.onTouchStartOrOnMouseDown({ event: u }), Object.assign(Object.assign(Object.assign({}, d), yI), { initial: b.slice(), xy: b, start: u.timeStamp || 0 });
    });
  }, r = (u) => {
    e((f, d) => {
      const h = "touches" in u;
      if (h && u.touches.length > 1)
        return f;
      if (u.timeStamp - f.start > d.swipeDuration)
        return f.swiping ? Object.assign(Object.assign({}, f), { swiping: !1 }) : f;
      const { clientX: g, clientY: w } = h ? u.touches[0] : u, [b, I] = qB([g, w], d.rotationAngle), A = b - f.xy[0], x = I - f.xy[1], N = Math.abs(A), j = Math.abs(x), K = (u.timeStamp || 0) - f.start, W = Math.sqrt(N * N + j * j) / (K || 1), O = [A / (K || 1), x / (K || 1)], k = Xpe(N, j, A, x), z = typeof d.delta == "number" ? d.delta : d.delta[k.toLowerCase()] || Fu.delta;
      if (N < z && j < z && !f.swiping)
        return f;
      const C = {
        absX: N,
        absY: j,
        deltaX: A,
        deltaY: x,
        dir: k,
        event: u,
        first: f.first,
        initial: f.initial,
        velocity: W,
        vxvy: O
      };
      C.first && d.onSwipeStart && d.onSwipeStart(C), d.onSwiping && d.onSwiping(C);
      let M = !1;
      return (d.onSwiping || d.onSwiped || d[`onSwiped${k}`]) && (M = !0), M && d.preventScrollOnSwipe && d.trackTouch && u.cancelable && u.preventDefault(), Object.assign(Object.assign({}, f), {
        // first is now always false
        first: !1,
        eventData: C,
        swiping: !0
      });
    });
  }, i = (u) => {
    e((f, d) => {
      let h;
      if (f.swiping && f.eventData) {
        if (u.timeStamp - f.start < d.swipeDuration) {
          h = Object.assign(Object.assign({}, f.eventData), { event: u }), d.onSwiped && d.onSwiped(h);
          const g = d[`onSwiped${h.dir}`];
          g && g(h);
        }
      } else
        d.onTap && d.onTap({ event: u });
      return d.onTouchEndOrOnMouseUp && d.onTouchEndOrOnMouseUp({ event: u }), Object.assign(Object.assign(Object.assign({}, f), yI), { eventData: h });
    });
  }, o = () => {
    document.removeEventListener(KB, r), document.removeEventListener(VB, a);
  }, a = (u) => {
    o(), i(u);
  }, s = (u, f) => {
    let d = () => {
    };
    if (u && u.addEventListener) {
      const h = Object.assign(Object.assign({}, Fu.touchEventOptions), f.touchEventOptions), g = [
        [Jpe, n, h],
        // preventScrollOnSwipe option supersedes touchEventOptions.passive
        [
          Zpe,
          r,
          Object.assign(Object.assign({}, h), f.preventScrollOnSwipe ? { passive: !1 } : {})
        ],
        [Ype, i, h]
      ];
      g.forEach(([w, b, I]) => u.addEventListener(w, b, I)), d = () => g.forEach(([w, b]) => u.removeEventListener(w, b));
    }
    return d;
  }, l = {
    ref: (u) => {
      u !== null && e((f, d) => {
        if (f.el === u)
          return f;
        const h = {};
        return f.el && f.el !== u && f.cleanUpTouch && (f.cleanUpTouch(), h.cleanUpTouch = void 0), d.trackTouch && u && (h.cleanUpTouch = s(u, d)), Object.assign(Object.assign(Object.assign({}, f), { el: u }), h);
      });
    }
  };
  return t.trackMouse && (l.onMouseDown = n), [l, s];
}
function eye(e, t, n, r) {
  return !t.trackTouch || !e.el ? (e.cleanUpTouch && e.cleanUpTouch(), Object.assign(Object.assign({}, e), { cleanUpTouch: void 0 })) : e.cleanUpTouch ? t.preventScrollOnSwipe !== n.preventScrollOnSwipe || t.touchEventOptions.passive !== n.touchEventOptions.passive ? (e.cleanUpTouch(), Object.assign(Object.assign({}, e), { cleanUpTouch: r(e.el, t) })) : e : Object.assign(Object.assign({}, e), { cleanUpTouch: r(e.el, t) });
}
function tye(e) {
  const { trackMouse: t } = e, n = gc.useRef(Object.assign({}, yI)), r = gc.useRef(Object.assign({}, Fu)), i = gc.useRef(Object.assign({}, r.current));
  i.current = Object.assign({}, r.current), r.current = Object.assign(Object.assign({}, Fu), e);
  let o;
  for (o in Fu)
    r.current[o] === void 0 && (r.current[o] = Fu[o]);
  const [a, s] = gc.useMemo(() => Qpe((c) => n.current = c(n.current, r.current), { trackMouse: t }), [t]);
  return n.current = eye(n.current, r.current, i.current, s), a;
}
function TU(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = TU(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function nye() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = TU(e)) && (r && (r += " "), r += t);
  return r;
}
const HB = !!navigator.userAgent.match("Phantom"), rye = Ge.div`
  ${({ paddingBottom: e }) => ir`
      padding-bottom: ${e};
    `}
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  padding: 0 1em 0 1em;
  justify-content: space-between;
  align-items: center;
  right: 0;
  top: 64px;
  bottom: 0;
  position: absolute;
  transition: right 0.25s;
  overflow: hidden;

  h1 {
    font-family: var(--kyc-sdk-primary-font);
    align-items: center;
    font-weight: 400;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    color: black;
    ${gr}
  }

  &.moving-center {
    right: 0;
  }

  &.moving-in {
    right: -100%;
  }

  &.moving-out {
    right: 100%;
  }
`, iye = Ge.div`
  width: 100%;
`, oye = Ge.div`
  box-sizing: border-box;
  align-items: stretch;
  width: 100%;
  height: 70%;
  flex-flow: column;

  p {
    font-family: var(--kyc-sdk-primary-font);
    font-weight: 400;
    color: black;
  }
`, aye = Ge.div`
  padding-bottom: 1rem;
  width: 100%;
  box-sizing: border-box;
  position: relative;

  .kyc-sdk-input {
    margin: 1rem 0;
  }
`, gi = ({
  onNext: e,
  onPrev: t,
  inactive: n = !1,
  disabled: r = !1,
  body: i,
  header: o,
  footer: a,
  onEnter: s,
  className: c,
  animation: l,
  onTransitionDone: u
}) => {
  const f = ln(Wn), [d, h] = pr(), [g, w] = pr(), b = tye({
    onSwipedLeft: e,
    onSwipedRight: t
  });
  Sb(() => {
    if (l) {
      h(l.from), w("inTransition");
      const K = setTimeout(() => {
        h(l.to);
      }, 0);
      return () => clearTimeout(K);
    } else
      w("transitionDone"), u && u("transitionDone");
  }, [u, l]), Sb(() => {
    const K = setTimeout(() => {
      l && g && d === (l == null ? void 0 : l.to) && (u && u("transitionDone"), w("transitionDone"));
    }, 250);
    return () => clearTimeout(K);
  }, [d, g, u, l]), Ht(() => {
    if (n || !s || g && g !== "transitionDone")
      return;
    const K = ({ key: W }) => {
      W === "Enter" && s();
    };
    return document.addEventListener("keyup", K), () => document.removeEventListener("keyup", K);
  }, [s, g, n]);
  const [I, A] = pr(
    "env(keyboard-inset-height, 0px)"
  ), x = Le(() => {
    HB && A("0px");
  }, []), N = Le(() => {
    HB && A("200px");
  }, []);
  if (!f)
    return /* @__PURE__ */ ee(gr, { children: "Something went seriously wrong! Probably you did not provided the data! Check your data provider!" });
  const j = g !== "transitionDone";
  return /* @__PURE__ */ We(
    rye,
    {
      paddingBottom: I,
      ...!n && !r && j ? b : {},
      className: nye(c, d),
      children: [
        o && /* @__PURE__ */ ee(iye, { children: o({
          disabled: r,
          inactive: n || j,
          onEnter: s,
          onNext: e,
          onPrev: t,
          onInputBlurred: x,
          onInputFocused: N
        }) }),
        i && /* @__PURE__ */ ee(oye, { children: i({
          disabled: r,
          inactive: n || j,
          onEnter: s,
          onNext: e,
          onPrev: t,
          onInputBlurred: x,
          onInputFocused: N
        }) }),
        a && /* @__PURE__ */ ee(aye, { children: a({
          disabled: r,
          inactive: n || j,
          onEnter: s,
          onNext: e,
          onPrev: t,
          onInputBlurred: x,
          onInputFocused: N
        }) })
      ]
    }
  );
}, xU = Ge.i`
  position: absolute;
  right: 3rem;
  opacity: 0;
  ${sm(0)};
  ${Ki};
`, MU = Ge.i`
  position: absolute;
  right: 1rem;
  ${sm(0)};
  ${Ki};
`, sye = ({
  disabled: e = !1,
  onClick: t,
  className: n,
  autoFocus: r,
  inactive: i = !1,
  label: o,
  label2: a,
  fullWidth: s = !0
}) => {
  const c = ya(null), [l, u] = pr(o || "Submit");
  Ht(() => {
    var h;
    r && !e && !i && ((h = c.current) == null || h.focus({ preventScroll: !0 }));
  }, [e, r, i]);
  const f = Le(() => {
    u(a || "Next");
  }, [a]), d = Le(() => {
    u(o || "Submit");
  }, [o]);
  return /* @__PURE__ */ We(
    Ya,
    {
      "aria-disabled": e || i,
      mode: "black",
      disabled: e || i,
      ref: c,
      onMouseEnter: f,
      onMouseLeave: d,
      fullWidth: s,
      className: n,
      onClick: i ? void 0 : t,
      children: [
        /* @__PURE__ */ ee("span", { children: l }),
        /* @__PURE__ */ ee(xU, { className: "material-icons", children: "arrow_forward" }),
        /* @__PURE__ */ ee(MU, { className: "material-icons", children: "arrow_forward" })
      ]
    }
  );
}, _o = Ge(sye)`
  overflow: hidden;

  span,
  .material-icons {
    padding-left: 1.5rem;
  }

  :hover {
    ${xU} {
      ${sm("2rem")};
      opacity: 1;
    }

    ${MU} {
      ${sm("8rem")};
    }
  }
`, cye = ({ onClose: e }) => /* @__PURE__ */ We(wU, { children: [
  /* @__PURE__ */ ee(vU, {}),
  /* @__PURE__ */ ee(ox, { onClick: e, children: "close" })
] }), uye = () => /* @__PURE__ */ ee(gr, { children: "Something went wrong!" }), OU = (e) => function({ error: n, resetErrorBoundary: r }) {
  const i = Le(() => /* @__PURE__ */ ee("div", { role: "alert", children: /* @__PURE__ */ ee(tn, { children: n.message || "An unknown, fatal error happened!" }) }), [n.message]), o = Le(() => {
    window.parent.postMessage(
      { type: "kycDaoCloseModal" },
      e
    );
  }, []), a = Le(
    () => /* @__PURE__ */ We(Ya, { mode: "underline", onClick: r, children: [
      /* @__PURE__ */ ee("i", { className: "material-icons", children: "refresh" }),
      /* @__PURE__ */ ee("span", { children: "Retry" })
    ] }),
    [r]
  );
  return /* @__PURE__ */ We(ar, { children: [
    /* @__PURE__ */ ee(cye, { onClose: o }),
    /* @__PURE__ */ ee(gi, { footer: a, disabled: !1, header: uye, body: i })
  ] });
}, qo = () => {
  const { dispatch: e } = ln(Wn);
  return Le(
    (t, n, r = "next") => {
      e({
        type: ke.changePage,
        payload: {
          current: t,
          [r === "next" ? "prev" : "next"]: n
        }
      });
    },
    [e]
  );
}, lye = () => /* @__PURE__ */ We(gr, { children: [
  /* @__PURE__ */ ee(Vo, {}),
  "KycDAO"
] }), fye = () => /* @__PURE__ */ We(ar, { children: [
  /* @__PURE__ */ ee(bU, { children: "The last proof you need in web3." }),
  /* @__PURE__ */ ee(tn, { children: "kycDAO is a web3 native reusable compliance framework." }),
  /* @__PURE__ */ ee(tn, { children: "CEXs/Ramps already know your wallet address; kycDAO makes it composable." }),
  /* @__PURE__ */ ee(tn, { children: "Our proofs allow smart contracts and services to interact with trusted wallets." }),
  /* @__PURE__ */ ee(tn, { children: "We use soulbound NFTs to prove your compliant account. Strictly no PII!" })
] }), dye = ({ inactive: e, disabled: t, onEnter: n }) => /* @__PURE__ */ ee(
  _o,
  {
    autoFocus: !e && !t,
    disabled: t,
    black: !0,
    fullWidth: !0,
    onClick: n,
    inactive: e,
    label: "Start"
  }
), hye = ({
  className: e,
  animation: t,
  disabled: n = !1,
  inactive: r = !1
}) => {
  const { dispatch: i } = ln(Wn), o = qo(), a = mo(), s = Le(async () => {
    o(Ue.kycDAOMembershipStep, Ue.AgreementStep);
  }, [o]), c = Le(() => {
    !n && !r && (i({
      payload: { button: Pt.prev, state: "hidden" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: { button: Pt.next, state: "enabled" },
      type: ke.SetHeaderButtonState
    }));
  }, [n, r, i]);
  return Ht(() => {
    if (!n && !r) {
      const l = Lo.subscribe(s);
      return l.unsubscribe.bind(l);
    }
  }, [n, r, i, s]), a ? /* @__PURE__ */ ee(
    gi,
    {
      onNext: s,
      onTransitionDone: c,
      disabled: n,
      className: e,
      inactive: r,
      animation: t,
      header: lye,
      onEnter: s,
      footer: dye,
      body: fye
    }
  ) : /* @__PURE__ */ ee(ar, { children: "Something went seriously wrong!" });
}, pye = ({ inactive: e, disabled: t }) => {
  const n = Le((b) => {
    console.log(b), d.current = !1;
  }, []), r = Ja(), {
    dispatch: i,
    data: {
      email: o,
      termsAccepted: a,
      taxResidency: s,
      messageTargetOrigin: c,
      isEmailConfirmed: l,
      grantFlowEnabled: u
    }
  } = ln(Wn), f = mo(), d = ya(!1), h = qo(), g = Le(() => {
    h(Ue.nftArtSelection), d.current = !1;
  }, [h]), w = Le(() => {
    h(u ? Ue.grantSocialSecurityNumberStep : Ue.taxResidenceStep, Ue.loading, "prev"), d.current = !1;
  }, [u, h]);
  return Ht(() => {
    e || t || !f || d.current || (u ? h(Ue.loading, Ue.grantSocialSecurityNumberStep) : h(Ue.loading, Ue.taxResidenceStep), d.current = !0, (async () => {
      try {
        await f.kycDao.startVerification(
          {
            email: o,
            isEmailConfirmed: l,
            isLegalEntity: !1,
            // @TODO
            taxResidency: s,
            termsAccepted: a,
            verificationType: Du.KYC
          },
          {
            personaOptions: {
              onCancel: w,
              onComplete: g,
              onError: n,
              frameAncestors: c ? [c] : void 0,
              messageTargetOrigin: window.self.origin
            }
          }
        );
      } catch (b) {
        r("fatal", b);
      }
    })());
  }, [
    d,
    f,
    e,
    t,
    w,
    g,
    i,
    o,
    n,
    c,
    s,
    a,
    l,
    u,
    h,
    r
  ]), f ? /* @__PURE__ */ ee(ar, {}) : /* @__PURE__ */ ee(gr, { children: "Error" });
}, yye = "data:image/svg+xml;base64,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", gye = /^[^@]+@([\w-]+\.)+[\w-]{2,}$/, bye = () => /* @__PURE__ */ We(gr, { children: [
  /* @__PURE__ */ ee(Vo, {}),
  "Confirm your email"
] }), mye = Ge.img`
  width: 32px;
`, _ye = Ge(tn)`
  margin-block: auto;
  margin-inline: 1em;
`, wye = Ge.div`
  display: flex;
  justify-content: start;
`, vye = Ge.div`
  color: black;
  background: var(--kyc-sdk-cybergreen);
  width: 64px;
  height: 64px;
  border-radius: var(--kyc-sdk-border-radius-light);
  display: flex;
  justify-content: center;
`, Sye = () => /* @__PURE__ */ We(ar, { children: [
  /* @__PURE__ */ ee(tn, { children: "Please confirm your email by clicking the magic link we will send." }),
  /* @__PURE__ */ ee(tn, { children: "This is important for us to maintain effective communication with our members." })
] }), Eye = ({
  className: e,
  animation: t,
  disabled: n = !1,
  inactive: r = !1
}) => {
  const {
    data: { email: i, currentModal: o, isEmailConfirmed: a },
    dispatch: s
  } = ln(Wn), c = qo(), l = mo(), u = Ja(), [f, d] = pr(!1), [h, g] = pr(""), w = ya();
  Sb(() => {
    i !== "" && (g(i), d(!0));
  }, [i]);
  const b = ya(null), I = Le(() => {
    var W;
    !n && !r && (i === "" && ((W = b.current) == null || W.focus()), s({
      payload: { button: Pt.prev, state: "enabled" },
      type: ke.SetHeaderButtonState
    }), s({
      payload: {
        button: Pt.next,
        state: i ? "enabled" : "hidden"
      },
      type: ke.SetHeaderButtonState
    }));
  }, [r, n, s, i]), A = jo(
    () => !gye.test(h),
    [h]
  );
  Ht(() => {
    !o && w.current && clearInterval(w.current);
  }, [o]), Ht(() => {
    s({
      payload: {
        button: Pt.next,
        state: A ? "hidden" : "enabled"
      },
      type: ke.SetHeaderButtonState
    });
  }, [A, s]);
  const x = Le(async () => {
    if (!A && l)
      if (a)
        c(Ue.taxResidenceStep, Ue.emailDiscordVerificationStep);
      else {
        s({
          type: ke.setModal,
          payload: "emailVerification"
        }), s({ type: ke.emailChange, payload: h });
        try {
          await l.kycDao.updateEmail(h);
          const W = async () => {
            try {
              const O = await (l == null ? void 0 : l.kycDao.checkEmailConfirmed());
              O != null && O.isConfirmed && (s({
                type: ke.setEmailConfirmed,
                payload: !0
              }), c(
                Ue.verificationStep,
                Ue.emailDiscordVerificationStep
              ), s({
                type: ke.setModal,
                payload: null
              }), clearInterval(w.current));
            } catch (O) {
              u("modal", O);
            }
          };
          w.current = setInterval(W, 1500);
        } catch (W) {
          u("modal", W);
        }
      }
  }, [
    A,
    l,
    a,
    s,
    h,
    c,
    u
  ]), N = Le(() => {
    clearInterval(w.current), c(
      Ue.verifyAccountStep,
      Ue.emailDiscordVerificationStep,
      "prev"
    );
  }, [c]);
  Ht(() => {
    if (!n && !r) {
      const W = Lo.subscribe(x), O = Za.subscribe(N);
      return () => {
        O.unsubscribe(), W.unsubscribe();
      };
    }
  }, [x, n, r, s, N]);
  const j = Le(
    (W) => {
      g(W), s({ type: ke.setEmailConfirmed, payload: !1 });
    },
    [s]
  ), K = Le(
    ({ disabled: W, inactive: O, onNext: k, onInputBlurred: z, onInputFocused: C }) => /* @__PURE__ */ We(ar, { children: [
      /* @__PURE__ */ We(wye, { style: { display: "none" }, children: [
        /* @__PURE__ */ ee(vye, { children: /* @__PURE__ */ ee(mye, { src: yye }) }),
        /* @__PURE__ */ ee(_ye, { children: "Connect Discord Soon" })
      ] }),
      /* @__PURE__ */ ee(
        vd,
        {
          onInputBlurred: z,
          onInputFocused: C,
          inputRef: b,
          disabled: W,
          fullWidth: !0,
          value: h,
          placeholder: "email",
          onChange: j,
          type: "email"
        }
      ),
      /* @__PURE__ */ ee(
        _o,
        {
          black: !0,
          fullWidth: !0,
          autoFocus: f,
          inactive: O,
          disabled: A || W,
          onClick: k
        }
      )
    ] }),
    [b, h, j, f, A]
  );
  return /* @__PURE__ */ ee(
    gi,
    {
      onNext: x,
      onPrev: N,
      onTransitionDone: I,
      disabled: n,
      inactive: r,
      animation: t,
      className: e,
      onEnter: x,
      footer: K,
      body: Sye,
      header: bye
    }
  );
};
var gE = { exports: {} };
/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */
var GB;
function Aye() {
  return GB || (GB = 1, function(e) {
    (function(t, n) {
      e.exports ? e.exports = n() : this[t] = n();
    })("$script", function() {
      var t = document, n = t.getElementsByTagName("head")[0], r = !1, i = "push", o = "readyState", a = "onreadystatechange", s = {}, c = {}, l = {}, u, f;
      function d(b, I) {
        for (var A = 0, x = b.length; A < x; ++A)
          if (!I(b[A]))
            return r;
        return 1;
      }
      function h(b, I) {
        d(b, function(A) {
          return I(A), 1;
        });
      }
      function g(b, I, A) {
        b = b[i] ? b : [b];
        var x = I && I.call, N = x ? I : A, j = x ? b.join("") : I, K = b.length;
        function W(k) {
          return k.call ? k() : s[k];
        }
        function O() {
          if (!--K) {
            s[j] = 1, N && N();
            for (var k in c)
              d(k.split("|"), W) && !h(c[k], W) && (c[k] = []);
          }
        }
        return setTimeout(function() {
          h(b, function k(z, C) {
            if (z === null)
              return O();
            if (!C && !/^https?:\/\//.test(z) && u && (z = z.indexOf(".js") === -1 ? u + z + ".js" : u + z), l[z])
              return l[z] == 2 ? O() : setTimeout(function() {
                k(z, !0);
              }, 0);
            l[z] = 1, w(z, O);
          });
        }, 0), g;
      }
      function w(b, I) {
        var A = t.createElement("script"), x;
        A.onload = A.onerror = A[a] = function() {
          A[o] && !/^c|loade/.test(A[o]) || x || (A.onload = A[a] = null, x = 1, l[b] = 2, I());
        }, A.async = 1, A.src = f ? b + (b.indexOf("?") === -1 ? "?" : "&") + f : b, n.insertBefore(A, n.lastChild);
      }
      return g.get = w, g.order = function(b, I, A) {
        (function x(N) {
          N = b.shift(), b.length ? g(N, x) : g(N, I, A);
        })();
      }, g.path = function(b) {
        u = b;
      }, g.urlArgs = function(b) {
        f = b;
      }, g.ready = function(b, I, A) {
        b = b[i] ? b : [b];
        var x = [];
        return !h(b, function(N) {
          s[N] || x[i](N);
        }) && d(b, function(N) {
          return s[N];
        }) ? I() : function(N) {
          c[N] = c[N] || [], c[N][i](I), A && A(x);
        }(b.join("|")), g;
      }, g.done = function(b) {
        g([null], b);
      }, g;
    });
  }(gE)), gE.exports;
}
var Iye = "https://platform.twitter.com/widgets.js", bE = "createShareButton", kye = function(t) {
  var n = vr.useRef(null), r = vr.useState(!0), i = r[0], o = r[1];
  return vr.useEffect(function() {
    var a = !0, s = Aye();
    return s(Iye, "twitter-embed", function() {
      if (!window.twttr) {
        console.error("Failure to load window.twttr, aborting load");
        return;
      }
      if (a) {
        if (!window.twttr.widgets[bE]) {
          console.error("Method " + bE + " is not present anymore in twttr.widget api");
          return;
        }
        window.twttr.widgets[bE](t.url, n == null ? void 0 : n.current, t.options).then(function(c) {
          o(!1), t.onLoad && t.onLoad(c);
        });
      }
    }), function() {
      a = !1;
    };
  }, []), vr.createElement(vr.Fragment, null, i && vr.createElement(vr.Fragment, null, t.placeholder), vr.createElement("div", {
    ref: n
  }));
};
const PU = Ge.div`
  display: flex;
  align-items: center;
  justify-content: center;
`, Tye = Ge.div`
  text-align: center;
`, xye = Ge.div`
  justify-content: center;
  display: flex;
  padding-top: 1em;
`, Mye = ({
  className: e,
  animation: t,
  disabled: n = !1
  // inactive = false,
}) => {
  var x;
  const r = mo(), {
    dispatch: i,
    data: {
      messageTargetOrigin: o,
      chainExplorerUrl: a,
      nftImageUrl: s,
      alreadyHaveAnNftOnThisChain: c,
      nearMinted: l
    }
  } = ln(Wn), u = Ja(), f = Le(
    () => c ? /* @__PURE__ */ ee(ar, {}) : /* @__PURE__ */ ee(gr, { marginBottom: "0", children: "Congrats!" }),
    [c]
  ), d = Le(() => {
    n || (i({
      payload: { button: Pt.prev, state: "hidden" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: { button: Pt.next, state: "hidden" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: { button: Pt.close, state: "enabled" },
      type: ke.SetHeaderButtonState
    }));
  }, [n, i]), [h, g] = pr(""), w = Le(() => {
    window.open(a, "_blank");
  }, [a]);
  Ht(() => {
    r && async function() {
      var N;
      if (c)
        try {
          const j = (await r.kycDao.getValidNfts("KYC")).tokens;
          j && j.length > 0 && j[0].image && g(j[0].image);
        } catch (j) {
          u("modal", j);
        }
      else
        g(((N = r.mintingResult) == null ? void 0 : N.imageUrl) || s);
    }();
  }, [r, s, u, c]);
  const b = Le(
    () => {
      var N;
      return /* @__PURE__ */ We(ar, { children: [
        /* @__PURE__ */ We(Mpe, { marginBottom: "0", children: [
          c && !l ? "You already have a " : "You have successfully minted your ",
          "kycNFT on ",
          (N = r == null ? void 0 : r.kycDao.connectedWallet) == null ? void 0 : N.blockchainNetwork
        ] }),
        /* @__PURE__ */ ee(Tye, { children: h ? /* @__PURE__ */ ee(
          "img",
          {
            alt: "",
            src: h,
            width: "300px",
            height: "300px"
          }
        ) : /* @__PURE__ */ ee(Kpe, { width: "300px", height: "300px" }) }),
        /* @__PURE__ */ ee(xye, { children: /* @__PURE__ */ ee(
          kye,
          {
            url: "https://kycdao.xyz/",
            options: {
              text: "I’m the n-th #trustedanon of #web3 bc I joined @kycdao!",
              hashtags: "kyc",
              size: "large"
            }
          }
        ) })
      ] });
    },
    [r, h, c, l]
  ), I = Le(async () => {
    var N;
    c ? window.parent.postMessage(
      {
        type: "kycDaoSuccess",
        data: `Already has an nft on ${(N = r == null ? void 0 : r.kycDao.connectedWallet) == null ? void 0 : N.blockchainNetwork}.`
      },
      o
    ) : window.parent.postMessage(
      {
        type: "kycDaoSuccess",
        data: a
      },
      o
    );
  }, [
    o,
    a,
    c,
    (x = r == null ? void 0 : r.kycDao.connectedWallet) == null ? void 0 : x.blockchainNetwork
  ]), A = Le(
    ({ disabled: N, inactive: j }) => /* @__PURE__ */ We(ar, { children: [
      a && /* @__PURE__ */ ee(PU, { children: /* @__PURE__ */ ee(
        Ya,
        {
          disabled: N,
          inactive: j,
          centered: !0,
          fullWidth: !0,
          mode: "underline",
          onClick: w,
          children: "Check on chain"
        }
      ) }),
      /* @__PURE__ */ ee(
        _o,
        {
          black: !0,
          fullWidth: !0,
          autoFocus: !j && !N,
          disabled: N,
          onClick: I,
          inactive: j,
          label: "Finish",
          label2: "Finish"
        }
      )
    ] }),
    [w, a, I]
  );
  return r ? /* @__PURE__ */ ee(
    gi,
    {
      onTransitionDone: d,
      disabled: n,
      animation: t,
      className: e,
      header: f,
      body: b,
      footer: A
    }
  ) : /* @__PURE__ */ ee(gr, { children: "An error happened!" });
}, Oye = Ge.h1`
  justify-content: center;
`, Pye = () => /* @__PURE__ */ We(ar, { children: [
  /* @__PURE__ */ ee(Oye, { children: "Loading" }),
  /* @__PURE__ */ ee(IU, {})
] }), Bye = ({
  className: e,
  animation: t,
  disabled: n = !1
}) => {
  const { dispatch: r } = ln(Wn), i = Le(() => {
    n || (r({
      payload: { button: Pt.prev, state: "hidden" },
      type: ke.SetHeaderButtonState
    }), r({
      payload: { button: Pt.next, state: "hidden" },
      type: ke.SetHeaderButtonState
    }));
  }, [n, r]);
  return /* @__PURE__ */ ee(
    gi,
    {
      disabled: n,
      onTransitionDone: i,
      className: e,
      animation: t,
      body: Pye
    }
  );
}, Cye = ({ disabled: e, inactive: t, onEnter: n }) => /* @__PURE__ */ We(ar, { children: [
  /* @__PURE__ */ We(Dl, { children: [
    "By starting verification you accept",
    " ",
    /* @__PURE__ */ ee(
      zB,
      {
        target: "_blank",
        rel: "noreferrer",
        href: "https://kycdao.xyz/privacy-policy",
        children: "Privacy Policy"
      }
    ),
    " ",
    "and",
    " ",
    /* @__PURE__ */ ee(
      zB,
      {
        target: "_blank",
        rel: "noreferrer",
        href: "https://kycdao.xyz/terms-and-conditions",
        children: "Terms & Conditions."
      }
    )
  ] }),
  /* @__PURE__ */ ee(
    _o,
    {
      black: !0,
      fullWidth: !0,
      autoFocus: !t && !e,
      disabled: e,
      inactive: t,
      onClick: n,
      label: "Join"
    }
  )
] }), mE = Ge.li`
  list-style: none;
  display: flex;
  margin-bottom: 2rem;
  align-items: center;
  position: relative;

  &:after {
    display: block;
    content: "";
    height: 100%;
    width: 1px;
    background-color: var(--kyc-sdk-cybergreen);
    position: absolute;
    top: 2rem;
    left: 1rem;
  }

  &:last-child {
    &:after {
      display: none;
    }
  }

  & > span {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  }

  & > div {
    margin-left: 1rem;
    display: flex;
    flex-flow: column;

    ${tn},
    b {
      font-family: var(--kyc-sdk-primary-font);
      font-weight: 400;
      color: black;
      margin-bottom: 0;
    }

    b {
      font-size: 12px;
      color: black;
    }
  }
`, _E = Ge.span`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2rem;
  width: 2rem;
  outline: 0.5rem solid var(--kyc-sdk-cybergreen-35);
  border-radius: 999rem;
  background: var(--kyc-sdk-cybergreen);
  color: black;
  font-weight: 800;
`, Dye = Ge.div`
  display: flex;
  align-items: center;
  height: 100%;
`, Rye = Ge(mU)`
  margin: 0 auto;
`, Nye = () => /* @__PURE__ */ ee(ar, { children: /* @__PURE__ */ ee(Dye, { children: /* @__PURE__ */ We(Rye, { children: [
  /* @__PURE__ */ We(mE, { children: [
    /* @__PURE__ */ ee(_E, { children: "1" }),
    /* @__PURE__ */ We("div", { children: [
      /* @__PURE__ */ ee(tn, { children: "Connect" }),
      /* @__PURE__ */ ee(yE, { children: "Using your wallet" })
    ] })
  ] }),
  /* @__PURE__ */ We(mE, { children: [
    /* @__PURE__ */ ee(_E, { children: "2" }),
    /* @__PURE__ */ We("div", { children: [
      /* @__PURE__ */ ee(tn, { children: "Verify" }),
      /* @__PURE__ */ ee(yE, { children: "Log-in or Open a compliant account" })
    ] })
  ] }),
  /* @__PURE__ */ We(mE, { children: [
    /* @__PURE__ */ ee(_E, { children: "3" }),
    /* @__PURE__ */ We("div", { children: [
      /* @__PURE__ */ ee(tn, { children: "Mint" }),
      /* @__PURE__ */ ee(yE, { children: "kycNFT - $5" })
    ] })
  ] })
] }) }) }), jye = () => /* @__PURE__ */ We(gr, { children: [
  /* @__PURE__ */ ee(Vo, {}),
  "KycDAO Membership"
] }), Uye = ({
  className: e,
  animation: t,
  disabled: n = !1,
  inactive: r = !1
}) => {
  const {
    dispatch: i,
    data: { returningUserFlow: o }
  } = ln(Wn), a = qo(), s = Ja(), c = mo(), l = Le(() => {
    a(o ? Ue.subscribedStartStep : Ue.AgreementStep, Ue.kycDAOMembershipStep, "prev");
  }, [a, o]);
  Ht(() => {
    if (!n && !r) {
      const d = Za.subscribe(l);
      return d.unsubscribe.bind(d);
    }
  }, [n, r, l]);
  const u = Le(async () => {
    if (c) {
      const d = yU(
        c.kycDao.sdkStatus.availableBlockchainNetworks[0]
      );
      if (d)
        try {
          await c.kycDao.connectWallet(d), await c.kycDao.registerOrLogin(), a(Ue.verifyAccountStep, Ue.kycDAOMembershipStep), i({ type: ke.termsAcceptedChange, payload: !0 });
        } catch (h) {
          let g = "Connecting to your wallet failed, because of an error. Please try again.";
          h instanceof Xn && h.errorCode === "NetworkNotEnabled" ? g = `Please switch your wallet to ${c.kycDao.sdkStatus.availableBlockchainNetworks[0]}` : h instanceof Error && (g = `${g} (${h.message})`), s("modal", g);
        }
    }
  }, [i, c, a, s]);
  Ht(() => {
    if (!n && !r) {
      const d = Lo.subscribe(u);
      return d.unsubscribe.bind(d);
    }
  }, [n, r, u]);
  const f = Le(() => {
    !n && !r && (i({
      payload: { button: Pt.prev, state: "enabled" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: { button: Pt.next, state: "enabled" },
      type: ke.SetHeaderButtonState
    }));
  }, [n, r, i]);
  return /* @__PURE__ */ ee(
    gi,
    {
      onNext: u,
      onPrev: l,
      inactive: r,
      onTransitionDone: f,
      disabled: n,
      animation: t,
      className: e,
      onEnter: u,
      footer: Cye,
      body: Nye,
      header: jye
    }
  );
}, zye = () => /* @__PURE__ */ We(gr, { children: [
  /* @__PURE__ */ ee(Vo, {}),
  "Select your KYC NFT art"
] }), Fye = Ge.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  height: 100%;
  overflow: auto;
`, Lye = Ge.div`
  height: 150px;
  width: 150px;
  border-radius: 999rem;
  padding: 0.5em;
  box-sizing: content-box;

  ${({ selected: e }) => ir`
    border: 2px solid ${e ? "black" : "transparent"};
    box-shadow: 0 0 0 5px
      ${e ? "var(--kyc-sdk-cybergreen-35)" : "transparent"};
  `}

  &:hover {
    cursor: pointer;
    box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-35);
    border: 2px solid black;
  }

  ${Ki}
`, $ye = Ge.img`
  height: 150px;
  width: 150px;
`, Wye = ({
  className: e,
  animation: t,
  disabled: n = !1,
  inactive: r = !1
}) => {
  const {
    dispatch: i,
    data: { imageId: o }
  } = ln(Wn), a = mo(), s = sx(), [c, l] = pr(o), [u, f] = pr([]), d = Ja(), h = Le(
    (N) => () => {
      n || (l(N), i({
        payload: { button: Pt.next, state: "enabled" },
        type: ke.SetHeaderButtonState
      }));
    },
    [n, i]
  );
  Ht(() => {
    !n && !r && (a == null || a.kycDao.getNftImageOptions().then((N) => {
      const j = [];
      Object.entries(N).forEach(([K, W]) => {
        j.push({ url: W + "?timestamp=" + Date.now().toString(), id: K });
      }), f(j.slice(0, 4));
    }));
  }, [a, n, r]);
  const g = Le(async () => {
    if (c)
      if (i({ type: ke.nftImageChange, payload: c }), a != null && a.kycDao.subscribed)
        try {
          await s(c);
        } catch (N) {
          d("fatal", N);
        }
      else
        i({
          type: ke.changePage,
          payload: {
            current: Ue.mintStep,
            prev: Ue.nftArtSelection
          }
        });
  }, [
    i,
    a == null ? void 0 : a.kycDao.subscribed,
    s,
    c,
    d
  ]), w = Le(() => {
    i({
      type: ke.changePage,
      payload: {
        current: Ue.subscribedStartStep,
        next: Ue.nftArtSelection
      }
    });
  }, [i]);
  Ht(() => {
    if (!n && !r) {
      const N = Za.subscribe(w);
      return () => {
        N.unsubscribe();
      };
    }
  }, [n, r, w]), Ht(() => {
    if (!n && !r) {
      const N = Lo.subscribe(g);
      return () => {
        N.unsubscribe();
      };
    }
  }, [n, r, g]);
  const b = Le(() => {
    !n && !r && (i({
      payload: { button: Pt.prev, state: "enabled" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: {
        button: Pt.next,
        state: c ? "enabled" : "hidden"
      },
      type: ke.SetHeaderButtonState
    }));
  }, [n, r, i, c]), I = Le(() => {
    a == null || a.kycDao.regenerateNftImageOptions().then((N) => {
      const j = [];
      l(void 0), i({
        payload: { button: Pt.next, state: "hidden" },
        type: ke.SetHeaderButtonState
      }), Object.entries(N).forEach(([K, W]) => {
        j.push({ url: W + "?timestamp=" + Date.now().toString(), id: K });
      }), f(j.slice(0, 4));
    });
  }, [a == null ? void 0 : a.kycDao, i]), A = Le(
    () => /* @__PURE__ */ ee(Fye, { children: u.map(({ id: N, url: j }) => /* @__PURE__ */ ee(
      Lye,
      {
        selected: c === N,
        onClick: h(N),
        children: /* @__PURE__ */ ee($ye, { alt: "Nft", src: j })
      },
      N
    )) }),
    [u, h, c]
  ), x = Le(
    ({ disabled: N, inactive: j, onEnter: K }) => /* @__PURE__ */ We(ar, { children: [
      /* @__PURE__ */ ee(PU, { children: /* @__PURE__ */ We(
        Ya,
        {
          mode: "underline",
          inactive: j,
          disabled: N,
          fullWidth: !0,
          onClick: I,
          children: [
            /* @__PURE__ */ ee("i", { className: "material-icons", children: "refresh" }),
            /* @__PURE__ */ ee("span", { children: "regenerate" })
          ]
        }
      ) }),
      /* @__PURE__ */ ee(
        _o,
        {
          black: !0,
          fullWidth: !0,
          autoFocus: !j && !N && !!c,
          disabled: N || !c,
          onClick: K,
          inactive: j,
          label: a != null && a.kycDao.subscribed ? "Mint free kycNFT" : "Submit",
          label2: a != null && a.kycDao.subscribed ? "Mint free kycNFT" : void 0
        }
      )
    ] }),
    [c, I, a == null ? void 0 : a.kycDao.subscribed]
  );
  return a ? /* @__PURE__ */ ee(
    gi,
    {
      onPrev: w,
      inactive: r,
      disabled: n,
      onTransitionDone: b,
      animation: t,
      className: e,
      header: zye,
      body: A,
      footer: x,
      onEnter: g
    }
  ) : /* @__PURE__ */ ee(gr, { children: "Error" });
}, Kye = () => /* @__PURE__ */ We(ar, { children: [
  /* @__PURE__ */ ee(bU, { children: "Welcome back trusted anon." }),
  /* @__PURE__ */ ee(tn, { children: "You are already a member, but a smart contract requires a kycNFT on this chain." }),
  /* @__PURE__ */ ee(tn, { children: "Please go ahead and mint a free kycNFT." })
] }), Vye = () => /* @__PURE__ */ We(gr, { children: [
  /* @__PURE__ */ ee(Vo, {}),
  "Welcome back to kycDAO"
] }), qye = ({ inactive: e, disabled: t, onEnter: n }) => /* @__PURE__ */ ee(
  _o,
  {
    black: !0,
    fullWidth: !0,
    autoFocus: !e && !t,
    disabled: t,
    onClick: n,
    inactive: e,
    label: "Let's go"
  }
), Hye = ({
  className: e,
  animation: t,
  disabled: n = !1,
  inactive: r = !1
}) => {
  const { dispatch: i } = ln(Wn), o = qo(), a = mo(), s = Le(() => {
    o(Ue.nftArtSelection, Ue.subscribedStartStep);
  }, [o]), c = Le(() => {
    !n && !r && (i({
      payload: { button: Pt.prev, state: "hidden" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: { button: Pt.next, state: "enabled" },
      type: ke.SetHeaderButtonState
    }));
  }, [n, r, i]);
  return Ht(() => {
    if (!n && !r) {
      const l = Lo.subscribe(s);
      return l.unsubscribe.bind(l);
    }
  }, [n, r, i, s]), a ? /* @__PURE__ */ ee(
    gi,
    {
      onNext: s,
      onTransitionDone: c,
      disabled: n,
      className: e,
      inactive: r,
      animation: t,
      header: Vye,
      onEnter: s,
      footer: qye,
      body: Kye
    }
  ) : /* @__PURE__ */ ee(gr, { children: "Something went seriously wrong!" });
}, Gye = () => /* @__PURE__ */ We(ar, { children: [
  /* @__PURE__ */ We(gr, { children: [
    /* @__PURE__ */ ee(Vo, {}),
    "Tax residence"
  ] }),
  /* @__PURE__ */ ee(tn, { children: "Please select the country where you are currently a tax residence." })
] }), Yye = ({
  className: e,
  animation: t,
  disabled: n = !1,
  inactive: r = !1
}) => {
  const [i, o] = pr(), {
    dispatch: a,
    data: { taxResidency: s, grantFlowEnabled: c }
  } = ln(Wn), l = jo(
    () => !Rf.find((x) => x.name === i),
    [i]
  ), u = ya(s), f = ya(null), d = qo();
  Ht(() => {
    var x;
    s && o(
      ((x = Rf.find((N) => N.iso_cca2 === s)) == null ? void 0 : x.name) || ""
    );
  }, [s]);
  const h = Le(() => {
    !n && !r && (a({
      payload: { button: Pt.prev, state: "enabled" },
      type: ke.SetHeaderButtonState
    }), a({
      payload: {
        button: Pt.next,
        state: s ? "enabled" : "hidden"
      },
      type: ke.SetHeaderButtonState
    }));
  }, [r, n, a, s]), g = Le(() => {
    n || r || l || (a({
      payload: u.current,
      type: ke.taxResidenceChange
    }), d(c ? Ue.grantNameAndAddressStep : Ue.beginVerificationStep, Ue.taxResidenceStep));
  }, [n, r, l, a, c, d]), w = Le(() => {
    d(Ue.verificationStep, Ue.taxResidenceStep, "prev"), a({
      payload: u.current,
      type: ke.taxResidenceChange
    });
  }, [a, d]);
  Ht(() => {
    if (!n && !r) {
      const x = Za.subscribe(w), N = Lo.subscribe(g);
      return () => {
        x.unsubscribe(), N.unsubscribe();
      };
    }
  }, [g, n, r, w]);
  const b = jo(() => Rf.map((x) => x.name), []), I = Le((x) => {
    var N;
    u.current = ((N = Rf.find((j) => j.name === x)) == null ? void 0 : N.iso_cca2) || "", o(x);
  }, []);
  Ht(() => {
    !n && !r && a({
      type: ke.SetHeaderButtonState,
      payload: {
        button: Pt.next,
        state: l ? "hidden" : "enabled"
      }
    });
  }, [l, n, r, a]);
  const A = Le(
    ({ disabled: x, inactive: N, onEnter: j, onInputBlurred: K, onInputFocused: W }) => /* @__PURE__ */ We(ar, { children: [
      /* @__PURE__ */ ee(
        vd,
        {
          onInputBlurred: K,
          onInputFocused: W,
          inputRef: f,
          autoFocus: l && !N,
          disabled: x,
          autoCompleteData: b,
          value: i,
          placeholder: "Type your tax residence here",
          fullWidth: !0,
          onChange: I
        }
      ),
      /* @__PURE__ */ ee(
        _o,
        {
          black: !0,
          fullWidth: !0,
          inactive: N,
          autoFocus: !l && !N,
          disabled: l || x,
          onClick: j
        }
      )
    ] }),
    [l, f, b, i, I]
  );
  return /* @__PURE__ */ ee(
    gi,
    {
      onNext: g,
      onPrev: w,
      inactive: r,
      onTransitionDone: h,
      disabled: n,
      animation: t,
      className: e,
      onEnter: g,
      footer: A,
      body: Gye
    }
  );
}, Zye = ({ disabled: e, inactive: t, onEnter: n }) => /* @__PURE__ */ ee(
  _o,
  {
    black: !0,
    fullWidth: !0,
    autoFocus: !e && !t,
    disabled: e,
    inactive: t,
    onClick: n
  }
), Jye = () => /* @__PURE__ */ We(gr, { children: [
  /* @__PURE__ */ ee(Vo, {}),
  "Open account"
] }), Xye = () => /* @__PURE__ */ We(ar, { children: [
  /* @__PURE__ */ ee(tn, { children: "Our partners use 3rd party partners to collect information for verification." }),
  /* @__PURE__ */ ee(tn, { children: "During the account opening you will be asked:" }),
  /* @__PURE__ */ We(mU, { children: [
    /* @__PURE__ */ ee(pE, { children: /* @__PURE__ */ ee(tn, { children: "Government ID" }) }),
    /* @__PURE__ */ ee(pE, { children: /* @__PURE__ */ ee(tn, { children: "Selfie" }) }),
    /* @__PURE__ */ ee(pE, { children: /* @__PURE__ */ ee(tn, { children: "Tax residency" }) })
  ] })
] }), Qye = ({
  className: e,
  disabled: t = !1,
  animation: n,
  inactive: r = !1
}) => {
  const { dispatch: i } = ln(Wn), o = qo(), a = Le(() => {
    o(Ue.taxResidenceStep, Ue.verificationStep);
  }, [o]), s = Le(() => {
    o(Ue.verifyAccountStep, Ue.verificationStep, "prev");
  }, [o]);
  Ht(() => {
    if (!t && !r) {
      const l = Lo.subscribe(a);
      return l.unsubscribe.bind(l);
    }
  }, [t, r, a]), Ht(() => {
    if (!t && !r) {
      const l = Za.subscribe(s);
      return l.unsubscribe.bind(l);
    }
  }, [t, r, s]);
  const c = Le(() => {
    !t && !r && (i({
      payload: { button: Pt.prev, state: "enabled" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: { button: Pt.next, state: "enabled" },
      type: ke.SetHeaderButtonState
    }));
  }, [t, i, r]);
  return /* @__PURE__ */ ee(
    gi,
    {
      onPrev: s,
      onNext: a,
      onTransitionDone: c,
      inactive: r,
      disabled: t,
      animation: n,
      className: e,
      onEnter: a,
      footer: Zye,
      body: Xye,
      header: Jye
    }
  );
}, e0e = () => /* @__PURE__ */ We(ar, { children: [
  /* @__PURE__ */ ee(tn, { children: "kycDao offers an annual membership to verified account holders to use kycNFTs across the ecosystem." }),
  /* @__PURE__ */ ee(tn, { children: "Set the initial length of your membership and mint kycNFTs for free on all supported chains." })
] }), t0e = () => /* @__PURE__ */ We(gr, { children: [
  /* @__PURE__ */ ee(Vo, {}),
  "Mint membership"
] }), n0e = ({
  children: e
}) => /* @__PURE__ */ ee("i", { className: "material-icons", children: e }), YB = Ge(n0e)`
  line-height: 2em;
`, r0e = Ge.div`
  align-items: center;

  p {
    font-family: var(--kyc-sdk-primary-font);
  }
`, i0e = Ge.div`
  display: flex;
  flex-flow: column;
  flex-direction: column;

  & > div {
    justify-content: space-evenly;
    flex-direction: row;
    display: flex;
    margin-bottom: 1em;
  }
`, ZB = Ge(Ya)`
  margin-block: auto;
  line-height: 2em;
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
  width: 3em;
  height: 3em;

  //background: rgb(0, 0, 0, 0);
  background: black;
  border: 2px black solid;

  span {
    color: white;

    i {
      vertical-align: middle;
    }
  }

  &:hover {
    box-shadow: 0 0 0 0px var(--kyc-sdk-cybergreen-35);
    background: var(--kyc-sdk-cybergreen);

    span {
      color: black;
    }

    &:focus {
      span {
        color: black;
      }
    }
  }

  &:focus {
    box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-35);

    span {
      color: white;
    }
  }

  &:active {
    background: var(--kyc-sdk-cybergreen);
    border: 2px solid var(--kyc-sdk-cybergreen);
    box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-35);
  }

  &:focus-visible {
    outline: none;
    border: none;
  }
`, o0e = Ge.div`
  align-items: center;
  justify-content: center;
`, a0e = Ge.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
`, BU = Ge.span`
  color: black;
  font-size: 12pt;
  font-weight: 800;
  font-family: var(--kyc-sdk-primary-font);
  -webkit-font-smoothing: antialiased;
`, s0e = Ge(BU)`
  text-decoration: line-through;
  font-weight: 500;
  margin-left: 0.5rem;
`;
Ge.div`
  color: black;
  font-size: 12px;
  display: flex;
  margin-bottom: 1em;
  font-family: var(--kyc-sdk-primary-font);

  padding: 0.5rem;
  background: var(--kyc-sdk-cybergreen-35);
  border-radius: 4px;
  align-items: center;

  i {
    margin-left: -2px;
    margin-right: 2px;
  }

  p {
    display: flex;
    font-size: 12px;
    padding-right: 3px;

    > strong {
      padding-right: 3px;
      color: black;
      font-weight: 800;
    }
  }
`;
const c0e = Ge.div`
  padding: 1rem;
  font-size: 12pt;
  width: 10rem;
  text-align: center;
  font-family: var(--kyc-sdk-primary-font);
  -webkit-font-smoothing: antialiased;
  color: black;
  display: flex;
  align-items: center;
  margin-block: auto;
  flex: 1;
  justify-content: center;
`, u0e = (e) => {
  if (e === 1)
    return 0;
  const t = 5, r = e - 1;
  return t * r;
}, l0e = (e) => e * 5, f0e = ({
  className: e,
  animation: t,
  disabled: n = !1,
  inactive: r = !1
}) => {
  const {
    dispatch: i,
    data: { imageId: o }
  } = ln(Wn), a = mo(), s = qo(), [c, l] = pr(1), u = sx(), f = Ja(), d = Le(async () => {
    if (a && c && c > 0 && o) {
      i({
        payload: c,
        type: ke.subscriptionYearsChange
      });
      try {
        await u(o, c);
      } catch (A) {
        f("minting", A);
      }
    }
  }, [a, c, u, i, o, f]), h = Le(() => {
    !n && !r && (i({
      payload: { button: Pt.prev, state: "enabled" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: { button: Pt.next, state: "hidden" },
      type: ke.SetHeaderButtonState
    }));
  }, [n, r, i]);
  Ht(() => {
    if (!n && !r) {
      const A = Lo.subscribe(d);
      return A.unsubscribe.bind(A);
    }
  }, [n, r, d]), Ht(() => {
    !n && !r && c && c > 0 && i({
      payload: { button: Pt.next, state: "enabled" },
      type: ke.SetHeaderButtonState
    }), (n || r || c === null) && i({
      payload: { button: Pt.next, state: "hidden" },
      type: ke.SetHeaderButtonState
    });
  }, [n, r, c, i]);
  const g = Le(() => {
    l((A) => A ? ++A : 1);
  }, []), w = Le(() => {
    l((A) => A && (A > 1 ? --A : 1));
  }, []), b = Le(() => {
    s(Ue.nftArtSelection, Ue.mintStep, "prev");
  }, [s]);
  Ht(() => {
    if (!n && !r) {
      const A = Za.subscribe(b);
      return () => {
        A.unsubscribe();
      };
    }
  }, [n, r, b]);
  const I = Le(
    ({ disabled: A, inactive: x, onEnter: N }) => /* @__PURE__ */ We(ar, { children: [
      /* @__PURE__ */ We(r0e, { children: [
        /* @__PURE__ */ ee(tn, { children: "Membership period:" }),
        /* @__PURE__ */ ee(i0e, { children: /* @__PURE__ */ We(o0e, { children: [
          /* @__PURE__ */ ee(
            ZB,
            {
              mode: "clean",
              disabled: A || c === null || c === 1,
              className: "square",
              onClick: w,
              children: /* @__PURE__ */ ee(YB, { children: "remove" })
            }
          ),
          /* @__PURE__ */ We(c0e, { children: [
            c,
            " year"
          ] }),
          /* @__PURE__ */ ee(
            ZB,
            {
              mode: "clean",
              disabled: A,
              className: "square",
              onClick: g,
              children: /* @__PURE__ */ ee(YB, { children: "add" })
            }
          ),
          /* @__PURE__ */ We(a0e, { children: [
            /* @__PURE__ */ We(BU, { children: [
              "$",
              u0e(c)
            ] }),
            /* @__PURE__ */ We(s0e, { children: [
              "$",
              l0e(c)
            ] })
          ] })
        ] }) })
      ] }),
      !1,
      /* @__PURE__ */ ee(
        _o,
        {
          black: !0,
          fullWidth: !0,
          autoFocus: !x && !A && !c,
          disabled: A || !c || c === 0,
          onClick: N,
          inactive: x,
          label: "Pay + mint",
          label2: "Pay + mint"
        }
      )
    ] }),
    [w, g, c]
  );
  return a ? /* @__PURE__ */ ee(
    gi,
    {
      onNext: d,
      onTransitionDone: h,
      disabled: n,
      className: e,
      inactive: r,
      animation: t,
      header: t0e,
      onEnter: d,
      footer: I,
      body: e0e
    }
  ) : /* @__PURE__ */ ee(gr, { children: "Error" });
}, CU = bI(() => {
}), d0e = ({
  disabled: e = !1,
  ...t
}) => {
  const {
    data: { errorModalBody: n, errorModalHeader: r },
    dispatch: i
  } = ln(Wn), o = ln(CU), a = () => /* @__PURE__ */ ee(gr, { children: r || "Something went wrong!" }), s = Le(() => {
    o();
  }, [o]);
  Ht(() => {
    i({
      type: ke.SetHeaderButtonState,
      payload: { button: Pt.close, state: "enabled" }
    }), i({
      type: ke.SetHeaderButtonState,
      payload: { button: Pt.next, state: "hidden" }
    }), i({
      type: ke.SetHeaderButtonState,
      payload: { button: Pt.prev, state: "hidden" }
    });
  }, [i]);
  const c = Le(
    () => /* @__PURE__ */ ee("div", { role: "alert", children: /* @__PURE__ */ ee(tn, { children: n || "An unknown, fatal error happened!" }) }),
    [n]
  ), l = Le(
    () => /* @__PURE__ */ We(Ya, { mode: "underline", onClick: s, children: [
      /* @__PURE__ */ ee("i", { className: "material-icons", children: "refresh" }),
      /* @__PURE__ */ ee("span", { children: " Retry" })
    ] }),
    [s]
  );
  return /* @__PURE__ */ ee(
    gi,
    {
      ...t,
      disabled: e,
      footer: l,
      header: a,
      body: c
    }
  );
}, h0e = () => /* @__PURE__ */ We(ar, { children: [
  /* @__PURE__ */ We(gr, { children: [
    /* @__PURE__ */ ee(Vo, {}),
    "Name and address"
  ] }),
  /* @__PURE__ */ ee(tn, { children: "Please share your name and current address below." })
] });
let wE = !1;
const p0e = ({
  className: e,
  animation: t,
  disabled: n = !1,
  inactive: r = !1
}) => {
  var K;
  const {
    dispatch: i,
    data: { grantFlow: o }
  } = ln(Wn), a = qo(), s = mo(), [c, l] = pr(o.name), [u, f] = pr(o.address), d = jo(
    () => !!c && !!u,
    [c, u]
  ), [h, g] = pr(!1), [w, b] = pr(!1), I = Le(() => {
    var W;
    wE || (wE = !0, window.ethereum.request({
      method: "personal_sign",
      params: [
        aD(
          "Grant officers will be able to decrypt and view your data. kycDAO does not have access to this data.",
          { addPrefix: !0 }
        ),
        (W = s == null ? void 0 : s.kycDao.connectedWallet) == null ? void 0 : W.address
      ]
    }).then(() => {
      b(!0);
    }).catch(() => {
      a(
        Ue.taxResidenceStep,
        Ue.grantNameAndAddressStep,
        "prev"
      );
    }).finally(() => {
      wE = !1;
    }));
  }, [(K = s == null ? void 0 : s.kycDao.connectedWallet) == null ? void 0 : K.address, a]);
  Ht(() => {
    I();
  }, [I]);
  const A = Le(() => {
    n || r || (i({
      payload: { button: Pt.prev, state: "enabled" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: {
        button: Pt.next,
        state: o.name && o.address ? "enabled" : "hidden"
      },
      type: ke.SetHeaderButtonState
    }));
  }, [r, n, i, o]), x = Le(() => {
    n || r || !d || a(
      Ue.grantSocialSecurityNumberStep,
      Ue.grantNameAndAddressStep
    );
  }, [n, r, d, a]), N = Le(() => {
    a(Ue.taxResidenceStep, Ue.grantNameAndAddressStep, "prev");
  }, [a]);
  Ht(() => {
    i({
      type: ke.grantNameAndAddressChange,
      payload: {
        name: c,
        address: u
      }
    });
  }, [c, u, i]), Ht(() => {
    if (!n && !r) {
      const W = Za.subscribe(N), O = Lo.subscribe(x);
      return () => {
        W.unsubscribe(), O.unsubscribe();
      };
    }
  }, [x, n, r, N]);
  const j = Le(
    ({ disabled: W, inactive: O, onEnter: k, onInputBlurred: z, onInputFocused: C }) => /* @__PURE__ */ We(ar, { children: [
      /* @__PURE__ */ ee(
        vd,
        {
          onInputBlurred: z,
          onInputFocused: C,
          disabled: W,
          value: c,
          placeholder: "Name",
          fullWidth: !0,
          onChange: (M) => {
            l(M), g(!0);
          },
          style: { marginBottom: "0" },
          autoFocus: !d && !h && !O
        }
      ),
      /* @__PURE__ */ ee(
        vd,
        {
          disabled: W,
          value: u,
          placeholder: "Address",
          fullWidth: !0,
          onChange: (M) => {
            f(M), g(!0);
          }
        }
      ),
      /* @__PURE__ */ ee(
        _o,
        {
          black: !0,
          fullWidth: !0,
          inactive: O,
          disabled: W || !d || !w,
          onClick: k,
          autoFocus: d && !h && !O
        }
      )
    ] }),
    [u, h, w, d, c]
  );
  return /* @__PURE__ */ ee(
    gi,
    {
      onNext: x,
      onPrev: N,
      inactive: r,
      onTransitionDone: A,
      disabled: n,
      animation: t,
      className: e,
      onEnter: x,
      footer: j,
      body: h0e
    }
  );
}, y0e = () => /* @__PURE__ */ We(ar, { children: [
  /* @__PURE__ */ We(gr, { children: [
    /* @__PURE__ */ ee(Vo, {}),
    "Social Security Number - SSN"
  ] }),
  /* @__PURE__ */ ee(tn, { children: "Please share your Social Security Number." })
] }), g0e = ({
  className: e,
  animation: t,
  disabled: n = !1,
  inactive: r = !1
}) => {
  const {
    dispatch: i,
    data: { grantFlow: o }
  } = ln(Wn), a = qo(), [s, c] = pr(o.socialSecurityNumber), l = jo(
    () => !!s,
    [s]
  ), [u, f] = pr(!1), d = Le(() => {
    !n && !r && (i({
      payload: { button: Pt.prev, state: "enabled" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: {
        button: Pt.next,
        state: o.socialSecurityNumber ? "enabled" : "hidden"
      },
      type: ke.SetHeaderButtonState
    }));
  }, [r, n, i, o]), h = Le(() => {
    n || r || !l || a(Ue.beginVerificationStep, Ue.grantSocialSecurityNumberStep);
  }, [n, r, l, a]), g = Le(() => {
    a(
      Ue.grantNameAndAddressStep,
      Ue.grantSocialSecurityNumberStep,
      "prev"
    );
  }, [a]);
  Ht(() => {
    i({
      type: ke.grantSocialSecurityNumberChange,
      payload: s
    });
  }, [s, i]), Ht(() => {
    if (!n && !r) {
      const b = Za.subscribe(g), I = Lo.subscribe(h);
      return () => {
        b.unsubscribe(), I.unsubscribe();
      };
    }
  }, [h, n, r, g]);
  const w = Le(
    ({ disabled: b, inactive: I, onEnter: A, onInputBlurred: x, onInputFocused: N }) => /* @__PURE__ */ We(ar, { children: [
      /* @__PURE__ */ ee(
        vd,
        {
          onInputBlurred: x,
          onInputFocused: N,
          disabled: b,
          value: s,
          placeholder: "Social Security Number",
          autoFocus: !l && !u && !I,
          fullWidth: !0,
          onChange: (j) => {
            c(j), f(!0);
          }
        }
      ),
      /* @__PURE__ */ ee(
        _o,
        {
          black: !0,
          fullWidth: !0,
          inactive: I,
          autoFocus: l && !u && !I,
          disabled: b || !l,
          onClick: A
        }
      )
    ] }),
    [s, l, u]
  );
  return /* @__PURE__ */ ee(
    gi,
    {
      onNext: h,
      onPrev: g,
      inactive: r,
      onTransitionDone: d,
      disabled: n,
      animation: t,
      className: e,
      onEnter: h,
      footer: w,
      body: y0e
    }
  );
}, b0e = Ge.div`
  padding-bottom: 1em;
`;
function m0e({
  items: e,
  onChange: t,
  renderItem: n,
  keyExtractor: r,
  disabledCheck: i
}) {
  const o = Le(
    (a) => () => {
      t(a);
    },
    [t]
  );
  return /* @__PURE__ */ ee("div", { children: e.map((a) => /* @__PURE__ */ ee(
    b0e,
    {
      onClick: i(a) ? void 0 : o(r(a)),
      children: n(a)
    },
    r(a)
  )) });
}
function _0e() {
  const e = mo();
  return () => {
    if (e)
      return e.kycDao.checkVerificationStatus().then((t) => Object.entries(t).reduce(
        (n, [, r]) => r ? !0 : n,
        !1
      )).catch((t) => {
        console.log(t);
      });
    throw new Error(
      "Kycdao should be defined. How this is possyble? Check useVerified()"
    );
  };
}
const w0e = /* @__PURE__ */ We(
  "svg",
  {
    width: "63.999996",
    height: "63.999996",
    viewBox: "0 0 16.933332 16.933332",
    version: "1.1",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ ee("defs", { id: "defs2" }),
      /* @__PURE__ */ We("g", { id: "layer1", children: [
        /* @__PURE__ */ ee(
          "rect",
          {
            style: {
              display: "inline",
              opacity: 1,
              fill: "#00ffb3",
              fillOpacity: 1,
              stroke: "none",
              strokeWidth: 1
            },
            id: "rect3300",
            width: "16.933332",
            height: "16.933332",
            x: "0",
            y: "8.9009603e-07",
            rx: "0.79374999",
            ry: "0.79374999"
          }
        ),
        /* @__PURE__ */ ee(
          "text",
          {
            xmlSpace: "preserve",
            style: {
              fontStyle: "normal",
              fontVariant: "normal",
              fontWeight: "normal",
              fontStretch: "normal",
              fontSize: "4.7625px",
              fontFamily: "neue-machina",
              display: "inline",
              opacity: 1,
              fill: "#000000",
              fillOpacity: 1,
              stroke: "none",
              strokeWidth: 1
            },
            x: "4.1215825",
            y: "10.24214",
            id: "text3362",
            children: /* @__PURE__ */ ee(
              "tspan",
              {
                id: "tspan3360",
                style: { fill: "#000000", strokeWidth: 1 },
                x: "4.1215825",
                y: "10.24214",
                children: "Veri"
              }
            )
          }
        )
      ] })
    ]
  }
), vE = /* @__PURE__ */ ee(
  "svg",
  {
    width: "64",
    height: "64",
    version: "1.1",
    viewBox: "0 0 16.933 16.933",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ ee("g", { fill: "#666", children: /* @__PURE__ */ ee(
      "rect",
      {
        y: "8.901e-7",
        width: "16.933",
        height: "16.933",
        rx: ".79375",
        ry: ".79375",
        fill: "#d9d9d9"
      }
    ) })
  }
), v0e = ({ disabled: e, inactive: t, onEnter: n }) => /* @__PURE__ */ ee(
  _o,
  {
    black: !0,
    fullWidth: !0,
    autoFocus: !e && !t,
    disabled: e,
    inactive: t,
    onClick: n
  }
), S0e = () => /* @__PURE__ */ We(gr, { children: [
  /* @__PURE__ */ ee(Vo, {}),
  "Verify account"
] }), E0e = Ge.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 2em;
  margin-block: auto;
  border: 2px solid transparent;
  border-radius: 6px;

  ${({ disabled: e }) => !e && ir`
      &:hover {
        cursor: pointer;
        box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-35);
        border: 2px solid black;
      }
    `}

  ${({ selected: e }) => e && ir`
       {
        cursor: pointer;
        box-shadow: 0 0 0 5px var(--kyc-sdk-cybergreen-35);
        border: 2px solid black;
      }
    `}
`, A0e = Ge.div`
  width: 64px;
  height: 64px;
`, I0e = Ge(tn)`
  margin-block: auto;
  min-width: 50%;
  margin-inline-start: 1em;
  ${({ comingSoon: e }) => e && ir`
      text-shadow: 0 0 12px black;
      color: transparent !important;
    `};
`, k0e = Ge(tn)`
  border: solid 2px black;
  border-radius: 3px;
  margin-block: auto;
  padding: 0.5em;
`;
function T0e({
  icon: e,
  id: t,
  label: n,
  onClick: r,
  comingSoon: i,
  disabled: o,
  selected: a
}) {
  const s = Le(() => r && r(t), [t, r]);
  return /* @__PURE__ */ We(
    E0e,
    {
      selected: a,
      disabled: o || i,
      onClick: s,
      children: [
        /* @__PURE__ */ ee(A0e, { children: e }),
        /* @__PURE__ */ ee(I0e, { comingSoon: i, children: n }),
        i && /* @__PURE__ */ ee(k0e, { children: "soon" })
      ]
    }
  );
}
const x0e = [
  {
    icon: w0e,
    id: "verilabs",
    label: "VeriLabs"
  },
  {
    icon: vE,
    id: "soon1",
    label: "Are you really",
    comingSoon: !0
  },
  {
    icon: vE,
    id: "soon2",
    label: "this curius,",
    comingSoon: !0
  },
  {
    icon: vE,
    id: "soon3",
    label: "aren't you? 🥚👀",
    comingSoon: !0
  }
], M0e = ({
  className: e,
  disabled: t = !1,
  animation: n,
  inactive: r = !1
}) => {
  const {
    dispatch: i,
    data: { returningUserFlow: o, isEmailConfirmed: a }
  } = ln(Wn), s = qo(), c = _0e(), l = Ja(), u = Le(() => {
    if (o)
      s(Ue.nftArtSelection, Ue.verifyAccountStep);
    else
      try {
        (async function() {
          await c() ? (i({
            payload: !0,
            type: ke.termsAcceptedChange
          }), s(Ue.nftArtSelection, Ue.verifyAccountStep)) : a ? (i({
            payload: !0,
            type: ke.termsAcceptedChange
          }), s(Ue.verificationStep, Ue.verifyAccountStep)) : (i({
            payload: !0,
            type: ke.termsAcceptedChange
          }), s(
            Ue.emailDiscordVerificationStep,
            Ue.verifyAccountStep
          ));
        })();
      } catch (b) {
        l("fatal", b);
      }
  }, [
    s,
    o,
    c,
    i,
    l,
    a
  ]), f = Le(() => {
    s(Ue.kycDAOMembershipStep, Ue.verifyAccountStep, "prev");
  }, [s, o]), [d, h] = pr("verilabs"), g = Le(() => /* @__PURE__ */ We(ar, { children: [
    /* @__PURE__ */ ee(tn, { children: "Log-in to your existing account or onboard with one of our partners." }),
    /* @__PURE__ */ ee(
      m0e,
      {
        current: d,
        onChange: h,
        items: x0e,
        keyExtractor: (b) => b.id,
        disabledCheck: (b) => b.disabled || b.comingSoon,
        renderItem: (b) => T0e({
          ...b,
          selected: d === b.id,
          disabled: b.disabled
        })
      }
    )
  ] }), [d]);
  Ht(() => {
    if (!t && !r) {
      const b = Lo.subscribe(u);
      return b.unsubscribe.bind(b);
    }
  }, [t, r, u]), Ht(() => {
    if (!t && !r) {
      const b = Za.subscribe(f);
      return b.unsubscribe.bind(b);
    }
  }, [t, r, f]);
  const w = Le(() => {
    !t && !r && (i({
      payload: { button: Pt.prev, state: "enabled" },
      type: ke.SetHeaderButtonState
    }), i({
      payload: { button: Pt.next, state: "enabled" },
      type: ke.SetHeaderButtonState
    }));
  }, [t, i, r]);
  return /* @__PURE__ */ ee(
    gi,
    {
      onPrev: f,
      onNext: u,
      onTransitionDone: w,
      inactive: r,
      disabled: t,
      animation: n,
      className: e,
      onEnter: u,
      footer: v0e,
      body: g,
      header: S0e
    }
  );
}, O0e = Ge.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  position: absolute;
  height: 100%;
  top: 0;
`, SE = ({ stepID: e, ...t }) => {
  switch (e) {
    case Ue.verifyAccountStep:
      return /* @__PURE__ */ ee(M0e, { ...t });
    case Ue.AgreementStep:
      return /* @__PURE__ */ ee(hye, { ...t });
    case Ue.kycDAOMembershipStep:
      return /* @__PURE__ */ ee(Uye, { ...t });
    case Ue.verificationStep:
      return /* @__PURE__ */ ee(Qye, { ...t });
    case Ue.emailDiscordVerificationStep:
      return /* @__PURE__ */ ee(Eye, { ...t });
    case Ue.taxResidenceStep:
      return /* @__PURE__ */ ee(Yye, { ...t });
    case Ue.grantNameAndAddressStep:
      return /* @__PURE__ */ ee(p0e, { ...t });
    case Ue.grantSocialSecurityNumberStep:
      return /* @__PURE__ */ ee(g0e, { ...t });
    case Ue.beginVerificationStep:
      return /* @__PURE__ */ ee(pye, { ...t });
    case Ue.nftArtSelection:
      return /* @__PURE__ */ ee(Wye, { ...t });
    case Ue.finalStep:
      return /* @__PURE__ */ ee(Mye, { ...t });
    case Ue.loading:
      return /* @__PURE__ */ ee(Bye, { ...t });
    case Ue.mintStep:
      return /* @__PURE__ */ ee(f0e, { ...t });
    case Ue.subscribedStartStep:
      return /* @__PURE__ */ ee(Hye, { ...t });
    case Ue.fatalError:
    default:
      return /* @__PURE__ */ ee(d0e, { ...t });
  }
};
function P0e(e, t) {
  return e ? "moving-in" : t ? "moving-out" : "moving-center";
}
const B0e = {
  from: "moving-center",
  to: "moving-out"
}, C0e = {
  from: "moving-center",
  to: "moving-in"
}, JB = () => {
  const {
    data: { prevPage: e, nextPage: t, currentPage: n, currentModal: r }
  } = ln(Wn), i = jo(() => e || t ? {
    to: "moving-center",
    from: P0e(e, t)
  } : void 0, [t, e]);
  return /* @__PURE__ */ We(O0e, { children: [
    e && /* @__PURE__ */ ee(
      SE,
      {
        stepID: e,
        animation: B0e,
        inactive: !0
      }
    ),
    /* @__PURE__ */ ee(
      SE,
      {
        stepID: n,
        animation: i,
        inactive: !!r,
        disabled: !!r
      }
    ),
    t && /* @__PURE__ */ ee(
      SE,
      {
        stepID: t,
        animation: C0e,
        inactive: !0
      }
    )
  ] });
}, D0e = function({
  config: t,
  isModal: n,
  iframeOptions: r,
  onReady: i,
  messageTargetOrigin: o
}) {
  var f;
  const [a, s] = WU(gz, C3), c = jo(() => ({ data: a, dispatch: s }), [a, s]), [l, u] = pr();
  return Ht(() => {
    s({
      payload: o,
      type: ke.setMessageTargetOrigin
    });
  }, [s, o]), Ht(() => {
    l && (async () => {
      var d, h, g, w;
      try {
        await l.kycDao.connectWallet(
          yU(t.enabledBlockchainNetworks[0])
        ), s({
          type: ke.setModalMode,
          payload: n
        });
        const b = await (l == null ? void 0 : l.kycDao.checkEmailConfirmed());
        if (s({
          type: ke.setEmailConfirmed,
          payload: !!b.isConfirmed
        }), b.address && s({
          type: ke.emailChange,
          payload: b.address
        }), await l.kycDao.hasValidNft("KYC") && l.redirectEvent !== "NearMint") {
          s({
            payload: {
              current: Ue.finalStep,
              prev: Ue.loading
            },
            type: ke.changePage
          }), s({
            payload: !0,
            type: ke.SetProcessSucess
          }), s({
            payload: !0,
            type: ke.SetAlreadyHaveAnNftOnThisChain
          });
          return;
        }
        await l.kycDao.registerOrLogin();
        let A = Ue.AgreementStep;
        if (l.redirectEvent)
          switch (s({
            type: ke.termsAcceptedChange,
            payload: !0
          }), l.redirectEvent) {
            case "NearLogin":
              A = Ue.AgreementStep;
              break;
            case "NearUserRejectedError":
              window.parent.postMessage(
                {
                  type: "kycDaoCloseModal"
                },
                o
              );
              return;
            case "NearMint":
              s({
                type: ke.SetNearMinted,
                payload: !0
              }), (d = l.mintingResult) != null && d.transactionUrl && s({
                type: ke.setChainExplorerUrl,
                payload: ((h = l.mintingResult) == null ? void 0 : h.transactionUrl) || ""
              }), (g = l.mintingResult) != null && g.imageUrl && s({
                type: ke.setNftImageUrl,
                payload: (w = l.mintingResult) == null ? void 0 : w.imageUrl
              }), A = Ue.finalStep;
          }
        else {
          const { subscribed: x } = l.kycDao;
          x && s({
            payload: !0,
            type: ke.SetReturnUserFlow
          }), A = x ? Ue.subscribedStartStep : Ue.AgreementStep;
        }
        s({
          payload: { current: A, prev: Ue.loading },
          type: ke.changePage
        }), n || s({
          type: ke.SetHeaderButtonState,
          payload: { button: Pt.close, state: "hidden" }
        });
      } catch (b) {
        RE(
          "fatal",
          b,
          s,
          Ue.loading,
          o
        );
      }
    })();
  }, [
    l,
    r,
    n,
    t.enabledBlockchainNetworks,
    o
  ]), Ht(() => {
    Hn.initialize(t).then((d) => {
      u(d), i && i(d);
    }).catch((d) => {
      RE(
        "fatal",
        d,
        s,
        Ue.loading,
        o
      );
    });
  }, [t, i, o]), Ht(() => {
    if (n) {
      const d = yz.subscribe(() => {
        var h;
        a.isProcessSuccess ? window.parent.postMessage(
          {
            type: "kycDaoSuccess",
            data: a.alreadyHaveAnNftOnThisChain && !a.nearMinted ? `Already has an nft on ${(h = l == null ? void 0 : l.kycDao.connectedWallet) == null ? void 0 : h.blockchainNetwork}.` : a.chainExplorerUrl
          },
          o
        ) : window.parent.postMessage(
          { type: "kycDaoCloseModal" },
          o
        );
      });
      return d.unsubscribe.bind(d);
    }
  }, [
    a.chainExplorerUrl,
    a.isProcessSuccess,
    o,
    a.nearMinted,
    n,
    (f = l == null ? void 0 : l.kycDao.connectedWallet) == null ? void 0 : f.blockchainNetwork,
    a.alreadyHaveAnNftOnThisChain
  ]), l ? /* @__PURE__ */ ee(cx, { children: /* @__PURE__ */ ee(wx, { children: /* @__PURE__ */ ee(AU.Provider, { value: l, children: /* @__PURE__ */ We(Wn.Provider, { value: c, children: [
    /* @__PURE__ */ ee(LB, {}),
    /* @__PURE__ */ ee(JB, {}),
    /* @__PURE__ */ ee(WB, {})
  ] }) }) }) }) : /* @__PURE__ */ ee(cx, { children: /* @__PURE__ */ ee(wx, { children: /* @__PURE__ */ We(Wn.Provider, { value: c, children: [
    /* @__PURE__ */ ee(LB, {}),
    /* @__PURE__ */ ee(JB, {}),
    /* @__PURE__ */ ee(WB, {})
  ] }) }) });
}, R0e = t3(D0e), XB = "data:font/woff2;base64,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", N0e = E3`
  @font-face {
    font-family: 'neue-machina';
    src: url(${XB}) format('woff2'),
    url(${XB}) format('woff');
    font-weight: 400;
    font-style: normal;
  }
`, DU = (e) => {
  Ht(() => {
    e.iframeOptions && "virtualKeyboard" in navigator && (navigator.virtualKeyboard.overlaysContent = !0);
  }, [e.iframeOptions]);
  const t = jo(
    () => {
      var o;
      return ((o = e.iframeOptions) == null ? void 0 : o.messageTargetOrigin) || window.location.origin;
    },
    [e.iframeOptions]
  ), [n, r] = pr(Date.now()), i = Le(() => {
    r(Date.now());
  }, []);
  return /* @__PURE__ */ We(CU.Provider, { value: i, children: [
    /* @__PURE__ */ ee(
      R0e,
      {
        messageTargetOrigin: t,
        ...e
      },
      n
    ),
    /* @__PURE__ */ ee(N0e, {})
  ] });
};
function gI(e, t) {
  return gI = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, gI(e, t);
}
function j0e(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, gI(e, t);
}
var U0e = function(t, n) {
  return t === void 0 && (t = []), n === void 0 && (n = []), t.length !== n.length || t.some(function(r, i) {
    return !Object.is(r, n[i]);
  });
}, QB = {
  error: null
}, RU = /* @__PURE__ */ function(e) {
  j0e(t, e);
  function t() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return r = e.call.apply(e, [this].concat(o)) || this, r.state = QB, r.resetErrorBoundary = function() {
      for (var s, c = arguments.length, l = new Array(c), u = 0; u < c; u++)
        l[u] = arguments[u];
      r.props.onReset == null || (s = r.props).onReset.apply(s, l), r.reset();
    }, r;
  }
  t.getDerivedStateFromError = function(i) {
    return {
      error: i
    };
  };
  var n = t.prototype;
  return n.reset = function() {
    this.setState(QB);
  }, n.componentDidCatch = function(i, o) {
    var a, s;
    (a = (s = this.props).onError) == null || a.call(s, i, o);
  }, n.componentDidUpdate = function(i, o) {
    var a = this.state.error, s = this.props.resetKeys;
    if (a !== null && o.error !== null && U0e(i.resetKeys, s)) {
      var c, l;
      (c = (l = this.props).onResetKeysChange) == null || c.call(l, i.resetKeys, s), this.reset();
    }
  }, n.render = function() {
    var i = this.state.error, o = this.props, a = o.fallbackRender, s = o.FallbackComponent, c = o.fallback;
    if (i !== null) {
      var l = {
        error: i,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (/* @__PURE__ */ gc.isValidElement(c))
        return c;
      if (typeof a == "function")
        return a(l);
      if (s)
        return /* @__PURE__ */ gc.createElement(s, l);
      throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return this.props.children;
  }, t;
}(gc.Component);
window.Buffer || (window.Buffer = Tz.Buffer);
function z0e({
  parent: e,
  ...t
}) {
  const n = _I(
    typeof e == "string" ? document.querySelector(e) : e
  ), r = OU(
    window.location.origin
  );
  n.render(
    /* @__PURE__ */ ee(RU, { FallbackComponent: r, children: /* @__PURE__ */ ee(DU, { ...t }) })
  );
}
const F0e = {
  ethereum: window.ethereum
};
function L0e({
  parent: e
}) {
  const t = _I(
    typeof e == "string" ? document.querySelector(e) : e
  ), n = [
    ...new URLSearchParams(window.location.search).entries()
  ].reduce((g, { 0: w, 1: b }) => (g[w] = b.match(/\[.*\]/) ? JSON.parse(b) : b, g), {});
  if (!n.messageTargetOrigin)
    throw new Error(
      "You need to give the messageTargetOrigin, if you want to use the page in an iframe!"
    );
  if (!n.baseUrl)
    throw new Error(
      "You need to give the baseUrl, if you want to use the page in an iframe!"
    );
  if (!n.enabledVerificationTypes)
    throw new Error(
      "You need to give the enabledVerificationTypes, if you want to use the page in an iframe!"
    );
  if (!n.enabledBlockchainNetworks)
    throw new Error(
      "You need to give the enabledBlockchainNetworks, if you want to use the page in an iframe!"
    );
  const {
    apiKey: r,
    baseUrl: i,
    demoMode: o,
    enabledBlockchainNetworks: a,
    enabledVerificationTypes: s,
    environment: c,
    height: l,
    messageTargetOrigin: u,
    width: f,
    evmProvider: d
  } = n, h = OU(u);
  t.render(
    /* @__PURE__ */ ee(RU, { FallbackComponent: h, children: /* @__PURE__ */ ee(
      DU,
      {
        config: {
          baseUrl: i,
          enabledVerificationTypes: s,
          apiKey: r,
          demoMode: o,
          enabledBlockchainNetworks: a,
          environment: c,
          evmProvider: d ? F0e[d] : void 0
        },
        iframeOptions: {
          messageTargetOrigin: u
        },
        height: l,
        width: f,
        isModal: !0
      }
    ) })
  );
}
const $0e = "Wallet callback handling error", e3 = {
  account_id: "NearLogin",
  errorCode: "NearUserRejectedError",
  transactionHashes: "NearMint"
}, W0e = /Near*./g, K0e = `
	.KycDaoModalRoot {
		width: 100%;
		position: absolute;
		inset: 0;
		background: var(--kyc-dao-backdrop);
	}

	.KycDaoModalFrame {
		box-shadow: 0px 1px 174px rgba(59, 31, 69, 0.2);
		width: 100%;
		height: 100%;
		background-color: #fefefe;
		position: absolute;
		overflow: hidden;
	}

	@media only screen and (max-width: 992px) {
		body:has(.KycDaoModalRoot) {
			overflow: hidden;
		}
		.KycDaoModalRoot {
			position: fixed;
		}
	}

	@media only screen and (min-width: 992px) {
		.KycDaoModalFrame {
			width: var(--width);
			height: var(--height);
			margin: auto;
			border-radius: 12px;
			overflow: hidden;
			inset: 0;
		}

		.KycDaoModalRoot {
			position: fixed;
			overflow: hidden;
			height: 100vh;
		}
	}
`.replace(/\t|\n*/gm, ""), NU = document.createElement("style");
NU.innerText = K0e;
document.head.appendChild(NU);
class jU {
  constructor({
    height: t = "650px",
    width: n = "400px",
    parent: r = document.body,
    onFail: i,
    onSuccess: o,
    config: a,
    configFromUrl: s = !1,
    backdrop: c = !0,
    modal: l = !0,
    onReady: u
  }) {
    ri(this, "height");
    ri(this, "width");
    ri(this, "parent", document.body);
    ri(this, "onFail");
    ri(this, "onSuccess");
    ri(this, "config");
    ri(this, "configFromUrl", !1);
    ri(this, "backdrop", !0);
    ri(this, "modal");
    ri(this, "onReady");
    ri(this, "isOpen", !1);
    ri(this, "isSuccessful", !1);
    ri(this, "isModal", !1);
    ri(this, "container");
    ri(this, "originalParentZIndex", null);
    if (this.config = a, this.width = typeof n == "string" ? n : `${n}px`, this.height = typeof t == "string" ? t : `${t}px`, this.parent = r, this.onFail = i, this.onSuccess = o, this.backdrop = c, this.isModal = l, this.configFromUrl = s, this.onReady = u, this.messageHndlr = this.messageHndlr.bind(this), this.configFromUrl)
      return;
    const f = this.config.enabledBlockchainNetworks.find(
      (d) => W0e.test(d)
    );
    f && this.nearRedirectCheck() && (this.container = document.createElement("div"), this.open(f));
  }
  getParentElement() {
    if (typeof this.parent == "string") {
      const t = document.querySelector(
        this.parent
      );
      if (!t)
        throw new Error(
          `There is no such element as '${this.parent}', check your parent selector string!`
        );
      return t;
    }
    return this.parent;
  }
  open(t, n) {
    if (!this.isOpen) {
      if (this.container = document.createElement("div"), this.parent = this.getParentElement() || document.body, this.configFromUrl)
        L0e({
          parent: this.container
        });
      else {
        const r = n || this.config.evmProvider, i = t ? [t] : [this.config.enabledBlockchainNetworks[0]];
        z0e({
          config: {
            ...this.config,
            enabledBlockchainNetworks: i,
            evmProvider: r
          },
          height: this.height,
          parent: this.container,
          width: this.width,
          isModal: this.isModal,
          onReady: this.onReady
        });
      }
      this.isModal && this.parent.classList.add("KycDaoModalRoot"), this.modal = document.createElement("div"), this.isModal && (this.modal.classList.add("KycDaoModal"), this.modal.style.setProperty("--width", this.width), this.modal.style.setProperty("--height", this.height)), this.backdrop && this.isModal && (this.originalParentZIndex = this.parent.style.getPropertyValue("z-index"), this.parent.style.setProperty(
        "--kyc-dao-backdrop",
        typeof this.backdrop == "boolean" ? "rgba(0, 0, 0, 0.7)" : this.backdrop
      ), this.parent.style.setProperty("z-index", "101")), this.isModal && this.container.classList.add("KycDaoModalFrame"), this.modal.appendChild(this.container), this.parent.appendChild(this.modal), this.isOpen = !0, window.addEventListener("message", this.messageHndlr);
    }
  }
  nearRedirectCheck() {
    const t = Object.keys(e3), r = [...new URLSearchParams(window.location.search)].filter(
      ([i]) => t.includes(i)
    );
    if (r.length > 1)
      console.error(
        `${$0e} - Multiple URL query parameters identified: ${r.map(
          ([i]) => i
        )}.`
      );
    else if (r.length === 1) {
      const o = r[0][0];
      if (e3[o].startsWith("Near"))
        return !0;
    }
    return !1;
  }
  close() {
    var t;
    if (this.isOpen && this.modal) {
      const n = this.getParentElement();
      this.isModal && (n.classList.remove("KycDaoModalRoot"), n.style.setProperty("z-index", this.originalParentZIndex), this.backdrop && n.style.setProperty("--kyc-dao-backdrop", null)), (t = this.container) == null || t.remove(), n.removeChild(this.modal), window.removeEventListener("message", this.messageHndlr), this.isOpen = !1;
    }
  }
  messageHndlr({ data: { data: t, type: n } }) {
    switch (n) {
      case "kycDaoCloseModal":
        this.onFail && this.onFail("cancelled"), this.isOpen && this.close();
        break;
      case "kycDaoSuccess":
        this.isSuccessful = !0, this.onSuccess && this.onSuccess(t), this.close();
        break;
      case "kycDaoFail":
        this.onFail && this.onFail(t);
    }
  }
}
window.KycDaoClient = jU;
const V0e = (e) => {
  const t = ya(null), n = ya();
  return Ht(() => {
    const r = jU;
    return t.current ? (n.current = new r({
      ...e,
      parent: t.current,
      width: 400,
      height: 650,
      configFromUrl: !1,
      modal: !1,
      backdrop: !1
    }), n.current.open()) : console.error("Something went wrong, check the widget creator function!"), () => {
      var i;
      (i = n.current) == null || i.close();
    };
  }, [e]), /* @__PURE__ */ ee("div", { ref: t });
};
window.KycDaoWidget = V0e;
const q0e = `
.KycDaoModalIFrame {
	box-shadow: 0px 1px 174px rgba(59, 31, 69, 0.2);
	width: 100%;
	height: 100%;
	background-color: #fefefe;
	position: absolute;
	overflow: hidden;
	border: 0px;
	border-width: 0;
}

.KycDaoIframeModalRoot {
	width: 100%;
	position: absolute;
	inset: 0;
	background: var(--kyc-dao-backdrop);
}

@media only screen and (max-width: 992px) { 
	body:has(.KycDaoIframeModalRoot) {
		overflow: hidden;
	}
	.KycDaoIframeModalRoot {
		position: fixed;
	}
}

@media only screen and (min-width: 992px) {
	.KycDaoModalIFrame {
		width: var(--width);
		height: var(--height);
		margin: auto;
		border-radius: 12px;
		overflow: hidden;
		inset: 0;
	}

	.KycDaoIframeModalRoot {
		position: fixed;
		overflow: hidden;
		height: 100vh;
	}
}
`.replace(/\t|\n*/gm, ""), UU = document.createElement("style");
UU.innerText = q0e;
document.head.appendChild(UU);
function sf({
  height: e = 650,
  width: t = 400,
  parent: n = document.body,
  onFail: r,
  onSuccess: i,
  iframeOptions: o,
  config: a,
  backdrop: s = !0,
  modal: c = !0
}) {
  "virtualKeyboard" in navigator && (navigator.virtualKeyboard.overlaysContent = !0), this.config = a, this.iframeOptions = o, this.width = typeof t == "string" ? t : `${t}px`, this.height = typeof e == "string" ? e : `${e}px`, this.isOpen = !1, this.parent = n, this.onFail = r, this.onSuccess = i, this.isSuccessful = !1, this.isModal = c, this.messageHndlr = this.messageHndlr.bind(this), this.open = this.open.bind(this), this.close = this.close.bind(this), this.getParentElement = this.getParentElement.bind(this), this.backdrop = s;
}
sf.prototype.messageHndlr = function({ data: { data: e, type: t } }) {
  switch (t) {
    case "kycDaoCloseModal":
      this.onFail && this.onFail("cancelled"), this.isOpen && this.close();
      break;
    case "kycDaoSuccess":
      this.isSuccessful = !0, this.onSuccess && (this.onSuccess(e), this.close());
      break;
    case "kycDaoFail":
      this.onFail && this.onFail(e);
  }
};
sf.prototype.getParentElement = function() {
  if (typeof this.parent == "string") {
    const e = document.querySelector(
      this.parent
    );
    if (!e)
      throw new Error(
        `There is no such element as '${this.parent}', check your parent selector string!`
      );
    return e;
  }
  return this.parent;
};
sf.prototype.open = function() {
  var e;
  if (!((e = this.iframeOptions) != null && e.url))
    throw new Error(
      "An URL is needed if you want to use an iframe! What do you want to display?"
    );
  if (!this.isOpen) {
    const t = new URLSearchParams(), n = ({ 0: i, 1: o }) => t.set(i, Array.isArray(o) ? `["${o.join('","')}"]` : o);
    Object.entries(this.config).forEach(n), Object.entries(this.iframeOptions).forEach(n), t.set("messageTargetOrigin", this.iframeOptions.messageTargetOrigin), this.parent = this.getParentElement() || document.body, this.isModal && this.parent.classList.add("KycDaoIframeModalRoot"), this.backdrop && this.isModal && this.parent.style.setProperty(
      "--backdrop",
      typeof this.backdrop == "boolean" ? "rgba(0, 0, 0, 0.7)" : this.backdrop
    ), this.modal = document.createElement("div"), this.isModal && (this.modal.classList.add("KycDaoIframeModalRoot"), this.modal.style.setProperty("--width", this.width), this.modal.style.setProperty("--height", this.height));
    const r = document.createElement("iframe");
    r.allow = "encrypted-media; camera", r.src = this.iframeOptions.url + "?" + t.toString(), r.width = this.width, r.height = this.height, this.isModal && r.classList.add("KycDaoModalIFrame"), this.modal.appendChild(r), this.parent.appendChild(this.modal), this.isOpen = !0, "virtualKeyboard" in navigator && (navigator.virtualKeyboard.overlaysContent = !0), window.addEventListener("message", this.messageHndlr), document.body.style.setProperty("height", "100%"), document.body.style.setProperty("overflow", "hidden");
  }
};
sf.prototype.close = function() {
  if (this.isOpen && this.modal) {
    const e = this.getParentElement();
    this.isModal && e.classList.remove("KycDaoIframeModalRoot"), e && e.removeChild(this.modal), window.removeEventListener("message", this.messageHndlr), this.isOpen = !1;
  }
};
window.KycDaoIframeClient = sf;
const fbe = sf;
export {
  L0e as BootstrapIframeKycDaoModal,
  z0e as BootstrapKycDaoModal,
  jU as KycDaoClient,
  fbe as KycDaoIframeClient,
  DU as KycDaoModal,
  V0e as KycDaoWidget,
  sf as kycDaoIframeClient
};
//# sourceMappingURL=index.js.map
